export const maharashtraGeoJson = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: [
          [74.435546875, 22.030998229980526],
          [74.439453125000284, 22.026519775390568],
          [74.446037292480469, 22.026519775390568],
          [74.442558288574162, 22.021600723266715],
          [74.44451904296875, 22.015991210937614],
          [74.447647094726847, 22.012479782104549],
          [74.451507568359489, 22.008968353271541],
          [74.453819274902514, 22.006170272827205],
          [74.453918457031477, 22.002269744873047],
          [74.449951171875284, 22.005462646484432],
          [74.445732116699276, 22.006851196289176],
          [74.443809509277571, 22.006160736084098],
          [74.436218261719034, 22.002229690551815],
          [74.436279296875171, 21.999481201171875],
          [74.441078186035156, 21.996440887451286],
          [74.442626953125057, 21.993629455566463],
          [74.443038940429915, 21.98306846618658],
          [74.447181701660156, 21.976270675659293],
          [74.448638916015739, 21.971130371093807],
          [74.451705932617131, 21.967500686645508],
          [74.459968566894531, 21.962831497192496],
          [74.464157104492187, 21.963211059570313],
          [74.46732330322294, 21.964799880981445],
          [74.472183227539062, 21.965520858764705],
          [74.475120544433878, 21.962709426879883],
          [74.477859497070483, 21.961549758911133],
          [74.482933044433878, 21.962440490722599],
          [74.484497070312614, 21.960750579834041],
          [74.485687255859546, 21.957532882690487],
          [74.489288330078068, 21.956760406494254],
          [74.493400573730696, 21.954490661621094],
          [74.489852905273381, 21.947149276733398],
          [74.492332458496037, 21.945461273193416],
          [74.496780395507813, 21.946411132812443],
          [74.515556335449503, 21.933919906616325],
          [74.515609741210881, 21.927871704101676],
          [74.514640808105582, 21.922468185424918],
          [74.517356872558764, 21.917551040649471],
          [74.523986816406364, 21.91306114196783],
          [74.527496337890625, 21.908781051635856],
          [74.527465820312671, 21.903450012207145],
          [74.521469116211222, 21.895509719848746],
          [74.518432617187784, 21.890110015869141],
          [74.51776123046875, 21.886240005493164],
          [74.517478942871378, 21.874900817871094],
          [74.516998291015625, 21.856491088867244],
          [74.511817932129077, 21.82122993469244],
          [74.509323120117358, 21.815879821777401],
          [74.503646850585937, 21.807182312011662],
          [74.503158569336222, 21.797800064086971],
          [74.505966186523494, 21.782609939575309],
          [74.506332397460994, 21.78174018859869],
          [74.506652832031421, 21.780830383300895],
          [74.506958007812557, 21.779939651489371],
          [74.507286071777401, 21.779029846191463],
          [74.507637023925952, 21.778141021728516],
          [74.508003234863452, 21.777269363403434],
          [74.508407592773438, 21.776428222656364],
          [74.508880615234659, 21.775619506835994],
          [74.509460449219034, 21.774908065795898],
          [74.510215759277628, 21.774271011352539],
          [74.511016845703239, 21.773700714111271],
          [74.511856079101563, 21.773120880127067],
          [74.512573242187671, 21.772470474243278],
          [74.513206481933651, 21.771760940551758],
          [74.513931274414233, 21.771030426025334],
          [74.514633178711051, 21.770309448242301],
          [74.515296936035213, 21.76956939697277],
          [74.51596832275402, 21.76880073547369],
          [74.516532897949503, 21.768030166626033],
          [74.517005920410156, 21.767230987548828],
          [74.517356872558764, 21.766399383545036],
          [74.517593383789119, 21.76554107666027],
          [74.517730712890796, 21.764631271362305],
          [74.51786041259794, 21.763708114624023],
          [74.517898559570256, 21.762760162353572],
          [74.517906188965014, 21.761789321899528],
          [74.517883300781364, 21.760831832885742],
          [74.517807006836165, 21.759870529174805],
          [74.517692565918082, 21.75889968872076],
          [74.517570495605469, 21.757940292358398],
          [74.517402648925838, 21.756999969482479],
          [74.517211914062557, 21.756080627441406],
          [74.517005920410156, 21.755180358886776],
          [74.516662597656477, 21.754350662231559],
          [74.515991210937443, 21.753610610962028],
          [74.515167236328409, 21.752939224243221],
          [74.514366149902401, 21.752260208129996],
          [74.513786315918026, 21.751529693603629],
          [74.513526916504077, 21.750690460205078],
          [74.513488769531364, 21.749811172485295],
          [74.513542175293139, 21.748910903930664],
          [74.513656616211222, 21.747980117797908],
          [74.513862609863565, 21.747039794921989],
          [74.514076232910099, 21.746089935302734],
          [74.514266967773381, 21.745130538940543],
          [74.514472961425952, 21.744169235229606],
          [74.514617919922159, 21.743230819702092],
          [74.514717102050781, 21.742280960083065],
          [74.514717102050781, 21.741350173950252],
          [74.514633178711051, 21.74043083190918],
          [74.514472961425952, 21.739509582519531],
          [74.51425933837902, 21.738582611084098],
          [74.514038085937784, 21.737670898437557],
          [74.513755798339844, 21.736761093139648],
          [74.513488769531364, 21.735822677612305],
          [74.513175964355469, 21.734909057617188],
          [74.512863159179744, 21.733980178832951],
          [74.512557983398381, 21.73307991027832],
          [74.512268066406307, 21.732162475586051],
          [74.511978149414006, 21.73125076293951],
          [74.511749267578409, 21.730339050292969],
          [74.511520385742415, 21.729440689086914],
          [74.511352539062784, 21.728548049926815],
          [74.511253356933764, 21.72764968872076],
          [74.511222839355412, 21.726749420166129],
          [74.511383056640909, 21.725851058960075],
          [74.51175689697294, 21.724950790405273],
          [74.512260437011776, 21.724090576171932],
          [74.512886047363565, 21.723260879516715],
          [74.513526916504077, 21.722530364990348],
          [74.514221191406534, 21.721879959106502],
          [74.514976501465128, 21.721281051635856],
          [74.515838623047046, 21.720760345459041],
          [74.516716003418253, 21.720291137695369],
          [74.517631530761776, 21.719869613647518],
          [74.518547058105526, 21.71947097778326],
          [74.519477844238281, 21.719110488891545],
          [74.520416259765796, 21.718790054321289],
          [74.521392822265625, 21.718509674072322],
          [74.522346496582031, 21.718282699584961],
          [74.523338317871321, 21.71808052062994],
          [74.52433013916044, 21.717918395996037],
          [74.52530670166044, 21.717809677124137],
          [74.526306152343921, 21.717721939087028],
          [74.527313232421932, 21.717630386352539],
          [74.528320312500057, 21.717582702636719],
          [74.529296875000284, 21.717540740966854],
          [74.530319213867358, 21.717479705810547],
          [74.531318664550838, 21.71747016906744],
          [74.532310485840071, 21.71747016906744],
          [74.533332824707145, 21.717491149902457],
          [74.534317016601733, 21.717540740966854],
          [74.535308837890625, 21.717582702636719],
          [74.536315917968977, 21.717699050903377],
          [74.537345886230412, 21.717870712280217],
          [74.538391113281307, 21.718090057373104],
          [74.539436340332145, 21.718328475952205],
          [74.540496826171932, 21.718610763549918],
          [74.541557312011889, 21.718879699707031],
          [74.542617797851619, 21.719150543212834],
          [74.543663024902514, 21.719409942626953],
          [74.544670104980526, 21.719650268554687],
          [74.545677185058651, 21.719829559326229],
          [74.546646118164347, 21.719970703125114],
          [74.547622680664347, 21.720029830932617],
          [74.548522949218977, 21.720029830932617],
          [74.549400329590014, 21.719919204711914],
          [74.550201416015682, 21.719707489013786],
          [74.550987243652401, 21.719392776489315],
          [74.551719665527344, 21.718948364257869],
          [74.552375793457315, 21.718399047851619],
          [74.553031921386889, 21.717741012573242],
          [74.553627014160156, 21.717018127441406],
          [74.554176330566577, 21.716230392456112],
          [74.554710388183537, 21.715370178222713],
          [74.555229187012003, 21.714479446411246],
          [74.555732727050838, 21.71355056762701],
          [74.556213378906364, 21.71261024475109],
          [74.556678771972656, 21.711669921875],
          [74.557136535644815, 21.710739135742244],
          [74.557609558105639, 21.70984077453619],
          [74.558067321777401, 21.708980560302791],
          [74.558563232422046, 21.708160400390739],
          [74.559036254883097, 21.707309722900504],
          [74.559486389160327, 21.706462860107479],
          [74.559898376465014, 21.705600738525504],
          [74.560249328613452, 21.704700469970703],
          [74.560569763183878, 21.703800201416072],
          [74.560798645019645, 21.702890396118107],
          [74.560966491699503, 21.701980590820369],
          [74.561073303222713, 21.701049804687557],
          [74.561157226562784, 21.700120925903377],
          [74.561248779296875, 21.69915962219244],
          [74.561332702637003, 21.698200225830078],
          [74.561378479003849, 21.697229385375977],
          [74.561416625976733, 21.69627952575695],
          [74.561462402343807, 21.695301055908317],
          [74.561470031738338, 21.694339752197379],
          [74.561439514160156, 21.693389892578182],
          [74.561378479003849, 21.692441940307731],
          [74.561309814453182, 21.691511154174918],
          [74.561210632324389, 21.690599441528377],
          [74.561058044433594, 21.689701080322322],
          [74.560867309570313, 21.688827514648494],
          [74.560546875000057, 21.687990188598746],
          [74.559776306152571, 21.687290191650504],
          [74.55877685546875, 21.686679840088004],
          [74.557739257812614, 21.686109542846737],
          [74.556945800781534, 21.685550689697379],
          [74.556610107421818, 21.684940338134822],
          [74.556800842285099, 21.684259414672852],
          [74.557296752929915, 21.683532714843864],
          [74.558006286621094, 21.682790756225586],
          [74.55887603759794, 21.682081222534237],
          [74.559806823730753, 21.681430816650391],
          [74.560729980468977, 21.680860519409123],
          [74.561607360840014, 21.680421829223633],
          [74.562629699707259, 21.680089950561637],
          [74.563713073730639, 21.679901123046989],
          [74.564765930176065, 21.679849624633789],
          [74.565696716308651, 21.679960250854492],
          [74.566261291504134, 21.680450439453182],
          [74.566360473632983, 21.681539535522518],
          [74.566520690918082, 21.682598114013672],
          [74.567260742187784, 21.683029174804687],
          [74.568138122558651, 21.683322906494141],
          [74.569061279296875, 21.68357086181652],
          [74.570007324218921, 21.68380165100109],
          [74.570991516113338, 21.683990478515625],
          [74.572006225586222, 21.684160232544059],
          [74.573020935058537, 21.684310913086051],
          [74.574050903320369, 21.684431076049918],
          [74.575073242187784, 21.684562683105469],
          [74.576118469238281, 21.68466949462902],
          [74.577133178711165, 21.684780120849723],
          [74.578140258789347, 21.684869766235408],
          [74.579162597656421, 21.684999465942383],
          [74.580276489257983, 21.685140609741268],
          [74.581413269042912, 21.685270309448242],
          [74.582489013671932, 21.68527984619152],
          [74.583450317383097, 21.685131072998104],
          [74.584167480468807, 21.684740066528434],
          [74.584701538085938, 21.68412017822277],
          [74.585159301757869, 21.683380126953239],
          [74.585571289062784, 21.682540893554744],
          [74.585899353027571, 21.681631088256779],
          [74.586196899414233, 21.680660247802734],
          [74.586441040039119, 21.679662704467887],
          [74.586616516113281, 21.678659439087028],
          [74.586776733398608, 21.67766189575201],
          [74.58689117431669, 21.676700592041072],
          [74.586936950683537, 21.675792694091854],
          [74.586700439453409, 21.674858093261719],
          [74.586273193359432, 21.673919677734375],
          [74.585792541503849, 21.673000335693303],
          [74.585472106933594, 21.672109603881836],
          [74.585456848144702, 21.671249389648437],
          [74.585746765137003, 21.670410156250114],
          [74.586151123047159, 21.66953086853033],
          [74.586570739746264, 21.668621063232422],
          [74.587089538574503, 21.667720794677734],
          [74.587677001953409, 21.666830062866268],
          [74.588310241699389, 21.666019439697322],
          [74.588996887207315, 21.665269851684684],
          [74.589767456054972, 21.664648056030217],
          [74.59055328369152, 21.66415977478033],
          [74.591407775878963, 21.663831710815543],
          [74.592277526855412, 21.663589477539063],
          [74.593193054199503, 21.663408279418888],
          [74.594139099121378, 21.663280487060547],
          [74.595092773437784, 21.663211822509879],
          [74.596076965332145, 21.663169860839787],
          [74.597091674804858, 21.663169860839787],
          [74.598098754882869, 21.663198471069393],
          [74.599136352539176, 21.663230895996094],
          [74.600189208984432, 21.663280487060547],
          [74.601226806640739, 21.663328170776367],
          [74.602279663085994, 21.66337966918951],
          [74.60330963134794, 21.663419723510799],
          [74.604347229003906, 21.663431167602539],
          [74.605377197265682, 21.663419723510799],
          [74.606399536132756, 21.66337966918951],
          [74.607421875000057, 21.663280487060547],
          [74.608398437500057, 21.663152694702148],
          [74.609390258789347, 21.662990570068416],
          [74.610366821289347, 21.662820816040153],
          [74.611343383789176, 21.662630081176871],
          [74.612312316894474, 21.662460327148438],
          [74.613296508789233, 21.662260055542049],
          [74.614273071289063, 21.662050247192496],
          [74.615242004394588, 21.661840438842773],
          [74.616210937500057, 21.661630630493221],
          [74.617179870605696, 21.661399841308707],
          [74.618141174316634, 21.661188125610352],
          [74.619132995605753, 21.66094970703125],
          [74.620086669922159, 21.660707473754996],
          [74.621063232421989, 21.660470962524471],
          [74.622016906738395, 21.660230636596793],
          [74.623001098632983, 21.659999847412223],
          [74.623962402343921, 21.659759521484375],
          [74.624946594238281, 21.659521102905273],
          [74.625907897949219, 21.659282684326172],
          [74.626876831054744, 21.659048080444393],
          [74.627845764160213, 21.658821105957031],
          [74.628822326660384, 21.658590316772461],
          [74.629806518554972, 21.658359527587891],
          [74.630760192871378, 21.658140182495231],
          [74.631736755371378, 21.657930374145508],
          [74.632698059082145, 21.657728195190543],
          [74.633689880371264, 21.657520294189567],
          [74.634651184082202, 21.657331466674862],
          [74.635643005371094, 21.657150268554744],
          [74.636611938476619, 21.656980514526481],
          [74.637611389160213, 21.656820297241325],
          [74.638580322265909, 21.656660079956055],
          [74.639587402343693, 21.656509399414063],
          [74.640571594238452, 21.656370162963924],
          [74.641555786132813, 21.65624046325695],
          [74.642547607422102, 21.656101226806697],
          [74.64353179931669, 21.65596961975092],
          [74.644538879394474, 21.655839920043945],
          [74.645530700683764, 21.655731201171818],
          [74.646507263183594, 21.655599594116268],
          [74.647499084472713, 21.655471801757869],
          [74.648506164551065, 21.655349731445256],
          [74.649490356445426, 21.655229568481445],
          [74.650466918945483, 21.655107498169002],
          [74.651466369628906, 21.654979705810604],
          [74.652458190918026, 21.654840469360352],
          [74.653427124023665, 21.654710769653377],
          [74.654449462890739, 21.654571533203239],
          [74.655426025390796, 21.654420852661246],
          [74.65643310546875, 21.654270172119254],
          [74.657402038574276, 21.65410041809082],
          [74.658370971679744, 21.653930664062557],
          [74.659339904785384, 21.653749465942383],
          [74.660331726074503, 21.65355110168457],
          [74.661315917968864, 21.653350830078182],
          [74.662277221679631, 21.653121948242188],
          [74.663261413574389, 21.652870178222599],
          [74.664207458496264, 21.652610778808651],
          [74.665176391601733, 21.652320861816406],
          [74.666122436523608, 21.652019500732365],
          [74.667060852050952, 21.651689529419002],
          [74.667976379394815, 21.651340484619197],
          [74.668876647949446, 21.650970458984318],
          [74.669776916503906, 21.650558471679801],
          [74.670661926269645, 21.650110244750977],
          [74.671516418457088, 21.649650573730469],
          [74.672370910644645, 21.649150848388615],
          [74.673202514648437, 21.648620605468864],
          [74.67402648925804, 21.648099899291992],
          [74.674873352050724, 21.647542953491211],
          [74.675659179687671, 21.646989822387809],
          [74.676483154296932, 21.646419525146541],
          [74.677299499512003, 21.645879745483455],
          [74.678092956543082, 21.645322799682674],
          [74.678886413574389, 21.644760131835994],
          [74.679702758789063, 21.644189834594727],
          [74.680473327636776, 21.643619537353459],
          [74.681266784668196, 21.643039703369254],
          [74.682052612304744, 21.642459869384879],
          [74.682823181152628, 21.641870498657227],
          [74.683609008789347, 21.641281127929687],
          [74.684387207031364, 21.640699386596737],
          [74.685173034667912, 21.640110015869197],
          [74.685966491699389, 21.639530181884822],
          [74.686752319335937, 21.63894081115734],
          [74.687530517578182, 21.638360977172908],
          [74.688308715820369, 21.637779235839957],
          [74.689102172851619, 21.637210845947322],
          [74.689903259277628, 21.636632919311523],
          [74.690696716308537, 21.636079788208121],
          [74.691490173340014, 21.63552284240734],
          [74.692306518554744, 21.634960174560604],
          [74.693130493164347, 21.634420394897518],
          [74.693962097168139, 21.633899688720646],
          [74.694778442382869, 21.633380889892578],
          [74.695648193359489, 21.632890701293888],
          [74.696517944335994, 21.632400512695369],
          [74.697380065917912, 21.631950378417969],
          [74.698272705078409, 21.631509780883903],
          [74.699172973632869, 21.631099700927734],
          [74.700080871582202, 21.630718231201172],
          [74.701011657715014, 21.63035964965826],
          [74.701927185058878, 21.63002967834467],
          [74.70285797119169, 21.629688262939567],
          [74.703796386718807, 21.629360198974609],
          [74.704742431640682, 21.629051208496094],
          [74.705673217773494, 21.628749847412053],
          [74.706626892089901, 21.628440856933707],
          [74.707588195801009, 21.62816047668457],
          [74.708526611328182, 21.62787055969244],
          [74.709487915039119, 21.627590179443473],
          [74.710449218750227, 21.627321243286246],
          [74.711418151855526, 21.627059936523494],
          [74.712379455566463, 21.626802444458008],
          [74.713340759277628, 21.626541137695426],
          [74.714302062988565, 21.626291275024471],
          [74.715278625488565, 21.626060485839901],
          [74.716247558593864, 21.625810623169059],
          [74.717208862304631, 21.625591278076229],
          [74.718162536621037, 21.625370025634766],
          [74.719146728515796, 21.625120162963981],
          [74.720123291015625, 21.624891281127987],
          [74.721076965332031, 21.624671936035156],
          [74.722038269042969, 21.624450683593693],
          [74.723022460937557, 21.624219894409123],
          [74.723976135253963, 21.623991012573356],
          [74.724967956543026, 21.623781204223633],
          [74.725921630859432, 21.623561859130973],
          [74.72690582275419, 21.62334060668951],
          [74.727867126465128, 21.623130798339844],
          [74.728851318359318, 21.622909545898551],
          [74.729812622070483, 21.622690200805721],
          [74.730796813965014, 21.622480392456168],
          [74.731773376464844, 21.622261047363338],
          [74.732742309570369, 21.622051239013786],
          [74.73371887207054, 21.621839523315487],
          [74.734687805175838, 21.621629714965934],
          [74.735656738281534, 21.621421813964844],
          [74.736640930176065, 21.621200561523551],
          [74.737617492675724, 21.621000289916992],
          [74.738601684570483, 21.620792388916016],
          [74.739562988281421, 21.620590209961051],
          [74.74053955078125, 21.620370864868164],
          [74.741516113281307, 21.620172500610352],
          [74.742492675781477, 21.619960784912223],
          [74.743461608886776, 21.619760513305664],
          [74.744438171387003, 21.619552612304688],
          [74.745407104492472, 21.619350433349723],
          [74.74637603759777, 21.619140625],
          [74.747352600097599, 21.618940353393555],
          [74.748336791992358, 21.618740081787166],
          [74.749313354492187, 21.618530273437614],
          [74.750289916992244, 21.618320465087891],
          [74.751266479492415, 21.618129730224609],
          [74.752243041992244, 21.617919921875114],
          [74.753196716308651, 21.617719650268668],
          [74.754196166992301, 21.617519378662109],
          [74.755157470703239, 21.617319107055664],
          [74.756149291992358, 21.617120742797852],
          [74.757125854492187, 21.616910934448356],
          [74.758087158203125, 21.616720199585075],
          [74.759078979492244, 21.616519927978629],
          [74.760063171386776, 21.616340637207088],
          [74.761047363281534, 21.616180419921932],
          [74.762031555175724, 21.616020202636832],
          [74.763031005859546, 21.61585807800293],
          [74.763999938964844, 21.615739822387695],
          [74.764999389648665, 21.615619659423828],
          [74.765991210937784, 21.615520477294979],
          [74.766983032226676, 21.615470886230582],
          [74.767967224121264, 21.61541938781744],
          [74.768966674804688, 21.615411758422852],
          [74.769966125488509, 21.615430831909293],
          [74.77097320556669, 21.615470886230582],
          [74.771972656250171, 21.615480422973746],
          [74.772979736328182, 21.615510940551871],
          [74.773971557617415, 21.61553955078125],
          [74.775016784668139, 21.61553955078125],
          [74.775932312012003, 21.615159988403263],
          [74.776832580566634, 21.614759445190487],
          [74.777740478515625, 21.614330291748104],
          [74.778633117675724, 21.613910675048828],
          [74.779548645019815, 21.613491058349553],
          [74.780456542968977, 21.613080978393612],
          [74.781372070312557, 21.612701416015682],
          [74.782310485839844, 21.612350463867244],
          [74.783241271972827, 21.612031936645565],
          [74.784179687500171, 21.611770629882869],
          [74.785148620605639, 21.611560821533317],
          [74.786117553710937, 21.611360549926758],
          [74.787101745605526, 21.611179351806754],
          [74.788085937500227, 21.611021041870231],
          [74.789062500000284, 21.610860824584904],
          [74.790077209472599, 21.610719680786246],
          [74.791069030761889, 21.610580444335938],
          [74.792098999023494, 21.610469818115234],
          [74.793083190918253, 21.610338211059684],
          [74.794082641601506, 21.610250473022575],
          [74.795097351074219, 21.610162734985465],
          [74.79609680175804, 21.610090255737418],
          [74.797088623047159, 21.610019683838004],
          [74.798088073730412, 21.609960556030273],
          [74.799072265625171, 21.609899520874137],
          [74.800048828125, 21.609859466552678],
          [74.801033020019588, 21.609830856323299],
          [74.802062988281534, 21.610050201415959],
          [74.802886962890796, 21.61073112487793],
          [74.803062438965014, 21.611560821533317],
          [74.802841186523551, 21.612558364868221],
          [74.802459716796989, 21.613630294799862],
          [74.802070617675895, 21.614639282226619],
          [74.801902770996037, 21.615489959716854],
          [74.802070617675895, 21.616050720214957],
          [74.802879333496264, 21.616130828857536],
          [74.804046630859375, 21.61586952209484],
          [74.805206298828125, 21.615499496459961],
          [74.806137084961108, 21.615142822265625],
          [74.807022094726847, 21.61469841003418],
          [74.807907104492244, 21.614221572875977],
          [74.808761596679631, 21.613729476928654],
          [74.809631347656477, 21.613269805908317],
          [74.810539245605469, 21.612871170043888],
          [74.811462402343921, 21.612541198730526],
          [74.812408447265796, 21.612251281738224],
          [74.813392639160156, 21.612031936645565],
          [74.814376831054744, 21.61182975769043],
          [74.815368652343807, 21.611640930175895],
          [74.816337585449503, 21.611471176147461],
          [74.817321777344034, 21.611299514770621],
          [74.818305969238224, 21.611120223999023],
          [74.819282531738452, 21.610940933227653],
          [74.820289611816463, 21.610790252685661],
          [74.821289062500057, 21.610631942749137],
          [74.822273254394815, 21.610490798950252],
          [74.823272705078296, 21.610380172729549],
          [74.824256896972827, 21.61029243469244],
          [74.825241088867244, 21.610210418701286],
          [74.826240539550838, 21.610189437866268],
          [74.827262878417912, 21.610189437866268],
          [74.828361511230753, 21.610210418701286],
          [74.829467773437727, 21.61029243469244],
          [74.830558776855469, 21.610418319702205],
          [74.831565856933821, 21.610620498657227],
          [74.832458496093921, 21.610900878906364],
          [74.833206176757983, 21.611299514770621],
          [74.833671569824446, 21.611860275268555],
          [74.833686828613338, 21.612739562988338],
          [74.833488464355526, 21.613790512084961],
          [74.833297729492244, 21.61487007141119],
          [74.833366394042912, 21.615840911865234],
          [74.833709716797159, 21.61669921875],
          [74.834236145019759, 21.617551803588867],
          [74.834899902343693, 21.618330001831055],
          [74.835647583007926, 21.618970870971737],
          [74.836509704589901, 21.619409561157227],
          [74.837409973144702, 21.619791030883789],
          [74.838333129882756, 21.620130538940487],
          [74.839248657226847, 21.620441436767635],
          [74.840202331543253, 21.620729446411133],
          [74.841156005859659, 21.62100982666027],
          [74.842140197753849, 21.621282577514705],
          [74.843109130859546, 21.621530532836971],
          [74.844093322754077, 21.621799468994197],
          [74.845069885253906, 21.62206077575695],
          [74.846015930175781, 21.622329711914176],
          [74.846977233886719, 21.622631072998161],
          [74.847938537597713, 21.622940063476563],
          [74.848846435547046, 21.623279571533203],
          [74.849769592285099, 21.623661041259766],
          [74.850662231445369, 21.624071121215934],
          [74.851531982422046, 21.624519348144531],
          [74.852378845214901, 21.625040054321403],
          [74.853218078613452, 21.625600814819336],
          [74.854072570801009, 21.626190185546875],
          [74.854881286621378, 21.626810073852539],
          [74.855682373046818, 21.627450942993221],
          [74.856475830078296, 21.628110885620174],
          [74.857276916503906, 21.628789901733342],
          [74.858078002929915, 21.629449844360465],
          [74.858848571777571, 21.630109786987418],
          [74.859649658203409, 21.630741119384822],
          [74.860382080078182, 21.631370544433594],
          [74.861152648925838, 21.631959915161133],
          [74.861930847168253, 21.632511138916129],
          [74.862663269043196, 21.633020401001033],
          [74.863426208496321, 21.633460998535156],
          [74.864158630371151, 21.63385009765625],
          [74.864860534668139, 21.634029388427848],
          [74.865341186523494, 21.633302688598633],
          [74.865753173828409, 21.632120132446403],
          [74.866302490234432, 21.631120681762809],
          [74.867095947265909, 21.630741119384822],
          [74.868019104003963, 21.630529403686523],
          [74.869003295898722, 21.630390167236385],
          [74.870010375976733, 21.630290985107422],
          [74.871063232421932, 21.630239486694393],
          [74.872093200683537, 21.630239486694393],
          [74.873123168945369, 21.630260467529411],
          [74.874153137207315, 21.630290985107422],
          [74.875160217285327, 21.630340576171989],
          [74.876136779785327, 21.630439758300838],
          [74.877136230468807, 21.63059043884283],
          [74.878128051757869, 21.630781173706112],
          [74.879096984863565, 21.630990982055607],
          [74.880065917969034, 21.63120079040533],
          [74.881057739257756, 21.631410598754883],
          [74.882049560547046, 21.631580352783317],
          [74.883026123046875, 21.631719589233398],
          [74.884010314941463, 21.631790161132869],
          [74.885017395019815, 21.631799697875977],
          [74.886016845703068, 21.631799697875977],
          [74.887016296386719, 21.631799697875977],
          [74.888031005859602, 21.631782531738338],
          [74.889038085937784, 21.631759643554688],
          [74.890052795410327, 21.631719589233398],
          [74.891059875488338, 21.631679534912166],
          [74.892082214355753, 21.631629943847713],
          [74.893096923828296, 21.631559371948299],
          [74.894119262695369, 21.631469726562614],
          [74.895126342773722, 21.631389617920036],
          [74.896102905273551, 21.631280899047908],
          [74.897087097168139, 21.631162643432674],
          [74.898071289062671, 21.631019592285213],
          [74.8990478515625, 21.630861282348633],
          [74.900016784668026, 21.630689620971793],
          [74.90093994140625, 21.63047981262207],
          [74.901878356933764, 21.630229949951286],
          [74.902763366699503, 21.629800796508903],
          [74.903587341308764, 21.629222869873104],
          [74.904342651367358, 21.628530502319393],
          [74.905006408691634, 21.627790451049918],
          [74.905639648437614, 21.627029418945369],
          [74.906181335449503, 21.626251220703182],
          [74.906616210937443, 21.625431060791072],
          [74.907035827636889, 21.62455940246582],
          [74.907432556152344, 21.623661041259766],
          [74.907806396484375, 21.622770309448299],
          [74.908180236816577, 21.621879577636776],
          [74.908607482910213, 21.62102127075201],
          [74.909072875976676, 21.620201110839957],
          [74.909622192383097, 21.619449615478516],
          [74.910263061523608, 21.618761062622184],
          [74.910957336426065, 21.618110656738395],
          [74.911727905273722, 21.617490768432731],
          [74.912506103515739, 21.616899490356445],
          [74.913337707519531, 21.616340637207088],
          [74.914161682129134, 21.615808486938533],
          [74.915046691894702, 21.615310668945313],
          [74.915916442871378, 21.614828109741325],
          [74.916801452636776, 21.6143798828125],
          [74.917701721191577, 21.613952636718864],
          [74.918579101562784, 21.613529205322266],
          [74.919479370117244, 21.613140106201172],
          [74.920387268066577, 21.612751007080078],
          [74.921302795410099, 21.612369537353516],
          [74.922225952148722, 21.612020492553711],
          [74.923149108887003, 21.611658096313533],
          [74.924087524414119, 21.611318588256893],
          [74.925025939941634, 21.610990524292049],
          [74.925956726074276, 21.610652923583984],
          [74.926918029785213, 21.610338211059684],
          [74.927856445312557, 21.610031127929744],
          [74.928802490234375, 21.609720230102596],
          [74.929740905761719, 21.609420776367188],
          [74.930679321289233, 21.609100341796932],
          [74.931632995605639, 21.608800888061523],
          [74.932586669922046, 21.608491897583008],
          [74.933532714843921, 21.608190536498967],
          [74.934471130371264, 21.607879638671875],
          [74.935417175292912, 21.607570648193303],
          [74.936363220214787, 21.607280731201229],
          [74.937316894531193, 21.606971740722656],
          [74.938247680664347, 21.606670379638672],
          [74.939201354980753, 21.606370925903434],
          [74.94016265869152, 21.606082916259766],
          [74.941085815429972, 21.605779647827148],
          [74.942047119140909, 21.605489730835075],
          [74.943000793457315, 21.605182647705135],
          [74.94394683837919, 21.604900360107365],
          [74.944892883301065, 21.604600906372127],
          [74.945846557617472, 21.604320526123161],
          [74.946823120117472, 21.604030609130916],
          [74.947761535644815, 21.60375022888195],
          [74.948699951171932, 21.603469848632756],
          [74.949668884277628, 21.603181838989258],
          [74.950607299804744, 21.602912902832031],
          [74.95157623291044, 21.602630615234432],
          [74.952529907226847, 21.602350234985465],
          [74.953498840332315, 21.602079391479606],
          [74.954437255859659, 21.601810455322379],
          [74.955398559570597, 21.60155105590826],
          [74.956359863281534, 21.601289749145508],
          [74.957321166992472, 21.601030349731559],
          [74.958267211914347, 21.600772857666016],
          [74.959236145019645, 21.600509643554744],
          [74.960189819336051, 21.600269317627067],
          [74.961166381835881, 21.600019454956055],
          [74.962142944336108, 21.599809646606502],
          [74.963127136230469, 21.59959983825695],
          [74.964088439941406, 21.599411010742301],
          [74.965072631835994, 21.599201202392578],
          [74.966049194335994, 21.599018096923828],
          [74.967025756836222, 21.598831176757869],
          [74.968002319336222, 21.598649978637752],
          [74.968986511230412, 21.598470687866154],
          [74.969978332519702, 21.598289489746207],
          [74.970962524414119, 21.598119735717773],
          [74.971946716308821, 21.597932815551871],
          [74.972930908203409, 21.597749710083121],
          [74.973907470703409, 21.597560882568416],
          [74.974876403808707, 21.597370147705135],
          [74.975860595703296, 21.597171783447322],
          [74.976837158203296, 21.596960067749023],
          [74.977806091308594, 21.596740722656364],
          [74.978759765625, 21.596519470214901],
          [74.979728698730469, 21.596269607543888],
          [74.980682373046875, 21.596019744873104],
          [74.98162841796875, 21.595741271972713],
          [74.982589721679688, 21.595460891723746],
          [74.983535766601563, 21.595172882080021],
          [74.9844970703125, 21.594869613647461],
          [74.985443115234375, 21.594560623168888],
          [74.98638916015625, 21.594249725341797],
          [74.987312316894702, 21.59392166137701],
          [74.988243103027287, 21.593589782714844],
          [74.989181518554801, 21.593250274658317],
          [74.990119934082315, 21.592901229858512],
          [74.991043090820369, 21.592550277709904],
          [74.991958618164119, 21.592191696166992],
          [74.992897033691463, 21.591831207275447],
          [74.993797302246264, 21.591449737548885],
          [74.994743347168139, 21.591091156005916],
          [74.995651245117472, 21.590700149536246],
          [74.996566772460994, 21.590330123901367],
          [74.997459411621094, 21.58992958068859],
          [74.998352050781193, 21.589500427246207],
          [74.999237060546932, 21.589050292968807],
          [75.000099182129077, 21.588590621948242],
          [75.000961303710994, 21.588119506835994],
          [75.001831054687671, 21.587642669677791],
          [75.002677917480526, 21.58716964721674],
          [75.003562927246094, 21.586708068847656],
          [75.004776000976619, 21.586042404174918],
          [75.013412475586051, 21.581188201904354],
          [75.01584625244169, 21.577880859375114],
          [75.017837524414233, 21.572610855102653],
          [75.031837463379134, 21.569309234619197],
          [75.053565979003963, 21.567190170288029],
          [75.057746887207088, 21.564939498901367],
          [75.060188293457202, 21.559339523315543],
          [75.063598632812671, 21.555000305175895],
          [75.065032958984602, 21.55081939697277],
          [75.072219848632812, 21.541650772094783],
          [75.076240539550781, 21.538019180297908],
          [75.078323364257813, 21.532131195068416],
          [75.083557128906534, 21.525751113891602],
          [75.089996337890682, 21.514331817626953],
          [75.092666625976619, 21.500909805297795],
          [75.094879150390796, 21.493812561035156],
          [75.100440979004077, 21.485311508178825],
          [75.10666656494169, 21.46962928771967],
          [75.115097045898608, 21.459560394287053],
          [75.122978210449276, 21.453332901001033],
          [75.129776000976506, 21.449279785156307],
          [75.147438049316463, 21.443340301513786],
          [75.157371520996378, 21.438272476196346],
          [75.188026428222713, 21.427310943603629],
          [75.195999145507983, 21.422859191894531],
          [75.203720092773722, 21.417318344116211],
          [75.20745849609375, 21.415840148925781],
          [75.210556030273665, 21.414220809936467],
          [75.219856262207031, 21.410869598388786],
          [75.232261657714844, 21.41658973693859],
          [75.23636627197294, 21.417100906372127],
          [75.243476867675952, 21.414939880371151],
          [75.247680664062671, 21.410671234130916],
          [75.253997802734375, 21.406139373779411],
          [75.259109497070483, 21.405218124389762],
          [75.267021179199446, 21.408870697021484],
          [75.276626586914176, 21.408870697021484],
          [75.288566589355696, 21.411811828613281],
          [75.291625976562727, 21.413909912109375],
          [75.299629211426009, 21.415660858154411],
          [75.301849365234546, 21.414831161499023],
          [75.303161621093921, 21.39519119262701],
          [75.301826477050952, 21.392419815063477],
          [75.301902770996151, 21.389249801635742],
          [75.308662414550895, 21.394500732421932],
          [75.311958312988452, 21.395280838012695],
          [75.320907592773608, 21.392402648925838],
          [75.326812744140796, 21.39423942565918],
          [75.334877014160156, 21.394668579101563],
          [75.353782653808651, 21.393489837646541],
          [75.358001708984602, 21.39617919921875],
          [75.361381530761719, 21.403230667114371],
          [75.366943359375057, 21.398910522460994],
          [75.378662109375114, 21.392419815063477],
          [75.381332397461051, 21.387630462646598],
          [75.384483337402401, 21.385589599609432],
          [75.393089294433821, 21.384069442749137],
          [75.395378112793196, 21.384679794311523],
          [75.398391723632812, 21.382980346679631],
          [75.400917053222884, 21.383979797363281],
          [75.403816223144815, 21.383779525756893],
          [75.409255981445313, 21.389921188354549],
          [75.413375854492301, 21.391067504882869],
          [75.419967651367244, 21.390270233154411],
          [75.431655883789347, 21.393949508667106],
          [75.436286926269474, 21.390720367431641],
          [75.443618774414119, 21.391019821167049],
          [75.446151733398722, 21.390470504760799],
          [75.4500732421875, 21.392402648925838],
          [75.454437255859546, 21.392051696777401],
          [75.460052490234432, 21.393022537231502],
          [75.465599060058878, 21.391361236572322],
          [75.468406677246151, 21.394201278686523],
          [75.484802246093807, 21.391260147094727],
          [75.496437072753963, 21.390731811523494],
          [75.500488281250057, 21.391572952270621],
          [75.510131835937671, 21.387992858886719],
          [75.516281127929744, 21.386730194091797],
          [75.524581909179801, 21.387161254882926],
          [75.529396057129077, 21.38472938537609],
          [75.539947509765682, 21.377191543579158],
          [75.54530334472679, 21.375799179077205],
          [75.547149658203125, 21.372659683227596],
          [75.548149108886776, 21.372489929199162],
          [75.551330566406421, 21.375448226928825],
          [75.555335998535327, 21.377450942993278],
          [75.559806823730526, 21.382261276245174],
          [75.561111450195369, 21.381170272827262],
          [75.560272216797046, 21.378810882568416],
          [75.564208984375284, 21.37809944152832],
          [75.565986633300724, 21.379150390625114],
          [75.572090148925724, 21.378229141235465],
          [75.581253051757983, 21.379859924316463],
          [75.581550598144588, 21.380849838256836],
          [75.576553344726619, 21.385520935058594],
          [75.584861755371037, 21.387599945068473],
          [75.587753295898608, 21.388900756835881],
          [75.59126281738304, 21.391740798950252],
          [75.602951049804972, 21.390529632568359],
          [75.608917236328296, 21.395000457763729],
          [75.61944580078125, 21.393461227416992],
          [75.621116638183764, 21.387870788574276],
          [75.623611450195483, 21.384281158447266],
          [75.626792907715128, 21.382009506225586],
          [75.629463195801065, 21.381229400634766],
          [75.632637023925838, 21.381771087646484],
          [75.639862060546875, 21.381490707397518],
          [75.645759582519531, 21.382471084594727],
          [75.654876708984546, 21.382020950317496],
          [75.658821105957315, 21.38274955749506],
          [75.673416137695312, 21.380350112915153],
          [75.675079345703068, 21.381450653076229],
          [75.678466796875284, 21.382171630859489],
          [75.68479156494152, 21.382230758666992],
          [75.687820434570597, 21.384330749511719],
          [75.689720153808878, 21.387500762939453],
          [75.694831848144759, 21.389562606811637],
          [75.706756591797046, 21.391321182251033],
          [75.713851928710937, 21.391611099243107],
          [75.721588134765909, 21.390991210937443],
          [75.722717285156534, 21.389152526855469],
          [75.732940673828125, 21.393329620361442],
          [75.735580444336108, 21.392709732055778],
          [75.738349914551065, 21.393432617187614],
          [75.744087219238565, 21.393190383911133],
          [75.746101379394531, 21.391710281372127],
          [75.754676818847656, 21.388389587402344],
          [75.758941650390682, 21.385490417480469],
          [75.760139465332145, 21.385700225830192],
          [75.773826599121378, 21.386648178100643],
          [75.792205810547046, 21.3892116546632],
          [75.801406860351563, 21.390150070190543],
          [75.805458068847884, 21.389030456543082],
          [75.812500000000057, 21.38733100891119],
          [75.832626342773381, 21.383300781250057],
          [75.843421936035384, 21.389450073242301],
          [75.846626281738338, 21.388139724731559],
          [75.851356506347827, 21.389350891113338],
          [75.859329223632756, 21.387300491333065],
          [75.862777709961108, 21.387300491333065],
          [75.868186950683651, 21.39048957824707],
          [75.872261047363565, 21.395500183105526],
          [75.876152038574389, 21.39819145202631],
          [75.882125854492244, 21.398429870605412],
          [75.888107299804972, 21.399629592895451],
          [75.895637512207031, 21.398740768432731],
          [75.897056579590128, 21.397260665893555],
          [75.905082702637003, 21.395639419555664],
          [75.912277221679915, 21.39064979553234],
          [75.91654205322277, 21.389827728271541],
          [75.932342529297159, 21.391510009765739],
          [75.937377929687671, 21.392869949340877],
          [75.947967529297159, 21.39298057556158],
          [75.959396362304744, 21.396190643310661],
          [75.968742370605526, 21.393970489501953],
          [75.984878540039233, 21.377178192138672],
          [75.991607666015682, 21.376089096069336],
          [76.000236511230753, 21.374811172485465],
          [76.015975952148438, 21.369882583618164],
          [76.027496337890682, 21.36813926696783],
          [76.034599304199332, 21.36527061462408],
          [76.042022705078409, 21.358892440796012],
          [76.047042846679858, 21.35519981384283],
          [76.052375793457202, 21.352701187133732],
          [76.065658569336222, 21.359199523925781],
          [76.077247619628963, 21.364269256591854],
          [76.088150024414119, 21.369989395141658],
          [76.095046997070597, 21.372671127319336],
          [76.09867095947294, 21.373928070068303],
          [76.106948852539233, 21.360202789306641],
          [76.115966796875057, 21.338779449463004],
          [76.122245788574276, 21.321638107299862],
          [76.127265930176065, 21.307340621948299],
          [76.129257202148608, 21.297510147094783],
          [76.134971618652514, 21.291500091552848],
          [76.139877319336222, 21.288999557495174],
          [76.14499664306669, 21.287771224975586],
          [76.147140502929801, 21.281370162963924],
          [76.149803161621207, 21.274209976196346],
          [76.153869628906421, 21.268819808960075],
          [76.156036376953352, 21.263210296630916],
          [76.159217834472656, 21.259141921997127],
          [76.158096313476619, 21.253549575805664],
          [76.154289245605526, 21.249139785766545],
          [76.15091705322294, 21.245611190795842],
          [76.144126892090014, 21.242580413818416],
          [76.144096374511662, 21.24147987365734],
          [76.144401550293196, 21.238090515136719],
          [76.145530700683651, 21.233190536499137],
          [76.148010253906307, 21.231649398803825],
          [76.153289794922046, 21.229818344116211],
          [76.159332275390909, 21.227251052856445],
          [76.164031982421932, 21.224172592163143],
          [76.163146972656534, 21.221950531005859],
          [76.161521911621094, 21.216688156127987],
          [76.164276123047159, 21.211811065673828],
          [76.167945861816349, 21.208120346069393],
          [76.167709350586222, 21.205881118774414],
          [76.16705322265625, 21.203580856323299],
          [76.165718078613281, 21.200048446655273],
          [76.165908813476562, 21.195489883422965],
          [76.169082641601506, 21.191881179809684],
          [76.172721862793139, 21.188289642334098],
          [76.170639038086108, 21.182172775268612],
          [76.169136047363281, 21.174480438232422],
          [76.166847229003906, 21.170721054077205],
          [76.160888671874943, 21.172000885009766],
          [76.155059814453182, 21.172561645507926],
          [76.142982482910327, 21.173131942748967],
          [76.130706787109659, 21.175550460815543],
          [76.127418518066634, 21.17791938781744],
          [76.119392395019588, 21.174680709838867],
          [76.114318847656534, 21.170459747314453],
          [76.113960266113224, 21.164640426635799],
          [76.118911743164176, 21.160118103027401],
          [76.124099731445483, 21.159099578857536],
          [76.128417968750284, 21.156709671020565],
          [76.13169097900402, 21.152679443359432],
          [76.139923095703296, 21.140068054199276],
          [76.140922546386719, 21.13602256774908],
          [76.139343261718921, 21.133630752563533],
          [76.134170532226676, 21.130319595336914],
          [76.135665893554972, 21.126211166381779],
          [76.142143249512003, 21.12107086181652],
          [76.151466369628963, 21.114999771118278],
          [76.162216186523381, 21.109960556030387],
          [76.167442321777401, 21.10629844665533],
          [76.168457031250284, 21.105411529541016],
          [76.169113159179858, 21.103719711303711],
          [76.169311523437671, 21.101419448852596],
          [76.169273376464787, 21.098659515380973],
          [76.168136596679631, 21.093231201171989],
          [76.167022705078296, 21.089570999145565],
          [76.168647766113565, 21.085821151733398],
          [76.172637939453182, 21.084600448608512],
          [76.177276611328239, 21.085491180420036],
          [76.180778503417969, 21.087419509887695],
          [76.183860778808651, 21.089950561523494],
          [76.189071655273722, 21.090311050415039],
          [76.208686828613338, 21.090179443359489],
          [76.227493286132983, 21.091449737548771],
          [76.235107421875171, 21.093910217285213],
          [76.262107849121378, 21.094701766967887],
          [76.269248962402514, 21.092950820922852],
          [76.273246765136889, 21.085411071777457],
          [76.277763366699503, 21.078029632568416],
          [76.281768798828409, 21.075309753418082],
          [76.285766601562784, 21.076499938964844],
          [76.297119140625, 21.077180862426815],
          [76.33481597900402, 21.077180862426815],
          [76.356979370117358, 21.079669952392578],
          [76.361320495605753, 21.080001831054744],
          [76.365791320800781, 21.079071044921932],
          [76.368621826172046, 21.078701019287109],
          [76.37198638916044, 21.078559875488395],
          [76.376373291015909, 21.077310562133789],
          [76.37961578369169, 21.078479766845646],
          [76.38104248046875, 21.079071044921932],
          [76.382759094238281, 21.079561233520621],
          [76.390106201172159, 21.08805084228527],
          [76.396820068359318, 21.090570449829158],
          [76.409439086914233, 21.094089508056754],
          [76.411827087402401, 21.107269287109432],
          [76.433738708496321, 21.106689453125057],
          [76.4375, 21.107589721679688],
          [76.441070556640568, 21.112131118774528],
          [76.447708129883097, 21.112859725952092],
          [76.452690124511832, 21.1148681640625],
          [76.452919006347827, 21.124429702758789],
          [76.455932617187614, 21.131919860839957],
          [76.457511901855639, 21.138339996338004],
          [76.465499877929858, 21.139240264892635],
          [76.467002868652457, 21.14319038391119],
          [76.466758728027401, 21.147268295288143],
          [76.468971252441406, 21.150569915771428],
          [76.474891662597656, 21.152070999145508],
          [76.477020263671932, 21.155300140380973],
          [76.476737976074162, 21.161289215087891],
          [76.478286743164233, 21.175680160522518],
          [76.482452392578239, 21.188230514526367],
          [76.487373352051065, 21.196060180664006],
          [76.491172790527401, 21.197820663452205],
          [76.498077392578409, 21.196140289306754],
          [76.520782470703239, 21.189220428466854],
          [76.529197692871037, 21.189292907714901],
          [76.541297912597713, 21.196290969848746],
          [76.55938720703125, 21.205810546875],
          [76.575180053711108, 21.204072952270621],
          [76.576049804687557, 21.203662872314453],
          [76.586746215820597, 21.198682785034123],
          [76.60562896728544, 21.197162628173828],
          [76.612319946289347, 21.195911407470817],
          [76.616783142090014, 21.198570251464844],
          [76.620033264160156, 21.195440292358342],
          [76.623367309570597, 21.192659378051871],
          [76.626869201660327, 21.198810577392692],
          [76.631576538086222, 21.205369949340877],
          [76.631340026855696, 21.215641021728516],
          [76.631690979003963, 21.228900909423885],
          [76.637283325195597, 21.23911285400402],
          [76.642578125000057, 21.247720718383846],
          [76.64987945556669, 21.249019622802734],
          [76.658493041992301, 21.247810363769531],
          [76.659027099609659, 21.25324821472168],
          [76.659446716308707, 21.262130737304744],
          [76.660179138183878, 21.273599624633789],
          [76.661071777343807, 21.282421112060547],
          [76.648628234863452, 21.300041198730469],
          [76.639732360840071, 21.310649871826172],
          [76.625839233398722, 21.329740524291992],
          [76.624526977539347, 21.335100173950309],
          [76.628646850585994, 21.339771270752067],
          [76.668411254882926, 21.36947059631359],
          [76.719093322753963, 21.400650024414119],
          [76.732086181640909, 21.408809661865348],
          [76.737228393554972, 21.415290832519588],
          [76.738426208496037, 21.429380416870174],
          [76.743392944335881, 21.443140029907227],
          [76.756546020507756, 21.449928283691349],
          [76.775787353515909, 21.46013069152832],
          [76.784187316894645, 21.466489791870117],
          [76.78513336181669, 21.476720809936637],
          [76.790176391601563, 21.482360839843693],
          [76.791801452637003, 21.489891052246151],
          [76.786491394042912, 21.499229431152401],
          [76.770233154297159, 21.510749816894645],
          [76.762931823730526, 21.522649765014705],
          [76.767517089843807, 21.52754020690918],
          [76.775306701660156, 21.532020568847713],
          [76.785537719726506, 21.535301208496151],
          [76.787826538085881, 21.540130615234489],
          [76.784576416015739, 21.546052932739371],
          [76.782836914062784, 21.551469802856445],
          [76.780242919922046, 21.562467575073242],
          [76.783592224121378, 21.577970504760799],
          [76.791488647461108, 21.587419509887752],
          [76.793395996093921, 21.595172882080021],
          [76.795349121093807, 21.597539901733398],
          [76.803871154785327, 21.596830368042049],
          [76.82318115234375, 21.592681884765682],
          [76.833549499512003, 21.5930690765382],
          [76.838630676269531, 21.60050010681158],
          [76.847763061523608, 21.613300323486271],
          [76.852149963379077, 21.615030288696289],
          [76.860733032226733, 21.612302780151424],
          [76.891746520996378, 21.600700378418026],
          [76.901123046874943, 21.600809097290153],
          [76.905670166015909, 21.604499816894588],
          [76.911552429199276, 21.614931106567496],
          [76.978668212890852, 21.665979385376033],
          [76.997276306152514, 21.681610107421932],
          [77.001586914062784, 21.682159423828182],
          [77.010162353515682, 21.684391021728629],
          [77.018142700195369, 21.690799713134766],
          [77.023338317871378, 21.693780899047852],
          [77.029167175292969, 21.696060180664119],
          [77.034271240234546, 21.700511932373047],
          [77.059486389160156, 21.709400177002067],
          [77.062057495117472, 21.715049743652287],
          [77.069038391113281, 21.721809387207088],
          [77.072326660156477, 21.722930908203125],
          [77.074066162109659, 21.722610473632869],
          [77.075309753418139, 21.722370147705192],
          [77.080245971679858, 21.718692779541072],
          [77.083778381347713, 21.71862983703619],
          [77.093933105469034, 21.719631195068416],
          [77.103309631347599, 21.722642898559627],
          [77.104110717773608, 21.722890853881836],
          [77.114166259765739, 21.724861145019588],
          [77.121101379394531, 21.725349426269474],
          [77.133338928222713, 21.722320556640625],
          [77.147506713867472, 21.714651107788086],
          [77.157775878906477, 21.713409423828182],
          [77.160049438476619, 21.713739395141715],
          [77.162422180175895, 21.714107513427791],
          [77.165061950683878, 21.71692085266119],
          [77.168037414550838, 21.725759506225643],
          [77.17144775390625, 21.727260589599666],
          [77.183830261230639, 21.724500656128043],
          [77.188026428222827, 21.72257041931158],
          [77.187660217285156, 21.720729827880859],
          [77.184326171875284, 21.704460144043026],
          [77.201362609863452, 21.696319580078239],
          [77.207420349121378, 21.694009780883846],
          [77.210212707519588, 21.697120666503849],
          [77.217979431152514, 21.698429107666016],
          [77.221595764160327, 21.700109481811637],
          [77.222236633301009, 21.701679229736385],
          [77.223236083984659, 21.704181671142635],
          [77.224601745605582, 21.717889785766658],
          [77.239936828613281, 21.717121124267578],
          [77.255180358886719, 21.715190887451172],
          [77.258026123047046, 21.715829849243278],
          [77.262771606445483, 21.723630905151367],
          [77.267379760742358, 21.729070663452262],
          [77.283149719238395, 21.724220275878906],
          [77.285812377929972, 21.72882080078125],
          [77.286903381347884, 21.736442565917969],
          [77.285018920898722, 21.737501144409293],
          [77.283287048339901, 21.738491058349666],
          [77.283088684082259, 21.741649627685661],
          [77.28446197509794, 21.746448516845703],
          [77.282272338867188, 21.748130798339901],
          [77.278266906738281, 21.749139785766658],
          [77.277748107910384, 21.753759384155273],
          [77.277076721191577, 21.759809494018668],
          [77.279975891113281, 21.761262893676701],
          [77.286239624023608, 21.762750625610465],
          [77.293670654297046, 21.759918212890625],
          [77.308891296387003, 21.759649276733398],
          [77.321296691894645, 21.757030487060604],
          [77.325981140136776, 21.757360458374023],
          [77.337387084960937, 21.761560440063533],
          [77.339126586914119, 21.761659622192383],
          [77.342292785644474, 21.761831283569393],
          [77.353385925293139, 21.759460449218864],
          [77.375923156738281, 21.757110595703182],
          [77.401130676269588, 21.756179809570369],
          [77.405311584472713, 21.756731033325195],
          [77.412986755371151, 21.757730484008846],
          [77.426658630371094, 21.760400772094783],
          [77.438507080078182, 21.762720108032283],
          [77.443878173828352, 21.763519287109375],
          [77.449882507324389, 21.763410568237418],
          [77.452629089355526, 21.764320373535156],
          [77.458686828613452, 21.768180847168026],
          [77.471382141113565, 21.771249771118221],
          [77.475471496582202, 21.771440505981502],
          [77.477767944335937, 21.770221710205192],
          [77.477012634277344, 21.767959594726619],
          [77.475151062011946, 21.765739440918082],
          [77.475509643554744, 21.761850357055664],
          [77.475868225097656, 21.757881164550838],
          [77.488822937011889, 21.750249862671012],
          [77.492317199707259, 21.749790191650447],
          [77.496871948242244, 21.749200820922965],
          [77.499862670898608, 21.744890213012695],
          [77.506050109863509, 21.741212844848746],
          [77.508361816406307, 21.735282897949219],
          [77.517906188965128, 21.727010726928825],
          [77.518325805664176, 21.724370956420898],
          [77.518829345703352, 21.721160888671818],
          [77.521041870117358, 21.714130401611385],
          [77.523086547851847, 21.713621139526481],
          [77.523452758789347, 21.713541030883903],
          [77.526107788086222, 21.715032577514648],
          [77.533386230469034, 21.712690353393668],
          [77.535926818847827, 21.708259582519588],
          [77.542182922363224, 21.701030731201115],
          [77.544570922851619, 21.692432403564567],
          [77.545669555664063, 21.686071395874023],
          [77.547363281250171, 21.681560516357536],
          [77.550506591796932, 21.676282882690373],
          [77.558563232422159, 21.668672561645565],
          [77.557540893554744, 21.655588150024357],
          [77.560379028320369, 21.645181655883846],
          [77.565536499023494, 21.635032653808651],
          [77.57132720947294, 21.627040863037109],
          [77.57096099853544, 21.623519897460937],
          [77.567840576171932, 21.621059417724723],
          [77.56817626953125, 21.616231918334961],
          [77.569931030273494, 21.611141204834098],
          [77.572196960449219, 21.58767127990734],
          [77.570228576660099, 21.575668334960937],
          [77.569999694824503, 21.569789886474723],
          [77.570999145507983, 21.562620162963867],
          [77.574089050292969, 21.557500839233398],
          [77.579727172851847, 21.558151245117244],
          [77.585517883300952, 21.558809280395565],
          [77.590682983398438, 21.561611175537053],
          [77.605758666992188, 21.550910949707088],
          [77.607116699218807, 21.542770385742301],
          [77.594886779785156, 21.533170700073299],
          [77.589248657226847, 21.530349731445369],
          [77.577896118164233, 21.529211044311637],
          [77.566986083984318, 21.529750823974553],
          [77.553398132324503, 21.536172866821403],
          [77.540733337402401, 21.538919448852539],
          [77.535339355468921, 21.539049148559513],
          [77.529190063476847, 21.540769577026424],
          [77.511917114257813, 21.547510147094727],
          [77.507263183593864, 21.55081939697277],
          [77.504356384277401, 21.554668426513729],
          [77.484001159668082, 21.553302764892635],
          [77.46872711181669, 21.554491043090934],
          [77.464729309082145, 21.555971145629996],
          [77.457511901855639, 21.556570053100586],
          [77.451950073242301, 21.555610656738281],
          [77.450309753417969, 21.551940917968864],
          [77.450248718261662, 21.548379898071403],
          [77.446640014648608, 21.545610427856502],
          [77.442070007324389, 21.544649124145508],
          [77.431877136230526, 21.546400070190373],
          [77.428947448730469, 21.545660018920898],
          [77.423507690429972, 21.542560577392578],
          [77.419906616211051, 21.538698196411133],
          [77.416969299316463, 21.533060073852596],
          [77.418800354004077, 21.520839691162109],
          [77.420799255371321, 21.516281127929801],
          [77.43112945556669, 21.502220153808594],
          [77.439216613769702, 21.489322662353459],
          [77.437377929687557, 21.483531951904354],
          [77.435150146484659, 21.481639862060661],
          [77.437850952148381, 21.478202819824219],
          [77.438087463379077, 21.475559234619254],
          [77.438308715820369, 21.472919464111271],
          [77.43875885009794, 21.47278022766119],
          [77.448921203613224, 21.469671249389762],
          [77.452362060547046, 21.467990875244141],
          [77.453788757324446, 21.467292785644474],
          [77.457160949707202, 21.467071533203239],
          [77.469306945800895, 21.45689964294445],
          [77.468582153320483, 21.452909469604606],
          [77.469757080078125, 21.448680877685661],
          [77.468841552734432, 21.442920684814567],
          [77.469207763671932, 21.437049865722713],
          [77.473022460937557, 21.432689666748047],
          [77.477096557617472, 21.420860290527401],
          [77.481750488281421, 21.415668487548942],
          [77.484191894531364, 21.398509979248161],
          [77.482986450195369, 21.390380859375114],
          [77.487022399902628, 21.377750396728516],
          [77.501731872558707, 21.379249572753963],
          [77.510528564453068, 21.376760482788143],
          [77.51692199707054, 21.378032684326229],
          [77.517852783203182, 21.377849578857479],
          [77.520721435546932, 21.377300262451286],
          [77.524276733398608, 21.379730224609489],
          [77.528762817382869, 21.379070281982365],
          [77.539840698242472, 21.381170272827262],
          [77.548408508300838, 21.381229400634766],
          [77.562500000000057, 21.373380661010856],
          [77.565330505371094, 21.372629165649471],
          [77.570892333984432, 21.373260498046818],
          [77.575996398925781, 21.37047004699707],
          [77.580810546875057, 21.369131088256893],
          [77.582626342773381, 21.366800308227653],
          [77.584442138672102, 21.364479064941349],
          [77.587013244628849, 21.367750167846737],
          [77.601486206054801, 21.36527061462408],
          [77.604812622070313, 21.36699295043951],
          [77.605758666992188, 21.370351791381779],
          [77.602043151855753, 21.384201049804744],
          [77.60066223144554, 21.385902404785156],
          [77.600646972656307, 21.389120101928768],
          [77.599388122558707, 21.392089843750114],
          [77.599197387695426, 21.392549514770621],
          [77.600677490234432, 21.393180847168026],
          [77.601547241211108, 21.393558502197379],
          [77.611457824707202, 21.393810272216797],
          [77.615196228027628, 21.390659332275504],
          [77.62931060791044, 21.39097976684576],
          [77.636177062988565, 21.389499664306697],
          [77.639205932617244, 21.387939453124943],
          [77.641456604003963, 21.388679504394645],
          [77.642570495605469, 21.391410827636719],
          [77.645896911621378, 21.393360137939567],
          [77.650970458984375, 21.393390655517578],
          [77.651580810547102, 21.390190124511832],
          [77.662086486816463, 21.387971878051871],
          [77.663352966308594, 21.385629653930721],
          [77.663078308105753, 21.377450942993278],
          [77.664810180664176, 21.373630523681697],
          [77.667221069336165, 21.371490478515739],
          [77.668777465820597, 21.372301101684684],
          [77.670005798340014, 21.372922897338924],
          [77.675201416015682, 21.378810882568416],
          [77.68109130859375, 21.385490417480469],
          [77.68827056884777, 21.396730422973746],
          [77.691131591796989, 21.397069931030273],
          [77.693527221679744, 21.396541595459041],
          [77.694252014160156, 21.394542694091797],
          [77.692596435547102, 21.380649566650391],
          [77.695541381835881, 21.377759933471793],
          [77.704330444336108, 21.377700805664063],
          [77.705146789550838, 21.373451232910099],
          [77.705192565918026, 21.367280960083065],
          [77.705245971679801, 21.359069824218807],
          [77.724899291992301, 21.364152908325138],
          [77.733879089355412, 21.364730834960938],
          [77.738349914550838, 21.366630554199219],
          [77.743362426758097, 21.380069732666016],
          [77.746490478515796, 21.384210586547852],
          [77.749938964843921, 21.385709762573299],
          [77.756896972656534, 21.386409759521541],
          [77.761405944824219, 21.384420394897575],
          [77.765068054199446, 21.384662628173828],
          [77.776550292969034, 21.388029098510856],
          [77.785522460937784, 21.38939094543457],
          [77.790100097656534, 21.389240264892578],
          [77.793449401855469, 21.390739440918026],
          [77.793968200683764, 21.399610519409237],
          [77.795227050781307, 21.403778076171818],
          [77.795989990234432, 21.406259536743278],
          [77.798477172851847, 21.410709381103629],
          [77.799369812011776, 21.412300109863395],
          [77.804496765136719, 21.412000656127987],
          [77.818016052246264, 21.408729553222599],
          [77.833923339843977, 21.401519775390625],
          [77.846611022949389, 21.394109725952205],
          [77.854736328125057, 21.390720367431641],
          [77.863212585449389, 21.388120651245117],
          [77.876220703125, 21.386430740356559],
          [77.883377075195597, 21.385490417480469],
          [77.881866455078239, 21.377691268920955],
          [77.886642456054801, 21.380420684814453],
          [77.892311096191463, 21.379049301147518],
          [77.899040222168082, 21.378419876098746],
          [77.900718688965128, 21.378711700439453],
          [77.905509948730753, 21.379570007324219],
          [77.911766052246151, 21.382761001586971],
          [77.918251037597713, 21.38474082946783],
          [77.924888610839901, 21.386060714721737],
          [77.931762695312557, 21.385818481445426],
          [77.93878173828125, 21.386909484863338],
          [77.94111633300804, 21.398950576782283],
          [77.957748413086222, 21.401140213012809],
          [77.959953308105469, 21.401428222656364],
          [77.971549987793139, 21.401380538940543],
          [77.975997924804744, 21.402099609375],
          [77.980278015137003, 21.402799606323242],
          [77.995826721191463, 21.413780212402401],
          [77.99973297119169, 21.41616249084484],
          [78.004432678222713, 21.41588020324707],
          [78.007072448730469, 21.418411254882926],
          [78.019577026367301, 21.420589447021541],
          [78.029121398925895, 21.425359725952205],
          [78.043457031250171, 21.435031890869197],
          [78.051055908203239, 21.437032699585018],
          [78.063713073730469, 21.438859939575309],
          [78.078567504882983, 21.445711135864315],
          [78.092491149902514, 21.456010818481502],
          [78.100746154785213, 21.460950851440373],
          [78.109062194824389, 21.464181900024471],
          [78.127227783203125, 21.473400115966854],
          [78.142807006835881, 21.482110977172908],
          [78.169342041015796, 21.498500823974609],
          [78.170570373535384, 21.502059936523438],
          [78.17134094238304, 21.508501052856559],
          [78.177642822265682, 21.514318466186637],
          [78.168006896972827, 21.526041030883903],
          [78.171066284179858, 21.528739929199219],
          [78.171676635742187, 21.535762786865291],
          [78.170616149902628, 21.542190551757926],
          [78.172737121582145, 21.553302764892635],
          [78.177268981933651, 21.55669975280756],
          [78.18094635009777, 21.558681488037166],
          [78.215476989746037, 21.553730010986442],
          [78.226669311523494, 21.556440353393612],
          [78.238716125488565, 21.565490722656364],
          [78.24655914306652, 21.564010620117188],
          [78.269256591796989, 21.570711135864201],
          [78.270248413086108, 21.572370529174805],
          [78.26902008056669, 21.574729919433594],
          [78.258537292480753, 21.581899642944336],
          [78.255409240722656, 21.585239410400504],
          [78.255172729492358, 21.589841842651481],
          [78.257621765136832, 21.591840744018555],
          [78.262207031249943, 21.593759536743278],
          [78.266120910644588, 21.594280242919922],
          [78.271072387695369, 21.592960357666072],
          [78.281639099121378, 21.586759567260799],
          [78.300003051757983, 21.585058212280387],
          [78.301780700683651, 21.580400466919059],
          [78.301849365234659, 21.572870254516602],
          [78.304107666015682, 21.571430206298885],
          [78.308822631835994, 21.573690414428711],
          [78.318740844726619, 21.575588226318359],
          [78.322937011718807, 21.577381134033317],
          [78.328460693359375, 21.581180572509822],
          [78.336776733398551, 21.590520858764648],
          [78.342033386230526, 21.582870483398381],
          [78.347686767578296, 21.578861236572322],
          [78.354682922363565, 21.576908111572266],
          [78.360961914062784, 21.578298568725586],
          [78.366050720214901, 21.581920623779354],
          [78.374153137207145, 21.589969635009879],
          [78.377632141113452, 21.595600128173828],
          [78.372039794922159, 21.610769271850643],
          [78.371658325195597, 21.615030288696289],
          [78.375717163086108, 21.617450714111442],
          [78.379516601562443, 21.618650436401481],
          [78.383552551269702, 21.616638183593693],
          [78.389320373535213, 21.610561370849666],
          [78.392562866210994, 21.610099792480582],
          [78.399047851562557, 21.611080169677791],
          [78.404487609863395, 21.610099792480582],
          [78.410865783691463, 21.606599807739258],
          [78.419258117675838, 21.604299545288143],
          [78.422561645508097, 21.601949691772461],
          [78.415847778320369, 21.588150024414119],
          [78.413497924804858, 21.577739715576229],
          [78.415946960449162, 21.573080062866325],
          [78.419067382812557, 21.571601867675895],
          [78.422256469726733, 21.563720703125057],
          [78.420730590820483, 21.554798126220703],
          [78.420600891113338, 21.548780441284237],
          [78.421951293945369, 21.545841217041016],
          [78.425506591797046, 21.542270660400447],
          [78.42752838134794, 21.538320541381893],
          [78.426856994629077, 21.530199050903377],
          [78.427825927734375, 21.526750564575252],
          [78.432182312011889, 21.51991081237793],
          [78.430267333984546, 21.509162902832088],
          [78.430099487304858, 21.501750946044922],
          [78.438583374023722, 21.50375938415533],
          [78.444679260253963, 21.501920700073356],
          [78.451698303222713, 21.497331619262695],
          [78.454193115234602, 21.498310089111328],
          [78.456275939941463, 21.504451751708984],
          [78.459228515625114, 21.504631042480582],
          [78.461677551269815, 21.503538131713867],
          [78.465301513672159, 21.503538131713867],
          [78.470909118652514, 21.504869461059684],
          [78.472091674804744, 21.506929397583065],
          [78.480400085449332, 21.506120681762695],
          [78.483398437500057, 21.50774002075201],
          [78.485618591308594, 21.512039184570369],
          [78.490753173828296, 21.517971038818359],
          [78.49600982666044, 21.517971038818359],
          [78.497917175293253, 21.522960662841854],
          [78.502082824707088, 21.526630401611385],
          [78.504348754882869, 21.526702880859432],
          [78.50856018066429, 21.52843284606945],
          [78.520072937011832, 21.525379180908203],
          [78.524742126464901, 21.52583122253418],
          [78.528350830078125, 21.524620056152401],
          [78.537277221679858, 21.524562835693473],
          [78.546470642089844, 21.519969940185661],
          [78.552398681640682, 21.519390106201229],
          [78.556488037109659, 21.515819549560661],
          [78.560043334960994, 21.514610290527344],
          [78.566528320312557, 21.515697479248047],
          [78.564689636230753, 21.509321212768612],
          [78.565299987793139, 21.505979537963867],
          [78.573257446289347, 21.498500823974609],
          [78.581192016601619, 21.489641189575309],
          [78.584869384765682, 21.486881256103516],
          [78.593261718750057, 21.487689971923885],
          [78.598632812500284, 21.484809875488395],
          [78.601020812988281, 21.487159729003906],
          [78.605377197265796, 21.488370895385856],
          [78.616065979004077, 21.481519699096793],
          [78.620971679687614, 21.47754096984869],
          [78.625328063965128, 21.477830886840763],
          [78.630462646484659, 21.481330871582088],
          [78.637451171875, 21.484197616577262],
          [78.643547058105469, 21.484251022338867],
          [78.650657653808821, 21.482820510864258],
          [78.659088134765909, 21.478889465332145],
          [78.664176940918026, 21.480730056762695],
          [78.684066772461222, 21.481960296630916],
          [78.684440612793253, 21.477951049804801],
          [78.688301086425895, 21.478860855102596],
          [78.691963195800952, 21.478681564330998],
          [78.696182250976563, 21.477411270141715],
          [78.695747375488224, 21.474430084228629],
          [78.701622009277628, 21.474700927734489],
          [78.703880310058651, 21.471200942993164],
          [78.713912963867358, 21.467950820922852],
          [78.719757080078409, 21.464620590209961],
          [78.724189758300952, 21.464380264282283],
          [78.729728698730639, 21.47136116027832],
          [78.735122680664119, 21.471410751342887],
          [78.738838195800895, 21.472900390625057],
          [78.740402221679858, 21.483711242675781],
          [78.746482849121037, 21.493869781494254],
          [78.750518798828296, 21.490760803222656],
          [78.761039733886719, 21.48975944519043],
          [78.760787963867131, 21.484710693359375],
          [78.76438140869169, 21.474279403686637],
          [78.772186279297159, 21.467130661010799],
          [78.775520324707202, 21.47351264953619],
          [78.777046203613452, 21.47907829284668],
          [78.78016662597679, 21.480808258056697],
          [78.784622192382926, 21.489139556884766],
          [78.789688110351619, 21.48850059509283],
          [78.792816162109489, 21.489860534667969],
          [78.810096740722713, 21.490869522094783],
          [78.813133239746151, 21.488729476928768],
          [78.819259643554915, 21.489629745483455],
          [78.823379516601733, 21.491119384765739],
          [78.827949523925952, 21.489959716796989],
          [78.844177246093921, 21.489971160888729],
          [78.847717285156534, 21.491460800170842],
          [78.851547241211222, 21.495700836181697],
          [78.875137329101619, 21.487928390502987],
          [78.879852294922046, 21.484970092773551],
          [78.885375976562671, 21.485591888427791],
          [78.890487670898381, 21.498239517211857],
          [78.895767211914119, 21.500568389892521],
          [78.902732849121264, 21.498018264770621],
          [78.907928466796932, 21.494251251220817],
          [78.92057037353544, 21.487630844116325],
          [78.931831359863565, 21.487400054931754],
          [78.933799743652514, 21.492389678955078],
          [78.936897277832031, 21.510440826416129],
          [78.940643310546989, 21.513700485229549],
          [78.93869781494169, 21.517288208007813],
          [78.936332702636719, 21.519390106201229],
          [78.926239013671932, 21.521640777587947],
          [78.92343902587919, 21.523788452148437],
          [78.923400878906477, 21.533081054687614],
          [78.924575805664347, 21.538681030273438],
          [78.921798706054858, 21.543188095092773],
          [78.904426574707202, 21.554840087890568],
          [78.909095764160384, 21.561750411987362],
          [78.912719726562727, 21.563129425048771],
          [78.923980712890852, 21.560150146484489],
          [78.927825927734659, 21.56028938293457],
          [78.928390502929972, 21.564430236816406],
          [78.919898986816577, 21.56895828247076],
          [78.914337158203068, 21.569641113281307],
          [78.911636352539347, 21.570909500122013],
          [78.912178039551065, 21.585180282592773],
          [78.913238525390625, 21.592359542846623],
          [78.922676086426065, 21.592609405517635],
          [78.929061889648608, 21.594631195068359],
          [78.940345764160213, 21.593759536743278],
          [78.94586181640625, 21.596040725708121],
          [78.962272644042969, 21.605880737304744],
          [78.974761962890909, 21.617559432983398],
          [78.981491088867358, 21.617160797119141],
          [78.994445800781193, 21.618749618530273],
          [78.997383117675838, 21.615779876708928],
          [78.999992370605639, 21.609798431396541],
          [79.005798339843977, 21.604021072387752],
          [79.009552001953296, 21.601499557495231],
          [79.030960083007869, 21.605609893798942],
          [79.042930603027514, 21.604709625244084],
          [79.04791259765625, 21.605690002441463],
          [79.050750732422046, 21.603942871093807],
          [79.076080322265568, 21.607681274414063],
          [79.081550598144815, 21.607151031494254],
          [79.088088989257756, 21.599189758300838],
          [79.092033386230526, 21.603429794311467],
          [79.098098754882869, 21.602840423583984],
          [79.104110717773381, 21.609359741211051],
          [79.099479675293253, 21.612270355224666],
          [79.09873199462919, 21.616310119628906],
          [79.099166870117358, 21.618900299072322],
          [79.111236572265625, 21.62556266784668],
          [79.127738952637003, 21.628059387207145],
          [79.137077331543253, 21.636850357055778],
          [79.14109039306669, 21.639530181884822],
          [79.147132873535384, 21.656560897827205],
          [79.147827148437671, 21.660520553588867],
          [79.186187744140625, 21.654428482055778],
          [79.216606140137003, 21.650190353393555],
          [79.219902038574389, 21.650810241699219],
          [79.221572875976847, 21.65690994262701],
          [79.226936340332145, 21.657649993896541],
          [79.228401184082088, 21.671390533447322],
          [79.226829528808651, 21.67439079284668],
          [79.224555969238338, 21.675880432128963],
          [79.220161437988338, 21.677000045776481],
          [79.218170166015568, 21.681261062622127],
          [79.220916748046932, 21.696590423584098],
          [79.221878051757869, 21.700599670410156],
          [79.234771728515568, 21.715208053588867],
          [79.228927612304744, 21.720489501953182],
          [79.228080749511832, 21.721910476684684],
          [79.228691101074389, 21.7239284515382],
          [79.257667541504077, 21.717540740966854],
          [79.26486968994169, 21.714920043945313],
          [79.271759033203239, 21.709039688110352],
          [79.274780273437784, 21.705230712890682],
          [79.276802062988338, 21.700229644775504],
          [79.284812927246151, 21.693910598754996],
          [79.317337036132926, 21.685819625854435],
          [79.320251464843921, 21.686599731445426],
          [79.322135925293139, 21.688381195068416],
          [79.342613220214901, 21.68451118469244],
          [79.348320007324219, 21.684408187866268],
          [79.349021911621037, 21.678890228271598],
          [79.361785888671989, 21.679510116577262],
          [79.383079528808821, 21.675390243530273],
          [79.394737243652628, 21.674591064453239],
          [79.397087097167912, 21.675640106201286],
          [79.400451660156307, 21.679649353027401],
          [79.407722473144815, 21.685560226440487],
          [79.411399841308764, 21.690967559814453],
          [79.415779113769474, 21.691448211670036],
          [79.422981262207315, 21.690572738647575],
          [79.427963256836051, 21.685260772705078],
          [79.432243347167969, 21.683490753173771],
          [79.440727233887003, 21.68223953247076],
          [79.451011657715128, 21.684337615966854],
          [79.458511352539233, 21.687322616577262],
          [79.488578796387003, 21.674121856689567],
          [79.489639282226562, 21.665800094604435],
          [79.490890502929972, 21.66370964050293],
          [79.494560241699389, 21.660539627075309],
          [79.497383117676065, 21.651939392089844],
          [79.499290466308878, 21.647848129272575],
          [79.501136779785384, 21.645717620849553],
          [79.500267028808537, 21.640520095825138],
          [79.502639770507869, 21.634599685669059],
          [79.509597778320426, 21.633361816406364],
          [79.511619567871151, 21.631130218505916],
          [79.512458801269645, 21.626480102539119],
          [79.508506774902514, 21.622861862182731],
          [79.504730224609432, 21.62326812744152],
          [79.503242492676009, 21.622360229492131],
          [79.501129150390682, 21.619649887084961],
          [79.498191833496264, 21.612369537353516],
          [79.503082275390909, 21.607509613037166],
          [79.506813049316406, 21.60238075256342],
          [79.505821228027514, 21.590280532836971],
          [79.510665893554744, 21.583160400390682],
          [79.521713256835994, 21.580320358276481],
          [79.527656555176009, 21.574800491333065],
          [79.532142639160327, 21.572980880737362],
          [79.537559509277401, 21.568990707397518],
          [79.539520263672159, 21.565200805664062],
          [79.536056518554744, 21.55496978759777],
          [79.533897399902344, 21.550760269165096],
          [79.534233093261889, 21.548168182373104],
          [79.536621093750227, 21.544218063354549],
          [79.547386169433537, 21.544298171997127],
          [79.560310363769815, 21.548019409179688],
          [79.571357727051065, 21.543800354003906],
          [79.57614898681669, 21.543359756469783],
          [79.589523315429801, 21.549558639526424],
          [79.594909667968921, 21.54965972900402],
          [79.599388122558651, 21.550769805908203],
          [79.608711242676009, 21.555931091308707],
          [79.616821289062671, 21.557210922241325],
          [79.62534332275419, 21.554861068725643],
          [79.634269714355696, 21.554950714111328],
          [79.640747070312557, 21.555480957031307],
          [79.647476196289347, 21.557172775268612],
          [79.650619506835938, 21.558809280395565],
          [79.653945922851847, 21.56345176696783],
          [79.658142089844034, 21.577331542968864],
          [79.66294097900419, 21.579710006713924],
          [79.684837341308651, 21.580690383911133],
          [79.689346313476562, 21.583641052246037],
          [79.691223144531421, 21.587890625],
          [79.693809509277628, 21.590951919555664],
          [79.699340820312784, 21.592321395874137],
          [79.706176757812727, 21.590900421142635],
          [79.713821411132869, 21.591131210327205],
          [79.732620239257983, 21.602529525756836],
          [79.744888305664119, 21.597869873046932],
          [79.768798828125284, 21.590431213378963],
          [79.791816711426009, 21.581409454345817],
          [79.803192138672046, 21.572629928588924],
          [79.811653137207259, 21.564300537109432],
          [79.818191528320597, 21.55900955200201],
          [79.825042724609659, 21.546720504760856],
          [79.841537475586108, 21.541818618774471],
          [79.850563049316634, 21.537530899047795],
          [79.854759216308821, 21.53252029418951],
          [79.857078552246378, 21.530921936035213],
          [79.871879577636719, 21.529560089111271],
          [79.876686096191463, 21.528470993041935],
          [79.885826110839901, 21.52964019775402],
          [79.889762878418139, 21.523880004882926],
          [79.892288208007812, 21.523260116577262],
          [79.901191711425724, 21.524360656738281],
          [79.915817260742244, 21.524480819702148],
          [79.91831207275419, 21.540311813354492],
          [79.921249389648608, 21.546199798583984],
          [79.927192687988281, 21.553730010986442],
          [79.931037902832088, 21.555610656738281],
          [79.936386108398494, 21.556800842285156],
          [79.947097778320369, 21.555250167846737],
          [79.961448669433707, 21.558000564575195],
          [79.966247558593921, 21.557270050048828],
          [79.971778869629077, 21.555120468139762],
          [79.985580444335994, 21.53677940368658],
          [79.993553161621264, 21.534711837768668],
          [79.996696472168253, 21.535310745239315],
          [79.998199462890852, 21.536640167236328],
          [80.002082824707145, 21.538970947265739],
          [80.004760742187443, 21.54087066650402],
          [80.007469177246264, 21.542568206787109],
          [80.010009765625057, 21.54459190368658],
          [80.012237548828296, 21.545980453491325],
          [80.014656066894815, 21.547351837158203],
          [80.016899108886776, 21.548851013183651],
          [80.019126892089844, 21.550790786743221],
          [80.022651672363565, 21.553819656372127],
          [80.026176452636719, 21.556650161743164],
          [80.028228759765568, 21.557340621948299],
          [80.031990051269815, 21.557558059692326],
          [80.034393310546875, 21.557470321655273],
          [80.038406372070369, 21.556859970092887],
          [80.041557312011832, 21.55624961853033],
          [80.044036865234489, 21.555149078369141],
          [80.04557037353527, 21.554750442504883],
          [80.048156738281307, 21.554149627685661],
          [80.050071716308821, 21.554119110107536],
          [80.050743103027514, 21.554119110107536],
          [80.054199218750171, 21.553541183471737],
          [80.057197570800895, 21.55360031127924],
          [80.059646606445597, 21.553730010986442],
          [80.061187744140909, 21.554019927978516],
          [80.062118530273722, 21.554241180419979],
          [80.063568115234375, 21.554580688476619],
          [80.066589355468921, 21.556840896606445],
          [80.06845855712902, 21.5584716796875],
          [80.070022583007983, 21.560380935669059],
          [80.071159362793139, 21.562000274658203],
          [80.073326110839901, 21.563850402832031],
          [80.075080871582088, 21.565139770507756],
          [80.077041625976676, 21.56675910949707],
          [80.078758239746207, 21.568399429321403],
          [80.082015991210881, 21.571769714355582],
          [80.084838867187784, 21.576179504394645],
          [80.086692810058821, 21.578559875488338],
          [80.089675903320483, 21.582281112670898],
          [80.090812683105639, 21.583562850952262],
          [80.093299865722827, 21.585371017456055],
          [80.094017028808707, 21.586299896240291],
          [80.096321105956974, 21.587432861328239],
          [80.098747253418253, 21.58865928649908],
          [80.100402832031307, 21.588739395141658],
          [80.102096557617188, 21.589389801025447],
          [80.105606079101847, 21.591110229492188],
          [80.107933044433707, 21.592119216918945],
          [80.109901428222827, 21.593410491943473],
          [80.111572265624943, 21.596479415893612],
          [80.112190246582202, 21.599550247192383],
          [80.112426757812557, 21.600809097290153],
          [80.112869262695597, 21.603771209716797],
          [80.114936828613338, 21.607009887695369],
          [80.118576049804972, 21.608898162841911],
          [80.121452331543253, 21.609060287475643],
          [80.124099731445369, 21.608610153198242],
          [80.126228332519815, 21.608301162719727],
          [80.132987976074219, 21.605609893798942],
          [80.137519836425724, 21.605199813842773],
          [80.140686035156307, 21.604721069335994],
          [80.143920898437727, 21.604972839355582],
          [80.147872924804687, 21.60630035400402],
          [80.149986267089901, 21.607419967651481],
          [80.152641296386719, 21.609701156616325],
          [80.154991149902401, 21.611799240112418],
          [80.156738281250284, 21.614120483398551],
          [80.159919738769588, 21.617490768432731],
          [80.162101745605582, 21.619489669799805],
          [80.164993286132983, 21.621730804443359],
          [80.168952941894815, 21.623201370239258],
          [80.171127319336108, 21.623741149902344],
          [80.173393249511889, 21.62412071228033],
          [80.174911499023608, 21.623960494995174],
          [80.176727294922102, 21.623920440673942],
          [80.180313110351619, 21.625520706176758],
          [80.182373046875171, 21.627040863037109],
          [80.183692932129077, 21.628490447998104],
          [80.185195922851506, 21.630640029907227],
          [80.186187744140796, 21.632669448852653],
          [80.188217163086222, 21.634201049804687],
          [80.189422607422046, 21.634250640869254],
          [80.192108154297046, 21.634620666503906],
          [80.195152282715014, 21.634939193725586],
          [80.200401306152628, 21.634700775146484],
          [80.204696655273608, 21.633541107177734],
          [80.207977294921932, 21.629650115966911],
          [80.210395812988452, 21.626279830932731],
          [80.212036132812784, 21.624219894409123],
          [80.214653015136776, 21.62124061584484],
          [80.216308593750171, 21.620340347290039],
          [80.220588684082259, 21.61963081359869],
          [80.22688293457054, 21.620101928710938],
          [80.232070922851847, 21.620452880859318],
          [80.235969543457202, 21.620769500732422],
          [80.240142822265796, 21.62051963806158],
          [80.242698669433651, 21.620491027832031],
          [80.247627258300781, 21.62249946594244],
          [80.252067565918196, 21.622249603271598],
          [80.255279541015682, 21.620729446411133],
          [80.256652832031307, 21.620281219482479],
          [80.260223388671875, 21.620149612426758],
          [80.264976501464844, 21.616558074951172],
          [80.270866394043139, 21.610620498657227],
          [80.272377014160327, 21.607120513916072],
          [80.273742675781421, 21.602630615234432],
          [80.275436401367358, 21.599079132080135],
          [80.279800415039006, 21.596130371093807],
          [80.282829284668253, 21.595119476318473],
          [80.286582946777571, 21.59343147277832],
          [80.288009643554631, 21.592290878295955],
          [80.288642883300781, 21.5896511077882],
          [80.289093017578409, 21.588430404663143],
          [80.289787292480469, 21.585912704467773],
          [80.290267944336222, 21.582630157470703],
          [80.291915893554744, 21.578029632568359],
          [80.295372009277401, 21.575479507446232],
          [80.299087524414233, 21.575389862060547],
          [80.303367614746321, 21.576129913330078],
          [80.307640075683707, 21.576740264892578],
          [80.309883117676065, 21.577341079712028],
          [80.312995910644474, 21.577091217041016],
          [80.316932678222713, 21.575681686401424],
          [80.318840026855526, 21.574550628662223],
          [80.320182800293253, 21.573579788207951],
          [80.321395874023608, 21.570590972900391],
          [80.322837829589901, 21.567430496215934],
          [80.324645996093921, 21.564100265503043],
          [80.326286315918253, 21.561580657959098],
          [80.327468872070426, 21.559640884399528],
          [80.328582763672159, 21.558269500732479],
          [80.329772949218693, 21.556310653686467],
          [80.330093383789119, 21.554700851440487],
          [80.329086303710994, 21.553659439086971],
          [80.327285766601676, 21.551740646362248],
          [80.325592041015796, 21.55034065246582],
          [80.324432373046818, 21.548717498779354],
          [80.32740783691429, 21.546091079712028],
          [80.329689025879134, 21.544441223144588],
          [80.330978393554688, 21.543701171875057],
          [80.332946777343807, 21.542209625244141],
          [80.335166931152344, 21.540740966796875],
          [80.338012695312671, 21.538749694824276],
          [80.339675903320426, 21.53790283203125],
          [80.342292785644588, 21.537420272827262],
          [80.346397399902514, 21.535720825195426],
          [80.351890563964957, 21.533002853393668],
          [80.356910705566406, 21.530799865722599],
          [80.362190246582145, 21.528490066528377],
          [80.365829467773381, 21.526340484619141],
          [80.367622375488338, 21.524679183959961],
          [80.369232177734659, 21.522911071777401],
          [80.370613098144702, 21.520969390869254],
          [80.370796203613452, 21.517869949340934],
          [80.370857238769588, 21.517091751098746],
          [80.371177673340014, 21.515148162841854],
          [80.372482299804801, 21.512790679931641],
          [80.373573303222713, 21.509450912475586],
          [80.373863220215014, 21.505081176757813],
          [80.373886108398438, 21.503061294555664],
          [80.374229431152514, 21.501100540161076],
          [80.374557495117472, 21.498979568481559],
          [80.374839782714844, 21.49591064453125],
          [80.374862670898494, 21.494831085205192],
          [80.374946594238565, 21.492870330810604],
          [80.375328063965128, 21.491140365600586],
          [80.375785827636889, 21.490940093994197],
          [80.377677917480639, 21.490129470825252],
          [80.378585815429801, 21.489330291748047],
          [80.380210876464901, 21.487270355224609],
          [80.381706237792969, 21.484800338745117],
          [80.382720947265852, 21.482440948486442],
          [80.383666992187727, 21.479000091552848],
          [80.384452819824276, 21.476350784301758],
          [80.386856079101563, 21.473432540893612],
          [80.389945983886776, 21.470928192138729],
          [80.392097473144815, 21.469390869140568],
          [80.395286560058651, 21.467870712280273],
          [80.396591186523438, 21.467239379882926],
          [80.399040222168139, 21.466400146484375],
          [80.400962829590014, 21.465431213378906],
          [80.402236938476676, 21.463371276855526],
          [80.403678894043026, 21.461309432983512],
          [80.404533386230582, 21.458610534668026],
          [80.404678344726847, 21.456359863281364],
          [80.405357360839844, 21.454401016235352],
          [80.406440734863395, 21.451192855835075],
          [80.408256530761776, 21.447219848632926],
          [80.409477233887003, 21.443599700927734],
          [80.410552978515682, 21.440160751342717],
          [80.411308288574276, 21.438201904296932],
          [80.410240173340128, 21.436399459838867],
          [80.408622741699276, 21.434829711914176],
          [80.406005859375057, 21.432451248168945],
          [80.404266357422102, 21.43070030212408],
          [80.401611328125057, 21.428079605102539],
          [80.398918151855526, 21.42494010925293],
          [80.398033142090128, 21.423089981079045],
          [80.399963378906193, 21.41948127746582],
          [80.399246215820483, 21.417909622192496],
          [80.396781921386719, 21.415349960327262],
          [80.39347076416027, 21.412670135498047],
          [80.389900207519702, 21.408889770507926],
          [80.38907623291027, 21.407379150390739],
          [80.389060974121378, 21.404319763183707],
          [80.389831542969034, 21.400871276855582],
          [80.391532897949503, 21.396631240844727],
          [80.393898010254077, 21.39215087890625],
          [80.396537780761662, 21.387849807739258],
          [80.397926330566406, 21.384109497070426],
          [80.399353027344034, 21.380491256713867],
          [80.401123046875171, 21.37827110290533],
          [80.401969909668026, 21.377811431884822],
          [80.403366088867472, 21.37648963928234],
          [80.404441833496151, 21.375810623168945],
          [80.406562805176009, 21.376409530639762],
          [80.408447265625057, 21.376089096069336],
          [80.410285949707202, 21.375459671020508],
          [80.414077758789006, 21.375272750854606],
          [80.417602539062557, 21.375650405883789],
          [80.420951843261662, 21.375682830810547],
          [80.422966003418196, 21.375240325927848],
          [80.424942016601676, 21.374500274658146],
          [80.426856994628849, 21.373081207275447],
          [80.427581787109659, 21.372909545898438],
          [80.430480957031193, 21.371892929077148],
          [80.433532714843693, 21.371181488037166],
          [80.435607910156534, 21.371250152587834],
          [80.437240600585994, 21.371379852294979],
          [80.440406799316349, 21.372100830078239],
          [80.442947387695313, 21.373798370361328],
          [80.443641662597599, 21.376399993896428],
          [80.443748474121321, 21.379690170288029],
          [80.443290710449389, 21.384639739990234],
          [80.443206787109659, 21.387992858886719],
          [80.444267272949219, 21.390529632568359],
          [80.445587158203296, 21.392560958862362],
          [80.447067260742301, 21.395570755004996],
          [80.447647094726506, 21.398460388183594],
          [80.448318481445369, 21.40233039855957],
          [80.450698852539006, 21.402349472046012],
          [80.453338623047159, 21.400360107421875],
          [80.454750061035327, 21.399660110473633],
          [80.456359863281307, 21.398700714111442],
          [80.460166931152401, 21.397010803222713],
          [80.462852478027628, 21.39635086059576],
          [80.464317321777401, 21.395900726318359],
          [80.466766357422046, 21.395570755004996],
          [80.468177795410213, 21.395240783691406],
          [80.471351623535156, 21.395839691162223],
          [80.473876953125057, 21.399320602417106],
          [80.474761962890796, 21.395750045776367],
          [80.475616455078182, 21.394729614257869],
          [80.478973388672046, 21.395908355712891],
          [80.481452941894702, 21.396970748901424],
          [80.483963012695369, 21.397270202636832],
          [80.485496520996151, 21.397638320922908],
          [80.489898681640682, 21.39635086059576],
          [80.493438720703296, 21.39423942565918],
          [80.496330261230639, 21.392940521240348],
          [80.500556945800838, 21.390779495239315],
          [80.502891540527401, 21.390581130981502],
          [80.505691528320312, 21.390720367431641],
          [80.508872985839787, 21.391090393066463],
          [80.511405944824219, 21.391860961914119],
          [80.514717102050838, 21.391019821167049],
          [80.516510009765568, 21.390518188476619],
          [80.519432067871094, 21.389570236206168],
          [80.520370483398438, 21.388250350952262],
          [80.521667480468921, 21.387340545654297],
          [80.524200439453125, 21.383720397949332],
          [80.526863098144531, 21.381668090820312],
          [80.529716491699219, 21.380950927734375],
          [80.532035827636776, 21.377281188964844],
          [80.533111572265796, 21.374860763549862],
          [80.534248352050724, 21.372051239013672],
          [80.536880493164347, 21.369131088256893],
          [80.539649963378906, 21.368520736694393],
          [80.540916442871037, 21.368120193481559],
          [80.544242858886776, 21.367290496826172],
          [80.545776367187557, 21.366260528564567],
          [80.550231933594034, 21.364740371704102],
          [80.555198669433878, 21.362710952758846],
          [80.558219909668253, 21.361288070678768],
          [80.559013366699503, 21.361129760742244],
          [80.559677124023438, 21.360380172729606],
          [80.564170837402457, 21.357870101928768],
          [80.563766479492472, 21.355739593505916],
          [80.561096191406534, 21.354402542114371],
          [80.558372497558651, 21.353162765503043],
          [80.558036804199503, 21.351030349731445],
          [80.559829711914233, 21.348569869995231],
          [80.560539245605753, 21.345460891723576],
          [80.561363220215014, 21.343309402465934],
          [80.564178466796989, 21.342779159545955],
          [80.566360473632869, 21.342800140380973],
          [80.569091796875284, 21.344430923461971],
          [80.571769714355753, 21.345609664916992],
          [80.575439453124943, 21.343790054321289],
          [80.577888488769815, 21.343000411987362],
          [80.580276489257813, 21.342100143432731],
          [80.581626892089901, 21.341590881347599],
          [80.58241271972679, 21.337221145629996],
          [80.58188629150419, 21.334329605102596],
          [80.583076477050724, 21.331169128417969],
          [80.586723327636889, 21.329460144043026],
          [80.589469909668196, 21.328340530395508],
          [80.591270446777287, 21.326740264892635],
          [80.593162536621207, 21.324790954589957],
          [80.597396850586108, 21.323499679565487],
          [80.599411010742244, 21.323230743408203],
          [80.602348327636889, 21.323720932006893],
          [80.605316162109432, 21.324310302734432],
          [80.608512878418026, 21.323932647705192],
          [80.610092163085994, 21.322620391845646],
          [80.610961914062671, 21.321701049804801],
          [80.612991333008097, 21.320341110229606],
          [80.617752075195597, 21.319171905517692],
          [80.620666503906421, 21.320159912109432],
          [80.623283386230753, 21.321460723877067],
          [80.624916076660213, 21.321821212768612],
          [80.628326416015625, 21.322589874267692],
          [80.631790161132869, 21.323720932006893],
          [80.633560180664347, 21.324188232421989],
          [80.638175964355582, 21.324859619140625],
          [80.644386291503963, 21.325479507446289],
          [80.64829254150402, 21.32637977600092],
          [80.650428771972827, 21.329931259155273],
          [80.651771545410327, 21.331190109253043],
          [80.656532287597827, 21.330772399902344],
          [80.657936096191463, 21.329370498657283],
          [80.659866333007869, 21.32777023315424],
          [80.662399291992301, 21.326120376586971],
          [80.663558959960881, 21.324859619140625],
          [80.665596008300838, 21.322111129760742],
          [80.666542053222713, 21.319351196289119],
          [80.666999816894474, 21.316181182861328],
          [80.668060302734602, 21.313819885253963],
          [80.670951843262003, 21.312280654907227],
          [80.672737121582202, 21.311269760131836],
          [80.673789978027401, 21.309080123901481],
          [80.672370910644702, 21.305889129638672],
          [80.673088073730582, 21.301179885864371],
          [80.672950744629077, 21.298288345337028],
          [80.670959472656534, 21.29590988159174],
          [80.668289184570597, 21.293991088867244],
          [80.665267944336051, 21.292291641235352],
          [80.663322448730753, 21.290950775146428],
          [80.660896301269474, 21.289779663085937],
          [80.658088684082031, 21.289409637451286],
          [80.654808044433764, 21.289510726928711],
          [80.653686523437671, 21.286041259765739],
          [80.652153015136889, 21.28325271606451],
          [80.650802612304858, 21.281589508056754],
          [80.648620605468807, 21.280170440673885],
          [80.64676666259777, 21.278142929077205],
          [80.644889831543139, 21.276002883911246],
          [80.643409729003906, 21.272291183471793],
          [80.642646789550781, 21.269050598144588],
          [80.641906738281307, 21.264429092407227],
          [80.64111328125, 21.261430740356502],
          [80.639480590820597, 21.257499694824219],
          [80.638732910156534, 21.254781723022461],
          [80.637359619140682, 21.252691268920898],
          [80.635307312012003, 21.250139236450195],
          [80.63224029541044, 21.247299194335994],
          [80.627670288086222, 21.245700836181754],
          [80.624641418457145, 21.244289398193359],
          [80.620101928711108, 21.242361068725529],
          [80.615722656250171, 21.240020751953182],
          [80.613441467285327, 21.236829757690373],
          [80.611709594726733, 21.234569549560604],
          [80.610488891601847, 21.233291625976563],
          [80.608688354492188, 21.231790542602539],
          [80.607666015625114, 21.231250762939396],
          [80.606086730957088, 21.229970932006779],
          [80.605079650878963, 21.228759765625057],
          [80.603446960449503, 21.227422714233455],
          [80.600997924804631, 21.226182937622127],
          [80.598899841308537, 21.225128173828182],
          [80.596221923828239, 21.224531173706112],
          [80.592323303222713, 21.224840164184627],
          [80.589385986328296, 21.224710464477653],
          [80.58447265625, 21.223060607910213],
          [80.581550598144474, 21.221771240234489],
          [80.57810211181652, 21.219900131225586],
          [80.574836730957315, 21.218259811401424],
          [80.571838378906421, 21.216850280761662],
          [80.568428039550952, 21.213882446289119],
          [80.566612243652628, 21.210809707641602],
          [80.566116333007983, 21.210279464721793],
          [80.564025878906421, 21.208021163940543],
          [80.561241149902571, 21.205810546875],
          [80.557792663574276, 21.203939437866268],
          [80.553672790527628, 21.202510833740234],
          [80.55063629150402, 21.201171875000114],
          [80.549301147461051, 21.200981140136832],
          [80.546569824218807, 21.200668334960937],
          [80.543510437011946, 21.200019836425895],
          [80.541877746581974, 21.199190139770508],
          [80.538887023925781, 21.199289321899471],
          [80.534980773926065, 21.199609756469727],
          [80.532341003417912, 21.200220108032283],
          [80.530456542968921, 21.200839996337947],
          [80.527900695801065, 21.202020645141545],
          [80.525016784668026, 21.202632904052848],
          [80.520736694336108, 21.203540802002067],
          [80.518226623535099, 21.201080322265625],
          [80.516242980957088, 21.198299407958984],
          [80.514801025390796, 21.196039199829158],
          [80.513168334960994, 21.193611145019531],
          [80.511550903320256, 21.191110610962028],
          [80.510810852050952, 21.188909530639762],
          [80.510330200195369, 21.186491012573242],
          [80.509323120117188, 21.183479309081974],
          [80.507637023925838, 21.182441711425838],
          [80.504531860351733, 21.183040618896484],
          [80.502571105957145, 21.183309555053768],
          [80.499893188476676, 21.184040069580135],
          [80.497879028320312, 21.184032440185604],
          [80.495498657226847, 21.183258056640739],
          [80.492309570312671, 21.179941177368164],
          [80.489532470703352, 21.177560806274528],
          [80.486000061035327, 21.177190780639648],
          [80.481811523437671, 21.176570892333984],
          [80.479438781738338, 21.174930572509879],
          [80.477096557617244, 21.173070907592887],
          [80.474906921386832, 21.171430587768555],
          [80.473342895508097, 21.171310424804687],
          [80.467849731445426, 21.171489715576229],
          [80.464187622070597, 21.172090530395508],
          [80.461631774902344, 21.172821044921875],
          [80.457298278808821, 21.172840118408317],
          [80.455268859863395, 21.169080734253043],
          [80.454269409179972, 21.165437698364258],
          [80.454002380371094, 21.161741256713867],
          [80.453918457031534, 21.158622741699332],
          [80.452819824218921, 21.154340744018612],
          [80.451576232910384, 21.149650573730526],
          [80.450096130371378, 21.146919250488281],
          [80.449218750000171, 21.144428253173942],
          [80.448211669921989, 21.14152908325201],
          [80.446960449218807, 21.138149261474723],
          [80.446029663085994, 21.13578033447277],
          [80.444023132324162, 21.130609512329158],
          [80.442466735840128, 21.128160476684684],
          [80.440727233887003, 21.125471115112305],
          [80.438652038574503, 21.121400833129883],
          [80.440376281738565, 21.120309829711971],
          [80.443870544433764, 21.119251251220817],
          [80.446189880371094, 21.118169784546012],
          [80.448226928710881, 21.116279602050895],
          [80.449142456054972, 21.115310668945369],
          [80.449333190918253, 21.114850997924862],
          [80.449249267578182, 21.111940383911246],
          [80.446960449218807, 21.111061096191406],
          [80.445503234863565, 21.111259460449276],
          [80.443717956543026, 21.111650466918945],
          [80.442260742187784, 21.111869812011776],
          [80.439506530761719, 21.11178016662609],
          [80.439056396484489, 21.109170913696289],
          [80.438728332519702, 21.106969833374023],
          [80.437660217285213, 21.104530334472656],
          [80.436721801758097, 21.102670669555664],
          [80.436073303222656, 21.101047515869141],
          [80.435180664062557, 21.099010467529354],
          [80.434196472168026, 21.098022460937443],
          [80.433319091797159, 21.097150802612362],
          [80.435508728027344, 21.095180511474666],
          [80.436401367187443, 21.092710494995174],
          [80.438133239746264, 21.08880805969244],
          [80.440002441406364, 21.085319519043026],
          [80.44095611572277, 21.083251953125057],
          [80.442016601562557, 21.080600738525391],
          [80.442543029785327, 21.077430725097599],
          [80.442756652832031, 21.074190139770621],
          [80.442611694336165, 21.072460174560604],
          [80.440971374511662, 21.070400238037166],
          [80.442596435546932, 21.06698036193842],
          [80.442977905273494, 21.065929412841797],
          [80.443992614746378, 21.063240051269588],
          [80.444747924804972, 21.061580657959041],
          [80.446105957031364, 21.059989929199276],
          [80.447273254394474, 21.056659698486385],
          [80.447631835937614, 21.054489135742301],
          [80.448226928710881, 21.051969528198356],
          [80.448501586914119, 21.04961013793951],
          [80.447868347168139, 21.046871185302734],
          [80.447067260742301, 21.044321060180664],
          [80.447349548339901, 21.040761947631779],
          [80.447547912597713, 21.039619445800895],
          [80.447341918945369, 21.03662109375],
          [80.446533203125171, 21.033620834350643],
          [80.445236206054687, 21.030942916870174],
          [80.443252563476676, 21.02918815612793],
          [80.440856933593807, 21.028009414672908],
          [80.438606262207259, 21.027170181274414],
          [80.436759948730582, 21.025011062622184],
          [80.435966491699503, 21.022050857544002],
          [80.434547424316406, 21.01923942565918],
          [80.432472229003963, 21.017131805419979],
          [80.430107116699162, 21.01635932922369],
          [80.428810119629077, 21.013570785522518],
          [80.427581787109659, 21.012460708618164],
          [80.423759460449503, 21.009590148925781],
          [80.424751281738395, 21.007339477539119],
          [80.426628112793253, 21.005050659179744],
          [80.429489135742472, 21.002639770507926],
          [80.433341979980412, 20.999750137329158],
          [80.43808746337919, 20.992099761962891],
          [80.438941955566406, 20.971559524536246],
          [80.440696716308821, 20.965459823608398],
          [80.443756103515852, 20.961032867431641],
          [80.448348999023494, 20.951011657714844],
          [80.448791503906193, 20.945301055908317],
          [80.456588745117472, 20.937248229980469],
          [80.455558776855526, 20.932109832763729],
          [80.459091186523381, 20.928150177002067],
          [80.465316772460994, 20.927288055419922],
          [80.473922729492472, 20.927360534667969],
          [80.482749938964787, 20.928470611572322],
          [80.491279602051065, 20.927850723266658],
          [80.500679016113224, 20.928911209106445],
          [80.510620117187671, 20.928800582885685],
          [80.526412963867301, 20.932109832763729],
          [80.535247802734375, 20.931320190429631],
          [80.541839599609659, 20.933919906616325],
          [80.538131713867244, 20.926080703735352],
          [80.539100646972713, 20.921060562133903],
          [80.546188354492244, 20.903079986572322],
          [80.549758911132813, 20.888910293579158],
          [80.548912048339957, 20.86808967590332],
          [80.550605773926065, 20.85991096496582],
          [80.55036926269554, 20.845670700073242],
          [80.55478668212919, 20.829420089721623],
          [80.555892944335994, 20.819681167602596],
          [80.550765991210994, 20.815460205078182],
          [80.548896789551065, 20.808410644531307],
          [80.545692443847599, 20.801372528076172],
          [80.543342590332315, 20.7917995452882],
          [80.545455932617472, 20.7822780609132],
          [80.545532226562671, 20.76536941528326],
          [80.548179626465014, 20.759080886840934],
          [80.552009582519702, 20.753450393676758],
          [80.554542541503963, 20.747150421142692],
          [80.555870056152401, 20.722570419311637],
          [80.560188293456974, 20.711772918701229],
          [80.563949584961222, 20.707189559936523],
          [80.574920654296875, 20.698429107666072],
          [80.577720642089957, 20.694070816040153],
          [80.579292297363452, 20.689979553222713],
          [80.580116271972713, 20.68364143371582],
          [80.578338623047046, 20.678770065307617],
          [80.572792053222827, 20.674289703369254],
          [80.566802978515909, 20.672929763793888],
          [80.55271148681669, 20.673089981079215],
          [80.547386169433707, 20.671260833740178],
          [80.537422180175838, 20.664020538330078],
          [80.525566101074276, 20.663190841674862],
          [80.518913269043026, 20.661760330200252],
          [80.507606506347656, 20.654600143432674],
          [80.502037048340014, 20.649190902709961],
          [80.489646911621264, 20.639898300170898],
          [80.484848022460881, 20.63517951965332],
          [80.481590270996207, 20.629762649536246],
          [80.480957031250057, 20.623550415039119],
          [80.481597900390568, 20.617099761962891],
          [80.484191894531477, 20.611959457397575],
          [80.492912292480469, 20.604089736938477],
          [80.497177124023494, 20.595809936523551],
          [80.500099182128849, 20.586862564087028],
          [80.511901855469034, 20.585119247436523],
          [80.51950836181669, 20.584680557250977],
          [80.529830932617472, 20.590080261230582],
          [80.551406860351506, 20.599079132080135],
          [80.559036254882756, 20.609979629516545],
          [80.567306518554688, 20.612407684326229],
          [80.578666687011832, 20.614120483398551],
          [80.58573150634777, 20.614152908325309],
          [80.59246826171875, 20.613098144531307],
          [80.602569580078296, 20.607389450073356],
          [80.608963012695597, 20.605989456176758],
          [80.617675781250057, 20.606170654296875],
          [80.622322082519815, 20.603862762451229],
          [80.619491577148551, 20.597919464111385],
          [80.612861633300952, 20.590578079223633],
          [80.614608764648438, 20.585271835327262],
          [80.617469787597656, 20.581037521362418],
          [80.614242553710994, 20.576930999755916],
          [80.619720458984546, 20.567319869995231],
          [80.617073059082031, 20.562231063842773],
          [80.612152099609432, 20.559589385986385],
          [80.609947204589957, 20.556329727172965],
          [80.611785888672102, 20.550960540771484],
          [80.610298156738565, 20.545059204101676],
          [80.613410949707202, 20.541570663452262],
          [80.612739562988509, 20.537260055541992],
          [80.610031127929688, 20.531980514526424],
          [80.608528137207088, 20.516202926635856],
          [80.606887817383097, 20.512540817260799],
          [80.607246398926065, 20.503910064697322],
          [80.606201171875, 20.487070083618221],
          [80.604942321777401, 20.481151580810547],
          [80.603317260742358, 20.462419509887695],
          [80.601669311523494, 20.457260131835994],
          [80.594688415527457, 20.446420669555721],
          [80.597152709961222, 20.442070007324332],
          [80.601448059082031, 20.437370300292969],
          [80.603439331054972, 20.433250427246151],
          [80.599876403808764, 20.426921844482365],
          [80.594451904296932, 20.420709609985408],
          [80.591735839843807, 20.415050506591911],
          [80.589752197265568, 20.412771224975643],
          [80.586517333984546, 20.400728225708121],
          [80.586021423339901, 20.395610809326286],
          [80.585983276367188, 20.392049789428825],
          [80.58744049072277, 20.38789176940918],
          [80.590171813965014, 20.384349822998161],
          [80.598396301269531, 20.380680084228572],
          [80.602226257324276, 20.376440048217773],
          [80.60072326660179, 20.372600555419922],
          [80.600898742675838, 20.369190216064453],
          [80.605133056640682, 20.366159439086971],
          [80.606201171875, 20.360790252685547],
          [80.606010437011719, 20.356420516967773],
          [80.611495971679631, 20.34934234619152],
          [80.610710144043082, 20.345260620117187],
          [80.616676330566577, 20.33761024475092],
          [80.617767333984489, 20.33368110656744],
          [80.616691589355469, 20.325740814209041],
          [80.606712341308707, 20.325349807739371],
          [80.605422973632983, 20.320190429687614],
          [80.584236145019702, 20.31929969787592],
          [80.551582336425895, 20.311531066894588],
          [80.542022705078409, 20.30684852600109],
          [80.539306640625227, 20.300390243530273],
          [80.535820007324219, 20.294679641723746],
          [80.526679992675781, 20.284780502319393],
          [80.510826110840014, 20.269611358642578],
          [80.494476318359432, 20.274799346923885],
          [80.475875854492131, 20.273689270019531],
          [80.465446472167969, 20.271621704101563],
          [80.456466674804858, 20.26890945434576],
          [80.448387145996378, 20.263881683349609],
          [80.437309265137003, 20.258478164672852],
          [80.422943115234432, 20.252609252929744],
          [80.419616699218693, 20.251560211181697],
          [80.415267944336108, 20.252290725708065],
          [80.409027099609432, 20.249130249023437],
          [80.403717041015682, 20.247699737548828],
          [80.386238098144474, 20.244611740112418],
          [80.382957458496378, 20.241720199585075],
          [80.388038635253963, 20.230619430542049],
          [80.398002624512003, 20.212779998779297],
          [80.409820556640682, 20.205289840698356],
          [80.412017822265796, 20.20220947265625],
          [80.413986206054744, 20.190231323242244],
          [80.413406372070369, 20.187530517578182],
          [80.404060363769588, 20.184410095214787],
          [80.398277282715014, 20.183441162109489],
          [80.394592285156534, 20.181589126586857],
          [80.392799377441463, 20.177400588989201],
          [80.391906738281534, 20.170730590820313],
          [80.390457153320483, 20.166271209716854],
          [80.386016845703409, 20.162809371948185],
          [80.384567260742187, 20.158510208129826],
          [80.387626647949219, 20.151580810546989],
          [80.39383697509794, 20.144020080566406],
          [80.401496887206974, 20.139511108398494],
          [80.426956176757869, 20.130239486694336],
          [80.431945800781307, 20.131340026855582],
          [80.439628601074332, 20.129119873046875],
          [80.444137573242415, 20.130342483520508],
          [80.447875976562671, 20.141571044921932],
          [80.451339721679688, 20.144870758056641],
          [80.45865631103544, 20.144550323486385],
          [80.466781616210937, 20.142681121826286],
          [80.477302551269588, 20.138530731201115],
          [80.482933044433537, 20.137889862060604],
          [80.491149902343921, 20.141479492187614],
          [80.498031616211108, 20.138919830322209],
          [80.503585815429687, 20.128789901733455],
          [80.51053619384794, 20.126930236816463],
          [80.518150329589901, 20.1268310546875],
          [80.523590087890796, 20.124471664428654],
          [80.526687622070369, 20.121379852294922],
          [80.528808593750057, 20.117500305175781],
          [80.535758972168082, 20.113849639892635],
          [80.540367126465014, 20.109832763671818],
          [80.541252136230753, 20.104949951171932],
          [80.535232543945483, 20.092180252075195],
          [80.534957885742472, 20.085399627685604],
          [80.541831970215128, 20.076681137085018],
          [80.546157836914119, 20.065710067749137],
          [80.545227050781477, 20.059570312500057],
          [80.541091918945426, 20.048189163208065],
          [80.541587829589901, 20.037221908569393],
          [80.535423278808764, 20.011209487915153],
          [80.532539367675952, 20.003932952880859],
          [80.535789489746264, 19.999919891357422],
          [80.539947509765739, 19.997720718383732],
          [80.543533325195597, 19.995082855224723],
          [80.545547485351563, 19.987180709838867],
          [80.544151306152457, 19.981510162353629],
          [80.537757873535213, 19.973560333251953],
          [80.534736633301009, 19.970920562744141],
          [80.532371520996264, 19.967060089111271],
          [80.533836364746378, 19.953029632568416],
          [80.526283264160156, 19.948627471923828],
          [80.526008605957315, 19.941120147705021],
          [80.520378112792969, 19.930879592895565],
          [80.508750915527344, 19.925910949707145],
          [80.501739501953352, 19.924751281738338],
          [80.480476379394702, 19.927801132202262],
          [80.472892761230469, 19.931249618530217],
          [80.469841003417969, 19.933660507202205],
          [80.468750000000057, 19.940269470214787],
          [80.464500427246094, 19.946250915527401],
          [80.453002929687671, 19.945238113403434],
          [80.443702697753906, 19.952671051025447],
          [80.438552856445313, 19.947130203247184],
          [80.43100738525419, 19.940940856933651],
          [80.425109863281534, 19.937309265136776],
          [80.420593261718921, 19.936229705810547],
          [80.409317016601506, 19.935380935668945],
          [80.406295776367358, 19.932500839233455],
          [80.405776977539119, 19.92545127868658],
          [80.402656555175952, 19.909601211547795],
          [80.407676696777401, 19.905902862548828],
          [80.414749145507869, 19.902919769287223],
          [80.43100738525419, 19.898410797119141],
          [80.435798645019815, 19.895519256591911],
          [80.444442749023608, 19.893550872802791],
          [80.452789306640739, 19.900009155273551],
          [80.461219787597827, 19.90343093872076],
          [80.468955993652628, 19.903360366821289],
          [80.482650756835994, 19.898899078369197],
          [80.489837646484546, 19.893672943115234],
          [80.491661071777628, 19.89053916931158],
          [80.496910095214844, 19.877180099487362],
          [80.497520446777401, 19.868749618530273],
          [80.487640380859432, 19.865129470825309],
          [80.475021362304744, 19.857059478759766],
          [80.471031188965071, 19.842660903930607],
          [80.468612670898551, 19.837530136108455],
          [80.463630676269815, 19.835832595825195],
          [80.460296630859375, 19.828029632568359],
          [80.455116271972827, 19.823799133300838],
          [80.446968078613338, 19.820320129394531],
          [80.431655883789233, 19.810300827026481],
          [80.424591064453296, 19.808040618896484],
          [80.417312622070426, 19.809150695800838],
          [80.404975891113281, 19.81542015075695],
          [80.397529602050952, 19.816230773925895],
          [80.398429870605582, 19.803190231323299],
          [80.394706726074276, 19.794578552246094],
          [80.400146484375114, 19.793630599975643],
          [80.417686462402457, 19.797140121460075],
          [80.429008483886719, 19.795110702514648],
          [80.435791015625284, 19.791851043701229],
          [80.442703247070483, 19.79054069519043],
          [80.449539184570426, 19.792659759521541],
          [80.452438354492358, 19.792900085449276],
          [80.461761474609318, 19.788232803344783],
          [80.466796875000057, 19.784879684448299],
          [80.478088378906477, 19.772409439087028],
          [80.482559204101506, 19.780710220336914],
          [80.482070922851619, 19.789501190185547],
          [80.480239868164347, 19.795440673828239],
          [80.477142333984432, 19.801229476928711],
          [80.474807739257869, 19.803390502929744],
          [80.462905883789006, 19.805759429931641],
          [80.459548950195369, 19.811330795288086],
          [80.469161987304972, 19.824661254882926],
          [80.476028442383097, 19.828001022338924],
          [80.490707397461222, 19.825361251831168],
          [80.498397827148608, 19.829471588134822],
          [80.507507324219034, 19.829948425293026],
          [80.517807006836222, 19.828861236572322],
          [80.53537750244152, 19.818130493164119],
          [80.542427062988395, 19.819271087646484],
          [80.544242858886776, 19.811201095581112],
          [80.541946411132869, 19.80315017700201],
          [80.542442321777287, 19.794242858886776],
          [80.538871765136719, 19.780702590942383],
          [80.539672851562557, 19.774599075317383],
          [80.550216674804972, 19.764551162719783],
          [80.567657470703296, 19.756679534912053],
          [80.570526123047046, 19.754739761352539],
          [80.578681945800724, 19.743921279907227],
          [80.582077026367472, 19.738071441650447],
          [80.590332031250171, 19.734430313110408],
          [80.613136291503963, 19.728929519653434],
          [80.620208740234659, 19.723770141601676],
          [80.633506774902401, 19.718490600585938],
          [80.640296936035099, 19.712459564208984],
          [80.645637512206974, 19.706499099731445],
          [80.661338806152344, 19.697500228881893],
          [80.665840148925895, 19.69221115112299],
          [80.664550781250171, 19.690750122070426],
          [80.666007995605753, 19.686269760131893],
          [80.665382385254134, 19.672969818115234],
          [80.662200927734659, 19.662580490112362],
          [80.656120300292912, 19.625150680541992],
          [80.655891418457315, 19.616979598999023],
          [80.656852722168253, 19.612260818481445],
          [80.662033081054631, 19.608730316162109],
          [80.683036804199389, 19.610609054565543],
          [80.696685791015682, 19.610830307006836],
          [80.707771301269815, 19.610458374023551],
          [80.720993041992358, 19.608390808105412],
          [80.757957458496207, 19.590171813964901],
          [80.764266967773381, 19.584831237793026],
          [80.765037536621037, 19.574260711669979],
          [80.766410827636889, 19.568319320678711],
          [80.785156250000057, 19.560409545898494],
          [80.809226989746378, 19.564510345459041],
          [80.819610595703296, 19.565401077270565],
          [80.827606201172046, 19.562671661377067],
          [80.833526611328296, 19.555971145629996],
          [80.836051940917969, 19.548980712890682],
          [80.837379455566406, 19.540630340576172],
          [80.840827941894588, 19.53357124328619],
          [80.845382690429687, 19.529172897338981],
          [80.852256774902344, 19.524169921875057],
          [80.863349914550838, 19.52194976806652],
          [80.873596191406421, 19.522350311279354],
          [80.879051208496378, 19.51902961730957],
          [80.88553619384794, 19.509250640869254],
          [80.889701843261776, 19.499250411987305],
          [80.891403198242415, 19.490840911865234],
          [80.892158508300838, 19.48151969909668],
          [80.892066955566349, 19.465681076049805],
          [80.885627746582031, 19.456502914428825],
          [80.875999450683878, 19.44795036315918],
          [80.867492675781421, 19.443460464477539],
          [80.857482910156534, 19.442541122436637],
          [80.8350830078125, 19.442380905151481],
          [80.825248718262003, 19.439121246337891],
          [80.807998657226562, 19.431619644164982],
          [80.79432678222679, 19.428768157959098],
          [80.787933349609546, 19.426700592041129],
          [80.792449951172159, 19.422660827636719],
          [80.795387268066577, 19.418760299682617],
          [80.797950744629134, 19.411649703979606],
          [80.808547973632983, 19.397039413452148],
          [80.812736511230639, 19.38274002075201],
          [80.815979003906421, 19.379070281982422],
          [80.823219299316577, 19.374740600585881],
          [80.83499908447294, 19.370681762695426],
          [80.842826843262003, 19.366109848022404],
          [80.845008850097656, 19.360910415649414],
          [80.839080810547046, 19.35515022277832],
          [80.826416015625284, 19.348039627075309],
          [80.816490173340128, 19.34247016906744],
          [80.812828063965071, 19.338130950927791],
          [80.806343078613509, 19.334909439087028],
          [80.802825927734546, 19.332281112670955],
          [80.799346923828239, 19.325162887573242],
          [80.795005798340014, 19.324760437011662],
          [80.787902832031364, 19.324111938476619],
          [80.782463073730526, 19.32174110412609],
          [80.778091430664119, 19.318540573120174],
          [80.766197204590014, 19.308130264282283],
          [80.763977050781307, 19.305271148681641],
          [80.759742736816406, 19.299751281738395],
          [80.755050659179744, 19.295240402221737],
          [80.749237060547046, 19.286741256713981],
          [80.743408203125057, 19.285970687866325],
          [80.736732482910213, 19.286960601806641],
          [80.730659484863565, 19.284030914306754],
          [80.718307495117131, 19.285499572753906],
          [80.709182739257983, 19.283309936523494],
          [80.700439453125, 19.28226280212408],
          [80.698738098144588, 19.282270431518612],
          [80.693748474121094, 19.282321929931584],
          [80.688606262207031, 19.283489227294922],
          [80.683563232422159, 19.286911010742244],
          [80.681800842285213, 19.295841217041129],
          [80.685287475586051, 19.312601089477482],
          [80.684196472168139, 19.320028305053768],
          [80.679222106933764, 19.324140548705998],
          [80.671890258789119, 19.326448440551815],
          [80.664390563964844, 19.326578140258789],
          [80.657882690429858, 19.324279785156307],
          [80.635307312012003, 19.312837600708008],
          [80.625495910644588, 19.306810379028377],
          [80.617721557617244, 19.304819107055664],
          [80.610153198242131, 19.307140350341797],
          [80.603942871093807, 19.31176948547369],
          [80.600067138672046, 19.318090438842773],
          [80.598518371581974, 19.324672698974553],
          [80.595680236816577, 19.331319808960018],
          [80.592666625976563, 19.335210800170842],
          [80.588623046875171, 19.344400405883903],
          [80.585586547851733, 19.353019714355469],
          [80.582260131836222, 19.368339538574276],
          [80.584716796875057, 19.373701095581168],
          [80.58393859863304, 19.377159118652457],
          [80.572860717773494, 19.398420333862362],
          [80.570846557617301, 19.399421691894588],
          [80.567817687988224, 19.400920867920036],
          [80.55934143066429, 19.397552490234432],
          [80.531539916992472, 19.374300003051815],
          [80.526123046875057, 19.367210388183651],
          [80.522712707519759, 19.359750747680664],
          [80.518981933593693, 19.354009628295955],
          [80.513839721679631, 19.348199844360408],
          [80.507209777832031, 19.343591690063533],
          [80.500389099121151, 19.34129905700695],
          [80.481101989746151, 19.3378200531007],
          [80.475585937500057, 19.335042953491211],
          [80.47049713134794, 19.32892036437994],
          [80.465301513672102, 19.31591987609869],
          [80.464500427246094, 19.31395149230957],
          [80.462127685546989, 19.308139801025391],
          [80.456802368164006, 19.299158096313533],
          [80.445426940917969, 19.269889831542969],
          [80.437026977539062, 19.261070251464844],
          [80.428070068359375, 19.254381179809684],
          [80.419166564941463, 19.250280380249137],
          [80.414466857910099, 19.249189376830998],
          [80.408180236816577, 19.247701644897461],
          [80.401573181152401, 19.246829986572379],
          [80.396842956543026, 19.246210098266715],
          [80.388450622558651, 19.24331092834484],
          [80.383346557617472, 19.239139556884822],
          [80.379180908203068, 19.232610702514648],
          [80.377021789551065, 19.217369079589957],
          [80.379936218261662, 19.208709716796932],
          [80.386116027832088, 19.195632934570256],
          [80.386672973632812, 19.189020156860352],
          [80.381111145019702, 19.180730819702148],
          [80.372901916504077, 19.175119400024414],
          [80.362358093262003, 19.169321060180778],
          [80.345466613769531, 19.162910461425838],
          [80.344116210937671, 19.161809921264762],
          [80.340591430664347, 19.158918380737418],
          [80.339630126953182, 19.153020858764762],
          [80.335548400878906, 19.147569656372184],
          [80.324851989746264, 19.141532897949219],
          [80.32086181640625, 19.124490737915153],
          [80.322357177734546, 19.120220184326172],
          [80.329681396484432, 19.107419967651481],
          [80.33154296875, 19.101079940795955],
          [80.324119567871094, 19.094930648803711],
          [80.319946289062557, 19.088220596313533],
          [80.322563171386889, 19.082160949707031],
          [80.322113037109659, 19.074871063232422],
          [80.31996154785179, 19.069402694702205],
          [80.315773010254134, 19.064580917358398],
          [80.302246093750057, 19.055549621582088],
          [80.291702270507869, 19.049800872802848],
          [80.288841247558651, 19.04628944396984],
          [80.290542602539062, 19.040010452270621],
          [80.295288085937671, 19.028739929199162],
          [80.293411254882813, 19.021591186523494],
          [80.288116455078352, 19.013931274414062],
          [80.272308349609659, 18.997440338134822],
          [80.267723083496151, 18.987329483032283],
          [80.267532348632869, 18.983961105346737],
          [80.267349243164347, 18.980670928955135],
          [80.269020080566463, 18.964160919189567],
          [80.267478942871151, 18.952571868896484],
          [80.265319824218921, 18.946992874145508],
          [80.264129638672159, 18.940521240234432],
          [80.26468658447294, 18.937320709228516],
          [80.265167236328125, 18.934560775756893],
          [80.267639160156421, 18.928789138794059],
          [80.270469665527514, 18.924919128418026],
          [80.291389465332315, 18.90759086608881],
          [80.298103332519645, 18.900461196899414],
          [80.308563232422159, 18.886167526245231],
          [80.309906005859659, 18.88480186462408],
          [80.313468933105526, 18.881179809570312],
          [80.321662902832088, 18.87483024597168],
          [80.325653076171932, 18.869960784912053],
          [80.335731506347827, 18.856119155883846],
          [80.33963775634794, 18.848342895507813],
          [80.345581054687784, 18.833930969238338],
          [80.348503112793139, 18.823940277099723],
          [80.347785949707088, 18.815940856933594],
          [80.346221923828296, 18.811080932617301],
          [80.334701538086222, 18.806110382080078],
          [80.318733215332202, 18.795980453491325],
          [80.305892944336222, 18.794349670410156],
          [80.299438476562614, 18.793531417846623],
          [80.294158935546875, 18.790590286254883],
          [80.290176391601619, 18.786251068115234],
          [80.279533386230696, 18.767852783203125],
          [80.276550292968864, 18.764850616455192],
          [80.271820068359546, 18.762220382690543],
          [80.265419006347884, 18.763160705566463],
          [80.262916564941463, 18.764289855957088],
          [80.26145172119169, 18.764970779419059],
          [80.260650634765852, 18.765079498291016],
          [80.254562377929744, 18.765951156616268],
          [80.249000549316463, 18.765251159668026],
          [80.242156982421932, 18.759748458862418],
          [80.240501403808707, 18.756610870361442],
          [80.239562988281193, 18.752210617065487],
          [80.240798950195369, 18.748689651489315],
          [80.247451782226619, 18.743551254272404],
          [80.254806518554801, 18.736131668090877],
          [80.257537841796875, 18.731260299682674],
          [80.267539978027628, 18.717969894409293],
          [80.260368347168139, 18.714099884033317],
          [80.246665954589844, 18.701320648193473],
          [80.241691589355639, 18.700220108032227],
          [80.235572814941577, 18.700420379638672],
          [80.229980468750284, 18.697530746460075],
          [80.225318908691406, 18.696149826049862],
          [80.220008850097713, 18.699190139770621],
          [80.214363098144645, 18.701129913330192],
          [80.207878112793082, 18.700460433959961],
          [80.201911926269588, 18.697441101074162],
          [80.194107055664347, 18.688531875610295],
          [80.191658020019815, 18.683631896972713],
          [80.190956115722827, 18.678970336914063],
          [80.188957214355753, 18.675580978393612],
          [80.175651550293082, 18.675899505615291],
          [80.170967102050838, 18.677339553833008],
          [80.167396545410213, 18.680070877075252],
          [80.164627075195483, 18.69029808044445],
          [80.1619873046875, 18.69403076171875],
          [80.158081054687784, 18.695940017700309],
          [80.152206420898381, 18.695278167724609],
          [80.148742675781534, 18.693241119384822],
          [80.142272949218864, 18.686252593994254],
          [80.136589050293139, 18.686801910400504],
          [80.130867004394702, 18.685411453247127],
          [80.121292114257926, 18.681209564209041],
          [80.118415832519815, 18.679132461547965],
          [80.115997314453296, 18.675849914550895],
          [80.110816955566349, 18.676189422607422],
          [80.106559753418253, 18.677528381347713],
          [80.100547790527514, 18.684959411621151],
          [80.08695220947277, 18.697570800781307],
          [80.084442138672159, 18.700839996337891],
          [80.082122802734602, 18.702449798584098],
          [80.078903198242472, 18.701339721679744],
          [80.074707031250284, 18.702560424804801],
          [80.067909240722827, 18.708709716796875],
          [80.065490722656307, 18.713262557983398],
          [80.061897277832259, 18.716512680053711],
          [80.053268432617188, 18.717798233032283],
          [80.046356201172046, 18.720920562744197],
          [80.032859802246094, 18.746440887451229],
          [80.029663085937727, 18.748699188232422],
          [80.018707275390796, 18.751010894775391],
          [80.016532897949503, 18.757020950317383],
          [80.014488220214787, 18.760129928588981],
          [80.012351989746378, 18.76675987243658],
          [80.009086608886776, 18.76857948303234],
          [79.992919921875114, 18.773519515991211],
          [79.981536865234546, 18.774280548095703],
          [79.950149536132869, 18.779909133911133],
          [79.940071105957315, 18.781791687011719],
          [79.931991577148494, 18.784429550170898],
          [79.916267395019474, 18.79734039306652],
          [79.909095764160213, 18.806690216064453],
          [79.894012451171875, 18.830839157104549],
          [79.904098510742358, 18.834880828857422],
          [79.920822143554801, 18.836210250854606],
          [79.925506591796932, 18.837541580200195],
          [79.933326721191463, 18.845041275024471],
          [79.939002990722827, 18.858892440796012],
          [79.940948486328182, 18.877389907836914],
          [79.940116882324389, 18.896738052368221],
          [79.941352844238509, 18.915769577026481],
          [79.940940856933651, 18.937660217285213],
          [79.935882568359659, 18.957639694213924],
          [79.932212829589901, 18.971580505371094],
          [79.931343078613452, 18.974790573120174],
          [79.932792663574276, 18.995700836181641],
          [79.934486389160384, 19.021699905395621],
          [79.933067321777514, 19.029689788818416],
          [79.925979614257926, 19.042490005493278],
          [79.916107177734546, 19.047359466552734],
          [79.902938842773608, 19.047979354858398],
          [79.89084625244169, 19.045450210571289],
          [79.881111145019815, 19.041389465332031],
          [79.871032714844034, 19.035541534423828],
          [79.859588623047159, 19.034629821777457],
          [79.857009887695313, 19.042200088500977],
          [79.861099243164347, 19.059949874878043],
          [79.860076904296932, 19.090959548950309],
          [79.858047485351847, 19.104110717773438],
          [79.863105773925781, 19.115821838378963],
          [79.871208190918253, 19.122699737548828],
          [79.905967712402287, 19.141788482666016],
          [79.922309875488565, 19.15712928771984],
          [79.926116943359432, 19.16094970703125],
          [79.940696716308764, 19.164400100707951],
          [79.943206787109375, 19.170600891113395],
          [79.942436218261889, 19.175880432128963],
          [79.93525695800804, 19.183851242065487],
          [79.922508239746378, 19.203409194946346],
          [79.919326782226733, 19.215019226074276],
          [79.920166015625057, 19.226409912109375],
          [79.931900024414006, 19.259321212768555],
          [79.945182800293026, 19.28412055969244],
          [79.948959350585994, 19.288860321044922],
          [79.961776733398494, 19.297491073608398],
          [79.963645935058651, 19.306539535522575],
          [79.957382202148665, 19.324470520019588],
          [79.957153320312557, 19.33456993103033],
          [79.964523315429631, 19.350679397583065],
          [79.966522216796932, 19.360889434814567],
          [79.967247009277344, 19.374580383300781],
          [79.970748901367244, 19.382129669189453],
          [79.972602844238338, 19.391580581665039],
          [79.973052978515909, 19.401020050048828],
          [79.970001220703409, 19.409460067749023],
          [79.959236145019531, 19.425910949707031],
          [79.945770263672159, 19.440780639648438],
          [79.946212768554631, 19.45093917846674],
          [79.944999694824276, 19.458818435669002],
          [79.940208435058821, 19.464509963989315],
          [79.937255859375171, 19.466960906982365],
          [79.932868957519702, 19.469121932983398],
          [79.923545837402514, 19.477581024170036],
          [79.917793273925724, 19.485540390014648],
          [79.91102600097679, 19.492340087890682],
          [79.902236938476619, 19.496490478515625],
          [79.878227233886946, 19.500701904296932],
          [79.870216369629134, 19.504961013794002],
          [79.863792419433707, 19.513597488403434],
          [79.856231689453125, 19.517110824585075],
          [79.828216552734432, 19.537010192871207],
          [79.82315826416044, 19.544309616088867],
          [79.820632934570369, 19.552350997924862],
          [79.819549560546989, 19.561489105224666],
          [79.816596984863338, 19.569009780883789],
          [79.811096191406307, 19.57384109497076],
          [79.805206298828409, 19.576759338378906],
          [79.793296813964844, 19.580089569091797],
          [79.786293029785384, 19.589651107788029],
          [79.785423278808537, 19.593589782714901],
          [79.777549743652628, 19.597679138183707],
          [79.766288757324503, 19.600151062011832],
          [79.754257202148494, 19.60233116149908],
          [79.740325927734602, 19.60313987731945],
          [79.729911804199162, 19.596569061279354],
          [79.71292877197277, 19.583330154419002],
          [79.705116271972599, 19.581220626831168],
          [79.695686340332259, 19.581090927124023],
          [79.684791564941463, 19.579168319702148],
          [79.67801666259777, 19.57656288146984],
          [79.665046691894645, 19.577169418335018],
          [79.652618408203409, 19.576692581176815],
          [79.639717102050952, 19.57500076293951],
          [79.621391296386662, 19.565099716186523],
          [79.615806579590128, 19.55862998962408],
          [79.610908508300952, 19.549179077148494],
          [79.60721588134794, 19.539461135864315],
          [79.602935791015625, 19.521068572998161],
          [79.602439880371151, 19.514520645141658],
          [79.600852966308594, 19.507951736450195],
          [79.598052978515682, 19.50377082824707],
          [79.591346740722713, 19.501731872558707],
          [79.582656860351676, 19.503051757812614],
          [79.573440551757869, 19.50663948059082],
          [79.565597534179744, 19.510900497436523],
          [79.552497863769815, 19.520042419433707],
          [79.547698974609432, 19.526081085205021],
          [79.545196533203352, 19.534000396728572],
          [79.544746398925952, 19.542711257934627],
          [79.542655944824389, 19.54852294921875],
          [79.534996032715014, 19.548070907592717],
          [79.526222229004077, 19.546060562133732],
          [79.514991760254077, 19.541950225830078],
          [79.514816284179687, 19.54076194763195],
          [79.515953063965014, 19.536809921264592],
          [79.515846252441463, 19.522359848022461],
          [79.513397216797159, 19.518060684204102],
          [79.493316650390852, 19.505191802978572],
          [79.480049133300724, 19.503812789916935],
          [79.470420837402401, 19.497451782226619],
          [79.46512603759794, 19.509010314941349],
          [79.458183288574219, 19.518960952758903],
          [79.441261291503963, 19.533510208129883],
          [79.430282592773608, 19.535100936889592],
          [79.423187255859659, 19.532840728759822],
          [79.413612365722713, 19.533479690551701],
          [79.401847839355412, 19.539831161499137],
          [79.388969421386776, 19.548919677734375],
          [79.380706787109546, 19.555850982666016],
          [79.371192932128906, 19.561548233032227],
          [79.369026184082145, 19.571231842041129],
          [79.340888977050838, 19.573770523071289],
          [79.329681396484432, 19.573680877685604],
          [79.321502685547159, 19.571750640869197],
          [79.314262390137003, 19.565521240234375],
          [79.309616088867244, 19.582010269165096],
          [79.304840087890682, 19.590150833129883],
          [79.293235778808821, 19.596721649169922],
          [79.267860412597713, 19.606660842895621],
          [79.255226135253906, 19.611209869384766],
          [79.243865966797159, 19.612552642822266],
          [79.237091064453296, 19.609489440918082],
          [79.237701416015682, 19.599540710449276],
          [79.243782043457031, 19.593341827392635],
          [79.248680114746207, 19.586860656738281],
          [79.250106811523494, 19.577680587768555],
          [79.239768981933764, 19.559480667114258],
          [79.238166809082315, 19.550931930541935],
          [79.239341735839787, 19.542049407959098],
          [79.238357543945597, 19.532760620117244],
          [79.236633300781534, 19.526798248291129],
          [79.232002258300838, 19.520750045776481],
          [79.223426818847884, 19.517009735107479],
          [79.215705871582202, 19.510580062866268],
          [79.208076477050952, 19.498649597168026],
          [79.206848144531307, 19.491670608520621],
          [79.20877838134794, 19.484798431396541],
          [79.220687866211108, 19.475589752197266],
          [79.222938537597599, 19.467790603637752],
          [79.218711853027628, 19.464500427246151],
          [79.189041137695312, 19.458700180053768],
          [79.177787780761719, 19.460691452026481],
          [79.169097900390909, 19.467769622802734],
          [79.156967163086108, 19.485549926757756],
          [79.140266418457259, 19.501110076904297],
          [79.126449584961108, 19.506490707397404],
          [79.112815856933651, 19.509780883789006],
          [79.104736328125, 19.512741088867244],
          [79.102355957031534, 19.519359588623161],
          [79.102867126464901, 19.527950286865348],
          [79.096611022949276, 19.530479431152401],
          [79.073837280273437, 19.528610229492301],
          [79.063392639160213, 19.531250000000057],
          [79.060111999511719, 19.538721084594783],
          [79.051521301269531, 19.545272827148437],
          [79.038818359375057, 19.544990539550838],
          [79.018356323242244, 19.539970397949219],
          [79.012191772461108, 19.543760299682674],
          [79.000061035156307, 19.559370040893555],
          [78.995567321777457, 19.561019897460994],
          [78.992858886719034, 19.562040328979492],
          [78.986351013183821, 19.557050704956055],
          [78.978477478027344, 19.550922393798828],
          [78.973556518554744, 19.549900054931754],
          [78.964851379394815, 19.550331115722713],
          [78.954551696777628, 19.55183029174799],
          [78.94956207275419, 19.557470321655273],
          [78.954460144043026, 19.562721252441463],
          [78.964706420898608, 19.570280075073299],
          [78.968986511230696, 19.573459625244197],
          [78.977851867675724, 19.579942703247127],
          [78.980529785156421, 19.585081100463867],
          [78.978302001953182, 19.590410232544002],
          [78.971328735351847, 19.597259521484432],
          [78.965621948242301, 19.604511260986328],
          [78.962860107421932, 19.61732292175293],
          [78.964675903320426, 19.629552841186523],
          [78.968002319335994, 19.639369964599723],
          [78.968955993652401, 19.649232864379996],
          [78.961677551269702, 19.658769607544059],
          [78.954193115234318, 19.663410186767521],
          [78.943595886230526, 19.665140151977539],
          [78.934989929199219, 19.662179946899528],
          [78.915908813476562, 19.667730331420955],
          [78.903793334961222, 19.664558410644588],
          [78.890975952148665, 19.655260086059627],
          [78.877937316894702, 19.65680122375494],
          [78.85880279541044, 19.65631103515625],
          [78.859123229980696, 19.668909072875977],
          [78.863212585449162, 19.679492950439453],
          [78.863983154296818, 19.686700820922852],
          [78.863479614257869, 19.696769714355526],
          [78.86167144775402, 19.705900192260799],
          [78.857376098632869, 19.71973991394043],
          [78.856918334960881, 19.731300354003963],
          [78.853576660156307, 19.738000869750977],
          [78.845626831054972, 19.758350372314567],
          [78.844337463378849, 19.759000778198356],
          [78.838302612304744, 19.762081146240234],
          [78.825286865234546, 19.760379791259822],
          [78.817146301269588, 19.760419845581055],
          [78.807609558105526, 19.757989883422852],
          [78.803176879882983, 19.76007080078125],
          [78.79695129394554, 19.768579483032283],
          [78.784866333007983, 19.778749465942496],
          [78.773216247558764, 19.779371261596793],
          [78.763229370117472, 19.775630950927734],
          [78.752243041992358, 19.777290344238338],
          [78.743087768554858, 19.779659271240291],
          [78.738349914550781, 19.779430389404297],
          [78.731842041015796, 19.772850036621094],
          [78.724731445312614, 19.76897048950201],
          [78.716445922851619, 19.766799926757869],
          [78.709182739257869, 19.772710800171012],
          [78.701789855957088, 19.785579681396541],
          [78.695907592773722, 19.789710998535213],
          [78.686370849609659, 19.789939880371207],
          [78.648338317871151, 19.801460266113281],
          [78.63520812988304, 19.803779602050838],
          [78.619338989257869, 19.808710098266545],
          [78.614341735840014, 19.813261032104549],
          [78.603652954101733, 19.817501068115348],
          [78.595275878906421, 19.817350387573356],
          [78.591751098633097, 19.815410614013786],
          [78.584991455078125, 19.811689376831055],
          [78.573707580566577, 19.813802719116211],
          [78.557922363281307, 19.815610885620231],
          [78.526268005371151, 19.821659088134822],
          [78.519210815429744, 19.819900512695426],
          [78.512390136718807, 19.814279556274414],
          [78.509613037109546, 19.801189422607422],
          [78.503669738769645, 19.792419433593864],
          [78.493919372558878, 19.793149948120231],
          [78.489471435546932, 19.798509597778377],
          [78.484291076660156, 19.80718994140625],
          [78.476188659668253, 19.816360473632869],
          [78.464653015136776, 19.816211700439453],
          [78.444587707519702, 19.819231033325195],
          [78.428672790527628, 19.823110580444279],
          [78.409042358398722, 19.829860687255916],
          [78.397659301757983, 19.836402893066463],
          [78.389236450195256, 19.846178054809627],
          [78.385932922363338, 19.852701187133846],
          [78.385971069336222, 19.855699539184627],
          [78.384178161621151, 19.863620758056697],
          [78.384971618652401, 19.873891830444336],
          [78.384147644042969, 19.879222869873104],
          [78.37446594238304, 19.879270553588924],
          [78.365753173828409, 19.882890701294059],
          [78.346687316894645, 19.881401062011776],
          [78.336250305175952, 19.883190155029297],
          [78.325241088867244, 19.890481948852653],
          [78.322967529297102, 19.894971847534293],
          [78.326606750488338, 19.899379730224609],
          [78.334587097168026, 19.904302597046012],
          [78.335105895996264, 19.910110473632926],
          [78.328376770019645, 19.916088104248161],
          [78.319511413574276, 19.915468215942496],
          [78.31019592285179, 19.912740707397575],
          [78.307617187500171, 19.908491134643612],
          [78.297691345214787, 19.87329292297369],
          [78.294212341308878, 19.855550765991211],
          [78.29412841796875, 19.849550247192383],
          [78.303169250488565, 19.845830917358398],
          [78.338996887207259, 19.839179992675724],
          [78.341369628906193, 19.832941055297852],
          [78.335983276367472, 19.818660736084098],
          [78.33921051025419, 19.813510894775504],
          [78.351615905762003, 19.810350418090877],
          [78.360488891601562, 19.805740356445426],
          [78.366996765136776, 19.794540405273381],
          [78.36773681640625, 19.781080245971737],
          [78.364791870117472, 19.767339706420955],
          [78.360801696777457, 19.753980636596737],
          [78.353202819824389, 19.737751007080192],
          [78.345413208007983, 19.734422683715877],
          [78.344299316406307, 19.724332809448242],
          [78.345275878906307, 19.713569641113338],
          [78.332519531250057, 19.70850944519043],
          [78.322692871093921, 19.703649520874137],
          [78.320106506347884, 19.696710586547965],
          [78.316062927246094, 19.690551757812614],
          [78.304946899414233, 19.688430786132869],
          [78.285812377929972, 19.689670562744197],
          [78.273391723632869, 19.670150756836051],
          [78.269721984863338, 19.663129806518555],
          [78.272659301758097, 19.660169601440543],
          [78.287559509277457, 19.654460906982422],
          [78.292427062988338, 19.644161224365234],
          [78.295501708984602, 19.631830215454158],
          [78.298973083496378, 19.62341117858881],
          [78.308891296387003, 19.611400604248047],
          [78.310989379883097, 19.604179382324332],
          [78.310043334961222, 19.586711883545036],
          [78.312042236328125, 19.578561782836971],
          [78.311149597168196, 19.571769714355412],
          [78.306121826172046, 19.567441940307674],
          [78.299911499023494, 19.566780090332145],
          [78.299285888671932, 19.56129264831543],
          [78.296508789062784, 19.558380126953239],
          [78.285346984863281, 19.560340881347656],
          [78.279106140136946, 19.558200836181697],
          [78.284606933593807, 19.550390243530273],
          [78.291450500488281, 19.543111801147404],
          [78.295028686523608, 19.537281036377067],
          [78.295486450195369, 19.530839920043945],
          [78.2987060546875, 19.513561248779297],
          [78.299430847168139, 19.504129409790039],
          [78.303611755371264, 19.493761062622184],
          [78.310012817382869, 19.486431121826172],
          [78.312049865722656, 19.479259490966854],
          [78.311958312988565, 19.465900421142635],
          [78.308891296387003, 19.456409454345817],
          [78.297332763672046, 19.448829650878963],
          [78.291152954101847, 19.448799133300781],
          [78.281990051269815, 19.452989578247013],
          [78.273216247558878, 19.453840255737248],
          [78.266929626465128, 19.447929382324332],
          [78.261833190917912, 19.440099716186637],
          [78.251998901367244, 19.430049896240291],
          [78.245811462402287, 19.428989410400504],
          [78.233619689941577, 19.432889938354492],
          [78.224266052246264, 19.434032440185604],
          [78.215080261230582, 19.427051544189567],
          [78.205482482910384, 19.414350509643668],
          [78.198112487793082, 19.407449722290039],
          [78.182167053222656, 19.411769866943416],
          [78.187568664550838, 19.39562034606945],
          [78.186988830566463, 19.384548187255973],
          [78.184822082519531, 19.376291275024528],
          [78.184455871582031, 19.368219375610408],
          [78.181365966797046, 19.360750198364315],
          [78.179595947265909, 19.353010177612305],
          [78.182250976562784, 19.345447540283317],
          [78.187118530273437, 19.33860969543457],
          [78.197151184082145, 19.331729888915959],
          [78.195060729980582, 19.324960708618278],
          [78.195510864257813, 19.314380645751953],
          [78.193176269531421, 19.302940368652401],
          [78.183151245117244, 19.278961181640739],
          [78.183258056640796, 19.261169433593807],
          [78.186408996582259, 19.249349594116325],
          [78.183319091796932, 19.241540908813533],
          [78.170059204101847, 19.236330032348633],
          [78.149742126464844, 19.230051040649414],
          [78.139266967773494, 19.239440917968807],
          [78.126708984375227, 19.246402740478572],
          [78.099388122558594, 19.245479583740348],
          [78.095123291015568, 19.249851226806754],
          [78.082252502441463, 19.254770278930778],
          [78.075141906738452, 19.246549606323242],
          [78.057556152343693, 19.239749908447379],
          [78.051132202148438, 19.241760253906364],
          [78.048049926757983, 19.247512817382756],
          [78.047622680664176, 19.255630493164119],
          [78.049446105957088, 19.262729644775391],
          [78.045745849609546, 19.27086067199707],
          [78.032882690429744, 19.274110794067383],
          [78.02728271484375, 19.278680801391602],
          [78.018249511718864, 19.29632759094244],
          [78.011611938476733, 19.30111122131359],
          [77.99588775634794, 19.305717468261719],
          [77.985496520996264, 19.308990478515625],
          [77.976905822754077, 19.321050643921012],
          [77.966651916503963, 19.327320098877067],
          [77.962707519531534, 19.331769943237248],
          [77.948921203613338, 19.341279983520508],
          [77.940628051757756, 19.342500686645621],
          [77.937232971191577, 19.335750579833984],
          [77.926322937011662, 19.331909179687557],
          [77.922042846679915, 19.325912475585881],
          [77.912277221679688, 19.317951202392692],
          [77.905776977539062, 19.315780639648551],
          [77.899528503418026, 19.317790985107536],
          [77.893257141113338, 19.321161270141715],
          [77.888046264648437, 19.312410354614201],
          [77.875228881836108, 19.30890083312994],
          [77.871116638183821, 19.305730819702205],
          [77.86087799072294, 19.302129745483455],
          [77.862640380859546, 19.295370101928711],
          [77.860847473144815, 19.287639617920036],
          [77.861923217773438, 19.284099578857422],
          [77.875389099121207, 19.279779434204215],
          [77.893058776855696, 19.278392791748104],
          [77.900672912597713, 19.277128219604549],
          [77.905708312988395, 19.267219543457031],
          [77.900390624999943, 19.256120681762809],
          [77.891876220703182, 19.257099151611442],
          [77.884628295898494, 19.260231018066463],
          [77.867385864257756, 19.255260467529297],
          [77.868080139160213, 19.246110916137752],
          [77.865402221679915, 19.237930297851676],
          [77.862289428710937, 19.23396110534668],
          [77.861526489257813, 19.226291656494141],
          [77.858451843261889, 19.218469619751033],
          [77.852333068847827, 19.209711074829158],
          [77.852676391601847, 19.204591751098746],
          [77.846549987793253, 19.196979522705135],
          [77.844535827636889, 19.188190460205135],
          [77.858390808105753, 19.180772781372184],
          [77.853019714355526, 19.176820755004883],
          [77.854232788085881, 19.172290802001953],
          [77.853858947754077, 19.169431686401481],
          [77.850357055664347, 19.167650222778263],
          [77.850166320801065, 19.162311553955192],
          [77.848747253417969, 19.159429550170955],
          [77.849243164062784, 19.155281066894588],
          [77.837677001953296, 19.138309478759879],
          [77.83109283447294, 19.135652542114258],
          [77.833930969238509, 19.132738113403263],
          [77.838638305664063, 19.118850708007869],
          [77.845191955566463, 19.11421012878418],
          [77.844146728515796, 19.096071243286246],
          [77.848182678222656, 19.092599868774471],
          [77.848136901855639, 19.090080261230526],
          [77.846588134765739, 19.088518142700195],
          [77.842185974121378, 19.086771011352482],
          [77.833808898925895, 19.086532592773381],
          [77.828613281250284, 19.084941864013672],
          [77.825477600097656, 19.09169960021984],
          [77.822372436523381, 19.096399307251033],
          [77.815170288086108, 19.103662490844783],
          [77.80576324462902, 19.103340148925781],
          [77.802650451660384, 19.101961135864315],
          [77.800247192382756, 19.098871231079158],
          [77.799766540527401, 19.09457969665533],
          [77.801307678222884, 19.084409713745117],
          [77.797286987304744, 19.074590682983455],
          [77.794456481933651, 19.073369979858398],
          [77.793533325195597, 19.071210861206168],
          [77.79715728759794, 19.064880371093807],
          [77.795669555664006, 19.061019897460937],
          [77.797180175781364, 19.051309585571289],
          [77.794540405273608, 19.050191879272575],
          [77.791137695312671, 19.050659179687614],
          [77.783096313476733, 19.054830551147404],
          [77.777946472168139, 19.054370880127067],
          [77.770988464355696, 19.056159973144645],
          [77.761688232422159, 19.062040328979606],
          [77.759559631347713, 19.05930137634283],
          [77.760932922363565, 19.05121040344244],
          [77.757392883300781, 19.028551101684684],
          [77.760238647461108, 19.022640228271541],
          [77.762161254882813, 19.02050971984869],
          [77.764266967773438, 19.019620895385799],
          [77.765327453613395, 19.015390396118278],
          [77.765747070312671, 19.007379531860465],
          [77.768432617187671, 18.999380111694336],
          [77.767356872558821, 18.981420516967773],
          [77.781509399414347, 18.976320266723746],
          [77.787132263183764, 18.984281539916992],
          [77.817138671875227, 18.982370376586971],
          [77.812866210937671, 18.96006011962902],
          [77.815200805664119, 18.959239959716797],
          [77.812690734863452, 18.949459075927848],
          [77.827392578125, 18.945720672607422],
          [77.830497741699446, 18.950201034545955],
          [77.853729248046932, 18.952278137207031],
          [77.848701477050724, 18.931381225585994],
          [77.844306945800724, 18.930320739746037],
          [77.841133117675781, 18.921461105346793],
          [77.840499877929631, 18.911300659179688],
          [77.856636047363338, 18.906070709228516],
          [77.869262695312784, 18.910320281982479],
          [77.881576538085994, 18.908531188964957],
          [77.88260650634794, 18.896379470825309],
          [77.887672424316406, 18.88512039184576],
          [77.89865875244152, 18.883739471435547],
          [77.899200439453409, 18.867927551269645],
          [77.906066894531534, 18.867319107055721],
          [77.925338745117472, 18.859210968017635],
          [77.92459869384777, 18.854141235351619],
          [77.932357788085994, 18.850931167602596],
          [77.929649353027401, 18.846490859985352],
          [77.944137573242244, 18.842290878295955],
          [77.945228576660327, 18.832109451294059],
          [77.942550659179858, 18.822290420532227],
          [77.92874908447294, 18.821720123291016],
          [77.907592773437784, 18.8295192718507],
          [77.859222412109546, 18.814060211181754],
          [77.837463378906421, 18.807460784912109],
          [77.827552795410327, 18.786012649536133],
          [77.823181152343921, 18.768501281738338],
          [77.810386657715014, 18.740249633789119],
          [77.802719116211051, 18.72924995422369],
          [77.802223205566406, 18.716119766235408],
          [77.786506652832145, 18.694320678710994],
          [77.786437988281477, 18.684120178222656],
          [77.769401550292969, 18.690589904785156],
          [77.768798828125171, 18.701620101928711],
          [77.76438140869152, 18.707939147949162],
          [77.757629394531477, 18.707090377807731],
          [77.749908447265796, 18.697830200195256],
          [77.749496459961051, 18.689781188964957],
          [77.744667053222884, 18.683889389038086],
          [77.732856750488338, 18.676000595092887],
          [77.728111267090128, 18.664209365844783],
          [77.733245849609659, 18.662128448486328],
          [77.733177185058594, 18.65570068359375],
          [77.730926513672102, 18.655321121215934],
          [77.730110168457031, 18.648122787475643],
          [77.729759216308651, 18.645589828491268],
          [77.729721069336108, 18.642732620239371],
          [77.73602294921875, 18.630897521972656],
          [77.742988586426065, 18.621400833129883],
          [77.748092651367415, 18.60531044006359],
          [77.747161865234432, 18.589080810546989],
          [77.735382080078239, 18.563180923462028],
          [77.736511230469034, 18.5548095703125],
          [77.727935791015909, 18.551540374755916],
          [77.712356567382983, 18.554439544677848],
          [77.682746887207145, 18.54080963134777],
          [77.675903320312671, 18.541339874267578],
          [77.662078857422102, 18.533250808715934],
          [77.65756988525402, 18.527200698852539],
          [77.645286560058821, 18.536300659179688],
          [77.649467468261776, 18.541330337524414],
          [77.65219879150419, 18.549631118774528],
          [77.649551391601676, 18.549661636352482],
          [77.648811340331974, 18.552619934082145],
          [77.640480041503906, 18.553930282592887],
          [77.634407043457088, 18.545181274414176],
          [77.629066467285213, 18.550640106201286],
          [77.616333007812784, 18.54866981506359],
          [77.615821838379077, 18.542940139770621],
          [77.613296508789347, 18.542390823364371],
          [77.610870361328296, 18.547769546508732],
          [77.59726715087919, 18.547540664672965],
          [77.598190307617244, 18.535039901733512],
          [77.593292236328239, 18.528020858764592],
          [77.593292236328239, 18.523141860962028],
          [77.600402832031421, 18.524971008300895],
          [77.601448059082315, 18.52194976806652],
          [77.596466064453352, 18.514999389648494],
          [77.587066650390625, 18.509849548339901],
          [77.586273193359546, 18.502920150756893],
          [77.593887329101733, 18.493869781494141],
          [77.602836608886662, 18.491380691528377],
          [77.603752136230753, 18.485258102417106],
          [77.601066589355753, 18.474210739135856],
          [77.593116760253849, 18.473510742187443],
          [77.590759277343807, 18.481109619140739],
          [77.576522827148381, 18.483779907226676],
          [77.570632934570483, 18.466859817504996],
          [77.560401916503963, 18.467491149902401],
          [77.558090209960994, 18.465270996093864],
          [77.546516418457315, 18.465719223022461],
          [77.546195983886662, 18.463382720947266],
          [77.548881530761889, 18.460809707641602],
          [77.549797058105582, 18.457969665527401],
          [77.559089660644588, 18.458000183105526],
          [77.583648681640682, 18.453550338745174],
          [77.583282470703182, 18.447191238403434],
          [77.585212707519759, 18.445449829101676],
          [77.582641601562671, 18.443069458007813],
          [77.574119567871151, 18.439342498779297],
          [77.56693267822294, 18.438610076904354],
          [77.560173034667969, 18.435049057006893],
          [77.54644775390625, 18.440559387207031],
          [77.534507751465128, 18.442399978637752],
          [77.528480529785327, 18.440481185913029],
          [77.525939941406534, 18.427350997924805],
          [77.535980224609432, 18.423450469970646],
          [77.535156250000171, 18.421180725097713],
          [77.544136047363452, 18.420410156250057],
          [77.555206298828125, 18.417852401733455],
          [77.549301147460938, 18.387718200683594],
          [77.541557312012003, 18.385219573974666],
          [77.530502319336222, 18.375770568847713],
          [77.521400451660099, 18.364650726318473],
          [77.519500732422046, 18.349252700805664],
          [77.527328491211108, 18.339401245117301],
          [77.542190551757756, 18.333900451660099],
          [77.55335998535179, 18.331222534179631],
          [77.566917419433651, 18.317949295043945],
          [77.570228576660099, 18.308179855346737],
          [77.555030822753906, 18.298311233520508],
          [77.549957275390909, 18.291349411010742],
          [77.539581298828125, 18.293830871582145],
          [77.523887634277514, 18.303031921386719],
          [77.519783020019759, 18.307369232177791],
          [77.509506225585994, 18.306730270385856],
          [77.508430480956974, 18.302169799804744],
          [77.512641906738452, 18.28198051452631],
          [77.510208129882813, 18.278440475463924],
          [77.497741699218693, 18.273349761962834],
          [77.492233276367358, 18.265880584716911],
          [77.480346679687784, 18.268659591674805],
          [77.474807739258097, 18.262290954589901],
          [77.469230651855526, 18.263160705566406],
          [77.465393066406307, 18.259960174560661],
          [77.450790405273722, 18.265960693359489],
          [77.445220947265682, 18.270120620727539],
          [77.444892883300895, 18.277240753173885],
          [77.436927795410327, 18.282039642334041],
          [77.434616088867131, 18.29298019409174],
          [77.436370849609546, 18.306491851806754],
          [77.427803039550781, 18.30917930603033],
          [77.425003051757869, 18.304670333862248],
          [77.407806396484432, 18.299560546874943],
          [77.396286010742358, 18.30298042297369],
          [77.392570495605696, 18.300930023193416],
          [77.381286621093807, 18.305950164794865],
          [77.362525939941577, 18.30829048156744],
          [77.358810424804915, 18.310649871826229],
          [77.355422973633097, 18.318519592285156],
          [77.367019653320369, 18.322322845459098],
          [77.373947143554801, 18.329509735107479],
          [77.378005981445483, 18.328689575195369],
          [77.380897521972713, 18.331930160522575],
          [77.379302978515568, 18.339101791381893],
          [77.386177062988452, 18.338190078735352],
          [77.389228820800952, 18.340789794921875],
          [77.392829895019645, 18.340549468994141],
          [77.392776489257869, 18.345670700073185],
          [77.395942687988281, 18.34464073181158],
          [77.398330688476847, 18.347499847412223],
          [77.398246765136719, 18.353530883789176],
          [77.391822814941463, 18.365930557251033],
          [77.400672912597827, 18.370170593261719],
          [77.407882690429972, 18.378490447998047],
          [77.41011047363304, 18.388530731201286],
          [77.400497436523608, 18.397800445556697],
          [77.392639160156364, 18.397029876709041],
          [77.369750976562614, 18.400709152221737],
          [77.364410400390739, 18.429849624633903],
          [77.365356445312614, 18.438089370727482],
          [77.36962890625, 18.447650909423942],
          [77.354072570801065, 18.448741912841854],
          [77.345291137695597, 18.434371948242301],
          [77.34207916259794, 18.430290222167969],
          [77.337310791015909, 18.435440063476562],
          [77.333381652832031, 18.441890716552791],
          [77.332710266113565, 18.448459625244141],
          [77.326019287109432, 18.448850631713981],
          [77.325576782226563, 18.455120086669865],
          [77.317413330078352, 18.453790664672852],
          [77.31327056884794, 18.43938064575201],
          [77.302261352539233, 18.438470840454045],
          [77.294769287109659, 18.43268013000494],
          [77.264556884765682, 18.418380737304801],
          [77.258361816406364, 18.410419464111385],
          [77.249122619628963, 18.408252716064453],
          [77.240226745605753, 18.408647537231502],
          [77.236396789551065, 18.399810791015682],
          [77.232872009277344, 18.386127471923828],
          [77.245033264160327, 18.370588302612362],
          [77.241630554199389, 18.366382598877067],
          [77.230812072753963, 18.365579605102653],
          [77.221366882324162, 18.347209930419922],
          [77.22727203369152, 18.3449001312257],
          [77.222976684570369, 18.337800979614258],
          [77.216911315918026, 18.324890136718864],
          [77.209976196289062, 18.313741683960018],
          [77.200149536133097, 18.319169998169002],
          [77.19541168212902, 18.312709808349666],
          [77.197647094726619, 18.295520782470703],
          [77.204460144042969, 18.290479660034237],
          [77.2061767578125, 18.277959823608342],
          [77.19882965087919, 18.279230117797852],
          [77.191650390625171, 18.274290084838981],
          [77.177841186523722, 18.281850814819336],
          [77.170532226562557, 18.280870437622184],
          [77.167381286621207, 18.27345085144043],
          [77.165679931640568, 18.25592041015625],
          [77.157196044922102, 18.253091812133789],
          [77.151412963867358, 18.237939834594783],
          [77.147766113281421, 18.237649917602539],
          [77.147689819336222, 18.221401214599666],
          [77.148796081543026, 18.221452713012695],
          [77.150642395019702, 18.221530914306641],
          [77.149986267090128, 18.216560363769645],
          [77.142219543456974, 18.216049194335938],
          [77.139495849609659, 18.207241058349666],
          [77.131149291992131, 18.206180572509879],
          [77.120986938476847, 18.206701278686523],
          [77.116622924804972, 18.202409744262695],
          [77.106590270996264, 18.201810836792106],
          [77.095542907714844, 18.195100784301701],
          [77.098861694336222, 18.191141128540039],
          [77.102928161621037, 18.186309814453125],
          [77.1163330078125, 18.167608261108455],
          [77.10888671875, 18.152690887451229],
          [77.096618652343864, 18.158130645751896],
          [77.092681884765625, 18.156978607177848],
          [77.089256286621094, 18.155960083007812],
          [77.086181640625171, 18.150270462036076],
          [77.069107055664347, 18.149440765380916],
          [77.057670593262003, 18.152362823486442],
          [77.057670593262003, 18.155929565429801],
          [77.050315856933764, 18.16127967834484],
          [77.049446105957088, 18.17320823669445],
          [77.038101196289233, 18.181310653686523],
          [77.032836914062727, 18.183780670166072],
          [77.032386779785327, 18.183000564575252],
          [77.030326843261776, 18.179340362548828],
          [77.021713256836108, 18.17822074890131],
          [77.022743225097713, 18.171249389648438],
          [77.023986816406421, 18.162679672241268],
          [76.997756958007869, 18.166849136352653],
          [76.995292663574503, 18.173330307006893],
          [76.995475769043026, 18.178390502929744],
          [76.992950439453182, 18.182050704956055],
          [76.991462707519588, 18.186651229858398],
          [76.98789215087902, 18.188478469848633],
          [76.980552673339901, 18.189399719238338],
          [76.979850769043253, 18.187400817871207],
          [76.970901489258097, 18.186861038208121],
          [76.958816528320369, 18.186140060424862],
          [76.954109191894815, 18.184890747070426],
          [76.950958251953125, 18.172479629516658],
          [76.943756103515682, 18.154739379882869],
          [76.933357238769474, 18.157909393310661],
          [76.925369262695483, 18.144819259643668],
          [76.927658081054858, 18.139860153198356],
          [76.931762695312557, 18.136579513549918],
          [76.92999267578125, 18.132251739501953],
          [76.924179077148722, 18.124460220336971],
          [76.922286987304801, 18.12018966674799],
          [76.922561645507869, 18.116109848022518],
          [76.932151794433651, 18.110982894897518],
          [76.942527770996264, 18.111410140991325],
          [76.953392028808537, 18.110111236572266],
          [76.958572387695483, 18.106430053710994],
          [76.968276977539233, 18.097110748290959],
          [76.967346191406421, 18.09263992309576],
          [76.964317321777344, 18.088211059570426],
          [76.954826354980696, 18.085359573364315],
          [76.949737548828409, 18.082330703735465],
          [76.947029113769588, 18.073760986328125],
          [76.949485778808821, 18.068269729614258],
          [76.952667236328296, 18.063409805297908],
          [76.950607299804744, 18.058269500732479],
          [76.948448181152514, 18.048660278320369],
          [76.948631286621264, 18.045721054077148],
          [76.954307556152628, 18.042730331420955],
          [76.954643249511946, 18.039680480957088],
          [76.952056884765568, 18.037710189819336],
          [76.938636779785213, 18.037229537963981],
          [76.917716979980412, 18.033229827880859],
          [76.919403076172159, 18.02201080322277],
          [76.920249938964844, 18.013759613037053],
          [76.917671203613565, 18.012340545654354],
          [76.918167114257813, 18.001871109008732],
          [76.918487548828068, 17.998689651489258],
          [76.917633056640852, 17.996259689330998],
          [76.919670104980639, 17.990640640258789],
          [76.919586181640909, 17.985380172729435],
          [76.918235778808878, 17.972850799560604],
          [76.917266845703182, 17.960479736328125],
          [76.913223266601619, 17.937208175659237],
          [76.919189453125284, 17.936660766601562],
          [76.918342590332031, 17.923109054565487],
          [76.91644287109375, 17.915090560913143],
          [76.913200378417969, 17.913799285888615],
          [76.900207519531421, 17.914688110351563],
          [76.896598815917969, 17.90802001953125],
          [76.893669128418082, 17.907371520996207],
          [76.892402648925781, 17.902851104736385],
          [76.889381408691463, 17.897180557250977],
          [76.883209228515796, 17.897079467773551],
          [76.881179809570369, 17.893051147460994],
          [76.875267028808651, 17.892730712890568],
          [76.871856689453352, 17.894741058349553],
          [76.853836059570483, 17.897838592529297],
          [76.846916198730753, 17.896400451660156],
          [76.831756591796875, 17.890672683715763],
          [76.833076477050952, 17.882749557495231],
          [76.820365905761946, 17.884452819824276],
          [76.817131042480526, 17.883090972900334],
          [76.811080932617301, 17.884088516235408],
          [76.808227539062614, 17.883090972900334],
          [76.805351257324503, 17.87420845031744],
          [76.806251525879134, 17.870492935180664],
          [76.802803039550838, 17.868320465087947],
          [76.797447204589901, 17.869340896606445],
          [76.774566650390682, 17.876960754394531],
          [76.773262023925838, 17.878660202026424],
          [76.773796081543026, 17.882240295410099],
          [76.77310943603544, 17.885150909423942],
          [76.7701416015625, 17.892360687255916],
          [76.765953063964844, 17.898429870605582],
          [76.742973327637003, 17.899021148681697],
          [76.740676879883097, 17.898010253906307],
          [76.739585876465014, 17.892049789428768],
          [76.739646911621151, 17.883621215820313],
          [76.737457275390739, 17.857059478759822],
          [76.745788574218977, 17.858310699462834],
          [76.754562377929915, 17.856588363647575],
          [76.759727478027401, 17.852060317993221],
          [76.764343261719034, 17.849500656127987],
          [76.765739440918139, 17.850799560546875],
          [76.779747009277401, 17.836330413818473],
          [76.785469055175838, 17.831462860107422],
          [76.788169860840128, 17.826471328735352],
          [76.784812927246264, 17.81963920593256],
          [76.781417846679744, 17.815120697021541],
          [76.779479980468921, 17.810289382934627],
          [76.779792785644815, 17.805919647216797],
          [76.776283264160213, 17.799381256103516],
          [76.770027160644588, 17.797019958496094],
          [76.766326904296875, 17.796649932861442],
          [76.762756347656477, 17.787109375],
          [76.74887847900419, 17.786350250244254],
          [76.747772216796818, 17.783609390258846],
          [76.744010925292969, 17.78346061706543],
          [76.743553161621378, 17.780790328979492],
          [76.739433288574219, 17.779130935668945],
          [76.724632263183651, 17.785078048706168],
          [76.719383239746264, 17.785299301147404],
          [76.715705871582315, 17.781919479370117],
          [76.712448120117472, 17.775091171264705],
          [76.712806701660213, 17.771360397338981],
          [76.71720123291044, 17.769849777221623],
          [76.720962524414119, 17.767589569091854],
          [76.719093322753963, 17.761331558227653],
          [76.717971801758097, 17.747869491577262],
          [76.721931457519588, 17.748029708862362],
          [76.726501464843807, 17.740369796752987],
          [76.727607727050781, 17.736999511718807],
          [76.703475952148722, 17.729120254516545],
          [76.698150634765909, 17.726039886474666],
          [76.70210266113304, 17.723711013794002],
          [76.703453063964901, 17.718620300292969],
          [76.700798034668253, 17.707269668579158],
          [76.692359924316463, 17.70526123046875],
          [76.690872192382869, 17.701940536498967],
          [76.691223144531307, 17.698141098022404],
          [76.693130493164119, 17.693761825561523],
          [76.690551757812443, 17.679952621460018],
          [76.688262939453068, 17.678510665893555],
          [76.678146362304801, 17.68734169006359],
          [76.671646118164347, 17.689140319824276],
          [76.663139343261719, 17.687860488891658],
          [76.659835815429801, 17.699190139770451],
          [76.658126831054631, 17.708530426025504],
          [76.655212402344034, 17.716400146484432],
          [76.650833129883097, 17.720830917358342],
          [76.637435913085994, 17.72410964965826],
          [76.63065338134777, 17.729000091552734],
          [76.629798889160213, 17.74187088012701],
          [76.626953125000227, 17.755960464477596],
          [76.623367309570597, 17.757890701294059],
          [76.614448547363224, 17.76831245422369],
          [76.609512329101733, 17.765979766845646],
          [76.606903076171932, 17.759580612182617],
          [76.604057312011776, 17.755830764770451],
          [76.598800659179801, 17.727970123291072],
          [76.593246459961222, 17.717559814453182],
          [76.587028503418139, 17.707889556884822],
          [76.577209472656534, 17.703140258789006],
          [76.573226928711222, 17.702169418334961],
          [76.569427490234489, 17.703741073608455],
          [76.568107604980412, 17.739799499511719],
          [76.56459045410179, 17.753660202026367],
          [76.569366455078182, 17.756380081176871],
          [76.57330322265625, 17.760000228881836],
          [76.567543029785327, 17.762889862060661],
          [76.559776306152344, 17.763139724731445],
          [76.5382080078125, 17.758939743042106],
          [76.531593322754134, 17.758529663085994],
          [76.526321411132926, 17.759361267089957],
          [76.523696899414233, 17.758890151977482],
          [76.525039672851733, 17.734672546386719],
          [76.524826049804858, 17.722909927368221],
          [76.523635864258097, 17.715230941772518],
          [76.510955810546932, 17.715919494628849],
          [76.492256164550781, 17.714941024780273],
          [76.486366271972713, 17.713520050048942],
          [76.485626220703352, 17.692699432373161],
          [76.484428405761719, 17.684429168701229],
          [76.484649658203182, 17.669630050659237],
          [76.48929595947294, 17.660669326782227],
          [76.452301025390909, 17.655548095703182],
          [76.451538085937784, 17.651510238647518],
          [76.440849304199503, 17.649370193481559],
          [76.442756652832315, 17.641870498657283],
          [76.434776306152287, 17.644531250000114],
          [76.428726196289062, 17.644411087036246],
          [76.427230834960994, 17.639780044555721],
          [76.425796508789176, 17.628320693969783],
          [76.424102783203068, 17.621540069580135],
          [76.420745849609432, 17.614240646362305],
          [76.418182373046818, 17.605831146240234],
          [76.415672302246378, 17.604200363159237],
          [76.382072448730526, 17.600780487060661],
          [76.373016357422046, 17.597938537597713],
          [76.359481811523608, 17.596292495727596],
          [76.348701477051065, 17.595399856567496],
          [76.336410522460938, 17.596040725708008],
          [76.331672668457088, 17.594869613647518],
          [76.332908630371207, 17.573831558227653],
          [76.334236145019815, 17.56348991394043],
          [76.337242126464901, 17.555179595947379],
          [76.340026855468921, 17.542570114135799],
          [76.345832824707088, 17.540210723876953],
          [76.354812622070597, 17.538730621337947],
          [76.360900878906307, 17.536260604858398],
          [76.364608764648608, 17.528520584106445],
          [76.366127014160327, 17.522172927856388],
          [76.36640930175804, 17.51671028137207],
          [76.356018066406421, 17.513370513916072],
          [76.346336364746094, 17.511480331420955],
          [76.343727111816463, 17.508119583129883],
          [76.343482971191406, 17.494350433349723],
          [76.345947265625, 17.491598129272461],
          [76.355186462402628, 17.494169235229549],
          [76.366592407226619, 17.495292663574219],
          [76.37503814697294, 17.493520736694336],
          [76.372299194335994, 17.485780715942383],
          [76.350006103515852, 17.472129821777457],
          [76.342788696289347, 17.470371246337891],
          [76.337768554687557, 17.470409393310547],
          [76.330802917480753, 17.468818664550838],
          [76.330841064453296, 17.461620330810547],
          [76.33365631103544, 17.432292938232479],
          [76.341957092285156, 17.433830261230412],
          [76.3638916015625, 17.435550689697322],
          [76.373176574706974, 17.434419631958121],
          [76.369880676269815, 17.423040390014762],
          [76.370048522949276, 17.407899856567496],
          [76.361999511718807, 17.375080108642635],
          [76.408065795898551, 17.369289398193359],
          [76.410507202148722, 17.354139328002987],
          [76.410636901855526, 17.347690582275504],
          [76.402046203613338, 17.343990325927791],
          [76.392990112304801, 17.336280822753963],
          [76.383895874023608, 17.319541931152457],
          [76.381706237793253, 17.311809539795036],
          [76.359367370605526, 17.31028938293457],
          [76.352272033691463, 17.310590744018555],
          [76.350601196289119, 17.327720642089957],
          [76.343612670898381, 17.349931716919059],
          [76.334739685058651, 17.349849700927734],
          [76.317047119140909, 17.34540939331049],
          [76.313011169433821, 17.343271255493107],
          [76.318367004394588, 17.331840515136719],
          [76.317207336426009, 17.329441070556641],
          [76.305023193359659, 17.328451156616325],
          [76.295898437500284, 17.328638076782227],
          [76.285766601562784, 17.330350875854606],
          [76.275878906250114, 17.330530166625977],
          [76.272636413574332, 17.347949981689453],
          [76.270179748535099, 17.356531143188533],
          [76.264945983886946, 17.358161926269531],
          [76.256278991699389, 17.357389450073299],
          [76.250000000000171, 17.357900619506836],
          [76.248908996582088, 17.362131118774528],
          [76.25044250488304, 17.366670608520565],
          [76.246711730956974, 17.367889404296875],
          [76.244361877441463, 17.374679565429801],
          [76.230377197265625, 17.370260238647404],
          [76.228996276855639, 17.363229751586971],
          [76.203521728515852, 17.358789443969727],
          [76.193206787109432, 17.358591079711914],
          [76.182907104492244, 17.356500625610352],
          [76.176033020019588, 17.35238075256359],
          [76.172332763671818, 17.348730087280273],
          [76.173507690429858, 17.332239151000977],
          [76.176338195800724, 17.32146072387701],
          [76.178916931152571, 17.313919067382812],
          [76.182601928711222, 17.314300537109375],
          [76.183830261230469, 17.311042785644531],
          [76.175758361816349, 17.297210693359489],
          [76.171882629394588, 17.297580718994141],
          [76.163803100585937, 17.300331115722656],
          [76.164222717285213, 17.319259643554687],
          [76.163146972656534, 17.340909957885742],
          [76.145668029785327, 17.347932815551815],
          [76.137588500976847, 17.352569580078068],
          [76.121208190917912, 17.366340637207031],
          [76.116676330566577, 17.366220474243164],
          [76.101997375488281, 17.362260818481502],
          [76.095962524414119, 17.357812881469727],
          [76.092765808105753, 17.354440689086971],
          [76.090469360351847, 17.350561141967887],
          [76.094078063965128, 17.347091674804688],
          [76.092521667480696, 17.343679428100643],
          [76.086967468261776, 17.338447570800724],
          [76.086853027344034, 17.333730697631893],
          [76.084991455078296, 17.332120895385685],
          [76.078742980957031, 17.330070495605412],
          [76.073478698730753, 17.332321166992301],
          [76.063201904297159, 17.351900100708008],
          [76.060462951660213, 17.35393142700201],
          [76.054527282714901, 17.354299545288086],
          [76.036666870117472, 17.34896278381359],
          [76.021278381347827, 17.349311828613395],
          [76.01545715332054, 17.350610733032283],
          [76.009140014648494, 17.347522735595646],
          [76.004173278808651, 17.342790603637752],
          [76.000267028808707, 17.337749481201286],
          [75.980712890625057, 17.336200714111385],
          [75.971527099609546, 17.336460113525334],
          [75.95981597900419, 17.333831787109489],
          [75.941749572754077, 17.324859619140739],
          [75.931152343750227, 17.324110031127873],
          [75.916221618652344, 17.338970184326172],
          [75.910713195800838, 17.345819473266602],
          [75.898086547851733, 17.3507595062257],
          [75.893661499023381, 17.353620529174918],
          [75.891983032226733, 17.360799789428768],
          [75.896392822265625, 17.369989395141602],
          [75.89697265625, 17.377000808715934],
          [75.896430969238338, 17.394979476928768],
          [75.894355773925838, 17.405902862548828],
          [75.890258789062671, 17.413600921630916],
          [75.887237548828125, 17.417329788208008],
          [75.882431030273608, 17.419000625610295],
          [75.878448486328296, 17.41654014587408],
          [75.877128601074219, 17.411350250244197],
          [75.879096984863338, 17.404939651489258],
          [75.878906250000057, 17.400329589843807],
          [75.876663208008097, 17.39697074890131],
          [75.864875793457202, 17.386440277099609],
          [75.861968994140909, 17.38585090637207],
          [75.85910797119169, 17.388969421386832],
          [75.856002807617415, 17.407682418823242],
          [75.84787750244152, 17.415340423584041],
          [75.838890075683878, 17.420541763305664],
          [75.827796936035213, 17.42371940612793],
          [75.82472229003929, 17.422849655151481],
          [75.821990966797046, 17.41967964172369],
          [75.820251464843921, 17.406560897827148],
          [75.817291259765852, 17.401210784912166],
          [75.816276550292969, 17.397811889648437],
          [75.817687988281307, 17.388040542602653],
          [75.817596435547046, 17.380729675293026],
          [75.815055847168253, 17.373849868774414],
          [75.811332702636719, 17.369939804077148],
          [75.802337646484546, 17.370101928711051],
          [75.791023254394815, 17.372980117797965],
          [75.782318115234546, 17.378812789917106],
          [75.776618957519531, 17.388202667236328],
          [75.769767761230526, 17.406841278076115],
          [75.764122009277628, 17.408420562744141],
          [75.758758544922159, 17.408411026001033],
          [75.750526428222884, 17.412900924682674],
          [75.73703765869169, 17.421899795532227],
          [75.73398590087919, 17.421659469604549],
          [75.729011535644815, 17.419509887695256],
          [75.722366333007926, 17.41177940368658],
          [75.715179443359546, 17.408931732177678],
          [75.708061218261832, 17.408319473266545],
          [75.697212219238224, 17.410568237304687],
          [75.691192626953182, 17.412611007690373],
          [75.687118530273608, 17.417301177978629],
          [75.680809020996037, 17.436162948608455],
          [75.680816650390796, 17.453971862793026],
          [75.677558898925724, 17.457971572875977],
          [75.67044830322294, 17.459320068359432],
          [75.662300109863224, 17.459680557250977],
          [75.656181335449332, 17.467510223388672],
          [75.649559020996264, 17.473409652710075],
          [75.635589599609489, 17.477510452270621],
          [75.632888793945597, 17.469640731811467],
          [75.631271362304688, 17.461179733276424],
          [75.625328063965014, 17.458110809326286],
          [75.618736267090071, 17.439111709594783],
          [75.615432739257813, 17.422029495239371],
          [75.610137939453182, 17.419540405273438],
          [75.610557556152628, 17.417119979858455],
          [75.614952087402628, 17.409561157226676],
          [75.616722106933537, 17.398639678955021],
          [75.615806579590014, 17.39185905456543],
          [75.61057281494169, 17.392009735107422],
          [75.603317260742472, 17.389860153198356],
          [75.598159790039347, 17.386100769043082],
          [75.588172912597656, 17.383020401001033],
          [75.583717346191349, 17.382200241088924],
          [75.578536987304972, 17.382930755615291],
          [75.584053039551065, 17.351341247558651],
          [75.584831237793253, 17.34977912902832],
          [75.589942932128963, 17.349689483642635],
          [75.598106384277401, 17.345119476318416],
          [75.613105773925952, 17.342290878295898],
          [75.616043090820369, 17.32876014709484],
          [75.613746643066463, 17.319440841674862],
          [75.605957031250227, 17.303260803222713],
          [75.624687194824503, 17.29380035400402],
          [75.627868652343807, 17.288120269775447],
          [75.631095886230526, 17.27984809875494],
          [75.633369445800781, 17.277389526367301],
          [75.632316589355753, 17.272220611572266],
          [75.657478332519815, 17.270570755004996],
          [75.659889221191406, 17.261440277099723],
          [75.660919189453409, 17.239999771118221],
          [75.66281890869169, 17.227939605712891],
          [75.66387939453125, 17.213750839233455],
          [75.662117004394474, 17.208330154419002],
          [75.657432556152401, 17.203781127929801],
          [75.64359283447277, 17.19408035278326],
          [75.642646789550895, 17.18815994262701],
          [75.630699157714844, 17.186161041259709],
          [75.630187988281307, 17.181449890136832],
          [75.62851715087919, 17.18074989318859],
          [75.628021240234375, 17.170120239257869],
          [75.63138580322277, 17.160070419311467],
          [75.642730712890682, 17.147638320922852],
          [75.648712158203409, 17.138801574707031],
          [75.649688720703409, 17.13318061828619],
          [75.652732849121378, 17.132730484008789],
          [75.653633117676009, 17.113130569458065],
          [75.674102783203409, 17.113550186157283],
          [75.675506591797046, 17.101129531860408],
          [75.678489685058878, 17.094171524047795],
          [75.677391052246264, 17.087749481201172],
          [75.680137634277401, 17.078268051147461],
          [75.681076049804744, 17.071140289306584],
          [75.678405761718807, 17.062860488891715],
          [75.670967102050838, 17.06157112121582],
          [75.662689208984318, 17.061782836914119],
          [75.654396057129134, 17.05508995056158],
          [75.647872924804688, 17.04657173156744],
          [75.643753051758097, 17.036399841308594],
          [75.648193359374943, 17.032690048217773],
          [75.653999328613338, 17.0306396484375],
          [75.662162780761719, 17.032449722290096],
          [75.672241210937671, 17.035730361938533],
          [75.673103332519588, 17.026170730590877],
          [75.670539855957202, 16.998830795288143],
          [75.668678283691463, 16.983219146728459],
          [75.668830871582202, 16.97776031494152],
          [75.669380187988452, 16.975629806518498],
          [75.672630310058764, 16.974081039428825],
          [75.674591064453182, 16.969350814819336],
          [75.678421020507869, 16.963941574096793],
          [75.674606323242244, 16.960269927978629],
          [75.671379089355696, 16.958538055419979],
          [75.663749694824446, 16.957881927490234],
          [75.65561676025402, 16.956110000610352],
          [75.649627685547102, 16.951999664306641],
          [75.645027160644588, 16.951032638549748],
          [75.639389038086222, 16.959159851074276],
          [75.636337280273722, 16.965810775756893],
          [75.630943298340071, 16.967149734497013],
          [75.621017456054915, 16.967750549316463],
          [75.610656738281421, 16.969619750976562],
          [75.609657287597599, 16.998939514160099],
          [75.609519958496094, 17.003110885620117],
          [75.599441528320369, 17.005220413208065],
          [75.575798034668026, 17.00779914855957],
          [75.569915771484432, 17.006170272827148],
          [75.569297790527401, 16.998859405517521],
          [75.570343017578409, 16.96362113952631],
          [75.558471679687557, 16.964349746704102],
          [75.542816162109602, 16.963140487670955],
          [75.532867431640682, 16.966651916503963],
          [75.530006408691463, 16.965829849243164],
          [75.524063110351733, 16.958740234375],
          [75.517005920410327, 16.951932907104606],
          [75.510650634765739, 16.947309494018612],
          [75.509292602539347, 16.948591232299805],
          [75.501876831054801, 16.94540977478033],
          [75.492492675781534, 16.942899703979549],
          [75.493011474609432, 16.945180892944336],
          [75.492630004882869, 16.951509475707951],
          [75.491783142089787, 16.957830429077205],
          [75.489692687988224, 16.965389251709041],
          [75.482498168945313, 16.975950241088924],
          [75.468589782714901, 16.979570388793945],
          [75.467910766601847, 16.985330581665039],
          [75.453536987304744, 16.982650756835994],
          [75.443801879882869, 16.979490280151367],
          [75.438850402832088, 16.970880508422908],
          [75.431022644043026, 16.963460922241211],
          [75.416831970214787, 16.969499588012695],
          [75.394760131835938, 16.976392745971623],
          [75.371688842773438, 16.968690872192383],
          [75.36435699462902, 16.963609695434627],
          [75.359573364258097, 16.956888198852539],
          [75.345329284668139, 16.952520370483512],
          [75.33796691894554, 16.95354080200201],
          [75.306129455566463, 16.954669952392578],
          [75.294746398925895, 16.954128265380916],
          [75.288436889648722, 16.954772949218807],
          [75.284622192383097, 16.953550338745117],
          [75.283599853515682, 16.942941665649414],
          [75.285575866699503, 16.909431457519588],
          [75.291778564453182, 16.901138305664062],
          [75.287498474121207, 16.883211135864201],
          [75.285652160644531, 16.878799438476562],
          [75.282775878906421, 16.874240875244197],
          [75.268302917480469, 16.860860824584961],
          [75.257972717285327, 16.862131118774471],
          [75.248672485351619, 16.864528656005973],
          [75.243446350097599, 16.86449050903326],
          [75.240997314453296, 16.862960815429631],
          [75.235656738281421, 16.854190826416072],
          [75.232910156250284, 16.845542907714957],
          [75.230010986328352, 16.840919494628963],
          [75.215858459472656, 16.840339660644588],
          [75.188285827637003, 16.840890884399414],
          [75.183197021484546, 16.842041015625],
          [75.189002990722884, 16.861898422241325],
          [75.192520141601506, 16.8695583343507],
          [75.189659118652287, 16.873500823974723],
          [75.180847167969034, 16.867511749267635],
          [75.171752929687671, 16.8647975921632],
          [75.164382934570369, 16.865579605102596],
          [75.150527954101847, 16.869409561157283],
          [75.14112854003929, 16.873540878296012],
          [75.138389587402514, 16.878269195556754],
          [75.137107849121151, 16.884599685668945],
          [75.138397216797046, 16.892921447753906],
          [75.127632141113565, 16.897180557250977],
          [75.123573303222713, 16.90043830871582],
          [75.122001647949219, 16.907230377197322],
          [75.118759155273437, 16.909971237182731],
          [75.106925964355639, 16.90952110290533],
          [75.097969055175781, 16.913869857788086],
          [75.094711303711108, 16.921150207519531],
          [75.094146728515796, 16.947229385376033],
          [75.090415954589901, 16.948650360107536],
          [75.082946777343807, 16.946598052978459],
          [75.065406799316634, 16.939260482788086],
          [75.055236816406421, 16.938859939575309],
          [75.050788879394645, 16.93966102600109],
          [75.048149108886889, 16.938711166381893],
          [75.045356750488338, 16.934259414672908],
          [75.034492492675838, 16.928739547729492],
          [75.031906127929801, 16.925670623779297],
          [75.030113220214901, 16.93114280700695],
          [75.030296325683651, 16.941530227661246],
          [75.011405944824276, 16.942581176757869],
          [75.003700256347599, 16.945827484130803],
          [74.999542236328296, 16.941898345947322],
          [74.994491577148722, 16.935039520263729],
          [74.985816955566406, 16.929019927978629],
          [74.981422424316577, 16.930610656738395],
          [74.975288391113452, 16.934600830078182],
          [74.969497680664347, 16.935911178588981],
          [74.966712951660327, 16.935649871826229],
          [74.95999908447277, 16.932931900024471],
          [74.95802307128929, 16.929140090942496],
          [74.954536437988281, 16.930000305175838],
          [74.952430725097827, 16.936220169067496],
          [74.94834136962919, 16.935819625854492],
          [74.938392639160213, 16.940990447998104],
          [74.928520202637003, 16.935201644897404],
          [74.927032470703296, 16.925622940063477],
          [74.936943054199162, 16.920730590820426],
          [74.938201904296932, 16.916469573974609],
          [74.944076538085994, 16.91327095031744],
          [74.948036193847827, 16.909170150756893],
          [74.952842712402401, 16.906480789184513],
          [74.967262268066349, 16.905380249023494],
          [74.964096069335994, 16.877880096435661],
          [74.956069946289063, 16.877290725708121],
          [74.948616027832202, 16.880090713501033],
          [74.945137023925724, 16.877122879028263],
          [74.939666748046875, 16.876520156860465],
          [74.939849853515625, 16.872320175170898],
          [74.937080383301065, 16.869161605835075],
          [74.931503295898494, 16.869541168212834],
          [74.927787780761662, 16.863349914550781],
          [74.911956787109318, 16.855939865112362],
          [74.913307189941577, 16.841449737548942],
          [74.91306304931669, 16.83074951171875],
          [74.915817260742187, 16.810220718383789],
          [74.915863037109432, 16.785680770874023],
          [74.923820495605639, 16.769950866699276],
          [74.907012939453296, 16.769790649414119],
          [74.892639160156534, 16.768690109252873],
          [74.868362426757869, 16.771080017089844],
          [74.854972839355469, 16.770769119262752],
          [74.850341796874943, 16.760320663452148],
          [74.804107666015852, 16.750762939453239],
          [74.800407409668139, 16.745651245117131],
          [74.791107177734432, 16.748149871826229],
          [74.779006958007756, 16.748590469360352],
          [74.775558471679801, 16.743999481201286],
          [74.775047302246264, 16.740779876708928],
          [74.769409179687557, 16.739469528198356],
          [74.763816833496094, 16.736801147460994],
          [74.756141662597827, 16.729629516601506],
          [74.754096984863338, 16.726190567016715],
          [74.748207092285213, 16.722120285034293],
          [74.736618041992472, 16.715839385986328],
          [74.722442626953182, 16.713291168213004],
          [74.707832336426065, 16.713090896606388],
          [74.698196411132813, 16.715200424194393],
          [74.695938110351619, 16.710540771484489],
          [74.695037841797159, 16.692441940307617],
          [74.695610046387003, 16.685831069946289],
          [74.688957214355753, 16.684120178222713],
          [74.687522888183594, 16.681661605835075],
          [74.687278747558764, 16.679010391235352],
          [74.694580078125, 16.6786403656007],
          [74.69610595703125, 16.674980163574276],
          [74.671737670898665, 16.663530349731445],
          [74.668800354004077, 16.655551910400391],
          [74.660507202148722, 16.637580871582088],
          [74.663047790527287, 16.632169723510742],
          [74.666000366210994, 16.628721237182617],
          [74.67386627197294, 16.628459930419922],
          [74.685310363769815, 16.619880676269588],
          [74.691223144531534, 16.618141174316463],
          [74.69431304931652, 16.615190505981559],
          [74.694625854492415, 16.610820770263729],
          [74.693382263183764, 16.607271194458008],
          [74.690376281738281, 16.604459762573185],
          [74.678550720214844, 16.606559753418082],
          [74.675292968750171, 16.605989456176815],
          [74.6688232421875, 16.602680206298942],
          [74.663871765136719, 16.601079940795898],
          [74.651748657226847, 16.606979370117131],
          [74.647712707519588, 16.608070373535213],
          [74.642807006836051, 16.606771469116211],
          [74.641136169433764, 16.604690551757756],
          [74.63974761962919, 16.599531173706055],
          [74.63938140869152, 16.594352722168082],
          [74.640518188476676, 16.581939697265682],
          [74.636367797851733, 16.575740814209041],
          [74.630661010742358, 16.577650070190487],
          [74.626953125000284, 16.580930709838924],
          [74.623939514160099, 16.581920623779297],
          [74.6243896484375, 16.577550888061637],
          [74.622642517090014, 16.573640823364371],
          [74.616996765136946, 16.567970275878963],
          [74.604843139648722, 16.562141418457145],
          [74.595886230468864, 16.564390182495231],
          [74.593353271484432, 16.563829421997127],
          [74.591796875000057, 16.560720443725643],
          [74.591621398926009, 16.558830261230526],
          [74.592536926269531, 16.557270050048942],
          [74.591957092285156, 16.555549621582031],
          [74.581520080566634, 16.555000305175838],
          [74.581520080566634, 16.551839828491211],
          [74.574050903320369, 16.551969528198356],
          [74.569076538085938, 16.55639839172369],
          [74.56552886962919, 16.557790756225586],
          [74.562202453613281, 16.55803108215332],
          [74.559669494628849, 16.559749603271598],
          [74.559089660644474, 16.567108154296989],
          [74.559700012207202, 16.571371078491268],
          [74.565101623535213, 16.574630737304687],
          [74.569816589355639, 16.581220626831055],
          [74.565559387207145, 16.590379714965877],
          [74.554595947265682, 16.592420578003043],
          [74.549850463867415, 16.592180252075195],
          [74.550247192382869, 16.609020233154297],
          [74.549377441406421, 16.615520477294922],
          [74.551437377929972, 16.633211135864258],
          [74.530090332031364, 16.630609512329158],
          [74.510292053222827, 16.631450653076286],
          [74.501670837402457, 16.62713813781744],
          [74.498008728027628, 16.626640319824162],
          [74.495506286621151, 16.627670288085994],
          [74.491783142090014, 16.632339477539176],
          [74.489837646484489, 16.636070251464901],
          [74.485870361328296, 16.639120101928825],
          [74.481338500976563, 16.654069900512752],
          [74.477386474609432, 16.66077995300293],
          [74.470138549804744, 16.65518951416027],
          [74.464797973632869, 16.652950286865291],
          [74.465187072753963, 16.646898269653263],
          [74.462837219238281, 16.644489288330078],
          [74.464469909668082, 16.633989334106445],
          [74.469810485839957, 16.623479843139762],
          [74.471366882324389, 16.621780395507869],
          [74.470802307129077, 16.614950180053654],
          [74.472457885742472, 16.604810714721793],
          [74.446983337402514, 16.600339889526424],
          [74.440818786621207, 16.598691940307731],
          [74.433540344238565, 16.594360351562614],
          [74.428833007812671, 16.582729339599609],
          [74.422286987304972, 16.583501815795898],
          [74.413719177246378, 16.58023834228527],
          [74.403480529785327, 16.578670501708928],
          [74.402160644531421, 16.574729919433707],
          [74.401206970215014, 16.570940017700309],
          [74.398399353027401, 16.5654296875],
          [74.400772094726676, 16.563472747802734],
          [74.401130676269815, 16.56088829040533],
          [74.395500183105469, 16.559522628784237],
          [74.395652770996264, 16.535671234130916],
          [74.392898559570369, 16.531070709228572],
          [74.389923095703296, 16.527900695800781],
          [74.385437011718977, 16.52740287780756],
          [74.371101379394588, 16.537651062011776],
          [74.366119384765625, 16.537639617920036],
          [74.36258697509794, 16.538740158081112],
          [74.364646911621321, 16.543680191040153],
          [74.362876892089844, 16.548561096191463],
          [74.369232177734602, 16.55327033996582],
          [74.365615844726619, 16.557069778442326],
          [74.363082885742187, 16.556201934814453],
          [74.359748840332315, 16.553689956665039],
          [74.355072021484375, 16.553110122680664],
          [74.346122741699276, 16.546449661254883],
          [74.340202331543026, 16.550132751464957],
          [74.332153320312671, 16.553699493408203],
          [74.329406738281534, 16.553470611572379],
          [74.323776245117187, 16.551460266113395],
          [74.322227478027514, 16.544500350952205],
          [74.322166442871378, 16.539051055908203],
          [74.323219299316406, 16.532209396362305],
          [74.322677612304744, 16.519001007080078],
          [74.323905944824332, 16.506298065185604],
          [74.321456909179858, 16.502670288085937],
          [74.314117431640682, 16.502098083496094],
          [74.313468933105639, 16.50325965881359],
          [74.311576843261719, 16.506927490234432],
          [74.308456420898551, 16.521871566772404],
          [74.308921813964901, 16.523998260498104],
          [74.30692291259777, 16.529170989990291],
          [74.297622680664233, 16.531930923461914],
          [74.294479370117244, 16.53154182434082],
          [74.294837951660384, 16.529291152954158],
          [74.289619445800952, 16.52256965637207],
          [74.289558410644815, 16.525262832641602],
          [74.287132263183764, 16.527320861816406],
          [74.286727905273381, 16.529409408569393],
          [74.288223266601847, 16.539470672607479],
          [74.284317016601619, 16.543092727661246],
          [74.276367187500284, 16.544532775878963],
          [74.271553039550838, 16.538660049438533],
          [74.271972656250057, 16.533430099487362],
          [74.275512695312671, 16.52515983581543],
          [74.276626586914233, 16.520610809326229],
          [74.281906127929972, 16.520551681518555],
          [74.28440093994169, 16.516479492187557],
          [74.286689758301065, 16.506771087646484],
          [74.285758972168082, 16.503370285034123],
          [74.278640747070369, 16.501020431518612],
          [74.263130187988281, 16.4989528656007],
          [74.255706787109432, 16.496770858764705],
          [74.253158569335881, 16.494880676269531],
          [74.260086059570313, 16.490907669067383],
          [74.262145996093921, 16.488670349121151],
          [74.264526367187557, 16.48545074462902],
          [74.265167236328068, 16.482400894165096],
          [74.26877593994152, 16.476030349731445],
          [74.278427124023494, 16.479639053344727],
          [74.282539367675952, 16.482570648193359],
          [74.280998229980412, 16.485790252685547],
          [74.280517578125057, 16.489360809326286],
          [74.283309936523608, 16.49603271484375],
          [74.288948059082088, 16.503780364990291],
          [74.299896240234546, 16.502630233764648],
          [74.300552368164119, 16.499631881713924],
          [74.297576904296989, 16.481611251831168],
          [74.294837951660384, 16.47435188293457],
          [74.296432495117301, 16.466711044311637],
          [74.296318054199219, 16.459011077880916],
          [74.301399230957145, 16.459060668945369],
          [74.302398681640796, 16.461080551147461],
          [74.304649353027287, 16.460790634155387],
          [74.307090759277628, 16.459590911865348],
          [74.314826965332031, 16.453199386596623],
          [74.321937561035213, 16.450040817260799],
          [74.330528259277401, 16.452791213989258],
          [74.335556030273381, 16.453081130981559],
          [74.338867187500057, 16.452161788940487],
          [74.339988708496094, 16.448129653930778],
          [74.338760375976847, 16.44664192199707],
          [74.339042663574219, 16.444860458374023],
          [74.342460632324389, 16.442329406738395],
          [74.342231750488224, 16.439569473266545],
          [74.340621948242415, 16.436170578002987],
          [74.340522766113452, 16.432979583740234],
          [74.343749999999943, 16.425540924072266],
          [74.337280273437671, 16.420209884643498],
          [74.338180541992472, 16.413370132446346],
          [74.341941833496151, 16.405210494995117],
          [74.342651367187671, 16.400491714477539],
          [74.349281311035099, 16.399400711059627],
          [74.349166870117244, 16.403940200805664],
          [74.359542846679972, 16.40398979187006],
          [74.364570617675952, 16.403238296508846],
          [74.367820739746264, 16.398469924926815],
          [74.369110107421989, 16.394329071044979],
          [74.368682861328409, 16.391170501708928],
          [74.359611511230639, 16.378820419311467],
          [74.361656188965128, 16.364749908447322],
          [74.351898193359659, 16.366300582885742],
          [74.351081848144588, 16.376760482788086],
          [74.348587036132813, 16.380382537841854],
          [74.347717285156534, 16.386011123657227],
          [74.345771789551009, 16.389520645141658],
          [74.343063354492244, 16.390670776367301],
          [74.340332031250171, 16.390962600708008],
          [74.335960388183764, 16.389642715454102],
          [74.335006713867358, 16.388719558715877],
          [74.334747314453409, 16.382858276367301],
          [74.332550048828125, 16.375570297241154],
          [74.325462341308764, 16.379249572753849],
          [74.327766418457202, 16.370340347289982],
          [74.327629089355526, 16.368110656738338],
          [74.332237243652401, 16.356950759887809],
          [74.33152008056669, 16.355569839477596],
          [74.32370758056652, 16.353610992431641],
          [74.331565856933764, 16.346490859985295],
          [74.334396362304801, 16.340522766113224],
          [74.328231811523494, 16.341100692749023],
          [74.323455810547102, 16.339891433715877],
          [74.324806213378963, 16.336669921875114],
          [74.329116821289062, 16.332590103149414],
          [74.327278137207088, 16.329200744628963],
          [74.324012756347713, 16.327421188354549],
          [74.323020935058594, 16.325122833252067],
          [74.329933166504134, 16.322362899780217],
          [74.333358764648494, 16.323741912841854],
          [74.337272644042912, 16.323392868042049],
          [74.340011596679744, 16.31693077087408],
          [74.335693359375284, 16.315000534057674],
          [74.33152008056669, 16.316410064697209],
          [74.331016540527514, 16.315021514892692],
          [74.332107543945426, 16.310760498046989],
          [74.340591430664119, 16.31162071228033],
          [74.342330932617415, 16.305091857910156],
          [74.340126037597599, 16.303989410400504],
          [74.341156005859432, 16.30282020568842],
          [74.344848632812784, 16.303268432617244],
          [74.348716735839787, 16.291469573974609],
          [74.342681884765682, 16.288770675659293],
          [74.336372375488281, 16.290170669555778],
          [74.331787109375, 16.286180496215934],
          [74.332153320312671, 16.284099578857479],
          [74.329322814941406, 16.281061172485295],
          [74.328689575195256, 16.279430389404297],
          [74.330657958984375, 16.27293968200695],
          [74.333839416503849, 16.268070220947322],
          [74.337051391601847, 16.265720367431641],
          [74.340415954589901, 16.267570495605526],
          [74.343902587890909, 16.272121429443473],
          [74.349456787109489, 16.273269653320312],
          [74.349357604980526, 16.275060653686467],
          [74.350746154785213, 16.27625846862793],
          [74.352127075195426, 16.274482727050895],
          [74.35514068603544, 16.274490356445426],
          [74.359863281250057, 16.279609680175838],
          [74.360336303711051, 16.281909942626953],
          [74.351699829101619, 16.28820991516119],
          [74.353286743164006, 16.291839599609489],
          [74.35459136962919, 16.289760589599609],
          [74.35611724853544, 16.290920257568416],
          [74.358535766601619, 16.288801193237248],
          [74.362571716308651, 16.287139892578125],
          [74.369606018066634, 16.290721893310547],
          [74.373771667480526, 16.290319442748967],
          [74.380065917968807, 16.293500900268612],
          [74.387420654296989, 16.290348052978572],
          [74.390380859375057, 16.290241241455192],
          [74.391265869140796, 16.275600433349609],
          [74.400756835937784, 16.276250839233398],
          [74.418022155761776, 16.280929565429744],
          [74.421226501465014, 16.280590057373047],
          [74.421592712402514, 16.271459579467773],
          [74.420822143554858, 16.26387977600109],
          [74.422531127929631, 16.257450103759879],
          [74.436332702636776, 16.254768371582031],
          [74.440940856933821, 16.25266075134283],
          [74.441841125488281, 16.254150390625],
          [74.442779541015796, 16.249559402465934],
          [74.461227416992301, 16.248430252075309],
          [74.461456298828296, 16.243778228759766],
          [74.463432312011776, 16.241830825805664],
          [74.473182678222884, 16.238519668579215],
          [74.476066589355753, 16.239030838012752],
          [74.480796813964901, 16.244329452514762],
          [74.484123229980582, 16.246730804443473],
          [74.494827270507983, 16.238019943237418],
          [74.495071411132813, 16.235969543457145],
          [74.503112792968807, 16.231040954589787],
          [74.508331298828409, 16.222940444946289],
          [74.507720947265682, 16.221281051635685],
          [74.502960205078409, 16.216220855713004],
          [74.502113342285156, 16.214139938354549],
          [74.503166198730753, 16.21156120300293],
          [74.513298034668082, 16.201229095458984],
          [74.513229370117415, 16.199220657348746],
          [74.510810852051065, 16.198818206787166],
          [74.512527465820597, 16.195840835571289],
          [74.512886047363565, 16.189399719238338],
          [74.512878417969034, 16.188262939453182],
          [74.509086608887003, 16.187839508056584],
          [74.501770019531307, 16.185430526733398],
          [74.497817993164347, 16.181339263916129],
          [74.495323181152401, 16.169000625610408],
          [74.494667053222827, 16.15504074096674],
          [74.489967346191634, 16.147222518921012],
          [74.485809326172159, 16.146989822387638],
          [74.487106323242415, 16.143091201782283],
          [74.490951538086222, 16.142000198364371],
          [74.497108459472599, 16.112369537353516],
          [74.496406555175781, 16.101579666137638],
          [74.493499755859546, 16.098592758178825],
          [74.49263000488304, 16.095539093017521],
          [74.492797851562557, 16.092838287353629],
          [74.490447998047046, 16.090370178222713],
          [74.489089965820256, 16.087320327758789],
          [74.481857299804858, 16.086969375610352],
          [74.478912353515682, 16.087890625000057],
          [74.477966308593807, 16.091899871826115],
          [74.464546203613281, 16.102111816406193],
          [74.460006713867244, 16.102910995483455],
          [74.454910278320597, 16.102670669555721],
          [74.444526672363281, 16.105180740356559],
          [74.437950134277628, 16.108160018920842],
          [74.434593200683594, 16.110620498657227],
          [74.422760009765796, 16.102569580078182],
          [74.418457031250057, 16.100891113281307],
          [74.416076660156421, 16.096000671386662],
          [74.415206909179744, 16.091819763183537],
          [74.407608032226847, 16.0906982421875],
          [74.404060363769702, 16.090978622436637],
          [74.39731597900419, 16.087129592895508],
          [74.398300170898381, 16.080118179321346],
          [74.397247314453182, 16.078388214111328],
          [74.390457153320597, 16.079929351806641],
          [74.386802673340128, 16.078090667724666],
          [74.380996704101563, 16.07826042175293],
          [74.379592895507926, 16.076820373535213],
          [74.380607604980639, 16.073020935058651],
          [74.380081176757869, 16.069580078125057],
          [74.375106811523494, 16.063369750976676],
          [74.370986938476847, 16.059570312499943],
          [74.368156433105582, 16.052959442138786],
          [74.370750427246321, 16.051019668579215],
          [74.380142211914347, 16.054767608642578],
          [74.381736755371264, 16.053569793701115],
          [74.378883361816577, 16.043399810791072],
          [74.378227233887003, 16.039260864257869],
          [74.378585815429744, 16.036621093750057],
          [74.39005279541044, 16.035129547119141],
          [74.396072387695312, 16.039600372314567],
          [74.409317016601847, 16.045330047607536],
          [74.40960693359375, 16.047098159790039],
          [74.411216735840128, 16.049011230468807],
          [74.415542602539119, 16.051059722900504],
          [74.422912597656193, 16.053190231323356],
          [74.432136535644588, 16.055131912231502],
          [74.436332702636776, 16.056730270385742],
          [74.440483093261889, 16.057020187378043],
          [74.44803619384794, 16.052400588989258],
          [74.455871582031534, 16.052160263061523],
          [74.463836669922102, 16.04773139953619],
          [74.467956542968921, 16.046699523925838],
          [74.47027587890625, 16.040540695190487],
          [74.467658996582088, 16.033649444580135],
          [74.467102050781534, 16.030269622802848],
          [74.463912963867131, 16.02256011962902],
          [74.456436157226847, 16.008909225463924],
          [74.453369140625284, 16.005809783935604],
          [74.449668884277344, 15.998531341552791],
          [74.45017242431652, 15.992601394653377],
          [74.448432922363565, 15.988290786743107],
          [74.448471069335881, 15.986400604248161],
          [74.449958801269815, 15.983230590820426],
          [74.443946838378906, 15.974330902099666],
          [74.442291259765682, 15.965478897094783],
          [74.435226440429915, 15.951169967651481],
          [74.412269592285327, 15.925200462341365],
          [74.402038574218977, 15.911050796508732],
          [74.391868591308594, 15.90115928649908],
          [74.392349243164347, 15.899261474609432],
          [74.398361206054687, 15.897710800170955],
          [74.399307250976562, 15.895771026611385],
          [74.401641845703182, 15.887269973754883],
          [74.402549743652344, 15.878260612487736],
          [74.399192810058651, 15.874349594116211],
          [74.412216186523551, 15.857639312744254],
          [74.411582946777401, 15.852590560913029],
          [74.406509399414006, 15.851900100708121],
          [74.403121948242188, 15.848959922790641],
          [74.393432617187557, 15.851770401000977],
          [74.392288208007869, 15.857449531555233],
          [74.388496398926009, 15.857219696044979],
          [74.387947082519815, 15.863941192627067],
          [74.385566711425952, 15.87323093414318],
          [74.383132934570369, 15.877761840820426],
          [74.376556396484318, 15.884941101074276],
          [74.372779846191577, 15.887689590454158],
          [74.374481201172046, 15.889941215515137],
          [74.374122619629077, 15.891610145568848],
          [74.370521545410156, 15.890390396118278],
          [74.370613098144815, 15.880002021789664],
          [74.369979858398494, 15.875680923461971],
          [74.367431640625171, 15.87321853637701],
          [74.367027282714787, 15.871090888977051],
          [74.364097595214901, 15.870161056518555],
          [74.352958679199219, 15.859240531921387],
          [74.353401184082259, 15.855731964111442],
          [74.344535827636889, 15.852050781249943],
          [74.346397399902628, 15.849349975586051],
          [74.353767395019588, 15.848100662231388],
          [74.387413024902457, 15.847111701965389],
          [74.389312744140909, 15.84414005279541],
          [74.389442443847884, 15.836311340332088],
          [74.38626861572277, 15.83326244354248],
          [74.374549865722713, 15.827500343322754],
          [74.373367309570313, 15.825832366943303],
          [74.370742797851619, 15.817220687866268],
          [74.366371154785384, 15.81549072265625],
          [74.369155883789233, 15.812161445617676],
          [74.374008178710994, 15.810441017150936],
          [74.374549865722713, 15.804521560669002],
          [74.375801086425724, 15.801200866699219],
          [74.375511169433651, 15.796719551086426],
          [74.370841979980412, 15.782181739807186],
          [74.367897033691634, 15.781599998474235],
          [74.364852905273494, 15.773651123046989],
          [74.350936889648494, 15.763360023498649],
          [74.346771240234659, 15.763110160827637],
          [74.342277526855469, 15.765521049499625],
          [74.334541320801065, 15.767679214477539],
          [74.329750061035384, 15.770380020141658],
          [74.327568054199389, 15.768200874328727],
          [74.324951171875057, 15.761300086975041],
          [74.324081420898722, 15.756529808044434],
          [74.318649291992244, 15.753410339355582],
          [74.314651489257869, 15.75214862823492],
          [74.312995910644815, 15.748299598693961],
          [74.292167663574446, 15.739311218261832],
          [74.284942626953182, 15.743310928344783],
          [74.274009704589844, 15.753120422363281],
          [74.270866394043253, 15.751910209655819],
          [74.266067504883097, 15.747020721435661],
          [74.258926391601562, 15.743391036987362],
          [74.250068664551065, 15.741180419921932],
          [74.243865966796875, 15.744400024414119],
          [74.238983154297159, 15.752140045166072],
          [74.235237121582202, 15.753970146179199],
          [74.235168457031534, 15.759611129760799],
          [74.240341186523722, 15.78075027465826],
          [74.238929748535213, 15.784540176391715],
          [74.235496520996151, 15.786830902099666],
          [74.227348327637003, 15.785671234130916],
          [74.222473144531421, 15.781701087951603],
          [74.217407226562727, 15.778760910034123],
          [74.215705871582088, 15.773870468139648],
          [74.214622497558537, 15.765991210937614],
          [74.211326599121378, 15.758589744567871],
          [74.204399108886776, 15.753400802612248],
          [74.197067260742301, 15.750221252441406],
          [74.171150207519702, 15.749950408935547],
          [74.167671203613565, 15.749250411987305],
          [74.162269592285213, 15.742071151733455],
          [74.160133361816406, 15.734349250793457],
          [74.155342102050952, 15.732281684875545],
          [74.150512695312784, 15.731700897216854],
          [74.147377014160213, 15.730071067810115],
          [74.142967224121094, 15.727190971374455],
          [74.141868591308821, 15.723178863525504],
          [74.140457153320483, 15.721671104431209],
          [74.134857177734659, 15.72218132019043],
          [74.130622863769759, 15.717921257019043],
          [74.134750366211108, 15.716032028198242],
          [74.135536193847656, 15.70925235748291],
          [74.138916015625171, 15.706340789794979],
          [74.141532897949503, 15.700361251831168],
          [74.13889312744152, 15.699031829833984],
          [74.140426635742131, 15.694560050964469],
          [74.138877868652628, 15.686229705810547],
          [74.133598327636889, 15.678400993347168],
          [74.127006530761776, 15.673740386962947],
          [74.117523193359489, 15.670780181884766],
          [74.106246948242472, 15.670640945434627],
          [74.100563049316349, 15.672349929809627],
          [74.096527099609659, 15.670849800109863],
          [74.098022460937557, 15.665970802307129],
          [74.10453033447294, 15.659201622009221],
          [74.112052917480639, 15.655031204223746],
          [74.121368408203296, 15.653670310974064],
          [74.126029968261776, 15.650289535522518],
          [74.122756958007812, 15.645220756530762],
          [74.112632751464844, 15.643080711364803],
          [74.108047485351733, 15.638870239257813],
          [74.102439880371378, 15.638960838317985],
          [74.080551147461108, 15.62617015838623],
          [74.073532104492187, 15.62667179107666],
          [74.067703247070597, 15.624711990356559],
          [74.056800842285384, 15.622721672058105],
          [74.039299011230753, 15.620850563049373],
          [74.035575866699219, 15.609291076660156],
          [74.027931213379077, 15.604599952697811],
          [74.013175964355753, 15.609340667724553],
          [74.007843017578409, 15.608299255371037],
          [74.002388000488281, 15.609051704406738],
          [73.998703002929801, 15.611129760742301],
          [73.992942810058878, 15.616311073303336],
          [73.990211486816463, 15.620630264282283],
          [73.986068725586222, 15.623380661010742],
          [73.981422424316406, 15.625031471252498],
          [73.975982666015909, 15.628941535949764],
          [73.969261169433821, 15.644321441650391],
          [73.970726013183594, 15.649661064148006],
          [73.974227905273494, 15.654670715332031],
          [73.975700378417969, 15.659781455993596],
          [73.971588134765909, 15.668391227722225],
          [73.972198486328068, 15.676692008972168],
          [73.971305847167969, 15.687251091003475],
          [73.965736389160327, 15.695020675659293],
          [73.957237243652571, 15.696739196777401],
          [73.958679199218921, 15.701251983642692],
          [73.956031799316577, 15.704791069030819],
          [73.957786560058651, 15.707350730896053],
          [73.958869934082202, 15.711291313171444],
          [73.955932617187784, 15.716920852661133],
          [73.950820922851676, 15.723229408264217],
          [73.949760437011719, 15.73263072967535],
          [73.945365905761719, 15.741521835327262],
          [73.924156188965014, 15.742820739746094],
          [73.917938232421932, 15.745401382446346],
          [73.914833068847827, 15.745491981506348],
          [73.908607482910384, 15.742330551147404],
          [73.885902404785384, 15.747261047363338],
          [73.882446289062557, 15.749350547790584],
          [73.880241394043253, 15.7525510787965],
          [73.882606506347656, 15.756691932678336],
          [73.884323120117187, 15.764620780944824],
          [73.886840820312557, 15.767129898071346],
          [73.88685607910179, 15.770291328430233],
          [73.880249023437614, 15.77739143371582],
          [73.879867553711051, 15.77921199798584],
          [73.87509918212902, 15.782899856567383],
          [73.874839782715071, 15.786340713500977],
          [73.875930786132812, 15.793231010437012],
          [73.873497009277401, 15.795321464538574],
          [73.865486145019588, 15.797529220581055],
          [73.861587524414233, 15.793880462646541],
          [73.860076904297046, 15.787791252136287],
          [73.855796813965128, 15.783260345459098],
          [73.856986999511832, 15.778229713440055],
          [73.851905822753906, 15.778411865234489],
          [73.849632263183651, 15.776029586792049],
          [73.847167968750057, 15.766130447387695],
          [73.845123291015909, 15.763360023498649],
          [73.838783264160213, 15.7608900070191],
          [73.840301513671932, 15.756201744079647],
          [73.838462829590128, 15.748830795288029],
          [73.833038330078182, 15.737751960754395],
          [73.820396423340014, 15.739910125732479],
          [73.816032409668139, 15.735269546508846],
          [73.8126220703125, 15.73351955413824],
          [73.802841186523608, 15.732199668884391],
          [73.797569274902401, 15.725091934204102],
          [73.793212890625227, 15.723660469055176],
          [73.786491394042969, 15.723250389099235],
          [73.775787353515796, 15.73053169250494],
          [73.758247375488281, 15.732751846313477],
          [73.748710632324219, 15.730570793151912],
          [73.74405670166044, 15.725641250610295],
          [73.741020202636832, 15.718721389770565],
          [73.737037658691577, 15.717250823974723],
          [73.732261657714787, 15.720581054687557],
          [73.727645874023722, 15.722479820251579],
          [73.722557067871264, 15.72288990020752],
          [73.718566894531421, 15.72161960601801],
          [73.710983276367244, 15.720230102539176],
          [73.706588745117244, 15.72173023223877],
          [73.702659606933878, 15.724910736084098],
          [73.697341918945426, 15.726230621338004],
          [73.691856384277514, 15.726909637451172],
          [73.685302734375284, 15.725871086120549],
          [73.682456970214957, 15.725251197814885],
          [73.680137634277628, 15.724370956421012],
          [73.680137634277628, 15.724861145019531],
          [73.679862976074219, 15.724861145019531],
          [73.679862976074219, 15.725141525268668],
          [73.679306030273494, 15.725141525268668],
          [73.679306030273494, 15.725421905517635],
          [73.677085876465128, 15.725417137145996],
          [73.677085876465128, 15.72569465637207],
          [73.676803588867187, 15.72569465637207],
          [73.676803588867187, 15.725971221923885],
          [73.676521301269815, 15.725971221923885],
          [73.676521301269815, 15.726251602172852],
          [73.676246643066406, 15.726251602172852],
          [73.676246643066406, 15.726531982421989],
          [73.675971984863395, 15.726531982421989],
          [73.675971984863395, 15.726810455322379],
          [73.675697326660213, 15.726804733276424],
          [73.675697326660213, 15.727083206176815],
          [73.675140380859602, 15.727081298828239],
          [73.675140380859602, 15.727640151977596],
          [73.674858093261889, 15.727640151977596],
          [73.674858093261889, 15.727919578552246],
          [73.674583435058651, 15.72791767120367],
          [73.674583435058651, 15.728193283081168],
          [73.674308776855639, 15.728191375732422],
          [73.674308776855639, 15.72875022888195],
          [73.674026489258097, 15.72875022888195],
          [73.674026489258097, 15.7290296554566],
          [73.673751831054687, 15.7290296554566],
          [73.673751831054687, 15.729310035705566],
          [73.673194885253906, 15.729306221008414],
          [73.673194885253906, 15.729862213134879],
          [73.672637939453182, 15.729859352111816],
          [73.672637939453182, 15.730139732360954],
          [73.672080993652401, 15.730139732360954],
          [73.672080993652401, 15.730695724487248],
          [73.671806335449389, 15.730695724487248],
          [73.671806335449389, 15.730972290039063],
          [73.671516418457259, 15.73096942901617],
          [73.671516418457259, 15.731249809265137],
          [73.671249389648608, 15.731249809265137],
          [73.671249389648608, 15.73096942901617],
          [73.670967102050838, 15.73096942901617],
          [73.670967102050838, 15.731249809265137],
          [73.670417785644815, 15.731249809265137],
          [73.670417785644815, 15.731530189514103],
          [73.670143127441406, 15.731530189514103],
          [73.670143127441406, 15.731249809265137],
          [73.669029235839901, 15.731249809265137],
          [73.669029235839901, 15.73096942901617],
          [73.668197631836108, 15.73096942901617],
          [73.668197631836108, 15.731530189514103],
          [73.667922973633097, 15.731530189514103],
          [73.667922973633097, 15.731809616088981],
          [73.667358398437784, 15.731809616088981],
          [73.667358398437784, 15.732361793518066],
          [73.667076110839844, 15.732361793518066],
          [73.667076110839844, 15.732640266418457],
          [73.666809082031534, 15.732640266418457],
          [73.666809082031534, 15.73347187042242],
          [73.666526794433651, 15.73347187042242],
          [73.666526794433651, 15.734581947326603],
          [73.666252136230582, 15.734581947326603],
          [73.666252136230582, 15.73486232757574],
          [73.665969848632869, 15.734860420227164],
          [73.665969848632869, 15.735139846801871],
          [73.665695190429631, 15.735137939453068],
          [73.665695190429631, 15.735693931579533],
          [73.665412902832259, 15.735693931579533],
          [73.665412902832259, 15.735972404479924],
          [73.665138244629077, 15.735972404479924],
          [73.665138244629077, 15.736528396606388],
          [73.664855957031307, 15.736518859863281],
          [73.664855957031307, 15.737360000610408],
          [73.664581298828296, 15.737360000610408],
          [73.664581298828296, 15.737640380859375],
          [73.664306640625284, 15.737640380859375],
          [73.664306640625284, 15.737920761108512],
          [73.663749694824503, 15.737915992736873],
          [73.663749694824503, 15.738194465637264],
          [73.661804199218807, 15.738194465637264],
          [73.661804199218807, 15.737915992736873],
          [73.661529541015796, 15.737915992736873],
          [73.661529541015796, 15.738471984863338],
          [73.660972595214844, 15.738470077514762],
          [73.660972595214844, 15.739030838012695],
          [73.660697937012003, 15.739030838012695],
          [73.660697937012003, 15.739311218261832],
          [73.659584045410099, 15.739306449890194],
          [73.659584045410099, 15.739582061767692],
          [73.659309387207259, 15.739582061767692],
          [73.659301757812557, 15.739863395690975],
          [73.659027099609546, 15.739859580993766],
          [73.659027099609546, 15.740140914917049],
          [73.658752441406307, 15.740140914917049],
          [73.658752441406307, 15.740421295166016],
          [73.658470153808764, 15.740415573120231],
          [73.658470153808764, 15.740694046020621],
          [73.658195495605753, 15.740694046020621],
          [73.658195495605753, 15.740973472595329],
          [73.655982971191577, 15.740969657897949],
          [73.655982971191577, 15.741250991821403],
          [73.655693054199446, 15.741250991821403],
          [73.655693054199446, 15.74181079864502],
          [73.655418395996264, 15.741806983947868],
          [73.655418395996264, 15.742081642150879],
          [73.654586791992472, 15.742079734802303],
          [73.654586791992472, 15.742361068725586],
          [73.65402984619169, 15.742361068725586],
          [73.65402984619169, 15.742650032043571],
          [73.653747558593807, 15.742650032043571],
          [73.653747558593807, 15.742920875549373],
          [73.653472900390739, 15.742917060852051],
          [73.653472900390739, 15.743194580078125],
          [73.653198242187557, 15.743194580078125],
          [73.653198242187557, 15.745695114135799],
          [73.652915954589787, 15.745695114135799],
          [73.652915954589787, 15.745972633361873],
          [73.651802062988452, 15.745972633361873],
          [73.651802062988452, 15.745695114135799],
          [73.650970458984659, 15.745695114135799],
          [73.650970458984659, 15.745416641235408],
          [73.649024963378963, 15.745416641235408],
          [73.649024963378963, 15.745695114135799],
          [73.648483276367472, 15.74569034576416],
          [73.648483276367472, 15.746530532836971],
          [73.649017333984602, 15.746530532836971],
          [73.649017333984602, 15.746811866760254],
          [73.650970458984659, 15.746811866760254],
          [73.650970458984659, 15.746530532836971],
          [73.652641296386946, 15.746530532836971],
          [73.652641296386946, 15.746811866760254],
          [73.653198242187557, 15.746805191040153],
          [73.653198242187557, 15.747082710266056],
          [73.653472900390739, 15.74708080291748],
          [73.653472900390739, 15.747921943664608],
          [73.653198242187557, 15.747921943664608],
          [73.653198242187557, 15.748750686645508],
          [73.654296875, 15.748750686645508],
          [73.654296875, 15.748458862304801],
          [73.655418395996264, 15.748473167419377],
          [73.655418395996264, 15.748194694519043],
          [73.655975341797046, 15.748194694519043],
          [73.655975341797046, 15.747917175292912],
          [73.656517028808707, 15.747921943664608],
          [73.656517028808707, 15.747640609741325],
          [73.657356262207031, 15.747640609741325],
          [73.657356262207031, 15.747361183166447],
          [73.657638549804972, 15.747361183166447],
          [73.657638549804972, 15.747640609741325],
          [73.658203125000284, 15.747640609741325],
          [73.658203125000284, 15.747921943664608],
          [73.658470153808764, 15.747917175292912],
          [73.658470153808764, 15.748194694519043],
          [73.658752441406307, 15.748194694519043],
          [73.658752441406307, 15.748473167419377],
          [73.659027099609546, 15.748458862304801],
          [73.659027099609546, 15.749032020568961],
          [73.659301757812557, 15.749032020568961],
          [73.659309387207259, 15.749309539795036],
          [73.659584045410099, 15.749304771423397],
          [73.659584045410099, 15.74958324432373],
          [73.659858703613338, 15.749581336975154],
          [73.659858703613338, 15.749860763549862],
          [73.660140991211051, 15.749860763549862],
          [73.660140991211051, 15.750419616699219],
          [73.660415649414063, 15.750416755676326],
          [73.660415649414063, 15.750970840454215],
          [73.660697937012003, 15.750970840454215],
          [73.660697937012003, 15.75152683258068],
          [73.660972595214844, 15.75152683258068],
          [73.660972595214844, 15.752082824707145],
          [73.661529541015796, 15.752082824707145],
          [73.661529541015796, 15.752361297607536],
          [73.662086486816577, 15.752361297607536],
          [73.662086486816577, 15.752641677856502],
          [73.662361145019759, 15.752641677856502],
          [73.662361145019759, 15.752920150756893],
          [73.663475036621151, 15.752915382385254],
          [73.663475036621151, 15.753195762634391],
          [73.664024353027344, 15.753195762634391],
          [73.664024353027344, 15.753471374511719],
          [73.664581298828296, 15.753471374511719],
          [73.664581298828296, 15.753751754760856],
          [73.664855957031307, 15.753751754760856],
          [73.664855957031307, 15.754030227661246],
          [73.665138244629077, 15.754030227661246],
          [73.665138244629077, 15.754309654235897],
          [73.665412902832259, 15.754309654235897],
          [73.665412902832259, 15.754590034484863],
          [73.665702819824389, 15.754590034484863],
          [73.665702819824389, 15.75514030456543],
          [73.665969848632869, 15.75514030456543],
          [73.665969848632869, 15.756529808044434],
          [73.666526794433651, 15.756529808044434],
          [73.666526794433651, 15.7568101882934],
          [73.666809082031534, 15.7568101882934],
          [73.666809082031534, 15.756529808044434],
          [73.667640686035327, 15.756529808044434],
          [73.667640686035327, 15.756250381469783],
          [73.667922973633097, 15.756250381469783],
          [73.667915344238338, 15.755971908569393],
          [73.668197631836108, 15.755971908569393],
          [73.668197631836108, 15.755417823791504],
          [73.669296264648551, 15.75541973114008],
          [73.669296264648551, 15.75514030456543],
          [73.669860839844034, 15.75514030456543],
          [73.669860839844034, 15.754861831665039],
          [73.670417785644815, 15.754861831665039],
          [73.670417785644815, 15.754590034484863],
          [73.670967102050838, 15.754590034484863],
          [73.670967102050838, 15.754309654235897],
          [73.671249389648608, 15.754309654235897],
          [73.671249389648608, 15.753751754760856],
          [73.671516418457259, 15.753751754760856],
          [73.671516418457259, 15.753190994262752],
          [73.672080993652401, 15.753195762634391],
          [73.672080993652401, 15.752915382385254],
          [73.672637939453182, 15.752920150756893],
          [73.672637939453182, 15.752641677856502],
          [73.674026489258097, 15.752641677856502],
          [73.674026489258097, 15.752920150756893],
          [73.674308776855639, 15.752915382385254],
          [73.674308776855639, 15.753195762634391],
          [73.67457580566429, 15.753190994262752],
          [73.67457580566429, 15.754030227661246],
          [73.674308776855639, 15.754030227661246],
          [73.674308776855639, 15.754861831665039],
          [73.674026489258097, 15.754861831665039],
          [73.674026489258097, 15.75514030456543],
          [73.673469543457315, 15.75514030456543],
          [73.673469543457315, 15.755693435669002],
          [73.672920227050895, 15.755693435669002],
          [73.672920227050895, 15.755971908569393],
          [73.672080993652401, 15.755971908569393],
          [73.672080993652401, 15.756250381469783],
          [73.671516418457259, 15.756250381469783],
          [73.671516418457259, 15.756529808044434],
          [73.671249389648608, 15.756529808044434],
          [73.671249389648608, 15.7568101882934],
          [73.670692443847827, 15.756806373596248],
          [73.670692443847827, 15.757083892822322],
          [73.670135498046875, 15.757083892822322],
          [73.670135498046875, 15.757362365722713],
          [73.669860839844034, 15.757360458374137],
          [73.669860839844034, 15.757651329040527],
          [73.669296264648551, 15.757651329040527],
          [73.669296264648551, 15.757920265197754],
          [73.668746948242131, 15.757916450500602],
          [73.668746948242131, 15.758189201355037],
          [73.667915344238338, 15.758195877075252],
          [73.667915344238338, 15.758472442627067],
          [73.667358398437784, 15.758472442627067],
          [73.667358398437784, 15.758195877075252],
          [73.666809082031534, 15.758195877075252],
          [73.666809082031534, 15.758472442627067],
          [73.665702819824389, 15.758468627929687],
          [73.665702819824389, 15.758749961853141],
          [73.665412902832259, 15.758749961853141],
          [73.665412902832259, 15.758468627929687],
          [73.664863586425838, 15.758472442627067],
          [73.664863586425838, 15.758195877075252],
          [73.664581298828296, 15.758189201355037],
          [73.664581298828296, 15.757916450500602],
          [73.664016723632983, 15.757920265197754],
          [73.664016723632983, 15.757651329040527],
          [73.663192749023551, 15.757639884948787],
          [73.663192749023551, 15.758189201355037],
          [73.662918090820369, 15.758200645446721],
          [73.662918090820369, 15.759030342102108],
          [73.663192749023551, 15.759028434753532],
          [73.663192749023551, 15.759584426879996],
          [73.662918090820369, 15.759581565856934],
          [73.662918090820369, 15.7598619461059],
          [73.663192749023551, 15.7598619461059],
          [73.663192749023551, 15.760140419006291],
          [73.663482666015682, 15.760140419006291],
          [73.663482666015682, 15.760419845581168],
          [73.663192749023551, 15.760419845581168],
          [73.663192749023551, 15.761249542236385],
          [73.662918090820369, 15.761249542236385],
          [73.662918090820369, 15.761811256408805],
          [73.663192749023551, 15.761811256408805],
          [73.663192749023551, 15.762921333312931],
          [73.662918090820369, 15.762921333312931],
          [73.662918090820369, 15.763750076294059],
          [73.662635803222599, 15.763750076294059],
          [73.662635803222599, 15.765420913696346],
          [73.662361145019759, 15.765420913696346],
          [73.662361145019759, 15.766819953918514],
          [73.662086486816577, 15.766819953918514],
          [73.662086486816577, 15.7673597335816],
          [73.661796569824446, 15.7673597335816],
          [73.661796569824446, 15.767641067504883],
          [73.661529541015796, 15.76763820648199],
          [73.661537170410327, 15.768751144409237],
          [73.661247253418253, 15.768751144409237],
          [73.661247253418253, 15.769589424133244],
          [73.660972595214844, 15.769584655761776],
          [73.660972595214844, 15.77097320556652],
          [73.660697937012003, 15.770971298217773],
          [73.660697937012003, 15.771812438964844],
          [73.660415649414063, 15.771804809570313],
          [73.660415649414063, 15.772083282470703],
          [73.660140991211051, 15.772083282470703],
          [73.660140991211051, 15.772639274597168],
          [73.659858703613338, 15.772639274597168],
          [73.659858703613338, 15.773470878601131],
          [73.659584045410099, 15.773470878601131],
          [73.659584045410099, 15.774582862854061],
          [73.659309387207259, 15.774580955505485],
          [73.659301757812557, 15.775419235229549],
          [73.659027099609546, 15.775417327880916],
          [73.659027099609546, 15.775973320007438],
          [73.658752441406307, 15.775971412658635],
          [73.658752441406307, 15.776529312133903],
          [73.658477783203296, 15.776529312133903],
          [73.658477783203296, 15.776809692382869],
          [73.658195495605753, 15.77680492401123],
          [73.658195495605753, 15.777083396911564],
          [73.658470153808764, 15.777083396911564],
          [73.658470153808764, 15.777360916137695],
          [73.658203125000284, 15.777360916137695],
          [73.658203125000284, 15.777919769287223],
          [73.657913208007983, 15.77791690826416],
          [73.657913208007983, 15.778470993042049],
          [73.657638549804972, 15.778470993042049],
          [73.657638549804972, 15.780420303344727],
          [73.657356262207031, 15.780420303344727],
          [73.657356262207031, 15.78125190734869],
          [73.65708160400419, 15.78125190734869],
          [73.65708160400419, 15.781819343566895],
          [73.656806945800838, 15.781805992126579],
          [73.656806945800838, 15.782084465026969],
          [73.656517028808707, 15.78208065032959],
          [73.656517028808707, 15.782640457153434],
          [73.656250000000057, 15.782640457153434],
          [73.656250000000057, 15.783749580383301],
          [73.655982971191577, 15.783749580383301],
          [73.655982971191577, 15.784310340881404],
          [73.655693054199446, 15.784310340881404],
          [73.655693054199446, 15.785140037536621],
          [73.655418395996264, 15.785140037536621],
          [73.655418395996264, 15.785420417785588],
          [73.655693054199446, 15.785415649414119],
          [73.655693054199446, 15.78569412231451],
          [73.655418395996264, 15.785689353942871],
          [73.655418395996264, 15.786529541015682],
          [73.655136108398494, 15.786527633667049],
          [73.655136108398494, 15.787083625793571],
          [73.654861450195483, 15.787083625793571],
          [73.654861450195483, 15.787362098693904],
          [73.654586791992472, 15.787362098693904],
          [73.654586791992472, 15.787637710571232],
          [73.654296875, 15.787631034851188],
          [73.654296875, 15.789030075073356],
          [73.65402984619169, 15.789030075073356],
          [73.65402984619169, 15.790420532226676],
          [73.653747558593807, 15.790415763855037],
          [73.653747558593807, 15.790971755981502],
          [73.65402984619169, 15.790969848632926],
          [73.65402984619169, 15.791810989379996],
          [73.654586791992472, 15.791806221008358],
          [73.654586791992472, 15.792083740234432],
          [73.656250000000057, 15.792079925537053],
          [73.656250000000057, 15.792640686035213],
          [73.656524658203239, 15.792637825012321],
          [73.656524658203239, 15.793193817138786],
          [73.656806945800838, 15.793193817138786],
          [73.656806945800838, 15.793472290039176],
          [73.65708160400419, 15.79347038269043],
          [73.65708160400419, 15.793760299682674],
          [73.656806945800838, 15.793760299682674],
          [73.656806945800838, 15.794031143188533],
          [73.65708160400419, 15.794031143188533],
          [73.65708160400419, 15.794310569763184],
          [73.656806945800838, 15.794310569763184],
          [73.656806945800838, 15.79625129699707],
          [73.65708160400419, 15.79625129699707],
          [73.65708160400419, 15.798194885253963],
          [73.657363891601563, 15.798194885253963],
          [73.657363891601563, 15.798473358154354],
          [73.657638549804972, 15.798471450805778],
          [73.657638549804972, 15.799311637878418],
          [73.657913208007983, 15.799306869506893],
          [73.657913208007983, 15.800695419311467],
          [73.658195495605753, 15.800695419311467],
          [73.658195495605753, 15.800972938537541],
          [73.658752441406307, 15.800971031188965],
          [73.658752441406307, 15.801251411437931],
          [73.659027099609546, 15.801251411437931],
          [73.659027099609546, 15.801530838012809],
          [73.659301757812557, 15.801530838012809],
          [73.659309387207259, 15.801810264587459],
          [73.659584045410099, 15.801804542541561],
          [73.659584045410099, 15.802083015441895],
          [73.660140991211051, 15.802083015441895],
          [73.660140991211051, 15.802360534668026],
          [73.660697937012003, 15.802360534668026],
          [73.660697937012003, 15.802640914916992],
          [73.660972595214844, 15.802639007568416],
          [73.660972595214844, 15.80291652679449],
          [73.661247253418253, 15.80291652679449],
          [73.661247253418253, 15.803193092346248],
          [73.661529541015796, 15.803193092346248],
          [73.661529541015796, 15.803473472595272],
          [73.661796569824446, 15.803470611572379],
          [73.661796569824446, 15.803750991821346],
          [73.662086486816577, 15.803750991821346],
          [73.662086486816577, 15.80431175231945],
          [73.662361145019759, 15.804305076599235],
          [73.662361145019759, 15.804582595825309],
          [73.662086486816577, 15.804580688476562],
          [73.662086486816577, 15.805142402648983],
          [73.661537170410327, 15.805142402648983],
          [73.661537170410327, 15.804580688476562],
          [73.661247253418253, 15.804582595825309],
          [73.661247253418253, 15.804305076599235],
          [73.660972595214844, 15.80431175231945],
          [73.660972595214844, 15.803750991821346],
          [73.660697937012003, 15.803750991821346],
          [73.660697937012003, 15.803470611572379],
          [73.660415649414063, 15.803473472595272],
          [73.660415649414063, 15.803193092346248],
          [73.660140991211051, 15.803193092346248],
          [73.660140991211051, 15.80291652679449],
          [73.659858703613338, 15.802930831909237],
          [73.659858703613338, 15.802640914916992],
          [73.659301757812557, 15.802640914916992],
          [73.659301757812557, 15.802360534668026],
          [73.658470153808764, 15.802360534668026],
          [73.658470153808764, 15.802083015441895],
          [73.657913208007983, 15.802083015441895],
          [73.657913208007983, 15.801804542541561],
          [73.65708160400419, 15.801810264587459],
          [73.65708160400419, 15.801530838012809],
          [73.656517028808707, 15.801530838012809],
          [73.656517028808707, 15.800971031188965],
          [73.656250000000057, 15.800972938537541],
          [73.656250000000057, 15.800416946411076],
          [73.655982971191577, 15.800421714782772],
          [73.655982971191577, 15.800141334533748],
          [73.656250000000057, 15.800141334533748],
          [73.656250000000057, 15.799031257629395],
          [73.655982971191577, 15.799031257629395],
          [73.655982971191577, 15.798471450805778],
          [73.655418395996264, 15.798473358154354],
          [73.655418395996264, 15.798194885253963],
          [73.655136108398494, 15.798194885253963],
          [73.655136108398494, 15.797638893127498],
          [73.654861450195483, 15.797640800476074],
          [73.654861450195483, 15.79625129699707],
          [73.654586791992472, 15.79625129699707],
          [73.654586791992472, 15.795969963073787],
          [73.654304504394531, 15.79597282409668],
          [73.654304504394531, 15.795138359069824],
          [73.65402984619169, 15.795141220092887],
          [73.65402984619169, 15.794580459594783],
          [73.653747558593807, 15.794582366943359],
          [73.653747558593807, 15.794306755066032],
          [73.653472900390739, 15.794310569763184],
          [73.653472900390739, 15.794031143188533],
          [73.652641296386946, 15.794031143188533],
          [73.652641296386946, 15.794862747192496],
          [73.652359008789233, 15.794859886169434],
          [73.652359008789233, 15.795695304870605],
          [73.652084350585994, 15.795695304870605],
          [73.652084350585994, 15.796805381774959],
          [73.651802062988452, 15.796805381774959],
          [73.651802062988452, 15.797082901001033],
          [73.65152740478544, 15.797080039978141],
          [73.65152740478544, 15.797640800476074],
          [73.651252746582031, 15.797640800476074],
          [73.651252746582031, 15.797921180725041],
          [73.650970458984659, 15.797921180725041],
          [73.650970458984659, 15.798750877380428],
          [73.651252746582031, 15.798750877380428],
          [73.651252746582031, 15.799031257629395],
          [73.650970458984659, 15.799027442932243],
          [73.650970458984659, 15.799583435058707],
          [73.650695800781307, 15.799571037292537],
          [73.650695800781307, 15.800141334533748],
          [73.650413513183707, 15.800139427185172],
          [73.650413513183707, 15.800695419311467],
          [73.650695800781307, 15.800689697265682],
          [73.650695800781307, 15.801810264587459],
          [73.650413513183707, 15.801804542541561],
          [73.650413513183707, 15.802360534668026],
          [73.650138854980526, 15.802360534668026],
          [73.650138854980526, 15.802930831909237],
          [73.649864196777287, 15.80291652679449],
          [73.649864196777287, 15.803193092346248],
          [73.649581909179915, 15.803193092346248],
          [73.649581909179915, 15.803473472595272],
          [73.649017333984602, 15.803470611572379],
          [73.649017333984602, 15.803750991821346],
          [73.648750305175952, 15.803750991821346],
          [73.648750305175952, 15.804029464721737],
          [73.648483276367472, 15.804029464721737],
          [73.648483276367472, 15.80431175231945],
          [73.647636413574219, 15.804305076599235],
          [73.647636413574219, 15.804582595825309],
          [73.646804809570256, 15.804582595825309],
          [73.646804809570256, 15.804305076599235],
          [73.646530151367415, 15.804305076599235],
          [73.646530151367415, 15.804582595825309],
          [73.645973205566463, 15.804580688476562],
          [73.645973205566463, 15.8048610687257],
          [73.645416259765909, 15.8048610687257],
          [73.645416259765909, 15.805421829223633],
          [73.644859313965128, 15.805421829223633],
          [73.644859313965128, 15.805700302124023],
          [73.644584655761719, 15.805694580078239],
          [73.644584655761719, 15.805971145629883],
          [73.644302368164347, 15.805971145629883],
          [73.644302368164347, 15.806531906127987],
          [73.644584655761719, 15.806527137756348],
          [73.644584655761719, 15.807083129882812],
          [73.644302368164347, 15.807081222534237],
          [73.644302368164347, 15.80764198303234],
          [73.644584655761719, 15.807640075683594],
          [73.644584655761719, 15.808193206787166],
          [73.644302368164347, 15.808193206787166],
          [73.644302368164347, 15.809583663940487],
          [73.644027709960994, 15.809578895568848],
          [73.644027709960994, 15.810139656066951],
          [73.643753051757756, 15.810139656066951],
          [73.643753051757756, 15.810972213745231],
          [73.643196105957202, 15.810969352722168],
          [73.643196105957202, 15.811249732971305],
          [73.642082214355639, 15.811249732971305],
          [73.642082214355639, 15.810969352722168],
          [73.640411376953182, 15.810969352722168],
          [73.640411376953182, 15.811530113220272],
          [73.640136718749943, 15.811530113220272],
          [73.640136718749943, 15.812640190124455],
          [73.639862060547102, 15.812640190124455],
          [73.639862060547102, 15.812919616699332],
          [73.639579772949389, 15.812915802001953],
          [73.639579772949389, 15.813194274902344],
          [73.639305114746151, 15.813194274902344],
          [73.639312744140909, 15.813471794128418],
          [73.639030456543139, 15.813471794128418],
          [73.639030456543139, 15.813750267028809],
          [73.638748168945597, 15.813750267028809],
          [73.638748168945597, 15.814029693603516],
          [73.637641906738395, 15.814029693603516],
          [73.637641906738395, 15.814311027526969],
          [73.637351989746151, 15.814311027526969],
          [73.637351989746151, 15.814870834350586],
          [73.637077331542912, 15.814870834350586],
          [73.637077331542912, 15.815141677856445],
          [73.636802673340071, 15.815141677856445],
          [73.636802673340071, 15.815420150756836],
          [73.636528015136889, 15.815416336059627],
          [73.636528015136889, 15.815693855285758],
          [73.636253356933651, 15.815693855285758],
          [73.636253356933651, 15.817084312439079],
          [73.636528015136889, 15.817079544067383],
          [73.636528015136889, 15.817640304565543],
          [73.636802673340071, 15.817640304565543],
          [73.636802673340071, 15.817930221557617],
          [73.637641906738395, 15.817915916442871],
          [73.637641906738395, 15.818194389343262],
          [73.637916564941463, 15.818194389343262],
          [73.637916564941463, 15.817915916442871],
          [73.638191223144815, 15.817930221557617],
          [73.638191223144815, 15.817640304565543],
          [73.638465881347656, 15.817640304565543],
          [73.638465881347656, 15.817930221557617],
          [73.639030456543139, 15.817915916442871],
          [73.639030456543139, 15.81958198547369],
          [73.638748168945597, 15.81958198547369],
          [73.638748168945597, 15.819863319396973],
          [73.639030456543139, 15.81986045837408],
          [73.639030456543139, 15.820421218872184],
          [73.638748168945597, 15.820421218872184],
          [73.638748168945597, 15.821531295776367],
          [73.638473510742187, 15.821529388427791],
          [73.638473510742187, 15.822081565856877],
          [73.638191223144815, 15.822079658508301],
          [73.638191223144815, 15.822920799255371],
          [73.637916564941463, 15.822916984558219],
          [73.637916564941463, 15.82319545745861],
          [73.637641906738395, 15.823189735412654],
          [73.637641906738395, 15.824311256408748],
          [73.637359619140682, 15.824304580688477],
          [73.637359619140682, 15.824583053588867],
          [73.637084960937443, 15.824583053588867],
          [73.637084960937443, 15.825695037841797],
          [73.636802673340071, 15.825690269470329],
          [73.636802673340071, 15.826531410217228],
          [73.636528015136889, 15.82652664184576],
          [73.636528015136889, 15.827082633972225],
          [73.636253356933651, 15.827080726623649],
          [73.636253356933651, 15.827640533447322],
          [73.635971069336108, 15.827638626098746],
          [73.635971069336108, 15.828473091125602],
          [73.635696411133097, 15.828473091125602],
          [73.635696411133097, 15.829583168029728],
          [73.635406494140796, 15.829581260681152],
          [73.635406494140796, 15.829870223999137],
          [73.635139465332315, 15.829870223999137],
          [73.635139465332315, 15.830418586731071],
          [73.634857177734375, 15.830418586731071],
          [73.634857177734375, 15.831531524658317],
          [73.634582519531364, 15.831526756286678],
          [73.634582519531364, 15.832361221313533],
          [73.634307861328182, 15.832361221313533],
          [73.634307861328182, 15.833194732666072],
          [73.634033203124943, 15.83319091796875],
          [73.634033203124943, 15.834030151367244],
          [73.633750915527571, 15.834027290344352],
          [73.633750915527571, 15.834583282470817],
          [73.633468627929858, 15.83458137512207],
          [73.633468627929858, 15.835140228271598],
          [73.633193969726619, 15.835140228271598],
          [73.633193969726619, 15.835693359375],
          [73.632919311523608, 15.835693359375],
          [73.632919311523608, 15.835970878601074],
          [73.632637023926065, 15.835970878601074],
          [73.632637023926065, 15.836810111999569],
          [73.632362365722656, 15.836810111999569],
          [73.632362365722656, 15.837639808654785],
          [73.632080078125284, 15.837639808654785],
          [73.632080078125284, 15.83819580078125],
          [73.631805419921875, 15.83819580078125],
          [73.631805419921875, 15.839584350585994],
          [73.631530761718864, 15.839582443237418],
          [73.631530761718864, 15.839861869812069],
          [73.631248474121151, 15.839861869812069],
          [73.631248474121151, 15.840419769287166],
          [73.630966186523551, 15.840419769287166],
          [73.630966186523551, 15.84152984619152],
          [73.630691528320369, 15.841527938842717],
          [73.630691528320369, 15.842083930969238],
          [73.630416870117358, 15.842082023620605],
          [73.630416870117358, 15.842639923095703],
          [73.630142211914119, 15.84263801574707],
          [73.630142211914119, 15.843194007873592],
          [73.629859924316577, 15.843189239501896],
          [73.629859924316577, 15.844310760498161],
          [73.629592895508097, 15.844310760498161],
          [73.629592895508097, 15.845140457153377],
          [73.629302978515796, 15.845140457153377],
          [73.629302978515796, 15.845420837402344],
          [73.629585266113565, 15.845416069030875],
          [73.629585266113565, 15.84569358825695],
          [73.629302978515796, 15.84568977355957],
          [73.629302978515796, 15.846249580383414],
          [73.629028320312784, 15.846249580383414],
          [73.629028320312784, 15.846530914306697],
          [73.628753662109375, 15.846528053283805],
          [73.628753662109375, 15.847082138061523],
          [73.628471374512003, 15.847082138061523],
          [73.628471374512003, 15.847363471984977],
          [73.628196716308651, 15.847363471984977],
          [73.628196716308651, 15.847915649414063],
          [73.627914428711051, 15.847915649414063],
          [73.627914428711051, 15.848472595214844],
          [73.627639770507869, 15.848469734191951],
          [73.627639770507869, 15.849031448364371],
          [73.627357482910099, 15.849031448364371],
          [73.627357482910099, 15.849310874939079],
          [73.627082824707259, 15.849310874939079],
          [73.627082824707259, 15.850140571594238],
          [73.626808166504077, 15.850138664245662],
          [73.626808166504077, 15.850694656372127],
          [73.626525878906307, 15.850691795349064],
          [73.626525878906307, 15.851250648498592],
          [73.626251220703296, 15.851250648498592],
          [73.626251220703296, 15.851531028747559],
          [73.626525878906307, 15.851531028747559],
          [73.626525878906307, 15.851811408996582],
          [73.626251220703296, 15.851804733276481],
          [73.626251220703296, 15.852083206176871],
          [73.625968933105753, 15.852080345153809],
          [73.625968933105753, 15.852641105651912],
          [73.625411987304972, 15.852641105651912],
          [73.625411987304972, 15.852920532226619],
          [73.625137329101619, 15.85291671752924],
          [73.625137329101619, 15.853470802307129],
          [73.624580383300838, 15.853470802307129],
          [73.624580383300838, 15.853751182556096],
          [73.624313354492358, 15.853751182556096],
          [73.624313354492358, 15.85404014587408],
          [73.623748779297046, 15.85404014587408],
          [73.623748779297046, 15.854311943054256],
          [73.623474121093807, 15.854305267333984],
          [73.623474121093807, 15.854582786560059],
          [73.622917175293253, 15.854580879211483],
          [73.622917175293253, 15.855140686035156],
          [73.622642517089844, 15.855140686035156],
          [73.622642517089844, 15.85542201995861],
          [73.622360229492472, 15.855417251586914],
          [73.622360229492472, 15.855694770813045],
          [73.622093200683651, 15.855690956115836],
          [73.622093200683651, 15.85625076293951],
          [73.62180328369152, 15.85625076293951],
          [73.62180328369152, 15.856529235839901],
          [73.621528625488338, 15.856529235839901],
          [73.621528625488338, 15.856809616088867],
          [73.621246337890568, 15.856804847717399],
          [73.621246337890568, 15.857083320617789],
          [73.621528625488338, 15.857081413268986],
          [73.621528625488338, 15.857639312744254],
          [73.62180328369152, 15.857639312744254],
          [73.62180328369152, 15.857919692993221],
          [73.621528625488338, 15.857916831970329],
          [73.621528625488338, 15.858470916748047],
          [73.621246337890568, 15.858470916748047],
          [73.621246337890568, 15.858751296997184],
          [73.620140075683764, 15.858751296997184],
          [73.620140075683764, 15.85819053649908],
          [73.619857788086222, 15.858195304870719],
          [73.619857788086222, 15.857639312744254],
          [73.619026184082031, 15.857639312744254],
          [73.619026184082031, 15.857360839843864],
          [73.618469238281307, 15.857360839843864],
          [73.618469238281307, 15.857081413268986],
          [73.618194580078068, 15.857083320617789],
          [73.618194580078068, 15.856804847717399],
          [73.617637634277514, 15.856809616088867],
          [73.617637634277514, 15.855140686035156],
          [73.617919921875227, 15.855140686035156],
          [73.617919921875227, 15.854580879211483],
          [73.618194580078068, 15.854582786560059],
          [73.618194580078068, 15.854305267333984],
          [73.61875152587902, 15.854311943054256],
          [73.61875152587902, 15.85404014587408],
          [73.619026184082031, 15.85404014587408],
          [73.619026184082031, 15.853751182556096],
          [73.619308471679972, 15.853751182556096],
          [73.619308471679972, 15.852360725402775],
          [73.61875152587902, 15.852360725402775],
          [73.61875152587902, 15.852080345153809],
          [73.618186950683707, 15.852080345153809],
          [73.618186950683707, 15.852641105651912],
          [73.617919921875227, 15.852641105651912],
          [73.617919921875227, 15.852920532226619],
          [73.617080688476733, 15.85291671752924],
          [73.617080688476733, 15.853195190429631],
          [73.615692138672159, 15.853195190429631],
          [73.615692138672159, 15.85291671752924],
          [73.615417480468807, 15.85291671752924],
          [73.615417480468807, 15.853195190429631],
          [73.615135192871207, 15.853195190429631],
          [73.615135192871207, 15.853470802307129],
          [73.614860534668026, 15.853470802307129],
          [73.614860534668026, 15.853751182556096],
          [73.614295959472884, 15.853751182556096],
          [73.614295959472884, 15.85404014587408],
          [73.613746643066463, 15.85404014587408],
          [73.613746643066463, 15.854311943054256],
          [73.61319732666044, 15.854305267333984],
          [73.61319732666044, 15.854582786560059],
          [73.612922668457031, 15.854580879211483],
          [73.612922668457031, 15.855140686035156],
          [73.61319732666044, 15.85513877868658],
          [73.61319732666044, 15.855973243713436],
          [73.612922668457031, 15.855971336364803],
          [73.612922668457031, 15.856529235839901],
          [73.612640380859659, 15.856529235839901],
          [73.612640380859659, 15.857083320617789],
          [73.612358093261776, 15.857081413268986],
          [73.612358093261776, 15.857639312744254],
          [73.612083435058707, 15.857639312744254],
          [73.612083435058707, 15.858195304870719],
          [73.611808776855526, 15.858195304870719],
          [73.611808776855526, 15.858470916748047],
          [73.611526489257756, 15.858470916748047],
          [73.611526489257756, 15.859310150146541],
          [73.611251831054915, 15.859305381774902],
          [73.611251831054915, 15.859582901000977],
          [73.610969543457202, 15.859582901000977],
          [73.610969543457202, 15.859861373901367],
          [73.611251831054915, 15.859849929809627],
          [73.611251831054915, 15.860141754150504],
          [73.610969543457202, 15.860141754150504],
          [73.610969543457202, 15.862640380859432],
          [73.610694885253963, 15.862636566162053],
          [73.610694885253963, 15.863471984863395],
          [73.610427856445312, 15.863471984863395],
          [73.610427856445312, 15.864031791687069],
          [73.610137939453409, 15.864031791687069],
          [73.610137939453409, 15.864310264587402],
          [73.60986328125, 15.86430644989025],
          [73.60986328125, 15.864862442016715],
          [73.609580993652628, 15.864859580993652],
          [73.609580993652628, 15.865139961242619],
          [73.60986328125, 15.865139961242619],
          [73.60986328125, 15.865420341491756],
          [73.610137939453409, 15.865415573120117],
          [73.610137939453409, 15.865694046020508],
          [73.610427856445312, 15.865689277649039],
          [73.610427856445312, 15.866530418395939],
          [73.610137939453409, 15.866530418395939],
          [73.610137939453409, 15.867919921875],
          [73.60986328125, 15.867919921875],
          [73.60986328125, 15.868749618530387],
          [73.609580993652628, 15.868749618530387],
          [73.609580993652628, 15.869038581848201],
          [73.609306335449276, 15.869038581848201],
          [73.609306335449276, 15.869311332702637],
          [73.609016418457315, 15.869311332702637],
          [73.609024047851676, 15.86985969543457],
          [73.608467102050724, 15.86985969543457],
          [73.608467102050724, 15.871250152587891],
          [73.608749389648494, 15.871250152587891],
          [73.608749389648494, 15.871530532837028],
          [73.608467102050724, 15.871530532837028],
          [73.608467102050724, 15.871810913085994],
          [73.608192443847884, 15.871806144714355],
          [73.608192443847884, 15.87208366394043],
          [73.607917785644702, 15.872079849243278],
          [73.607917785644702, 15.872639656066895],
          [73.607635498046932, 15.872637748718319],
          [73.607635498046932, 15.873193740844783],
          [73.607360839843921, 15.873193740844783],
          [73.607360839843921, 15.873472213745174],
          [73.607086181640909, 15.873470306396598],
          [73.607086181640909, 15.873749732971248],
          [73.606796264648608, 15.873749732971248],
          [73.606796264648608, 15.874031066894531],
          [73.606529235840128, 15.874028205871639],
          [73.606529235840128, 15.874582290649528],
          [73.606246948242188, 15.874580383300781],
          [73.606246948242188, 15.875420570373535],
          [73.605972290039176, 15.875415802001896],
          [73.605972290039176, 15.875695228576774],
          [73.605697631835994, 15.875690460205135],
          [73.605697631835994, 15.876251220703239],
          [73.605415344238224, 15.876251220703239],
          [73.605415344238224, 15.877361297607422],
          [73.605140686035384, 15.877361297607422],
          [73.605140686035384, 15.877921104431266],
          [73.604858398437671, 15.877921104431266],
          [73.604858398437671, 15.878750801086426],
          [73.604576110840071, 15.878750801086426],
          [73.604576110840071, 15.879860877990779],
          [73.604301452636889, 15.879860877990779],
          [73.604301452636889, 15.880141258239746],
          [73.604026794433878, 15.880141258239746],
          [73.604026794433878, 15.880979537963981],
          [73.603752136230469, 15.880979537963981],
          [73.603752136230469, 15.881530761718807],
          [73.603469848633097, 15.881526947021428],
          [73.603469848633097, 15.882082939147892],
          [73.602912902832315, 15.882082939147892],
          [73.602912902832315, 15.882361412048283],
          [73.603202819824276, 15.882361412048283],
          [73.603202819824276, 15.882640838623161],
          [73.602912902832315, 15.882640838623161],
          [73.602912902832315, 15.882919311523551],
          [73.602638244628963, 15.882917404174748],
          [73.602638244628963, 15.883193016052246],
          [73.602912902832315, 15.88319110870367],
          [73.602912902832315, 15.88514232635498],
          [73.602355957031364, 15.88514232635498],
          [73.602355957031364, 15.885421752929801],
          [73.601524353027571, 15.885416984558162],
          [73.601524353027571, 15.885695457458553],
          [73.600975036621378, 15.885695457458553],
          [73.600975036621378, 15.885971069336051],
          [73.599586486816463, 15.885971069336051],
          [73.599586486816463, 15.886251449585018],
          [73.599296569824332, 15.886251449585018],
          [73.599296569824332, 15.886531829833984],
          [73.598747253417912, 15.886531829833984],
          [73.598747253417912, 15.887920379638729],
          [73.598472595215071, 15.887918472290153],
          [73.598472595215071, 15.888193130493164],
          [73.598747253417912, 15.888193130493164],
          [73.598747253417912, 15.888474464416618],
          [73.599296569824332, 15.888470649719238],
          [73.599296569824332, 15.888751983642692],
          [73.599586486816463, 15.888751983642692],
          [73.599586486816463, 15.889030456543082],
          [73.599861145019815, 15.889030456543082],
          [73.599861145019815, 15.889311790466365],
          [73.599586486816463, 15.88930606842041],
          [73.599586486816463, 15.889862060546875],
          [73.598747253417912, 15.889859199523983],
          [73.598747253417912, 15.89015102386486],
          [73.598472595215071, 15.89015102386486],
          [73.598472595215071, 15.890419960021916],
          [73.598197937011889, 15.89041805267334],
          [73.598197937011889, 15.890693664550838],
          [73.597084045410156, 15.890693664550838],
          [73.597084045410156, 15.890972137451229],
          [73.596809387207315, 15.890969276428336],
          [73.596801757812784, 15.89153003692627],
          [73.596527099609432, 15.89153003692627],
          [73.596527099609432, 15.892359733581657],
          [73.596801757812784, 15.892359733581657],
          [73.596801757812784, 15.892642021179256],
          [73.596527099609432, 15.892642021179256],
          [73.596527099609432, 15.89291954040533],
          [73.596801757812784, 15.892915725707951],
          [73.596801757812784, 15.893471717834416],
          [73.596527099609432, 15.893471717834416],
          [73.596527099609432, 15.893750190734806],
          [73.596801757812784, 15.893750190734806],
          [73.596801757812784, 15.894310951232967],
          [73.596527099609432, 15.894310951232967],
          [73.596527099609432, 15.895139694213867],
          [73.596252441406364, 15.895137786865234],
          [73.596252441406364, 15.895693778991756],
          [73.595970153808651, 15.895691871643123],
          [73.595970153808651, 15.896530151367188],
          [73.595703125000171, 15.896530151367188],
          [73.595703125000171, 15.896810531616325],
          [73.59541320800804, 15.896805763244686],
          [73.59541320800804, 15.897359848022575],
          [73.595138549804858, 15.897359848022575],
          [73.595138549804858, 15.897640228271541],
          [73.594856262207088, 15.897640228271541],
          [73.594856262207088, 15.897920608520508],
          [73.594581604004077, 15.897915840149039],
          [73.594581604004077, 15.898471832275504],
          [73.594306945801065, 15.898469924926758],
          [73.594306945801065, 15.898750305175895],
          [73.594024658203125, 15.898750305175895],
          [73.594024658203125, 15.899027824401969],
          [73.593750000000284, 15.899019241332951],
          [73.593750000000284, 15.899311065673828],
          [73.593193054199332, 15.89930629730236],
          [73.593193054199332, 15.899581909179688],
          [73.592636108398381, 15.899583816528434],
          [73.592636108398381, 15.899862289428825],
          [73.592086791992358, 15.899860382080078],
          [73.592086791992358, 15.900142669677791],
          [73.591796875000227, 15.900142669677791],
          [73.591796875000227, 15.900421142578182],
          [73.591247558594034, 15.900421142578182],
          [73.591247558594034, 15.901252746582145],
          [73.590972900390625, 15.901252746582145],
          [73.590972900390625, 15.901810646057243],
          [73.591247558594034, 15.901810646057243],
          [73.591247558594034, 15.902641296386719],
          [73.590972900390625, 15.902641296386719],
          [73.590972900390625, 15.903751373291072],
          [73.590698242187784, 15.903751373291072],
          [73.590698242187784, 15.904861450195426],
          [73.590415954589844, 15.904861450195426],
          [73.590415954589844, 15.905973434448356],
          [73.590141296386832, 15.905970573425293],
          [73.590141296386832, 15.906531333923454],
          [73.589859008789119, 15.906531333923454],
          [73.589859008789119, 15.90681171417242],
          [73.58957672119152, 15.90681171417242],
          [73.58957672119152, 15.907361030578613],
          [73.589302062988338, 15.907361030578613],
          [73.589302062988338, 15.90764141082758],
          [73.589027404785327, 15.90764141082758],
          [73.589027404785327, 15.907920837402457],
          [73.588752746582088, 15.907917022705078],
          [73.588752746582088, 15.908194541931209],
          [73.588470458984546, 15.908194541931209],
          [73.588470458984546, 15.9084730148316],
          [73.588195800781534, 15.908471107482967],
          [73.588195800781534, 15.909030914306641],
          [73.587913513183764, 15.909029006958065],
          [73.587913513183764, 15.909583091735954],
          [73.589859008789119, 15.909583091735954],
          [73.589859008789119, 15.909304618835563],
          [73.590698242187784, 15.909304618835563],
          [73.590698242187784, 15.909480094909725],
          [73.590698242187784, 15.911811828613281],
          [73.590415954589844, 15.911805152893066],
          [73.590415954589844, 15.912361145019531],
          [73.589859008789119, 15.912361145019531],
          [73.589859008789119, 15.912082672119141],
          [73.589302062988338, 15.912082672119141],
          [73.589302062988338, 15.911805152893066],
          [73.589027404785327, 15.911811828613281],
          [73.589027404785327, 15.911528587341422],
          [73.588752746582088, 15.911528587341422],
          [73.588752746582088, 15.910960197448787],
          [73.588470458984546, 15.910972595214957],
          [73.588470458984546, 15.910695075988883],
          [73.588195800781534, 15.910695075988883],
          [73.588195800781534, 15.910416603088493],
          [73.586807250976619, 15.910416603088493],
          [73.586807250976619, 15.910139083862418],
          [73.58625793457054, 15.910140991210994],
          [73.58625793457054, 15.909860610962028],
          [73.585975646972827, 15.909860610962028],
          [73.585975646972827, 15.909304618835563],
          [73.585693359375227, 15.909304618835563],
          [73.585693359375227, 15.909860610962028],
          [73.585418701172046, 15.909860610962028],
          [73.585418701172046, 15.909583091735954],
          [73.585136413574276, 15.909583091735954],
          [73.585136413574276, 15.909860610962028],
          [73.581802368164233, 15.909860610962028],
          [73.581802368164233, 15.910140991210994],
          [73.579307556152514, 15.910140991210994],
          [73.579307556152514, 15.909860610962028],
          [73.578750610351733, 15.909860610962028],
          [73.578750610351733, 15.910419464111385],
          [73.578475952148722, 15.910419464111385],
          [73.578475952148722, 15.911528587341422],
          [73.577362060546989, 15.911528587341422],
          [73.577362060546989, 15.911811828613281],
          [73.576812744140568, 15.911811828613281],
          [73.576812744140568, 15.911528587341422],
          [73.576248168945483, 15.911528587341422],
          [73.576248168945483, 15.911811828613281],
          [73.574028015136776, 15.911805152893066],
          [73.574028015136776, 15.912082672119141],
          [73.57236480712919, 15.912082672119141],
          [73.57236480712919, 15.911805152893066],
          [73.571525573730469, 15.911805152893066],
          [73.571525573730469, 15.912082672119141],
          [73.570137023925724, 15.912082672119141],
          [73.570137023925724, 15.912361145019531],
          [73.569580078125171, 15.912361145019531],
          [73.569580078125171, 15.912641525268668],
          [73.568748474121378, 15.912638664245605],
          [73.568748474121378, 15.91319465637207],
          [73.568466186523438, 15.913190841674918],
          [73.568466186523438, 15.914310455322379],
          [73.568191528320597, 15.914310455322379],
          [73.568191528320597, 15.915140151977596],
          [73.567916870117244, 15.915140151977596],
          [73.567916870117244, 15.915693283081168],
          [73.567642211914176, 15.915691375732422],
          [73.567642211914176, 15.915970802307072],
          [73.567359924316463, 15.915970802307072],
          [73.567359924316463, 15.916249275207633],
          [73.567085266113224, 15.916249275207633],
          [73.567085266113224, 15.918472290039062],
          [73.566802978515852, 15.91846942901617],
          [73.566802978515852, 15.918749809265137],
          [73.566246032714901, 15.918749809265137],
          [73.566246032714901, 15.919030189514103],
          [73.565971374511889, 15.919030189514103],
          [73.565971374511889, 15.919309616088981],
          [73.565696716308878, 15.919305801391602],
          [73.565696716308878, 15.919584274291992],
          [73.565406799316577, 15.919582366943416],
          [73.565406799316577, 15.919861793518066],
          [73.565139770508097, 15.919861793518066],
          [73.565139770508097, 15.920140266418457],
          [73.564025878906193, 15.92013072967535],
          [73.564025878906193, 15.920419692993164],
          [73.563751220703352, 15.920415878295955],
          [73.563751220703352, 15.920694351196346],
          [73.563468933105639, 15.920694351196346],
          [73.563468933105639, 15.92097187042242],
          [73.562637329101847, 15.92097187042242],
          [73.562637329101847, 15.921250343322811],
          [73.561813354492244, 15.921250343322811],
          [73.561813354492244, 15.921529769897518],
          [73.561248779296932, 15.921529769897518],
          [73.561248779296932, 15.921811103820801],
          [73.560691833496151, 15.921806335449276],
          [73.560691833496151, 15.922362327575797],
          [73.559860229492358, 15.922360420226994],
          [73.559860229492358, 15.922639846801871],
          [73.559303283691577, 15.922637939453068],
          [73.559303283691577, 15.92319393157959],
          [73.559028625488565, 15.923192024230957],
          [73.559028625488565, 15.923749923706055],
          [73.558746337890625, 15.923749923706055],
          [73.558746337890625, 15.924030303955192],
          [73.558197021484432, 15.924030303955192],
          [73.558197021484432, 15.924310684204158],
          [73.55708312988304, 15.92430591583252],
          [73.55708312988304, 15.92458438873291],
          [73.556526184082088, 15.924579620361442],
          [73.556526184082088, 15.924860000610408],
          [73.555969238281534, 15.924860000610408],
          [73.555969238281534, 15.925140380859375],
          [73.555686950683594, 15.925140380859375],
          [73.555686950683594, 15.925420761108512],
          [73.555419921875284, 15.925415992736873],
          [73.555419921875284, 15.925694465637264],
          [73.555137634277401, 15.925694465637264],
          [73.555137634277401, 15.925971984863338],
          [73.554862976074332, 15.925970077514762],
          [73.554862976074332, 15.926261901855412],
          [73.55403137207054, 15.926261901855412],
          [73.55403137207054, 15.926811218261832],
          [73.552085876464901, 15.926806449890194],
          [73.552085876464901, 15.927363395690975],
          [73.549575805664233, 15.927359580993766],
          [73.549575805664233, 15.927640914917049],
          [73.549308776855753, 15.927638053894157],
          [73.549308776855753, 15.928194046020621],
          [73.548751831054801, 15.928194046020621],
          [73.548751831054801, 15.928471565246525],
          [73.548469543457088, 15.928469657897949],
          [73.548469543457088, 15.928750991821403],
          [73.547920227051009, 15.928750991821403],
          [73.547920227051009, 15.929031372070369],
          [73.547637939453296, 15.929031372070369],
          [73.547637939453296, 15.929320335388184],
          [73.547080993652514, 15.929306983947868],
          [73.547080993652514, 15.929585456848258],
          [73.546806335449503, 15.929579734802303],
          [73.546806335449503, 15.930141448974723],
          [73.546516418457202, 15.930141448974723],
          [73.546516418457202, 15.93042087554943],
          [73.546249389648722, 15.930417060852051],
          [73.546249389648722, 15.930694580078125],
          [73.545967102050781, 15.930689811706657],
          [73.545967102050781, 15.93125057220459],
          [73.545852661133097, 15.93125057220459],
          [73.545417785644588, 15.93125057220459],
          [73.545417785644588, 15.931530952453556],
          [73.545143127441349, 15.931530952453556],
          [73.545143127441349, 15.93181133270275],
          [73.544586181640796, 15.93181133270275],
          [73.544586181640796, 15.932360649108944],
          [73.544029235840014, 15.932360649108944],
          [73.544029235840014, 15.93264102935791],
          [73.543746948242244, 15.93264102935791],
          [73.543746948242244, 15.932921409606934],
          [73.543472290039233, 15.932916641235408],
          [73.543472290039233, 15.93347263336193],
          [73.543197631836222, 15.933470726013127],
          [73.543197631836222, 15.933751106262264],
          [73.54264068603544, 15.933751106262264],
          [73.54264068603544, 15.934030532836971],
          [73.542358398437557, 15.934030532836971],
          [73.542358398437557, 15.934311866760254],
          [73.541809082031307, 15.934305191039982],
          [73.541809082031307, 15.934582710266056],
          [73.541526794433537, 15.934582710266056],
          [73.541526794433537, 15.935138702392578],
          [73.540969848632983, 15.935138702392578],
          [73.540969848632983, 15.935694694519043],
          [73.540695190429744, 15.935694694519043],
          [73.540695190429744, 15.935973167419434],
          [73.54013824462919, 15.935971260070801],
          [73.54013824462919, 15.936531066894645],
          [73.538482666015796, 15.936531066894645],
          [73.538482666015796, 15.936809539795036],
          [73.538192749023665, 15.936804771423397],
          [73.538192749023665, 15.937083244323787],
          [73.53708648681669, 15.937081336975154],
          [73.53708648681669, 15.937639236450252],
          [73.535148620605696, 15.937639236450252],
          [73.535148620605696, 15.937360763549862],
          [73.534858703613452, 15.937360763549862],
          [73.534858703613452, 15.936531066894645],
          [73.534576416015852, 15.936531066894645],
          [73.534576416015852, 15.935971260070801],
          [73.534301757812671, 15.935973167419434],
          [73.534301757812671, 15.935694694519043],
          [73.534027099609659, 15.935694694519043],
          [73.534027099609659, 15.935138702392578],
          [73.53375244140625, 15.935138702392578],
          [73.53375244140625, 15.934582710266056],
          [73.533195495605469, 15.934582710266056],
          [73.533195495605469, 15.934026718139592],
          [73.532928466796989, 15.934030532836971],
          [73.532913208008097, 15.933751106262264],
          [73.532638549804744, 15.933751106262264],
          [73.532638549804744, 15.933470726013127],
          [73.532363891601506, 15.93347263336193],
          [73.532363891601506, 15.933195114135799],
          [73.532081604003963, 15.933195114135799],
          [73.532081604003963, 15.932916641235408],
          [73.530693054199389, 15.932916641235408],
          [73.530693054199389, 15.933195114135799],
          [73.529586791992244, 15.93319034576416],
          [73.529586791992244, 15.933751106262264],
          [73.528472900390852, 15.933751106262264],
          [73.528472900390852, 15.934030532836971],
          [73.527915954589901, 15.934030532836971],
          [73.527915954589901, 15.934311866760254],
          [73.527641296386889, 15.934305191039982],
          [73.527641296386889, 15.934582710266056],
          [73.526527404785213, 15.934582710266056],
          [73.526527404785213, 15.934861183166447],
          [73.526252746582145, 15.934861183166447],
          [73.526252746582145, 15.935138702392578],
          [73.525962829589901, 15.935132026672477],
          [73.525962829589901, 15.935421943664608],
          [73.525695800781193, 15.935417175292912],
          [73.525695800781193, 15.935973167419434],
          [73.525405883789119, 15.935971260070801],
          [73.525405883789119, 15.936250686645508],
          [73.524856567382869, 15.936250686645508],
          [73.524856567382869, 15.936531066894645],
          [73.524581909179858, 15.936529159545898],
          [73.524581909179858, 15.936671257019043],
          [73.524581909179858, 15.936809539795036],
          [73.524024963378906, 15.936804771423397],
          [73.524024963378906, 15.937083244323787],
          [73.523750305176065, 15.937081336975154],
          [73.523750305176065, 15.937360763549862],
          [73.523483276367244, 15.937360763549862],
          [73.523483276367244, 15.937639236450252],
          [73.522918701171932, 15.937639236450252],
          [73.522918701171932, 15.937918663024902],
          [73.522636413574162, 15.937918663024902],
          [73.522636413574162, 15.938199996948356],
          [73.522087097168139, 15.938199996948356],
          [73.522087097168139, 15.938470840454215],
          [73.521316528320483, 15.938470840454215],
          [73.520416259765625, 15.938470840454215],
          [73.520416259765625, 15.938751220703182],
          [73.520141601562614, 15.938751220703182],
          [73.520141601562614, 15.938470840454215],
          [73.519577026367301, 15.938470840454215],
          [73.519577026367301, 15.938199996948356],
          [73.519302368164119, 15.938199996948356],
          [73.519302368164119, 15.938470840454215],
          [73.517906188965014, 15.938470840454215],
          [73.517906188965014, 15.938199996948356],
          [73.517082214355753, 15.938199996948356],
          [73.517082214355753, 15.937918663024902],
          [73.516807556152401, 15.937918663024902],
          [73.516807556152401, 15.938199996948356],
          [73.516525268554801, 15.938195228576717],
          [73.516532897949162, 15.938751220703182],
          [73.516250610351619, 15.938751220703182],
          [73.516250610351619, 15.939311981201115],
          [73.514312744140625, 15.939311981201115],
          [73.514312744140625, 15.939031600952148],
          [73.514022827148722, 15.939031600952148],
          [73.514022827148722, 15.938751220703182],
          [73.513748168945369, 15.938751220703182],
          [73.513748168945369, 15.938470840454215],
          [73.51346588134777, 15.938470840454215],
          [73.51346588134777, 15.938199996948356],
          [73.513191223144588, 15.938199996948356],
          [73.513191223144588, 15.937639236450252],
          [73.512916564941349, 15.937639236450252],
          [73.512916564941349, 15.937081336975154],
          [73.512641906738509, 15.937083244323787],
          [73.512641906738509, 15.936804771423397],
          [73.510696411132869, 15.936804771423397],
          [73.510696411132869, 15.937083244323787],
          [73.510139465332088, 15.937081336975154],
          [73.510139465332088, 15.937360763549862],
          [73.509857177734318, 15.937360763549862],
          [73.509857177734318, 15.937918663024902],
          [73.509582519531477, 15.937918663024902],
          [73.509582519531477, 15.939031600952148],
          [73.509864807128849, 15.93902683258068],
          [73.509864807128849, 15.939582824707145],
          [73.510139465332088, 15.939580917358398],
          [73.510139465332088, 15.940141677856502],
          [73.509864807128849, 15.94013881683361],
          [73.509864807128849, 15.940694808959904],
          [73.509582519531477, 15.940690994262752],
          [73.509582519531477, 15.941530227661246],
          [73.509307861328296, 15.941530227661246],
          [73.509307861328296, 15.941809654235897],
          [73.509033203125057, 15.941809654235897],
          [73.509033203125057, 15.94264030456543],
          [73.508750915527514, 15.94264030456543],
          [73.508750915527514, 15.943193435669002],
          [73.508468627929972, 15.94319057464611],
          [73.508468627929972, 15.943750381469783],
          [73.508186340332202, 15.943750381469783],
          [73.508186340332202, 15.944029808044434],
          [73.507919311523722, 15.944027900695858],
          [73.507919311523722, 15.944583892822322],
          [73.50736236572277, 15.944583892822322],
          [73.50736236572277, 15.944862365722713],
          [73.507080078125057, 15.944858551025334],
          [73.507080078125057, 15.945420265197754],
          [73.506805419921818, 15.945416450500602],
          [73.506813049316349, 15.945689201355037],
          [73.506530761718977, 15.945695877075252],
          [73.506530761718977, 15.945972442627067],
          [73.506248474121264, 15.945972442627067],
          [73.506248474121264, 15.946251869201774],
          [73.505973815918026, 15.946249961852971],
          [73.505973815918026, 15.947084426879826],
          [73.505691528320483, 15.947084426879826],
          [73.505691528320483, 15.94819355010992],
          [73.505416870117472, 15.948191642761287],
          [73.505416870117472, 15.949311256408805],
          [73.505142211914062, 15.94930553436285],
          [73.505142211914062, 15.94958400726324],
          [73.50485992431669, 15.94958400726324],
          [73.50485992431669, 15.949861526489315],
          [73.504592895507869, 15.949859619140739],
          [73.504592895507869, 15.950421333312988],
          [73.504028320312557, 15.950415611267204],
          [73.504028320312557, 15.950971603393668],
          [73.503746032714957, 15.950969696044922],
          [73.503746032714957, 15.951250076294059],
          [73.503196716308764, 15.951250076294059],
          [73.503196716308764, 15.952920913696346],
          [73.502906799316634, 15.952920913696346],
          [73.502906799316634, 15.953749656677246],
          [73.502639770507983, 15.953749656677246],
          [73.502639770507983, 15.954582214355526],
          [73.502357482910213, 15.95458030700695],
          [73.502357482910213, 15.9548597335816],
          [73.502082824707202, 15.9548597335816],
          [73.502082824707202, 15.955141067504883],
          [73.50180816650419, 15.955141067504883],
          [73.50180816650419, 15.95542144775402],
          [73.50152587890625, 15.95542144775402],
          [73.50152587890625, 15.955972671508846],
          [73.50180816650419, 15.955972671508846],
          [73.50180816650419, 15.956530570983887],
          [73.502357482910213, 15.956528663635311],
          [73.502357482910213, 15.957084655761776],
          [73.503196716308764, 15.957084655761776],
          [73.503196716308764, 15.956804275512809],
          [73.503471374511776, 15.956804275512809],
          [73.503471374511776, 15.957084655761776],
          [73.504028320312557, 15.957081794738713],
          [73.504028320312557, 15.95764064788824],
          [73.504302978515909, 15.95764064788824],
          [73.504302978515909, 15.959031105041618],
          [73.504585266113281, 15.959029197692814],
          [73.504585266113281, 15.959306716918888],
          [73.50485992431669, 15.959306716918888],
          [73.50485992431669, 15.959583282470703],
          [73.505142211914062, 15.959580421447811],
          [73.505142211914062, 15.960141181945744],
          [73.505416870117472, 15.960141181945744],
          [73.505416870117472, 15.960420608520621],
          [73.505691528320483, 15.960416793823242],
          [73.505691528320483, 15.960695266723633],
          [73.505966186523665, 15.960689544677678],
          [73.505966186523665, 15.961251258850098],
          [73.506248474121264, 15.961251258850098],
          [73.506248474121264, 15.962361335754451],
          [73.506530761718977, 15.962361335754451],
          [73.506530761718977, 15.965695381164551],
          [73.506248474121264, 15.965695381164551],
          [73.506248474121264, 15.967361450195369],
          [73.505966186523665, 15.967361450195369],
          [73.505966186523665, 15.968199729919377],
          [73.505691528320483, 15.968193054199332],
          [73.505691528320483, 15.968474388122615],
          [73.504302978515909, 15.968470573425236],
          [73.504302978515909, 15.96875190734869],
          [73.502639770507983, 15.96875190734869],
          [73.502639770507983, 15.968470573425236],
          [73.502082824707202, 15.968474388122615],
          [73.502082824707202, 15.968193054199332],
          [73.50152587890625, 15.968193054199332],
          [73.50152587890625, 15.968474388122615],
          [73.501251220703409, 15.968470573425236],
          [73.501251220703409, 15.96875190734869],
          [73.500968933105526, 15.96875190734869],
          [73.500968933105526, 15.96903038024908],
          [73.500686645507926, 15.96903038024908],
          [73.500686645507926, 15.96930980682373],
          [73.500419616699276, 15.969305038452092],
          [73.500419616699276, 15.969584465026969],
          [73.499862670898665, 15.969584465026969],
          [73.499862670898665, 15.97069263458252],
          [73.499580383300952, 15.97069263458252],
          [73.499580383300952, 15.971249580383301],
          [73.499313354492472, 15.971240043640194],
          [73.499313354492472, 15.971529960632267],
          [73.499031066894702, 15.971528053283691],
          [73.499031066894702, 15.972084045410156],
          [73.498748779297159, 15.972079277038688],
          [73.498748779297159, 15.972641944885254],
          [73.498466491699219, 15.972641944885254],
          [73.498466491699219, 15.972920417785588],
          [73.498191833496378, 15.972915649414119],
          [73.498191833496378, 15.97319412231451],
          [73.497917175293026, 15.97319412231451],
          [73.497917175293026, 15.973471641540584],
          [73.497642517089957, 15.973471641540584],
          [73.497642517089957, 15.974029541015682],
          [73.497360229492244, 15.974027633667106],
          [73.497360229492244, 15.974583625793571],
          [73.497085571289006, 15.974583625793571],
          [73.497085571289006, 15.974862098693961],
          [73.496803283691634, 15.974860191345158],
          [73.496803283691634, 15.975419998169002],
          [73.496528625488452, 15.975418090820426],
          [73.496528625488452, 15.975693702697754],
          [73.496246337890682, 15.975691795349121],
          [73.496246337890682, 15.976530075073356],
          [73.495979309082202, 15.976530075073356],
          [73.495979309082202, 15.976811408996639],
          [73.495414733886719, 15.976805686950684],
          [73.495414733886719, 15.977084159851074],
          [73.495140075683878, 15.977080345153865],
          [73.495140075683878, 15.977640151977539],
          [73.494857788085938, 15.977640151977539],
          [73.494857788085938, 15.978194236755428],
          [73.494583129882926, 15.978194236755428],
          [73.494583129882926, 15.978471755981502],
          [73.494308471679744, 15.978469848632926],
          [73.494308471679744, 15.979030609130859],
          [73.494026184081974, 15.979030609130859],
          [73.494026184081974, 15.979310989379996],
          [73.493751525879134, 15.979306221008358],
          [73.493751525879134, 15.979583740234432],
          [73.493469238281421, 15.979583740234432],
          [73.493469238281421, 15.979860305786246],
          [73.492919921875171, 15.979860305786246],
          [73.492919921875171, 15.980693817138786],
          [73.492637634277628, 15.980693817138786],
          [73.492637634277628, 15.980972290039176],
          [73.492362976074219, 15.98097038269043],
          [73.492362976074219, 15.981252670288143],
          [73.492080688476847, 15.981252670288143],
          [73.492080688476847, 15.981531143188533],
          [73.491806030273437, 15.981528282165641],
          [73.491806030273437, 15.982082366943359],
          [73.491531372070426, 15.982080459594783],
          [73.491531372070426, 15.982641220092887],
          [73.491249084472713, 15.982638359069824],
          [73.491249084472713, 15.983195304870605],
          [73.490966796875114, 15.983180999755803],
          [73.490966796875114, 15.98375129699707],
          [73.490692138671932, 15.98375129699707],
          [73.490692138671932, 15.984030723571721],
          [73.490417480468921, 15.984028816223145],
          [73.490417480468921, 15.984582901001033],
          [73.490142822265682, 15.984580039978141],
          [73.490142822265682, 15.985140800476074],
          [73.489860534668139, 15.985138893127498],
          [73.489860534668139, 15.985694885253963],
          [73.489585876465128, 15.985690116882324],
          [73.489585876465128, 15.986811637878418],
          [73.489303588867358, 15.98680686950695],
          [73.489303588867358, 15.987083435058707],
          [73.489028930664347, 15.987079620361385],
          [73.489028930664347, 15.987920761108455],
          [73.488746643066406, 15.987916946411076],
          [73.488746643066406, 15.991029739379883],
          [73.488746643066406, 15.992369651794547],
          [73.488471984863565, 15.9923610687257],
          [73.488471984863565, 15.993194580078068],
          [73.488746643066406, 15.993194580078068],
          [73.488746643066406, 15.993471145629883],
          [73.488471984863565, 15.993471145629883],
          [73.488471984863565, 15.994860649108887],
          [73.488746643066406, 15.994860649108887],
          [73.488746643066406, 15.997083663940487],
          [73.489028930664347, 15.997083663940487],
          [73.489028930664347, 15.998472213745231],
          [73.488746643066406, 15.998469352722168],
          [73.488746643066406, 15.999030113220272],
          [73.489028930664347, 15.999030113220272],
          [73.489028930664347, 15.999309539794979],
          [73.489295959472827, 15.999309539794979],
          [73.489303588867358, 15.999861717224064],
          [73.489303588867358, 16.002361297607479],
          [73.489585876465128, 16.002361297607479],
          [73.489585876465128, 16.003194808960018],
          [73.489860534668139, 16.003194808960018],
          [73.489860534668139, 16.007083892822266],
          [73.490135192871321, 16.007083892822266],
          [73.490135192871321, 16.00736045837408],
          [73.490417480468921, 16.007350921630916],
          [73.490417480468921, 16.007640838623047],
          [73.490692138671932, 16.007638931274471],
          [73.490692138671932, 16.009582519531364],
          [73.490966796875114, 16.009580612182617],
          [73.490966796875114, 16.011531829834041],
          [73.490692138671932, 16.011531829834041],
          [73.490692138671932, 16.011810302734432],
          [73.490417480468921, 16.011806488037053],
          [73.490417480468921, 16.012361526489258],
          [73.490142822265682, 16.012361526489258],
          [73.490142822265682, 16.012641906738395],
          [73.489852905273608, 16.012641906738395],
          [73.489852905273608, 16.013750076294002],
          [73.489585876465128, 16.013750076294002],
          [73.489585876465128, 16.015972137451286],
          [73.489303588867358, 16.015972137451286],
          [73.489303588867358, 16.017084121704045],
          [73.489028930664347, 16.017084121704045],
          [73.489028930664347, 16.018472671508789],
          [73.488746643066406, 16.018470764160213],
          [73.488746643066406, 16.01902961730957],
          [73.488471984863565, 16.01902961730957],
          [73.488471984863565, 16.019309997558707],
          [73.488197326660213, 16.019304275512752],
          [73.488197326660213, 16.019582748413143],
          [73.487922668456974, 16.019580841064567],
          [73.487922668456974, 16.020420074462891],
          [73.487640380859432, 16.020416259765682],
          [73.487640380859432, 16.020971298217887],
          [73.487358093261662, 16.020969390869141],
          [73.487358093261662, 16.021530151367244],
          [73.487083435058821, 16.021526336669865],
          [73.487083435058821, 16.022361755371207],
          [73.486808776855639, 16.022361755371207],
          [73.486808776855639, 16.023471832275391],
          [73.486526489257869, 16.023469924926815],
          [73.486526489257869, 16.023748397827205],
          [73.486251831054858, 16.023748397827205],
          [73.486251831054858, 16.024030685424918],
          [73.485969543457315, 16.024030685424918],
          [73.485969543457315, 16.024858474731559],
          [73.485687255859375, 16.024858474731559],
          [73.485687255859375, 16.025140762329102],
          [73.485969543457315, 16.025140762329102],
          [73.485969543457315, 16.025693893432674],
          [73.485687255859375, 16.025688171386719],
          [73.485687255859375, 16.026531219482422],
          [73.485420227051065, 16.026531219482422],
          [73.485420227051065, 16.0276393890382],
          [73.485137939453182, 16.0276393890382],
          [73.485137939453182, 16.029310226440487],
          [73.484863281250114, 16.029306411743107],
          [73.484863281250114, 16.029861450195312],
          [73.484580993652401, 16.029859542846737],
          [73.484580993652401, 16.03042030334484],
          [73.484306335449162, 16.030416488647461],
          [73.484306335449162, 16.031528472900447],
          [73.484016418457088, 16.031520843505916],
          [73.484016418457088, 16.032920837402344],
          [73.483749389648608, 16.032920837402344],
          [73.483749389648608, 16.034030914306697],
          [73.483467102050838, 16.034030914306697],
          [73.483467102050838, 16.035140991211051],
          [73.483192443847827, 16.035137176513672],
          [73.483192443847827, 16.035972595214844],
          [73.482917785644815, 16.035970687866268],
          [73.482917785644815, 16.036529541015625],
          [73.482635498046875, 16.036529541015625],
          [73.482635498046875, 16.037082672119197],
          [73.482360839844034, 16.037080764770621],
          [73.482360839844034, 16.037639617919979],
          [73.482086181640682, 16.037639617919979],
          [73.482086181640682, 16.038194656372127],
          [73.481803894043082, 16.038194656372127],
          [73.481803894043082, 16.038473129272518],
          [73.481529235839901, 16.038469314575195],
          [73.481529235839901, 16.038751602172908],
          [73.481246948242131, 16.038751602172908],
          [73.481246948242131, 16.03930473327631],
          [73.48097229003929, 16.03930473327631],
          [73.48097229003929, 16.039583206176871],
          [73.480697631836108, 16.039579391479549],
          [73.480697631836108, 16.040140151977653],
          [73.480140686035327, 16.040140151977653],
          [73.480140686035327, 16.040420532226619],
          [73.479858398437784, 16.040420532226619],
          [73.479858398437784, 16.04071044921875],
          [73.479576110840014, 16.04071044921875],
          [73.479576110840014, 16.041250228881836],
          [73.479309082031534, 16.041250228881836],
          [73.479309082031534, 16.041530609130973],
          [73.479026794433594, 16.041530609130973],
          [73.479026794433594, 16.041812896728516],
          [73.478469848632869, 16.041805267333984],
          [73.478469848632869, 16.042083740234375],
          [73.478195190429631, 16.042083740234375],
          [73.478202819824162, 16.04236030578619],
          [73.477912902832088, 16.04236030578619],
          [73.477912902832088, 16.042921066284293],
          [73.477638244629077, 16.042917251586971],
          [73.477638244629077, 16.043472290039119],
          [73.477355957031477, 16.043462753296012],
          [73.477355957031477, 16.04375076293951],
          [73.477081298828296, 16.04375076293951],
          [73.477081298828296, 16.044031143188477],
          [73.475692749023722, 16.044031143188477],
          [73.475692749023722, 16.044309616088867],
          [73.474861145019588, 16.044305801391658],
          [73.474861145019588, 16.044584274292049],
          [73.474296569824446, 16.044580459594727],
          [73.474296569824446, 16.04514122009283],
          [73.473472595215014, 16.04514122009283],
          [73.473472595215014, 16.045419692993221],
          [73.472640991211222, 16.045415878295842],
          [73.472640991211222, 16.045694351196232],
          [73.471809387207088, 16.045694351196232],
          [73.471801757812557, 16.045972824096793],
          [73.470970153808764, 16.045970916748047],
          [73.470970153808764, 16.046249389648437],
          [73.469024658203239, 16.046249389648437],
          [73.469024658203239, 16.046527862548828],
          [73.468475341796818, 16.046527862548828],
          [73.468475341796818, 16.047082901000977],
          [73.468193054199446, 16.047080993652401],
          [73.468193054199446, 16.047920227050895],
          [73.468475341796818, 16.047916412353516],
          [73.468475341796818, 16.048471450805721],
          [73.468750000000057, 16.048471450805721],
          [73.468750000000057, 16.049861907959041],
          [73.468482971191577, 16.049858093261662],
          [73.468482971191577, 16.051809310913143],
          [73.468193054199446, 16.051805496215763],
          [73.468193054199446, 16.052083969116154],
          [73.467918395996264, 16.052078247070369],
          [73.467918395996264, 16.052650451660213],
          [73.467636108398494, 16.052650451660213],
          [73.467636108398494, 16.052919387817496],
          [73.467361450195483, 16.05291748046875],
          [73.467361450195483, 16.053472518920898],
          [73.467086791992472, 16.053472518920898],
          [73.467086791992472, 16.053752899169865],
          [73.466796875000171, 16.053752899169865],
          [73.466796875000171, 16.05402946472168],
          [73.46624755859375, 16.05402946472168],
          [73.46624755859375, 16.054309844970817],
          [73.465698242187557, 16.054306030273438],
          [73.465698242187557, 16.054582595825252],
          [73.465415954589787, 16.054582595825252],
          [73.465415954589787, 16.054861068725643],
          [73.463470458984659, 16.054861068725643],
          [73.463470458984659, 16.055139541626033],
          [73.462638854980526, 16.055139541626033],
          [73.462638854980526, 16.055419921875],
          [73.46097564697294, 16.055416107177791],
          [73.46097564697294, 16.055694580078182],
          [73.459304809570426, 16.055694580078182],
          [73.459304809570426, 16.055416107177791],
          [73.459030151367244, 16.055419921875],
          [73.459030151367244, 16.054861068725643],
          [73.458747863769474, 16.054861068725643],
          [73.458747863769474, 16.053472518920898],
          [73.458473205566634, 16.053472518920898],
          [73.458473205566634, 16.053194046020508],
          [73.456527709960994, 16.053194046020508],
          [73.456527709960994, 16.053472518920898],
          [73.456253051757926, 16.053472518920898],
          [73.456253051757926, 16.053752899169865],
          [73.455970764160213, 16.053752899169865],
          [73.455970764160213, 16.05402946472168],
          [73.455696105956974, 16.05402946472168],
          [73.455696105956974, 16.054309844970817],
          [73.455413818359602, 16.054306030273438],
          [73.455413818359602, 16.054582595825252],
          [73.455139160156421, 16.054582595825252],
          [73.455139160156421, 16.055139541626033],
          [73.454864501953182, 16.055139541626033],
          [73.454864501953182, 16.055694580078182],
          [73.455139160156421, 16.055694580078182],
          [73.455139160156421, 16.055973052978572],
          [73.455696105956974, 16.055973052978572],
          [73.455696105956974, 16.055694580078182],
          [73.456253051757926, 16.055694580078182],
          [73.456253051757926, 16.055973052978572],
          [73.456527709960994, 16.055971145629996],
          [73.456527709960994, 16.056529998779354],
          [73.456802368164347, 16.056528091430778],
          [73.456802368164347, 16.057361602783317],
          [73.456527709960994, 16.05735969543457],
          [73.456527709960994, 16.057640075683707],
          [73.456253051757926, 16.057640075683707],
          [73.456253051757926, 16.057920455932674],
          [73.455970764160213, 16.057920455932674],
          [73.455970764160213, 16.058200836181641],
          [73.455696105956974, 16.058193206787109],
          [73.455696105956974, 16.0584716796875],
          [73.455406188964901, 16.05846023559576],
          [73.455406188964901, 16.058750152587891],
          [73.455696105956974, 16.058750152587891],
          [73.455696105956974, 16.059310913085994],
          [73.455970764160213, 16.059305191040039],
          [73.455970764160213, 16.060693740844783],
          [73.455696105956974, 16.060693740844783],
          [73.455696105956974, 16.060972213745174],
          [73.455413818359602, 16.060972213745174],
          [73.455413818359602, 16.061525344848576],
          [73.455139160156421, 16.061525344848576],
          [73.455139160156421, 16.062084197998104],
          [73.454856872558651, 16.062080383300781],
          [73.454856872558651, 16.062919616699276],
          [73.455139160156421, 16.062915802001896],
          [73.455139160156421, 16.063194274902287],
          [73.456527709960994, 16.063194274902287],
          [73.456527709960994, 16.062915802001896],
          [73.456802368164347, 16.062915802001896],
          [73.456802368164347, 16.063194274902287],
          [73.458190917968921, 16.063194274902287],
          [73.458190917968921, 16.062915802001896],
          [73.458473205566634, 16.062919616699276],
          [73.458473205566634, 16.062641143798885],
          [73.458747863769474, 16.062641143798885],
          [73.458747863769474, 16.062360763549918],
          [73.459869384765739, 16.062360763549918],
          [73.459869384765739, 16.062641143798885],
          [73.460418701172159, 16.062641143798885],
          [73.460418701172159, 16.062919616699276],
          [73.46097564697294, 16.062915802001896],
          [73.46097564697294, 16.063194274902287],
          [73.461517333984602, 16.063190460205135],
          [73.461517333984602, 16.063751220703239],
          [73.462081909179744, 16.063751220703239],
          [73.462081909179744, 16.06430816650402],
          [73.462364196777287, 16.064306259155217],
          [73.462364196777287, 16.064861297607422],
          [73.462905883789347, 16.064861297607422],
          [73.462905883789347, 16.06542015075695],
          [73.46319580078125, 16.06541633605957],
          [73.46319580078125, 16.065694808959961],
          [73.463470458984659, 16.065694808959961],
          [73.463470458984659, 16.066804885864315],
          [73.463752746582031, 16.066799163818359],
          [73.463752746582031, 16.067649841308594],
          [73.46402740478544, 16.067649841308594],
          [73.46402740478544, 16.067920684814453],
          [73.464302062988452, 16.067920684814453],
          [73.464302062988452, 16.06875038146984],
          [73.46402740478544, 16.06875038146984],
          [73.46402740478544, 16.069030761718807],
          [73.463752746582031, 16.069030761718807],
          [73.463752746582031, 16.069311141967773],
          [73.463470458984659, 16.069305419921818],
          [73.463470458984659, 16.069583892822209],
          [73.46319580078125, 16.069580078125057],
          [73.46319580078125, 16.070421218872127],
          [73.463470458984659, 16.070417404174805],
          [73.463470458984659, 16.070695877075138],
          [73.46402740478544, 16.070695877075138],
          [73.46402740478544, 16.070972442626953],
          [73.464302062988452, 16.070970535278377],
          [73.464302062988452, 16.071250915527344],
          [73.464859008789233, 16.071250915527344],
          [73.464859008789233, 16.071529388427734],
          [73.465415954589787, 16.071529388427734],
          [73.465415954589787, 16.071250915527344],
          [73.465682983398494, 16.071250915527344],
          [73.465698242187557, 16.070970535278377],
          [73.465972900390739, 16.070972442626953],
          [73.465972900390739, 16.070417404174805],
          [73.46624755859375, 16.070421218872127],
          [73.46624755859375, 16.069860458374023],
          [73.46652984619169, 16.069860458374023],
          [73.46652984619169, 16.069580078125057],
          [73.467361450195483, 16.069580078125057],
          [73.467361450195483, 16.069860458374023],
          [73.467636108398494, 16.069860458374023],
          [73.467636108398494, 16.071250915527344],
          [73.467361450195483, 16.071250915527344],
          [73.467361450195483, 16.072082519531307],
          [73.467086791992472, 16.072080612182731],
          [73.467086791992472, 16.072639465332088],
          [73.466804504394531, 16.072639465332088],
          [73.466804504394531, 16.073194503784237],
          [73.46652984619169, 16.073194503784237],
          [73.46652984619169, 16.073472976684627],
          [73.465972900390739, 16.073471069336051],
          [73.465972900390739, 16.073749542236442],
          [73.465698242187557, 16.073749542236442],
          [73.465698242187557, 16.074029922485408],
          [73.465415954589787, 16.074029922485408],
          [73.465415954589787, 16.075420379638729],
          [73.465141296386946, 16.075420379638729],
          [73.465141296386946, 16.075700759887695],
          [73.464859008789233, 16.075700759887695],
          [73.464859008789233, 16.077640533447266],
          [73.464302062988452, 16.077640533447266],
          [73.464302062988452, 16.078193664550838],
          [73.463752746582031, 16.078189849853516],
          [73.463752746582031, 16.07902908325201],
          [73.463470458984659, 16.07902908325201],
          [73.463470458984659, 16.079309463500977],
          [73.462905883789347, 16.079309463500977],
          [73.462905883789347, 16.07959175109869],
          [73.462638854980526, 16.07959175109869],
          [73.462638854980526, 16.079862594604549],
          [73.462356567382926, 16.079862594604549],
          [73.462356567382926, 16.08014106750494],
          [73.458747863769474, 16.08014106750494],
          [73.458747863769474, 16.079862594604549],
          [73.457641601562671, 16.079862594604549],
          [73.457641601562671, 16.08014106750494],
          [73.457359313965128, 16.080139160156364],
          [73.457359313965128, 16.080694198608342],
          [73.457077026367188, 16.08069038391119],
          [73.457077026367188, 16.081809997558651],
          [73.457359313965128, 16.081806182861271],
          [73.457359313965128, 16.082082748413086],
          [73.457916259765682, 16.082082748413086],
          [73.457916259765682, 16.082639694213867],
          [73.458473205566634, 16.082630157470703],
          [73.458473205566634, 16.082920074463004],
          [73.458747863769474, 16.082916259765625],
          [73.458747863769474, 16.083194732666016],
          [73.459030151367244, 16.08319282531744],
          [73.459030151367244, 16.084030151367187],
          [73.458747863769474, 16.084028244018612],
          [73.458747863769474, 16.08458328247076],
          [73.458473205566634, 16.084579467773437],
          [73.458473205566634, 16.085140228271541],
          [73.458190917968921, 16.085140228271541],
          [73.458190917968921, 16.085420608520508],
          [73.457916259765682, 16.085416793823356],
          [73.457916259765682, 16.08569526672369],
          [73.457641601562671, 16.08569526672369],
          [73.457641601562671, 16.085971832275504],
          [73.457916259765682, 16.085969924926758],
          [73.457916259765682, 16.086250305175895],
          [73.458747863769474, 16.086250305175895],
          [73.458747863769474, 16.085969924926758],
          [73.459304809570426, 16.085971832275504],
          [73.459304809570426, 16.08569526672369],
          [73.46097564697294, 16.08569526672369],
          [73.46097564697294, 16.085971832275504],
          [73.461807250976733, 16.085969924926758],
          [73.461807250976733, 16.086250305175895],
          [73.462638854980526, 16.086250305175895],
          [73.462638854980526, 16.086530685424862],
          [73.462356567382926, 16.086530685424862],
          [73.462356567382926, 16.087360382080078],
          [73.462081909179744, 16.087360382080078],
          [73.462081909179744, 16.089582443237362],
          [73.461807250976733, 16.089580535888786],
          [73.461807250976733, 16.091819763183537],
          [73.461517333984602, 16.091819763183537],
          [73.461517333984602, 16.094030380249137],
          [73.461250305175952, 16.094030380249137],
          [73.461250305175952, 16.096250534057674],
          [73.46097564697294, 16.096250534057674],
          [73.46097564697294, 16.097082138061637],
          [73.460693359375171, 16.097080230712891],
          [73.460693359375171, 16.097360610962028],
          [73.460418701172159, 16.097360610962028],
          [73.460418701172159, 16.098194122314396],
          [73.460136413574219, 16.098190307617244],
          [73.460136413574219, 16.098751068115348],
          [73.459869384765739, 16.098751068115348],
          [73.459869384765739, 16.099309921264705],
          [73.459587097168026, 16.099309921264705],
          [73.459587097168026, 16.100139617919922],
          [73.459297180175895, 16.100139617919922],
          [73.459297180175895, 16.100419998169059],
          [73.459030151367244, 16.100419998169059],
          [73.459030151367244, 16.100700378418026],
          [73.458747863769474, 16.100700378418026],
          [73.458747863769474, 16.101530075073242],
          [73.458473205566634, 16.101526260376033],
          [73.458473205566634, 16.102083206176815],
          [73.458190917968921, 16.102083206176815],
          [73.458190917968921, 16.103471755981559],
          [73.457916259765682, 16.103469848632812],
          [73.457916259765682, 16.104030609130916],
          [73.457641601562671, 16.104030609130916],
          [73.457641601562671, 16.109584808349666],
          [73.457359313965128, 16.109584808349666],
          [73.457359313965128, 16.109861373901481],
          [73.457641601562671, 16.109859466552734],
          [73.457641601562671, 16.110420227050838],
          [73.457916259765682, 16.110420227050838],
          [73.457916259765682, 16.111249923706055],
          [73.458190917968921, 16.111249923706055],
          [73.458190917968921, 16.111810684204158],
          [73.457916259765682, 16.111810684204158],
          [73.457916259765682, 16.116529464721793],
          [73.457641601562671, 16.116529464721793],
          [73.457641601562671, 16.117637634277401],
          [73.457359313965128, 16.117637634277401],
          [73.457359313965128, 16.119304656982479],
          [73.457084655761719, 16.119304656982479],
          [73.457084655761719, 16.119583129882869],
          [73.457359313965128, 16.119583129882869],
          [73.457359313965128, 16.120971679687614],
          [73.457077026367188, 16.120971679687614],
          [73.457077026367188, 16.121530532836971],
          [73.456802368164347, 16.121528625488395],
          [73.456802368164347, 16.122083663940373],
          [73.456527709960994, 16.122079849243221],
          [73.456527709960994, 16.122920989990291],
          [73.456253051757926, 16.122920989990291],
          [73.456253051757926, 16.123750686645508],
          [73.455970764160213, 16.123750686645508],
          [73.455970764160213, 16.124584197998047],
          [73.455696105956974, 16.124580383300895],
          [73.455696105956974, 16.125419616699219],
          [73.455406188964901, 16.125419616699219],
          [73.455406188964901, 16.126251220703182],
          [73.455139160156421, 16.126249313354606],
          [73.455139160156421, 16.127082824707145],
          [73.454864501953182, 16.127082824707145],
          [73.454864501953182, 16.128194808959904],
          [73.454582214355639, 16.128190994262752],
          [73.454582214355639, 16.129030227661246],
          [73.454307556152628, 16.129026412963867],
          [73.454307556152628, 16.129861831665039],
          [73.454032897949219, 16.129859924316463],
          [73.454032897949219, 16.13014030456543],
          [73.453742980957315, 16.13014030456543],
          [73.453742980957315, 16.131809234619141],
          [73.453475952148494, 16.131809234619141],
          [73.453475952148494, 16.13292121887207],
          [73.453186035156534, 16.13292121887207],
          [73.453186035156534, 16.134029388427848],
          [73.452919006347713, 16.134029388427848],
          [73.452919006347713, 16.135139465332031],
          [73.452636718749943, 16.135139465332031],
          [73.452636718749943, 16.13569450378418],
          [73.452362060547102, 16.135690689087028],
          [73.452362060547102, 16.137920379638672],
          [73.452079772949389, 16.137920379638672],
          [73.452079772949389, 16.139310836791992],
          [73.451805114746151, 16.139305114746037],
          [73.451805114746151, 16.139583587646428],
          [73.452079772949389, 16.139579772949276],
          [73.452079772949389, 16.14180946350109],
          [73.451805114746151, 16.141805648803711],
          [73.451805114746151, 16.143472671508846],
          [73.451530456543139, 16.14347076416027],
          [73.451530456543139, 16.144029617309627],
          [73.451248168945597, 16.144029617309627],
          [73.451248168945597, 16.1445827484132],
          [73.450973510742187, 16.1445827484132],
          [73.450973510742187, 16.145969390869197],
          [73.450675964355753, 16.145969390869197],
          [73.450675964355753, 16.146530151367301],
          [73.450416564941406, 16.146530151367301],
          [73.450416564941406, 16.147920608520621],
          [73.450141906738395, 16.147920608520621],
          [73.450141906738395, 16.149311065673771],
          [73.449859619140682, 16.149305343627987],
          [73.449859619140682, 16.150972366333121],
          [73.449584960937443, 16.150972366333121],
          [73.449584960937443, 16.152082443237305],
          [73.449859619140682, 16.152080535888729],
          [73.449859619140682, 16.152919769287223],
          [73.449584960937443, 16.152914047241268],
          [73.449584960937443, 16.153472900390625],
          [73.449302673339901, 16.153470993042049],
          [73.449302673339901, 16.154310226440543],
          [73.449028015136889, 16.154310226440543],
          [73.449028015136889, 16.15513992309576],
          [73.448753356933651, 16.15513992309576],
          [73.448753356933651, 16.155420303344727],
          [73.448471069336108, 16.155420303344727],
          [73.448471069336108, 16.156248092651367],
          [73.448196411133097, 16.156248092651367],
          [73.448196411133097, 16.156810760498047],
          [73.447914123535327, 16.156805038452092],
          [73.447914123535327, 16.157361984253043],
          [73.447639465332315, 16.157358169555721],
          [73.447639465332315, 16.157640457153434],
          [73.447364807128906, 16.157640457153434],
          [73.447364807128906, 16.158470153808651],
          [73.447082519531534, 16.158468246460075],
          [73.447082519531534, 16.158748626709041],
          [73.446807861328182, 16.158748626709041],
          [73.446807861328182, 16.159309387207145],
          [73.446525573730582, 16.159305572509766],
          [73.446525573730582, 16.16069412231451],
          [73.446250915527401, 16.160690307617188],
          [73.446250915527401, 16.162919998169002],
          [73.445968627929631, 16.162916183471623],
          [73.445968627929631, 16.164861679077148],
          [73.445686340332259, 16.164859771728572],
          [73.445686340332259, 16.166250228881893],
          [73.445419311523608, 16.166250228881893],
          [73.445419311523608, 16.167640686035213],
          [73.445137023925838, 16.167638778686637],
          [73.445137023925838, 16.168472290039176],
          [73.444862365722827, 16.16847038269043],
          [73.444862365722827, 16.169031143188533],
          [73.444580078125284, 16.169027328491211],
          [73.444580078125284, 16.16986083984375],
          [73.444305419921875, 16.16986083984375],
          [73.444313049316406, 16.171247482299918],
          [73.444030761719034, 16.171247482299918],
          [73.444030761719034, 16.172359466552848],
          [73.443748474121151, 16.172359466552848],
          [73.443748474121151, 16.173194885253963],
          [73.443466186523551, 16.173189163208065],
          [73.443466186523551, 16.174030303955135],
          [73.443191528320369, 16.174030303955135],
          [73.443191528320369, 16.175140380859489],
          [73.442916870117131, 16.175140380859489],
          [73.442916870117131, 16.175979614257813],
          [73.44264221191429, 16.175979614257813],
          [73.44264221191429, 16.176811218261776],
          [73.442359924316577, 16.176811218261776],
          [73.442359924316577, 16.177919387817383],
          [73.442092895508097, 16.177919387817383],
          [73.442092895508097, 16.178750991821346],
          [73.441802978515796, 16.178750991821346],
          [73.441802978515796, 16.1798610687257],
          [73.441528320312784, 16.1798610687257],
          [73.441528320312784, 16.18569374084467],
          [73.441246032714844, 16.185689926147518],
          [73.441246032714844, 16.186252593994197],
          [73.440971374512003, 16.186252593994197],
          [73.440971374512003, 16.186809539794979],
          [73.440696716308651, 16.186809539794979],
          [73.440696716308651, 16.187362670898381],
          [73.44040679931669, 16.187362670898381],
          [73.44040679931669, 16.187641143798942],
          [73.440139770507869, 16.187641143798942],
          [73.440139770507869, 16.188751220703125],
          [73.439857482910099, 16.188749313354549],
          [73.439857482910099, 16.189584732055664],
          [73.439582824707259, 16.189582824707088],
          [73.439582824707259, 16.190420150756836],
          [73.439308166504077, 16.190420150756836],
          [73.439308166504077, 16.191249847412223],
          [73.439025878906307, 16.191249847412223],
          [73.439025878906307, 16.192083358764592],
          [73.438735961914233, 16.19207954406744],
          [73.438735961914233, 16.19292068481451],
          [73.438468933105753, 16.192916870117187],
          [73.438468933105753, 16.194026947021541],
          [73.438186645507983, 16.194021224975586],
          [73.438186645507983, 16.19486045837408],
          [73.437919616699503, 16.19486045837408],
          [73.437919616699503, 16.19597244262701],
          [73.437637329101563, 16.195970535278434],
          [73.437637329101563, 16.196527481079215],
          [73.437362670898551, 16.196527481079215],
          [73.437362670898551, 16.196809768676758],
          [73.437080383300838, 16.196809768676758],
          [73.437080383300838, 16.197359085083008],
          [73.436813354492131, 16.197359085083008],
          [73.436813354492131, 16.197919845581112],
          [73.436531066894759, 16.197916030883732],
          [73.436531066894759, 16.198194503784123],
          [73.436248779297046, 16.198190689086971],
          [73.436248779297046, 16.198751449585075],
          [73.435966491699446, 16.198751449585075],
          [73.435966491699446, 16.199031829834041],
          [73.435691833496264, 16.199029922485465],
          [73.435691833496264, 16.200969696045036],
          [73.435966491699446, 16.200969696045036],
          [73.435966491699446, 16.201250076294002],
          [73.436531066894759, 16.201250076294002],
          [73.436531066894759, 16.201530456542969],
          [73.436813354492131, 16.201530456542969],
          [73.436813354492131, 16.201250076294002],
          [73.437080383300838, 16.201250076294002],
          [73.437080383300838, 16.200969696045036],
          [73.437362670898551, 16.200969696045036],
          [73.437362670898551, 16.200695037841797],
          [73.437637329101563, 16.200702667236385],
          [73.437637329101563, 16.200420379638786],
          [73.437919616699503, 16.200420379638786],
          [73.437919616699503, 16.200149536132756],
          [73.439308166504077, 16.200149536132756],
          [73.439308166504077, 16.200420379638786],
          [73.440696716308651, 16.200420379638786],
          [73.440696716308651, 16.200149536132756],
          [73.441246032714844, 16.200149536132756],
          [73.441246032714844, 16.199861526489258],
          [73.441528320312784, 16.199861526489258],
          [73.441528320312784, 16.199581146240291],
          [73.442359924316577, 16.199581146240291],
          [73.442359924316577, 16.199029922485465],
          [73.44264221191429, 16.199031829834041],
          [73.44264221191429, 16.198469161987362],
          [73.442916870117131, 16.198472976684513],
          [73.442916870117131, 16.198194503784123],
          [73.444030761719034, 16.198194503784123],
          [73.444030761719034, 16.198472976684513],
          [73.444305419921875, 16.198472976684513],
          [73.444305419921875, 16.198751449585075],
          [73.444580078125284, 16.198751449585075],
          [73.444580078125284, 16.199031829834041],
          [73.444862365722827, 16.199029922485465],
          [73.444862365722827, 16.199861526489258],
          [73.444580078125284, 16.199861526489258],
          [73.444580078125284, 16.201810836791935],
          [73.444305419921875, 16.201805114746151],
          [73.444305419921875, 16.202362060546932],
          [73.444030761719034, 16.202360153198356],
          [73.444030761719034, 16.202640533447322],
          [73.442092895508097, 16.202638626098746],
          [73.441802978515796, 16.202640533447322],
          [73.441802978515796, 16.202079772949219],
          [73.441528320312784, 16.202083587646541],
          [73.441528320312784, 16.201805114746151],
          [73.441246032714844, 16.201810836791935],
          [73.441246032714844, 16.201530456542969],
          [73.440971374512003, 16.201530456542969],
          [73.440971374512003, 16.201250076294002],
          [73.439582824707259, 16.201250076294002],
          [73.439582824707259, 16.201530456542969],
          [73.439025878906307, 16.201530456542969],
          [73.439025878906307, 16.202920913696289],
          [73.439308166504077, 16.202917098999137],
          [73.439308166504077, 16.203472137451286],
          [73.439025878906307, 16.203470230102539],
          [73.439025878906307, 16.203750610351676],
          [73.439308166504077, 16.203750610351676],
          [73.439308166504077, 16.205141067504996],
          [73.439582824707259, 16.205141067504996],
          [73.439582824707259, 16.205419540405387],
          [73.439857482910099, 16.205415725708008],
          [73.439857482910099, 16.205694198608398],
          [73.440414428711051, 16.205694198608398],
          [73.440414428711051, 16.205972671508789],
          [73.440696716308651, 16.205961227417106],
          [73.440696716308651, 16.20625114440918],
          [73.44095611572294, 16.206249237060604],
          [73.441246032714844, 16.20625114440918],
          [73.441246032714844, 16.205961227417106],
          [73.442085266113338, 16.205972671508789],
          [73.442085266113338, 16.205415725708008],
          [73.442359924316577, 16.205419540405387],
          [73.442359924316577, 16.204860687255859],
          [73.44264221191429, 16.204860687255859],
          [73.44264221191429, 16.204309463501033],
          [73.443191528320369, 16.204305648803654],
          [73.443191528320369, 16.204584121704045],
          [73.443748474121151, 16.204580307006893],
          [73.443748474121151, 16.204860687255859],
          [73.445137023925838, 16.204860687255859],
          [73.445137023925838, 16.205141067504996],
          [73.446250915527401, 16.205141067504996],
          [73.446250915527401, 16.205419540405387],
          [73.446807861328182, 16.205415725708008],
          [73.446807861328182, 16.205694198608398],
          [73.447357177734375, 16.205690383911246],
          [73.447357177734375, 16.20625114440918],
          [73.447639465332315, 16.20625114440918],
          [73.447639465332315, 16.20652961730957],
          [73.447914123535327, 16.206527709960994],
          [73.447914123535327, 16.207082748413143],
          [73.448196411133097, 16.207080841064567],
          [73.448196411133097, 16.207361221313533],
          [73.448471069336108, 16.207361221313533],
          [73.448471069336108, 16.207639694213924],
          [73.448753356933651, 16.207639694213924],
          [73.448753356933651, 16.207920074462891],
          [73.449028015136889, 16.207916259765739],
          [73.449028015136889, 16.208194732666072],
          [73.448753356933651, 16.208194732666072],
          [73.448753356933651, 16.209861755371207],
          [73.449028015136889, 16.209859848022461],
          [73.449028015136889, 16.210420608520565],
          [73.449302673339901, 16.210420608520565],
          [73.449302673339901, 16.211530685424918],
          [73.449028015136889, 16.211530685424918],
          [73.449028015136889, 16.212089538574276],
          [73.448471069336108, 16.212089538574276],
          [73.448471069336108, 16.211809158325309],
          [73.448196411133097, 16.211809158325309],
          [73.448196411133097, 16.210420608520565],
          [73.447906494140796, 16.210420608520565],
          [73.447906494140796, 16.209020614624137],
          [73.447639465332315, 16.209026336669865],
          [73.447639465332315, 16.208471298217887],
          [73.447364807128906, 16.208471298217887],
          [73.447364807128906, 16.207916259765739],
          [73.447082519531534, 16.207920074462891],
          [73.447082519531534, 16.207639694213924],
          [73.446807861328182, 16.207639694213924],
          [73.446807861328182, 16.207361221313533],
          [73.446525573730582, 16.207361221313533],
          [73.446525573730582, 16.207082748413143],
          [73.44569396972679, 16.207082748413143],
          [73.44569396972679, 16.206804275512752],
          [73.444862365722827, 16.206809997558707],
          [73.444862365722827, 16.20652961730957],
          [73.444030761719034, 16.20652961730957],
          [73.444030761719034, 16.20625114440918],
          [73.443748474121151, 16.20625114440918],
          [73.443748474121151, 16.20652961730957],
          [73.442916870117131, 16.20652961730957],
          [73.442916870117131, 16.206809997558707],
          [73.442359924316577, 16.206804275512752],
          [73.442359924316577, 16.207082748413143],
          [73.44264221191429, 16.207080841064567],
          [73.44264221191429, 16.207920074462891],
          [73.442916870117131, 16.207916259765739],
          [73.442916870117131, 16.208194732666072],
          [73.443473815918082, 16.208194732666072],
          [73.443473815918082, 16.208471298217887],
          [73.443748474121151, 16.208469390869141],
          [73.443748474121151, 16.208749771118278],
          [73.444030761719034, 16.208749771118278],
          [73.444030761719034, 16.209026336669865],
          [73.444313049316406, 16.209020614624137],
          [73.444313049316406, 16.210138320922852],
          [73.444580078125284, 16.210138320922852],
          [73.444580078125284, 16.212358474731559],
          [73.444862365722827, 16.212358474731559],
          [73.444862365722827, 16.214580535888672],
          [73.445137023925838, 16.214580535888672],
          [73.445137023925838, 16.215419769287166],
          [73.445419311523608, 16.215415954589787],
          [73.445419311523608, 16.215974807739371],
          [73.445968627929631, 16.215972900390568],
          [73.445968627929631, 16.21652984619152],
          [73.446250915527401, 16.21652984619152],
          [73.446250915527401, 16.217639923095703],
          [73.445968627929631, 16.217639923095703],
          [73.445968627929631, 16.21792030334484],
          [73.446250915527401, 16.21792030334484],
          [73.446250915527401, 16.219030380249023],
          [73.446525573730582, 16.219028472900447],
          [73.446525573730582, 16.219861984252987],
          [73.446807861328182, 16.219860076904411],
          [73.446807861328182, 16.221530914306697],
          [73.447082519531534, 16.221525192260742],
          [73.447082519531534, 16.223194122314453],
          [73.447364807128906, 16.223194122314453],
          [73.447364807128906, 16.224582672119197],
          [73.447082519531534, 16.224582672119197],
          [73.447082519531534, 16.22430610656744],
          [73.446533203124943, 16.224309921264762],
          [73.446533203124943, 16.223749160766658],
          [73.446250915527401, 16.223749160766658],
          [73.446250915527401, 16.222919464111442],
          [73.445968627929631, 16.222919464111442],
          [73.445968627929631, 16.222360610961914],
          [73.445686340332259, 16.222360610961914],
          [73.445686340332259, 16.221250534057731],
          [73.445419311523608, 16.221250534057731],
          [73.445419311523608, 16.219860076904411],
          [73.44569396972679, 16.219861984252987],
          [73.44569396972679, 16.219583511352596],
          [73.445419311523608, 16.219583511352596],
          [73.445419311523608, 16.219028472900447],
          [73.445137023925838, 16.219030380249023],
          [73.445137023925838, 16.21846961975109],
          [73.444862365722827, 16.218471527099666],
          [73.444862365722827, 16.217916488647518],
          [73.445137023925838, 16.21792030334484],
          [73.445137023925838, 16.217639923095703],
          [73.444580078125284, 16.217639923095703],
          [73.444580078125284, 16.216810226440487],
          [73.444313049316406, 16.216810226440487],
          [73.444313049316406, 16.215972900390568],
          [73.444030761719034, 16.215974807739371],
          [73.444030761719034, 16.215694427490178],
          [73.443748474121151, 16.215694427490178],
          [73.443748474121151, 16.2151393890382],
          [73.443466186523551, 16.21515083312994],
          [73.443466186523551, 16.211530685424918],
          [73.443191528320369, 16.211530685424918],
          [73.443191528320369, 16.210969924926815],
          [73.442916870117131, 16.210971832275391],
          [73.442916870117131, 16.210695266723576],
          [73.44264221191429, 16.210699081420955],
          [73.44264221191429, 16.210420608520565],
          [73.442359924316577, 16.210420608520565],
          [73.442359924316577, 16.210138320922852],
          [73.442092895508097, 16.210138320922852],
          [73.442092895508097, 16.209859848022461],
          [73.441253662109375, 16.209861755371207],
          [73.441253662109375, 16.209583282470646],
          [73.440971374512003, 16.209583282470646],
          [73.440971374512003, 16.209304809570256],
          [73.440696716308651, 16.209304809570256],
          [73.440696716308651, 16.209026336669865],
          [73.440414428711051, 16.209026336669865],
          [73.440414428711051, 16.208749771118278],
          [73.440139770507869, 16.208749771118278],
          [73.440139770507869, 16.208471298217887],
          [73.439857482910099, 16.208471298217887],
          [73.439857482910099, 16.208194732666072],
          [73.439582824707259, 16.208194732666072],
          [73.439582824707259, 16.207639694213924],
          [73.439308166504077, 16.207639694213924],
          [73.439308166504077, 16.207080841064567],
          [73.439025878906307, 16.207082748413143],
          [73.439025878906307, 16.206527709960994],
          [73.438735961914233, 16.20652961730957],
          [73.438735961914233, 16.20625114440918],
          [73.438468933105753, 16.20625114440918],
          [73.438468933105753, 16.205961227417106],
          [73.438194274902344, 16.205972671508789],
          [73.438194274902344, 16.205694198608398],
          [73.437637329101563, 16.205694198608398],
          [73.437637329101563, 16.205417633056641],
          [73.437362670898551, 16.205419540405387],
          [73.437362670898551, 16.205141067504996],
          [73.437080383300838, 16.205141067504996],
          [73.437080383300838, 16.204580307006893],
          [73.436805725097599, 16.204584121704045],
          [73.436805725097599, 16.203750610351676],
          [73.436531066894759, 16.203750610351676],
          [73.436531066894759, 16.203189849853572],
          [73.436248779297046, 16.203193664550724],
          [73.436248779297046, 16.202917098999137],
          [73.435966491699446, 16.202920913696289],
          [73.435966491699446, 16.202640533447322],
          [73.435699462890796, 16.202640533447322],
          [73.435699462890796, 16.202360153198356],
          [73.435417175293253, 16.202362060546932],
          [73.435417175293253, 16.202083587646541],
          [73.434860229492472, 16.202083587646541],
          [73.434860229492472, 16.201805114746151],
          [73.43430328369169, 16.201810836791935],
          [73.43430328369169, 16.201530456542969],
          [73.434028625488338, 16.201530456542969],
          [73.434028625488338, 16.201250076294002],
          [73.433746337890739, 16.201250076294002],
          [73.433746337890739, 16.200969696045036],
          [73.433471679687557, 16.200969696045036],
          [73.433471679687557, 16.200695037841797],
          [73.432907104492415, 16.200702667236385],
          [73.432907104492415, 16.200149536132756],
          [73.432357788085994, 16.200149536132756],
          [73.432357788085994, 16.199861526489258],
          [73.431808471679972, 16.199861526489258],
          [73.431808471679972, 16.199581146240291],
          [73.431526184082031, 16.199581146240291],
          [73.431526184082031, 16.199306488037109],
          [73.43125152587919, 16.199310302734432],
          [73.43125152587919, 16.199031829834041],
          [73.430969238281307, 16.199031829834041],
          [73.430969238281307, 16.198751449585075],
          [73.430686950683707, 16.198751449585075],
          [73.430686950683707, 16.199031829834041],
          [73.429862976074446, 16.199031829834041],
          [73.429862976074446, 16.199310302734432],
          [73.429580688476733, 16.199306488037109],
          [73.429580688476733, 16.199581146240291],
          [73.429306030273494, 16.199581146240291],
          [73.429306030273494, 16.199861526489258],
          [73.429031372070483, 16.199861526489258],
          [73.429031372070483, 16.200149536132756],
          [73.42874908447294, 16.200149536132756],
          [73.42874908447294, 16.200420379638786],
          [73.428466796875, 16.200420379638786],
          [73.428466796875, 16.200702667236385],
          [73.428192138672159, 16.200695037841797],
          [73.428192138672159, 16.200969696045036],
          [73.427917480468807, 16.200969696045036],
          [73.427917480468807, 16.201530456542969],
          [73.427635192871207, 16.201528549194393],
          [73.427635192871207, 16.202083587646541],
          [73.427360534668026, 16.202079772949219],
          [73.427360534668026, 16.202640533447322],
          [73.427085876464787, 16.202638626098746],
          [73.427085876464787, 16.203193664550724],
          [73.426795959472713, 16.203189849853572],
          [73.426795959472713, 16.204309463501033],
          [73.426528930664233, 16.204309463501033],
          [73.426528930664233, 16.20652961730957],
          [73.426795959472713, 16.20652961730957],
          [73.426795959472713, 16.207361221313533],
          [73.427085876464787, 16.207361221313533],
          [73.427085876464787, 16.207920074462891],
          [73.427360534668026, 16.207916259765739],
          [73.427360534668026, 16.208471298217887],
          [73.427635192871207, 16.208471298217887],
          [73.427635192871207, 16.209304809570256],
          [73.427360534668026, 16.209300994873104],
          [73.427360534668026, 16.210138320922852],
          [73.427085876464787, 16.210138320922852],
          [73.427085876464787, 16.210699081420955],
          [73.426795959472713, 16.210699081420955],
          [73.426795959472713, 16.212358474731559],
          [73.427085876464787, 16.212358474731559],
          [73.427085876464787, 16.212921142578068],
          [73.427360534668026, 16.212921142578068],
          [73.427360534668026, 16.214031219482422],
          [73.427085876464787, 16.214031219482422],
          [73.427085876464787, 16.214862823486385],
          [73.426795959472713, 16.214862823486385],
          [73.426795959472713, 16.215419769287166],
          [73.426246643066463, 16.215415954589787],
          [73.426246643066463, 16.215694427490178],
          [73.425971984863452, 16.215694427490178],
          [73.425971984863452, 16.215974807739371],
          [73.42569732666044, 16.215972900390568],
          [73.42569732666044, 16.216249465942383],
          [73.425422668457031, 16.216249465942383],
          [73.425422668457031, 16.21652984619152],
          [73.425140380859659, 16.216527938842773],
          [73.425140380859659, 16.217084884643498],
          [73.424858093261719, 16.217084884643498],
          [73.424858093261719, 16.217361450195313],
          [73.424583435058707, 16.217361450195313],
          [73.424583435058707, 16.219861984252987],
          [73.424858093261719, 16.219860076904411],
          [73.424858093261719, 16.224027633667049],
          [73.424575805664347, 16.224027633667049],
          [73.424575805664347, 16.225141525268555],
          [73.424308776855526, 16.225141525268555],
          [73.424308776855526, 16.226251602172908],
          [73.424026489257756, 16.226251602172908],
          [73.424026489257756, 16.227361679077262],
          [73.423751831054915, 16.227361679077262],
          [73.423751831054915, 16.228473663330021],
          [73.423469543457202, 16.228473663330021],
          [73.423469543457202, 16.229583740234375],
          [73.423194885253963, 16.229583740234375],
          [73.423194885253963, 16.230693817138729],
          [73.422920227050952, 16.230690002441406],
          [73.422920227050952, 16.231809616088867],
          [73.422637939453409, 16.231809616088867],
          [73.422637939453409, 16.23264122009283],
          [73.42236328125, 16.232639312744254],
          [73.42236328125, 16.233194351196232],
          [73.422080993652628, 16.23319053649908],
          [73.422080993652628, 16.233749389648438],
          [73.421806335449219, 16.233749389648438],
          [73.421806335449219, 16.234310150146541],
          [73.421524047851847, 16.234306335449219],
          [73.421524047851847, 16.234861373901367],
          [73.421249389648494, 16.234859466552791],
          [73.421249389648494, 16.235420227050895],
          [73.420967102050895, 16.235420227050895],
          [73.420967102050895, 16.236530303955078],
          [73.420700073242415, 16.236530303955078],
          [73.420700073242415, 16.237638473510856],
          [73.420417785644702, 16.237638473510856],
          [73.420417785644702, 16.240419387817496],
          [73.420143127441463, 16.240419387817496],
          [73.420143127441463, 16.24152946472168],
          [73.419860839843921, 16.24152946472168],
          [73.419860839843921, 16.244029998779354],
          [73.419586181640909, 16.244028091430778],
          [73.419586181640909, 16.244304656982365],
          [73.419303894043139, 16.244304656982365],
          [73.419303894043139, 16.244583129882756],
          [73.418472290039347, 16.244583129882756],
          [73.418472290039347, 16.244861602783317],
          [73.417915344238395, 16.244861602783317],
          [73.417915344238395, 16.245138168334961],
          [73.417358398437443, 16.24513053894043],
          [73.417358398437443, 16.245420455932674],
          [73.417076110840071, 16.245420455932674],
          [73.417076110840071, 16.245700836181641],
          [73.416809082031421, 16.245700836181641],
          [73.416809082031421, 16.246810913085994],
          [73.416526794433651, 16.246810913085994],
          [73.416526794433651, 16.247360229492244],
          [73.416252136230639, 16.247360229492244],
          [73.416252136230639, 16.250419616699276],
          [73.416526794433651, 16.250419616699276],
          [73.416526794433651, 16.251262664794979],
          [73.416252136230639, 16.251247406005916],
          [73.416252136230639, 16.252082824707031],
          [73.415695190429687, 16.252082824707031],
          [73.415702819824219, 16.253751754760742],
          [73.415412902832315, 16.253751754760742],
          [73.415412902832315, 16.254583358764705],
          [73.415138244628963, 16.254579544067383],
          [73.415138244628963, 16.256530761718807],
          [73.414855957031364, 16.256530761718807],
          [73.414855957031364, 16.257640838623161],
          [73.414581298828182, 16.257638931274414],
          [73.414581298828182, 16.258195877075195],
          [73.414306640624943, 16.258190155029411],
          [73.414306640624943, 16.258750915527344],
          [73.414016723632869, 16.258750915527344],
          [73.414016723632869, 16.260139465332088],
          [73.413749694824389, 16.260139465332088],
          [73.413749694824389, 16.260972976684627],
          [73.413475036621151, 16.260972976684627],
          [73.413475036621151, 16.263471603393555],
          [73.413192749023608, 16.263469696044979],
          [73.413192749023608, 16.265420913696232],
          [73.412918090820597, 16.26541709899908],
          [73.412918090820597, 16.265970230102653],
          [73.412635803222656, 16.265968322753906],
          [73.412635803222656, 16.266809463500977],
          [73.412361145019815, 16.266809463500977],
          [73.412361145019815, 16.267362594604549],
          [73.412086486816463, 16.267362594604549],
          [73.412086486816463, 16.269029617309684],
          [73.411796569824503, 16.269029617309684],
          [73.411796569824503, 16.270420074463004],
          [73.411529541015682, 16.270420074463004],
          [73.411529541015682, 16.271530151367188],
          [73.411247253417912, 16.271528244018612],
          [73.411247253417912, 16.273471832275504],
          [73.410972595215071, 16.273469924926758],
          [73.410972595215071, 16.274860382080078],
          [73.411247253417912, 16.274860382080078],
          [73.411247253417912, 16.275140762329215],
          [73.411529541015682, 16.275140762329215],
          [73.411529541015682, 16.275430679321346],
          [73.411796569824503, 16.275430679321346],
          [73.411796569824503, 16.276250839233398],
          [73.412086486816463, 16.276250839233398],
          [73.412086486816463, 16.277082443237362],
          [73.412361145019815, 16.277080535888786],
          [73.412361145019815, 16.277919769287109],
          [73.412635803222656, 16.277919769287109],
          [73.412635803222656, 16.278200149536076],
          [73.412918090820597, 16.278194427490291],
          [73.412918090820597, 16.278472900390682],
          [73.413192749023608, 16.278469085693359],
          [73.413192749023608, 16.278751373291072],
          [73.413482666015909, 16.278751373291072],
          [73.413482666015909, 16.27931022644043],
          [73.413749694824389, 16.27931022644043],
          [73.413749694824389, 16.280141830444393],
          [73.414016723632869, 16.280141830444393],
          [73.414016723632869, 16.28070068359375],
          [73.414306640624943, 16.28070068359375],
          [73.414306640624943, 16.28264045715332],
          [73.414566040039119, 16.28264045715332],
          [73.414566040039119, 16.282920837402287],
          [73.414863586425895, 16.282917022705135],
          [73.414863586425895, 16.283193588256893],
          [73.417915344238395, 16.283193588256893],
          [73.417915344238395, 16.282917022705135],
          [73.418746948242188, 16.282917022705135],
          [73.418746948242188, 16.283193588256893],
          [73.419029235840128, 16.283193588256893],
          [73.419029235840128, 16.283472061157283],
          [73.419296264648608, 16.283470153808707],
          [73.419296264648608, 16.283750534057674],
          [73.420852661132813, 16.283750534057674],
          [73.421516418457315, 16.283750534057674],
          [73.421516418457315, 16.284030914306641],
          [73.42236328125, 16.284030914306641],
          [73.42236328125, 16.283750534057674],
          [73.422637939453409, 16.283750534057674],
          [73.422637939453409, 16.283470153808707],
          [73.422920227050952, 16.283472061157283],
          [73.422920227050952, 16.283193588256893],
          [73.424026489257756, 16.283193588256893],
          [73.424026489257756, 16.282917022705135],
          [73.424308776855526, 16.282917022705135],
          [73.424308776855526, 16.283193588256893],
          [73.427085876464787, 16.283193588256893],
          [73.427085876464787, 16.283472061157283],
          [73.42874908447294, 16.283472061157283],
          [73.42874908447294, 16.283193588256893],
          [73.429862976074446, 16.283193588256893],
          [73.429862976074446, 16.283472061157283],
          [73.430969238281307, 16.283470153808707],
          [73.430969238281307, 16.283750534057674],
          [73.433471679687557, 16.283750534057674],
          [73.433471679687557, 16.284030914306641],
          [73.43430328369169, 16.284027099609489],
          [73.43430328369169, 16.284585952758846],
          [73.434593200683651, 16.284580230712891],
          [73.434593200683651, 16.285140991210994],
          [73.434860229492472, 16.285140991210994],
          [73.434860229492472, 16.285419464111385],
          [73.435142517089844, 16.285417556762809],
          [73.435142517089844, 16.285694122314396],
          [73.435417175293253, 16.285694122314396],
          [73.435417175293253, 16.285972595214787],
          [73.435699462890796, 16.285970687866211],
          [73.435699462890796, 16.286529541015739],
          [73.435417175293253, 16.286529541015739],
          [73.435417175293253, 16.286809921264705],
          [73.435142517089844, 16.286809921264705],
          [73.435142517089844, 16.286529541015739],
          [73.434593200683651, 16.286529541015739],
          [73.434593200683651, 16.286251068115348],
          [73.43430328369169, 16.286251068115348],
          [73.43430328369169, 16.285970687866211],
          [73.434028625488338, 16.285972595214787],
          [73.434028625488338, 16.285694122314396],
          [73.433746337890739, 16.285694122314396],
          [73.433746337890739, 16.285417556762809],
          [73.433471679687557, 16.285419464111385],
          [73.433471679687557, 16.285140991210994],
          [73.433197021484546, 16.285140991210994],
          [73.433197021484546, 16.284860610962028],
          [73.432907104492415, 16.284860610962028],
          [73.432907104492415, 16.284580230712891],
          [73.432083129882983, 16.284585952758846],
          [73.432083129882983, 16.284305572509879],
          [73.430969238281307, 16.284305572509879],
          [73.430969238281307, 16.284585952758846],
          [73.429306030273494, 16.284580230712891],
          [73.429306030273494, 16.284860610962028],
          [73.428466796875, 16.284860610962028],
          [73.428466796875, 16.284580230712891],
          [73.427360534668026, 16.284580230712891],
          [73.427360534668026, 16.284860610962028],
          [73.4254150390625, 16.284860610962028],
          [73.4254150390625, 16.284585952758846],
          [73.425140380859659, 16.284585952758846],
          [73.425140380859659, 16.284305572509879],
          [73.42236328125, 16.284305572509879],
          [73.42236328125, 16.284585952758846],
          [73.422080993652628, 16.284580230712891],
          [73.422080993652628, 16.284860610962028],
          [73.421806335449219, 16.284860610962028],
          [73.421806335449219, 16.285140991210994],
          [73.421249389648494, 16.285140991210994],
          [73.421249389648494, 16.285419464111385],
          [73.420417785644702, 16.285417556762809],
          [73.420417785644702, 16.285694122314396],
          [73.420036315918139, 16.285694122314396],
          [73.419860839843921, 16.285694122314396],
          [73.419860839843921, 16.285972595214787],
          [73.419303894043139, 16.285972595214787],
          [73.419303894043139, 16.285694122314396],
          [73.417083740234602, 16.285694122314396],
          [73.417083740234602, 16.285972595214787],
          [73.416809082031421, 16.285970687866211],
          [73.416809082031421, 16.286251068115348],
          [73.416526794433651, 16.286251068115348],
          [73.416526794433651, 16.286529541015739],
          [73.416252136230639, 16.286529541015739],
          [73.416252136230639, 16.286809921264705],
          [73.415969848633097, 16.286809921264705],
          [73.415969848633097, 16.287370681762638],
          [73.416252136230639, 16.287370681762638],
          [73.416252136230639, 16.287639617919922],
          [73.416526794433651, 16.287639617919922],
          [73.416526794433651, 16.287919998169059],
          [73.417915344238395, 16.287916183471737],
          [73.417915344238395, 16.288473129272461],
          [73.418197631835994, 16.288473129272461],
          [73.418197631835994, 16.289304733276424],
          [73.417915344238395, 16.289304733276424],
          [73.417915344238395, 16.289861679077205],
          [73.417640686035213, 16.289861679077205],
          [73.417640686035213, 16.290971755981559],
          [73.417915344238395, 16.290971755981559],
          [73.417915344238395, 16.292083740234318],
          [73.417358398437443, 16.292083740234318],
          [73.417358398437443, 16.292190551757869],
          [73.417358398437443, 16.292358398437557],
          [73.416809082031421, 16.292358398437557],
          [73.416809082031421, 16.291809082031307],
          [73.416526794433651, 16.291809082031307],
          [73.416526794433651, 16.291248321533203],
          [73.416252136230639, 16.291248321533203],
          [73.416252136230639, 16.290700912475529],
          [73.415969848633097, 16.290700912475529],
          [73.415969848633097, 16.289859771728629],
          [73.415695190429687, 16.289861679077205],
          [73.415695190429687, 16.289304733276424],
          [73.415412902832315, 16.289304733276424],
          [73.415412902832315, 16.288749694824276],
          [73.415138244628963, 16.288749694824276],
          [73.415138244628963, 16.287919998169059],
          [73.414855957031364, 16.287919998169059],
          [73.414855957031364, 16.287370681762638],
          [73.414306640624943, 16.287370681762638],
          [73.414306640624943, 16.287080764770565],
          [73.413749694824389, 16.287082672119141],
          [73.413749694824389, 16.28680419921875],
          [73.413482666015909, 16.286809921264705],
          [73.413482666015909, 16.286529541015739],
          [73.412918090820597, 16.286529541015739],
          [73.412918090820597, 16.286251068115348],
          [73.412635803222656, 16.286251068115348],
          [73.412635803222656, 16.285970687866211],
          [73.412361145019815, 16.285972595214787],
          [73.412361145019815, 16.285417556762809],
          [73.411796569824503, 16.285419464111385],
          [73.411796569824503, 16.285140991210994],
          [73.410972595215071, 16.285140991210994],
          [73.410972595215071, 16.284299850463924],
          [73.410697937011889, 16.284305572509879],
          [73.410697937011889, 16.281805038452148],
          [73.410972595215071, 16.281810760498104],
          [73.410972595215071, 16.28123855590826],
          [73.411247253417912, 16.281251907348576],
          [73.411247253417912, 16.280969619751033],
          [73.411529541015682, 16.280969619751033],
          [73.411529541015682, 16.280416488647461],
          [73.411796569824503, 16.280420303344783],
          [73.411796569824503, 16.280141830444393],
          [73.412086486816463, 16.280141830444393],
          [73.412086486816463, 16.27931022644043],
          [73.411796569824503, 16.27931022644043],
          [73.411796569824503, 16.278751373291072],
          [73.411529541015682, 16.278751373291072],
          [73.411529541015682, 16.278469085693359],
          [73.411247253417912, 16.278472900390682],
          [73.411247253417912, 16.278194427490291],
          [73.410972595215071, 16.278200149536076],
          [73.410972595215071, 16.277919769287109],
          [73.410423278808651, 16.277919769287109],
          [73.410423278808651, 16.27931022644043],
          [73.410140991211108, 16.279306411743278],
          [73.410140991211108, 16.279581069946289],
          [73.409858703613565, 16.279579162597713],
          [73.409858703613565, 16.280141830444393],
          [73.409576416015796, 16.280141830444393],
          [73.409576416015796, 16.28070068359375],
          [73.409309387207315, 16.280694961547795],
          [73.409301757812784, 16.282083511352539],
          [73.409027099609375, 16.282079696655387],
          [73.409027099609375, 16.283750534057674],
          [73.408752441406364, 16.283750534057674],
          [73.408760070800895, 16.284860610962028],
          [73.408470153808651, 16.284860610962028],
          [73.408470153808651, 16.285694122314396],
          [73.408203124999943, 16.285690307617244],
          [73.408203124999943, 16.286809921264705],
          [73.407913208007869, 16.286809921264705],
          [73.407913208007869, 16.287639617919922],
          [73.407638549804858, 16.287639617919922],
          [73.407638549804858, 16.288749694824276],
          [73.407363891601619, 16.288749694824276],
          [73.407363891601619, 16.289861679077205],
          [73.407081604004077, 16.289859771728629],
          [73.407081604004077, 16.290700912475529],
          [73.406806945801065, 16.290695190429801],
          [73.406806945801065, 16.292083740234318],
          [73.406517028808764, 16.292079925537166],
          [73.406517028808764, 16.292919158935661],
          [73.406250000000284, 16.292919158935661],
          [73.406250000000284, 16.29403114318842],
          [73.405982971191463, 16.29403114318842],
          [73.405982971191463, 16.295141220092773],
          [73.405693054199503, 16.295139312744197],
          [73.405693054199503, 16.296249389648551],
          [73.405418395996151, 16.296249389648551],
          [73.405418395996151, 16.297084808349723],
          [73.405136108398551, 16.297084808349723],
          [73.405136108398551, 16.297361373901481],
          [73.404861450195369, 16.297359466552734],
          [73.404861450195369, 16.297639846801871],
          [73.404586791992358, 16.297639846801871],
          [73.404586791992358, 16.297920227050838],
          [73.404296875000227, 16.297920227050838],
          [73.404296875000227, 16.299030303955192],
          [73.404029846191577, 16.299030303955192],
          [73.404029846191577, 16.299310684204158],
          [73.403747558593807, 16.299306869506836],
          [73.403747558593807, 16.299583435058594],
          [73.401802062988338, 16.299583435058594],
          [73.401802062988338, 16.299306869506836],
          [73.401252746582259, 16.299306869506836],
          [73.401252746582259, 16.299583435058594],
          [73.400413513183764, 16.299583435058594],
          [73.400413513183764, 16.299861907958984],
          [73.400138854980753, 16.299860000610408],
          [73.400138854980753, 16.300420761108342],
          [73.399864196777344, 16.30041694641119],
          [73.399856567382812, 16.300689697265625],
          [73.399581909179972, 16.30069541931158],
          [73.399581909179972, 16.300971984863338],
          [73.399307250976619, 16.300970077514762],
          [73.399307250976619, 16.301530838012695],
          [73.399017333984659, 16.301530838012695],
          [73.399017333984659, 16.304027557373047],
          [73.398750305175838, 16.304027557373047],
          [73.398750305175838, 16.305141448974553],
          [73.398475646972599, 16.305141448974553],
          [73.398475646972599, 16.305694580078125],
          [73.398193359375227, 16.305690765380973],
          [73.398193359375227, 16.308202743530387],
          [73.397918701172046, 16.308202743530387],
          [73.397918701172046, 16.308750152588004],
          [73.397636413574276, 16.308750152588004],
          [73.397636413574276, 16.309030532836971],
          [73.397361755371264, 16.309030532836971],
          [73.397361755371264, 16.309310913085937],
          [73.397087097168253, 16.309305191039982],
          [73.397087097168253, 16.309583663940373],
          [73.396797180175952, 16.309579849243221],
          [73.396797180175952, 16.309860229492187],
          [73.396247863769531, 16.309860229492187],
          [73.396247863769531, 16.310140609741325],
          [73.39597320556652, 16.310140609741325],
          [73.39597320556652, 16.310420989990291],
          [73.395690917968807, 16.310417175292969],
          [73.395690917968807, 16.310693740844727],
          [73.395416259765568, 16.310693740844727],
          [73.395416259765568, 16.312084197998047],
          [73.395141601562727, 16.312080383300895],
          [73.395141601562727, 16.312641143798828],
          [73.394859313965014, 16.312639236450252],
          [73.394859313965014, 16.313194274902401],
          [73.394584655761776, 16.313194274902401],
          [73.394584655761776, 16.313472747802791],
          [73.394302368164233, 16.313470840454215],
          [73.394302368164233, 16.314310073852539],
          [73.394027709961222, 16.314306259155387],
          [73.394027709961222, 16.314582824706974],
          [73.393753051757812, 16.314582824706974],
          [73.393753051757812, 16.317361831665039],
          [73.394027709961222, 16.317350387573356],
          [73.394027709961222, 16.317638397216854],
          [73.394302368164233, 16.317638397216854],
          [73.394302368164233, 16.317920684814396],
          [73.395416259765568, 16.317920684814396],
          [73.395416259765568, 16.318199157714957],
          [73.395690917968807, 16.318195343017635],
          [73.395690917968807, 16.318471908569393],
          [73.39597320556652, 16.31846809387207],
          [73.39597320556652, 16.319862365722713],
          [73.396247863769531, 16.319862365722713],
          [73.396247863769531, 16.322080612182674],
          [73.39597320556652, 16.322080612182674],
          [73.39597320556652, 16.322919845581168],
          [73.395690917968807, 16.322919845581168],
          [73.395690917968807, 16.323749542236385],
          [73.395416259765568, 16.323749542236385],
          [73.395416259765568, 16.324310302734318],
          [73.395141601562727, 16.324310302734318],
          [73.395141601562727, 16.325139999389705],
          [73.394859313965014, 16.325139999389705],
          [73.394859313965014, 16.325420379638672],
          [73.394577026367415, 16.325420379638672],
          [73.394577026367415, 16.326250076294059],
          [73.394302368164233, 16.326250076294059],
          [73.394302368164233, 16.326810836791992],
          [73.394584655761776, 16.326805114746037],
          [73.394584655761776, 16.328472137451172],
          [73.394859313965014, 16.328470230102596],
          [73.394859313965014, 16.329030990600529],
          [73.395141601562727, 16.329030990600529],
          [73.395141601562727, 16.32930946350109],
          [73.395690917968807, 16.329305648803768],
          [73.395690917968807, 16.330972671508846],
          [73.395416259765568, 16.33097076416027],
          [73.395416259765568, 16.33181190490717],
          [73.395141601562727, 16.331806182861442],
          [73.395141601562727, 16.332082748413029],
          [73.394859313965014, 16.332082748413029],
          [73.394859313965014, 16.332359313964844],
          [73.394577026367415, 16.33234977722168],
          [73.394577026367415, 16.332641601562557],
          [73.394302368164233, 16.332641601562557],
          [73.394302368164233, 16.33234977722168],
          [73.393196105957031, 16.33234977722168],
          [73.393196105957031, 16.332641601562557],
          [73.392639160156307, 16.332641601562557],
          [73.392639160156307, 16.332920074462947],
          [73.392364501953068, 16.332916259765625],
          [73.392364501953068, 16.333194732665959],
          [73.391807556152514, 16.333194732665959],
          [73.391807556152514, 16.333469390869197],
          [73.390975952148722, 16.333469390869197],
          [73.390975952148722, 16.33375167846674],
          [73.39041900634794, 16.33375167846674],
          [73.39041900634794, 16.334030151367301],
          [73.39013671875, 16.334028244018555],
          [73.39013671875, 16.334304809570312],
          [73.389305114746207, 16.334304809570312],
          [73.389305114746207, 16.334583282470703],
          [73.389030456543026, 16.334583282470703],
          [73.389030456543026, 16.33486366271967],
          [73.388191223144702, 16.334861755371094],
          [73.388191223144702, 16.335140228271484],
          [73.387359619140909, 16.335140228271484],
          [73.387359619140909, 16.335420608520451],
          [73.387077331542969, 16.335420608520451],
          [73.387077331542969, 16.335702896118221],
          [73.386802673340128, 16.33569526672369],
          [73.386802673340128, 16.335973739624023],
          [73.386253356933707, 16.335971832275447],
          [73.386253356933707, 16.336250305175838],
          [73.385696411132756, 16.336250305175838],
          [73.385696411132756, 16.336530685424805],
          [73.385406494140682, 16.336530685424805],
          [73.385406494140682, 16.337360382080192],
          [73.385696411132756, 16.337360382080192],
          [73.385696411132756, 16.337640762329158],
          [73.385971069335994, 16.337638854980582],
          [73.385971069335994, 16.338195800781364],
          [73.386253356933707, 16.338190078735408],
          [73.386253356933707, 16.338479995727482],
          [73.386528015136776, 16.338479995727482],
          [73.386528015136776, 16.338750839233512],
          [73.386802673340128, 16.338750839233512],
          [73.386802673340128, 16.339031219482479],
          [73.3870849609375, 16.339027404785156],
          [73.3870849609375, 16.339582443237305],
          [73.387359619140909, 16.339582443237305],
          [73.387359619140909, 16.342361450195369],
          [73.387649536132812, 16.342359542846793],
          [73.387649536132812, 16.343200683593693],
          [73.387916564941463, 16.343200683593693],
          [73.387916564941463, 16.34403038024908],
          [73.388191223144702, 16.34403038024908],
          [73.388191223144702, 16.344583511352482],
          [73.388473510742415, 16.344583511352482],
          [73.388473510742415, 16.344860076904297],
          [73.388748168945256, 16.344858169555721],
          [73.388748168945256, 16.345420837402401],
          [73.389305114746207, 16.345418930053825],
          [73.389305114746207, 16.345693588256836],
          [73.389579772949276, 16.345693588256836],
          [73.389579772949276, 16.345970153808651],
          [73.389862060547159, 16.345968246460075],
          [73.389862060547159, 16.346248626709041],
          [73.39013671875, 16.346248626709041],
          [73.39013671875, 16.346532821655387],
          [73.39041900634794, 16.346532821655387],
          [73.39041900634794, 16.347642898559513],
          [73.39013671875, 16.347642898559513],
          [73.39013671875, 16.347919464111328],
          [73.389862060547159, 16.347917556762752],
          [73.389862060547159, 16.348472595214901],
          [73.389579772949276, 16.348472595214901],
          [73.389579772949276, 16.348751068115291],
          [73.389312744140568, 16.348751068115291],
          [73.389312744140568, 16.349029541015682],
          [73.389030456543026, 16.349027633667106],
          [73.389030456543026, 16.350694656372013],
          [73.388748168945256, 16.350694656372013],
          [73.388748168945256, 16.352083206176758],
          [73.388465881347884, 16.352079391479606],
          [73.388465881347884, 16.352920532226506],
          [73.388191223144702, 16.352920532226506],
          [73.388191223144702, 16.354030609130859],
          [73.387916564941463, 16.354030609130859],
          [73.387916564941463, 16.354860305786246],
          [73.387641906738452, 16.354860305786246],
          [73.387641906738452, 16.355972290039006],
          [73.387359619140909, 16.35597038269043],
          [73.387359619140909, 16.35736083984375],
          [73.387077331542969, 16.35736083984375],
          [73.387077331542969, 16.357919692993278],
          [73.387359619140909, 16.357915878295955],
          [73.387359619140909, 16.358539581298942],
          [73.387359619140909, 16.358749389648494],
          [73.387641906738452, 16.358749389648494],
          [73.387641906738452, 16.359859466552848],
          [73.387916564941463, 16.359859466552848],
          [73.387916564941463, 16.360420227050781],
          [73.388191223144702, 16.360416412353629],
          [73.388191223144702, 16.36069488525402],
          [73.388465881347884, 16.360689163208065],
          [73.388465881347884, 16.361251831054744],
          [73.388748168945256, 16.361251831054744],
          [73.388748168945256, 16.361530303955135],
          [73.389030456543026, 16.361530303955135],
          [73.389030456543026, 16.361810684204102],
          [73.389305114746207, 16.361804962158146],
          [73.389305114746207, 16.362083435058537],
          [73.389579772949276, 16.362083435058537],
          [73.389579772949276, 16.361804962158146],
          [73.389862060547159, 16.361810684204102],
          [73.389862060547159, 16.361530303955135],
          [73.39041900634794, 16.361530303955135],
          [73.39041900634794, 16.360420227050781],
          [73.390686035156421, 16.360420227050781],
          [73.390686035156421, 16.359579086303711],
          [73.390975952148722, 16.359582901001033],
          [73.390975952148722, 16.359306335449276],
          [73.391250610351733, 16.359310150146428],
          [73.391250610351733, 16.358749389648494],
          [73.391532897949276, 16.358749389648494],
          [73.391525268554915, 16.358194351196289],
          [73.391807556152514, 16.358194351196289],
          [73.391807556152514, 16.357915878295955],
          [73.392082214355526, 16.357919692993278],
          [73.392082214355526, 16.357080459594783],
          [73.392364501953068, 16.357082366943359],
          [73.392364501953068, 16.356527328491211],
          [73.392639160156307, 16.356527328491211],
          [73.392639160156307, 16.356250762939567],
          [73.392906188965128, 16.356250762939567],
          [73.392906188965128, 16.35597038269043],
          [73.393196105957031, 16.355972290039006],
          [73.393196105957031, 16.355810165405273],
          [73.393196105957031, 16.355693817138615],
          [73.39347076416044, 16.355693817138615],
          [73.39347076416044, 16.355417251587028],
          [73.393753051757812, 16.35542106628418],
          [73.393753051757812, 16.355140686035213],
          [73.394302368164233, 16.355140686035213],
          [73.394302368164233, 16.354860305786246],
          [73.397361755371264, 16.354860305786246],
          [73.397361755371264, 16.355140686035213],
          [73.397918701172046, 16.355140686035213],
          [73.397918701172046, 16.35542106628418],
          [73.398475646972599, 16.355417251587028],
          [73.398475646972599, 16.355693817138615],
          [73.39902496337902, 16.355693817138615],
          [73.39902496337902, 16.355972290039006],
          [73.399581909179972, 16.355972290039006],
          [73.399581909179972, 16.356250762939567],
          [73.402359008789119, 16.356250762939567],
          [73.402359008789119, 16.35597038269043],
          [73.404029846191577, 16.35597038269043],
          [73.404029846191577, 16.356250762939567],
          [73.404586791992358, 16.356250762939567],
          [73.404586791992358, 16.356527328491211],
          [73.405693054199503, 16.356527328491211],
          [73.405693054199503, 16.357082366943359],
          [73.406517028808764, 16.357080459594783],
          [73.406517028808764, 16.35736083984375],
          [73.407356262207259, 16.35736083984375],
          [73.407356262207259, 16.357641220092717],
          [73.408203124999943, 16.357641220092717],
          [73.408203124999943, 16.357919692993278],
          [73.409301757812784, 16.357915878295955],
          [73.409301757812784, 16.358055114746207],
          [73.409309387207315, 16.358194351196289],
          [73.410415649414119, 16.358194351196289],
          [73.410415649414119, 16.35847282409668],
          [73.410697937011889, 16.358470916748104],
          [73.410697937011889, 16.358749389648494],
          [73.410972595215071, 16.358749389648494],
          [73.410972595215071, 16.359031677246037],
          [73.411247253417912, 16.359029769897461],
          [73.411247253417912, 16.359210968017635],
          [73.411247253417912, 16.359306335449276],
          [73.411529541015682, 16.359306335449276],
          [73.411529541015682, 16.359859466552848],
          [73.411796569824503, 16.359859466552848],
          [73.411796569824503, 16.360420227050781],
          [73.411529541015682, 16.360416412353629],
          [73.411529541015682, 16.36069488525402],
          [73.411247253417912, 16.36069488525402],
          [73.411247253417912, 16.362083435058537],
          [73.410697937011889, 16.362083435058537],
          [73.410697937011889, 16.361804962158146],
          [73.410140991211108, 16.361810684204102],
          [73.410140991211108, 16.361530303955135],
          [73.409858703613565, 16.361530303955135],
          [73.409858703613565, 16.361251831054744],
          [73.409576416015796, 16.361251831054744],
          [73.409576416015796, 16.360969543457031],
          [73.409301757812784, 16.360969543457031],
          [73.409301757812784, 16.36069488525402],
          [73.408981323242358, 16.36069488525402],
          [73.408752441406364, 16.36069488525402],
          [73.408752441406364, 16.360416412353629],
          [73.408470153808651, 16.360420227050781],
          [73.408470153808651, 16.360141754150391],
          [73.407913208007869, 16.360141754150391],
          [73.407913208007869, 16.359031677246037],
          [73.407638549804858, 16.359031677246037],
          [73.407638549804858, 16.358190536499137],
          [73.406806945801065, 16.358194351196289],
          [73.406806945801065, 16.357915878295955],
          [73.406250000000284, 16.357915878295955],
          [73.406250000000284, 16.358194351196289],
          [73.405693054199503, 16.358190536499137],
          [73.405693054199503, 16.359031677246037],
          [73.404861450195369, 16.359031677246037],
          [73.404861450195369, 16.359310150146428],
          [73.402641296387003, 16.359306335449276],
          [73.402641296387003, 16.359582901001033],
          [73.399909973144759, 16.359582901001033],
          [73.399307250976619, 16.359582901001033],
          [73.399307250976619, 16.359859466552848],
          [73.398193359375227, 16.359859466552848],
          [73.398193359375227, 16.359582901001033],
          [73.396530151367472, 16.359582901001033],
          [73.396530151367472, 16.359306335449276],
          [73.395416259765568, 16.359310150146428],
          [73.395416259765568, 16.359031677246037],
          [73.395141601562727, 16.359031677246037],
          [73.395141601562727, 16.359310150146428],
          [73.394859313965014, 16.359310150146428],
          [73.394859313965014, 16.359031677246037],
          [73.393753051757812, 16.359031677246037],
          [73.393753051757812, 16.358749389648494],
          [73.393196105957031, 16.358749389648494],
          [73.393196105957031, 16.359031677246037],
          [73.392913818359659, 16.359029769897461],
          [73.392913818359659, 16.359582901001033],
          [73.392639160156307, 16.359579086303711],
          [73.392639160156307, 16.360141754150391],
          [73.392906188965128, 16.360141754150391],
          [73.392906188965128, 16.360420227050781],
          [73.393196105957031, 16.360416412353629],
          [73.393196105957031, 16.36069488525402],
          [73.392913818359659, 16.36069488525402],
          [73.392913818359659, 16.362083435058537],
          [73.392639160156307, 16.362083435058537],
          [73.392639160156307, 16.362363815307731],
          [73.392082214355526, 16.362361907958928],
          [73.392082214355526, 16.363750457763672],
          [73.391807556152514, 16.363750457763672],
          [73.391807556152514, 16.364860534668026],
          [73.391532897949276, 16.364860534668026],
          [73.391532897949276, 16.365419387817383],
          [73.391250610351733, 16.365417480468807],
          [73.391250610351733, 16.365695953369197],
          [73.389862060547159, 16.365695953369197],
          [73.389862060547159, 16.365417480468807],
          [73.389579772949276, 16.365419387817383],
          [73.389579772949276, 16.364860534668026],
          [73.389305114746207, 16.364860534668026],
          [73.389305114746207, 16.364585876464844],
          [73.389030456543026, 16.364585876464844],
          [73.389030456543026, 16.364305496215877],
          [73.388748168945256, 16.364311218261776],
          [73.388748168945256, 16.364030838012638],
          [73.388465881347884, 16.364030838012638],
          [73.388465881347884, 16.363750457763672],
          [73.388191223144702, 16.363750457763672],
          [73.388191223144702, 16.363470077514705],
          [73.387641906738452, 16.363473892211857],
          [73.387641906738452, 16.363195419311523],
          [73.386528015136776, 16.363189697265739],
          [73.386528015136776, 16.36069488525402],
          [73.386253356933707, 16.36069488525402],
          [73.386253356933707, 16.360416412353629],
          [73.385971069335994, 16.360420227050781],
          [73.385971069335994, 16.360141754150391],
          [73.385696411132756, 16.360141754150391],
          [73.385696411132756, 16.359859466552848],
          [73.385414123535384, 16.359859466552848],
          [73.385414123535384, 16.359582901001033],
          [73.384864807128963, 16.359582901001033],
          [73.384864807128963, 16.359306335449276],
          [73.384307861328409, 16.359310150146428],
          [73.384307861328409, 16.359031677246037],
          [73.383750915527628, 16.359031677246037],
          [73.383750915527628, 16.358749389648494],
          [73.383186340332315, 16.358749389648494],
          [73.383186340332315, 16.359031677246037],
          [73.382919311523494, 16.359029769897461],
          [73.382919311523494, 16.359582901001033],
          [73.382637023925724, 16.359582901001033],
          [73.382637023925724, 16.359859466552848],
          [73.382919311523494, 16.359859466552848],
          [73.382919311523494, 16.360141754150391],
          [73.382637023925724, 16.360141754150391],
          [73.382637023925724, 16.36069488525402],
          [73.382362365722884, 16.36069488525402],
          [73.382362365722884, 16.360969543457031],
          [73.382080078125171, 16.360969543457031],
          [73.382080078125171, 16.361251831054744],
          [73.381248474121378, 16.361251831054744],
          [73.381248474121378, 16.361530303955135],
          [73.379028320312671, 16.361530303955135],
          [73.379028320312671, 16.361810684204102],
          [73.378196716308878, 16.361804962158146],
          [73.378196716308878, 16.362083435058537],
          [73.377639770508097, 16.362083435058537],
          [73.377639770508097, 16.362363815307731],
          [73.377357482910156, 16.362363815307731],
          [73.377357482910156, 16.362083435058537],
          [73.377082824707315, 16.362083435058537],
          [73.377082824707315, 16.361804962158146],
          [73.376808166503963, 16.361810684204102],
          [73.376808166503963, 16.361251831054744],
          [73.376525878906364, 16.361251831054744],
          [73.376525878906364, 16.360969543457031],
          [73.376251220703182, 16.360969543457031],
          [73.376251220703182, 16.36069488525402],
          [73.375968933105412, 16.36069488525402],
          [73.375968933105412, 16.360416412353629],
          [73.37568664550804, 16.360420227050781],
          [73.37568664550804, 16.360141754150391],
          [73.375419616699389, 16.360141754150391],
          [73.375419616699389, 16.359859466552848],
          [73.372360229492358, 16.359859466552848],
          [73.372360229492358, 16.360420227050781],
          [73.372085571289119, 16.360416412353629],
          [73.372085571289119, 16.36069488525402],
          [73.371246337890625, 16.36069488525402],
          [73.371246337890625, 16.360969543457031],
          [73.370697021484432, 16.360969543457031],
          [73.370697021484432, 16.361251831054744],
          [73.370407104492472, 16.361251831054744],
          [73.370407104492472, 16.361530303955135],
          [73.370140075683651, 16.361530303955135],
          [73.370140075683651, 16.361810684204102],
          [73.369857788085881, 16.361804962158146],
          [73.369857788085881, 16.362083435058537],
          [73.369308471679858, 16.362083435058537],
          [73.369308471679858, 16.362363815307731],
          [73.368751525879077, 16.362361907958928],
          [73.368751525879077, 16.362649917602653],
          [73.368469238281534, 16.362649917602653],
          [73.368469238281534, 16.362920761108455],
          [73.368194580078125, 16.362916946411133],
          [73.368194580078125, 16.363473892211857],
          [73.367919921875284, 16.363470077514705],
          [73.367919921875284, 16.364860534668026],
          [73.368186950683764, 16.364860534668026],
          [73.368186950683764, 16.365419387817383],
          [73.368469238281534, 16.365417480468807],
          [73.368469238281534, 16.365972518920955],
          [73.368751525879077, 16.365970611572379],
          [73.368751525879077, 16.366809844970703],
          [73.369026184082088, 16.366809844970703],
          [73.369026184082088, 16.3673610687257],
          [73.369308471679858, 16.3673610687257],
          [73.369308471679858, 16.36763954162609],
          [73.36958312988304, 16.36763954162609],
          [73.36958312988304, 16.368194580078068],
          [73.369857788085881, 16.368190765380916],
          [73.369857788085881, 16.368749618530273],
          [73.370140075683651, 16.368749618530273],
          [73.370140075683651, 16.369304656982422],
          [73.370414733886832, 16.369304656982422],
          [73.370414733886832, 16.369861602783203],
          [73.370697021484432, 16.369859695434627],
          [73.370697021484432, 16.37042045593256],
          [73.371246337890625, 16.370416641235408],
          [73.371246337890625, 16.370971679687557],
          [73.371528625488565, 16.370969772338981],
          [73.371528625488565, 16.371248245239371],
          [73.371803283691577, 16.371248245239371],
          [73.371803283691577, 16.371810913085881],
          [73.372085571289119, 16.371805191040153],
          [73.372085571289119, 16.373470306396484],
          [73.371803283691577, 16.373470306396484],
          [73.371803283691577, 16.374031066894588],
          [73.371528625488565, 16.374031066894588],
          [73.371528625488565, 16.374589920043945],
          [73.371246337890625, 16.374589920043945],
          [73.371246337890625, 16.375141143798771],
          [73.370697021484432, 16.375141143798771],
          [73.370697021484432, 16.375419616699332],
          [73.370407104492472, 16.375419616699332],
          [73.370407104492472, 16.375141143798771],
          [73.368751525879077, 16.375141143798771],
          [73.368751525879077, 16.375419616699332],
          [73.368194580078125, 16.37541580200201],
          [73.368194580078125, 16.375694274902344],
          [73.367637634277344, 16.375694274902344],
          [73.367637634277344, 16.375972747802734],
          [73.367362976074332, 16.375972747802734],
          [73.367362976074332, 16.376251220703125],
          [73.367080688476619, 16.376251220703125],
          [73.367080688476619, 16.376810073852482],
          [73.366806030273381, 16.37680625915533],
          [73.366806030273381, 16.377361297607479],
          [73.36653137207054, 16.377361297607479],
          [73.36653137207054, 16.379306793213004],
          [73.366806030273381, 16.379306793213004],
          [73.366806030273381, 16.379583358764592],
          [73.367080688476619, 16.379583358764592],
          [73.367080688476619, 16.379861831664982],
          [73.367637634277344, 16.379859924316406],
          [73.367637634277344, 16.380140304565543],
          [73.368469238281534, 16.380140304565543],
          [73.368469238281534, 16.38042068481451],
          [73.368751525879077, 16.380416870117188],
          [73.368751525879077, 16.380695343017578],
          [73.369026184082088, 16.380689620971793],
          [73.369026184082088, 16.382921218872013],
          [73.369308471679858, 16.382917404174862],
          [73.369308471679858, 16.384582519531193],
          [73.36958312988304, 16.384580612182617],
          [73.36958312988304, 16.385141372680721],
          [73.369857788085881, 16.385141372680721],
          [73.369857788085881, 16.385694503784123],
          [73.370140075683651, 16.385690689086971],
          [73.370140075683651, 16.387920379638615],
          [73.370414733886832, 16.387916564941463],
          [73.370414733886832, 16.388473510742187],
          [73.370697021484432, 16.388469696045036],
          [73.370697021484432, 16.389030456542969],
          [73.370971679687784, 16.389030456542969],
          [73.370971679687784, 16.389591217041129],
          [73.371246337890625, 16.389591217041129],
          [73.371246337890625, 16.389860153198356],
          [73.371803283691577, 16.389860153198356],
          [73.371803283691577, 16.390140533447322],
          [73.372360229492358, 16.390140533447322],
          [73.372360229492358, 16.389860153198356],
          [73.372917175292912, 16.389860153198356],
          [73.372917175292912, 16.389591217041129],
          [73.373466491699332, 16.389591217041129],
          [73.373466491699332, 16.389310836791935],
          [73.374031066894815, 16.389310836791935],
          [73.374031066894815, 16.388750076294002],
          [73.374313354492188, 16.388750076294002],
          [73.374305725097656, 16.387916564941463],
          [73.374580383301065, 16.387920379638615],
          [73.374580383301065, 16.387079238891715],
          [73.374862670898608, 16.387081146240291],
          [73.374862670898608, 16.386251449584904],
          [73.375137329101619, 16.386251449584904],
          [73.375137329101619, 16.385141372680721],
          [73.374862670898608, 16.385141372680721],
          [73.374862670898608, 16.384580612182617],
          [73.374580383301065, 16.384582519531193],
          [73.374580383301065, 16.384027481079215],
          [73.374313354492188, 16.384027481079215],
          [73.374313354492188, 16.38181114196783],
          [73.374031066894815, 16.38181114196783],
          [73.374031066894815, 16.381530761718693],
          [73.373748779296932, 16.381530761718693],
          [73.373748779296932, 16.38097000122076],
          [73.373474121093864, 16.380971908569336],
          [73.373474121093864, 16.380416870117188],
          [73.373191833496151, 16.38042068481451],
          [73.373191833496151, 16.379859924316406],
          [73.372917175292912, 16.379861831664982],
          [73.372917175292912, 16.37680625915533],
          [73.373191833496151, 16.376810073852482],
          [73.373191833496151, 16.376529693603516],
          [73.373466491699332, 16.376529693603516],
          [73.373466491699332, 16.376251220703125],
          [73.373748779296932, 16.376251220703125],
          [73.373748779296932, 16.376529693603516],
          [73.374313354492188, 16.376529693603516],
          [73.374313354492188, 16.376810073852482],
          [73.374580383301065, 16.37680625915533],
          [73.374580383301065, 16.377361297607479],
          [73.374862670898608, 16.377359390258903],
          [73.374862670898608, 16.377920150756836],
          [73.375137329101619, 16.377916336059684],
          [73.375137329101619, 16.378471374511832],
          [73.375419616699389, 16.378469467163086],
          [73.375419616699389, 16.378749847412223],
          [73.37568664550804, 16.378749847412223],
          [73.37568664550804, 16.37903022766119],
          [73.376251220703182, 16.379028320312614],
          [73.376251220703182, 16.379306793213004],
          [73.377357482910156, 16.379306793213004],
          [73.377357482910156, 16.379583358764592],
          [73.377639770508097, 16.379583358764592],
          [73.377639770508097, 16.379861831664982],
          [73.377906799316577, 16.379859924316406],
          [73.377906799316577, 16.38042068481451],
          [73.378196716308878, 16.380416870117188],
          [73.378196716308878, 16.382083892822266],
          [73.378456115722827, 16.382080078125114],
          [73.378456115722827, 16.38236045837408],
          [73.378746032715071, 16.38236045837408],
          [73.378746032715071, 16.384309768676758],
          [73.379028320312671, 16.384309768676758],
          [73.379028320312671, 16.384859085083008],
          [73.379302978515682, 16.384859085083008],
          [73.379302978515682, 16.385141372680721],
          [73.379028320312671, 16.385141372680721],
          [73.379028320312671, 16.387359619140682],
          [73.379302978515682, 16.387359619140682],
          [73.379302978515682, 16.387641906738224],
          [73.379592895507756, 16.387641906738224],
          [73.379592895507756, 16.387920379638615],
          [73.379859924316463, 16.387916564941463],
          [73.379859924316463, 16.388473510742187],
          [73.380416870117187, 16.388469696045036],
          [73.380416870117187, 16.388750076294002],
          [73.380966186523608, 16.388750076294002],
          [73.380966186523608, 16.389030456542969],
          [73.381523132324389, 16.389030456542969],
          [73.381523132324389, 16.389310836791935],
          [73.381813049316463, 16.389310836791935],
          [73.381813049316463, 16.389591217041129],
          [73.382080078125171, 16.389591217041129],
          [73.382080078125171, 16.389860153198356],
          [73.382637023925724, 16.389860153198356],
          [73.382637023925724, 16.390140533447322],
          [73.383186340332315, 16.390140533447322],
          [73.383186340332315, 16.390420913696289],
          [73.384307861328409, 16.390417098999137],
          [73.384307861328409, 16.390693664550724],
          [73.384582519531421, 16.390693664550724],
          [73.384582519531421, 16.390972137451115],
          [73.384864807128963, 16.390972137451115],
          [73.384864807128963, 16.391189575195369],
          [73.384857177734432, 16.391530990600643],
          [73.385139465332202, 16.391530990600643],
          [73.385139465332202, 16.391809463501033],
          [73.385414123535384, 16.391805648803711],
          [73.385414123535384, 16.392084121704045],
          [73.385696411132756, 16.392084121704045],
          [73.385696411132756, 16.39263916015625],
          [73.385971069335994, 16.39263916015625],
          [73.385971069335994, 16.393194198608398],
          [73.386253356933707, 16.393194198608398],
          [73.386253356933707, 16.393472671508789],
          [73.386528015136776, 16.393470764160213],
          [73.386528015136776, 16.39375114440918],
          [73.386802673340128, 16.39375114440918],
          [73.386802673340128, 16.39402961730957],
          [73.387359619140909, 16.39402961730957],
          [73.387359619140909, 16.394309997558537],
          [73.387916564941463, 16.394306182861385],
          [73.387916564941463, 16.394582748413143],
          [73.388191223144702, 16.394580841064567],
          [73.388191223144702, 16.394861221313533],
          [73.388748168945256, 16.394861221313533],
          [73.388748168945256, 16.395139694213924],
          [73.39013671875, 16.395139694213924],
          [73.39013671875, 16.394861221313533],
          [73.390975952148722, 16.394861221313533],
          [73.390975952148722, 16.394580841064567],
          [73.391525268554915, 16.394582748413143],
          [73.391525268554915, 16.394306182861385],
          [73.391807556152514, 16.394309997558537],
          [73.391807556152514, 16.39402961730957],
          [73.392082214355526, 16.39402961730957],
          [73.392082214355526, 16.393470764160213],
          [73.392364501953068, 16.393472671508789],
          [73.392364501953068, 16.392915725708065],
          [73.392639160156307, 16.392919540405387],
          [73.392639160156307, 16.392629623413143],
          [73.392913818359659, 16.39263916015625],
          [73.392913818359659, 16.392084121704045],
          [73.393196105957031, 16.392084121704045],
          [73.393196105957031, 16.391805648803711],
          [73.393463134765909, 16.391809463501033],
          [73.393463134765909, 16.391530990600643],
          [73.393753051757812, 16.391530990600643],
          [73.393753051757812, 16.390970230102539],
          [73.394027709961222, 16.390972137451115],
          [73.394027709961222, 16.390693664550724],
          [73.394302368164233, 16.390693664550724],
          [73.394302368164233, 16.390417098999137],
          [73.394859313965014, 16.390420913696289],
          [73.394859313965014, 16.390140533447322],
          [73.395416259765568, 16.390140533447322],
          [73.395416259765568, 16.389860153198356],
          [73.39597320556652, 16.389860153198356],
          [73.39597320556652, 16.389591217041129],
          [73.396530151367472, 16.389591217041129],
          [73.396530151367472, 16.389310836791935],
          [73.398193359375227, 16.389310836791935],
          [73.398193359375227, 16.389030456542969],
          [73.400138854980753, 16.389030456542969],
          [73.400138854980753, 16.389310836791935],
          [73.400695800781307, 16.389310836791935],
          [73.400695800781307, 16.389591217041129],
          [73.401252746582259, 16.389591217041129],
          [73.401252746582259, 16.389860153198356],
          [73.401527404785099, 16.389860153198356],
          [73.401527404785099, 16.390140533447322],
          [73.401802062988338, 16.390138626098746],
          [73.401802062988338, 16.390693664550724],
          [73.402084350586051, 16.390693664550724],
          [73.402084350586051, 16.390972137451115],
          [73.402359008789119, 16.390970230102539],
          [73.402359008789119, 16.391250610351676],
          [73.40262603759794, 16.391250610351676],
          [73.40262603759794, 16.391530990600643],
          [73.402915954589844, 16.391530990600643],
          [73.402915954589844, 16.392360687255859],
          [73.403198242187784, 16.392360687255859],
          [73.403198242187784, 16.392919540405387],
          [73.403472900390796, 16.392915725708065],
          [73.403472900390796, 16.393194198608398],
          [73.403747558593807, 16.393194198608398],
          [73.403747558593807, 16.393472671508789],
          [73.404029846191577, 16.393470764160213],
          [73.404029846191577, 16.39402961730957],
          [73.404296875000227, 16.39402961730957],
          [73.404296875000227, 16.394309997558537],
          [73.404586791992358, 16.394309997558537],
          [73.404586791992358, 16.394861221313533],
          [73.404861450195369, 16.394861221313533],
          [73.404861450195369, 16.395694732666129],
          [73.405136108398551, 16.395694732666129],
          [73.405136108398551, 16.396804809570256],
          [73.405418395996151, 16.396804809570256],
          [73.405418395996151, 16.399639129638729],
          [73.405418395996151, 16.400970458984489],
          [73.405136108398551, 16.400970458984489],
          [73.405136108398551, 16.402080535888672],
          [73.404861450195369, 16.402080535888672],
          [73.404861450195369, 16.404310226440487],
          [73.405136108398551, 16.404306411743164],
          [73.405136108398551, 16.404584884643555],
          [73.405418395996151, 16.404584884643555],
          [73.405418395996151, 16.404861450195313],
          [73.403472900390796, 16.404861450195313],
          [73.403472900390796, 16.404584884643555],
          [73.403198242187784, 16.404584884643555],
          [73.403190612793253, 16.404306411743164],
          [73.402915954589844, 16.404310226440487],
          [73.402915954589844, 16.40402984619152],
          [73.40262603759794, 16.40402984619152],
          [73.40262603759794, 16.403749465942383],
          [73.402359008789119, 16.403749465942383],
          [73.402359008789119, 16.403472900390568],
          [73.401802062988338, 16.403474807739371],
          [73.401802062988338, 16.403194427490178],
          [73.401252746582259, 16.403194427490178],
          [73.401252746582259, 16.402915954589844],
          [73.400970458984546, 16.402919769287166],
          [73.400970458984546, 16.4026393890382],
          [73.400405883789233, 16.4026393890382],
          [73.400405883789233, 16.402362823486385],
          [73.399856567382812, 16.402362823486385],
          [73.399856567382812, 16.402080535888672],
          [73.399581909179972, 16.402080535888672],
          [73.399581909179972, 16.401805877685661],
          [73.399307250976619, 16.401821136474723],
          [73.399307250976619, 16.401531219482422],
          [73.398483276367358, 16.401531219482422],
          [73.398483276367358, 16.401252746582031],
          [73.397361755371264, 16.401252746582031],
          [73.397361755371264, 16.400970458984489],
          [73.396530151367472, 16.400970458984489],
          [73.396530151367472, 16.400693893432674],
          [73.395416259765568, 16.400693893432674],
          [73.395416259765568, 16.400417327880916],
          [73.395141601562727, 16.400417327880916],
          [73.395141601562727, 16.400693893432674],
          [73.394302368164233, 16.400693893432674],
          [73.394302368164233, 16.400417327880916],
          [73.392913818359659, 16.400417327880916],
          [73.392913818359659, 16.400693893432674],
          [73.390693664550952, 16.400693893432674],
          [73.390693664550952, 16.400970458984489],
          [73.39041900634794, 16.400970458984489],
          [73.39041900634794, 16.401252746582031],
          [73.389862060547159, 16.401252746582031],
          [73.389862060547159, 16.401531219482422],
          [73.389312744140568, 16.401531219482422],
          [73.389312744140568, 16.401821136474723],
          [73.388748168945256, 16.401805877685661],
          [73.388748168945256, 16.402080535888672],
          [73.388191223144702, 16.402080535888672],
          [73.388191223144702, 16.4026393890382],
          [73.387916564941463, 16.4026393890382],
          [73.387916564941463, 16.402919769287166],
          [73.387359619140909, 16.402915954589844],
          [73.387359619140909, 16.403194427490178],
          [73.3870849609375, 16.403194427490178],
          [73.3870849609375, 16.403474807739371],
          [73.386253356933707, 16.403474807739371],
          [73.386253356933707, 16.403194427490178],
          [73.385971069335994, 16.403194427490178],
          [73.385971069335994, 16.4026393890382],
          [73.385696411132756, 16.4026393890382],
          [73.385696411132756, 16.402362823486385],
          [73.385406494140682, 16.402362823486385],
          [73.385406494140682, 16.401252746582031],
          [73.385139465332202, 16.401252746582031],
          [73.385139465332202, 16.400421142578068],
          [73.384857177734432, 16.400421142578068],
          [73.384857177734432, 16.400142669677678],
          [73.384590148925952, 16.400142669677678],
          [73.384590148925952, 16.399858474731559],
          [73.384307861328409, 16.399858474731559],
          [73.384307861328409, 16.399309158325309],
          [73.384033203125, 16.399309158325309],
          [73.384033203125, 16.399030685424748],
          [73.383750915527628, 16.399030685424748],
          [73.383750915527628, 16.398469924926815],
          [73.383468627929688, 16.398471832275391],
          [73.383468627929688, 16.398195266723633],
          [73.382919311523494, 16.398199081420955],
          [73.382919311523494, 16.397920608520565],
          [73.382637023925724, 16.397920608520565],
          [73.382637023925724, 16.397638320922852],
          [73.382080078125171, 16.397638320922852],
          [73.382080078125171, 16.397359848022461],
          [73.381530761718921, 16.397361755371037],
          [73.381530761718921, 16.397083282470646],
          [73.381248474121378, 16.397083282470646],
          [73.381248474121378, 16.396804809570256],
          [73.380973815917969, 16.396804809570256],
          [73.380973815917969, 16.396526336669922],
          [73.380691528320597, 16.396528244018668],
          [73.380691528320597, 16.396249771118278],
          [73.380142211914176, 16.396249771118278],
          [73.380142211914176, 16.395969390869141],
          [73.379859924316463, 16.395971298217887],
          [73.379859924316463, 16.395694732666129],
          [73.378646850586108, 16.395694732666129],
          [73.377639770508097, 16.395694732666129],
          [73.377639770508097, 16.395971298217887],
          [73.377082824707315, 16.395969390869141],
          [73.377082824707315, 16.396249771118278],
          [73.376808166503963, 16.396249771118278],
          [73.376808166503963, 16.396804809570256],
          [73.376525878906364, 16.396804809570256],
          [73.376525878906364, 16.397083282470646],
          [73.375694274902571, 16.397083282470646],
          [73.375694274902571, 16.397361755371037],
          [73.375419616699389, 16.397361755371037],
          [73.375419616699389, 16.397083282470646],
          [73.374862670898608, 16.397083282470646],
          [73.374862670898608, 16.396804809570256],
          [73.374580383301065, 16.396804809570256],
          [73.374580383301065, 16.396526336669922],
          [73.374313354492188, 16.396528244018668],
          [73.374313354492188, 16.396249771118278],
          [73.373748779296932, 16.396249771118278],
          [73.373748779296932, 16.395969390869141],
          [73.372917175292912, 16.395971298217887],
          [73.372917175292912, 16.395694732666129],
          [73.372642517090071, 16.395694732666129],
          [73.372642517090071, 16.395971298217887],
          [73.369857788085881, 16.395971298217887],
          [73.369857788085881, 16.395694732666129],
          [73.369308471679858, 16.395694732666129],
          [73.369308471679858, 16.395971298217887],
          [73.368751525879077, 16.395971298217887],
          [73.368751525879077, 16.395694732666129],
          [73.368469238281534, 16.395694732666129],
          [73.368469238281534, 16.395971298217887],
          [73.368186950683764, 16.395969390869141],
          [73.368186950683764, 16.396249771118278],
          [73.367637634277344, 16.396249771118278],
          [73.367637634277344, 16.396528244018668],
          [73.367362976074332, 16.396526336669922],
          [73.367362976074332, 16.396804809570256],
          [73.366806030273381, 16.396804809570256],
          [73.366806030273381, 16.397083282470646],
          [73.365974426269588, 16.397083282470646],
          [73.365974426269588, 16.397361755371037],
          [73.365692138672046, 16.397359848022461],
          [73.365692138672046, 16.397638320922852],
          [73.365417480469034, 16.397638320922852],
          [73.365417480469034, 16.399030685424748],
          [73.365692138672046, 16.399030685424748],
          [73.365692138672046, 16.399309158325309],
          [73.365974426269588, 16.399305343627987],
          [73.365974426269588, 16.39958381652832],
          [73.366249084472827, 16.399578094482422],
          [73.366249084472827, 16.399858474731559],
          [73.366516113281307, 16.399858474731559],
          [73.366516113281307, 16.400142669677678],
          [73.366806030273381, 16.400142669677678],
          [73.366806030273381, 16.400421142578068],
          [73.367080688476619, 16.400417327880916],
          [73.367080688476619, 16.400693893432674],
          [73.367362976074332, 16.400690078735352],
          [73.367362976074332, 16.401252746582031],
          [73.367080688476619, 16.401252746582031],
          [73.367080688476619, 16.401531219482422],
          [73.366806030273381, 16.401531219482422],
          [73.366806030273381, 16.401821136474723],
          [73.366249084472827, 16.401821136474723],
          [73.366249084472827, 16.402362823486385],
          [73.365966796875227, 16.402362823486385],
          [73.365966796875227, 16.402919769287166],
          [73.365692138672046, 16.402919769287166],
          [73.365692138672046, 16.40402984619152],
          [73.365417480469034, 16.40402984619152],
          [73.365417480469034, 16.40542030334467],
          [73.365135192871264, 16.405416488647518],
          [73.365135192871264, 16.407638549804801],
          [73.365417480469034, 16.40763092041027],
          [73.365417480469034, 16.407920837402344],
          [73.365692138672046, 16.407915115356388],
          [73.365692138672046, 16.408193588256779],
          [73.365974426269588, 16.408193588256779],
          [73.365974426269588, 16.40847206115717],
          [73.366249084472827, 16.408470153808594],
          [73.366249084472827, 16.408750534057731],
          [73.366806030273381, 16.408750534057731],
          [73.366806030273381, 16.409030914306697],
          [73.367080688476619, 16.409030914306697],
          [73.367080688476619, 16.409860610961914],
          [73.366806030273381, 16.409860610961914],
          [73.366806030273381, 16.410139083862305],
          [73.366516113281307, 16.410139083862305],
          [73.366516113281307, 16.410699844360408],
          [73.366249084472827, 16.410699844360408],
          [73.366249084472827, 16.411249160766658],
          [73.365966796875227, 16.411249160766658],
          [73.365966796875227, 16.411811828613395],
          [73.365692138672046, 16.411811828613395],
          [73.365692138672046, 16.413761138916072],
          [73.365417480469034, 16.413751602172908],
          [73.365417480469034, 16.414581298828125],
          [73.365142822265625, 16.414579391479549],
          [73.365142822265625, 16.415140151977653],
          [73.364860534668253, 16.415140151977653],
          [73.364860534668253, 16.415702819824219],
          [73.364585876464844, 16.415695190429687],
          [73.364585876464844, 16.415973663330021],
          [73.36429595947294, 16.415969848632869],
          [73.36429595947294, 16.416530609130803],
          [73.364028930664119, 16.416528701782227],
          [73.364028930664119, 16.416805267334041],
          [73.36374664306652, 16.416805267334041],
          [73.36374664306652, 16.417083740234375],
          [73.363197326660327, 16.417079925537223],
          [73.363197326660327, 16.41736030578619],
          [73.362922668457088, 16.41736030578619],
          [73.362922668457088, 16.417640686035156],
          [73.362640380859546, 16.417640686035156],
          [73.362640380859546, 16.417921066284123],
          [73.362358093261776, 16.417917251586971],
          [73.362358093261776, 16.418195724487362],
          [73.362075805664233, 16.418190002441406],
          [73.362075805664233, 16.419031143188477],
          [73.361808776855753, 16.419031143188477],
          [73.361808776855753, 16.419860839843864],
          [73.361526489257813, 16.419860839843864],
          [73.361526489257813, 16.420419692993221],
          [73.361251831054972, 16.420419692993221],
          [73.361251831054972, 16.421249389648437],
          [73.360969543457088, 16.421249389648437],
          [73.360969543457088, 16.423194885253963],
          [73.360687255859489, 16.423191070556754],
          [73.360687255859489, 16.423749923706112],
          [73.360420227050838, 16.423749923706112],
          [73.360420227050838, 16.424028396606502],
          [73.357917785644588, 16.424028396606502],
          [73.357917785644588, 16.425699234008789],
          [73.35819244384794, 16.425693511962834],
          [73.35819244384794, 16.427083969116154],
          [73.358467102050781, 16.427080154419002],
          [73.358467102050781, 16.427362442016545],
          [73.358749389648722, 16.427362442016545],
          [73.358749389648722, 16.427642822265739],
          [73.359016418457202, 16.427642822265739],
          [73.359016418457202, 16.427919387817496],
          [73.359306335449276, 16.42791748046875],
          [73.359306335449276, 16.428192138671932],
          [73.359580993652514, 16.428190231323356],
          [73.359580993652514, 16.430139541626033],
          [73.359306335449276, 16.430139541626033],
          [73.359306335449276, 16.432361602783146],
          [73.359024047851733, 16.432361602783146],
          [73.359024047851733, 16.4334716796875],
          [73.358749389648722, 16.433469772338924],
          [73.358749389648722, 16.435140609741211],
          [73.358474731445313, 16.435138702392635],
          [73.358474731445313, 16.437084197998161],
          [73.35819244384794, 16.437084197998161],
          [73.35819244384794, 16.438194274902287],
          [73.357917785644588, 16.438190460205135],
          [73.357917785644588, 16.438749313354492],
          [73.35764312744152, 16.438749313354492],
          [73.35764312744152, 16.439310073852596],
          [73.357360839843807, 16.439306259155273],
          [73.357360839843807, 16.439859390258846],
          [73.357086181640568, 16.439859390258846],
          [73.357086181640568, 16.440420150756779],
          [73.357360839843807, 16.440420150756779],
          [73.357360839843807, 16.441251754760742],
          [73.35764312744152, 16.441251754760742],
          [73.35764312744152, 16.441530227661133],
          [73.358467102050781, 16.441530227661133],
          [73.358467102050781, 16.441251754760742],
          [73.358749389648722, 16.441251754760742],
          [73.358749389648722, 16.4409694671632],
          [73.361526489257813, 16.4409694671632],
          [73.361526489257813, 16.440694808960018],
          [73.362083435058764, 16.440694808960018],
          [73.362083435058764, 16.440416336059627],
          [73.362358093261776, 16.440420150756779],
          [73.362358093261776, 16.440141677856388],
          [73.362640380859546, 16.440141677856388],
          [73.362640380859546, 16.439859390258846],
          [73.362915039062727, 16.439859390258846],
          [73.362915039062727, 16.439582824707031],
          [73.363197326660327, 16.439582824707031],
          [73.363197326660327, 16.439306259155273],
          [73.36374664306652, 16.439310073852596],
          [73.36374664306652, 16.439031600952205],
          [73.364860534668253, 16.439027786254883],
          [73.364860534668253, 16.439582824707031],
          [73.364585876464844, 16.439582824707031],
          [73.364585876464844, 16.439859390258846],
          [73.36374664306652, 16.439859390258846],
          [73.36374664306652, 16.440141677856388],
          [73.36347961425804, 16.440141677856388],
          [73.36347961425804, 16.440420150756779],
          [73.363197326660327, 16.440416336059627],
          [73.363197326660327, 16.4409694671632],
          [73.362915039062727, 16.4409694671632],
          [73.362922668457088, 16.441251754760742],
          [73.362640380859546, 16.441251754760742],
          [73.362640380859546, 16.441804885864371],
          [73.362358093261776, 16.441804885864371],
          [73.362358093261776, 16.442083358764705],
          [73.362075805664233, 16.442079544067383],
          [73.362075805664233, 16.442640304565487],
          [73.361526489257813, 16.442640304565487],
          [73.361526489257813, 16.442920684814453],
          [73.360687255859489, 16.442920684814453],
          [73.360687255859489, 16.442640304565487],
          [73.360137939453068, 16.442640304565487],
          [73.360137939453068, 16.442361831665096],
          [73.359306335449276, 16.442361831665096],
          [73.359306335449276, 16.442640304565487],
          [73.358749389648722, 16.442640304565487],
          [73.358749389648722, 16.442920684814453],
          [73.35819244384794, 16.442920684814453],
          [73.35819244384794, 16.44320106506342],
          [73.357635498046989, 16.443195343017692],
          [73.357635498046989, 16.443473815918082],
          [73.357360839843807, 16.443473815918082],
          [73.357360839843807, 16.44375038146984],
          [73.357086181640568, 16.443742752075309],
          [73.357086181640568, 16.444030761718807],
          [73.356529235840014, 16.444026947021484],
          [73.356529235840014, 16.444585800171012],
          [73.356246948242244, 16.444580078125057],
          [73.356246948242244, 16.44514083862299],
          [73.355972290039233, 16.445138931274414],
          [73.355972290039233, 16.445695877075195],
          [73.355697631836222, 16.445695877075195],
          [73.355697631836222, 16.445972442626953],
          [73.355415344238281, 16.445972442626953],
          [73.355422973632812, 16.446250915527344],
          [73.35514068603544, 16.446250915527344],
          [73.35514068603544, 16.446529388427734],
          [73.354026794433537, 16.446529388427734],
          [73.354026794433537, 16.446250915527344],
          [73.353752136230696, 16.446250915527344],
          [73.353752136230696, 16.444860458374023],
          [73.353195190429744, 16.444860458374023],
          [73.353195190429744, 16.444585800171012],
          [73.352081298828409, 16.444580078125057],
          [73.352081298828409, 16.444860458374023],
          [73.351806640625, 16.444860458374023],
          [73.351806640625, 16.44514083862299],
          [73.351249694824276, 16.44514083862299],
          [73.351249694824276, 16.445421218872127],
          [73.350975036621037, 16.445417404174805],
          [73.350975036621037, 16.445695877075195],
          [73.350692749023494, 16.445695877075195],
          [73.350692749023494, 16.445972442626953],
          [73.350418090820483, 16.445970535278377],
          [73.350418090820483, 16.446529388427734],
          [73.350135803222884, 16.446527481079158],
          [73.350135803222884, 16.447082519531307],
          [73.349861145019702, 16.447080612182731],
          [73.349861145019702, 16.447639465332088],
          [73.34958648681669, 16.447639465332088],
          [73.34958648681669, 16.447919845581055],
          [73.349296569824389, 16.447919845581055],
          [73.349296569824389, 16.448749542236442],
          [73.349029541015909, 16.448749542236442],
          [73.349029541015909, 16.44958305358881],
          [73.348747253417969, 16.449581146240234],
          [73.348747253417969, 16.450138092041016],
          [73.348480224609489, 16.450138092041016],
          [73.348480224609489, 16.450420379638729],
          [73.348197937011776, 16.450420379638729],
          [73.348197937011776, 16.450700759887695],
          [73.347923278808537, 16.450700759887695],
          [73.347923278808537, 16.451530456542912],
          [73.347640991210994, 16.451530456542912],
          [73.347640991210994, 16.452930450439567],
          [73.347358703613224, 16.452930450439567],
          [73.347358703613224, 16.453752517700195],
          [73.347076416015852, 16.453752517700195],
          [73.347076416015852, 16.454309463500977],
          [73.347358703613224, 16.454305648803825],
          [73.347358703613224, 16.455694198608342],
          [73.347076416015852, 16.455680847168082],
          [73.347076416015852, 16.457920074462834],
          [73.346809387207202, 16.457916259765682],
          [73.346801757812671, 16.45847129821783],
          [73.346527099609432, 16.458469390869254],
          [73.346527099609432, 16.459030151367188],
          [73.346252441406421, 16.459028244018612],
          [73.346252441406421, 16.45958328247076],
          [73.345970153808878, 16.459579467773438],
          [73.345970153808878, 16.460420608520508],
          [73.345695495605469, 16.460416793823356],
          [73.345695495605469, 16.460971832275334],
          [73.345413208008097, 16.460971832275334],
          [73.345420837402628, 16.461250305175895],
          [73.345138549804744, 16.461250305175895],
          [73.345138549804744, 16.461811065673828],
          [73.344863891601676, 16.46180534362793],
          [73.344863891601676, 16.462083816528263],
          [73.344581604003963, 16.462080001831112],
          [73.344581604003963, 16.462360382080078],
          [73.344306945800724, 16.462360382080078],
          [73.344306945800724, 16.462640762329045],
          [73.344024658203352, 16.462638854980469],
          [73.344024658203352, 16.463193893432617],
          [73.343750000000171, 16.463190078735465],
          [73.343750000000171, 16.463750839233398],
          [73.343475341796932, 16.463750839233398],
          [73.343475341796932, 16.464582443237362],
          [73.343193054199389, 16.464580535888786],
          [73.343193054199389, 16.465137481689567],
          [73.342918395996378, 16.465137481689567],
          [73.342918395996378, 16.465421676635685],
          [73.342636108398437, 16.465421676635685],
          [73.342636108398437, 16.466249465942496],
          [73.342361450195597, 16.466249465942496],
          [73.342361450195597, 16.467081069946289],
          [73.342086791992244, 16.467079162597713],
          [73.342086791992244, 16.468751907348576],
          [73.341796875000284, 16.468751907348576],
          [73.341796875000284, 16.470420837402287],
          [73.341529846191463, 16.470420837402287],
          [73.341529846191463, 16.471530914306641],
          [73.341804504394645, 16.471527099609489],
          [73.341804504394645, 16.472085952758846],
          [73.342086791992244, 16.472080230712891],
          [73.342086791992244, 16.472919464111385],
          [73.342361450195597, 16.472917556762809],
          [73.342361450195597, 16.475694656372127],
          [73.342086791992244, 16.475690841674918],
          [73.342086791992244, 16.476249694824276],
          [73.341796875000284, 16.476249694824276],
          [73.341796875000284, 16.47763824462902],
          [73.341529846191463, 16.47763824462902],
          [73.341529846191463, 16.478471755981388],
          [73.341247558593693, 16.478469848632812],
          [73.341247558593693, 16.478748321533203],
          [73.340972900390852, 16.478748321533203],
          [73.340972900390852, 16.479309082031307],
          [73.340698242187671, 16.479305267333984],
          [73.340698242187671, 16.479583740234318],
          [73.339302062988565, 16.479583740234318],
          [73.339302062988565, 16.479858398437557],
          [73.338752746582145, 16.479858398437557],
          [73.338752746582145, 16.479583740234318],
          [73.337913513183651, 16.479583740234318],
          [73.337913513183651, 16.479858398437557],
          [73.33735656738304, 16.479850769043026],
          [73.33735656738304, 16.480142593383903],
          [73.337081909179858, 16.480142593383903],
          [73.337081909179858, 16.480421066284237],
          [73.336524963379077, 16.480417251586914],
          [73.336524963379077, 16.480693817138672],
          [73.336250305176065, 16.480693817138672],
          [73.336250305176065, 16.482084274292049],
          [73.335975646972656, 16.482084274292049],
          [73.335975646972656, 16.482915878296012],
          [73.335693359375284, 16.482915878296012],
          [73.335693359375284, 16.483474731445369],
          [73.335418701171932, 16.483472824096737],
          [73.335418701171932, 16.483749389648551],
          [73.335136413574332, 16.483749389648551],
          [73.335136413574332, 16.484029769897518],
          [73.334861755371151, 16.484029769897518],
          [73.334861755371151, 16.484310150146484],
          [73.334587097168139, 16.484306335449332],
          [73.334587097168139, 16.484584808349723],
          [73.33430480957054, 16.484584808349723],
          [73.33430480957054, 16.48486137390131],
          [73.334030151367358, 16.484859466552734],
          [73.334030151367358, 16.485139846801871],
          [73.333747863769588, 16.485139846801871],
          [73.333747863769588, 16.485420227050838],
          [73.333473205566577, 16.485420227050838],
          [73.333473205566577, 16.485980987548828],
          [73.333190917969034, 16.485980987548828],
          [73.333190917969034, 16.486530303955021],
          [73.332916259765625, 16.486528396606445],
          [73.332916259765625, 16.487083435058594],
          [73.332641601562784, 16.487079620361442],
          [73.332641601562784, 16.487920761108342],
          [73.332359313964901, 16.48791694641119],
          [73.332359313964901, 16.488189697265625],
          [73.332084655761832, 16.48819541931158],
          [73.332084655761832, 16.488471984863338],
          [73.331802368164119, 16.488470077514762],
          [73.331802368164119, 16.489040374755859],
          [73.331527709960881, 16.489040374755859],
          [73.331527709960881, 16.490417480468864],
          [73.33125305175804, 16.490417480468864],
          [73.33125305175804, 16.490972518920842],
          [73.331527709960881, 16.490972518920842],
          [73.331527709960881, 16.492082595825195],
          [73.33125305175804, 16.492082595825195],
          [73.33125305175804, 16.49347114562994],
          [73.330970764160327, 16.493469238281364],
          [73.330970764160327, 16.494031906127873],
          [73.330139160156534, 16.494031906127873],
          [73.330139160156534, 16.495140075683651],
          [73.329864501953125, 16.495138168335075],
          [73.329864501953125, 16.497083663940373],
          [73.329582214355753, 16.497079849243221],
          [73.329582214355753, 16.497920989990291],
          [73.329307556152401, 16.497920989990291],
          [73.329307556152401, 16.500419616699219],
          [73.329025268554801, 16.500415802002067],
          [73.329032897949332, 16.502639770507926],
          [73.328750610351619, 16.502639770507926],
          [73.328750610351619, 16.503471374511719],
          [73.328475952148381, 16.503471374511719],
          [73.328475952148381, 16.504304885864315],
          [73.328186035156307, 16.504301071167106],
          [73.328186035156307, 16.505420684814396],
          [73.327919006347827, 16.505420684814396],
          [73.327919006347827, 16.50653076171875],
          [73.327636718750057, 16.50653076171875],
          [73.327636718750057, 16.507362365722713],
          [73.327346801757983, 16.507362365722713],
          [73.327346801757983, 16.50792121887207],
          [73.327079772949503, 16.507917404174918],
          [73.327079772949503, 16.50847053527832],
          [73.326812744140625, 16.50847053527832],
          [73.326812744140625, 16.509309768676815],
          [73.326530456543253, 16.509309768676815],
          [73.326530456543253, 16.510150909423942],
          [73.326248168945313, 16.510139465332031],
          [73.326248168945313, 16.510694503784237],
          [73.32596588134794, 16.510690689087028],
          [73.32596588134794, 16.511249542236385],
          [73.325691223144588, 16.511249542236385],
          [73.325691223144588, 16.512083053588924],
          [73.325416564941349, 16.512081146240348],
          [73.325416564941349, 16.512920379638672],
          [73.325141906738509, 16.512920379638672],
          [73.325141906738509, 16.513750076294059],
          [73.324859619140796, 16.513750076294059],
          [73.324859619140796, 16.514030456543026],
          [73.324577331543196, 16.514030456543026],
          [73.324577331543196, 16.514310836791992],
          [73.324302673340014, 16.514305114746094],
          [73.324302673340014, 16.514862060546818],
          [73.324028015137003, 16.514860153198242],
          [73.324028015137003, 16.515140533447209],
          [73.323753356933594, 16.515140533447209],
          [73.323753356933594, 16.515420913696346],
          [73.323471069336222, 16.515415191650447],
          [73.323471069336222, 16.515693664550781],
          [73.323196411132813, 16.515693664550781],
          [73.323196411132813, 16.515972137451172],
          [73.322906494140909, 16.515960693359489],
          [73.322906494140909, 16.516250610351563],
          [73.322639465332088, 16.516250610351563],
          [73.322639465332088, 16.516529083251953],
          [73.320968627929744, 16.516529083251953],
          [73.320968627929744, 16.516250610351563],
          [73.320137023925781, 16.516250610351563],
          [73.320137023925781, 16.515960693359489],
          [73.31986236572294, 16.515972137451172],
          [73.31986236572294, 16.515693664550781],
          [73.319030761718807, 16.515693664550781],
          [73.319030761718807, 16.515415191650447],
          [73.318748474121037, 16.515420913696346],
          [73.318748474121037, 16.515140533447209],
          [73.318176269531193, 16.515140533447209],
          [73.318176269531193, 16.514860153198242],
          [73.317916870117244, 16.514862060546818],
          [73.317916870117244, 16.514583587646428],
          [73.317642211914233, 16.514583587646428],
          [73.317642211914233, 16.514305114746094],
          [73.31735992431669, 16.514310836791992],
          [73.31735992431669, 16.514030456543026],
          [73.317092895507813, 16.514030456543026],
          [73.317092895507813, 16.513750076294059],
          [73.316802978515909, 16.513750076294059],
          [73.316802978515909, 16.513469696044922],
          [73.316246032714957, 16.513469696044922],
          [73.316246032714957, 16.515140533447209],
          [73.316528320312557, 16.515138626098633],
          [73.316528320312557, 16.515972137451172],
          [73.316802978515909, 16.515960693359489],
          [73.316802978515909, 16.51680946350092],
          [73.317085266113281, 16.516805648803768],
          [73.317085266113281, 16.517084121704158],
          [73.31735992431669, 16.51708030700695],
          [73.31735992431669, 16.517639160156307],
          [73.317642211914233, 16.517639160156307],
          [73.317642211914233, 16.517917633056697],
          [73.317916870117244, 16.517915725708121],
          [73.317916870117244, 16.518472671508846],
          [73.318176269531193, 16.51847076416027],
          [73.318176269531193, 16.518749237060661],
          [73.318466186523665, 16.518749237060661],
          [73.318466186523665, 16.519859313964844],
          [73.318176269531193, 16.519859313964844],
          [73.318176269531193, 16.520141601562557],
          [73.317916870117244, 16.520141601562557],
          [73.317916870117244, 16.520694732666016],
          [73.317642211914233, 16.520690917968807],
          [73.317642211914233, 16.522640228271484],
          [73.31735992431669, 16.522640228271484],
          [73.31735992431669, 16.522920608520451],
          [73.317085266113281, 16.522916793823299],
          [73.317085266113281, 16.52347373962408],
          [73.316802978515909, 16.523469924926871],
          [73.316802978515909, 16.523750305175838],
          [73.316528320312557, 16.523750305175838],
          [73.316528320312557, 16.524030685424805],
          [73.316246032714957, 16.524030685424805],
          [73.316246032714957, 16.526250839233342],
          [73.315971374511776, 16.526250839233342],
          [73.315971374511776, 16.526809692382869],
          [73.315696716308537, 16.526809692382869],
          [73.315696716308537, 16.527639389038086],
          [73.315971374511776, 16.527639389038086],
          [73.315971374511776, 16.528194427490291],
          [73.316253662109489, 16.528194427490291],
          [73.316253662109489, 16.528472900390625],
          [73.316528320312557, 16.528470993042049],
          [73.316528320312557, 16.52874946594244],
          [73.316802978515909, 16.52874946594244],
          [73.316802978515909, 16.529310226440373],
          [73.317092895507813, 16.529310226440373],
          [73.317092895507813, 16.53013992309576],
          [73.31735992431669, 16.53013992309576],
          [73.31735992431669, 16.530700683593693],
          [73.317085266113281, 16.530694961547965],
          [73.317085266113281, 16.530971527099553],
          [73.316802978515909, 16.530960083007869],
          [73.316802978515909, 16.531248092651367],
          [73.316253662109489, 16.531248092651367],
          [73.316253662109489, 16.532083511352482],
          [73.315971374511776, 16.532083511352482],
          [73.315971374511776, 16.532360076904297],
          [73.315696716308537, 16.532358169555721],
          [73.315696716308537, 16.532638549804687],
          [73.315406799316463, 16.532638549804687],
          [73.315406799316463, 16.532920837402401],
          [73.314857482910213, 16.532917022705078],
          [73.314857482910213, 16.533193588256836],
          [73.314582824707202, 16.533193588256836],
          [73.314582824707202, 16.533470153808651],
          [73.31402587890625, 16.533468246460075],
          [73.31402587890625, 16.533752441406193],
          [73.313751220703409, 16.533752441406193],
          [73.313751220703409, 16.534032821655387],
          [73.313468933105469, 16.534032821655387],
          [73.313468933105469, 16.534309387206974],
          [73.313194274902457, 16.534305572509822],
          [73.313194274902457, 16.534584045410213],
          [73.312919616699276, 16.534580230713004],
          [73.312919616699276, 16.534862518310547],
          [73.312637329101506, 16.534862518310547],
          [73.312637329101506, 16.53514289855957],
          [73.312370300293196, 16.53514289855957],
          [73.312370300293196, 16.537090301513615],
          [73.312080383300952, 16.537090301513615],
          [73.312080383300952, 16.537361145019474],
          [73.311813354492244, 16.537361145019474],
          [73.311813354492244, 16.537919998169002],
          [73.311531066894702, 16.53791618347168],
          [73.311531066894702, 16.53819465637207],
          [73.311248779297159, 16.53819465637207],
          [73.311248779297159, 16.53791618347168],
          [73.310142517089957, 16.537919998169002],
          [73.310142517089957, 16.539030075073185],
          [73.310417175292969, 16.539028167724609],
          [73.310417175292969, 16.539583206176758],
          [73.311248779297159, 16.539583206176758],
          [73.311248779297159, 16.539304733276424],
          [73.311805725097713, 16.539304733276424],
          [73.311805725097713, 16.539028167724609],
          [73.312637329101506, 16.539028167724609],
          [73.312637329101506, 16.539304733276424],
          [73.312362670898665, 16.539304733276424],
          [73.312362670898665, 16.539583206176758],
          [73.312080383300952, 16.539583206176758],
          [73.312080383300952, 16.539861679077148],
          [73.311805725097713, 16.539861679077148],
          [73.311805725097713, 16.540138244628963],
          [73.311248779297159, 16.540130615234432],
          [73.311248779297159, 16.540420532226506],
          [73.31097412109375, 16.540416717529354],
          [73.31097412109375, 16.540971755981502],
          [73.310691833496378, 16.540969848632926],
          [73.310691833496378, 16.541530609130859],
          [73.31097412109375, 16.541528701782283],
          [73.31097412109375, 16.542083740234489],
          [73.311248779297159, 16.542079925537109],
          [73.311248779297159, 16.542360305786246],
          [73.312080383300952, 16.542360305786246],
          [73.312080383300952, 16.542079925537109],
          [73.312362670898665, 16.542083740234489],
          [73.312362670898665, 16.541805267334098],
          [73.312637329101506, 16.541810989379826],
          [73.312637329101506, 16.541530609130859],
          [73.312919616699276, 16.541530609130859],
          [73.312919616699276, 16.541250228881893],
          [73.313186645508097, 16.541250228881893],
          [73.313186645508097, 16.541530609130859],
          [73.31430816650419, 16.541528701782283],
          [73.31430816650419, 16.542083740234489],
          [73.314582824707202, 16.542079925537109],
          [73.314582824707202, 16.542640686035213],
          [73.31430816650419, 16.542640686035213],
          [73.31430816650419, 16.54486083984375],
          [73.314582824707202, 16.54486083984375],
          [73.314582824707202, 16.545139312744141],
          [73.314857482910213, 16.545139312744141],
          [73.314857482910213, 16.545421600341911],
          [73.315139770507983, 16.545415878295955],
          [73.315139770507983, 16.545694351196346],
          [73.315406799316463, 16.545690536499137],
          [73.315406799316463, 16.546262741088981],
          [73.315696716308537, 16.546262741088981],
          [73.315696716308537, 16.546531677246037],
          [73.315971374511776, 16.546531677246037],
          [73.315971374511776, 16.546810150146428],
          [73.316253662109489, 16.546806335449276],
          [73.316253662109489, 16.547082901001033],
          [73.316528320312557, 16.547082901001033],
          [73.316528320312557, 16.547359466552848],
          [73.317092895507813, 16.547359466552848],
          [73.317092895507813, 16.547641754150391],
          [73.31735992431669, 16.547637939453239],
          [73.31735992431669, 16.54819488525402],
          [73.317642211914233, 16.54819488525402],
          [73.317642211914233, 16.548473358154411],
          [73.317916870117244, 16.548469543457031],
          [73.317916870117244, 16.549030303955135],
          [73.318176269531193, 16.549030303955135],
          [73.318176269531193, 16.549320220947266],
          [73.318473815918196, 16.54930305480957],
          [73.318473815918196, 16.549583435058537],
          [73.318748474121037, 16.549583435058537],
          [73.318748474121037, 16.549863815307731],
          [73.319030761718807, 16.549861907958928],
          [73.319030761718807, 16.550420761108455],
          [73.319305419921989, 16.550416946411133],
          [73.319313049316349, 16.552360534668026],
          [73.319030761718807, 16.552360534668026],
          [73.319030761718807, 16.552640914916992],
          [73.318748474121037, 16.552640914916992],
          [73.318748474121037, 16.552919387817383],
          [73.318473815918196, 16.552917480468807],
          [73.318473815918196, 16.553472518920955],
          [73.318176269531193, 16.553470611572379],
          [73.318176269531193, 16.554029464721737],
          [73.317916870117244, 16.554029464721737],
          [73.317916870117244, 16.554861068725529],
          [73.317642211914233, 16.554861068725529],
          [73.317642211914233, 16.556249618530273],
          [73.318176269531193, 16.556249618530273],
          [73.318176269531193, 16.556528091430664],
          [73.318748474121037, 16.556526184082088],
          [73.318748474121037, 16.556804656982479],
          [73.319305419921989, 16.556804656982479],
          [73.319305419921989, 16.556526184082088],
          [73.31986236572294, 16.556528091430664],
          [73.31986236572294, 16.555971145629883],
          [73.320137023925781, 16.555973052978459],
          [73.320137023925781, 16.555694580078125],
          [73.320419311523722, 16.555694580078125],
          [73.320419311523722, 16.554861068725529],
          [73.320686340332202, 16.554861068725529],
          [73.320686340332202, 16.554309844970703],
          [73.321533203125057, 16.554309844970703],
          [73.321533203125057, 16.553750991821346],
          [73.321807861328296, 16.553750991821346],
          [73.321807861328296, 16.553190231323242],
          [73.321525573730696, 16.553195953369197],
          [73.321525573730696, 16.552639007568416],
          [73.321250915527514, 16.552640914916992],
          [73.321250915527514, 16.551811218261832],
          [73.322082519531307, 16.551805496215877],
          [73.322082519531307, 16.552085876464844],
          [73.322639465332088, 16.552070617675781],
          [73.322639465332088, 16.552360534668026],
          [73.322906494140909, 16.552360534668026],
          [73.322906494140909, 16.552640914916992],
          [73.323196411132813, 16.552640914916992],
          [73.323196411132813, 16.552919387817383],
          [73.324302673340014, 16.552917480468807],
          [73.324302673340014, 16.553472518920955],
          [73.324577331543196, 16.553470611572379],
          [73.324577331543196, 16.554029464721737],
          [73.324859619140796, 16.554027557373161],
          [73.324859619140796, 16.554582595825138],
          [73.325141906738509, 16.554582595825138],
          [73.325141906738509, 16.55513954162609],
          [73.325416564941349, 16.555130004882812],
          [73.325416564941349, 16.555419921875057],
          [73.325691223144588, 16.555419921875057],
          [73.325691223144588, 16.556249618530273],
          [73.325973510742301, 16.556249618530273],
          [73.325973510742301, 16.557361602783203],
          [73.326248168945313, 16.557359695434627],
          [73.326248168945313, 16.55792045593256],
          [73.328186035156307, 16.55792045593256],
          [73.328186035156307, 16.557638168335018],
          [73.328475952148381, 16.557638168335018],
          [73.328475952148381, 16.557359695434627],
          [73.329307556152401, 16.557361602783203],
          [73.329307556152401, 16.557083129882812],
          [73.329582214355753, 16.557083129882812],
          [73.329582214355753, 16.556804656982479],
          [73.330139160156534, 16.556804656982479],
          [73.330139160156534, 16.556526184082088],
          [73.331527709960881, 16.556526184082088],
          [73.331527709960881, 16.556804656982479],
          [73.332084655761832, 16.556804656982479],
          [73.332084655761832, 16.557083129882812],
          [73.332359313964901, 16.557083129882812],
          [73.332359313964901, 16.557361602783203],
          [73.332641601562784, 16.557359695434627],
          [73.332641601562784, 16.557638168335018],
          [73.332916259765625, 16.557638168335018],
          [73.332916259765625, 16.55792045593256],
          [73.333190917969034, 16.55792045593256],
          [73.333190917969034, 16.559030532836914],
          [73.332916259765625, 16.559030532836914],
          [73.332916259765625, 16.559583663940543],
          [73.332359313964901, 16.559579849243164],
          [73.332359313964901, 16.559858322143555],
          [73.332077026367301, 16.559858322143555],
          [73.332077026367301, 16.560138702392692],
          [73.331802368164119, 16.560138702392692],
          [73.331802368164119, 16.560422897338867],
          [73.331527709960881, 16.560417175293082],
          [73.331527709960881, 16.560970306396484],
          [73.33125305175804, 16.560970306396484],
          [73.33125305175804, 16.561809539794979],
          [73.331527709960881, 16.561805725097656],
          [73.331527709960881, 16.562084197998047],
          [73.331802368164119, 16.562080383300838],
          [73.331802368164119, 16.562362670898381],
          [73.332077026367301, 16.562362670898381],
          [73.332077026367301, 16.562080383300838],
          [73.332916259765625, 16.562080383300838],
          [73.332916259765625, 16.562362670898381],
          [73.333473205566577, 16.562362670898381],
          [73.333473205566577, 16.562080383300838],
          [73.334030151367358, 16.562084197998047],
          [73.334030151367358, 16.561805725097656],
          [73.334297180176009, 16.561809539794979],
          [73.334297180176009, 16.561531066894588],
          [73.334861755371151, 16.561531066894588],
          [73.334861755371151, 16.561260223388786],
          [73.335136413574332, 16.561260223388786],
          [73.335136413574332, 16.560970306396484],
          [73.335418701171932, 16.560970306396484],
          [73.335418701171932, 16.560138702392692],
          [73.335693359375284, 16.560138702392692],
          [73.335693359375284, 16.558469772338981],
          [73.335975646972656, 16.558471679687557],
          [73.335975646972656, 16.557916641235408],
          [73.336250305176065, 16.55792045593256],
          [73.336250305176065, 16.557359695434627],
          [73.336807250976847, 16.557361602783203],
          [73.336807250976847, 16.557083129882812],
          [73.337081909179858, 16.557083129882812],
          [73.337081909179858, 16.556804656982479],
          [73.337364196777401, 16.556804656982479],
          [73.337364196777401, 16.556526184082088],
          [73.337905883789119, 16.556528091430664],
          [73.337905883789119, 16.555690765380916],
          [73.338195800781193, 16.555694580078125],
          [73.338195800781193, 16.554861068725529],
          [73.338470458984432, 16.554861068725529],
          [73.338470458984432, 16.554580688476562],
          [73.338752746582145, 16.554582595825138],
          [73.338752746582145, 16.554307937622127],
          [73.339027404785156, 16.554309844970703],
          [73.339027404785156, 16.554010391235295],
          [73.339027404785156, 16.553472518920955],
          [73.339302062988565, 16.553472518920955],
          [73.339302062988565, 16.553195953369197],
          [73.339584350585937, 16.553195953369197],
          [73.339584350585937, 16.552360534668026],
          [73.339859008789347, 16.552360534668026],
          [73.339859008789347, 16.551811218261832],
          [73.340141296386889, 16.551811218261832],
          [73.340141296386889, 16.551530838012638],
          [73.340415954589901, 16.551530838012638],
          [73.340415954589901, 16.550689697265739],
          [73.340690612793139, 16.550691604614315],
          [73.340690612793139, 16.549028396606559],
          [73.340415954589901, 16.549030303955135],
          [73.340415954589901, 16.548469543457031],
          [73.340141296386889, 16.548473358154411],
          [73.340141296386889, 16.547359466552848],
          [73.340415954589901, 16.547359466552848],
          [73.340415954589901, 16.547082901001033],
          [73.340690612793139, 16.547082901001033],
          [73.340698242187671, 16.546806335449276],
          [73.341247558593693, 16.546810150146428],
          [73.341247558593693, 16.546531677246037],
          [73.341529846191463, 16.546531677246037],
          [73.341529846191463, 16.546262741088981],
          [73.341796875000284, 16.546262741088981],
          [73.341796875000284, 16.545970916748104],
          [73.342361450195597, 16.54597282409668],
          [73.342361450195597, 16.545694351196346],
          [73.342636108398437, 16.545694351196346],
          [73.342636108398437, 16.545137405395565],
          [73.342918395996378, 16.545139312744141],
          [73.342918395996378, 16.54486083984375],
          [73.343193054199389, 16.54486083984375],
          [73.343193054199389, 16.544580459594783],
          [73.343750000000171, 16.544582366943359],
          [73.343750000000171, 16.544305801391602],
          [73.344017028808651, 16.544309616088924],
          [73.344017028808651, 16.544031143188533],
          [73.344306945800724, 16.544031143188533],
          [73.344306945800724, 16.543750762939396],
          [73.344581604003963, 16.543750762939396],
          [73.344581604003963, 16.543190002441463],
          [73.344863891601676, 16.543193817138615],
          [73.344863891601676, 16.542917251587028],
          [73.345138549804744, 16.54292106628418],
          [73.345138549804744, 16.542640686035213],
          [73.345420837402628, 16.542640686035213],
          [73.345420837402628, 16.541530609130859],
          [73.345703125, 16.541530609130859],
          [73.345703125, 16.539859771728572],
          [73.345970153808878, 16.539861679077148],
          [73.345970153808878, 16.534027099609432],
          [73.346252441406421, 16.534032821655387],
          [73.346252441406421, 16.531810760498047],
          [73.346527099609432, 16.531810760498047],
          [73.346527099609432, 16.530700683593693],
          [73.346801757812671, 16.530700683593693],
          [73.346801757812671, 16.529859542846793],
          [73.347084045410384, 16.529861450195369],
          [73.347084045410384, 16.529582977294979],
          [73.347358703613224, 16.529582977294979],
          [73.347358703613224, 16.529306411743221],
          [73.347640991210994, 16.529310226440373],
          [73.347640991210994, 16.529029846191406],
          [73.348197937011776, 16.529029846191406],
          [73.348197937011776, 16.52874946594244],
          [73.348480224609489, 16.52874946594244],
          [73.348472595215128, 16.528472900390625],
          [73.348747253417969, 16.528472900390625],
          [73.348747253417969, 16.528194427490291],
          [73.349029541015909, 16.528194427490291],
          [73.349029541015909, 16.527917861938477],
          [73.349296569824389, 16.527919769287053],
          [73.349296569824389, 16.527360916137695],
          [73.34958648681669, 16.527360916137695],
          [73.34958648681669, 16.527080535888729],
          [73.349861145019702, 16.527082443237305],
          [73.349861145019702, 16.526805877685547],
          [73.350135803222884, 16.526809692382869],
          [73.350135803222884, 16.526531219482479],
          [73.350692749023494, 16.526531219482479],
          [73.350692749023494, 16.525970458984375],
          [73.351249694824276, 16.525972366332951],
          [73.351249694824276, 16.525138854980582],
          [73.351516723633097, 16.525150299072322],
          [73.351516723633097, 16.524860382080192],
          [73.351806640625, 16.524860382080192],
          [73.351806640625, 16.524580001831055],
          [73.352081298828409, 16.52458572387701],
          [73.352081298828409, 16.524026870727653],
          [73.352355957031421, 16.524030685424805],
          [73.352355957031421, 16.523469924926871],
          [73.352912902832202, 16.52347373962408],
          [73.352912902832202, 16.522916793823299],
          [73.353469848632983, 16.522920608520451],
          [73.353469848632983, 16.522640228271484],
          [73.353752136230696, 16.522640228271484],
          [73.353752136230696, 16.522361755371094],
          [73.354309082031307, 16.522361755371094],
          [73.354309082031307, 16.522640228271484],
          [73.3548583984375, 16.522640228271484],
          [73.3548583984375, 16.522361755371094],
          [73.356529235840014, 16.522363662719727],
          [73.356529235840014, 16.522081375122127],
          [73.356796264648494, 16.522092819213867],
          [73.356796264648494, 16.521802902221737],
          [73.357360839843807, 16.521804809570369],
          [73.357360839843807, 16.521528244018555],
          [73.35764312744152, 16.521530151367131],
          [73.35764312744152, 16.520969390869197],
          [73.35819244384794, 16.520969390869197],
          [73.35819244384794, 16.520694732666016],
          [73.358749389648722, 16.520694732666016],
          [73.358749389648722, 16.520416259765625],
          [73.359306335449276, 16.520420074462947],
          [73.359306335449276, 16.520141601562557],
          [73.359580993652514, 16.520141601562557],
          [73.359580993652514, 16.519580841064453],
          [73.359863281250227, 16.519582748413029],
          [73.359863281250227, 16.519306182861442],
          [73.360420227050838, 16.519311904907227],
          [73.360420227050838, 16.519018173217717],
          [73.360969543457088, 16.519027709961051],
          [73.360969543457088, 16.518749237060661],
          [73.361526489257813, 16.518749237060661],
          [73.361526489257813, 16.51847076416027],
          [73.362083435058764, 16.518472671508846],
          [73.362083435058764, 16.518194198608512],
          [73.362358093261776, 16.518194198608512],
          [73.362358093261776, 16.517915725708121],
          [73.362640380859546, 16.517917633056697],
          [73.362640380859546, 16.517639160156307],
          [73.362922668457088, 16.517639160156307],
          [73.362922668457088, 16.517360687255916],
          [73.363197326660327, 16.517360687255916],
          [73.363197326660327, 16.516529083251953],
          [73.36347961425804, 16.516529083251953],
          [73.36347961425804, 16.515960693359489],
          [73.364028930664119, 16.515972137451172],
          [73.364028930664119, 16.513196945190487],
          [73.36374664306652, 16.513210296630973],
          [73.36374664306652, 16.512639999389705],
          [73.36347961425804, 16.512639999389705],
          [73.36347961425804, 16.511810302734318],
          [73.362922668457088, 16.511810302734318],
          [73.362922668457088, 16.511529922485352],
          [73.362640380859546, 16.511529922485352],
          [73.362640380859546, 16.511249542236385],
          [73.361526489257813, 16.511249542236385],
          [73.361526489257813, 16.510971069335994],
          [73.360420227050838, 16.510974884033203],
          [73.360420227050838, 16.510694503784237],
          [73.359024047851733, 16.510694503784237],
          [73.359024047851733, 16.510416030883846],
          [73.35819244384794, 16.510419845580998],
          [73.35819244384794, 16.510150909423942],
          [73.357917785644588, 16.510150909423942],
          [73.357917785644588, 16.509862899780217],
          [73.357360839843807, 16.509862899780217],
          [73.357360839843807, 16.509580612182674],
          [73.356529235840014, 16.509580612182674],
          [73.356529235840014, 16.509027481079102],
          [73.355422973632812, 16.509029388427848],
          [73.355422973632812, 16.50875282287609],
          [73.354309082031307, 16.50875282287609],
          [73.354309082031307, 16.50847053527832],
          [73.353195190429744, 16.50847053527832],
          [73.353195190429744, 16.507917404174918],
          [73.351806640625, 16.50792121887207],
          [73.351806640625, 16.507642745971737],
          [73.351249694824276, 16.507642745971737],
          [73.351249694824276, 16.507362365722713],
          [73.350692749023494, 16.507362365722713],
          [73.350692749023494, 16.507080078125],
          [73.350135803222884, 16.507083892822379],
          [73.350135803222884, 16.506805419921989],
          [73.349861145019702, 16.506811141967717],
          [73.349861145019702, 16.50653076171875],
          [73.349296569824389, 16.50653076171875],
          [73.349296569824389, 16.506248474121207],
          [73.349029541015909, 16.506248474121207],
          [73.349029541015909, 16.504301071167106],
          [73.349861145019702, 16.504304885864315],
          [73.349861145019702, 16.504861831665039],
          [73.350135803222884, 16.504859924316463],
          [73.350135803222884, 16.505699157714787],
          [73.350418090820483, 16.505695343017635],
          [73.350418090820483, 16.505971908569393],
          [73.350692749023494, 16.50596809387207],
          [73.350692749023494, 16.506248474121207],
          [73.351249694824276, 16.506248474121207],
          [73.351249694824276, 16.50653076171875],
          [73.351806640625, 16.50653076171875],
          [73.351806640625, 16.506811141967717],
          [73.352363586425781, 16.506805419921989],
          [73.352363586425781, 16.507083892822379],
          [73.354026794433537, 16.507080078125],
          [73.354026794433537, 16.507362365722713],
          [73.354576110840128, 16.507362365722713],
          [73.354576110840128, 16.507080078125],
          [73.35514068603544, 16.507080078125],
          [73.35514068603544, 16.507362365722713],
          [73.355972290039233, 16.507362365722713],
          [73.355972290039233, 16.507642745971737],
          [73.357086181640568, 16.507642745971737],
          [73.357086181640568, 16.50792121887207],
          [73.357360839843807, 16.507917404174918],
          [73.357360839843807, 16.50819206237793],
          [73.357917785644588, 16.50819206237793],
          [73.357917785644588, 16.50847053527832],
          [73.358749389648722, 16.50847053527832],
          [73.358749389648722, 16.509029388427848],
          [73.359580993652514, 16.509029388427848],
          [73.359580993652514, 16.509309768676815],
          [73.360137939453068, 16.509305953979492],
          [73.360137939453068, 16.509580612182674],
          [73.360466003418253, 16.509580612182674],
          [73.360687255859489, 16.509580612182674],
          [73.360687255859489, 16.509862899780217],
          [73.362075805664233, 16.509862899780217],
          [73.362075805664233, 16.510150909423942],
          [73.36429595947294, 16.510150909423942],
          [73.36429595947294, 16.510419845580998],
          [73.365135192871264, 16.510416030883846],
          [73.365135192871264, 16.510694503784237],
          [73.365417480469034, 16.510694503784237],
          [73.365417480469034, 16.510974884033203],
          [73.365692138672046, 16.510971069335994],
          [73.365692138672046, 16.511249542236385],
          [73.365974426269588, 16.511249542236385],
          [73.365974426269588, 16.512170791626033],
          [73.365974426269588, 16.512361526489315],
          [73.366516113281307, 16.512359619140739],
          [73.366516113281307, 16.512920379638672],
          [73.366806030273381, 16.512920379638672],
          [73.366806030273381, 16.513210296630973],
          [73.367362976074332, 16.513210296630973],
          [73.367362976074332, 16.512920379638672],
          [73.367919921875284, 16.512920379638672],
          [73.367919921875284, 16.512639999389705],
          [73.368469238281534, 16.512639999389705],
          [73.368469238281534, 16.512081146240348],
          [73.368751525879077, 16.512083053588924],
          [73.368751525879077, 16.511760711669922],
          [73.368751525879077, 16.511528015136776],
          [73.369026184082088, 16.511529922485352],
          [73.369026184082088, 16.510971069335994],
          [73.370140075683651, 16.510971069335994],
          [73.370140075683651, 16.511249542236385],
          [73.372917175292912, 16.511249542236385],
          [73.372917175292912, 16.511529922485352],
          [73.373748779296932, 16.511528015136776],
          [73.373748779296932, 16.51180458068859],
          [73.374305725097656, 16.51180458068859],
          [73.374305725097656, 16.511528015136776],
          [73.375419616699389, 16.511529922485352],
          [73.375419616699389, 16.511249542236385],
          [73.37568664550804, 16.511249542236385],
          [73.37568664550804, 16.511529922485352],
          [73.376525878906364, 16.511528015136776],
          [73.376525878906364, 16.511800765991211],
          [73.378753662109432, 16.511806488037166],
          [73.378753662109432, 16.512083053588924],
          [73.379302978515682, 16.512083053588924],
          [73.379302978515682, 16.511806488037166],
          [73.379859924316463, 16.511806488037166],
          [73.379859924316463, 16.512083053588924],
          [73.381530761718921, 16.512083053588924],
          [73.381530761718921, 16.512361526489315],
          [73.381805419921932, 16.512361526489315],
          [73.381805419921932, 16.512083053588924],
          [73.382080078125171, 16.512083053588924],
          [73.382080078125171, 16.511806488037166],
          [73.383186340332315, 16.511800765991211],
          [73.383193969726676, 16.511528015136776],
          [73.383468627929688, 16.511529922485352],
          [73.383468627929688, 16.511249542236385],
          [73.383750915527628, 16.511249542236385],
          [73.383750915527628, 16.510971069335994],
          [73.384307861328409, 16.510974884033203],
          [73.384307861328409, 16.510694503784237],
          [73.384582519531421, 16.510694503784237],
          [73.384582519531421, 16.510416030883846],
          [73.385139465332202, 16.510419845580998],
          [73.385139465332202, 16.510150909423942],
          [73.385971069335994, 16.510150909423942],
          [73.385971069335994, 16.509862899780217],
          [73.386802673340128, 16.509862899780217],
          [73.386802673340128, 16.510150909423942],
          [73.388191223144702, 16.510150909423942],
          [73.388191223144702, 16.509862899780217],
          [73.39013671875, 16.509862899780217],
          [73.39013671875, 16.513992309570369],
          [73.39013671875, 16.514310836791992],
          [73.389312744140568, 16.514310836791992],
          [73.389312744140568, 16.514030456543026],
          [73.389030456543026, 16.514030456543026],
          [73.389030456543026, 16.513469696044922],
          [73.388748168945256, 16.513471603393498],
          [73.388748168945256, 16.513196945190487],
          [73.387641906738452, 16.513196945190487],
          [73.387641906738452, 16.513471603393498],
          [73.386802673340128, 16.513469696044922],
          [73.386802673340128, 16.513750076294059],
          [73.385406494140682, 16.513750076294059],
          [73.385406494140682, 16.514030456543026],
          [73.384857177734432, 16.514030456543026],
          [73.384857177734432, 16.514310836791992],
          [73.384307861328409, 16.514305114746094],
          [73.384300231933878, 16.515130996704102],
          [73.384025573730469, 16.515138626098633],
          [73.384033203125, 16.515291213989201],
          [73.384033203125, 16.515420913696346],
          [73.383750915527628, 16.515415191650447],
          [73.383750915527628, 16.515693664550781],
          [73.383468627929688, 16.515693664550781],
          [73.383468627929688, 16.515972137451172],
          [73.383186340332315, 16.515960693359489],
          [73.383186340332315, 16.516250610351563],
          [73.382919311523494, 16.516250610351563],
          [73.382919311523494, 16.51680946350092],
          [73.382080078125171, 16.516805648803768],
          [73.382080078125171, 16.517084121704158],
          [73.380912780761832, 16.517084121704158],
          [73.380416870117187, 16.517084121704158],
          [73.380416870117187, 16.516805648803768],
          [73.379859924316463, 16.51680946350092],
          [73.379859924316463, 16.516529083251953],
          [73.378746032715071, 16.516529083251953],
          [73.378746032715071, 16.51680946350092],
          [73.378456115722827, 16.51680946350092],
          [73.378456115722827, 16.516529083251953],
          [73.376808166503963, 16.516529083251953],
          [73.376808166503963, 16.51680946350092],
          [73.376525878906364, 16.516805648803768],
          [73.376525878906364, 16.517084121704158],
          [73.37568664550804, 16.51708030700695],
          [73.37568664550804, 16.517360687255916],
          [73.375419616699389, 16.517360687255916],
          [73.375419616699389, 16.517639160156307],
          [73.375137329101619, 16.517639160156307],
          [73.375137329101619, 16.517917633056697],
          [73.374862670898608, 16.517917633056697],
          [73.374862670898608, 16.518194198608512],
          [73.374580383301065, 16.518194198608512],
          [73.374580383301065, 16.518472671508846],
          [73.374313354492188, 16.51847076416027],
          [73.374313354492188, 16.518749237060661],
          [73.373748779296932, 16.518749237060661],
          [73.373748779296932, 16.519027709961051],
          [73.373191833496151, 16.519018173217717],
          [73.373191833496151, 16.519311904907227],
          [73.372642517090071, 16.519306182861442],
          [73.372642517090071, 16.519582748413029],
          [73.372360229492358, 16.519580841064453],
          [73.372360229492358, 16.519859313964844],
          [73.371528625488565, 16.519859313964844],
          [73.371528625488565, 16.520141601562557],
          [73.370697021484432, 16.520141601562557],
          [73.370697021484432, 16.520420074462947],
          [73.370414733886832, 16.520416259765625],
          [73.370414733886832, 16.520694732666016],
          [73.369857788085881, 16.520694732666016],
          [73.369857788085881, 16.520969390869197],
          [73.36958312988304, 16.520969390869197],
          [73.36958312988304, 16.521530151367131],
          [73.369026184082088, 16.521528244018555],
          [73.369026184082088, 16.521804809570369],
          [73.368186950683764, 16.521802902221737],
          [73.368186950683764, 16.522092819213867],
          [73.367637634277344, 16.522081375122127],
          [73.367637634277344, 16.522363662719727],
          [73.367080688476619, 16.522361755371094],
          [73.367080688476619, 16.522640228271484],
          [73.366516113281307, 16.522640228271484],
          [73.366516113281307, 16.522920608520451],
          [73.366249084472827, 16.522920608520451],
          [73.366249084472827, 16.523202896118221],
          [73.365417480469034, 16.52319526672369],
          [73.365417480469034, 16.52347373962408],
          [73.364860534668253, 16.523469924926871],
          [73.364860534668253, 16.523750305175838],
          [73.36374664306652, 16.523750305175838],
          [73.36374664306652, 16.524030685424805],
          [73.36347961425804, 16.524030685424805],
          [73.36347961425804, 16.524311065673771],
          [73.362915039062727, 16.524305343628043],
          [73.362915039062727, 16.52458572387701],
          [73.362640380859546, 16.524580001831055],
          [73.362640380859546, 16.525150299072322],
          [73.361808776855753, 16.525150299072322],
          [73.361808776855753, 16.525421142578125],
          [73.361251831054972, 16.525417327880973],
          [73.361251831054972, 16.525695800781364],
          [73.360618591308821, 16.525695800781364],
          [73.359580993652514, 16.525695800781364],
          [73.359580993652514, 16.525972366332951],
          [73.359016418457202, 16.525970458984375],
          [73.359016418457202, 16.526250839233342],
          [73.357917785644588, 16.526250839233342],
          [73.357917785644588, 16.526809692382869],
          [73.357635498046989, 16.526805877685547],
          [73.35764312744152, 16.527360916137695],
          [73.357360839843807, 16.527360916137695],
          [73.357360839843807, 16.52874946594244],
          [73.355972290039233, 16.52874946594244],
          [73.355972290039233, 16.529029846191406],
          [73.355697631836222, 16.52902793884283],
          [73.355697631836222, 16.529582977294979],
          [73.355422973632812, 16.529581069946403],
          [73.355422973632812, 16.53013992309576],
          [73.35514068603544, 16.530136108398437],
          [73.35514068603544, 16.530971527099553],
          [73.3548583984375, 16.530971527099553],
          [73.3548583984375, 16.532083511352482],
          [73.35514068603544, 16.53207969665533],
          [73.35514068603544, 16.532638549804687],
          [73.355422973632812, 16.532638549804687],
          [73.355422973632812, 16.532920837402401],
          [73.355697631836222, 16.532917022705078],
          [73.355697631836222, 16.533470153808651],
          [73.355422973632812, 16.533468246460075],
          [73.355422973632812, 16.534032821655387],
          [73.35514068603544, 16.534032821655387],
          [73.35514068603544, 16.534862518310547],
          [73.3548583984375, 16.534862518310547],
          [73.3548583984375, 16.535419464111328],
          [73.354583740234489, 16.535417556762752],
          [73.354583740234489, 16.535972595214901],
          [73.354309082031307, 16.535972595214901],
          [73.354309082031307, 16.537639617920036],
          [73.354026794433537, 16.537639617920036],
          [73.354026794433537, 16.539030075073185],
          [73.354309082031307, 16.539028167724609],
          [73.354309082031307, 16.539304733276424],
          [73.3548583984375, 16.539304733276424],
          [73.3548583984375, 16.539583206176758],
          [73.355415344238281, 16.539583206176758],
          [73.355415344238281, 16.539762496948356],
          [73.355415344238281, 16.539861679077148],
          [73.357086181640568, 16.539861679077148],
          [73.357086181640568, 16.539583206176758],
          [73.357917785644588, 16.539583206176758],
          [73.357917785644588, 16.539304733276424],
          [73.35819244384794, 16.539304733276424],
          [73.35819244384794, 16.539028167724609],
          [73.358467102050781, 16.539030075073185],
          [73.358467102050781, 16.538749694824219],
          [73.359306335449276, 16.538749694824219],
          [73.359306335449276, 16.539030075073185],
          [73.359580993652514, 16.539028167724609],
          [73.359580993652514, 16.539304733276424],
          [73.359863281250227, 16.539304733276424],
          [73.359863281250227, 16.539583206176758],
          [73.360420227050838, 16.539583206176758],
          [73.360420227050838, 16.539861679077148],
          [73.361526489257813, 16.539861679077148],
          [73.361526489257813, 16.539583206176758],
          [73.362083435058764, 16.539583206176758],
          [73.362083435058764, 16.539861679077148],
          [73.362358093261776, 16.539861679077148],
          [73.362358093261776, 16.539583206176758],
          [73.366249084472827, 16.539583206176758],
          [73.366249084472827, 16.540971755981502],
          [73.365966796875227, 16.540969848632926],
          [73.365966796875227, 16.541250228881893],
          [73.365692138672046, 16.541250228881893],
          [73.365692138672046, 16.541530609130859],
          [73.366249084472827, 16.541530609130859],
          [73.366249084472827, 16.541810989379826],
          [73.36653137207054, 16.541805267334098],
          [73.36653137207054, 16.542083740234489],
          [73.366806030273381, 16.542079925537109],
          [73.366806030273381, 16.542360305786246],
          [73.367362976074332, 16.542360305786246],
          [73.367362976074332, 16.542640686035213],
          [73.368469238281534, 16.542640686035213],
          [73.368469238281534, 16.542360305786246],
          [73.368751525879077, 16.542360305786246],
          [73.368751525879077, 16.542079925537109],
          [73.369026184082088, 16.542083740234489],
          [73.369026184082088, 16.541805267334098],
          [73.369308471679858, 16.541810989379826],
          [73.369308471679858, 16.541530609130859],
          [73.36958312988304, 16.541530609130859],
          [73.36958312988304, 16.541250228881893],
          [73.369857788085881, 16.541250228881893],
          [73.369857788085881, 16.540969848632926],
          [73.370414733886832, 16.540971755981502],
          [73.370414733886832, 16.540695190429744],
          [73.370697021484432, 16.5407009124757],
          [73.370697021484432, 16.540420532226506],
          [73.370971679687784, 16.540420532226506],
          [73.370971679687784, 16.539859771728572],
          [73.371246337890625, 16.539861679077148],
          [73.371246337890625, 16.539583206176758],
          [73.371528625488565, 16.539583206176758],
          [73.371528625488565, 16.539304733276424],
          [73.372085571289119, 16.539304733276424],
          [73.372085571289119, 16.539028167724609],
          [73.372360229492358, 16.539030075073185],
          [73.372360229492358, 16.538749694824219],
          [73.372642517090071, 16.538749694824219],
          [73.372642517090071, 16.539304733276424],
          [73.372917175292912, 16.539304733276424],
          [73.372917175292912, 16.539861679077148],
          [73.372650146484432, 16.539859771728572],
          [73.372650146484432, 16.540420532226506],
          [73.371803283691577, 16.540420532226506],
          [73.371803283691577, 16.5407009124757],
          [73.371246337890625, 16.540695190429744],
          [73.371246337890625, 16.540971755981502],
          [73.370971679687784, 16.540969848632926],
          [73.370971679687784, 16.541250228881893],
          [73.370697021484432, 16.541250228881893],
          [73.370697021484432, 16.541810989379826],
          [73.370414733886832, 16.541805267334098],
          [73.370414733886832, 16.542083740234489],
          [73.369857788085881, 16.542079925537109],
          [73.369857788085881, 16.542360305786246],
          [73.36958312988304, 16.542360305786246],
          [73.36958312988304, 16.542640686035213],
          [73.369308471679858, 16.542640686035213],
          [73.369308471679858, 16.54292106628418],
          [73.369026184082088, 16.542917251587028],
          [73.369026184082088, 16.543193817138615],
          [73.368751525879077, 16.543193817138615],
          [73.368751525879077, 16.543472290039006],
          [73.368469238281534, 16.54347038269043],
          [73.368469238281534, 16.543750762939396],
          [73.368186950683764, 16.543750762939396],
          [73.368186950683764, 16.544031143188533],
          [73.367919921875284, 16.544027328491211],
          [73.367919921875284, 16.544750213623047],
          [73.367919921875284, 16.54486083984375],
          [73.367080688476619, 16.54486083984375],
          [73.367080688476619, 16.5447292327882],
          [73.367080688476619, 16.544584274291992],
          [73.366806030273381, 16.544584274291992],
          [73.366806030273381, 16.544027328491211],
          [73.366516113281307, 16.544031143188533],
          [73.366516113281307, 16.543750762939396],
          [73.365966796875227, 16.543750762939396],
          [73.365966796875227, 16.54347038269043],
          [73.365417480469034, 16.543472290039006],
          [73.365417480469034, 16.543193817138615],
          [73.365135192871264, 16.543193817138615],
          [73.365135192871264, 16.542917251587028],
          [73.364860534668253, 16.54292106628418],
          [73.364860534668253, 16.542640686035213],
          [73.36429595947294, 16.542640686035213],
          [73.36429595947294, 16.542360305786246],
          [73.363670349121321, 16.542360305786246],
          [73.363197326660327, 16.542360305786246],
          [73.363197326660327, 16.542079925537109],
          [73.362915039062727, 16.542083740234489],
          [73.362922668457088, 16.542360305786246],
          [73.362358093261776, 16.542360305786246],
          [73.362358093261776, 16.542640686035213],
          [73.361526489257813, 16.542640686035213],
          [73.361526489257813, 16.542360305786246],
          [73.360687255859489, 16.542360305786246],
          [73.360687255859489, 16.542640686035213],
          [73.359580993652514, 16.542640686035213],
          [73.359580993652514, 16.541250228881893],
          [73.359306335449276, 16.541250228881893],
          [73.359306335449276, 16.540969848632926],
          [73.359024047851733, 16.540971755981502],
          [73.359024047851733, 16.540695190429744],
          [73.358474731445313, 16.540695190429744],
          [73.358474731445313, 16.540971755981502],
          [73.357635498046989, 16.540971755981502],
          [73.35764312744152, 16.541250228881893],
          [73.357086181640568, 16.541250228881893],
          [73.357086181640568, 16.541530609130859],
          [73.356529235840014, 16.541530609130859],
          [73.356529235840014, 16.541810989379826],
          [73.35514068603544, 16.541810989379826],
          [73.35514068603544, 16.541530609130859],
          [73.3548583984375, 16.541530609130859],
          [73.3548583984375, 16.541810989379826],
          [73.354736328125284, 16.541805267334098],
          [73.354583740234489, 16.541805267334098],
          [73.354583740234489, 16.542083740234489],
          [73.354026794433537, 16.542079925537109],
          [73.354026794433537, 16.542360305786246],
          [73.353752136230696, 16.542360305786246],
          [73.353752136230696, 16.543472290039006],
          [73.353469848632983, 16.54347038269043],
          [73.353469848632983, 16.543750762939396],
          [73.35263824462919, 16.543750762939396],
          [73.35263824462919, 16.54347038269043],
          [73.352081298828409, 16.543472290039006],
          [73.352081298828409, 16.543193817138615],
          [73.351806640625, 16.543193817138615],
          [73.351806640625, 16.543472290039006],
          [73.350692749023494, 16.54347038269043],
          [73.350692749023494, 16.543750762939396],
          [73.350418090820483, 16.543750762939396],
          [73.350418090820483, 16.544584274291992],
          [73.350135803222884, 16.544580459594783],
          [73.350135803222884, 16.545139312744141],
          [73.349861145019702, 16.545139312744141],
          [73.349861145019702, 16.545421600341911],
          [73.34958648681669, 16.545415878295955],
          [73.34958648681669, 16.54597282409668],
          [73.349296569824389, 16.545970916748104],
          [73.349296569824389, 16.546262741088981],
          [73.349029541015909, 16.546262741088981],
          [73.349029541015909, 16.546531677246037],
          [73.348747253417969, 16.546531677246037],
          [73.348747253417969, 16.546810150146428],
          [73.349029541015909, 16.546806335449276],
          [73.349029541015909, 16.547082901001033],
          [73.348747253417969, 16.547079086303711],
          [73.348747253417969, 16.547641754150391],
          [73.349296569824389, 16.547641754150391],
          [73.349296569824389, 16.547920227050781],
          [73.34958648681669, 16.547916412353629],
          [73.34958648681669, 16.54819488525402],
          [73.349296569824389, 16.548189163208065],
          [73.349296569824389, 16.549320220947266],
          [73.34958648681669, 16.54930305480957],
          [73.34958648681669, 16.549583435058537],
          [73.349861145019702, 16.549583435058537],
          [73.349861145019702, 16.549863815307731],
          [73.350906372070369, 16.549863815307731],
          [73.352081298828409, 16.549861907958928],
          [73.352081298828409, 16.550140380859318],
          [73.352355957031421, 16.550140380859318],
          [73.352355957031421, 16.550420761108455],
          [73.352081298828409, 16.550416946411133],
          [73.352081298828409, 16.550689697265739],
          [73.351806640625, 16.550695419311523],
          [73.351806640625, 16.550973892211914],
          [73.351249694824276, 16.550973892211914],
          [73.351249694824276, 16.550695419311523],
          [73.350692749023494, 16.550695419311523],
          [73.350692749023494, 16.550973892211914],
          [73.350418090820483, 16.550970077514705],
          [73.350418090820483, 16.551250457763672],
          [73.350242614746264, 16.551250457763672],
          [73.34958648681669, 16.551250457763672],
          [73.34958648681669, 16.551530838012638],
          [73.349029541015909, 16.551530838012638],
          [73.349029541015909, 16.551250457763672],
          [73.348197937011776, 16.551250457763672],
          [73.348197937011776, 16.551530838012638],
          [73.347358703613224, 16.551530838012638],
          [73.347358703613224, 16.551811218261832],
          [73.347076416015852, 16.551811218261832],
          [73.347076416015852, 16.552360534668026],
          [73.346809387207202, 16.552360534668026],
          [73.346801757812671, 16.552640914916992],
          [73.346527099609432, 16.552639007568416],
          [73.346527099609432, 16.553195953369197],
          [73.346252441406421, 16.553190231323242],
          [73.346252441406421, 16.553750991821346],
          [73.345970153808878, 16.55374908447277],
          [73.345970153808878, 16.555694580078125],
          [73.345695495605469, 16.555694580078125],
          [73.345695495605469, 16.555820465087891],
          [73.345703125, 16.556528091430664],
          [73.345970153808878, 16.556526184082088],
          [73.345970153808878, 16.556804656982479],
          [73.346252441406421, 16.556804656982479],
          [73.346252441406421, 16.557083129882812],
          [73.350135803222884, 16.557083129882812],
          [73.350135803222884, 16.557361602783203],
          [73.351524353027628, 16.557361602783203],
          [73.351524353027628, 16.557083129882812],
          [73.352081298828409, 16.557083129882812],
          [73.352081298828409, 16.556804656982479],
          [73.352363586425781, 16.556804656982479],
          [73.352363586425781, 16.556526184082088],
          [73.35263824462919, 16.556528091430664],
          [73.35263824462919, 16.556249618530273],
          [73.352912902832202, 16.556249618530273],
          [73.352912902832202, 16.555971145629883],
          [73.353195190429744, 16.555973052978459],
          [73.353195190429744, 16.555416107177734],
          [73.353469848632983, 16.555419921875057],
          [73.353469848632983, 16.555130004882812],
          [73.354026794433537, 16.55513954162609],
          [73.354026794433537, 16.554861068725529],
          [73.354309082031307, 16.554861068725529],
          [73.354309082031307, 16.554580688476562],
          [73.354583740234489, 16.554582595825138],
          [73.354583740234489, 16.554307937622127],
          [73.35514068603544, 16.554309844970703],
          [73.35514068603544, 16.554029464721737],
          [73.355972290039233, 16.554029464721737],
          [73.355972290039233, 16.553750991821346],
          [73.356246948242244, 16.553750991821346],
          [73.356246948242244, 16.553190231323242],
          [73.356529235840014, 16.553195953369197],
          [73.356529235840014, 16.552917480468807],
          [73.356796264648494, 16.552919387817383],
          [73.356796264648494, 16.552640914916992],
          [73.357360839843807, 16.552640914916992],
          [73.357360839843807, 16.552919387817383],
          [73.357917785644588, 16.552917480468807],
          [73.357917785644588, 16.553195953369197],
          [73.35819244384794, 16.553195953369197],
          [73.35819244384794, 16.552917480468807],
          [73.358749389648722, 16.552919387817383],
          [73.358749389648722, 16.552640914916992],
          [73.359016418457202, 16.552640914916992],
          [73.359016418457202, 16.552360534668026],
          [73.359306335449276, 16.552360534668026],
          [73.359306335449276, 16.552070617675781],
          [73.359580993652514, 16.552085876464844],
          [73.359580993652514, 16.551805496215877],
          [73.359863281250227, 16.551811218261832],
          [73.359863281250227, 16.551530838012638],
          [73.360137939453068, 16.551530838012638],
          [73.360137939453068, 16.551250457763672],
          [73.362358093261776, 16.551250457763672],
          [73.362358093261776, 16.551530838012638],
          [73.365966796875227, 16.551530838012638],
          [73.365966796875227, 16.551250457763672],
          [73.366249084472827, 16.551250457763672],
          [73.366249084472827, 16.551530838012638],
          [73.366806030273381, 16.551530838012638],
          [73.366806030273381, 16.551250457763672],
          [73.368469238281534, 16.551250457763672],
          [73.368469238281534, 16.550970077514705],
          [73.370414733886832, 16.550973892211914],
          [73.370414733886832, 16.550691604614315],
          [73.372917175292912, 16.550691604614315],
          [73.372917175292912, 16.550416946411133],
          [73.373466491699332, 16.550420761108455],
          [73.373466491699332, 16.550140380859318],
          [73.374580383301065, 16.550140380859318],
          [73.374580383301065, 16.550420761108455],
          [73.376808166503963, 16.550416946411133],
          [73.376808166503963, 16.550691604614315],
          [73.377082824707315, 16.550691604614315],
          [73.377082824707315, 16.550973892211914],
          [73.377357482910156, 16.550970077514705],
          [73.377357482910156, 16.551250457763672],
          [73.377639770508097, 16.551250457763672],
          [73.377639770508097, 16.552085876464844],
          [73.377357482910156, 16.552085876464844],
          [73.377357482910156, 16.553195953369197],
          [73.377639770508097, 16.553195953369197],
          [73.377639770508097, 16.553472518920955],
          [73.378196716308878, 16.553470611572379],
          [73.378196716308878, 16.553750991821346],
          [73.378746032715071, 16.553750991821346],
          [73.378746032715071, 16.554029464721737],
          [73.382080078125171, 16.554029464721737],
          [73.382080078125171, 16.554309844970703],
          [73.382637023925724, 16.554307937622127],
          [73.382637023925724, 16.554582595825138],
          [73.384307861328409, 16.554582595825138],
          [73.384307861328409, 16.554307937622127],
          [73.387649536132812, 16.554309844970703],
          [73.387649536132812, 16.554029464721737],
          [73.387992858886889, 16.554027557373161],
          [73.388191223144702, 16.554029464721737],
          [73.388191223144702, 16.553750991821346],
          [73.388748168945256, 16.553750991821346],
          [73.388748168945256, 16.553470611572379],
          [73.389579772949276, 16.553472518920955],
          [73.389579772949276, 16.553195953369197],
          [73.392639160156307, 16.553195953369197],
          [73.392639160156307, 16.552917480468807],
          [73.393196105957031, 16.552919387817383],
          [73.393196105957031, 16.552640914916992],
          [73.394027709961222, 16.552640914916992],
          [73.394027709961222, 16.553750991821346],
          [73.393753051757812, 16.553750991821346],
          [73.393753051757812, 16.554309844970703],
          [73.392913818359659, 16.554307937622127],
          [73.392913818359659, 16.554479598998967],
          [73.392913818359659, 16.554582595825138],
          [73.391525268554915, 16.554582595825138],
          [73.391532897949276, 16.554861068725529],
          [73.39013671875, 16.554861068725529],
          [73.39013671875, 16.554580688476562],
          [73.389862060547159, 16.554580688476562],
          [73.389862060547159, 16.554861068725529],
          [73.389030456543026, 16.554861068725529],
          [73.389030456543026, 16.55513954162609],
          [73.387359619140909, 16.555130004882812],
          [73.387359619140909, 16.555419921875057],
          [73.385971069335994, 16.555416107177734],
          [73.385971069335994, 16.555694580078125],
          [73.385414123535384, 16.555694580078125],
          [73.385414123535384, 16.555973052978459],
          [73.384307861328409, 16.555973052978459],
          [73.384307861328409, 16.555694580078125],
          [73.384025573730469, 16.555694580078125],
          [73.384025573730469, 16.555973052978459],
          [73.383186340332315, 16.555971145629883],
          [73.383186340332315, 16.556249618530273],
          [73.382362365722884, 16.556249618530273],
          [73.382362365722884, 16.555971145629883],
          [73.382080078125171, 16.555973052978459],
          [73.382080078125171, 16.555694580078125],
          [73.380973815917969, 16.555694580078125],
          [73.380973815917969, 16.555416107177734],
          [73.380691528320597, 16.555416107177734],
          [73.380691528320597, 16.555694580078125],
          [73.380416870117187, 16.555694580078125],
          [73.380416870117187, 16.555973052978459],
          [73.380691528320597, 16.555971145629883],
          [73.380691528320597, 16.556528091430664],
          [73.380973815917969, 16.556526184082088],
          [73.380973815917969, 16.556804656982479],
          [73.381248474121378, 16.556804656982479],
          [73.381248474121378, 16.557083129882812],
          [73.381530761718921, 16.557083129882812],
          [73.381530761718921, 16.557361602783203],
          [73.381248474121378, 16.557359695434627],
          [73.381248474121378, 16.557638168335018],
          [73.380691528320597, 16.557638168335018],
          [73.380691528320597, 16.557359695434627],
          [73.380142211914176, 16.557361602783203],
          [73.380142211914176, 16.557083129882812],
          [73.379859924316463, 16.557083129882812],
          [73.379859924316463, 16.556526184082088],
          [73.379028320312671, 16.556528091430664],
          [73.379028320312671, 16.556249618530273],
          [73.378456115722827, 16.556249618530273],
          [73.378456115722827, 16.555971145629883],
          [73.378196716308878, 16.555973052978459],
          [73.378196716308878, 16.555694580078125],
          [73.377914428711108, 16.555694580078125],
          [73.377914428711108, 16.555416107177734],
          [73.377639770508097, 16.555419921875057],
          [73.377639770508097, 16.554861068725529],
          [73.377357482910156, 16.554861068725529],
          [73.377357482910156, 16.554309844970703],
          [73.377082824707315, 16.554309844970703],
          [73.377082824707315, 16.554029464721737],
          [73.376808166503963, 16.554029464721737],
          [73.376808166503963, 16.553750991821346],
          [73.376525878906364, 16.553750991821346],
          [73.376525878906364, 16.553470611572379],
          [73.376251220703182, 16.553472518920955],
          [73.376251220703182, 16.553195953369197],
          [73.375968933105412, 16.553195953369197],
          [73.375968933105412, 16.552917480468807],
          [73.37568664550804, 16.552919387817383],
          [73.37568664550804, 16.552640914916992],
          [73.375137329101619, 16.552640914916992],
          [73.375137329101619, 16.552360534668026],
          [73.374862670898608, 16.552360534668026],
          [73.374862670898608, 16.552070617675781],
          [73.373748779296932, 16.552070617675781],
          [73.373748779296932, 16.552360534668026],
          [73.373466491699332, 16.552360534668026],
          [73.373466491699332, 16.552640914916992],
          [73.372650146484432, 16.552640914916992],
          [73.372650146484432, 16.552360534668026],
          [73.372085571289119, 16.552360534668026],
          [73.372085571289119, 16.552085876464844],
          [73.371528625488565, 16.552070617675781],
          [73.371528625488565, 16.552360534668026],
          [73.370971679687784, 16.552360534668026],
          [73.370971679687784, 16.552919387817383],
          [73.369026184082088, 16.552917480468807],
          [73.369026184082088, 16.553195953369197],
          [73.368194580078125, 16.553195953369197],
          [73.368194580078125, 16.553472518920955],
          [73.367080688476619, 16.553470611572379],
          [73.367080688476619, 16.553750991821346],
          [73.366516113281307, 16.553750991821346],
          [73.366516113281307, 16.554029464721737],
          [73.366355895996151, 16.554029464721737],
          [73.366249084472827, 16.554029464721737],
          [73.366249084472827, 16.554309844970703],
          [73.365417480469034, 16.554309844970703],
          [73.365417480469034, 16.554029464721737],
          [73.365142822265625, 16.554029464721737],
          [73.365142822265625, 16.553750991821346],
          [73.36429595947294, 16.553750991821346],
          [73.36429595947294, 16.553470611572379],
          [73.36374664306652, 16.553470611572379],
          [73.36374664306652, 16.553750991821346],
          [73.362640380859546, 16.553750991821346],
          [73.362640380859546, 16.554029464721737],
          [73.362358093261776, 16.554027557373161],
          [73.362358093261776, 16.554582595825138],
          [73.361526489257813, 16.554582595825138],
          [73.361526489257813, 16.554307937622127],
          [73.36069488525402, 16.554307937622127],
          [73.36069488525402, 16.554582595825138],
          [73.360420227050838, 16.554580688476562],
          [73.360420227050838, 16.554861068725529],
          [73.360137939453068, 16.554861068725529],
          [73.360137939453068, 16.55513954162609],
          [73.359306335449276, 16.555130004882812],
          [73.359306335449276, 16.555419921875057],
          [73.358474731445313, 16.555416107177734],
          [73.358474731445313, 16.555694580078125],
          [73.35819244384794, 16.555694580078125],
          [73.35819244384794, 16.555973052978459],
          [73.357917785644588, 16.555971145629883],
          [73.357917785644588, 16.556249618530273],
          [73.357635498046989, 16.556249618530273],
          [73.357635498046989, 16.555973052978459],
          [73.357086181640568, 16.555973052978459],
          [73.357086181640568, 16.555694580078125],
          [73.356803894043196, 16.555694580078125],
          [73.356803894043196, 16.555416107177734],
          [73.356246948242244, 16.555416107177734],
          [73.356246948242244, 16.555694580078125],
          [73.355972290039233, 16.555694580078125],
          [73.355972290039233, 16.555973052978459],
          [73.355697631836222, 16.555971145629883],
          [73.355697631836222, 16.556528091430664],
          [73.355415344238281, 16.556526184082088],
          [73.355415344238281, 16.557361602783203],
          [73.355697631836222, 16.557359695434627],
          [73.355697631836222, 16.557638168335018],
          [73.355972290039233, 16.557638168335018],
          [73.355972290039233, 16.558200836181754],
          [73.356246948242244, 16.558200836181754],
          [73.356246948242244, 16.558748245239371],
          [73.356529235840014, 16.558748245239371],
          [73.356529235840014, 16.56069374084467],
          [73.356246948242244, 16.56069374084467],
          [73.356246948242244, 16.560970306396484],
          [73.356529235840014, 16.560970306396484],
          [73.356529235840014, 16.561531066894588],
          [73.356796264648494, 16.561531066894588],
          [73.356796264648494, 16.562641143798771],
          [73.356529235840014, 16.562641143798771],
          [73.356529235840014, 16.562919616699162],
          [73.356246948242244, 16.56291580200201],
          [73.356246948242244, 16.563194274902401],
          [73.355972290039233, 16.563190460205192],
          [73.355972290039233, 16.564029693603516],
          [73.355697631836222, 16.564029693603516],
          [73.355697631836222, 16.564319610595817],
          [73.355415344238281, 16.56430625915533],
          [73.355415344238281, 16.564584732055721],
          [73.35514068603544, 16.564582824707088],
          [73.35514068603544, 16.565139770507869],
          [73.3548583984375, 16.565139770507869],
          [73.3548583984375, 16.565971374511662],
          [73.35514068603544, 16.565969467163086],
          [73.35514068603544, 16.566249847412223],
          [73.356796264648494, 16.566249847412223],
          [73.356796264648494, 16.56653022766119],
          [73.357086181640568, 16.56653022766119],
          [73.357086181640568, 16.566249847412223],
          [73.357337951660156, 16.566249847412223],
          [73.357360839843807, 16.56653022766119],
          [73.358467102050781, 16.56653022766119],
          [73.358467102050781, 16.566249847412223],
          [73.358749389648722, 16.566249847412223],
          [73.358749389648722, 16.565969467163086],
          [73.359863281250227, 16.565969467163086],
          [73.359863281250227, 16.566249847412223],
          [73.360420227050838, 16.566249847412223],
          [73.360420227050838, 16.56653022766119],
          [73.360969543457088, 16.56653022766119],
          [73.360969543457088, 16.566249847412223],
          [73.362083435058764, 16.566249847412223],
          [73.362083435058764, 16.566806793213004],
          [73.362358093261776, 16.566806793213004],
          [73.362358093261776, 16.568471908569336],
          [73.361808776855753, 16.568471908569336],
          [73.361808776855753, 16.568195343017578],
          [73.361526489257813, 16.568201065063533],
          [73.361526489257813, 16.56792068481451],
          [73.361251831054972, 16.56792068481451],
          [73.361251831054972, 16.567640304565373],
          [73.360420227050838, 16.567640304565373],
          [73.360420227050838, 16.567359924316406],
          [73.359863281250227, 16.567359924316406],
          [73.359863281250227, 16.567640304565373],
          [73.359016418457202, 16.567640304565373],
          [73.359016418457202, 16.568201065063533],
          [73.358749389648722, 16.568195343017578],
          [73.358749389648722, 16.568471908569336],
          [73.357505798340014, 16.568471908569336],
          [73.357360839843807, 16.568471908569336],
          [73.357360839843807, 16.567916870117188],
          [73.356529235840014, 16.56792068481451],
          [73.356529235840014, 16.567640304565373],
          [73.35514068603544, 16.567640304565373],
          [73.35514068603544, 16.567359924316406],
          [73.3548583984375, 16.567361831664982],
          [73.3548583984375, 16.567083358764592],
          [73.354583740234489, 16.567083358764592],
          [73.354583740234489, 16.566806793213004],
          [73.354309082031307, 16.566806793213004],
          [73.354309082031307, 16.565971374511662],
          [73.354026794433537, 16.565971374511662],
          [73.354026794433537, 16.565694808960075],
          [73.353752136230696, 16.565694808960075],
          [73.353752136230696, 16.565139770507869],
          [73.353469848632983, 16.565139770507869],
          [73.353469848632983, 16.564582824707088],
          [73.352912902832202, 16.564584732055721],
          [73.352912902832202, 16.56430625915533],
          [73.352081298828409, 16.56430625915533],
          [73.352081298828409, 16.564861297607479],
          [73.351516723633097, 16.564859390258903],
          [73.351516723633097, 16.565139770507869],
          [73.348747253417969, 16.565139770507869],
          [73.348747253417969, 16.564859390258903],
          [73.347915649414176, 16.564861297607479],
          [73.347915649414176, 16.564584732055721],
          [73.346809387207202, 16.564584732055721],
          [73.346801757812671, 16.564861297607479],
          [73.346527099609432, 16.564859390258903],
          [73.346527099609432, 16.565139770507869],
          [73.345420837402628, 16.565139770507869],
          [73.345420837402628, 16.565420150756836],
          [73.344581604003963, 16.565416336059684],
          [73.344581604003963, 16.565694808960075],
          [73.343750000000171, 16.565694808960075],
          [73.343750000000171, 16.565971374511662],
          [73.343193054199389, 16.565969467163086],
          [73.343193054199389, 16.566249847412223],
          [73.342636108398437, 16.566249847412223],
          [73.342636108398437, 16.566806793213004],
          [73.342361450195597, 16.566806793213004],
          [73.342361450195597, 16.567083358764592],
          [73.342086791992244, 16.567070007324332],
          [73.342086791992244, 16.56792068481451],
          [73.342361450195597, 16.567916870117188],
          [73.342361450195597, 16.568471908569336],
          [73.342636108398437, 16.56847000122076],
          [73.342636108398437, 16.569030761718693],
          [73.342918395996378, 16.569030761718693],
          [73.342918395996378, 16.569311141967887],
          [73.343193054199389, 16.569311141967887],
          [73.343193054199389, 16.56986045837408],
          [73.34348297119169, 16.56986045837408],
          [73.34348297119169, 16.570421218872013],
          [73.343750000000171, 16.570417404174862],
          [73.343750000000171, 16.570693969726676],
          [73.344306945800724, 16.570690155029297],
          [73.344306945800724, 16.571250915527401],
          [73.344581604003963, 16.571250915527401],
          [73.344581604003963, 16.571527481079215],
          [73.344863891601676, 16.571527481079215],
          [73.344863891601676, 16.572082519531193],
          [73.345138549804744, 16.572080612182617],
          [73.345138549804744, 16.573749542236328],
          [73.344856262207145, 16.573749542236328],
          [73.344856262207145, 16.574031829834098],
          [73.344581604003963, 16.574031829834098],
          [73.344581604003963, 16.574310302734432],
          [73.344306945800724, 16.574306488037109],
          [73.344306945800724, 16.574581146240291],
          [73.344017028808651, 16.574579238891715],
          [73.344017028808651, 16.575420379638615],
          [73.344581604003963, 16.575420379638615],
          [73.344581604003963, 16.575700759887809],
          [73.344856262207145, 16.575700759887809],
          [73.344856262207145, 16.576259613037166],
          [73.344581604003963, 16.576259613037166],
          [73.344581604003963, 16.576530456542969],
          [73.344306945800724, 16.576530456542969],
          [73.344306945800724, 16.576810836791935],
          [73.344024658203352, 16.576805114746207],
          [73.344024658203352, 16.577083587646598],
          [73.343750000000171, 16.577083587646598],
          [73.343750000000171, 16.577362060546932],
          [73.34348297119169, 16.577360153198356],
          [73.34348297119169, 16.577640533447322],
          [73.343193054199389, 16.577640533447322],
          [73.343193054199389, 16.577920913696289],
          [73.342918395996378, 16.577917098999137],
          [73.342918395996378, 16.578472137451115],
          [73.342636108398437, 16.578470230102539],
          [73.342636108398437, 16.578750610351506],
          [73.342346191406534, 16.578750610351506],
          [73.342346191406534, 16.579030990600643],
          [73.342086791992244, 16.57902717590332],
          [73.342086791992244, 16.579305648803711],
          [73.341804504394645, 16.579305648803711],
          [73.341804504394645, 16.579584121704102],
          [73.341247558593693, 16.579580307006893],
          [73.341247558593693, 16.579860687255859],
          [73.340972900390852, 16.579860687255859],
          [73.340972900390852, 16.580141067504826],
          [73.340415954589901, 16.580141067504826],
          [73.340415954589901, 16.580419540405217],
          [73.339859008789347, 16.580419540405217],
          [73.339859008789347, 16.580141067504826],
          [73.339027404785156, 16.580141067504826],
          [73.339027404785156, 16.579860687255859],
          [73.338333129883097, 16.579860687255859],
          [73.336807250976847, 16.579860687255859],
          [73.336807250976847, 16.579580307006893],
          [73.336250305176065, 16.579584121704102],
          [73.336250305176065, 16.57902717590332],
          [73.335983276367244, 16.579030990600643],
          [73.335983276367244, 16.578750610351506],
          [73.335418701171932, 16.578750610351506],
          [73.335418701171932, 16.578470230102539],
          [73.335136413574332, 16.578472137451115],
          [73.335136413574332, 16.577638626098746],
          [73.334861755371151, 16.577640533447322],
          [73.334861755371151, 16.577079772949219],
          [73.334587097168139, 16.577083587646598],
          [73.334587097168139, 16.576805114746207],
          [73.332641601562784, 16.576805114746207],
          [73.332641601562784, 16.577083587646598],
          [73.330970764160327, 16.577083587646598],
          [73.330970764160327, 16.577362060546932],
          [73.330406188965014, 16.577360153198356],
          [73.330406188965014, 16.577640533447322],
          [73.330139160156534, 16.577640533447322],
          [73.330139160156534, 16.577920913696289],
          [73.329864501953125, 16.577917098999137],
          [73.329864501953125, 16.578472137451115],
          [73.329582214355753, 16.578470230102539],
          [73.329582214355753, 16.578750610351506],
          [73.329307556152401, 16.578750610351506],
          [73.329307556152401, 16.579030990600643],
          [73.328750610351619, 16.57902717590332],
          [73.328750610351619, 16.579305648803711],
          [73.327919006347827, 16.579305648803711],
          [73.327919006347827, 16.579584121704102],
          [73.327636718750057, 16.579580307006893],
          [73.327636718750057, 16.579860687255859],
          [73.327346801757983, 16.579860687255859],
          [73.327346801757983, 16.580419540405217],
          [73.327079772949503, 16.580417633056641],
          [73.327079772949503, 16.580694198608455],
          [73.326805114746094, 16.580694198608455],
          [73.326805114746094, 16.580972671508789],
          [73.326248168945313, 16.580970764160213],
          [73.326248168945313, 16.58125114440918],
          [73.325416564941349, 16.58125114440918],
          [73.325416564941349, 16.58152961730957],
          [73.324577331543196, 16.58152961730957],
          [73.324577331543196, 16.581808090209961],
          [73.324028015137003, 16.581806182861385],
          [73.324028015137003, 16.582082748413143],
          [73.323753356933594, 16.582080841064567],
          [73.323753356933594, 16.582361221313533],
          [73.323471069336222, 16.582361221313533],
          [73.323471069336222, 16.582639694213924],
          [73.323196411132813, 16.582639694213924],
          [73.323196411132813, 16.582918167114315],
          [73.32291412353544, 16.582916259765739],
          [73.32291412353544, 16.583194732666129],
          [73.322639465332088, 16.58319091796875],
          [73.322639465332088, 16.583749771118278],
          [73.322364807128849, 16.583749771118278],
          [73.322364807128849, 16.584304809570312],
          [73.322082519531307, 16.584304809570312],
          [73.322082519531307, 16.584583282470646],
          [73.322357177734489, 16.584579467773494],
          [73.322357177734489, 16.585699081420955],
          [73.322639465332088, 16.585699081420955],
          [73.322639465332088, 16.586248397827205],
          [73.322906494140909, 16.586248397827205],
          [73.322906494140909, 16.587921142578068],
          [73.322639465332088, 16.587917327880916],
          [73.322639465332088, 16.588470458984489],
          [73.322906494140909, 16.588470458984489],
          [73.322906494140909, 16.589309692382812],
          [73.322639465332088, 16.589309692382812],
          [73.322639465332088, 16.589862823486442],
          [73.322364807128849, 16.589862823486442],
          [73.322364807128849, 16.590694427490234],
          [73.322082519531307, 16.590694427490234],
          [73.322082519531307, 16.590974807739371],
          [73.321807861328296, 16.590974807739371],
          [73.321807861328296, 16.591249465942383],
          [73.321533203125057, 16.591241836547852],
          [73.321533203125057, 16.591529846191349],
          [73.320686340332202, 16.591529846191349],
          [73.320686340332202, 16.591810226440487],
          [73.320137023925781, 16.591806411743164],
          [73.320137023925781, 16.592084884643555],
          [73.31986236572294, 16.592084884643555],
          [73.31986236572294, 16.592361450195312],
          [73.319580078125057, 16.592359542846737],
          [73.319580078125057, 16.592639923095703],
          [73.319313049316349, 16.592639923095703],
          [73.319313049316349, 16.593200683593864],
          [73.319030761718807, 16.593196868896484],
          [73.319030761718807, 16.594583511352653],
          [73.318748474121037, 16.594579696655273],
          [73.318748474121037, 16.595140457153377],
          [73.318466186523665, 16.595140457153377],
          [73.318466186523665, 16.596530914306697],
          [73.318748474121037, 16.596527099609375],
          [73.318748474121037, 16.597084045410156],
          [73.319030761718807, 16.597080230712947],
          [73.319030761718807, 16.597368240356445],
          [73.319580078125057, 16.597368240356445],
          [73.319580078125057, 16.597639083862305],
          [73.31986236572294, 16.597639083862305],
          [73.31986236572294, 16.597917556762695],
          [73.319580078125057, 16.597917556762695],
          [73.319580078125057, 16.598749160766658],
          [73.319313049316349, 16.598749160766658],
          [73.319313049316349, 16.599031448364201],
          [73.319030761718807, 16.599031448364201],
          [73.319030761718807, 16.599311828613395],
          [73.318748474121037, 16.59930610656744],
          [73.318748474121037, 16.599582672119197],
          [73.318466186523665, 16.599580764770621],
          [73.318466186523665, 16.599859237671012],
          [73.317916870117244, 16.599859237671012],
          [73.317916870117244, 16.600141525268555],
          [73.31735992431669, 16.600141525268555],
          [73.31735992431669, 16.600429534912109],
          [73.317085266113281, 16.600416183471793],
          [73.317085266113281, 16.600971221923771],
          [73.316802978515909, 16.600969314575195],
          [73.316802978515909, 16.601530075073299],
          [73.317085266113281, 16.601528167724723],
          [73.317085266113281, 16.602081298828125],
          [73.31735992431669, 16.602081298828125],
          [73.31735992431669, 16.602363586425895],
          [73.317642211914233, 16.602359771728516],
          [73.317642211914233, 16.602640151977482],
          [73.317916870117244, 16.602640151977482],
          [73.317916870117244, 16.602920532226619],
          [73.318466186523665, 16.602920532226619],
          [73.318466186523665, 16.603200912475643],
          [73.319030761718807, 16.603195190429688],
          [73.319030761718807, 16.603473663330078],
          [73.319313049316349, 16.603469848632869],
          [73.319313049316349, 16.605140686035156],
          [73.319580078125057, 16.605140686035156],
          [73.319580078125057, 16.605421066284123],
          [73.31986236572294, 16.605417251586971],
          [73.31986236572294, 16.605695724487362],
          [73.320137023925781, 16.605695724487362],
          [73.320137023925781, 16.607082366943303],
          [73.320419311523722, 16.607080459594727],
          [73.320419311523722, 16.607360839843693],
          [73.321807861328296, 16.607360839843693],
          [73.321807861328296, 16.607080459594727],
          [73.322364807128849, 16.607082366943303],
          [73.322364807128849, 16.606805801391715],
          [73.322906494140909, 16.606809616088867],
          [73.322906494140909, 16.606531143188477],
          [73.323471069336222, 16.606531143188477],
          [73.323471069336222, 16.606241226196403],
          [73.323753356933594, 16.60625076293951],
          [73.323753356933594, 16.605972290039119],
          [73.324028015137003, 16.605972290039119],
          [73.324028015137003, 16.605695724487362],
          [73.324859619140796, 16.605695724487362],
          [73.324859619140796, 16.605972290039119],
          [73.325141906738509, 16.605972290039119],
          [73.325141906738509, 16.60625076293951],
          [73.325416564941349, 16.606241226196403],
          [73.325416564941349, 16.606809616088867],
          [73.325691223144588, 16.606805801391715],
          [73.325691223144588, 16.607082366943303],
          [73.32596588134794, 16.607080459594727],
          [73.32596588134794, 16.607360839843693],
          [73.326248168945313, 16.607360839843693],
          [73.326248168945313, 16.60764122009283],
          [73.328186035156307, 16.60764122009283],
          [73.328186035156307, 16.607919692993221],
          [73.329025268554801, 16.607917785644645],
          [73.329025268554801, 16.608194351196289],
          [73.330413818359546, 16.608194351196289],
          [73.330413818359546, 16.608472824096623],
          [73.330696105957088, 16.608472824096623],
          [73.330696105957088, 16.608194351196289],
          [73.331802368164119, 16.608194351196289],
          [73.331802368164119, 16.607917785644645],
          [73.332916259765625, 16.607919692993221],
          [73.332916259765625, 16.60764122009283],
          [73.333473205566577, 16.60764122009283],
          [73.333473205566577, 16.607360839843693],
          [73.334030151367358, 16.607360839843693],
          [73.334030151367358, 16.607080459594727],
          [73.334587097168139, 16.607082366943303],
          [73.334587097168139, 16.606805801391715],
          [73.334861755371151, 16.606809616088867],
          [73.334861755371151, 16.606531143188477],
          [73.335136413574332, 16.606531143188477],
          [73.335136413574332, 16.606241226196403],
          [73.335418701171932, 16.60625076293951],
          [73.335418701171932, 16.605695724487362],
          [73.335975646972656, 16.605695724487362],
          [73.335975646972656, 16.605417251586971],
          [73.336524963379077, 16.605417251586971],
          [73.336524963379077, 16.605695724487362],
          [73.337913513183651, 16.605695724487362],
          [73.337913513183651, 16.605417251586971],
          [73.338470458984432, 16.605421066284123],
          [73.338470458984432, 16.605140686035156],
          [73.338752746582145, 16.605140686035156],
          [73.338752746582145, 16.60486030578619],
          [73.339286804199503, 16.60486030578619],
          [73.339286804199503, 16.604579925537223],
          [73.339584350585937, 16.604583740234432],
          [73.339584350585937, 16.604305267334041],
          [73.339859008789347, 16.604310989379996],
          [73.339859008789347, 16.604030609130803],
          [73.340141296386889, 16.604030609130803],
          [73.340141296386889, 16.603750228881836],
          [73.340415954589901, 16.603750228881836],
          [73.340415954589901, 16.602359771728516],
          [73.340141296386889, 16.602363586425895],
          [73.340141296386889, 16.601528167724723],
          [73.340972900390852, 16.601530075073299],
          [73.340972900390852, 16.601251602172908],
          [73.341247558593693, 16.601251602172908],
          [73.341247558593693, 16.600969314575195],
          [73.341529846191463, 16.600971221923771],
          [73.341529846191463, 16.600694656372184],
          [73.341804504394645, 16.600694656372184],
          [73.341804504394645, 16.600416183471793],
          [73.342918395996378, 16.600429534912109],
          [73.342918395996378, 16.600141525268555],
          [73.343750000000171, 16.600141525268555],
          [73.343750000000171, 16.599859237671012],
          [73.344017028808651, 16.599859237671012],
          [73.344017028808651, 16.599311828613395],
          [73.344306945800724, 16.599311828613395],
          [73.344306945800724, 16.599031448364201],
          [73.345970153808878, 16.599031448364201],
          [73.345970153808878, 16.598749160766658],
          [73.346527099609432, 16.598749160766658],
          [73.346527099609432, 16.598470687866268],
          [73.346801757812671, 16.598472595214844],
          [73.346801757812671, 16.597360610961914],
          [73.346527099609432, 16.597368240356445],
          [73.346527099609432, 16.595689773559627],
          [73.346801757812671, 16.595693588256779],
          [73.346801757812671, 16.595415115356445],
          [73.347076416015852, 16.595420837402344],
          [73.347076416015852, 16.595140457153377],
          [73.347358703613224, 16.595140457153377],
          [73.347358703613224, 16.595420837402344],
          [73.347640991210994, 16.595415115356445],
          [73.347640991210994, 16.595693588256779],
          [73.347915649414176, 16.595693588256779],
          [73.347915649414176, 16.59597206115717],
          [73.348747253417969, 16.595970153808594],
          [73.348747253417969, 16.59625053405756],
          [73.349296569824389, 16.59625053405756],
          [73.349296569824389, 16.595970153808594],
          [73.349861145019702, 16.59597206115717],
          [73.349861145019702, 16.595693588256779],
          [73.350418090820483, 16.595693588256779],
          [73.350418090820483, 16.595415115356445],
          [73.350692749023494, 16.595420837402344],
          [73.350692749023494, 16.595140457153377],
          [73.350982666015568, 16.595140457153377],
          [73.350982666015568, 16.594860076904411],
          [73.351249694824276, 16.594861984252987],
          [73.351249694824276, 16.594583511352653],
          [73.351806640625, 16.594583511352653],
          [73.351806640625, 16.594861984252987],
          [73.352081298828409, 16.594860076904411],
          [73.352081298828409, 16.595140457153377],
          [73.352363586425781, 16.595138549804801],
          [73.352355957031421, 16.596380233764705],
          [73.352355957031421, 16.596530914306697],
          [73.35263824462919, 16.596530914306697],
          [73.35263824462919, 16.596807479858512],
          [73.352363586425781, 16.596805572509766],
          [73.352363586425781, 16.597084045410156],
          [73.351806640625, 16.597084045410156],
          [73.351806640625, 16.596805572509766],
          [73.351638793945369, 16.596805572509766],
          [73.350975036621037, 16.596805572509766],
          [73.350975036621037, 16.597084045410156],
          [73.350692749023494, 16.597080230712947],
          [73.350692749023494, 16.597368240356445],
          [73.350418090820483, 16.597360610961914],
          [73.350418090820483, 16.597530364990348],
          [73.350418090820483, 16.597917556762695],
          [73.350135803222884, 16.597917556762695],
          [73.350135803222884, 16.599031448364201],
          [73.349861145019702, 16.599031448364201],
          [73.349861145019702, 16.599311828613395],
          [73.350135803222884, 16.59930610656744],
          [73.350135803222884, 16.599582672119197],
          [73.349861145019702, 16.599580764770621],
          [73.349861145019702, 16.599859237671012],
          [73.34958648681669, 16.599859237671012],
          [73.34958648681669, 16.600971221923771],
          [73.349296569824389, 16.600969314575195],
          [73.349296569824389, 16.601251602172908],
          [73.34958648681669, 16.601251602172908],
          [73.34958648681669, 16.602920532226619],
          [73.349296569824389, 16.602920532226619],
          [73.349296569824389, 16.603200912475643],
          [73.349029541015909, 16.603195190429688],
          [73.349029541015909, 16.603473663330078],
          [73.348472595215128, 16.603473663330078],
          [73.348472595215128, 16.603195190429688],
          [73.348197937011776, 16.603200912475643],
          [73.348197937011776, 16.602640151977482],
          [73.347923278808537, 16.602640151977482],
          [73.347923278808537, 16.602079391479549],
          [73.347640991210994, 16.602081298828125],
          [73.347640991210994, 16.601528167724723],
          [73.347358703613224, 16.601530075073299],
          [73.347358703613224, 16.601251602172908],
          [73.346809387207202, 16.601251602172908],
          [73.346801757812671, 16.601530075073299],
          [73.345695495605469, 16.601528167724723],
          [73.345695495605469, 16.602363586425895],
          [73.345420837402628, 16.602359771728516],
          [73.345420837402628, 16.602920532226619],
          [73.345138549804744, 16.602920532226619],
          [73.345138549804744, 16.603200912475643],
          [73.344856262207145, 16.603200912475643],
          [73.344856262207145, 16.603750228881836],
          [73.344306945800724, 16.603750228881836],
          [73.344306945800724, 16.604030609130803],
          [73.344017028808651, 16.604030609130803],
          [73.344017028808651, 16.604310989379996],
          [73.343750000000171, 16.604305267334041],
          [73.343750000000171, 16.604583740234432],
          [73.342346191406534, 16.604579925537223],
          [73.342346191406534, 16.60486030578619],
          [73.341529846191463, 16.60486030578619],
          [73.341529846191463, 16.605140686035156],
          [73.340972900390852, 16.605140686035156],
          [73.340972900390852, 16.605421066284123],
          [73.340698242187671, 16.605421066284123],
          [73.340698242187671, 16.606809616088867],
          [73.340972900390852, 16.606805801391715],
          [73.340972900390852, 16.607082366943303],
          [73.341247558593693, 16.607080459594727],
          [73.341247558593693, 16.607360839843693],
          [73.341529846191463, 16.607360839843693],
          [73.341529846191463, 16.60764122009283],
          [73.341796875000284, 16.60764122009283],
          [73.341796875000284, 16.607919692993221],
          [73.342086791992244, 16.607917785644645],
          [73.342086791992244, 16.608194351196289],
          [73.342361450195597, 16.608194351196289],
          [73.342361450195597, 16.608472824096623],
          [73.342636108398437, 16.608470916748047],
          [73.342636108398437, 16.609029769897404],
          [73.342918395996378, 16.609027862548828],
          [73.342918395996378, 16.609861373901367],
          [73.343193054199389, 16.609859466552791],
          [73.343193054199389, 16.610139846801758],
          [73.343750000000171, 16.610139846801758],
          [73.343750000000171, 16.610418319702148],
          [73.344306945800724, 16.610416412353572],
          [73.344306945800724, 16.610694885253963],
          [73.344581604003963, 16.610691070556754],
          [73.344581604003963, 16.611249923706112],
          [73.344856262207145, 16.611249923706112],
          [73.344856262207145, 16.611810684204045],
          [73.345413208008097, 16.611804962158317],
          [73.345413208008097, 16.612083435058707],
          [73.345703125, 16.612079620361328],
          [73.345703125, 16.612369537353629],
          [73.345970153808878, 16.612369537353629],
          [73.345970153808878, 16.612638473510856],
          [73.346801757812671, 16.612638473510856],
          [73.346809387207202, 16.612920761108398],
          [73.347358703613224, 16.612916946411246],
          [73.347358703613224, 16.613193511962834],
          [73.348472595215128, 16.613193511962834],
          [73.348472595215128, 16.612916946411246],
          [73.348747253417969, 16.612920761108398],
          [73.348747253417969, 16.612638473510856],
          [73.349029541015909, 16.612638473510856],
          [73.349029541015909, 16.612369537353629],
          [73.349296569824389, 16.612369537353629],
          [73.349296569824389, 16.612079620361328],
          [73.34958648681669, 16.612083435058707],
          [73.34958648681669, 16.611804962158317],
          [73.350135803222884, 16.611810684204045],
          [73.350135803222884, 16.611528396606502],
          [73.350692749023494, 16.611528396606502],
          [73.350692749023494, 16.611810684204045],
          [73.350982666015568, 16.611810684204045],
          [73.350982666015568, 16.612369537353629],
          [73.351249694824276, 16.612361907959041],
          [73.351249694824276, 16.613193511962834],
          [73.351516723633097, 16.613189697265682],
          [73.351516723633097, 16.613752365112418],
          [73.351806640625, 16.613752365112418],
          [73.351806640625, 16.615680694580078],
          [73.351806640625, 16.618194580078239],
          [73.351524353027628, 16.618194580078239],
          [73.351524353027628, 16.622083663940487],
          [73.351806640625, 16.622079849243278],
          [73.351806640625, 16.622640609741211],
          [73.352081298828409, 16.622640609741211],
          [73.352081298828409, 16.622920989990178],
          [73.35263824462919, 16.622917175293026],
          [73.35263824462919, 16.62319374084484],
          [73.352355957031421, 16.623189926147461],
          [73.352355957031421, 16.623750686645565],
          [73.352081298828409, 16.623750686645565],
          [73.352081298828409, 16.623929977416992],
          [73.352081298828409, 16.624584197998161],
          [73.351806640625, 16.624580383300781],
          [73.351806640625, 16.625139236450309],
          [73.351249694824276, 16.625139236450309],
          [73.351249694824276, 16.624580383300781],
          [73.350692749023494, 16.624584197998161],
          [73.350692749023494, 16.62430572509777],
          [73.350418090820483, 16.624309539794922],
          [73.350418090820483, 16.623750686645565],
          [73.349861145019702, 16.623750686645565],
          [73.349861145019702, 16.623470306396598],
          [73.34958648681669, 16.623472213745174],
          [73.34958648681669, 16.62319374084484],
          [73.349304199218921, 16.62319374084484],
          [73.349304199218921, 16.622917175293026],
          [73.348747253417969, 16.622920989990178],
          [73.348747253417969, 16.622640609741211],
          [73.348480224609489, 16.622640609741211],
          [73.348480224609489, 16.622079849243278],
          [73.347915649414176, 16.622083663940487],
          [73.347915649414176, 16.621805191040096],
          [73.347358703613224, 16.621810913086051],
          [73.347358703613224, 16.621538162231388],
          [73.346527099609432, 16.621538162231388],
          [73.346527099609432, 16.621250152587891],
          [73.345413208008097, 16.621250152587891],
          [73.345413208008097, 16.6209716796875],
          [73.340698242187671, 16.620969772338924],
          [73.340698242187671, 16.621250152587891],
          [73.340141296386889, 16.621250152587891],
          [73.340141296386889, 16.622360229492244],
          [73.339859008789347, 16.622360229492244],
          [73.339859008789347, 16.622640609741211],
          [73.339584350585937, 16.622638702392635],
          [73.339584350585937, 16.62319374084484],
          [73.339302062988565, 16.62319374084484],
          [73.339302062988565, 16.623472213745174],
          [73.339027404785156, 16.623470306396598],
          [73.339027404785156, 16.623750686645565],
          [73.338752746582145, 16.623750686645565],
          [73.338752746582145, 16.624029159545955],
          [73.33735656738304, 16.624029159545955],
          [73.33735656738304, 16.623750686645565],
          [73.337081909179858, 16.623750686645565],
          [73.337081909179858, 16.623470306396598],
          [73.336807250976847, 16.623472213745174],
          [73.336807250976847, 16.622917175293026],
          [73.336517333984546, 16.622920989990178],
          [73.336517333984546, 16.622640609741211],
          [73.336250305176065, 16.622640609741211],
          [73.336250305176065, 16.622360229492244],
          [73.335975646972656, 16.622360229492244],
          [73.335975646972656, 16.6209716796875],
          [73.335693359375284, 16.6209716796875],
          [73.335693359375284, 16.619861602783146],
          [73.335136413574332, 16.619861602783146],
          [73.335136413574332, 16.619583129882756],
          [73.334861755371151, 16.619583129882756],
          [73.334861755371151, 16.619304656982422],
          [73.332916259765625, 16.619304656982422],
          [73.332916259765625, 16.619583129882756],
          [73.331802368164119, 16.619583129882756],
          [73.331802368164119, 16.619861602783146],
          [73.33125305175804, 16.61985969543457],
          [73.33125305175804, 16.620140075683537],
          [73.330696105957088, 16.620140075683537],
          [73.330696105957088, 16.620420455932674],
          [73.330406188965014, 16.620420455932674],
          [73.330406188965014, 16.620700836181697],
          [73.330139160156534, 16.620695114135742],
          [73.330139160156534, 16.622083663940487],
          [73.330406188965014, 16.622079849243278],
          [73.330406188965014, 16.622360229492244],
          [73.330696105957088, 16.622360229492244],
          [73.330696105957088, 16.622640609741211],
          [73.330970764160327, 16.622640609741211],
          [73.330970764160327, 16.622920989990178],
          [73.33125305175804, 16.622917175293026],
          [73.33125305175804, 16.62319374084484],
          [73.331527709960881, 16.623189926147461],
          [73.331527709960881, 16.623750686645565],
          [73.331802368164119, 16.623750686645565],
          [73.331802368164119, 16.624029159545955],
          [73.332077026367301, 16.624029159545955],
          [73.332077026367301, 16.624309539794922],
          [73.332359313964901, 16.62430572509777],
          [73.332359313964901, 16.624584197998161],
          [73.332641601562784, 16.624580383300781],
          [73.332641601562784, 16.624860763549748],
          [73.332916259765625, 16.624860763549748],
          [73.332916259765625, 16.625139236450309],
          [73.333190917969034, 16.625139236450309],
          [73.333190917969034, 16.625421524047908],
          [73.333747863769588, 16.625415802001953],
          [73.333747863769588, 16.625694274902344],
          [73.334030151367358, 16.625694274902344],
          [73.334030151367358, 16.625972747802678],
          [73.334297180176009, 16.625970840454102],
          [73.334297180176009, 16.626249313354492],
          [73.334587097168139, 16.626249313354492],
          [73.334587097168139, 16.626531600952262],
          [73.334861755371151, 16.626531600952262],
          [73.334861755371151, 16.626810073852596],
          [73.335136413574332, 16.626806259155273],
          [73.335136413574332, 16.627082824707031],
          [73.335418701171932, 16.627082824707031],
          [73.335418701171932, 16.627359390258846],
          [73.336807250976847, 16.627349853515739],
          [73.336807250976847, 16.627641677856388],
          [73.337081909179858, 16.627641677856388],
          [73.337081909179858, 16.627920150756779],
          [73.337913513183651, 16.627916336059627],
          [73.337913513183651, 16.628194808960018],
          [73.338470458984432, 16.628194808960018],
          [73.338470458984432, 16.627916336059627],
          [73.339027404785156, 16.627920150756779],
          [73.339027404785156, 16.627641677856388],
          [73.339286804199503, 16.627641677856388],
          [73.339286804199503, 16.627349853515739],
          [73.339584350585937, 16.627359390258846],
          [73.339584350585937, 16.627082824707031],
          [73.340141296386889, 16.627082824707031],
          [73.340141296386889, 16.626806259155273],
          [73.340698242187671, 16.626806259155273],
          [73.340698242187671, 16.627082824707031],
          [73.341247558593693, 16.627082824707031],
          [73.341247558593693, 16.627359390258846],
          [73.341529846191463, 16.627349853515739],
          [73.341529846191463, 16.627920150756779],
          [73.341804504394645, 16.627916336059627],
          [73.341804504394645, 16.628194808960018],
          [73.342086791992244, 16.628189086914063],
          [73.342086791992244, 16.628751754760742],
          [73.341796875000284, 16.628751754760742],
          [73.341796875000284, 16.629030227661133],
          [73.341529846191463, 16.629028320312557],
          [73.341529846191463, 16.629304885864371],
          [73.341247558593693, 16.629304885864371],
          [73.341247558593693, 16.629581451415959],
          [73.340972900390852, 16.629581451415959],
          [73.340972900390852, 16.629863739013729],
          [73.340698242187671, 16.629861831665096],
          [73.340698242187671, 16.630140304565487],
          [73.340415954589901, 16.630140304565487],
          [73.340415954589901, 16.630701065063477],
          [73.340141296386889, 16.630695343017692],
          [73.340141296386889, 16.630973815918082],
          [73.339859008789347, 16.630970001220703],
          [73.339859008789347, 16.63125038146967],
          [73.339576721191577, 16.63125038146967],
          [73.339576721191577, 16.63181114196783],
          [73.339286804199503, 16.63181114196783],
          [73.339286804199503, 16.632921218872184],
          [73.339584350585937, 16.632917404174805],
          [73.339584350585937, 16.633195877075195],
          [73.339859008789347, 16.633195877075195],
          [73.339859008789347, 16.633449554443359],
          [73.340141296386889, 16.633480072021541],
          [73.340141296386889, 16.634029388427734],
          [73.340415954589901, 16.634029388427734],
          [73.340415954589901, 16.634860992431697],
          [73.340141296386889, 16.634860992431697],
          [73.340141296386889, 16.635419845581055],
          [73.339859008789347, 16.635417938232479],
          [73.339859008789347, 16.635972976684684],
          [73.339584350585937, 16.635972976684684],
          [73.339584350585937, 16.63708305358881],
          [73.339859008789347, 16.637081146240234],
          [73.339859008789347, 16.638200759887752],
          [73.339027404785156, 16.638200759887752],
          [73.339027404785156, 16.637920379638729],
          [73.337364196777401, 16.637916564941406],
          [73.337364196777401, 16.638080596923885],
          [73.337364196777401, 16.638471603393555],
          [73.336807250976847, 16.638469696044979],
          [73.336807250976847, 16.639028549194336],
          [73.336250305176065, 16.639028549194336],
          [73.336250305176065, 16.639583587646541],
          [73.335975646972656, 16.639583587646541],
          [73.335975646972656, 16.639860153198299],
          [73.335693359375284, 16.639858245849723],
          [73.335693359375284, 16.64013862609869],
          [73.334297180176009, 16.64013862609869],
          [73.334297180176009, 16.640422821045036],
          [73.333747863769588, 16.64041709899908],
          [73.333747863769588, 16.640693664550895],
          [73.333473205566577, 16.640691757202092],
          [73.333473205566577, 16.641252517700252],
          [73.332916259765625, 16.641252517700252],
          [73.332916259765625, 16.641532897949219],
          [73.329856872558594, 16.641532897949219],
          [73.329856872558594, 16.641252517700252],
          [73.329307556152401, 16.641252517700252],
          [73.329307556152401, 16.640970230102653],
          [73.329025268554801, 16.640970230102653],
          [73.329025268554801, 16.64041709899908],
          [73.328750610351619, 16.640422821045036],
          [73.328750610351619, 16.639579772949332],
          [73.329025268554801, 16.639583587646541],
          [73.329025268554801, 16.639305114746151],
          [73.329307556152401, 16.639310836792106],
          [73.329307556152401, 16.639028549194336],
          [73.329582214355753, 16.639028549194336],
          [73.329582214355753, 16.638469696044979],
          [73.329307556152401, 16.638471603393555],
          [73.329307556152401, 16.638195037841797],
          [73.329032897949332, 16.638200759887752],
          [73.329032897949332, 16.637920379638729],
          [73.328750610351619, 16.637920379638729],
          [73.328750610351619, 16.637638092041016],
          [73.328475952148381, 16.637638092041016],
          [73.328475952148381, 16.637359619140625],
          [73.327636718750057, 16.637361526489201],
          [73.327636718750057, 16.63708305358881],
          [73.327079772949503, 16.63708305358881],
          [73.327079772949503, 16.636806488037223],
          [73.326248168945313, 16.636810302734375],
          [73.326248168945313, 16.63653755187994],
          [73.324859619140796, 16.63653755187994],
          [73.324859619140796, 16.636249542236442],
          [73.323753356933594, 16.636249542236442],
          [73.323753356933594, 16.63653755187994],
          [73.323471069336222, 16.63653755187994],
          [73.323471069336222, 16.638200759887752],
          [73.323196411132813, 16.638195037841797],
          [73.323196411132813, 16.638471603393555],
          [73.322906494140909, 16.638469696044979],
          [73.322906494140909, 16.639028549194336],
          [73.322639465332088, 16.639028549194336],
          [73.322639465332088, 16.640422821045036],
          [73.322357177734489, 16.640422821045036],
          [73.322357177734489, 16.641532897949219],
          [73.322082519531307, 16.641527175903434],
          [73.322082519531307, 16.642362594604606],
          [73.321807861328296, 16.642362594604606],
          [73.321807861328296, 16.644584655761719],
          [73.322082519531307, 16.64458084106451],
          [73.322082519531307, 16.644861221313477],
          [73.322357177734489, 16.644861221313477],
          [73.322357177734489, 16.645139694213867],
          [73.322639465332088, 16.645139694213867],
          [73.322639465332088, 16.645420074462834],
          [73.323196411132813, 16.645416259765682],
          [73.323196411132813, 16.645694732666072],
          [73.323471069336222, 16.645694732666072],
          [73.323471069336222, 16.64597129821783],
          [73.323753356933594, 16.645969390869254],
          [73.323753356933594, 16.646249771118221],
          [73.324028015137003, 16.646249771118221],
          [73.324028015137003, 16.647361755371151],
          [73.323753356933594, 16.647359848022575],
          [73.323753356933594, 16.647920608520508],
          [73.324028015137003, 16.647920608520508],
          [73.324028015137003, 16.648200988769531],
          [73.324310302734546, 16.648200988769531],
          [73.324310302734546, 16.648479461669865],
          [73.324859619140796, 16.648479461669865],
          [73.324859619140796, 16.648200988769531],
          [73.326530456543253, 16.648200988769531],
          [73.326530456543253, 16.647920608520508],
          [73.326812744140625, 16.647920608520508],
          [73.326812744140625, 16.647640228271541],
          [73.327079772949503, 16.647640228271541],
          [73.327079772949503, 16.647359848022575],
          [73.327362060547046, 16.647361755371151],
          [73.327362060547046, 16.646806716919002],
          [73.327636718750057, 16.646806716919002],
          [73.327636718750057, 16.646528244018612],
          [73.327919006347827, 16.646530151367187],
          [73.327919006347827, 16.646249771118221],
          [73.328475952148381, 16.646249771118221],
          [73.328475952148381, 16.646530151367187],
          [73.328750610351619, 16.646528244018612],
          [73.328750610351619, 16.646806716919002],
          [73.329307556152401, 16.646806716919002],
          [73.329307556152401, 16.647083282470817],
          [73.329864501953125, 16.647083282470817],
          [73.329864501953125, 16.647361755371151],
          [73.330139160156534, 16.647359848022575],
          [73.330139160156534, 16.647640228271541],
          [73.330406188965014, 16.647640228271541],
          [73.330406188965014, 16.648200988769531],
          [73.330696105957088, 16.648200988769531],
          [73.330696105957088, 16.648479461669865],
          [73.330970764160327, 16.648479461669865],
          [73.330970764160327, 16.649030685424862],
          [73.33125305175804, 16.649026870727539],
          [73.33125305175804, 16.64958381652832],
          [73.331527709960881, 16.649580001831112],
          [73.331527709960881, 16.650140762329045],
          [73.331802368164119, 16.650138854980469],
          [73.331802368164119, 16.650693893432674],
          [73.332084655761832, 16.650693893432674],
          [73.332084655761832, 16.650972366333008],
          [73.332359313964901, 16.650970458984432],
          [73.332359313964901, 16.652639389038143],
          [73.332641601562784, 16.652639389038143],
          [73.332641601562784, 16.652921676635742],
          [73.332916259765625, 16.652915954589957],
          [73.332916259765625, 16.653472900390739],
          [73.333190917969034, 16.653469085693359],
          [73.333190917969034, 16.65764045715332],
          [73.332916259765625, 16.65764045715332],
          [73.332916259765625, 16.659309387207031],
          [73.332641601562784, 16.659305572509879],
          [73.332641601562784, 16.660694122314453],
          [73.332359313964901, 16.660690307617244],
          [73.332359313964901, 16.662639617919922],
          [73.332077026367301, 16.662639617919922],
          [73.332077026367301, 16.66513824462902],
          [73.331802368164119, 16.66513824462902],
          [73.331802368164119, 16.667360305786133],
          [73.331527709960881, 16.667360305786133],
          [73.331527709960881, 16.668193817138729],
          [73.33125305175804, 16.668193817138729],
          [73.33125305175804, 16.668470382690487],
          [73.331527709960881, 16.668470382690487],
          [73.331527709960881, 16.66903114318842],
          [73.33125305175804, 16.66903114318842],
          [73.33125305175804, 16.66986274719244],
          [73.330970764160327, 16.66986274719244],
          [73.330970764160327, 16.671529769897518],
          [73.330696105957088, 16.671529769897518],
          [73.330696105957088, 16.674030303955021],
          [73.330406188965014, 16.674030303955021],
          [73.330406188965014, 16.676811218261719],
          [73.330139160156534, 16.676811218261719],
          [73.330139160156534, 16.677917480468864],
          [73.329856872558594, 16.677917480468864],
          [73.329856872558594, 16.678749084472656],
          [73.329582214355753, 16.67874717712408],
          [73.329582214355753, 16.679582595825195],
          [73.329307556152401, 16.679580688476619],
          [73.329307556152401, 16.682920455932617],
          [73.329582214355753, 16.682916641235465],
          [73.329582214355753, 16.685695648193359],
          [73.329864501953125, 16.685695648193359],
          [73.329864501953125, 16.685972213745117],
          [73.334030151367358, 16.685972213745117],
          [73.334030151367358, 16.685695648193359],
          [73.334587097168139, 16.685695648193359],
          [73.334587097168139, 16.685417175292969],
          [73.334861755371151, 16.685420989990348],
          [73.334861755371151, 16.685140609741154],
          [73.336807250976847, 16.685140609741154],
          [73.336807250976847, 16.684860229492188],
          [73.33735656738304, 16.684860229492188],
          [73.33735656738304, 16.684589385986328],
          [73.339286804199503, 16.684589385986328],
          [73.339286804199503, 16.685140609741154],
          [73.339584350585937, 16.685138702392578],
          [73.339584350585937, 16.685695648193359],
          [73.339302062988565, 16.685695648193359],
          [73.339302062988565, 16.685972213745117],
          [73.338752746582145, 16.685970306396541],
          [73.338752746582145, 16.686531066894474],
          [73.337905883789119, 16.686531066894474],
          [73.337905883789119, 16.686250686645508],
          [73.33735656738304, 16.686250686645508],
          [73.33735656738304, 16.685970306396541],
          [73.335975646972656, 16.685972213745117],
          [73.335983276367244, 16.686250686645508],
          [73.335418701171932, 16.686250686645508],
          [73.335418701171932, 16.686531066894474],
          [73.335136413574332, 16.686531066894474],
          [73.335136413574332, 16.686809539794865],
          [73.334861755371151, 16.686809539794865],
          [73.334861755371151, 16.687360763549862],
          [73.334587097168139, 16.687360763549862],
          [73.334587097168139, 16.687650680541992],
          [73.334297180176009, 16.687650680541992],
          [73.334297180176009, 16.687919616699219],
          [73.332359313964901, 16.687919616699219],
          [73.332359313964901, 16.687650680541992],
          [73.331527709960881, 16.687650680541992],
          [73.331527709960881, 16.687360763549862],
          [73.330139160156534, 16.687360763549862],
          [73.330139160156534, 16.687650680541992],
          [73.329856872558594, 16.687650680541992],
          [73.329856872558594, 16.687919616699219],
          [73.329582214355753, 16.687917709350643],
          [73.329582214355753, 16.688194274902457],
          [73.329307556152401, 16.688194274902457],
          [73.329307556152401, 16.688472747802848],
          [73.328750610351619, 16.688470840454045],
          [73.328750610351619, 16.688751220703182],
          [73.328475952148381, 16.688751220703182],
          [73.328475952148381, 16.689029693603572],
          [73.328186035156307, 16.689029693603572],
          [73.328186035156307, 16.689308166503963],
          [73.327636718750057, 16.689306259155387],
          [73.327636718750057, 16.689582824706974],
          [73.326805114746094, 16.689582824706974],
          [73.326805114746094, 16.689861297607365],
          [73.326248168945313, 16.689859390258789],
          [73.326248168945313, 16.690139770507756],
          [73.325691223144588, 16.690139770507756],
          [73.325691223144588, 16.690418243408317],
          [73.325416564941349, 16.69041633605957],
          [73.325416564941349, 16.690694808959961],
          [73.324859619140796, 16.690694808959961],
          [73.324859619140796, 16.690971374511719],
          [73.324310302734546, 16.690969467163143],
          [73.324310302734546, 16.6915283203125],
          [73.324028015137003, 16.6915283203125],
          [73.324028015137003, 16.692083358764705],
          [73.323471069336222, 16.692083358764705],
          [73.323471069336222, 16.692361831665039],
          [73.323196411132813, 16.692359924316463],
          [73.323196411132813, 16.692638397216854],
          [73.322906494140909, 16.692638397216854],
          [73.322906494140909, 16.692920684814396],
          [73.322639465332088, 16.692916870117244],
          [73.322639465332088, 16.693471908569393],
          [73.322357177734489, 16.69346809387207],
          [73.322357177734489, 16.693752288818416],
          [73.321807861328296, 16.693752288818416],
          [73.321807861328296, 16.694032669067383],
          [73.321533203125057, 16.694032669067383],
          [73.321533203125057, 16.694311141967773],
          [73.321250915527514, 16.694305419921989],
          [73.321250915527514, 16.694583892822379],
          [73.320968627929744, 16.694580078125],
          [73.320968627929744, 16.694860458373967],
          [73.320686340332202, 16.694860458373967],
          [73.320686340332202, 16.695142745971737],
          [73.320137023925781, 16.695142745971737],
          [73.320137023925781, 16.695421218872127],
          [73.319580078125057, 16.695417404174918],
          [73.319580078125057, 16.69569206237793],
          [73.319305419921989, 16.69569206237793],
          [73.319305419921989, 16.69597053527832],
          [73.319030761718807, 16.69597053527832],
          [73.319030761718807, 16.69625282287609],
          [73.318466186523665, 16.69625282287609],
          [73.318466186523665, 16.696529388427678],
          [73.318176269531193, 16.696529388427678],
          [73.318176269531193, 16.697362899780273],
          [73.317916870117244, 16.697362899780273],
          [73.317916870117244, 16.697919845580998],
          [73.317642211914233, 16.697916030883846],
          [73.317642211914233, 16.698474884033203],
          [73.31735992431669, 16.698471069335994],
          [73.31735992431669, 16.700420379638672],
          [73.317642211914233, 16.700420379638672],
          [73.317642211914233, 16.702360153198242],
          [73.317916870117244, 16.702362060546818],
          [73.317916870117244, 16.702638626098633],
          [73.318466186523665, 16.702630996704102],
          [73.318466186523665, 16.702920913696403],
          [73.318748474121037, 16.702917098999023],
          [73.318748474121037, 16.703472137451172],
          [73.319030761718807, 16.703470230102596],
          [73.319030761718807, 16.704307556152344],
          [73.318748474121037, 16.704305648803768],
          [73.318748474121037, 16.704584121704158],
          [73.318473815918196, 16.704584121704158],
          [73.318473815918196, 16.705694198608512],
          [73.318176269531193, 16.705690383911133],
          [73.318176269531193, 16.706249237060661],
          [73.317916870117244, 16.706249237060661],
          [73.317916870117244, 16.706811904907227],
          [73.317642211914233, 16.706811904907227],
          [73.317642211914233, 16.707359313964844],
          [73.31735992431669, 16.707359313964844],
          [73.31735992431669, 16.707641601562614],
          [73.317092895507813, 16.707641601562614],
          [73.317092895507813, 16.708761215210075],
          [73.316802978515909, 16.70875167846674],
          [73.316802978515909, 16.709581375122127],
          [73.316528320312557, 16.709579467773551],
          [73.316528320312557, 16.710700988769645],
          [73.316253662109489, 16.71069526672369],
          [73.316253662109489, 16.71097373962408],
          [73.315971374511776, 16.710969924926871],
          [73.315971374511776, 16.711530685424805],
          [73.315696716308537, 16.711526870727653],
          [73.315696716308537, 16.71208572387701],
          [73.315406799316463, 16.712080001831055],
          [73.315406799316463, 16.712640762329158],
          [73.315139770507983, 16.712640762329158],
          [73.315139770507983, 16.712921142578182],
          [73.31430816650419, 16.712917327880973],
          [73.31430816650419, 16.713195800781364],
          [73.313751220703409, 16.713195800781364],
          [73.313751220703409, 16.713472366332951],
          [73.312919616699276, 16.713470458984375],
          [73.312919616699276, 16.713750839233342],
          [73.312637329101506, 16.713750839233342],
          [73.312637329101506, 16.714309692382869],
          [73.312362670898665, 16.714305877685547],
          [73.312362670898665, 16.714582443237305],
          [73.312080383300952, 16.714570999145621],
          [73.312080383300952, 16.714860916137695],
          [73.311531066894702, 16.714860916137695],
          [73.311531066894702, 16.715139389038086],
          [73.311248779297159, 16.715139389038086],
          [73.311248779297159, 16.715972900390682],
          [73.31097412109375, 16.715972900390682],
          [73.31097412109375, 16.717361450195369],
          [73.311248779297159, 16.717361450195369],
          [73.311248779297159, 16.718471527099553],
          [73.311531066894702, 16.718469619750977],
          [73.311531066894702, 16.721532821655387],
          [73.311248779297159, 16.721532821655387],
          [73.311248779297159, 16.721809387206974],
          [73.31097412109375, 16.721805572509822],
          [73.31097412109375, 16.72208213806158],
          [73.310691833496378, 16.722080230713004],
          [73.310691833496378, 16.722362518310604],
          [73.310417175292969, 16.722362518310604],
          [73.310417175292969, 16.72264289855957],
          [73.309860229492244, 16.72264289855957],
          [73.309860229492244, 16.723760604858455],
          [73.310142517089957, 16.723760604858455],
          [73.310142517089957, 16.724861145019474],
          [73.309860229492244, 16.724861145019474],
          [73.309860229492244, 16.725419998169002],
          [73.309585571289006, 16.72541618347168],
          [73.309585571289006, 16.726249694824219],
          [73.309303283691463, 16.726249694824219],
          [73.309303283691463, 16.726806640625],
          [73.307357788085938, 16.726806640625],
          [73.307357788085938, 16.727361679077148],
          [73.307083129883097, 16.727359771728572],
          [73.307083129883097, 16.727920532226506],
          [73.306808471679744, 16.727920532226506],
          [73.306808471679744, 16.7282009124757],
          [73.306526184082145, 16.728195190429744],
          [73.306526184082145, 16.728471755981502],
          [73.305969238281193, 16.728469848632926],
          [73.305969238281193, 16.728750228881893],
          [73.305686950683821, 16.728750228881893],
          [73.305686950683821, 16.729310989379883],
          [73.305419921875171, 16.729305267334098],
          [73.305419921875171, 16.730693817138672],
          [73.305694580078352, 16.730693817138672],
          [73.305694580078352, 16.730972290039006],
          [73.305969238281193, 16.73097038269043],
          [73.305969238281193, 16.731250762939396],
          [73.306236267089901, 16.731250762939396],
          [73.306236267089901, 16.731809616088924],
          [73.306526184082145, 16.731809616088924],
          [73.306526184082145, 16.734310150146428],
          [73.306236267089901, 16.734310150146428],
          [73.306236267089901, 16.735420227050781],
          [73.305969238281193, 16.735416412353629],
          [73.305969238281193, 16.735973358154411],
          [73.305686950683821, 16.735969543457031],
          [73.305686950683821, 16.736530303955135],
          [73.305419921875171, 16.736530303955135],
          [73.305419921875171, 16.736810684204158],
          [73.305686950683821, 16.736810684204158],
          [73.305686950683821, 16.739860534668026],
          [73.305419921875171, 16.739860534668026],
          [73.305419921875171, 16.741529464721737],
          [73.305694580078352, 16.741527557373161],
          [73.305694580078352, 16.742082595825138],
          [73.305969238281193, 16.742082595825138],
          [73.305969238281193, 16.743194580078125],
          [73.305686950683821, 16.743190765380916],
          [73.305686950683821, 16.746528625488338],
          [73.306236267089901, 16.746528625488338],
          [73.306236267089901, 16.746810913085937],
          [73.306526184082145, 16.746805191040153],
          [73.306526184082145, 16.747083663940543],
          [73.306808471679744, 16.747079849243164],
          [73.306808471679744, 16.747360229492131],
          [73.307083129883097, 16.747360229492131],
          [73.307083129883097, 16.747642517089901],
          [73.307357788085938, 16.747642517089901],
          [73.307357788085938, 16.749309539794979],
          [73.307083129883097, 16.749305725097656],
          [73.307083129883097, 16.749584197998047],
          [73.306526184082145, 16.749580383300838],
          [73.306526184082145, 16.749862670898437],
          [73.305969238281193, 16.749862670898437],
          [73.305969238281193, 16.750141143798771],
          [73.305686950683821, 16.750141143798771],
          [73.305686950683821, 16.750419616699162],
          [73.304862976074389, 16.750419616699162],
          [73.304862976074389, 16.751251220703125],
          [73.305137634277401, 16.751249313354549],
          [73.305137634277401, 16.752084732055721],
          [73.305419921875171, 16.752084732055721],
          [73.305419921875171, 16.753471374511662],
          [73.305137634277401, 16.753469467163086],
          [73.305137634277401, 16.756811141967887],
          [73.305419921875171, 16.756805419921932],
          [73.305419921875171, 16.76069450378418],
          [73.305686950683821, 16.760690689086971],
          [73.305686950683821, 16.761531829834098],
          [73.305419921875171, 16.761531829834098],
          [73.305419921875171, 16.763750076294002],
          [73.305137634277401, 16.763750076294002],
          [73.305137634277401, 16.767084121704102],
          [73.305419921875171, 16.767084121704102],
          [73.305419921875171, 16.768472671508846],
          [73.305686950683821, 16.768470764160213],
          [73.305686950683821, 16.76875114440918],
          [73.305969238281193, 16.76875114440918],
          [73.305969238281193, 16.76902961730957],
          [73.306236267089901, 16.76902961730957],
          [73.306236267089901, 16.769308090209961],
          [73.306526184082145, 16.769308090209961],
          [73.306526184082145, 16.769861221313533],
          [73.306808471679744, 16.769861221313533],
          [73.306808471679744, 16.770418167114315],
          [73.307083129883097, 16.770418167114315],
          [73.307083129883097, 16.771249771118107],
          [73.307357788085938, 16.771249771118107],
          [73.307357788085938, 16.773471832275391],
          [73.307083129883097, 16.773469924926815],
          [73.307083129883097, 16.774032592773551],
          [73.306808471679744, 16.774026870727596],
          [73.306808471679744, 16.774583816528377],
          [73.306526184082145, 16.774581909179744],
          [73.306526184082145, 16.775421142578125],
          [73.306808471679744, 16.775421142578125],
          [73.306808471679744, 16.776252746582088],
          [73.307083129883097, 16.776252746582088],
          [73.307083129883097, 16.777084350586051],
          [73.307357788085938, 16.777080535888672],
          [73.307357788085938, 16.778749465942383],
          [73.307640075683878, 16.778749465942383],
          [73.307640075683878, 16.780139923095703],
          [73.307907104492358, 16.780139923095703],
          [73.307907104492358, 16.780700683593864],
          [73.308197021484659, 16.780696868896484],
          [73.308197021484659, 16.780971527099666],
          [73.308471679687671, 16.78096961975109],
          [73.308471679687671, 16.781530380249023],
          [73.308746337890852, 16.781528472900447],
          [73.308746337890852, 16.782083511352653],
          [73.309028625488452, 16.782079696655273],
          [73.309028625488452, 16.782640457153377],
          [73.309303283691463, 16.782638549804801],
          [73.309303283691463, 16.78375053405756],
          [73.309593200683537, 16.78375053405756],
          [73.309593200683537, 16.785139083862305],
          [73.309860229492244, 16.785137176513729],
          [73.309860229492244, 16.78569412231451],
          [73.310142517089957, 16.785690307617301],
          [73.310142517089957, 16.786249160766658],
          [73.310417175292969, 16.786249160766658],
          [73.310417175292969, 16.786811828613395],
          [73.310691833496378, 16.78680610656744],
          [73.310691833496378, 16.787082672119254],
          [73.310966491699389, 16.787080764770451],
          [73.310966491699389, 16.787641525268612],
          [73.311248779297159, 16.787641525268612],
          [73.311248779297159, 16.788194656372184],
          [73.311531066894702, 16.788194656372184],
          [73.311531066894702, 16.788471221923771],
          [73.311805725097713, 16.788471221923771],
          [73.311805725097713, 16.788749694824162],
          [73.312362670898665, 16.788749694824162],
          [73.312362670898665, 16.789304733276367],
          [73.312637329101506, 16.789304733276367],
          [73.312637329101506, 16.789863586425895],
          [73.313186645508097, 16.789850234985408],
          [73.313186645508097, 16.790420532226676],
          [73.313468933105469, 16.790416717529297],
          [73.313468933105469, 16.790973663330078],
          [73.313751220703409, 16.790969848632869],
          [73.313751220703409, 16.791250228881836],
          [73.31402587890625, 16.791250228881836],
          [73.31402587890625, 16.791530609130803],
          [73.31430816650419, 16.791528701782227],
          [73.31430816650419, 16.792085647583008],
          [73.314582824707202, 16.792079925537223],
          [73.314582824707202, 16.79236030578619],
          [73.314857482910213, 16.79236030578619],
          [73.314857482910213, 16.792640686035156],
          [73.315139770507983, 16.79263877868658],
          [73.315139770507983, 16.792917251586971],
          [73.315414428711165, 16.792917251586971],
          [73.315414428711165, 16.793195724487362],
          [73.315696716308537, 16.793195724487362],
          [73.315696716308537, 16.793472290039176],
          [73.315971374511776, 16.793470382690373],
          [73.315971374511776, 16.79375076293951],
          [73.316246032714957, 16.79375076293951],
          [73.316246032714957, 16.794309616088867],
          [73.316528320312557, 16.794305801391715],
          [73.316528320312557, 16.794582366943303],
          [73.317085266113281, 16.794584274292106],
          [73.317085266113281, 16.794860839843693],
          [73.31735992431669, 16.794860839843693],
          [73.31735992431669, 16.795141220092887],
          [73.317642211914233, 16.795141220092887],
          [73.317642211914233, 16.796529769897404],
          [73.31735992431669, 16.796529769897404],
          [73.31735992431669, 16.796808242797795],
          [73.317085266113281, 16.796806335449219],
          [73.317085266113281, 16.797361373901367],
          [73.316802978515909, 16.797359466552791],
          [73.316802978515909, 16.797918319702148],
          [73.316528320312557, 16.797918319702148],
          [73.316528320312557, 16.800420761108455],
          [73.316246032714957, 16.800420761108455],
          [73.316246032714957, 16.801811218261776],
          [73.316528320312557, 16.801811218261776],
          [73.316528320312557, 16.802360534667969],
          [73.316802978515909, 16.802360534667969],
          [73.316802978515909, 16.803192138671932],
          [73.317092895507813, 16.803190231323356],
          [73.317092895507813, 16.80402946472168],
          [73.31735992431669, 16.80402946472168],
          [73.31735992431669, 16.804309844970646],
          [73.317642211914233, 16.804306030273494],
          [73.317642211914233, 16.805973052978629],
          [73.318176269531193, 16.805971145629826],
          [73.318176269531193, 16.806249618530217],
          [73.318466186523665, 16.806249618530217],
          [73.318466186523665, 16.806529998779354],
          [73.319030761718807, 16.806528091430778],
          [73.319030761718807, 16.806806564331168],
          [73.319526672363452, 16.806806564331168],
          [73.320137023925781, 16.806806564331168],
          [73.320137023925781, 16.807083129882812],
          [73.320968627929744, 16.807083129882812],
          [73.320968627929744, 16.807361602783146],
          [73.321533203125057, 16.80735969543457],
          [73.321533203125057, 16.807640075683537],
          [73.321807861328296, 16.807640075683537],
          [73.321807861328296, 16.807920455932731],
          [73.322357177734489, 16.807920455932731],
          [73.322357177734489, 16.808210372924805],
          [73.322639465332088, 16.808195114135742],
          [73.322639465332088, 16.8084716796875],
          [73.322906494140909, 16.808469772338924],
          [73.322906494140909, 16.809030532836857],
          [73.323196411132813, 16.809028625488281],
          [73.323196411132813, 16.809583663940487],
          [73.323471069336222, 16.809579849243278],
          [73.323471069336222, 16.809860229492244],
          [73.323753356933594, 16.809860229492244],
          [73.323753356933594, 16.810140609741211],
          [73.324028015137003, 16.810140609741211],
          [73.324028015137003, 16.810419082641602],
          [73.324302673340014, 16.810417175293026],
          [73.324302673340014, 16.81069374084484],
          [73.324584960937557, 16.81069374084484],
          [73.324584960937557, 16.811250686645565],
          [73.324859619140796, 16.811250686645565],
          [73.324859619140796, 16.811807632446346],
          [73.325141906738509, 16.81180572509777],
          [73.325141906738509, 16.812084197998161],
          [73.325416564941349, 16.812080383300781],
          [73.325416564941349, 16.812360763549748],
          [73.325691223144588, 16.812360763549748],
          [73.325691223144588, 16.812639236450138],
          [73.326248168945313, 16.812639236450138],
          [73.326248168945313, 16.812921524047908],
          [73.329582214355753, 16.812921524047908],
          [73.329582214355753, 16.812639236450138],
          [73.330696105957088, 16.812639236450138],
          [73.330696105957088, 16.812360763549748],
          [73.331527709960881, 16.812360763549748],
          [73.331527709960881, 16.812921524047908],
          [73.331802368164119, 16.812915802001953],
          [73.331802368164119, 16.813472747802734],
          [73.332084655761832, 16.813472747802734],
          [73.332084655761832, 16.814027786254883],
          [73.332359313964901, 16.814027786254883],
          [73.332359313964901, 16.814582824707088],
          [73.332641601562784, 16.814580917358455],
          [73.332641601562784, 16.815141677856445],
          [73.332916259765625, 16.815141677856445],
          [73.332916259765625, 16.815694808960018],
          [73.333190917969034, 16.815692901611442],
          [73.333190917969034, 16.816530227661133],
          [73.332641601562784, 16.816528320312557],
          [73.332641601562784, 16.817081451415959],
          [73.332359313964901, 16.817081451415959],
          [73.332359313964901, 16.817363739013729],
          [73.332077026367301, 16.817359924316349],
          [73.332077026367301, 16.81792068481451],
          [73.331802368164119, 16.81792068481451],
          [73.331802368164119, 16.818201065063477],
          [73.331527709960881, 16.818201065063477],
          [73.331527709960881, 16.81875038146967],
          [73.33125305175804, 16.81875038146967],
          [73.33125305175804, 16.819030761718864],
          [73.330970764160327, 16.819026947021484],
          [73.330970764160327, 16.819585800171012],
          [73.330696105957088, 16.819580078125057],
          [73.330696105957088, 16.819860458374023],
          [73.329856872558594, 16.819860458374023],
          [73.329856872558594, 16.820150375366325],
          [73.329032897949332, 16.820150375366325],
          [73.329032897949332, 16.820421218872184],
          [73.328475952148381, 16.820417404174805],
          [73.328475952148381, 16.820695877075195],
          [73.326530456543253, 16.820695877075195],
          [73.326530456543253, 16.820138931274414],
          [73.326248168945313, 16.820150375366325],
          [73.326248168945313, 16.81931114196783],
          [73.32596588134794, 16.81931114196783],
          [73.32596588134794, 16.818201065063477],
          [73.325691223144588, 16.818201065063477],
          [73.325691223144588, 16.81792068481451],
          [73.325416564941349, 16.81792068481451],
          [73.325416564941349, 16.817640304565487],
          [73.325141906738509, 16.817640304565487],
          [73.325141906738509, 16.817359924316349],
          [73.324584960937557, 16.817363739013729],
          [73.324584960937557, 16.816804885864371],
          [73.324302673340014, 16.816804885864371],
          [73.324302673340014, 16.816528320312557],
          [73.324028015137003, 16.816530227661133],
          [73.324028015137003, 16.815692901611442],
          [73.323753356933594, 16.815694808960018],
          [73.323753356933594, 16.815416336059627],
          [73.323471069336222, 16.815420150756779],
          [73.323471069336222, 16.814580917358455],
          [73.323196411132813, 16.814582824707088],
          [73.323196411132813, 16.813749313354492],
          [73.322906494140909, 16.813749313354492],
          [73.322906494140909, 16.813190460205135],
          [73.322639465332088, 16.813194274902344],
          [73.322639465332088, 16.812639236450138],
          [73.322357177734489, 16.812639236450138],
          [73.322357177734489, 16.812360763549748],
          [73.322082519531307, 16.812360763549748],
          [73.322082519531307, 16.811807632446346],
          [73.321533203125057, 16.811807632446346],
          [73.321533203125057, 16.811250686645565],
          [73.320968627929744, 16.811250686645565],
          [73.320968627929744, 16.810689926147461],
          [73.320693969726733, 16.81069374084484],
          [73.320693969726733, 16.810417175293026],
          [73.320419311523722, 16.810419082641602],
          [73.320419311523722, 16.810140609741211],
          [73.31986236572294, 16.810140609741211],
          [73.31986236572294, 16.809860229492244],
          [73.318748474121037, 16.809860229492244],
          [73.318748474121037, 16.809579849243278],
          [73.317916870117244, 16.809583663940487],
          [73.317916870117244, 16.809028625488281],
          [73.317642211914233, 16.809030532836857],
          [73.317642211914233, 16.808750152587891],
          [73.317085266113281, 16.808750152587891],
          [73.317085266113281, 16.8084716796875],
          [73.316802978515909, 16.8084716796875],
          [73.316802978515909, 16.808195114135742],
          [73.316528320312557, 16.808210372924805],
          [73.316528320312557, 16.807920455932731],
          [73.316246032714957, 16.807920455932731],
          [73.316246032714957, 16.807640075683537],
          [73.315971374511776, 16.807640075683537],
          [73.315971374511776, 16.80735969543457],
          [73.315696716308537, 16.807361602783146],
          [73.315696716308537, 16.807083129882812],
          [73.312362670898665, 16.807083129882812],
          [73.312362670898665, 16.806806564331168],
          [73.311248779297159, 16.806806564331168],
          [73.311248779297159, 16.807083129882812],
          [73.310691833496378, 16.807083129882812],
          [73.310691833496378, 16.807361602783146],
          [73.310417175292969, 16.80735969543457],
          [73.310417175292969, 16.807640075683537],
          [73.309860229492244, 16.807640075683537],
          [73.309860229492244, 16.807920455932731],
          [73.309310913086165, 16.807920455932731],
          [73.309310913086165, 16.808210372924805],
          [73.309028625488452, 16.808195114135742],
          [73.309028625488452, 16.8084716796875],
          [73.308197021484659, 16.808469772338924],
          [73.308197021484659, 16.808750152587891],
          [73.303466796875114, 16.808750152587891],
          [73.303466796875114, 16.809030532836857],
          [73.303176879882869, 16.809030532836857],
          [73.303176879882869, 16.809310913086051],
          [73.302635192871321, 16.809305191040096],
          [73.302635192871321, 16.809583663940487],
          [73.302360534668139, 16.809579849243278],
          [73.302360534668139, 16.809860229492244],
          [73.301795959472827, 16.809860229492244],
          [73.301795959472827, 16.810140609741211],
          [73.301528930664347, 16.810140609741211],
          [73.301528930664347, 16.810419082641602],
          [73.301246643066406, 16.810417175293026],
          [73.301246643066406, 16.81069374084484],
          [73.300971984863565, 16.810689926147461],
          [73.300971984863565, 16.810979843139762],
          [73.300415039062614, 16.810972213745231],
          [73.300430297851506, 16.811250686645565],
          [73.300140380859432, 16.811250686645565],
          [73.300140380859432, 16.811529159545955],
          [73.299858093261662, 16.811529159545955],
          [73.299858093261662, 16.811807632446346],
          [73.299583435058821, 16.81180572509777],
          [73.299583435058821, 16.812084197998161],
          [73.299308776855639, 16.812080383300781],
          [73.299308776855639, 16.812360763549748],
          [73.299026489257869, 16.812360763549748],
          [73.299026489257869, 16.812639236450138],
          [73.298751831054858, 16.812639236450138],
          [73.298751831054858, 16.812921524047908],
          [73.298469543457315, 16.812915802001953],
          [73.298469543457315, 16.813194274902344],
          [73.298194885253906, 16.813194274902344],
          [73.298194885253906, 16.813472747802734],
          [73.297920227051065, 16.813470840454102],
          [73.297920227051065, 16.813749313354492],
          [73.297637939453125, 16.813749313354492],
          [73.297637939453125, 16.814027786254883],
          [73.297370910644645, 16.814018249511776],
          [73.297370910644645, 16.814310073852653],
          [73.297080993652401, 16.814306259155273],
          [73.297080993652401, 16.814582824707088],
          [73.296806335449162, 16.814580917358455],
          [73.296806335449162, 16.815141677856445],
          [73.296516418457088, 16.815141677856445],
          [73.296516418457088, 16.815420150756779],
          [73.296249389648608, 16.815416336059627],
          [73.296249389648608, 16.815694808960018],
          [73.295967102051009, 16.815692901611442],
          [73.295967102051009, 16.816251754760799],
          [73.295692443847827, 16.816251754760799],
          [73.295692443847827, 16.816804885864371],
          [73.295417785644815, 16.816791534423885],
          [73.295417785644815, 16.819030761718864],
          [73.295143127441406, 16.819030761718864],
          [73.295143127441406, 16.821529388427734],
          [73.295417785644815, 16.821527481079158],
          [73.295417785644815, 16.822082519531364],
          [73.295967102051009, 16.82208061218256],
          [73.295967102051009, 16.822360992431697],
          [73.296516418457088, 16.822360992431697],
          [73.296516418457088, 16.822639465332088],
          [73.296806335449162, 16.822639465332088],
          [73.296806335449162, 16.822919845581055],
          [73.297080993652401, 16.822919845581055],
          [73.297080993652401, 16.824029922485408],
          [73.296806335449162, 16.824029922485408],
          [73.296806335449162, 16.824310302734432],
          [73.296524047851619, 16.824306488037223],
          [73.296524047851619, 16.824861526489201],
          [73.296249389648608, 16.824859619140625],
          [73.296249389648608, 16.826810836792106],
          [73.296524047851619, 16.826805114746151],
          [73.296524047851619, 16.828193664550895],
          [73.296249389648608, 16.828193664550895],
          [73.296249389648608, 16.828470230102482],
          [73.295967102051009, 16.828470230102482],
          [73.295967102051009, 16.828752517700252],
          [73.295692443847827, 16.828752517700252],
          [73.295692443847827, 16.829027175903434],
          [73.295417785644815, 16.829021453857479],
          [73.295417785644815, 16.829309463500977],
          [73.295135498047046, 16.829305648803825],
          [73.295143127441406, 16.829862594604606],
          [73.294860839844034, 16.829862594604606],
          [73.294860839844034, 16.830141067504996],
          [73.294586181640625, 16.830141067504996],
          [73.294586181640625, 16.83041954040533],
          [73.294303894043253, 16.830417633056754],
          [73.294303894043253, 16.830974578857536],
          [73.294029235839901, 16.830970764160156],
          [73.294029235839901, 16.831809997558707],
          [73.294296264648722, 16.831809997558707],
          [73.294296264648722, 16.832920074462834],
          [73.294586181640625, 16.832920074462834],
          [73.294586181640625, 16.833749771118221],
          [73.294296264648722, 16.833749771118221],
          [73.294296264648722, 16.834030151367188],
          [73.293746948242301, 16.834028244018612],
          [73.293746948242301, 16.834306716919002],
          [73.293472290039119, 16.834306716919002],
          [73.293472290039119, 16.834583282470817],
          [73.293197631836108, 16.834583282470817],
          [73.293197631836108, 16.834861755371207],
          [73.292922973632869, 16.834859848022404],
          [73.292922973632869, 16.835420608520565],
          [73.292640686035327, 16.835420608520565],
          [73.292640686035327, 16.836250305175724],
          [73.292915344238509, 16.836250305175724],
          [73.292915344238509, 16.837360382080078],
          [73.293197631836108, 16.837360382080078],
          [73.293197631836108, 16.838193893432674],
          [73.294029235839901, 16.838188171386719],
          [73.294029235839901, 16.838750839233398],
          [73.293746948242301, 16.838750839233398],
          [73.293746948242301, 16.839311599731559],
          [73.293472290039119, 16.839311599731559],
          [73.293472290039119, 16.839860916137752],
          [73.293197631836108, 16.839860916137752],
          [73.293197631836108, 16.840421676635742],
          [73.292915344238509, 16.840415954589957],
          [73.292915344238509, 16.840972900390739],
          [73.292640686035327, 16.840959548950252],
          [73.292640686035327, 16.841531753540096],
          [73.292358398437557, 16.841527938842887],
          [73.292358398437557, 16.842081069946289],
          [73.292076110840014, 16.842079162597713],
          [73.292076110840014, 16.84264183044445],
          [73.291809082031534, 16.84264183044445],
          [73.291809082031534, 16.84292030334484],
          [73.291526794433594, 16.84292030334484],
          [73.291526794433594, 16.843200683593807],
          [73.291252136230753, 16.843193054199276],
          [73.291252136230753, 16.843471527099609],
          [73.290969848632869, 16.843469619751033],
          [73.290969848632869, 16.843751907348633],
          [73.290138244628849, 16.843751907348633],
          [73.290138244628849, 16.843469619751033],
          [73.289863586426009, 16.843471527099609],
          [73.289863586426009, 16.843193054199276],
          [73.289581298828296, 16.843200683593807],
          [73.289581298828296, 16.84292030334484],
          [73.289016723632983, 16.84292030334484],
          [73.289016723632983, 16.843200683593807],
          [73.288192749023722, 16.843193054199276],
          [73.288192749023722, 16.843471527099609],
          [73.287918090820369, 16.843471527099609],
          [73.287918090820369, 16.844863891601563],
          [73.288200378418253, 16.844860076904354],
          [73.288200378418253, 16.84514045715332],
          [73.288490295410213, 16.84514045715332],
          [73.288490295410213, 16.845420837402344],
          [73.288749694824503, 16.845417022705135],
          [73.288749694824503, 16.845695495605526],
          [73.289306640625057, 16.845695495605526],
          [73.289306640625057, 16.84597206115734],
          [73.289855957031477, 16.845970153808537],
          [73.289855957031477, 16.846530914306697],
          [73.290412902832088, 16.846530914306697],
          [73.290412902832088, 16.846809387207031],
          [73.290702819824162, 16.846809387207031],
          [73.290702819824162, 16.847089767456055],
          [73.29123687744169, 16.847089767456055],
          [73.29123687744169, 16.847360610961857],
          [73.291526794433594, 16.847360610961857],
          [73.291526794433594, 16.847640991211051],
          [73.292076110840014, 16.847640991211051],
          [73.292076110840014, 16.847919464111385],
          [73.292358398437557, 16.847917556762809],
          [73.292358398437557, 16.848194122314453],
          [73.292640686035327, 16.848194122314453],
          [73.292640686035327, 16.848472595214844],
          [73.292922973632869, 16.848470687866211],
          [73.292922973632869, 16.849029541015568],
          [73.293197631836108, 16.849027633666992],
          [73.293197631836108, 16.849582672119197],
          [73.292922973632869, 16.849580764770565],
          [73.292922973632869, 16.851528167724666],
          [73.292640686035327, 16.851528167724666],
          [73.292640686035327, 16.851804733276481],
          [73.291809082031534, 16.851804733276481],
          [73.291809082031534, 16.851528167724666],
          [73.291526794433594, 16.851528167724666],
          [73.291526794433594, 16.851249694824276],
          [73.290702819824162, 16.851249694824276],
          [73.290702819824162, 16.851528167724666],
          [73.290412902832088, 16.851528167724666],
          [73.290412902832088, 16.852083206176871],
          [73.290138244628849, 16.852079391479492],
          [73.290138244628849, 16.852920532226619],
          [73.290969848632869, 16.852916717529411],
          [73.290969848632869, 16.853195190429801],
          [73.292358398437557, 16.853195190429801],
          [73.292358398437557, 16.853471755981388],
          [73.292640686035327, 16.853469848632813],
          [73.292640686035327, 16.855421066284293],
          [73.292358398437557, 16.855417251586914],
          [73.292358398437557, 16.855693817138729],
          [73.292083740234546, 16.855693817138729],
          [73.292083740234546, 16.855970382690487],
          [73.290969848632869, 16.855970382690487],
          [73.290969848632869, 16.856260299682617],
          [73.289855957031477, 16.856260299682617],
          [73.289855957031477, 16.856531143188477],
          [73.289306640625057, 16.856531143188477],
          [73.289306640625057, 16.85680961608881],
          [73.288200378418253, 16.85680961608881],
          [73.288200378418253, 16.85764122009283],
          [73.287918090820369, 16.857639312744197],
          [73.287918090820369, 16.858192443847599],
          [73.288475036621094, 16.858192443847599],
          [73.288475036621094, 16.858474731445369],
          [73.288749694824503, 16.85847091674799],
          [73.288749694824503, 16.858749389648381],
          [73.289306640625057, 16.858749389648381],
          [73.289306640625057, 16.859029769897518],
          [73.289855957031477, 16.859029769897518],
          [73.289855957031477, 16.859319686889648],
          [73.290695190429801, 16.859306335449332],
          [73.290695190429801, 16.859584808349723],
          [73.291526794433594, 16.859584808349723],
          [73.291526794433594, 16.85986137390131],
          [73.292076110840014, 16.859859466552734],
          [73.292076110840014, 16.860139846801701],
          [73.293472290039119, 16.860139846801701],
          [73.293472290039119, 16.859859466552734],
          [73.294029235839901, 16.85986137390131],
          [73.294029235839901, 16.859306335449332],
          [73.294296264648722, 16.859319686889648],
          [73.294296264648722, 16.85847091674799],
          [73.294586181640625, 16.858474731445369],
          [73.294586181640625, 16.858192443847599],
          [73.295135498047046, 16.858192443847599],
          [73.295135498047046, 16.859584808349723],
          [73.294860839844034, 16.859584808349723],
          [73.294860839844034, 16.862083435058651],
          [73.294586181640625, 16.862070083618164],
          [73.294586181640625, 16.863750457763729],
          [73.294296264648722, 16.863750457763729],
          [73.294296264648722, 16.864030838012752],
          [73.294029235839901, 16.864030838012752],
          [73.294029235839901, 16.866531372070426],
          [73.293746948242301, 16.866531372070426],
          [73.293746948242301, 16.867639541625977],
          [73.293472290039119, 16.867639541625977],
          [73.293472290039119, 16.868200302124137],
          [73.293197631836108, 16.868194580078182],
          [73.293197631836108, 16.869863510131893],
          [73.292922973632869, 16.869859695434513],
          [73.292922973632869, 16.870700836181641],
          [73.292640686035327, 16.870693206787109],
          [73.292640686035327, 16.870973587036246],
          [73.292076110840014, 16.870969772338867],
          [73.292076110840014, 16.871259689331168],
          [73.291526794433594, 16.871259689331168],
          [73.291526794433594, 16.870700836181641],
          [73.291252136230753, 16.870693206787109],
          [73.291252136230753, 16.870973587036246],
          [73.290969848632869, 16.870973587036246],
          [73.290969848632869, 16.870416641235465],
          [73.290138244628849, 16.870420455932674],
          [73.290138244628849, 16.870700836181641],
          [73.289581298828296, 16.870693206787109],
          [73.289581298828296, 16.870973587036246],
          [73.289306640625057, 16.870973587036246],
          [73.289306640625057, 16.872085571289176],
          [73.289016723632983, 16.872079849243221],
          [73.289016723632983, 16.872640609741154],
          [73.288749694824503, 16.872640609741154],
          [73.288749694824503, 16.872920989990348],
          [73.288475036621094, 16.872917175292969],
          [73.288475036621094, 16.873195648193359],
          [73.286247253418026, 16.873195648193359],
          [73.286247253418026, 16.873472213745174],
          [73.285972595215014, 16.873470306396541],
          [73.285972595215014, 16.876251220703239],
          [73.286247253418026, 16.876251220703239],
          [73.286247253418026, 16.876808166503963],
          [73.286529541015796, 16.876806259155387],
          [73.286529541015796, 16.877082824707031],
          [73.286804199218977, 16.877082824707031],
          [73.286804199218977, 16.878194808959961],
          [73.286529541015796, 16.878194808959961],
          [73.286529541015796, 16.878471374511719],
          [73.286247253418026, 16.878471374511719],
          [73.286247253418026, 16.879304885864315],
          [73.285972595215014, 16.879304885864315],
          [73.285972595215014, 16.879583358764705],
          [73.285697937012003, 16.879579544067496],
          [73.285697937012003, 16.88070106506359],
          [73.285972595215014, 16.88070106506359],
          [73.285972595215014, 16.881250381469783],
          [73.286247253418026, 16.881250381469783],
          [73.286247253418026, 16.881532669067383],
          [73.286529541015796, 16.881532669067383],
          [73.286529541015796, 16.881811141967773],
          [73.287086486816349, 16.881805419921989],
          [73.287086486816349, 16.882083892822379],
          [73.287361145019588, 16.882080078125],
          [73.287361145019588, 16.882360458373967],
          [73.28763580322277, 16.882360458373967],
          [73.28763580322277, 16.882642745971737],
          [73.288490295410213, 16.882642745971737],
          [73.288490295410213, 16.882921218872127],
          [73.289016723632983, 16.882921218872127],
          [73.289016723632983, 16.883199691772518],
          [73.289863586426009, 16.88319206237793],
          [73.289863586426009, 16.88347053527832],
          [73.290695190429801, 16.88347053527832],
          [73.290695190429801, 16.88375282287609],
          [73.29123687744169, 16.88375282287609],
          [73.29123687744169, 16.884029388427678],
          [73.291526794433594, 16.884029388427678],
          [73.291526794433594, 16.884309768676871],
          [73.291809082031534, 16.884304046630916],
          [73.291809082031534, 16.884584426879883],
          [73.292076110840014, 16.884580612182674],
          [73.292076110840014, 16.884862899780273],
          [73.292640686035327, 16.884862899780273],
          [73.292640686035327, 16.885139465332031],
          [73.292915344238509, 16.885139465332031],
          [73.292915344238509, 16.885692596435661],
          [73.293197631836108, 16.885690689086857],
          [73.293197631836108, 16.886529922485352],
          [73.293472290039119, 16.886528015136776],
          [73.293472290039119, 16.887083053588981],
          [73.293746948242301, 16.887081146240178],
          [73.293746948242301, 16.887639999389705],
          [73.294029235839901, 16.887639999389705],
          [73.294029235839901, 16.887920379638729],
          [73.294586181640625, 16.887920379638729],
          [73.294586181640625, 16.888200759887695],
          [73.295135498047046, 16.888196945190487],
          [73.295135498047046, 16.888471603393498],
          [73.295417785644815, 16.888469696044922],
          [73.295417785644815, 16.888750076293888],
          [73.295974731445369, 16.888750076293888],
          [73.295974731445369, 16.889305114746094],
          [73.296524047851619, 16.889305114746094],
          [73.296524047851619, 16.889583587646484],
          [73.296806335449162, 16.889579772949276],
          [73.296806335449162, 16.889860153198242],
          [73.297920227051065, 16.889860153198242],
          [73.297920227051065, 16.890140533447209],
          [73.300140380859432, 16.890140533447209],
          [73.300140380859432, 16.890420913696403],
          [73.300971984863565, 16.890417098999023],
          [73.300971984863565, 16.890693664550838],
          [73.301803588867358, 16.890693664550838],
          [73.301803588867358, 16.890417098999023],
          [73.302917480468693, 16.890420913696403],
          [73.302917480468693, 16.890140533447209],
          [73.303749084472713, 16.890140533447209],
          [73.303749084472713, 16.889860153198242],
          [73.304031372070597, 16.889860153198242],
          [73.304031372070597, 16.889579772949276],
          [73.304580688476847, 16.889583587646484],
          [73.304580688476847, 16.889305114746094],
          [73.306251525878963, 16.889305114746094],
          [73.306251525878963, 16.889583587646484],
          [73.306526184082145, 16.889579772949276],
          [73.306526184082145, 16.889860153198242],
          [73.306808471679744, 16.889860153198242],
          [73.306808471679744, 16.890140533447209],
          [73.307357788085938, 16.890140533447209],
          [73.307357788085938, 16.890420913696403],
          [73.307640075683878, 16.890420913696403],
          [73.307640075683878, 16.890140533447209],
          [73.308197021484659, 16.890140533447209],
          [73.308197021484659, 16.890420913696403],
          [73.308746337890852, 16.890420913696403],
          [73.308746337890852, 16.890140533447209],
          [73.310142517089957, 16.890140533447209],
          [73.310142517089957, 16.889860153198242],
          [73.310691833496378, 16.889860153198242],
          [73.310691833496378, 16.889579772949276],
          [73.311248779297159, 16.889583587646484],
          [73.311248779297159, 16.889305114746094],
          [73.311805725097713, 16.889305114746094],
          [73.311805725097713, 16.888750076293888],
          [73.312080383300952, 16.888750076293888],
          [73.312080383300952, 16.888200759887695],
          [73.312370300293196, 16.888200759887695],
          [73.312370300293196, 16.887639999389705],
          [73.312919616699276, 16.887639999389705],
          [73.312919616699276, 16.887920379638729],
          [73.313468933105469, 16.887920379638729],
          [73.313468933105469, 16.889030456543082],
          [73.313194274902457, 16.889028549194279],
          [73.313194274902457, 16.889583587646484],
          [73.312637329101506, 16.889583587646484],
          [73.312637329101506, 16.889862060546875],
          [73.312370300293196, 16.889860153198242],
          [73.312370300293196, 16.890140533447209],
          [73.311813354492244, 16.890140533447209],
          [73.311813354492244, 16.890420913696403],
          [73.311531066894702, 16.890417098999023],
          [73.311531066894702, 16.890693664550838],
          [73.31097412109375, 16.890693664550838],
          [73.31097412109375, 16.890972137451229],
          [73.310417175292969, 16.890970230102596],
          [73.310417175292969, 16.891250610351563],
          [73.309028625488452, 16.891250610351563],
          [73.309028625488452, 16.891529083251953],
          [73.306472778320369, 16.891527175903377],
          [73.306251525878963, 16.891527175903377],
          [73.306251525878963, 16.891250610351563],
          [73.305969238281193, 16.891250610351563],
          [73.305969238281193, 16.891450881958008],
          [73.305969238281193, 16.891527175903377],
          [73.305686950683821, 16.891529083251953],
          [73.305686950683821, 16.891412734985295],
          [73.305694580078352, 16.891250610351563],
          [73.304656982422046, 16.891250610351563],
          [73.304306030273437, 16.891250610351563],
          [73.304306030273437, 16.890972137451229],
          [73.303749084472713, 16.890972137451229],
          [73.303749084472713, 16.891109466552734],
          [73.303749084472713, 16.891250610351563],
          [73.303176879882869, 16.891250610351563],
          [73.303176879882869, 16.891529083251953],
          [73.302642822265852, 16.891529083251953],
          [73.302642822265852, 16.891807556152344],
          [73.302085876464901, 16.891805648803768],
          [73.302085876464901, 16.892084121704158],
          [73.301528930664347, 16.892080307006779],
          [73.301528930664347, 16.892360687255916],
          [73.300971984863565, 16.892360687255916],
          [73.300971984863565, 16.892639160156307],
          [73.300415039062614, 16.892639160156307],
          [73.300415039062614, 16.893194198608512],
          [73.300140380859432, 16.893194198608512],
          [73.300140380859432, 16.893472671508903],
          [73.299858093261662, 16.893470764160099],
          [73.299858093261662, 16.89374923706049],
          [73.299583435058821, 16.89374923706049],
          [73.299583435058821, 16.894582748413086],
          [73.299308776855639, 16.894580841064453],
          [73.299308776855639, 16.894859313964844],
          [73.299026489257869, 16.894859313964844],
          [73.299026489257869, 16.895141601562614],
          [73.298751831054858, 16.895141601562614],
          [73.298751831054858, 16.895429611206112],
          [73.298469543457315, 16.895416259765625],
          [73.298469543457315, 16.895694732666016],
          [73.298187255859546, 16.89569282531744],
          [73.298187255859546, 16.896249771118164],
          [73.297920227051065, 16.896249771118164],
          [73.297920227051065, 16.896530151367131],
          [73.297637939453125, 16.896528244018555],
          [73.297637939453125, 16.896804809570369],
          [73.297080993652401, 16.896804809570369],
          [73.297080993652401, 16.897081375122127],
          [73.296524047851619, 16.897081375122127],
          [73.296524047851619, 16.897363662719727],
          [73.295692443847827, 16.897359848022518],
          [73.295692443847827, 16.897640228271484],
          [73.294769287109375, 16.897638320922908],
          [73.293746948242301, 16.897640228271484],
          [73.293746948242301, 16.897920608520508],
          [73.293472290039119, 16.897920608520508],
          [73.293472290039119, 16.897640228271484],
          [73.291526794433594, 16.897640228271484],
          [73.291526794433594, 16.897359848022518],
          [73.290695190429801, 16.897363662719727],
          [73.290695190429801, 16.896804809570369],
          [73.290412902832088, 16.896804809570369],
          [73.290412902832088, 16.896528244018555],
          [73.289581298828296, 16.896530151367131],
          [73.289581298828296, 16.896249771118164],
          [73.289016723632983, 16.896249771118164],
          [73.289016723632983, 16.896530151367131],
          [73.288475036621094, 16.896528244018555],
          [73.288475036621094, 16.896804809570369],
          [73.28763580322277, 16.896804809570369],
          [73.28763580322277, 16.896528244018555],
          [73.287361145019588, 16.896530151367131],
          [73.287361145019588, 16.896249771118164],
          [73.287086486816349, 16.896249771118164],
          [73.287086486816349, 16.895969390869197],
          [73.287361145019588, 16.895971298217773],
          [73.287361145019588, 16.895694732666016],
          [73.28763580322277, 16.895694732666016],
          [73.28763580322277, 16.89374923706049],
          [73.287361145019588, 16.89374923706049],
          [73.287361145019588, 16.893190383911133],
          [73.287086486816349, 16.893194198608512],
          [73.287086486816349, 16.892917633056697],
          [73.286529541015796, 16.892921447753906],
          [73.286529541015796, 16.892639160156307],
          [73.285430908203125, 16.892639160156307],
          [73.285430908203125, 16.892921447753906],
          [73.285140991211222, 16.892917633056697],
          [73.285140991211222, 16.893194198608512],
          [73.284858703613281, 16.893194198608512],
          [73.284858703613281, 16.892917633056697],
          [73.283470153808764, 16.892921447753906],
          [73.283470153808764, 16.892639160156307],
          [73.283203125000057, 16.892639160156307],
          [73.283203125000057, 16.892080307006779],
          [73.282363891601562, 16.892084121704158],
          [73.282363891601562, 16.891805648803768],
          [73.281517028808878, 16.891807556152344],
          [73.281517028808878, 16.891529083251953],
          [73.280693054199276, 16.891529083251953],
          [73.280693054199276, 16.891807556152344],
          [73.280418395996264, 16.891805648803768],
          [73.280418395996264, 16.892084121704158],
          [73.279861450195483, 16.892084121704158],
          [73.279861450195483, 16.891805648803768],
          [73.279586791992472, 16.891807556152344],
          [73.279586791992472, 16.891529083251953],
          [73.278472900390909, 16.891529083251953],
          [73.278472900390909, 16.891807556152344],
          [73.278198242187557, 16.891805648803768],
          [73.278198242187557, 16.892084121704158],
          [73.277084350586165, 16.892084121704158],
          [73.277084350586165, 16.893472671508903],
          [73.277359008789006, 16.893470764160099],
          [73.277359008789006, 16.89403152465826],
          [73.277641296386776, 16.89403152465826],
          [73.277641296386776, 16.894311904907227],
          [73.277915954589957, 16.894311904907227],
          [73.277915954589957, 16.894859313964844],
          [73.278198242187557, 16.894859313964844],
          [73.278198242187557, 16.895141601562614],
          [73.278472900390909, 16.895141601562614],
          [73.278472900390909, 16.895429611206112],
          [73.27874755859375, 16.895416259765625],
          [73.27874755859375, 16.895971298217773],
          [73.27902984619169, 16.895969390869197],
          [73.27902984619169, 16.896249771118164],
          [73.279296875000171, 16.896249771118164],
          [73.279296875000171, 16.896530151367131],
          [73.279586791992472, 16.896528244018555],
          [73.279586791992472, 16.896804809570369],
          [73.279861450195483, 16.896804809570369],
          [73.279861450195483, 16.897081375122127],
          [73.280136108398665, 16.897081375122127],
          [73.280136108398665, 16.89847373962408],
          [73.279861450195483, 16.898469924926701],
          [73.279861450195483, 16.898750305175838],
          [73.279586791992472, 16.898750305175838],
          [73.279586791992472, 16.902639389038086],
          [73.279304504394702, 16.902639389038086],
          [73.279304504394702, 16.903194427490291],
          [73.27902984619169, 16.903190612792912],
          [73.27902984619169, 16.904029846191406],
          [73.279304504394702, 16.90402793884283],
          [73.279304504394702, 16.904306411743221],
          [73.279586791992472, 16.904306411743221],
          [73.279586791992472, 16.904861450195426],
          [73.279861450195483, 16.904861450195426],
          [73.279861450195483, 16.904582977295036],
          [73.280136108398665, 16.904582977295036],
          [73.280136108398665, 16.904861450195426],
          [73.280418395996264, 16.904859542846623],
          [73.280418395996264, 16.90513992309576],
          [73.280693054199276, 16.90513992309576],
          [73.280693054199276, 16.90570068359375],
          [73.280975341796818, 16.905694961547965],
          [73.280975341796818, 16.905971527099553],
          [73.281250000000057, 16.905969619750977],
          [73.281250000000057, 16.906248092651367],
          [73.282066345215128, 16.906248092651367],
          [73.282066345215128, 16.906528472900334],
          [73.282638549804972, 16.906528472900334],
          [73.282638549804972, 16.906810760498104],
          [73.282913208007983, 16.906805038452148],
          [73.282913208007983, 16.907083511352539],
          [73.283203125000057, 16.90707969665533],
          [73.283203125000057, 16.907369613647461],
          [73.283470153808764, 16.907369613647461],
          [73.283470153808764, 16.907642364502067],
          [73.283752441406477, 16.907642364502067],
          [73.283752441406477, 16.907922744751033],
          [73.284027099609318, 16.907922744751033],
          [73.284027099609318, 16.909860610961971],
          [73.283752441406477, 16.909860610961971],
          [73.283752441406477, 16.91014289855957],
          [73.284027099609318, 16.910139083862362],
          [73.284027099609318, 16.910692214965763],
          [73.284301757812557, 16.910692214965763],
          [73.284309387207088, 16.911249160766545],
          [73.284309387207088, 16.911529541015682],
          [73.284576416015909, 16.911529541015682],
          [73.284576416015909, 16.911809921264705],
          [73.284858703613281, 16.911809921264705],
          [73.284858703613281, 16.912361145019474],
          [73.285415649414063, 16.912361145019474],
          [73.285415649414063, 16.912639617919865],
          [73.285697937012003, 16.912639617919865],
          [73.285697937012003, 16.91319465637207],
          [73.285430908203125, 16.913179397583008],
          [73.285430908203125, 16.914030075073185],
          [73.285140991211222, 16.914028167724609],
          [73.285140991211222, 16.914583206176815],
          [73.284858703613281, 16.914579391479606],
          [73.284858703613281, 16.915140151977539],
          [73.285140991211222, 16.915140151977539],
          [73.285140991211222, 16.915420532226562],
          [73.285430908203125, 16.915420532226562],
          [73.285430908203125, 16.9157009124757],
          [73.285972595215014, 16.915695190429744],
          [73.285972595215014, 16.915971755981559],
          [73.286529541015796, 16.915971755981559],
          [73.286529541015796, 16.916250228881893],
          [73.286796569824276, 16.916240692138786],
          [73.286796569824276, 16.91764068603527],
          [73.286529541015796, 16.91764068603527],
          [73.286529541015796, 16.919311523437557],
          [73.286247253418026, 16.919311523437557],
          [73.286247253418026, 16.920139312744141],
          [73.285972595215014, 16.920139312744141],
          [73.285972595215014, 16.920421600341911],
          [73.285697937012003, 16.920415878295955],
          [73.285697937012003, 16.920694351196346],
          [73.285415649414063, 16.920694351196346],
          [73.285415649414063, 16.920972824096737],
          [73.284576416015909, 16.920970916748104],
          [73.284576416015909, 16.921810150146484],
          [73.284309387207088, 16.921810150146484],
          [73.284301757812557, 16.922372817993164],
          [73.284027099609318, 16.922372817993164],
          [73.284027099609318, 16.922920227050838],
          [73.283470153808764, 16.922916412353629],
          [73.283470153808764, 16.923471450805607],
          [73.283195495605526, 16.923471450805607],
          [73.283203125000057, 16.923749923705998],
          [73.282913208007983, 16.923749923705998],
          [73.282913208007983, 16.924310684204158],
          [73.282638549804972, 16.924303054809627],
          [73.282638549804972, 16.924863815307731],
          [73.282363891601562, 16.924863815307731],
          [73.282363891601562, 16.925695419311523],
          [73.282638549804972, 16.925695419311523],
          [73.282638549804972, 16.925973892211914],
          [73.282913208007983, 16.925970077514705],
          [73.282913208007983, 16.926530838012695],
          [73.282638549804972, 16.926530838012695],
          [73.282638549804972, 16.926811218261832],
          [73.282363891601562, 16.926805496215877],
          [73.282363891601562, 16.927085876464844],
          [73.282066345215128, 16.927080154418888],
          [73.282066345215128, 16.92930984497076],
          [73.282356262207202, 16.92930984497076],
          [73.282356262207202, 16.930419921875114],
          [73.282638549804972, 16.930419921875114],
          [73.282638549804972, 16.931249618530273],
          [73.283203125000057, 16.931249618530273],
          [73.283203125000057, 16.931541442871151],
          [73.283752441406477, 16.931528091430664],
          [73.283752441406477, 16.931804656982479],
          [73.285140991211222, 16.931804656982479],
          [73.285140991211222, 16.932083129882869],
          [73.285415649414063, 16.932083129882869],
          [73.285415649414063, 16.931804656982479],
          [73.285697937012003, 16.931804656982479],
          [73.285697937012003, 16.931528091430664],
          [73.286804199218977, 16.931528091430664],
          [73.286804199218977, 16.931804656982479],
          [73.287086486816349, 16.931800842285099],
          [73.287086486816349, 16.932918548583984],
          [73.287361145019588, 16.932918548583984],
          [73.287361145019588, 16.935142517089901],
          [73.287086486816349, 16.935138702392521],
          [73.287086486816349, 16.935970306396484],
          [73.286796569824276, 16.935970306396484],
          [73.286796569824276, 16.936252593994254],
          [73.286529541015796, 16.936252593994254],
          [73.286529541015796, 16.937082290649471],
          [73.286247253418026, 16.937082290649471],
          [73.286247253418026, 16.937360763549805],
          [73.285972595215014, 16.937349319458121],
          [73.285972595215014, 16.938751220703182],
          [73.285697937012003, 16.938751220703182],
          [73.285697937012003, 16.939310073852539],
          [73.285415649414063, 16.93930625915533],
          [73.285415649414063, 16.939861297607536],
          [73.285140991211222, 16.939859390258732],
          [73.285140991211222, 16.940139770507869],
          [73.284858703613281, 16.940139770507869],
          [73.284858703613281, 16.940696716308651],
          [73.28458404541027, 16.940696716308651],
          [73.28458404541027, 16.940971374511662],
          [73.284309387207088, 16.940969467163086],
          [73.284301757812557, 16.941530227661246],
          [73.283752441406477, 16.941528320312443],
          [73.283752441406477, 16.941806793213004],
          [73.283470153808764, 16.941806793213004],
          [73.283470153808764, 16.942083358764648],
          [73.283752441406477, 16.94207954406744],
          [73.283752441406477, 16.942920684814567],
          [73.284027099609318, 16.942920684814567],
          [73.284027099609318, 16.943201065063533],
          [73.284301757812557, 16.943201065063533],
          [73.284309387207088, 16.943479537963924],
          [73.284576416015909, 16.943479537963924],
          [73.284576416015909, 16.943750381469727],
          [73.284309387207088, 16.943750381469727],
          [73.284301757812557, 16.944311141967887],
          [73.284027099609318, 16.944311141967887],
          [73.284027099609318, 16.94542121887207],
          [73.283470153808764, 16.945417404174862],
          [73.283470153808764, 16.945972442627067],
          [73.283203125000057, 16.945970535278263],
          [73.283203125000057, 16.946811676025391],
          [73.282913208007983, 16.946805953979606],
          [73.282913208007983, 16.94708251953125],
          [73.282638549804972, 16.947080612182617],
          [73.282638549804972, 16.947359085083008],
          [73.282356262207202, 16.947359085083008],
          [73.282356262207202, 16.947639465331974],
          [73.282066345215128, 16.947639465331974],
          [73.282066345215128, 16.947921752929744],
          [73.281806945800781, 16.947916030883789],
          [73.281806945800781, 16.949581146240291],
          [73.282066345215128, 16.949581146240291],
          [73.282066345215128, 16.950420379638672],
          [73.282356262207202, 16.950420379638672],
          [73.282356262207202, 16.951250076294002],
          [73.282638549804972, 16.951250076294002],
          [73.282638549804972, 16.951810836791992],
          [73.282913208007983, 16.951803207397461],
          [73.282913208007983, 16.952360153198185],
          [73.283203125000057, 16.952350616455078],
          [73.283203125000057, 16.952640533447379],
          [73.283470153808764, 16.952640533447379],
          [73.283470153808764, 16.952920913696346],
          [73.283752441406477, 16.952917098999137],
          [73.283752441406477, 16.953472137451172],
          [73.284301757812557, 16.953470230102539],
          [73.284309387207088, 16.953750610351506],
          [73.284858703613281, 16.953750610351506],
          [73.284858703613281, 16.953470230102539],
          [73.285140991211222, 16.953472137451172],
          [73.285140991211222, 16.953195571899528],
          [73.285415649414063, 16.953195571899528],
          [73.285415649414063, 16.952917098999137],
          [73.285697937012003, 16.952920913696346],
          [73.285697937012003, 16.952640533447379],
          [73.285972595215014, 16.952640533447379],
          [73.285972595215014, 16.952350616455078],
          [73.286247253418026, 16.952360153198185],
          [73.286247253418026, 16.952085494995174],
          [73.288192749023722, 16.952085494995174],
          [73.288192749023722, 16.953195571899528],
          [73.288475036621094, 16.953195571899528],
          [73.288475036621094, 16.953472137451172],
          [73.288749694824503, 16.953470230102539],
          [73.288749694824503, 16.95430946350109],
          [73.289024353027514, 16.954305648803711],
          [73.289024353027514, 16.954584121704102],
          [73.289306640625057, 16.954580307006893],
          [73.289306640625057, 16.954860687255859],
          [73.289581298828296, 16.954860687255859],
          [73.289581298828296, 16.955141067504883],
          [73.289855957031477, 16.955141067504883],
          [73.289855957031477, 16.955419540405217],
          [73.290412902832088, 16.955417633056641],
          [73.290412902832088, 16.955694198608455],
          [73.291526794433594, 16.955690383911076],
          [73.291526794433594, 16.956251144409237],
          [73.291809082031534, 16.956251144409237],
          [73.291809082031534, 16.956808090209961],
          [73.292083740234546, 16.956806182861385],
          [73.292083740234546, 16.959304809570313],
          [73.291809082031534, 16.959299087524528],
          [73.291809082031534, 16.962642669677734],
          [73.291526794433594, 16.962638854980526],
          [73.291526794433594, 16.963470458984318],
          [73.291809082031534, 16.963470458984318],
          [73.291809082031534, 16.963752746582088],
          [73.292076110840014, 16.963752746582088],
          [73.292076110840014, 16.964031219482479],
          [73.292358398437557, 16.96402740478527],
          [73.292358398437557, 16.964582443237305],
          [73.292640686035327, 16.964580535888672],
          [73.292640686035327, 16.964862823486442],
          [73.292915344238509, 16.964862823486442],
          [73.292915344238509, 16.965139389038029],
          [73.293197631836108, 16.965139389038029],
          [73.293197631836108, 16.965419769287223],
          [73.293472290039119, 16.965419769287223],
          [73.293472290039119, 16.966249465942383],
          [73.293746948242301, 16.966249465942383],
          [73.293746948242301, 16.966810226440543],
          [73.294029235839901, 16.966810226440543],
          [73.294029235839901, 16.967639923095703],
          [73.293746948242301, 16.967638015747127],
          [73.293746948242301, 16.969583511352653],
          [73.294303894043253, 16.969583511352653],
          [73.294303894043253, 16.969861984253043],
          [73.294029235839901, 16.96986007690424],
          [73.294029235839901, 16.971807479858342],
          [73.293746948242301, 16.971807479858342],
          [73.293746948242301, 16.972360610961914],
          [73.294029235839901, 16.972360610961914],
          [73.294029235839901, 16.972921371460075],
          [73.293746948242301, 16.972921371460075],
          [73.293746948242301, 16.974031448364258],
          [73.294029235839901, 16.974031448364258],
          [73.294029235839901, 16.977640151977482],
          [73.293746948242301, 16.977640151977482],
          [73.293746948242301, 16.978200912475643],
          [73.294029235839901, 16.978200912475643],
          [73.294029235839901, 16.978750228881836],
          [73.294303894043253, 16.978750228881836],
          [73.294303894043253, 16.979585647583008],
          [73.294586181640625, 16.979579925537053],
          [73.294586181640625, 16.98042106628418],
          [73.294860839844034, 16.98042106628418],
          [73.294860839844034, 16.981250762939567],
          [73.294586181640625, 16.981250762939567],
          [73.294586181640625, 16.981531143188533],
          [73.294303894043253, 16.981527328491325],
          [73.294303894043253, 16.985971450805778],
          [73.293746948242301, 16.985969543456974],
          [73.293746948242301, 16.986249923706112],
          [73.293472290039119, 16.986249923706112],
          [73.293472290039119, 16.986528396606502],
          [73.293197631836108, 16.986528396606502],
          [73.293197631836108, 16.986810684204102],
          [73.292915344238509, 16.986804962158317],
          [73.292915344238509, 16.987083435058707],
          [73.292640686035327, 16.987083435058707],
          [73.292640686035327, 16.987361907959098],
          [73.292358398437557, 16.987358093261719],
          [73.292358398437557, 16.987642288208065],
          [73.292076110840014, 16.987642288208065],
          [73.292076110840014, 16.987922668457031],
          [73.291961669922102, 16.987916946411246],
          [73.291526794433594, 16.987916946411246],
          [73.291526794433594, 16.988191604614258],
          [73.291252136230753, 16.988195419311637],
          [73.291252136230753, 16.988470077514648],
          [73.290695190429801, 16.988470077514648],
          [73.290702819824162, 16.988750457763615],
          [73.290412902832088, 16.988750457763615],
          [73.290412902832088, 16.989032745361385],
          [73.284576416015909, 16.989032745361385],
          [73.284576416015909, 16.989311218261776],
          [73.284027099609318, 16.98930549621582],
          [73.284027099609318, 16.989582061767635],
          [73.283752441406477, 16.989580154419002],
          [73.283752441406477, 16.989860534667969],
          [73.283363342285213, 16.989860534667969],
          [73.282913208007983, 16.989860534667969],
          [73.282913208007983, 16.990142822265739],
          [73.282638549804972, 16.990142822265739],
          [73.282638549804972, 16.990419387817326],
          [73.282363891601562, 16.99041748046875],
          [73.282363891601562, 16.990692138671989],
          [73.28208160400419, 16.990692138671989],
          [73.28208160400419, 16.990974426269531],
          [73.281806945800781, 16.990970611572322],
          [73.281806945800781, 16.991252899169922],
          [73.281250000000057, 16.991252899169922],
          [73.281250000000057, 16.99152946472168],
          [73.280693054199276, 16.99152946472168],
          [73.280693054199276, 16.991809844970703],
          [73.280418395996264, 16.991804122924918],
          [73.280418395996264, 16.992084503173885],
          [73.279861450195483, 16.992080688476506],
          [73.279861450195483, 16.9923610687257],
          [73.277915954589957, 16.9923610687257],
          [73.277915954589957, 16.992080688476506],
          [73.276802062988452, 16.992084503173885],
          [73.276802062988452, 16.991249084472713],
          [73.276527404785213, 16.991252899169922],
          [73.276527404785213, 16.990970611572322],
          [73.276252746582202, 16.990974426269531],
          [73.276252746582202, 16.990692138671989],
          [73.275970458984659, 16.990692138671989],
          [73.275970458984659, 16.990139007568359],
          [73.27569580078125, 16.990142822265739],
          [73.27569580078125, 16.989580154419002],
          [73.275138854980526, 16.989582061767635],
          [73.275138854980526, 16.98902702331543],
          [73.274856567382926, 16.989032745361385],
          [73.274856567382926, 16.988201141357422],
          [73.274581909179744, 16.988191604614258],
          [73.274581909179744, 16.987638473510685],
          [73.274856567382926, 16.987642288208065],
          [73.274856567382926, 16.987358093261719],
          [73.274581909179744, 16.987361907959098],
          [73.274581909179744, 16.986528396606502],
          [73.274307250976506, 16.986528396606502],
          [73.274307250976506, 16.986249923706112],
          [73.273750305175952, 16.986249923706112],
          [73.273750305175952, 16.985691070556584],
          [73.272087097168026, 16.985694885253963],
          [73.272087097168026, 16.985971450805778],
          [73.271797180176065, 16.985969543456974],
          [73.271797180176065, 16.986249923706112],
          [73.271530151367244, 16.986249923706112],
          [73.271530151367244, 16.986528396606502],
          [73.270973205566634, 16.986528396606502],
          [73.270973205566634, 16.987083435058707],
          [73.270690917968921, 16.987079620361328],
          [73.270690917968921, 16.987922668457031],
          [73.270416259765682, 16.987916946411246],
          [73.270416259765682, 16.988470077514648],
          [73.270126342773608, 16.988460540771541],
          [73.270126342773608, 16.989311218261776],
          [73.269859313965128, 16.989311218261776],
          [73.269859313965128, 16.989860534667969],
          [73.268470764160213, 16.989860534667969],
          [73.268470764160213, 16.990142822265739],
          [73.268196105956974, 16.990142822265739],
          [73.268196105956974, 16.9923610687257],
          [73.268470764160213, 16.9923610687257],
          [73.268470764160213, 16.993192672729492],
          [73.268753051757926, 16.993190765380859],
          [73.268753051757926, 16.995140075683537],
          [73.267906188964901, 16.995140075683537],
          [73.267906188964901, 16.996530532836914],
          [73.268196105956974, 16.996530532836914],
          [73.268196105956974, 16.996810913086051],
          [73.268470764160213, 16.996810913086051],
          [73.268470764160213, 16.997648239135799],
          [73.268753051757926, 16.997648239135799],
          [73.268753051757926, 16.997919082641602],
          [73.269027709960937, 16.997919082641602],
          [73.269027709960937, 16.999307632446346],
          [73.269577026367358, 16.999307632446346],
          [73.269577026367358, 16.999860763549748],
          [73.269302368164347, 16.999860763549748],
          [73.269302368164347, 16.999998092651481],
          [73.269302368164347, 17.000139236450138],
          [73.269577026367358, 17.000139236450138],
          [73.269577026367358, 17.000421524047908],
          [73.269859313965128, 17.000421524047908],
          [73.269859313965128, 17.000139236450138],
          [73.270126342773608, 17.000139236450138],
          [73.270126342773608, 16.999860763549748],
          [73.270126342773608, 16.999307632446346],
          [73.270416259765682, 16.999307632446346],
          [73.270416259765682, 16.999029159545955],
          [73.270973205566634, 16.999029159545955],
          [73.270973205566634, 16.999307632446346],
          [73.271530151367244, 16.99930572509777],
          [73.271530151367244, 16.999584197998161],
          [73.271797180176065, 16.999580383300781],
          [73.271797180176065, 16.999860763549748],
          [73.273200988769702, 16.999860763549748],
          [73.273193359375171, 16.997638702392635],
          [73.274307250976506, 16.997648239135799],
          [73.274307250976506, 16.997919082641602],
          [73.275413513183878, 16.997917175293026],
          [73.275413513183878, 16.99819374084484],
          [73.27569580078125, 16.99819374084484],
          [73.27569580078125, 16.998472213745231],
          [73.276252746582202, 16.998472213745231],
          [73.276252746582202, 16.999584197998161],
          [73.276802062988452, 16.999580383300781],
          [73.276802062988452, 16.999860763549748],
          [73.277084350586165, 16.999860763549748],
          [73.277084350586165, 17.000972747802734],
          [73.277641296386776, 17.000970840454102],
          [73.277641296386776, 17.001249313354492],
          [73.277915954589957, 17.001249313354492],
          [73.277915954589957, 17.000690460205135],
          [73.278190612793026, 17.000694274902344],
          [73.278198242187557, 17.000415802001953],
          [73.280136108398665, 17.000415802001953],
          [73.280136108398665, 17.000694274902344],
          [73.280975341796818, 17.000694274902344],
          [73.280975341796818, 17.000972747802734],
          [73.282913208007983, 17.000970840454102],
          [73.282913208007983, 17.001531600952262],
          [73.283203125000057, 17.001531600952262],
          [73.283203125000057, 17.001810073852653],
          [73.283470153808764, 17.001806259155273],
          [73.283470153808764, 17.002082824707088],
          [73.283752441406477, 17.002080917358455],
          [73.283752441406477, 17.00403022766119],
          [73.283195495605526, 17.004028320312557],
          [73.283195495605526, 17.004581451415959],
          [73.283752441406477, 17.004579544067383],
          [73.283752441406477, 17.005140304565543],
          [73.283470153808764, 17.005140304565543],
          [73.283470153808764, 17.00542068481451],
          [73.283752441406477, 17.00542068481451],
          [73.283752441406477, 17.00625038146967],
          [73.284027099609318, 17.00625038146967],
          [73.284027099609318, 17.008195877075195],
          [73.284301757812557, 17.008195877075195],
          [73.284301757812557, 17.010694503784293],
          [73.284027099609318, 17.010690689086914],
          [73.284027099609318, 17.011249542236271],
          [73.283752441406477, 17.011249542236271],
          [73.283752441406477, 17.012083053588867],
          [73.283470153808764, 17.012083053588867],
          [73.283470153808764, 17.012638092041016],
          [73.283203125000057, 17.012630462646484],
          [73.283203125000057, 17.013200759887752],
          [73.282913208007983, 17.013200759887752],
          [73.282913208007983, 17.013748168945369],
          [73.282638549804972, 17.013748168945369],
          [73.282638549804972, 17.014028549194336],
          [73.282363891601562, 17.014028549194336],
          [73.282363891601562, 17.014583587646541],
          [73.28208160400419, 17.014583587646541],
          [73.28208160400419, 17.014860153198299],
          [73.281806945800781, 17.014860153198299],
          [73.281806945800781, 17.016250610351676],
          [73.281250000000057, 17.016250610351676],
          [73.281250000000057, 17.016809463501033],
          [73.280975341796818, 17.016805648803825],
          [73.280982971191349, 17.017360687255803],
          [73.280693054199276, 17.017360687255803],
          [73.280693054199276, 17.017562866210994],
          [73.280693054199276, 17.017639160156193],
          [73.280418395996264, 17.017639160156193],
          [73.280418395996264, 17.018192291259822],
          [73.280136108398665, 17.018192291259822],
          [73.280136108398665, 17.018474578857536],
          [73.279861450195483, 17.018470764160156],
          [73.279861450195483, 17.018760681152457],
          [73.279586791992472, 17.018760681152457],
          [73.279586791992472, 17.019309997558707],
          [73.279304504394702, 17.019306182861328],
          [73.279304504394702, 17.019584655761719],
          [73.27902984619169, 17.01958084106451],
          [73.27902984619169, 17.019861221313533],
          [73.27874755859375, 17.019861221313533],
          [73.27874755859375, 17.020420074462891],
          [73.278472900390909, 17.020414352417106],
          [73.278472900390909, 17.020971298217887],
          [73.278198242187557, 17.020969390869084],
          [73.278198242187557, 17.021249771118221],
          [73.277915954589957, 17.021249771118221],
          [73.277915954589957, 17.021530151367244],
          [73.277641296386776, 17.021528244018612],
          [73.277641296386776, 17.022083282470817],
          [73.277359008789006, 17.022083282470817],
          [73.277359008789006, 17.022361755371207],
          [73.277076721191634, 17.022359848022404],
          [73.277076721191634, 17.022920608520565],
          [73.276527404785213, 17.022920608520565],
          [73.276527404785213, 17.023200988769531],
          [73.276252746582202, 17.023195266723746],
          [73.276252746582202, 17.023471832275391],
          [73.274581909179744, 17.023469924926758],
          [73.274581909179744, 17.023750305175724],
          [73.273475646972713, 17.023750305175724],
          [73.273475646972713, 17.023471832275391],
          [73.272918701172159, 17.023471832275391],
          [73.272918701172159, 17.023195266723746],
          [73.272636413574219, 17.023200988769531],
          [73.272636413574219, 17.022920608520565],
          [73.272361755371378, 17.022920608520565],
          [73.272361755371378, 17.022640228271598],
          [73.271247863769474, 17.022640228271598],
          [73.271247863769474, 17.022920608520565],
          [73.271530151367244, 17.022920608520565],
          [73.271530151367244, 17.023750305175724],
          [73.271247863769474, 17.023750305175724],
          [73.271247863769474, 17.024311065673885],
          [73.270690917968921, 17.02430534362793],
          [73.269027709960937, 17.02430534362793],
          [73.269027709960937, 17.02458381652832],
          [73.266525268554858, 17.02458381652832],
          [73.266525268554858, 17.023471832275391],
          [73.266250610351847, 17.023471832275391],
          [73.266250610351847, 17.022361755371207],
          [73.265975952148438, 17.022361755371207],
          [73.265975952148438, 17.022083282470817],
          [73.265693664551065, 17.022083282470817],
          [73.265693664551065, 17.021806716919002],
          [73.265419006347713, 17.021806716919002],
          [73.265419006347713, 17.021528244018612],
          [73.265136718750114, 17.021530151367244],
          [73.265136718750114, 17.021249771118221],
          [73.264862060546932, 17.021249771118221],
          [73.264862060546932, 17.020690917968693],
          [73.264579772949162, 17.020696640014648],
          [73.264579772949162, 17.020414352417106],
          [73.262916564941406, 17.020414352417106],
          [73.262916564941406, 17.020696640014648],
          [73.262359619140682, 17.020696640014648],
          [73.262359619140682, 17.020971298217887],
          [73.260971069336108, 17.020971298217887],
          [73.260971069336108, 17.020696640014648],
          [73.260414123535327, 17.020696640014648],
          [73.260414123535327, 17.020414352417106],
          [73.260139465332315, 17.020420074462891],
          [73.260139465332315, 17.020139694213867],
          [73.259582519531534, 17.020139694213867],
          [73.259582519531534, 17.019861221313533],
          [73.258750915527401, 17.019861221313533],
          [73.258750915527401, 17.01958084106451],
          [73.257362365722827, 17.01958084106451],
          [73.257362365722827, 17.020420074462891],
          [73.257080078125284, 17.020414352417106],
          [73.257080078125284, 17.020971298217887],
          [73.256813049316406, 17.020969390869084],
          [73.256813049316406, 17.021530151367244],
          [73.256530761719034, 17.021528244018612],
          [73.256530761719034, 17.021806716919002],
          [73.256248474121094, 17.021806716919002],
          [73.256248474121094, 17.023471832275391],
          [73.255966186523722, 17.023469924926758],
          [73.255966186523722, 17.023750305175724],
          [73.255691528320369, 17.023750305175724],
          [73.255691528320369, 17.025419235229435],
          [73.255416870117131, 17.025417327880859],
          [73.255416870117131, 17.025972366333065],
          [73.255126953125057, 17.025970458984432],
          [73.255126953125057, 17.026250839233455],
          [73.254859924316577, 17.026250839233455],
          [73.254859924316577, 17.026529312133789],
          [73.254585266113338, 17.026527404785213],
          [73.254585266113338, 17.027082443237418],
          [73.254302978515796, 17.027080535888615],
          [73.254302978515796, 17.027360916137809],
          [73.254592895507869, 17.027360916137809],
          [73.254592895507869, 17.027921676635742],
          [73.25514221191429, 17.027915954589957],
          [73.25514221191429, 17.028472900390739],
          [73.255416870117131, 17.028469085693359],
          [73.255416870117131, 17.028749465942326],
          [73.255691528320369, 17.028749465942326],
          [73.255691528320369, 17.029581069946289],
          [73.255966186523722, 17.029581069946289],
          [73.255966186523722, 17.03042030334484],
          [73.256248474121094, 17.030416488647461],
          [73.256248474121094, 17.030971527099666],
          [73.256530761719034, 17.030969619751033],
          [73.256530761719034, 17.031810760498161],
          [73.256813049316406, 17.031810760498161],
          [73.256813049316406, 17.031530380249023],
          [73.257362365722827, 17.031530380249023],
          [73.257362365722827, 17.031810760498161],
          [73.257637023925838, 17.031803131103629],
          [73.257637023925838, 17.033195495605526],
          [73.257362365722827, 17.03318977355957],
          [73.257362365722827, 17.033760070800838],
          [73.257637023925838, 17.033760070800838],
          [73.257637023925838, 17.036529541015568],
          [73.257362365722827, 17.036529541015568],
          [73.257362365722827, 17.037361145019588],
          [73.257080078125284, 17.037361145019588],
          [73.257080078125284, 17.037639617919922],
          [73.256805419921875, 17.037639617919922],
          [73.256805419921875, 17.038194656372127],
          [73.257080078125284, 17.038194656372127],
          [73.257080078125284, 17.039861679077262],
          [73.256813049316406, 17.039859771728459],
          [73.256813049316406, 17.040138244628849],
          [73.256530761719034, 17.040138244628849],
          [73.256530761719034, 17.040700912475586],
          [73.256248474121094, 17.040700912475586],
          [73.256248474121094, 17.041250228881779],
          [73.255691528320369, 17.041250228881779],
          [73.255691528320369, 17.042930603027401],
          [73.255416870117131, 17.042930603027401],
          [73.255416870117131, 17.044860839843864],
          [73.255691528320369, 17.044860839843864],
          [73.255691528320369, 17.045419692993221],
          [73.255966186523722, 17.045419692993221],
          [73.255966186523722, 17.046529769897575],
          [73.255691528320369, 17.046527862548771],
          [73.255691528320369, 17.047361373901367],
          [73.255966186523722, 17.047359466552734],
          [73.255966186523722, 17.047920227050895],
          [73.256248474121094, 17.047916412353516],
          [73.256248474121094, 17.048196792602482],
          [73.256530761719034, 17.048196792602482],
          [73.256530761719034, 17.048471450805721],
          [73.256805419921875, 17.048471450805721],
          [73.256805419921875, 17.048749923706055],
          [73.257919311523608, 17.048749923706055],
          [73.257919311523608, 17.048471450805721],
          [73.258468627929631, 17.048471450805721],
          [73.258468627929631, 17.048749923706055],
          [73.260414123535327, 17.048749923706055],
          [73.260414123535327, 17.048471450805721],
          [73.261528015136662, 17.048471450805721],
          [73.261528015136662, 17.048749923706055],
          [73.261802673339901, 17.048740386962947],
          [73.261802673339901, 17.049030303955078],
          [73.262092590331974, 17.049030303955078],
          [73.262092590331974, 17.048740386962947],
          [73.263473510742358, 17.048749923706055],
          [73.263473510742358, 17.048471450805721],
          [73.264030456543139, 17.048471450805721],
          [73.264030456543139, 17.048196792602482],
          [73.264579772949162, 17.048196792602482],
          [73.264579772949162, 17.047916412353516],
          [73.265419006347713, 17.047920227050895],
          [73.265419006347713, 17.047639846801701],
          [73.265975952148438, 17.047639846801701],
          [73.265975952148438, 17.046810150146541],
          [73.266532897949219, 17.046810150146541],
          [73.266532897949219, 17.045700073242188],
          [73.266807556152628, 17.045700073242188],
          [73.266807556152628, 17.045419692993221],
          [73.267066955566577, 17.045419692993221],
          [73.267066955566577, 17.04514122009283],
          [73.267906188964901, 17.04514122009283],
          [73.267906188964901, 17.045419692993221],
          [73.268470764160213, 17.045419692993221],
          [73.268470764160213, 17.04458045959467],
          [73.268753051757926, 17.044582366943473],
          [73.268753051757926, 17.044027328491268],
          [73.269027709960937, 17.044031143188477],
          [73.269027709960937, 17.043752670288086],
          [73.269302368164347, 17.043752670288086],
          [73.269302368164347, 17.043470382690487],
          [73.269859313965128, 17.043470382690487],
          [73.269859313965128, 17.043300628662053],
          [73.269859313965128, 17.042917251586914],
          [73.269577026367358, 17.042930603027401],
          [73.269577026367358, 17.042360305786133],
          [73.269302368164347, 17.042360305786133],
          [73.269302368164347, 17.041250228881779],
          [73.269027709960937, 17.041250228881779],
          [73.269027709960937, 17.040700912475586],
          [73.270126342773608, 17.040700912475586],
          [73.270126342773608, 17.039859771728459],
          [73.269584655761719, 17.039861679077262],
          [73.269584655761719, 17.039304733276481],
          [73.269859313965128, 17.039304733276481],
          [73.269859313965128, 17.038749694824276],
          [73.270706176757983, 17.038749694824276],
          [73.271797180176065, 17.038749694824276],
          [73.271797180176065, 17.039028167724666],
          [73.272087097168026, 17.039028167724666],
          [73.272087097168026, 17.039583206176871],
          [73.272636413574219, 17.039583206176871],
          [73.272636413574219, 17.039304733276481],
          [73.273193359375171, 17.039304733276481],
          [73.273193359375171, 17.039028167724666],
          [73.273490905762003, 17.039028167724666],
          [73.273490905762003, 17.038471221923942],
          [73.273750305175952, 17.038473129272518],
          [73.273750305175952, 17.037916183471737],
          [73.274032592773665, 17.037918090820312],
          [73.274032592773665, 17.037639617919922],
          [73.274307250976506, 17.037639617919922],
          [73.274307250976506, 17.037361145019588],
          [73.274856567382926, 17.037361145019588],
          [73.274856567382926, 17.037080764770565],
          [73.275138854980526, 17.037082672119197],
          [73.275138854980526, 17.036527633666992],
          [73.275405883789347, 17.036529541015568],
          [73.275405883789347, 17.036251068115234],
          [73.27569580078125, 17.036251068115234],
          [73.27569580078125, 17.035970687866211],
          [73.275970458984659, 17.035972595214844],
          [73.275970458984659, 17.035694122314453],
          [73.276252746582202, 17.035694122314453],
          [73.276252746582202, 17.035139083862248],
          [73.276527404785213, 17.035140991211051],
          [73.276527404785213, 17.034309387207088],
          [73.276802062988452, 17.034309387207088],
          [73.276802062988452, 17.034030914306697],
          [73.277641296386776, 17.034030914306697],
          [73.277641296386776, 17.032920837402344],
          [73.277915954589957, 17.032920837402344],
          [73.277915954589957, 17.032079696655217],
          [73.277641296386776, 17.032085418701172],
          [73.277641296386776, 17.029861450195312],
          [73.277359008789006, 17.029861450195312],
          [73.277359008789006, 17.029306411743278],
          [73.277076721191634, 17.029310226440487],
          [73.277076721191634, 17.029031753540096],
          [73.276802062988452, 17.029031753540096],
          [73.276802062988452, 17.028749465942326],
          [73.276527404785213, 17.028749465942326],
          [73.276527404785213, 17.027921676635742],
          [73.27569580078125, 17.027921676635742],
          [73.27569580078125, 17.025970458984432],
          [73.275413513183878, 17.025972366333065],
          [73.275413513183878, 17.025417327880859],
          [73.27569580078125, 17.025419235229435],
          [73.27569580078125, 17.025140762329102],
          [73.276527404785213, 17.025140762329102],
          [73.276527404785213, 17.024860382080078],
          [73.276802062988452, 17.024860382080078],
          [73.276802062988452, 17.024570465088004],
          [73.277084350586165, 17.02458381652832],
          [73.277084350586165, 17.02430534362793],
          [73.277359008789006, 17.024311065673885],
          [73.277359008789006, 17.024030685424918],
          [73.277915954589957, 17.024030685424918],
          [73.277915954589957, 17.023750305175724],
          [73.278190612793026, 17.023750305175724],
          [73.278198242187557, 17.023469924926758],
          [73.27874755859375, 17.023471832275391],
          [73.27874755859375, 17.023195266723746],
          [73.27902984619169, 17.023200988769531],
          [73.27902984619169, 17.022359848022404],
          [73.279304504394702, 17.022361755371207],
          [73.279304504394702, 17.021528244018612],
          [73.279861450195483, 17.021530151367244],
          [73.279861450195483, 17.021249771118221],
          [73.280136108398665, 17.021249771118221],
          [73.280136108398665, 17.020690917968693],
          [73.280975341796818, 17.020696640014648],
          [73.280975341796818, 17.020414352417106],
          [73.281250000000057, 17.020420074462891],
          [73.281250000000057, 17.01958084106451],
          [73.281524658203409, 17.019584655761719],
          [73.281524658203409, 17.019306182861328],
          [73.281806945800781, 17.019309997558707],
          [73.281806945800781, 17.018760681152457],
          [73.282066345215128, 17.018760681152457],
          [73.282066345215128, 17.018489837646428],
          [73.282356262207202, 17.018470764160156],
          [73.282363891601562, 17.018192291259822],
          [73.282638549804972, 17.018192291259822],
          [73.282638549804972, 17.017915725708008],
          [73.283470153808764, 17.017919540405387],
          [73.283470153808764, 17.018760681152457],
          [73.284301757812557, 17.018760681152457],
          [73.284309387207088, 17.019029617309513],
          [73.28458404541027, 17.019027709960938],
          [73.28458404541027, 17.019584655761719],
          [73.284858703613281, 17.01958084106451],
          [73.284858703613281, 17.019861221313533],
          [73.285972595215014, 17.019861221313533],
          [73.285972595215014, 17.020139694213867],
          [73.286796569824276, 17.020139694213867],
          [73.286796569824276, 17.020420074462891],
          [73.286529541015796, 17.020414352417106],
          [73.286529541015796, 17.020696640014648],
          [73.286804199218977, 17.020696640014648],
          [73.286804199218977, 17.020959854125977],
          [73.286796569824276, 17.021249771118221],
          [73.287086486816349, 17.021249771118221],
          [73.287086486816349, 17.021530151367244],
          [73.288192749023722, 17.021528244018612],
          [73.288192749023722, 17.021806716919002],
          [73.289863586426009, 17.021806716919002],
          [73.289863586426009, 17.020971298217887],
          [73.289581298828296, 17.020971298217887],
          [73.289581298828296, 17.020139694213867],
          [73.289306640625057, 17.020139694213867],
          [73.289306640625057, 17.019861221313533],
          [73.288749694824503, 17.019861221313533],
          [73.288749694824503, 17.01958084106451],
          [73.288475036621094, 17.019584655761719],
          [73.288475036621094, 17.018474578857536],
          [73.28763580322277, 17.018474578857536],
          [73.28763580322277, 17.018192291259822],
          [73.287361145019588, 17.018192291259822],
          [73.287361145019588, 17.017917633056584],
          [73.286247253418026, 17.017919540405387],
          [73.286247253418026, 17.017360687255803],
          [73.286796569824276, 17.017360687255803],
          [73.286796569824276, 17.016809463501033],
          [73.287361145019588, 17.016805648803825],
          [73.287361145019588, 17.017082214355469],
          [73.287918090820369, 17.017082214355469],
          [73.287918090820369, 17.016805648803825],
          [73.28763580322277, 17.016809463501033],
          [73.28763580322277, 17.016250610351676],
          [73.287361145019588, 17.016250610351676],
          [73.287361145019588, 17.015970230102482],
          [73.28763580322277, 17.015970230102482],
          [73.28763580322277, 17.01541709899908],
          [73.286796569824276, 17.015422821045036],
          [73.286796569824276, 17.014860153198299],
          [73.286529541015796, 17.014860153198299],
          [73.286529541015796, 17.011806488037223],
          [73.286247253418026, 17.011808395385799],
          [73.286247253418026, 17.009309768676758],
          [73.286796569824276, 17.009309768676758],
          [73.286796569824276, 17.009029388427734],
          [73.287361145019588, 17.009029388427734],
          [73.287361145019588, 17.008750915527401],
          [73.28763580322277, 17.008750915527401],
          [73.28763580322277, 17.00819015502924],
          [73.287918090820369, 17.008195877075195],
          [73.287918090820369, 17.007638931274414],
          [73.288200378418253, 17.007640838623047],
          [73.288200378418253, 17.007080078125057],
          [73.288475036621094, 17.007085800171012],
          [73.288475036621094, 17.006803512573299],
          [73.289306640625057, 17.006820678710938],
          [73.289306640625057, 17.008750915527401],
          [73.289016723632983, 17.008750915527401],
          [73.289016723632983, 17.009029388427734],
          [73.288749694824503, 17.009029388427734],
          [73.288749694824503, 17.009309768676758],
          [73.288490295410213, 17.009309768676758],
          [73.288490295410213, 17.009590148925895],
          [73.288749694824503, 17.009590148925895],
          [73.288749694824503, 17.010139465332088],
          [73.289855957031477, 17.010139465332088],
          [73.289855957031477, 17.010419845581112],
          [73.290138244628849, 17.010417938232479],
          [73.290138244628849, 17.010694503784293],
          [73.289306640625057, 17.010694503784293],
          [73.289306640625057, 17.010972976684684],
          [73.288475036621094, 17.010972976684684],
          [73.288475036621094, 17.012638092041016],
          [73.288749694824503, 17.012630462646484],
          [73.288749694824503, 17.012918472289982],
          [73.289016723632983, 17.012918472289982],
          [73.289016723632983, 17.013748168945369],
          [73.289306640625057, 17.013748168945369],
          [73.289306640625057, 17.014028549194336],
          [73.289581298828296, 17.014028549194336],
          [73.289581298828296, 17.014583587646541],
          [73.289855957031477, 17.014581680297965],
          [73.289855957031477, 17.015142440795898],
          [73.290138244628849, 17.015142440795898],
          [73.290138244628849, 17.015422821045036],
          [73.290412902832088, 17.01541709899908],
          [73.290412902832088, 17.015970230102482],
          [73.290695190429801, 17.015970230102482],
          [73.290702819824162, 17.016250610351676],
          [73.290412902832088, 17.016250610351676],
          [73.290412902832088, 17.016809463501033],
          [73.290695190429801, 17.016805648803825],
          [73.290702819824162, 17.017330169677848],
          [73.290702819824162, 17.017641067504996],
          [73.290969848632869, 17.017641067504996],
          [73.290969848632869, 17.019029617309513],
          [73.29123687744169, 17.019029617309513],
          [73.29123687744169, 17.019309997558707],
          [73.291526794433594, 17.019306182861328],
          [73.291526794433594, 17.019584655761719],
          [73.292640686035327, 17.01958084106451],
          [73.292640686035327, 17.019861221313533],
          [73.292922973632869, 17.019861221313533],
          [73.292922973632869, 17.020420074462891],
          [73.293197631836108, 17.020414352417106],
          [73.293197631836108, 17.020696640014648],
          [73.292640686035327, 17.020696640014648],
          [73.292640686035327, 17.020971298217887],
          [73.292915344238509, 17.020971298217887],
          [73.292915344238509, 17.022083282470817],
          [73.293197631836108, 17.022079467773438],
          [73.293197631836108, 17.022640228271598],
          [73.292922973632869, 17.022640228271598],
          [73.292922973632869, 17.022920608520565],
          [73.292640686035327, 17.022916793823356],
          [73.292640686035327, 17.023471832275391],
          [73.292358398437557, 17.023469924926758],
          [73.292358398437557, 17.024030685424918],
          [73.292083740234546, 17.024028778076115],
          [73.292083740234546, 17.02458381652832],
          [73.291809082031534, 17.024570465088004],
          [73.291809082031534, 17.024860382080078],
          [73.291526794433594, 17.024860382080078],
          [73.291526794433594, 17.025140762329102],
          [73.29123687744169, 17.025140762329102],
          [73.29123687744169, 17.025419235229435],
          [73.290695190429801, 17.025417327880859],
          [73.290695190429801, 17.025693893432674],
          [73.290138244628849, 17.025693893432674],
          [73.290138244628849, 17.025972366333065],
          [73.289855957031477, 17.025970458984432],
          [73.289855957031477, 17.026250839233455],
          [73.289306640625057, 17.026250839233455],
          [73.289306640625057, 17.027639389038143],
          [73.289016723632983, 17.027629852295036],
          [73.289016723632983, 17.027921676635742],
          [73.288749694824503, 17.027915954589957],
          [73.288749694824503, 17.028472900390739],
          [73.288490295410213, 17.028469085693359],
          [73.288490295410213, 17.029310226440487],
          [73.287086486816349, 17.029306411743278],
          [73.287086486816349, 17.029581069946289],
          [73.285972595215014, 17.029581069946289],
          [73.285972595215014, 17.029861450195312],
          [73.284858703613281, 17.02985954284668],
          [73.284858703613281, 17.03014183044445],
          [73.283752441406477, 17.03014183044445],
          [73.283752441406477, 17.03042030334484],
          [73.283470153808764, 17.03042030334484],
          [73.283470153808764, 17.030700683593807],
          [73.283195495605526, 17.030693054199276],
          [73.283195495605526, 17.030971527099666],
          [73.282913208007983, 17.030969619751033],
          [73.282913208007983, 17.03125],
          [73.281806945800781, 17.03125],
          [73.281806945800781, 17.031530380249023],
          [73.281250000000057, 17.031530380249023],
          [73.281250000000057, 17.031810760498161],
          [73.280975341796818, 17.031803131103629],
          [73.280975341796818, 17.032085418701172],
          [73.280418395996264, 17.032079696655217],
          [73.280418395996264, 17.032920837402344],
          [73.280693054199276, 17.032920837402344],
          [73.280693054199276, 17.033760070800838],
          [73.280418395996264, 17.033760070800838],
          [73.280418395996264, 17.034309387207088],
          [73.280693054199276, 17.034309387207088],
          [73.280693054199276, 17.034860610961857],
          [73.281250000000057, 17.034860610961857],
          [73.281250000000057, 17.035140991211051],
          [73.281806945800781, 17.035140991211051],
          [73.281806945800781, 17.035419464111442],
          [73.28208160400419, 17.035417556762638],
          [73.28208160400419, 17.035694122314453],
          [73.282638549804972, 17.035694122314453],
          [73.282638549804972, 17.035972595214844],
          [73.282913208007983, 17.035970687866211],
          [73.282913208007983, 17.036251068115234],
          [73.283203125000057, 17.036251068115234],
          [73.283203125000057, 17.036529541015568],
          [73.283470153808764, 17.036527633666992],
          [73.283470153808764, 17.036806106567383],
          [73.283752441406477, 17.036800384521428],
          [73.283752441406477, 17.037361145019588],
          [73.284027099609318, 17.037361145019588],
          [73.284027099609318, 17.038749694824276],
          [73.284301757812557, 17.038749694824276],
          [73.284309387207088, 17.040138244628849],
          [73.284858703613281, 17.040138244628849],
          [73.284858703613281, 17.040418624877987],
          [73.285140991211222, 17.040416717529411],
          [73.285156250000114, 17.040626525878963],
          [73.285415649414063, 17.040695190429801],
          [73.285415649414063, 17.040971755981445],
          [73.286247253418026, 17.040971755981445],
          [73.286247253418026, 17.040695190429801],
          [73.287086486816349, 17.040700912475586],
          [73.287086486816349, 17.040418624877987],
          [73.28763580322277, 17.040418624877987],
          [73.28763580322277, 17.040138244628849],
          [73.288200378418253, 17.040138244628849],
          [73.288200378418253, 17.039569854736385],
          [73.287918090820369, 17.039583206176871],
          [73.287918090820369, 17.039028167724666],
          [73.28763580322277, 17.039028167724666],
          [73.28763580322277, 17.038749694824276],
          [73.287361145019588, 17.038749694824276],
          [73.287361145019588, 17.039028167724666],
          [73.287086486816349, 17.039028167724666],
          [73.287086486816349, 17.039304733276481],
          [73.286621093750227, 17.039304733276481],
          [73.285140991211222, 17.039304733276481],
          [73.285140991211222, 17.037916183471737],
          [73.287361145019588, 17.037918090820312],
          [73.287361145019588, 17.037639617919922],
          [73.28763580322277, 17.037639617919922],
          [73.28763580322277, 17.037361145019588],
          [73.288475036621094, 17.037361145019588],
          [73.288475036621094, 17.038379669189453],
          [73.288475036621094, 17.038749694824276],
          [73.289306640625057, 17.038749694824276],
          [73.289306640625057, 17.039028167724666],
          [73.290412902832088, 17.039028167724666],
          [73.290412902832088, 17.038471221923942],
          [73.290695190429801, 17.038473129272518],
          [73.290695190429801, 17.037916183471737],
          [73.290969848632869, 17.037918090820312],
          [73.290969848632869, 17.037080764770565],
          [73.290695190429801, 17.037082672119197],
          [73.290695190429801, 17.036806106567383],
          [73.292083740234546, 17.036806106567383],
          [73.292083740234546, 17.037082672119197],
          [73.292205810547159, 17.037082672119197],
          [73.292358398437557, 17.037080764770565],
          [73.292358398437557, 17.037361145019588],
          [73.292167663574276, 17.037361145019588],
          [73.291809082031534, 17.037361145019588],
          [73.291809082031534, 17.038194656372127],
          [73.292076110840014, 17.038190841674748],
          [73.292076110840014, 17.039028167724666],
          [73.291526794433594, 17.039028167724666],
          [73.291526794433594, 17.039304733276481],
          [73.291252136230753, 17.039304733276481],
          [73.291252136230753, 17.039583206176871],
          [73.291526794433594, 17.039583206176871],
          [73.291526794433594, 17.039861679077262],
          [73.293746948242301, 17.039861679077262],
          [73.293746948242301, 17.039028167724666],
          [73.294029235839901, 17.039028167724666],
          [73.294029235839901, 17.038471221923942],
          [73.294860839844034, 17.038471221923942],
          [73.294860839844034, 17.039028167724666],
          [73.294586181640625, 17.039028167724666],
          [73.294586181640625, 17.039583206176871],
          [73.294303894043253, 17.039583206176871],
          [73.294303894043253, 17.039861679077262],
          [73.295692443847827, 17.039861679077262],
          [73.295692443847827, 17.039304733276481],
          [73.295974731445369, 17.039304733276481],
          [73.295974731445369, 17.039028167724666],
          [73.296249389648608, 17.039028167724666],
          [73.296249389648608, 17.038749694824276],
          [73.296516418457088, 17.038749694824276],
          [73.296516418457088, 17.038471221923942],
          [73.296806335449162, 17.038473129272518],
          [73.296806335449162, 17.038194656372127],
          [73.297080993652401, 17.038194656372127],
          [73.297080993652401, 17.037916183471737],
          [73.298187255859546, 17.037918090820312],
          [73.298187255859546, 17.037639617919922],
          [73.297920227051065, 17.037639617919922],
          [73.297920227051065, 17.037361145019588],
          [73.298469543457315, 17.037361145019588],
          [73.298469543457315, 17.037080764770565],
          [73.299026489257869, 17.037082672119197],
          [73.299026489257869, 17.036806106567383],
          [73.299308776855639, 17.036806106567383],
          [73.299308776855639, 17.036527633666992],
          [73.299858093261662, 17.036529541015568],
          [73.299858093261662, 17.036251068115234],
          [73.300430297851506, 17.036251068115234],
          [73.300430297851506, 17.035970687866211],
          [73.300971984863565, 17.035972595214844],
          [73.300971984863565, 17.035694122314453],
          [73.301528930664347, 17.035694122314453],
          [73.301528930664347, 17.035417556762638],
          [73.302085876464901, 17.035419464111442],
          [73.302085876464901, 17.035140991211051],
          [73.302642822265852, 17.035140991211051],
          [73.302642822265852, 17.034860610961857],
          [73.303192138671932, 17.034860610961857],
          [73.303176879882869, 17.034580230712891],
          [73.304031372070597, 17.034585952758846],
          [73.304031372070597, 17.034305572509879],
          [73.304862976074389, 17.034309387207088],
          [73.304862976074389, 17.034030914306697],
          [73.306808471679744, 17.034030914306697],
          [73.306808471679744, 17.034309387207088],
          [73.307083129883097, 17.034305572509879],
          [73.307083129883097, 17.034585952758846],
          [73.307907104492358, 17.034580230712891],
          [73.307907104492358, 17.034860610961857],
          [73.308197021484659, 17.034860610961857],
          [73.308197021484659, 17.035140991211051],
          [73.309028625488452, 17.035140991211051],
          [73.309028625488452, 17.034860610961857],
          [73.309310913086165, 17.034860610961857],
          [73.309310913086165, 17.035140991211051],
          [73.309593200683537, 17.035140991211051],
          [73.309593200683537, 17.034860610961857],
          [73.310691833496378, 17.034860610961857],
          [73.310691833496378, 17.034580230712891],
          [73.311805725097713, 17.034585952758846],
          [73.311805725097713, 17.034305572509879],
          [73.311981201172102, 17.034307479858455],
          [73.312370300293196, 17.034309387207088],
          [73.312370300293196, 17.034030914306697],
          [73.312637329101506, 17.034030914306697],
          [73.312637329101506, 17.033760070800838],
          [73.313186645508097, 17.033760070800838],
          [73.313186645508097, 17.033470153808537],
          [73.313751220703409, 17.03347206115734],
          [73.313751220703409, 17.033195495605526],
          [73.315139770507983, 17.033195495605526],
          [73.315139770507983, 17.03347206115734],
          [73.315696716308537, 17.033470153808537],
          [73.315696716308537, 17.033760070800838],
          [73.316246032714957, 17.033760070800838],
          [73.316246032714957, 17.034030914306697],
          [73.316528320312557, 17.034030914306697],
          [73.316528320312557, 17.034309387207088],
          [73.315971374511776, 17.034305572509879],
          [73.315971374511776, 17.034585952758846],
          [73.315696716308537, 17.034580230712891],
          [73.315696716308537, 17.034860610961857],
          [73.316253662109489, 17.034860610961857],
          [73.316253662109489, 17.035139083862248],
          [73.316528320312557, 17.035139083862248],
          [73.316528320312557, 17.035694122314453],
          [73.314857482910213, 17.035694122314453],
          [73.314857482910213, 17.035972595214844],
          [73.31430816650419, 17.035970687866211],
          [73.31430816650419, 17.036251068115234],
          [73.31402587890625, 17.036251068115234],
          [73.31402587890625, 17.036529541015568],
          [73.313468933105469, 17.036529541015568],
          [73.313468933105469, 17.037639617919922],
          [73.313751220703409, 17.037639617919922],
          [73.313751220703409, 17.037918090820312],
          [73.314582824707202, 17.037918090820312],
          [73.314582824707202, 17.037639617919922],
          [73.315406799316463, 17.037639617919922],
          [73.315406799316463, 17.037361145019588],
          [73.315696716308537, 17.037361145019588],
          [73.315696716308537, 17.036800384521428],
          [73.315139770507983, 17.036806106567383],
          [73.315139770507983, 17.036527633666992],
          [73.315406799316463, 17.036529541015568],
          [73.315406799316463, 17.036251068115234],
          [73.315971374511776, 17.036251068115234],
          [73.315971374511776, 17.036529541015568],
          [73.316528320312557, 17.036527633666992],
          [73.316528320312557, 17.036806106567383],
          [73.317085266113281, 17.036806106567383],
          [73.317085266113281, 17.036249160766602],
          [73.31735992431669, 17.036251068115234],
          [73.31735992431669, 17.035970687866211],
          [73.317916870117244, 17.035972595214844],
          [73.317916870117244, 17.035417556762638],
          [73.319580078125057, 17.035417556762638],
          [73.319580078125057, 17.035694122314453],
          [73.319305419921989, 17.035694122314453],
          [73.319305419921989, 17.035972595214844],
          [73.318176269531193, 17.035970687866211],
          [73.318176269531193, 17.036529541015568],
          [73.318473815918196, 17.036527633666992],
          [73.318473815918196, 17.037082672119197],
          [73.318748474121037, 17.037080764770565],
          [73.318748474121037, 17.037639617919922],
          [73.31986236572294, 17.037639617919922],
          [73.31986236572294, 17.038194656372127],
          [73.318473815918196, 17.038194656372127],
          [73.318473815918196, 17.037916183471737],
          [73.317092895507813, 17.037918090820312],
          [73.317092895507813, 17.037639617919922],
          [73.316528320312557, 17.037639617919922],
          [73.316528320312557, 17.038194656372127],
          [73.317085266113281, 17.038194656372127],
          [73.317085266113281, 17.038473129272518],
          [73.31735992431669, 17.038471221923942],
          [73.31735992431669, 17.038749694824276],
          [73.317085266113281, 17.038749694824276],
          [73.317085266113281, 17.039304733276481],
          [73.316802978515909, 17.039304733276481],
          [73.316802978515909, 17.039583206176871],
          [73.315971374511776, 17.039583206176871],
          [73.315971374511776, 17.039304733276481],
          [73.315696716308537, 17.039304733276481],
          [73.315696716308537, 17.039583206176871],
          [73.315414428711165, 17.039583206176871],
          [73.315414428711165, 17.039861679077262],
          [73.314857482910213, 17.039861679077262],
          [73.314857482910213, 17.039583206176871],
          [73.314582824707202, 17.039583206176871],
          [73.314582824707202, 17.039304733276481],
          [73.31430816650419, 17.039304733276481],
          [73.31430816650419, 17.039028167724666],
          [73.312637329101506, 17.039028167724666],
          [73.312637329101506, 17.038749694824276],
          [73.311805725097713, 17.038749694824276],
          [73.311805725097713, 17.038473129272518],
          [73.311531066894702, 17.038473129272518],
          [73.311531066894702, 17.038194656372127],
          [73.311248779297159, 17.038194656372127],
          [73.311248779297159, 17.037639617919922],
          [73.310142517089957, 17.037639617919922],
          [73.310142517089957, 17.037361145019588],
          [73.309303283691463, 17.037361145019588],
          [73.309303283691463, 17.037082672119197],
          [73.307083129883097, 17.037082672119197],
          [73.307083129883097, 17.036806106567383],
          [73.305694580078352, 17.036806106567383],
          [73.305694580078352, 17.037082672119197],
          [73.305137634277401, 17.037080764770565],
          [73.305137634277401, 17.037361145019588],
          [73.302635192871321, 17.037361145019588],
          [73.302635192871321, 17.037639617919922],
          [73.302917480468693, 17.037639617919922],
          [73.302917480468693, 17.037918090820312],
          [73.303192138671932, 17.037916183471737],
          [73.303192138671932, 17.038194656372127],
          [73.303749084472713, 17.038194656372127],
          [73.303749084472713, 17.038473129272518],
          [73.304031372070597, 17.038471221923942],
          [73.304031372070597, 17.039028167724666],
          [73.303749084472713, 17.039028167724666],
          [73.303749084472713, 17.039304733276481],
          [73.303474426269645, 17.039304733276481],
          [73.303474426269645, 17.039583206176871],
          [73.302635192871321, 17.039583206176871],
          [73.302635192871321, 17.039861679077262],
          [73.301795959472827, 17.039859771728459],
          [73.301795959472827, 17.040138244628849],
          [73.300430297851506, 17.040138244628849],
          [73.300430297851506, 17.040418624877987],
          [73.298751831054858, 17.040418624877987],
          [73.298751831054858, 17.040700912475586],
          [73.298194885253906, 17.040695190429801],
          [73.298194885253906, 17.040971755981445],
          [73.297920227051065, 17.040969848632812],
          [73.297920227051065, 17.041250228881779],
          [73.297637939453125, 17.041250228881779],
          [73.297637939453125, 17.041812896728516],
          [73.297363281250114, 17.041805267333984],
          [73.297363281250114, 17.042083740234375],
          [73.297080993652401, 17.042081832885799],
          [73.297080993652401, 17.042360305786133],
          [73.296806335449162, 17.042360305786133],
          [73.296806335449162, 17.042930603027401],
          [73.296524047851619, 17.042917251586914],
          [73.296524047851619, 17.043193817138729],
          [73.296249389648608, 17.043193817138729],
          [73.296249389648608, 17.043470382690487],
          [73.295417785644815, 17.043470382690487],
          [73.295417785644815, 17.043752670288086],
          [73.295143127441406, 17.043752670288086],
          [73.295143127441406, 17.044309616088867],
          [73.294860839844034, 17.044305801391658],
          [73.294860839844034, 17.044582366943473],
          [73.289024353027514, 17.044582366943473],
          [73.289024353027514, 17.044305801391658],
          [73.288749694824503, 17.044309616088867],
          [73.288749694824503, 17.044031143188477],
          [73.28763580322277, 17.044031143188477],
          [73.28763580322277, 17.044309616088867],
          [73.287361145019588, 17.044305801391658],
          [73.287361145019588, 17.044582366943473],
          [73.287086486816349, 17.04458045959467],
          [73.287086486816349, 17.04514122009283],
          [73.287361145019588, 17.04514122009283],
          [73.287361145019588, 17.045419692993221],
          [73.28763580322277, 17.045419692993221],
          [73.28763580322277, 17.045700073242188],
          [73.287918090820369, 17.045692443847656],
          [73.287918090820369, 17.045974731445369],
          [73.288192749023722, 17.045974731445369],
          [73.288192749023722, 17.046249389648381],
          [73.288490295410213, 17.046249389648381],
          [73.288490295410213, 17.046529769897575],
          [73.290702819824162, 17.046529769897575],
          [73.290702819824162, 17.046810150146541],
          [73.291252136230753, 17.046806335449332],
          [73.291252136230753, 17.047084808349723],
          [73.291526794433594, 17.047084808349723],
          [73.291526794433594, 17.047361373901367],
          [73.290138244628849, 17.047359466552734],
          [73.290138244628849, 17.047639846801701],
          [73.288490295410213, 17.047639846801701],
          [73.288490295410213, 17.047359466552734],
          [73.28763580322277, 17.047361373901367],
          [73.28763580322277, 17.046806335449332],
          [73.287361145019588, 17.046810150146541],
          [73.287361145019588, 17.046249389648381],
          [73.287086486816349, 17.046249389648381],
          [73.287086486816349, 17.045700073242188],
          [73.286247253418026, 17.045700073242188],
          [73.286247253418026, 17.045419692993221],
          [73.285697937012003, 17.045419692993221],
          [73.285697937012003, 17.04514122009283],
          [73.285140991211222, 17.04514122009283],
          [73.285140991211222, 17.04458045959467],
          [73.28458404541027, 17.044582366943473],
          [73.28458404541027, 17.044305801391658],
          [73.284301757812557, 17.044309616088867],
          [73.284301757812557, 17.044031143188477],
          [73.284027099609318, 17.044031143188477],
          [73.284027099609318, 17.043752670288086],
          [73.283752441406477, 17.043752670288086],
          [73.283752441406477, 17.043470382690487],
          [73.283470153808764, 17.043470382690487],
          [73.283470153808764, 17.043193817138729],
          [73.282913208007983, 17.043193817138729],
          [73.282913208007983, 17.042917251586914],
          [73.282638549804972, 17.042930603027401],
          [73.282638549804972, 17.042642593383903],
          [73.282356262207202, 17.042642593383903],
          [73.282356262207202, 17.042360305786133],
          [73.282066345215128, 17.042360305786133],
          [73.282066345215128, 17.041812896728516],
          [73.281806945800781, 17.041812896728516],
          [73.281806945800781, 17.041532516479549],
          [73.281517028808878, 17.041532516479549],
          [73.281517028808878, 17.041250228881779],
          [73.281250000000057, 17.041250228881779],
          [73.281250000000057, 17.040969848632812],
          [73.280975341796818, 17.040971755981445],
          [73.280975341796818, 17.040695190429801],
          [73.280693054199276, 17.040700912475586],
          [73.280693054199276, 17.040418624877987],
          [73.280418395996264, 17.040418624877987],
          [73.280418395996264, 17.039859771728459],
          [73.280136108398665, 17.039861679077262],
          [73.280136108398665, 17.039583206176871],
          [73.279861450195483, 17.039583206176871],
          [73.279861450195483, 17.039304733276481],
          [73.279586791992472, 17.039304733276481],
          [73.279586791992472, 17.039583206176871],
          [73.279304504394702, 17.039583206176871],
          [73.279304504394702, 17.039861679077262],
          [73.27902984619169, 17.039859771728459],
          [73.27902984619169, 17.040138244628849],
          [73.27874755859375, 17.040138244628849],
          [73.27874755859375, 17.040418624877987],
          [73.278472900390909, 17.040418624877987],
          [73.278472900390909, 17.040700912475586],
          [73.27874755859375, 17.040700912475586],
          [73.27874755859375, 17.041250228881779],
          [73.279296875000171, 17.041250228881779],
          [73.279296875000171, 17.041532516479549],
          [73.279586791992472, 17.041532516479549],
          [73.279586791992472, 17.041812896728516],
          [73.279861450195483, 17.041805267333984],
          [73.279861450195483, 17.042083740234375],
          [73.280136108398665, 17.042081832885799],
          [73.280136108398665, 17.042360305786133],
          [73.280418395996264, 17.042360305786133],
          [73.280418395996264, 17.042642593383903],
          [73.280693054199276, 17.042638778686523],
          [73.280693054199276, 17.043193817138729],
          [73.280975341796818, 17.043193817138729],
          [73.280975341796818, 17.043752670288086],
          [73.281250000000057, 17.043752670288086],
          [73.281250000000057, 17.044031143188477],
          [73.281402587890796, 17.044031143188477],
          [73.281806945800781, 17.044031143188477],
          [73.281806945800781, 17.044309616088867],
          [73.282066345215128, 17.044309616088867],
          [73.282066345215128, 17.044860839843864],
          [73.282356262207202, 17.044860839843864],
          [73.282356262207202, 17.045419692993221],
          [73.282638549804972, 17.045415878296012],
          [73.282638549804972, 17.045974731445369],
          [73.282913208007983, 17.04597091674799],
          [73.282913208007983, 17.046249389648381],
          [73.283203125000057, 17.046249389648381],
          [73.283203125000057, 17.046529769897575],
          [73.283470153808764, 17.046529769897575],
          [73.283470153808764, 17.046810150146541],
          [73.283752441406477, 17.046806335449332],
          [73.283752441406477, 17.047361373901367],
          [73.284027099609318, 17.047359466552734],
          [73.284027099609318, 17.047639846801701],
          [73.284301757812557, 17.047639846801701],
          [73.284309387207088, 17.047920227050895],
          [73.28458404541027, 17.047916412353516],
          [73.28458404541027, 17.048196792602482],
          [73.284858703613281, 17.048196792602482],
          [73.284858703613281, 17.048749923706055],
          [73.285140991211222, 17.048740386962947],
          [73.285140991211222, 17.049310684204215],
          [73.285415649414063, 17.049306869506836],
          [73.285415649414063, 17.049861907959041],
          [73.285697937012003, 17.049860000610408],
          [73.285697937012003, 17.050420761108398],
          [73.285972595215014, 17.050418853759766],
          [73.285972595215014, 17.050971984863395],
          [73.286247253418026, 17.050970077514592],
          [73.286247253418026, 17.051250457763786],
          [73.286529541015796, 17.051250457763786],
          [73.286529541015796, 17.051805496215934],
          [73.286796569824276, 17.051799774169979],
          [73.286796569824276, 17.052360534667912],
          [73.287086486816349, 17.052360534667912],
          [73.287086486816349, 17.052921295166072],
          [73.287361145019588, 17.052917480468693],
          [73.287361145019588, 17.053472518920898],
          [73.28763580322277, 17.053470611572266],
          [73.28763580322277, 17.054311752319393],
          [73.287918090820369, 17.054311752319393],
          [73.287918090820369, 17.05653190612793],
          [73.288200378418253, 17.05653190612793],
          [73.288200378418253, 17.057929992675781],
          [73.288475036621094, 17.057916641235465],
          [73.288475036621094, 17.063472747802848],
          [73.288200378418253, 17.063470840454045],
          [73.288200378418253, 17.0665283203125],
          [73.287918090820369, 17.0665283203125],
          [73.287918090820369, 17.070421218872127],
          [73.288192749023722, 17.070417404174748],
          [73.288192749023722, 17.073192596435661],
          [73.287918090820369, 17.073192596435661],
          [73.287918090820369, 17.073474884033203],
          [73.288200378418253, 17.073471069336051],
          [73.288200378418253, 17.075420379638729],
          [73.288749694824503, 17.075420379638729],
          [73.288749694824503, 17.075700759887695],
          [73.289306640625057, 17.075696945190487],
          [73.289306640625057, 17.075971603393555],
          [73.289581298828296, 17.075969696044922],
          [73.289581298828296, 17.076530456543082],
          [73.289855957031477, 17.076530456543082],
          [73.289855957031477, 17.076810836792049],
          [73.290138244628849, 17.076810836792049],
          [73.290138244628849, 17.077360153198242],
          [73.290969848632869, 17.077360153198242],
          [73.290969848632869, 17.077079772949276],
          [73.291252136230753, 17.077083587646484],
          [73.291252136230753, 17.076805114746094],
          [73.291809082031534, 17.076810836792049],
          [73.291809082031534, 17.076530456543082],
          [73.293197631836108, 17.076530456543082],
          [73.293197631836108, 17.076250076293888],
          [73.293472290039119, 17.076250076293888],
          [73.293472290039119, 17.075969696044922],
          [73.294029235839901, 17.075971603393555],
          [73.294029235839901, 17.075696945190487],
          [73.295974731445369, 17.075696945190487],
          [73.295974731445369, 17.077083587646484],
          [73.296806335449162, 17.077083587646484],
          [73.296806335449162, 17.076528549194279],
          [73.297080993652401, 17.076530456543082],
          [73.297080993652401, 17.076250076293888],
          [73.297370910644645, 17.076250076293888],
          [73.297363281250114, 17.075696945190487],
          [73.297637939453125, 17.075700759887695],
          [73.297637939453125, 17.075139999389762],
          [73.297920227051065, 17.075139999389762],
          [73.297920227051065, 17.074859619140568],
          [73.298469543457315, 17.074859619140568],
          [73.298469543457315, 17.075139999389762],
          [73.298751831054858, 17.075139999389762],
          [73.298751831054858, 17.075700759887695],
          [73.298469543457315, 17.075700759887695],
          [73.298469543457315, 17.076250076293888],
          [73.298194885253906, 17.076250076293888],
          [73.298194885253906, 17.078472137451229],
          [73.297920227051065, 17.078470230102596],
          [73.297920227051065, 17.078750610351619],
          [73.296806335449162, 17.078750610351619],
          [73.296806335449162, 17.078470230102596],
          [73.295974731445369, 17.078472137451229],
          [73.295974731445369, 17.078193664550838],
          [73.295692443847827, 17.078193664550838],
          [73.295692443847827, 17.078472137451229],
          [73.291526794433594, 17.078472137451229],
          [73.291526794433594, 17.078193664550838],
          [73.290969848632869, 17.078193664550838],
          [73.290969848632869, 17.077917098999023],
          [73.290412902832088, 17.077917098999023],
          [73.290412902832088, 17.078193664550838],
          [73.28763580322277, 17.078193664550838],
          [73.28763580322277, 17.078472137451229],
          [73.286796569824276, 17.078470230102596],
          [73.286796569824276, 17.078750610351619],
          [73.285140991211222, 17.078750610351619],
          [73.285140991211222, 17.079029083251953],
          [73.284027099609318, 17.079029083251953],
          [73.284027099609318, 17.079307556152344],
          [73.283752441406477, 17.079305648803768],
          [73.283752441406477, 17.079584121704158],
          [73.283203125000057, 17.079580307006779],
          [73.283203125000057, 17.080421447753906],
          [73.282913208007983, 17.080417633056697],
          [73.282913208007983, 17.080694198608512],
          [73.283195495605526, 17.080694198608512],
          [73.283195495605526, 17.080972671508903],
          [73.283470153808764, 17.080970764160099],
          [73.283470153808764, 17.08124923706049],
          [73.283752441406477, 17.08124923706049],
          [73.283752441406477, 17.081529617309684],
          [73.284027099609318, 17.081529617309684],
          [73.284027099609318, 17.081811904907227],
          [73.284301757812557, 17.081806182861442],
          [73.284309387207088, 17.082082748413086],
          [73.284576416015909, 17.082080841064453],
          [73.284576416015909, 17.082359313964844],
          [73.285140991211222, 17.082359313964844],
          [73.285140991211222, 17.082920074463004],
          [73.285415649414063, 17.082916259765625],
          [73.285415649414063, 17.083194732666016],
          [73.285697937012003, 17.083194732666016],
          [73.285697937012003, 17.084304809570369],
          [73.285972595215014, 17.084304809570369],
          [73.285972595215014, 17.084581375122184],
          [73.285430908203125, 17.084579467773381],
          [73.285430908203125, 17.085420608520508],
          [73.285697937012003, 17.085416793823299],
          [73.285697937012003, 17.08597373962408],
          [73.285972595215014, 17.085969924926701],
          [73.285972595215014, 17.086811065673828],
          [73.286247253418026, 17.086803436279297],
          [73.286247253418026, 17.08708572387701],
          [73.285972595215014, 17.087080001831055],
          [73.285972595215014, 17.087640762329215],
          [73.285697937012003, 17.087638854980412],
          [73.285697937012003, 17.088195800781364],
          [73.285415649414063, 17.088195800781364],
          [73.285430908203125, 17.089860916137752],
          [73.285140991211222, 17.089860916137752],
          [73.285140991211222, 17.090139389038086],
          [73.284858703613281, 17.090139389038086],
          [73.284858703613281, 17.090419769287109],
          [73.28458404541027, 17.090417861938477],
          [73.28458404541027, 17.090972900390682],
          [73.284858703613281, 17.090972900390682],
          [73.284858703613281, 17.092361450195426],
          [73.284576416015909, 17.092359542846623],
          [73.284576416015909, 17.095422744751033],
          [73.284309387207088, 17.095417022705078],
          [73.284309387207088, 17.095970153808651],
          [73.28458404541027, 17.095970153808651],
          [73.28458404541027, 17.097082138061637],
          [73.284858703613281, 17.097080230712834],
          [73.284858703613281, 17.098751068115348],
          [73.285140991211222, 17.098749160766545],
          [73.285140991211222, 17.099584579467887],
          [73.285430908203125, 17.099580764770508],
          [73.285430908203125, 17.100419998169059],
          [73.285140991211222, 17.100414276123104],
          [73.285140991211222, 17.102361679077205],
          [73.284858703613281, 17.102361679077205],
          [73.284858703613281, 17.102916717529354],
          [73.28458404541027, 17.102916717529354],
          [73.28458404541027, 17.103471755981559],
          [73.284858703613281, 17.103469848632756],
          [73.284858703613281, 17.104030609130916],
          [73.285140991211222, 17.104030609130916],
          [73.285140991211222, 17.10514068603527],
          [73.285415649414063, 17.105138778686467],
          [73.285415649414063, 17.105693817138672],
          [73.285140991211222, 17.105688095092887],
          [73.285140991211222, 17.106250762939453],
          [73.284858703613281, 17.106250762939453],
          [73.284858703613281, 17.106811523437557],
          [73.284576416015909, 17.106811523437557],
          [73.284576416015909, 17.107360839843807],
          [73.284027099609318, 17.107360839843807],
          [73.284027099609318, 17.107921600341911],
          [73.283470153808764, 17.107915878295955],
          [73.283470153808764, 17.108194351196346],
          [73.282913208007983, 17.108190536498967],
          [73.282913208007983, 17.108749389648494],
          [73.282638549804972, 17.108749389648494],
          [73.282638549804972, 17.109310150146484],
          [73.282356262207202, 17.109310150146484],
          [73.282356262207202, 17.110420227050838],
          [73.28208160400419, 17.110416412353629],
          [73.28208160400419, 17.110971450805664],
          [73.282356262207202, 17.110969543457031],
          [73.282356262207202, 17.111249923705998],
          [73.282638549804972, 17.111249923705998],
          [73.282638549804972, 17.111530303955192],
          [73.282913208007983, 17.111530303955192],
          [73.282913208007983, 17.111810684204158],
          [73.282638549804972, 17.111803054809627],
          [73.282638549804972, 17.112363815307731],
          [73.282913208007983, 17.112360000610352],
          [73.282913208007983, 17.112640380859375],
          [73.283203125000057, 17.112640380859375],
          [73.283203125000057, 17.112920761108512],
          [73.283470153808764, 17.112916946411133],
          [73.283470153808764, 17.113195419311523],
          [73.283248901367301, 17.113195419311523],
          [73.282638549804972, 17.113195419311523],
          [73.282638549804972, 17.112916946411133],
          [73.282356262207202, 17.112920761108512],
          [73.282356262207202, 17.112360000610352],
          [73.281524658203409, 17.112363815307731],
          [73.281524658203409, 17.112081527710018],
          [73.281250000000057, 17.112081527710018],
          [73.281250000000057, 17.111803054809627],
          [73.280982971191349, 17.111810684204158],
          [73.280982971191349, 17.111530303955192],
          [73.280136108398665, 17.111530303955192],
          [73.280136108398665, 17.111810684204158],
          [73.279586791992472, 17.111803054809627],
          [73.279586791992472, 17.112363815307731],
          [73.280982971191349, 17.112360000610352],
          [73.280982971191349, 17.112640380859375],
          [73.281250000000057, 17.112638473510742],
          [73.281250000000057, 17.113195419311523],
          [73.281524658203409, 17.113195419311523],
          [73.281524658203409, 17.113473892211914],
          [73.282638549804972, 17.113470077514705],
          [73.282638549804972, 17.114030838012695],
          [73.281250000000057, 17.114030838012695],
          [73.281250000000057, 17.113750457763729],
          [73.279861450195483, 17.113750457763729],
          [73.279861450195483, 17.113470077514705],
          [73.274864196777457, 17.113473892211914],
          [73.274864196777457, 17.113195419311523],
          [73.273200988769702, 17.113189697265568],
          [73.273193359375171, 17.112916946411133],
          [73.272918701172159, 17.112920761108512],
          [73.272918701172159, 17.112640380859375],
          [73.269302368164347, 17.112640380859375],
          [73.269302368164347, 17.112079620361385],
          [73.269027709960937, 17.112081527710018],
          [73.269027709960937, 17.111803054809627],
          [73.266807556152628, 17.111803054809627],
          [73.266807556152628, 17.112363815307731],
          [73.266250610351847, 17.112360000610352],
          [73.266250610351847, 17.112920761108512],
          [73.265975952148438, 17.112916946411133],
          [73.265975952148438, 17.113195419311523],
          [73.266525268554858, 17.113195419311523],
          [73.266525268554858, 17.113473892211914],
          [73.267066955566577, 17.113470077514705],
          [73.267066955566577, 17.113750457763729],
          [73.267356872558821, 17.113750457763729],
          [73.267356872558821, 17.114030838012695],
          [73.267639160156421, 17.114025115966911],
          [73.267639160156421, 17.114585876464844],
          [73.267906188964901, 17.114580154418888],
          [73.267906188964901, 17.11541938781744],
          [73.268196105956974, 17.115417480468807],
          [73.268196105956974, 17.115695953369197],
          [73.268470764160213, 17.115690231323242],
          [73.268470764160213, 17.116250991821403],
          [73.268753051757926, 17.116250991821403],
          [73.268753051757926, 17.116529464721793],
          [73.269027709960937, 17.11652755737299],
          [73.269027709960937, 17.117082595825195],
          [73.269302368164347, 17.117080688476562],
          [73.269302368164347, 17.117361068725586],
          [73.269577026367358, 17.117361068725586],
          [73.269577026367358, 17.117919921875114],
          [73.269859313965128, 17.117916107177734],
          [73.269859313965128, 17.118194580078125],
          [73.270416259765682, 17.118194580078125],
          [73.270416259765682, 17.118473052978516],
          [73.271530151367244, 17.11847114562994],
          [73.271530151367244, 17.118749618530273],
          [73.272361755371378, 17.118749618530273],
          [73.272361755371378, 17.119304656982479],
          [73.272636413574219, 17.119300842285099],
          [73.272636413574219, 17.120418548583984],
          [73.272361755371378, 17.120418548583984],
          [73.272361755371378, 17.121812820434684],
          [73.272087097168026, 17.121812820434684],
          [73.272087097168026, 17.122360229492131],
          [73.271797180176065, 17.122360229492131],
          [73.271797180176065, 17.122922897338867],
          [73.271530151367244, 17.122917175292912],
          [73.271530151367244, 17.124582290649471],
          [73.271247863769474, 17.124580383300838],
          [73.271247863769474, 17.125141143798828],
          [73.270973205566634, 17.125139236450195],
          [73.270973205566634, 17.127361297607536],
          [73.271247863769474, 17.127359390258732],
          [73.271247863769474, 17.127639770507926],
          [73.270973205566634, 17.127639770507926],
          [73.270973205566634, 17.128471374511719],
          [73.270690917968921, 17.128471374511719],
          [73.270690917968921, 17.129583358764648],
          [73.269302368164347, 17.12957954406744],
          [73.269302368164347, 17.130420684814567],
          [73.269027709960937, 17.130420684814567],
          [73.269027709960937, 17.130701065063533],
          [73.268753051757926, 17.130695343017578],
          [73.268753051757926, 17.130971908569393],
          [73.269027709960937, 17.13097000122076],
          [73.269027709960937, 17.13153076171875],
          [73.268753051757926, 17.131528854370117],
          [73.268753051757926, 17.132083892822322],
          [73.268470764160213, 17.132078170776367],
          [73.268470764160213, 17.132360458374137],
          [73.268196105956974, 17.132360458374137],
          [73.268196105956974, 17.133472442627067],
          [73.267913818359432, 17.133472442627067],
          [73.267913818359432, 17.13569450378418],
          [73.268196105956974, 17.13569450378418],
          [73.268196105956974, 17.137361526489315],
          [73.267356872558821, 17.137359619140682],
          [73.267356872558821, 17.137920379638672],
          [73.267639160156421, 17.137920379638672],
          [73.267639160156421, 17.138750076294059],
          [73.267906188964901, 17.138750076294059],
          [73.267906188964901, 17.139310836791992],
          [73.267639160156421, 17.139303207397461],
          [73.267639160156421, 17.139585494995174],
          [73.267364501953182, 17.139585494995174],
          [73.267364501953182, 17.140695571899528],
          [73.267066955566577, 17.140689849853572],
          [73.267066955566577, 17.14180946350109],
          [73.266807556152628, 17.14180946350109],
          [73.266807556152628, 17.142089843750057],
          [73.266532897949219, 17.142089843750057],
          [73.266532897949219, 17.142641067504883],
          [73.266250610351847, 17.142641067504883],
          [73.266250610351847, 17.144308090209961],
          [73.265975952148438, 17.144308090209961],
          [73.265975952148438, 17.14486122131359],
          [73.265693664551065, 17.14486122131359],
          [73.265693664551065, 17.145694732666129],
          [73.265975952148438, 17.14569091796875],
          [73.265975952148438, 17.146528244018498],
          [73.265693664551065, 17.146528244018498],
          [73.265693664551065, 17.146804809570312],
          [73.265419006347713, 17.146804809570312],
          [73.265419006347713, 17.147083282470703],
          [73.265136718750114, 17.147077560424918],
          [73.265136718750114, 17.147922515869197],
          [73.264862060546932, 17.147922515869197],
          [73.264862060546932, 17.149032592773551],
          [73.264579772949162, 17.149032592773551],
          [73.264579772949162, 17.149311065673942],
          [73.264862060546932, 17.149311065673942],
          [73.264862060546932, 17.149860382080192],
          [73.264579772949162, 17.149860382080192],
          [73.264579772949162, 17.151531219482479],
          [73.264305114746321, 17.151527404785099],
          [73.264305114746321, 17.152082443237305],
          [73.263465881347827, 17.152080535888672],
          [73.263465881347827, 17.152360916137695],
          [73.263748168945369, 17.152360916137695],
          [73.263748168945369, 17.153192520141658],
          [73.263473510742358, 17.153192520141658],
          [73.263473510742358, 17.154584884643555],
          [73.263748168945369, 17.154581069946403],
          [73.263748168945369, 17.155700683593864],
          [73.263465881347827, 17.155700683593864],
          [73.263465881347827, 17.156250000000114],
          [73.264030456543139, 17.156250000000114],
          [73.264030456543139, 17.15596961975092],
          [73.264305114746321, 17.155971527099723],
          [73.264305114746321, 17.155696868896484],
          [73.264579772949162, 17.155696868896484],
          [73.264579772949162, 17.155971527099723],
          [73.264862060546932, 17.15596961975092],
          [73.264862060546932, 17.156810760498047],
          [73.264320373535213, 17.156810760498047],
          [73.264320373535213, 17.157091140747184],
          [73.264030456543139, 17.157083511352653],
          [73.264030456543139, 17.157361984253043],
          [73.263748168945369, 17.15736007690424],
          [73.263748168945369, 17.157920837402401],
          [73.263473510742358, 17.157918930053825],
          [73.263473510742358, 17.158472061157227],
          [73.263191223144815, 17.158470153808594],
          [73.263191223144815, 17.159030914306754],
          [73.262916564941406, 17.159027099609375],
          [73.262916564941406, 17.159584045410156],
          [73.262641906738565, 17.159578323364371],
          [73.262641906738565, 17.159860610961971],
          [73.262359619140682, 17.159860610961971],
          [73.262359619140682, 17.160139083862305],
          [73.262092590331974, 17.160129547119197],
          [73.262092590331974, 17.160421371460075],
          [73.261260986328182, 17.160421371460075],
          [73.261260986328182, 17.161249160766658],
          [73.260971069336108, 17.161249160766658],
          [73.260971069336108, 17.161811828613395],
          [73.260696411132869, 17.161811828613395],
          [73.260696411132869, 17.162359237670842],
          [73.260971069336108, 17.162359237670842],
          [73.260971069336108, 17.163471221923828],
          [73.260696411132869, 17.163471221923828],
          [73.260696411132869, 17.164030075073356],
          [73.260414123535327, 17.164028167724553],
          [73.260414123535327, 17.164581298828182],
          [73.260139465332315, 17.164581298828182],
          [73.260139465332315, 17.164863586425895],
          [73.259857177734375, 17.164859771728516],
          [73.259857177734375, 17.165420532226676],
          [73.259582519531534, 17.165416717529297],
          [73.259582519531534, 17.165971755981502],
          [73.259307861328182, 17.165969848632869],
          [73.259307861328182, 17.166530609130859],
          [73.259582519531534, 17.166528701782227],
          [73.259582519531534, 17.167085647583008],
          [73.259307861328182, 17.167079925537053],
          [73.259307861328182, 17.167640686035213],
          [73.259033203125114, 17.167640686035213],
          [73.259033203125114, 17.16792106628418],
          [73.259307861328182, 17.167917251586971],
          [73.259307861328182, 17.169582366943359],
          [73.259582519531534, 17.169580459594727],
          [73.259582519531534, 17.16986083984375],
          [73.259857177734375, 17.16986083984375],
          [73.259857177734375, 17.170419692993278],
          [73.259582519531534, 17.170419692993278],
          [73.259582519531534, 17.171529769897461],
          [73.259864807128906, 17.171527862548828],
          [73.259864807128906, 17.172082901001033],
          [73.259582519531534, 17.172082901001033],
          [73.259582519531534, 17.171806335449219],
          [73.259307861328182, 17.171806335449219],
          [73.259307861328182, 17.172082901001033],
          [73.258468627929631, 17.172069549560547],
          [73.258468627929631, 17.174310684204102],
          [73.25819396972679, 17.174304962158317],
          [73.25819396972679, 17.175138473510685],
          [73.257637023925838, 17.175138473510685],
          [73.257637023925838, 17.175691604614315],
          [73.257362365722827, 17.175701141357422],
          [73.257362365722827, 17.176532745361385],
          [73.257080078125284, 17.17652702331543],
          [73.257080078125284, 17.177082061767635],
          [73.256813049316406, 17.177080154419002],
          [73.256813049316406, 17.178752899169922],
          [73.256530761719034, 17.178752899169922],
          [73.256530761719034, 17.179029464721737],
          [73.256248474121094, 17.179029464721737],
          [73.256248474121094, 17.179309844970703],
          [73.255973815918082, 17.179304122924918],
          [73.255973815918082, 17.179582595825309],
          [73.255691528320369, 17.179580688476506],
          [73.255691528320369, 17.18013954162609],
          [73.255416870117131, 17.18013954162609],
          [73.255416870117131, 17.180696487426815],
          [73.255691528320369, 17.180690765380859],
          [73.255691528320369, 17.181261062622127],
          [73.255416870117131, 17.181249618530217],
          [73.255416870117131, 17.181806564330998],
          [73.25514221191429, 17.181806564330998],
          [73.25514221191429, 17.182083129882813],
          [73.254859924316577, 17.182083129882813],
          [73.254859924316577, 17.182361602783203],
          [73.254592895507869, 17.18235969543457],
          [73.254592895507869, 17.182920455932731],
          [73.254302978515796, 17.182916641235352],
          [73.254302978515796, 17.184583663940487],
          [73.254028320312784, 17.184579849243107],
          [73.254028320312784, 17.184860229492301],
          [73.253746032715014, 17.184860229492301],
          [73.253746032715014, 17.185419082641658],
          [73.253471374512003, 17.185419082641658],
          [73.253471374512003, 17.186811447143555],
          [73.253196716308594, 17.186811447143555],
          [73.253196716308594, 17.187360763549805],
          [73.25290679931669, 17.187360763549805],
          [73.25290679931669, 17.189029693603516],
          [73.252639770507869, 17.189029693603516],
          [73.252639770507869, 17.189310073852653],
          [73.25235748291027, 17.189306259155273],
          [73.25235748291027, 17.189861297607479],
          [73.252082824707088, 17.189861297607479],
          [73.25209045410179, 17.190139770507869],
          [73.251808166504077, 17.190139770507869],
          [73.251808166504077, 17.190420150756836],
          [73.250968933105526, 17.190416336059627],
          [73.250968933105526, 17.190694808960018],
          [73.251251220703296, 17.190694808960018],
          [73.251251220703296, 17.190971374511832],
          [73.250968933105526, 17.190969467163029],
          [73.250968933105526, 17.191249847412223],
          [73.250419616699503, 17.191249847412223],
          [73.250419616699503, 17.19153022766119],
          [73.250137329101563, 17.191528320312557],
          [73.250137329101563, 17.191804885864371],
          [73.249862670898722, 17.191804885864371],
          [73.249862670898722, 17.192081451416016],
          [73.247642517090014, 17.192081451416016],
          [73.247642517090014, 17.191804885864371],
          [73.247360229492472, 17.191804885864371],
          [73.247360229492472, 17.191528320312557],
          [73.24680328369169, 17.19153022766119],
          [73.24680328369169, 17.191249847412223],
          [73.246528625488338, 17.191249847412223],
          [73.246528625488338, 17.190969467163029],
          [73.245697021484318, 17.190971374511832],
          [73.245697021484318, 17.190694808960018],
          [73.244857788085994, 17.190694808960018],
          [73.244857788085994, 17.190971374511832],
          [73.244308471679972, 17.190971374511832],
          [73.244308471679972, 17.190694808960018],
          [73.244026184082031, 17.190694808960018],
          [73.244026184082031, 17.190971374511832],
          [73.24346923828125, 17.190969467163029],
          [73.24346923828125, 17.191249847412223],
          [73.242637634277287, 17.191249847412223],
          [73.242637634277287, 17.191804885864371],
          [73.242362976074446, 17.191804885864371],
          [73.242362976074446, 17.192363739013729],
          [73.24124908447294, 17.192359924316349],
          [73.24124908447294, 17.193201065063477],
          [73.24041748046875, 17.193193435668945],
          [73.24041748046875, 17.193473815918082],
          [73.239860534668026, 17.193470001220703],
          [73.239860534668026, 17.193750381469727],
          [73.239585876464787, 17.193750381469727],
          [73.239585876464787, 17.194030761718864],
          [73.239028930664233, 17.194030761718864],
          [73.239028930664233, 17.19431114196783],
          [73.237640380859659, 17.19431114196783],
          [73.237640380859659, 17.194030761718864],
          [73.236808776855526, 17.194030761718864],
          [73.236808776855526, 17.193750381469727],
          [73.235420227050952, 17.193750381469727],
          [73.235420227050952, 17.194030761718864],
          [73.235137939453182, 17.194030761718864],
          [73.235137939453182, 17.19431114196783],
          [73.234863281250171, 17.194303512573299],
          [73.234863281250171, 17.195695877075195],
          [73.234024047851847, 17.195695877075195],
          [73.234024047851847, 17.19597244262701],
          [73.233192443847713, 17.195970535278434],
          [73.233192443847713, 17.196529388427791],
          [73.232635498047102, 17.196527481079158],
          [73.232635498047102, 17.197082519531364],
          [73.232360839843921, 17.19708061218256],
          [73.232360839843921, 17.197360992431754],
          [73.232086181640682, 17.197360992431754],
          [73.232086181640682, 17.197639465332145],
          [73.231796264648608, 17.197639465332145],
          [73.231796264648608, 17.197919845581112],
          [73.231529235840128, 17.197917938232479],
          [73.231529235840128, 17.198194503784293],
          [73.231246948242188, 17.198194503784293],
          [73.231246948242188, 17.199306488037053],
          [73.230957031250284, 17.199300765991268],
          [73.230957031250284, 17.200700759887752],
          [73.231246948242188, 17.200695037841797],
          [73.231246948242188, 17.200971603393612],
          [73.231529235840128, 17.200969696044979],
          [73.231529235840128, 17.201250076294002],
          [73.231796264648608, 17.201250076294002],
          [73.231796264648608, 17.201532363891715],
          [73.232360839843921, 17.201532363891715],
          [73.232360839843921, 17.201812744140682],
          [73.232635498047102, 17.201805114746151],
          [73.232635498047102, 17.202083587646541],
          [73.234580993652628, 17.202083587646541],
          [73.234580993652628, 17.201528549194336],
          [73.237091064453239, 17.201532363891715],
          [73.237091064453239, 17.201250076294002],
          [73.237640380859659, 17.201250076294002],
          [73.237640380859659, 17.200969696044979],
          [73.238471984863452, 17.200971603393612],
          [73.238471984863452, 17.200695037841797],
          [73.239028930664233, 17.200700759887752],
          [73.239028930664233, 17.200418472289982],
          [73.239295959472713, 17.200418472289982],
          [73.239295959472713, 17.200138092041016],
          [73.239585876464787, 17.200138092041016],
          [73.239585876464787, 17.199859619140625],
          [73.239860534668026, 17.199861526489258],
          [73.239860534668026, 17.199583053588867],
          [73.240135192871378, 17.199583053588867],
          [73.240135192871378, 17.199306488037053],
          [73.24041748046875, 17.199304580688477],
          [73.24041748046875, 17.199029922485465],
          [73.240966796875171, 17.199029922485465],
          [73.240966796875171, 17.198749542236271],
          [73.242080688476733, 17.198749542236271],
          [73.242080688476733, 17.198471069335937],
          [73.242637634277287, 17.198472976684684],
          [73.242637634277287, 17.198194503784293],
          [73.243194580078239, 17.198194503784293],
          [73.243194580078239, 17.197917938232479],
          [73.24346923828125, 17.197919845581112],
          [73.24346923828125, 17.197639465332145],
          [73.24375152587919, 17.197639465332145],
          [73.24375152587919, 17.197360992431754],
          [73.244026184082031, 17.197360992431754],
          [73.244026184082031, 17.196809768676758],
          [73.244308471679972, 17.196809768676758],
          [73.244308471679972, 17.196529388427791],
          [73.245140075683764, 17.196529388427791],
          [73.245140075683764, 17.196809768676758],
          [73.245407104492244, 17.196809768676758],
          [73.245407104492244, 17.197639465332145],
          [73.245140075683764, 17.197639465332145],
          [73.245140075683764, 17.197919845581112],
          [73.244308471679972, 17.197917938232479],
          [73.244308471679972, 17.198194503784293],
          [73.24375152587919, 17.198194503784293],
          [73.24375152587919, 17.198472976684684],
          [73.24346923828125, 17.198471069335937],
          [73.24346923828125, 17.198749542236271],
          [73.243194580078239, 17.198749542236271],
          [73.243194580078239, 17.199306488037053],
          [73.242919921875057, 17.199300765991268],
          [73.242919921875057, 17.200138092041016],
          [73.243186950683878, 17.200138092041016],
          [73.243186950683878, 17.200700759887752],
          [73.24346923828125, 17.200700759887752],
          [73.24346923828125, 17.201250076294002],
          [73.24375152587919, 17.201250076294002],
          [73.24375152587919, 17.201812744140682],
          [73.244026184082031, 17.201805114746151],
          [73.244026184082031, 17.202083587646541],
          [73.244308471679972, 17.202081680297965],
          [73.244308471679972, 17.202360153198356],
          [73.244583129882983, 17.202360153198356],
          [73.244583129882983, 17.202922821045036],
          [73.244857788085994, 17.20291709899908],
          [73.244857788085994, 17.203470230102482],
          [73.245140075683764, 17.203470230102482],
          [73.245140075683764, 17.203750610351676],
          [73.245407104492244, 17.203750610351676],
          [73.245407104492244, 17.204032897949219],
          [73.246246337890739, 17.204032897949219],
          [73.246246337890739, 17.205141067504996],
          [73.245697021484318, 17.205141067504996],
          [73.245697021484318, 17.204860687255859],
          [73.244857788085994, 17.204860687255859],
          [73.244857788085994, 17.205141067504996],
          [73.245140075683764, 17.205139160156193],
          [73.245140075683764, 17.205692291259822],
          [73.245414733886946, 17.205692291259822],
          [73.245414733886946, 17.205974578857536],
          [73.245971679687557, 17.205970764160213],
          [73.245971679687557, 17.207361221313533],
          [73.246246337890739, 17.207361221313533],
          [73.246246337890739, 17.208749771118278],
          [73.246528625488338, 17.208749771118278],
          [73.246528625488338, 17.210140228271598],
          [73.247093200683594, 17.210140228271598],
          [73.247093200683594, 17.210420608520565],
          [73.24680328369169, 17.210420608520565],
          [73.24680328369169, 17.210700988769531],
          [73.246528625488338, 17.210700988769531],
          [73.246528625488338, 17.211530685424918],
          [73.246246337890739, 17.211530685424918],
          [73.246246337890739, 17.212919235229492],
          [73.245971679687557, 17.212917327880859],
          [73.245971679687557, 17.214305877685604],
          [73.245697021484318, 17.214298248291072],
          [73.245697021484318, 17.216249465942326],
          [73.245971679687557, 17.216249465942326],
          [73.245971679687557, 17.216810226440487],
          [73.245140075683764, 17.216810226440487],
          [73.245140075683764, 17.217372894287166],
          [73.245697021484318, 17.217372894287166],
          [73.245697021484318, 17.217639923095703],
          [73.245407104492244, 17.217639923095703],
          [73.245407104492244, 17.218200683593807],
          [73.245140075683764, 17.218193054199276],
          [73.245140075683764, 17.218471527099666],
          [73.244857788085994, 17.218469619751033],
          [73.244857788085994, 17.219310760498161],
          [73.244583129882983, 17.219303131103629],
          [73.244583129882983, 17.219585418701172],
          [73.244857788085994, 17.219585418701172],
          [73.244857788085994, 17.219863891601563],
          [73.244583129882983, 17.219863891601563],
          [73.244583129882983, 17.220695495605526],
          [73.244857788085994, 17.220695495605526],
          [73.244857788085994, 17.22097206115734],
          [73.244583129882983, 17.220970153808537],
          [73.244583129882983, 17.221250534057731],
          [73.244308471679972, 17.221250534057731],
          [73.244308471679972, 17.222640991211051],
          [73.244026184082031, 17.222639083862248],
          [73.244026184082031, 17.223472595214844],
          [73.24375152587919, 17.223470687866268],
          [73.24375152587919, 17.224309921264762],
          [73.24346923828125, 17.224309921264762],
          [73.24346923828125, 17.224861145019588],
          [73.243194580078239, 17.224861145019588],
          [73.243194580078239, 17.225973129272518],
          [73.242637634277287, 17.225973129272518],
          [73.242637634277287, 17.226249694824332],
          [73.242362976074446, 17.226240158081168],
          [73.242362976074446, 17.226528167724666],
          [73.241806030273494, 17.226528167724666],
          [73.241806030273494, 17.226804733276481],
          [73.241531372070483, 17.226804733276481],
          [73.241531372070483, 17.227083206176871],
          [73.24124908447294, 17.227083206176871],
          [73.24124908447294, 17.227361679077262],
          [73.240966796875171, 17.227359771728459],
          [73.240966796875171, 17.227922439575195],
          [73.240692138672159, 17.227922439575195],
          [73.240692138672159, 17.228202819824162],
          [73.24041748046875, 17.228195190429801],
          [73.24041748046875, 17.228471755981445],
          [73.239860534668026, 17.228471755981445],
          [73.239860534668026, 17.228195190429801],
          [73.239585876464787, 17.228202819824162],
          [73.239585876464787, 17.227922439575195],
          [73.239028930664233, 17.227922439575195],
          [73.239028930664233, 17.227638244628849],
          [73.23819732666044, 17.227638244628849],
          [73.23819732666044, 17.227359771728459],
          [73.237640380859659, 17.227361679077262],
          [73.237640380859659, 17.227083206176871],
          [73.236808776855526, 17.227083206176871],
          [73.236808776855526, 17.226804733276481],
          [73.235137939453182, 17.226804733276481],
          [73.235137939453182, 17.227083206176871],
          [73.234863281250171, 17.227077484130916],
          [73.234863281250171, 17.227638244628849],
          [73.234580993652628, 17.227638244628849],
          [73.234580993652628, 17.228202819824162],
          [73.234306335449219, 17.228195190429801],
          [73.234306335449219, 17.229583740234375],
          [73.234031677246378, 17.229581832885799],
          [73.234031677246378, 17.230421066284293],
          [73.233749389648494, 17.230417251586914],
          [73.233749389648494, 17.230972290039119],
          [73.233467102050895, 17.230970382690543],
          [73.233467102050895, 17.23125076293951],
          [73.233192443847713, 17.23125076293951],
          [73.233192443847713, 17.231809616088867],
          [73.232917785644474, 17.231805801391658],
          [73.232917785644474, 17.232082366943473],
          [73.232643127441634, 17.23208045959467],
          [73.232643127441634, 17.232370376586971],
          [73.232360839843921, 17.232370376586971],
          [73.232360839843921, 17.23264122009283],
          [73.232086181640682, 17.232639312744254],
          [73.232086181640682, 17.233192443847656],
          [73.231796264648608, 17.233190536499023],
          [73.231796264648608, 17.235139846801758],
          [73.232086181640682, 17.235137939453125],
          [73.232086181640682, 17.235696792602482],
          [73.232360839843921, 17.235696792602482],
          [73.232360839843921, 17.235971450805721],
          [73.232635498047102, 17.235971450805721],
          [73.232635498047102, 17.236249923706112],
          [73.233192443847713, 17.236249923706112],
          [73.233192443847713, 17.236530303955078],
          [73.233467102050895, 17.236530303955078],
          [73.233467102050895, 17.236810684204215],
          [73.233749389648494, 17.236806869506836],
          [73.233749389648494, 17.237361907959041],
          [73.234031677246378, 17.237360000610465],
          [73.234031677246378, 17.237920761108398],
          [73.234306335449219, 17.237918853759822],
          [73.234306335449219, 17.238471984863395],
          [73.233467102050895, 17.238470077514592],
          [73.233467102050895, 17.239030838012752],
          [73.233192443847713, 17.239028930664176],
          [73.233192443847713, 17.239583969116325],
          [73.232917785644474, 17.239578247070369],
          [73.232917785644474, 17.240140914917106],
          [73.232643127441634, 17.240140914917106],
          [73.232643127441634, 17.240419387817496],
          [73.232360839843921, 17.240417480468693],
          [73.232360839843921, 17.240972518920898],
          [73.232086181640682, 17.240970611572322],
          [73.232086181640682, 17.241542816162166],
          [73.231803894043139, 17.241527557373047],
          [73.231803894043139, 17.242082595825252],
          [73.231529235840128, 17.242082595825252],
          [73.231529235840128, 17.2459716796875],
          [73.231246948242188, 17.245969772338867],
          [73.231246948242188, 17.246250152587891],
          [73.230957031250284, 17.246250152587891],
          [73.230957031250284, 17.246810913085994],
          [73.230697631835994, 17.246803283691463],
          [73.230697631835994, 17.247085571289006],
          [73.230140686035213, 17.247085571289006],
          [73.230140686035213, 17.246250152587891],
          [73.22821044921875, 17.246250152587891],
          [73.22821044921875, 17.246530532837028],
          [73.226516723632869, 17.246530532837028],
          [73.226516723632869, 17.246810913085994],
          [73.225418090820597, 17.246803283691463],
          [73.225418090820597, 17.247085571289006],
          [73.224029541015682, 17.247085571289006],
          [73.224029541015682, 17.247360229492244],
          [73.223472595214901, 17.24735069274908],
          [73.223472595214901, 17.247640609741211],
          [73.223197937011889, 17.247638702392578],
          [73.223197937011889, 17.248472213745174],
          [73.223472595214901, 17.248470306396598],
          [73.223472595214901, 17.248750686645565],
          [73.223747253418082, 17.248750686645565],
          [73.223747253418082, 17.249031066894531],
          [73.224029541015682, 17.249031066894531],
          [73.224029541015682, 17.249309539794922],
          [73.224861145019815, 17.249307632446289],
          [73.224861145019815, 17.249584197998104],
          [73.225975036621151, 17.249584197998104],
          [73.225975036621151, 17.249307632446289],
          [73.227081298828182, 17.249307632446289],
          [73.227081298828182, 17.249584197998104],
          [73.227355957031534, 17.249580383300724],
          [73.227355957031534, 17.250141143798885],
          [73.227638244628906, 17.250139236450309],
          [73.227638244628906, 17.250417709350643],
          [73.228469848633097, 17.250417709350643],
          [73.228469848633097, 17.250972747802848],
          [73.228752136230639, 17.250970840454102],
          [73.228752136230639, 17.251529693603629],
          [73.227912902832315, 17.251527786254826],
          [73.227912902832315, 17.252082824707031],
          [73.227638244628906, 17.252080917358455],
          [73.227638244628906, 17.252639770507812],
          [73.227363586425895, 17.252639770507812],
          [73.227363586425895, 17.253194808959961],
          [73.227081298828182, 17.253189086914006],
          [73.227081298828182, 17.253749847412166],
          [73.226806640624943, 17.253749847412166],
          [73.226806640624943, 17.25570106506359],
          [73.226249694824389, 17.255695343017635],
          [73.226249694824389, 17.25597190856945],
          [73.225975036621151, 17.25597190856945],
          [73.225982666015682, 17.25625038146984],
          [73.224586486816406, 17.25625038146984],
          [73.224586486816406, 17.25597190856945],
          [73.224029541015682, 17.25597190856945],
          [73.224029541015682, 17.255695343017635],
          [73.223747253418082, 17.25570106506359],
          [73.223747253418082, 17.2554225921632],
          [73.223472595214901, 17.2554225921632],
          [73.223472595214901, 17.255140304565487],
          [73.222091674804687, 17.255140304565487],
          [73.222091674804687, 17.2554225921632],
          [73.221809387207315, 17.2554225921632],
          [73.221801757812784, 17.25570106506359],
          [73.221527099609375, 17.255695343017635],
          [73.221527099609375, 17.25597190856945],
          [73.221801757812784, 17.25597190856945],
          [73.221801757812784, 17.256181716919002],
          [73.221809387207315, 17.256811141967773],
          [73.222091674804687, 17.256811141967773],
          [73.222091674804687, 17.257921218872127],
          [73.221809387207315, 17.257917404174748],
          [73.221801757812784, 17.258472442626953],
          [73.221527099609375, 17.258470535278377],
          [73.221527099609375, 17.25875282287609],
          [73.221252441406534, 17.25875282287609],
          [73.221252441406534, 17.259309768676871],
          [73.220970153808651, 17.259309768676871],
          [73.220970153808651, 17.260419845581055],
          [73.220695495605582, 17.26041412353527],
          [73.220695495605582, 17.260974884033203],
          [73.220970153808651, 17.260971069336051],
          [73.220970153808651, 17.261249542236442],
          [73.221801757812784, 17.261249542236442],
          [73.221809387207315, 17.261800765991211],
          [73.222084045410327, 17.261806488037166],
          [73.222084045410327, 17.262361526489371],
          [73.222358703613338, 17.262350082397461],
          [73.222358703613338, 17.262639999389762],
          [73.222923278808651, 17.262639999389762],
          [73.222923278808651, 17.262920379638729],
          [73.223197937011889, 17.262916564941349],
          [73.223197937011889, 17.264583587646484],
          [73.22291564941429, 17.264583587646484],
          [73.22291564941429, 17.265972137451229],
          [73.223472595214901, 17.265970230102653],
          [73.223472595214901, 17.26652908325201],
          [73.222640991211108, 17.26652908325201],
          [73.222640991211108, 17.266250610351619],
          [73.222358703613338, 17.266250610351619],
          [73.222358703613338, 17.26652908325201],
          [73.222091674804687, 17.26652908325201],
          [73.222091674804687, 17.266811370849723],
          [73.221809387207315, 17.266805648803768],
          [73.221801757812784, 17.267084121704158],
          [73.221527099609375, 17.267078399658203],
          [73.221527099609375, 17.267360687255973],
          [73.221252441406534, 17.267360687255973],
          [73.221252441406534, 17.267639160156364],
          [73.220970153808651, 17.267639160156364],
          [73.220970153808651, 17.26791954040533],
          [73.220695495605582, 17.267917633056697],
          [73.220695495605582, 17.268194198608512],
          [73.220413208007869, 17.268188476562557],
          [73.220413208007869, 17.268480300903434],
          [73.220703124999943, 17.268480300903434],
          [73.220703124999943, 17.26874923706049],
          [73.220970153808651, 17.26874923706049],
          [73.220970153808651, 17.269311904907227],
          [73.220695495605582, 17.269306182861271],
          [73.220703124999943, 17.270139694213867],
          [73.219017028808764, 17.270139694213867],
          [73.219017028808764, 17.269861221313477],
          [73.218750000000284, 17.269861221313477],
          [73.218750000000284, 17.26958084106451],
          [73.217361450195369, 17.26958084106451],
          [73.217361450195369, 17.269861221313477],
          [73.217086791992131, 17.269861221313477],
          [73.217086791992131, 17.270420074463004],
          [73.216804504394759, 17.270416259765625],
          [73.216804504394759, 17.27097129821783],
          [73.217086791992131, 17.27097129821783],
          [73.217086791992131, 17.271528244018555],
          [73.216804504394759, 17.271528244018555],
          [73.216804504394759, 17.271804809570369],
          [73.216529846191577, 17.271804809570369],
          [73.216529846191577, 17.272081375122184],
          [73.215972900390796, 17.272081375122184],
          [73.215972900390796, 17.272363662719727],
          [73.215698242187784, 17.272359848022575],
          [73.215698242187784, 17.272640228271541],
          [73.215415954589844, 17.272640228271541],
          [73.215415954589844, 17.272920608520508],
          [73.215141296387003, 17.272916793823299],
          [73.215141296387003, 17.273471832275504],
          [73.214859008789063, 17.273469924926701],
          [73.214859008789063, 17.274030685424862],
          [73.214584350586051, 17.274026870727482],
          [73.214584350586051, 17.27458572387701],
          [73.212081909179972, 17.274580001831055],
          [73.212081909179972, 17.275140762329215],
          [73.211807250976563, 17.275138854980412],
          [73.211807250976563, 17.275695800781193],
          [73.211250305175838, 17.275695800781193],
          [73.211250305175838, 17.275138854980412],
          [73.210983276367131, 17.275140762329215],
          [73.210983276367131, 17.273200988769645],
          [73.210693359375057, 17.273200988769645],
          [73.210693359375057, 17.272359848022575],
          [73.210418701172046, 17.272363662719727],
          [73.210418701172046, 17.271804809570369],
          [73.210136413574446, 17.271804809570369],
          [73.210136413574446, 17.271528244018555],
          [73.210418701172046, 17.271528244018555],
          [73.210418701172046, 17.271249771118221],
          [73.210136413574446, 17.271249771118221],
          [73.210136413574446, 17.270416259765625],
          [73.209297180175952, 17.270420074463004],
          [73.209297180175952, 17.270139694213867],
          [73.209030151367472, 17.270139694213867],
          [73.209030151367472, 17.26958084106451],
          [73.207916259765739, 17.269582748413086],
          [73.207916259765739, 17.269306182861271],
          [73.207359313964787, 17.269311904907227],
          [73.207359313964787, 17.269029617309684],
          [73.206527709960994, 17.269029617309684],
          [73.206527709960994, 17.26874923706049],
          [73.206253051757983, 17.26874923706049],
          [73.206253051757983, 17.268480300903434],
          [73.204582214355526, 17.268480300903434],
          [73.204582214355526, 17.26874923706049],
          [73.204307556152287, 17.26874923706049],
          [73.204307556152287, 17.269029617309684],
          [73.204017639160213, 17.269029617309684],
          [73.204017639160213, 17.269311904907227],
          [73.203750610351733, 17.269311904907227],
          [73.203750610351733, 17.269861221313477],
          [73.203475952148494, 17.269861221313477],
          [73.203475952148494, 17.270694732666016],
          [73.203186035156421, 17.27069282531744],
          [73.203186035156421, 17.271249771118221],
          [73.20291900634794, 17.271249771118221],
          [73.20291900634794, 17.273200988769645],
          [73.20263671875, 17.273200988769645],
          [73.20263671875, 17.274311065673828],
          [73.202362060547159, 17.274311065673828],
          [73.202362060547159, 17.276531219482536],
          [73.202079772949219, 17.276531219482536],
          [73.202079772949219, 17.277360916137752],
          [73.201805114746207, 17.277360916137752],
          [73.201812744140739, 17.278749465942496],
          [73.201530456543026, 17.278749465942496],
          [73.201530456543026, 17.279308319091854],
          [73.201248168945256, 17.279308319091854],
          [73.201248168945256, 17.280139923095817],
          [73.200981140136946, 17.280139923095817],
          [73.200981140136946, 17.280710220336857],
          [73.200691223144702, 17.280710220336857],
          [73.200691223144702, 17.28181266784668],
          [73.200416564941463, 17.28181266784668],
          [73.200416564941463, 17.282922744751033],
          [73.200691223144702, 17.282917022705078],
          [73.200691223144702, 17.283470153808707],
          [73.200981140136946, 17.283460617065543],
          [73.200981140136946, 17.284032821655387],
          [73.201248168945256, 17.284032821655387],
          [73.201248168945256, 17.284309387207031],
          [73.202362060547159, 17.284305572509822],
          [73.202362060547159, 17.284582138061637],
          [73.20263671875, 17.284580230712834],
          [73.20263671875, 17.284860610962028],
          [73.20291900634794, 17.284860610962028],
          [73.20291900634794, 17.285419464111385],
          [73.203193664550952, 17.285417556762752],
          [73.203193664550952, 17.28569221496582],
          [73.20291900634794, 17.285690307617188],
          [73.20291900634794, 17.286809921264705],
          [73.20263671875, 17.286809921264705],
          [73.20263671875, 17.287361145019531],
          [73.202362060547159, 17.287361145019531],
          [73.202362060547159, 17.288196563720646],
          [73.202079772949219, 17.288196563720646],
          [73.202079772949219, 17.288473129272461],
          [73.201248168945256, 17.288473129272461],
          [73.201248168945256, 17.288196563720646],
          [73.200141906738452, 17.288196563720646],
          [73.200141906738452, 17.288473129272461],
          [73.1995849609375, 17.288473129272461],
          [73.199592590332031, 17.288749694824276],
          [73.199028015136719, 17.288749694824276],
          [73.199028015136719, 17.289030075073242],
          [73.198753356933707, 17.289028167724609],
          [73.198753356933707, 17.289306640625],
          [73.198471069335994, 17.289306640625],
          [73.198471069335994, 17.289583206176815],
          [73.198196411132756, 17.289583206176815],
          [73.198196411132756, 17.289861679077205],
          [73.197921752929915, 17.289859771728629],
          [73.197921752929915, 17.290140151977596],
          [73.197639465332202, 17.290140151977596],
          [73.197639465332202, 17.2907009124757],
          [73.197357177734602, 17.2907009124757],
          [73.197357177734602, 17.292648315429801],
          [73.197082519531421, 17.292648315429801],
          [73.197082519531421, 17.292919158935661],
          [73.196807861328409, 17.292917251586857],
          [73.196807861328409, 17.293193817138672],
          [73.195968627929688, 17.293193817138672],
          [73.195968627929688, 17.293472290039063],
          [73.195419311523494, 17.293470382690487],
          [73.195419311523494, 17.293750762939453],
          [73.195137023925895, 17.293750762939453],
          [73.195137023925895, 17.294029235839844],
          [73.194847106933651, 17.294029235839844],
          [73.194847106933651, 17.295139312744197],
          [73.194580078124943, 17.295139312744197],
          [73.194580078124943, 17.295694351196346],
          [73.194305419922102, 17.295694351196346],
          [73.194313049316463, 17.296249389648551],
          [73.192359924316463, 17.296249389648551],
          [73.192359924316463, 17.296529769897518],
          [73.191787719726619, 17.296529769897518],
          [73.191787719726619, 17.296810150146484],
          [73.191528320312443, 17.296806335449276],
          [73.191528320312443, 17.29708290100109],
          [73.190696716308651, 17.29708290100109],
          [73.190696716308651, 17.297361373901481],
          [73.189857482910156, 17.297359466552678],
          [73.189857482910156, 17.297639846801871],
          [73.189582824707315, 17.297639846801871],
          [73.189582824707315, 17.297920227050838],
          [73.189308166503963, 17.297920227050838],
          [73.189308166503963, 17.299030303955192],
          [73.189582824707315, 17.299028396606388],
          [73.189582824707315, 17.29958534240717],
          [73.190139770508097, 17.29958534240717],
          [73.190139770508097, 17.299863815307731],
          [73.190971374511889, 17.299860000610408],
          [73.190971374511889, 17.300140380859375],
          [73.191246032715071, 17.300140380859375],
          [73.191246032715071, 17.300420761108512],
          [73.191528320312443, 17.300416946411133],
          [73.191528320312443, 17.300973892211914],
          [73.191787719726619, 17.300970077514762],
          [73.191787719726619, 17.301250457763729],
          [73.191246032715071, 17.301250457763729],
          [73.191246032715071, 17.301811218261832],
          [73.190971374511889, 17.301811218261832],
          [73.190971374511889, 17.30430984497076],
          [73.191246032715071, 17.30430984497076],
          [73.191246032715071, 17.304590225219727],
          [73.191528320312443, 17.304590225219727],
          [73.191528320312443, 17.304861068725586],
          [73.194305419922102, 17.304861068725586],
          [73.194305419922102, 17.305139541625977],
          [73.194847106933651, 17.305139541625977],
          [73.194847106933651, 17.305419921875114],
          [73.195137023925895, 17.305416107177734],
          [73.195137023925895, 17.305694580078125],
          [73.195419311523494, 17.305690765380973],
          [73.195419311523494, 17.30624961853033],
          [73.195693969726847, 17.30624961853033],
          [73.195693969726847, 17.306804656982479],
          [73.196807861328409, 17.306804656982479],
          [73.196807861328409, 17.306528091430664],
          [73.197082519531421, 17.306528091430664],
          [73.197082519531421, 17.30624961853033],
          [73.197357177734602, 17.30624961853033],
          [73.197357177734602, 17.30597114562994],
          [73.197639465332202, 17.305973052978516],
          [73.197639465332202, 17.305694580078125],
          [73.198196411132756, 17.305694580078125],
          [73.198196411132756, 17.305416107177734],
          [73.198471069335994, 17.305419921875114],
          [73.198471069335994, 17.305139541625977],
          [73.198753356933707, 17.305139541625977],
          [73.198753356933707, 17.304861068725586],
          [73.199302673340128, 17.304861068725586],
          [73.199302673340128, 17.304590225219727],
          [73.199592590332031, 17.304590225219727],
          [73.199592590332031, 17.30430984497076],
          [73.199859619140909, 17.30430984497076],
          [73.199859619140909, 17.302080154418888],
          [73.200691223144702, 17.302085876464844],
          [73.200691223144702, 17.301525115966911],
          [73.201530456543026, 17.301530838012695],
          [73.201530456543026, 17.301250457763729],
          [73.20173645019554, 17.301250457763729],
          [73.201812744140739, 17.300970077514762],
          [73.202362060547159, 17.300973892211914],
          [73.202362060547159, 17.300693511962947],
          [73.20263671875, 17.300693511962947],
          [73.20263671875, 17.300416946411133],
          [73.20291900634794, 17.300420761108512],
          [73.20291900634794, 17.300140380859375],
          [73.203186035156421, 17.300140380859375],
          [73.203186035156421, 17.299310684204158],
          [73.203475952148494, 17.299310684204158],
          [73.203475952148494, 17.299030303955192],
          [73.204017639160213, 17.299030303955192],
          [73.204017639160213, 17.299310684204158],
          [73.204307556152287, 17.299310684204158],
          [73.204307556152287, 17.299030303955192],
          [73.204856872558707, 17.299030303955192],
          [73.204856872558707, 17.298749923706055],
          [73.205696105957031, 17.298749923706055],
          [73.205696105957031, 17.299310684204158],
          [73.20597076416044, 17.299303054809627],
          [73.20597076416044, 17.29958534240717],
          [73.206802368164233, 17.29958534240717],
          [73.206802368164233, 17.299863815307731],
          [73.207359313964787, 17.299860000610408],
          [73.207359313964787, 17.300140380859375],
          [73.207641601562557, 17.300140380859375],
          [73.207641601562557, 17.300420761108512],
          [73.207916259765739, 17.300416946411133],
          [73.207916259765739, 17.300693511962947],
          [73.208190917968807, 17.300693511962947],
          [73.208190917968807, 17.300973892211914],
          [73.20847320556669, 17.300970077514762],
          [73.20847320556669, 17.301250457763729],
          [73.208747863769531, 17.301250457763729],
          [73.208747863769531, 17.302085876464844],
          [73.209030151367472, 17.302080154418888],
          [73.209030151367472, 17.30291938781744],
          [73.209304809570483, 17.302917480468807],
          [73.209304809570483, 17.303195953369197],
          [73.209587097168253, 17.303195953369197],
          [73.209587097168253, 17.303472518921012],
          [73.209861755371264, 17.303470611572266],
          [73.209861755371264, 17.303750991821403],
          [73.210060119629077, 17.303749084472599],
          [73.210136413574446, 17.303749084472599],
          [73.210151672363338, 17.304029464721793],
          [73.210418701172046, 17.304029464721793],
          [73.210418701172046, 17.30430984497076],
          [73.210983276367131, 17.30430984497076],
          [73.210983276367131, 17.304029464721793],
          [73.211532592773551, 17.304029464721793],
          [73.211532592773551, 17.303470611572266],
          [73.211807250976563, 17.303472518921012],
          [73.211807250976563, 17.303195953369197],
          [73.213470458984546, 17.303195953369197],
          [73.213470458984546, 17.302917480468807],
          [73.214302062988338, 17.30291938781744],
          [73.214302062988338, 17.302640914917049],
          [73.215415954589844, 17.302640914917049],
          [73.215415954589844, 17.302360534668082],
          [73.216796875000057, 17.302360534668082],
          [73.216796875000057, 17.302640914917049],
          [73.217361450195369, 17.302640914917049],
          [73.217361450195369, 17.30291938781744],
          [73.217636108398551, 17.302917480468807],
          [73.217636108398551, 17.303195953369197],
          [73.217918395996151, 17.303195953369197],
          [73.217918395996151, 17.302917480468807],
          [73.218750000000284, 17.30291938781744],
          [73.218750000000284, 17.302640914917049],
          [73.219581604004077, 17.302640914917049],
          [73.219581604004077, 17.302360534668082],
          [73.220970153808651, 17.302360534668082],
          [73.220970153808651, 17.30291938781744],
          [73.222091674804687, 17.30291938781744],
          [73.222091674804687, 17.302640914917049],
          [73.222358703613338, 17.302640914917049],
          [73.222358703613338, 17.302360534668082],
          [73.222640991211108, 17.302360534668082],
          [73.222640991211108, 17.301811218261832],
          [73.222923278808651, 17.301811218261832],
          [73.222923278808651, 17.301530838012695],
          [73.223472595214901, 17.301530838012695],
          [73.223472595214901, 17.301250457763729],
          [73.223747253418082, 17.301250457763729],
          [73.223747253418082, 17.300970077514762],
          [73.224029541015682, 17.300973892211914],
          [73.224029541015682, 17.300830841064453],
          [73.224029541015682, 17.300693511962947],
          [73.224304199219034, 17.300693511962947],
          [73.224304199219034, 17.29958534240717],
          [73.224029541015682, 17.29958534240717],
          [73.224029541015682, 17.299303054809627],
          [73.223747253418082, 17.299310684204158],
          [73.223747253418082, 17.298749923706055],
          [73.223472595214901, 17.298749923706055],
          [73.223472595214901, 17.298191070556697],
          [73.223197937011889, 17.29819488525402],
          [73.223197937011889, 17.297639846801871],
          [73.222923278808651, 17.297639846801871],
          [73.222923278808651, 17.296249389648551],
          [73.222640991211108, 17.296249389648551],
          [73.222640991211108, 17.295688629150391],
          [73.222358703613338, 17.295694351196346],
          [73.222358703613338, 17.295415878295955],
          [73.221801757812784, 17.295421600341911],
          [73.221801757812784, 17.294860839843807],
          [73.222091674804687, 17.294860839843807],
          [73.222084045410327, 17.294584274291992],
          [73.222358703613338, 17.294582366943416],
          [73.222358703613338, 17.294305801391602],
          [73.222640991211108, 17.294311523437557],
          [73.222640991211108, 17.294029235839844],
          [73.222923278808651, 17.294029235839844],
          [73.222923278808651, 17.293750762939453],
          [73.223197937011889, 17.293750762939453],
          [73.223197937011889, 17.293470382690487],
          [73.223472595214901, 17.293472290039063],
          [73.223472595214901, 17.293193817138672],
          [73.223747253418082, 17.293193817138672],
          [73.223747253418082, 17.292917251586857],
          [73.224029541015682, 17.292919158935661],
          [73.224029541015682, 17.292079925537109],
          [73.223747253418082, 17.292083740234489],
          [73.223747253418082, 17.291805267334098],
          [73.223197937011889, 17.291809082031307],
          [73.223197937011889, 17.291530609130916],
          [73.223747253418082, 17.291530609130916],
          [73.223747253418082, 17.29125022888195],
          [73.224296569824503, 17.29125022888195],
          [73.224296569824503, 17.290969848632756],
          [73.224029541015682, 17.290971755981559],
          [73.224029541015682, 17.290695190429744],
          [73.224296569824503, 17.2907009124757],
          [73.224296569824503, 17.288749694824276],
          [73.224029541015682, 17.288749694824276],
          [73.224029541015682, 17.286251068115348],
          [73.224296569824503, 17.286251068115348],
          [73.224296569824503, 17.285690307617188],
          [73.224586486816406, 17.28569221496582],
          [73.224586486816406, 17.285417556762752],
          [73.224861145019815, 17.285419464111385],
          [73.224861145019815, 17.284580230712834],
          [73.224586486816406, 17.284582138061637],
          [73.224586486816406, 17.284027099609432],
          [73.224861145019815, 17.284032821655387],
          [73.224861145019815, 17.283460617065543],
          [73.225135803222827, 17.283470153808707],
          [73.225135803222827, 17.283193588256893],
          [73.225418090820597, 17.283193588256893],
          [73.225418090820597, 17.282638549804687],
          [73.225692749023608, 17.28264045715332],
          [73.225692749023608, 17.282081604003963],
          [73.225975036621151, 17.282083511352539],
          [73.225975036621151, 17.281528472900334],
          [73.227638244628906, 17.281530380249137],
          [73.227638244628906, 17.28181266784668],
          [73.22821044921875, 17.28181266784668],
          [73.22821044921875, 17.28264045715332],
          [73.228752136230639, 17.28264045715332],
          [73.228752136230639, 17.282922744751033],
          [73.229309082031421, 17.282917022705078],
          [73.229309082031421, 17.283193588256893],
          [73.229858398437443, 17.283193588256893],
          [73.229858398437443, 17.283470153808707],
          [73.230140686035213, 17.283460617065543],
          [73.230140686035213, 17.284032821655387],
          [73.230422973632926, 17.284032821655387],
          [73.230422973632926, 17.284309387207031],
          [73.230697631835994, 17.284309387207031],
          [73.230697631835994, 17.284860610962028],
          [73.230957031250284, 17.284860610962028],
          [73.230957031250284, 17.285419464111385],
          [73.231529235840128, 17.285417556762752],
          [73.231529235840128, 17.28569221496582],
          [73.231803894043139, 17.28569221496582],
          [73.231803894043139, 17.285974502563533],
          [73.232360839843921, 17.285970687866211],
          [73.232360839843921, 17.286251068115348],
          [73.234580993652628, 17.286251068115348],
          [73.234580993652628, 17.286809921264705],
          [73.234863281250171, 17.286809921264705],
          [73.234863281250171, 17.287639617919922],
          [73.235137939453182, 17.287639617919922],
          [73.235137939453182, 17.288473129272461],
          [73.235420227050952, 17.288473129272461],
          [73.235420227050952, 17.289306640625],
          [73.235694885254134, 17.289306640625],
          [73.235694885254134, 17.289861679077205],
          [73.235969543456974, 17.289859771728629],
          [73.235969543456974, 17.2907009124757],
          [73.236251831054744, 17.2907009124757],
          [73.236267089843977, 17.291530609130916],
          [73.236526489257926, 17.29152870178234],
          [73.236526489257926, 17.292083740234489],
          [73.236808776855526, 17.292079925537109],
          [73.236808776855526, 17.292648315429801],
          [73.236030578613281, 17.292638778686467],
          [73.235137939453182, 17.292638778686467],
          [73.235137939453182, 17.293193817138672],
          [73.234863281250171, 17.293193817138672],
          [73.234863281250171, 17.293472290039063],
          [73.235137939453182, 17.293470382690487],
          [73.235137939453182, 17.294311523437557],
          [73.235420227050952, 17.294305801391602],
          [73.235420227050952, 17.294582366943416],
          [73.23557281494152, 17.29458045959484],
          [73.235687255859602, 17.29458045959484],
          [73.235687255859602, 17.294860839843807],
          [73.235969543456974, 17.294860839843807],
          [73.235969543456974, 17.295139312744197],
          [73.236526489257926, 17.295139312744197],
          [73.236526489257926, 17.295421600341911],
          [73.237083435058878, 17.295415878295955],
          [73.237083435058878, 17.295694351196346],
          [73.236808776855526, 17.295688629150391],
          [73.236808776855526, 17.296249389648551],
          [73.237083435058878, 17.296249389648551],
          [73.237083435058878, 17.29708290100109],
          [73.237358093261719, 17.29708290100109],
          [73.237358093261719, 17.297639846801871],
          [73.237640380859659, 17.297639846801871],
          [73.237640380859659, 17.297920227050838],
          [73.237915039062671, 17.297916412353459],
          [73.237915039062671, 17.29819488525402],
          [73.23819732666044, 17.298191070556697],
          [73.23819732666044, 17.298749923706055],
          [73.238471984863452, 17.298749923706055],
          [73.238471984863452, 17.299310684204158],
          [73.238746643066634, 17.299303054809627],
          [73.238746643066634, 17.299863815307731],
          [73.239028930664233, 17.299863815307731],
          [73.239028930664233, 17.300693511962947],
          [73.239303588867244, 17.300693511962947],
          [73.239303588867244, 17.300973892211914],
          [73.239585876464787, 17.300970077514762],
          [73.239585876464787, 17.301530838012695],
          [73.239860534668026, 17.301530838012695],
          [73.239860534668026, 17.302360534668082],
          [73.239585876464787, 17.302360534668082],
          [73.239585876464787, 17.303195953369197],
          [73.239295959472713, 17.303190231323242],
          [73.239295959472713, 17.304861068725586],
          [73.239860534668026, 17.304861068725586],
          [73.239860534668026, 17.305139541625977],
          [73.240135192871378, 17.305139541625977],
          [73.240135192871378, 17.305694580078125],
          [73.24041748046875, 17.305694580078125],
          [73.24041748046875, 17.305973052978516],
          [73.240692138672159, 17.30597114562994],
          [73.240692138672159, 17.30624961853033],
          [73.240966796875171, 17.30624961853033],
          [73.240966796875171, 17.306528091430664],
          [73.242362976074446, 17.306528091430664],
          [73.242362976074446, 17.306804656982479],
          [73.244026184082031, 17.306804656982479],
          [73.244026184082031, 17.30736160278326],
          [73.24346923828125, 17.307359695434684],
          [73.24346923828125, 17.307649612426758],
          [73.243186950683878, 17.307649612426758],
          [73.243186950683878, 17.307918548584041],
          [73.242637634277287, 17.307918548584041],
          [73.242637634277287, 17.307359695434684],
          [73.242362976074446, 17.307359695434684],
          [73.242362976074446, 17.307649612426758],
          [73.242080688476733, 17.307649612426758],
          [73.242080688476733, 17.307918548584041],
          [73.241806030273494, 17.307918548584041],
          [73.241806030273494, 17.308750152588004],
          [73.241531372070483, 17.308750152588004],
          [73.241531372070483, 17.309032440185547],
          [73.241806030273494, 17.309032440185547],
          [73.241806030273494, 17.309860229492187],
          [73.242080688476733, 17.309860229492187],
          [73.242080688476733, 17.311250686645508],
          [73.242362976074446, 17.311250686645508],
          [73.242362976074446, 17.312360763549862],
          [73.242080688476733, 17.312360763549862],
          [73.242080688476733, 17.312641143798828],
          [73.241806030273494, 17.312639236450252],
          [73.241806030273494, 17.313192367553825],
          [73.241531372070483, 17.313190460205021],
          [73.241531372070483, 17.315139770507926],
          [73.241806030273494, 17.315139770507926],
          [73.241806030273494, 17.315971374511719],
          [73.241531372070483, 17.315969467163086],
          [73.241531372070483, 17.316530227661246],
          [73.242080688476733, 17.316530227661246],
          [73.242080688476733, 17.317920684814567],
          [73.242362976074446, 17.31791877746582],
          [73.242362976074446, 17.318471908569393],
          [73.242637634277287, 17.318468093872013],
          [73.242637634277287, 17.318750381469783],
          [73.241806030273494, 17.318750381469783],
          [73.241806030273494, 17.318468093872013],
          [73.241531372070483, 17.318471908569393],
          [73.241531372070483, 17.31791877746582],
          [73.24124908447294, 17.317920684814567],
          [73.24124908447294, 17.31764030456543],
          [73.240966796875171, 17.31764030456543],
          [73.240966796875171, 17.317359924316463],
          [73.239295959472713, 17.317359924316463],
          [73.239295959472713, 17.31764030456543],
          [73.239028930664233, 17.31764030456543],
          [73.239028930664233, 17.317920684814567],
          [73.238471984863452, 17.317920684814567],
          [73.238471984863452, 17.318201065063533],
          [73.23819732666044, 17.318195343017578],
          [73.23819732666044, 17.318471908569393],
          [73.237358093261719, 17.318468093872013],
          [73.237358093261719, 17.318750381469783],
          [73.234306335449219, 17.318750381469783],
          [73.234306335449219, 17.31903076171875],
          [73.233749389648494, 17.31903076171875],
          [73.233749389648494, 17.319309234619141],
          [73.232086181640682, 17.319309234619141],
          [73.232086181640682, 17.31903076171875],
          [73.229309082031421, 17.31903076171875],
          [73.229309082031421, 17.319309234619141],
          [73.229026794433651, 17.319309234619141],
          [73.229026794433651, 17.319587707519531],
          [73.228752136230639, 17.319587707519531],
          [73.228752136230639, 17.320419311523494],
          [73.228195190429687, 17.320417404174862],
          [73.228195190429687, 17.320693969726676],
          [73.227912902832315, 17.320693969726676],
          [73.227912902832315, 17.320972442627067],
          [73.227638244628906, 17.32097053527832],
          [73.227638244628906, 17.322359085083008],
          [73.227363586425895, 17.322359085083008],
          [73.227363586425895, 17.322639465332031],
          [73.226806640624943, 17.322629928588867],
          [73.226806640624943, 17.322921752929744],
          [73.226524353027401, 17.322916030883789],
          [73.226524353027401, 17.32319450378418],
          [73.226249694824389, 17.32319450378418],
          [73.226249694824389, 17.323471069335994],
          [73.225692749023608, 17.323471069335994],
          [73.225692749023608, 17.323749542236385],
          [73.225418090820597, 17.323749542236385],
          [73.225418090820597, 17.324031829834098],
          [73.225151062011719, 17.324031829834098],
          [73.225151062011719, 17.324310302734489],
          [73.224586486816406, 17.324306488037109],
          [73.224586486816406, 17.324581146240348],
          [73.224304199219034, 17.324581146240348],
          [73.224304199219034, 17.324861526489315],
          [73.223747253418082, 17.324859619140739],
          [73.223747253418082, 17.325139999389705],
          [73.223472595214901, 17.325139999389705],
          [73.223472595214901, 17.325420379638672],
          [73.22291564941429, 17.325416564941463],
          [73.22291564941429, 17.325693130493278],
          [73.222358703613338, 17.325693130493278],
          [73.222358703613338, 17.325971603393668],
          [73.222084045410327, 17.325971603393668],
          [73.222091674804687, 17.326250076294059],
          [73.221527099609375, 17.326250076294059],
          [73.221527099609375, 17.326530456543026],
          [73.221252441406534, 17.326530456543026],
          [73.221252441406534, 17.326810836791992],
          [73.220695495605582, 17.326803207397461],
          [73.220695495605582, 17.327085494995174],
          [73.220413208007869, 17.327085494995174],
          [73.220413208007869, 17.327362060546989],
          [73.220138549804631, 17.327360153198242],
          [73.220138549804631, 17.327920913696346],
          [73.219856262207259, 17.327920913696346],
          [73.219856262207259, 17.32876014709484],
          [73.219581604004077, 17.32876014709484],
          [73.219581604004077, 17.3290309906007],
          [73.219017028808764, 17.3290309906007],
          [73.219017028808764, 17.32930946350109],
          [73.218750000000284, 17.329307556152287],
          [73.218750000000284, 17.330972671508846],
          [73.219017028808764, 17.33097076416027],
          [73.219017028808764, 17.331529617309627],
          [73.219306945800838, 17.331527709960994],
          [73.219306945800838, 17.3320827484132],
          [73.219581604004077, 17.332080841064453],
          [73.219581604004077, 17.33236122131359],
          [73.219856262207259, 17.33236122131359],
          [73.219856262207259, 17.332639694213981],
          [73.220138549804631, 17.332639694213981],
          [73.220138549804631, 17.332918167114371],
          [73.220413208007869, 17.332916259765568],
          [73.220413208007869, 17.333194732666129],
          [73.221252441406534, 17.333194732666129],
          [73.221252441406534, 17.333471298217773],
          [73.222358703613338, 17.333467483520565],
          [73.222358703613338, 17.333749771118164],
          [73.223197937011889, 17.333749771118164],
          [73.223197937011889, 17.333467483520565],
          [73.226516723632869, 17.333467483520565],
          [73.226516723632869, 17.333749771118164],
          [73.226806640624943, 17.333749771118164],
          [73.226806640624943, 17.334304809570313],
          [73.225975036621151, 17.334304809570313],
          [73.225975036621151, 17.334583282470703],
          [73.225692749023608, 17.334583282470703],
          [73.225692749023608, 17.334861755371094],
          [73.225418090820597, 17.334861755371094],
          [73.225418090820597, 17.336811065673942],
          [73.225135803222827, 17.336805343627987],
          [73.225135803222827, 17.337360382080192],
          [73.225692749023608, 17.337360382080192],
          [73.225692749023608, 17.337638854980582],
          [73.225151062011719, 17.337629318237418],
          [73.225151062011719, 17.337921142578125],
          [73.224586486816406, 17.337917327880916],
          [73.224586486816406, 17.338193893432731],
          [73.223197937011889, 17.338193893432731],
          [73.223197937011889, 17.338472366333121],
          [73.222640991211108, 17.338470458984375],
          [73.222640991211108, 17.338750839233512],
          [73.222358703613338, 17.338750839233512],
          [73.222358703613338, 17.339031219482479],
          [73.222091674804687, 17.339031219482479],
          [73.222091674804687, 17.339309692382869],
          [73.221809387207315, 17.33930587768549],
          [73.221801757812784, 17.339582443237305],
          [73.221252441406534, 17.339580535888729],
          [73.221252441406534, 17.339860916137695],
          [73.220970153808651, 17.339860916137695],
          [73.220970153808651, 17.340139389038086],
          [73.220703124999943, 17.340139389038086],
          [73.220703124999943, 17.340419769287223],
          [73.220413208007869, 17.340414047241268],
          [73.220413208007869, 17.340974807739201],
          [73.220138549804631, 17.340970993042049],
          [73.220138549804631, 17.34124946594244],
          [73.219856262207259, 17.34124946594244],
          [73.219856262207259, 17.341810226440543],
          [73.219581604004077, 17.341806411743164],
          [73.219581604004077, 17.342084884643555],
          [73.219306945800838, 17.342081069946403],
          [73.219306945800838, 17.34263992309576],
          [73.218750000000284, 17.34263992309576],
          [73.218750000000284, 17.342920303344727],
          [73.217918395996151, 17.342920303344727],
          [73.217918395996151, 17.343200683593864],
          [73.217361450195369, 17.343196868896484],
          [73.217361450195369, 17.343471527099723],
          [73.216796875000057, 17.34346961975092],
          [73.216796875000057, 17.343759536743221],
          [73.216529846191577, 17.343759536743221],
          [73.216529846191577, 17.34403038024908],
          [73.216247558593807, 17.34403038024908],
          [73.216247558593807, 17.344310760498047],
          [73.215972900390796, 17.344306945800838],
          [73.215972900390796, 17.344583511352653],
          [73.215698242187784, 17.344583511352653],
          [73.215698242187784, 17.344861984253043],
          [73.215415954589844, 17.344860076904297],
          [73.215415954589844, 17.345140457153434],
          [73.214859008789063, 17.345138549804631],
          [73.214859008789063, 17.345693588256836],
          [73.214584350586051, 17.345693588256836],
          [73.214584350586051, 17.346805572509766],
          [73.214302062988338, 17.346805572509766],
          [73.214302062988338, 17.34819412231451],
          [73.21457672119169, 17.348188400268555],
          [73.21457672119169, 17.349029541015682],
          [73.214859008789063, 17.349029541015682],
          [73.214859008789063, 17.349311828613395],
          [73.215141296387003, 17.34930610656744],
          [73.215141296387003, 17.349582672119254],
          [73.215415954589844, 17.349571228027344],
          [73.215415954589844, 17.349861145019645],
          [73.216247558593807, 17.349861145019645],
          [73.216247558593807, 17.350139617920036],
          [73.216529846191577, 17.350139617920036],
          [73.216529846191577, 17.350694656372184],
          [73.216804504394759, 17.350694656372184],
          [73.216804504394759, 17.350971221923828],
          [73.217361450195369, 17.350971221923828],
          [73.217361450195369, 17.351249694824219],
          [73.218750000000284, 17.351249694824219],
          [73.218750000000284, 17.351804733276367],
          [73.219024658203296, 17.351804733276367],
          [73.219024658203296, 17.352361679077148],
          [73.219581604004077, 17.352359771728572],
          [73.219581604004077, 17.352640151977539],
          [73.219856262207259, 17.352640151977539],
          [73.219856262207259, 17.352930068969783],
          [73.220138549804631, 17.352930068969783],
          [73.220138549804631, 17.354310989379996],
          [73.219856262207259, 17.354310989379996],
          [73.219856262207259, 17.356531143188533],
          [73.219581604004077, 17.356531143188533],
          [73.219581604004077, 17.356809616088924],
          [73.219306945800838, 17.356807708740348],
          [73.219306945800838, 17.357084274292106],
          [73.219017028808764, 17.357080459594783],
          [73.219017028808764, 17.35736083984375],
          [73.218193054199503, 17.35736083984375],
          [73.218193054199503, 17.357641220092887],
          [73.216247558593807, 17.357639312744141],
          [73.216247558593807, 17.358194351196289],
          [73.215957641601733, 17.358190536499137],
          [73.215957641601733, 17.359308242797852],
          [73.216247558593807, 17.359306335449219],
          [73.216247558593807, 17.359582901001033],
          [73.215957641601733, 17.359579086303654],
          [73.215957641601733, 17.360139846801815],
          [73.215698242187784, 17.360139846801815],
          [73.215698242187784, 17.360418319702205],
          [73.215415954589844, 17.360416412353572],
          [73.215415954589844, 17.360694885253963],
          [73.215141296387003, 17.360689163208008],
          [73.215141296387003, 17.361249923706168],
          [73.214859008789063, 17.361249923706168],
          [73.214859008789063, 17.361530303955135],
          [73.214584350586051, 17.361528396606559],
          [73.214584350586051, 17.361804962158317],
          [73.214302062988338, 17.361804962158317],
          [73.214302062988338, 17.362083435058707],
          [73.214027404785099, 17.362081527709961],
          [73.214027404785099, 17.362922668457031],
          [73.213752746582259, 17.362922668457031],
          [73.213752746582259, 17.363750457763672],
          [73.214027404785099, 17.363750457763672],
          [73.214027404785099, 17.364311218261776],
          [73.214302062988338, 17.36430549621582],
          [73.214302062988338, 17.364582061767635],
          [73.21457672119169, 17.364580154419059],
          [73.21457672119169, 17.365142822265739],
          [73.214859008789063, 17.365139007568416],
          [73.214859008789063, 17.365692138671989],
          [73.215141296387003, 17.365690231323185],
          [73.215141296387003, 17.366252899169922],
          [73.215415954589844, 17.366252899169922],
          [73.215415954589844, 17.366809844970703],
          [73.215698242187784, 17.366809844970703],
          [73.215698242187784, 17.3673610687257],
          [73.215957641601733, 17.3673610687257],
          [73.215957641601733, 17.367929458618164],
          [73.216247558593807, 17.367914199829102],
          [73.216247558593807, 17.368473052978629],
          [73.216529846191577, 17.368471145629883],
          [73.216529846191577, 17.369029998779411],
          [73.216804504394759, 17.369028091430607],
          [73.216804504394759, 17.369583129882812],
          [73.216529846191577, 17.369581222534237],
          [73.216529846191577, 17.370140075683594],
          [73.216247558593807, 17.370136260986385],
          [73.216247558593807, 17.370971679687557],
          [73.214859008789063, 17.370971679687557],
          [73.214859008789063, 17.370695114135742],
          [73.21457672119169, 17.370700836181697],
          [73.21457672119169, 17.370420455932731],
          [73.213752746582259, 17.370420455932731],
          [73.213752746582259, 17.370700836181697],
          [73.209587097168253, 17.370695114135742],
          [73.209587097168253, 17.370971679687557],
          [73.209297180175952, 17.370969772338981],
          [73.209297180175952, 17.371250152587947],
          [73.209030151367472, 17.371250152587947],
          [73.209030151367472, 17.371530532836914],
          [73.208747863769531, 17.371530532836914],
          [73.208747863769531, 17.372360229492301],
          [73.209030151367472, 17.372360229492301],
          [73.209030151367472, 17.372919082641658],
          [73.209304809570483, 17.372917175293026],
          [73.209304809570483, 17.373750686645621],
          [73.209587097168253, 17.373741149902287],
          [73.209587097168253, 17.374860763549805],
          [73.209861755371264, 17.374860763549805],
          [73.209861755371264, 17.375419616699332],
          [73.210136413574446, 17.375415802001953],
          [73.210136413574446, 17.375972747802734],
          [73.210418701172046, 17.375972747802734],
          [73.210418701172046, 17.377361297607479],
          [73.210151672363338, 17.377359390258903],
          [73.210151672363338, 17.377920150756836],
          [73.209861755371264, 17.377920150756836],
          [73.209861755371264, 17.378749847412223],
          [73.209587097168253, 17.378749847412223],
          [73.209587097168253, 17.379583358764762],
          [73.209297180175952, 17.379579544067383],
          [73.209297180175952, 17.380140304565543],
          [73.209030151367472, 17.380140304565543],
          [73.209030151367472, 17.38042068481451],
          [73.208747863769531, 17.38042068481451],
          [73.208747863769531, 17.38181114196783],
          [73.20847320556669, 17.381803512573299],
          [73.20847320556669, 17.382085800170842],
          [73.208190917968807, 17.382080078125114],
          [73.208190917968807, 17.38236045837408],
          [73.207916259765739, 17.38236045837408],
          [73.207916259765739, 17.382917404174805],
          [73.207641601562557, 17.382917404174805],
          [73.207641601562557, 17.38347244262701],
          [73.207359313964787, 17.383470535278434],
          [73.207359313964787, 17.383750915527401],
          [73.207077026367415, 17.383750915527401],
          [73.207077026367415, 17.384309768676758],
          [73.206527709960994, 17.384307861328182],
          [73.206527709960994, 17.384582519531364],
          [73.206253051757983, 17.384580612182617],
          [73.206253051757983, 17.385139465332145],
          [73.205406188965128, 17.385139465332145],
          [73.205406188965128, 17.384860992431754],
          [73.205139160156307, 17.384860992431754],
          [73.205139160156307, 17.384580612182617],
          [73.204307556152287, 17.384582519531364],
          [73.204307556152287, 17.384307861328182],
          [73.202957153320426, 17.384307861328182],
          [73.202362060547159, 17.384307861328182],
          [73.202362060547159, 17.384582519531364],
          [73.202079772949219, 17.384580612182617],
          [73.202079772949219, 17.384860992431754],
          [73.201805114746207, 17.384860992431754],
          [73.201812744140739, 17.385139465332145],
          [73.201530456543026, 17.385139465332145],
          [73.201530456543026, 17.385694503784293],
          [73.201248168945256, 17.385694503784293],
          [73.201248168945256, 17.385972976684684],
          [73.200973510742415, 17.385972976684684],
          [73.200973510742415, 17.387361526489258],
          [73.199859619140909, 17.387359619140682],
          [73.199859619140909, 17.387638092041016],
          [73.199577331543139, 17.387638092041016],
          [73.199577331543139, 17.387918472290039],
          [73.199028015136719, 17.387918472290039],
          [73.199028015136719, 17.387638092041016],
          [73.197357177734602, 17.387638092041016],
          [73.197357177734602, 17.387359619140682],
          [73.197082519531421, 17.387361526489258],
          [73.197082519531421, 17.387083053588867],
          [73.197364807128963, 17.387083053588867],
          [73.197364807128963, 17.386529922485465],
          [73.197639465332202, 17.386529922485465],
          [73.197639465332202, 17.386249542236328],
          [73.196250915527628, 17.386249542236328],
          [73.196250915527628, 17.386529922485465],
          [73.195968627929688, 17.386529922485465],
          [73.195968627929688, 17.386808395385856],
          [73.195693969726847, 17.386806488037053],
          [73.195693969726847, 17.387083053588867],
          [73.195419311523494, 17.387083053588867],
          [73.195419311523494, 17.387361526489258],
          [73.194847106933651, 17.387359619140682],
          [73.194847106933651, 17.387918472290039],
          [73.194580078124943, 17.387918472290039],
          [73.194580078124943, 17.388202667236328],
          [73.192916870117187, 17.388195037841797],
          [73.192916870117187, 17.388471603393612],
          [73.192642211914347, 17.388471603393612],
          [73.192642211914347, 17.388750076294002],
          [73.190971374511889, 17.388750076294002],
          [73.190971374511889, 17.388471603393612],
          [73.190414428711108, 17.388471603393612],
          [73.190414428711108, 17.387638092041016],
          [73.190139770508097, 17.387638092041016],
          [73.190139770508097, 17.387302398681697],
          [73.190139770508097, 17.387083053588867],
          [73.190414428711108, 17.387083053588867],
          [73.190414428711108, 17.386249542236328],
          [73.190696716308651, 17.386249542236328],
          [73.190696716308651, 17.384860992431754],
          [73.190406799316577, 17.384860992431754],
          [73.190406799316577, 17.384580612182617],
          [73.190139770508097, 17.384582519531364],
          [73.190139770508097, 17.384307861328182],
          [73.189582824707315, 17.384309768676758],
          [73.189582824707315, 17.384860992431754],
          [73.189308166503963, 17.384860992431754],
          [73.189308166503963, 17.385139465332145],
          [73.188751220703182, 17.385139465332145],
          [73.188751220703182, 17.385419845581112],
          [73.187637329101619, 17.385419845581112],
          [73.187637329101619, 17.385139465332145],
          [73.185417175292912, 17.385139465332145],
          [73.185417175292912, 17.384580612182617],
          [73.185142517090071, 17.384580612182617],
          [73.185142517090071, 17.384860992431754],
          [73.183746337890796, 17.384860992431754],
          [73.183746337890796, 17.385139465332145],
          [73.183471679687784, 17.385139465332145],
          [73.183471679687784, 17.385694503784293],
          [73.182914733887003, 17.385694503784293],
          [73.182914733887003, 17.385972976684684],
          [73.182357788086051, 17.385971069335938],
          [73.182357788086051, 17.386249542236328],
          [73.181526184082259, 17.386249542236328],
          [73.181526184082259, 17.386808395385856],
          [73.181251525879077, 17.386806488037053],
          [73.181251525879077, 17.387083053588867],
          [73.179580688476619, 17.387083053588867],
          [73.179580688476619, 17.386806488037053],
          [73.179031372070369, 17.386806488037053],
          [73.179031372070369, 17.387083053588867],
          [73.177085876464844, 17.387083053588867],
          [73.177085876464844, 17.387361526489258],
          [73.176528930664119, 17.387359619140682],
          [73.176528930664119, 17.387918472290039],
          [73.17624664306652, 17.387916564941406],
          [73.17624664306652, 17.388471603393612],
          [73.175971984863338, 17.388471603393612],
          [73.175971984863338, 17.389312744140682],
          [73.175697326660099, 17.389305114746151],
          [73.175697326660099, 17.389860153198356],
          [73.174858093261776, 17.389860153198356],
          [73.174858093261776, 17.390140533447322],
          [73.174583435058764, 17.390138626098746],
          [73.174583435058764, 17.390693664550895],
          [73.174308776855753, 17.390691757202148],
          [73.174308776855753, 17.391532897949219],
          [73.174026489257813, 17.391527175903263],
          [73.174041748046875, 17.392360687255859],
          [73.173751831054972, 17.392360687255859],
          [73.173751831054972, 17.394309997558707],
          [73.173469543457031, 17.394309997558707],
          [73.173469543457031, 17.395420074462891],
          [73.17319488525402, 17.395414352417106],
          [73.17319488525402, 17.395696640014648],
          [73.172920227050838, 17.39569091796875],
          [73.172920227050838, 17.396249771118278],
          [73.172637939453068, 17.396249771118278],
          [73.172637939453068, 17.396530151367244],
          [73.172080993652514, 17.396528244018668],
          [73.172080993652514, 17.397083282470817],
          [73.171806335449276, 17.397083282470817],
          [73.171806335449276, 17.397361755371207],
          [73.171516418457202, 17.397359848022461],
          [73.171516418457202, 17.397640228271598],
          [73.171249389648722, 17.397636413574219],
          [73.171249389648722, 17.397918701171989],
          [73.170967102050952, 17.397911071777457],
          [73.170967102050952, 17.398199081420955],
          [73.170677185058878, 17.398199081420955],
          [73.170677185058878, 17.399030685424918],
          [73.170417785644531, 17.399028778076172],
          [73.170417785644531, 17.39958381652832],
          [73.170135498047159, 17.39958381652832],
          [73.17014312744152, 17.399860382080135],
          [73.169860839843807, 17.399860382080135],
          [73.169860839843807, 17.400419235229492],
          [73.169586181640568, 17.400417327880859],
          [73.169586181640568, 17.400693893432674],
          [73.169303894043026, 17.400693893432674],
          [73.169303894043026, 17.400972366333065],
          [73.169029235840014, 17.400970458984489],
          [73.169029235840014, 17.401529312133846],
          [73.168746948242415, 17.401529312133846],
          [73.168746948242415, 17.401811599731559],
          [73.168472290039233, 17.401811599731559],
          [73.168472290039233, 17.402360916137809],
          [73.168197631836222, 17.402360916137809],
          [73.168197631836222, 17.402921676635742],
          [73.167915344238452, 17.402915954589787],
          [73.167915344238452, 17.403194427490348],
          [73.16764068603544, 17.403192520141602],
          [73.16764068603544, 17.404310226440487],
          [73.1673583984375, 17.404310226440487],
          [73.1673583984375, 17.405139923095703],
          [73.167083740234659, 17.40513801574707],
          [73.167083740234659, 17.405971527099666],
          [73.1673583984375, 17.40596961975109],
          [73.1673583984375, 17.406810760498161],
          [73.16764068603544, 17.406803131103629],
          [73.16764068603544, 17.407085418701172],
          [73.167915344238452, 17.407085418701172],
          [73.167915344238452, 17.407363891601563],
          [73.168472290039233, 17.407360076904411],
          [73.168472290039233, 17.407640457153377],
          [73.17014312744152, 17.407640457153377],
          [73.17014312744152, 17.407360076904411],
          [73.170417785644531, 17.407360076904411],
          [73.170417785644531, 17.407640457153377],
          [73.170677185058878, 17.407640457153377],
          [73.170677185058878, 17.407360076904411],
          [73.172363281250227, 17.407363891601563],
          [73.172363281250227, 17.406803131103629],
          [73.172637939453068, 17.406810760498161],
          [73.172637939453068, 17.406530380249023],
          [73.173187255859659, 17.406530380249023],
          [73.173187255859659, 17.406810760498161],
          [73.173469543457031, 17.406803131103629],
          [73.173469543457031, 17.407085418701172],
          [73.174575805664233, 17.407079696655217],
          [73.174575805664233, 17.407920837402344],
          [73.175140380859546, 17.407920837402344],
          [73.175140380859546, 17.407640457153377],
          [73.175422668457259, 17.407640457153377],
          [73.175422668457259, 17.406810760498161],
          [73.175140380859546, 17.406810760498161],
          [73.175140380859546, 17.406530380249023],
          [73.176811218262003, 17.406530380249023],
          [73.176811218262003, 17.406810760498161],
          [73.178749084472599, 17.406803131103629],
          [73.178749084472599, 17.407363891601563],
          [73.178474426269759, 17.407363891601563],
          [73.178474426269759, 17.40819358825695],
          [73.178192138672046, 17.40818977355957],
          [73.178192138672046, 17.408750534057731],
          [73.178466796875227, 17.408750534057731],
          [73.178466796875227, 17.409309387207088],
          [73.178749084472599, 17.409307479858512],
          [73.178749084472599, 17.409860610961914],
          [73.178466796875227, 17.40985107421875],
          [73.178466796875227, 17.410419464111442],
          [73.179031372070369, 17.410417556762638],
          [73.179031372070369, 17.410972595214844],
          [73.179306030273551, 17.410970687866268],
          [73.179306030273551, 17.411251068115234],
          [73.179580688476619, 17.411251068115234],
          [73.179580688476619, 17.411529541015625],
          [73.17984771728544, 17.411529541015625],
          [73.17984771728544, 17.411809921264762],
          [73.180137634277344, 17.411806106567383],
          [73.180137634277344, 17.412082672119197],
          [73.180969238281307, 17.412080764770621],
          [73.180969238281307, 17.412361145019588],
          [73.182907104492472, 17.412361145019588],
          [73.182907104492472, 17.412639617919979],
          [73.183197021484375, 17.412639617919979],
          [73.183197021484375, 17.412361145019588],
          [73.183471679687784, 17.412361145019588],
          [73.183471679687784, 17.412080764770621],
          [73.184303283691577, 17.412080764770621],
          [73.184303283691577, 17.413749694824332],
          [73.184585571289119, 17.413749694824332],
          [73.184585571289119, 17.414304733276481],
          [73.186531066894815, 17.414304733276481],
          [73.186531066894815, 17.414583206176871],
          [73.187080383301065, 17.414577484130916],
          [73.187080383301065, 17.415422439575195],
          [73.186531066894815, 17.415422439575195],
          [73.186531066894815, 17.415702819824162],
          [73.186248779296875, 17.415702819824162],
          [73.186248779296875, 17.416250228881836],
          [73.185691833496151, 17.416250228881836],
          [73.185691833496151, 17.416532516479549],
          [73.185142517090071, 17.416532516479549],
          [73.185142517090071, 17.416812896728516],
          [73.184860229492358, 17.416812896728516],
          [73.184860229492358, 17.41736030578619],
          [73.185142517090071, 17.41736030578619],
          [73.185142517090071, 17.418193817138729],
          [73.185417175292912, 17.418191909790153],
          [73.185417175292912, 17.41875076293951],
          [73.185691833496151, 17.41875076293951],
          [73.185691833496151, 17.419040679931584],
          [73.185417175292912, 17.419040679931584],
          [73.185417175292912, 17.419309616088867],
          [73.185691833496151, 17.419309616088867],
          [73.185691833496151, 17.419860839843864],
          [73.185974121093864, 17.419860839843864],
          [73.185974121093864, 17.420692443847656],
          [73.185691833496151, 17.42069053649908],
          [73.185691833496151, 17.421249389648437],
          [73.185417175292912, 17.421249389648437],
          [73.185417175292912, 17.422920227050895],
          [73.185142517090071, 17.42291450500494],
          [73.185142517090071, 17.423196792602482],
          [73.185691833496151, 17.423191070556754],
          [73.185691833496151, 17.423749923706112],
          [73.185981750488395, 17.423749923706112],
          [73.185974121093864, 17.423196792602482],
          [73.186248779296875, 17.423196792602482],
          [73.186248779296875, 17.42291450500494],
          [73.186805725097656, 17.42291450500494],
          [73.186805725097656, 17.423196792602482],
          [73.187080383301065, 17.423191070556754],
          [73.187080383301065, 17.424310684204215],
          [73.186805725097656, 17.424306869506836],
          [73.186805725097656, 17.424861907959041],
          [73.186531066894815, 17.424861907959041],
          [73.186531066894815, 17.425693511963004],
          [73.186813354492187, 17.425689697265625],
          [73.186813354492187, 17.426530838012752],
          [73.187080383301065, 17.426530838012752],
          [73.187080383301065, 17.42902946472168],
          [73.186805725097656, 17.429027557373047],
          [73.186805725097656, 17.430694580078182],
          [73.187080383301065, 17.430692672729606],
          [73.187080383301065, 17.430980682373104],
          [73.187637329101619, 17.430980682373104],
          [73.187637329101619, 17.431249618530387],
          [73.187919616699389, 17.431249618530387],
          [73.187919616699389, 17.43153190612793],
          [73.188194274902571, 17.431528091430778],
          [73.188194274902571, 17.431804656982536],
          [73.189308166503963, 17.431804656982536],
          [73.189308166503963, 17.43208122253418],
          [73.189857482910156, 17.43208122253418],
          [73.189857482910156, 17.432361602783317],
          [73.190406799316577, 17.43235969543457],
          [73.190406799316577, 17.432640075683707],
          [73.192077636718864, 17.432640075683707],
          [73.192077636718864, 17.43235969543457],
          [73.192359924316463, 17.432361602783317],
          [73.192359924316463, 17.43208122253418],
          [73.192916870117187, 17.43208122253418],
          [73.192916870117187, 17.432361602783317],
          [73.193191528320597, 17.43235969543457],
          [73.193191528320597, 17.432920455932674],
          [73.193466186523608, 17.432920455932674],
          [73.193466186523608, 17.433750152587891],
          [73.193748474121151, 17.433750152587891],
          [73.193748474121151, 17.434028625488281],
          [73.194030761718921, 17.434022903442496],
          [73.194030761718921, 17.434310913085994],
          [73.194313049316463, 17.434310913085994],
          [73.194313049316463, 17.435140609741211],
          [73.194580078124943, 17.435140609741211],
          [73.194580078124943, 17.435420989990348],
          [73.195419311523494, 17.435415267944393],
          [73.195419311523494, 17.435695648193359],
          [73.195686340332315, 17.435689926147404],
          [73.195686340332315, 17.436250686645565],
          [73.195968627929688, 17.436250686645565],
          [73.195968627929688, 17.436531066894531],
          [73.196250915527628, 17.436525344848746],
          [73.196250915527628, 17.437084197998104],
          [73.196525573730639, 17.437084197998104],
          [73.196525573730639, 17.437360763549918],
          [73.197357177734602, 17.437360763549918],
          [73.197357177734602, 17.437641143798885],
          [73.198471069335994, 17.437641143798885],
          [73.198471069335994, 17.437919616699276],
          [73.1995849609375, 17.4379177093507],
          [73.1995849609375, 17.438194274902457],
          [73.199859619140909, 17.438194274902457],
          [73.199859619140909, 17.438472747802848],
          [73.200416564941463, 17.438472747802848],
          [73.200416564941463, 17.438194274902457],
          [73.200691223144702, 17.438194274902457],
          [73.200691223144702, 17.4379177093507],
          [73.201805114746207, 17.4379177093507],
          [73.201805114746207, 17.438194274902457],
          [73.202362060547159, 17.438194274902457],
          [73.202362060547159, 17.438472747802848],
          [73.204017639160213, 17.438470840454102],
          [73.204017639160213, 17.438751220703239],
          [73.204856872558707, 17.438751220703239],
          [73.204856872558707, 17.438470840454102],
          [73.205696105957031, 17.438470840454102],
          [73.205696105957031, 17.439029693603629],
          [73.204307556152287, 17.439029693603629],
          [73.204307556152287, 17.43930816650402],
          [73.201530456543026, 17.439306259155217],
          [73.201530456543026, 17.439582824707031],
          [73.200691223144702, 17.439582824707031],
          [73.200691223144702, 17.439861297607422],
          [73.199859619140909, 17.439857482910213],
          [73.199859619140909, 17.44014930725109],
          [73.199028015136719, 17.44014930725109],
          [73.199028015136719, 17.440418243408203],
          [73.198753356933707, 17.44041633605957],
          [73.198753356933707, 17.440971374511776],
          [73.198471069335994, 17.440967559814396],
          [73.198471069335994, 17.441249847412166],
          [73.197921752929915, 17.441249847412166],
          [73.197921752929915, 17.441528320312557],
          [73.197639465332202, 17.441528320312557],
          [73.197639465332202, 17.441804885864315],
          [73.196807861328409, 17.441804885864315],
          [73.196807861328409, 17.442083358764705],
          [73.195419311523494, 17.442083358764705],
          [73.195419311523494, 17.441804885864315],
          [73.195137023925895, 17.441804885864315],
          [73.195137023925895, 17.442361831665096],
          [73.193466186523608, 17.442361831665096],
          [73.193466186523608, 17.442640304565487],
          [73.192077636718864, 17.442640304565487],
          [73.192077636718864, 17.442361831665096],
          [73.191802978515682, 17.442361831665096],
          [73.191802978515682, 17.441804885864315],
          [73.191528320312443, 17.441804885864315],
          [73.191528320312443, 17.441528320312557],
          [73.190406799316577, 17.441528320312557],
          [73.190406799316577, 17.441249847412166],
          [73.188186645507869, 17.441249847412166],
          [73.188186645507869, 17.441528320312557],
          [73.186805725097656, 17.441528320312557],
          [73.186805725097656, 17.441804885864315],
          [73.185974121093864, 17.441804885864315],
          [73.185974121093864, 17.442361831665096],
          [73.185691833496151, 17.442361831665096],
          [73.185691833496151, 17.442640304565487],
          [73.185981750488395, 17.442640304565487],
          [73.185981750488395, 17.442922592163029],
          [73.186248779296875, 17.442922592163029],
          [73.186248779296875, 17.443210601806754],
          [73.185974121093864, 17.443195343017635],
          [73.185981750488395, 17.44375038146984],
          [73.185691833496151, 17.44375038146984],
          [73.185691833496151, 17.444311141967773],
          [73.185974121093864, 17.444305419921818],
          [73.185974121093864, 17.444860458374023],
          [73.186248779296875, 17.444860458374023],
          [73.186248779296875, 17.445692062377987],
          [73.185974121093864, 17.445692062377987],
          [73.185974121093864, 17.448474884033203],
          [73.186248779296875, 17.448471069336051],
          [73.186248779296875, 17.449310302734375],
          [73.185981750488395, 17.449310302734375],
          [73.185981750488395, 17.450420379638729],
          [73.186248779296875, 17.450420379638729],
          [73.186248779296875, 17.451250076293945],
          [73.186531066894815, 17.451250076293945],
          [73.186531066894815, 17.451810836792049],
          [73.186248779296875, 17.451810836792049],
          [73.186248779296875, 17.452091217041016],
          [73.185974121093864, 17.452083587646484],
          [73.185974121093864, 17.452362060546875],
          [73.185691833496151, 17.452360153198299],
          [73.185691833496151, 17.452640533447266],
          [73.185417175292912, 17.452640533447266],
          [73.185417175292912, 17.452920913696403],
          [73.185142517090071, 17.452917098999023],
          [73.185142517090071, 17.453193664550838],
          [73.184585571289119, 17.453193664550838],
          [73.184585571289119, 17.453472137451229],
          [73.184303283691577, 17.453468322753849],
          [73.184303283691577, 17.45402908325201],
          [73.184585571289119, 17.454027175903377],
          [73.184585571289119, 17.454584121704158],
          [73.184303283691577, 17.454578399658203],
          [73.184303283691577, 17.454860687255973],
          [73.184028625488565, 17.454860687255973],
          [73.184028625488565, 17.455694198608512],
          [73.184303283691577, 17.455688476562557],
          [73.184303283691577, 17.456249237060547],
          [73.184585571289119, 17.456249237060547],
          [73.184585571289119, 17.457082748413086],
          [73.184860229492358, 17.457082748413086],
          [73.184860229492358, 17.457361221313477],
          [73.185142517090071, 17.457361221313477],
          [73.185142517090071, 17.457639694213867],
          [73.185417175292912, 17.457639694213867],
          [73.185417175292912, 17.457920074463004],
          [73.185974121093864, 17.457916259765625],
          [73.185974121093864, 17.458194732666016],
          [73.186248779296875, 17.458194732666016],
          [73.186248779296875, 17.45847129821783],
          [73.186531066894815, 17.458469390869254],
          [73.186531066894815, 17.458749771118221],
          [73.186813354492187, 17.458749771118221],
          [73.186820983886719, 17.459030151367188],
          [73.187080383301065, 17.459028244018612],
          [73.187080383301065, 17.459304809570369],
          [73.187637329101619, 17.459304809570369],
          [73.187637329101619, 17.45958328247076],
          [73.188194274902571, 17.45958328247076],
          [73.188194274902571, 17.459861755371151],
          [73.188468933105412, 17.459859848022575],
          [73.188468933105412, 17.460140228271541],
          [73.189308166503963, 17.460140228271541],
          [73.189308166503963, 17.460420608520508],
          [73.189857482910156, 17.460416793823299],
          [73.189857482910156, 17.460971832275504],
          [73.190139770508097, 17.460960388183594],
          [73.190139770508097, 17.461250305175895],
          [73.190406799316577, 17.461250305175895],
          [73.190406799316577, 17.461530685424862],
          [73.190696716308651, 17.461530685424862],
          [73.190696716308651, 17.461811065673828],
          [73.190971374511889, 17.461803436279297],
          [73.190971374511889, 17.46208572387701],
          [73.191246032715071, 17.462080001831112],
          [73.191246032715071, 17.462360382080078],
          [73.191528320312443, 17.462360382080078],
          [73.191528320312443, 17.462921142578182],
          [73.192085266113395, 17.462917327880803],
          [73.192085266113395, 17.463472366333008],
          [73.192642211914347, 17.463470458984432],
          [73.192642211914347, 17.465419769287109],
          [73.193748474121151, 17.465417861938533],
          [73.193748474121151, 17.465972900390682],
          [73.193473815918139, 17.465972900390682],
          [73.193473815918139, 17.467361450195426],
          [73.193748474121151, 17.467361450195426],
          [73.193748474121151, 17.468471527099609],
          [73.193466186523608, 17.468471527099609],
          [73.193466186523608, 17.469030380249137],
          [73.193191528320597, 17.469028472900391],
          [73.193191528320597, 17.470138549804744],
          [73.192916870117187, 17.470138549804744],
          [73.192916870117187, 17.470693588256893],
          [73.192642211914347, 17.470693588256893],
          [73.192642211914347, 17.472082138061637],
          [73.192359924316463, 17.472080230712891],
          [73.192359924316463, 17.472360610962028],
          [73.192077636718864, 17.472360610962028],
          [73.192077636718864, 17.47264289855957],
          [73.191787719726619, 17.47264289855957],
          [73.191787719726619, 17.472919464111385],
          [73.191253662109602, 17.472917556762809],
          [73.191253662109602, 17.47319221496582],
          [73.190971374511889, 17.473190307617244],
          [73.190971374511889, 17.473751068115348],
          [73.190696716308651, 17.473751068115348],
          [73.190696716308651, 17.475419998169059],
          [73.190414428711108, 17.475414276123104],
          [73.190414428711108, 17.475696563720646],
          [73.190139770508097, 17.475696563720646],
          [73.190139770508097, 17.475973129272461],
          [73.189857482910156, 17.475971221923885],
          [73.189857482910156, 17.476261138915959],
          [73.189582824707315, 17.476249694824276],
          [73.189582824707315, 17.477083206176815],
          [73.189308166503963, 17.477079391479435],
          [73.189308166503963, 17.477920532226562],
          [73.189025878906364, 17.477918624877987],
          [73.189025878906364, 17.478471755981559],
          [73.188751220703182, 17.478469848632812],
          [73.188751220703182, 17.479030609130916],
          [73.188468933105412, 17.479030609130916],
          [73.188468933105412, 17.479318618774414],
          [73.188751220703182, 17.479305267333928],
          [73.188751220703182, 17.479583740234489],
          [73.189025878906364, 17.479583740234489],
          [73.189025878906364, 17.480972290039062],
          [73.188751220703182, 17.480970382690487],
          [73.188751220703182, 17.481529235839844],
          [73.188468933105412, 17.481529235839844],
          [73.188468933105412, 17.481811523437557],
          [73.188186645507869, 17.481811523437557],
          [73.188186645507869, 17.482360839843807],
          [73.187919616699389, 17.482360839843807],
          [73.187919616699389, 17.482919692993164],
          [73.187637329101619, 17.482915878295955],
          [73.187637329101619, 17.483472824096737],
          [73.187362670898608, 17.483472824096737],
          [73.187362670898608, 17.484029769897518],
          [73.187080383301065, 17.484027862548942],
          [73.187080383301065, 17.484861373901481],
          [73.186813354492187, 17.484859466552734],
          [73.186813354492187, 17.485420227050838],
          [73.186531066894815, 17.485416412353459],
          [73.186531066894815, 17.485971450805664],
          [73.186248779296875, 17.485969543457088],
          [73.186248779296875, 17.486810684204158],
          [73.185974121093864, 17.486803054809627],
          [73.185974121093864, 17.48736381530756],
          [73.185691833496151, 17.487360000610408],
          [73.185691833496151, 17.487920761108512],
          [73.185417175292912, 17.487916946411133],
          [73.185417175292912, 17.488471984863338],
          [73.184860229492358, 17.488471984863338],
          [73.184860229492358, 17.489585876464844],
          [73.184593200683651, 17.489580154418945],
          [73.184593200683651, 17.490140914917049],
          [73.184860229492358, 17.49013710021967],
          [73.184860229492358, 17.490695953369197],
          [73.185142517090071, 17.490690231323299],
          [73.185142517090071, 17.49126052856451],
          [73.184860229492358, 17.49126052856451],
          [73.184860229492358, 17.49180984497076],
          [73.184585571289119, 17.491807937622184],
          [73.184585571289119, 17.492082595825195],
          [73.184303283691577, 17.492082595825195],
          [73.184303283691577, 17.49486160278326],
          [73.183471679687784, 17.494859695434684],
          [73.183471679687784, 17.495140075683651],
          [73.183197021484375, 17.495140075683651],
          [73.183197021484375, 17.49570274353033],
          [73.182914733887003, 17.495695114135799],
          [73.182914733887003, 17.495971679687614],
          [73.183471679687784, 17.495971679687614],
          [73.183471679687784, 17.496250152588004],
          [73.183197021484375, 17.496250152588004],
          [73.183197021484375, 17.496812820434513],
          [73.182907104492472, 17.496812820434513],
          [73.182907104492472, 17.497922897338867],
          [73.182640075683651, 17.497922897338867],
          [73.182640075683651, 17.498750686645508],
          [73.182357788086051, 17.498750686645508],
          [73.182357788086051, 17.500419616699219],
          [73.181526184082259, 17.500419616699219],
          [73.181526184082259, 17.501251220703182],
          [73.181808471679858, 17.501249313354606],
          [73.181808471679858, 17.502082824707145],
          [73.181251525879077, 17.502082824707145],
          [73.181251525879077, 17.502361297607536],
          [73.181526184082259, 17.502359390258789],
          [73.181526184082259, 17.502920150756893],
          [73.181808471679858, 17.502920150756893],
          [73.181808471679858, 17.503200531005859],
          [73.183197021484375, 17.503196716308707],
          [73.183197021484375, 17.503471374511719],
          [73.183471679687784, 17.503469467163143],
          [73.183471679687784, 17.503749847412109],
          [73.183746337890796, 17.503749847412109],
          [73.183746337890796, 17.504030227661246],
          [73.184028625488565, 17.504030227661246],
          [73.184028625488565, 17.505699157714957],
          [73.183471679687784, 17.505699157714957],
          [73.183471679687784, 17.50514030456543],
          [73.183197021484375, 17.50514030456543],
          [73.183197021484375, 17.504579544067496],
          [73.182914733887003, 17.504583358764648],
          [73.182914733887003, 17.5040283203125],
          [73.182357788086051, 17.5040283203125],
          [73.182357788086051, 17.504306793212834],
          [73.181808471679858, 17.504306793212834],
          [73.181808471679858, 17.504583358764648],
          [73.181526184082259, 17.504579544067496],
          [73.181526184082259, 17.507640838623104],
          [73.181251525879077, 17.507640838623104],
          [73.181251525879077, 17.507919311523494],
          [73.180969238281307, 17.507917404174918],
          [73.180969238281307, 17.508193969726676],
          [73.180694580078296, 17.508193969726676],
          [73.180694580078296, 17.508472442627067],
          [73.180137634277344, 17.50847053527832],
          [73.180137634277344, 17.509859085083065],
          [73.17984771728544, 17.509859085083065],
          [73.17984771728544, 17.510421752929744],
          [73.179580688476619, 17.510416030883789],
          [73.179580688476619, 17.51069450378418],
          [73.179031372070369, 17.51069450378418],
          [73.179031372070369, 17.510416030883789],
          [73.177917480468807, 17.510416030883789],
          [73.177917480468807, 17.51069450378418],
          [73.177635192871264, 17.51069450378418],
          [73.177635192871264, 17.510971069335994],
          [73.177360534668253, 17.510971069335994],
          [73.177360534668253, 17.511810302734489],
          [73.177085876464844, 17.511806488037109],
          [73.177085876464844, 17.512361526489315],
          [73.176811218262003, 17.512359619140739],
          [73.176811218262003, 17.513200759887809],
          [73.176528930664119, 17.513193130493278],
          [73.176528930664119, 17.513471603393668],
          [73.17624664306652, 17.513471603393668],
          [73.17624664306652, 17.514585494995174],
          [73.175697326660099, 17.514585494995174],
          [73.175697326660099, 17.514862060546989],
          [73.175422668457259, 17.514860153198242],
          [73.175422668457259, 17.515140533447379],
          [73.175697326660099, 17.515140533447379],
          [73.175697326660099, 17.5165309906007],
          [73.175415039062727, 17.516525268554744],
          [73.175422668457259, 17.517360687255916],
          [73.174858093261776, 17.517360687255916],
          [73.174858093261776, 17.517641067504883],
          [73.174575805664233, 17.517641067504883],
          [73.174575805664233, 17.517919540405273],
          [73.174041748046875, 17.517919540405273],
          [73.174041748046875, 17.518199920654411],
          [73.173751831054972, 17.518194198608455],
          [73.173751831054972, 17.518472671508846],
          [73.173469543457031, 17.51847076416027],
          [73.173469543457031, 17.518751144409237],
          [73.172363281250227, 17.518751144409237],
          [73.172363281250227, 17.51847076416027],
          [73.172080993652514, 17.518472671508846],
          [73.172080993652514, 17.518194198608455],
          [73.171524047851733, 17.518194198608455],
          [73.171524047851733, 17.518472671508846],
          [73.170967102050952, 17.51847076416027],
          [73.170967102050952, 17.518751144409237],
          [73.170417785644531, 17.518751144409237],
          [73.170417785644531, 17.519308090210018],
          [73.170135498047159, 17.519306182861385],
          [73.170135498047159, 17.5195827484132],
          [73.169860839843807, 17.519580841064453],
          [73.169860839843807, 17.51986122131359],
          [73.169586181640568, 17.51986122131359],
          [73.169586181640568, 17.520418167114371],
          [73.169303894043026, 17.520416259765568],
          [73.169303894043026, 17.521249771118164],
          [73.168746948242415, 17.521240234375],
          [73.168746948242415, 17.521528244018555],
          [73.168472290039233, 17.521528244018555],
          [73.168472290039233, 17.521804809570313],
          [73.168197631836222, 17.521799087524357],
          [73.168197631836222, 17.522922515869197],
          [73.167907714843921, 17.522922515869197],
          [73.167907714843921, 17.523750305175838],
          [73.16764068603544, 17.523750305175838],
          [73.16764068603544, 17.524032592773381],
          [73.1673583984375, 17.524026870727596],
          [73.1673583984375, 17.524305343627987],
          [73.167083740234659, 17.524305343627987],
          [73.167083740234659, 17.524583816528377],
          [73.166809082031307, 17.524581909179801],
          [73.166809082031307, 17.525140762329158],
          [73.166526794433707, 17.525138854980582],
          [73.166526794433707, 17.525972366333121],
          [73.165969848632756, 17.525970458984375],
          [73.165969848632756, 17.526250839233512],
          [73.165702819824276, 17.526250839233512],
          [73.165702819824276, 17.526531219482479],
          [73.165138244628963, 17.526531219482479],
          [73.165138244628963, 17.526809692382869],
          [73.164863586425952, 17.52680587768549],
          [73.164863586425952, 17.527082443237305],
          [73.164306640625, 17.527080535888729],
          [73.164306640625, 17.527370452880803],
          [73.164016723633097, 17.527370452880803],
          [73.164016723633097, 17.527639389038086],
          [73.163749694824276, 17.527639389038086],
          [73.163749694824276, 17.527919769287223],
          [73.163475036621207, 17.527914047241268],
          [73.163475036621207, 17.52819633483881],
          [73.163192749023494, 17.52819633483881],
          [73.163192749023494, 17.528474807739201],
          [73.162918090820256, 17.528470993042049],
          [73.162918090820256, 17.52874946594244],
          [73.162635803222884, 17.52874946594244],
          [73.162635803222884, 17.529310226440543],
          [73.162361145019702, 17.529304504394588],
          [73.162361145019702, 17.529861450195369],
          [73.162101745605753, 17.529859542846793],
          [73.162101745605753, 17.53013992309576],
          [73.160972595215128, 17.53013992309576],
          [73.160972595215128, 17.529859542846793],
          [73.160697937011776, 17.529861450195369],
          [73.160697937011776, 17.529582977294979],
          [73.160140991210994, 17.529582977294979],
          [73.160140991210994, 17.529304504394588],
          [73.159576416015682, 17.529310226440543],
          [73.159576416015682, 17.529029846191406],
          [73.159027099609432, 17.529029846191406],
          [73.159027099609432, 17.52874946594244],
          [73.158195495605469, 17.52874946594244],
          [73.158195495605469, 17.528474807739201],
          [73.157638549804688, 17.528474807739201],
          [73.157638549804688, 17.52819633483881],
          [73.155693054199389, 17.52819633483881],
          [73.155693054199389, 17.528474807739201],
          [73.155418395996378, 17.528470993042049],
          [73.155418395996378, 17.52874946594244],
          [73.155136108398608, 17.52874946594244],
          [73.155136108398608, 17.529029846191406],
          [73.154586791992188, 17.529029846191406],
          [73.154586791992188, 17.529310226440543],
          [73.154304504394815, 17.529304504394588],
          [73.154304504394815, 17.529861450195369],
          [73.154029846191463, 17.529859542846793],
          [73.154029846191463, 17.531250000000114],
          [73.153747558593864, 17.531250000000114],
          [73.153747558593864, 17.53153038024908],
          [73.153472900390682, 17.531528472900504],
          [73.153472900390682, 17.533193588256836],
          [73.153747558593864, 17.53318023681652],
          [73.153747558593864, 17.534309387207145],
          [73.153198242187671, 17.534309387207145],
          [73.153190612792912, 17.534030914306754],
          [73.152641296386889, 17.534030914306754],
          [73.152641296386889, 17.533750534057617],
          [73.151802062988565, 17.533750534057617],
          [73.151802062988565, 17.534584045410156],
          [73.151527404785156, 17.534578323364201],
          [73.151527404785156, 17.535139083862362],
          [73.151802062988565, 17.535139083862362],
          [73.151802062988565, 17.535972595214901],
          [73.152084350586108, 17.535972595214901],
          [73.152084350586108, 17.536249160766715],
          [73.153198242187671, 17.536239624023381],
          [73.153198242187671, 17.536529541015682],
          [73.152915954590071, 17.536527633667106],
          [73.152915954590071, 17.537361145019645],
          [73.153198242187671, 17.537361145019645],
          [73.153198242187671, 17.538194656372013],
          [73.152084350586108, 17.538194656372013],
          [73.152084350586108, 17.538471221923828],
          [73.151527404785156, 17.538471221923828],
          [73.151527404785156, 17.538749694824219],
          [73.151252746582315, 17.538749694824219],
          [73.151252746582315, 17.539030075073356],
          [73.150405883789119, 17.539030075073356],
          [73.150405883789119, 17.538749694824219],
          [73.149864196777571, 17.538749694824219],
          [73.149864196777571, 17.538471221923828],
          [73.149307250976619, 17.538471221923828],
          [73.149307250976619, 17.538749694824219],
          [73.149017333984546, 17.538749694824219],
          [73.149017333984546, 17.539030075073356],
          [73.148750305176065, 17.539028167724609],
          [73.148750305176065, 17.539583206176758],
          [73.148193359375284, 17.539583206176758],
          [73.148193359375284, 17.539861679077148],
          [73.147636413574332, 17.539859771728572],
          [73.147636413574332, 17.540420532226676],
          [73.147361755371151, 17.540420532226676],
          [73.147361755371151, 17.540700912475643],
          [73.147087097167912, 17.540700912475643],
          [73.147087097167912, 17.541250228881893],
          [73.146797180175838, 17.541250228881893],
          [73.146797180175838, 17.540969848632926],
          [73.146530151367358, 17.540969848632926],
          [73.146530151367358, 17.541250228881893],
          [73.146247863769588, 17.541250228881893],
          [73.146247863769588, 17.541530609130859],
          [73.145973205566577, 17.541530609130859],
          [73.145973205566577, 17.541810989379996],
          [73.145690917969034, 17.541803359985465],
          [73.145690917969034, 17.542085647583008],
          [73.145416259765625, 17.542079925537109],
          [73.145416259765625, 17.542369842529354],
          [73.144859313964844, 17.542369842529354],
          [73.144859313964844, 17.542640686035213],
          [73.144577026367472, 17.542640686035213],
          [73.144577026367472, 17.54292106628418],
          [73.144302368164119, 17.542915344238224],
          [73.144302368164119, 17.543193817138786],
          [73.144027709960881, 17.543190002441463],
          [73.144027709960881, 17.543750762939567],
          [73.143737792968807, 17.543750762939567],
          [73.143737792968807, 17.544031143188533],
          [73.143470764160327, 17.544031143188533],
          [73.143470764160327, 17.544309616088924],
          [73.142913818359546, 17.544307708740348],
          [73.142913818359546, 17.544584274291935],
          [73.142639160156534, 17.544580459594783],
          [73.142639160156534, 17.54486083984375],
          [73.142356872558764, 17.54486083984375],
          [73.142356872558764, 17.545141220092887],
          [73.142082214355753, 17.545139312744141],
          [73.142082214355753, 17.54597282409668],
          [73.141807556152344, 17.54597282409668],
          [73.141807556152344, 17.548194885253963],
          [73.141525268554972, 17.548194885253963],
          [73.141532897949332, 17.548751831054744],
          [73.141250610351619, 17.548751831054744],
          [73.141250610351619, 17.549312591552678],
          [73.140975952148381, 17.549304962158146],
          [73.140975952148381, 17.549583435058707],
          [73.140693664550838, 17.549583435058707],
          [73.140693664550838, 17.549861907959098],
          [73.140419006347827, 17.549861907959098],
          [73.140419006347827, 17.550140380859489],
          [73.140136718750227, 17.550140380859489],
          [73.140136718750227, 17.550422668457031],
          [73.139862060547046, 17.550416946411076],
          [73.139862060547046, 17.550691604614315],
          [73.139579772949276, 17.550695419311467],
          [73.139579772949276, 17.550970077514705],
          [73.139305114746264, 17.550970077514705],
          [73.139312744140625, 17.551250457763672],
          [73.139030456543253, 17.551250457763672],
          [73.139030456543253, 17.551811218261776],
          [73.138748168945313, 17.55180549621582],
          [73.138748168945313, 17.554029464721737],
          [73.138748168945313, 17.554309844970703],
          [73.138473510742472, 17.554304122924918],
          [73.138473510742472, 17.554582595825309],
          [73.138191223144588, 17.554580688476562],
          [73.138191223144588, 17.55513954162609],
          [73.137931823730412, 17.55513954162609],
          [73.137931823730412, 17.555419921875057],
          [73.137641906738338, 17.555414199829102],
          [73.137641906738338, 17.555696487426871],
          [73.137359619140568, 17.555696487426871],
          [73.137359619140568, 17.555973052978629],
          [73.137084960937727, 17.555973052978629],
          [73.137084960937727, 17.557361602783203],
          [73.137359619140568, 17.557350158691463],
          [73.137359619140568, 17.558200836181697],
          [73.137641906738338, 17.558200836181697],
          [73.137641906738338, 17.559860229492301],
          [73.13791656494152, 17.559860229492301],
          [73.13791656494152, 17.560417175293082],
          [73.138191223144588, 17.560417175293082],
          [73.138191223144588, 17.56069374084484],
          [73.13846588134794, 17.560689926147518],
          [73.13846588134794, 17.561809539794979],
          [73.138748168945313, 17.561809539794979],
          [73.138748168945313, 17.562360763549805],
          [73.139030456543253, 17.562360763549805],
          [73.139030456543253, 17.562639236450195],
          [73.139312744140625, 17.562639236450195],
          [73.139312744140625, 17.562919616699332],
          [73.139862060547046, 17.562919616699332],
          [73.139862060547046, 17.56792068481451],
          [73.140136718750227, 17.56792068481451],
          [73.140136718750227, 17.568201065063477],
          [73.140419006347827, 17.568193435668945],
          [73.140419006347827, 17.568471908569336],
          [73.141250610351619, 17.56847000122076],
          [73.141250610351619, 17.568750381469727],
          [73.141807556152344, 17.568750381469727],
          [73.141807556152344, 17.569030761718864],
          [73.142639160156534, 17.569030761718864],
          [73.142639160156534, 17.56931114196783],
          [73.142906188965014, 17.56931114196783],
          [73.142906188965014, 17.56986045837408],
          [73.143196105957088, 17.56986045837408],
          [73.143196105957088, 17.570140838623047],
          [73.143470764160327, 17.570140838623047],
          [73.143470764160327, 17.570421218872184],
          [73.14375305175804, 17.570415496826229],
          [73.14375305175804, 17.570695877075195],
          [73.144302368164119, 17.570695877075195],
          [73.144302368164119, 17.57097244262701],
          [73.144859313964844, 17.57097244262701],
          [73.144859313964844, 17.570695877075195],
          [73.145416259765625, 17.570695877075195],
          [73.145416259765625, 17.57097244262701],
          [73.145973205566577, 17.570970535278434],
          [73.145973205566577, 17.571250915527401],
          [73.146247863769588, 17.571250915527401],
          [73.146247863769588, 17.571529388427791],
          [73.146530151367358, 17.571529388427791],
          [73.146530151367358, 17.571809768676758],
          [73.14680480957054, 17.571807861328182],
          [73.14680480957054, 17.572082519531364],
          [73.148193359375284, 17.572082519531364],
          [73.148193359375284, 17.572360992431754],
          [73.148475646972656, 17.572360992431754],
          [73.148475646972656, 17.572639465332145],
          [73.148750305176065, 17.572639465332145],
          [73.148750305176065, 17.572919845581112],
          [73.149307250976619, 17.572917938232536],
          [73.149307250976619, 17.573194503784123],
          [73.149581909179858, 17.573194503784123],
          [73.149581909179858, 17.573472976684684],
          [73.151527404785156, 17.573471069335938],
          [73.151527404785156, 17.573749542236328],
          [73.152359008789119, 17.573749542236328],
          [73.152359008789119, 17.573471069335938],
          [73.152641296386889, 17.573472976684684],
          [73.152641296386889, 17.573194503784123],
          [73.152915954590071, 17.573194503784123],
          [73.152915954590071, 17.572917938232536],
          [73.153472900390682, 17.572919845581112],
          [73.153472900390682, 17.572639465332145],
          [73.153747558593864, 17.572639465332145],
          [73.153747558593864, 17.572349548339844],
          [73.154029846191463, 17.572360992431754],
          [73.154029846191463, 17.571807861328182],
          [73.154296875000284, 17.571809768676758],
          [73.154296875000284, 17.571250915527401],
          [73.154586791992188, 17.571250915527401],
          [73.154586791992188, 17.571029663085938],
          [73.154586791992188, 17.570695877075195],
          [73.154861450195597, 17.570695877075195],
          [73.154861450195597, 17.570415496826229],
          [73.155136108398608, 17.570421218872184],
          [73.155136108398608, 17.570140838623047],
          [73.155418395996378, 17.570140838623047],
          [73.155418395996378, 17.56986045837408],
          [73.155677795410327, 17.56986045837408],
          [73.155677795410327, 17.56847000122076],
          [73.155136108398608, 17.568471908569336],
          [73.155136108398608, 17.568193435668945],
          [73.155418395996378, 17.568201065063477],
          [73.155418395996378, 17.567640304565543],
          [73.155677795410327, 17.567640304565543],
          [73.155677795410327, 17.56707954406744],
          [73.155975341796932, 17.567083358764762],
          [73.155975341796932, 17.566804885864201],
          [73.157081604003963, 17.566804885864201],
          [73.157081604003963, 17.567083358764762],
          [73.157363891601676, 17.567083358764762],
          [73.157363891601676, 17.567361831665153],
          [73.157638549804688, 17.567359924316406],
          [73.157638549804688, 17.567640304565543],
          [73.159858703613224, 17.567640304565543],
          [73.159858703613224, 17.56792068481451],
          [73.160140991210994, 17.56792068481451],
          [73.160140991210994, 17.568201065063477],
          [73.160972595215128, 17.568193435668945],
          [73.160972595215128, 17.568471908569336],
          [73.163192749023494, 17.56847000122076],
          [73.163192749023494, 17.570140838623047],
          [73.163040161132869, 17.570140838623047],
          [73.162918090820256, 17.570140838623047],
          [73.162918090820256, 17.570421218872184],
          [73.162635803222884, 17.570415496826229],
          [73.162635803222884, 17.570695877075195],
          [73.162361145019702, 17.570695877075195],
          [73.162361145019702, 17.57097244262701],
          [73.162086486816463, 17.57097244262701],
          [73.162086486816463, 17.571250915527401],
          [73.161804199218921, 17.571250915527401],
          [73.161804199218921, 17.572360992431754],
          [73.162086486816463, 17.572360992431754],
          [73.162101745605753, 17.574300765991325],
          [73.162361145019702, 17.574308395385856],
          [73.162361145019702, 17.575138092041072],
          [73.162101745605753, 17.575138092041072],
          [73.162101745605753, 17.575420379638786],
          [73.162361145019702, 17.575420379638786],
          [73.162361145019702, 17.575702667236328],
          [73.162635803222884, 17.575702667236328],
          [73.162635803222884, 17.576250076294002],
          [73.162918090820256, 17.576250076294002],
          [73.162918090820256, 17.576530456542969],
          [73.163192749023494, 17.576530456542969],
          [73.163192749023494, 17.576812744140682],
          [73.163749694824276, 17.576805114746151],
          [73.163749694824276, 17.577083587646541],
          [73.166252136230526, 17.577081680297965],
          [73.166252136230526, 17.577360153198356],
          [73.166526794433707, 17.577360153198356],
          [73.166526794433707, 17.577922821044865],
          [73.166809082031307, 17.577922821044865],
          [73.166809082031307, 17.578750610351676],
          [73.167076110840128, 17.578750610351676],
          [73.167076110840128, 17.579309463501033],
          [73.1673583984375, 17.579309463501033],
          [73.1673583984375, 17.580141067504996],
          [73.16764068603544, 17.58013916015625],
          [73.16764068603544, 17.580692291259822],
          [73.167915344238452, 17.580692291259822],
          [73.167915344238452, 17.581527709960994],
          [73.168197631836222, 17.581527709960994],
          [73.168197631836222, 17.582082748413143],
          [73.168472290039233, 17.582080841064567],
          [73.168472290039233, 17.582361221313533],
          [73.1673583984375, 17.582361221313533],
          [73.1673583984375, 17.582920074462891],
          [73.167083740234659, 17.582914352417106],
          [73.167083740234659, 17.583471298217887],
          [73.166809082031307, 17.583469390869141],
          [73.166809082031307, 17.583749771118278],
          [73.166252136230526, 17.583749771118278],
          [73.166252136230526, 17.584030151367244],
          [73.165969848632756, 17.584026336669865],
          [73.165969848632756, 17.584306716919059],
          [73.165695190429915, 17.584306716919059],
          [73.165695190429915, 17.584861755371207],
          [73.165412902832202, 17.584859848022461],
          [73.165412902832202, 17.585140228271598],
          [73.165138244628963, 17.585140228271598],
          [73.165138244628963, 17.585699081420955],
          [73.164871215820312, 17.585699081420955],
          [73.164871215820312, 17.586809158325309],
          [73.164306640625, 17.586809158325309],
          [73.164306640625, 17.587640762329102],
          [73.163749694824276, 17.587640762329102],
          [73.163749694824276, 17.587919235229492],
          [73.163482666015568, 17.587919235229492],
          [73.163482666015568, 17.589029312133846],
          [73.162918090820256, 17.589029312133846],
          [73.162918090820256, 17.589311599731388],
          [73.162635803222884, 17.589311599731388],
          [73.162651062011776, 17.5901393890382],
          [73.162086486816463, 17.5901393890382],
          [73.162086486816463, 17.590320587158146],
          [73.162101745605753, 17.591249465942383],
          [73.161247253417969, 17.591249465942383],
          [73.161247253417969, 17.59152984619152],
          [73.160423278808707, 17.59152984619152],
          [73.160423278808707, 17.591810226440487],
          [73.159584045410384, 17.591806411743107],
          [73.159584045410384, 17.592081069946346],
          [73.158470153808878, 17.592081069946346],
          [73.158470153808878, 17.591806411743107],
          [73.157348632812784, 17.591806411743107],
          [73.156524658203182, 17.591806411743107],
          [73.156524658203182, 17.592081069946346],
          [73.155418395996378, 17.592081069946346],
          [73.155418395996378, 17.592361450195312],
          [73.155136108398608, 17.592359542846737],
          [73.155136108398608, 17.592639923095703],
          [73.154861450195597, 17.592639923095703],
          [73.154861450195597, 17.59292030334484],
          [73.154586791992188, 17.59292030334484],
          [73.154586791992188, 17.593200683593807],
          [73.154029846191463, 17.593200683593807],
          [73.154029846191463, 17.593750000000057],
          [73.153747558593864, 17.593750000000057],
          [73.153747558593864, 17.594030380249023],
          [73.153472900390682, 17.594030380249023],
          [73.153472900390682, 17.594310760498161],
          [73.152359008789119, 17.594310760498161],
          [73.152359008789119, 17.595140457153377],
          [73.152084350586108, 17.595138549804801],
          [73.152084350586108, 17.595672607421932],
          [73.152084350586108, 17.59597206115734],
          [73.152359008789119, 17.595970153808594],
          [73.152359008789119, 17.596809387207088],
          [73.152641296386889, 17.596809387207088],
          [73.152641296386889, 17.597360610961914],
          [73.152915954590071, 17.597360610961914],
          [73.152915954590071, 17.598472595214844],
          [73.151252746582315, 17.598472595214844],
          [73.151252746582315, 17.598194122314453],
          [73.149864196777571, 17.598194122314453],
          [73.149864196777571, 17.597917556762695],
          [73.149627685546875, 17.597917556762695],
          [73.149024963379077, 17.597917556762695],
          [73.149024963379077, 17.598194122314453],
          [73.148193359375284, 17.598194122314453],
          [73.148193359375284, 17.598472595214844],
          [73.147918701171932, 17.598470687866268],
          [73.147918701171932, 17.598751068115234],
          [73.147361755371151, 17.598751068115234],
          [73.147361755371151, 17.599029541015625],
          [73.147087097167912, 17.599029541015625],
          [73.147087097167912, 17.599582672119197],
          [73.146797180175838, 17.599580764770621],
          [73.146797180175838, 17.600139617919979],
          [73.145973205566577, 17.600139617919979],
          [73.145973205566577, 17.600418090820369],
          [73.145416259765625, 17.600416183471737],
          [73.145416259765625, 17.600694656372127],
          [73.144859313964844, 17.600694656372127],
          [73.144859313964844, 17.600973129272518],
          [73.144577026367472, 17.600971221923942],
          [73.144577026367472, 17.601249694824332],
          [73.144302368164119, 17.601249694824332],
          [73.144302368164119, 17.601528167724723],
          [73.144027709960881, 17.601528167724723],
          [73.144027709960881, 17.60180473327631],
          [73.143737792968807, 17.601800918579158],
          [73.143737792968807, 17.602922439575195],
          [73.143470764160327, 17.602922439575195],
          [73.143470764160327, 17.603202819824162],
          [73.143196105957088, 17.603202819824162],
          [73.143196105957088, 17.603750228881836],
          [73.142906188965014, 17.603750228881836],
          [73.142906188965014, 17.604030609130973],
          [73.142364501953125, 17.604028701782227],
          [73.142364501953125, 17.604583740234375],
          [73.142082214355753, 17.604581832885799],
          [73.142082214355753, 17.605140686035156],
          [73.141525268554972, 17.60513877868658],
          [73.141525268554972, 17.605693817138729],
          [73.141250610351619, 17.605693817138729],
          [73.141250610351619, 17.605972290039119],
          [73.140678405761776, 17.605970382690543],
          [73.140678405761776, 17.606531143188477],
          [73.140419006347827, 17.606531143188477],
          [73.140419006347827, 17.607360839843864],
          [73.140136718750227, 17.607360839843864],
          [73.140136718750227, 17.607919692993221],
          [73.139862060547046, 17.607919692993221],
          [73.139862060547046, 17.608749389648438],
          [73.139579772949276, 17.608749389648438],
          [73.139579772949276, 17.609029769897575],
          [73.139312744140625, 17.609029769897575],
          [73.139312744140625, 17.609310150146541],
          [73.139030456543253, 17.609304428100586],
          [73.139030456543253, 17.609582901000977],
          [73.13846588134794, 17.609580993652401],
          [73.13846588134794, 17.610139846801758],
          [73.138191223144588, 17.610139846801758],
          [73.138191223144588, 17.610420227050895],
          [73.13791656494152, 17.61041450500494],
          [73.13791656494152, 17.610971450805721],
          [73.137359619140568, 17.610969543457145],
          [73.137359619140568, 17.611810684204215],
          [73.137084960937727, 17.611806869506893],
          [73.137084960937727, 17.612361907959041],
          [73.136802673340014, 17.612358093261662],
          [73.136802673340014, 17.612920761108398],
          [73.136528015136776, 17.612918853759822],
          [73.136528015136776, 17.613471984863395],
          [73.136253356933764, 17.613468170166016],
          [73.136253356933764, 17.613750457763786],
          [73.135971069336222, 17.613750457763786],
          [73.135971069336222, 17.614309310913143],
          [73.135696411132813, 17.614309310913143],
          [73.135696411132813, 17.614591598510685],
          [73.135971069336222, 17.614591598510685],
          [73.135971069336222, 17.614860534667969],
          [73.135696411132813, 17.614860534667969],
          [73.135696411132813, 17.616249084472713],
          [73.13541412353544, 17.616249084472713],
          [73.13541412353544, 17.617082595825252],
          [73.135139465332088, 17.617082595825252],
          [73.135139465332088, 17.618471145629996],
          [73.13486480712902, 17.618471145629996],
          [73.13486480712902, 17.620693206787109],
          [73.134582519531307, 17.620693206787109],
          [73.134582519531307, 17.6209716796875],
          [73.134307861328068, 17.620969772338924],
          [73.134307861328068, 17.621810913085994],
          [73.134033203125227, 17.621810913085994],
          [73.134033203125227, 17.624309539794922],
          [73.133750915527514, 17.624309539794922],
          [73.133750915527514, 17.625419616699276],
          [73.133468627929744, 17.6254177093507],
          [73.133468627929744, 17.627361297607422],
          [73.133193969726733, 17.627361297607422],
          [73.133193969726733, 17.628194808959961],
          [73.132919311523722, 17.628189086914006],
          [73.132919311523722, 17.628751754760742],
          [73.132637023925781, 17.628751754760742],
          [73.132637023925781, 17.629030227661133],
          [73.13236236572294, 17.629030227661133],
          [73.13236236572294, 17.629592895507869],
          [73.131805419921989, 17.629583358764705],
          [73.131805419921989, 17.629861831665096],
          [73.131530761718807, 17.629861831665096],
          [73.131530761718807, 17.63070106506342],
          [73.131248474121037, 17.630695343017635],
          [73.131248474121037, 17.632980346679688],
          [73.131248474121037, 17.633192062377987],
          [73.130973815918196, 17.633192062377987],
          [73.130966186523494, 17.63356971740717],
          [73.130966186523494, 17.633750915527344],
          [73.130691528320483, 17.633750915527344],
          [73.130668640136832, 17.634168624877987],
          [73.130661010742301, 17.634309768676871],
          [73.130416870117244, 17.634304046630916],
          [73.130393981933651, 17.634759902954102],
          [73.130386352539119, 17.634860992431697],
          [73.130142211914233, 17.634860992431697],
          [73.130142211914233, 17.635139465332088],
          [73.129302978515909, 17.635139465332088],
          [73.129302978515909, 17.635419845581055],
          [73.1290283203125, 17.63541412353527],
          [73.1290283203125, 17.635694503784237],
          [73.128471374511776, 17.635694503784237],
          [73.128471374511776, 17.635974884033203],
          [73.127906799316463, 17.635971069336051],
          [73.127906799316463, 17.636249542236442],
          [73.127639770507983, 17.636249542236442],
          [73.127639770507983, 17.636529922485408],
          [73.127357482910384, 17.636526107788029],
          [73.127357482910384, 17.637083053588981],
          [73.127082824707202, 17.637081146240234],
          [73.127082824707202, 17.637639999389762],
          [73.127357482910384, 17.637639999389762],
          [73.127357482910384, 17.638759613037053],
          [73.127639770507983, 17.638759613037053],
          [73.127639770507983, 17.639030456543082],
          [73.127906799316463, 17.639030456543082],
          [73.127906799316463, 17.639310836792049],
          [73.128196716308537, 17.639305114746094],
          [73.128196716308537, 17.639862060546875],
          [73.127914428710994, 17.639862060546875],
          [73.127914428710994, 17.640693664550838],
          [73.128196716308537, 17.640689849853516],
          [73.128196716308537, 17.641250610351619],
          [73.128471374511776, 17.641250610351619],
          [73.128471374511776, 17.64152908325201],
          [73.1290283203125, 17.64152908325201],
          [73.1290283203125, 17.641822814941463],
          [73.129302978515909, 17.641805648803768],
          [73.129302978515909, 17.642084121704158],
          [73.129585266113281, 17.642084121704158],
          [73.129585266113281, 17.642360687255973],
          [73.12985992431669, 17.642360687255973],
          [73.12985992431669, 17.642639160156364],
          [73.130142211914233, 17.642639160156364],
          [73.130142211914233, 17.643194198608342],
          [73.130416870117244, 17.643194198608342],
          [73.130416870117244, 17.643472671508903],
          [73.130691528320483, 17.643470764160156],
          [73.130691528320483, 17.643751144409293],
          [73.131530761718807, 17.643751144409293],
          [73.131530761718807, 17.644029617309684],
          [73.132080078125, 17.644029617309684],
          [73.132080078125, 17.644311904907227],
          [73.133460998535384, 17.644311904907227],
          [73.133468627929744, 17.644029617309684],
          [73.134033203125227, 17.644029617309684],
          [73.134033203125227, 17.643751144409293],
          [73.134857177734489, 17.643751144409293],
          [73.134857177734489, 17.644029617309684],
          [73.135139465332088, 17.644029617309684],
          [73.135139465332088, 17.644311904907227],
          [73.135696411132813, 17.644306182861271],
          [73.135696411132813, 17.644582748413086],
          [73.135406494140909, 17.64456939697277],
          [73.135406494140909, 17.644861221313477],
          [73.135139465332088, 17.644861221313477],
          [73.135139465332088, 17.645139694213867],
          [73.134857177734489, 17.645139694213867],
          [73.134857177734489, 17.648200988769474],
          [73.134582519531307, 17.648200988769474],
          [73.134582519531307, 17.649030685424862],
          [73.134307861328068, 17.649030685424862],
          [73.134307861328068, 17.650421142578182],
          [73.134025573730696, 17.650415420532227],
          [73.134025573730696, 17.650972366333008],
          [73.133750915527514, 17.650970458984432],
          [73.133750915527514, 17.651250839233398],
          [73.133468627929744, 17.651250839233398],
          [73.133468627929744, 17.653194427490291],
          [73.133186340332202, 17.653190612792969],
          [73.133186340332202, 17.65376091003418],
          [73.132919311523722, 17.65376091003418],
          [73.132919311523722, 17.654029846191463],
          [73.132637023925781, 17.654029846191463],
          [73.132637023925781, 17.654582977295036],
          [73.13236236572294, 17.654582977295036],
          [73.13236236572294, 17.654861450195426],
          [73.132080078125, 17.654857635498047],
          [73.132080078125, 17.655420303344783],
          [73.131797790527628, 17.655420303344783],
          [73.131797790527628, 17.655702590942326],
          [73.131530761718807, 17.655694961547795],
          [73.131530761718807, 17.655971527099609],
          [73.131248474121037, 17.655971527099609],
          [73.131248474121037, 17.656805038452148],
          [73.130416870117244, 17.656805038452148],
          [73.130416870117244, 17.657083511352539],
          [73.130142211914233, 17.657081604003963],
          [73.130142211914233, 17.65764045715332],
          [73.12985992431669, 17.657638549804744],
          [73.12985992431669, 17.658193588256893],
          [73.129585266113281, 17.658193588256893],
          [73.129585266113281, 17.658472061157283],
          [73.127983093262003, 17.658470153808707],
          [73.127082824707202, 17.658470153808707],
          [73.127082824707202, 17.658750534057674],
          [73.126525878906421, 17.658750534057674],
          [73.126525878906421, 17.659309387207031],
          [73.126251220703409, 17.659309387207031],
          [73.126251220703409, 17.660419464111385],
          [73.126525878906421, 17.660419464111385],
          [73.126525878906421, 17.661529541015739],
          [73.126251220703409, 17.661529541015739],
          [73.126251220703409, 17.661809921264705],
          [73.125968933105469, 17.661809921264705],
          [73.125968933105469, 17.662361145019531],
          [73.125137329101676, 17.662361145019531],
          [73.125137329101676, 17.663196563720703],
          [73.125419616699276, 17.663196563720703],
          [73.125419616699276, 17.664304733276424],
          [73.124031066894702, 17.664304733276424],
          [73.124031066894702, 17.664583206176815],
          [73.122917175292969, 17.664583206176815],
          [73.122917175292969, 17.664861679077205],
          [73.122093200683537, 17.664859771728629],
          [73.122093200683537, 17.665140151977596],
          [73.121803283691463, 17.665136337280217],
          [73.121803283691463, 17.665971755981559],
          [73.121528625488224, 17.665969848632812],
          [73.121528625488224, 17.666530609130916],
          [73.121246337890852, 17.666530609130916],
          [73.121246337890852, 17.667360305786133],
          [73.120971679687671, 17.667360305786133],
          [73.120971679687671, 17.667919158935661],
          [73.120697021484432, 17.667917251586914],
          [73.120697021484432, 17.668193817138672],
          [73.120971679687671, 17.668193817138672],
          [73.120971679687671, 17.668750762939453],
          [73.121246337890852, 17.668750762939453],
          [73.121246337890852, 17.670694351196346],
          [73.120697021484432, 17.670694351196346],
          [73.120697021484432, 17.670972824096737],
          [73.119857788085938, 17.670972824096737],
          [73.119857788085938, 17.671249389648551],
          [73.119308471679744, 17.671249389648551],
          [73.119308471679744, 17.671529769897518],
          [73.119026184082145, 17.671527862548942],
          [73.119026184082145, 17.671806335449332],
          [73.118751525878963, 17.671806335449332],
          [73.118751525878963, 17.672361373901481],
          [73.118469238281193, 17.672361373901481],
          [73.118469238281193, 17.673471450805664],
          [73.118194580078352, 17.673471450805664],
          [73.118194580078352, 17.674583435058594],
          [73.117919921875171, 17.674583435058594],
          [73.117919921875171, 17.675689697265625],
          [73.117637634277401, 17.675701141357479],
          [73.117637634277401, 17.676530838012695],
          [73.117919921875171, 17.676530838012695],
          [73.117919921875171, 17.677640914917049],
          [73.117637634277401, 17.67763710021967],
          [73.117637634277401, 17.678472518921012],
          [73.116531372070597, 17.678470611572266],
          [73.116531372070597, 17.678750991821403],
          [73.115966796875284, 17.678750991821403],
          [73.115966796875284, 17.67930984497076],
          [73.115692138671932, 17.67930984497076],
          [73.115692138671932, 17.679861068725586],
          [73.115417480468693, 17.679861068725586],
          [73.115417480468693, 17.68124961853033],
          [73.115142822265852, 17.68124961853033],
          [73.115142822265852, 17.683202743530387],
          [73.115417480468693, 17.683195114135799],
          [73.115417480468693, 17.683750152588004],
          [73.114585876464901, 17.683750152588004],
          [73.114585876464901, 17.684583663940373],
          [73.114303588867358, 17.684583663940373],
          [73.114303588867358, 17.685693740844727],
          [73.114585876464901, 17.685691833496151],
          [73.114585876464901, 17.686250686645508],
          [73.114860534668139, 17.686250686645508],
          [73.114860534668139, 17.686531066894645],
          [73.114585876464901, 17.686531066894645],
          [73.114585876464901, 17.687641143798828],
          [73.114295959472827, 17.687641143798828],
          [73.114295959472827, 17.688751220703182],
          [73.114028930664347, 17.688751220703182],
          [73.114028930664347, 17.689310073852539],
          [73.113746643066577, 17.689304351806584],
          [73.113746643066577, 17.690971374511719],
          [73.114028930664347, 17.690969467163143],
          [73.114028930664347, 17.691530227661246],
          [73.114303588867358, 17.691526412963867],
          [73.114303588867358, 17.692361831665039],
          [73.114585876464901, 17.692359924316463],
          [73.114585876464901, 17.69403076171875],
          [73.114028930664347, 17.69403076171875],
          [73.114028930664347, 17.694309234619141],
          [73.114295959472827, 17.694309234619141],
          [73.114295959472827, 17.694860458374137],
          [73.114585876464901, 17.694860458374137],
          [73.114585876464901, 17.695419311523494],
          [73.114860534668139, 17.695417404174918],
          [73.114860534668139, 17.695693969726506],
          [73.115135192871151, 17.695693969726506],
          [73.115135192871151, 17.695972442627067],
          [73.115417480468693, 17.69597053527832],
          [73.115417480468693, 17.696250915527457],
          [73.115692138671932, 17.696250915527457],
          [73.115692138671932, 17.696529388427848],
          [73.115966796875284, 17.696529388427848],
          [73.115966796875284, 17.696811676025391],
          [73.116249084472656, 17.696805953979435],
          [73.116249084472656, 17.69708251953125],
          [73.116531372070597, 17.69708251953125],
          [73.116531372070597, 17.697639465332031],
          [73.116798400879077, 17.697639465332031],
          [73.116798400879077, 17.697919845581168],
          [73.117080688476847, 17.697916030883789],
          [73.117080688476847, 17.69819450378418],
          [73.117362976074389, 17.698192596435604],
          [73.117362976074389, 17.698749542236385],
          [73.119026184082145, 17.698749542236385],
          [73.119026184082145, 17.699304580688533],
          [73.119857788085938, 17.699304580688533],
          [73.119857788085938, 17.699028015136776],
          [73.120971679687671, 17.699028015136776],
          [73.120971679687671, 17.699302673339957],
          [73.121246337890852, 17.699310302734489],
          [73.121246337890852, 17.700139999389705],
          [73.121528625488224, 17.700139999389705],
          [73.121528625488224, 17.700420379638672],
          [73.122917175292969, 17.700420379638672],
          [73.122917175292969, 17.700139999389705],
          [73.123191833496378, 17.700139999389705],
          [73.123191833496378, 17.700420379638672],
          [73.123748779296932, 17.700420379638672],
          [73.123748779296932, 17.700149536132812],
          [73.124580383300724, 17.700139999389705],
          [73.124580383300724, 17.700420379638672],
          [73.124862670898494, 17.70041656494152],
          [73.124862670898494, 17.700870513916072],
          [73.124862670898494, 17.700971603393668],
          [73.125022888183594, 17.700969696044922],
          [73.125137329101676, 17.700969696044922],
          [73.125137329101676, 17.701250076294059],
          [73.124862670898494, 17.701250076294059],
          [73.124862670898494, 17.701810836791992],
          [73.125137329101676, 17.701803207397461],
          [73.125137329101676, 17.702083587646428],
          [73.125968933105469, 17.702079772949276],
          [73.125968933105469, 17.702360153198242],
          [73.126800537109432, 17.702362060546989],
          [73.127082824707202, 17.702362060546989],
          [73.127082824707202, 17.702831268310661],
          [73.127082824707202, 17.703193664550781],
          [73.127273559570483, 17.703193664550781],
          [73.127357482910384, 17.703193664550781],
          [73.127357482910384, 17.7040309906007],
          [73.127639770507983, 17.704025268554744],
          [73.127639770507983, 17.704584121704102],
          [73.127906799316463, 17.70458030700695],
          [73.127906799316463, 17.705141067504883],
          [73.128471374511776, 17.705160140991325],
          [73.128471374511776, 17.705419540405273],
          [73.128616333007983, 17.705417633056697],
          [73.128753662109489, 17.705417633056697],
          [73.128753662109489, 17.705694198608455],
          [73.129302978515909, 17.705694198608455],
          [73.129302978515909, 17.705972671508846],
          [73.12985992431669, 17.70597076416027],
          [73.12985992431669, 17.706251144409237],
          [73.130416870117244, 17.706251144409237],
          [73.130416870117244, 17.706529617309627],
          [73.131797790527628, 17.706529617309627],
          [73.131797790527628, 17.706251144409237],
          [73.132919311523722, 17.706251144409237],
          [73.132919311523722, 17.706529617309627],
          [73.133186340332202, 17.706529617309627],
          [73.133186340332202, 17.706808090210018],
          [73.133468627929744, 17.706806182861442],
          [73.133468627929744, 17.7070827484132],
          [73.133750915527514, 17.707080841064453],
          [73.133750915527514, 17.70736122131359],
          [73.134582519531307, 17.70736122131359],
          [73.134582519531307, 17.707916259765568],
          [73.13486480712902, 17.707916259765568],
          [73.13486480712902, 17.707639694213981],
          [73.135696411132813, 17.707639694213981],
          [73.135696411132813, 17.707916259765568],
          [73.135139465332088, 17.707916259765568],
          [73.135139465332088, 17.708194732665959],
          [73.134857177734489, 17.708190917968807],
          [73.134857177734489, 17.708749771118164],
          [73.134582519531307, 17.708749771118164],
          [73.134582519531307, 17.709304809570312],
          [73.13486480712902, 17.709304809570312],
          [73.13486480712902, 17.709861755371094],
          [73.135139465332088, 17.709861755371094],
          [73.135139465332088, 17.711530685424805],
          [73.135406494140909, 17.711530685424805],
          [73.135406494140909, 17.711811065673771],
          [73.135139465332088, 17.711811065673771],
          [73.135139465332088, 17.712921142578125],
          [73.13486480712902, 17.712917327880973],
          [73.13486480712902, 17.71319389343256],
          [73.134582519531307, 17.713190078735408],
          [73.134582519531307, 17.714860916137695],
          [73.13486480712902, 17.714860916137695],
          [73.13486480712902, 17.715694427490234],
          [73.135139465332088, 17.715690612793082],
          [73.135139465332088, 17.71624946594244],
          [73.134857177734489, 17.71624946594244],
          [73.134857177734489, 17.716529846191406],
          [73.134582519531307, 17.716529846191406],
          [73.134582519531307, 17.716810226440543],
          [73.134307861328068, 17.716810226440543],
          [73.134307861328068, 17.71763992309576],
          [73.134033203125227, 17.71763992309576],
          [73.134033203125227, 17.717920303344727],
          [73.133750915527514, 17.717920303344727],
          [73.133750915527514, 17.718748092651367],
          [73.133468627929744, 17.718748092651367],
          [73.133468627929744, 17.721250534057617],
          [73.133186340332202, 17.721250534057617],
          [73.133186340332202, 17.721809387207145],
          [73.132919311523722, 17.721809387207145],
          [73.132919311523722, 17.722360610961971],
          [73.132637023925781, 17.722360610961971],
          [73.132637023925781, 17.72319412231451],
          [73.13236236572294, 17.72319412231451],
          [73.13236236572294, 17.723472595214901],
          [73.132637023925781, 17.723470687866325],
          [73.132637023925781, 17.724029541015682],
          [73.132919311523722, 17.724029541015682],
          [73.132919311523722, 17.724311828613224],
          [73.13236236572294, 17.724306106567496],
          [73.13236236572294, 17.724582672119254],
          [73.132080078125, 17.724582672119254],
          [73.132080078125, 17.725139617920036],
          [73.131797790527628, 17.725139617920036],
          [73.131797790527628, 17.726249694824219],
          [73.131530761718807, 17.726249694824219],
          [73.131530761718807, 17.726804733276367],
          [73.131805419921989, 17.726804733276367],
          [73.131805419921989, 17.727083206176758],
          [73.131248474121037, 17.727079391479606],
          [73.131248474121037, 17.727920532226676],
          [73.131530761718807, 17.727920532226676],
          [73.131530761718807, 17.728200912475643],
          [73.131248474121037, 17.728200912475643],
          [73.131248474121037, 17.728750228881893],
          [73.130966186523494, 17.728750228881893],
          [73.130966186523494, 17.729310989379826],
          [73.130691528320483, 17.729303359985465],
          [73.130691528320483, 17.729583740234432],
          [73.130416870117244, 17.729579925537109],
          [73.130416870117244, 17.729860305786246],
          [73.12985992431669, 17.729860305786246],
          [73.12985992431669, 17.730140686035213],
          [73.1290283203125, 17.730138778686637],
          [73.1290283203125, 17.730972290039176],
          [73.128738403320597, 17.73097038269043],
          [73.128738403320597, 17.731809616088924],
          [73.128471374511776, 17.731809616088924],
          [73.128471374511776, 17.732641220092887],
          [73.128196716308537, 17.732639312744141],
          [73.128196716308537, 17.733194351196289],
          [73.127906799316463, 17.733190536499137],
          [73.127906799316463, 17.736530303955135],
          [73.128196716308537, 17.736528396606559],
          [73.128196716308537, 17.737361907959098],
          [73.128471374511776, 17.737361907959098],
          [73.128471374511776, 17.737922668457031],
          [73.128196716308537, 17.737916946411133],
          [73.128196716308537, 17.738191604614315],
          [73.127914428710994, 17.738195419311467],
          [73.127914428710994, 17.738473892211857],
          [73.128196716308537, 17.738470077514705],
          [73.128196716308537, 17.738750457763672],
          [73.128471374511776, 17.738750457763672],
          [73.128471374511776, 17.739032745361385],
          [73.128196716308537, 17.739027023315487],
          [73.128196716308537, 17.739582061767635],
          [73.127906799316463, 17.739580154419059],
          [73.127906799316463, 17.740140914916992],
          [73.127639770507983, 17.740139007568416],
          [73.127639770507983, 17.740692138671989],
          [73.127082824707202, 17.740690231323242],
          [73.127082824707202, 17.740980148315487],
          [73.125701904296989, 17.740980148315487],
          [73.125701904296989, 17.741250991821346],
          [73.125419616699276, 17.741250991821346],
          [73.125419616699276, 17.741529464721737],
          [73.124862670898494, 17.741529464721737],
          [73.124862670898494, 17.74263954162609],
          [73.125419616699276, 17.74263954162609],
          [73.125419616699276, 17.742919921875057],
          [73.125694274902628, 17.742914199829102],
          [73.125694274902628, 17.743194580078068],
          [73.125419616699276, 17.743194580078068],
          [73.125419616699276, 17.743473052978459],
          [73.125137329101676, 17.743473052978459],
          [73.125137329101676, 17.744583129882813],
          [73.124862670898494, 17.744581222534237],
          [73.124862670898494, 17.745700836181697],
          [73.124580383300724, 17.745695114135742],
          [73.124580383300724, 17.745971679687557],
          [73.124313354492244, 17.745969772338981],
          [73.124313354492244, 17.746530532836914],
          [73.124031066894702, 17.746528625488338],
          [73.124031066894702, 17.747083663940487],
          [73.123748779296932, 17.747079849243164],
          [73.123748779296932, 17.747919082641658],
          [73.123466491699389, 17.747919082641658],
          [73.123466491699389, 17.751251220703125],
          [73.123748779296932, 17.751251220703125],
          [73.123748779296932, 17.751810073852653],
          [73.124031066894702, 17.751810073852653],
          [73.124031066894702, 17.752639770507869],
          [73.123748779296932, 17.752639770507869],
          [73.123748779296932, 17.752920150756836],
          [73.123474121093921, 17.752916336059684],
          [73.123474121093921, 17.753194808960018],
          [73.123191833496378, 17.753194808960018],
          [73.123191833496378, 17.753471374511832],
          [73.122917175292969, 17.753469467163086],
          [73.122917175292969, 17.753749847412223],
          [73.122642517090128, 17.753749847412223],
          [73.122642517090128, 17.754304885864201],
          [73.122360229492244, 17.754304885864201],
          [73.122360229492244, 17.754861831665153],
          [73.122093200683537, 17.754859924316406],
          [73.122093200683537, 17.755140304565543],
          [73.121803283691463, 17.755140304565543],
          [73.121803283691463, 17.75542068481451],
          [73.121528625488224, 17.75542068481451],
          [73.121528625488224, 17.756250381469727],
          [73.121246337890852, 17.756250381469727],
          [73.121246337890852, 17.756530761718864],
          [73.120971679687671, 17.756526947021541],
          [73.120971679687671, 17.757085800170898],
          [73.120697021484432, 17.757080078125114],
          [73.120697021484432, 17.75736045837408],
          [73.120407104492358, 17.75736045837408],
          [73.120407104492358, 17.757640838623047],
          [73.120140075683878, 17.757638931274471],
          [73.120140075683878, 17.758193969726619],
          [73.119857788085938, 17.758190155029297],
          [73.119857788085938, 17.758750915527401],
          [73.119567871094034, 17.758750915527401],
          [73.119567871094034, 17.759309768676758],
          [73.119308471679744, 17.759307861328182],
          [73.119308471679744, 17.759471893310661],
          [73.119308471679744, 17.760972976684513],
          [73.119026184082145, 17.760969161987362],
          [73.119026184082145, 17.761249542236328],
          [73.119308471679744, 17.761249542236328],
          [73.119308471679744, 17.761808395385856],
          [73.119026184082145, 17.761808395385856],
          [73.119026184082145, 17.762092590332031],
          [73.118751525878963, 17.762092590332031],
          [73.118751525878963, 17.762920379638786],
          [73.118469238281193, 17.762916564941463],
          [73.118469238281193, 17.765693664550724],
          [73.118194580078352, 17.765693664550724],
          [73.118194580078352, 17.765972137451286],
          [73.117637634277401, 17.765970230102539],
          [73.117637634277401, 17.766532897949219],
          [73.117362976074389, 17.76652717590332],
          [73.117362976074389, 17.767082214355469],
          [73.117210388183651, 17.767082214355469],
          [73.117080688476847, 17.767082214355469],
          [73.117080688476847, 17.767562866211051],
          [73.117080688476847, 17.76763916015625],
          [73.116798400879077, 17.767641067504996],
          [73.116798400879077, 17.767919540405387],
          [73.116531372070597, 17.767917633056641],
          [73.116531372070597, 17.768472671508789],
          [73.116249084472656, 17.768470764160213],
          [73.116249084472656, 17.76875114440918],
          [73.116531372070597, 17.768749237060604],
          [73.116531372070597, 17.769582748413143],
          [73.116249084472656, 17.769580841064567],
          [73.116249084472656, 17.769861221313533],
          [73.115692138671932, 17.769861221313533],
          [73.115692138671932, 17.770420074462891],
          [73.115135192871151, 17.770414352416935],
          [73.115142822265852, 17.771249771118278],
          [73.114860534668139, 17.771249771118278],
          [73.114860534668139, 17.772920608520565],
          [73.114585876464901, 17.772920608520565],
          [73.114585876464901, 17.773199081420955],
          [73.114303588867358, 17.773195266723576],
          [73.114303588867358, 17.773471832275391],
          [73.114028930664347, 17.773469924926815],
          [73.114028930664347, 17.774030685424918],
          [73.113761901855469, 17.774030685424918],
          [73.113761901855469, 17.775419235229492],
          [73.113471984863565, 17.775417327880916],
          [73.113471984863565, 17.775972366333065],
          [73.113197326660156, 17.775968551635742],
          [73.113197326660156, 17.776529312133846],
          [73.112922668457145, 17.776529312133846],
          [73.112922668457145, 17.777090072631779],
          [73.113197326660156, 17.777082443237418],
          [73.113197326660156, 17.778194427490178],
          [73.112915039062784, 17.778194427490178],
          [73.112915039062784, 17.779581069946346],
          [73.112640380859432, 17.779581069946346],
          [73.112640380859432, 17.779951095580998],
          [73.112640380859432, 17.780138015747127],
          [73.112503051758097, 17.780138015747127],
          [73.112358093261832, 17.780138015747127],
          [73.112358093261832, 17.780309677124137],
          [73.112358093261832, 17.780971527099666],
          [73.112075805664119, 17.78096961975109],
          [73.112075805664119, 17.781530380249023],
          [73.111808776855639, 17.781530380249023],
          [73.111808776855639, 17.782920837402344],
          [73.11152648925804, 17.782920837402344],
          [73.11152648925804, 17.784309387207088],
          [73.111251831054858, 17.784309387207088],
          [73.111251831054858, 17.785419464111442],
          [73.110969543457088, 17.785419464111442],
          [73.110969543457088, 17.786260604858342],
          [73.110694885254077, 17.786247253418082],
          [73.110694885254077, 17.787082672119197],
          [73.110420227051065, 17.787080764770621],
          [73.110420227051065, 17.787639617919979],
          [73.110137939453125, 17.787639617919979],
          [73.110137939453125, 17.787918090820369],
          [73.109863281250284, 17.787916183471793],
          [73.109863281250284, 17.788194656372127],
          [73.109580993652401, 17.788194656372127],
          [73.109580993652401, 17.788473129272518],
          [73.109863281250284, 17.788471221923942],
          [73.109863281250284, 17.789030075073299],
          [73.110137939453125, 17.789030075073299],
          [73.110137939453125, 17.788749694824332],
          [73.110420227051065, 17.788749694824332],
          [73.110420227051065, 17.788471221923942],
          [73.110969543457088, 17.788473129272518],
          [73.110969543457088, 17.787916183471793],
          [73.111251831054858, 17.787918090820369],
          [73.111251831054858, 17.787639617919979],
          [73.110694885254077, 17.787639617919979],
          [73.110694885254077, 17.787361145019588],
          [73.110969543457088, 17.787361145019588],
          [73.110969543457088, 17.787080764770621],
          [73.111251831054858, 17.787082672119197],
          [73.111251831054858, 17.78680610656744],
          [73.112358093261832, 17.786809921264762],
          [73.112358093261832, 17.787361145019588],
          [73.112083435058651, 17.787361145019588],
          [73.112083435058651, 17.788194656372127],
          [73.111808776855639, 17.788190841674805],
          [73.111808776855639, 17.789030075073299],
          [73.112083435058651, 17.789028167724723],
          [73.112083435058651, 17.789583206176701],
          [73.111251831054858, 17.789583206176701],
          [73.111251831054858, 17.789861679077262],
          [73.110969543457088, 17.789861679077262],
          [73.110969543457088, 17.790140151977653],
          [73.109016418457088, 17.790140151977653],
          [73.109016418457088, 17.790420532226619],
          [73.108467102051009, 17.790420532226619],
          [73.108467102051009, 17.790702819824219],
          [73.108192443847827, 17.790695190429631],
          [73.108192443847827, 17.790971755981445],
          [73.107917785644588, 17.790971755981445],
          [73.107917785644588, 17.791250228881836],
          [73.107627868652514, 17.791250228881836],
          [73.107627868652514, 17.791812896728572],
          [73.107360839844034, 17.791805267333984],
          [73.107360839844034, 17.792083740234375],
          [73.107086181640625, 17.792068481445313],
          [73.107086181640625, 17.792640686035156],
          [73.106803894043253, 17.79263877868658],
          [73.106803894043253, 17.793193817138729],
          [73.106529235839901, 17.793193817138729],
          [73.106529235839901, 17.793472290039119],
          [73.106246948242301, 17.793470382690543],
          [73.106246948242301, 17.79375076293951],
          [73.105972290039119, 17.79375076293951],
          [73.105972290039119, 17.794860839843864],
          [73.105697631835881, 17.794860839843864],
          [73.105697631835881, 17.795139312744254],
          [73.105140686035327, 17.79512977600092],
          [73.105140686035327, 17.795419692993221],
          [73.104858398437557, 17.795415878295842],
          [73.104858398437557, 17.795972824096623],
          [73.105140686035327, 17.795970916748047],
          [73.105140686035327, 17.796529769897575],
          [73.104858398437557, 17.796527862548828],
          [73.104858398437557, 17.797082901000977],
          [73.104568481445483, 17.797080993652401],
          [73.104568481445483, 17.797639846801758],
          [73.104309082031534, 17.797639846801758],
          [73.104309082031534, 17.798200607299862],
          [73.104026794433594, 17.798196792602539],
          [73.104026794433594, 17.798471450805721],
          [73.103469848632812, 17.798471450805721],
          [73.103469848632812, 17.799861907959041],
          [73.103752136230753, 17.799858093261719],
          [73.103752136230753, 17.800420761108398],
          [73.103469848632812, 17.800418853759822],
          [73.103469848632812, 17.800971984863395],
          [73.103202819824332, 17.800968170166072],
          [73.103202819824332, 17.802919387817496],
          [73.102638244628849, 17.80291748046875],
          [73.102638244628849, 17.803194046020508],
          [73.102363586426009, 17.803194046020508],
          [73.102363586426009, 17.803472518920898],
          [73.101821899414347, 17.803470611572322],
          [73.101821899414347, 17.803752899169865],
          [73.101249694824503, 17.803752899169865],
          [73.101249694824503, 17.803188323974553],
          [73.100692749023722, 17.803194046020508],
          [73.100692749023722, 17.803472518920898],
          [73.100418090820313, 17.803470611572322],
          [73.100418090820313, 17.804861068725643],
          [73.100692749023722, 17.804861068725643],
          [73.100692749023722, 17.805694580078182],
          [73.100418090820313, 17.805694580078182],
          [73.100418090820313, 17.805971145629996],
          [73.10013580322294, 17.805971145629996],
          [73.10013580322294, 17.806249618530387],
          [73.099861145019588, 17.806249618530387],
          [73.099861145019588, 17.806529998779354],
          [73.099586486816349, 17.806528091430778],
          [73.099586486816349, 17.806804656982365],
          [73.099304199218807, 17.806804656982365],
          [73.099304199218807, 17.807083129882756],
          [73.098747253418196, 17.807083129882756],
          [73.098747253418196, 17.807361602783317],
          [73.098472595215014, 17.80735969543457],
          [73.098472595215014, 17.807920455932674],
          [73.096252441406307, 17.807920455932674],
          [73.096252441406307, 17.808750152587891],
          [73.096527099609489, 17.808750152587891],
          [73.096527099609489, 17.810140609741211],
          [73.096252441406307, 17.810140609741211],
          [73.096252441406307, 17.810420989990178],
          [73.095970153808537, 17.810415267944393],
          [73.095970153808537, 17.810693740844783],
          [73.095695495605696, 17.810693740844783],
          [73.095695495605696, 17.810972213745174],
          [73.094856262207202, 17.810970306396598],
          [73.094856262207202, 17.811250686645565],
          [73.094306945800781, 17.811250686645565],
          [73.094306945800781, 17.811531066894531],
          [73.091796875000171, 17.811531066894531],
          [73.091796875000171, 17.811809539794922],
          [73.090415954589957, 17.811809539794922],
          [73.090415954589957, 17.811531066894531],
          [73.090141296386776, 17.811531066894531],
          [73.090141296386776, 17.810987472534237],
          [73.089859008789006, 17.810970306396598],
          [73.089859008789006, 17.810415267944393],
          [73.089591979980696, 17.810420989990178],
          [73.089591979980696, 17.809860229492244],
          [73.089302062988452, 17.809860229492244],
          [73.089302062988452, 17.809310913085994],
          [73.089591979980696, 17.809310913085994],
          [73.089591979980696, 17.809030532837028],
          [73.089859008789006, 17.809030532837028],
          [73.089859008789006, 17.808469772338924],
          [73.089584350586165, 17.8084716796875],
          [73.089584350586165, 17.808193206787109],
          [73.089302062988452, 17.808200836181641],
          [73.089302062988452, 17.807920455932674],
          [73.088752746582202, 17.807920455932674],
          [73.088752746582202, 17.808200836181641],
          [73.088470458984659, 17.808200836181641],
          [73.088470458984659, 17.809310913085994],
          [73.088752746582202, 17.809303283691463],
          [73.088752746582202, 17.810693740844783],
          [73.089027404785213, 17.810689926147461],
          [73.089027404785213, 17.811809539794922],
          [73.088752746582202, 17.811809539794922],
          [73.088752746582202, 17.812360763549918],
          [73.089027404785213, 17.812360763549918],
          [73.089027404785213, 17.812919616699276],
          [73.089187622070369, 17.812919616699276],
          [73.089591979980696, 17.812919616699276],
          [73.089591979980696, 17.813198089599666],
          [73.089859008789006, 17.813198089599666],
          [73.089859008789006, 17.812919616699276],
          [73.090698242187557, 17.812919616699276],
          [73.090698242187557, 17.813198089599666],
          [73.090972900390909, 17.813198089599666],
          [73.090972900390909, 17.814029693603629],
          [73.090698242187557, 17.814029693603629],
          [73.090698242187557, 17.81430816650402],
          [73.090415954589957, 17.814306259155273],
          [73.090415954589957, 17.814582824707031],
          [73.090141296386776, 17.814582824707031],
          [73.090141296386776, 17.814861297607422],
          [73.089302062988452, 17.814861297607422],
          [73.089302062988452, 17.815694808959961],
          [73.089027404785213, 17.815694808959961],
          [73.089027404785213, 17.815971374511776],
          [73.089302062988452, 17.815971374511776],
          [73.089302062988452, 17.816259384155273],
          [73.089591979980696, 17.816259384155273],
          [73.089591979980696, 17.816530227661133],
          [73.090141296386776, 17.816528320312557],
          [73.090141296386776, 17.816804885864315],
          [73.092636108398665, 17.816804885864315],
          [73.092636108398665, 17.817083358764705],
          [73.093193054199276, 17.817083358764705],
          [73.093193054199276, 17.817361831665096],
          [73.093482971191349, 17.817361831665096],
          [73.093482971191349, 17.81820106506342],
          [73.093193054199276, 17.81820106506342],
          [73.093193054199276, 17.81875038146984],
          [73.092918395996037, 17.81875038146984],
          [73.092918395996037, 17.819583892822209],
          [73.093193054199276, 17.819580078125057],
          [73.093193054199276, 17.820140838623161],
          [73.093750000000057, 17.820140838623161],
          [73.093750000000057, 17.820421218872127],
          [73.094024658203409, 17.820417404174805],
          [73.094024658203409, 17.820692062377987],
          [73.09458160400419, 17.820692062377987],
          [73.09458160400419, 17.820972442626953],
          [73.094856262207202, 17.820970535278377],
          [73.094856262207202, 17.821529388427734],
          [73.09458160400419, 17.821529388427734],
          [73.09458160400419, 17.821809768676871],
          [73.094306945800781, 17.821804046630916],
          [73.094306945800781, 17.822082519531307],
          [73.09458160400419, 17.822080612182731],
          [73.09458160400419, 17.822639465332088],
          [73.094306945800781, 17.822639465332088],
          [73.094306945800781, 17.822919845581055],
          [73.09458160400419, 17.822919845581055],
          [73.09458160400419, 17.823749542236442],
          [73.094856262207202, 17.823749542236442],
          [73.094856262207202, 17.824029922485408],
          [73.09458160400419, 17.824029922485408],
          [73.09458160400419, 17.825139999389762],
          [73.094306945800781, 17.825139999389762],
          [73.094306945800781, 17.826248168945369],
          [73.094024658203409, 17.826248168945369],
          [73.094024658203409, 17.827083587646484],
          [73.093750000000057, 17.827079772949332],
          [73.093750000000057, 17.827640533447266],
          [73.093475341796989, 17.827640533447266],
          [73.093475341796989, 17.828193664550838],
          [73.093193054199276, 17.828180313110352],
          [73.093193054199276, 17.828750610351619],
          [73.092918395996037, 17.828750610351619],
          [73.092918395996037, 17.829309463500977],
          [73.092636108398665, 17.829305648803825],
          [73.092636108398665, 17.829584121704158],
          [73.092361450195483, 17.82957839965826],
          [73.092361450195483, 17.830139160156364],
          [73.092086791992244, 17.830139160156364],
          [73.092086791992244, 17.830972671508732],
          [73.092361450195483, 17.830972671508732],
          [73.092361450195483, 17.831249237060547],
          [73.092086791992244, 17.831241607666016],
          [73.092086791992244, 17.831811904907227],
          [73.091796875000171, 17.831811904907227],
          [73.091796875000171, 17.832361221313477],
          [73.09152984619169, 17.832361221313477],
          [73.09152984619169, 17.833194732666016],
          [73.090415954589957, 17.83319282531744],
          [73.090415954589957, 17.833749771118221],
          [73.090141296386776, 17.833749771118221],
          [73.090141296386776, 17.834304809570369],
          [73.089431762695597, 17.834304809570369],
          [73.088752746582202, 17.834304809570369],
          [73.088752746582202, 17.835111618041992],
          [73.088752746582202, 17.835420608520508],
          [73.089591979980696, 17.835420608520508],
          [73.089591979980696, 17.835700988769474],
          [73.089302062988452, 17.835693359374943],
          [73.089302062988452, 17.835971832275504],
          [73.089027404785213, 17.835969924926758],
          [73.089027404785213, 17.836250305175895],
          [73.088752746582202, 17.836250305175895],
          [73.088752746582202, 17.836530685424862],
          [73.088470458984659, 17.836530685424862],
          [73.088470458984659, 17.836811065673828],
          [73.08819580078125, 17.836805343627873],
          [73.08819580078125, 17.837083816528263],
          [73.088050842285213, 17.837081909179688],
          [73.087905883789347, 17.837080001831112],
          [73.087905883789347, 17.837369918823185],
          [73.087638854980469, 17.837360382080078],
          [73.087638854980469, 17.838193893432617],
          [73.087356567383097, 17.838190078735465],
          [73.087356567383097, 17.838750839233398],
          [73.087638854980469, 17.838750839233398],
          [73.087638854980469, 17.839031219482365],
          [73.08819580078125, 17.83902549743658],
          [73.08819580078125, 17.83961105346674],
          [73.08819580078125, 17.840139389038143],
          [73.088470458984659, 17.840139389038143],
          [73.088470458984659, 17.840694427490291],
          [73.088752746582202, 17.840694427490291],
          [73.088752746582202, 17.840972900390682],
          [73.089027404785213, 17.840969085693359],
          [73.089027404785213, 17.84124755859375],
          [73.089302062988452, 17.84124755859375],
          [73.089302062988452, 17.841529846191463],
          [73.089859008789006, 17.841529846191463],
          [73.089859008789006, 17.84124755859375],
          [73.090698242187557, 17.84124755859375],
          [73.090698242187557, 17.841529846191463],
          [73.092628479003963, 17.841529846191463],
          [73.092628479003963, 17.841808319091854],
          [73.093750000000057, 17.841808319091854],
          [73.093750000000057, 17.841529846191463],
          [73.094856262207202, 17.841529846191463],
          [73.094856262207202, 17.840969085693359],
          [73.095970153808537, 17.840969085693359],
          [73.095970153808537, 17.84124755859375],
          [73.096527099609489, 17.84124755859375],
          [73.096527099609489, 17.841529846191463],
          [73.097076416015909, 17.841529846191463],
          [73.097076416015909, 17.84124755859375],
          [73.097358703613281, 17.84124755859375],
          [73.097358703613281, 17.840969085693359],
          [73.098747253418196, 17.840972900390682],
          [73.098747253418196, 17.840694427490291],
          [73.099304199218807, 17.840694427490291],
          [73.099304199218807, 17.840417861938533],
          [73.100982666015625, 17.840429306030217],
          [73.100982666015625, 17.840139389038143],
          [73.102912902832088, 17.840139389038143],
          [73.102912902832088, 17.839860916137752],
          [73.103469848632812, 17.839860916137752],
          [73.103469848632812, 17.839580535888786],
          [73.103752136230753, 17.839582443237362],
          [73.103752136230753, 17.83902549743658],
          [73.105140686035327, 17.839031219482365],
          [73.105140686035327, 17.838750839233398],
          [73.105697631835881, 17.838750839233398],
          [73.105697631835881, 17.838470458984432],
          [73.105972290039119, 17.838472366333008],
          [73.105972290039119, 17.837915420532227],
          [73.106796264648722, 17.837921142578182],
          [73.106796264648722, 17.837640762329215],
          [73.107086181640625, 17.837640762329215],
          [73.107086181640625, 17.837369918823185],
          [73.107360839844034, 17.837369918823185],
          [73.107360839844034, 17.837080001831112],
          [73.107635498047046, 17.837083816528263],
          [73.107635498047046, 17.836805343627873],
          [73.107917785644588, 17.836811065673828],
          [73.107917785644588, 17.836530685424862],
          [73.108192443847827, 17.836530685424862],
          [73.108192443847827, 17.836250305175895],
          [73.108467102051009, 17.836250305175895],
          [73.108467102051009, 17.835969924926758],
          [73.108749389648381, 17.835971832275504],
          [73.108749389648381, 17.835693359374943],
          [73.109306335449332, 17.835700988769474],
          [73.109306335449332, 17.835420608520508],
          [73.109580993652401, 17.835420608520508],
          [73.109580993652401, 17.835140228271541],
          [73.109863281250284, 17.835140228271541],
          [73.109863281250284, 17.834859848022575],
          [73.111251831054858, 17.834861755371151],
          [73.111251831054858, 17.83458328247076],
          [73.112915039062784, 17.83458328247076],
          [73.112915039062784, 17.834304809570369],
          [73.114028930664347, 17.834304809570369],
          [73.114028930664347, 17.834028244018612],
          [73.114585876464901, 17.834030151367188],
          [73.114585876464901, 17.833749771118221],
          [73.114860534668139, 17.833749771118221],
          [73.114860534668139, 17.833469390869254],
          [73.117080688476847, 17.833469390869254],
          [73.117080688476847, 17.833749771118221],
          [73.118194580078352, 17.833749771118221],
          [73.118194580078352, 17.834304809570369],
          [73.119583129883097, 17.834304809570369],
          [73.119583129883097, 17.83458328247076],
          [73.119857788085938, 17.83458328247076],
          [73.119857788085938, 17.834861755371151],
          [73.120140075683878, 17.834859848022575],
          [73.120140075683878, 17.835140228271541],
          [73.120697021484432, 17.835140228271541],
          [73.120697021484432, 17.835420608520508],
          [73.122917175292969, 17.835420608520508],
          [73.122917175292969, 17.835700988769474],
          [73.124305725097884, 17.835693359374943],
          [73.124305725097884, 17.835971832275504],
          [73.124862670898494, 17.835971832275504],
          [73.124862670898494, 17.835416793823356],
          [73.125137329101676, 17.835420608520508],
          [73.125137329101676, 17.835140228271541],
          [73.125701904296989, 17.835140228271541],
          [73.125701904296989, 17.834859848022575],
          [73.126251220703409, 17.834861755371151],
          [73.126251220703409, 17.83458328247076],
          [73.126525878906421, 17.83458328247076],
          [73.126525878906421, 17.834304809570369],
          [73.127082824707202, 17.834304809570369],
          [73.127082824707202, 17.834028244018612],
          [73.127357482910384, 17.834030151367188],
          [73.127357482910384, 17.833749771118221],
          [73.128471374511776, 17.833749771118221],
          [73.128471374511776, 17.833469390869254],
          [73.1290283203125, 17.83347129821783],
          [73.1290283203125, 17.833194732666016],
          [73.129302978515909, 17.833194732666016],
          [73.129302978515909, 17.832639694213867],
          [73.129592895507813, 17.832639694213867],
          [73.129585266113281, 17.832361221313477],
          [73.12985992431669, 17.832361221313477],
          [73.12985992431669, 17.831811904907227],
          [73.130142211914233, 17.831811904907227],
          [73.130142211914233, 17.831529617309684],
          [73.130416870117244, 17.831529617309684],
          [73.130416870117244, 17.830972671508732],
          [73.130691528320483, 17.830972671508732],
          [73.130691528320483, 17.830415725707951],
          [73.130966186523494, 17.83041954040533],
          [73.130966186523494, 17.829860687255973],
          [73.131248474121037, 17.829860687255973],
          [73.131248474121037, 17.829309463500977],
          [73.131530761718807, 17.829309463500977],
          [73.131530761718807, 17.828750610351619],
          [73.131797790527628, 17.828750610351619],
          [73.131797790527628, 17.828180313110352],
          [73.132080078125, 17.828193664550838],
          [73.132080078125, 17.827640533447266],
          [73.13236236572294, 17.827640533447266],
          [73.13236236572294, 17.825429916381893],
          [73.132637023925781, 17.825429916381893],
          [73.132637023925781, 17.825139999389762],
          [73.132919311523722, 17.825139999389762],
          [73.132919311523722, 17.824859619140625],
          [73.133193969726733, 17.824861526489371],
          [73.133193969726733, 17.82458305358881],
          [73.134033203125227, 17.824581146240234],
          [73.134033203125227, 17.825139999389762],
          [73.133750915527514, 17.825139999389762],
          [73.133750915527514, 17.825429916381893],
          [73.133468627929744, 17.825418472290153],
          [73.133468627929744, 17.825971603393555],
          [73.133186340332202, 17.825969696044979],
          [73.133186340332202, 17.827640533447266],
          [73.132919311523722, 17.827640533447266],
          [73.132919311523722, 17.82902908325201],
          [73.132637023925781, 17.82902908325201],
          [73.132637023925781, 17.830139160156364],
          [73.13236236572294, 17.830139160156364],
          [73.13236236572294, 17.830694198608342],
          [73.131805419921989, 17.830694198608342],
          [73.131805419921989, 17.830972671508732],
          [73.131530761718807, 17.830972671508732],
          [73.131530761718807, 17.831811904907227],
          [73.131248474121037, 17.831811904907227],
          [73.131248474121037, 17.832361221313477],
          [73.130966186523494, 17.832361221313477],
          [73.130966186523494, 17.832639694213867],
          [73.130691528320483, 17.832639694213867],
          [73.130691528320483, 17.832920074463004],
          [73.130416870117244, 17.832916259765682],
          [73.130416870117244, 17.833194732666016],
          [73.12985992431669, 17.833194732666016],
          [73.12985992431669, 17.83347129821783],
          [73.129585266113281, 17.83347129821783],
          [73.129592895507813, 17.833749771118221],
          [73.129302978515909, 17.833749771118221],
          [73.129302978515909, 17.834304809570369],
          [73.1290283203125, 17.834304809570369],
          [73.1290283203125, 17.83458328247076],
          [73.128753662109489, 17.83458328247076],
          [73.128753662109489, 17.834861755371151],
          [73.128196716308537, 17.834859848022575],
          [73.128196716308537, 17.835140228271541],
          [73.127639770507983, 17.835140228271541],
          [73.127639770507983, 17.835420608520508],
          [73.127082824707202, 17.835420608520508],
          [73.127082824707202, 17.835700988769474],
          [73.126525878906421, 17.835693359374943],
          [73.126525878906421, 17.835971832275504],
          [73.126251220703409, 17.835969924926758],
          [73.126251220703409, 17.836250305175895],
          [73.125701904296989, 17.836250305175895],
          [73.125701904296989, 17.836530685424862],
          [73.125137329101676, 17.836530685424862],
          [73.125137329101676, 17.836811065673828],
          [73.123466491699389, 17.836811065673828],
          [73.123466491699389, 17.836530685424862],
          [73.122642517090128, 17.836530685424862],
          [73.122642517090128, 17.836250305175895],
          [73.121528625488224, 17.836250305175895],
          [73.121528625488224, 17.835969924926758],
          [73.120697021484432, 17.835971832275504],
          [73.120697021484432, 17.835693359374943],
          [73.119857788085938, 17.835700988769474],
          [73.119857788085938, 17.835420608520508],
          [73.118751525878963, 17.835420608520508],
          [73.118751525878963, 17.835140228271541],
          [73.117919921875171, 17.835140228271541],
          [73.117919921875171, 17.834859848022575],
          [73.115692138671932, 17.834861755371151],
          [73.115692138671932, 17.83458328247076],
          [73.114028930664347, 17.83458328247076],
          [73.114028930664347, 17.834861755371151],
          [73.113471984863565, 17.834859848022575],
          [73.113471984863565, 17.835140228271541],
          [73.113197326660156, 17.835140228271541],
          [73.113197326660156, 17.835420608520508],
          [73.112640380859432, 17.835420608520508],
          [73.112640380859432, 17.835700988769474],
          [73.112083435058651, 17.835693359374943],
          [73.112083435058651, 17.835971832275504],
          [73.111808776855639, 17.835969924926758],
          [73.111808776855639, 17.836250305175895],
          [73.111251831054858, 17.836250305175895],
          [73.111251831054858, 17.836530685424862],
          [73.110969543457088, 17.836530685424862],
          [73.110969543457088, 17.836811065673828],
          [73.110420227051065, 17.836805343627873],
          [73.110420227051065, 17.837083816528263],
          [73.110137939453125, 17.837080001831112],
          [73.110137939453125, 17.837369918823185],
          [73.109580993652401, 17.837369918823185],
          [73.109580993652401, 17.837640762329215],
          [73.109306335449332, 17.837640762329215],
          [73.109306335449332, 17.837921142578182],
          [73.108749389648381, 17.837915420532227],
          [73.108749389648381, 17.838193893432617],
          [73.10847473144554, 17.838193893432617],
          [73.10847473144554, 17.838472366333008],
          [73.107917785644588, 17.838470458984432],
          [73.107917785644588, 17.838750839233398],
          [73.107627868652514, 17.838750839233398],
          [73.107627868652514, 17.839031219482365],
          [73.107086181640625, 17.83902549743658],
          [73.107086181640625, 17.839582443237362],
          [73.106796264648722, 17.839580535888786],
          [73.106796264648722, 17.839860916137752],
          [73.106246948242301, 17.839860916137752],
          [73.106246948242301, 17.840139389038143],
          [73.105972290039119, 17.840139389038143],
          [73.105972290039119, 17.840429306030217],
          [73.105697631835881, 17.840417861938533],
          [73.105697631835881, 17.840694427490291],
          [73.104858398437557, 17.840694427490291],
          [73.104858398437557, 17.840972900390682],
          [73.103752136230753, 17.840969085693359],
          [73.103752136230753, 17.84124755859375],
          [73.101821899414347, 17.84124755859375],
          [73.101821899414347, 17.841529846191463],
          [73.100982666015625, 17.841529846191463],
          [73.100982666015625, 17.841808319091854],
          [73.100418090820313, 17.841806411743278],
          [73.100418090820313, 17.842082977294865],
          [73.099586486816349, 17.842082977294865],
          [73.099586486816349, 17.842361450195426],
          [73.099029541015796, 17.842361450195426],
          [73.099029541015796, 17.842641830444393],
          [73.097076416015909, 17.842641830444393],
          [73.097076416015909, 17.842920303344783],
          [73.096809387207088, 17.842920303344783],
          [73.096809387207088, 17.844030380249137],
          [73.09708404541044, 17.844028472900391],
          [73.09708404541044, 17.844583511352539],
          [73.098747253418196, 17.844583511352539],
          [73.098747253418196, 17.844305038452148],
          [73.099586486816349, 17.844312667846737],
          [73.099586486816349, 17.844030380249137],
          [73.100418090820313, 17.844030380249137],
          [73.100418090820313, 17.843751907348576],
          [73.100982666015625, 17.843751907348576],
          [73.100975036621094, 17.843471527099609],
          [73.101524353027514, 17.843471527099609],
          [73.101524353027514, 17.843194961547795],
          [73.102638244628849, 17.843202590942383],
          [73.102638244628849, 17.844030380249137],
          [73.102355957031307, 17.844030380249137],
          [73.102355957031307, 17.844312667846737],
          [73.101806640625057, 17.844305038452148],
          [73.101806640625057, 17.844583511352539],
          [73.100692749023722, 17.844583511352539],
          [73.100692749023722, 17.844860076904354],
          [73.099861145019588, 17.844860076904354],
          [73.099861145019588, 17.84514045715332],
          [73.098197937012003, 17.84514045715332],
          [73.098197937012003, 17.84542274475109],
          [73.09708404541044, 17.845417022705135],
          [73.09708404541044, 17.845693588256893],
          [73.096527099609489, 17.845693588256893],
          [73.096527099609489, 17.845417022705135],
          [73.095138549804744, 17.845417022705135],
          [73.095138549804744, 17.845693588256893],
          [73.09458160400419, 17.845693588256893],
          [73.09458160400419, 17.845417022705135],
          [73.094306945800781, 17.84542274475109],
          [73.094306945800781, 17.84514045715332],
          [73.093750000000057, 17.84514045715332],
          [73.093750000000057, 17.844581604003963],
          [73.093475341796989, 17.844583511352539],
          [73.093475341796989, 17.844305038452148],
          [73.093193054199276, 17.844312667846737],
          [73.093193054199276, 17.843751907348576],
          [73.092628479003963, 17.843751907348576],
          [73.092628479003963, 17.843471527099609],
          [73.090972900390909, 17.843471527099609],
          [73.090972900390909, 17.843751907348576],
          [73.090415954589957, 17.843751907348576],
          [73.090415954589957, 17.844030380249137],
          [73.090141296386776, 17.844030380249137],
          [73.090141296386776, 17.844312667846737],
          [73.089859008789006, 17.844305038452148],
          [73.089859008789006, 17.844583511352539],
          [73.089584350586165, 17.844583511352539],
          [73.089584350586165, 17.844860076904354],
          [73.089302062988452, 17.844860076904354],
          [73.089302062988452, 17.84514045715332],
          [73.089027404785213, 17.84514045715332],
          [73.089027404785213, 17.84542274475109],
          [73.088752746582202, 17.845417022705135],
          [73.088752746582202, 17.845693588256893],
          [73.088470458984659, 17.845693588256893],
          [73.088470458984659, 17.845972061157283],
          [73.08819580078125, 17.845970153808707],
          [73.08819580078125, 17.846530914306641],
          [73.087913513183878, 17.846527099609489],
          [73.087913513183878, 17.847082138061637],
          [73.087638854980469, 17.847080230712891],
          [73.087638854980469, 17.847360610962028],
          [73.087364196777457, 17.847360610962028],
          [73.087364196777457, 17.848472595214787],
          [73.087081909179744, 17.848470687866211],
          [73.087081909179744, 17.848751068115348],
          [73.086822509765796, 17.848751068115348],
          [73.086822509765796, 17.849309921264705],
          [73.086524963378963, 17.84930419921875],
          [73.086524963378963, 17.849582672119141],
          [73.086250305175952, 17.849580764770565],
          [73.086250305175952, 17.850139617919922],
          [73.085975646972713, 17.850139617919922],
          [73.085975646972713, 17.85069465637207],
          [73.085693359375171, 17.850690841674918],
          [73.085693359375171, 17.851530075073242],
          [73.085418701172159, 17.851530075073242],
          [73.085418701172159, 17.852371215820369],
          [73.085136413574389, 17.852371215820369],
          [73.085136413574389, 17.854030609130916],
          [73.084861755371378, 17.85402870178234],
          [73.084861755371378, 17.855972290039063],
          [73.084587097167969, 17.855968475341911],
          [73.084587097167969, 17.856529235839844],
          [73.084304809570597, 17.856527328491268],
          [73.084304809570597, 17.857084274291992],
          [73.084030151367244, 17.857084274291992],
          [73.084030151367244, 17.858472824096737],
          [73.083747863769645, 17.858472824096737],
          [73.083747863769645, 17.858749389648551],
          [73.083457946777401, 17.858749389648551],
          [73.083457946777401, 17.859029769897518],
          [73.082077026367358, 17.859029769897518],
          [73.082077026367358, 17.859310150146484],
          [73.081802368164347, 17.859306335449332],
          [73.081802368164347, 17.85958290100092],
          [73.081527709960937, 17.85958290100092],
          [73.081527709960937, 17.859861373901481],
          [73.081253051758097, 17.859859466552734],
          [73.081253051758097, 17.860139846801871],
          [73.080970764160213, 17.860139846801871],
          [73.080970764160213, 17.860694885253849],
          [73.080688476562614, 17.860691070556697],
          [73.080688476562614, 17.861249923706055],
          [73.080413818359432, 17.861249923706055],
          [73.080413818359432, 17.862083435058594],
          [73.080139160156193, 17.862083435058594],
          [73.080139160156193, 17.862390518188533],
          [73.080139160156193, 17.862920761108342],
          [73.080413818359432, 17.86291694641119],
          [73.080413818359432, 17.863193511962947],
          [73.080696105957145, 17.863193511962947],
          [73.080696105957145, 17.863471984863338],
          [73.080970764160213, 17.863470077514762],
          [73.080970764160213, 17.863750457763729],
          [73.081253051758097, 17.863750457763729],
          [73.081253051758097, 17.864030838012695],
          [73.081527709960937, 17.864030838012695],
          [73.081527709960937, 17.864311218261662],
          [73.081802368164347, 17.864305496215934],
          [73.081802368164347, 17.864585876464901],
          [73.081527709960937, 17.864580154418945],
          [73.081527709960937, 17.86541938781744],
          [73.081253051758097, 17.86541938781744],
          [73.081253051758097, 17.866250991821403],
          [73.080970764160213, 17.866250991821403],
          [73.080970764160213, 17.866529464721793],
          [73.080688476562614, 17.866529464721793],
          [73.080688476562614, 17.867639541625977],
          [73.080398559570369, 17.867639541625977],
          [73.080398559570369, 17.867919921875114],
          [73.080139160156193, 17.867916107177791],
          [73.080139160156193, 17.868473052978516],
          [73.079856872558821, 17.868469238281364],
          [73.079856872558821, 17.869031906127873],
          [73.079582214355639, 17.869028091430721],
          [73.079582214355639, 17.869304656982479],
          [73.079307556152401, 17.869300842285156],
          [73.079307556152401, 17.870140075683651],
          [73.078750610351847, 17.870138168335075],
          [73.078750610351847, 17.870416641235465],
          [73.078475952148438, 17.87041091918951],
          [73.078475952148438, 17.870702743530387],
          [73.078193664551065, 17.870695114135856],
          [73.078193664551065, 17.870971679687614],
          [73.077919006347713, 17.870971679687614],
          [73.077919006347713, 17.871250152588004],
          [73.077651977539006, 17.871250152588004],
          [73.077651977539006, 17.871530532836971],
          [73.077079772949162, 17.871530532836971],
          [73.077079772949162, 17.87181282043457],
          [73.076805114746321, 17.871805191039982],
          [73.076805114746321, 17.872083663940373],
          [73.076248168945369, 17.872083663940373],
          [73.076248168945369, 17.873193740844727],
          [73.075965881347827, 17.873191833496151],
          [73.075965881347827, 17.874031066894474],
          [73.075691223144815, 17.874031066894474],
          [73.075691223144815, 17.874309539795036],
          [73.075416564941406, 17.874309539795036],
          [73.075416564941406, 17.874860763549862],
          [73.075141906738565, 17.874860763549862],
          [73.075141906738565, 17.877952575683651],
          [73.075141906738565, 17.879583358764648],
          [73.074859619140625, 17.879579544067496],
          [73.074859619140625, 17.880420684814396],
          [73.074584960937614, 17.88041877746582],
          [73.074584960937614, 17.882083892822322],
          [73.074302673339901, 17.882078170776424],
          [73.074302673339901, 17.882919311523494],
          [73.073753356933821, 17.882917404174918],
          [73.073753356933821, 17.883193969726506],
          [73.073471069336108, 17.883188247680778],
          [73.073471069336108, 17.884029388427848],
          [73.073196411132869, 17.884029388427848],
          [73.073196411132869, 17.884862899780217],
          [73.072906494140796, 17.884862899780217],
          [73.072906494140796, 17.885419845581168],
          [73.072639465332315, 17.885419845581168],
          [73.072639465332315, 17.886810302734318],
          [73.072357177734546, 17.886810302734318],
          [73.072357177734546, 17.887639999389705],
          [73.072082519531534, 17.887639999389705],
          [73.072082519531534, 17.888200759887638],
          [73.071807861328125, 17.888200759887638],
          [73.071807861328125, 17.888481140136832],
          [73.071517944336222, 17.888481140136832],
          [73.071517944336222, 17.888750076294059],
          [73.071250915527401, 17.888750076294059],
          [73.071250915527401, 17.890420913696346],
          [73.071517944336222, 17.890420913696346],
          [73.071517944336222, 17.89180946350109],
          [73.071807861328125, 17.891807556152344],
          [73.071807861328125, 17.893194198608455],
          [73.072082519531534, 17.893190383911133],
          [73.072082519531534, 17.894029617309627],
          [73.072364807128906, 17.894029617309627],
          [73.072364807128906, 17.894582748413029],
          [73.072906494140796, 17.894580841064453],
          [73.072906494140796, 17.89486122131359],
          [73.073196411132869, 17.89486122131359],
          [73.073196411132869, 17.895139694213981],
          [73.073753356933821, 17.895139694213981],
          [73.073753356933821, 17.895418167114371],
          [73.074302673339901, 17.895416259765625],
          [73.074302673339901, 17.895694732665959],
          [73.074584960937614, 17.895694732665959],
          [73.074584960937614, 17.895971298217773],
          [73.075416564941406, 17.895971298217773],
          [73.075416564941406, 17.89625167846674],
          [73.075973510742358, 17.89625167846674],
          [73.075973510742358, 17.896804809570312],
          [73.074859619140625, 17.896804809570312],
          [73.074859619140625, 17.897083282470703],
          [73.074584960937614, 17.897083282470703],
          [73.074584960937614, 17.896528244018555],
          [73.074302673339901, 17.896530151367301],
          [73.074302673339901, 17.89625167846674],
          [73.074028015136662, 17.89625167846674],
          [73.074028015136662, 17.895971298217773],
          [73.073753356933821, 17.895971298217773],
          [73.073753356933821, 17.895694732665959],
          [73.073196411132869, 17.895694732665959],
          [73.073196411132869, 17.895416259765625],
          [73.072906494140796, 17.895418167114371],
          [73.072906494140796, 17.895139694213981],
          [73.072639465332315, 17.895139694213981],
          [73.072639465332315, 17.89486122131359],
          [73.071250915527401, 17.89486122131359],
          [73.071250915527401, 17.894308090210018],
          [73.070968627929801, 17.894308090210018],
          [73.070968627929801, 17.894029617309627],
          [73.071250915527401, 17.894029617309627],
          [73.071250915527401, 17.89347076416027],
          [73.070968627929801, 17.893472671508846],
          [73.070968627929801, 17.892919540405273],
          [73.070686340332088, 17.892919540405273],
          [73.070686340332088, 17.892641067504883],
          [73.070419311523608, 17.892641067504883],
          [73.070419311523608, 17.892360687255916],
          [73.069580078125057, 17.892360687255916],
          [73.069580078125057, 17.89180946350109],
          [73.069313049316406, 17.89180946350109],
          [73.069313049316406, 17.891250610351563],
          [73.069030761719034, 17.891250610351563],
          [73.069030761719034, 17.890970230102596],
          [73.066528320312557, 17.890972137451172],
          [73.066528320312557, 17.890693664550781],
          [73.065696716308594, 17.890693664550781],
          [73.065696716308594, 17.890415191650391],
          [73.06485748291027, 17.890415191650391],
          [73.06485748291027, 17.890693664550781],
          [73.063468933105526, 17.890693664550781],
          [73.063468933105526, 17.890970230102596],
          [73.063201904297046, 17.890979766845703],
          [73.063194274902514, 17.891250610351563],
          [73.062919616699503, 17.891250610351563],
          [73.062919616699503, 17.891525268554744],
          [73.062782287597599, 17.891525268554744],
          [73.061531066894588, 17.891519546508846],
          [73.061531066894588, 17.89180946350109],
          [73.061248779296818, 17.89180946350109],
          [73.061248779296818, 17.892360687255916],
          [73.060974121093977, 17.892360687255916],
          [73.060974121093977, 17.893194198608455],
          [73.060691833496264, 17.893194198608455],
          [73.060691833496264, 17.893472671508846],
          [73.060417175293026, 17.89347076416027],
          [73.060417175293026, 17.893751144409237],
          [73.060142517090014, 17.893751144409237],
          [73.060142517090014, 17.894029617309627],
          [73.059860229492472, 17.894029617309627],
          [73.059860229492472, 17.894308090210018],
          [73.059585571289062, 17.894306182861442],
          [73.059585571289062, 17.894582748413029],
          [73.059028625488281, 17.894580841064453],
          [73.059028625488281, 17.895139694213981],
          [73.058746337890909, 17.895139694213981],
          [73.058746337890909, 17.895694732665959],
          [73.058471679687557, 17.895694732665959],
          [73.058471679687557, 17.895971298217773],
          [73.058197021484318, 17.895971298217773],
          [73.058197021484318, 17.89625167846674],
          [73.057907104492244, 17.89625167846674],
          [73.057907104492244, 17.896530151367301],
          [73.057640075683764, 17.896528244018555],
          [73.057640075683764, 17.896804809570312],
          [73.057357788086165, 17.896804809570312],
          [73.057357788086165, 17.897361755371094],
          [73.057083129882983, 17.897361755371094],
          [73.057083129882983, 17.897640228271484],
          [73.056808471679972, 17.897640228271484],
          [73.056808471679972, 17.897920608520451],
          [73.056518554687671, 17.897920608520451],
          [73.056518554687671, 17.898202896118221],
          [73.05625152587919, 17.89819526672369],
          [73.05625152587919, 17.898471832275447],
          [73.055686950683878, 17.898471832275447],
          [73.055686950683878, 17.898750305175838],
          [73.055419921875057, 17.898750305175838],
          [73.055419921875057, 17.899030685424805],
          [73.055137634277457, 17.899030685424805],
          [73.055137634277457, 17.899311065673771],
          [73.054862976074276, 17.899311065673771],
          [73.054862976074276, 17.899860382080192],
          [73.054580688476506, 17.899860382080192],
          [73.054580688476506, 17.900140762329158],
          [73.054306030273665, 17.900140762329158],
          [73.054306030273665, 17.900421142578125],
          [73.054031372070483, 17.900421142578125],
          [73.054031372070483, 17.901531219482479],
          [73.054306030273665, 17.901531219482479],
          [73.054306030273665, 17.901809692382869],
          [73.054031372070483, 17.901809692382869],
          [73.054031372070483, 17.902360916137695],
          [73.053749084472713, 17.902360916137695],
          [73.053749084472713, 17.902919769287223],
          [73.053474426269702, 17.902914047241268],
          [73.053474426269702, 17.903194427490234],
          [73.053192138672159, 17.903194427490234],
          [73.053192138672159, 17.903472900390625],
          [73.052360534668026, 17.903459548950138],
          [73.052360534668026, 17.90374946594244],
          [73.051795959472713, 17.90374946594244],
          [73.051795959472713, 17.904029846191406],
          [73.051528930664006, 17.90402793884283],
          [73.051528930664006, 17.904582977294979],
          [73.051246643066634, 17.904581069946403],
          [73.051246643066634, 17.90513992309576],
          [73.050971984863452, 17.90513992309576],
          [73.050971984863452, 17.905420303344727],
          [73.050712585449503, 17.905420303344727],
          [73.050712585449503, 17.905700683593693],
          [73.050971984863452, 17.905696868896541],
          [73.050971984863452, 17.905971527099723],
          [73.050697326660213, 17.905971527099723],
          [73.050697326660213, 17.906526565551758],
          [73.050422668457202, 17.906520843505973],
          [73.050422668457202, 17.906810760498047],
          [73.050140380859659, 17.906806945800895],
          [73.050140380859659, 17.907361984252873],
          [73.050422668457202, 17.907358169555721],
          [73.050422668457202, 17.907640457153434],
          [73.051795959472713, 17.907640457153434],
          [73.051795959472713, 17.907358169555721],
          [73.052360534668026, 17.907358169555721],
          [73.052360534668026, 17.907640457153434],
          [73.052711486816577, 17.907640457153434],
          [73.05291748046875, 17.907640457153434],
          [73.05291748046875, 17.907920837402401],
          [73.053474426269702, 17.907918930053825],
          [73.053474426269702, 17.908193588256836],
          [73.053749084472713, 17.908189773559684],
          [73.053749084472713, 17.909860610961971],
          [73.054031372070483, 17.909860610961971],
          [73.054031372070483, 17.910419464111328],
          [73.054306030273665, 17.910417556762752],
          [73.054306030273665, 17.91069412231451],
          [73.054031372070483, 17.91069412231451],
          [73.054031372070483, 17.911449432373104],
          [73.054031372070483, 17.912082672119084],
          [73.05417633056652, 17.912082672119084],
          [73.054306030273665, 17.912082672119084],
          [73.054306030273665, 17.912639617920036],
          [73.054580688476506, 17.912639617920036],
          [73.054580688476506, 17.912820816040039],
          [73.054580688476506, 17.913194656372013],
          [73.055137634277457, 17.913194656372013],
          [73.055137634277457, 17.913471221923828],
          [73.054862976074276, 17.913471221923828],
          [73.054862976074276, 17.913749694824219],
          [73.054580688476506, 17.913749694824219],
          [73.054580688476506, 17.915140151977539],
          [73.054862976074276, 17.915140151977539],
          [73.054862976074276, 17.915710449218807],
          [73.055137634277457, 17.915710449218807],
          [73.055137634277457, 17.916250228881893],
          [73.054862976074276, 17.916250228881893],
          [73.054862976074276, 17.917083740234432],
          [73.054580688476506, 17.917083740234432],
          [73.054580688476506, 17.918472290039006],
          [73.054306030273665, 17.918472290039006],
          [73.054306030273665, 17.919584274291935],
          [73.054031372070483, 17.919584274291935],
          [73.054031372070483, 17.92097282409668],
          [73.053749084472713, 17.92097282409668],
          [73.053749084472713, 17.922082901001033],
          [73.054031372070483, 17.922079086303711],
          [73.054031372070483, 17.922639846801815],
          [73.053474426269702, 17.922641754150391],
          [73.053474426269702, 17.92319488525402],
          [73.053192138672159, 17.923189163208065],
          [73.053192138672159, 17.924030303955135],
          [73.05291748046875, 17.924028396606559],
          [73.05291748046875, 17.924861907958928],
          [73.052635192871378, 17.924861907958928],
          [73.052642822265909, 17.925689697265739],
          [73.052360534668026, 17.925695419311523],
          [73.052360534668026, 17.927328109741268],
          [73.052085876464957, 17.927360534668026],
          [73.052085876464957, 17.929029464721737],
          [73.053749084472713, 17.929029464721737],
          [73.053749084472713, 17.928750991821346],
          [73.054031372070483, 17.928750991821346],
          [73.054031372070483, 17.928470611572379],
          [73.054580688476506, 17.928472518920955],
          [73.054580688476506, 17.928192138671989],
          [73.055137634277457, 17.928192138671989],
          [73.055137634277457, 17.927917480468807],
          [73.055419921875057, 17.927919387817383],
          [73.055419921875057, 17.927650451660156],
          [73.055686950683878, 17.927650451660156],
          [73.055686950683878, 17.927360534668026],
          [73.05596923828125, 17.927360534668026],
          [73.05596923828125, 17.927080154419059],
          [73.05625152587919, 17.927082061767635],
          [73.05625152587919, 17.926527023315487],
          [73.057357788086165, 17.926527023315487],
          [73.057357788086165, 17.926900863647518],
          [73.057357788086165, 17.927360534668026],
          [73.057640075683764, 17.927360534668026],
          [73.057640075683764, 17.927919387817383],
          [73.058471679687557, 17.927917480468807],
          [73.058471679687557, 17.928192138671989],
          [73.05930328369169, 17.928192138671989],
          [73.05930328369169, 17.927917480468807],
          [73.059860229492472, 17.927919387817383],
          [73.059860229492472, 17.927650451660156],
          [73.060142517090014, 17.927650451660156],
          [73.060142517090014, 17.927360534668026],
          [73.060417175293026, 17.927360534668026],
          [73.060417175293026, 17.926811218261776],
          [73.060966491699276, 17.926811218261776],
          [73.060989379882869, 17.926595687866325],
          [73.061248779296818, 17.926530838012638],
          [73.061248779296818, 17.926250457763672],
          [73.062362670898722, 17.926250457763672],
          [73.062362670898722, 17.926500320434684],
          [73.062652587890625, 17.926530838012638],
          [73.062652587890625, 17.926811218261776],
          [73.065422058105753, 17.926811218261776],
          [73.065422058105753, 17.926530838012638],
          [73.066802978515796, 17.926530838012638],
          [73.066802978515796, 17.926811218261776],
          [73.067085266113509, 17.926805496215877],
          [73.067085266113509, 17.927082061767635],
          [73.066802978515796, 17.927080154419059],
          [73.066802978515796, 17.927650451660156],
          [73.065971374512003, 17.927650451660156],
          [73.065971374512003, 17.927360534668026],
          [73.062080383300781, 17.927360534668026],
          [73.062080383300781, 17.928192138671989],
          [73.062362670898722, 17.928190231323242],
          [73.062362670898722, 17.929309844970703],
          [73.062637329101563, 17.929304122924748],
          [73.062637329101563, 17.929582595825138],
          [73.062919616699503, 17.929580688476562],
          [73.062919616699503, 17.9298610687257],
          [73.063186645507983, 17.9298610687257],
          [73.063186645507983, 17.93013954162609],
          [73.063468933105526, 17.93013954162609],
          [73.063468933105526, 17.930694580078068],
          [73.063751220703296, 17.930690765380916],
          [73.063751220703296, 17.931249618530273],
          [73.064025878906477, 17.931249618530273],
          [73.064025878906477, 17.931804656982422],
          [73.064582824707088, 17.931804656982422],
          [73.064582824707088, 17.932083129882812],
          [73.06485748291027, 17.932083129882812],
          [73.06485748291027, 17.932361602783203],
          [73.065422058105753, 17.932359695434627],
          [73.065422058105753, 17.932640075683594],
          [73.065971374512003, 17.932640075683594],
          [73.065971374512003, 17.932359695434627],
          [73.066528320312557, 17.932361602783203],
          [73.066528320312557, 17.931804656982422],
          [73.066802978515796, 17.931804656982422],
          [73.066802978515796, 17.929582595825138],
          [73.067085266113509, 17.929582595825138],
          [73.067085266113509, 17.929027557373161],
          [73.067359924316349, 17.929029464721737],
          [73.067359924316349, 17.928750991821346],
          [73.067642211914119, 17.928750991821346],
          [73.067642211914119, 17.928470611572379],
          [73.067916870117301, 17.928472518920955],
          [73.067916870117301, 17.927917480468807],
          [73.068191528320369, 17.927919387817383],
          [73.068191528320369, 17.926811218261776],
          [73.070137023926009, 17.926805496215877],
          [73.070137023926009, 17.927082061767635],
          [73.070968627929801, 17.927080154419059],
          [73.070968627929801, 17.927360534668026],
          [73.072357177734546, 17.927360534668026],
          [73.072357177734546, 17.927650451660156],
          [73.072639465332315, 17.927639007568416],
          [73.072639465332315, 17.928192138671989],
          [73.072914123535327, 17.928192138671989],
          [73.072914123535327, 17.928472518920955],
          [73.073196411132869, 17.928470611572379],
          [73.073196411132869, 17.928750991821346],
          [73.073471069336108, 17.928750991821346],
          [73.073471069336108, 17.929309844970703],
          [73.073753356933821, 17.929304122924748],
          [73.073753356933821, 17.929582595825138],
          [73.074584960937614, 17.929582595825138],
          [73.074584960937614, 17.9298610687257],
          [73.075141906738565, 17.9298610687257],
          [73.075141906738565, 17.930419921875057],
          [73.075416564941406, 17.930414199829102],
          [73.075416564941406, 17.930973052978459],
          [73.075691223144815, 17.930971145629883],
          [73.075691223144815, 17.931529998779411],
          [73.075965881347827, 17.931529998779411],
          [73.075965881347827, 17.93292045593256],
          [73.076248168945369, 17.93292045593256],
          [73.076248168945369, 17.933200836181697],
          [73.076530456543139, 17.933195114135799],
          [73.076530456543139, 17.933471679687557],
          [73.077079772949162, 17.933469772338981],
          [73.077079772949162, 17.933748245239371],
          [73.077362060546932, 17.933748245239371],
          [73.077362060546932, 17.934030532836914],
          [73.077919006347713, 17.934030532836914],
          [73.077919006347713, 17.934310913085881],
          [73.078193664551065, 17.934305191040153],
          [73.078193664551065, 17.934583663940487],
          [73.078750610351847, 17.934579849243164],
          [73.078750610351847, 17.934858322143555],
          [73.079307556152401, 17.934858322143555],
          [73.079307556152401, 17.935140609741268],
          [73.079582214355639, 17.935140609741268],
          [73.079582214355639, 17.935419082641658],
          [73.080413818359432, 17.935417175293082],
          [73.080413818359432, 17.93569374084467],
          [73.081253051758097, 17.93569374084467],
          [73.081253051758097, 17.93597221374506],
          [73.082077026367358, 17.935968399047908],
          [73.082077026367358, 17.936529159546012],
          [73.082359313964901, 17.936529159546012],
          [73.082359313964901, 17.936822891235465],
          [73.082641601562671, 17.936822891235465],
          [73.082641601562671, 17.937362670898381],
          [73.082916259765852, 17.937362670898381],
          [73.082916259765852, 17.937641143798771],
          [73.083747863769645, 17.937641143798771],
          [73.083747863769645, 17.937919616699332],
          [73.084304809570597, 17.93791580200201],
          [73.084304809570597, 17.938194274902344],
          [73.084861755371378, 17.938194274902344],
          [73.084861755371378, 17.938472747802734],
          [73.085418701172159, 17.938472747802734],
          [73.085418701172159, 17.938751220703125],
          [73.086250305175952, 17.938751220703125],
          [73.086250305175952, 17.939029693603516],
          [73.086822509765796, 17.939029693603516],
          [73.086822509765796, 17.939310073852482],
          [73.087638854980469, 17.939310073852482],
          [73.087638854980469, 17.939590454101619],
          [73.08819580078125, 17.939582824707088],
          [73.08819580078125, 17.939861297607479],
          [73.088752746582202, 17.939859390258903],
          [73.088752746582202, 17.940139770507869],
          [73.089859008789006, 17.940139770507869],
          [73.089859008789006, 17.940420150756836],
          [73.092361450195483, 17.940416336059684],
          [73.092361450195483, 17.940694808960075],
          [73.09124755859375, 17.940694808960075],
          [73.09124755859375, 17.940971374511832],
          [73.088752746582202, 17.940971374511832],
          [73.088752746582202, 17.940694808960075],
          [73.08819580078125, 17.940694808960075],
          [73.08819580078125, 17.940416336059684],
          [73.087081909179744, 17.940420150756836],
          [73.087081909179744, 17.940139770507869],
          [73.085418701172159, 17.940139770507869],
          [73.085418701172159, 17.939859390258903],
          [73.085136413574389, 17.939861297607479],
          [73.085136413574389, 17.939582824707088],
          [73.084587097167969, 17.939590454101619],
          [73.084587097167969, 17.939310073852482],
          [73.084297180176065, 17.939310073852482],
          [73.084297180176065, 17.939029693603516],
          [73.083747863769645, 17.939029693603516],
          [73.083747863769645, 17.938751220703125],
          [73.083190917968693, 17.938751220703125],
          [73.083190917968693, 17.938472747802734],
          [73.082916259765852, 17.938472747802734],
          [73.082916259765852, 17.938194274902344],
          [73.082359313964901, 17.938194274902344],
          [73.082359313964901, 17.93791580200201],
          [73.082077026367358, 17.937919616699332],
          [73.082077026367358, 17.937641143798771],
          [73.081802368164347, 17.937641143798771],
          [73.081802368164347, 17.937362670898381],
          [73.080398559570369, 17.937362670898381],
          [73.080398559570369, 17.937078475952262],
          [73.080139160156193, 17.93708419799799],
          [73.080139160156193, 17.936805725097656],
          [73.079856872558821, 17.936822891235465],
          [73.079856872558821, 17.936529159546012],
          [73.079582214355639, 17.936529159546012],
          [73.079582214355639, 17.936250686645621],
          [73.079025268554858, 17.936250686645621],
          [73.079025268554858, 17.93597221374506],
          [73.078193664551065, 17.93597221374506],
          [73.078193664551065, 17.93569374084467],
          [73.077362060546932, 17.93569374084467],
          [73.077362060546932, 17.935417175293082],
          [73.076248168945369, 17.935419082641658],
          [73.076248168945369, 17.935140609741268],
          [73.075965881347827, 17.935140609741268],
          [73.075965881347827, 17.934579849243164],
          [73.075416564941406, 17.934583663940487],
          [73.075416564941406, 17.934028625488338],
          [73.074592590332145, 17.934030532836914],
          [73.074592590332145, 17.933748245239371],
          [73.074302673339901, 17.933748245239371],
          [73.074302673339901, 17.933469772338981],
          [73.074028015136662, 17.933471679687557],
          [73.074028015136662, 17.932918548583984],
          [73.073753356933821, 17.93292045593256],
          [73.073753356933821, 17.932359695434627],
          [73.073471069336108, 17.932361602783203],
          [73.073471069336108, 17.931804656982422],
          [73.073196411132869, 17.931804656982422],
          [73.073196411132869, 17.930973052978459],
          [73.072914123535327, 17.930973052978459],
          [73.072914123535327, 17.9298610687257],
          [73.072639465332315, 17.9298610687257],
          [73.072639465332315, 17.929580688476562],
          [73.072364807128906, 17.929582595825138],
          [73.072364807128906, 17.929304122924748],
          [73.072082519531534, 17.929309844970703],
          [73.072082519531534, 17.929029464721737],
          [73.070419311523608, 17.929029464721737],
          [73.070419311523608, 17.929309844970703],
          [73.069862365722827, 17.929304122924748],
          [73.069862365722827, 17.929582595825138],
          [73.069580078125057, 17.929580688476562],
          [73.069580078125057, 17.9298610687257],
          [73.069313049316406, 17.9298610687257],
          [73.069313049316406, 17.930419921875057],
          [73.069580078125057, 17.930419921875057],
          [73.069580078125057, 17.931249618530273],
          [73.069313049316406, 17.931249618530273],
          [73.069313049316406, 17.931529998779411],
          [73.069030761719034, 17.931526184082088],
          [73.069030761719034, 17.932083129882812],
          [73.068748474121094, 17.932081222534237],
          [73.068748474121094, 17.932640075683594],
          [73.068473815918253, 17.932636260986442],
          [73.068473815918253, 17.933471679687557],
          [73.067916870117301, 17.933469772338981],
          [73.067916870117301, 17.933748245239371],
          [73.067359924316349, 17.933748245239371],
          [73.067359924316349, 17.934030532836914],
          [73.067092895507869, 17.934030532836914],
          [73.067092895507869, 17.933748245239371],
          [73.066802978515796, 17.933748245239371],
          [73.066802978515796, 17.934030532836914],
          [73.066528320312557, 17.934030532836914],
          [73.066528320312557, 17.933748245239371],
          [73.065971374512003, 17.933748245239371],
          [73.065971374512003, 17.933469772338981],
          [73.065414428711222, 17.933471679687557],
          [73.065414428711222, 17.933195114135799],
          [73.064025878906477, 17.933200836181697],
          [73.064025878906477, 17.93292045593256],
          [73.061813354492301, 17.93292045593256],
          [73.061813354492301, 17.932640075683594],
          [73.061248779296818, 17.932640075683594],
          [73.061248779296818, 17.932359695434627],
          [73.057640075683764, 17.932361602783203],
          [73.057640075683764, 17.932083129882812],
          [73.057083129882983, 17.932083129882812],
          [73.057083129882983, 17.931804656982422],
          [73.056808471679972, 17.931804656982422],
          [73.056808471679972, 17.931526184082088],
          [73.056526184082202, 17.931526184082088],
          [73.056526184082202, 17.931804656982422],
          [73.054306030273665, 17.931804656982422],
          [73.054306030273665, 17.931526184082088],
          [73.052360534668026, 17.931526184082088],
          [73.052360534668026, 17.931804656982422],
          [73.050971984863452, 17.931804656982422],
          [73.050971984863452, 17.932083129882812],
          [73.049858093261719, 17.932083129882812],
          [73.049858093261719, 17.932361602783203],
          [73.047637939453182, 17.932359695434627],
          [73.047637939453182, 17.932640075683594],
          [73.047080993652628, 17.932640075683594],
          [73.047080993652628, 17.93292045593256],
          [73.046806335449219, 17.93292045593256],
          [73.046806335449219, 17.933200836181697],
          [73.046524047851847, 17.933195114135799],
          [73.046524047851847, 17.933471679687557],
          [73.046249389648438, 17.933469772338981],
          [73.046249389648438, 17.933748245239371],
          [73.045417785644474, 17.933748245239371],
          [73.045417785644474, 17.934030532836914],
          [73.044288635254077, 17.934030532836914],
          [73.044288635254077, 17.933748245239371],
          [73.044029235840128, 17.933748245239371],
          [73.044029235840128, 17.933469772338981],
          [73.043746948242358, 17.933471679687557],
          [73.043746948242358, 17.933195114135799],
          [73.043472290039347, 17.933200836181697],
          [73.043472290039347, 17.932640075683594],
          [73.042358398437614, 17.932640075683594],
          [73.042358398437614, 17.932359695434627],
          [73.041847229003906, 17.932359695434627],
          [73.041542053222713, 17.932359695434627],
          [73.041542053222713, 17.932640075683594],
          [73.041252136230639, 17.932636260986442],
          [73.041229248046818, 17.932910919189453],
          [73.040412902832315, 17.93292045593256],
          [73.040412902832315, 17.933200836181697],
          [73.039581298828182, 17.933195114135799],
          [73.039581298828182, 17.933471679687557],
          [73.039306640625114, 17.933469772338981],
          [73.039306640625114, 17.933748245239371],
          [73.038749694824162, 17.933748245239371],
          [73.038749694824162, 17.934030532836914],
          [73.038482666015682, 17.934030532836914],
          [73.038482666015682, 17.934310913085881],
          [73.037918090820369, 17.934310913085881],
          [73.037918090820369, 17.934858322143555],
          [73.037635803222827, 17.934858322143555],
          [73.037635803222827, 17.935419082641658],
          [73.037361145019815, 17.935417175293082],
          [73.037361145019815, 17.93597221374506],
          [73.037086486816406, 17.935968399047908],
          [73.037086486816406, 17.936250686645621],
          [73.036796569824503, 17.936250686645621],
          [73.036796569824503, 17.936529159546012],
          [73.036529541015682, 17.936529159546012],
          [73.036529541015682, 17.936822891235465],
          [73.036247253418082, 17.936805725097656],
          [73.036247253418082, 17.93708419799799],
          [73.035972595214901, 17.937078475952262],
          [73.035972595214901, 17.937641143798771],
          [73.035697937011662, 17.937639236450195],
          [73.035697937011662, 17.938194274902344],
          [73.035423278808821, 17.938190460205192],
          [73.035423278808821, 17.939029693603516],
          [73.035140991211108, 17.939029693603516],
          [73.035140991211108, 17.939310073852482],
          [73.034027099609375, 17.939310073852482],
          [73.034027099609375, 17.939590454101619],
          [73.033752441406534, 17.939582824707088],
          [73.033752441406534, 17.939861297607479],
          [73.033470153808594, 17.939859390258903],
          [73.033470153808594, 17.940139770507869],
          [73.032638549804631, 17.940139770507869],
          [73.032638549804631, 17.940420150756836],
          [73.032081604004077, 17.940416336059684],
          [73.032081604004077, 17.940971374511832],
          [73.031806945800838, 17.940969467163086],
          [73.031806945800838, 17.941249847412223],
          [73.031524658203296, 17.941249847412223],
          [73.031524658203296, 17.941804885864201],
          [73.031250000000284, 17.941804885864201],
          [73.031250000000284, 17.942361831664982],
          [73.030982971191406, 17.942359924316406],
          [73.030982971191406, 17.943201065063477],
          [73.030693054199503, 17.943195343017578],
          [73.030693054199503, 17.943471908569336],
          [73.030418395996094, 17.94347000122076],
          [73.030418395996094, 17.943750381469727],
          [73.030136108398722, 17.943750381469727],
          [73.030136108398722, 17.944030761718693],
          [73.029861450195369, 17.944030761718693],
          [73.029861450195369, 17.94431114196783],
          [73.029602050781421, 17.94431114196783],
          [73.029602050781421, 17.946809768676758],
          [73.029289245605526, 17.946809768676758],
          [73.029289245605526, 17.947359085083008],
          [73.029029846191577, 17.947359085083008],
          [73.029029846191577, 17.947919845581112],
          [73.028747558593977, 17.947919845581112],
          [73.028747558593977, 17.949029922485465],
          [73.028472900390796, 17.949029922485465],
          [73.028472900390796, 17.949583053588867],
          [73.028747558593977, 17.949579238891715],
          [73.028747558593977, 17.953750610351676],
          [73.029029846191577, 17.953750610351676],
          [73.029029846191577, 17.954030990600643],
          [73.029861450195369, 17.954030990600643],
          [73.029861450195369, 17.954309463501033],
          [73.030136108398722, 17.954305648803711],
          [73.030136108398722, 17.954582214355469],
          [73.030418395996094, 17.954572677612362],
          [73.030418395996094, 17.954860687255859],
          [73.030693054199503, 17.954860687255859],
          [73.030693054199503, 17.955141067504826],
          [73.030975341796875, 17.95513916015625],
          [73.030975341796875, 17.955694198608398],
          [73.031250000000284, 17.955690383911246],
          [73.031250000000284, 17.957361221313533],
          [73.030982971191406, 17.957361221313533],
          [73.030982971191406, 17.957920074462891],
          [73.030693054199503, 17.957914352416935],
          [73.030693054199503, 17.958194732666129],
          [73.030418395996094, 17.95819091796875],
          [73.030418395996094, 17.958749771118278],
          [73.030136108398722, 17.958749771118278],
          [73.030136108398722, 17.959583282470646],
          [73.029861450195369, 17.959579467773494],
          [73.029861450195369, 17.961250305175781],
          [73.029586791992131, 17.961250305175781],
          [73.029602050781421, 17.9651393890382],
          [73.029304504394588, 17.9651393890382],
          [73.029304504394588, 17.966806411743164],
          [73.029586791992131, 17.966806411743164],
          [73.029586791992131, 17.967361450195313],
          [73.030136108398722, 17.967359542846737],
          [73.030136108398722, 17.967639923095703],
          [73.030693054199503, 17.967639923095703],
          [73.030693054199503, 17.96792030334467],
          [73.030975341796875, 17.967916488647518],
          [73.030975341796875, 17.968471527099666],
          [73.031250000000284, 17.96846961975109],
          [73.031250000000284, 17.969030380249023],
          [73.031517028808764, 17.969030380249023],
          [73.031517028808764, 17.96931076049799],
          [73.031806945800838, 17.969303131103459],
          [73.031806945800838, 17.969861984252987],
          [73.032081604004077, 17.969860076904411],
          [73.032081604004077, 17.970140457153377],
          [73.032348632812557, 17.970140457153377],
          [73.032348632812557, 17.970420837402344],
          [73.032638549804631, 17.970415115356388],
          [73.032638549804631, 17.970693588256779],
          [73.033195495605582, 17.970693588256779],
          [73.033195495605582, 17.97097206115717],
          [73.033752441406534, 17.970970153808594],
          [73.033752441406534, 17.971250534057731],
          [73.034301757812784, 17.971250534057731],
          [73.034309387207315, 17.971530914306697],
          [73.034576416015796, 17.971530914306697],
          [73.034576416015796, 17.971809387207088],
          [73.034858703613338, 17.971805572509766],
          [73.034858703613338, 17.972085952758903],
          [73.035140991211108, 17.972080230712947],
          [73.035140991211108, 17.972640991210881],
          [73.035423278808821, 17.972640991210881],
          [73.035423278808821, 17.972930908203182],
          [73.035697937011662, 17.972919464111442],
          [73.035697937011662, 17.973194122314453],
          [73.036529541015682, 17.973194122314453],
          [73.036529541015682, 17.973472595214844],
          [73.037086486816406, 17.973470687866268],
          [73.037086486816406, 17.973751068115234],
          [73.037361145019815, 17.973751068115234],
          [73.037361145019815, 17.974309921264592],
          [73.037635803222827, 17.974309921264592],
          [73.037635803222827, 17.974861145019588],
          [73.037918090820369, 17.974861145019588],
          [73.037918090820369, 17.975139617919979],
          [73.038192749023608, 17.975139617919979],
          [73.038192749023608, 17.975418090820369],
          [73.038482666015682, 17.975418090820369],
          [73.038482666015682, 17.975702285766715],
          [73.038749694824162, 17.975702285766715],
          [73.038749694824162, 17.976530075073299],
          [73.039024353027401, 17.976528167724723],
          [73.039024353027401, 17.97680473327631],
          [73.039306640625114, 17.97680473327631],
          [73.039306640625114, 17.977361679077092],
          [73.039581298828182, 17.977361679077092],
          [73.039581298828182, 17.977640151977653],
          [73.039855957031534, 17.977640151977653],
          [73.039855957031534, 17.977920532226619],
          [73.040138244628906, 17.977920532226619],
          [73.040138244628906, 17.978202819824219],
          [73.039855957031534, 17.978202819824219],
          [73.039855957031534, 17.979030609130803],
          [73.039581298828182, 17.979030609130803],
          [73.039581298828182, 17.97986030578619],
          [73.039306640625114, 17.97986030578619],
          [73.039306640625114, 17.980693817138729],
          [73.039016723632869, 17.980691909790153],
          [73.039016723632869, 17.981531143188477],
          [73.038749694824162, 17.981531143188477],
          [73.038749694824162, 17.98264122009283],
          [73.038475036621321, 17.982639312744254],
          [73.038475036621321, 17.983472824096623],
          [73.038192749023608, 17.983470916748047],
          [73.038192749023608, 17.984310150146541],
          [73.037918090820369, 17.984304428100586],
          [73.037918090820369, 17.984582901000977],
          [73.037635803222827, 17.984582901000977],
          [73.037635803222827, 17.984304428100586],
          [73.037361145019815, 17.984310150146541],
          [73.037345886230526, 17.984863281249943],
          [73.037086486816406, 17.98489952087408],
          [73.037086486816406, 17.985139846801758],
          [73.036796569824503, 17.985139846801758],
          [73.036796569824503, 17.985420227050724],
          [73.036529541015682, 17.985416412353572],
          [73.036529541015682, 17.985696792602539],
          [73.035140991211108, 17.985696792602539],
          [73.035140991211108, 17.985971450805721],
          [73.034309387207315, 17.985969543457145],
          [73.034301757812784, 17.986249923706112],
          [73.034027099609375, 17.986249923706112],
          [73.034027099609375, 17.986530303955078],
          [73.033470153808594, 17.986530303955078],
          [73.033470153808594, 17.986810684204045],
          [73.033195495605582, 17.986804962158317],
          [73.033195495605582, 17.987083435058651],
          [73.032913208007869, 17.987083435058651],
          [73.032913208007869, 17.987361907959041],
          [73.032638549804631, 17.987358093261719],
          [73.032638549804631, 17.987930297851563],
          [73.032913208007869, 17.987918853759822],
          [73.032913208007869, 17.988189697265682],
          [73.032638549804631, 17.988199234008789],
          [73.032638549804631, 17.988750457763786],
          [73.032913208007869, 17.988750457763786],
          [73.032913208007869, 17.989309310913143],
          [73.03236389160179, 17.98930549621582],
          [73.03236389160179, 17.989583969116154],
          [73.031806945800838, 17.989578247070426],
          [73.031806945800838, 17.989860534667969],
          [73.031517028808764, 17.989860534667969],
          [73.031517028808764, 17.990140914916935],
          [73.030982971191406, 17.990140914916935],
          [73.030982971191406, 17.990419387817496],
          [73.030136108398722, 17.99041748046875],
          [73.030136108398722, 17.990694046020508],
          [73.029861450195369, 17.990694046020508],
          [73.029861450195369, 17.990972518920898],
          [73.029602050781421, 17.990972518920898],
          [73.029602050781421, 17.991252899169865],
          [73.029029846191577, 17.991252899169865],
          [73.029029846191577, 17.990419387817496],
          [73.028747558593977, 17.990419387817496],
          [73.028747558593977, 17.990140914916935],
          [73.028472900390796, 17.990140914916935],
          [73.028472900390796, 17.989860534667969],
          [73.028198242187784, 17.989860534667969],
          [73.028190612793026, 17.989578247070426],
          [73.027915954590014, 17.989583969116154],
          [73.027915954590014, 17.98930549621582],
          [73.027359008789063, 17.989309310913143],
          [73.027359008789063, 17.989030838012752],
          [73.026542663574162, 17.989030838012752],
          [73.026542663574162, 17.988750457763786],
          [73.025138854980526, 17.988750457763786],
          [73.025138854980526, 17.989030838012752],
          [73.024032592773722, 17.989030838012752],
          [73.024032592773722, 17.989309310913143],
          [73.023193359375057, 17.98930549621582],
          [73.023193359375057, 17.989583969116154],
          [73.022361755371264, 17.989578247070426],
          [73.022361755371264, 17.989860534667969],
          [73.021797180175952, 17.989860534667969],
          [73.021797180175952, 17.990140914916935],
          [73.020408630371378, 17.990140914916935],
          [73.020408630371378, 17.989860534667969],
          [73.019859313964787, 17.989860534667969],
          [73.019859313964787, 17.990140914916935],
          [73.019027709960994, 17.990140914916935],
          [73.019027709960994, 17.990419387817496],
          [73.018753051757983, 17.99041748046875],
          [73.018753051757983, 17.990694046020508],
          [73.01847076416044, 17.990694046020508],
          [73.01847076416044, 17.990972518920898],
          [73.017913818359659, 17.990972518920898],
          [73.017913818359659, 17.991119384765739],
          [73.017913818359659, 17.992082595825252],
          [73.018196105957031, 17.992082595825252],
          [73.018196105957031, 17.992639541626033],
          [73.018753051757983, 17.992639541626033],
          [73.018753051757983, 17.992919921875],
          [73.020141601562557, 17.992919921875],
          [73.020141601562557, 17.992639541626033],
          [73.02097320556669, 17.992639541626033],
          [73.02097320556669, 17.992919921875],
          [73.021247863769531, 17.992916107177848],
          [73.021247863769531, 17.993194580078239],
          [73.021530151367472, 17.993194580078239],
          [73.021530151367472, 17.993749618530387],
          [73.021247863769531, 17.993740081787109],
          [73.021247863769531, 17.994029998779354],
          [73.02097320556669, 17.994028091430778],
          [73.02097320556669, 17.994304656982365],
          [73.020416259765739, 17.994304656982365],
          [73.020416259765739, 17.994583129882756],
          [73.020141601562557, 17.994583129882756],
          [73.020141601562557, 17.994861602783146],
          [73.019859313964787, 17.99485969543457],
          [73.019859313964787, 17.995700836181641],
          [73.019577026367244, 17.995700836181641],
          [73.019577026367244, 17.996530532836857],
          [73.019302368164233, 17.996528625488281],
          [73.019302368164233, 17.99708366394043],
          [73.019027709960994, 17.997079849243278],
          [73.019027709960994, 17.997920989990178],
          [73.018753051757983, 17.997920989990178],
          [73.018753051757983, 17.998750686645565],
          [73.01847076416044, 17.998750686645565],
          [73.01847076416044, 17.999584197998161],
          [73.018196105957031, 17.999580383300781],
          [73.018196105957031, 18.000141143798885],
          [73.018196105957031, 18.001529693603629],
          [73.017913818359659, 18.001529693603629],
          [73.017913818359659, 18.002916336059627],
          [73.01763916015625, 18.002910614013672],
          [73.01763916015625, 18.004030227661133],
          [73.017364501953239, 18.004028320312557],
          [73.017364501953239, 18.004861831665096],
          [73.017082214355526, 18.004861831665096],
          [73.017082214355526, 18.005420684814453],
          [73.016807556152287, 18.005420684814453],
          [73.016807556152287, 18.006530761718807],
          [73.016532897949446, 18.006530761718807],
          [73.016532897949446, 18.006811141967773],
          [73.016250610351733, 18.006805419921875],
          [73.016250610351733, 18.007083892822209],
          [73.015975952148494, 18.007080078125057],
          [73.015975952148494, 18.00764083862299],
          [73.015686035156421, 18.00764083862299],
          [73.015686035156421, 18.007921218872127],
          [73.01541900634794, 18.007917404174805],
          [73.01541900634794, 18.008192062377987],
          [73.015136718750171, 18.008192062377987],
          [73.015136718750171, 18.008472442626953],
          [73.014579772949219, 18.008470535278377],
          [73.014579772949219, 18.009029388427734],
          [73.014312744140739, 18.009029388427734],
          [73.014312744140739, 18.009309768676701],
          [73.014030456543026, 18.009309768676701],
          [73.014030456543026, 18.009029388427734],
          [73.013191223144474, 18.009029388427734],
          [73.013191223144474, 18.009309768676701],
          [73.012916564941634, 18.009304046630916],
          [73.012916564941634, 18.009582519531307],
          [73.012641906738452, 18.009580612182731],
          [73.012641906738452, 18.009860992431697],
          [73.012359619140682, 18.009860992431697],
          [73.012359619140682, 18.010139465332088],
          [73.012092590332031, 18.010139465332088],
          [73.012092590332031, 18.010419845581055],
          [73.009857177734602, 18.010419845581055],
          [73.009857177734602, 18.010139465332088],
          [73.009147644043253, 18.010139465332088],
          [73.009025573730639, 18.010139465332088],
          [73.009025573730639, 18.01027870178217],
          [73.008941650390909, 18.010414123535099],
          [73.008468627929688, 18.010414123535099],
          [73.008468627929688, 18.010694503784293],
          [73.008193969726847, 18.010694503784293],
          [73.008193969726847, 18.010972976684627],
          [73.007919311523494, 18.010971069336051],
          [73.007919311523494, 18.011529922485408],
          [73.007637023925895, 18.011526107788086],
          [73.007637023925895, 18.01208305358881],
          [73.007362365722713, 18.01208305358881],
          [73.007362365722713, 18.012361526489201],
          [73.006813049316634, 18.012359619140625],
          [73.006813049316634, 18.012638092041016],
          [73.006530761718921, 18.012638092041016],
          [73.006530761718921, 18.012920379638729],
          [73.006248474121151, 18.012918472290153],
          [73.006248474121151, 18.013471603393555],
          [73.005973815918139, 18.013471603393555],
          [73.005958557129077, 18.014299392700195],
          [73.005691528320597, 18.014305114746151],
          [73.005691528320597, 18.014640808105469],
          [73.005691528320597, 18.016250610351619],
          [73.005409240722827, 18.016250610351619],
          [73.005409240722827, 18.01652908325201],
          [73.005142211914347, 18.016527175903434],
          [73.005142211914347, 18.017084121704215],
          [73.004859924316406, 18.01707839965826],
          [73.004859924316406, 18.019029617309684],
          [73.004592895507926, 18.019029617309684],
          [73.004592895507926, 18.019309997558651],
          [73.004302978515682, 18.019306182861328],
          [73.004302978515682, 18.019582748413086],
          [73.004028320312443, 18.019582748413086],
          [73.004028320312443, 18.019861221313477],
          [73.003471374511889, 18.019861221313477],
          [73.003471374511889, 18.020139694213867],
          [73.002372741699219, 18.020139694213867],
          [73.002372741699219, 18.020420074462834],
          [73.002082824707315, 18.020420074462834],
          [73.002082824707315, 18.021249771118221],
          [73.002372741699219, 18.021249771118221],
          [73.002372741699219, 18.021530151367188],
          [73.003471374511889, 18.021528244018612],
          [73.003471374511889, 18.021804809570426],
          [73.004028320312443, 18.021804809570426],
          [73.004028320312443, 18.02208328247076],
          [73.004302978515682, 18.02208328247076],
          [73.004302978515682, 18.021804809570426],
          [73.005142211914347, 18.021804809570426],
          [73.005142211914347, 18.021528244018612],
          [73.006248474121151, 18.021528244018612],
          [73.006248474121151, 18.021804809570426],
          [73.006805419922102, 18.021804809570426],
          [73.006805419922102, 18.02208328247076],
          [73.007362365722713, 18.02208328247076],
          [73.007362365722713, 18.022361755371151],
          [73.007637023925895, 18.022359848022575],
          [73.007637023925895, 18.022640228271541],
          [73.007919311523494, 18.022640228271541],
          [73.007919311523494, 18.022920608520508],
          [73.008193969726847, 18.022916793823356],
          [73.008193969726847, 18.023471832275334],
          [73.008750915527628, 18.023469924926758],
          [73.008750915527628, 18.023750305175895],
          [73.009033203125171, 18.023750305175895],
          [73.009033203125171, 18.024040222168026],
          [73.009857177734602, 18.024040222168026],
          [73.009857177734602, 18.024311065673828],
          [73.010139465331974, 18.02430534362793],
          [73.010139465331974, 18.024583816528263],
          [73.010696411132926, 18.024580001831112],
          [73.010696411132926, 18.024860382080078],
          [73.011253356933878, 18.024860382080078],
          [73.011253356933878, 18.024580001831112],
          [73.011528015136719, 18.024580001831112],
          [73.011528015136719, 18.024860382080078],
          [73.012359619140682, 18.024860382080078],
          [73.012359619140682, 18.025140762329045],
          [73.012802124023381, 18.025138854980469],
          [73.012916564941634, 18.025138854980469],
          [73.014579772949219, 18.025140762329045],
          [73.014579772949219, 18.025421142578182],
          [73.014862060547159, 18.025415420532283],
          [73.014862060547159, 18.025693893432617],
          [73.017913818359659, 18.025693893432617],
          [73.017913818359659, 18.025972366333008],
          [73.018127441406364, 18.025972366333008],
          [73.019027709960994, 18.025972366333008],
          [73.019027709960994, 18.025415420532283],
          [73.019302368164233, 18.025421142578182],
          [73.019302368164233, 18.025140762329045],
          [73.019577026367244, 18.025140762329045],
          [73.019577026367244, 18.024580001831112],
          [73.019859313964787, 18.024583816528263],
          [73.019859313964787, 18.02430534362793],
          [73.020141601562557, 18.024311065673828],
          [73.020141601562557, 18.024040222168026],
          [73.02069091796875, 18.024040222168026],
          [73.02069091796875, 18.023750305175895],
          [73.021247863769531, 18.023750305175895],
          [73.021247863769531, 18.023469924926758],
          [73.022636413574446, 18.023469924926758],
          [73.022636413574446, 18.023750305175895],
          [73.023468017578239, 18.023750305175895],
          [73.023468017578239, 18.024311065673828],
          [73.02402496337919, 18.02430534362793],
          [73.02402496337919, 18.024583816528263],
          [73.024581909179972, 18.024580001831112],
          [73.024581909179972, 18.024860382080078],
          [73.024856567382983, 18.024860382080078],
          [73.024856567382983, 18.025140762329045],
          [73.025138854980526, 18.025140762329045],
          [73.025138854980526, 18.025421142578182],
          [73.025413513183764, 18.025415420532283],
          [73.025413513183764, 18.025693893432617],
          [73.025695800781477, 18.025693893432617],
          [73.025695800781477, 18.025972366333008],
          [73.02652740478527, 18.025972366333008],
          [73.02652740478527, 18.026250839233398],
          [73.026802062988338, 18.026250839233398],
          [73.026802062988338, 18.026531219482365],
          [73.02707672119169, 18.026531219482365],
          [73.02707672119169, 18.026250839233398],
          [73.027359008789063, 18.026250839233398],
          [73.027359008789063, 18.026531219482365],
          [73.027641296387003, 18.026531219482365],
          [73.027641296387003, 18.026809692382756],
          [73.027915954590014, 18.02680778503418],
          [73.027915954590014, 18.027082443237362],
          [73.028198242187784, 18.027080535888786],
          [73.028198242187784, 18.027360916137752],
          [73.028747558593977, 18.027360916137752],
          [73.028747558593977, 18.027637481689567],
          [73.029289245605526, 18.027637481689567],
          [73.029289245605526, 18.027919769287109],
          [73.029586791992131, 18.027917861938533],
          [73.029586791992131, 18.02874755859375],
          [73.030136108398722, 18.02874755859375],
          [73.030136108398722, 18.029029846191463],
          [73.030418395996094, 18.029029846191463],
          [73.030418395996094, 18.02931022644043],
          [73.030693054199503, 18.029306411743278],
          [73.030693054199503, 18.029861450195256],
          [73.031250000000284, 18.02984809875494],
          [73.031250000000284, 18.030420303344783],
          [73.031517028808764, 18.030420303344783],
          [73.031517028808764, 18.030702590942383],
          [73.031806945800838, 18.030694961547852],
          [73.031806945800838, 18.030971527099609],
          [73.032081604004077, 18.030971527099609],
          [73.032081604004077, 18.031251907348576],
          [73.032348632812557, 18.031251907348576],
          [73.032348632812557, 18.031530380248967],
          [73.032913208007869, 18.031530380248967],
          [73.032913208007869, 18.031812667846737],
          [73.033195495605582, 18.031805038452205],
          [73.033195495605582, 18.032363891601562],
          [73.034301757812784, 18.032360076904354],
          [73.034309387207315, 18.03264045715332],
          [73.034584045410327, 18.032638549804744],
          [73.034584045410327, 18.032917022705135],
          [73.034858703613338, 18.032917022705135],
          [73.034858703613338, 18.033472061157283],
          [73.035140991211108, 18.033470153808707],
          [73.035140991211108, 18.033750534057674],
          [73.035697937011662, 18.033750534057674],
          [73.035697937011662, 18.034030914306641],
          [73.035972595214901, 18.034027099609489],
          [73.035972595214901, 18.034582138061467],
          [73.036529541015682, 18.034580230712891],
          [73.036529541015682, 18.034860610962028],
          [73.036796569824503, 18.034860610962028],
          [73.036796569824503, 18.035140991210994],
          [73.037086486816406, 18.035140991210994],
          [73.037086486816406, 18.035419464111385],
          [73.037361145019815, 18.035417556762809],
          [73.037361145019815, 18.035694122314396],
          [73.037635803222827, 18.035690307617244],
          [73.037635803222827, 18.035980224609318],
          [73.037918090820369, 18.035980224609318],
          [73.037918090820369, 18.036251068115178],
          [73.038482666015682, 18.036251068115178],
          [73.038482666015682, 18.036529541015739],
          [73.038749694824162, 18.036529541015739],
          [73.038749694824162, 18.036809921264705],
          [73.039016723632869, 18.036809921264705],
          [73.039016723632869, 18.038749694824276],
          [73.039306640625114, 18.038749694824276],
          [73.039306640625114, 18.039039611816406],
          [73.039581298828182, 18.03902626037609],
          [73.039581298828182, 18.039861679077205],
          [73.039855957031534, 18.039859771728629],
          [73.039855957031534, 18.040420532226562],
          [73.040138244628906, 18.040420532226562],
          [73.040138244628906, 18.041248321533203],
          [73.039863586426065, 18.041248321533203],
          [73.039863586426065, 18.042083740234318],
          [73.040138244628906, 18.042079925537166],
          [73.040138244628906, 18.042358398437557],
          [73.040412902832315, 18.042358398437557],
          [73.040412902832315, 18.042919158935661],
          [73.040695190429858, 18.042917251586914],
          [73.040695190429858, 18.043193817138672],
          [73.041252136230639, 18.043193817138672],
          [73.041252136230639, 18.043472290039062],
          [73.041526794433821, 18.043472290039062],
          [73.041526794433821, 18.043193817138672],
          [73.042915344238565, 18.043193817138672],
          [73.042915344238565, 18.042640686035099],
          [73.043197631835938, 18.042640686035099],
          [73.043197631835938, 18.042079925537166],
          [73.043472290039347, 18.042083740234318],
          [73.043472290039347, 18.041805267333984],
          [73.043746948242358, 18.041809082031307],
          [73.043746948242358, 18.041530609130916],
          [73.044288635254077, 18.041530609130916],
          [73.044288635254077, 18.041248321533203],
          [73.044578552246321, 18.041248321533203],
          [73.044578552246321, 18.040969848632812],
          [73.044860839843921, 18.040971755981388],
          [73.044860839843921, 18.040695190429801],
          [73.045135498046932, 18.040695190429801],
          [73.045135498046932, 18.040971755981388],
          [73.045417785644474, 18.040969848632812],
          [73.045417785644474, 18.041530609130916],
          [73.045143127441634, 18.041530609130916],
          [73.045143127441634, 18.041809082031307],
          [73.044860839843921, 18.041805267333984],
          [73.044860839843921, 18.042083740234318],
          [73.044578552246321, 18.042079925537166],
          [73.044578552246321, 18.042640686035099],
          [73.044288635254077, 18.042640686035099],
          [73.044288635254077, 18.042919158935661],
          [73.044029235840128, 18.042917251586914],
          [73.044029235840128, 18.043193817138672],
          [73.043746948242358, 18.043193817138672],
          [73.043746948242358, 18.043472290039062],
          [73.043472290039347, 18.043468475341911],
          [73.043472290039347, 18.043750762939453],
          [73.043197631835938, 18.043750762939453],
          [73.043197631835938, 18.04403114318842],
          [73.042358398437614, 18.04403114318842],
          [73.042358398437614, 18.04430961608881],
          [73.040702819824219, 18.04430961608881],
          [73.040702819824219, 18.04403114318842],
          [73.040412902832315, 18.04403114318842],
          [73.040412902832315, 18.043750762939453],
          [73.040138244628906, 18.043750762939453],
          [73.040138244628906, 18.043468475341911],
          [73.039863586426065, 18.043472290039062],
          [73.039863586426065, 18.043193817138672],
          [73.039581298828182, 18.043193817138672],
          [73.039581298828182, 18.042640686035099],
          [73.039306640625114, 18.042640686035099],
          [73.039306640625114, 18.042079925537166],
          [73.039024353027401, 18.042083740234318],
          [73.039024353027401, 18.040136337280273],
          [73.038749694824162, 18.040140151977596],
          [73.038749694824162, 18.039859771728629],
          [73.038475036621321, 18.039861679077205],
          [73.038475036621321, 18.039583206176815],
          [73.038192749023608, 18.039583206176815],
          [73.038192749023608, 18.03902626037609],
          [73.037918090820369, 18.039039611816406],
          [73.037918090820369, 18.038190841674918],
          [73.037635803222827, 18.038194656372127],
          [73.037635803222827, 18.037914276123104],
          [73.037361145019815, 18.037919998168888],
          [73.037361145019815, 18.037361145019531],
          [73.037086486816406, 18.037361145019531],
          [73.037086486816406, 18.037080764770565],
          [73.036804199219034, 18.037082672119141],
          [73.036804199219034, 18.03680419921875],
          [73.035972595214901, 18.036809921264705],
          [73.035972595214901, 18.036529541015739],
          [73.035720825195483, 18.036529541015739],
          [73.035697937011662, 18.036251068115178],
          [73.035423278808821, 18.036251068115178],
          [73.035423278808821, 18.035690307617244],
          [73.034858703613338, 18.035694122314396],
          [73.034858703613338, 18.035417556762809],
          [73.034576416015796, 18.035419464111385],
          [73.034576416015796, 18.035140991210994],
          [73.034301757812784, 18.035140991210994],
          [73.034301757812784, 18.034860610962028],
          [73.034027099609375, 18.034860610962028],
          [73.034027099609375, 18.034580230712891],
          [73.033752441406534, 18.034582138061467],
          [73.033752441406534, 18.034305572509879],
          [73.033470153808594, 18.034309387207031],
          [73.033470153808594, 18.033750534057674],
          [73.032913208007869, 18.033750534057674],
          [73.032913208007869, 18.033470153808707],
          [73.032638549804631, 18.033472061157283],
          [73.032638549804631, 18.033193588256893],
          [73.032081604004077, 18.033193588256893],
          [73.032081604004077, 18.032917022705135],
          [73.031524658203296, 18.032917022705135],
          [73.031524658203296, 18.032638549804744],
          [73.031250000000284, 18.03264045715332],
          [73.031250000000284, 18.032360076904354],
          [73.030975341796875, 18.032363891601562],
          [73.030975341796875, 18.032083511352539],
          [73.029586791992131, 18.032083511352539],
          [73.029586791992131, 18.032917022705135],
          [73.029304504394588, 18.032917022705135],
          [73.029304504394588, 18.033193588256893],
          [73.029029846191577, 18.033193588256893],
          [73.029029846191577, 18.033472061157283],
          [73.028747558593977, 18.033470153808707],
          [73.028747558593977, 18.033750534057674],
          [73.028198242187784, 18.033750534057674],
          [73.028198242187784, 18.034309387207031],
          [73.027915954590014, 18.034309387207031],
          [73.027915954590014, 18.035140991210994],
          [73.027641296387003, 18.035140991210994],
          [73.027641296387003, 18.035419464111385],
          [73.027359008789063, 18.035417556762809],
          [73.027359008789063, 18.035694122314396],
          [73.026542663574162, 18.035690307617244],
          [73.026542663574162, 18.036529541015739],
          [73.026802062988338, 18.036529541015739],
          [73.026802062988338, 18.037639617919922],
          [73.026542663574162, 18.037639617919922],
          [73.026542663574162, 18.037919998168888],
          [73.026252746582088, 18.037919998168888],
          [73.026252746582088, 18.037639617919922],
          [73.025138854980526, 18.037639617919922],
          [73.025138854980526, 18.037361145019531],
          [73.024307250976563, 18.037361145019531],
          [73.024307250976563, 18.037080764770565],
          [73.02402496337919, 18.037082672119141],
          [73.02402496337919, 18.03680419921875],
          [73.024307250976563, 18.036809921264705],
          [73.024307250976563, 18.036529541015739],
          [73.024581909179972, 18.036529541015739],
          [73.024581909179972, 18.036251068115178],
          [73.024032592773722, 18.036251068115178],
          [73.024032592773722, 18.036529541015739],
          [73.023468017578239, 18.036529541015739],
          [73.023468017578239, 18.036809921264705],
          [73.023193359375057, 18.03680419921875],
          [73.023193359375057, 18.037082672119141],
          [73.022636413574446, 18.037082672119141],
          [73.022636413574446, 18.03680419921875],
          [73.021530151367472, 18.03680419921875],
          [73.021530151367472, 18.039304733276481],
          [73.021804809570483, 18.039304733276481],
          [73.021804809570483, 18.039583206176815],
          [73.022361755371264, 18.039583206176815],
          [73.022361755371264, 18.039861679077205],
          [73.022636413574446, 18.039859771728629],
          [73.022636413574446, 18.040140151977596],
          [73.022918701171818, 18.040140151977596],
          [73.022918701171818, 18.040420532226562],
          [73.023193359375057, 18.040418624877987],
          [73.023193359375057, 18.040971755981388],
          [73.023468017578239, 18.040969848632812],
          [73.023468017578239, 18.041248321533203],
          [73.023750305175838, 18.041248321533203],
          [73.023750305175838, 18.041530609130916],
          [73.02402496337919, 18.041530609130916],
          [73.02402496337919, 18.042358398437557],
          [73.024581909179972, 18.042358398437557],
          [73.024581909179972, 18.042640686035099],
          [73.024856567382983, 18.042640686035099],
          [73.024856567382983, 18.042919158935661],
          [73.025138854980526, 18.042917251586914],
          [73.025138854980526, 18.043193817138672],
          [73.025413513183764, 18.043193817138672],
          [73.025413513183764, 18.043472290039062],
          [73.025695800781477, 18.043468475341911],
          [73.025695800781477, 18.043750762939453],
          [73.025970458984318, 18.043750762939453],
          [73.025970458984318, 18.044584274292049],
          [73.025695800781477, 18.044582366943416],
          [73.025695800781477, 18.045141220092773],
          [73.025970458984318, 18.045141220092773],
          [73.025970458984318, 18.045419692993164],
          [73.026252746582088, 18.045415878296012],
          [73.026252746582088, 18.045694351196403],
          [73.026802062988338, 18.045694351196403],
          [73.026802062988338, 18.045972824096737],
          [73.027359008789063, 18.045972824096737],
          [73.027359008789063, 18.046249389648551],
          [73.028472900390796, 18.046249389648551],
          [73.028472900390796, 18.046529769897518],
          [73.028747558593977, 18.046529769897518],
          [73.028747558593977, 18.046810150146484],
          [73.029304504394588, 18.046806335449332],
          [73.029304504394588, 18.04708290100092],
          [73.029861450195369, 18.04708290100092],
          [73.029861450195369, 18.04736137390131],
          [73.030693054199503, 18.047359466552734],
          [73.030693054199503, 18.047639846801871],
          [73.031806945800838, 18.047639846801871],
          [73.031806945800838, 18.047920227050838],
          [73.032913208007869, 18.047916412353516],
          [73.032913208007869, 18.048194885253906],
          [73.033195495605582, 18.048194885253906],
          [73.033195495605582, 18.048471450805664],
          [73.033752441406534, 18.048469543457088],
          [73.033752441406534, 18.048749923706055],
          [73.034027099609375, 18.048749923706055],
          [73.034027099609375, 18.049030303955021],
          [73.035140991211108, 18.049030303955021],
          [73.035140991211108, 18.049310684204158],
          [73.035972595214901, 18.049303054809627],
          [73.035972595214901, 18.049583435058594],
          [73.037635803222827, 18.049583435058594],
          [73.037635803222827, 18.049303054809627],
          [73.038749694824162, 18.049310684204158],
          [73.038749694824162, 18.049030303955021],
          [73.039306640625114, 18.049030303955021],
          [73.039306640625114, 18.048749923706055],
          [73.039581298828182, 18.048749923706055],
          [73.039581298828182, 18.049030303955021],
          [73.039863586426065, 18.049028396606445],
          [73.039863586426065, 18.049583435058594],
          [73.039581298828182, 18.049583435058594],
          [73.039581298828182, 18.049861907958984],
          [73.039855957031534, 18.049860000610408],
          [73.039855957031534, 18.050140380859375],
          [73.040138244628906, 18.050140380859375],
          [73.040138244628906, 18.050420761108342],
          [73.039855957031534, 18.050420761108342],
          [73.039855957031534, 18.051811218261662],
          [73.039581298828182, 18.051805496215934],
          [73.039581298828182, 18.052083969116325],
          [73.039855957031534, 18.052080154418945],
          [73.039855957031534, 18.052360534668082],
          [73.040138244628906, 18.052360534668082],
          [73.040138244628906, 18.05291938781744],
          [73.040412902832315, 18.052915573120117],
          [73.040412902832315, 18.053194046020451],
          [73.040138244628906, 18.053194046020451],
          [73.040138244628906, 18.053472518920842],
          [73.039855957031534, 18.053470611572266],
          [73.039855957031534, 18.053750991821232],
          [73.039016723632869, 18.053750991821232],
          [73.039016723632869, 18.053470611572266],
          [73.038749694824162, 18.053472518920842],
          [73.038749694824162, 18.052915573120117],
          [73.038482666015682, 18.05291938781744],
          [73.038482666015682, 18.052360534668082],
          [73.037918090820369, 18.052360534668082],
          [73.037918090820369, 18.052640914917049],
          [73.036796569824503, 18.052640914917049],
          [73.036796569824503, 18.052360534668082],
          [73.036247253418082, 18.052360534668082],
          [73.036247253418082, 18.052080154418945],
          [73.035697937011662, 18.052080154418945],
          [73.035697937011662, 18.052360534668082],
          [73.035423278808821, 18.052360534668082],
          [73.035423278808821, 18.052640914917049],
          [73.035140991211108, 18.052640914917049],
          [73.035140991211108, 18.052360534668082],
          [73.034858703613338, 18.052360534668082],
          [73.034858703613338, 18.052080154418945],
          [73.034584045410327, 18.052083969116325],
          [73.034584045410327, 18.051805496215934],
          [73.034858703613338, 18.051811218261662],
          [73.034858703613338, 18.051530838012695],
          [73.034301757812784, 18.051530838012695],
          [73.034301757812784, 18.051250457763729],
          [73.033752441406534, 18.051250457763729],
          [73.033752441406534, 18.050979614257869],
          [73.033470153808594, 18.050979614257869],
          [73.033470153808594, 18.050701141357536],
          [73.032913208007869, 18.050689697265625],
          [73.032913208007869, 18.05041694641119],
          [73.032348632812557, 18.050420761108342],
          [73.032348632812557, 18.050140380859375],
          [73.032081604004077, 18.050140380859375],
          [73.032081604004077, 18.050420761108342],
          [73.031806945800838, 18.050420761108342],
          [73.031806945800838, 18.050140380859375],
          [73.030982971191406, 18.050140380859375],
          [73.030982971191406, 18.049860000610408],
          [73.029861450195369, 18.049860000610408],
          [73.029861450195369, 18.050140380859375],
          [73.029289245605526, 18.050140380859375],
          [73.029289245605526, 18.050420761108342],
          [73.029029846191577, 18.05041694641119],
          [73.029029846191577, 18.050693511962947],
          [73.028472900390796, 18.050693511962947],
          [73.028472900390796, 18.05041694641119],
          [73.028198242187784, 18.050420761108342],
          [73.028198242187784, 18.04999923706049],
          [73.028190612793026, 18.049579620361442],
          [73.027359008789063, 18.049583435058594],
          [73.027359008789063, 18.049303054809627],
          [73.026252746582088, 18.049310684204158],
          [73.026252746582088, 18.050140380859375],
          [73.025970458984318, 18.050140380859375],
          [73.025970458984318, 18.050420761108342],
          [73.025138854980526, 18.050420761108342],
          [73.025138854980526, 18.050140380859375],
          [73.024856567382983, 18.050140380859375],
          [73.024856567382983, 18.049860000610408],
          [73.024581909179972, 18.049861907958984],
          [73.024581909179972, 18.048749923706055],
          [73.024856567382983, 18.048749923706055],
          [73.024856567382983, 18.048469543457088],
          [73.025413513183764, 18.048471450805664],
          [73.025413513183764, 18.048194885253906],
          [73.025138854980526, 18.048194885253906],
          [73.025138854980526, 18.047916412353516],
          [73.024856567382983, 18.047920227050838],
          [73.024856567382983, 18.047359466552734],
          [73.024581909179972, 18.04736137390131],
          [73.024581909179972, 18.046806335449332],
          [73.024307250976563, 18.046806335449332],
          [73.024307250976563, 18.04708290100092],
          [73.023750305175838, 18.04708290100092],
          [73.023750305175838, 18.046806335449332],
          [73.023468017578239, 18.046810150146484],
          [73.023468017578239, 18.045972824096737],
          [73.023193359375057, 18.045972824096737],
          [73.023193359375057, 18.045139312744197],
          [73.022918701171818, 18.045141220092773],
          [73.022918701171818, 18.044582366943416],
          [73.022636413574446, 18.044584274292049],
          [73.022636413574446, 18.044305801391658],
          [73.022918701171818, 18.04430961608881],
          [73.022918701171818, 18.043750762939453],
          [73.022636413574446, 18.043750762939453],
          [73.022636413574446, 18.042919158935661],
          [73.022087097168026, 18.042919158935661],
          [73.022087097168026, 18.042640686035099],
          [73.021797180175952, 18.042640686035099],
          [73.021797180175952, 18.042358398437557],
          [73.021247863769531, 18.042358398437557],
          [73.021247863769531, 18.041809082031307],
          [73.02097320556669, 18.041809082031307],
          [73.02097320556669, 18.040700912475529],
          [73.020408630371378, 18.040700912475529],
          [73.020408630371378, 18.040140151977596],
          [73.020141601562557, 18.040140151977596],
          [73.020141601562557, 18.039300918579102],
          [73.019859313964787, 18.039304733276481],
          [73.019859313964787, 18.038473129272461],
          [73.019584655761946, 18.038473129272461],
          [73.019584655761946, 18.037082672119141],
          [73.019302368164233, 18.037082672119141],
          [73.019302368164233, 18.03680419921875],
          [73.019027709960994, 18.036809921264705],
          [73.019027709960994, 18.036529541015739],
          [73.018753051757983, 18.036529541015739],
          [73.018753051757983, 18.035980224609318],
          [73.01847076416044, 18.035980224609318],
          [73.01847076416044, 18.034580230712891],
          [73.018196105957031, 18.034582138061467],
          [73.018196105957031, 18.033193588256893],
          [73.017913818359659, 18.033193588256893],
          [73.017913818359659, 18.032917022705135],
          [73.017364501953239, 18.032917022705135],
          [73.017364501953239, 18.032363891601562],
          [73.017082214355526, 18.032363891601562],
          [73.017082214355526, 18.032083511352539],
          [73.015693664550952, 18.032083511352539],
          [73.015693664550952, 18.032363891601562],
          [73.01541900634794, 18.032360076904354],
          [73.01541900634794, 18.03264045715332],
          [73.015136718750171, 18.032638549804744],
          [73.015136718750171, 18.032917022705135],
          [73.014579772949219, 18.032917022705135],
          [73.014579772949219, 18.033472061157283],
          [73.014312744140739, 18.033470153808707],
          [73.014312744140739, 18.034309387207031],
          [73.014030456543026, 18.034309387207031],
          [73.014030456543026, 18.034860610962028],
          [73.013465881347713, 18.034860610962028],
          [73.013465881347713, 18.035140991210994],
          [73.012916564941634, 18.035140991210994],
          [73.012916564941634, 18.035419464111385],
          [73.012641906738452, 18.035419464111385],
          [73.012641906738452, 18.035980224609318],
          [73.012359619140682, 18.035972595214787],
          [73.012359619140682, 18.037082672119141],
          [73.012084960937671, 18.037082672119141],
          [73.012092590332031, 18.038749694824276],
          [73.011802673340128, 18.038749694824276],
          [73.011802673340128, 18.039583206176815],
          [73.011528015136719, 18.039583206176815],
          [73.011528015136719, 18.039861679077205],
          [73.011253356933878, 18.039859771728629],
          [73.011253356933878, 18.040420532226562],
          [73.011528015136719, 18.040420532226562],
          [73.011528015136719, 18.040700912475529],
          [73.011253356933878, 18.040695190429801],
          [73.011253356933878, 18.040971755981388],
          [73.010971069335994, 18.040969848632812],
          [73.010971069335994, 18.041248321533203],
          [73.010696411132926, 18.041248321533203],
          [73.010696411132926, 18.041809082031307],
          [73.010139465331974, 18.041809082031307],
          [73.010139465331974, 18.042358398437557],
          [73.010406494140682, 18.042358398437557],
          [73.010406494140682, 18.042640686035099],
          [73.010696411132926, 18.042640686035099],
          [73.010696411132926, 18.043750762939453],
          [73.010406494140682, 18.043750762939453],
          [73.010406494140682, 18.04430961608881],
          [73.010139465331974, 18.044305801391658],
          [73.010139465331974, 18.044584274292049],
          [73.009857177734602, 18.044582366943416],
          [73.009857177734602, 18.045141220092773],
          [73.009582519531421, 18.045141220092773],
          [73.009582519531421, 18.045419692993164],
          [73.009307861328182, 18.045419692993164],
          [73.009307861328182, 18.046529769897518],
          [73.009033203125171, 18.046529769897518],
          [73.009033203125171, 18.047639846801871],
          [73.008750915527628, 18.047639846801871],
          [73.008750915527628, 18.048471450805664],
          [73.008468627929688, 18.048469543457088],
          [73.008468627929688, 18.048749923706055],
          [73.008178710937784, 18.048749923706055],
          [73.008178710937784, 18.049310684204158],
          [73.007919311523494, 18.049303054809627],
          [73.007919311523494, 18.049583435058594],
          [73.007637023925895, 18.049583435058594],
          [73.007637023925895, 18.049861907958984],
          [73.007362365722713, 18.049860000610408],
          [73.007362365722713, 18.050140380859375],
          [73.007080078124943, 18.050140380859375],
          [73.007080078124943, 18.050420761108342],
          [73.006530761718921, 18.050420761108342],
          [73.006530761718921, 18.050979614257869],
          [73.006248474121151, 18.050979614257869],
          [73.006248474121151, 18.051250457763729],
          [73.005966186523608, 18.051250457763729],
          [73.005966186523608, 18.051530838012695],
          [73.005691528320597, 18.051530838012695],
          [73.005691528320597, 18.051811218261662],
          [73.005416870117187, 18.051805496215934],
          [73.005416870117187, 18.052083969116325],
          [73.005142211914347, 18.052080154418945],
          [73.005142211914347, 18.052360534668082],
          [73.004859924316406, 18.052360534668082],
          [73.004859924316406, 18.052640914917049],
          [73.004302978515682, 18.052640914917049],
          [73.004302978515682, 18.05291938781744],
          [73.003753662109602, 18.052915573120117],
          [73.003753662109602, 18.053194046020451],
          [73.003196716308651, 18.053194046020451],
          [73.003196716308651, 18.053472518920842],
          [73.002372741699219, 18.053470611572266],
          [73.002372741699219, 18.05430984497076],
          [73.002082824707315, 18.054307937622184],
          [73.002082824707315, 18.054582595825195],
          [73.001525878906534, 18.054582595825195],
          [73.001525878906534, 18.054307937622184],
          [73.001251220703182, 18.05430984497076],
          [73.001251220703182, 18.053750991821232],
          [73.000968933105582, 18.053750991821232],
          [73.000968933105582, 18.053470611572266],
          [73.000694274902401, 18.053472518920842],
          [73.000694274902401, 18.052915573120117],
          [73.000419616699389, 18.05291938781744],
          [73.000419616699389, 18.051530838012695],
          [72.999862670898608, 18.051530838012695],
          [72.999862670898608, 18.051250457763729],
          [72.999580383300838, 18.051250457763729],
          [72.999580383300838, 18.050979614257869],
          [72.999313354492187, 18.050979614257869],
          [72.999313354492187, 18.050701141357536],
          [72.999031066894815, 18.050689697265625],
          [72.999031066894815, 18.05041694641119],
          [72.998748779296875, 18.050420761108342],
          [72.998748779296875, 18.050140380859375],
          [72.998466491699503, 18.050140380859375],
          [72.998466491699503, 18.049860000610408],
          [72.997917175293082, 18.049861907958984],
          [72.997917175293082, 18.049583435058594],
          [72.997360229492131, 18.049583435058594],
          [72.997360229492131, 18.049303054809627],
          [72.996879577636776, 18.049303054809627],
          [72.994857788086051, 18.049303054809627],
          [72.994857788086051, 18.049583435058594],
          [72.994308471679631, 18.049583435058594],
          [72.994308471679631, 18.049861907958984],
          [72.993751525879077, 18.049860000610408],
          [72.993751525879077, 18.050140380859375],
          [72.993469238281307, 18.050140380859375],
          [72.993469238281307, 18.051530838012695],
          [72.993179321289233, 18.051530838012695],
          [72.993179321289233, 18.051811218261662],
          [72.992919921875284, 18.051805496215934],
          [72.992919921875284, 18.052083969116325],
          [72.992637634277344, 18.052080154418945],
          [72.992637634277344, 18.052360534668082],
          [72.992080688476562, 18.052360534668082],
          [72.992080688476562, 18.052640914917049],
          [72.991806030273551, 18.052640914917049],
          [72.991806030273551, 18.05291938781744],
          [72.991531372070369, 18.052915573120117],
          [72.991531372070369, 18.053472518920842],
          [72.991249084472599, 18.053470611572266],
          [72.991249084472599, 18.053750991821232],
          [72.990966796875057, 18.053750991821232],
          [72.990966796875057, 18.05430984497076],
          [72.990692138672046, 18.054307937622184],
          [72.990692138672046, 18.054582595825195],
          [72.990417480468807, 18.054582595825195],
          [72.990417480468807, 18.05485916137701],
          [72.990135192871264, 18.05485916137701],
          [72.990142822265796, 18.055139541625977],
          [72.989860534668253, 18.055139541625977],
          [72.989860534668253, 18.055973052978516],
          [72.989585876464844, 18.055973052978516],
          [72.989585876464844, 18.057083129882869],
          [72.989860534668253, 18.057079315185547],
          [72.989860534668253, 18.058202743530387],
          [72.990135192871264, 18.058195114135856],
          [72.990135192871264, 18.058750152588004],
          [72.990432739258097, 18.058750152588004],
          [72.990432739258097, 18.05931282043457],
          [72.990692138672046, 18.05931282043457],
          [72.990692138672046, 18.061250686645508],
          [72.990966796875057, 18.061250686645508],
          [72.990966796875057, 18.061531066894474],
          [72.991249084472599, 18.061531066894474],
          [72.991249084472599, 18.061809539794865],
          [72.991531372070369, 18.061805725097713],
          [72.991531372070369, 18.062084197998104],
          [72.991806030273551, 18.062080383300895],
          [72.991806030273551, 18.062360763549862],
          [72.992080688476562, 18.062360763549862],
          [72.992080688476562, 18.062919616699219],
          [72.992362976074503, 18.062915802002067],
          [72.992362976074503, 18.063194274902457],
          [72.992637634277344, 18.063194274902457],
          [72.992637634277344, 18.063472747802791],
          [72.992919921875284, 18.063470840454215],
          [72.992919921875284, 18.063751220703182],
          [72.993194580078296, 18.063749313354606],
          [72.993194580078296, 18.064060211181754],
          [72.993194580078296, 18.064861297607365],
          [72.993469238281307, 18.064859390258789],
          [72.993469238281307, 18.066530227661076],
          [72.993751525879077, 18.066526412963924],
          [72.993751525879077, 18.066804885864315],
          [72.994308471679631, 18.066804885864315],
          [72.994308471679631, 18.067083358764648],
          [72.994583129882869, 18.067083358764648],
          [72.994583129882869, 18.067361831665039],
          [72.994857788086051, 18.067359924316463],
          [72.994857788086051, 18.06764030456543],
          [72.995140075683651, 18.06764030456543],
          [72.995140075683651, 18.067920684814396],
          [72.995407104492472, 18.067920684814396],
          [72.995407104492472, 18.068199157714787],
          [72.997436523437557, 18.068195343017635],
          [72.997642517089901, 18.068195343017635],
          [72.997642517089901, 18.068471908569393],
          [72.998191833496151, 18.06846809387207],
          [72.998191833496151, 18.068750381469783],
          [72.998474121094034, 18.068750381469783],
          [72.998474121094034, 18.069028854370174],
          [72.998748779296875, 18.069028854370174],
          [72.998748779296875, 18.069583892822379],
          [72.999031066894815, 18.069578170776424],
          [72.999031066894815, 18.069858551025391],
          [72.999313354492187, 18.069858551025391],
          [72.999313354492187, 18.070419311523494],
          [73.00013732910179, 18.070419311523494],
          [73.000419616699389, 18.070417404174918],
          [73.000419616699389, 18.070693969726506],
          [73.001525878906534, 18.070693969726506],
          [73.001525878906534, 18.070972442626896],
          [73.001808166503906, 18.070972442626896],
          [73.001808166503906, 18.071529388427848],
          [73.002082824707315, 18.071529388427848],
          [73.002082824707315, 18.072919845580998],
          [73.002357482910327, 18.072916030883846],
          [73.002357482910327, 18.074583053588924],
          [73.002639770508097, 18.074581146240348],
          [73.002639770508097, 18.075149536132869],
          [73.002906799316577, 18.075149536132869],
          [73.002906799316577, 18.075700759887638],
          [73.002639770508097, 18.075693130493107],
          [73.002639770508097, 18.075971603393498],
          [73.002082824707315, 18.075971603393498],
          [73.002082824707315, 18.07541656494152],
          [73.001251220703182, 18.075420379638672],
          [73.001251220703182, 18.075700759887638],
          [73.000968933105582, 18.075693130493107],
          [73.000968933105582, 18.075971603393498],
          [73.000686645507869, 18.075969696044922],
          [73.000686645507869, 18.076530456543026],
          [73.000419616699389, 18.076530456543026],
          [73.000419616699389, 18.076810836791992],
          [73.00013732910179, 18.076810836791992],
          [72.999862670898608, 18.076810836791992],
          [72.999862670898608, 18.073749542236385],
          [72.999580383300838, 18.073749542236385],
          [72.999580383300838, 18.074029922485352],
          [72.999313354492187, 18.074029922485352],
          [72.999313354492187, 18.074310302734318],
          [72.999031066894815, 18.074306488037166],
          [72.999031066894815, 18.074583053588924],
          [72.998748779296875, 18.074581146240348],
          [72.998748779296875, 18.075420379638672],
          [72.998466491699503, 18.075420379638672],
          [72.998466491699503, 18.076250076294059],
          [72.998191833496151, 18.076250076294059],
          [72.998191833496151, 18.076530456543026],
          [72.997642517089901, 18.076530456543026],
          [72.997642517089901, 18.076810836791992],
          [72.997360229492131, 18.076805114746094],
          [72.997360229492131, 18.078193664550781],
          [72.99708557128929, 18.078193664550781],
          [72.99708557128929, 18.078472137451172],
          [72.996803283691577, 18.078470230102596],
          [72.996803283691577, 18.079030990600529],
          [72.996528625488338, 18.079025268554801],
          [72.996528625488338, 18.079584121704158],
          [72.996803283691577, 18.07958030700695],
          [72.996803283691577, 18.080141067504883],
          [72.996528625488338, 18.080137252807731],
          [72.996528625488338, 18.080694198608512],
          [72.996246337890796, 18.080694198608512],
          [72.996246337890796, 18.082082748413029],
          [72.995971679687784, 18.082082748413029],
          [72.995971679687784, 18.083469390869197],
          [72.995697021484375, 18.083469390869197],
          [72.995697021484375, 18.084030151367131],
          [72.995414733887003, 18.084028244018555],
          [72.995414733887003, 18.084861755371094],
          [72.995140075683651, 18.084861755371094],
          [72.995140075683651, 18.085420608520451],
          [72.994857788086051, 18.085420608520451],
          [72.994857788086051, 18.085702896118221],
          [72.994583129882869, 18.085702896118221],
          [72.994583129882869, 18.086811065673771],
          [72.994308471679631, 18.086811065673771],
          [72.994308471679631, 18.087921142578125],
          [72.994026184082259, 18.087917327880973],
          [72.994026184082259, 18.088472366332951],
          [72.993751525879077, 18.088470458984375],
          [72.993751525879077, 18.089860916137695],
          [72.993469238281307, 18.089860916137695],
          [72.993469238281307, 18.090694427490291],
          [72.993179321289233, 18.090690612793082],
          [72.993179321289233, 18.091810226440373],
          [72.992919921875284, 18.091808319091797],
          [72.992919921875284, 18.092361450195369],
          [72.992637634277344, 18.092361450195369],
          [72.992637634277344, 18.093471527099553],
          [72.992362976074503, 18.093471527099553],
          [72.992362976074503, 18.094583511352482],
          [72.992080688476562, 18.09457969665533],
          [72.992080688476562, 18.095140457153263],
          [72.991806030273551, 18.095140457153263],
          [72.991806030273551, 18.095693588256836],
          [72.991531372070369, 18.095689773559684],
          [72.991531372070369, 18.096260070800781],
          [72.991249084472599, 18.096260070800781],
          [72.991249084472599, 18.096809387206974],
          [72.990966796875057, 18.096809387206974],
          [72.990966796875057, 18.09764289855957],
          [72.990692138672046, 18.097639083862362],
          [72.990692138672046, 18.098194122314567],
          [72.990432739258097, 18.098190307617187],
          [72.990432739258097, 18.099029541015682],
          [72.990135192871264, 18.099027633667106],
          [72.990135192871264, 18.099582672119084],
          [72.989860534668253, 18.099582672119084],
          [72.989860534668253, 18.100139617920036],
          [72.989585876464844, 18.100139617920036],
          [72.989585876464844, 18.100419998169002],
          [72.989303588867472, 18.10041618347168],
          [72.989303588867472, 18.10069465637207],
          [72.989028930664063, 18.10069465637207],
          [72.989028930664063, 18.100973129272404],
          [72.98874664306669, 18.100971221923828],
          [72.98874664306669, 18.101249694824219],
          [72.988471984863338, 18.101249694824219],
          [72.988471984863338, 18.101530075073185],
          [72.988197326660099, 18.101528167724609],
          [72.988197326660099, 18.101804733276424],
          [72.987915039062557, 18.101804733276424],
          [72.987915039062557, 18.102083206176758],
          [72.986526489257983, 18.102083206176758],
          [72.986526489257983, 18.101804733276424],
          [72.98569488525419, 18.101804733276424],
          [72.98569488525419, 18.102083206176758],
          [72.985137939453239, 18.102083206176758],
          [72.985137939453239, 18.102361679077148],
          [72.984580993652287, 18.102359771728572],
          [72.984580993652287, 18.102640151977539],
          [72.984008789062443, 18.102640151977539],
          [72.984008789062443, 18.102920532226506],
          [72.983474731445483, 18.102916717529354],
          [72.983474731445483, 18.103471755981502],
          [72.98319244384794, 18.103469848632926],
          [72.98319244384794, 18.104030609130859],
          [72.982917785644531, 18.104030609130859],
          [72.982917785644531, 18.104310989379826],
          [72.982635498047159, 18.104305267334098],
          [72.982635498047159, 18.105138778686637],
          [72.982360839843807, 18.105131149292106],
          [72.982360839843807, 18.10542106628418],
          [72.982086181640739, 18.105415344238281],
          [72.982086181640739, 18.105693817138615],
          [72.980972290039233, 18.105690002441463],
          [72.980972290039233, 18.106250762939396],
          [72.980697631835994, 18.106250762939396],
          [72.980697631835994, 18.106809616088924],
          [72.980415344238452, 18.106807708740348],
          [72.980422973632983, 18.10736083984375],
          [72.98014068603544, 18.10736083984375],
          [72.98014068603544, 18.107641220092717],
          [72.979576110840128, 18.107641220092717],
          [72.979576110840128, 18.107919692993107],
          [72.979309082031307, 18.107919692993107],
          [72.979309082031307, 18.108198165893668],
          [72.979026794433707, 18.108194351196346],
          [72.979026794433707, 18.109861373901424],
          [72.978752136230526, 18.109861373901424],
          [72.978752136230526, 18.111810684204102],
          [72.979026794433707, 18.111804962158203],
          [72.979026794433707, 18.112083435058537],
          [72.979309082031307, 18.112079620361385],
          [72.979309082031307, 18.113750457763672],
          [72.979026794433707, 18.113750457763672],
          [72.979026794433707, 18.114030838012638],
          [72.978202819824446, 18.114030838012638],
          [72.978202819824446, 18.11432075500494],
          [72.977081298828409, 18.11432075500494],
          [72.977081298828409, 18.114860534668026],
          [72.976806640625, 18.114860534668026],
          [72.976806640625, 18.115972518920955],
          [72.977081298828409, 18.115972518920955],
          [72.977081298828409, 18.117082595825138],
          [72.977355957031421, 18.117071151733455],
          [72.977355957031421, 18.117361068725529],
          [72.977081298828409, 18.117361068725529],
          [72.977081298828409, 18.117919921875057],
          [72.976806640625, 18.117914199829102],
          [72.976806640625, 18.118473052978459],
          [72.976516723633097, 18.118471145629883],
          [72.976516723633097, 18.11902999877924],
          [72.976806640625, 18.119026184082088],
          [72.976806640625, 18.119583129882812],
          [72.976516723633097, 18.119581222534237],
          [72.976516723633097, 18.120138168335018],
          [72.976249694824219, 18.120138168335018],
          [72.976249694824219, 18.120700836181754],
          [72.975982666015739, 18.120700836181754],
          [72.975982666015739, 18.121810913085881],
          [72.975692749023494, 18.121810913085881],
          [72.975692749023494, 18.122358322143555],
          [72.975433349609546, 18.122358322143555],
          [72.975433349609546, 18.122919082641658],
          [72.975135803222713, 18.122919082641658],
          [72.975135803222713, 18.123199462890625],
          [72.974586486816463, 18.12319374084467],
          [72.974586486816463, 18.12347221374506],
          [72.974304199218921, 18.12347221374506],
          [72.974304199218921, 18.12319374084467],
          [72.974029541015909, 18.12319374084467],
          [72.974029541015909, 18.12347221374506],
          [72.973747253418139, 18.123468399047908],
          [72.973747253418139, 18.123750686645451],
          [72.973197937011719, 18.123750686645451],
          [72.973197937011719, 18.124029159546012],
          [72.972923278808707, 18.124029159546012],
          [72.972923278808707, 18.124309539794979],
          [72.972640991210994, 18.124309539794979],
          [72.972640991210994, 18.124862670898381],
          [72.972358703613395, 18.124862670898381],
          [72.972358703613395, 18.126529693603516],
          [72.972152709961222, 18.126529693603516],
          [72.972068786621151, 18.127639770507869],
          [72.971809387207202, 18.127639770507869],
          [72.971801757812443, 18.129861831664982],
          [72.971527099609602, 18.129861831664982],
          [72.971527099609602, 18.130971908569336],
          [72.971252441406421, 18.130971908569336],
          [72.971252441406421, 18.132083892822322],
          [72.970970153808651, 18.132080078125114],
          [72.970970153808651, 18.132921218872013],
          [72.972640991210994, 18.132921218872013],
          [72.972640991210994, 18.132640838623047],
          [72.972923278808707, 18.132640838623047],
          [72.972923278808707, 18.132921218872013],
          [72.973197937011719, 18.132915496826286],
          [72.973197937011719, 18.13347244262701],
          [72.973472595215128, 18.133470535278434],
          [72.973472595215128, 18.133750915527401],
          [72.973747253418139, 18.133750915527401],
          [72.973747253418139, 18.134220123291072],
          [72.973747253418139, 18.134307861328182],
          [72.974861145019702, 18.134307861328182],
          [72.974861145019702, 18.134582519531193],
          [72.975418090820256, 18.134582519531193],
          [72.975418090820256, 18.134859085083008],
          [72.975975036621207, 18.134859085083008],
          [72.975975036621207, 18.135137557983398],
          [72.976516723633097, 18.135137557983398],
          [72.976516723633097, 18.135429382324276],
          [72.978469848632756, 18.135417938232536],
          [72.978469848632756, 18.13569450378418],
          [72.979026794433707, 18.13569450378418],
          [72.979026794433707, 18.135972976684513],
          [72.979309082031307, 18.135969161987362],
          [72.979309082031307, 18.136251449584904],
          [72.9798583984375, 18.136251449584904],
          [72.9798583984375, 18.136531829834098],
          [72.980972290039233, 18.136529922485295],
          [72.980972290039233, 18.136800765991325],
          [72.981529235839787, 18.136806488037109],
          [72.981529235839787, 18.137083053588867],
          [72.981803894043026, 18.137083053588867],
          [72.981803894043026, 18.140972137451115],
          [72.982086181640739, 18.140970230102539],
          [72.982086181640739, 18.141530990600643],
          [72.982360839843807, 18.14152717590332],
          [72.982360839843807, 18.142084121704102],
          [72.982635498047159, 18.142084121704102],
          [72.982635498047159, 18.142360687255859],
          [72.983467102050952, 18.142360687255859],
          [72.983467102050952, 18.142641067504826],
          [72.984863281250057, 18.142641067504826],
          [72.984863281250057, 18.142919540405217],
          [72.985137939453239, 18.142915725708065],
          [72.985137939453239, 18.143472671508789],
          [72.985420227050838, 18.143470764160213],
          [72.985420227050838, 18.147367477416992],
          [72.98569488525419, 18.147361755371037],
          [72.98569488525419, 18.148471832275391],
          [72.985969543457031, 18.148469924926815],
          [72.985969543457031, 18.148748397827205],
          [72.986251831054972, 18.148748397827205],
          [72.986251831054972, 18.149030685424748],
          [72.986808776855753, 18.149028778076172],
          [72.986808776855753, 18.149583816528377],
          [72.986526489257983, 18.149578094482422],
          [72.986526489257983, 18.150140762329102],
          [72.986251831054972, 18.150140762329102],
          [72.986251831054972, 18.150972366333065],
          [72.985969543457031, 18.150968551635742],
          [72.985969543457031, 18.151531219482422],
          [72.98569488525419, 18.15152740478527],
          [72.98569488525419, 18.152082443237248],
          [72.985969543457031, 18.152082443237248],
          [72.985969543457031, 18.1526393890382],
          [72.98569488525419, 18.1526393890382],
          [72.98569488525419, 18.153472900390568],
          [72.985420227050838, 18.153472900390568],
          [72.985420227050838, 18.154310226440487],
          [72.985687255859659, 18.154310226440487],
          [72.985687255859659, 18.155139923095703],
          [72.985969543457031, 18.155139923095703],
          [72.985969543457031, 18.155700683593864],
          [72.986251831054972, 18.155700683593864],
          [72.986251831054972, 18.15681076049799],
          [72.986526489257983, 18.156803131103459],
          [72.986526489257983, 18.157361984252987],
          [72.986808776855753, 18.157360076904411],
          [72.986808776855753, 18.157640457153377],
          [72.987075805664233, 18.157640457153377],
          [72.987075805664233, 18.157920837402344],
          [72.987922668457259, 18.157920837402344],
          [72.987922668457259, 18.157640457153377],
          [72.98874664306669, 18.157640457153377],
          [72.98874664306669, 18.157360076904411],
          [72.989860534668253, 18.157360076904411],
          [72.989860534668253, 18.157640457153377],
          [72.990142822265796, 18.157640457153377],
          [72.990142822265796, 18.157920837402344],
          [72.990417480468807, 18.157915115356445],
          [72.990417480468807, 18.159860610961914],
          [72.990135192871264, 18.159860610961914],
          [72.990135192871264, 18.159584045410156],
          [72.989303588867472, 18.159584045410156],
          [72.989303588867472, 18.159305572509766],
          [72.988471984863338, 18.159309387207088],
          [72.988471984863338, 18.159860610961914],
          [72.987922668457259, 18.159860610961914],
          [72.987922668457259, 18.160419464111271],
          [72.987640380859546, 18.160419464111271],
          [72.987640380859546, 18.161529541015625],
          [72.987358093261946, 18.161529541015625],
          [72.987358093261946, 18.163194656372184],
          [72.987075805664233, 18.163190841674805],
          [72.987075805664233, 18.164030075073299],
          [72.986808776855753, 18.164028167724723],
          [72.986808776855753, 18.164861679077092],
          [72.986526489257983, 18.164861679077092],
          [72.986526489257983, 18.165702819824219],
          [72.986251831054972, 18.165702819824219],
          [72.986251831054972, 18.167640686035156],
          [72.985969543457031, 18.16763877868658],
          [72.985969543457031, 18.168193817138786],
          [72.985687255859659, 18.168180465698299],
          [72.985687255859659, 18.16875076293951],
          [72.985420227050838, 18.16875076293951],
          [72.985420227050838, 18.170419692993221],
          [72.985137939453239, 18.170415878295898],
          [72.985137939453239, 18.170972824096623],
          [72.984863281250057, 18.170970916748047],
          [72.984863281250057, 18.171541213989315],
          [72.984580993652287, 18.171527862548828],
          [72.984580993652287, 18.173471450805721],
          [72.984306335449446, 18.173471450805721],
          [72.984306335449446, 18.174861907959041],
          [72.984008789062443, 18.174858093261719],
          [72.984008789062443, 18.175420761108398],
          [72.983749389648494, 18.175418853759822],
          [72.983749389648494, 18.175689697265682],
          [72.983467102050952, 18.175699234008789],
          [72.983467102050952, 18.176530838012752],
          [72.983749389648494, 18.176528930664176],
          [72.983749389648494, 18.177083969116211],
          [72.983474731445483, 18.177083969116211],
          [72.983474731445483, 18.177358627319393],
          [72.98319244384794, 18.177349090576286],
          [72.98319244384794, 18.177919387817326],
          [72.982917785644531, 18.177919387817326],
          [72.982917785644531, 18.178752899169922],
          [72.98264312744169, 18.178752899169922],
          [72.98264312744169, 18.179309844970646],
          [72.982360839843807, 18.179309844970646],
          [72.982360839843807, 18.180139541626033],
          [72.982086181640739, 18.180139541626033],
          [72.982086181640739, 18.182083129882756],
          [72.981796264648494, 18.18208122253418],
          [72.981796264648494, 18.182920455932674],
          [72.981529235839787, 18.182920455932674],
          [72.981529235839787, 18.183481216430664],
          [72.981246948242415, 18.1834716796875],
          [72.981246948242415, 18.184583663940487],
          [72.980972290039233, 18.184579849243278],
          [72.980972290039233, 18.185140609741211],
          [72.980697631835994, 18.185140609741211],
          [72.980697631835994, 18.185420989990178],
          [72.980415344238452, 18.18541526794445],
          [72.980422973632983, 18.186250686645565],
          [72.98014068603544, 18.186250686645565],
          [72.98014068603544, 18.187360763549748],
          [72.9798583984375, 18.187360763549748],
          [72.9798583984375, 18.188751220703068],
          [72.979576110840128, 18.188751220703068],
          [72.979576110840128, 18.18930816650402],
          [72.979309082031307, 18.18930816650402],
          [72.979309082031307, 18.192640304565487],
          [72.979026794433707, 18.192638397216911],
          [72.979026794433707, 18.193473815918082],
          [72.979309082031307, 18.193471908569279],
          [72.979309082031307, 18.19375038146967],
          [72.979576110840128, 18.19375038146967],
          [72.979576110840128, 18.194030761718807],
          [72.98014068603544, 18.194030761718807],
          [72.98014068603544, 18.19375038146967],
          [72.980422973632983, 18.19375038146967],
          [72.980415344238452, 18.193473815918082],
          [72.980697631835994, 18.193473815918082],
          [72.980697631835994, 18.193195343017692],
          [72.981239318847713, 18.193201065063477],
          [72.981239318847713, 18.192920684814453],
          [72.982360839843807, 18.192920684814453],
          [72.982360839843807, 18.193201065063477],
          [72.98319244384794, 18.193201065063477],
          [72.98319244384794, 18.192920684814453],
          [72.983749389648494, 18.192920684814453],
          [72.983749389648494, 18.192640304565487],
          [72.984863281250057, 18.192640304565487],
          [72.984863281250057, 18.192920684814453],
          [72.985137939453239, 18.192920684814453],
          [72.985137939453239, 18.192640304565487],
          [72.985420227050838, 18.192640304565487],
          [72.985420227050838, 18.192920684814453],
          [72.98569488525419, 18.192916870117301],
          [72.98569488525419, 18.193473815918082],
          [72.987640380859546, 18.193471908569279],
          [72.987640380859546, 18.194030761718807],
          [72.987922668457259, 18.194030761718807],
          [72.987922668457259, 18.19431114196783],
          [72.987640380859546, 18.19431114196783],
          [72.987640380859546, 18.19514083862299],
          [72.987373352050838, 18.19514083862299],
          [72.987373352050838, 18.195421218872184],
          [72.984580993652287, 18.195421218872184],
          [72.984580993652287, 18.19514083862299],
          [72.984298706054915, 18.19514083862299],
          [72.984298706054915, 18.195421218872184],
          [72.984008789062443, 18.195421218872184],
          [72.984008789062443, 18.19514083862299],
          [72.982917785644531, 18.19514083862299],
          [72.982917785644531, 18.194860458374023],
          [72.98264312744169, 18.194860458374023],
          [72.98264312744169, 18.19514083862299],
          [72.982086181640739, 18.19514083862299],
          [72.982086181640739, 18.195421218872184],
          [72.981246948242415, 18.195417404174805],
          [72.981246948242415, 18.195972442626953],
          [72.980415344238452, 18.195972442626953],
          [72.980422973632983, 18.196250915527344],
          [72.98014068603544, 18.196250915527344],
          [72.98014068603544, 18.196529388427734],
          [72.9798583984375, 18.196529388427734],
          [72.9798583984375, 18.196809768676701],
          [72.979583740234659, 18.196804046630973],
          [72.979583740234659, 18.197082519531307],
          [72.979309082031307, 18.197080612182731],
          [72.979309082031307, 18.197360992431697],
          [72.979026794433707, 18.197360992431697],
          [72.979026794433707, 18.197639465332088],
          [72.978752136230526, 18.197639465332088],
          [72.978752136230526, 18.197919845581055],
          [72.978469848632756, 18.197914123535099],
          [72.978469848632756, 18.198194503784293],
          [72.978202819824446, 18.198190689086914],
          [72.978202819824446, 18.198480606079215],
          [72.977638244628963, 18.198480606079215],
          [72.977638244628963, 18.199310302734375],
          [72.977363586425952, 18.199308395385799],
          [72.977363586425952, 18.19958305358881],
          [72.977081298828409, 18.199581146240234],
          [72.977081298828409, 18.200138092041016],
          [72.976806640625, 18.200138092041016],
          [72.976806640625, 18.200420379638729],
          [72.976249694824219, 18.200420379638729],
          [72.976249694824219, 18.200700759887752],
          [72.975418090820256, 18.200696945190543],
          [72.975418090820256, 18.200971603393555],
          [72.975135803222713, 18.200969696044979],
          [72.975135803222713, 18.201248168945369],
          [72.974861145019702, 18.201248168945369],
          [72.974861145019702, 18.201530456542912],
          [72.974586486816463, 18.201520919799805],
          [72.974586486816463, 18.201810836792106],
          [72.974304199218921, 18.201805114746151],
          [72.974304199218921, 18.202083587646541],
          [72.973747253418139, 18.202083587646541],
          [72.973747253418139, 18.202362060546875],
          [72.973472595215128, 18.202358245849723],
          [72.973472595215128, 18.202640533447266],
          [72.973197937011719, 18.202640533447266],
          [72.973197937011719, 18.203193664550895],
          [72.972915649414347, 18.203193664550895],
          [72.972915649414347, 18.203470230102653],
          [72.972358703613395, 18.203468322753906],
          [72.972358703613395, 18.203750610351619],
          [72.971527099609602, 18.203750610351619],
          [72.971527099609602, 18.203468322753906],
          [72.971252441406421, 18.203470230102653],
          [72.971252441406421, 18.203193664550895],
          [72.970970153808651, 18.203193664550895],
          [72.970970153808651, 18.203470230102653],
          [72.970413208008097, 18.203468322753906],
          [72.970413208008097, 18.203750610351619],
          [72.970138549804687, 18.203750610351619],
          [72.970138549804687, 18.204584121704215],
          [72.969856262207315, 18.204580307006836],
          [72.969856262207315, 18.20514106750494],
          [72.969581604003963, 18.20514106750494],
          [72.969581604003963, 18.20541954040533],
          [72.969299316406364, 18.20541954040533],
          [72.969299316406364, 18.20514106750494],
          [72.968193054199389, 18.20514106750494],
          [72.968193054199389, 18.20541954040533],
          [72.967918395996151, 18.20541954040533],
          [72.967918395996151, 18.206251144409123],
          [72.967636108398608, 18.206251144409123],
          [72.967636108398608, 18.206809997558651],
          [72.967361450195597, 18.206806182861328],
          [72.967361450195597, 18.207082748413086],
          [72.967086791992188, 18.207082748413086],
          [72.967086791992188, 18.207639694213867],
          [72.966804504394815, 18.207639694213867],
          [72.966804504394815, 18.208194732666072],
          [72.966529846191463, 18.208194732666072],
          [72.966529846191463, 18.209304809570426],
          [72.966247558593864, 18.209304809570426],
          [72.966247558593864, 18.209861755371151],
          [72.965972900390682, 18.209859848022575],
          [72.965972900390682, 18.210140228271541],
          [72.965698242187443, 18.210140228271541],
          [72.965698242187443, 18.210420608520508],
          [72.965415954590071, 18.210420608520508],
          [72.965415954590071, 18.210710525512809],
          [72.965141296386889, 18.210695266723746],
          [72.965141296386889, 18.210971832275334],
          [72.964859008789119, 18.210969924926758],
          [72.964859008789119, 18.211530685424862],
          [72.964576721191577, 18.211530685424862],
          [72.964576721191577, 18.211811065673885],
          [72.964302062988565, 18.21180534362793],
          [72.964302062988565, 18.21208381652832],
          [72.962638854980412, 18.212080001831112],
          [72.962638854980412, 18.212360382080078],
          [72.962356567382869, 18.212360382080078],
          [72.962356567382869, 18.212921142578239],
          [72.962081909179858, 18.212915420532283],
          [72.962081909179858, 18.213193893432674],
          [72.961807250976619, 18.213193893432674],
          [72.961807250976619, 18.213472366333008],
          [72.961524963379077, 18.213472366333008],
          [72.961524963379077, 18.213750839233398],
          [72.960983276367188, 18.213750839233398],
          [72.960983276367188, 18.214031219482365],
          [72.960693359375284, 18.214031219482365],
          [72.960693359375284, 18.214309692382756],
          [72.960418701171875, 18.21430778503418],
          [72.960418701171875, 18.214582443237362],
          [72.960128784179972, 18.214580535888786],
          [72.960128784179972, 18.214860916137752],
          [72.959861755371151, 18.214860916137752],
          [72.959861755371151, 18.215419769287109],
          [72.959587097167912, 18.215415954589957],
          [72.959587097167912, 18.215694427490348],
          [72.959297180175838, 18.215690612792969],
          [72.959297180175838, 18.21624755859375],
          [72.959030151367358, 18.21624755859375],
          [72.959030151367358, 18.21681022644043],
          [72.958747863769759, 18.216806411743278],
          [72.958747863769759, 18.217081069946289],
          [72.958190917968807, 18.217081069946289],
          [72.958190917968807, 18.217361450195256],
          [72.957916259765796, 18.217361450195256],
          [72.957916259765796, 18.217920303344783],
          [72.957359313964844, 18.217920303344783],
          [72.957359313964844, 18.218202590942383],
          [72.957084655762003, 18.218194961547852],
          [72.957084655762003, 18.218469619751033],
          [72.956802368164119, 18.218469619751033],
          [72.956802368164119, 18.218751907348576],
          [72.956527709961051, 18.218751907348576],
          [72.956527709961051, 18.219030380248967],
          [72.956253051757869, 18.219030380248967],
          [72.956253051757869, 18.219310760498161],
          [72.955696105957259, 18.219310760498161],
          [72.955696105957259, 18.219591140747127],
          [72.953475952148551, 18.219591140747127],
          [72.953475952148551, 18.219310760498161],
          [72.953186035156307, 18.219310760498161],
          [72.953186035156307, 18.219030380248967],
          [72.952919006347599, 18.219030380248967],
          [72.952919006347599, 18.218751907348576],
          [72.951812744140796, 18.218751907348576],
          [72.951812744140796, 18.219030380248967],
          [72.951530456543253, 18.219030380248967],
          [72.951530456543253, 18.219310760498161],
          [72.951248168945313, 18.219305038452205],
          [72.951248168945313, 18.219863891601563],
          [72.95096588134794, 18.219860076904354],
          [72.95096588134794, 18.220420837402287],
          [72.950691223144531, 18.220417022705135],
          [72.950691223144531, 18.22069358825695],
          [72.95041656494152, 18.22069358825695],
          [72.95041656494152, 18.220972061157283],
          [72.950141906738338, 18.220970153808707],
          [72.950141906738338, 18.221250534057674],
          [72.949859619140568, 18.221250534057674],
          [72.949859619140568, 18.221530914306641],
          [72.949302673340014, 18.221530914306641],
          [72.949302673340014, 18.221809387207031],
          [72.948471069336222, 18.221805572509879],
          [72.948471069336222, 18.222082138061467],
          [72.947906494140909, 18.222080230712891],
          [72.947906494140909, 18.222360610961857],
          [72.947357177734659, 18.222360610961857],
          [72.947357177734659, 18.222650527954158],
          [72.947082519531307, 18.222650527954158],
          [72.947082519531307, 18.222919464111385],
          [72.946525573730526, 18.222917556762809],
          [72.946525573730526, 18.223194122314453],
          [72.944580078125, 18.223194122314453],
          [72.944580078125, 18.222639083862418],
          [72.94431304931652, 18.222650527954158],
          [72.94431304931652, 18.222360610961857],
          [72.943748474121207, 18.222360610961857],
          [72.943748474121207, 18.222080230712891],
          [72.943191528320256, 18.222082138061467],
          [72.943191528320256, 18.221805572509879],
          [72.942916870117415, 18.221809387207031],
          [72.942916870117415, 18.22014045715332],
          [72.942642211914233, 18.22014045715332],
          [72.942642211914233, 18.219860076904354],
          [72.941802978515909, 18.219860076904354],
          [72.941802978515909, 18.22014045715332],
          [72.941246032715128, 18.22014045715332],
          [72.941246032715128, 18.219860076904354],
          [72.940971374511776, 18.219863891601563],
          [72.940971374511776, 18.219583511352596],
          [72.940406799316463, 18.219591140747127],
          [72.940406799316463, 18.219310760498161],
          [72.939315795898722, 18.219310760498161],
          [72.939315795898722, 18.219030380248967],
          [72.939025878906421, 18.219030380248967],
          [72.939025878906421, 18.218202590942383],
          [72.939315795898722, 18.218202590942383],
          [72.939315795898722, 18.21681022644043],
          [72.938194274902628, 18.216806411743278],
          [72.938194274902628, 18.217081069946289],
          [72.937362670898494, 18.217081069946289],
          [72.937362670898494, 18.216806411743278],
          [72.935691833496378, 18.216806411743278],
          [72.935691833496378, 18.217081069946289],
          [72.935417175292969, 18.217081069946289],
          [72.935417175292969, 18.217361450195256],
          [72.934860229492188, 18.217361450195256],
          [72.934860229492188, 18.21764183044445],
          [72.933746337890682, 18.21764183044445],
          [72.933746337890682, 18.217920303344783],
          [72.933189392090071, 18.217920303344783],
          [72.933189392090071, 18.218202590942383],
          [72.932640075683878, 18.218194961547852],
          [72.932640075683878, 18.218469619751033],
          [72.932357788086108, 18.218469619751033],
          [72.932357788086108, 18.218751907348576],
          [72.932083129883097, 18.218751907348576],
          [72.932083129883097, 18.219030380248967],
          [72.931808471679688, 18.219030380248967],
          [72.931808471679688, 18.219310760498161],
          [72.931526184082315, 18.219305038452205],
          [72.931526184082315, 18.219863891601563],
          [72.931251525878963, 18.219860076904354],
          [72.931251525878963, 18.220420837402287],
          [72.930969238281364, 18.220417022705135],
          [72.930969238281364, 18.220649719238281],
          [72.930969238281364, 18.221250534057674],
          [72.931251525878963, 18.221250534057674],
          [72.931251525878963, 18.221530914306641],
          [72.930969238281364, 18.221530914306641],
          [72.930969238281364, 18.223751068115178],
          [72.931251525878963, 18.223751068115178],
          [72.931251525878963, 18.224029541015568],
          [72.931808471679688, 18.224029541015568],
          [72.931808471679688, 18.224309921264705],
          [72.932876586914176, 18.224304199218807],
          [72.933197021484432, 18.224304199218807],
          [72.933197021484432, 18.224582672119141],
          [72.933471679687671, 18.224582672119141],
          [72.933471679687671, 18.22543907165533],
          [72.933471679687671, 18.225973129272518],
          [72.933746337890682, 18.225971221923885],
          [72.933746337890682, 18.226530075073242],
          [72.934028625488224, 18.226530075073242],
          [72.934028625488224, 18.22763824462902],
          [72.934303283691463, 18.227636337280273],
          [72.934303283691463, 18.228471755981388],
          [72.934593200683707, 18.228460311889705],
          [72.934593200683707, 18.229030609130916],
          [72.934860229492188, 18.229030609130916],
          [72.934860229492188, 18.229309082031307],
          [72.935142517090128, 18.229305267333984],
          [72.935142517090128, 18.229583740234375],
          [72.935417175292969, 18.229579925537166],
          [72.935417175292969, 18.229858398437557],
          [72.935691833496378, 18.229858398437557],
          [72.935691833496378, 18.230140686035099],
          [72.936248779296932, 18.230140686035099],
          [72.936248779296932, 18.23041915893549],
          [72.937080383300724, 18.230417251586914],
          [72.937080383300724, 18.230693817138729],
          [72.937362670898494, 18.230693817138729],
          [72.937362670898494, 18.230972290039063],
          [72.937637329101676, 18.230968475341911],
          [72.937637329101676, 18.232641220092773],
          [72.937919616699276, 18.232641220092773],
          [72.937919616699276, 18.232919692993164],
          [72.938468933105469, 18.232915878296012],
          [72.938468933105469, 18.233194351196403],
          [72.939308166503963, 18.233194351196403],
          [72.939308166503963, 18.232915878296012],
          [72.939857482910384, 18.232915878296012],
          [72.939857482910384, 18.233194351196403],
          [72.940139770507756, 18.233194351196403],
          [72.940139770507756, 18.233472824096793],
          [72.940696716308707, 18.233472824096793],
          [72.940696716308707, 18.233749389648551],
          [72.940971374511776, 18.233749389648551],
          [72.940971374511776, 18.234029769897518],
          [72.941246032715128, 18.234029769897518],
          [72.941246032715128, 18.234590530395508],
          [72.9415283203125, 18.234584808349723],
          [72.9415283203125, 18.237361907958984],
          [72.941253662109659, 18.237361907958984],
          [72.941253662109659, 18.238471984863338],
          [72.940971374511776, 18.238470077514762],
          [72.940971374511776, 18.238750457763729],
          [72.940696716308707, 18.238750457763729],
          [72.940696716308707, 18.239030838012695],
          [72.940406799316463, 18.239030838012695],
          [72.940406799316463, 18.239860534667912],
          [72.940139770507756, 18.239860534667912],
          [72.940139770507756, 18.242082595825195],
          [72.939857482910384, 18.242082595825195],
          [72.939857482910384, 18.243194580078182],
          [72.940414428710994, 18.243194580078182],
          [72.940414428710994, 18.243473052978572],
          [72.940696716308707, 18.243469238281364],
          [72.940696716308707, 18.243751525878906],
          [72.940971374511776, 18.243751525878906],
          [72.940971374511776, 18.244304656982536],
          [72.941246032715128, 18.244300842285156],
          [72.941246032715128, 18.245140075683651],
          [72.940971374511776, 18.245140075683651],
          [72.940971374511776, 18.245420455932617],
          [72.9415283203125, 18.245420455932617],
          [72.9415283203125, 18.245702743530387],
          [72.941802978515909, 18.245695114135856],
          [72.941802978515909, 18.245973587036246],
          [72.942085266113452, 18.245973587036246],
          [72.942085266113452, 18.246250152587834],
          [72.942359924316463, 18.246250152587834],
          [72.942359924316463, 18.246820449829102],
          [72.942642211914233, 18.246820449829102],
          [72.942642211914233, 18.247920989990348],
          [72.942359924316463, 18.247917175292969],
          [72.942359924316463, 18.248472213745117],
          [72.942092895507813, 18.248470306396541],
          [72.942092895507813, 18.249031066894474],
          [72.941802978515909, 18.249031066894474],
          [72.941802978515909, 18.249309539794865],
          [72.9415283203125, 18.249309539794865],
          [72.9415283203125, 18.249860763549862],
          [72.942092895507813, 18.249860763549862],
          [72.942092895507813, 18.250141143798828],
          [72.942359924316463, 18.250141143798828],
          [72.942359924316463, 18.251810073852539],
          [72.942085266113452, 18.251804351806641],
          [72.942085266113452, 18.252082824706974],
          [72.941802978515909, 18.252082824706974],
          [72.941802978515909, 18.252361297607365],
          [72.9415283203125, 18.252361297607365],
          [72.9415283203125, 18.253471374511719],
          [72.941802978515909, 18.253469467163143],
          [72.941802978515909, 18.255138397216854],
          [72.9415283203125, 18.255138397216854],
          [72.9415283203125, 18.255420684814396],
          [72.941253662109659, 18.25541877746582],
          [72.941253662109659, 18.255971908569393],
          [72.940971374511776, 18.25596809387207],
          [72.940971374511776, 18.256809234619141],
          [72.940696716308707, 18.256809234619141],
          [72.940696716308707, 18.257358551025391],
          [72.940406799316463, 18.257358551025391],
          [72.940406799316463, 18.257921218872127],
          [72.940139770507756, 18.257917404174918],
          [72.940139770507756, 18.258472442626896],
          [72.939857482910384, 18.258472442626896],
          [72.939857482910384, 18.259029388427678],
          [72.939582824707202, 18.259029388427678],
          [72.939582824707202, 18.259862899780273],
          [72.939308166503963, 18.259862899780273],
          [72.939308166503963, 18.260694503784237],
          [72.939582824707202, 18.260694503784237],
          [72.939582824707202, 18.260974884033203],
          [72.939857482910384, 18.260971069335994],
          [72.939857482910384, 18.262639999389705],
          [72.939582824707202, 18.262639999389705],
          [72.939582824707202, 18.264310836792049],
          [72.939308166503963, 18.264305114746094],
          [72.939308166503963, 18.264583587646484],
          [72.939025878906421, 18.264583587646484],
          [72.939025878906421, 18.264862060546818],
          [72.938751220703409, 18.264860153198242],
          [72.938751220703409, 18.265420913696403],
          [72.938468933105469, 18.265415191650447],
          [72.938468933105469, 18.265972137451172],
          [72.938186645508097, 18.265970230102596],
          [72.938186645508097, 18.266250610351562],
          [72.937919616699276, 18.266250610351562],
          [72.937919616699276, 18.266530990600529],
          [72.937637329101676, 18.266530990600529],
          [72.937637329101676, 18.269029617309627],
          [72.937362670898494, 18.269029617309627],
          [72.937362670898494, 18.269582748413029],
          [72.937080383300724, 18.269580841064453],
          [72.937080383300724, 18.269859313964844],
          [72.936805725097884, 18.269859313964844],
          [72.936813354492415, 18.270141601562614],
          [72.936531066894702, 18.270141601562614],
          [72.936531066894702, 18.270420074462947],
          [72.936248779296932, 18.270420074462947],
          [72.936248779296932, 18.270700454711971],
          [72.935974121093921, 18.270694732666016],
          [72.935974121093921, 18.270969390869197],
          [72.935691833496378, 18.270969390869197],
          [72.935691833496378, 18.271238327026481],
          [72.935142517090128, 18.27125167846674],
          [72.935142517090128, 18.271530151367131],
          [72.934860229492188, 18.271528244018555],
          [72.934860229492188, 18.271804809570369],
          [72.934593200683707, 18.271799087524414],
          [72.934593200683707, 18.272920608520451],
          [72.934860229492188, 18.272916793823299],
          [72.934860229492188, 18.27347373962408],
          [72.935142517090128, 18.273471832275447],
          [72.935142517090128, 18.273759841919002],
          [72.935417175292969, 18.273759841919002],
          [72.935417175292969, 18.274030685424805],
          [72.935691833496378, 18.274030685424805],
          [72.935691833496378, 18.274311065673828],
          [72.935974121093921, 18.274305343628043],
          [72.935974121093921, 18.274583816528434],
          [72.936119079589957, 18.274583816528434],
          [72.936531066894702, 18.274581909179631],
          [72.936531066894702, 18.274860382080021],
          [72.937080383300724, 18.274860382080021],
          [72.937080383300724, 18.275140762329158],
          [72.937362670898494, 18.275138854980582],
          [72.937362670898494, 18.275695800781364],
          [72.937080383300724, 18.275695800781364],
          [72.937080383300724, 18.275972366332951],
          [72.936805725097884, 18.275972366332951],
          [72.936813354492415, 18.276250839233342],
          [72.936531066894702, 18.276250839233342],
          [72.936531066894702, 18.276531219482536],
          [72.936363220215014, 18.276529312133732],
          [72.936248779296932, 18.276531219482536],
          [72.936248779296932, 18.27874946594244],
          [72.935966491699389, 18.27874946594244],
          [72.935966491699389, 18.279029846191406],
          [72.935691833496378, 18.279029846191406],
          [72.935691833496378, 18.279310226440373],
          [72.935417175292969, 18.279306411743221],
          [72.935417175292969, 18.279861450195369],
          [72.935142517090128, 18.279861450195369],
          [72.935142517090128, 18.280971527099553],
          [72.935417175292969, 18.280969619750977],
          [72.935417175292969, 18.28153038024908],
          [72.935691833496378, 18.28153038024908],
          [72.935691833496378, 18.281810760498104],
          [72.935974121093921, 18.281805038452148],
          [72.935974121093921, 18.282083511352539],
          [72.936248779296932, 18.282083511352539],
          [72.936248779296932, 18.282360076904297],
          [72.936531066894702, 18.282358169555721],
          [72.936531066894702, 18.282640457153263],
          [72.936805725097884, 18.282640457153263],
          [72.936805725097884, 18.283193588256893],
          [72.937080383300724, 18.283193588256893],
          [72.937080383300724, 18.283470153808651],
          [72.937362670898494, 18.283468246460075],
          [72.937362670898494, 18.283748626709041],
          [72.937919616699276, 18.283748626709041],
          [72.937919616699276, 18.284030914306584],
          [72.938186645508097, 18.284030914306584],
          [72.938186645508097, 18.284309387206974],
          [72.938751220703409, 18.284305572509822],
          [72.938751220703409, 18.284584045410213],
          [72.939025878906421, 18.284584045410213],
          [72.939025878906421, 18.284305572509822],
          [72.939582824707202, 18.284309387206974],
          [72.939582824707202, 18.284030914306584],
          [72.940139770507756, 18.284030914306584],
          [72.940139770507756, 18.284309387206974],
          [72.940696716308707, 18.284309387206974],
          [72.940696716308707, 18.284862518310604],
          [72.940971374511776, 18.284862518310604],
          [72.940971374511776, 18.28514289855957],
          [72.9415283203125, 18.28514289855957],
          [72.9415283203125, 18.285419464111328],
          [72.942092895507813, 18.285419464111328],
          [72.942092895507813, 18.28514289855957],
          [72.944580078125, 18.28514289855957],
          [72.944580078125, 18.284862518310604],
          [72.945968627929915, 18.284862518310604],
          [72.945968627929915, 18.28514289855957],
          [72.946533203125227, 18.28514289855957],
          [72.946533203125227, 18.285419464111328],
          [72.947906494140909, 18.285419464111328],
          [72.947906494140909, 18.28514289855957],
          [72.948471069336222, 18.28514289855957],
          [72.948471069336222, 18.284862518310604],
          [72.949028015136776, 18.284862518310604],
          [72.949028015136776, 18.284578323364258],
          [72.949584960937727, 18.284584045410213],
          [72.949584960937727, 18.284305572509822],
          [72.950141906738338, 18.284309387206974],
          [72.950141906738338, 18.284030914306584],
          [72.950691223144531, 18.284030914306584],
          [72.950691223144531, 18.283468246460075],
          [72.950973510742472, 18.283470153808651],
          [72.950973510742472, 18.282918930053654],
          [72.951255798339844, 18.282930374145565],
          [72.951255798339844, 18.28256988525402],
          [72.951248168945313, 18.28153038024908],
          [72.95096588134794, 18.28153038024908],
          [72.95096588134794, 18.28013992309576],
          [72.951255798339844, 18.28013992309576],
          [72.951255798339844, 18.279859542846793],
          [72.951805114746264, 18.279861450195369],
          [72.951805114746264, 18.279582977295036],
          [72.952919006347599, 18.279582977295036],
          [72.952919006347599, 18.279306411743221],
          [72.953186035156307, 18.279310226440373],
          [72.953186035156307, 18.279029846191406],
          [72.953475952148551, 18.279029846191406],
          [72.953475952148551, 18.27874946594244],
          [72.953750610351619, 18.27874946594244],
          [72.953750610351619, 18.278190612793082],
          [72.954582214355753, 18.278194427490291],
          [72.954582214355753, 18.277914047241325],
          [72.955139160156307, 18.277919769287053],
          [72.955139160156307, 18.277639389038086],
          [72.956253051757869, 18.277639389038086],
          [72.956253051757869, 18.277919769287053],
          [72.957084655762003, 18.277914047241325],
          [72.957084655762003, 18.278194427490291],
          [72.957359313964844, 18.278194427490291],
          [72.957359313964844, 18.278472900390682],
          [72.958473205566577, 18.278470993042049],
          [72.958473205566577, 18.279029846191406],
          [72.959030151367358, 18.279029846191406],
          [72.959030151367358, 18.279310226440373],
          [72.959304809570369, 18.279306411743221],
          [72.959304809570369, 18.279861450195369],
          [72.959587097167912, 18.279859542846793],
          [72.959587097167912, 18.28013992309576],
          [72.960128784179972, 18.28013992309576],
          [72.960128784179972, 18.280420303344727],
          [72.961250305176065, 18.280420303344727],
          [72.961250305176065, 18.28070068359375],
          [72.962677001953296, 18.280698776245117],
          [72.963195800781364, 18.28070068359375],
          [72.963195800781364, 18.280420303344727],
          [72.963752746582315, 18.280420303344727],
          [72.963752746582315, 18.28013992309576],
          [72.964576721191577, 18.28013992309576],
          [72.964576721191577, 18.279859542846793],
          [72.964859008789119, 18.279861450195369],
          [72.964859008789119, 18.279582977295036],
          [72.965415954590071, 18.279582977295036],
          [72.965415954590071, 18.279306411743221],
          [72.965690612792912, 18.279310226440373],
          [72.965698242187443, 18.279029846191406],
          [72.965972900390682, 18.279029846191406],
          [72.965972900390682, 18.27874946594244],
          [72.966262817382756, 18.27874946594244],
          [72.966247558593864, 18.278472900390682],
          [72.966529846191463, 18.278472900390682],
          [72.966529846191463, 18.277914047241325],
          [72.966796875000284, 18.277919769287053],
          [72.966796875000284, 18.276800155639762],
          [72.966529846191463, 18.276805877685547],
          [72.966529846191463, 18.276290893554631],
          [72.966529846191463, 18.275972366332951],
          [72.966804504394815, 18.275972366332951],
          [72.966804504394815, 18.275417327880973],
          [72.967086791992188, 18.275421142578182],
          [72.967086791992188, 18.275140762329158],
          [72.968193054199389, 18.275140762329158],
          [72.968193054199389, 18.274860382080021],
          [72.968749999999943, 18.274860382080021],
          [72.968749999999943, 18.274581909179631],
          [72.969306945800895, 18.274583816528434],
          [72.969306945800895, 18.274305343628043],
          [72.969581604003963, 18.274311065673828],
          [72.969581604003963, 18.272361755371094],
          [72.969863891601847, 18.272361755371094],
          [72.969863891601847, 18.27208328247076],
          [72.970413208008097, 18.27208328247076],
          [72.970413208008097, 18.27125167846674],
          [72.970703125, 18.27125167846674],
          [72.970695495605639, 18.269306182861442],
          [72.970413208008097, 18.269308090210018],
          [72.970413208008097, 18.269029617309627],
          [72.969856262207315, 18.269029617309627],
          [72.969856262207315, 18.268749237060661],
          [72.969581604003963, 18.268749237060661],
          [72.969581604003963, 18.267919540405273],
          [72.969856262207315, 18.267919540405273],
          [72.969856262207315, 18.2676296234132],
          [72.970138549804687, 18.267637252807731],
          [72.970138549804687, 18.266525268554801],
          [72.970413208008097, 18.266530990600529],
          [72.970413208008097, 18.265140533447209],
          [72.970138549804687, 18.265140533447209],
          [72.970138549804687, 18.264570236206168],
          [72.969863891601847, 18.264583587646484],
          [72.969863891601847, 18.264305114746094],
          [72.970703125, 18.264310836792049],
          [72.970703125, 18.264030456543026],
          [72.971252441406421, 18.264030456543026],
          [72.971252441406421, 18.263750076293888],
          [72.971527099609602, 18.263750076293888],
          [72.971527099609602, 18.263469696044922],
          [72.973747253418139, 18.263471603393498],
          [72.973747253418139, 18.26291656494152],
          [72.974029541015909, 18.262920379638672],
          [72.974029541015909, 18.262359619140739],
          [72.973747253418139, 18.262361526489315],
          [72.973747253418139, 18.262083053588981],
          [72.973472595215128, 18.262083053588981],
          [72.973472595215128, 18.261528015136776],
          [72.973197937011719, 18.261529922485352],
          [72.973197937011719, 18.261249542236385],
          [72.972915649414347, 18.261249542236385],
          [72.972915649414347, 18.260974884033203],
          [72.972640991210994, 18.260974884033203],
          [72.972640991210994, 18.260694503784237],
          [72.972084045410213, 18.260694503784237],
          [72.972084045410213, 18.260416030883846],
          [72.971801757812443, 18.260419845580998],
          [72.971801757812443, 18.260139465332031],
          [72.971252441406421, 18.260139465332031],
          [72.971252441406421, 18.257078170776424],
          [72.971527099609602, 18.257083892822379],
          [72.971527099609602, 18.255971908569393],
          [72.971801757812443, 18.255971908569393],
          [72.971801757812443, 18.255138397216854],
          [72.972068786621151, 18.255138397216854],
          [72.972068786621151, 18.254301071167106],
          [72.972358703613395, 18.254304885864315],
          [72.972358703613395, 18.253194808959961],
          [72.972640991210994, 18.253194808959961],
          [72.972640991210994, 18.252639770507756],
          [72.972915649414347, 18.252639770507756],
          [72.972915649414347, 18.252082824706974],
          [72.973197937011719, 18.252082824706974],
          [72.973197937011719, 18.251527786254996],
          [72.973472595215128, 18.251529693603572],
          [72.973472595215128, 18.250970840454045],
          [72.973747253418139, 18.250972747802848],
          [72.973747253418139, 18.250415802002067],
          [72.974029541015909, 18.250419616699219],
          [72.974029541015909, 18.249031066894474],
          [72.973747253418139, 18.249031066894474],
          [72.973747253418139, 18.247640609741154],
          [72.974029541015909, 18.247640609741154],
          [72.974029541015909, 18.246820449829102],
          [72.974296569824389, 18.246820449829102],
          [72.974296569824389, 18.246530532836971],
          [72.975135803222713, 18.246530532836971],
          [72.975135803222713, 18.246820449829102],
          [72.975982666015739, 18.246820449829102],
          [72.975982666015739, 18.246530532836971],
          [72.976516723633097, 18.246530532836971],
          [72.976516723633097, 18.246250152587834],
          [72.977355957031421, 18.246250152587834],
          [72.977355957031421, 18.245971679687443],
          [72.978195190429915, 18.245973587036246],
          [72.978195190429915, 18.245695114135856],
          [72.9798583984375, 18.245702743530387],
          [72.9798583984375, 18.245420455932617],
          [72.980422973632983, 18.245420455932617],
          [72.980422973632983, 18.24486160278326],
          [72.980697631835994, 18.24486160278326],
          [72.980697631835994, 18.244304656982536],
          [72.980972290039233, 18.244304656982536],
          [72.980972290039233, 18.243751525878906],
          [72.981239318847713, 18.243751525878906],
          [72.981239318847713, 18.242921829223746],
          [72.981529235839787, 18.242921829223746],
          [72.981529235839787, 18.242080688476619],
          [72.982360839843807, 18.242080688476619],
          [72.982360839843807, 18.24235916137701],
          [72.982635498047159, 18.24235916137701],
          [72.982635498047159, 18.242637634277401],
          [72.982917785644531, 18.242637634277401],
          [72.982917785644531, 18.242916107177791],
          [72.98319244384794, 18.242916107177791],
          [72.98319244384794, 18.243194580078182],
          [72.984306335449446, 18.243194580078182],
          [72.984306335449446, 18.243473052978572],
          [72.984863281250057, 18.243473052978572],
          [72.984863281250057, 18.243194580078182],
          [72.986526489257983, 18.243194580078182],
          [72.986526489257983, 18.243473052978572],
          [72.987915039062557, 18.243473052978572],
          [72.987915039062557, 18.243751525878906],
          [72.988471984863338, 18.243751525878906],
          [72.988471984863338, 18.24403190612793],
          [72.989303588867472, 18.244028091430721],
          [72.989303588867472, 18.244304656982536],
          [72.989860534668253, 18.244304656982536],
          [72.989860534668253, 18.244583129882926],
          [72.990417480468807, 18.244583129882926],
          [72.990417480468807, 18.24486160278326],
          [72.990692138672046, 18.24486160278326],
          [72.990692138672046, 18.245140075683651],
          [72.991249084472599, 18.245140075683651],
          [72.991249084472599, 18.245420455932617],
          [72.991531372070369, 18.245420455932617],
          [72.991531372070369, 18.245702743530387],
          [72.991806030273551, 18.245695114135856],
          [72.991806030273551, 18.245973587036246],
          [72.992637634277344, 18.245971679687443],
          [72.992637634277344, 18.246250152587834],
          [72.993179321289233, 18.246250152587834],
          [72.993179321289233, 18.245971679687443],
          [72.994026184082259, 18.245973587036246],
          [72.994026184082259, 18.245695114135856],
          [72.994583129882869, 18.245702743530387],
          [72.994583129882869, 18.245420455932617],
          [72.995407104492472, 18.245420455932617],
          [72.995407104492472, 18.245140075683651],
          [72.996238708496264, 18.245140075683651],
          [72.996238708496264, 18.24486160278326],
          [72.997642517089901, 18.24486160278326],
          [72.997642517089901, 18.245140075683651],
          [72.997917175293082, 18.245140075683651],
          [72.997917175293082, 18.247640609741154],
          [72.998191833496151, 18.247640609741154],
          [72.998191833496151, 18.247920989990348],
          [72.998474121094034, 18.247917175292969],
          [72.998474121094034, 18.248193740844783],
          [72.998748779296875, 18.248193740844783],
          [72.998748779296875, 18.248472213745117],
          [72.999938964843977, 18.248472213745117],
          [73.000419616699389, 18.248472213745117],
          [73.000419616699389, 18.248193740844783],
          [73.000968933105582, 18.248193740844783],
          [73.000968933105582, 18.247917175292969],
          [73.001525878906534, 18.247920989990348],
          [73.001525878906534, 18.247640609741154],
          [73.001808166503906, 18.247640609741154],
          [73.001808166503906, 18.247360229492188],
          [73.002082824707315, 18.247360229492188],
          [73.002082824707315, 18.247079849243221],
          [73.002357482910327, 18.24708366394043],
          [73.002357482910327, 18.246528625488395],
          [73.002639770508097, 18.246530532836971],
          [73.002639770508097, 18.246250152587834],
          [73.004302978515682, 18.246250152587834],
          [73.004302978515682, 18.245971679687443],
          [73.004585266113395, 18.245973587036246],
          [73.004585266113395, 18.245695114135856],
          [73.004859924316406, 18.245702743530387],
          [73.004859924316406, 18.245420455932617],
          [73.005142211914347, 18.245420455932617],
          [73.005142211914347, 18.245140075683651],
          [73.005409240722827, 18.245140075683651],
          [73.005409240722827, 18.24486160278326],
          [73.007637023925895, 18.24486160278326],
          [73.007637023925895, 18.245140075683651],
          [73.008750915527628, 18.245140075683651],
          [73.008750915527628, 18.24486160278326],
          [73.010414123535213, 18.24486160278326],
          [73.010414123535213, 18.244583129882926],
          [73.010971069335994, 18.244583129882926],
          [73.010971069335994, 18.244304656982536],
          [73.011253356933878, 18.244304656982536],
          [73.011253356933878, 18.244028091430721],
          [73.011528015136719, 18.24403190612793],
          [73.011528015136719, 18.243469238281364],
          [73.011802673340128, 18.243473052978572],
          [73.011802673340128, 18.243194580078182],
          [73.012084960937671, 18.243194580078182],
          [73.012084960937671, 18.242916107177791],
          [73.012359619140682, 18.242921829223746],
          [73.012359619140682, 18.24235916137701],
          [73.012496948242244, 18.24235916137701],
          [73.012641906738452, 18.24235916137701],
          [73.012641906738452, 18.242080688476619],
          [73.013191223144474, 18.242080688476619],
          [73.013191223144474, 18.24235916137701],
          [73.013648986816463, 18.24235916137701],
          [73.014579772949219, 18.24235916137701],
          [73.014579772949219, 18.242637634277401],
          [73.01541900634794, 18.242637634277401],
          [73.01541900634794, 18.243089675903377],
          [73.01541900634794, 18.243194580078182],
          [73.015693664550952, 18.243194580078182],
          [73.015693664550952, 18.243473052978572],
          [73.01541900634794, 18.243469238281364],
          [73.01541900634794, 18.24403190612793],
          [73.015693664550952, 18.244028091430721],
          [73.015693664550952, 18.244304656982536],
          [73.015975952148494, 18.244304656982536],
          [73.015975952148494, 18.244583129882926],
          [73.016250610351733, 18.244583129882926],
          [73.016250610351733, 18.24486160278326],
          [73.016532897949446, 18.24486160278326],
          [73.016532897949446, 18.245140075683651],
          [73.016807556152287, 18.245140075683651],
          [73.016807556152287, 18.245420455932617],
          [73.017082214355526, 18.245420455932617],
          [73.017082214355526, 18.245702743530387],
          [73.017906188965128, 18.245702743530387],
          [73.017906188965128, 18.244579315185547],
          [73.018196105957031, 18.244583129882926],
          [73.018196105957031, 18.243789672851619],
          [73.018196105957031, 18.243473052978572],
          [73.01847076416044, 18.243473052978572],
          [73.01847076416044, 18.242916107177791],
          [73.018753051757983, 18.242921829223746],
          [73.018753051757983, 18.242637634277401],
          [73.019302368164233, 18.242637634277401],
          [73.019302368164233, 18.242080688476619],
          [73.019584655761946, 18.242082595825195],
          [73.019584655761946, 18.241527557373047],
          [73.020141601562557, 18.241527557373047],
          [73.020141601562557, 18.241249084472656],
          [73.020408630371378, 18.241249084472656],
          [73.020408630371378, 18.241527557373047],
          [73.021247863769531, 18.241527557373047],
          [73.021247863769531, 18.24180984497076],
          [73.021530151367472, 18.24180984497076],
          [73.021530151367472, 18.241527557373047],
          [73.021797180175952, 18.241527557373047],
          [73.021797180175952, 18.240970611572266],
          [73.022361755371264, 18.240972518920842],
          [73.022361755371264, 18.240694046020508],
          [73.022636413574446, 18.240694046020508],
          [73.022636413574446, 18.240972518920842],
          [73.022918701171818, 18.240972518920842],
          [73.022918701171818, 18.240694046020508],
          [73.02347564697277, 18.240694046020508],
          [73.02347564697277, 18.240972518920842],
          [73.025138854980526, 18.240972518920842],
          [73.025138854980526, 18.240694046020508],
          [73.026252746582088, 18.240694046020508],
          [73.026252746582088, 18.24041938781744],
          [73.026802062988338, 18.24041938781744],
          [73.026802062988338, 18.240694046020508],
          [73.027000427246151, 18.240694046020508],
          [73.027359008789063, 18.240694046020508],
          [73.027359008789063, 18.24041938781744],
          [73.028190612793026, 18.24041938781744],
          [73.028198242187784, 18.240140914917049],
          [73.028747558593977, 18.240140914917049],
          [73.028747558593977, 18.239860534667912],
          [73.029289245605526, 18.239860534667912],
          [73.029289245605526, 18.239580154418945],
          [73.030136108398722, 18.239583969116325],
          [73.030136108398722, 18.239305496215934],
          [73.030693054199503, 18.239311218261719],
          [73.030693054199503, 18.239030838012695],
          [73.031250000000284, 18.239030838012695],
          [73.031250000000284, 18.238750457763729],
          [73.031517028808764, 18.238750457763729],
          [73.031517028808764, 18.238470077514762],
          [73.031806945800838, 18.238471984863338],
          [73.031806945800838, 18.238193511963004],
          [73.032638549804631, 18.238193511963004],
          [73.032638549804631, 18.23791694641119],
          [73.033203125000114, 18.237920761108342],
          [73.033203125000114, 18.237649917602539],
          [73.033470153808594, 18.237649917602539],
          [73.033470153808594, 18.237360000610408],
          [73.034027099609375, 18.237361907958984],
          [73.034027099609375, 18.237083435058651],
          [73.034858703613338, 18.237083435058651],
          [73.034858703613338, 18.236803054809627],
          [73.035423278808821, 18.236810684204215],
          [73.035423278808821, 18.236249923706055],
          [73.035972595214901, 18.236249923706055],
          [73.035972595214901, 18.235969543457088],
          [73.036247253418082, 18.235971450805664],
          [73.036247253418082, 18.235416412353516],
          [73.036529541015682, 18.235420227050838],
          [73.036529541015682, 18.234859466552734],
          [73.038482666015682, 18.234859466552734],
          [73.038482666015682, 18.235420227050838],
          [73.039024353027401, 18.235416412353516],
          [73.039024353027401, 18.235694885253906],
          [73.040969848632869, 18.235694885253906],
          [73.040969848632869, 18.235416412353516],
          [73.041809082031421, 18.235420227050838],
          [73.041809082031421, 18.235139846801701],
          [73.042358398437614, 18.235139846801701],
          [73.042358398437614, 18.234859466552734],
          [73.042915344238565, 18.23486137390131],
          [73.042915344238565, 18.234584808349723],
          [73.044029235840128, 18.234590530395508],
          [73.044029235840128, 18.234310150146484],
          [73.044288635254077, 18.234310150146484],
          [73.044288635254077, 18.234029769897518],
          [73.044860839843921, 18.234029769897518],
          [73.044860839843921, 18.233749389648551],
          [73.045143127441634, 18.233749389648551],
          [73.045143127441634, 18.234029769897518],
          [73.045692443847713, 18.234029769897518],
          [73.045692443847713, 18.233749389648551],
          [73.046249389648438, 18.233749389648551],
          [73.046249389648438, 18.233472824096793],
          [73.046806335449219, 18.233472824096793],
          [73.046806335449219, 18.233194351196403],
          [73.047363281250171, 18.233194351196403],
          [73.047363281250171, 18.232915878296012],
          [73.048751831054744, 18.232919692993164],
          [73.048751831054744, 18.23208045959484],
          [73.049026489257926, 18.23208045959484],
          [73.049026489257926, 18.231527328491268],
          [73.049308776855526, 18.23153114318842],
          [73.049308776855526, 18.231252670288086],
          [73.049026489257926, 18.231252670288086],
          [73.049026489257926, 18.230688095092773],
          [73.048751831054744, 18.230693817138729],
          [73.048751831054744, 18.230417251586914],
          [73.049026489257926, 18.23041915893549],
          [73.049026489257926, 18.230140686035099],
          [73.049308776855526, 18.230140686035099],
          [73.049308776855526, 18.229858398437557],
          [73.049575805664347, 18.229858398437557],
          [73.049575805664347, 18.230140686035099],
          [73.049858093261719, 18.230140686035099],
          [73.049858093261719, 18.23041915893549],
          [73.050140380859659, 18.230417251586914],
          [73.050140380859659, 18.230693817138729],
          [73.050415039062671, 18.230693817138729],
          [73.050415039062671, 18.230972290039063],
          [73.050697326660213, 18.230972290039063],
          [73.050697326660213, 18.231252670288086],
          [73.050971984863452, 18.231252670288086],
          [73.050971984863452, 18.23180961608881],
          [73.051246643066634, 18.231805801391658],
          [73.051246643066634, 18.23208045959484],
          [73.051803588867244, 18.23208045959484],
          [73.051803588867244, 18.231805801391658],
          [73.05291748046875, 18.23180961608881],
          [73.05291748046875, 18.23153114318842],
          [73.053192138672159, 18.23153114318842],
          [73.053192138672159, 18.231252670288086],
          [73.053749084472713, 18.231252670288086],
          [73.053749084472713, 18.230968475341911],
          [73.054862976074276, 18.230972290039063],
          [73.054862976074276, 18.230693817138729],
          [73.055137634277457, 18.230693817138729],
          [73.055137634277457, 18.230417251586914],
          [73.05625152587919, 18.23041915893549],
          [73.05625152587919, 18.230140686035099],
          [73.057083129882983, 18.230140686035099],
          [73.057083129882983, 18.229858398437557],
          [73.057907104492244, 18.229858398437557],
          [73.057907104492244, 18.229579925537166],
          [73.058471679687557, 18.229583740234375],
          [73.058471679687557, 18.229305267333984],
          [73.059028625488281, 18.229309082031307],
          [73.059028625488281, 18.229030609130916],
          [73.05930328369169, 18.229030609130916],
          [73.05930328369169, 18.228748321533203],
          [73.060142517090014, 18.228748321533203],
          [73.060142517090014, 18.228460311889705],
          [73.060691833496264, 18.228471755981388],
          [73.060691833496264, 18.228195190429801],
          [73.061248779296818, 18.228200912475586],
          [73.061248779296818, 18.227920532226562],
          [73.061813354492301, 18.227920532226562],
          [73.061813354492301, 18.22763824462902],
          [73.062080383300781, 18.22763824462902],
          [73.062080383300781, 18.227359771728629],
          [73.062919616699503, 18.227361679077205],
          [73.062919616699503, 18.227083206176871],
          [73.063751220703296, 18.227083206176871],
          [73.063751220703296, 18.226804733276481],
          [73.064025878906477, 18.226804733276481],
          [73.064025878906477, 18.22652626037609],
          [73.064308166503849, 18.226530075073242],
          [73.064308166503849, 18.226249694824276],
          [73.064582824707088, 18.226249694824276],
          [73.064582824707088, 18.225971221923885],
          [73.065139770507869, 18.225973129272518],
          [73.065139770507869, 18.225694656372127],
          [73.065414428711222, 18.225694656372127],
          [73.065414428711222, 18.225416183471737],
          [73.065711975097713, 18.225419998168888],
          [73.065711975097713, 18.225139617919922],
          [73.066253662109546, 18.225139617919922],
          [73.066246032715014, 18.224580764770565],
          [73.066528320312557, 18.224582672119141],
          [73.066528320312557, 18.224304199218807],
          [73.066802978515796, 18.224309921264705],
          [73.066802978515796, 18.224029541015568],
          [73.067359924316349, 18.224029541015568],
          [73.067359924316349, 18.223470687866211],
          [73.067916870117301, 18.223472595214787],
          [73.067916870117301, 18.223194122314453],
          [73.068191528320369, 18.223194122314453],
          [73.068191528320369, 18.222917556762809],
          [73.06845855712919, 18.222919464111385],
          [73.06845855712919, 18.222360610961857],
          [73.069030761719034, 18.222360610961857],
          [73.069030761719034, 18.222080230712891],
          [73.069305419922046, 18.222082138061467],
          [73.069305419922046, 18.221250534057674],
          [73.069580078125057, 18.221250534057674],
          [73.069580078125057, 18.220970153808707],
          [73.069862365722827, 18.220972061157283],
          [73.069862365722827, 18.219305038452205],
          [73.070137023926009, 18.219310760498161],
          [73.070137023926009, 18.215690612792969],
          [73.070419311523608, 18.215694427490348],
          [73.070419311523608, 18.210971832275334],
          [73.070693969726619, 18.210971832275334],
          [73.070693969726619, 18.209861755371151],
          [73.070968627929801, 18.209861755371151],
          [73.070968627929801, 18.209304809570426],
          [73.070693969726619, 18.209304809570426],
          [73.070693969726619, 18.208194732666072],
          [73.070419311523608, 18.208194732666072],
          [73.070419311523608, 18.207639694213867],
          [73.070686340332088, 18.207639694213867],
          [73.070686340332088, 18.207361221313477],
          [73.070419311523608, 18.207361221313477],
          [73.070419311523608, 18.206809997558651],
          [73.070137023926009, 18.206809997558651],
          [73.070137023926009, 18.205972671508732],
          [73.069862365722827, 18.205972671508732],
          [73.069862365722827, 18.205694198608398],
          [73.069580078125057, 18.205694198608398],
          [73.069580078125057, 18.205417633056754],
          [73.069313049316406, 18.20541954040533],
          [73.069313049316406, 18.20514106750494],
          [73.068748474121094, 18.20514106750494],
          [73.068748474121094, 18.204862594604606],
          [73.06845855712919, 18.204862594604606],
          [73.06845855712919, 18.204580307006836],
          [73.067916870117301, 18.204584121704215],
          [73.067916870117301, 18.204305648803825],
          [73.067642211914119, 18.204309463500977],
          [73.067642211914119, 18.20402908325201],
          [73.067092895507869, 18.20402908325201],
          [73.067092895507869, 18.203750610351619],
          [73.066802978515796, 18.203750610351619],
          [73.066802978515796, 18.203468322753906],
          [73.066253662109546, 18.203470230102653],
          [73.066253662109546, 18.203193664550895],
          [73.065971374512003, 18.203193664550895],
          [73.065971374512003, 18.20291709899908],
          [73.064918518066577, 18.202920913696232],
          [73.06485748291027, 18.202640533447266],
          [73.064308166503849, 18.202640533447266],
          [73.064308166503849, 18.202358245849723],
          [73.064025878906477, 18.202362060546875],
          [73.064025878906477, 18.202083587646541],
          [73.063468933105526, 18.202083587646541],
          [73.063468933105526, 18.201805114746151],
          [73.062919616699503, 18.201810836792106],
          [73.062919616699503, 18.201520919799805],
          [73.061531066894588, 18.201530456542912],
          [73.061531066894588, 18.201248168945369],
          [73.060691833496264, 18.201248168945369],
          [73.060691833496264, 18.200969696044979],
          [73.060142517090014, 18.200971603393555],
          [73.060142517090014, 18.200696945190543],
          [73.059860229492472, 18.200700759887752],
          [73.059860229492472, 18.200420379638729],
          [73.059577941894702, 18.200420379638729],
          [73.059577941894702, 18.200138092041016],
          [73.05930328369169, 18.200138092041016],
          [73.05930328369169, 18.199859619140625],
          [73.058746337890909, 18.199861526489201],
          [73.058746337890909, 18.19958305358881],
          [73.058197021484318, 18.19958305358881],
          [73.058197021484318, 18.199026107788086],
          [73.057640075683764, 18.199029922485408],
          [73.057640075683764, 18.198190689086914],
          [73.057357788086165, 18.198194503784293],
          [73.057357788086165, 18.197914123535099],
          [73.057083129882983, 18.197919845581055],
          [73.057083129882983, 18.197360992431697],
          [73.056808471679972, 18.197360992431697],
          [73.056808471679972, 18.196809768676701],
          [73.056518554687671, 18.196809768676701],
          [73.056518554687671, 18.196529388427734],
          [73.05625152587919, 18.196529388427734],
          [73.05625152587919, 18.195970535278377],
          [73.05596923828125, 18.195972442626953],
          [73.05596923828125, 18.195417404174805],
          [73.055686950683878, 18.195421218872184],
          [73.055686950683878, 18.19514083862299],
          [73.055419921875057, 18.19514083862299],
          [73.055419921875057, 18.19431114196783],
          [73.055137634277457, 18.19431114196783],
          [73.055137634277457, 18.194030761718807],
          [73.055419921875057, 18.194030761718807],
          [73.055419921875057, 18.193471908569279],
          [73.055137634277457, 18.193473815918082],
          [73.055137634277457, 18.190694808960018],
          [73.055419921875057, 18.190694808960018],
          [73.055419921875057, 18.190141677856388],
          [73.055137634277457, 18.190141677856388],
          [73.055137634277457, 18.189859390258846],
          [73.055419921875057, 18.189859390258846],
          [73.055419921875057, 18.188194274902344],
          [73.055694580078409, 18.188194274902344],
          [73.055694580078409, 18.187084197998161],
          [73.05596923828125, 18.187084197998161],
          [73.05596923828125, 18.186250686645565],
          [73.05625152587919, 18.186250686645565],
          [73.05625152587919, 18.185689926147461],
          [73.056526184082202, 18.18569374084484],
          [73.056526184082202, 18.18541526794445],
          [73.056808471679972, 18.185420989990178],
          [73.056808471679972, 18.185140609741211],
          [73.057083129882983, 18.185140609741211],
          [73.057083129882983, 18.184579849243278],
          [73.057640075683764, 18.184583663940487],
          [73.057640075683764, 18.184028625488281],
          [73.057907104492244, 18.184030532836857],
          [73.057907104492244, 18.183481216430664],
          [73.058471679687557, 18.183481216430664],
          [73.058471679687557, 18.182920455932674],
          [73.058746337890909, 18.182920455932674],
          [73.058746337890909, 18.182640075683537],
          [73.05930328369169, 18.182640075683537],
          [73.05930328369169, 18.18235969543457],
          [73.059585571289062, 18.182361602783146],
          [73.059585571289062, 18.182083129882756],
          [73.059860229492472, 18.182083129882756],
          [73.059860229492472, 18.181804656982422],
          [73.060142517090014, 18.181804656982422],
          [73.060142517090014, 18.181528091430778],
          [73.060691833496264, 18.181529998779354],
          [73.060691833496264, 18.180971145629826],
          [73.061248779296818, 18.180973052978629],
          [73.061248779296818, 18.180416107177848],
          [73.061531066894588, 18.180416107177848],
          [73.061531066894588, 18.180139541626033],
          [73.061813354492301, 18.180139541626033],
          [73.06180572509777, 18.179861068725643],
          [73.062080383300781, 18.179861068725643],
          [73.062080383300781, 18.179309844970646],
          [73.062362670898722, 18.179309844970646],
          [73.062362670898722, 18.17902946472168],
          [73.062919616699503, 18.17902946472168],
          [73.062919616699503, 18.178752899169922],
          [73.063468933105526, 18.178752899169922],
          [73.063468933105526, 18.178472518920898],
          [73.063873291015909, 18.178472518920898],
          [73.064025878906477, 18.178472518920898],
          [73.064025878906477, 18.178194046020565],
          [73.064582824707088, 18.178194046020565],
          [73.064582824707088, 18.177488327026367],
          [73.064582824707088, 18.177358627319393],
          [73.06485748291027, 18.177358627319393],
          [73.06485748291027, 18.177083969116211],
          [73.065139770507869, 18.177083969116211],
          [73.065139770507869, 18.17680549621582],
          [73.065711975097713, 18.176809310913143],
          [73.065711975097713, 18.176530838012752],
          [73.065971374512003, 18.176530838012752],
          [73.065971374512003, 18.176248550415039],
          [73.066528320312557, 18.176248550415039],
          [73.066528320312557, 18.175968170166072],
          [73.067085266113509, 18.175970077514648],
          [73.067085266113509, 18.175693511962834],
          [73.067359924316349, 18.175693511962834],
          [73.067359924316349, 18.175418853759822],
          [73.067642211914119, 18.175420761108398],
          [73.067642211914119, 18.175140380859432],
          [73.068191528320369, 18.175140380859432],
          [73.068191528320369, 18.174858093261719],
          [73.068473815918253, 18.174861907959041],
          [73.068473815918253, 18.174583435058707],
          [73.068748474121094, 18.174583435058707],
          [73.068748474121094, 18.174304962158317],
          [73.069030761719034, 18.174304962158317],
          [73.069030761719034, 18.174583435058707],
          [73.069580078125057, 18.174583435058707],
          [73.069580078125057, 18.174304962158317],
          [73.069862365722827, 18.174310684204045],
          [73.069862365722827, 18.174030303955078],
          [73.070137023926009, 18.174030303955078],
          [73.070137023926009, 18.173469543457145],
          [73.070419311523608, 18.173471450805721],
          [73.070419311523608, 18.172916412353572],
          [73.070968627929801, 18.172920227050724],
          [73.070968627929801, 18.172359466552791],
          [73.071525573730753, 18.172361373901367],
          [73.071525573730753, 18.171527862548828],
          [73.071807861328125, 18.171541213989315],
          [73.071807861328125, 18.17069053649908],
          [73.072082519531534, 18.170694351196289],
          [73.072082519531534, 18.170415878295898],
          [73.071807861328125, 18.170419692993221],
          [73.071807861328125, 18.17014122009283],
          [73.071250915527401, 18.17014122009283],
          [73.071250915527401, 18.169580459594727],
          [73.070968627929801, 18.169584274292106],
          [73.070968627929801, 18.169305801391715],
          [73.070686340332088, 18.169309616088867],
          [73.070686340332088, 18.169031143188477],
          [73.070419311523608, 18.169031143188477],
          [73.070419311523608, 18.168470382690543],
          [73.070137023926009, 18.168472290039119],
          [73.070137023926009, 18.168193817138786],
          [73.069862365722827, 18.168193817138786],
          [73.069862365722827, 18.16763877868658],
          [73.069580078125057, 18.167640686035156],
          [73.069580078125057, 18.167081832885799],
          [73.069305419922046, 18.167083740234432],
          [73.069305419922046, 18.166805267334041],
          [73.069030761719034, 18.166812896728572],
          [73.069030761719034, 18.165702819824219],
          [73.068748474121094, 18.165702819824219],
          [73.068748474121094, 18.165409088134766],
          [73.069030761719034, 18.165416717529297],
          [73.069030761719034, 18.165138244628906],
          [73.069305419922046, 18.165138244628906],
          [73.069305419922046, 18.165973663330078],
          [73.069580078125057, 18.165971755981445],
          [73.069580078125057, 18.166250228881836],
          [73.069862365722827, 18.166250228881836],
          [73.069862365722827, 18.166812896728572],
          [73.070137023926009, 18.166805267334041],
          [73.070137023926009, 18.167083740234432],
          [73.070419311523608, 18.167081832885799],
          [73.070419311523608, 18.16736030578619],
          [73.070686340332088, 18.16736030578619],
          [73.070686340332088, 18.167921066284123],
          [73.070968627929801, 18.167917251586971],
          [73.070968627929801, 18.168193817138786],
          [73.071250915527401, 18.168193817138786],
          [73.071250915527401, 18.168472290039119],
          [73.071388244629077, 18.168470382690543],
          [73.071517944336222, 18.168470382690543],
          [73.071517944336222, 18.169031143188477],
          [73.071807861328125, 18.169027328491325],
          [73.071807861328125, 18.169582366943303],
          [73.072082519531534, 18.169580459594727],
          [73.072082519531534, 18.169860839843693],
          [73.073196411132869, 18.169860839843693],
          [73.073196411132869, 18.169580459594727],
          [73.073471069336108, 18.169582366943303],
          [73.073471069336108, 18.169305801391715],
          [73.073753356933821, 18.169309616088867],
          [73.073753356933821, 18.16875076293951],
          [73.074028015136662, 18.16875076293951],
          [73.074028015136662, 18.168180465698299],
          [73.074302673339901, 18.168193817138786],
          [73.074302673339901, 18.16763877868658],
          [73.074859619140625, 18.167640686035156],
          [73.074859619140625, 18.167081832885799],
          [73.075141906738565, 18.167083740234432],
          [73.075141906738565, 18.166805267334041],
          [73.075416564941406, 18.166812896728572],
          [73.075416564941406, 18.165971755981445],
          [73.075691223144815, 18.165973663330078],
          [73.075691223144815, 18.165695190429688],
          [73.075965881347827, 18.165702819824219],
          [73.075965881347827, 18.165409088134766],
          [73.076530456543139, 18.165416717529297],
          [73.076530456543139, 18.165138244628906],
          [73.076812744140852, 18.165140151977482],
          [73.076812744140852, 18.164861679077092],
          [73.077079772949162, 18.164861679077092],
          [73.077079772949162, 18.163751602172908],
          [73.076805114746321, 18.163751602172908],
          [73.076805114746321, 18.162637710571403],
          [73.076530456543139, 18.162637710571403],
          [73.076530456543139, 18.161809921264592],
          [73.076248168945369, 18.161809921264592],
          [73.076248168945369, 18.160970687866268],
          [73.075973510742358, 18.160972595214844],
          [73.075973510742358, 18.160869598388672],
          [73.075973510742358, 18.16069412231451],
          [73.075691223144815, 18.16069412231451],
          [73.075691223144815, 18.160419464111271],
          [73.075416564941406, 18.160419464111271],
          [73.075416564941406, 18.160140991210881],
          [73.075141906738565, 18.160140991210881],
          [73.075141906738565, 18.159860610961914],
          [73.074859619140625, 18.159860610961914],
          [73.074859619140625, 18.159580230712947],
          [73.074584960937614, 18.159584045410156],
          [73.074584960937614, 18.159305572509766],
          [73.074028015136662, 18.159309387207088],
          [73.074028015136662, 18.159030914306697],
          [73.073753356933821, 18.159030914306697],
          [73.073753356933821, 18.158470153808594],
          [73.073471069336108, 18.15847206115717],
          [73.073471069336108, 18.157638549804801],
          [73.073196411132869, 18.157640457153377],
          [73.073196411132869, 18.157360076904411],
          [73.072914123535327, 18.157361984252987],
          [73.072914123535327, 18.156803131103459],
          [73.072639465332315, 18.15681076049799],
          [73.072639465332315, 18.156530380249023],
          [73.073196411132869, 18.156530380249023],
          [73.073196411132869, 18.15681076049799],
          [73.073471069336108, 18.156803131103459],
          [73.073471069336108, 18.157083511352653],
          [73.073753356933821, 18.157083511352653],
          [73.073753356933821, 18.157361984252987],
          [73.074028015136662, 18.157360076904411],
          [73.074028015136662, 18.157640457153377],
          [73.074302673339901, 18.157640457153377],
          [73.074302673339901, 18.157920837402344],
          [73.074584960937614, 18.157915115356445],
          [73.074584960937614, 18.15847206115717],
          [73.074859619140625, 18.158470153808594],
          [73.074859619140625, 18.159030914306697],
          [73.075141906738565, 18.159030914306697],
          [73.075141906738565, 18.159309387207088],
          [73.075416564941406, 18.159305572509766],
          [73.075416564941406, 18.159584045410156],
          [73.075965881347827, 18.159580230712947],
          [73.075965881347827, 18.159860610961914],
          [73.076560974121094, 18.159860610961914],
          [73.077079772949162, 18.159860610961914],
          [73.077079772949162, 18.160140991210881],
          [73.077362060546932, 18.160137176513729],
          [73.077362060546932, 18.16069412231451],
          [73.077651977539006, 18.160690307617301],
          [73.077651977539006, 18.161529541015625],
          [73.077919006347713, 18.161529541015625],
          [73.077919006347713, 18.162082672119197],
          [73.078186035156534, 18.162080764770621],
          [73.078186035156534, 18.162370681762752],
          [73.079307556152401, 18.162370681762752],
          [73.079307556152401, 18.162080764770621],
          [73.079864501953352, 18.162082672119197],
          [73.079864501953352, 18.16180610656744],
          [73.080398559570369, 18.161809921264592],
          [73.080398559570369, 18.161529541015625],
          [73.080688476562614, 18.161529541015625],
          [73.080688476562614, 18.160690307617301],
          [73.080970764160213, 18.16069412231451],
          [73.080970764160213, 18.159860610961914],
          [73.081253051758097, 18.159860610961914],
          [73.081253051758097, 18.159030914306697],
          [73.081527709960937, 18.159030914306697],
          [73.081527709960937, 18.158189773559627],
          [73.081253051758097, 18.158193588256779],
          [73.081253051758097, 18.156528472900447],
          [73.081527709960937, 18.156530380249023],
          [73.081527709960937, 18.15624046325695],
          [73.081802368164347, 18.15624046325695],
          [73.081802368164347, 18.156530380249023],
          [73.082084655761889, 18.156528472900447],
          [73.082084655761889, 18.157361984252987],
          [73.082359313964901, 18.157360076904411],
          [73.082359313964901, 18.157640457153377],
          [73.083190917968693, 18.157640457153377],
          [73.083190917968693, 18.157920837402344],
          [73.084030151367244, 18.157920837402344],
          [73.084030151367244, 18.157360076904411],
          [73.084304809570597, 18.157361984252987],
          [73.084304809570597, 18.156803131103459],
          [73.085136413574389, 18.15681076049799],
          [73.085136413574389, 18.156530380249023],
          [73.085418701172159, 18.156530380249023],
          [73.085418701172159, 18.15596961975109],
          [73.085693359375171, 18.155971527099666],
          [73.085693359375171, 18.155416488647518],
          [73.085983276367244, 18.15542030334467],
          [73.085983276367244, 18.154859542846737],
          [73.086250305175952, 18.154861450195312],
          [73.086250305175952, 18.154027938842773],
          [73.086532592773665, 18.154029846191349],
          [73.086532592773665, 18.1526393890382],
          [73.086250305175952, 18.1526393890382],
          [73.086250305175952, 18.151340484619141],
          [73.086250305175952, 18.150693893432731],
          [73.086524963378963, 18.150693893432731],
          [73.086524963378963, 18.150417327880916],
          [73.087081909179744, 18.150417327880916],
          [73.087081909179744, 18.150693893432731],
          [73.087364196777457, 18.150693893432731],
          [73.087364196777457, 18.150829315185604],
          [73.087364196777457, 18.150972366333065],
          [73.087638854980469, 18.150968551635742],
          [73.087638854980469, 18.151252746582088],
          [73.087905883789347, 18.151252746582088],
          [73.087905883789347, 18.151531219482422],
          [73.08819580078125, 18.15152740478527],
          [73.08819580078125, 18.152082443237248],
          [73.087905883789347, 18.152082443237248],
          [73.087905883789347, 18.15542030334467],
          [73.087638854980469, 18.15542030334467],
          [73.087638854980469, 18.155700683593864],
          [73.087364196777457, 18.155693054199276],
          [73.087364196777457, 18.156250000000057],
          [73.087081909179744, 18.156250000000057],
          [73.087081909179744, 18.157083511352653],
          [73.086822509765796, 18.157079696655273],
          [73.086822509765796, 18.157640457153377],
          [73.087081909179744, 18.157640457153377],
          [73.087081909179744, 18.157920837402344],
          [73.087364196777457, 18.157915115356445],
          [73.087364196777457, 18.158193588256779],
          [73.087081909179744, 18.158193588256779],
          [73.087081909179744, 18.15847206115717],
          [73.086250305175952, 18.158470153808594],
          [73.086250305175952, 18.15875053405756],
          [73.085693359375171, 18.15875053405756],
          [73.085693359375171, 18.159030914306697],
          [73.085418701172159, 18.159030914306697],
          [73.085418701172159, 18.159309387207088],
          [73.085136413574389, 18.159305572509766],
          [73.085136413574389, 18.159584045410156],
          [73.084861755371378, 18.159580230712947],
          [73.084861755371378, 18.159860610961914],
          [73.084297180176065, 18.159860610961914],
          [73.084297180176065, 18.160419464111271],
          [73.084030151367244, 18.160419464111271],
          [73.084030151367244, 18.161251068115234],
          [73.083747863769645, 18.161251068115234],
          [73.083747863769645, 18.161809921264592],
          [73.084304809570597, 18.16180610656744],
          [73.084304809570597, 18.162082672119197],
          [73.084861755371378, 18.162080764770621],
          [73.084861755371378, 18.162370681762752],
          [73.085136413574389, 18.162370681762752],
          [73.085136413574389, 18.162637710571403],
          [73.086250305175952, 18.162637710571403],
          [73.086250305175952, 18.162921905517578],
          [73.086807250976506, 18.162916183471793],
          [73.086807250976506, 18.163194656372184],
          [73.087081909179744, 18.163194656372184],
          [73.087081909179744, 18.163473129272575],
          [73.087638854980469, 18.163469314575195],
          [73.087638854980469, 18.163751602172908],
          [73.08819580078125, 18.163751602172908],
          [73.08819580078125, 18.164030075073299],
          [73.089027404785213, 18.164028167724723],
          [73.089027404785213, 18.164304733276367],
          [73.089302062988452, 18.164304733276367],
          [73.089302062988452, 18.163473129272575],
          [73.089584350586165, 18.163473129272575],
          [73.089584350586165, 18.163194656372184],
          [73.089859008789006, 18.163194656372184],
          [73.089859008789006, 18.162916183471793],
          [73.090141296386776, 18.162921905517578],
          [73.090141296386776, 18.162637710571403],
          [73.090415954589957, 18.162637710571403],
          [73.090415954589957, 18.162370681762752],
          [73.09124755859375, 18.162370681762752],
          [73.09124755859375, 18.162080764770621],
          [73.091796875000171, 18.162080764770621],
          [73.091796875000171, 18.162370681762752],
          [73.092086791992244, 18.162370681762752],
          [73.092086791992244, 18.162637710571403],
          [73.092361450195483, 18.162637710571403],
          [73.092361450195483, 18.162921905517578],
          [73.092636108398665, 18.162916183471793],
          [73.092636108398665, 18.163194656372184],
          [73.092361450195483, 18.163194656372184],
          [73.092361450195483, 18.163473129272575],
          [73.092086791992244, 18.163469314575195],
          [73.092086791992244, 18.164030075073299],
          [73.091804504394702, 18.164028167724723],
          [73.091804504394702, 18.164304733276367],
          [73.09152984619169, 18.164304733276367],
          [73.09152984619169, 18.164861679077092],
          [73.09124755859375, 18.164861679077092],
          [73.09124755859375, 18.165140151977482],
          [73.090698242187557, 18.165138244628906],
          [73.090698242187557, 18.165416717529297],
          [73.090415954589957, 18.165416717529297],
          [73.090415954589957, 18.165138244628906],
          [73.090141296386776, 18.165138244628906],
          [73.090141296386776, 18.165416717529297],
          [73.089859008789006, 18.165409088134766],
          [73.089859008789006, 18.165702819824219],
          [73.089584350586165, 18.165695190429688],
          [73.089584350586165, 18.167083740234432],
          [73.089859008789006, 18.167081832885799],
          [73.089859008789006, 18.16736030578619],
          [73.090141296386776, 18.16736030578619],
          [73.090141296386776, 18.167640686035156],
          [73.090690612792969, 18.167640686035156],
          [73.090698242187557, 18.16736030578619],
          [73.09124755859375, 18.16736030578619],
          [73.09124755859375, 18.167640686035156],
          [73.09152984619169, 18.167640686035156],
          [73.09152984619169, 18.167921066284123],
          [73.09124755859375, 18.167917251586971],
          [73.09124755859375, 18.168193817138786],
          [73.090972900390909, 18.168193817138786],
          [73.090972900390909, 18.168472290039119],
          [73.090698242187557, 18.168470382690543],
          [73.090698242187557, 18.169031143188477],
          [73.090415954589957, 18.169031143188477],
          [73.090415954589957, 18.169309616088867],
          [73.089859008789006, 18.169305801391715],
          [73.089859008789006, 18.169584274292106],
          [73.089584350586165, 18.169584274292106],
          [73.089591979980696, 18.169860839843693],
          [73.088752746582202, 18.169860839843693],
          [73.088752746582202, 18.17014122009283],
          [73.08819580078125, 18.17014122009283],
          [73.08819580078125, 18.170419692993221],
          [73.087913513183878, 18.170415878295898],
          [73.087913513183878, 18.170694351196289],
          [73.087638854980469, 18.170694351196289],
          [73.087638854980469, 18.170972824096623],
          [73.087364196777457, 18.170972824096623],
          [73.087364196777457, 18.170694351196289],
          [73.087081909179744, 18.170694351196289],
          [73.087081909179744, 18.170139312744254],
          [73.086822509765796, 18.17014122009283],
          [73.086822509765796, 18.169860839843693],
          [73.085975646972713, 18.169860839843693],
          [73.085975646972713, 18.169584274292106],
          [73.085693359375171, 18.169580459594727],
          [73.085693359375171, 18.169860839843693],
          [73.085418701172159, 18.169860839843693],
          [73.085418701172159, 18.169580459594727],
          [73.085136413574389, 18.169580459594727],
          [73.085136413574389, 18.169860839843693],
          [73.084030151367244, 18.169860839843693],
          [73.084030151367244, 18.17014122009283],
          [73.083747863769645, 18.17014122009283],
          [73.083747863769645, 18.169860839843693],
          [73.083190917968693, 18.169860839843693],
          [73.083190917968693, 18.17014122009283],
          [73.082916259765852, 18.17014122009283],
          [73.082916259765852, 18.170419692993221],
          [73.082641601562671, 18.170415878295898],
          [73.082641601562671, 18.170694351196289],
          [73.082359313964901, 18.170694351196289],
          [73.082359313964901, 18.170972824096623],
          [73.082077026367358, 18.170970916748047],
          [73.082077026367358, 18.171249389648438],
          [73.081802368164347, 18.171249389648438],
          [73.081802368164347, 18.171541213989315],
          [73.081253051758097, 18.171527862548828],
          [73.081253051758097, 18.172082901000977],
          [73.080970764160213, 18.172080993652401],
          [73.080970764160213, 18.172920227050724],
          [73.080688476562614, 18.172920227050724],
          [73.080688476562614, 18.174030303955078],
          [73.080970764160213, 18.174030303955078],
          [73.080970764160213, 18.174310684204045],
          [73.080696105957145, 18.174304962158317],
          [73.080696105957145, 18.175970077514648],
          [73.080398559570369, 18.175968170166072],
          [73.080398559570369, 18.176809310913143],
          [73.080139160156193, 18.17680549621582],
          [73.080139160156193, 18.177083969116211],
          [73.079856872558821, 18.177078247070426],
          [73.079856872558821, 18.177642822265739],
          [73.080139160156193, 18.177642822265739],
          [73.080139160156193, 18.177919387817326],
          [73.080413818359432, 18.17791748046875],
          [73.080413818359432, 18.178194046020565],
          [73.080688476562614, 18.178190231323356],
          [73.080688476562614, 18.17902946472168],
          [73.080398559570369, 18.17902946472168],
          [73.080398559570369, 18.179309844970646],
          [73.080139160156193, 18.179309844970646],
          [73.080139160156193, 18.17902946472168],
          [73.079856872558821, 18.17902946472168],
          [73.079856872558821, 18.178752899169922],
          [73.076248168945369, 18.178752899169922],
          [73.076248168945369, 18.17902946472168],
          [73.075965881347827, 18.17902946472168],
          [73.075965881347827, 18.179861068725643],
          [73.075691223144815, 18.179861068725643],
          [73.075691223144815, 18.180694580078239],
          [73.075416564941406, 18.180694580078239],
          [73.075416564941406, 18.180973052978629],
          [73.075141906738565, 18.180973052978629],
          [73.075141906738565, 18.180694580078239],
          [73.074859619140625, 18.180694580078239],
          [73.074859619140625, 18.179861068725643],
          [73.073753356933821, 18.179861068725643],
          [73.073753356933821, 18.180139541626033],
          [73.073471069336108, 18.180139541626033],
          [73.073471069336108, 18.180416107177848],
          [73.072364807128906, 18.180416107177848],
          [73.072364807128906, 18.180694580078239],
          [73.071807861328125, 18.180694580078239],
          [73.071807861328125, 18.180973052978629],
          [73.071517944336222, 18.180971145629826],
          [73.071517944336222, 18.181249618530387],
          [73.070968627929801, 18.181249618530387],
          [73.070968627929801, 18.181529998779354],
          [73.070419311523608, 18.181528091430778],
          [73.070419311523608, 18.181804656982422],
          [73.069862365722827, 18.181804656982422],
          [73.069862365722827, 18.182083129882756],
          [73.069580078125057, 18.182083129882756],
          [73.069580078125057, 18.182361602783146],
          [73.069030761719034, 18.18235969543457],
          [73.069030761719034, 18.182640075683537],
          [73.068748474121094, 18.182640075683537],
          [73.068748474121094, 18.182920455932674],
          [73.068191528320369, 18.182920455932674],
          [73.068191528320369, 18.183200836181697],
          [73.067642211914119, 18.183200836181697],
          [73.067642211914119, 18.183481216430664],
          [73.067085266113509, 18.1834716796875],
          [73.067092895507869, 18.183750152587891],
          [73.066802978515796, 18.183750152587891],
          [73.066802978515796, 18.184310913086051],
          [73.066528320312557, 18.184305191040096],
          [73.066528320312557, 18.184583663940487],
          [73.065971374512003, 18.184579849243278],
          [73.065971374512003, 18.184860229492244],
          [73.065711975097713, 18.184860229492244],
          [73.065711975097713, 18.185140609741211],
          [73.065139770507869, 18.185140609741211],
          [73.065139770507869, 18.185420989990178],
          [73.064582824707088, 18.18541526794445],
          [73.064582824707088, 18.18569374084484],
          [73.064308166503849, 18.18569374084484],
          [73.064308166503849, 18.185972213745174],
          [73.064025878906477, 18.185970306396598],
          [73.064025878906477, 18.186250686645565],
          [73.063468933105526, 18.186250686645565],
          [73.063468933105526, 18.186809539794922],
          [73.063194274902514, 18.18680572509777],
          [73.063194274902514, 18.187084197998161],
          [73.062919616699503, 18.187080383300781],
          [73.062919616699503, 18.187360763549748],
          [73.062652587890625, 18.187360763549748],
          [73.062652587890625, 18.187641143798885],
          [73.062362670898722, 18.187641143798885],
          [73.062362670898722, 18.187919616699276],
          [73.062080383300781, 18.187915802001953],
          [73.062080383300781, 18.188194274902344],
          [73.06180572509777, 18.188194274902344],
          [73.06180572509777, 18.188472747802678],
          [73.061531066894588, 18.188470840454102],
          [73.061531066894588, 18.188751220703068],
          [73.061248779296818, 18.188751220703068],
          [73.061248779296818, 18.189029693603459],
          [73.060966491699276, 18.189029693603459],
          [73.060966491699276, 18.18930816650402],
          [73.060691833496264, 18.189306259155273],
          [73.060691833496264, 18.189582824707031],
          [73.060417175293026, 18.189580917358455],
          [73.060417175293026, 18.190141677856388],
          [73.060142517090014, 18.190141677856388],
          [73.060142517090014, 18.190420150756779],
          [73.059860229492472, 18.190416336059627],
          [73.059860229492472, 18.190694808960018],
          [73.059585571289062, 18.190694808960018],
          [73.059585571289062, 18.193473815918082],
          [73.059860229492472, 18.193471908569279],
          [73.059860229492472, 18.19375038146967],
          [73.060142517090014, 18.19375038146967],
          [73.060142517090014, 18.194860458374023],
          [73.060417175293026, 18.194860458374023],
          [73.060417175293026, 18.19514083862299],
          [73.060691833496264, 18.195138931274414],
          [73.060691833496264, 18.195695877075195],
          [73.061248779296818, 18.195695877075195],
          [73.061248779296818, 18.195972442626953],
          [73.061531066894588, 18.195970535278377],
          [73.061531066894588, 18.196250915527344],
          [73.061813354492301, 18.196250915527344],
          [73.061813354492301, 18.196529388427734],
          [73.062652587890625, 18.196529388427734],
          [73.062652587890625, 18.196809768676701],
          [73.062919616699503, 18.196804046630973],
          [73.062919616699503, 18.197082519531307],
          [73.063468933105526, 18.197080612182731],
          [73.063468933105526, 18.197360992431697],
          [73.064025878906477, 18.197360992431697],
          [73.064025878906477, 18.197639465332088],
          [73.06485748291027, 18.197639465332088],
          [73.06485748291027, 18.197919845581055],
          [73.065139770507869, 18.197919845581055],
          [73.065139770507869, 18.197639465332088],
          [73.065330505371151, 18.197639465332088],
          [73.065971374512003, 18.197639465332088],
          [73.065971374512003, 18.197919845581055],
          [73.067916870117301, 18.197919845581055],
          [73.067916870117301, 18.197639465332088],
          [73.06845855712919, 18.197639465332088],
          [73.06845855712919, 18.197360992431697],
          [73.069030761719034, 18.197360992431697],
          [73.069030761719034, 18.197080612182731],
          [73.069580078125057, 18.197080612182731],
          [73.069580078125057, 18.197360992431697],
          [73.070686340332088, 18.197360992431697],
          [73.070686340332088, 18.197639465332088],
          [73.071807861328125, 18.197639465332088],
          [73.071807861328125, 18.197919845581055],
          [73.072082519531534, 18.197914123535099],
          [73.072082519531534, 18.198194503784293],
          [73.072639465332315, 18.198190689086914],
          [73.072639465332315, 18.198480606079215],
          [73.073196411132869, 18.198480606079215],
          [73.073196411132869, 18.198749542236442],
          [73.073753356933821, 18.198749542236442],
          [73.073753356933821, 18.199029922485408],
          [73.074584960937614, 18.199026107788086],
          [73.074592590332145, 18.199300765991268],
          [73.075141906738565, 18.199308395385799],
          [73.075141906738565, 18.199861526489201],
          [73.075492858886776, 18.199859619140625],
          [73.075691223144815, 18.199859619140625],
          [73.075691223144815, 18.200700759887752],
          [73.075965881347827, 18.200700759887752],
          [73.075965881347827, 18.201810836792106],
          [73.076248168945369, 18.201810836792106],
          [73.076248168945369, 18.202358245849723],
          [73.076530456543139, 18.202358245849723],
          [73.076530456543139, 18.20402908325201],
          [73.076248168945369, 18.20402908325201],
          [73.076248168945369, 18.204309463500977],
          [73.076530456543139, 18.204305648803825],
          [73.076530456543139, 18.204584121704215],
          [73.076248168945369, 18.204580307006836],
          [73.076248168945369, 18.207639694213867],
          [73.076530456543139, 18.207639694213867],
          [73.076530456543139, 18.208749771118221],
          [73.076805114746321, 18.208749771118221],
          [73.076805114746321, 18.209304809570426],
          [73.077079772949162, 18.209302902221623],
          [73.077079772949162, 18.210140228271541],
          [73.077362060546932, 18.210140228271541],
          [73.077362060546932, 18.210710525512809],
          [73.077919006347713, 18.210710525512809],
          [73.077919006347713, 18.211530685424862],
          [73.078193664551065, 18.211526870727539],
          [73.078193664551065, 18.21208381652832],
          [73.078475952148438, 18.212080001831112],
          [73.078475952148438, 18.212640762329045],
          [73.078750610351847, 18.212638854980469],
          [73.078750610351847, 18.213193893432674],
          [73.079025268554858, 18.213193893432674],
          [73.079025268554858, 18.213750839233398],
          [73.079307556152401, 18.213750839233398],
          [73.079307556152401, 18.214031219482365],
          [73.079582214355639, 18.214027404785213],
          [73.079582214355639, 18.214582443237362],
          [73.079856872558821, 18.214580535888786],
          [73.079856872558821, 18.215137481689567],
          [73.080139160156193, 18.215137481689567],
          [73.080139160156193, 18.215419769287109],
          [73.080696105957145, 18.215415954589957],
          [73.080696105957145, 18.215694427490348],
          [73.080970764160213, 18.215690612792969],
          [73.080970764160213, 18.21624755859375],
          [73.080696105957145, 18.21624755859375],
          [73.080696105957145, 18.216529846191463],
          [73.080398559570369, 18.216520309448356],
          [73.080398559570369, 18.21681022644043],
          [73.080139160156193, 18.21681022644043],
          [73.080139160156193, 18.217920303344783],
          [73.080398559570369, 18.217920303344783],
          [73.080398559570369, 18.218202590942383],
          [73.080688476562614, 18.218202590942383],
          [73.080688476562614, 18.221530914306641],
          [73.080398559570369, 18.221530914306641],
          [73.080398559570369, 18.221809387207031],
          [73.080139160156193, 18.221809387207031],
          [73.080139160156193, 18.222360610961857],
          [73.079856872558821, 18.222360610961857],
          [73.079856872558821, 18.222650527954158],
          [73.079307556152401, 18.222650527954158],
          [73.079307556152401, 18.222919464111385],
          [73.079025268554858, 18.222917556762809],
          [73.079025268554858, 18.223194122314453],
          [73.078750610351847, 18.223190307617244],
          [73.078750610351847, 18.223751068115178],
          [73.078475952148438, 18.223751068115178],
          [73.078475952148438, 18.225139617919922],
          [73.078750610351847, 18.225139617919922],
          [73.078750610351847, 18.225973129272518],
          [73.079582214355639, 18.225971221923885],
          [73.079582214355639, 18.226249694824276],
          [73.080398559570369, 18.226249694824276],
          [73.080398559570369, 18.226530075073242],
          [73.080696105957145, 18.22652626037609],
          [73.080696105957145, 18.227083206176871],
          [73.080413818359432, 18.227083206176871],
          [73.080413818359432, 18.227361679077205],
          [73.079856872558821, 18.227359771728629],
          [73.079856872558821, 18.22763824462902],
          [73.080139160156193, 18.227636337280273],
          [73.080139160156193, 18.228471755981388],
          [73.080413818359432, 18.228471755981388],
          [73.080413818359432, 18.229583740234375],
          [73.080688476562614, 18.229579925537166],
          [73.080688476562614, 18.230140686035099],
          [73.080398559570369, 18.230140686035099],
          [73.080398559570369, 18.231252670288086],
          [73.080139160156193, 18.231252670288086],
          [73.080139160156193, 18.23153114318842],
          [73.079856872558821, 18.23153114318842],
          [73.079856872558821, 18.23180961608881],
          [73.079582214355639, 18.231805801391658],
          [73.079582214355639, 18.232084274292049],
          [73.078750610351847, 18.23208045959484],
          [73.078750610351847, 18.23236274719244],
          [73.078186035156534, 18.23236274719244],
          [73.078186035156534, 18.233749389648551],
          [73.078475952148438, 18.233749389648551],
          [73.078475952148438, 18.235694885253906],
          [73.078193664551065, 18.235694885253906],
          [73.078193664551065, 18.235971450805664],
          [73.077919006347713, 18.235969543457088],
          [73.077919006347713, 18.236249923706055],
          [73.077362060546932, 18.236249923706055],
          [73.077362060546932, 18.235969543457088],
          [73.077079772949162, 18.235971450805664],
          [73.077079772949162, 18.235694885253906],
          [73.076530456543139, 18.235694885253906],
          [73.076530456543139, 18.235971450805664],
          [73.076248168945369, 18.235969543457088],
          [73.076248168945369, 18.238750457763729],
          [73.075965881347827, 18.238750457763729],
          [73.075965881347827, 18.239030838012695],
          [73.074859619140625, 18.239030838012695],
          [73.074859619140625, 18.239311218261719],
          [73.073753356933821, 18.239305496215934],
          [73.073753356933821, 18.239583969116325],
          [73.072906494140796, 18.239580154418945],
          [73.072906494140796, 18.239860534667912],
          [73.071807861328125, 18.239860534667912],
          [73.071807861328125, 18.240140914917049],
          [73.071525573730753, 18.240137100219727],
          [73.071525573730753, 18.240694046020508],
          [73.071250915527401, 18.240694046020508],
          [73.071250915527401, 18.240972518920842],
          [73.070419311523608, 18.240970611572266],
          [73.070419311523608, 18.241249084472656],
          [73.069862365722827, 18.241249084472656],
          [73.069862365722827, 18.241527557373047],
          [73.069580078125057, 18.241527557373047],
          [73.069580078125057, 18.24180984497076],
          [73.069030761719034, 18.241807937622184],
          [73.069030761719034, 18.242082595825195],
          [73.06845855712919, 18.242080688476619],
          [73.06845855712919, 18.242637634277401],
          [73.068191528320369, 18.242637634277401],
          [73.068191528320369, 18.243194580078182],
          [73.067916870117301, 18.243190765380973],
          [73.067916870117301, 18.24403190612793],
          [73.067642211914119, 18.244028091430721],
          [73.067642211914119, 18.244583129882926],
          [73.067359924316349, 18.244583129882926],
          [73.067359924316349, 18.24486160278326],
          [73.067092895507869, 18.24486160278326],
          [73.067092895507869, 18.245420455932617],
          [73.066528320312557, 18.245420455932617],
          [73.066528320312557, 18.245702743530387],
          [73.066246032715014, 18.245702743530387],
          [73.066253662109546, 18.246250152587834],
          [73.065711975097713, 18.246250152587834],
          [73.065711975097713, 18.246820449829102],
          [73.065414428711222, 18.246805191040039],
          [73.065414428711222, 18.24708366394043],
          [73.06485748291027, 18.247079849243221],
          [73.06485748291027, 18.247920989990348],
          [73.064582824707088, 18.247917175292969],
          [73.064582824707088, 18.248193740844783],
          [73.064025878906477, 18.248193740844783],
          [73.064025878906477, 18.248472213745117],
          [73.063468933105526, 18.248470306396541],
          [73.063468933105526, 18.249031066894474],
          [73.063186645507983, 18.249031066894474],
          [73.063186645507983, 18.249309539794865],
          [73.062919616699503, 18.249309539794865],
          [73.062919616699503, 18.249589920044059],
          [73.062637329101563, 18.249584197998104],
          [73.062652587890625, 18.249860763549862],
          [73.062080383300781, 18.249860763549862],
          [73.062080383300781, 18.250419616699219],
          [73.06180572509777, 18.250415802002067],
          [73.06180572509777, 18.250972747802848],
          [73.061531066894588, 18.250972747802848],
          [73.061531066894588, 18.252361297607365],
          [73.061248779296818, 18.252361297607365],
          [73.061248779296818, 18.252639770507756],
          [73.061531066894588, 18.252639770507756],
          [73.061531066894588, 18.254304885864315],
          [73.061813354492301, 18.254301071167106],
          [73.061813354492301, 18.256809234619141],
          [73.062080383300781, 18.256805419921989],
          [73.062080383300781, 18.257083892822379],
          [73.062362670898722, 18.257078170776424],
          [73.062362670898722, 18.257358551025391],
          [73.062080383300781, 18.257358551025391],
          [73.062080383300781, 18.257640838623104],
          [73.062362670898722, 18.257640838623104],
          [73.062362670898722, 18.258193969726562],
          [73.062637329101563, 18.258193969726562],
          [73.062637329101563, 18.258472442626896],
          [73.062919616699503, 18.258472442626896],
          [73.062919616699503, 18.258760452270621],
          [73.063186645507983, 18.258760452270621],
          [73.063186645507983, 18.259029388427678],
          [73.063468933105526, 18.259029388427678],
          [73.063468933105526, 18.259309768676815],
          [73.063751220703296, 18.259309768676815],
          [73.063751220703296, 18.259862899780273],
          [73.064025878906477, 18.259862899780273],
          [73.064025878906477, 18.260139465332031],
          [73.064582824707088, 18.260139465332031],
          [73.064582824707088, 18.260694503784237],
          [73.06485748291027, 18.260694503784237],
          [73.06485748291027, 18.260974884033203],
          [73.065414428711222, 18.260974884033203],
          [73.065414428711222, 18.261249542236385],
          [73.065696716308594, 18.261249542236385],
          [73.065711975097713, 18.261800765991211],
          [73.066528320312557, 18.261806488037166],
          [73.066528320312557, 18.262083053588981],
          [73.066802978515796, 18.262083053588981],
          [73.066802978515796, 18.262361526489315],
          [73.067359924316349, 18.262359619140739],
          [73.067359924316349, 18.262920379638672],
          [73.067642211914119, 18.262920379638672],
          [73.067642211914119, 18.263200759887695],
          [73.067916870117301, 18.263200759887695],
          [73.067916870117301, 18.264030456543026],
          [73.068191528320369, 18.264030456543026],
          [73.068191528320369, 18.264310836792049],
          [73.06845855712919, 18.264310836792049],
          [73.06845855712919, 18.265140533447209],
          [73.068748474121094, 18.265140533447209],
          [73.068748474121094, 18.265420913696403],
          [73.069030761719034, 18.265420913696403],
          [73.069030761719034, 18.26680946350092],
          [73.068748474121094, 18.26680946350092],
          [73.068748474121094, 18.267919540405273],
          [73.06845855712919, 18.267919540405273],
          [73.06845855712919, 18.269029617309627],
          [73.068191528320369, 18.269029617309627],
          [73.068191528320369, 18.269308090210018],
          [73.067916870117301, 18.269308090210018],
          [73.067916870117301, 18.270141601562614],
          [73.067642211914119, 18.270141601562614],
          [73.067642211914119, 18.270420074462947],
          [73.067359924316349, 18.270416259765625],
          [73.067359924316349, 18.270969390869197],
          [73.067092895507869, 18.270969390869197],
          [73.067092895507869, 18.271530151367131],
          [73.066802978515796, 18.271528244018555],
          [73.066802978515796, 18.271804809570369],
          [73.066528320312557, 18.271804809570369],
          [73.066528320312557, 18.27208328247076],
          [73.066253662109546, 18.27208328247076],
          [73.066253662109546, 18.272361755371094],
          [73.065971374512003, 18.272361755371094],
          [73.065971374512003, 18.272640228271484],
          [73.065711975097713, 18.272640228271484],
          [73.065711975097713, 18.273202896118221],
          [73.065414428711222, 18.27319526672369],
          [73.065414428711222, 18.27347373962408],
          [73.065139770507869, 18.273471832275447],
          [73.065139770507869, 18.274311065673828],
          [73.06485748291027, 18.274305343628043],
          [73.06485748291027, 18.274583816528434],
          [73.064582824707088, 18.274581909179631],
          [73.064582824707088, 18.274860382080021],
          [73.064308166503849, 18.274860382080021],
          [73.064308166503849, 18.275140762329158],
          [73.064025878906477, 18.275140762329158],
          [73.064025878906477, 18.275421142578182],
          [73.063751220703296, 18.275417327880973],
          [73.063751220703296, 18.275695800781364],
          [73.063468933105526, 18.275695800781364],
          [73.063468933105526, 18.275972366332951],
          [73.063186645507983, 18.275970458984375],
          [73.063186645507983, 18.276531219482536],
          [73.062919616699503, 18.276531219482536],
          [73.062919616699503, 18.277639389038086],
          [73.063194274902514, 18.277639389038086],
          [73.063194274902514, 18.278194427490291],
          [73.062919616699503, 18.278194427490291],
          [73.062919616699503, 18.278472900390682],
          [73.062637329101563, 18.278472900390682],
          [73.062637329101563, 18.278194427490291],
          [73.062080383300781, 18.278194427490291],
          [73.062080383300781, 18.277914047241325],
          [73.06180572509777, 18.277914047241325],
          [73.06180572509777, 18.278194427490291],
          [73.061248779296818, 18.278194427490291],
          [73.061248779296818, 18.277914047241325],
          [73.059860229492472, 18.277914047241325],
          [73.059860229492472, 18.278194427490291],
          [73.058746337890909, 18.278194427490291],
          [73.058746337890909, 18.278472900390682],
          [73.058471679687557, 18.278470993042049],
          [73.058471679687557, 18.27874946594244],
          [73.057907104492244, 18.27874946594244],
          [73.057907104492244, 18.279029846191406],
          [73.057357788086165, 18.279029846191406],
          [73.057357788086165, 18.279310226440373],
          [73.056808471679972, 18.279306411743221],
          [73.056808471679972, 18.279582977295036],
          [73.055625915527401, 18.279571533203125],
          [73.055419921875057, 18.279569625854549],
          [73.055450439453352, 18.279880523681641],
          [73.052642822265909, 18.279859542846793],
          [73.052642822265909, 18.280420303344727],
          [73.05291748046875, 18.280416488647575],
          [73.05291748046875, 18.280971527099553],
          [73.052635192871378, 18.280971527099553],
          [73.052642822265909, 18.281248092651367],
          [73.052360534668026, 18.281248092651367],
          [73.052360534668026, 18.28153038024908],
          [73.052085876464957, 18.28153038024908],
          [73.052085876464957, 18.281810760498104],
          [73.051803588867244, 18.281805038452148],
          [73.051803588867244, 18.282083511352539],
          [73.051528930664006, 18.28207969665533],
          [73.051528930664006, 18.282930374145565],
          [73.051246643066634, 18.282918930053654],
          [73.051246643066634, 18.283193588256893],
          [73.050971984863452, 18.283189773559684],
          [73.050971984863452, 18.283748626709041],
          [73.050422668457202, 18.283748626709041],
          [73.050422668457202, 18.284309387206974],
          [73.050140380859659, 18.284305572509822],
          [73.050140380859659, 18.284584045410213],
          [73.049858093261719, 18.284584045410213],
          [73.049858093261719, 18.28490066528326],
          [73.049858093261719, 18.285699844360295],
          [73.049583435058878, 18.285694122314567],
          [73.049583435058878, 18.285972595214957],
          [73.049308776855526, 18.285972595214957],
          [73.049308776855526, 18.286809921264648],
          [73.049026489257926, 18.286809921264648],
          [73.049026489257926, 18.287919998169002],
          [73.048751831054744, 18.287919998169002],
          [73.048751831054744, 18.289030075073185],
          [73.048469543456974, 18.289028167724609],
          [73.048469543456974, 18.289304733276424],
          [73.048194885254134, 18.289304733276424],
          [73.048194885254134, 18.289583206176815],
          [73.047920227050952, 18.289579391479606],
          [73.047920227050952, 18.290420532226506],
          [73.047637939453182, 18.290416717529354],
          [73.047637939453182, 18.290971755981502],
          [73.047363281250171, 18.290969848632926],
          [73.047363281250171, 18.291530609130859],
          [73.047080993652628, 18.291528701782283],
          [73.047080993652628, 18.291805267334098],
          [73.046806335449219, 18.291799545288143],
          [73.046806335449219, 18.292640686035213],
          [73.046524047851847, 18.292638778686637],
          [73.046524047851847, 18.293193817138672],
          [73.046249389648438, 18.293190002441463],
          [73.046249389648438, 18.293750762939396],
          [73.045967102051065, 18.293750762939396],
          [73.045967102051065, 18.29403114318859],
          [73.045692443847713, 18.29403114318859],
          [73.045692443847713, 18.294868469238281],
          [73.045417785644474, 18.294868469238281],
          [73.045417785644474, 18.295141220092717],
          [73.045135498046932, 18.295137405395565],
          [73.045135498046932, 18.295694351196346],
          [73.044586181640682, 18.295694351196346],
          [73.044586181640682, 18.295972824096737],
          [73.044029235840128, 18.295970916748104],
          [73.044029235840128, 18.296247482299918],
          [73.043373107910156, 18.296247482299918],
          [73.043197631835938, 18.296247482299918],
          [73.043197631835938, 18.29708290100109],
          [73.042922973632926, 18.297079086303711],
          [73.042922973632926, 18.299030303955135],
          [73.043197631835938, 18.299028396606559],
          [73.043197631835938, 18.299863815307731],
          [73.043472290039347, 18.299861907958928],
          [73.043472290039347, 18.300420761108512],
          [73.044029235840128, 18.300420761108512],
          [73.044029235840128, 18.301250457763672],
          [73.044288635254077, 18.301250457763672],
          [73.044288635254077, 18.301811218261832],
          [73.044860839843921, 18.301805496215877],
          [73.044860839843921, 18.302082061767635],
          [73.045135498046932, 18.302082061767635],
          [73.045135498046932, 18.302360534668026],
          [73.045692443847713, 18.302360534668026],
          [73.045692443847713, 18.302640914916992],
          [73.046249389648438, 18.302640914916992],
          [73.046249389648438, 18.302919387817383],
          [73.047080993652628, 18.302917480468807],
          [73.047080993652628, 18.303195953369197],
          [73.048194885254134, 18.303195953369197],
          [73.048194885254134, 18.30374908447277],
          [73.051246643066634, 18.30374908447277],
          [73.051246643066634, 18.303472518921012],
          [73.052085876464957, 18.303472518921012],
          [73.052085876464957, 18.303195953369197],
          [73.052635192871378, 18.303195953369197],
          [73.052635192871378, 18.302917480468807],
          [73.05301666259794, 18.302917480468807],
          [73.053192138672159, 18.302919387817383],
          [73.053192138672159, 18.302640914916992],
          [73.053749084472713, 18.302640914916992],
          [73.053749084472713, 18.302360534668026],
          [73.054031372070483, 18.302360534668026],
          [73.054031372070483, 18.302080154419059],
          [73.054862976074276, 18.302082061767635],
          [73.054862976074276, 18.301805496215877],
          [73.055137634277457, 18.301811218261832],
          [73.055137634277457, 18.301530838012638],
          [73.055419921875057, 18.301530838012638],
          [73.055419921875057, 18.301250457763672],
          [73.055686950683878, 18.301250457763672],
          [73.055686950683878, 18.300970077514705],
          [73.05596923828125, 18.300973892211914],
          [73.05596923828125, 18.300693511962947],
          [73.05625152587919, 18.300693511962947],
          [73.05625152587919, 18.300416946411133],
          [73.057083129882983, 18.300420761108512],
          [73.057083129882983, 18.300140380859318],
          [73.060691833496264, 18.300140380859318],
          [73.060691833496264, 18.299861907958928],
          [73.06180572509777, 18.299863815307731],
          [73.06180572509777, 18.299583435058594],
          [73.063194274902514, 18.299583435058594],
          [73.063194274902514, 18.299304962158203],
          [73.065139770507869, 18.299310684204158],
          [73.065139770507869, 18.299030303955135],
          [73.065971374512003, 18.299030303955135],
          [73.065971374512003, 18.299310684204158],
          [73.066253662109546, 18.299304962158203],
          [73.066253662109546, 18.299583435058594],
          [73.067916870117301, 18.299583435058594],
          [73.067916870117301, 18.299304962158203],
          [73.068748474121094, 18.299310684204158],
          [73.068748474121094, 18.299030303955135],
          [73.070137023926009, 18.299030303955135],
          [73.070137023926009, 18.299310684204158],
          [73.070419311523608, 18.299310684204158],
          [73.070419311523608, 18.299030303955135],
          [73.072082519531534, 18.299030303955135],
          [73.072082519531534, 18.298751831054801],
          [73.072906494140796, 18.298751831054801],
          [73.072906494140796, 18.298469543457031],
          [73.076805114746321, 18.298469543457031],
          [73.076805114746321, 18.29819488525402],
          [73.076530456543139, 18.29819488525402],
          [73.076530456543139, 18.296247482299918],
          [73.076812744140852, 18.296247482299918],
          [73.076805114746321, 18.295972824096737],
          [73.077079772949162, 18.295972824096737],
          [73.077079772949162, 18.295694351196346],
          [73.077362060546932, 18.295694351196346],
          [73.077362060546932, 18.295415878295955],
          [73.079582214355639, 18.295419692993107],
          [73.079582214355639, 18.295141220092717],
          [73.081527709960937, 18.295141220092717],
          [73.081527709960937, 18.294868469238281],
          [73.081802368164347, 18.294868469238281],
          [73.081802368164347, 18.294580459594783],
          [73.082084655761889, 18.294582366943359],
          [73.082084655761889, 18.294027328491211],
          [73.082359313964901, 18.29403114318859],
          [73.082359313964901, 18.293750762939396],
          [73.082641601562671, 18.293750762939396],
          [73.082641601562671, 18.29347038269043],
          [73.082916259765852, 18.293472290039006],
          [73.082916259765852, 18.292915344238281],
          [73.083190917968693, 18.292921066284237],
          [73.083190917968693, 18.292079925537109],
          [73.083473205566463, 18.292083740234489],
          [73.083473205566463, 18.291528701782283],
          [73.083747863769645, 18.291530609130859],
          [73.083747863769645, 18.290969848632926],
          [73.084030151367244, 18.290971755981502],
          [73.084030151367244, 18.290416717529354],
          [73.084297180176065, 18.290420532226506],
          [73.084297180176065, 18.290220260620117],
          [73.084304809570597, 18.289583206176815],
          [73.084587097167969, 18.289583206176815],
          [73.084587097167969, 18.289304733276424],
          [73.084861755371378, 18.289304733276424],
          [73.084861755371378, 18.288749694824219],
          [73.085136413574389, 18.288749694824219],
          [73.085136413574389, 18.288473129272461],
          [73.085418701172159, 18.288473129272461],
          [73.085418701172159, 18.28819465637207],
          [73.085975646972713, 18.28819465637207],
          [73.085975646972713, 18.28791618347168],
          [73.086250305175952, 18.28791618347168],
          [73.086250305175952, 18.28819465637207],
          [73.086524963378963, 18.28819465637207],
          [73.086524963378963, 18.288473129272461],
          [73.086250305175952, 18.288473129272461],
          [73.086250305175952, 18.288749694824219],
          [73.085983276367244, 18.288740158081112],
          [73.085983276367244, 18.289030075073185],
          [73.085693359375171, 18.289028167724609],
          [73.085693359375171, 18.289304733276424],
          [73.085418701172159, 18.289304733276424],
          [73.085418701172159, 18.289583206176815],
          [73.085136413574389, 18.289583206176815],
          [73.085136413574389, 18.289829254150447],
          [73.085136413574389, 18.290420532226506],
          [73.084861755371378, 18.290416717529354],
          [73.084861755371378, 18.290971755981502],
          [73.084587097167969, 18.290969848632926],
          [73.084587097167969, 18.291530609130859],
          [73.084304809570597, 18.291528701782283],
          [73.084304809570597, 18.292083740234489],
          [73.084030151367244, 18.292079925537109],
          [73.084030151367244, 18.292921066284237],
          [73.083747863769645, 18.292915344238281],
          [73.083747863769645, 18.293472290039006],
          [73.083457946777401, 18.29347038269043],
          [73.083457946777401, 18.29403114318859],
          [73.083190917968693, 18.29403114318859],
          [73.083190917968693, 18.294309616088924],
          [73.082916259765852, 18.294309616088924],
          [73.082916259765852, 18.294868469238281],
          [73.082641601562671, 18.29486083984375],
          [73.082641601562671, 18.295694351196346],
          [73.082359313964901, 18.295694351196346],
          [73.082359313964901, 18.295972824096737],
          [73.082077026367358, 18.295970916748104],
          [73.082077026367358, 18.296247482299918],
          [73.080970764160213, 18.296247482299918],
          [73.080970764160213, 18.296531677246094],
          [73.078475952148438, 18.296531677246094],
          [73.078475952148438, 18.296810150146428],
          [73.078193664551065, 18.296806335449276],
          [73.078193664551065, 18.29708290100109],
          [73.077919006347713, 18.29708290100109],
          [73.077919006347713, 18.297359466552848],
          [73.077636718750114, 18.297359466552848],
          [73.077636718750114, 18.298469543457031],
          [73.077919006347713, 18.298469543457031],
          [73.077919006347713, 18.298751831054801],
          [73.078186035156534, 18.298751831054801],
          [73.078186035156534, 18.299030303955135],
          [73.078475952148438, 18.299028396606559],
          [73.078475952148438, 18.299583435058594],
          [73.078750610351847, 18.299579620361385],
          [73.078750610351847, 18.300140380859318],
          [73.079032897949389, 18.300140380859318],
          [73.079032897949389, 18.300420761108512],
          [73.079864501953352, 18.300416946411133],
          [73.079864501953352, 18.300693511962947],
          [73.080413818359432, 18.300693511962947],
          [73.080413818359432, 18.300973892211914],
          [73.082359313964901, 18.300970077514705],
          [73.082359313964901, 18.301250457763672],
          [73.082641601562671, 18.301250457763672],
          [73.082641601562671, 18.303810119628906],
          [73.082641601562671, 18.304861068725529],
          [73.082916259765852, 18.304861068725529],
          [73.082916259765852, 18.30513954162592],
          [73.082641601562671, 18.30513954162592],
          [73.082641601562671, 18.305419921875057],
          [73.082916259765852, 18.305419921875057],
          [73.082916259765852, 18.308200836181754],
          [73.083190917968693, 18.308200836181754],
          [73.083190917968693, 18.308748245239371],
          [73.082916259765852, 18.308748245239371],
          [73.082916259765852, 18.309310913085937],
          [73.082641601562671, 18.309310913085937],
          [73.082641601562671, 18.310140609741268],
          [73.082359313964901, 18.310140609741268],
          [73.082359313964901, 18.310419082641658],
          [73.082084655761889, 18.310417175293082],
          [73.082084655761889, 18.312084197998047],
          [73.082359313964901, 18.312084197998047],
          [73.082359313964901, 18.31291580200201],
          [73.082641601562671, 18.31291580200201],
          [73.082641601562671, 18.313472747802791],
          [73.082916259765852, 18.313472747802791],
          [73.082916259765852, 18.314029693603516],
          [73.083190917968693, 18.314029693603516],
          [73.083190917968693, 18.314310073852482],
          [73.083473205566463, 18.31430625915533],
          [73.083473205566463, 18.314584732055721],
          [73.083190917968693, 18.314584732055721],
          [73.083190917968693, 18.314861297607479],
          [73.083457946777401, 18.314859390258903],
          [73.083457946777401, 18.315139770507869],
          [73.083747863769645, 18.315139770507869],
          [73.083747863769645, 18.315694808960075],
          [73.084304809570597, 18.315694808960075],
          [73.084304809570597, 18.315971374511662],
          [73.084587097167969, 18.315969467163086],
          [73.084587097167969, 18.316249847412053],
          [73.084861755371378, 18.316249847412053],
          [73.084861755371378, 18.316804885864258],
          [73.085136413574389, 18.316804885864258],
          [73.085136413574389, 18.317361831664982],
          [73.085418701172159, 18.317361831664982],
          [73.085418701172159, 18.318471908569336],
          [73.085693359375171, 18.31847000122076],
          [73.085693359375171, 18.318750381469727],
          [73.085983276367244, 18.318750381469727],
          [73.085983276367244, 18.319030761718693],
          [73.086532592773665, 18.319030761718693],
          [73.086532592773665, 18.319311141967887],
          [73.086250305175952, 18.319305419921932],
          [73.086250305175952, 18.319583892822322],
          [73.086532592773665, 18.319580078125114],
          [73.086532592773665, 18.320140838623047],
          [73.086822509765796, 18.320140838623047],
          [73.086822509765796, 18.32042121887207],
          [73.087081909179744, 18.32042121887207],
          [73.087081909179744, 18.321250915527401],
          [73.087356567383097, 18.321250915527401],
          [73.087356567383097, 18.322359085083008],
          [73.087638854980469, 18.322359085083008],
          [73.087638854980469, 18.322637557983398],
          [73.087905883789347, 18.322637557983398],
          [73.087905883789347, 18.322919845581112],
          [73.08819580078125, 18.322916030883789],
          [73.08819580078125, 18.32347297668457],
          [73.088470458984659, 18.323469161987362],
          [73.088470458984659, 18.323751449584904],
          [73.08819580078125, 18.323751449584904],
          [73.08819580078125, 18.324031829834098],
          [73.087638854980469, 18.324031829834098],
          [73.087638854980469, 18.323751449584904],
          [73.087356567383097, 18.323751449584904],
          [73.087356567383097, 18.323190689086971],
          [73.087081909179744, 18.32319450378418],
          [73.087081909179744, 18.322916030883789],
          [73.086822509765796, 18.322919845581112],
          [73.086822509765796, 18.322637557983398],
          [73.086524963378963, 18.322637557983398],
          [73.086524963378963, 18.322359085083008],
          [73.086250305175952, 18.322359085083008],
          [73.086250305175952, 18.321527481079215],
          [73.085983276367244, 18.321527481079215],
          [73.085983276367244, 18.320140838623047],
          [73.085693359375171, 18.320140838623047],
          [73.085693359375171, 18.32042121887207],
          [73.085136413574389, 18.320419311523437],
          [73.085136413574389, 18.320693969726676],
          [73.084861755371378, 18.320693969726676],
          [73.084861755371378, 18.320972442627067],
          [73.084587097167969, 18.320970535278263],
          [73.084587097167969, 18.322637557983398],
          [73.084297180176065, 18.322637557983398],
          [73.084297180176065, 18.322919845581112],
          [73.084030151367244, 18.322916030883789],
          [73.084030151367244, 18.324861526489258],
          [73.083747863769645, 18.324848175048771],
          [73.083747863769645, 18.325420379638615],
          [73.084030151367244, 18.325420379638615],
          [73.084030151367244, 18.326530456542969],
          [73.084297180176065, 18.326530456542969],
          [73.084297180176065, 18.326810836791992],
          [73.085136413574389, 18.326810836791992],
          [73.085136413574389, 18.326530456542969],
          [73.085983276367244, 18.326530456542969],
          [73.085983276367244, 18.326250076294002],
          [73.087905883789347, 18.326250076294002],
          [73.087905883789347, 18.326810836791992],
          [73.085975646972713, 18.326805114746207],
          [73.085975646972713, 18.327083587646598],
          [73.085418701172159, 18.327083587646598],
          [73.085418701172159, 18.327362060546989],
          [73.085136413574389, 18.327360153198185],
          [73.085136413574389, 18.327640533447322],
          [73.084861755371378, 18.327638626098746],
          [73.084861755371378, 18.328193664550781],
          [73.085136413574389, 18.328193664550781],
          [73.085136413574389, 18.329584121704102],
          [73.084861755371378, 18.329580307006893],
          [73.084861755371378, 18.329860687255859],
          [73.084587097167969, 18.329860687255859],
          [73.084587097167969, 18.329580307006893],
          [73.084304809570597, 18.329584121704102],
          [73.084304809570597, 18.329305648803711],
          [73.084030151367244, 18.329309463501033],
          [73.084030151367244, 18.327360153198185],
          [73.083747863769645, 18.327362060546989],
          [73.083747863769645, 18.327083587646598],
          [73.083473205566463, 18.327083587646598],
          [73.083473205566463, 18.326805114746207],
          [73.083190917968693, 18.326810836791992],
          [73.083190917968693, 18.326530456542969],
          [73.082916259765852, 18.326530456542969],
          [73.082916259765852, 18.324848175048771],
          [73.082641601562671, 18.324861526489258],
          [73.082641601562671, 18.324581146240291],
          [73.082359313964901, 18.324581146240291],
          [73.082359313964901, 18.32347297668457],
          [73.082084655761889, 18.32347297668457],
          [73.082084655761889, 18.32319450378418],
          [73.081802368164347, 18.32319450378418],
          [73.081802368164347, 18.322916030883789],
          [73.081527709960937, 18.322919845581112],
          [73.081527709960937, 18.322637557983398],
          [73.081253051758097, 18.322637557983398],
          [73.081253051758097, 18.322359085083008],
          [73.080970764160213, 18.322359085083008],
          [73.080970764160213, 18.321809768676758],
          [73.080688476562614, 18.321809768676758],
          [73.080688476562614, 18.321527481079215],
          [73.080398559570369, 18.321527481079215],
          [73.080398559570369, 18.320970535278263],
          [73.080139160156193, 18.320972442627067],
          [73.080139160156193, 18.320138931274471],
          [73.079856872558821, 18.320140838623047],
          [73.079856872558821, 18.319580078125114],
          [73.079582214355639, 18.319583892822322],
          [73.079582214355639, 18.319305419921932],
          [73.079307556152401, 18.319311141967887],
          [73.079307556152401, 18.317640304565373],
          [73.079032897949389, 18.317640304565373],
          [73.079032897949389, 18.316801071167049],
          [73.078750610351847, 18.316804885864258],
          [73.078750610351847, 18.316249847412053],
          [73.079032897949389, 18.316249847412053],
          [73.079025268554858, 18.315694808960075],
          [73.078750610351847, 18.315694808960075],
          [73.078750610351847, 18.314584732055721],
          [73.078475952148438, 18.314584732055721],
          [73.078475952148438, 18.31430625915533],
          [73.077919006347713, 18.314310073852482],
          [73.077919006347713, 18.314029693603516],
          [73.077651977539006, 18.314029693603516],
          [73.077651977539006, 18.313751220703125],
          [73.077362060546932, 18.313751220703125],
          [73.077362060546932, 18.313190460205192],
          [73.077079772949162, 18.313194274902401],
          [73.077079772949162, 18.31291580200201],
          [73.076805114746321, 18.31291580200201],
          [73.076805114746321, 18.312639236450195],
          [73.076530456543139, 18.312641143798771],
          [73.076530456543139, 18.312362670898437],
          [73.076248168945369, 18.312362670898437],
          [73.076248168945369, 18.312080383300838],
          [73.075973510742358, 18.312084197998047],
          [73.075973510742358, 18.311805725097656],
          [73.075691223144815, 18.311809539794979],
          [73.075691223144815, 18.311252593994254],
          [73.075416564941406, 18.311252593994254],
          [73.075416564941406, 18.310968399047908],
          [73.074859619140625, 18.310970306396484],
          [73.074859619140625, 18.310693740844727],
          [73.074584960937614, 18.310693740844727],
          [73.074584960937614, 18.309858322143555],
          [73.074302673339901, 18.309871673584041],
          [73.074302673339901, 18.309579849243164],
          [73.074028015136662, 18.309583663940543],
          [73.074028015136662, 18.309305191040153],
          [73.073753356933821, 18.309310913085937],
          [73.073753356933821, 18.308748245239371],
          [73.073471069336108, 18.308748245239371],
          [73.073471069336108, 18.308469772338981],
          [73.072639465332315, 18.308471679687557],
          [73.072639465332315, 18.308195114135799],
          [73.072357177734546, 18.308200836181754],
          [73.072357177734546, 18.30792045593256],
          [73.071807861328125, 18.30792045593256],
          [73.071807861328125, 18.307638168335018],
          [73.071517944336222, 18.307638168335018],
          [73.071517944336222, 18.307359695434627],
          [73.070968627929801, 18.307361602783203],
          [73.070968627929801, 18.307083129882869],
          [73.070693969726619, 18.307083129882869],
          [73.070693969726619, 18.306804656982479],
          [73.069862365722827, 18.306810379028434],
          [73.069862365722827, 18.306528091430664],
          [73.069580078125057, 18.306528091430664],
          [73.069580078125057, 18.306249618530273],
          [73.069305419922046, 18.306249618530273],
          [73.069305419922046, 18.305973052978516],
          [73.069030761719034, 18.305973052978516],
          [73.069030761719034, 18.305694580078125],
          [73.068748474121094, 18.305694580078125],
          [73.068748474121094, 18.305416107177734],
          [73.06845855712919, 18.305419921875057],
          [73.06845855712919, 18.30513954162592],
          [73.068191528320369, 18.30513954162592],
          [73.068191528320369, 18.304861068725529],
          [73.067359924316349, 18.304861068725529],
          [73.067359924316349, 18.304580688476563],
          [73.066802978515796, 18.304582595825138],
          [73.066802978515796, 18.304304122924805],
          [73.065971374512003, 18.304309844970703],
          [73.065971374512003, 18.304029464721737],
          [73.065711975097713, 18.304029464721737],
          [73.065711975097713, 18.303739547729492],
          [73.063751220703296, 18.30374908447277],
          [73.063751220703296, 18.303472518921012],
          [73.063194274902514, 18.303472518921012],
          [73.063194274902514, 18.303195953369197],
          [73.062637329101563, 18.303195953369197],
          [73.062637329101563, 18.302917480468807],
          [73.061531066894588, 18.302917480468807],
          [73.061531066894588, 18.303195953369197],
          [73.060974121093977, 18.303195953369197],
          [73.060974121093977, 18.303472518921012],
          [73.059860229492472, 18.303472518921012],
          [73.059860229492472, 18.30374908447277],
          [73.058471679687557, 18.303739547729492],
          [73.058471679687557, 18.304029464721737],
          [73.058197021484318, 18.304029464721737],
          [73.058197021484318, 18.304309844970703],
          [73.057640075683764, 18.304304122924805],
          [73.057640075683764, 18.304582595825138],
          [73.05625152587919, 18.304580688476563],
          [73.05625152587919, 18.304861068725529],
          [73.05596923828125, 18.304861068725529],
          [73.05596923828125, 18.30513954162592],
          [73.055419921875057, 18.30513954162592],
          [73.055419921875057, 18.305419921875057],
          [73.054862976074276, 18.305416107177734],
          [73.054862976074276, 18.305694580078125],
          [73.054580688476506, 18.305694580078125],
          [73.054580688476506, 18.305973052978516],
          [73.054100036621151, 18.305971145629883],
          [73.054031372070483, 18.306249618530273],
          [73.053749084472713, 18.306249618530273],
          [73.053749084472713, 18.306528091430664],
          [73.05291748046875, 18.306528091430664],
          [73.05291748046875, 18.306810379028434],
          [73.052360534668026, 18.306804656982479],
          [73.052360534668026, 18.307083129882869],
          [73.051803588867244, 18.307083129882869],
          [73.051803588867244, 18.307361602783203],
          [73.051246643066634, 18.307359695434627],
          [73.051246643066634, 18.307638168335018],
          [73.050712585449503, 18.307638168335018],
          [73.050712585449503, 18.30792045593256],
          [73.050422668457202, 18.30792045593256],
          [73.050422668457202, 18.307638168335018],
          [73.049026489257926, 18.307638168335018],
          [73.049026489257926, 18.307359695434627],
          [73.048469543456974, 18.307361602783203],
          [73.048469543456974, 18.307083129882869],
          [73.048194885254134, 18.307083129882869],
          [73.048194885254134, 18.306804656982479],
          [73.047637939453182, 18.306810379028434],
          [73.047637939453182, 18.306528091430664],
          [73.046806335449219, 18.306528091430664],
          [73.046806335449219, 18.306810379028434],
          [73.046516418457315, 18.306810379028434],
          [73.046516418457315, 18.306528091430664],
          [73.045417785644474, 18.306528091430664],
          [73.045417785644474, 18.305971145629883],
          [73.044860839843921, 18.305973052978516],
          [73.044860839843921, 18.305694580078125],
          [73.044586181640682, 18.305694580078125],
          [73.044586181640682, 18.305416107177734],
          [73.044029235840128, 18.305419921875057],
          [73.044029235840128, 18.30513954162592],
          [73.043746948242358, 18.30513954162592],
          [73.043746948242358, 18.304861068725529],
          [73.043457031250284, 18.304861068725529],
          [73.043441772460994, 18.304309844970703],
          [73.042922973632926, 18.304309844970703],
          [73.042922973632926, 18.303739547729492],
          [73.042358398437614, 18.30374908447277],
          [73.042358398437614, 18.303472518921012],
          [73.042083740234432, 18.303472518921012],
          [73.042083740234432, 18.302917480468807],
          [73.041809082031421, 18.302919387817383],
          [73.041809082031421, 18.302640914916992],
          [73.041252136230639, 18.302640914916992],
          [73.041252136230639, 18.302080154419059],
          [73.040695190429858, 18.302082061767635],
          [73.040695190429858, 18.301805496215877],
          [73.040412902832315, 18.301811218261832],
          [73.040412902832315, 18.301530838012638],
          [73.040138244628906, 18.301530838012638],
          [73.040138244628906, 18.300970077514705],
          [73.039863586426065, 18.300973892211914],
          [73.039863586426065, 18.300695419311523],
          [73.039581298828182, 18.300680160522461],
          [73.039581298828182, 18.299583435058594],
          [73.039306640625114, 18.299583435058594],
          [73.039306640625114, 18.297916412353629],
          [73.039581298828182, 18.297929763793945],
          [73.039581298828182, 18.297641754150447],
          [73.039306640625114, 18.297641754150447],
          [73.039306640625114, 18.296810150146428],
          [73.039581298828182, 18.296810150146428],
          [73.039581298828182, 18.296531677246094],
          [73.039306640625114, 18.296531677246094],
          [73.039306640625114, 18.296247482299918],
          [73.039581298828182, 18.296247482299918],
          [73.039581298828182, 18.295970916748104],
          [73.039306640625114, 18.295972824096737],
          [73.039306640625114, 18.295694351196346],
          [73.039581298828182, 18.295694351196346],
          [73.039581298828182, 18.294584274291992],
          [73.039863586426065, 18.294582366943359],
          [73.039863586426065, 18.293750762939396],
          [73.040138244628906, 18.293750762939396],
          [73.040138244628906, 18.292921066284237],
          [73.040412902832315, 18.292921066284237],
          [73.040412902832315, 18.292360305786076],
          [73.040702819824219, 18.292360305786076],
          [73.040695190429858, 18.291805267334098],
          [73.040969848632869, 18.291805267334098],
          [73.040969848632869, 18.291528701782283],
          [73.041252136230639, 18.291530609130859],
          [73.041252136230639, 18.290969848632926],
          [73.041526794433821, 18.290971755981502],
          [73.041526794433821, 18.290695190429744],
          [73.042076110839901, 18.2907009124757],
          [73.042076110839901, 18.290140151977539],
          [73.042358398437614, 18.290140151977539],
          [73.042358398437614, 18.289859771728572],
          [73.042640686035213, 18.289861679077148],
          [73.042640686035213, 18.289583206176815],
          [73.042915344238565, 18.289583206176815],
          [73.042915344238565, 18.289304733276424],
          [73.043197631835938, 18.289304733276424],
          [73.043197631835938, 18.289028167724609],
          [73.043472290039347, 18.289030075073185],
          [73.043472290039347, 18.288471221923828],
          [73.043746948242358, 18.288473129272461],
          [73.043746948242358, 18.287639617919865],
          [73.044029235840128, 18.287639617919865],
          [73.044029235840128, 18.287082672119084],
          [73.044303894043139, 18.287082672119084],
          [73.044303894043139, 18.286527633667106],
          [73.044578552246321, 18.286529541015682],
          [73.044578552246321, 18.285972595214957],
          [73.044860839843921, 18.285972595214957],
          [73.044860839843921, 18.284862518310604],
          [73.045143127441634, 18.284862518310604],
          [73.045135498046932, 18.284305572509822],
          [73.045417785644474, 18.284309387206974],
          [73.045417785644474, 18.283748626709041],
          [73.045967102051065, 18.283748626709041],
          [73.045967102051065, 18.283468246460075],
          [73.045692443847713, 18.283470153808651],
          [73.045692443847713, 18.282640457153263],
          [73.045967102051065, 18.282640457153263],
          [73.045967102051065, 18.281248092651367],
          [73.046249389648438, 18.281248092651367],
          [73.046249389648438, 18.280969619750977],
          [73.046524047851847, 18.280971527099553],
          [73.046524047851847, 18.280694961547965],
          [73.047363281250171, 18.28070068359375],
          [73.047363281250171, 18.280420303344727],
          [73.047920227050952, 18.280420303344727],
          [73.047920227050952, 18.279859542846793],
          [73.048194885254134, 18.279861450195369],
          [73.048194885254134, 18.279306411743221],
          [73.048469543456974, 18.279310226440373],
          [73.048469543456974, 18.279029846191406],
          [73.048751831054744, 18.279029846191406],
          [73.048751831054744, 18.278470993042049],
          [73.049308776855526, 18.278472900390682],
          [73.049308776855526, 18.278194427490291],
          [73.049583435058878, 18.278194427490291],
          [73.049583435058878, 18.277639389038086],
          [73.049858093261719, 18.277639389038086],
          [73.049858093261719, 18.277360916137695],
          [73.050422668457202, 18.277360916137695],
          [73.050415039062671, 18.277082443237305],
          [73.050697326660213, 18.277082443237305],
          [73.050697326660213, 18.276805877685547],
          [73.051246643066634, 18.276805877685547],
          [73.051246643066634, 18.276527404785156],
          [73.051528930664006, 18.276531219482536],
          [73.051528930664006, 18.276250839233342],
          [73.051795959472713, 18.276250839233342],
          [73.051795959472713, 18.275970458984375],
          [73.052085876464957, 18.275972366332951],
          [73.052085876464957, 18.275417327880973],
          [73.052360534668026, 18.275421142578182],
          [73.052360534668026, 18.275140762329158],
          [73.052642822265909, 18.275140762329158],
          [73.052642822265909, 18.274860382080021],
          [73.053192138672159, 18.274860382080021],
          [73.053192138672159, 18.274581909179631],
          [73.053474426269702, 18.274583816528434],
          [73.053474426269702, 18.274026870727653],
          [73.053749084472713, 18.274030685424805],
          [73.053749084472713, 18.273759841919002],
          [73.054031372070483, 18.273759841919002],
          [73.054031372070483, 18.273202896118221],
          [73.054306030273665, 18.273202896118221],
          [73.054306030273665, 18.272920608520451],
          [73.054580688476506, 18.272920608520451],
          [73.054580688476506, 18.271799087524414],
          [73.054862976074276, 18.271804809570369],
          [73.054862976074276, 18.271528244018555],
          [73.054580688476506, 18.271530151367131],
          [73.054580688476506, 18.270420074462947],
          [73.054306030273665, 18.270420074462947],
          [73.054306030273665, 18.269859313964844],
          [73.054031372070483, 18.269859313964844],
          [73.054031372070483, 18.269580841064453],
          [73.053749084472713, 18.269582748413029],
          [73.053749084472713, 18.269306182861442],
          [73.053482055664063, 18.269308090210018],
          [73.053482055664063, 18.269029617309627],
          [73.053192138672159, 18.269029617309627],
          [73.053192138672159, 18.268749237060661],
          [73.052642822265909, 18.268749237060661],
          [73.052642822265909, 18.268470764160099],
          [73.052360534668026, 18.268472671508903],
          [73.052360534668026, 18.268194198608512],
          [73.052085876464957, 18.268194198608512],
          [73.052085876464957, 18.268472671508903],
          [73.050697326660213, 18.268472671508903],
          [73.050697326660213, 18.268194198608512],
          [73.049583435058878, 18.268194198608512],
          [73.049583435058878, 18.267919540405273],
          [73.049026489257926, 18.267919540405273],
          [73.049026489257926, 18.2676296234132],
          [73.048194885254134, 18.267637252807731],
          [73.048194885254134, 18.267360687255916],
          [73.047363281250171, 18.267360687255916],
          [73.047363281250171, 18.26708030700695],
          [73.046249389648438, 18.267084121704158],
          [73.046249389648438, 18.266805648803768],
          [73.045417785644474, 18.26680946350092],
          [73.045417785644474, 18.266530990600529],
          [73.043746948242358, 18.266530990600529],
          [73.043746948242358, 18.265970230102596],
          [73.043472290039347, 18.265972137451172],
          [73.043472290039347, 18.265693664550838],
          [73.042915344238565, 18.265693664550838],
          [73.042915344238565, 18.265415191650447],
          [73.042358398437614, 18.265420913696403],
          [73.042358398437614, 18.265140533447209],
          [73.041809082031421, 18.265140533447209],
          [73.041809082031421, 18.264860153198242],
          [73.041526794433821, 18.264862060546818],
          [73.041526794433821, 18.264583587646484],
          [73.039863586426065, 18.264583587646484],
          [73.039863586426065, 18.264862060546818],
          [73.038208007812671, 18.264862060546818],
          [73.035972595214901, 18.264862060546818],
          [73.035972595214901, 18.264583587646484],
          [73.035697937011662, 18.264583587646484],
          [73.035697937011662, 18.264862060546818],
          [73.035140991211108, 18.264860153198242],
          [73.035140991211108, 18.265140533447209],
          [73.034858703613338, 18.265140533447209],
          [73.034858703613338, 18.265420913696403],
          [73.034584045410327, 18.265415191650447],
          [73.034584045410327, 18.265693664550838],
          [73.033752441406534, 18.265693664550838],
          [73.033752441406534, 18.265972137451172],
          [73.032638549804631, 18.265970230102596],
          [73.032638549804631, 18.266250610351562],
          [73.031517028808764, 18.266250610351562],
          [73.031517028808764, 18.265970230102596],
          [73.031250000000284, 18.265972137451172],
          [73.031250000000284, 18.265693664550838],
          [73.030693054199503, 18.265693664550838],
          [73.030693054199503, 18.265415191650447],
          [73.030418395996094, 18.265420913696403],
          [73.030418395996094, 18.265140533447209],
          [73.030136108398722, 18.265140533447209],
          [73.030136108398722, 18.264860153198242],
          [73.029586791992131, 18.264862060546818],
          [73.029586791992131, 18.264583587646484],
          [73.029029846191577, 18.264583587646484],
          [73.029029846191577, 18.264305114746094],
          [73.027915954590014, 18.264305114746094],
          [73.027915954590014, 18.265972137451172],
          [73.028198242187784, 18.265970230102596],
          [73.028198242187784, 18.26680946350092],
          [73.027915954590014, 18.266805648803768],
          [73.027915954590014, 18.267084121704158],
          [73.027359008789063, 18.26708030700695],
          [73.027359008789063, 18.267360687255916],
          [73.027084350586222, 18.267360687255916],
          [73.027084350586222, 18.267637252807731],
          [73.026802062988338, 18.2676296234132],
          [73.026802062988338, 18.267919540405273],
          [73.026542663574162, 18.267919540405273],
          [73.026542663574162, 18.268749237060661],
          [73.026252746582088, 18.268749237060661],
          [73.026252746582088, 18.269029617309627],
          [73.025970458984318, 18.269029617309627],
          [73.025970458984318, 18.269308090210018],
          [73.025413513183764, 18.269306182861442],
          [73.025413513183764, 18.269582748413029],
          [73.025138854980526, 18.269582748413029],
          [73.025138854980526, 18.269306182861442],
          [73.024856567382983, 18.269308090210018],
          [73.024856567382983, 18.268749237060661],
          [73.024581909179972, 18.268749237060661],
          [73.024581909179972, 18.268470764160099],
          [73.023468017578239, 18.268470764160099],
          [73.023468017578239, 18.268749237060661],
          [73.022918701171818, 18.268749237060661],
          [73.022918701171818, 18.269029617309627],
          [73.021530151367472, 18.269029617309627],
          [73.021530151367472, 18.269582748413029],
          [73.02097320556669, 18.269580841064453],
          [73.02097320556669, 18.269859313964844],
          [73.02069091796875, 18.269859313964844],
          [73.02069091796875, 18.270420074462947],
          [73.020416259765739, 18.270416259765625],
          [73.020416259765739, 18.271804809570369],
          [73.02097320556669, 18.271804809570369],
          [73.02097320556669, 18.27208328247076],
          [73.021247863769531, 18.27208328247076],
          [73.021247863769531, 18.272361755371094],
          [73.021797180175952, 18.272361755371094],
          [73.021797180175952, 18.272640228271484],
          [73.022087097168026, 18.272640228271484],
          [73.022087097168026, 18.272920608520451],
          [73.022361755371264, 18.272920608520451],
          [73.022361755371264, 18.273202896118221],
          [73.022636413574446, 18.273202896118221],
          [73.022636413574446, 18.274030685424805],
          [73.022361755371264, 18.274030685424805],
          [73.022361755371264, 18.275140762329158],
          [73.022087097168026, 18.275140762329158],
          [73.022087097168026, 18.275421142578182],
          [73.021797180175952, 18.275421142578182],
          [73.021797180175952, 18.276531219482536],
          [73.022087097168026, 18.276527404785156],
          [73.022087097168026, 18.276805877685547],
          [73.022361755371264, 18.276800155639762],
          [73.022361755371264, 18.277360916137695],
          [73.022087097168026, 18.277360916137695],
          [73.022087097168026, 18.277919769287053],
          [73.021804809570483, 18.277914047241325],
          [73.021804809570483, 18.278194427490291],
          [73.021530151367472, 18.278194427490291],
          [73.021530151367472, 18.278472900390682],
          [73.02069091796875, 18.278470993042049],
          [73.02069091796875, 18.279029846191406],
          [73.020408630371378, 18.279029846191406],
          [73.020408630371378, 18.279310226440373],
          [73.020141601562557, 18.279306411743221],
          [73.020141601562557, 18.279582977295036],
          [73.019859313964787, 18.279582977295036],
          [73.019859313964787, 18.279861450195369],
          [73.019302368164233, 18.279859542846793],
          [73.019302368164233, 18.28013992309576],
          [73.018753051757983, 18.28013992309576],
          [73.018753051757983, 18.280420303344727],
          [73.01847076416044, 18.280420303344727],
          [73.01847076416044, 18.28070068359375],
          [73.017913818359659, 18.280694961547965],
          [73.017913818359659, 18.280971527099553],
          [73.017349243164347, 18.280969619750977],
          [73.017349243164347, 18.281248092651367],
          [73.016807556152287, 18.281248092651367],
          [73.016807556152287, 18.28153038024908],
          [73.016540527343977, 18.28153038024908],
          [73.016532897949446, 18.281810760498104],
          [73.015975952148494, 18.281805038452148],
          [73.015975952148494, 18.282083511352539],
          [73.015136718750171, 18.282083511352539],
          [73.015136718750171, 18.282360076904297],
          [73.014579772949219, 18.282358169555721],
          [73.014579772949219, 18.282640457153263],
          [73.014312744140739, 18.282640457153263],
          [73.014312744140739, 18.282930374145565],
          [73.013748168945426, 18.282918930053654],
          [73.013748168945426, 18.283193588256893],
          [73.012916564941634, 18.283193588256893],
          [73.012916564941634, 18.283470153808651],
          [73.012359619140682, 18.283468246460075],
          [73.012359619140682, 18.283748626709041],
          [73.011253356933878, 18.283748626709041],
          [73.011253356933878, 18.284030914306584],
          [73.009582519531421, 18.284030914306584],
          [73.009582519531421, 18.284309387206974],
          [73.008750915527628, 18.284305572509822],
          [73.008750915527628, 18.284584045410213],
          [73.002914428711108, 18.284584045410213],
          [73.002914428711108, 18.284305572509822],
          [73.000419616699389, 18.284309387206974],
          [73.000419616699389, 18.283468246460075],
          [72.999862670898608, 18.283470153808651],
          [72.999305725097827, 18.283470153808651],
          [72.999305725097827, 18.283193588256893],
          [72.998748779296875, 18.283193588256893],
          [72.998748779296875, 18.282918930053654],
          [72.997917175293082, 18.282930374145565],
          [72.997917175293082, 18.28207969665533],
          [72.998191833496151, 18.282083511352539],
          [72.998191833496151, 18.281248092651367],
          [72.997917175293082, 18.281248092651367],
          [72.997917175293082, 18.28070068359375],
          [72.997642517089901, 18.28070068359375],
          [72.997642517089901, 18.28013992309576],
          [72.997360229492131, 18.28013992309576],
          [72.997360229492131, 18.279569625854549],
          [72.99708557128929, 18.279582977295036],
          [72.99708557128929, 18.278194427490291],
          [72.996803283691577, 18.278194427490291],
          [72.996803283691577, 18.277082443237305],
          [72.996528625488338, 18.277082443237305],
          [72.996528625488338, 18.276527404785156],
          [72.996238708496264, 18.276531219482536],
          [72.996238708496264, 18.276250839233342],
          [72.995971679687784, 18.276250839233342],
          [72.995971679687784, 18.275970458984375],
          [72.995697021484375, 18.275972366332951],
          [72.995697021484375, 18.275695800781364],
          [72.995414733887003, 18.275695800781364],
          [72.995414733887003, 18.275417327880973],
          [72.995140075683651, 18.275421142578182],
          [72.995140075683651, 18.275140762329158],
          [72.994857788086051, 18.275140762329158],
          [72.994857788086051, 18.274860382080021],
          [72.994308471679631, 18.274860382080021],
          [72.994308471679631, 18.274311065673828],
          [72.994026184082259, 18.274311065673828],
          [72.994026184082259, 18.273471832275447],
          [72.992919921875284, 18.273471832275447],
          [72.992919921875284, 18.275140762329158],
          [72.992637634277344, 18.275140762329158],
          [72.992637634277344, 18.276250839233342],
          [72.992362976074503, 18.276250839233342],
          [72.992362976074503, 18.276805877685547],
          [72.991806030273551, 18.276800155639762],
          [72.991806030273551, 18.279029846191406],
          [72.992080688476562, 18.279029846191406],
          [72.992080688476562, 18.28013992309576],
          [72.991806030273551, 18.28013992309576],
          [72.991806030273551, 18.28070068359375],
          [72.991531372070369, 18.28070068359375],
          [72.991531372070369, 18.281248092651367],
          [72.991249084472599, 18.281248092651367],
          [72.991249084472599, 18.28153038024908],
          [72.990974426269759, 18.28153038024908],
          [72.990974426269759, 18.282083511352539],
          [72.990692138672046, 18.282083511352539],
          [72.990692138672046, 18.282360076904297],
          [72.990432739258097, 18.282358169555721],
          [72.990432739258097, 18.284030914306584],
          [72.990692138672046, 18.284027099609432],
          [72.990692138672046, 18.284584045410213],
          [72.990432739258097, 18.284578323364258],
          [72.990432739258097, 18.285419464111328],
          [72.990142822265796, 18.285419464111328],
          [72.990142822265796, 18.286529541015682],
          [72.989860534668253, 18.286527633667106],
          [72.989860534668253, 18.287082672119084],
          [72.989585876464844, 18.287082672119084],
          [72.989585876464844, 18.287361145019474],
          [72.987640380859546, 18.287361145019474],
          [72.987640380859546, 18.287082672119084],
          [72.987075805664233, 18.287082672119084],
          [72.987075805664233, 18.287639617919865],
          [72.986808776855753, 18.287639617919865],
          [72.986808776855753, 18.288473129272461],
          [72.986526489257983, 18.288473129272461],
          [72.986526489257983, 18.289583206176815],
          [72.986808776855753, 18.289579391479606],
          [72.986808776855753, 18.290420532226506],
          [72.986526489257983, 18.290420532226506],
          [72.986526489257983, 18.291530609130859],
          [72.986251831054972, 18.291528701782283],
          [72.986251831054972, 18.291805267334098],
          [72.985969543457031, 18.291799545288143],
          [72.985969543457031, 18.292360305786076],
          [72.985137939453239, 18.292360305786076],
          [72.985137939453239, 18.292640686035213],
          [72.984008789062443, 18.292640686035213],
          [72.984008789062443, 18.292921066284237],
          [72.983749389648494, 18.292921066284237],
          [72.983749389648494, 18.29403114318859],
          [72.983474731445483, 18.294027328491211],
          [72.983474731445483, 18.294584274291992],
          [72.98319244384794, 18.294580459594783],
          [72.98319244384794, 18.295141220092717],
          [72.982917785644531, 18.295137405395565],
          [72.982917785644531, 18.295972824096737],
          [72.98264312744169, 18.295970916748104],
          [72.98264312744169, 18.296810150146428],
          [72.982360839843807, 18.296806335449276],
          [72.982360839843807, 18.297170639038143],
          [72.982360839843807, 18.297929763793945],
          [72.982086181640739, 18.297916412353629],
          [72.982086181640739, 18.298469543457031],
          [72.981796264648494, 18.298469543457031],
          [72.981796264648494, 18.299310684204158],
          [72.981529235839787, 18.299304962158203],
          [72.981529235839787, 18.299863815307731],
          [72.980606079101733, 18.299861907958928],
          [72.980422973632983, 18.299861907958928],
          [72.980422973632983, 18.300140380859318],
          [72.979026794433707, 18.300140380859318],
          [72.979026794433707, 18.299579620361385],
          [72.979309082031307, 18.299583435058594],
          [72.979309082031307, 18.299028396606559],
          [72.978469848632756, 18.299030303955135],
          [72.978469848632756, 18.298751831054801],
          [72.977912902832202, 18.298751831054801],
          [72.977912902832202, 18.299030303955135],
          [72.977081298828409, 18.299030303955135],
          [72.977081298828409, 18.299310684204158],
          [72.976249694824219, 18.299304962158203],
          [72.976249694824219, 18.299583435058594],
          [72.975692749023494, 18.299583435058594],
          [72.975692749023494, 18.299863815307731],
          [72.974586486816463, 18.299861907958928],
          [72.974586486816463, 18.300140380859318],
          [72.974296569824389, 18.300140380859318],
          [72.974296569824389, 18.300420761108512],
          [72.974029541015909, 18.300416946411133],
          [72.974029541015909, 18.300680160522461],
          [72.973747253418139, 18.300695419311523],
          [72.973747253418139, 18.300973892211914],
          [72.973472595215128, 18.300970077514705],
          [72.973472595215128, 18.301250457763672],
          [72.973197937011719, 18.301250457763672],
          [72.973197937011719, 18.301811218261832],
          [72.972358703613395, 18.301811218261832],
          [72.972358703613395, 18.301530838012638],
          [72.971801757812443, 18.301530838012638],
          [72.971801757812443, 18.301250457763672],
          [72.970970153808651, 18.301250457763672],
          [72.970970153808651, 18.299579620361385],
          [72.970413208008097, 18.299583435058594],
          [72.970413208008097, 18.299863815307731],
          [72.970138549804687, 18.299861907958928],
          [72.970138549804687, 18.300140380859318],
          [72.969863891601847, 18.300138473510742],
          [72.969856262207315, 18.300680160522461],
          [72.969581604003963, 18.300701141357479],
          [72.969581604003963, 18.301250457763672],
          [72.969299316406364, 18.301250457763672],
          [72.969299316406364, 18.301811218261832],
          [72.969009399414119, 18.301811218261832],
          [72.969009399414119, 18.302360534668026],
          [72.968749999999943, 18.302360534668026],
          [72.968749999999943, 18.30374908447277],
          [72.968475341797102, 18.30374908447277],
          [72.968475341797102, 18.304582595825138],
          [72.968193054199389, 18.304582595825138],
          [72.968193054199389, 18.305694580078125],
          [72.967918395996151, 18.305694580078125],
          [72.967918395996151, 18.307083129882869],
          [72.968193054199389, 18.307083129882869],
          [72.968193054199389, 18.307439804077205],
          [72.968193054199389, 18.30792045593256],
          [72.968482971191463, 18.30792045593256],
          [72.968482971191463, 18.309030532836914],
          [72.968193054199389, 18.309030532836914],
          [72.968193054199389, 18.309310913085937],
          [72.967918395996151, 18.309305191040153],
          [72.967918395996151, 18.309583663940543],
          [72.967636108398608, 18.309579849243164],
          [72.967636108398608, 18.310140609741268],
          [72.967361450195597, 18.310140609741268],
          [72.967361450195597, 18.310419082641658],
          [72.967086791992188, 18.310417175293082],
          [72.967086791992188, 18.310693740844727],
          [72.966804504394815, 18.310693740844727],
          [72.966804504394815, 18.310970306396484],
          [72.966529846191463, 18.310968399047908],
          [72.966529846191463, 18.311252593994254],
          [72.966262817382756, 18.311252593994254],
          [72.966262817382756, 18.311531066894645],
          [72.965972900390682, 18.311531066894645],
          [72.965972900390682, 18.311809539794979],
          [72.965415954590071, 18.311805725097656],
          [72.965415954590071, 18.312084197998047],
          [72.965141296386889, 18.312080383300838],
          [72.965141296386889, 18.312362670898437],
          [72.964859008789119, 18.312362670898437],
          [72.964859008789119, 18.312641143798771],
          [72.964584350586108, 18.312639236450195],
          [72.964584350586108, 18.31291580200201],
          [72.964302062988565, 18.31291580200201],
          [72.964302062988565, 18.313194274902401],
          [72.962638854980412, 18.313194274902401],
          [72.962638854980412, 18.31291580200201],
          [72.962364196777571, 18.31291580200201],
          [72.962364196777571, 18.312084197998047],
          [72.961807250976619, 18.312084197998047],
          [72.961807250976619, 18.311805725097656],
          [72.961250305176065, 18.311809539794979],
          [72.961250305176065, 18.311670303344727],
          [72.961250305176065, 18.311527252197266],
          [72.959861755371151, 18.311531066894645],
          [72.959861755371151, 18.311252593994254],
          [72.959587097167912, 18.311252593994254],
          [72.959587097167912, 18.311531066894645],
          [72.959030151367358, 18.311531066894645],
          [72.959030151367358, 18.311809539794979],
          [72.958747863769759, 18.311809539794979],
          [72.958747863769759, 18.312362670898437],
          [72.958473205566577, 18.312362670898437],
          [72.958473205566577, 18.312641143798771],
          [72.958190917968807, 18.312639236450195],
          [72.958190917968807, 18.31291580200201],
          [72.957916259765796, 18.31291580200201],
          [72.957916259765796, 18.313194274902401],
          [72.957641601562784, 18.313194274902401],
          [72.957641601562784, 18.313472747802791],
          [72.957359313964844, 18.313472747802791],
          [72.957359313964844, 18.314029693603516],
          [72.95706939697294, 18.314029693603516],
          [72.95706939697294, 18.314310073852482],
          [72.956802368164119, 18.31430625915533],
          [72.956802368164119, 18.314584732055721],
          [72.956527709961051, 18.314584732055721],
          [72.956527709961051, 18.314861297607479],
          [72.956253051757869, 18.314859390258903],
          [72.956253051757869, 18.315139770507869],
          [72.955970764160099, 18.315139770507869],
          [72.955970764160099, 18.315694808960075],
          [72.955696105957259, 18.315694808960075],
          [72.955696105957259, 18.315971374511662],
          [72.955406188965014, 18.315969467163086],
          [72.955406188965014, 18.31653022766119],
          [72.955696105957259, 18.316528320312614],
          [72.955696105957259, 18.317361831664982],
          [72.955970764160099, 18.317359924316406],
          [72.955970764160099, 18.317920684814567],
          [72.956253051757869, 18.317920684814567],
          [72.956253051757869, 18.318201065063533],
          [72.956802368164119, 18.318195343017578],
          [72.956802368164119, 18.318471908569336],
          [72.957359313964844, 18.31847000122076],
          [72.957359313964844, 18.318750381469727],
          [72.957916259765796, 18.318750381469727],
          [72.957916259765796, 18.319030761718693],
          [72.958190917968807, 18.319026947021541],
          [72.958190917968807, 18.319583892822322],
          [72.958473205566577, 18.319580078125114],
          [72.958473205566577, 18.31986045837408],
          [72.958747863769759, 18.31986045837408],
          [72.958747863769759, 18.319580078125114],
          [72.959304809570369, 18.319583892822322],
          [72.959304809570369, 18.319305419921932],
          [72.960975646972656, 18.319305419921932],
          [72.960975646972656, 18.319583892822322],
          [72.960693359375284, 18.319580078125114],
          [72.960693359375284, 18.31986045837408],
          [72.960418701171875, 18.31986045837408],
          [72.960418701171875, 18.320140838623047],
          [72.960128784179972, 18.320140838623047],
          [72.960128784179972, 18.32042121887207],
          [72.959861755371151, 18.320419311523437],
          [72.959861755371151, 18.320693969726676],
          [72.959587097167912, 18.320693969726676],
          [72.959587097167912, 18.320972442627067],
          [72.959297180175838, 18.320970535278263],
          [72.959297180175838, 18.321250915527401],
          [72.959030151367358, 18.321250915527401],
          [72.959030151367358, 18.321527481079215],
          [72.958747863769759, 18.321527481079215],
          [72.958747863769759, 18.321809768676758],
          [72.958473205566577, 18.321805953979606],
          [72.958473205566577, 18.322082519531193],
          [72.958190917968807, 18.322080612182617],
          [72.958190917968807, 18.322637557983398],
          [72.957916259765796, 18.322637557983398],
          [72.957916259765796, 18.322919845581112],
          [72.957641601562784, 18.322916030883789],
          [72.957641601562784, 18.32319450378418],
          [72.957359313964844, 18.323190689086971],
          [72.957359313964844, 18.323751449584904],
          [72.956802368164119, 18.323751449584904],
          [72.956802368164119, 18.324310302734489],
          [72.956527709961051, 18.324306488037109],
          [72.956527709961051, 18.324581146240291],
          [72.956253051757869, 18.324579238891715],
          [72.956253051757869, 18.325141906738281],
          [72.955970764160099, 18.325141906738281],
          [72.955970764160099, 18.325702667236385],
          [72.955696105957259, 18.325695037841854],
          [72.955696105957259, 18.325969696045036],
          [72.955406188965014, 18.325969696045036],
          [72.955406188965014, 18.326530456542969],
          [72.955139160156307, 18.326530456542969],
          [72.955139160156307, 18.326810836791992],
          [72.954864501953296, 18.326805114746207],
          [72.954864501953296, 18.327917098999137],
          [72.954582214355753, 18.327917098999137],
          [72.954582214355753, 18.328193664550781],
          [72.954322814941463, 18.328189849853572],
          [72.954322814941463, 18.3290309906007],
          [72.954025268554972, 18.32902717590332],
          [72.954025268554972, 18.329584121704102],
          [72.953750610351619, 18.329580307006893],
          [72.953750610351619, 18.330141067504826],
          [72.953475952148551, 18.33013916015625],
          [72.953475952148551, 18.330694198608455],
          [72.953186035156307, 18.330690383911246],
          [72.953186035156307, 18.33152961730957],
          [72.952919006347599, 18.33152961730957],
          [72.952919006347599, 18.333749771118107],
          [72.952636718750227, 18.333749771118107],
          [72.952636718750227, 18.334039688110408],
          [72.952079772949276, 18.334026336669922],
          [72.952079772949276, 18.334304809570313],
          [72.951805114746264, 18.334304809570313],
          [72.951805114746264, 18.334861755371037],
          [72.951530456543253, 18.334859848022461],
          [72.951530456543253, 18.335138320922852],
          [72.95096588134794, 18.335138320922852],
          [72.95096588134794, 18.336248397827205],
          [72.950691223144531, 18.336248397827205],
          [72.950691223144531, 18.336530685424748],
          [72.95041656494152, 18.336530685424748],
          [72.95041656494152, 18.336809158325138],
          [72.950141906738338, 18.336805343627987],
          [72.950141906738338, 18.337083816528377],
          [72.949859619140568, 18.337078094482422],
          [72.949859619140568, 18.337358474731559],
          [72.949577331543026, 18.337358474731559],
          [72.949577331543026, 18.337640762329102],
          [72.949028015136776, 18.337640762329102],
          [72.949028015136776, 18.337921142578125],
          [72.948753356933764, 18.337917327880916],
          [72.948753356933764, 18.338193893432731],
          [72.947639465332031, 18.338193893432731],
          [72.947639465332031, 18.338472366333121],
          [72.946807861328068, 18.338472366333121],
          [72.946807861328068, 18.338752746582088],
          [72.946250915527514, 18.338752746582088],
          [72.946250915527514, 18.339031219482479],
          [72.945686340332202, 18.339031219482479],
          [72.945686340332202, 18.339309692382812],
          [72.945419311523722, 18.339305877685661],
          [72.945419311523722, 18.340694427490234],
          [72.945129394531421, 18.340690612793026],
          [72.945129394531421, 18.341529846191349],
          [72.94431304931652, 18.341529846191349],
          [72.94431304931652, 18.341810226440543],
          [72.944030761718807, 18.341806411743164],
          [72.944030761718807, 18.342361450195313],
          [72.943748474121207, 18.342359542846737],
          [72.943748474121207, 18.342639923095703],
          [72.943473815918026, 18.342638015747127],
          [72.943473815918026, 18.342916488647518],
          [72.942916870117415, 18.342910766601563],
          [72.942916870117415, 18.343200683593864],
          [72.942359924316463, 18.343193054199332],
          [72.942359924316463, 18.343471527099666],
          [72.942085266113452, 18.343471527099666],
          [72.942092895507813, 18.343750000000057],
          [72.9415283203125, 18.343750000000057],
          [72.9415283203125, 18.344030380249023],
          [72.940696716308707, 18.344030380249023],
          [72.940696716308707, 18.344310760498047],
          [72.939582824707202, 18.344310760498047],
          [72.939582824707202, 18.344030380249023],
          [72.939315795898722, 18.344030380249023],
          [72.939315795898722, 18.34346961975109],
          [72.939025878906421, 18.343471527099666],
          [72.939025878906421, 18.343193054199332],
          [72.938751220703409, 18.343200683593864],
          [72.938751220703409, 18.342639923095703],
          [72.938194274902628, 18.342638015747127],
          [72.938194274902628, 18.342916488647518],
          [72.937637329101676, 18.342910766601563],
          [72.937637329101676, 18.343200683593864],
          [72.937362670898494, 18.343193054199332],
          [72.937362670898494, 18.343471527099666],
          [72.936248779296932, 18.343471527099666],
          [72.936248779296932, 18.343193054199332],
          [72.935966491699389, 18.343200683593864],
          [72.935966491699389, 18.342910766601563],
          [72.935691833496378, 18.342916488647518],
          [72.935691833496378, 18.342638015747127],
          [72.934585571289176, 18.342638015747127],
          [72.934585571289176, 18.342916488647518],
          [72.934028625488224, 18.342916488647518],
          [72.934028625488224, 18.344583511352653],
          [72.934303283691463, 18.344579696655273],
          [72.934303283691463, 18.345140457153377],
          [72.934585571289176, 18.345138549804801],
          [72.934585571289176, 18.345693588256836],
          [72.934860229492188, 18.345689773559627],
          [72.934860229492188, 18.345979690551758],
          [72.935142517090128, 18.345979690551758],
          [72.935142517090128, 18.346530914306754],
          [72.935417175292969, 18.346525192260799],
          [72.935417175292969, 18.347084045410156],
          [72.935691833496378, 18.347080230712947],
          [72.935691833496378, 18.347639083862305],
          [72.935974121093921, 18.347637176513729],
          [72.935974121093921, 18.34819412231451],
          [72.936248779296932, 18.348190307617301],
          [72.936248779296932, 18.348749160766658],
          [72.935966491699389, 18.348749160766658],
          [72.935966491699389, 18.349309921264592],
          [72.935691833496378, 18.34930610656744],
          [72.935691833496378, 18.349582672119254],
          [72.935142517090128, 18.349580764770451],
          [72.935142517090128, 18.349859237671012],
          [72.934860229492188, 18.349859237671012],
          [72.934860229492188, 18.350141525268612],
          [72.934585571289176, 18.350141525268612],
          [72.934585571289176, 18.350694656372184],
          [72.934303283691463, 18.350694656372184],
          [72.934303283691463, 18.350973129272575],
          [72.932083129883097, 18.350973129272575],
          [72.932083129883097, 18.350416183471793],
          [72.931808471679688, 18.350421905517578],
          [72.931808471679688, 18.350141525268612],
          [72.931526184082315, 18.350141525268612],
          [72.931526184082315, 18.349859237671012],
          [72.931251525878963, 18.349859237671012],
          [72.931251525878963, 18.349580764770451],
          [72.930419921875171, 18.349580764770451],
          [72.930419921875171, 18.349859237671012],
          [72.929031372070597, 18.349859237671012],
          [72.929031372070597, 18.349580764770451],
          [72.928474426269815, 18.349582672119254],
          [72.928474426269815, 18.34930610656744],
          [72.926803588867358, 18.34930610656744],
          [72.926803588867358, 18.349582672119254],
          [72.926246643066577, 18.349580764770451],
          [72.926246643066577, 18.349859237671012],
          [72.925971984863565, 18.349859237671012],
          [72.925971984863565, 18.350141525268612],
          [72.925422668457315, 18.350141525268612],
          [72.925422668457315, 18.350421905517578],
          [72.924308776855412, 18.350421905517578],
          [72.924308776855412, 18.350141525268612],
          [72.924575805664119, 18.350141525268612],
          [72.924575805664119, 18.349859237671012],
          [72.924308776855412, 18.349859237671012],
          [72.924308776855412, 18.349580764770451],
          [72.92402648925804, 18.349582672119254],
          [72.92402648925804, 18.34930610656744],
          [72.923187255859546, 18.349309921264592],
          [72.923187255859546, 18.349039077758789],
          [72.922080993652344, 18.349039077758789],
          [72.922080993652344, 18.348190307617301],
          [72.922363281250284, 18.34819412231451],
          [72.922363281250284, 18.347637176513729],
          [72.922080993652344, 18.347639083862305],
          [72.922080993652344, 18.347360610961914],
          [72.921806335449332, 18.347360610961914],
          [72.921806335449332, 18.347080230712947],
          [72.921524047851619, 18.347084045410156],
          [72.921524047851619, 18.346805572509766],
          [72.919860839844034, 18.346805572509766],
          [72.919860839844034, 18.347084045410156],
          [72.919296264648722, 18.347080230712947],
          [72.919296264648722, 18.347360610961914],
          [72.919029235839844, 18.347360610961914],
          [72.919029235839844, 18.347639083862305],
          [72.918472290039119, 18.347639083862305],
          [72.918472290039119, 18.347919464111271],
          [72.917915344238338, 18.347919464111271],
          [72.917915344238338, 18.34819412231451],
          [72.917640686035327, 18.34819412231451],
          [72.917640686035327, 18.348472595214901],
          [72.917358398437727, 18.348470687866268],
          [72.917358398437727, 18.349039077758789],
          [72.917083740234546, 18.349027633667049],
          [72.917083740234546, 18.350694656372184],
          [72.916809082031534, 18.350690841674805],
          [72.916809082031534, 18.351251602172965],
          [72.916526794433764, 18.351251602172965],
          [72.916526794433764, 18.351804733276367],
          [72.916252136230753, 18.351804733276367],
          [72.916252136230753, 18.352361679077092],
          [72.915969848632812, 18.352361679077092],
          [72.915969848632812, 18.352920532226676],
          [72.915702819824332, 18.352920532226676],
          [72.915702819824332, 18.353202819824219],
          [72.915412902832088, 18.353195190429688],
          [72.915412902832088, 18.353473663330078],
          [72.91513824462902, 18.353473663330078],
          [72.915145874023381, 18.353750228881836],
          [72.914855957031307, 18.353750228881836],
          [72.914855957031307, 18.354030609130803],
          [72.914581298828068, 18.354028701782227],
          [72.914581298828068, 18.354583740234432],
          [72.914306640625227, 18.354583740234432],
          [72.914306640625227, 18.35486030578619],
          [72.914016723632983, 18.354852676391658],
          [72.914016723632983, 18.35542106628418],
          [72.914306640625227, 18.35542106628418],
          [72.914306640625227, 18.35625076293951],
          [72.914581298828068, 18.35625076293951],
          [72.914581298828068, 18.357360839843693],
          [72.914863586425838, 18.357360839843693],
          [72.914863586425838, 18.358194351196289],
          [72.914581298828068, 18.35819053649908],
          [72.914581298828068, 18.359029769897404],
          [72.914306640625227, 18.359029769897404],
          [72.914306640625227, 18.359310150146598],
          [72.914024353027514, 18.359306335449219],
          [72.914024353027514, 18.359582901001033],
          [72.913749694824276, 18.359582901001033],
          [72.913749694824276, 18.359861373901367],
          [72.913482666015625, 18.359859466552791],
          [72.913482666015625, 18.360139846801758],
          [72.913192749023722, 18.360139846801758],
          [72.913192749023722, 18.360420227050724],
          [72.912918090820313, 18.360416412353572],
          [72.912918090820313, 18.360694885253963],
          [72.912361145019588, 18.360691070556584],
          [72.912361145019588, 18.360979080200309],
          [72.91208648681652, 18.360979080200309],
          [72.91208648681652, 18.361530303955078],
          [72.911804199218807, 18.361526489257926],
          [72.911796569824276, 18.363189697265682],
          [72.911529541015568, 18.363199234008789],
          [72.911529541015568, 18.365142822265739],
          [72.911247253418196, 18.365142822265739],
          [72.911247253418196, 18.366809844970646],
          [72.911529541015568, 18.366809844970646],
          [72.911529541015568, 18.367361068725643],
          [72.911796569824276, 18.367361068725643],
          [72.911796569824276, 18.367919921875],
          [72.91208648681652, 18.367916107177848],
          [72.91208648681652, 18.368473052978629],
          [72.912361145019588, 18.368471145629826],
          [72.912361145019588, 18.368749618530217],
          [72.91263580322294, 18.368749618530217],
          [72.91263580322294, 18.369029998779354],
          [72.912918090820313, 18.369028091430778],
          [72.912918090820313, 18.369583129882812],
          [72.913192749023722, 18.369583129882812],
          [72.913192749023722, 18.369861602783146],
          [72.913482666015625, 18.36985969543457],
          [72.913482666015625, 18.370149612426871],
          [72.913749694824276, 18.370149612426871],
          [72.913749694824276, 18.370420455932731],
          [72.914306640625227, 18.370420455932731],
          [72.914306640625227, 18.370700836181697],
          [72.914581298828068, 18.370695114135742],
          [72.914581298828068, 18.3709716796875],
          [72.91513824462902, 18.3709716796875],
          [72.91513824462902, 18.371250152587891],
          [72.915412902832088, 18.371250152587891],
          [72.915412902832088, 18.371530532836857],
          [72.915969848632812, 18.371530532836857],
          [72.915969848632812, 18.371810913086051],
          [72.916252136230753, 18.371805191040096],
          [72.916252136230753, 18.372083663940487],
          [72.916809082031534, 18.372079849243278],
          [72.916809082031534, 18.372640609741211],
          [72.917640686035327, 18.372640609741211],
          [72.917640686035327, 18.372079849243278],
          [72.917915344238338, 18.372083663940487],
          [72.917915344238338, 18.371805191040096],
          [72.919586181640625, 18.371805191040096],
          [72.919586181640625, 18.372083663940487],
          [72.920135498047046, 18.372083663940487],
          [72.920135498047046, 18.372360229492244],
          [72.920692443847827, 18.372360229492244],
          [72.920692443847827, 18.372640609741211],
          [72.921249389648381, 18.372640609741211],
          [72.921249389648381, 18.372920989990234],
          [72.921524047851619, 18.37291526794445],
          [72.921524047851619, 18.37319374084484],
          [72.922080993652344, 18.37319374084484],
          [72.922080993652344, 18.373472213745231],
          [72.922363281250284, 18.373470306396428],
          [72.922363281250284, 18.373750686645565],
          [72.923187255859546, 18.373750686645565],
          [72.923187255859546, 18.373470306396428],
          [72.923751831054858, 18.373472213745231],
          [72.923751831054858, 18.37319374084484],
          [72.92402648925804, 18.37319374084484],
          [72.92402648925804, 18.373472213745231],
          [72.924308776855412, 18.373472213745231],
          [72.924308776855412, 18.37319374084484],
          [72.924858093261832, 18.37319374084484],
          [72.924858093261832, 18.37291526794445],
          [72.926246643066577, 18.37291526794445],
          [72.926246643066577, 18.37319374084484],
          [72.925971984863565, 18.37319374084484],
          [72.925971984863565, 18.373472213745231],
          [72.925140380859432, 18.373470306396428],
          [72.925140380859432, 18.373750686645565],
          [72.924575805664119, 18.373750686645565],
          [72.924575805664119, 18.374031066894588],
          [72.924858093261832, 18.374031066894588],
          [72.924858093261832, 18.374309539794922],
          [72.924583435058651, 18.37430572509777],
          [72.924583435058651, 18.375694274902344],
          [72.924858093261832, 18.375690460205135],
          [72.924858093261832, 18.376810073852653],
          [72.925140380859432, 18.376810073852653],
          [72.925140380859432, 18.377920150756779],
          [72.925415039062784, 18.377916336059627],
          [72.925415039062784, 18.378751754760799],
          [72.925697326660156, 18.378751754760799],
          [72.925697326660156, 18.380140304565487],
          [72.925971984863565, 18.380140304565487],
          [72.925971984863565, 18.38125038146967],
          [72.926246643066577, 18.38125038146967],
          [72.926246643066577, 18.38264083862299],
          [72.925971984863565, 18.38264083862299],
          [72.925971984863565, 18.382921218872184],
          [72.926246643066577, 18.382921218872184],
          [72.926246643066577, 18.386529922485408],
          [72.925971984863565, 18.386529922485408],
          [72.925971984863565, 18.387920379638786],
          [72.925697326660156, 18.387916564941406],
          [72.925697326660156, 18.388471603393555],
          [72.925422668457315, 18.388469696044979],
          [72.925422668457315, 18.389310836792106],
          [72.925140380859432, 18.389310836792106],
          [72.925140380859432, 18.390140533447266],
          [72.924858093261832, 18.390140533447266],
          [72.924858093261832, 18.390693664550895],
          [72.924575805664119, 18.390689849853516],
          [72.924575805664119, 18.391248703003043],
          [72.924308776855412, 18.391248703003043],
          [72.924308776855412, 18.391532897949219],
          [72.92402648925804, 18.391527175903434],
          [72.92402648925804, 18.392084121704215],
          [72.923469543457088, 18.392080307006836],
          [72.923469543457088, 18.392362594604606],
          [72.922920227051065, 18.392362594604606],
          [72.922920227051065, 18.392641067504996],
          [72.922080993652344, 18.392641067504996],
          [72.922080993652344, 18.39291954040533],
          [72.921249389648381, 18.392917633056754],
          [72.921249389648381, 18.393194198608398],
          [72.917358398437727, 18.393194198608398],
          [72.917358398437727, 18.392917633056754],
          [72.917076110840014, 18.39291954040533],
          [72.917076110840014, 18.392362594604606],
          [72.915969848632812, 18.392362594604606],
          [72.915969848632812, 18.39291954040533],
          [72.915412902832088, 18.392917633056754],
          [72.915412902832088, 18.393472671508789],
          [72.915145874023381, 18.393472671508789],
          [72.915145874023381, 18.393751144409123],
          [72.914306640625227, 18.393751144409123],
          [72.914306640625227, 18.39319038391119],
          [72.913436889648381, 18.393194198608398],
          [72.913192749023722, 18.393194198608398],
          [72.913192749023722, 18.393472671508789],
          [72.913085937500171, 18.393472671508789],
          [72.912918090820313, 18.393472671508789],
          [72.912918090820313, 18.393611907959041],
          [72.912918090820313, 18.393751144409123],
          [72.912742614746151, 18.393751144409123],
          [72.91263580322294, 18.393751144409123],
          [72.91263580322294, 18.394029617309513],
          [72.912368774414119, 18.394041061401424],
          [72.912361145019588, 18.394319534301815],
          [72.91208648681652, 18.394319534301815],
          [72.91208648681652, 18.395139694213867],
          [72.912361145019588, 18.395139694213867],
          [72.912361145019588, 18.396530151367188],
          [72.91208648681652, 18.396530151367188],
          [72.91208648681652, 18.397090911865348],
          [72.911796569824276, 18.397090911865348],
          [72.911796569824276, 18.397640228271541],
          [72.911529541015568, 18.397640228271541],
          [72.911529541015568, 18.397920608520565],
          [72.911247253418196, 18.397920608520565],
          [72.911247253418196, 18.398200988769531],
          [72.910972595215014, 18.398195266723746],
          [72.910972595215014, 18.398471832275334],
          [72.910697937011776, 18.398469924926758],
          [72.910697937011776, 18.398750305175724],
          [72.909019470215128, 18.398750305175724],
          [72.909019470215128, 18.399030685424918],
          [72.908752441406307, 18.399030685424918],
          [72.908752441406307, 18.399311065673885],
          [72.908470153808537, 18.399311065673885],
          [72.908470153808537, 18.399860382080078],
          [72.908203125000227, 18.399860382080078],
          [72.908203125000227, 18.400421142578239],
          [72.908470153808537, 18.400417327880859],
          [72.908470153808537, 18.400972366333065],
          [72.908752441406307, 18.400970458984432],
          [72.908752441406307, 18.401531219482422],
          [72.909019470215128, 18.401531219482422],
          [72.909019470215128, 18.401809692382756],
          [72.908752441406307, 18.401805877685604],
          [72.908752441406307, 18.402082443237418],
          [72.908470153808537, 18.402080535888615],
          [72.908470153808537, 18.402360916137752],
          [72.908195495605696, 18.402360916137752],
          [72.908203125000227, 18.402637481689567],
          [72.906524658203409, 18.402637481689567],
          [72.906524658203409, 18.403472900390739],
          [72.906806945800781, 18.403469085693359],
          [72.906806945800781, 18.404031753540096],
          [72.907638549804744, 18.404031753540096],
          [72.907638549804744, 18.404310226440487],
          [72.908203125000227, 18.404310226440487],
          [72.908203125000227, 18.405700683593807],
          [72.907356262207202, 18.405700683593807],
          [72.907356262207202, 18.406810760498161],
          [72.907638549804744, 18.406810760498161],
          [72.907638549804744, 18.409030914306697],
          [72.907363891601733, 18.409027099609489],
          [72.907363891601733, 18.409585952758846],
          [72.90708160400419, 18.409580230712891],
          [72.90708160400419, 18.409860610961857],
          [72.906806945800781, 18.409860610961857],
          [72.906806945800781, 18.410140991211051],
          [72.905693054199276, 18.410140991211051],
          [72.905693054199276, 18.411529541015568],
          [72.90708160400419, 18.411527633666992],
          [72.90708160400419, 18.414304733276481],
          [72.907363891601733, 18.414304733276481],
          [72.907363891601733, 18.414583206176871],
          [72.907638549804744, 18.414579391479492],
          [72.907638549804744, 18.415700912475586],
          [72.907363891601733, 18.415695190429801],
          [72.907363891601733, 18.415971755981388],
          [72.906806945800781, 18.415969848632813],
          [72.906806945800781, 18.416248321533203],
          [72.906517028808878, 18.416248321533203],
          [72.906517028808878, 18.416809082031307],
          [72.90625, 18.416809082031307],
          [72.90625, 18.417358398437557],
          [72.906517028808878, 18.417358398437557],
          [72.906517028808878, 18.417640686035099],
          [72.906806945800781, 18.417640686035099],
          [72.906806945800781, 18.417358398437557],
          [72.90708160400419, 18.417358398437557],
          [72.90708160400419, 18.417640686035099],
          [72.907638549804744, 18.417640686035099],
          [72.907638549804744, 18.418199539184684],
          [72.907913208007983, 18.418193817138729],
          [72.907913208007983, 18.418470382690487],
          [72.908203125000227, 18.418470382690487],
          [72.908203125000227, 18.419031143188477],
          [72.908470153808537, 18.419031143188477],
          [72.908470153808537, 18.41986274719244],
          [72.908752441406307, 18.41986274719244],
          [72.908752441406307, 18.420694351196403],
          [72.909019470215128, 18.420690536499023],
          [72.909019470215128, 18.421810150146541],
          [72.908752441406307, 18.421806335449332],
          [72.908752441406307, 18.42236137390131],
          [72.908470153808537, 18.42236137390131],
          [72.908470153808537, 18.423194885253906],
          [72.908195495605696, 18.423194885253906],
          [72.908203125000227, 18.423749923706055],
          [72.907356262207202, 18.423749923706055],
          [72.907356262207202, 18.424030303955021],
          [72.90708160400419, 18.424030303955021],
          [72.90708160400419, 18.424320220947322],
          [72.906806945800781, 18.424306869506836],
          [72.906806945800781, 18.424583435058651],
          [72.906517028808878, 18.424579620361442],
          [72.906517028808878, 18.425140380859375],
          [72.90625, 18.425138473510799],
          [72.90625, 18.425689697265625],
          [72.90598297119152, 18.425701141357536],
          [72.90598297119152, 18.426811218261719],
          [72.905693054199276, 18.426811218261719],
          [72.905693054199276, 18.427360534667912],
          [72.905418395996037, 18.427360534667912],
          [72.905418395996037, 18.427640914917106],
          [72.904861450195483, 18.427640914917106],
          [72.904861450195483, 18.427917480468864],
          [72.904304504394702, 18.427917480468864],
          [72.904304504394702, 18.428194046020508],
          [72.90402984619169, 18.428190231323299],
          [72.90402984619169, 18.430141448974609],
          [72.904304504394702, 18.430141448974609],
          [72.904304504394702, 18.430694580078182],
          [72.904586791992244, 18.430694580078182],
          [72.904586791992244, 18.430973052978572],
          [72.904861450195483, 18.430969238281364],
          [72.904861450195483, 18.431251525878963],
          [72.905136108398494, 18.431251525878963],
          [72.905136108398494, 18.431510925293082],
          [72.905136108398494, 18.431804656982536],
          [72.905693054199276, 18.431804656982536],
          [72.905693054199276, 18.432081222534123],
          [72.906120300293026, 18.432079315185547],
          [72.90625, 18.432079315185547],
          [72.90625, 18.432920455932674],
          [72.906517028808878, 18.432920455932674],
          [72.906517028808878, 18.435140609741154],
          [72.90625, 18.435140609741154],
          [72.90625, 18.436531066894531],
          [72.905975341796989, 18.436527252197322],
          [72.90598297119152, 18.437360763549862],
          [72.905693054199276, 18.437360763549862],
          [72.905693054199276, 18.439029693603572],
          [72.905418395996037, 18.439027786254996],
          [72.905418395996037, 18.440971374511719],
          [72.905136108398494, 18.440969467163143],
          [72.905136108398494, 18.4415283203125],
          [72.904861450195483, 18.441526412963924],
          [72.904861450195483, 18.442083358764705],
          [72.904586791992244, 18.442079544067496],
          [72.904586791992244, 18.442920684814453],
          [72.904304504394702, 18.442916870117244],
          [72.904304504394702, 18.44347190856945],
          [72.90402984619169, 18.44346809387207],
          [72.90402984619169, 18.443748474121207],
          [72.903747558593921, 18.443748474121207],
          [72.903747558593921, 18.444030761718807],
          [72.903472900390909, 18.444026947021598],
          [72.903472900390909, 18.445972442626953],
          [72.9031982421875, 18.445972442626953],
          [72.903205871582088, 18.44625282287609],
          [72.902915954590128, 18.44625282287609],
          [72.902915954590128, 18.446529388427678],
          [72.902641296386776, 18.446527481079102],
          [72.902641296386776, 18.447080612182674],
          [72.902359008789176, 18.447080612182674],
          [72.902359008789176, 18.448194503784237],
          [72.902076721191463, 18.44818115234375],
          [72.902076721191463, 18.449029922485352],
          [72.901802062988224, 18.449028015136776],
          [72.901802062988224, 18.449583053588981],
          [72.901527404785384, 18.449581146240178],
          [72.901527404785384, 18.450139999389705],
          [72.901252746582202, 18.450139999389705],
          [72.901252746582202, 18.451530456543082],
          [72.900970458984432, 18.451530456543082],
          [72.900970458984432, 18.451810836792049],
          [72.900695800781421, 18.451805114746094],
          [72.900695800781421, 18.452362060546875],
          [72.900413513183878, 18.452362060546875],
          [72.900413513183878, 18.453193664550838],
          [72.900146484375, 18.453189849853629],
          [72.900146484375, 18.454030990600586],
          [72.899856567383097, 18.454030990600586],
          [72.899856567383097, 18.454860687255916],
          [72.899581909179744, 18.454860687255916],
          [72.899581909179744, 18.455419540405273],
          [72.899307250976676, 18.455419540405273],
          [72.899307250976676, 18.455694198608512],
          [72.899024963378963, 18.455694198608512],
          [72.899024963378963, 18.455972671508903],
          [72.898750305175724, 18.455970764160099],
          [72.898750305175724, 18.45624923706049],
          [72.898483276367244, 18.45624923706049],
          [72.898483276367244, 18.456811904907227],
          [72.898193359375171, 18.456806182861442],
          [72.898193359375171, 18.457082748413086],
          [72.897918701171932, 18.457080841064453],
          [72.897918701171932, 18.45737266540533],
          [72.897636413574389, 18.45737266540533],
          [72.897636413574389, 18.457920074463004],
          [72.896247863769645, 18.457920074463004],
          [72.896247863769645, 18.457641601562614],
          [72.895690917968693, 18.457641601562614],
          [72.895690917968693, 18.45737266540533],
          [72.895416259765852, 18.45737266540533],
          [72.895416259765852, 18.457080841064453],
          [72.894584655761889, 18.457082748413086],
          [72.894584655761889, 18.458194732666016],
          [72.894859313964901, 18.458190917968807],
          [72.894859313964901, 18.463750839233342],
          [72.895141601562671, 18.463750839233342],
          [72.895141601562671, 18.464860916137695],
          [72.895416259765852, 18.464860916137695],
          [72.895416259765852, 18.467920303344783],
          [72.895690917968693, 18.467916488647575],
          [72.895690917968693, 18.470970153808651],
          [72.895416259765852, 18.470968246460075],
          [72.895416259765852, 18.47264289855957],
          [72.895973205566463, 18.47264289855957],
          [72.895973205566463, 18.472919464111328],
          [72.896247863769645, 18.472917556762752],
          [72.896247863769645, 18.473194122314567],
          [72.896804809570597, 18.473194122314567],
          [72.896804809570597, 18.472917556762752],
          [72.897079467773438, 18.472919464111328],
          [72.897079467773438, 18.47264289855957],
          [72.897361755371378, 18.47264289855957],
          [72.897361755371378, 18.472370147705135],
          [72.898193359375171, 18.472370147705135],
          [72.898193359375171, 18.47264289855957],
          [72.898483276367244, 18.47264289855957],
          [72.898483276367244, 18.472919464111328],
          [72.899024963378963, 18.472917556762752],
          [72.899024963378963, 18.473194122314567],
          [72.899581909179744, 18.473194122314567],
          [72.899581909179744, 18.473472595214957],
          [72.899856567383097, 18.473472595214957],
          [72.899856567383097, 18.474029541015682],
          [72.900138854980469, 18.474027633667106],
          [72.900138854980469, 18.474584579467887],
          [72.900413513183878, 18.474584579467887],
          [72.900413513183878, 18.47569465637207],
          [72.900695800781421, 18.475690841674862],
          [72.900695800781421, 18.476249694824219],
          [72.901252746582202, 18.476249694824219],
          [72.901252746582202, 18.4782009124757],
          [72.900970458984432, 18.4782009124757],
          [72.900970458984432, 18.478750228881893],
          [72.901252746582202, 18.478750228881893],
          [72.901252746582202, 18.479030609130916],
          [72.900970458984432, 18.479028701782283],
          [72.900970458984432, 18.479583740234489],
          [72.901252746582202, 18.479579925537109],
          [72.901252746582202, 18.479860305786076],
          [72.901527404785384, 18.479860305786076],
          [72.901527404785384, 18.482919692993107],
          [72.901252746582202, 18.482919692993107],
          [72.901252746582202, 18.487640380859318],
          [72.900970458984432, 18.487640380859318],
          [72.900970458984432, 18.487920761108512],
          [72.900695800781421, 18.487920761108512],
          [72.900695800781421, 18.489860534668026],
          [72.900970458984432, 18.489860534668026],
          [72.900970458984432, 18.490972518921012],
          [72.901252746582202, 18.490972518921012],
          [72.901252746582202, 18.492082595825195],
          [72.901527404785384, 18.492080688476562],
          [72.901527404785384, 18.492919921875114],
          [72.901802062988224, 18.492919921875114],
          [72.901802062988224, 18.493480682373047],
          [72.902915954590128, 18.493480682373047],
          [72.902915954590128, 18.493749618530273],
          [72.9031982421875, 18.493749618530273],
          [72.9031982421875, 18.494304656982479],
          [72.903472900390909, 18.494304656982479],
          [72.903472900390909, 18.494583129882869],
          [72.903747558593921, 18.494581222534237],
          [72.903747558593921, 18.495700836181754],
          [72.90402984619169, 18.495700836181754],
          [72.90402984619169, 18.497919082641658],
          [72.903747558593921, 18.497919082641658],
          [72.903747558593921, 18.498752593994254],
          [72.903472900390909, 18.498752593994254],
          [72.903472900390909, 18.499309539795036],
          [72.903747558593921, 18.499309539795036],
          [72.903747558593921, 18.499862670898438],
          [72.90402984619169, 18.499862670898438],
          [72.90402984619169, 18.501529693603516],
          [72.904304504394702, 18.50152778625494],
          [72.904304504394702, 18.502084732055721],
          [72.904586791992244, 18.502082824707145],
          [72.904586791992244, 18.502639770507869],
          [72.904861450195483, 18.502639770507869],
          [72.904861450195483, 18.502920150756893],
          [72.905136108398494, 18.502916336059684],
          [72.905136108398494, 18.503194808960075],
          [72.905418395996037, 18.503194808960075],
          [72.905418395996037, 18.503471374511662],
          [72.905975341796989, 18.503471374511662],
          [72.905975341796989, 18.503749847412053],
          [72.90625, 18.503749847412053],
          [72.90625, 18.504030227661246],
          [72.907638549804744, 18.504030227661246],
          [72.907638549804744, 18.503192901611328],
          [72.909027099609489, 18.503194808960075],
          [72.909027099609489, 18.503471374511662],
          [72.909858703613281, 18.503471374511662],
          [72.909858703613281, 18.502916336059684],
          [72.910697937011776, 18.502916336059684],
          [72.910697937011776, 18.503194808960075],
          [72.911247253418196, 18.503192901611328],
          [72.911247253418196, 18.504030227661246],
          [72.90958404541044, 18.504028320312443],
          [72.90958404541044, 18.504306793213004],
          [72.909858703613281, 18.504306793213004],
          [72.909858703613281, 18.504583358764648],
          [72.910697937011776, 18.50457954406744],
          [72.910697937011776, 18.505140304565373],
          [72.910972595215014, 18.505140304565373],
          [72.910972595215014, 18.505701065063533],
          [72.911247253418196, 18.505701065063533],
          [72.911247253418196, 18.509309768676815],
          [72.910972595215014, 18.509309768676815],
          [72.910972595215014, 18.510141372680778],
          [72.910697937011776, 18.510141372680778],
          [72.910697937011776, 18.510971069335938],
          [72.910415649414233, 18.510971069335938],
          [72.910423278808764, 18.511800765991154],
          [72.910697937011776, 18.511810302734489],
          [72.910697937011776, 18.512641906738281],
          [72.910423278808764, 18.512641906738281],
          [72.910423278808764, 18.512920379638672],
          [72.910140991211222, 18.512920379638672],
          [72.910140991211222, 18.513200759887809],
          [72.910415649414233, 18.513195037841854],
          [72.910415649414233, 18.514860153198185],
          [72.910697937011776, 18.514862060546989],
          [72.910697937011776, 18.515693664550781],
          [72.910972595215014, 18.515689849853572],
          [72.910972595215014, 18.5165309906007],
          [72.911247253418196, 18.51652717590332],
          [72.911247253418196, 18.518194198608455],
          [72.910972595215014, 18.518194198608455],
          [72.910972595215014, 18.5195827484132],
          [72.911247253418196, 18.519580841064396],
          [72.911247253418196, 18.521249771118107],
          [72.910972595215014, 18.521249771118107],
          [72.910972595215014, 18.521804809570313],
          [72.910697937011776, 18.521800994873104],
          [72.910697937011776, 18.522920608520621],
          [72.910972595215014, 18.522920608520621],
          [72.910972595215014, 18.523199081421012],
          [72.911247253418196, 18.523195266723633],
          [72.911247253418196, 18.523471832275447],
          [72.910972595215014, 18.523471832275447],
          [72.910972595215014, 18.524583816528377],
          [72.910697937011776, 18.524578094482422],
          [72.910697937011776, 18.525421142578125],
          [72.910140991211222, 18.525417327880916],
          [72.910140991211222, 18.527080535888672],
          [72.909858703613281, 18.527080535888672],
          [72.909858703613281, 18.527919769287223],
          [72.909576416015909, 18.527919769287223],
          [72.909576416015909, 18.529029846191349],
          [72.909309387207088, 18.529029846191349],
          [72.9093017578125, 18.530139923095703],
          [72.909019470215128, 18.530139923095703],
          [72.909019470215128, 18.530420303344727],
          [72.908752441406307, 18.530416488647518],
          [72.908752441406307, 18.530971527099723],
          [72.908470153808537, 18.53096961975092],
          [72.908470153808537, 18.531810760498047],
          [72.908195495605696, 18.531806945800838],
          [72.908195495605696, 18.532083511352653],
          [72.907913208007983, 18.532083511352653],
          [72.907913208007983, 18.532361984253043],
          [72.907638549804744, 18.53236007690424],
          [72.907638549804744, 18.532920837402401],
          [72.90708160400419, 18.532915115356445],
          [72.90708160400419, 18.533193588256836],
          [72.907363891601733, 18.533193588256836],
          [72.907363891601733, 18.533472061157227],
          [72.90708160400419, 18.533470153808594],
          [72.90708160400419, 18.534030914306754],
          [72.906806945800781, 18.534027099609375],
          [72.906806945800781, 18.534584045410156],
          [72.906517028808878, 18.534580230712947],
          [72.906517028808878, 18.535139083862305],
          [72.90625, 18.535139083862305],
          [72.90625, 18.536527633667049],
          [72.90598297119152, 18.536527633667049],
          [72.90598297119152, 18.536811828613395],
          [72.904586791992244, 18.536811828613395],
          [72.904586791992244, 18.537359237670842],
          [72.904304504394702, 18.537359237670842],
          [72.904304504394702, 18.538473129272575],
          [72.904586791992244, 18.538473129272575],
          [72.904586791992244, 18.539304733276367],
          [72.905136108398494, 18.539304733276367],
          [72.905136108398494, 18.539581298828125],
          [72.905418395996037, 18.539579391479549],
          [72.905418395996037, 18.540140151977482],
          [72.905693054199276, 18.540138244628906],
          [72.905693054199276, 18.540973663330078],
          [72.90625, 18.540969848632869],
          [72.90625, 18.541250228881836],
          [72.90708160400419, 18.541250228881836],
          [72.90708160400419, 18.540969848632869],
          [72.907363891601733, 18.540973663330078],
          [72.907363891601733, 18.540695190429687],
          [72.907638549804744, 18.540702819824219],
          [72.907638549804744, 18.540140151977482],
          [72.907913208007983, 18.540140151977482],
          [72.907913208007983, 18.539579391479549],
          [72.908195495605696, 18.539581298828125],
          [72.908195495605696, 18.539028167724553],
          [72.908470153808537, 18.539030075073356],
          [72.908470153808537, 18.538751602172965],
          [72.908752441406307, 18.538751602172965],
          [72.908752441406307, 18.538190841674805],
          [72.909027099609489, 18.538194656372184],
          [72.909027099609489, 18.537641525268612],
          [72.9093017578125, 18.537641525268612],
          [72.9093017578125, 18.537359237670842],
          [72.909576416015909, 18.537359237670842],
          [72.909576416015909, 18.536249160766658],
          [72.909858703613281, 18.536249160766658],
          [72.909858703613281, 18.535417556762695],
          [72.910140991211222, 18.535417556762695],
          [72.910140991211222, 18.534860610961914],
          [72.910423278808764, 18.534860610961914],
          [72.910415649414233, 18.53375053405756],
          [72.910697937011776, 18.53375053405756],
          [72.910697937011776, 18.53153038024908],
          [72.910972595215014, 18.53153038024908],
          [72.910972595215014, 18.53096961975092],
          [72.911247253418196, 18.530971527099723],
          [72.911247253418196, 18.530416488647518],
          [72.911529541015568, 18.530420303344727],
          [72.911529541015568, 18.530139923095703],
          [72.91208648681652, 18.530139923095703],
          [72.91208648681652, 18.529859542846737],
          [72.914024353027514, 18.529861450195369],
          [72.914024353027514, 18.529584884643555],
          [72.914581298828068, 18.52959060668951],
          [72.914581298828068, 18.529310226440543],
          [72.915145874023381, 18.529310226440543],
          [72.915145874023381, 18.529029846191349],
          [72.916549682617188, 18.529029846191349],
          [72.917358398437727, 18.529029846191349],
          [72.917358398437727, 18.529310226440543],
          [72.917640686035327, 18.529310226440543],
          [72.917640686035327, 18.52959060668951],
          [72.917915344238338, 18.529584884643555],
          [72.917915344238338, 18.529861450195369],
          [72.918472290039119, 18.529859542846737],
          [72.918472290039119, 18.530139923095703],
          [72.918746948242472, 18.530139923095703],
          [72.918746948242472, 18.530420303344727],
          [72.919029235839844, 18.530420303344727],
          [72.919029235839844, 18.530700683593864],
          [72.919303894043253, 18.530693054199332],
          [72.919303894043253, 18.530971527099723],
          [72.919860839844034, 18.53096961975092],
          [72.919860839844034, 18.531250000000057],
          [72.921249389648381, 18.531250000000057],
          [72.921249389648381, 18.53153038024908],
          [72.922363281250284, 18.53153038024908],
          [72.922363281250284, 18.531810760498047],
          [72.922637939453125, 18.531806945800838],
          [72.922637939453125, 18.532083511352653],
          [72.922920227051065, 18.532083511352653],
          [72.922920227051065, 18.532361984253043],
          [72.923187255859546, 18.53236007690424],
          [72.923187255859546, 18.532648086547965],
          [72.923454284668196, 18.532705307006893],
          [72.923469543457088, 18.532920837402401],
          [72.924583435058651, 18.532915115356445],
          [72.924583435058651, 18.533193588256836],
          [72.924858093261832, 18.533193588256836],
          [72.924858093261832, 18.533472061157227],
          [72.925140380859432, 18.533470153808594],
          [72.925140380859432, 18.53375053405756],
          [72.926246643066577, 18.53375053405756],
          [72.926246643066577, 18.534030914306754],
          [72.926528930664119, 18.534030914306754],
          [72.926528930664119, 18.534309387207145],
          [72.926795959472827, 18.534309387207145],
          [72.926795959472827, 18.534860610961914],
          [72.927085876465071, 18.534860610961914],
          [72.927085876465071, 18.535139083862305],
          [72.927917480468864, 18.535139083862305],
          [72.927917480468864, 18.535417556762695],
          [72.928749084472656, 18.535417556762695],
          [72.928749084472656, 18.53569412231451],
          [72.928466796875284, 18.535690307617131],
          [72.928466796875284, 18.541810989379996],
          [72.928192138671932, 18.541805267334041],
          [72.928192138671932, 18.542083740234432],
          [72.927917480468864, 18.542079925537053],
          [72.927917480468864, 18.54236030578619],
          [72.927642822265682, 18.54236030578619],
          [72.927642822265682, 18.542640686035213],
          [72.927360534667912, 18.542640686035213],
          [72.927360534667912, 18.54292106628418],
          [72.927085876465071, 18.542917251586971],
          [72.927085876465071, 18.543195724487362],
          [72.926803588867358, 18.543195724487362],
          [72.926803588867358, 18.543472290039176],
          [72.926528930664119, 18.543470382690373],
          [72.926528930664119, 18.543750762939567],
          [72.926246643066577, 18.543750762939567],
          [72.926246643066577, 18.544031143188533],
          [72.925422668457315, 18.544031143188533],
          [72.925422668457315, 18.544309616088924],
          [72.925140380859432, 18.544309616088924],
          [72.925140380859432, 18.544860839843693],
          [72.924575805664119, 18.544860839843693],
          [72.924575805664119, 18.545141220092887],
          [72.924308776855412, 18.545141220092887],
          [72.924308776855412, 18.546529769897404],
          [72.92402648925804, 18.546529769897404],
          [72.92402648925804, 18.547647476196346],
          [72.923751831054858, 18.547647476196346],
          [72.923751831054858, 18.550138473510685],
          [72.923469543457088, 18.550138473510685],
          [72.923469543457088, 18.551811218261776],
          [72.923187255859546, 18.551811218261776],
          [72.923187255859546, 18.552362442016602],
          [72.922920227051065, 18.552362442016602],
          [72.922920227051065, 18.552919387817326],
          [72.922637939453125, 18.55291748046875],
          [72.922637939453125, 18.553472518920955],
          [72.922363281250284, 18.553472518920955],
          [72.922363281250284, 18.55402946472168],
          [72.922080993652344, 18.554027557373104],
          [72.922080993652344, 18.554580688476506],
          [72.921806335449332, 18.554580688476506],
          [72.921806335449332, 18.555139541626033],
          [72.921524047851619, 18.555139541626033],
          [72.921524047851619, 18.555694580078239],
          [72.921249389648381, 18.555690765380859],
          [72.921249389648381, 18.556529998779411],
          [72.92097473144554, 18.556528091430607],
          [72.92097473144554, 18.557361602783203],
          [72.920692443847827, 18.55735969543457],
          [72.920692443847827, 18.557920455932731],
          [72.920417785644588, 18.557920455932731],
          [72.920417785644588, 18.559860229492244],
          [72.920143127441577, 18.559860229492244],
          [72.920143127441577, 18.560140609741268],
          [72.919860839844034, 18.560140609741268],
          [72.919860839844034, 18.560420989990234],
          [72.919586181640625, 18.56041526794445],
          [72.919586181640625, 18.560972213745231],
          [72.919296264648722, 18.560970306396428],
          [72.919296264648722, 18.561250686645621],
          [72.919029235839844, 18.561250686645621],
          [72.919029235839844, 18.561531066894588],
          [72.918746948242472, 18.561531066894588],
          [72.918746948242472, 18.561809539794979],
          [72.918472290039119, 18.561809539794979],
          [72.918472290039119, 18.562360763549748],
          [72.918197631835881, 18.562360763549748],
          [72.918197631835881, 18.562637329101563],
          [72.917915344238338, 18.562637329101563],
          [72.917915344238338, 18.563194274902344],
          [72.917640686035327, 18.563194274902344],
          [72.917640686035327, 18.563472747802734],
          [72.917358398437727, 18.563470840454102],
          [72.917358398437727, 18.564031600952262],
          [72.917076110840014, 18.564031600952262],
          [72.917076110840014, 18.565141677856445],
          [72.916809082031534, 18.565141677856445],
          [72.916809082031534, 18.565420150756836],
          [72.916526794433764, 18.565416336059627],
          [72.916526794433764, 18.565969467163029],
          [72.916252136230753, 18.565969467163029],
          [72.916252136230753, 18.566251754760799],
          [72.915969848632812, 18.566251754760799],
          [72.915969848632812, 18.566804885864371],
          [72.915695190429972, 18.566804885864371],
          [72.915695190429972, 18.567363739013729],
          [72.915412902832088, 18.567361831665153],
          [72.915412902832088, 18.567640304565543],
          [72.915145874023381, 18.567640304565543],
          [72.915145874023381, 18.568201065063477],
          [72.914855957031307, 18.568201065063477],
          [72.914855957031307, 18.568759918213004],
          [72.914581298828068, 18.56875038146967],
          [72.914581298828068, 18.569585800171012],
          [72.914306640625227, 18.569580078125057],
          [72.914306640625227, 18.570421218872184],
          [72.914024353027514, 18.570417404174805],
          [72.914024353027514, 18.57097244262701],
          [72.913749694824276, 18.570970535278377],
          [72.913749694824276, 18.571250915527401],
          [72.913482666015625, 18.571250915527401],
          [72.913482666015625, 18.571821212768612],
          [72.913192749023722, 18.571804046630973],
          [72.913192749023722, 18.572082519531364],
          [72.912918090820313, 18.57208061218256],
          [72.912918090820313, 18.572360992431754],
          [72.91263580322294, 18.572360992431754],
          [72.91263580322294, 18.572639465332088],
          [72.912361145019588, 18.572639465332088],
          [72.912361145019588, 18.573194503784293],
          [72.91208648681652, 18.573194503784293],
          [72.91208648681652, 18.573472976684684],
          [72.911804199218807, 18.573472976684684],
          [72.911804199218807, 18.574583053588867],
          [72.911529541015568, 18.574569702148551],
          [72.911529541015568, 18.575700759887752],
          [72.911247253418196, 18.575700759887752],
          [72.911247253418196, 18.576810836792106],
          [72.910972595215014, 18.576810836792106],
          [72.910972595215014, 18.577920913696289],
          [72.910697937011776, 18.57791709899908],
          [72.910697937011776, 18.578470230102482],
          [72.910415649414233, 18.578470230102482],
          [72.910423278808764, 18.578752517700252],
          [72.909309387207088, 18.578752517700252],
          [72.9093017578125, 18.579309463501033],
          [72.909019470215128, 18.579309463501033],
          [72.909019470215128, 18.579862594604606],
          [72.908752441406307, 18.579862594604606],
          [72.908752441406307, 18.580699920654354],
          [72.908470153808537, 18.580699920654354],
          [72.908470153808537, 18.58125114440918],
          [72.908203125000227, 18.58125114440918],
          [72.908203125000227, 18.583761215209961],
          [72.908470153808537, 18.583761215209961],
          [72.908470153808537, 18.584030151367244],
          [72.908752441406307, 18.584028244018612],
          [72.908752441406307, 18.584583282470817],
          [72.909027099609489, 18.584583282470817],
          [72.909027099609489, 18.584861755371207],
          [72.9093017578125, 18.584859848022404],
          [72.9093017578125, 18.584999084472713],
          [72.909309387207088, 18.585140228271598],
          [72.909858703613281, 18.585140228271598],
          [72.909858703613281, 18.585420608520565],
          [72.910140991211222, 18.585416793823356],
          [72.910140991211222, 18.585971832275391],
          [72.909858703613281, 18.585969924926758],
          [72.909858703613281, 18.586250305175724],
          [72.908195495605696, 18.586250305175724],
          [72.908195495605696, 18.585971832275391],
          [72.907638549804744, 18.585971832275391],
          [72.907638549804744, 18.585695266723746],
          [72.907356262207202, 18.585700988769531],
          [72.907356262207202, 18.585420608520565],
          [72.90708160400419, 18.585420608520565],
          [72.90708160400419, 18.585700988769531],
          [72.906524658203409, 18.585695266723746],
          [72.906524658203409, 18.585971832275391],
          [72.90625, 18.585969924926758],
          [72.90625, 18.586250305175724],
          [72.905693054199276, 18.586250305175724],
          [72.905693054199276, 18.58680534362793],
          [72.905418395996037, 18.586799621582145],
          [72.905418395996037, 18.587360382080078],
          [72.905136108398494, 18.587360382080078],
          [72.905136108398494, 18.588472366333065],
          [72.904861450195483, 18.588470458984432],
          [72.904861450195483, 18.589031219482422],
          [72.904586791992244, 18.589031219482422],
          [72.904586791992244, 18.589860916137809],
          [72.904296875000171, 18.589860916137809],
          [72.904296875000171, 18.590421676635742],
          [72.90402984619169, 18.590415954589957],
          [72.90402984619169, 18.590694427490348],
          [72.903747558593921, 18.590690612792969],
          [72.903747558593921, 18.591249465942326],
          [72.903472900390909, 18.591249465942326],
          [72.903472900390909, 18.591531753540096],
          [72.903205871582088, 18.591531753540096],
          [72.903205871582088, 18.591810226440487],
          [72.902915954590128, 18.591810226440487],
          [72.902915954590128, 18.59264183044445],
          [72.902641296386776, 18.59264183044445],
          [72.902641296386776, 18.593200683593807],
          [72.902359008789176, 18.593200683593807],
          [72.902359008789176, 18.594030380249023],
          [72.902076721191463, 18.594030380249023],
          [72.902076721191463, 18.594310760498161],
          [72.901802062988224, 18.594305038452205],
          [72.901802062988224, 18.59597206115734],
          [72.901527404785384, 18.595970153808537],
          [72.901527404785384, 18.596250534057731],
          [72.901252746582202, 18.596250534057731],
          [72.901252746582202, 18.596530914306697],
          [72.900970458984432, 18.596530914306697],
          [72.900970458984432, 18.597360610961857],
          [72.900695800781421, 18.597360610961857],
          [72.900695800781421, 18.598194122314453],
          [72.900413513183878, 18.598194122314453],
          [72.900413513183878, 18.598472595214844],
          [72.900146484375, 18.598470687866211],
          [72.900146484375, 18.599029541015568],
          [72.899856567383097, 18.599029541015568],
          [72.899856567383097, 18.599861145019588],
          [72.899581909179744, 18.599861145019588],
          [72.899581909179744, 18.601249694824276],
          [72.899307250976676, 18.601249694824276],
          [72.899307250976676, 18.601528167724666],
          [72.899024963378963, 18.60152626037609],
          [72.899024963378963, 18.601804733276481],
          [72.898475646972884, 18.601804733276481],
          [72.898475646972884, 18.602361679077262],
          [72.898193359375171, 18.602359771728459],
          [72.898193359375171, 18.603200912475586],
          [72.897918701171932, 18.603195190429801],
          [72.897918701171932, 18.603471755981445],
          [72.897636413574389, 18.603469848632812],
          [72.897636413574389, 18.604030609130973],
          [72.897361755371378, 18.604030609130973],
          [72.897361755371378, 18.604871749878043],
          [72.897079467773438, 18.604871749878043],
          [72.897079467773438, 18.605421066284293],
          [72.896789550781534, 18.605421066284293],
          [72.896789550781534, 18.606252670288086],
          [72.896530151367244, 18.606252670288086],
          [72.896530151367244, 18.606531143188477],
          [72.896247863769645, 18.606531143188477],
          [72.896247863769645, 18.606809616088867],
          [72.895973205566463, 18.606809616088867],
          [72.895973205566463, 18.60736274719244],
          [72.895690917968693, 18.60736274719244],
          [72.895690917968693, 18.608194351196403],
          [72.895416259765852, 18.608194351196403],
          [72.895416259765852, 18.608474731445369],
          [72.895141601562671, 18.608472824096793],
          [72.895141601562671, 18.609029769897575],
          [72.894859313964901, 18.609029769897575],
          [72.894859313964901, 18.610420227050895],
          [72.894577026367358, 18.610420227050895],
          [72.894577026367358, 18.611249923706055],
          [72.894302368164347, 18.611249923706055],
          [72.894302368164347, 18.612083435058651],
          [72.894027709960937, 18.612083435058651],
          [72.894027709960937, 18.612361907959041],
          [72.893753051758097, 18.612360000610408],
          [72.893753051758097, 18.612640380859432],
          [72.893470764160156, 18.612640380859432],
          [72.893470764160156, 18.612920761108398],
          [72.893196105957145, 18.61291694641119],
          [72.893196105957145, 18.613471984863395],
          [72.892913818359432, 18.613471984863395],
          [72.892913818359432, 18.613750457763786],
          [72.892639160156193, 18.613740921020621],
          [72.892639160156193, 18.614311218261719],
          [72.892356872558651, 18.614311218261719],
          [72.892356872558651, 18.615140914917106],
          [72.892082214355639, 18.615140914917106],
          [72.892082214355639, 18.615417480468693],
          [72.891807556152401, 18.615417480468693],
          [72.891807556152401, 18.615972518920898],
          [72.891250610351847, 18.615970611572266],
          [72.891250610351847, 18.616249084472656],
          [72.890975952148438, 18.616249084472656],
          [72.890975952148438, 18.61735916137701],
          [72.890686035156534, 18.61735916137701],
          [72.890686035156534, 18.617921829223746],
          [72.890419006347656, 18.617916107177791],
          [72.890419006347656, 18.618471145629996],
          [72.890136718750284, 18.618469238281193],
          [72.890136718750284, 18.61903190612793],
          [72.889862060546932, 18.619028091430721],
          [72.889862060546932, 18.619304656982536],
          [72.889312744140852, 18.619300842285156],
          [72.889312744140852, 18.619871139526424],
          [72.88874816894554, 18.619871139526424],
          [72.88874816894554, 18.620140075683707],
          [72.888465881347827, 18.620140075683707],
          [72.888465881347827, 18.620420455932674],
          [72.888191223144588, 18.620416641235465],
          [72.888191223144588, 18.620973587036246],
          [72.887916564941577, 18.620969772338867],
          [72.887916564941577, 18.621530532837028],
          [72.887641906738565, 18.621530532837028],
          [72.887641906738565, 18.622640609741211],
          [72.887359619140625, 18.622638702392578],
          [72.887359619140625, 18.622917175292969],
          [72.887077331543253, 18.622909545898438],
          [72.887077331543253, 18.623750686645565],
          [72.886802673339901, 18.623750686645565],
          [72.886802673339901, 18.624584197998104],
          [72.886528015136832, 18.624580383300724],
          [72.886528015136832, 18.624860763549918],
          [72.886253356933651, 18.624860763549918],
          [72.886253356933651, 18.625419616699276],
          [72.885971069335881, 18.625415802002067],
          [72.885971069335881, 18.625972747802848],
          [72.88569641113304, 18.625970840454045],
          [72.88569641113304, 18.626251220703239],
          [72.885406494140796, 18.626251220703239],
          [72.885406494140796, 18.627639770507756],
          [72.885139465332088, 18.627639770507756],
          [72.885139465332088, 18.629861831665096],
          [72.884849548340014, 18.629859924316463],
          [72.884849548340014, 18.632642745971737],
          [72.884582519531534, 18.632640838623161],
          [72.884582519531534, 18.634580612182674],
          [72.884307861328125, 18.634580612182674],
          [72.884307861328125, 18.635139465332031],
          [72.884025573730753, 18.635139465332031],
          [72.884025573730753, 18.638471603393555],
          [72.884864807129077, 18.638471603393555],
          [72.884864807129077, 18.638196945190487],
          [72.887359619140625, 18.638200759887695],
          [72.887359619140625, 18.637910842895565],
          [72.887916564941577, 18.63791656494152],
          [72.887916564941577, 18.637638092040959],
          [72.888465881347827, 18.637639999389762],
          [72.888465881347827, 18.637359619140568],
          [72.889030456543139, 18.637361526489371],
          [72.889030456543139, 18.637083053588981],
          [72.891113281249943, 18.637083053588981],
          [72.891250610351847, 18.637083053588981],
          [72.891250610351847, 18.636528015136776],
          [72.891532897949389, 18.636529922485408],
          [72.891532897949389, 18.636249542236385],
          [72.891807556152401, 18.636249542236385],
          [72.891807556152401, 18.635971069336051],
          [72.892082214355639, 18.635974884033203],
          [72.892082214355639, 18.635694503784237],
          [72.895973205566463, 18.635694503784237],
          [72.895973205566463, 18.635416030883846],
          [72.897079467773438, 18.635419845581055],
          [72.897079467773438, 18.634849548339957],
          [72.897361755371378, 18.634862899780273],
          [72.897361755371378, 18.634305953979492],
          [72.897636413574389, 18.634309768676871],
          [72.897636413574389, 18.63375282287609],
          [72.897918701171932, 18.63375282287609],
          [72.897918701171932, 18.63257026672369],
          [72.897918701171932, 18.632083892822379],
          [72.898193359375171, 18.632083892822379],
          [72.898193359375171, 18.630416870117244],
          [72.898483276367244, 18.630420684814453],
          [72.898483276367244, 18.629579544067326],
          [72.899307250976676, 18.629583358764705],
          [72.899307250976676, 18.629861831665096],
          [72.900405883789347, 18.629859924316463],
          [72.900405883789347, 18.630138397216854],
          [72.900695800781421, 18.630138397216854],
          [72.900695800781421, 18.630699157714844],
          [72.900970458984432, 18.630699157714844],
          [72.900970458984432, 18.631248474121037],
          [72.901252746582202, 18.631248474121037],
          [72.901252746582202, 18.631811141967773],
          [72.901527404785384, 18.631811141967773],
          [72.901527404785384, 18.63236236572277],
          [72.901802062988224, 18.63236236572277],
          [72.901802062988224, 18.632642745971737],
          [72.901527404785384, 18.632640838623161],
          [72.901527404785384, 18.633192062377987],
          [72.901252746582202, 18.633192062377987],
          [72.901252746582202, 18.63347053527832],
          [72.900970458984432, 18.63347053527832],
          [72.900970458984432, 18.634029388427678],
          [72.900695800781421, 18.634029388427678],
          [72.900695800781421, 18.634309768676871],
          [72.900413513183878, 18.634305953979492],
          [72.900413513183878, 18.634580612182674],
          [72.900138854980469, 18.634580612182674],
          [72.900138854980469, 18.634862899780273],
          [72.899856567383097, 18.634849548339957],
          [72.899856567383097, 18.635139465332031],
          [72.899581909179744, 18.635139465332031],
          [72.899581909179744, 18.635419845581055],
          [72.899307250976676, 18.635416030883846],
          [72.899307250976676, 18.635694503784237],
          [72.898750305175724, 18.635694503784237],
          [72.898750305175724, 18.635974884033203],
          [72.898193359375171, 18.635971069336051],
          [72.898193359375171, 18.636249542236385],
          [72.896789550781534, 18.636249542236385],
          [72.896789550781534, 18.636529922485408],
          [72.896530151367244, 18.636529922485408],
          [72.896530151367244, 18.636810302734375],
          [72.895973205566463, 18.636806488037166],
          [72.895973205566463, 18.637083053588981],
          [72.895690917968693, 18.637083053588981],
          [72.895690917968693, 18.637361526489371],
          [72.895141601562671, 18.637359619140568],
          [72.895141601562671, 18.637639999389762],
          [72.894302368164347, 18.637638092040959],
          [72.894302368164347, 18.63791656494152],
          [72.893753051758097, 18.63791656494152],
          [72.893753051758097, 18.638040542602539],
          [72.893753051758097, 18.638200759887695],
          [72.892913818359432, 18.638196945190487],
          [72.892913818359432, 18.638471603393555],
          [72.892356872558651, 18.638469696044922],
          [72.892356872558651, 18.638750076293888],
          [72.891807556152401, 18.638750076293888],
          [72.891807556152401, 18.639030456543082],
          [72.891250610351847, 18.639030456543082],
          [72.891250610351847, 18.639310836792049],
          [72.890693664551065, 18.639305114746094],
          [72.890693664551065, 18.639583587646484],
          [72.890136718750284, 18.639583587646484],
          [72.890136718750284, 18.639862060546875],
          [72.889579772949332, 18.639860153198242],
          [72.889579772949332, 18.640140533447266],
          [72.889030456543139, 18.640140533447266],
          [72.889030456543139, 18.640420913696403],
          [72.888473510742358, 18.640415191650447],
          [72.888473510742358, 18.640693664550838],
          [72.887916564941577, 18.640693664550838],
          [72.887916564941577, 18.640972137451229],
          [72.887359619140625, 18.640970230102596],
          [72.887359619140625, 18.641250610351619],
          [72.884307861328125, 18.641250610351619],
          [72.884307861328125, 18.640970230102596],
          [72.883750915527401, 18.640972137451229],
          [72.883750915527401, 18.640693664550838],
          [72.883468627929801, 18.640693664550838],
          [72.883468627929801, 18.640415191650447],
          [72.882919311523381, 18.640420913696403],
          [72.882919311523381, 18.639030456543082],
          [72.882736206054858, 18.639030456543082],
          [72.882637023926009, 18.639028549194279],
          [72.882637023926009, 18.638200759887695],
          [72.882362365722827, 18.638200759887695],
          [72.882362365722827, 18.637639999389762],
          [72.882080078125057, 18.637639999389762],
          [72.882080078125057, 18.637359619140568],
          [72.877639770507813, 18.637359619140568],
          [72.877639770507813, 18.637639999389762],
          [72.87735748291044, 18.637638092040959],
          [72.87735748291044, 18.63791656494152],
          [72.877082824707088, 18.63791656494152],
          [72.877082824707088, 18.637638092040959],
          [72.876525878906307, 18.637638092040959],
          [72.876525878906307, 18.63791656494152],
          [72.875976562500057, 18.637910842895565],
          [72.875976562500057, 18.638200759887695],
          [72.875137329101733, 18.638196945190487],
          [72.875137329101733, 18.638471603393555],
          [72.872642517090014, 18.638469696044922],
          [72.872642517090014, 18.638750076293888],
          [72.872093200683594, 18.638750076293888],
          [72.872093200683594, 18.639030456543082],
          [72.871528625488281, 18.639030456543082],
          [72.871528625488281, 18.639310836792049],
          [72.870971679687557, 18.639305114746094],
          [72.870971679687557, 18.639583587646484],
          [72.870407104492244, 18.639579772949276],
          [72.870407104492244, 18.640140533447266],
          [72.870140075683537, 18.640138626098633],
          [72.870140075683537, 18.640972137451229],
          [72.869850158691463, 18.640970230102596],
          [72.869850158691463, 18.641529083251953],
          [72.869583129882983, 18.641529083251953],
          [72.869583129882983, 18.642360687255973],
          [72.869308471679744, 18.642360687255973],
          [72.869308471679744, 18.642917633056697],
          [72.869026184082202, 18.642917633056697],
          [72.869026184082202, 18.643194198608512],
          [72.86875152587919, 18.643190383911133],
          [72.86875152587919, 18.64374923706049],
          [72.86846923828125, 18.64374923706049],
          [72.86846923828125, 18.644311904907227],
          [72.868186950683878, 18.644311904907227],
          [72.868186950683878, 18.645141601562614],
          [72.867919921875057, 18.645141601562614],
          [72.867919921875057, 18.645420074463004],
          [72.867637634277457, 18.645416259765625],
          [72.867637634277457, 18.645969390869197],
          [72.867362976074276, 18.645969390869197],
          [72.867362976074276, 18.646251678466797],
          [72.867080688476506, 18.646251678466797],
          [72.867080688476506, 18.646530151367188],
          [72.866806030273665, 18.646528244018555],
          [72.866806030273665, 18.647081375122184],
          [72.866531372070483, 18.647079467773381],
          [72.866531372070483, 18.647640228271541],
          [72.866249084472713, 18.647640228271541],
          [72.866249084472713, 18.648202896118221],
          [72.865966796875171, 18.648202896118221],
          [72.865966796875171, 18.649030685424862],
          [72.865692138672159, 18.649030685424862],
          [72.865692138672159, 18.650140762329215],
          [72.86541748046875, 18.650140762329215],
          [72.86541748046875, 18.651531219482536],
          [72.865135192871378, 18.651527404785156],
          [72.865135192871378, 18.652917861938477],
          [72.864860534667969, 18.652910232543945],
          [72.864860534667969, 18.654029846191463],
          [72.864585876464957, 18.654029846191463],
          [72.864585876464957, 18.655139923095817],
          [72.864295959472713, 18.655139923095817],
          [72.864303588867244, 18.656248092651367],
          [72.864028930664006, 18.656248092651367],
          [72.864028930664006, 18.657360076904297],
          [72.863746643066463, 18.657360076904297],
          [72.863746643066463, 18.658470153808651],
          [72.863471984863452, 18.658470153808651],
          [72.863471984863452, 18.66069221496582],
          [72.863197326660213, 18.66069221496582],
          [72.863197326660213, 18.663473129272461],
          [72.863471984863452, 18.663471221923885],
          [72.863471984863452, 18.665420532226563],
          [72.863746643066463, 18.665420532226563],
          [72.863746643066463, 18.666810989379883],
          [72.864028930664006, 18.666805267334098],
          [72.864028930664006, 18.667360305786076],
          [72.864303588867244, 18.667360305786076],
          [72.864303588867244, 18.668193817138672],
          [72.864585876464957, 18.668190002441463],
          [72.864585876464957, 18.668750762939453],
          [72.864295959472713, 18.668750762939453],
          [72.864295959472713, 18.669309616088981],
          [72.864028930664006, 18.669305801391602],
          [72.864036560058537, 18.669860839843807],
          [72.863746643066463, 18.669860839843807],
          [72.863746643066463, 18.670421600341911],
          [72.863471984863452, 18.670421600341911],
          [72.863471984863452, 18.670980453491268],
          [72.863197326660213, 18.670980453491268],
          [72.863197326660213, 18.671810150146484],
          [72.862922668457202, 18.671810150146484],
          [72.862922668457202, 18.672641754150447],
          [72.862640380859659, 18.672641754150447],
          [72.862640380859659, 18.673751831054801],
          [72.862358093261889, 18.673751831054801],
          [72.862358093261889, 18.674583435058594],
          [72.862075805664347, 18.674579620361385],
          [72.862075805664347, 18.675420761108512],
          [72.861808776855469, 18.675420761108512],
          [72.861808776855469, 18.676530838012695],
          [72.861526489258097, 18.676530838012695],
          [72.861526489258097, 18.67791938781744],
          [72.861251831054744, 18.677917480468807],
          [72.861251831054744, 18.679582595825195],
          [72.860969543457145, 18.679580688476562],
          [72.860969543457145, 18.681249618530273],
          [72.860679626464901, 18.681249618530273],
          [72.860679626464901, 18.683210372924862],
          [72.860420227050952, 18.683210372924862],
          [72.860420227050952, 18.685422897338867],
          [72.860137939453352, 18.685422897338867],
          [72.860137939453352, 18.687641143798828],
          [72.859863281250171, 18.687639236450195],
          [72.859863281250171, 18.689584732055721],
          [72.859580993652401, 18.689584732055721],
          [72.859580993652401, 18.690694808960075],
          [72.859306335449389, 18.690690994262695],
          [72.859306335449389, 18.691249847412053],
          [72.859024047851847, 18.691249847412053],
          [72.859024047851847, 18.691806793212834],
          [72.858749389648437, 18.691806793212834],
          [72.858749389648437, 18.692361831665039],
          [72.858467102051065, 18.692359924316406],
          [72.858467102051065, 18.692920684814567],
          [72.858192443847713, 18.692920684814567],
          [72.858192443847713, 18.693201065063533],
          [72.857635498046932, 18.693195343017578],
          [72.857635498046932, 18.693471908569393],
          [72.857360839843693, 18.69347000122076],
          [72.857360839843693, 18.693750381469783],
          [72.857086181640852, 18.693750381469783],
          [72.857086181640852, 18.69403076171875],
          [72.856803894043139, 18.694026947021541],
          [72.856803894043139, 18.694583892822322],
          [72.856529235839901, 18.694580078124943],
          [72.856529235839901, 18.694860458374137],
          [72.856246948242358, 18.694860458374137],
          [72.856246948242358, 18.695148468017635],
          [72.855972290039347, 18.695138931274471],
          [72.855972290039347, 18.695693969726676],
          [72.855697631835938, 18.695693969726676],
          [72.855697631835938, 18.695972442627067],
          [72.855422973633097, 18.695970535278263],
          [72.855422973633097, 18.696809768676815],
          [72.855140686035213, 18.696809768676815],
          [72.855140686035213, 18.697359085083008],
          [72.855697631835938, 18.697359085083008],
          [72.855697631835938, 18.69819450378418],
          [72.855972290039347, 18.698190689086971],
          [72.855972290039347, 18.699031829834098],
          [72.856246948242358, 18.699029922485352],
          [72.856246948242358, 18.699581146240348],
          [72.856529235839901, 18.699579238891545],
          [72.856529235839901, 18.700420379638672],
          [72.856803894043139, 18.700416564941463],
          [72.856803894043139, 18.700973510742244],
          [72.857086181640852, 18.700973510742244],
          [72.857086181640852, 18.700695037841854],
          [72.857360839843693, 18.700695037841854],
          [72.857360839843693, 18.700973510742244],
          [72.857910156250114, 18.700960159301758],
          [72.857910156250114, 18.701530456543026],
          [72.858192443847713, 18.701528549194393],
          [72.858192443847713, 18.702083587646598],
          [72.858467102051065, 18.702079772949219],
          [72.858467102051065, 18.702640533447379],
          [72.858749389648437, 18.702638626098576],
          [72.858749389648437, 18.703195571899528],
          [72.859024047851847, 18.703195571899528],
          [72.859024047851847, 18.703472137451172],
          [72.859306335449389, 18.703470230102539],
          [72.859306335449389, 18.7040309906007],
          [72.859580993652401, 18.70402717590332],
          [72.859580993652401, 18.704584121704102],
          [72.859863281250171, 18.704580307006893],
          [72.859863281250171, 18.705141067504883],
          [72.860137939453352, 18.70513916015625],
          [72.860137939453352, 18.705694198608455],
          [72.860420227050952, 18.705690383911076],
          [72.860420227050952, 18.707090377807731],
          [72.860679626464901, 18.707090377807731],
          [72.860679626464901, 18.708749771118107],
          [72.860969543457145, 18.708749771118107],
          [72.860969543457145, 18.709583282470703],
          [72.861251831054744, 18.709579467773494],
          [72.861251831054744, 18.710420608520621],
          [72.861526489258097, 18.710420608520621],
          [72.861526489258097, 18.711248397827205],
          [72.861808776855469, 18.711248397827205],
          [72.861808776855469, 18.712360382080192],
          [72.862083435058878, 18.712360382080192],
          [72.862083435058878, 18.713470458984318],
          [72.862358093261889, 18.713470458984318],
          [72.862358093261889, 18.714580535888672],
          [72.862640380859659, 18.714580535888672],
          [72.862640380859659, 18.715694427490234],
          [72.862922668457202, 18.715690612793026],
          [72.862922668457202, 18.716810226440543],
          [72.863197326660213, 18.716810226440543],
          [72.863197326660213, 18.717920303344727],
          [72.863471984863452, 18.717920303344727],
          [72.863471984863452, 18.71903038024908],
          [72.863746643066463, 18.71903038024908],
          [72.863746643066463, 18.720140457153434],
          [72.864028930664006, 18.720138549804631],
          [72.864028930664006, 18.721250534057617],
          [72.864295959472713, 18.721250534057617],
          [72.864295959472713, 18.731809616088924],
          [72.864028930664006, 18.731805801391715],
          [72.864028930664006, 18.734582901001033],
          [72.863746643066463, 18.734582901001033],
          [72.863746643066463, 18.735694885253963],
          [72.863471984863452, 18.735691070556584],
          [72.863471984863452, 18.736528396606502],
          [72.863197326660213, 18.736528396606502],
          [72.863197326660213, 18.737638473510685],
          [72.862915039062671, 18.737638473510685],
          [72.862915039062671, 18.738470077514648],
          [72.862640380859659, 18.738468170166072],
          [72.862640380859659, 18.739311218261776],
          [72.862358093261889, 18.739311218261776],
          [72.862358093261889, 18.743200302124023],
          [72.862640380859659, 18.743194580078239],
          [72.862640380859659, 18.744304656982422],
          [72.862922668457202, 18.744300842285213],
          [72.862922668457202, 18.745420455932731],
          [72.863197326660213, 18.745420455932731],
          [72.863197326660213, 18.746530532836914],
          [72.863471984863452, 18.746530532836914],
          [72.863471984863452, 18.747640609741268],
          [72.863746643066463, 18.747640609741268],
          [72.863746643066463, 18.748750686645621],
          [72.864028930664006, 18.748750686645621],
          [72.864028930664006, 18.74930572509777],
          [72.864295959472713, 18.749298095703239],
          [72.864295959472713, 18.750139236450138],
          [72.864585876464957, 18.750139236450138],
          [72.864585876464957, 18.751531600952262],
          [72.864860534667969, 18.751527786254883],
          [72.864860534667969, 18.753194808960018],
          [72.865135192871378, 18.753194808960018],
          [72.865135192871378, 18.754581451416016],
          [72.86541748046875, 18.754579544067383],
          [72.86541748046875, 18.755430221557617],
          [72.865692138672159, 18.755430221557617],
          [72.865692138672159, 18.756250381469727],
          [72.865966796875171, 18.756250381469727],
          [72.865966796875171, 18.75681114196783],
          [72.866806030273665, 18.75681114196783],
          [72.866806030273665, 18.756530761718864],
          [72.867080688476506, 18.756530761718864],
          [72.867080688476506, 18.755701065063477],
          [72.867362976074276, 18.755701065063477],
          [72.867362976074276, 18.755430221557617],
          [72.867919921875057, 18.755430221557617],
          [72.867919921875057, 18.755701065063477],
          [72.868186950683878, 18.755701065063477],
          [72.868186950683878, 18.756250381469727],
          [72.867919921875057, 18.756250381469727],
          [72.867919921875057, 18.756530761718864],
          [72.867637634277457, 18.756530761718864],
          [72.867637634277457, 18.75681114196783],
          [72.867362976074276, 18.756805419921875],
          [72.867362976074276, 18.757085800170842],
          [72.867080688476506, 18.757080078125057],
          [72.867080688476506, 18.757640838623047],
          [72.866806030273665, 18.757640838623047],
          [72.866806030273665, 18.758750915527401],
          [72.866249084472713, 18.758750915527401],
          [72.866249084472713, 18.759309768676758],
          [72.865974426269702, 18.759304046630973],
          [72.865974426269702, 18.759582519531364],
          [72.865692138672159, 18.75958061218256],
          [72.865692138672159, 18.760139465332145],
          [72.86541748046875, 18.760139465332145],
          [72.86541748046875, 18.760694503784293],
          [72.865135192871378, 18.760694503784293],
          [72.865135192871378, 18.761249542236271],
          [72.864860534667969, 18.761240005493164],
          [72.864860534667969, 18.762638092041016],
          [72.864585876464957, 18.762638092041016],
          [72.864585876464957, 18.763200759887752],
          [72.864860534667969, 18.763195037841797],
          [72.864860534667969, 18.764583587646541],
          [72.864585876464957, 18.764579772949162],
          [72.864585876464957, 18.766532897949219],
          [72.864295959472713, 18.766532897949219],
          [72.864295959472713, 18.767370223999137],
          [72.86541748046875, 18.767362594604606],
          [72.86541748046875, 18.768192291259822],
          [72.865135192871378, 18.768192291259822],
          [72.865135192871378, 18.768474578857536],
          [72.864860534667969, 18.768472671508789],
          [72.864860534667969, 18.76875114440918],
          [72.864585876464957, 18.76875114440918],
          [72.864585876464957, 18.76902961730957],
          [72.864295959472713, 18.76902961730957],
          [72.864295959472713, 18.769309997558707],
          [72.864028930664006, 18.769306182861328],
          [72.864028930664006, 18.769584655761719],
          [72.863746643066463, 18.769580841064567],
          [72.863746643066463, 18.770139694213924],
          [72.863471984863452, 18.770139694213924],
          [72.863471984863452, 18.770694732666072],
          [72.863197326660213, 18.770690917968693],
          [72.863197326660213, 18.771249771118278],
          [72.863471984863452, 18.771249771118278],
          [72.863471984863452, 18.772640228271598],
          [72.863197326660213, 18.772638320922795],
          [72.863197326660213, 18.773471832275391],
          [72.863471984863452, 18.773469924926758],
          [72.863471984863452, 18.774030685424918],
          [72.863197326660213, 18.774026870727539],
          [72.863197326660213, 18.77458381652832],
          [72.863471984863452, 18.774580001831112],
          [72.863471984863452, 18.777921676635742],
          [72.863197326660213, 18.777915954589957],
          [72.863197326660213, 18.778472900390739],
          [72.863471984863452, 18.778472900390739],
          [72.863471984863452, 18.77985954284668],
          [72.863197326660213, 18.77985954284668],
          [72.863197326660213, 18.78042030334484],
          [72.863471984863452, 18.78042030334484],
          [72.863471984863452, 18.781251907348633],
          [72.863746643066463, 18.781251907348633],
          [72.863746643066463, 18.781810760498161],
          [72.863471984863452, 18.781810760498161],
          [72.863471984863452, 18.784030914306697],
          [72.863197326660213, 18.784030914306697],
          [72.863197326660213, 18.784860610961914],
          [72.863471984863452, 18.784860610961914],
          [72.863471984863452, 18.791248321533203],
          [72.863746643066463, 18.791248321533203],
          [72.863746643066463, 18.793470382690543],
          [72.864036560058537, 18.793470382690543],
          [72.864036560058537, 18.794309616088867],
          [72.864295959472713, 18.794309616088867],
          [72.864295959472713, 18.795419692993221],
          [72.864585876464957, 18.795415878296012],
          [72.864585876464957, 18.795974731445369],
          [72.864860534667969, 18.795972824096793],
          [72.864860534667969, 18.796529769897575],
          [72.865142822265909, 18.796529769897575],
          [72.865142822265909, 18.796810150146541],
          [72.866531372070483, 18.796806335449162],
          [72.866531372070483, 18.797084808349723],
          [72.867080688476506, 18.797084808349723],
          [72.867080688476506, 18.797361373901367],
          [72.867362976074276, 18.797349929809627],
          [72.867362976074276, 18.797920227050895],
          [72.867637634277457, 18.797920227050895],
          [72.867637634277457, 18.798749923706112],
          [72.867919921875057, 18.798749923706112],
          [72.867919921875057, 18.800140380859432],
          [72.868186950683878, 18.800140380859432],
          [72.868186950683878, 18.801811218261719],
          [72.86846923828125, 18.801811218261719],
          [72.86846923828125, 18.802360534667969],
          [72.86875152587919, 18.802360534667969],
          [72.86875152587919, 18.803749084472656],
          [72.869026184082202, 18.803749084472656],
          [72.869026184082202, 18.804311752319393],
          [72.869308471679744, 18.804306030273438],
          [72.869308471679744, 18.804582595825252],
          [72.869583129882983, 18.804582595825252],
          [72.869583129882983, 18.804306030273438],
          [72.870697021484489, 18.804311752319393],
          [72.870697021484489, 18.804031372070426],
          [72.870971679687557, 18.804031372070426],
          [72.870971679687557, 18.803478240966854],
          [72.871246337890909, 18.803478240966854],
          [72.871246337890909, 18.802917480468693],
          [72.871528625488281, 18.802917480468693],
          [72.871528625488281, 18.802640914917106],
          [72.87180328369169, 18.802640914917106],
          [72.87180328369169, 18.802360534667969],
          [72.872360229492244, 18.802360534667969],
          [72.872360229492244, 18.802080154418945],
          [72.873191833496037, 18.802083969116325],
          [72.873191833496037, 18.801805496215934],
          [72.876808166503849, 18.801805496215934],
          [72.876808166503849, 18.802083969116325],
          [72.877250671386719, 18.802082061767578],
          [72.877639770507813, 18.802080154418945],
          [72.877639770507813, 18.802360534667969],
          [72.878471374512003, 18.802360534667969],
          [72.878471374512003, 18.802640914917106],
          [72.879035949707088, 18.802640914917106],
          [72.879035949707088, 18.802917480468693],
          [72.879302978515796, 18.802917480468693],
          [72.879302978515796, 18.803194046020508],
          [72.879859924316349, 18.803190231323299],
          [72.879859924316349, 18.803478240966854],
          [72.880416870117301, 18.803478240966854],
          [72.880416870117301, 18.803749084472656],
          [72.880691528320312, 18.803749084472656],
          [72.880691528320312, 18.804031372070426],
          [72.881248474121094, 18.804031372070426],
          [72.881248474121094, 18.804311752319393],
          [72.881530761719034, 18.804306030273438],
          [72.881530761719034, 18.804582595825252],
          [72.882080078125057, 18.804580688476676],
          [72.882080078125057, 18.80485916137701],
          [72.882637023926009, 18.80485916137701],
          [72.882637023926009, 18.804311752319393],
          [72.882919311523381, 18.804311752319393],
          [72.882919311523381, 18.804031372070426],
          [72.885971069335881, 18.804031372070426],
          [72.885971069335881, 18.803749084472656],
          [72.887077331543253, 18.803749084472656],
          [72.887077331543253, 18.803478240966854],
          [72.887641906738565, 18.803478240966854],
          [72.887641906738565, 18.802917480468693],
          [72.887916564941577, 18.802917480468693],
          [72.887916564941577, 18.802080154418945],
          [72.887641906738565, 18.802083969116325],
          [72.887641906738565, 18.801528930664176],
          [72.887359619140625, 18.801530838012752],
          [72.887359619140625, 18.801250457763786],
          [72.887077331543253, 18.801250457763786],
          [72.887077331543253, 18.800701141357536],
          [72.886802673339901, 18.800689697265625],
          [72.886802673339901, 18.799861907959041],
          [72.887084960937784, 18.799861907959041],
          [72.887084960937784, 18.799730300903263],
          [72.887084960937784, 18.799583435058651],
          [72.887359619140625, 18.799583435058651],
          [72.887359619140625, 18.798196792602482],
          [72.888191223144588, 18.798191070556754],
          [72.888191223144588, 18.798749923706112],
          [72.891807556152401, 18.798749923706112],
          [72.891807556152401, 18.799030303955078],
          [72.892639160156193, 18.799030303955078],
          [72.892639160156193, 18.799310684204215],
          [72.893196105957145, 18.799306869506836],
          [72.893196105957145, 18.799583435058651],
          [72.894027709960937, 18.799583435058651],
          [72.894027709960937, 18.799861907959041],
          [72.894577026367358, 18.799860000610465],
          [72.894577026367358, 18.800140380859432],
          [72.895141601562671, 18.800138473510799],
          [72.895141601562671, 18.80041694641119],
          [72.895416259765852, 18.80041694641119],
          [72.895416259765852, 18.800693511963004],
          [72.895973205566463, 18.800693511963004],
          [72.895973205566463, 18.800971984863395],
          [72.896530151367244, 18.800970077514592],
          [72.896530151367244, 18.801811218261719],
          [72.897079467773438, 18.801811218261719],
          [72.897079467773438, 18.801530838012752],
          [72.897918701171932, 18.801530838012752],
          [72.897918701171932, 18.801250457763786],
          [72.898193359375171, 18.801250457763786],
          [72.898193359375171, 18.801530838012752],
          [72.898475646972884, 18.801528930664176],
          [72.898475646972884, 18.802083969116325],
          [72.898750305175724, 18.802083969116325],
          [72.898750305175724, 18.803194046020508],
          [72.899017333984432, 18.803190231323299],
          [72.899017333984432, 18.803478240966854],
          [72.899581909179744, 18.803478240966854],
          [72.899581909179744, 18.803749084472656],
          [72.899856567383097, 18.803749084472656],
          [72.899856567383097, 18.804031372070426],
          [72.900695800781421, 18.804031372070426],
          [72.900695800781421, 18.803749084472656],
          [72.900970458984432, 18.803749084472656],
          [72.900970458984432, 18.803478240966854],
          [72.901252746582202, 18.803478240966854],
          [72.901252746582202, 18.803190231323299],
          [72.901527404785384, 18.803194046020508],
          [72.901527404785384, 18.802917480468693],
          [72.902641296386776, 18.802917480468693],
          [72.902641296386776, 18.802640914917106],
          [72.902915954590128, 18.802640914917106],
          [72.902915954590128, 18.802360534667969],
          [72.903190612792969, 18.802360534667969],
          [72.903205871582088, 18.802080154418945],
          [72.903747558593921, 18.802083969116325],
          [72.903747558593921, 18.801805496215934],
          [72.90402984619169, 18.801811218261719],
          [72.90402984619169, 18.801530838012752],
          [72.904296875000171, 18.801530838012752],
          [72.904296875000171, 18.801250457763786],
          [72.904586791992244, 18.801250457763786],
          [72.904586791992244, 18.800970077514592],
          [72.904861450195483, 18.800971984863395],
          [72.904861450195483, 18.800693511963004],
          [72.905136108398494, 18.800693511963004],
          [72.905136108398494, 18.80041694641119],
          [72.905418395996037, 18.80041694641119],
          [72.905418395996037, 18.799583435058651],
          [72.905693054199276, 18.799583435058651],
          [72.905693054199276, 18.799390792846793],
          [72.905693054199276, 18.798749923706112],
          [72.905418395996037, 18.798749923706112],
          [72.905418395996037, 18.797639846801758],
          [72.905136108398494, 18.797639846801758],
          [72.905136108398494, 18.796529769897575],
          [72.905418395996037, 18.796529769897575],
          [72.905418395996037, 18.795419692993221],
          [72.905693054199276, 18.795419692993221],
          [72.905693054199276, 18.79458045959467],
          [72.90625, 18.79458045959467],
          [72.90625, 18.794305801391658],
          [72.906517028808878, 18.794309616088867],
          [72.906517028808878, 18.794031143188477],
          [72.90708160400419, 18.794031143188477],
          [72.90708160400419, 18.793752670288086],
          [72.907638549804744, 18.793752670288086],
          [72.907638549804744, 18.793470382690543],
          [72.908195495605696, 18.793470382690543],
          [72.908195495605696, 18.793193817138729],
          [72.908470153808537, 18.793193817138729],
          [72.908470153808537, 18.792917251586914],
          [72.909019470215128, 18.792921066284293],
          [72.909019470215128, 18.792642593383903],
          [72.909576416015909, 18.792642593383903],
          [72.909576416015909, 18.79236030578619],
          [72.910697937011776, 18.79236030578619],
          [72.910697937011776, 18.792079925537166],
          [72.914306640625227, 18.792079925537166],
          [72.914306640625227, 18.79236030578619],
          [72.915122985840128, 18.79236030578619],
          [72.916252136230753, 18.79236030578619],
          [72.916252136230753, 18.792642593383903],
          [72.916809082031534, 18.792642593383903],
          [72.916809082031534, 18.792921066284293],
          [72.917083740234546, 18.792917251586914],
          [72.917083740234546, 18.793193817138729],
          [72.917358398437727, 18.793193817138729],
          [72.917358398437727, 18.793470382690543],
          [72.917915344238338, 18.793470382690543],
          [72.917915344238338, 18.793752670288086],
          [72.918212890625171, 18.793752670288086],
          [72.918212890625171, 18.794031143188477],
          [72.918472290039119, 18.794031143188477],
          [72.918472290039119, 18.794309616088867],
          [72.919029235839844, 18.794305801391658],
          [72.919029235839844, 18.79458045959467],
          [72.919296264648722, 18.79458045959467],
          [72.919296264648722, 18.79486274719244],
          [72.919586181640625, 18.79486274719244],
          [72.919586181640625, 18.795419692993221],
          [72.920135498047046, 18.795415878296012],
          [72.920135498047046, 18.795692443847656],
          [72.920417785644588, 18.795692443847656],
          [72.920417785644588, 18.795974731445369],
          [72.920692443847827, 18.795972824096793],
          [72.920692443847827, 18.796249389648381],
          [72.920959472656307, 18.796249389648381],
          [72.920959472656307, 18.796529769897575],
          [72.921249389648381, 18.796529769897575],
          [72.921249389648381, 18.796810150146541],
          [72.921524047851619, 18.796806335449162],
          [72.921524047851619, 18.797084808349723],
          [72.921806335449332, 18.797084808349723],
          [72.921806335449332, 18.797361373901367],
          [72.922080993652344, 18.797349929809627],
          [72.922080993652344, 18.797639846801758],
          [72.922363281250284, 18.797639846801758],
          [72.922363281250284, 18.797920227050895],
          [72.922637939453125, 18.797916412353516],
          [72.922637939453125, 18.798471450805721],
          [72.922920227051065, 18.798469543457088],
          [72.922920227051065, 18.798749923706112],
          [72.923187255859546, 18.798749923706112],
          [72.923187255859546, 18.799030303955078],
          [72.923469543457088, 18.799030303955078],
          [72.923469543457088, 18.799310684204215],
          [72.923751831054858, 18.799306869506836],
          [72.923751831054858, 18.799861907959041],
          [72.92402648925804, 18.799860000610465],
          [72.92402648925804, 18.800140380859432],
          [72.924308776855412, 18.800138473510799],
          [72.924308776855412, 18.80041694641119],
          [72.924583435058651, 18.80041694641119],
          [72.924583435058651, 18.800971984863395],
          [72.924858093261832, 18.800970077514592],
          [72.924858093261832, 18.801250457763786],
          [72.925140380859432, 18.801250457763786],
          [72.925140380859432, 18.801530838012752],
          [72.925422668457315, 18.801530838012752],
          [72.925422668457315, 18.801811218261719],
          [72.925697326660156, 18.801805496215934],
          [72.925697326660156, 18.802083969116325],
          [72.925971984863565, 18.802080154418945],
          [72.925971984863565, 18.802360534667969],
          [72.926246643066577, 18.802360534667969],
          [72.926246643066577, 18.802640914917106],
          [72.926528930664119, 18.802637100219727],
          [72.926528930664119, 18.803194046020508],
          [72.926795959472827, 18.803190231323299],
          [72.926795959472827, 18.803478240966854],
          [72.927085876465071, 18.803478240966854],
          [72.927085876465071, 18.803749084472656],
          [72.927360534667912, 18.803749084472656],
          [72.927360534667912, 18.804031372070426],
          [72.927642822265682, 18.804031372070426],
          [72.927642822265682, 18.804311752319393],
          [72.927917480468864, 18.804306030273438],
          [72.927917480468864, 18.804582595825252],
          [72.928192138671932, 18.804580688476676],
          [72.928192138671932, 18.805141448974609],
          [72.928474426269815, 18.805141448974609],
          [72.928474426269815, 18.805694580078182],
          [72.929031372070597, 18.805690765380803],
          [72.929031372070597, 18.806249618530387],
          [72.929306030273608, 18.806249618530387],
          [72.929306030273608, 18.808200836181641],
          [72.929580688476619, 18.808200836181641],
          [72.929580688476619, 18.809030532837028],
          [72.929862976074389, 18.809028625488224],
          [72.929862976074389, 18.80958366394043],
          [72.930152893066463, 18.809579849243221],
          [72.930152893066463, 18.810140609741211],
          [72.930694580078182, 18.810138702392578],
          [72.930694580078182, 18.810972213745174],
          [72.930969238281364, 18.810970306396598],
          [72.930969238281364, 18.811809539794922],
          [72.931251525878963, 18.811809539794922],
          [72.931251525878963, 18.812641143798885],
          [72.931526184082315, 18.812639236450309],
          [72.931526184082315, 18.813194274902457],
          [72.931808471679688, 18.813190460205078],
          [72.931808471679688, 18.813751220703239],
          [72.932083129883097, 18.813751220703239],
          [72.932083129883097, 18.81430816650402],
          [72.932357788086108, 18.814306259155217],
          [72.932357788086108, 18.814861297607422],
          [72.932640075683878, 18.814859390258789],
          [72.932640075683878, 18.815139770507812],
          [72.932899475097827, 18.815139770507812],
          [72.932899475097827, 18.815418243408146],
          [72.933197021484432, 18.81541633605957],
          [72.933197021484432, 18.815694808959961],
          [72.933471679687671, 18.815690994262809],
          [72.933471679687671, 18.816249847412166],
          [72.933746337890682, 18.816249847412166],
          [72.933746337890682, 18.817083358764705],
          [72.934028625488224, 18.817079544067326],
          [72.934028625488224, 18.817920684814453],
          [72.934303283691463, 18.817920684814453],
          [72.934303283691463, 18.818752288818416],
          [72.934593200683707, 18.818752288818416],
          [72.934593200683707, 18.819311141967773],
          [72.934860229492188, 18.819311141967773],
          [72.934860229492188, 18.820142745971737],
          [72.935142517090128, 18.820140838623161],
          [72.935142517090128, 18.820970535278377],
          [72.935417175292969, 18.820970535278377],
          [72.935417175292969, 18.821527481079102],
          [72.935691833496378, 18.821521759033146],
          [72.935691833496378, 18.822362899780273],
          [72.935974121093921, 18.822362899780273],
          [72.935974121093921, 18.823194503784237],
          [72.936248779296932, 18.823190689086857],
          [72.936248779296932, 18.823749542236442],
          [72.936531066894702, 18.823749542236442],
          [72.936531066894702, 18.824291229248104],
          [72.936805725097884, 18.824306488037166],
          [72.936805725097884, 18.824861526489371],
          [72.937080383300724, 18.824859619140568],
          [72.937080383300724, 18.825139999389762],
          [72.937362670898494, 18.825139999389762],
          [72.937362670898494, 18.825700759887695],
          [72.937637329101676, 18.825696945190487],
          [72.937637329101676, 18.825971603393555],
          [72.937919616699276, 18.825969696044922],
          [72.937919616699276, 18.826250076293945],
          [72.938186645508097, 18.826250076293945],
          [72.938186645508097, 18.826530456543082],
          [72.938468933105469, 18.826528549194279],
          [72.938468933105469, 18.827083587646484],
          [72.939025878906421, 18.827079772949276],
          [72.939025878906421, 18.827360153198299],
          [72.939315795898722, 18.827360153198299],
          [72.939308166503963, 18.827083587646484],
          [72.939857482910384, 18.827079772949276],
          [72.939857482910384, 18.827360153198299],
          [72.940696716308707, 18.827360153198299],
          [72.940696716308707, 18.827920913696403],
          [72.943466186523494, 18.827920913696403],
          [72.943466186523494, 18.827079772949276],
          [72.943748474121207, 18.827083587646484],
          [72.943748474121207, 18.826250076293945],
          [72.944030761718807, 18.826250076293945],
          [72.944030761718807, 18.825420379638729],
          [72.94431304931652, 18.825420379638729],
          [72.94431304931652, 18.824581146240234],
          [72.944580078125, 18.824583053588981],
          [72.944580078125, 18.823749542236442],
          [72.94486236572294, 18.823749542236442],
          [72.94486236572294, 18.823190689086857],
          [72.945137023925952, 18.823194503784237],
          [72.945137023925952, 18.822362899780273],
          [72.945419311523722, 18.822362899780273],
          [72.945419311523722, 18.822080612182731],
          [72.945968627929915, 18.822084426879883],
          [72.945968627929915, 18.821805953979492],
          [72.946533203125227, 18.821809768676871],
          [72.946533203125227, 18.820690155029354],
          [72.947082519531307, 18.820692062377987],
          [72.947082519531307, 18.820417404174748],
          [72.947357177734659, 18.820421218872127],
          [72.947357177734659, 18.820142745971737],
          [72.947639465332031, 18.820142745971737],
          [72.947639465332031, 18.819860458374023],
          [72.947906494140909, 18.819860458374023],
          [72.947906494140909, 18.819580078125],
          [72.948196411132812, 18.819583892822379],
          [72.948196411132812, 18.819305419921989],
          [72.948471069336222, 18.819311141967773],
          [72.948471069336222, 18.819032669067383],
          [72.948753356933764, 18.819032669067383],
          [72.948753356933764, 18.818752288818416],
          [72.949028015136776, 18.818752288818416],
          [72.949028015136776, 18.818199157714844],
          [72.949302673340014, 18.818199157714844],
          [72.949302673340014, 18.817920684814453],
          [72.949577331543026, 18.817920684814453],
          [72.949577331543026, 18.81735992431652],
          [72.949859619140568, 18.817361831665096],
          [72.949859619140568, 18.816804885864315],
          [72.950141906738338, 18.816804885864315],
          [72.950141906738338, 18.816249847412166],
          [72.95041656494152, 18.816249847412166],
          [72.95041656494152, 18.815690994262809],
          [72.950691223144531, 18.815694808959961],
          [72.950691223144531, 18.814861297607422],
          [72.950973510742472, 18.814861297607422],
          [72.950973510742472, 18.814306259155217],
          [72.951255798339844, 18.81430816650402],
          [72.951255798339844, 18.813751220703239],
          [72.951530456543253, 18.813751220703239],
          [72.951530456543253, 18.813190460205078],
          [72.951805114746264, 18.813194274902457],
          [72.951805114746264, 18.812360763549918],
          [72.952079772949276, 18.812360763549918],
          [72.952079772949276, 18.811805725097713],
          [72.952362060547046, 18.811809539794922],
          [72.952362060547046, 18.811250686645565],
          [72.952636718750227, 18.811250686645565],
          [72.952636718750227, 18.810689926147404],
          [72.952919006347599, 18.810695648193359],
          [72.952919006347599, 18.810138702392578],
          [72.953186035156307, 18.810140609741211],
          [72.953186035156307, 18.809579849243221],
          [72.953475952148551, 18.80958366394043],
          [72.953475952148551, 18.809028625488224],
          [72.953750610351619, 18.809030532837028],
          [72.953750610351619, 18.808469772338867],
          [72.954025268554972, 18.808473587036246],
          [72.954025268554972, 18.807916641235295],
          [72.954322814941463, 18.807920455932674],
          [72.954322814941463, 18.807359695434513],
          [72.954582214355753, 18.807363510131893],
          [72.954582214355753, 18.806804656982536],
          [72.954864501953296, 18.806804656982536],
          [72.954864501953296, 18.806249618530387],
          [72.955139160156307, 18.806249618530387],
          [72.955139160156307, 18.805690765380803],
          [72.955413818359546, 18.805694580078182],
          [72.955413818359546, 18.805141448974609],
          [72.955696105957259, 18.805141448974609],
          [72.955696105957259, 18.804580688476676],
          [72.955970764160099, 18.804582595825252],
          [72.955970764160099, 18.804027557373047],
          [72.956253051757869, 18.804031372070426],
          [72.956253051757869, 18.803478240966854],
          [72.956527709961051, 18.803478240966854],
          [72.956527709961051, 18.802917480468693],
          [72.956802368164119, 18.802917480468693],
          [72.956802368164119, 18.802360534667969],
          [72.95706939697294, 18.802360534667969],
          [72.95706939697294, 18.801811218261719],
          [72.957359313964844, 18.801811218261719],
          [72.957359313964844, 18.801250457763786],
          [72.957641601562784, 18.801250457763786],
          [72.957641601562784, 18.800970077514592],
          [72.957916259765796, 18.800971984863395],
          [72.957916259765796, 18.800693511963004],
          [72.958190917968807, 18.800693511963004],
          [72.958190917968807, 18.80041694641119],
          [72.958473205566577, 18.80041694641119],
          [72.958473205566577, 18.799861907959041],
          [72.958747863769759, 18.799861907959041],
          [72.958747863769759, 18.799583435058651],
          [72.959030151367358, 18.799583435058651],
          [72.959030151367358, 18.799306869506836],
          [72.959297180175838, 18.799310684204215],
          [72.959297180175838, 18.799030303955078],
          [72.959587097167912, 18.799030303955078],
          [72.959587097167912, 18.798749923706112],
          [72.959861755371151, 18.798749923706112],
          [72.959861755371151, 18.798469543457088],
          [72.960136413574503, 18.798471450805721],
          [72.960136413574503, 18.798196792602482],
          [72.960418701171875, 18.798196792602482],
          [72.960418701171875, 18.797637939453125],
          [72.960693359375284, 18.797639846801758],
          [72.960693359375284, 18.797349929809627],
          [72.960975646972656, 18.797361373901367],
          [72.960975646972656, 18.797084808349723],
          [72.961250305176065, 18.797084808349723],
          [72.961250305176065, 18.796806335449162],
          [72.961517333984546, 18.796810150146541],
          [72.961517333984546, 18.796529769897575],
          [72.961807250976619, 18.796529769897575],
          [72.961807250976619, 18.796249389648381],
          [72.962081909179858, 18.796249389648381],
          [72.962081909179858, 18.795972824096793],
          [72.962364196777571, 18.795974731445369],
          [72.962364196777571, 18.795692443847656],
          [72.962638854980412, 18.795692443847656],
          [72.962638854980412, 18.795415878296012],
          [72.962905883789119, 18.795419692993221],
          [72.962905883789119, 18.79514122009283],
          [72.963195800781364, 18.79514122009283],
          [72.963195800781364, 18.79486274719244],
          [72.963470458984375, 18.79486274719244],
          [72.963470458984375, 18.79458045959467],
          [72.963752746582315, 18.79458045959467],
          [72.963752746582315, 18.794305801391658],
          [72.964302062988565, 18.794309616088867],
          [72.964302062988565, 18.794031143188477],
          [72.964576721191577, 18.794031143188477],
          [72.964576721191577, 18.793752670288086],
          [72.964859008789119, 18.793752670288086],
          [72.964859008789119, 18.793470382690543],
          [72.965415954590071, 18.793470382690543],
          [72.965415954590071, 18.793193817138729],
          [72.965690612792912, 18.793193817138729],
          [72.965698242187443, 18.792917251586914],
          [72.965972900390682, 18.792921066284293],
          [72.965972900390682, 18.792642593383903],
          [72.966529846191463, 18.792642593383903],
          [72.966529846191463, 18.79236030578619],
          [72.966796875000284, 18.79236030578619],
          [72.966796875000284, 18.792079925537166],
          [72.967361450195597, 18.792083740234375],
          [72.967361450195597, 18.791805267333984],
          [72.967636108398608, 18.791809082031364],
          [72.967636108398608, 18.79154014587408],
          [72.968193054199389, 18.79154014587408],
          [72.968193054199389, 18.791248321533203],
          [72.968482971191463, 18.791248321533203],
          [72.968475341797102, 18.790971755981445],
          [72.969024658203182, 18.790971755981445],
          [72.969024658203182, 18.790695190429801],
          [72.969299316406364, 18.790700912475586],
          [72.969299316406364, 18.790420532226619],
          [72.969856262207315, 18.790420532226619],
          [72.969856262207315, 18.790138244628849],
          [72.970413208008097, 18.790138244628849],
          [72.970413208008097, 18.789859771728459],
          [72.971252441406421, 18.789859771728459],
          [72.971252441406421, 18.790138244628849],
          [72.971527099609602, 18.790138244628849],
          [72.971527099609602, 18.790420532226619],
          [72.971801757812443, 18.79041671752924],
          [72.971809387207202, 18.790849685669002],
          [72.971809387207202, 18.790971755981445],
          [72.972068786621151, 18.790969848632812],
          [72.972068786621151, 18.79154014587408],
          [72.972358703613395, 18.791530609130973],
          [72.972358703613395, 18.792083740234375],
          [72.972640991210994, 18.792079925537166],
          [72.972640991210994, 18.792642593383903],
          [72.972923278808707, 18.792642593383903],
          [72.972923278808707, 18.792921066284293],
          [72.973197937011719, 18.792917251586914],
          [72.973197937011719, 18.793470382690543],
          [72.973472595215128, 18.793470382690543],
          [72.973472595215128, 18.794031143188477],
          [72.973747253418139, 18.794027328491268],
          [72.973747253418139, 18.79458045959467],
          [72.974029541015909, 18.79458045959467],
          [72.974029541015909, 18.79486274719244],
          [72.974296569824389, 18.79486274719244],
          [72.974296569824389, 18.795419692993221],
          [72.974586486816463, 18.795415878296012],
          [72.974586486816463, 18.795974731445369],
          [72.974861145019702, 18.795972824096793],
          [72.974861145019702, 18.796529769897575],
          [72.975135803222713, 18.796527862548771],
          [72.975135803222713, 18.797084808349723],
          [72.975418090820256, 18.797084808349723],
          [72.975418090820256, 18.797361373901367],
          [72.975692749023494, 18.797349929809627],
          [72.975692749023494, 18.797920227050895],
          [72.975975036621207, 18.797916412353516],
          [72.975975036621207, 18.798471450805721],
          [72.976249694824219, 18.798469543457088],
          [72.976249694824219, 18.799030303955078],
          [72.976516723633097, 18.799030303955078],
          [72.976516723633097, 18.799310684204215],
          [72.976806640625, 18.799306869506836],
          [72.976806640625, 18.799583435058651],
          [72.977081298828409, 18.799583435058651],
          [72.977081298828409, 18.799861907959041],
          [72.976806640625, 18.799861907959041],
          [72.976806640625, 18.800689697265625],
          [72.976516723633097, 18.800701141357536],
          [72.976516723633097, 18.801530838012752],
          [72.976249694824219, 18.801528930664176],
          [72.976249694824219, 18.802083969116325],
          [72.975982666015739, 18.802080154418945],
          [72.975982666015739, 18.802917480468693],
          [72.975692749023494, 18.802917480468693],
          [72.975692749023494, 18.803749084472656],
          [72.975982666015739, 18.803749084472656],
          [72.975982666015739, 18.804311752319393],
          [72.976524353027628, 18.804306030273438],
          [72.976524353027628, 18.804582595825252],
          [72.976806640625, 18.804580688476676],
          [72.976806640625, 18.80485916137701],
          [72.977081298828409, 18.80485916137701],
          [72.977081298828409, 18.805141448974609],
          [72.978469848632756, 18.805141448974609],
          [72.978469848632756, 18.80485916137701],
          [72.979309082031307, 18.80485916137701],
          [72.979309082031307, 18.804580688476676],
          [72.979576110840128, 18.804580688476676],
          [72.979576110840128, 18.80485916137701],
          [72.9798583984375, 18.80485916137701],
          [72.9798583984375, 18.805421829223746],
          [72.98014068603544, 18.805416107177791],
          [72.98014068603544, 18.805971145629996],
          [72.980415344238452, 18.805971145629996],
          [72.980415344238452, 18.806249618530387],
          [72.980697631835994, 18.806249618530387],
          [72.980697631835994, 18.806804656982536],
          [72.980972290039233, 18.806804656982536],
          [72.980972290039233, 18.807363510131893],
          [72.981239318847713, 18.807359695434513],
          [72.981239318847713, 18.807920455932674],
          [72.981529235839787, 18.807920455932674],
          [72.981529235839787, 18.808200836181641],
          [72.981796264648494, 18.808200836181641],
          [72.981796264648494, 18.808750152587891],
          [72.982086181640739, 18.808750152587891],
          [72.982086181640739, 18.809310913085994],
          [72.982360839843807, 18.809303283691463],
          [72.982360839843807, 18.80958366394043],
          [72.98264312744169, 18.809579849243221],
          [72.98264312744169, 18.810140609741211],
          [72.982360839843807, 18.810140609741211],
          [72.982360839843807, 18.810420989990348],
          [72.982086181640739, 18.810417175292969],
          [72.982086181640739, 18.810695648193359],
          [72.981796264648494, 18.810689926147404],
          [72.981796264648494, 18.811250686645565],
          [72.981529235839787, 18.811250686645565],
          [72.981529235839787, 18.811531066894531],
          [72.981246948242415, 18.811527252197322],
          [72.981246948242415, 18.812084197998104],
          [72.980972290039233, 18.812080383300724],
          [72.980972290039233, 18.812919616699276],
          [72.980697631835994, 18.812919616699276],
          [72.980697631835994, 18.813751220703239],
          [72.980415344238452, 18.813749313354435],
          [72.980415344238452, 18.814582824707031],
          [72.98014068603544, 18.814580917358455],
          [72.98014068603544, 18.815418243408146],
          [72.9798583984375, 18.81541633605957],
          [72.9798583984375, 18.817083358764705],
          [72.979583740234659, 18.817083358764705],
          [72.979583740234659, 18.822084426879883],
          [72.9798583984375, 18.822080612182731],
          [72.9798583984375, 18.822639465332088],
          [72.98014068603544, 18.822639465332088],
          [72.98014068603544, 18.823194503784237],
          [72.980415344238452, 18.823194503784237],
          [72.980415344238452, 18.823749542236442],
          [72.980697631835994, 18.823749542236442],
          [72.980697631835994, 18.824291229248104],
          [72.980972290039233, 18.824306488037166],
          [72.980972290039233, 18.824861526489371],
          [72.981239318847713, 18.824859619140568],
          [72.981239318847713, 18.825420379638729],
          [72.981529235839787, 18.825420379638729],
          [72.981529235839787, 18.825700759887695],
          [72.981796264648494, 18.825700759887695],
          [72.981796264648494, 18.826250076293945],
          [72.982086181640739, 18.826250076293945],
          [72.982086181640739, 18.826530456543082],
          [72.982360839843807, 18.826530456543082],
          [72.982360839843807, 18.826810836792049],
          [72.982635498047159, 18.826805114746094],
          [72.982635498047159, 18.827360153198299],
          [72.982917785644531, 18.827360153198299],
          [72.982917785644531, 18.827640533447266],
          [72.98319244384794, 18.827640533447266],
          [72.98319244384794, 18.827920913696403],
          [72.983474731445483, 18.827917098999023],
          [72.983474731445483, 18.828472137451229],
          [72.983749389648494, 18.828470230102653],
          [72.983749389648494, 18.828750610351619],
          [72.983467102050952, 18.828750610351619],
          [72.983467102050952, 18.82902908325201],
          [72.98319244384794, 18.82902908325201],
          [72.98319244384794, 18.829307556152344],
          [72.982917785644531, 18.829307556152344],
          [72.982917785644531, 18.829860687255973],
          [72.982635498047159, 18.829860687255973],
          [72.982635498047159, 18.830694198608512],
          [72.982917785644531, 18.830694198608512],
          [72.982917785644531, 18.832082748413086],
          [72.98319244384794, 18.832082748413086],
          [72.98319244384794, 18.833194732666016],
          [72.983467102050952, 18.833190917968864],
          [72.983467102050952, 18.834030151367188],
          [72.98319244384794, 18.834030151367188],
          [72.98319244384794, 18.835700988769645],
          [72.982917785644531, 18.835700988769645],
          [72.982917785644531, 18.836811065673828],
          [72.982635498047159, 18.836805343628043],
          [72.98264312744169, 18.837360382080078],
          [72.982360839843807, 18.837360382080078],
          [72.982360839843807, 18.837921142578182],
          [72.982086181640739, 18.837917327880803],
          [72.982086181640739, 18.838472366333008],
          [72.981796264648494, 18.838470458984432],
          [72.981796264648494, 18.838750839233398],
          [72.982086181640739, 18.838750839233398],
          [72.982086181640739, 18.841249465942496],
          [72.981803894043026, 18.841249465942496],
          [72.981803894043026, 18.842361450195426],
          [72.981529235839787, 18.842361450195426],
          [72.981529235839787, 18.843471527099609],
          [72.981246948242415, 18.843471527099609],
          [72.981246948242415, 18.844860076904354],
          [72.980972290039233, 18.844860076904354],
          [72.980972290039233, 18.845970153808707],
          [72.980697631835994, 18.845970153808707],
          [72.980697631835994, 18.84669113159174],
          [72.980697631835994, 18.847082138061637],
          [72.980819702148438, 18.847082138061637],
          [72.980972290039233, 18.847082138061637],
          [72.980972290039233, 18.847600936889705],
          [72.980972290039233, 18.84819221496582],
          [72.981246948242415, 18.84819221496582],
          [72.981239318847713, 18.848518371582031],
          [72.981239318847713, 18.848751068115348],
          [72.980972290039233, 18.848751068115348],
          [72.980972290039233, 18.849309921264705],
          [72.980697631835994, 18.849306106567326],
          [72.980697631835994, 18.85069465637207],
          [72.980972290039233, 18.85069465637207],
          [72.980972290039233, 18.852083206176815],
          [72.981246948242415, 18.852083206176815],
          [72.981246948242415, 18.852361679077205],
          [72.981529235839787, 18.852359771728629],
          [72.981529235839787, 18.852640151977596],
          [72.981796264648494, 18.852640151977596],
          [72.981796264648494, 18.8532009124757],
          [72.982086181640739, 18.853195190429744],
          [72.982086181640739, 18.853471755981559],
          [72.982360839843807, 18.853469848632756],
          [72.982360839843807, 18.85375022888195],
          [72.98264312744169, 18.85375022888195],
          [72.98264312744169, 18.854310989379883],
          [72.982917785644531, 18.854310989379883],
          [72.982917785644531, 18.854589462280273],
          [72.98319244384794, 18.854589462280273],
          [72.98319244384794, 18.85514068603527],
          [72.983467102050952, 18.85514068603527],
          [72.983467102050952, 18.855421066284237],
          [72.983749389648494, 18.855417251586857],
          [72.983749389648494, 18.855972290039063],
          [72.984008789062443, 18.855970382690487],
          [72.984008789062443, 18.856250762939453],
          [72.984298706054915, 18.856250762939453],
          [72.984298706054915, 18.856809616088981],
          [72.984580993652287, 18.856805801391602],
          [72.984580993652287, 18.857082366943416],
          [72.984863281250057, 18.85708045959484],
          [72.984863281250057, 18.857652664184684],
          [72.985137939453239, 18.857652664184684],
          [72.985137939453239, 18.857921600341911],
          [72.985420227050838, 18.857915878295955],
          [72.985420227050838, 18.858472824096737],
          [72.985687255859659, 18.858470916748161],
          [72.985687255859659, 18.859031677246094],
          [72.985969543457031, 18.859027862548885],
          [72.985969543457031, 18.85958290100109],
          [72.986251831054972, 18.859579086303711],
          [72.986251831054972, 18.860141754150447],
          [72.986526489257983, 18.860137939453068],
          [72.986526489257983, 18.86069488525402],
          [72.986808776855753, 18.860691070556697],
          [72.986808776855753, 18.861251831054801],
          [72.987075805664233, 18.861251831054801],
          [72.987075805664233, 18.861810684204158],
          [72.987358093261946, 18.861803054809627],
          [72.987358093261946, 18.862363815307731],
          [72.987640380859546, 18.862360000610408],
          [72.987640380859546, 18.862920761108512],
          [72.987915039062557, 18.862916946411133],
          [72.987915039062557, 18.863473892211914],
          [72.988197326660099, 18.863470077514762],
          [72.988197326660099, 18.864030838012695],
          [72.988471984863338, 18.864030838012695],
          [72.988471984863338, 18.864860534668082],
          [72.98874664306669, 18.864860534668082],
          [72.98874664306669, 18.865972518921012],
          [72.988471984863338, 18.865970611572266],
          [72.988471984863338, 18.866250991821403],
          [72.987922668457259, 18.866250991821403],
          [72.987922668457259, 18.866529464721793],
          [72.987640380859546, 18.866529464721793],
          [72.987640380859546, 18.866817474365291],
          [72.987083435058764, 18.866807937622184],
          [72.987083435058764, 18.867082595825195],
          [72.986808776855753, 18.867082595825195],
          [72.986808776855753, 18.866807937622184],
          [72.986526489257983, 18.866817474365291],
          [72.986526489257983, 18.866529464721793],
          [72.986251831054972, 18.866529464721793],
          [72.986251831054972, 18.866250991821403],
          [72.985969543457031, 18.866250991821403],
          [72.985969543457031, 18.865970611572266],
          [72.985420227050838, 18.865972518921012],
          [72.985420227050838, 18.865695953369197],
          [72.985137939453239, 18.865695953369197],
          [72.985137939453239, 18.865417480468807],
          [72.984863281250057, 18.86541938781744],
          [72.984863281250057, 18.865140914917049],
          [72.984580993652287, 18.865140914917049],
          [72.984580993652287, 18.864860534668082],
          [72.984008789062443, 18.864860534668082],
          [72.984008789062443, 18.864580154418888],
          [72.983749389648494, 18.864585876464844],
          [72.983749389648494, 18.864305496215877],
          [72.98319244384794, 18.864311218261832],
          [72.98319244384794, 18.864030838012695],
          [72.98264312744169, 18.864030838012695],
          [72.98264312744169, 18.863750457763729],
          [72.98014068603544, 18.863750457763729],
          [72.98014068603544, 18.863470077514762],
          [72.979026794433707, 18.863473892211914],
          [72.979026794433707, 18.863195419311523],
          [72.977920532226733, 18.863189697265568],
          [72.977912902832202, 18.862916946411133],
          [72.977638244628963, 18.862920761108512],
          [72.977638244628963, 18.862640380859375],
          [72.977355957031421, 18.862640380859375],
          [72.977355957031421, 18.862360000610408],
          [72.977081298828409, 18.862363815307731],
          [72.977081298828409, 18.862081527710018],
          [72.976524353027628, 18.862081527710018],
          [72.976524353027628, 18.861803054809627],
          [72.976249694824219, 18.861810684204158],
          [72.976249694824219, 18.861530303955192],
          [72.975769042969034, 18.861530303955192],
          [72.975692749023494, 18.861528396606388],
          [72.975692749023494, 18.861251831054801],
          [72.975418090820256, 18.861251831054801],
          [72.975418090820256, 18.860973358154411],
          [72.974861145019702, 18.860973358154411],
          [72.974861145019702, 18.86069488525402],
          [72.974586486816463, 18.86069488525402],
          [72.974586486816463, 18.860416412353459],
          [72.974296569824389, 18.860420227050838],
          [72.974296569824389, 18.860141754150447],
          [72.973747253418139, 18.860141754150447],
          [72.973747253418139, 18.859859466552678],
          [72.973472595215128, 18.859859466552678],
          [72.973472595215128, 18.85958290100109],
          [72.973197937011719, 18.85958290100109],
          [72.973197937011719, 18.859306335449276],
          [72.972923278808707, 18.859310150146484],
          [72.972923278808707, 18.859031677246094],
          [72.972640991210994, 18.859031677246094],
          [72.972640991210994, 18.858749389648551],
          [72.972358703613395, 18.858749389648551],
          [72.972358703613395, 18.858470916748161],
          [72.971801757812443, 18.858472824096737],
          [72.971801757812443, 18.858194351196346],
          [72.971527099609602, 18.858194351196346],
          [72.971527099609602, 18.857915878295955],
          [72.971252441406421, 18.857921600341911],
          [72.971252441406421, 18.857652664184684],
          [72.970970153808651, 18.857652664184684],
          [72.970970153808651, 18.857360839843807],
          [72.970413208008097, 18.857360839843807],
          [72.970413208008097, 18.85708045959484],
          [72.970138549804687, 18.857084274291992],
          [72.970138549804687, 18.856805801391602],
          [72.969581604003963, 18.856809616088981],
          [72.969581604003963, 18.856529235839844],
          [72.969299316406364, 18.856529235839844],
          [72.969299316406364, 18.856250762939453],
          [72.969009399414119, 18.856250762939453],
          [72.969009399414119, 18.855970382690487],
          [72.968193054199389, 18.855972290039063],
          [72.968193054199389, 18.855693817138672],
          [72.967636108398608, 18.855693817138672],
          [72.967636108398608, 18.855417251586857],
          [72.967361450195597, 18.855421066284237],
          [72.967361450195597, 18.85514068603527],
          [72.967086791992188, 18.85514068603527],
          [72.967086791992188, 18.854860305786133],
          [72.966796875000284, 18.854860305786133],
          [72.966796875000284, 18.854589462280273],
          [72.966529846191463, 18.854589462280273],
          [72.966529846191463, 18.854310989379883],
          [72.966262817382756, 18.854310989379883],
          [72.966262817382756, 18.854030609130916],
          [72.965972900390682, 18.854030609130916],
          [72.965972900390682, 18.85375022888195],
          [72.965827941894815, 18.85375022888195],
          [72.965698242187443, 18.85375022888195],
          [72.965690612792912, 18.853469848632756],
          [72.965141296386889, 18.853471755981559],
          [72.965141296386889, 18.853195190429744],
          [72.964859008789119, 18.8532009124757],
          [72.964859008789119, 18.852920532226563],
          [72.964302062988565, 18.852920532226563],
          [72.964302062988565, 18.852640151977596],
          [72.964027404785156, 18.852640151977596],
          [72.964027404785156, 18.852920532226563],
          [72.963470458984375, 18.852920532226563],
          [72.963470458984375, 18.8532009124757],
          [72.963195800781364, 18.853195190429744],
          [72.963195800781364, 18.853471755981559],
          [72.962364196777571, 18.853471755981559],
          [72.962364196777571, 18.853195190429744],
          [72.962081909179858, 18.8532009124757],
          [72.962081909179858, 18.852920532226563],
          [72.961517333984546, 18.852920532226563],
          [72.961517333984546, 18.852640151977596],
          [72.961250305176065, 18.852640151977596],
          [72.961250305176065, 18.852359771728629],
          [72.960975646972656, 18.852361679077205],
          [72.960975646972656, 18.851806640625],
          [72.960418701171875, 18.851806640625],
          [72.960418701171875, 18.851528167724609],
          [72.959861755371151, 18.851530075073242],
          [72.959861755371151, 18.851249694824276],
          [72.959030151367358, 18.851249694824276],
          [72.959030151367358, 18.850971221923885],
          [72.958473205566577, 18.850973129272461],
          [72.958473205566577, 18.85069465637207],
          [72.957916259765796, 18.85069465637207],
          [72.957916259765796, 18.85041618347168],
          [72.956802368164119, 18.850419998169059],
          [72.956802368164119, 18.850139617919922],
          [72.956253051757869, 18.850139617919922],
          [72.956253051757869, 18.849861145019531],
          [72.955139160156307, 18.849861145019531],
          [72.955139160156307, 18.849580764770565],
          [72.953475952148551, 18.849584579467887],
          [72.953475952148551, 18.849306106567326],
          [72.953186035156307, 18.849309921264705],
          [72.953186035156307, 18.849029541015739],
          [72.952919006347599, 18.849029541015739],
          [72.952919006347599, 18.848751068115348],
          [72.952636718750227, 18.848751068115348],
          [72.952636718750227, 18.848459243774471],
          [72.952079772949276, 18.848474502563533],
          [72.952079772949276, 18.84819221496582],
          [72.951530456543253, 18.84819221496582],
          [72.951530456543253, 18.847917556762752],
          [72.95096588134794, 18.847919464111385],
          [72.95096588134794, 18.84764289855957],
          [72.950141906738338, 18.84764289855957],
          [72.950141906738338, 18.847362518310604],
          [72.949302673340014, 18.847362518310604],
          [72.949302673340014, 18.847080230712834],
          [72.948471069336222, 18.847082138061637],
          [72.948471069336222, 18.846805572509822],
          [72.947357177734659, 18.846809387207031],
          [72.947357177734659, 18.846532821655387],
          [72.946533203125227, 18.846532821655387],
          [72.946533203125227, 18.84625244140625],
          [72.945129394531421, 18.84625244140625],
          [72.945129394531421, 18.845970153808707],
          [72.944160461425952, 18.845970153808707],
          [72.943748474121207, 18.845970153808707],
          [72.943748474121207, 18.845693588256893],
          [72.942916870117415, 18.845693588256893],
          [72.942916870117415, 18.845970153808707],
          [72.942642211914233, 18.845970153808707],
          [72.942642211914233, 18.846149444580078],
          [72.942642211914233, 18.84625244140625],
          [72.942092895507813, 18.84625244140625],
          [72.942092895507813, 18.846532821655387],
          [72.941802978515909, 18.846532821655387],
          [72.941802978515909, 18.846809387207031],
          [72.9415283203125, 18.846805572509822],
          [72.9415283203125, 18.847082138061637],
          [72.941246032715128, 18.847080230712834],
          [72.941246032715128, 18.847362518310604],
          [72.940696716308707, 18.847362518310604],
          [72.940696716308707, 18.84764289855957],
          [72.940406799316463, 18.84764289855957],
          [72.940406799316463, 18.847919464111385],
          [72.940139770507756, 18.847917556762752],
          [72.940139770507756, 18.84819221496582],
          [72.939582824707202, 18.84819221496582],
          [72.939582824707202, 18.848474502563533],
          [72.939315795898722, 18.848459243774471],
          [72.939315795898722, 18.848751068115348],
          [72.938751220703409, 18.848751068115348],
          [72.938751220703409, 18.849029541015739],
          [72.938468933105469, 18.849029541015739],
          [72.938468933105469, 18.849309921264705],
          [72.936889648437443, 18.849308013916129],
          [72.932640075683878, 18.849306106567326],
          [72.932640075683878, 18.849584579467887],
          [72.932357788086108, 18.849580764770565],
          [72.932357788086108, 18.849861145019531],
          [72.932083129883097, 18.849861145019531],
          [72.932083129883097, 18.850139617919922],
          [72.931808471679688, 18.850139617919922],
          [72.931808471679688, 18.850419998169059],
          [72.931526184082315, 18.85041618347168],
          [72.931526184082315, 18.85069465637207],
          [72.931251525878963, 18.85069465637207],
          [72.931251525878963, 18.850973129272461],
          [72.930686950683651, 18.850971221923885],
          [72.930694580078182, 18.851249694824276],
          [72.930152893066463, 18.851249694824276],
          [72.930152893066463, 18.851530075073242],
          [72.927642822265682, 18.851530075073242],
          [72.927642822265682, 18.851249694824276],
          [72.927360534667912, 18.851249694824276],
          [72.927360534667912, 18.850971221923885],
          [72.926528930664119, 18.850971221923885],
          [72.926528930664119, 18.851249694824276],
          [72.926246643066577, 18.851249694824276],
          [72.926246643066577, 18.851530075073242],
          [72.925697326660156, 18.851528167724609],
          [72.925697326660156, 18.851806640625],
          [72.925415039062784, 18.851806640625],
          [72.925415039062784, 18.852361679077205],
          [72.925140380859432, 18.852361679077205],
          [72.925140380859432, 18.853471755981559],
          [72.924858093261832, 18.853469848632756],
          [72.924858093261832, 18.854310989379883],
          [72.924308776855412, 18.854310989379883],
          [72.924308776855412, 18.854589462280273],
          [72.92402648925804, 18.854589462280273],
          [72.92402648925804, 18.854860305786133],
          [72.922637939453125, 18.854860305786133],
          [72.922637939453125, 18.85514068603527],
          [72.922920227051065, 18.85514068603527],
          [72.922920227051065, 18.856809616088981],
          [72.923194885254077, 18.856805801391602],
          [72.923194885254077, 18.858194351196346],
          [72.923469543457088, 18.858190536498967],
          [72.923469543457088, 18.858749389648551],
          [72.923751831054858, 18.858749389648551],
          [72.923751831054858, 18.863473892211914],
          [72.923469543457088, 18.863473892211914],
          [72.923469543457088, 18.864585876464844],
          [72.923187255859546, 18.864580154418888],
          [72.923187255859546, 18.86541938781744],
          [72.922920227051065, 18.865417480468807],
          [72.922920227051065, 18.865695953369197],
          [72.922637939453125, 18.865695953369197],
          [72.922637939453125, 18.865972518921012],
          [72.922363281250284, 18.865970611572266],
          [72.922363281250284, 18.866529464721793],
          [72.922080993652344, 18.866529464721793],
          [72.922080993652344, 18.867639541625977],
          [72.921806335449332, 18.867639541625977],
          [72.921806335449332, 18.868194580078125],
          [72.921249389648381, 18.868194580078125],
          [72.921249389648381, 18.868473052978516],
          [72.920959472656307, 18.86847114562994],
          [72.920959472656307, 18.86874961853033],
          [72.920692443847827, 18.86874961853033],
          [72.920692443847827, 18.869304656982479],
          [72.920143127441577, 18.869300842285099],
          [72.920143127441577, 18.870138168335018],
          [72.919860839844034, 18.870138168335018],
          [72.919860839844034, 18.870700836181754],
          [72.919586181640625, 18.870695114135799],
          [72.919586181640625, 18.870971679687614],
          [72.919296264648722, 18.87096977233881],
          [72.919296264648722, 18.871248245239201],
          [72.919029235839844, 18.871248245239201],
          [72.919029235839844, 18.871528625488395],
          [72.918746948242472, 18.871528625488395],
          [72.918746948242472, 18.871810913085937],
          [72.918472290039119, 18.871810913085937],
          [72.918472290039119, 18.872360229492187],
          [72.918197631835881, 18.872360229492187],
          [72.918197631835881, 18.872638702392521],
          [72.91792297363304, 18.872629165649414],
          [72.91792297363304, 18.872922897338867],
          [72.917640686035327, 18.872917175292912],
          [72.917640686035327, 18.873470306396541],
          [72.917358398437727, 18.873470306396541],
          [72.917358398437727, 18.874031066894645],
          [72.917083740234546, 18.874027252197266],
          [72.917083740234546, 18.874582290649471],
          [72.916809082031534, 18.874580383300895],
          [72.916809082031534, 18.875141143798828],
          [72.916526794433764, 18.875139236450252],
          [72.916526794433764, 18.875692367553825],
          [72.916252136230753, 18.875690460205021],
          [72.916252136230753, 18.876529693603572],
          [72.915969848632812, 18.87652778625494],
          [72.915969848632812, 18.877084732055721],
          [72.915702819824332, 18.877080917358398],
          [72.915702819824332, 18.877920150756893],
          [72.915412902832088, 18.877920150756893],
          [72.915412902832088, 18.878759384155387],
          [72.91513824462902, 18.878749847412109],
          [72.91513824462902, 18.879306793212834],
          [72.914863586425838, 18.879306793212834],
          [72.914863586425838, 18.879861831665039],
          [72.914581298828068, 18.879859924316463],
          [72.914581298828068, 18.88014030456543],
          [72.914306640625227, 18.88014030456543],
          [72.914306640625227, 18.880701065063533],
          [72.914024353027514, 18.880695343017578],
          [72.914024353027514, 18.880971908569393],
          [72.913749694824276, 18.880970001220817],
          [72.913749694824276, 18.881250381469783],
          [72.913482666015625, 18.881250381469783],
          [72.913482666015625, 18.881820678710994],
          [72.913192749023722, 18.881805419921932],
          [72.913192749023722, 18.882083892822322],
          [72.912918090820313, 18.882080078124943],
          [72.912918090820313, 18.882360458374137],
          [72.91263580322294, 18.882360458374137],
          [72.91263580322294, 18.88292121887207],
          [72.910972595215014, 18.882917404174862],
          [72.910972595215014, 18.883472442627067],
          [72.910697937011776, 18.88347053527832],
          [72.910697937011776, 18.883750915527457],
          [72.910423278808764, 18.883750915527457],
          [72.910423278808764, 18.884311676025391],
          [72.910140991211222, 18.884305953979435],
          [72.910140991211222, 18.88458251953125],
          [72.909858703613281, 18.88457107543951],
          [72.909858703613281, 18.884859085083008],
          [72.909309387207088, 18.884859085083008],
          [72.9093017578125, 18.885139465332031],
          [72.909019470215128, 18.885139465332031],
          [72.909019470215128, 18.885421752929744],
          [72.908470153808537, 18.885416030883789],
          [72.908470153808537, 18.88569450378418],
          [72.908195495605696, 18.88569450378418],
          [72.908195495605696, 18.888473510742244],
          [72.908470153808537, 18.888469696044865],
          [72.908470153808537, 18.891250610351563],
          [72.908203125000227, 18.891250610351563],
          [72.908203125000227, 18.892641067504883],
          [72.908470153808537, 18.892639160156307],
          [72.908470153808537, 18.897083282470703],
          [72.908752441406307, 18.897079467773494],
          [72.908752441406307, 18.898199081421012],
          [72.908195495605696, 18.898195266723633],
          [72.908195495605696, 18.898471832275447],
          [72.907913208007983, 18.898469924926871],
          [72.907913208007983, 18.899032592773551],
          [72.907638549804744, 18.899032592773551],
          [72.907638549804744, 18.900421142578125],
          [72.907913208007983, 18.900417327880916],
          [72.907913208007983, 18.902084350586051],
          [72.908470153808537, 18.902080535888729],
          [72.908470153808537, 18.902362823486442],
          [72.908752441406307, 18.902362823486442],
          [72.908752441406307, 18.902639389038086],
          [72.9093017578125, 18.902639389038086],
          [72.909309387207088, 18.902931213378906],
          [72.90958404541044, 18.902914047241268],
          [72.90958404541044, 18.903192520141658],
          [72.909858703613281, 18.903190612793082],
          [72.909858703613281, 18.90374946594244],
          [72.910140991211222, 18.90374946594244],
          [72.910140991211222, 18.904310226440543],
          [72.910697937011776, 18.904310226440543],
          [72.910697937011776, 18.904029846191406],
          [72.912918090820313, 18.904029846191406],
          [72.912918090820313, 18.90374946594244],
          [72.915145874023381, 18.90374946594244],
          [72.915145874023381, 18.904029846191406],
          [72.915412902832088, 18.904029846191406],
          [72.915412902832088, 18.904310226440543],
          [72.915695190429972, 18.904306411743164],
          [72.915695190429972, 18.904584884643555],
          [72.916252136230753, 18.904584884643555],
          [72.916252136230753, 18.904861450195369],
          [72.916526794433764, 18.904859542846793],
          [72.916526794433764, 18.905420303344727],
          [72.916809082031534, 18.905416488647518],
          [72.916809082031534, 18.905971527099723],
          [72.917076110840014, 18.90596961975092],
          [72.917076110840014, 18.90653038024908],
          [72.917358398437727, 18.90653038024908],
          [72.917358398437727, 18.907920837402401],
          [72.917076110840014, 18.907920837402401],
          [72.917076110840014, 18.909030914306754],
          [72.916809082031534, 18.909030914306754],
          [72.916809082031534, 18.910417556762752],
          [72.917358398437727, 18.910417556762752],
          [72.917358398437727, 18.910139083862362],
          [72.91792297363304, 18.910139083862362],
          [72.91792297363304, 18.909860610961971],
          [72.918472290039119, 18.909860610961971],
          [72.918472290039119, 18.909580230713004],
          [72.919586181640625, 18.909580230713004],
          [72.919586181640625, 18.909860610961971],
          [72.919860839844034, 18.909860610961971],
          [72.919860839844034, 18.910417556762752],
          [72.920135498047046, 18.910417556762752],
          [72.920135498047046, 18.91069412231451],
          [72.920417785644588, 18.91069412231451],
          [72.920417785644588, 18.910972595214901],
          [72.921249389648381, 18.910970687866325],
          [72.921249389648381, 18.911531448364258],
          [72.921806335449332, 18.911527633667106],
          [72.921806335449332, 18.91180610656744],
          [72.922637939453125, 18.91180610656744],
          [72.922637939453125, 18.912082672119254],
          [72.923469543457088, 18.912082672119254],
          [72.923469543457088, 18.91180610656744],
          [72.92402648925804, 18.91180610656744],
          [72.92402648925804, 18.911527633667106],
          [72.927360534667912, 18.911531448364258],
          [72.927360534667912, 18.911249160766715],
          [72.928466796875284, 18.911249160766715],
          [72.928466796875284, 18.910970687866325],
          [72.929031372070597, 18.910972595214901],
          [72.929031372070597, 18.91069412231451],
          [72.929580688476619, 18.91069412231451],
          [72.929580688476619, 18.910417556762752],
          [72.929862976074389, 18.910417556762752],
          [72.929862976074389, 18.909580230713004],
          [72.930137634277571, 18.909584045410156],
          [72.930137634277571, 18.908750534057617],
          [72.930419921875171, 18.908750534057617],
          [72.930419921875171, 18.907638549804631],
          [72.930686950683651, 18.907640457153434],
          [72.930686950683651, 18.907360076904297],
          [72.930969238281364, 18.907361984253043],
          [72.930969238281364, 18.907083511352653],
          [72.931251525878963, 18.907083511352653],
          [72.931251525878963, 18.906528472900504],
          [72.931526184082315, 18.90653038024908],
          [72.931526184082315, 18.90596961975092],
          [72.931808471679688, 18.905971527099723],
          [72.931808471679688, 18.905696868896484],
          [72.932083129883097, 18.905700683593864],
          [72.932083129883097, 18.905420303344727],
          [72.932357788086108, 18.905420303344727],
          [72.932357788086108, 18.90513992309576],
          [72.932640075683878, 18.90513992309576],
          [72.932640075683878, 18.904859542846793],
          [72.932914733886889, 18.904861450195369],
          [72.932914733886889, 18.904306411743164],
          [72.933746337890682, 18.904310226440543],
          [72.933746337890682, 18.904029846191406],
          [72.934303283691463, 18.904029846191406],
          [72.934303283691463, 18.90374946594244],
          [72.934593200683707, 18.90374946594244],
          [72.934585571289176, 18.903474807739201],
          [72.934860229492188, 18.903474807739201],
          [72.934860229492188, 18.903192520141658],
          [72.935142517090128, 18.903192520141658],
          [72.935142517090128, 18.902914047241268],
          [72.935691833496378, 18.902931213378906],
          [72.935691833496378, 18.902362823486442],
          [72.936248779296932, 18.902362823486442],
          [72.936248779296932, 18.902080535888729],
          [72.936531066894702, 18.902084350586051],
          [72.936531066894702, 18.90180587768549],
          [72.936813354492415, 18.901809692382869],
          [72.936813354492415, 18.901531219482479],
          [72.937080383300724, 18.901531219482479],
          [72.937080383300724, 18.901252746582088],
          [72.937637329101676, 18.901252746582088],
          [72.937637329101676, 18.900970458984375],
          [72.937919616699276, 18.900970458984375],
          [72.937919616699276, 18.900417327880916],
          [72.938186645508097, 18.900421142578125],
          [72.938186645508097, 18.900142669677734],
          [72.938751220703409, 18.900142669677734],
          [72.938751220703409, 18.899860382080192],
          [72.939025878906421, 18.899860382080192],
          [72.939025878906421, 18.899570465087891],
          [72.939308166503963, 18.899583816528377],
          [72.939308166503963, 18.899305343627987],
          [72.939582824707202, 18.899311065673942],
          [72.939582824707202, 18.899032592773551],
          [72.939857482910384, 18.899032592773551],
          [72.939857482910384, 18.898748397827205],
          [72.940139770507756, 18.898748397827205],
          [72.940139770507756, 18.898469924926871],
          [72.940414428710994, 18.898471832275447],
          [72.940414428710994, 18.898195266723633],
          [72.940696716308707, 18.898199081421012],
          [72.940696716308707, 18.897920608520621],
          [72.940971374511776, 18.897920608520621],
          [72.940971374511776, 18.896528244018498],
          [72.940696716308707, 18.896528244018498],
          [72.940696716308707, 18.895418167114371],
          [72.941802978515909, 18.895416259765568],
          [72.941802978515909, 18.897083282470703],
          [72.941909790039063, 18.897081375122127],
          [72.942092895507813, 18.897079467773494],
          [72.942092895507813, 18.897920608520621],
          [72.942359924316463, 18.897920608520621],
          [72.942359924316463, 18.899032592773551],
          [72.942642211914233, 18.899032592773551],
          [72.942642211914233, 18.899860382080192],
          [72.942916870117415, 18.899860382080192],
          [72.942916870117415, 18.905420303344727],
          [72.942642211914233, 18.905420303344727],
          [72.942642211914233, 18.905700683593864],
          [72.942359924316463, 18.905700683593864],
          [72.942359924316463, 18.906250000000114],
          [72.942085266113452, 18.906250000000114],
          [72.942085266113452, 18.908750534057617],
          [72.942359924316463, 18.908740997314453],
          [72.942359924316463, 18.909307479858398],
          [72.943191528320256, 18.909307479858398],
          [72.943191528320256, 18.909030914306754],
          [72.944580078125, 18.909030914306754],
          [72.944580078125, 18.909307479858398],
          [72.94486236572294, 18.909307479858398],
          [72.94486236572294, 18.910139083862362],
          [72.945137023925952, 18.910137176513729],
          [72.945137023925952, 18.910972595214901],
          [72.946250915527514, 18.910972595214901],
          [72.946250915527514, 18.91069412231451],
          [72.949859619140568, 18.91069412231451],
          [72.949859619140568, 18.910417556762752],
          [72.95041656494152, 18.910417556762752],
          [72.95041656494152, 18.910139083862362],
          [72.950691223144531, 18.910139083862362],
          [72.950691223144531, 18.909860610961971],
          [72.95096588134794, 18.909860610961971],
          [72.95096588134794, 18.909580230713004],
          [72.951530456543253, 18.909584045410156],
          [72.951530456543253, 18.909027099609375],
          [72.952079772949276, 18.909030914306754],
          [72.952079772949276, 18.908740997314453],
          [72.952362060547046, 18.908750534057617],
          [72.952362060547046, 18.908472061157227],
          [72.952919006347599, 18.908472061157227],
          [72.952919006347599, 18.908193588256836],
          [72.954025268554972, 18.908193588256836],
          [72.954025268554972, 18.908472061157227],
          [72.955139160156307, 18.908472061157227],
          [72.955139160156307, 18.908193588256836],
          [72.955696105957259, 18.908193588256836],
          [72.955696105957259, 18.908472061157227],
          [72.955970764160099, 18.908472061157227],
          [72.955970764160099, 18.908193588256836],
          [72.956527709961051, 18.908193588256836],
          [72.956527709961051, 18.907918930053825],
          [72.957084655762003, 18.907918930053825],
          [72.957084655762003, 18.908193588256836],
          [72.957359313964844, 18.908193588256836],
          [72.957359313964844, 18.908472061157227],
          [72.957641601562784, 18.908472061157227],
          [72.957641601562784, 18.908750534057617],
          [72.957359313964844, 18.908750534057617],
          [72.957359313964844, 18.909584045410156],
          [72.957641601562784, 18.909580230713004],
          [72.957641601562784, 18.910139083862362],
          [72.957916259765796, 18.910139083862362],
          [72.957916259765796, 18.910417556762752],
          [72.958190917968807, 18.910417556762752],
          [72.958190917968807, 18.910972595214901],
          [72.958473205566577, 18.910970687866325],
          [72.958473205566577, 18.911249160766715],
          [72.958747863769759, 18.911249160766715],
          [72.958747863769759, 18.91180610656744],
          [72.959030151367358, 18.911800384521541],
          [72.959030151367358, 18.912359237670898],
          [72.959297180175838, 18.912359237670898],
          [72.959297180175838, 18.912641525268612],
          [72.959587097167912, 18.912641525268612],
          [72.959587097167912, 18.912921905517578],
          [72.959861755371151, 18.912916183471623],
          [72.959861755371151, 18.913471221923828],
          [72.960128784179972, 18.913469314575252],
          [72.960128784179972, 18.914030075073356],
          [72.960418701171875, 18.914028167724609],
          [72.960418701171875, 18.914581298828182],
          [72.960693359375284, 18.914579391479606],
          [72.960693359375284, 18.915140151977539],
          [72.960975646972656, 18.915138244628963],
          [72.960983276367188, 18.916250228881893],
          [72.960693359375284, 18.916250228881893],
          [72.960693359375284, 18.917930603027287],
          [72.960983276367188, 18.917930603027287],
          [72.960983276367188, 18.919031143188533],
          [72.961250305176065, 18.919027328491154],
          [72.961250305176065, 18.919582366943359],
          [72.961517333984546, 18.919580459594783],
          [72.961517333984546, 18.920419692993278],
          [72.961807250976619, 18.920419692993278],
          [72.961807250976619, 18.921808242797852],
          [72.961517333984546, 18.921808242797852],
          [72.961517333984546, 18.922639846801815],
          [72.961250305176065, 18.922639846801815],
          [72.961250305176065, 18.923194885253963],
          [72.960975646972656, 18.923194885253963],
          [72.960975646972656, 18.923749923706168],
          [72.959861755371151, 18.923740386962834],
          [72.959861755371151, 18.924028396606559],
          [72.959297180175838, 18.924028396606559],
          [72.959297180175838, 18.924310684204102],
          [72.959030151367358, 18.924304962158317],
          [72.959030151367358, 18.924583435058707],
          [72.958473205566577, 18.924583435058707],
          [72.958473205566577, 18.924861907959098],
          [72.958190917968807, 18.924858093261719],
          [72.958190917968807, 18.925138473510742],
          [72.957641601562784, 18.925138473510742],
          [72.957641601562784, 18.925422668457031],
          [72.957359313964844, 18.925416946411076],
          [72.957359313964844, 18.925689697265739],
          [72.957084655762003, 18.925695419311467],
          [72.957084655762003, 18.925970077514705],
          [72.956802368164119, 18.925970077514705],
          [72.956802368164119, 18.926252365112418],
          [72.956527709961051, 18.926252365112418],
          [72.956527709961051, 18.926532745361385],
          [72.956253051757869, 18.926532745361385],
          [72.956253051757869, 18.926811218261776],
          [72.955970764160099, 18.92680549621582],
          [72.955970764160099, 18.927082061767635],
          [72.955696105957259, 18.927080154419059],
          [72.955696105957259, 18.927360534668026],
          [72.955406188965014, 18.927360534668026],
          [72.955406188965014, 18.927642822265739],
          [72.955139160156307, 18.927642822265739],
          [72.955139160156307, 18.927919387817383],
          [72.954864501953296, 18.927917480468807],
          [72.954864501953296, 18.928192138671989],
          [72.954582214355753, 18.928192138671989],
          [72.954582214355753, 18.928470611572379],
          [72.954322814941463, 18.928470611572379],
          [72.954322814941463, 18.928752899169922],
          [72.954032897949503, 18.928752899169922],
          [72.954032897949503, 18.929029464721737],
          [72.953750610351619, 18.929029464721737],
          [72.953750610351619, 18.929309844970703],
          [72.953475952148551, 18.929306030273494],
          [72.953475952148551, 18.929584503173885],
          [72.953186035156307, 18.929580688476562],
          [72.953186035156307, 18.929870605468807],
          [72.952919006347599, 18.929870605468807],
          [72.952919006347599, 18.93013954162609],
          [72.952636718750227, 18.93013954162609],
          [72.952636718750227, 18.930419921875057],
          [72.952362060547046, 18.930414199829102],
          [72.952362060547046, 18.930694580078239],
          [72.952079772949276, 18.930694580078239],
          [72.952079772949276, 18.930973052978629],
          [72.951530456543253, 18.930971145629883],
          [72.951530456543253, 18.931249618530273],
          [72.951255798339844, 18.931249618530273],
          [72.951255798339844, 18.931529998779411],
          [72.950973510742472, 18.931528091430664],
          [72.950973510742472, 18.931806564330998],
          [72.950691223144531, 18.931806564330998],
          [72.950691223144531, 18.932083129882812],
          [72.950141906738338, 18.932083129882812],
          [72.950141906738338, 18.932361602783203],
          [72.949859619140568, 18.932359695434627],
          [72.949859619140568, 18.932640075683594],
          [72.949584960937727, 18.932638168335018],
          [72.949584960937727, 18.932916641235352],
          [72.949302673340014, 18.932910919189453],
          [72.949302673340014, 18.933200836181697],
          [72.949028015136776, 18.933195114135742],
          [72.949028015136776, 18.933471679687557],
          [72.948753356933764, 18.933469772338981],
          [72.948753356933764, 18.934030532836914],
          [72.948471069336222, 18.934030532836914],
          [72.948471069336222, 18.934310913086051],
          [72.948196411132812, 18.934305191040096],
          [72.948196411132812, 18.934583663940487],
          [72.947906494140909, 18.934579849243164],
          [72.947906494140909, 18.934860229492301],
          [72.947639465332031, 18.934860229492301],
          [72.947639465332031, 18.935140609741268],
          [72.947357177734659, 18.935140609741268],
          [72.947357177734659, 18.935419082641658],
          [72.946807861328068, 18.935417175293082],
          [72.946807861328068, 18.93569374084484],
          [72.946525573730526, 18.93569374084484],
          [72.946525573730526, 18.935972213745231],
          [72.946250915527514, 18.935970306396484],
          [72.946250915527514, 18.936250686645621],
          [72.945968627929915, 18.936250686645621],
          [72.945968627929915, 18.936807632446403],
          [72.945693969726733, 18.936805725097599],
          [72.945693969726733, 18.939582824707088],
          [72.945419311523722, 18.939580917358512],
          [72.945419311523722, 18.940141677856445],
          [72.945129394531421, 18.940141677856445],
          [72.945129394531421, 18.940420150756836],
          [72.94486236572294, 18.940416336059627],
          [72.94486236572294, 18.940971374511832],
          [72.944580078125, 18.940969467163086],
          [72.944580078125, 18.941249847412223],
          [72.94431304931652, 18.941249847412223],
          [72.94431304931652, 18.94153022766119],
          [72.943748474121207, 18.94153022766119],
          [72.943748474121207, 18.941810607910156],
          [72.943473815918026, 18.941804885864371],
          [72.943473815918026, 18.942363739013729],
          [72.943191528320256, 18.942359924316406],
          [72.943191528320256, 18.94292068481451],
          [72.942916870117415, 18.94292068481451],
          [72.942916870117415, 18.943201065063477],
          [72.942642211914233, 18.943195343017521],
          [72.942642211914233, 18.943473815918082],
          [72.942085266113452, 18.943473815918082],
          [72.942092895507813, 18.943750381469727],
          [72.941802978515909, 18.943750381469727],
          [72.941802978515909, 18.944030761718864],
          [72.9415283203125, 18.944030761718864],
          [72.9415283203125, 18.94431114196783],
          [72.941253662109659, 18.944305419921875],
          [72.941253662109659, 18.944585800170842],
          [72.940971374511776, 18.944585800170842],
          [72.940971374511776, 18.94486045837408],
          [72.940696716308707, 18.944852828979549],
          [72.940696716308707, 18.945140838623047],
          [72.940139770507756, 18.945140838623047],
          [72.940139770507756, 18.945421218872184],
          [72.939582824707202, 18.945417404174862],
          [72.939582824707202, 18.94597244262701],
          [72.939315795898722, 18.945970535278434],
          [72.939315795898722, 18.946529388427791],
          [72.939582824707202, 18.946527481079215],
          [72.939582824707202, 18.947082519531364],
          [72.939857482910384, 18.947080612182617],
          [72.939857482910384, 18.947360992431754],
          [72.940139770507756, 18.947360992431754],
          [72.940139770507756, 18.947917938232536],
          [72.940414428710994, 18.947917938232536],
          [72.940414428710994, 18.948194503784293],
          [72.940696716308707, 18.948194503784293],
          [72.940696716308707, 18.948472976684684],
          [72.940971374511776, 18.948471069335938],
          [72.940971374511776, 18.948749542236328],
          [72.941246032715128, 18.948749542236328],
          [72.941246032715128, 18.949029922485465],
          [72.9415283203125, 18.949026107788086],
          [72.9415283203125, 18.949300765991325],
          [72.941802978515909, 18.949306488037053],
          [72.941802978515909, 18.949861526489258],
          [72.942092895507813, 18.949859619140682],
          [72.942092895507813, 18.950138092041072],
          [72.942642211914233, 18.950138092041072],
          [72.942642211914233, 18.950418472290039],
          [72.942916870117415, 18.950418472290039],
          [72.942916870117415, 18.950700759887752],
          [72.943191528320256, 18.950695037841797],
          [72.943191528320256, 18.950971603393612],
          [72.943466186523494, 18.950969696045036],
          [72.943466186523494, 18.951248168945426],
          [72.944030761718807, 18.951248168945426],
          [72.944030761718807, 18.951528549194393],
          [72.94431304931652, 18.951528549194393],
          [72.94431304931652, 18.951810836792106],
          [72.944580078125, 18.951805114746151],
          [72.944580078125, 18.952083587646541],
          [72.94486236572294, 18.952079772949219],
          [72.94486236572294, 18.952360153198356],
          [72.945129394531421, 18.952360153198356],
          [72.945129394531421, 18.952922821044865],
          [72.945419311523722, 18.952922821044865],
          [72.945419311523722, 18.954309463501033],
          [72.945693969726733, 18.954305648803654],
          [72.945693969726733, 18.955570220947379],
          [72.945693969726733, 18.955692291259822],
          [72.945968627929915, 18.955692291259822],
          [72.945968627929915, 18.955989837646484],
          [72.945968627929915, 18.95625114440918],
          [72.946136474609432, 18.956249237060604],
          [72.946250915527514, 18.956249237060604],
          [72.946258544922046, 18.956430435180721],
          [72.946266174316577, 18.95652961730957],
          [72.946533203125227, 18.95652961730957],
          [72.946533203125227, 18.956809997558707],
          [72.946807861328068, 18.956809997558707],
          [72.946807861328068, 18.957361221313533],
          [72.947082519531307, 18.957361221313533],
          [72.947082519531307, 18.957639694213924],
          [72.94736480712902, 18.957639694213924],
          [72.94736480712902, 18.958196640014705],
          [72.947639465332031, 18.95819091796875],
          [72.947639465332031, 18.959030151367244],
          [72.94791412353544, 18.959028244018668],
          [72.94791412353544, 18.959583282470817],
          [72.948188781738452, 18.959579467773494],
          [72.948188781738452, 18.960420608520565],
          [72.948471069336222, 18.960416793823185],
          [72.948471069336222, 18.961120605468807],
          [72.948471069336222, 18.961250305175781],
          [72.948753356933764, 18.961250305175781],
          [72.948753356933764, 18.961677551269588],
          [72.948753356933764, 18.96208381652832],
          [72.949028015136776, 18.96208381652832],
          [72.949028015136776, 18.962209701538143],
          [72.949028015136776, 18.962360382080135],
          [72.949302673340014, 18.962360382080135],
          [72.949302673340014, 18.962640762329102],
          [72.949584960937727, 18.962638854980526],
          [72.949584960937727, 18.962917327880916],
          [72.95041656494152, 18.962917327880916],
          [72.95041656494152, 18.96180534362793],
          [72.950141906738338, 18.961811065673885],
          [72.950141906738338, 18.960700988769531],
          [72.949859619140568, 18.960700988769531],
          [72.949859619140568, 18.960140228271598],
          [72.949577331543026, 18.960140228271598],
          [72.949577331543026, 18.959850311279297],
          [72.949302673340014, 18.959861755371207],
          [72.949302673340014, 18.959306716919059],
          [72.949028015136776, 18.959306716919059],
          [72.949028015136776, 18.958749771118278],
          [72.948753356933764, 18.958749771118278],
          [72.948753356933764, 18.95819091796875],
          [72.948471069336222, 18.958196640014705],
          [72.948471069336222, 18.957361221313533],
          [72.948188781738452, 18.957361221313533],
          [72.948188781738452, 18.956809997558707],
          [72.947906494140909, 18.956809997558707],
          [72.947906494140909, 18.95625114440918],
          [72.947639465332031, 18.95625114440918],
          [72.947639465332031, 18.955419540405387],
          [72.947357177734659, 18.955419540405387],
          [72.947357177734659, 18.954580307006893],
          [72.947082519531307, 18.954582214355469],
          [72.947082519531307, 18.954027175903263],
          [72.946807861328068, 18.95404052734375],
          [72.946807861328068, 18.953470230102539],
          [72.947082519531307, 18.953470230102539],
          [72.947082519531307, 18.952917098999137],
          [72.947639465332031, 18.952922821044865],
          [72.947639465332031, 18.952642440795898],
          [72.948196411132812, 18.952638626098746],
          [72.948196411132812, 18.953193664550895],
          [72.948471069336222, 18.953191757202148],
          [72.948471069336222, 18.95404052734375],
          [72.948753356933764, 18.95404052734375],
          [72.948753356933764, 18.954860687255859],
          [72.949028015136776, 18.954860687255859],
          [72.949028015136776, 18.955419540405387],
          [72.949302673340014, 18.955415725708008],
          [72.949302673340014, 18.955692291259822],
          [72.949577331543026, 18.955690383911246],
          [72.949577331543026, 18.95625114440918],
          [72.949859619140568, 18.95625114440918],
          [72.949859619140568, 18.956809997558707],
          [72.950141906738338, 18.956809997558707],
          [72.950141906738338, 18.957639694213924],
          [72.95041656494152, 18.957639694213924],
          [72.95041656494152, 18.958196640014705],
          [72.950691223144531, 18.95819091796875],
          [72.950691223144531, 18.958749771118278],
          [72.950973510742472, 18.958749771118278],
          [72.950973510742472, 18.959583282470817],
          [72.951255798339844, 18.959579467773494],
          [72.951255798339844, 18.960140228271598],
          [72.951530456543253, 18.960140228271598],
          [72.951530456543253, 18.960420608520565],
          [72.951812744140796, 18.960420608520565],
          [72.951812744140796, 18.960140228271598],
          [72.952636718750227, 18.960140228271598],
          [72.952636718750227, 18.960700988769531],
          [72.952919006347599, 18.960700988769531],
          [72.952919006347599, 18.961250305175781],
          [72.953186035156307, 18.961250305175781],
          [72.953186035156307, 18.961530685424918],
          [72.953475952148551, 18.961528778076172],
          [72.953475952148551, 18.96208381652832],
          [72.953750610351619, 18.962080001831168],
          [72.953750610351619, 18.962360382080135],
          [72.954025268554972, 18.962360382080135],
          [72.954025268554972, 18.962917327880916],
          [72.954307556152344, 18.962917327880916],
          [72.954307556152344, 18.963472366333065],
          [72.954582214355753, 18.963470458984489],
          [72.954582214355753, 18.963750839233455],
          [72.954856872558764, 18.963750839233455],
          [72.954856872558764, 18.964311599731559],
          [72.954307556152344, 18.964305877685604],
          [72.954307556152344, 18.964582443237418],
          [72.954582214355753, 18.964580535888672],
          [72.954582214355753, 18.964860916137809],
          [72.954856872558764, 18.964860916137809],
          [72.954856872558764, 18.9651393890382],
          [72.955139160156307, 18.9651393890382],
          [72.955139160156307, 18.965694427490348],
          [72.955406188965014, 18.965690612793026],
          [72.955406188965014, 18.966810226440487],
          [72.955696105957259, 18.966810226440487],
          [72.955696105957259, 18.968200683593807],
          [72.955406188965014, 18.968200683593807],
          [72.955406188965014, 18.968751907348633],
          [72.955139160156307, 18.968751907348633],
          [72.955139160156307, 18.969039916992131],
          [72.954856872558764, 18.969039916992131],
          [72.954856872558764, 18.969310760498161],
          [72.954582214355753, 18.969303131103629],
          [72.954582214355753, 18.96958160400402],
          [72.954025268554972, 18.96958160400402],
          [72.954025268554972, 18.969863891601563],
          [72.953750610351619, 18.969860076904411],
          [72.953750610351619, 18.970140457153377],
          [72.953475952148551, 18.970140457153377],
          [72.953475952148551, 18.971250534057731],
          [72.953750610351619, 18.971250534057731],
          [72.953750610351619, 18.971530914306697],
          [72.954322814941463, 18.971530914306697],
          [72.954322814941463, 18.971809387207088],
          [72.954582214355753, 18.971809387207088],
          [72.954582214355753, 18.972360610961914],
          [72.954856872558764, 18.972360610961914],
          [72.954856872558764, 18.972640991211051],
          [72.955139160156307, 18.972639083862305],
          [72.955139160156307, 18.973194122314453],
          [72.955413818359546, 18.973194122314453],
          [72.955413818359546, 18.973472595214844],
          [72.955696105957259, 18.973470687866268],
          [72.955696105957259, 18.974029541015625],
          [72.956802368164119, 18.974029541015625],
          [72.956802368164119, 18.973470687866268],
          [72.957359313964844, 18.973472595214844],
          [72.957359313964844, 18.973194122314453],
          [72.959587097167912, 18.973194122314453],
          [72.959587097167912, 18.973472595214844],
          [72.959861755371151, 18.973472595214844],
          [72.959861755371151, 18.973194122314453],
          [72.960136413574503, 18.973194122314453],
          [72.960136413574503, 18.972639083862305],
          [72.960418701171875, 18.972640991211051],
          [72.960418701171875, 18.972360610961914],
          [72.960693359375284, 18.972360610961914],
          [72.960693359375284, 18.972080230712947],
          [72.960975646972656, 18.972085952758903],
          [72.960975646972656, 18.971527099609318],
          [72.961250305176065, 18.971530914306697],
          [72.961250305176065, 18.971250534057731],
          [72.961517333984546, 18.971250534057731],
          [72.961517333984546, 18.970689773559627],
          [72.961807250976619, 18.970695495605526],
          [72.961807250976619, 18.970417022705192],
          [72.962081909179858, 18.970420837402344],
          [72.962081909179858, 18.969860076904411],
          [72.962364196777571, 18.969863891601563],
          [72.962364196777571, 18.96958160400402],
          [72.962638854980412, 18.96958160400402],
          [72.962638854980412, 18.969028472900447],
          [72.962905883789119, 18.969039916992131],
          [72.962905883789119, 18.968751907348633],
          [72.963195800781364, 18.968751907348633],
          [72.963195800781364, 18.96846961975109],
          [72.963470458984375, 18.968471527099666],
          [72.963470458984375, 18.967916488647461],
          [72.963752746582315, 18.96792030334484],
          [72.963752746582315, 18.96764183044445],
          [72.964027404785156, 18.96764183044445],
          [72.964027404785156, 18.967359542846737],
          [72.964584350586108, 18.967363357544059],
          [72.964584350586108, 18.967081069946346],
          [72.964859008789119, 18.967081069946346],
          [72.964859008789119, 18.966806411743107],
          [72.966804504394815, 18.966806411743107],
          [72.966804504394815, 18.967081069946346],
          [72.967636108398608, 18.967081069946346],
          [72.967636108398608, 18.966806411743107],
          [72.968193054199389, 18.966810226440487],
          [72.968193054199389, 18.966531753540096],
          [72.968482971191463, 18.966531753540096],
          [72.968482971191463, 18.966249465942383],
          [72.969024658203182, 18.966249465942383],
          [72.969009399414119, 18.96598052978527],
          [72.969581604003963, 18.96598052978527],
          [72.969581604003963, 18.965690612793026],
          [72.969863891601847, 18.965694427490348],
          [72.969856262207315, 18.965400695800895],
          [72.970138549804687, 18.965421676635742],
          [72.970138549804687, 18.9651393890382],
          [72.970413208008097, 18.9651393890382],
          [72.970413208008097, 18.964580535888672],
          [72.970695495605639, 18.964582443237418],
          [72.970695495605639, 18.964305877685604],
          [72.971252441406421, 18.964311599731559],
          [72.971252441406421, 18.964029312133846],
          [72.971527099609602, 18.964029312133846],
          [72.971527099609602, 18.963750839233455],
          [72.972068786621151, 18.963750839233455],
          [72.972068786621151, 18.963470458984489],
          [72.975135803222713, 18.963472366333065],
          [72.975135803222713, 18.963193893432674],
          [72.975418090820256, 18.963193893432674],
          [72.975418090820256, 18.962917327880916],
          [72.977363586425952, 18.962917327880916],
          [72.977363586425952, 18.962638854980526],
          [72.979309082031307, 18.962638854980526],
          [72.979309082031307, 18.962917327880916],
          [72.9798583984375, 18.962917327880916],
          [72.9798583984375, 18.963193893432674],
          [72.980972290039233, 18.963193893432674],
          [72.980972290039233, 18.963472366333065],
          [72.981529235839787, 18.963470458984489],
          [72.981529235839787, 18.963750839233455],
          [72.981796264648494, 18.963750839233455],
          [72.981796264648494, 18.964311599731559],
          [72.982086181640739, 18.964311599731559],
          [72.982086181640739, 18.964860916137809],
          [72.982360839843807, 18.964860916137809],
          [72.982360839843807, 18.965421676635742],
          [72.98264312744169, 18.965421676635742],
          [72.98264312744169, 18.96598052978527],
          [72.982917785644531, 18.96598052978527],
          [72.982917785644531, 18.966249465942383],
          [72.98319244384794, 18.966249465942383],
          [72.98319244384794, 18.966810226440487],
          [72.983474731445483, 18.966806411743107],
          [72.983474731445483, 18.967363357544059],
          [72.983749389648494, 18.967359542846737],
          [72.983749389648494, 18.96792030334484],
          [72.984024047851733, 18.967916488647461],
          [72.984024047851733, 18.968471527099666],
          [72.984298706054915, 18.96846961975109],
          [72.984298706054915, 18.969039916992131],
          [72.984580993652287, 18.969028472900447],
          [72.984580993652287, 18.96958160400402],
          [72.984863281250057, 18.96958160400402],
          [72.984863281250057, 18.969863891601563],
          [72.985420227050838, 18.969860076904411],
          [72.985420227050838, 18.970140457153377],
          [72.986251831054972, 18.970140457153377],
          [72.986251831054972, 18.969860076904411],
          [72.986526489257983, 18.969863891601563],
          [72.986526489257983, 18.96958160400402],
          [72.986808776855753, 18.96958160400402],
          [72.986808776855753, 18.969028472900447],
          [72.987075805664233, 18.969039916992131],
          [72.987075805664233, 18.968751907348633],
          [72.987373352050838, 18.968751907348633],
          [72.987358093261946, 18.968471527099666],
          [72.988197326660099, 18.968471527099666],
          [72.988197326660099, 18.968193054199276],
          [72.990142822265796, 18.968200683593807],
          [72.990142822265796, 18.96792030334484],
          [72.993179321289233, 18.96792030334484],
          [72.993179321289233, 18.968200683593807],
          [72.994857788086051, 18.968193054199276],
          [72.994857788086051, 18.968471527099666],
          [72.996238708496264, 18.96846961975109],
          [72.996238708496264, 18.968751907348633],
          [72.996803283691577, 18.968751907348633],
          [72.996803283691577, 18.969039916992131],
          [72.997360229492131, 18.969039916992131],
          [72.997360229492131, 18.969310760498161],
          [72.997917175293082, 18.969303131103629],
          [72.997917175293082, 18.96958160400402],
          [72.998474121094034, 18.96958160400402],
          [72.998474121094034, 18.969863891601563],
          [72.999031066894815, 18.969860076904411],
          [72.999031066894815, 18.970140457153377],
          [72.999580383300838, 18.970140457153377],
          [72.999580383300838, 18.970420837402344],
          [73.00013732910179, 18.970420837402344],
          [73.000419616699389, 18.970417022705192],
          [73.000419616699389, 18.970695495605526],
          [73.001251220703182, 18.970689773559627],
          [73.001251220703182, 18.971250534057731],
          [73.002372741699219, 18.971250534057731],
          [73.002372741699219, 18.971809387207088],
          [73.002639770508097, 18.971805572509709],
          [73.002639770508097, 18.972085952758903],
          [73.002906799316577, 18.972080230712947],
          [73.002906799316577, 18.972360610961914],
          [73.003196716308651, 18.972360610961914],
          [73.003196716308651, 18.972640991211051],
          [73.003471374511889, 18.972640991211051],
          [73.003471374511889, 18.972919464111442],
          [73.003753662109602, 18.972917556762695],
          [73.003753662109602, 18.973194122314453],
          [73.004028320312443, 18.973194122314453],
          [73.004028320312443, 18.973472595214844],
          [73.004302978515682, 18.973470687866268],
          [73.004302978515682, 18.973751068115234],
          [73.004028320312443, 18.973751068115234],
          [73.004028320312443, 18.974309921264762],
          [73.003746032714901, 18.974309921264762],
          [73.003746032714901, 18.975418090820369],
          [73.004859924316406, 18.975418090820369],
          [73.004859924316406, 18.975139617919979],
          [73.005691528320597, 18.975139617919979],
          [73.005691528320597, 18.975418090820369],
          [73.005966186523608, 18.975418090820369],
          [73.005966186523608, 18.976249694824332],
          [73.005691528320597, 18.976249694824332],
          [73.005691528320597, 18.976528167724723],
          [73.005973815918139, 18.976528167724723],
          [73.005973815918139, 18.976804733276481],
          [73.006805419922102, 18.976804733276481],
          [73.006805419922102, 18.977083206176871],
          [73.009025573730639, 18.977083206176871],
          [73.009025573730639, 18.976804733276481],
          [73.011253356933878, 18.976804733276481],
          [73.011253356933878, 18.977083206176871],
          [73.011802673340128, 18.977083206176871],
          [73.011802673340128, 18.977361679077262],
          [73.012077331543139, 18.977359771728516],
          [73.012077331543139, 18.977638244628906],
          [73.012641906738452, 18.977638244628906],
          [73.012641906738452, 18.977920532226619],
          [73.012916564941634, 18.97791671752924],
          [73.012916564941634, 18.978471755981445],
          [73.013465881347713, 18.978469848632869],
          [73.013465881347713, 18.97874832153326],
          [73.013748168945426, 18.97874832153326],
          [73.013748168945426, 18.979032516479549],
          [73.014312744140739, 18.979032516479549],
          [73.014312744140739, 18.979312896728516],
          [73.014862060547159, 18.979305267333984],
          [73.014862060547159, 18.979583740234375],
          [73.015136718750171, 18.979581832885799],
          [73.015136718750171, 18.97986030578619],
          [73.015686035156421, 18.97986030578619],
          [73.015686035156421, 18.980142593383903],
          [73.016250610351733, 18.980142593383903],
          [73.016250610351733, 18.980421066284293],
          [73.016532897949446, 18.980421066284293],
          [73.016532897949446, 18.980979919433651],
          [73.017082214355526, 18.980979919433651],
          [73.017082214355526, 18.98264122009283],
          [73.017349243164347, 18.98264122009283],
          [73.017349243164347, 18.983749389648437],
          [73.017082214355526, 18.983749389648437],
          [73.017082214355526, 18.985420227050895],
          [73.016807556152287, 18.985416412353516],
          [73.016807556152287, 18.985971450805721],
          [73.017082214355526, 18.985969543457145],
          [73.017082214355526, 18.986530303955078],
          [73.017349243164347, 18.986530303955078],
          [73.017349243164347, 18.986810684204215],
          [73.019027709960994, 18.986806869506893],
          [73.019027709960994, 18.987083435058651],
          [73.019302368164233, 18.987083435058651],
          [73.019302368164233, 18.987361907959041],
          [73.019859313964787, 18.987360000610465],
          [73.019859313964787, 18.987640380859432],
          [73.020141601562557, 18.987640380859432],
          [73.020141601562557, 18.987920761108398],
          [73.020416259765739, 18.987918853759822],
          [73.020416259765739, 18.988193511963004],
          [73.02069091796875, 18.988193511963004],
          [73.02069091796875, 18.988471984863395],
          [73.02097320556669, 18.988470077514648],
          [73.02097320556669, 18.989030838012752],
          [73.021247863769531, 18.989030838012752],
          [73.021247863769531, 18.989860534667969],
          [73.021530151367472, 18.989860534667969],
          [73.021530151367472, 18.990148544311637],
          [73.021797180175952, 18.990148544311637],
          [73.021797180175952, 18.99041748046875],
          [73.022087097168026, 18.99041748046875],
          [73.022087097168026, 18.990694046020508],
          [73.022361755371264, 18.990694046020508],
          [73.022361755371264, 18.99041748046875],
          [73.022636413574446, 18.99041748046875],
          [73.022636413574446, 18.990148544311637],
          [73.023193359375057, 18.990137100219727],
          [73.023193359375057, 18.990972518920898],
          [73.02402496337919, 18.990972518920898],
          [73.02402496337919, 18.990694046020508],
          [73.024307250976563, 18.990694046020508],
          [73.024307250976563, 18.99041748046875],
          [73.024581909179972, 18.99041748046875],
          [73.024581909179972, 18.990148544311637],
          [73.024307250976563, 18.990148544311637],
          [73.024307250976563, 18.989860534667969],
          [73.024581909179972, 18.989860534667969],
          [73.024581909179972, 18.989580154419002],
          [73.024864196777514, 18.989583969116325],
          [73.024864196777514, 18.989305496215763],
          [73.025138854980526, 18.989311218261719],
          [73.025138854980526, 18.989030838012752],
          [73.026252746582088, 18.989030838012752],
          [73.026252746582088, 18.988750457763786],
          [73.027359008789063, 18.988750457763786],
          [73.027359008789063, 18.989030838012752],
          [73.027641296387003, 18.989028930664176],
          [73.027641296387003, 18.989583969116325],
          [73.027359008789063, 18.989580154419002],
          [73.027359008789063, 18.99041748046875],
          [73.027084350586222, 18.99041748046875],
          [73.027084350586222, 18.990694046020508],
          [73.027359008789063, 18.990690231323356],
          [73.027359008789063, 18.991249084472713],
          [73.027641296387003, 18.991249084472713],
          [73.027641296387003, 18.992082595825252],
          [73.028190612793026, 18.992082595825252],
          [73.028198242187784, 18.991806030273437],
          [73.028472900390796, 18.991811752319393],
          [73.028472900390796, 18.991249084472713],
          [73.029029846191577, 18.991249084472713],
          [73.029029846191577, 18.991531372070426],
          [73.029602050781421, 18.991531372070426],
          [73.029602050781421, 18.991811752319393],
          [73.029861450195369, 18.991811752319393],
          [73.029861450195369, 18.992359161377067],
          [73.030136108398722, 18.992359161377067],
          [73.030136108398722, 18.992639541626033],
          [73.030982971191406, 18.992639541626033],
          [73.030982971191406, 18.992921829223746],
          [73.031250000000284, 18.992916107177791],
          [73.031250000000284, 18.993194580078182],
          [73.031517028808764, 18.993190765380859],
          [73.031517028808764, 18.993749618530387],
          [73.031806945800838, 18.993749618530387],
          [73.031806945800838, 18.994304656982536],
          [73.032081604004077, 18.994304656982536],
          [73.032081604004077, 18.99458122253418],
          [73.032348632812557, 18.99458122253418],
          [73.032348632812557, 18.996810913085994],
          [73.032081604004077, 18.996803283691463],
          [73.032081604004077, 18.997085571289006],
          [73.031806945800838, 18.997079849243278],
          [73.031806945800838, 18.997920989990348],
          [73.032081604004077, 18.997917175293026],
          [73.032081604004077, 18.998195648193359],
          [73.03236389160179, 18.998195648193359],
          [73.032348632812557, 18.999151229858398],
          [73.032348632812557, 18.999309539794922],
          [73.031806945800838, 18.999305725097713],
          [73.031806945800838, 18.999584197998104],
          [73.031517028808764, 18.999580383300781],
          [73.031524658203296, 19.000139236450309],
          [73.031524658203296, 19.000694274902457],
          [73.031250000000284, 19.000694274902457],
          [73.031250000000284, 19.000972747802848],
          [73.030982971191406, 19.000970840454102],
          [73.030982971191406, 19.001251220703239],
          [73.030418395996094, 19.001251220703239],
          [73.030418395996094, 19.001529693603629],
          [73.030136108398722, 19.001529693603629],
          [73.030136108398722, 19.00180816650402],
          [73.029861450195369, 19.00180816650402],
          [73.029861450195369, 19.002090454101563],
          [73.029289245605526, 19.002090454101563],
          [73.029289245605526, 19.00180816650402],
          [73.028198242187784, 19.00180816650402],
          [73.028190612793026, 19.001529693603629],
          [73.026252746582088, 19.001529693603629],
          [73.026252746582088, 19.00180816650402],
          [73.025970458984318, 19.00180816650402],
          [73.025970458984318, 19.002090454101563],
          [73.025413513183764, 19.002082824707031],
          [73.025413513183764, 19.002361297607422],
          [73.023750305175838, 19.002361297607422],
          [73.023750305175838, 19.002082824707031],
          [73.023193359375057, 19.002090454101563],
          [73.023193359375057, 19.001529693603629],
          [73.019859313964787, 19.001529693603629],
          [73.019859313964787, 19.000970840454102],
          [73.019584655761946, 19.000972747802848],
          [73.019584655761946, 19.000139236450309],
          [73.019577026367244, 18.999580383300781],
          [73.019027709960994, 18.999584197998104],
          [73.019027709960994, 18.999305725097713],
          [73.01763916015625, 18.999309539794922],
          [73.01763916015625, 18.999019622802791],
          [73.017082214355526, 18.999027252197379],
          [73.017082214355526, 18.998750686645565],
          [73.016807556152287, 18.998750686645565],
          [73.016807556152287, 18.998470306396598],
          [73.015975952148494, 18.998470306396598],
          [73.015975952148494, 18.998750686645565],
          [73.014579772949219, 18.998750686645565],
          [73.014579772949219, 18.999027252197379],
          [73.014030456543026, 18.999027252197379],
          [73.014030456543026, 18.998750686645565],
          [73.012641906738452, 18.998750686645565],
          [73.012641906738452, 18.999027252197379],
          [73.011802673340128, 18.999027252197379],
          [73.011802673340128, 18.998750686645565],
          [73.008750915527628, 18.998750686645565],
          [73.008750915527628, 18.999584197998104],
          [73.007919311523494, 18.999580383300781],
          [73.007919311523494, 19.000141143798885],
          [73.007919311523494, 19.000419616699276],
          [73.007637023925895, 19.0004177093507],
          [73.007637023925895, 19.000694274902457],
          [73.006805419922102, 19.000694274902457],
          [73.006805419922102, 19.000972747802848],
          [73.006530761718921, 19.000970840454102],
          [73.006530761718921, 19.001251220703239],
          [73.005966186523608, 19.001251220703239],
          [73.005966186523608, 19.001529693603629],
          [73.003746032714901, 19.001529693603629],
          [73.003746032714901, 19.001251220703239],
          [73.003196716308651, 19.001251220703239],
          [73.003196716308651, 19.001529693603629],
          [73.002906799316577, 19.001529693603629],
          [73.002906799316577, 19.002918243408203],
          [73.002639770508097, 19.00291633605957],
          [73.002639770508097, 19.003471374511776],
          [73.002357482910327, 19.003471374511776],
          [73.002357482910327, 19.004861831665096],
          [73.002082824707315, 19.00485992431652],
          [73.002082824707315, 19.00625038146984],
          [73.001808166503906, 19.00625038146984],
          [73.001808166503906, 19.006811141967773],
          [73.001525878906534, 19.006811141967773],
          [73.001525878906534, 19.009862899780273],
          [73.001808166503906, 19.009862899780273],
          [73.001808166503906, 19.011810302734375],
          [73.001525878906534, 19.011806488037223],
          [73.001525878906534, 19.012361526489371],
          [73.001808166503906, 19.012359619140625],
          [73.001808166503906, 19.012639999389762],
          [73.002082824707315, 19.012639999389762],
          [73.002082824707315, 19.014320373535213],
          [73.001808166503906, 19.014305114746094],
          [73.001808166503906, 19.014583587646484],
          [73.001525878906534, 19.014583587646484],
          [73.001525878906534, 19.014862060546875],
          [73.000968933105582, 19.014860153198299],
          [73.000968933105582, 19.015420913696403],
          [73.000686645507869, 19.015420913696403],
          [73.000686645507869, 19.016807556152401],
          [73.000968933105582, 19.016807556152401],
          [73.000968933105582, 19.017360687255973],
          [73.001251220703182, 19.017360687255973],
          [73.001251220703182, 19.017639160156364],
          [73.001525878906534, 19.017639160156364],
          [73.001525878906534, 19.017921447753906],
          [73.001808166503906, 19.017915725707951],
          [73.001808166503906, 19.018194198608512],
          [73.002082824707315, 19.018194198608512],
          [73.002082824707315, 19.018472671508903],
          [73.002372741699219, 19.018470764160156],
          [73.002372741699219, 19.01903152465826],
          [73.002639770508097, 19.01903152465826],
          [73.002639770508097, 19.019311904907227],
          [73.002914428711108, 19.019306182861271],
          [73.002914428711108, 19.020694732666016],
          [73.002639770508097, 19.020694732666016],
          [73.002639770508097, 19.02097129821783],
          [73.002906799316577, 19.020969390869254],
          [73.002906799316577, 19.021249771118221],
          [73.003196716308651, 19.021249771118221],
          [73.003196716308651, 19.021530151367188],
          [73.003471374511889, 19.021528244018612],
          [73.003471374511889, 19.021804809570369],
          [73.003196716308651, 19.021804809570369],
          [73.003196716308651, 19.022363662719727],
          [73.003471374511889, 19.022359848022575],
          [73.003471374511889, 19.022920608520508],
          [73.003196716308651, 19.022920608520508],
          [73.003196716308651, 19.024860382080078],
          [73.003471374511889, 19.024860382080078],
          [73.003471374511889, 19.025421142578182],
          [73.003746032714901, 19.025421142578182],
          [73.003746032714901, 19.026260375976506],
          [73.004028320312443, 19.026260375976506],
          [73.004028320312443, 19.027639389038143],
          [73.003746032714901, 19.027639389038143],
          [73.003746032714901, 19.02932167053234],
          [73.003471374511889, 19.029306411743278],
          [73.003471374511889, 19.029582977295036],
          [73.003196716308651, 19.029581069946289],
          [73.003196716308651, 19.030139923095817],
          [73.002914428711108, 19.030139923095817],
          [73.002914428711108, 19.030971527099609],
          [73.002639770508097, 19.030969619751033],
          [73.002639770508097, 19.031248092651424],
          [73.002357482910327, 19.031248092651424],
          [73.002357482910327, 19.032360076904354],
          [73.002082824707315, 19.032358169555778],
          [73.002082824707315, 19.032922744751033],
          [73.001808166503906, 19.032922744751033],
          [73.001808166503906, 19.034309387207031],
          [73.001525878906534, 19.034305572509822],
          [73.001525878906534, 19.034582138061637],
          [73.001808166503906, 19.034580230712891],
          [73.001808166503906, 19.035419464111385],
          [73.001525878906534, 19.035417556762809],
          [73.001525878906534, 19.03569221496582],
          [73.001251220703182, 19.03569221496582],
          [73.001251220703182, 19.035974502563533],
          [73.000968933105582, 19.035970687866211],
          [73.000968933105582, 19.036251068115348],
          [73.000686645507869, 19.036251068115348],
          [73.000686645507869, 19.036809921264705],
          [73.000419616699389, 19.036806106567326],
          [73.000419616699389, 19.037084579467717],
          [73.000686645507869, 19.037080764770565],
          [73.000686645507869, 19.037361145019531],
          [73.000419616699389, 19.037361145019531],
          [73.000419616699389, 19.037639617919922],
          [73.000694274902401, 19.037639617919922],
          [73.000694274902401, 19.039583206176815],
          [73.000419616699389, 19.039579391479492],
          [73.000419616699389, 19.040420532226562],
          [73.00013732910179, 19.040420532226562],
          [72.999580383300838, 19.040416717529411],
          [72.999580383300838, 19.040971755981559],
          [72.999305725097827, 19.040971755981559],
          [72.999305725097827, 19.042083740234489],
          [72.999031066894815, 19.042079925537166],
          [72.999031066894815, 19.043750762939453],
          [72.998748779296875, 19.043750762939453],
          [72.998748779296875, 19.044860839843807],
          [72.998466491699503, 19.044860839843807],
          [72.998466491699503, 19.048749923706055],
          [72.998191833496151, 19.048749923706055],
          [72.998191833496151, 19.049030303955192],
          [72.997917175293082, 19.049028396606445],
          [72.997917175293082, 19.049581527710018],
          [72.997642517089901, 19.049579620361442],
          [72.997642517089901, 19.050140380859375],
          [72.997360229492131, 19.050140380859375],
          [72.997360229492131, 19.050420761108512],
          [72.99708557128929, 19.05041694641119],
          [72.99708557128929, 19.050973892211914],
          [72.996803283691577, 19.050970077514762],
          [72.996803283691577, 19.051250457763729],
          [72.996528625488338, 19.051250457763729],
          [72.996528625488338, 19.051530838012695],
          [72.996238708496264, 19.051530838012695],
          [72.996238708496264, 19.051811218261832],
          [72.995971679687784, 19.051811218261832],
          [72.995971679687784, 19.052640914917049],
          [72.995697021484375, 19.052639007568473],
          [72.995681762695483, 19.053180694580135],
          [72.995407104492472, 19.053199768066406],
          [72.995407104492472, 19.053750991821403],
          [72.995140075683651, 19.053750991821403],
          [72.995140075683651, 19.05430984497076],
          [72.994857788086051, 19.05430984497076],
          [72.994857788086051, 19.054861068725586],
          [72.994583129882869, 19.054861068725586],
          [72.994583129882869, 19.055419921875114],
          [72.994308471679631, 19.055416107177734],
          [72.994308471679631, 19.055973052978516],
          [72.994026184082259, 19.05597114562994],
          [72.994026184082259, 19.056259155273438],
          [72.994308471679631, 19.05624961853033],
          [72.994308471679631, 19.056804656982479],
          [72.994026184082259, 19.056804656982479],
          [72.994026184082259, 19.057083129882869],
          [72.993751525879077, 19.057081222534293],
          [72.993751525879077, 19.057918548584041],
          [72.993469238281307, 19.057916641235465],
          [72.993469238281307, 19.058471679687614],
          [72.993179321289233, 19.058469772338867],
          [72.993179321289233, 19.058748245239258],
          [72.992919921875284, 19.058748245239258],
          [72.992919921875284, 19.059032440185547],
          [72.992362976074503, 19.059028625488395],
          [72.992362976074503, 19.059305191039982],
          [72.992080688476562, 19.059305191039982],
          [72.992080688476562, 19.059583663940543],
          [72.991249084472599, 19.059581756591797],
          [72.991249084472599, 19.059860229492188],
          [72.990692138672046, 19.059860229492188],
          [72.990692138672046, 19.060142517089901],
          [72.989860534668253, 19.060142517089901],
          [72.989860534668253, 19.060422897338867],
          [72.98874664306669, 19.060417175292969],
          [72.98874664306669, 19.060693740844727],
          [72.988471984863338, 19.060693740844727],
          [72.988471984863338, 19.060970306396541],
          [72.988197326660099, 19.060970306396541],
          [72.988197326660099, 19.061080932617244],
          [72.988197326660099, 19.061252593994254],
          [72.987922668457259, 19.061252593994254],
          [72.987922668457259, 19.061531066894645],
          [72.987075805664233, 19.061531066894645],
          [72.987075805664233, 19.061809539795036],
          [72.986808776855753, 19.061805725097656],
          [72.986808776855753, 19.062082290649471],
          [72.985687255859659, 19.062080383300895],
          [72.985687255859659, 19.062360763549862],
          [72.984863281250057, 19.062360763549862],
          [72.984863281250057, 19.062641143798828],
          [72.982360839843807, 19.062641143798828],
          [72.982360839843807, 19.062360763549862],
          [72.98014068603544, 19.062360763549862],
          [72.98014068603544, 19.062080383300895],
          [72.978469848632756, 19.062082290649471],
          [72.978469848632756, 19.061805725097656],
          [72.977912902832202, 19.061809539795036],
          [72.977912902832202, 19.061531066894645],
          [72.975982666015739, 19.061531066894645],
          [72.975982666015739, 19.061252593994254],
          [72.974586486816463, 19.061252593994254],
          [72.974586486816463, 19.060970306396541],
          [72.973472595215128, 19.060970306396541],
          [72.973472595215128, 19.060693740844727],
          [72.972640991210994, 19.060693740844727],
          [72.972640991210994, 19.060417175292969],
          [72.971527099609602, 19.060422897338867],
          [72.971527099609602, 19.060142517089901],
          [72.970703125, 19.060142517089901],
          [72.970703125, 19.059860229492188],
          [72.969856262207315, 19.059860229492188],
          [72.969856262207315, 19.059581756591797],
          [72.969581604003963, 19.059581756591797],
          [72.969581604003963, 19.059860229492188],
          [72.968475341797102, 19.059860229492188],
          [72.968475341797102, 19.059583663940543],
          [72.968193054199389, 19.059583663940543],
          [72.968193054199389, 19.059305191039982],
          [72.967918395996151, 19.059305191039982],
          [72.967918395996151, 19.059028625488395],
          [72.966262817382756, 19.059032440185547],
          [72.966262817382756, 19.058748245239258],
          [72.965415954590071, 19.058748245239258],
          [72.965415954590071, 19.058469772338867],
          [72.963195800781364, 19.058471679687614],
          [72.963195800781364, 19.058195114135799],
          [72.962638854980412, 19.058200836181754],
          [72.962638854980412, 19.057918548584041],
          [72.962356567382869, 19.057918548584041],
          [72.962356567382869, 19.056800842285156],
          [72.962081909179858, 19.056804656982479],
          [72.962081909179858, 19.051805496215877],
          [72.962356567382869, 19.051811218261832],
          [72.962356567382869, 19.049579620361442],
          [72.962081909179858, 19.049581527710018],
          [72.962081909179858, 19.049303054809627],
          [72.962356567382869, 19.049310684204158],
          [72.962356567382869, 19.049030303955192],
          [72.962081909179858, 19.049030303955192],
          [72.962081909179858, 19.047067642212028],
          [72.961807250976619, 19.04708290100109],
          [72.961807250976619, 19.046806335449332],
          [72.962081909179858, 19.046810150146484],
          [72.962081909179858, 19.046531677246094],
          [72.961807250976619, 19.046531677246094],
          [72.961807250976619, 19.045690536499023],
          [72.961524963379077, 19.045694351196346],
          [72.961524963379077, 19.045415878295955],
          [72.961250305176065, 19.045421600341911],
          [72.961250305176065, 19.042360305786133],
          [72.960975646972656, 19.042360305786133],
          [72.960975646972656, 19.039583206176815],
          [72.960693359375284, 19.039583206176815],
          [72.960693359375284, 19.038473129272461],
          [72.960418701171875, 19.038473129272461],
          [72.960418701171875, 19.037914276123104],
          [72.960128784179972, 19.037919998169059],
          [72.960128784179972, 19.036809921264705],
          [72.959861755371151, 19.036809921264705],
          [72.959861755371151, 19.035970687866211],
          [72.959587097167912, 19.035974502563533],
          [72.959587097167912, 19.03569221496582],
          [72.959304809570369, 19.03569221496582],
          [72.959304809570369, 19.035417556762809],
          [72.959030151367358, 19.035419464111385],
          [72.959030151367358, 19.034860610962028],
          [72.958717346191463, 19.034856796264648],
          [72.958732604980526, 19.034580230712891],
          [72.958747863769759, 19.034305572509822],
          [72.958473205566577, 19.034309387207031],
          [72.958473205566577, 19.034032821655217],
          [72.958190917968807, 19.034032821655217],
          [72.958190917968807, 19.033470153808707],
          [72.957916259765796, 19.033470153808707],
          [72.957916259765796, 19.033193588256893],
          [72.957641601562784, 19.033193588256893],
          [72.957641601562784, 19.032638549804744],
          [72.957359313964844, 19.032642364502067],
          [72.957359313964844, 19.032068252563477],
          [72.957084655762003, 19.032083511352539],
          [72.957084655762003, 19.031570434570426],
          [72.957084655762003, 19.030694961547795],
          [72.956802368164119, 19.03070068359375],
          [72.956802368164119, 19.030139923095817],
          [72.956527709961051, 19.030139923095817],
          [72.956527709961051, 19.02932167053234],
          [72.956253051757869, 19.02932167053234],
          [72.956253051757869, 19.029029846191463],
          [72.955970764160099, 19.029029846191463],
          [72.955970764160099, 19.028749465942496],
          [72.955696105957259, 19.028749465942496],
          [72.955696105957259, 19.028190612792969],
          [72.955413818359546, 19.028194427490291],
          [72.955413818359546, 19.027639389038143],
          [72.955139160156307, 19.027639389038143],
          [72.955139160156307, 19.027360916137752],
          [72.954856872558764, 19.027360916137752],
          [72.954856872558764, 19.027080535888786],
          [72.954025268554972, 19.027082443237362],
          [72.954025268554972, 19.02680778503418],
          [72.953475952148551, 19.026809692382926],
          [72.953475952148551, 19.025970458984432],
          [72.953193664550838, 19.025972366333008],
          [72.953193664550838, 19.025695800781193],
          [72.952636718750227, 19.025695800781193],
          [72.952636718750227, 19.025417327880859],
          [72.952079772949276, 19.025421142578182],
          [72.952079772949276, 19.025140762329215],
          [72.951812744140796, 19.025140762329215],
          [72.951812744140796, 19.024860382080078],
          [72.951530456543253, 19.024860382080078],
          [72.951530456543253, 19.024311065673828],
          [72.95096588134794, 19.024311065673828],
          [72.95096588134794, 19.024030685424862],
          [72.950691223144531, 19.024030685424862],
          [72.950691223144531, 19.023750305175895],
          [72.95041656494152, 19.023750305175895],
          [72.95041656494152, 19.023469924926758],
          [72.950141906738338, 19.02347373962408],
          [72.950141906738338, 19.02319526672369],
          [72.949859619140568, 19.02319526672369],
          [72.949859619140568, 19.022638320922965],
          [72.949577331543026, 19.022640228271541],
          [72.949577331543026, 19.022359848022575],
          [72.949302673340014, 19.022363662719727],
          [72.949302673340014, 19.021804809570369],
          [72.948471069336222, 19.021804809570369],
          [72.948471069336222, 19.021528244018612],
          [72.947906494140909, 19.021530151367188],
          [72.947906494140909, 19.021249771118221],
          [72.947639465332031, 19.021249771118221],
          [72.947639465332031, 19.02069282531744],
          [72.94736480712902, 19.020694732666016],
          [72.94736480712902, 19.020416259765625],
          [72.946533203125227, 19.020420074463004],
          [72.946533203125227, 19.020128250122127],
          [72.946250915527514, 19.020139694213867],
          [72.946250915527514, 19.019859313964901],
          [72.945686340332202, 19.019859313964901],
          [72.945686340332202, 19.01958084106451],
          [72.945137023925952, 19.019582748413086],
          [72.945137023925952, 19.019027709960938],
          [72.94486236572294, 19.01903152465826],
          [72.94486236572294, 19.018749237060547],
          [72.944580078125, 19.018749237060547],
          [72.944580078125, 19.01903152465826],
          [72.94431304931652, 19.01903152465826],
          [72.94431304931652, 19.018749237060547],
          [72.944030761718807, 19.018749237060547],
          [72.944030761718807, 19.018470764160156],
          [72.943748474121207, 19.018472671508903],
          [72.943748474121207, 19.018194198608512],
          [72.943473815918026, 19.018194198608512],
          [72.943473815918026, 19.017917633056754],
          [72.943176269531364, 19.017921447753906],
          [72.942916870117415, 19.017921447753906],
          [72.942916870117415, 19.017639160156364],
          [72.942642211914233, 19.017639160156364],
          [72.942642211914233, 19.017360687255973],
          [72.942359924316463, 19.017360687255973],
          [72.942359924316463, 19.017089843750114],
          [72.940971374511776, 19.017089843750114],
          [72.940971374511776, 19.016807556152401],
          [72.940406799316463, 19.016807556152401],
          [72.940406799316463, 19.01652908325201],
          [72.940139770507756, 19.01652908325201],
          [72.940139770507756, 19.016250610351619],
          [72.939857482910384, 19.016250610351619],
          [72.939857482910384, 19.015970230102653],
          [72.939025878906421, 19.015972137451229],
          [72.939025878906421, 19.015693664550838],
          [72.938751220703409, 19.015693664550838],
          [72.938751220703409, 19.01541709899908],
          [72.938468933105469, 19.015420913696403],
          [72.938468933105469, 19.015140533447266],
          [72.938186645508097, 19.015140533447266],
          [72.938186645508097, 19.014860153198299],
          [72.937919616699276, 19.014862060546875],
          [72.937919616699276, 19.014583587646484],
          [72.937637329101676, 19.014583587646484],
          [72.937637329101676, 19.014305114746094],
          [72.937362670898494, 19.014320373535213],
          [72.937362670898494, 19.014030456543082],
          [72.936531066894702, 19.014030456543082],
          [72.936531066894702, 19.013750076293945],
          [72.936248779296932, 19.013750076293945],
          [72.936248779296932, 19.013469696044979],
          [72.935691833496378, 19.013471603393555],
          [72.935691833496378, 19.013196945190543],
          [72.935417175292969, 19.013200759887695],
          [72.935417175292969, 19.012920379638729],
          [72.935142517090128, 19.012920379638729],
          [72.935142517090128, 19.012639999389762],
          [72.934860229492188, 19.012639999389762],
          [72.934860229492188, 19.012359619140625],
          [72.934585571289176, 19.012361526489371],
          [72.934585571289176, 19.012083053588981],
          [72.934303283691463, 19.012083053588981],
          [72.934303283691463, 19.011806488037223],
          [72.934028625488224, 19.011810302734375],
          [72.934028625488224, 19.011529922485408],
          [72.933746337890682, 19.011529922485408],
          [72.933746337890682, 19.011249542236442],
          [72.932899475097827, 19.011249542236442],
          [72.932899475097827, 19.010690689086914],
          [72.932357788086108, 19.010692596435661],
          [72.932357788086108, 19.01041412353527],
          [72.931808471679688, 19.010419845581055],
          [72.931808471679688, 19.009862899780273],
          [72.931526184082315, 19.009862899780273],
          [72.931526184082315, 19.009580612182731],
          [72.930969238281364, 19.009584426879883],
          [72.930969238281364, 19.009304046630916],
          [72.930152893066463, 19.009309768676871],
          [72.930152893066463, 19.00875282287609],
          [72.929862976074389, 19.00875282287609],
          [72.929862976074389, 19.008470535278377],
          [72.929306030273608, 19.008470535278377],
          [72.929306030273608, 19.008192062377987],
          [72.928749084472656, 19.008192062377987],
          [72.928749084472656, 19.007917404174805],
          [72.928466796875284, 19.007921218872127],
          [72.928466796875284, 19.007642745971737],
          [72.928192138671932, 19.007642745971737],
          [72.928192138671932, 19.007360458374023],
          [72.927635192871151, 19.007360458374023],
          [72.927635192871151, 19.007083892822379],
          [72.927360534667912, 19.007083892822379],
          [72.927360534667912, 19.006805419921818],
          [72.926795959472827, 19.006811141967773],
          [72.926795959472827, 19.006532669067383],
          [72.926528930664119, 19.006532669067383],
          [72.926528930664119, 19.00625038146984],
          [72.925971984863565, 19.00625038146984],
          [72.925971984863565, 19.00597190856945],
          [72.925697326660156, 19.00597190856945],
          [72.925697326660156, 19.005695343017635],
          [72.925140380859432, 19.00570106506359],
          [72.925140380859432, 19.005420684814453],
          [72.924575805664119, 19.005420684814453],
          [72.924575805664119, 19.005151748657227],
          [72.924308776855412, 19.005151748657227],
          [72.924308776855412, 19.004579544067383],
          [72.92402648925804, 19.004583358764705],
          [72.92402648925804, 19.004304885864315],
          [72.924308776855412, 19.004304885864315],
          [72.924308776855412, 19.004028320312557],
          [72.923751831054858, 19.004028320312557],
          [72.923751831054858, 19.003749847412166],
          [72.923187255859546, 19.003749847412166],
          [72.923187255859546, 19.0034694671632],
          [72.922637939453125, 19.003471374511776],
          [72.922637939453125, 19.003194808959961],
          [72.922080993652344, 19.003194808959961],
          [72.922080993652344, 19.00291633605957],
          [72.921806335449332, 19.002918243408203],
          [72.921806335449332, 19.002090454101563],
          [72.921516418457088, 19.002090454101563],
          [72.921516418457088, 19.00180816650402],
          [72.920692443847827, 19.00180816650402],
          [72.920692443847827, 19.001529693603629],
          [72.920143127441577, 19.001529693603629],
          [72.920143127441577, 19.001251220703239],
          [72.919860839844034, 19.001251220703239],
          [72.919860839844034, 19.000970840454102],
          [72.919586181640625, 19.000972747802848],
          [72.919586181640625, 19.000694274902457],
          [72.919029235839844, 19.000694274902457],
          [72.919029235839844, 19.000139236450309],
          [72.918472290039119, 19.000141143798885],
          [72.918472290039119, 18.999580383300781],
          [72.913749694824276, 18.999580383300781],
          [72.913749694824276, 18.999860763549918],
          [72.913475036621264, 18.999860763549918],
          [72.913475036621264, 18.999584197998104],
          [72.913192749023722, 18.999584197998104],
          [72.913192749023722, 18.999305725097713],
          [72.911796569824276, 18.999309539794922],
          [72.911796569824276, 18.999019622802791],
          [72.911529541015568, 18.999019622802791],
          [72.911529541015568, 18.999309539794922],
          [72.908752441406307, 18.999305725097713],
          [72.908752441406307, 18.999584197998104],
          [72.907363891601733, 18.999584197998104],
          [72.907363891601733, 18.999305725097713],
          [72.906806945800781, 18.999309539794922],
          [72.906806945800781, 18.998189926147461],
          [72.906311035156307, 18.998191833496207],
          [72.905975341796989, 18.998195648193359],
          [72.905975341796989, 18.997638702392635],
          [72.90625, 18.997640609741211],
          [72.90625, 18.997079849243278],
          [72.906524658203409, 18.997085571289006],
          [72.906524658203409, 18.996528625488281],
          [72.90625, 18.996530532837028],
          [72.90625, 18.996810913085994],
          [72.905975341796989, 18.996803283691463],
          [72.905975341796989, 18.997085571289006],
          [72.905693054199276, 18.997079849243278],
          [72.905693054199276, 18.997360229492244],
          [72.905136108398494, 18.997360229492244],
          [72.905136108398494, 18.996530532837028],
          [72.905418395996037, 18.996530532837028],
          [72.905418395996037, 18.99596023559576],
          [72.905693054199276, 18.995973587036246],
          [72.905693054199276, 18.995693206787109],
          [72.90598297119152, 18.995700836181641],
          [72.90598297119152, 18.995420455932674],
          [72.90625, 18.995420455932674],
          [72.90625, 18.995140075683707],
          [72.906517028808878, 18.995140075683707],
          [72.906517028808878, 18.99485969543457],
          [72.906806945800781, 18.994863510131893],
          [72.906806945800781, 18.99458122253418],
          [72.90708160400419, 18.99458122253418],
          [72.90708160400419, 18.994304656982536],
          [72.907363891601733, 18.994304656982536],
          [72.907363891601733, 18.994028091430778],
          [72.907638549804744, 18.99403190612793],
          [72.907638549804744, 18.993749618530387],
          [72.907913208007983, 18.993749618530387],
          [72.907913208007983, 18.99346923828125],
          [72.908195495605696, 18.993471145629996],
          [72.908195495605696, 18.993194580078182],
          [72.908470153808537, 18.993194580078182],
          [72.908470153808537, 18.992916107177791],
          [72.908752441406307, 18.992921829223746],
          [72.908752441406307, 18.992639541626033],
          [72.9093017578125, 18.992639541626033],
          [72.9093017578125, 18.991249084472713],
          [72.907913208007983, 18.991249084472713],
          [72.907913208007983, 18.991531372070426],
          [72.908195495605696, 18.991527557373104],
          [72.908195495605696, 18.992082595825252],
          [72.907638549804744, 18.992080688476676],
          [72.907638549804744, 18.992639541626033],
          [72.907363891601733, 18.992639541626033],
          [72.907363891601733, 18.993194580078182],
          [72.90708160400419, 18.993194580078182],
          [72.90708160400419, 18.993471145629996],
          [72.906806945800781, 18.99346923828125],
          [72.906806945800781, 18.993749618530387],
          [72.906517028808878, 18.993749618530387],
          [72.906517028808878, 18.99403190612793],
          [72.90625, 18.994028091430778],
          [72.90625, 18.994304656982536],
          [72.905975341796989, 18.994304656982536],
          [72.905975341796989, 18.994863510131893],
          [72.905693054199276, 18.99485969543457],
          [72.905693054199276, 18.995140075683707],
          [72.905418395996037, 18.995140075683707],
          [72.905418395996037, 18.995420455932674],
          [72.904861450195483, 18.995420455932674],
          [72.904861450195483, 18.99485969543457],
          [72.904586791992244, 18.994863510131893],
          [72.904586791992244, 18.994028091430778],
          [72.904861450195483, 18.99403190612793],
          [72.904861450195483, 18.99346923828125],
          [72.905136108398494, 18.993471145629996],
          [72.905136108398494, 18.992639541626033],
          [72.905418395996037, 18.992639541626033],
          [72.905418395996037, 18.991811752319393],
          [72.905693054199276, 18.991811752319393],
          [72.905693054199276, 18.991531372070426],
          [72.90625, 18.991531372070426],
          [72.90625, 18.990970611572322],
          [72.906524658203409, 18.990972518920898],
          [72.906524658203409, 18.990694046020508],
          [72.905975341796989, 18.990694046020508],
          [72.905975341796989, 18.99041748046875],
          [72.905418395996037, 18.99041748046875],
          [72.905418395996037, 18.990148544311637],
          [72.905136108398494, 18.990148544311637],
          [72.905136108398494, 18.99041748046875],
          [72.904861450195483, 18.99041748046875],
          [72.904861450195483, 18.992082595825252],
          [72.904586791992244, 18.992080688476676],
          [72.904586791992244, 18.992639541626033],
          [72.904304504394702, 18.992639541626033],
          [72.904304504394702, 18.993194580078182],
          [72.90402984619169, 18.993190765380859],
          [72.90402984619169, 18.995700836181641],
          [72.903747558593921, 18.995700836181641],
          [72.903747558593921, 18.996250152587891],
          [72.903472900390909, 18.996250152587891],
          [72.903472900390909, 18.996810913085994],
          [72.9031982421875, 18.996803283691463],
          [72.9031982421875, 18.997085571289006],
          [72.902915954590128, 18.997079849243278],
          [72.902915954590128, 18.997360229492244],
          [72.898750305175724, 18.997360229492244],
          [72.898750305175724, 18.997079849243278],
          [72.897636413574389, 18.997085571289006],
          [72.897636413574389, 18.996803283691463],
          [72.896530151367244, 18.996810913085994],
          [72.896530151367244, 18.996530532837028],
          [72.895973205566463, 18.996528625488281],
          [72.895973205566463, 18.998195648193359],
          [72.896530151367244, 18.998195648193359],
          [72.896530151367244, 18.997917175293026],
          [72.897636413574389, 18.997917175293026],
          [72.897636413574389, 18.998195648193359],
          [72.897361755371378, 18.998195648193359],
          [72.897361755371378, 18.999027252197379],
          [72.896789550781534, 18.999019622802791],
          [72.896789550781534, 18.999309539794922],
          [72.895690917968693, 18.999309539794922],
          [72.895690917968693, 18.999019622802791],
          [72.895416259765852, 18.999027252197379],
          [72.895416259765852, 18.999584197998104],
          [72.895240783691463, 18.999584197998104],
          [72.890419006347656, 18.999580383300781],
          [72.890419006347656, 18.999860763549918],
          [72.889862060546932, 18.999860763549918],
          [72.889862060546932, 18.999580383300781],
          [72.885971069335881, 18.999580383300781],
          [72.885971069335881, 19.000141143798885],
          [72.885971069335881, 19.003749847412166],
          [72.88569641113304, 19.003749847412166],
          [72.88569641113304, 19.007642745971737],
          [72.885406494140796, 19.007642745971737],
          [72.885414123535327, 19.008192062377987],
          [72.885139465332088, 19.008190155029411],
          [72.885139465332088, 19.009029388427734],
          [72.881813049316577, 19.009029388427734],
          [72.881813049316577, 19.00875282287609],
          [72.881805419922046, 19.007917404174805],
          [72.880691528320312, 19.007921218872127],
          [72.880691528320312, 19.007642745971737],
          [72.879859924316349, 19.007642745971737],
          [72.879859924316349, 19.007360458374023],
          [72.879028320312557, 19.007360458374023],
          [72.879028320312557, 19.007083892822379],
          [72.87430572509794, 19.007083892822379],
          [72.87430572509794, 19.006805419921818],
          [72.873191833496037, 19.006811141967773],
          [72.873191833496037, 19.006532669067383],
          [72.872360229492244, 19.006532669067383],
          [72.872360229492244, 19.00625038146984],
          [72.870971679687557, 19.00625038146984],
          [72.870971679687557, 19.00597190856945],
          [72.870697021484489, 19.00597190856945],
          [72.870697021484489, 19.005416870117301],
          [72.870140075683537, 19.005420684814453],
          [72.870140075683537, 19.005151748657227],
          [72.869308471679744, 19.005151748657227],
          [72.869308471679744, 19.00485992431652],
          [72.867919921875057, 19.004861831665096],
          [72.867919921875057, 19.004583358764705],
          [72.867362976074276, 19.004583358764705],
          [72.867362976074276, 19.004861831665096],
          [72.865692138672159, 19.004861831665096],
          [72.865692138672159, 19.004583358764705],
          [72.864860534667969, 19.004583358764705],
          [72.864860534667969, 19.004304885864315],
          [72.864303588867244, 19.004304885864315],
          [72.864303588867244, 19.004028320312557],
          [72.864036560058537, 19.004028320312557],
          [72.864036560058537, 19.003749847412166],
          [72.863746643066463, 19.003749847412166],
          [72.863746643066463, 19.0034694671632],
          [72.863197326660213, 19.003471374511776],
          [72.863197326660213, 19.003194808959961],
          [72.862640380859659, 19.003194808959961],
          [72.862640380859659, 19.00291633605957],
          [72.862075805664347, 19.002918243408203],
          [72.862075805664347, 19.00180816650402],
          [72.861808776855469, 19.00180816650402],
          [72.861808776855469, 19.000690460205135],
          [72.861526489258097, 19.000694274902457],
          [72.861526489258097, 19.0004177093507],
          [72.860969543457145, 19.000419616699276],
          [72.860969543457145, 19.000141143798885],
          [72.860679626464901, 19.000141143798885],
          [72.860679626464901, 18.999860763549918],
          [72.860420227050952, 18.999860763549918],
          [72.860420227050952, 18.999580383300781],
          [72.860137939453352, 18.999584197998104],
          [72.860137939453352, 18.998750686645565],
          [72.859863281250171, 18.998750686645565],
          [72.859863281250171, 18.998189926147461],
          [72.860137939453352, 18.998195648193359],
          [72.860137939453352, 18.997917175293026],
          [72.860420227050952, 18.997920989990348],
          [72.860420227050952, 18.997360229492244],
          [72.860679626464901, 18.997360229492244],
          [72.860679626464901, 18.997079849243278],
          [72.860969543457145, 18.997085571289006],
          [72.860969543457145, 18.996528625488281],
          [72.861251831054744, 18.996530532837028],
          [72.861251831054744, 18.99596023559576],
          [72.861526489258097, 18.995973587036246],
          [72.861526489258097, 18.995693206787109],
          [72.860420227050952, 18.995700836181641],
          [72.860420227050952, 18.99403190612793],
          [72.860137939453352, 18.99403190612793],
          [72.860137939453352, 18.993749618530387],
          [72.859863281250171, 18.993749618530387],
          [72.859863281250171, 18.99346923828125],
          [72.858749389648437, 18.993471145629996],
          [72.858749389648437, 18.993194580078182],
          [72.859024047851847, 18.993194580078182],
          [72.859024047851847, 18.992916107177791],
          [72.858749389648437, 18.992921829223746],
          [72.858749389648437, 18.992639541626033],
          [72.858467102051065, 18.992639541626033],
          [72.858467102051065, 18.992359161377067],
          [72.857086181640852, 18.992359161377067],
          [72.857086181640852, 18.992080688476676],
          [72.856803894043139, 18.992082595825252],
          [72.856803894043139, 18.991527557373104],
          [72.857086181640852, 18.991531372070426],
          [72.857086181640852, 18.990970611572322],
          [72.857360839843693, 18.990972518920898],
          [72.857360839843693, 18.990137100219727],
          [72.857643127441463, 18.990148544311637],
          [72.857643127441463, 18.989580154419002],
          [72.857917785644645, 18.989583969116325],
          [72.857917785644645, 18.989028930664176],
          [72.858192443847713, 18.989030838012752],
          [72.858192443847713, 18.988189697265682],
          [72.858474731445597, 18.988193511963004],
          [72.858474731445597, 18.987638473510856],
          [72.858749389648437, 18.987640380859432],
          [72.858749389648437, 18.987079620361328],
          [72.859024047851847, 18.987083435058651],
          [72.859024047851847, 18.986528396606502],
          [72.859306335449389, 18.986530303955078],
          [72.859306335449389, 18.985969543457145],
          [72.859580993652401, 18.985971450805721],
          [72.859580993652401, 18.985416412353516],
          [72.859863281250171, 18.985420227050895],
          [72.859863281250171, 18.984859466552791],
          [72.860137939453352, 18.984861373901367],
          [72.860137939453352, 18.984306335449162],
          [72.860420227050952, 18.984310150146541],
          [72.860420227050952, 18.983470916748047],
          [72.860694885253963, 18.983474731445369],
          [72.860694885253963, 18.98236274719244],
          [72.860969543457145, 18.98236274719244],
          [72.860969543457145, 18.981531143188477],
          [72.860679626464901, 18.981531143188477],
          [72.860679626464901, 18.981252670288086],
          [72.860420227050952, 18.981252670288086],
          [72.860420227050952, 18.980979919433651],
          [72.860137939453352, 18.980979919433651],
          [72.860137939453352, 18.980691909790153],
          [72.859863281250171, 18.980693817138729],
          [72.859863281250171, 18.980417251586971],
          [72.859306335449389, 18.980421066284293],
          [72.859306335449389, 18.980142593383903],
          [72.859016418457315, 18.980142593383903],
          [72.859016418457315, 18.97986030578619],
          [72.858749389648437, 18.97986030578619],
          [72.858749389648437, 18.979581832885799],
          [72.858474731445597, 18.979583740234375],
          [72.858474731445597, 18.979305267333984],
          [72.858192443847713, 18.979312896728516],
          [72.858192443847713, 18.97874832153326],
          [72.857910156250114, 18.97874832153326],
          [72.857910156250114, 18.978469848632869],
          [72.857635498046932, 18.978471755981445],
          [72.857635498046932, 18.978195190429631],
          [72.857360839843693, 18.978195190429631],
          [72.857360839843693, 18.978471755981445],
          [72.856246948242358, 18.978469848632869],
          [72.856246948242358, 18.97874832153326],
          [72.855140686035213, 18.97874832153326],
          [72.855140686035213, 18.979032516479549],
          [72.854026794433821, 18.979032516479549],
          [72.854026794433821, 18.979312896728516],
          [72.852638244628906, 18.979312896728516],
          [72.852638244628906, 18.97874832153326],
          [72.852912902832315, 18.97874832153326],
          [72.852912902832315, 18.978469848632869],
          [72.854026794433821, 18.978471755981445],
          [72.854026794433821, 18.978195190429631],
          [72.854866027832145, 18.97821044921875],
          [72.854866027832145, 18.977920532226619],
          [72.855697631835938, 18.977920532226619],
          [72.855697631835938, 18.976800918579158],
          [72.855415344238565, 18.976804733276481],
          [72.855415344238565, 18.976528167724723],
          [72.854858398437614, 18.976528167724723],
          [72.854858398437614, 18.976804733276481],
          [72.853752136230639, 18.976804733276481],
          [72.853752136230639, 18.977083206176871],
          [72.852638244628906, 18.977083206176871],
          [72.852638244628906, 18.977361679077262],
          [72.851249694824162, 18.977361679077262],
          [72.851249694824162, 18.976804733276481],
          [72.851806640625114, 18.976804733276481],
          [72.851806640625114, 18.976528167724723],
          [72.852638244628906, 18.976528167724723],
          [72.852638244628906, 18.976249694824332],
          [72.854026794433821, 18.976249694824332],
          [72.854026794433821, 18.975971221923942],
          [72.855415344238565, 18.975973129272518],
          [72.855415344238565, 18.974306106567383],
          [72.854858398437614, 18.974306106567383],
          [72.854858398437614, 18.974582672119197],
          [72.853752136230639, 18.974582672119197],
          [72.853752136230639, 18.974861145019588],
          [72.851524353027401, 18.974861145019588],
          [72.851524353027401, 18.974582672119197],
          [72.851249694824162, 18.974582672119197],
          [72.851249694824162, 18.974306106567383],
          [72.851516723632869, 18.974309921264762],
          [72.851516723632869, 18.974029541015625],
          [72.852912902832315, 18.974029541015625],
          [72.852912902832315, 18.973751068115234],
          [72.853752136230639, 18.973751068115234],
          [72.853752136230639, 18.973470687866268],
          [72.853469848632869, 18.973472595214844],
          [72.853469848632869, 18.972917556762695],
          [72.853202819824389, 18.972919464111442],
          [72.853202819824389, 18.972360610961914],
          [72.852912902832315, 18.972360610961914],
          [72.852912902832315, 18.972080230712947],
          [72.851806640625114, 18.972080230712947],
          [72.851806640625114, 18.972360610961914],
          [72.851249694824162, 18.972360610961914],
          [72.851249694824162, 18.972640991211051],
          [72.850135803222827, 18.972640991211051],
          [72.850135803222827, 18.972080230712947],
          [72.850418090820369, 18.972085952758903],
          [72.850418090820369, 18.971250534057731],
          [72.850692749023608, 18.971250534057731],
          [72.850692749023608, 18.970689773559627],
          [72.850975036621321, 18.970695495605526],
          [72.850975036621321, 18.969303131103629],
          [72.851516723632869, 18.969310760498161],
          [72.851516723632869, 18.969039916992131],
          [72.852081298828125, 18.969039916992131],
          [72.852081298828125, 18.96764183044445],
          [72.851249694824162, 18.96764183044445],
          [72.851249694824162, 18.967359542846737],
          [72.850975036621321, 18.967363357544059],
          [72.850975036621321, 18.967081069946346],
          [72.850692749023608, 18.967081069946346],
          [72.850692749023608, 18.966806411743107],
          [72.850418090820369, 18.966810226440487],
          [72.850418090820369, 18.966531753540096],
          [72.850135803222827, 18.966531753540096],
          [72.850135803222827, 18.966249465942383],
          [72.849861145019815, 18.966249465942383],
          [72.849861145019815, 18.965421676635742],
          [72.849586486816406, 18.965421676635742],
          [72.849586486816406, 18.964311599731559],
          [72.849296569824503, 18.964311599731559],
          [72.849296569824503, 18.963188171386719],
          [72.849029541015625, 18.963193893432674],
          [72.849029541015625, 18.96208381652832],
          [72.848747253418253, 18.96208381652832],
          [72.848747253418253, 18.960971832275391],
          [72.848472595214901, 18.960971832275391],
          [72.848472595214901, 18.959583282470817],
          [72.848197937011662, 18.959583282470817],
          [72.848197937011662, 18.957916259765682],
          [72.847923278808821, 18.957920074462891],
          [72.847923278808821, 18.956809997558707],
          [72.847640991211108, 18.956809997558707],
          [72.847640991211108, 18.955970764160213],
          [72.847358703613509, 18.955974578857365],
          [72.847358703613509, 18.954860687255859],
          [72.847076416015796, 18.954860687255859],
          [72.847076416015796, 18.953752517700252],
          [72.846801757812557, 18.953752517700252],
          [72.846801757812557, 18.948190689086971],
          [72.846527099609546, 18.948194503784293],
          [72.846527099609546, 18.947360992431754],
          [72.846252441406534, 18.947360992431754],
          [72.846252441406534, 18.946250915527401],
          [72.845970153808594, 18.946250915527401],
          [72.845970153808594, 18.94431114196783],
          [72.845703125000114, 18.94431114196783],
          [72.845703125000114, 18.94153022766119],
          [72.845413208007869, 18.94153022766119],
          [72.845413208007869, 18.939859390258903],
          [72.845138549804801, 18.939859390258903],
          [72.845138549804801, 18.939306259155273],
          [72.844856262207088, 18.939310073852653],
          [72.844856262207088, 18.937360763549805],
          [72.844581604003849, 18.937360763549805],
          [72.844581604003849, 18.937080383300838],
          [72.844306945801009, 18.937084197998161],
          [72.844306945801009, 18.936805725097599],
          [72.844017028808764, 18.936807632446403],
          [72.844017028808764, 18.936529159546012],
          [72.843750000000057, 18.936529159546012],
          [72.843750000000057, 18.935970306396484],
          [72.843475341797046, 18.935972213745231],
          [72.843475341797046, 18.93569374084484],
          [72.843193054199503, 18.93569374084484],
          [72.843193054199503, 18.935138702392692],
          [72.843482971191406, 18.935140609741268],
          [72.843482971191406, 18.933750152587947],
          [72.843750000000057, 18.933750152587947],
          [72.843750000000057, 18.932081222534237],
          [72.844024658203296, 18.932083129882812],
          [72.844024658203296, 18.9298610687257],
          [72.844306945801009, 18.929870605468807],
          [72.844306945801009, 18.929029464721737],
          [72.844017028808764, 18.929029464721737],
          [72.844017028808764, 18.928470611572379],
          [72.843475341797046, 18.928470611572379],
          [72.843475341797046, 18.928192138671989],
          [72.842636108398722, 18.928192138671989],
          [72.842636108398722, 18.928470611572379],
          [72.842361450195369, 18.928470611572379],
          [72.842361450195369, 18.928752899169922],
          [72.842086791992301, 18.928752899169922],
          [72.842086791992301, 18.931249618530273],
          [72.841804504394588, 18.931249618530273],
          [72.841804504394588, 18.932083129882812],
          [72.841529846191349, 18.932083129882812],
          [72.841529846191349, 18.932361602783203],
          [72.840698242187557, 18.932361602783203],
          [72.840690612793026, 18.930414199829102],
          [72.840415954590014, 18.930419921875057],
          [72.840415954590014, 18.93013954162609],
          [72.839859008789063, 18.93013954162609],
          [72.839859008789063, 18.929584503173885],
          [72.839584350586222, 18.929584503173885],
          [72.839584350586222, 18.929306030273494],
          [72.839302062988281, 18.929309844970703],
          [72.839302062988281, 18.929029464721737],
          [72.838752746582088, 18.929029464721737],
          [72.838752746582088, 18.928752899169922],
          [72.838470458984318, 18.928752899169922],
          [72.838470458984318, 18.928470611572379],
          [72.838195800781477, 18.928470611572379],
          [72.838195800781477, 18.928192138671989],
          [72.838470458984318, 18.928192138671989],
          [72.838470458984318, 18.927917480468807],
          [72.838752746582088, 18.927919387817383],
          [72.838752746582088, 18.927642822265739],
          [72.839302062988281, 18.927642822265739],
          [72.839302062988281, 18.927919387817383],
          [72.840415954590014, 18.927919387817383],
          [72.840415954590014, 18.927642822265739],
          [72.840690612793026, 18.927642822265739],
          [72.840690612793026, 18.927360534668026],
          [72.840415954590014, 18.927360534668026],
          [72.840415954590014, 18.926811218261776],
          [72.840141296387003, 18.926811218261776],
          [72.840141296387003, 18.926532745361385],
          [72.83957672119169, 18.926532745361385],
          [72.83957672119169, 18.926252365112418],
          [72.839302062988281, 18.926252365112418],
          [72.839302062988281, 18.925970077514705],
          [72.838752746582088, 18.925970077514705],
          [72.838752746582088, 18.925695419311467],
          [72.838470458984318, 18.925689697265739],
          [72.838470458984318, 18.925416946411076],
          [72.838752746582088, 18.925422668457031],
          [72.838752746582088, 18.924858093261719],
          [72.83902740478527, 18.924861907959098],
          [72.83902740478527, 18.924304962158317],
          [72.839302062988281, 18.924310684204102],
          [72.839302062988281, 18.924028396606559],
          [72.83957672119169, 18.924028396606559],
          [72.83957672119169, 18.923469543457031],
          [72.839859008789063, 18.923471450805778],
          [72.839859008789063, 18.922916412353572],
          [72.840141296387003, 18.922918319702205],
          [72.840141296387003, 18.922359466552848],
          [72.840972900390796, 18.922359466552848],
          [72.840972900390796, 18.922639846801815],
          [72.841247558593977, 18.922639846801815],
          [72.841247558593977, 18.922918319702205],
          [72.841529846191349, 18.922916412353572],
          [72.841529846191349, 18.923194885253963],
          [72.841804504394588, 18.923194885253963],
          [72.841804504394588, 18.923471450805778],
          [72.842361450195369, 18.923471450805778],
          [72.842361450195369, 18.923749923706168],
          [72.842636108398722, 18.923740386962834],
          [72.842636108398722, 18.924028396606559],
          [72.842918395996094, 18.924028396606559],
          [72.842918395996094, 18.924583435058707],
          [72.843193054199503, 18.924583435058707],
          [72.843193054199503, 18.924861907959098],
          [72.843750000000057, 18.924858093261719],
          [72.843750000000057, 18.925422668457031],
          [72.844024658203296, 18.925416946411076],
          [72.844024658203296, 18.925693511962891],
          [72.844306945801009, 18.925693511962891],
          [72.844306945801009, 18.925970077514705],
          [72.844863891601619, 18.925970077514705],
          [72.844863891601619, 18.924861907959098],
          [72.844581604003849, 18.924861907959098],
          [72.844581604003849, 18.924304962158317],
          [72.844306945801009, 18.924310684204102],
          [72.844306945801009, 18.924028396606559],
          [72.843750000000057, 18.924028396606559],
          [72.843750000000057, 18.923740386962834],
          [72.843475341797046, 18.923749923706168],
          [72.843475341797046, 18.923471450805778],
          [72.843193054199503, 18.923471450805778],
          [72.843193054199503, 18.923194885253963],
          [72.842918395996094, 18.923194885253963],
          [72.842918395996094, 18.922916412353572],
          [72.842636108398722, 18.922918319702205],
          [72.842636108398722, 18.922359466552848],
          [72.842361450195369, 18.922361373901424],
          [72.842361450195369, 18.922082901001033],
          [72.842086791992301, 18.922082901001033],
          [72.842086791992301, 18.921806335449219],
          [72.841796875000057, 18.921808242797852],
          [72.841796875000057, 18.921529769897461],
          [72.841529846191349, 18.921529769897461],
          [72.841529846191349, 18.920970916748104],
          [72.841247558593977, 18.92097282409668],
          [72.841247558593977, 18.920694351196289],
          [72.840972900390796, 18.920694351196289],
          [72.840972900390796, 18.920417785644531],
          [72.840415954590014, 18.920419692993278],
          [72.840415954590014, 18.920141220092887],
          [72.83957672119169, 18.920141220092887],
          [72.83957672119169, 18.91986083984375],
          [72.838752746582088, 18.91986083984375],
          [72.838752746582088, 18.920141220092887],
          [72.838195800781477, 18.920141220092887],
          [72.838195800781477, 18.920419692993278],
          [72.837913513183764, 18.920417785644531],
          [72.837913513183764, 18.920694351196289],
          [72.837364196777514, 18.920694351196289],
          [72.837364196777514, 18.92097282409668],
          [72.836799621582202, 18.920970916748104],
          [72.836799621582202, 18.921249389648494],
          [72.836517333984659, 18.921249389648494],
          [72.836517333984659, 18.921529769897461],
          [72.836250305175781, 18.921529769897461],
          [72.836250305175781, 18.921808242797852],
          [72.83597564697277, 18.921806335449219],
          [72.83597564697277, 18.922082901001033],
          [72.835418701171818, 18.922082901001033],
          [72.835418701171818, 18.922361373901424],
          [72.834861755371264, 18.922361373901424],
          [72.834861755371264, 18.921806335449219],
          [72.835136413574276, 18.921808242797852],
          [72.835136413574276, 18.921249389648494],
          [72.834587097168026, 18.921249389648494],
          [72.834587097168026, 18.921529769897461],
          [72.834030151367472, 18.921529769897461],
          [72.834030151367472, 18.921249389648494],
          [72.83319091796875, 18.921249389648494],
          [72.83319091796875, 18.920419692993278],
          [72.832916259765909, 18.920419692993278],
          [72.832916259765909, 18.919309616088924],
          [72.832641601562557, 18.919309616088924],
          [72.832641601562557, 18.91847038269043],
          [72.832359313964957, 18.918472290039176],
          [72.832359313964957, 18.917917251587028],
          [72.832077026367244, 18.917930603027287],
          [72.832077026367244, 18.917360305786246],
          [72.831802368164006, 18.917360305786246],
          [72.831802368164006, 18.917079925537109],
          [72.831527709961165, 18.917085647583008],
          [72.831527709961165, 18.916803359985465],
          [72.831253051757983, 18.916810989379996],
          [72.831253051757983, 18.916530609130859],
          [72.830970764160213, 18.916530609130859],
          [72.830970764160213, 18.916250228881893],
          [72.830406188965128, 18.916250228881893],
          [72.830406188965128, 18.915969848632926],
          [72.830970764160213, 18.915973663330078],
          [72.830970764160213, 18.915695190429688],
          [72.831253051757983, 18.915700912475643],
          [72.831253051757983, 18.914579391479606],
          [72.830970764160213, 18.914581298828182],
          [72.830970764160213, 18.914304733276367],
          [72.830696105957202, 18.914304733276367],
          [72.830696105957202, 18.914028167724609],
          [72.830406188965128, 18.914030075073356],
          [72.830406188965128, 18.913749694824219],
          [72.83013916015625, 18.913749694824219],
          [72.83013916015625, 18.914030075073356],
          [72.829582214355526, 18.914030075073356],
          [72.829582214355526, 18.913190841674862],
          [72.829307556152457, 18.913194656372184],
          [72.829307556152457, 18.912916183471623],
          [72.829032897949276, 18.912921905517578],
          [72.829032897949276, 18.912641525268612],
          [72.828750610351506, 18.912641525268612],
          [72.828750610351506, 18.912359237670898],
          [72.828475952148665, 18.912359237670898],
          [72.828475952148665, 18.912080764770508],
          [72.828193664550952, 18.912082672119254],
          [72.828193664550952, 18.91180610656744],
          [72.827919006347713, 18.91180610656744],
          [72.827919006347713, 18.911527633667106],
          [72.827636718750171, 18.911531448364258],
          [72.827636718750171, 18.911249160766715],
          [72.827362060547159, 18.911249160766715],
          [72.827362060547159, 18.910970687866325],
          [72.827079772949219, 18.910972595214901],
          [72.827079772949219, 18.909860610961971],
          [72.826805114746378, 18.909860610961971],
          [72.826805114746378, 18.909027099609375],
          [72.826530456543026, 18.909030914306754],
          [72.826530456543026, 18.908470153808651],
          [72.826248168945426, 18.908472061157227],
          [72.826248168945426, 18.908193588256836],
          [72.825973510742244, 18.908193588256836],
          [72.825973510742244, 18.907918930053825],
          [72.825691223144474, 18.907920837402401],
          [72.825691223144474, 18.907640457153434],
          [72.825416564941634, 18.907640457153434],
          [72.825416564941634, 18.907360076904297],
          [72.825141906738452, 18.907360076904297],
          [72.825141906738452, 18.907640457153434],
          [72.824859619140682, 18.907640457153434],
          [72.824859619140682, 18.907920837402401],
          [72.824584960937671, 18.907918930053825],
          [72.824584960937671, 18.908193588256836],
          [72.824302673340128, 18.908193588256836],
          [72.824302673340128, 18.908472061157227],
          [72.823753356933878, 18.908472061157227],
          [72.823753356933878, 18.908750534057617],
          [72.823471069335938, 18.908740997314453],
          [72.823471069335938, 18.909030914306754],
          [72.823196411132926, 18.909030914306754],
          [72.823196411132926, 18.909307479858398],
          [72.822914123535213, 18.909305572509766],
          [72.822914123535213, 18.909584045410156],
          [72.822357177734432, 18.909580230713004],
          [72.822357177734432, 18.909860610961971],
          [72.821800231933821, 18.909860610961971],
          [72.821800231933821, 18.909580230713004],
          [72.821525573730639, 18.909584045410156],
          [72.821525573730639, 18.909305572509766],
          [72.820968627929858, 18.909307479858398],
          [72.820968627929858, 18.909030914306754],
          [72.820686340332315, 18.909030914306754],
          [72.820686340332315, 18.908470153808651],
          [72.820968627929858, 18.908472061157227],
          [72.820968627929858, 18.908193588256836],
          [72.820693969726847, 18.908193588256836],
          [72.820693969726847, 18.907638549804631],
          [72.820419311523438, 18.907640457153434],
          [72.820419311523438, 18.907360076904297],
          [72.819862365722713, 18.907361984253043],
          [72.819862365722713, 18.907083511352653],
          [72.819030761718921, 18.907083511352653],
          [72.819030761718921, 18.906806945800838],
          [72.818885803222656, 18.906806945800838],
          [72.81874084472679, 18.906810760498047],
          [72.81874084472679, 18.90653038024908],
          [72.818466186523608, 18.90653038024908],
          [72.818466186523608, 18.903472900390625],
          [72.818191528320369, 18.903474807739201],
          [72.818191528320369, 18.902639389038086],
          [72.817916870117358, 18.902639389038086],
          [72.817916870117358, 18.901531219482479],
          [72.817642211914347, 18.901531219482479],
          [72.817642211914347, 18.900970458984375],
          [72.817359924316406, 18.900970458984375],
          [72.817359924316406, 18.900417327880916],
          [72.817092895507926, 18.900421142578125],
          [72.817092895507926, 18.900142669677734],
          [72.816802978515682, 18.900142669677734],
          [72.816802978515682, 18.899570465087891],
          [72.816528320312614, 18.899583816528377],
          [72.816528320312614, 18.899026870727596],
          [72.816246032714901, 18.899032592773551],
          [72.816246032714901, 18.898748397827205],
          [72.815406799316577, 18.898748397827205],
          [72.815406799316577, 18.898199081421012],
          [72.815139770507869, 18.898199081421012],
          [72.815139770507869, 18.897359848022518],
          [72.814857482910327, 18.897361755371094],
          [72.814857482910327, 18.897083282470703],
          [72.814582824707315, 18.897083282470703],
          [72.814582824707315, 18.896804809570313],
          [72.814308166503906, 18.896804809570313],
          [72.814308166503906, 18.896249771118164],
          [72.814025878906534, 18.896249771118164],
          [72.814025878906534, 18.895969390869141],
          [72.813751220703182, 18.895971298217773],
          [72.813751220703182, 18.895694732666129],
          [72.813468933105582, 18.895694732666129],
          [72.813468933105582, 18.895139694213981],
          [72.813186645507869, 18.895139694213981],
          [72.813186645507869, 18.89486122131359],
          [72.812919616699162, 18.89486122131359],
          [72.812919616699162, 18.894580841064453],
          [72.81263732910179, 18.8945827484132],
          [72.81263732910179, 18.894027709960994],
          [72.811813354492358, 18.894029617309627],
          [72.811813354492358, 18.893190383911076],
          [72.811531066894815, 18.893194198608455],
          [72.811531066894815, 18.892639160156307],
          [72.810966491699503, 18.892641067504883],
          [72.810966491699503, 18.892360687255916],
          [72.809860229492131, 18.892360687255916],
          [72.809860229492131, 18.89208030700695],
          [72.809303283691577, 18.892084121704102],
          [72.809303283691577, 18.891805648803711],
          [72.808471679687784, 18.89180946350109],
          [72.808471679687784, 18.890970230102596],
          [72.808197021484375, 18.890972137451172],
          [72.808197021484375, 18.890695571899357],
          [72.807914733887003, 18.890695571899357],
          [72.807914733887003, 18.890972137451172],
          [72.807640075683594, 18.890970230102596],
          [72.807640075683594, 18.89180946350109],
          [72.807907104492472, 18.89180946350109],
          [72.807907104492472, 18.892641067504883],
          [72.808197021484375, 18.892639160156307],
          [72.808197021484375, 18.893472671508846],
          [72.808471679687784, 18.89347076416027],
          [72.808471679687784, 18.894308090210018],
          [72.808197021484375, 18.894306182861385],
          [72.808197021484375, 18.8945827484132],
          [72.807907104492472, 18.894580841064453],
          [72.807907104492472, 18.89486122131359],
          [72.807640075683594, 18.89486122131359],
          [72.807640075683594, 18.895139694213981],
          [72.807357788086222, 18.895139694213981],
          [72.807357788086222, 18.895694732666129],
          [72.807083129882869, 18.895694732666129],
          [72.807083129882869, 18.895971298217773],
          [72.80680084228527, 18.895969390869141],
          [72.80680084228527, 18.896249771118164],
          [72.806526184082088, 18.896249771118164],
          [72.806526184082088, 18.896528244018498],
          [72.806251525879077, 18.896528244018498],
          [72.806251525879077, 18.897083282470703],
          [72.805969238281477, 18.897083282470703],
          [72.805969238281477, 18.897361755371094],
          [72.805686950683764, 18.897359848022518],
          [72.805686950683764, 18.897920608520621],
          [72.805419921875284, 18.897920608520621],
          [72.805419921875284, 18.898199081421012],
          [72.805137634277514, 18.898199081421012],
          [72.805137634277514, 18.898748397827205],
          [72.804862976074503, 18.898748397827205],
          [72.804862976074503, 18.899311065673942],
          [72.804580688476562, 18.899311065673942],
          [72.804580688476562, 18.900142669677734],
          [72.804306030273722, 18.900138854980582],
          [72.804306030273722, 18.900970458984375],
          [72.804031372070369, 18.900970458984375],
          [72.804031372070369, 18.902362823486442],
          [72.80374908447277, 18.902362823486442],
          [72.803756713867131, 18.90374946594244],
          [72.803474426269588, 18.90374946594244],
          [72.803474426269588, 18.907361984253043],
          [72.80374908447277, 18.907361984253043],
          [72.80374908447277, 18.908472061157227],
          [72.804031372070369, 18.908470153808651],
          [72.804031372070369, 18.909307479858398],
          [72.804306030273722, 18.909305572509766],
          [72.804306030273722, 18.909584045410156],
          [72.804580688476562, 18.909580230713004],
          [72.804580688476562, 18.910139083862362],
          [72.804862976074503, 18.910139083862362],
          [72.804862976074503, 18.910417556762752],
          [72.805137634277514, 18.910417556762752],
          [72.805137634277514, 18.910972595214901],
          [72.805419921875284, 18.910970687866325],
          [72.805419921875284, 18.911531448364258],
          [72.805694580078296, 18.911527633667106],
          [72.805694580078296, 18.91180610656744],
          [72.805969238281477, 18.911800384521541],
          [72.805969238281477, 18.912359237670898],
          [72.806251525879077, 18.912359237670898],
          [72.806251525879077, 18.912921905517578],
          [72.806526184082088, 18.912916183471623],
          [72.806526184082088, 18.913194656372184],
          [72.806808471679631, 18.913194656372184],
          [72.806808471679631, 18.913471221923828],
          [72.807083129882869, 18.913469314575252],
          [72.807083129882869, 18.914030075073356],
          [72.807357788086222, 18.914028167724609],
          [72.807357788086222, 18.914304733276367],
          [72.807640075683594, 18.914304733276367],
          [72.807640075683594, 18.914581298828182],
          [72.808197021484375, 18.914579391479606],
          [72.808197021484375, 18.914871215820256],
          [72.808471679687784, 18.914871215820256],
          [72.808471679687784, 18.914579391479606],
          [72.808746337890796, 18.914581298828182],
          [72.808746337890796, 18.914304733276367],
          [72.809028625488338, 18.914304733276367],
          [72.809028625488338, 18.914028167724609],
          [72.809303283691577, 18.914030075073356],
          [72.809303283691577, 18.913749694824219],
          [72.809593200683821, 18.913749694824219],
          [72.80958557128929, 18.913471221923828],
          [72.809860229492131, 18.913471221923828],
          [72.809860229492131, 18.913194656372184],
          [72.810142517089901, 18.913194656372184],
          [72.810142517089901, 18.912916183471623],
          [72.810691833496094, 18.912921905517578],
          [72.810691833496094, 18.912641525268612],
          [72.810966491699503, 18.912641525268612],
          [72.810966491699503, 18.912359237670898],
          [72.811248779296875, 18.912359237670898],
          [72.811248779296875, 18.912080764770508],
          [72.811531066894815, 18.912082672119254],
          [72.811531066894815, 18.911527633667106],
          [72.811813354492358, 18.911531448364258],
          [72.811813354492358, 18.911249160766715],
          [72.812919616699162, 18.911249160766715],
          [72.812919616699162, 18.911531448364258],
          [72.813468933105582, 18.911527633667106],
          [72.813468933105582, 18.91180610656744],
          [72.813751220703182, 18.91180610656744],
          [72.813751220703182, 18.912082672119254],
          [72.814025878906534, 18.912080764770508],
          [72.814025878906534, 18.912359237670898],
          [72.814582824707315, 18.912359237670898],
          [72.814582824707315, 18.912921905517578],
          [72.814857482910327, 18.912916183471623],
          [72.814857482910327, 18.913194656372184],
          [72.815414428711108, 18.913194656372184],
          [72.815414428711108, 18.914581298828182],
          [72.815696716308821, 18.914579391479606],
          [72.815696716308821, 18.914871215820256],
          [72.815971374511662, 18.914871215820256],
          [72.815971374511662, 18.915140151977539],
          [72.816246032714901, 18.915140151977539],
          [72.816246032714901, 18.915420532226676],
          [72.816528320312614, 18.915420532226676],
          [72.816528320312614, 18.916250228881893],
          [72.816246032714901, 18.916250228881893],
          [72.816246032714901, 18.916530609130859],
          [72.815971374511662, 18.916530609130859],
          [72.815971374511662, 18.917640686035213],
          [72.816253662109432, 18.917638778686637],
          [72.816253662109432, 18.918195724487362],
          [72.816528320312614, 18.918195724487362],
          [72.816528320312614, 18.918472290039176],
          [72.817642211914347, 18.918472290039176],
          [72.817642211914347, 18.918195724487362],
          [72.818473815918139, 18.918195724487362],
          [72.818473815918139, 18.917917251587028],
          [72.819580078125114, 18.917930603027287],
          [72.819580078125114, 18.917640686035213],
          [72.820968627929858, 18.917640686035213],
          [72.820968627929858, 18.917360305786246],
          [72.821250915527628, 18.917360305786246],
          [72.821250915527628, 18.917079925537109],
          [72.821525573730639, 18.917085647583008],
          [72.821525573730639, 18.916803359985465],
          [72.822364807129134, 18.916803359985465],
          [72.822364807129134, 18.917085647583008],
          [72.822639465331974, 18.917079925537109],
          [72.822639465331974, 18.917360305786246],
          [72.822906494140682, 18.917360305786246],
          [72.822906494140682, 18.917930603027287],
          [72.823196411132926, 18.917917251587028],
          [72.823196411132926, 18.918195724487362],
          [72.823471069335938, 18.918190002441463],
          [72.823471069335938, 18.918750762939567],
          [72.823753356933878, 18.918750762939567],
          [72.823753356933878, 18.919031143188533],
          [72.824066162109432, 18.919031143188533],
          [72.824302673340128, 18.919031143188533],
          [72.824302673340128, 18.919309616088924],
          [72.824584960937671, 18.919305801391545],
          [72.824584960937671, 18.919582366943359],
          [72.825416564941634, 18.919580459594783],
          [72.825416564941634, 18.920141220092887],
          [72.824859619140682, 18.920139312744141],
          [72.824859619140682, 18.92035102844244],
          [72.824859619140682, 18.921808242797852],
          [72.825141906738452, 18.921808242797852],
          [72.825141906738452, 18.922639846801815],
          [72.824302673340128, 18.922639846801815],
          [72.824302673340128, 18.922359466552848],
          [72.823753356933878, 18.922361373901424],
          [72.823753356933878, 18.922082901001033],
          [72.823196411132926, 18.922080993652457],
          [72.823196411132926, 18.922639846801815],
          [72.822906494140682, 18.922639846801815],
          [72.822906494140682, 18.922918319702205],
          [72.822364807129134, 18.922916412353572],
          [72.822364807129134, 18.923194885253963],
          [72.821807861328182, 18.923194885253963],
          [72.821807861328182, 18.923471450805778],
          [72.820968627929858, 18.923471450805778],
          [72.820968627929858, 18.923749923706168],
          [72.819862365722713, 18.923740386962834],
          [72.819862365722713, 18.924028396606559],
          [72.819313049316634, 18.924028396606559],
          [72.819313049316634, 18.924310684204102],
          [72.819030761718921, 18.924304962158317],
          [72.819030761718921, 18.924583435058707],
          [72.818748474121321, 18.924583435058707],
          [72.818748474121321, 18.924861907959098],
          [72.818473815918139, 18.924861907959098],
          [72.818473815918139, 18.925693511962891],
          [72.81874084472679, 18.925689697265739],
          [72.81874084472679, 18.926532745361385],
          [72.819030761718921, 18.926532745361385],
          [72.819030761718921, 18.926811218261776],
          [72.819305419921932, 18.92680549621582],
          [72.819305419921932, 18.927082061767635],
          [72.819862365722713, 18.927080154419059],
          [72.819862365722713, 18.927360534668026],
          [72.820137023926065, 18.927360534668026],
          [72.820137023926065, 18.927919387817383],
          [72.820419311523438, 18.927917480468807],
          [72.820419311523438, 18.928192138671989],
          [72.820686340332315, 18.928190231323242],
          [72.820686340332315, 18.928752899169922],
          [72.820968627929858, 18.928752899169922],
          [72.820968627929858, 18.929309844970703],
          [72.821250915527628, 18.929306030273494],
          [72.821250915527628, 18.929584503173885],
          [72.821525573730639, 18.929584503173885],
          [72.821525573730639, 18.93013954162609],
          [72.821800231933821, 18.93013954162609],
          [72.821800231933821, 18.930419921875057],
          [72.822082519531421, 18.930414199829102],
          [72.822082519531421, 18.930973052978629],
          [72.822357177734432, 18.930971145629883],
          [72.822357177734432, 18.931529998779411],
          [72.822639465331974, 18.931528091430664],
          [72.822639465331974, 18.932083129882812],
          [72.822914123535213, 18.932083129882812],
          [72.822914123535213, 18.932916641235352],
          [72.823196411132926, 18.932910919189453],
          [72.823196411132926, 18.933750152587947],
          [72.823471069335938, 18.933750152587947],
          [72.823471069335938, 18.934860229492301],
          [72.823753356933878, 18.934860229492301],
          [72.823753356933878, 18.940141677856445],
          [72.823471069335938, 18.940141677856445],
          [72.823471069335938, 18.94153022766119],
          [72.823196411132926, 18.941528320312614],
          [72.823196411132926, 18.942363739013729],
          [72.822906494140682, 18.942359924316406],
          [72.822906494140682, 18.943201065063477],
          [72.822639465331974, 18.943201065063477],
          [72.822639465331974, 18.944030761718864],
          [72.822364807129134, 18.944026947021484],
          [72.822364807129134, 18.944585800170842],
          [72.822082519531421, 18.944580078125114],
          [72.822082519531421, 18.945140838623047],
          [72.821807861328182, 18.945138931274471],
          [72.821807861328182, 18.945695877075195],
          [72.821525573730639, 18.945695877075195],
          [72.821533203125171, 18.946250915527401],
          [72.821250915527628, 18.946250915527401],
          [72.821250915527628, 18.946809768676758],
          [72.820968627929858, 18.946807861328182],
          [72.820968627929858, 18.947082519531364],
          [72.820686340332315, 18.947080612182617],
          [72.820686340332315, 18.947639465332145],
          [72.820419311523438, 18.947639465332145],
          [72.820419311523438, 18.947917938232536],
          [72.820137023926065, 18.947917938232536],
          [72.820137023926065, 18.948194503784293],
          [72.819862365722713, 18.948194503784293],
          [72.819862365722713, 18.948320388793945],
          [72.819862365722713, 18.948749542236328],
          [72.819580078125114, 18.948749542236328],
          [72.819580078125114, 18.949029922485465],
          [72.819313049316634, 18.949029922485465],
          [72.819313049316634, 18.949310302734432],
          [72.819030761718921, 18.949306488037053],
          [72.819030761718921, 18.949583053588867],
          [72.818748474121321, 18.949583053588867],
          [72.818748474121321, 18.949861526489258],
          [72.818191528320369, 18.949859619140682],
          [72.818191528320369, 18.950138092041072],
          [72.817916870117358, 18.950138092041072],
          [72.817916870117358, 18.950700759887752],
          [72.817642211914347, 18.950695037841797],
          [72.817642211914347, 18.950971603393612],
          [72.817085266113565, 18.950971603393612],
          [72.817092895507926, 18.951248168945426],
          [72.816802978515682, 18.951248168945426],
          [72.816802978515682, 18.951528549194393],
          [72.816246032714901, 18.951528549194393],
          [72.816246032714901, 18.951810836792106],
          [72.815696716308821, 18.951805114746151],
          [72.815696716308821, 18.952083587646541],
          [72.815414428711108, 18.952083587646541],
          [72.815414428711108, 18.952360153198356],
          [72.814857482910327, 18.952360153198356],
          [72.814857482910327, 18.952642440795898],
          [72.814582824707315, 18.952642440795898],
          [72.814582824707315, 18.952922821044865],
          [72.814308166503906, 18.952917098999137],
          [72.814308166503906, 18.953193664550895],
          [72.814025878906534, 18.953193664550895],
          [72.814025878906534, 18.953470230102539],
          [72.813468933105582, 18.953470230102539],
          [72.813468933105582, 18.953752517700252],
          [72.812919616699162, 18.953752517700252],
          [72.812919616699162, 18.95404052734375],
          [72.81263732910179, 18.95404052734375],
          [72.81263732910179, 18.954309463501033],
          [72.812362670898608, 18.954305648803654],
          [72.812362670898608, 18.954582214355469],
          [72.810417175293082, 18.954580307006893],
          [72.810417175293082, 18.954860687255859],
          [72.808197021484375, 18.954860687255859],
          [72.808197021484375, 18.954580307006893],
          [72.807914733887003, 18.954582214355469],
          [72.807914733887003, 18.954305648803654],
          [72.807640075683594, 18.954309463501033],
          [72.807640075683594, 18.95404052734375],
          [72.807357788086222, 18.95404052734375],
          [72.807357788086222, 18.953752517700252],
          [72.807083129882869, 18.953752517700252],
          [72.807083129882869, 18.953470230102539],
          [72.806808471679631, 18.953470230102539],
          [72.806808471679631, 18.952917098999137],
          [72.806251525879077, 18.952922821044865],
          [72.806251525879077, 18.952642440795898],
          [72.805801391601847, 18.952642440795898],
          [72.805419921875284, 18.952642440795898],
          [72.805412292480526, 18.952100753784237],
          [72.804862976074503, 18.952079772949219],
          [72.804862976074503, 18.951528549194393],
          [72.804580688476562, 18.951528549194393],
          [72.804580688476562, 18.951248168945426],
          [72.804306030273722, 18.951248168945426],
          [72.804306030273722, 18.950969696045036],
          [72.804031372070369, 18.950971603393612],
          [72.804031372070369, 18.950695037841797],
          [72.803756713867131, 18.950700759887752],
          [72.803756713867131, 18.950138092041072],
          [72.803192138671818, 18.950138092041072],
          [72.803192138671818, 18.949581146240291],
          [72.802635192871264, 18.949583053588867],
          [72.802635192871264, 18.949306488037053],
          [72.802360534668026, 18.949310302734432],
          [72.802360534668026, 18.949029922485465],
          [72.802085876465014, 18.949029922485465],
          [72.802085876465014, 18.948749542236328],
          [72.801528930664063, 18.948749542236328],
          [72.801528930664063, 18.948471069335938],
          [72.800971984863338, 18.948472976684684],
          [72.800971984863338, 18.948194503784293],
          [72.800140380859318, 18.948194503784293],
          [72.800140380859318, 18.947917938232536],
          [72.799583435058764, 18.947917938232536],
          [72.799583435058764, 18.947639465332145],
          [72.798751831054972, 18.947639465332145],
          [72.798751831054972, 18.947080612182617],
          [72.798469543457031, 18.947082519531364],
          [72.798469543457031, 18.946807861328182],
          [72.798187255859659, 18.946809768676758],
          [72.798187255859659, 18.946529388427791],
          [72.797920227050838, 18.946529388427791],
          [72.797920227050838, 18.946250915527401],
          [72.797630310058878, 18.946250915527401],
          [72.797630310058878, 18.945140838623047],
          [72.797363281250057, 18.945140838623047],
          [72.797363281250057, 18.944852828979549],
          [72.796806335449446, 18.94486045837408],
          [72.796806335449446, 18.944585800170842],
          [72.796524047851733, 18.944585800170842],
          [72.796524047851733, 18.944305419921875],
          [72.796249389648494, 18.94431114196783],
          [72.796249389648494, 18.944030761718864],
          [72.795967102050952, 18.944030761718864],
          [72.795967102050952, 18.94347000122076],
          [72.79569244384794, 18.943473815918082],
          [72.79569244384794, 18.942363739013729],
          [72.795417785644531, 18.942363739013729],
          [72.795417785644531, 18.941249847412223],
          [72.795135498047159, 18.941249847412223],
          [72.795135498047159, 18.940416336059627],
          [72.79486083984375, 18.940420150756836],
          [72.79486083984375, 18.939580917358512],
          [72.794586181640739, 18.939582824707088],
          [72.794586181640739, 18.939306259155273],
          [72.794296264648494, 18.939310073852653],
          [72.794296264648494, 18.939031600952262],
          [72.794029235839787, 18.939031600952262],
          [72.794029235839787, 18.938749313354549],
          [72.793197631835994, 18.938749313354549],
          [72.793197631835994, 18.939031600952262],
          [72.792922973632983, 18.939031600952262],
          [72.792922973632983, 18.939310073852653],
          [72.79264068603544, 18.939306259155273],
          [72.79264068603544, 18.939582824707088],
          [72.792083740234659, 18.939582824707088],
          [72.792083740234659, 18.939859390258903],
          [72.79180908203125, 18.939859390258903],
          [72.79180908203125, 18.940694808960018],
          [72.792083740234659, 18.940694808960018],
          [72.792083740234659, 18.940971374511832],
          [72.792358398437671, 18.940969467163086],
          [72.792358398437671, 18.94153022766119],
          [72.79264068603544, 18.941528320312614],
          [72.79264068603544, 18.942081451416016],
          [72.792922973632983, 18.94207954406744],
          [72.792922973632983, 18.942640304565543],
          [72.793197631835994, 18.942640304565543],
          [72.793197631835994, 18.943750381469727],
          [72.792915344238452, 18.943750381469727],
          [72.792915344238452, 18.944585800170842],
          [72.79264068603544, 18.944580078125114],
          [72.79264068603544, 18.945421218872184],
          [72.792358398437671, 18.945421218872184],
          [72.792358398437671, 18.946529388427791],
          [72.792083740234659, 18.946527481079215],
          [72.792083740234659, 18.947082519531364],
          [72.79180908203125, 18.947082519531364],
          [72.791816711425838, 18.947639465332145],
          [72.791526794433878, 18.947639465332145],
          [72.791526794433878, 18.948194503784293],
          [72.791816711425838, 18.948190689086971],
          [72.791816711425838, 18.950700759887752],
          [72.792358398437671, 18.950700759887752],
          [72.792358398437671, 18.951248168945426],
          [72.79264068603544, 18.951248168945426],
          [72.79264068603544, 18.951810836792106],
          [72.792915344238452, 18.951805114746151],
          [72.792915344238452, 18.952360153198356],
          [72.793197631835994, 18.952360153198356],
          [72.793197631835994, 18.952642440795898],
          [72.793472290039233, 18.952642440795898],
          [72.793472290039233, 18.952922821044865],
          [72.793746948242244, 18.952917098999137],
          [72.793746948242244, 18.953470230102539],
          [72.794029235839787, 18.953470230102539],
          [72.794029235839787, 18.953752517700252],
          [72.794296264648494, 18.953752517700252],
          [72.794296264648494, 18.95404052734375],
          [72.794586181640739, 18.95404052734375],
          [72.794586181640739, 18.954309463501033],
          [72.79486083984375, 18.954305648803654],
          [72.79486083984375, 18.954582214355469],
          [72.795135498047159, 18.954582214355469],
          [72.795135498047159, 18.955692291259822],
          [72.795417785644531, 18.955692291259822],
          [72.795417785644531, 18.955974578857365],
          [72.79569244384794, 18.955970764160213],
          [72.79569244384794, 18.95625114440918],
          [72.795967102050952, 18.95625114440918],
          [72.795967102050952, 18.95652961730957],
          [72.796249389648494, 18.95652961730957],
          [72.796249389648494, 18.956809997558707],
          [72.796524047851733, 18.956806182861328],
          [72.796524047851733, 18.957084655761719],
          [72.797080993652287, 18.957080841064567],
          [72.797080993652287, 18.957361221313533],
          [72.797363281250057, 18.957361221313533],
          [72.797363281250057, 18.957639694213924],
          [72.797630310058878, 18.957639694213924],
          [72.797630310058878, 18.957920074462891],
          [72.798187255859659, 18.957920074462891],
          [72.798187255859659, 18.959030151367244],
          [72.799308776855526, 18.959028244018668],
          [72.799308776855526, 18.959306716919059],
          [72.799575805664233, 18.959300994873104],
          [72.799575805664233, 18.960140228271598],
          [72.799308776855526, 18.960138320922852],
          [72.799308776855526, 18.960971832275391],
          [72.799575805664233, 18.960969924926815],
          [72.799575805664233, 18.961530685424918],
          [72.799858093261946, 18.961530685424918],
          [72.799858093261946, 18.961811065673885],
          [72.800140380859318, 18.961811065673885],
          [72.800140380859318, 18.962360382080135],
          [72.800422668457088, 18.962360382080135],
          [72.800422668457088, 18.962640762329102],
          [72.80069732666027, 18.962638854980526],
          [72.80069732666027, 18.963193893432674],
          [72.800971984863338, 18.963193893432674],
          [72.800971984863338, 18.963472366333065],
          [72.80124664306669, 18.963470458984489],
          [72.80124664306669, 18.964029312133846],
          [72.801528930664063, 18.964029312133846],
          [72.801528930664063, 18.965421676635742],
          [72.802085876465014, 18.965415954589787],
          [72.802085876465014, 18.965694427490348],
          [72.802635192871264, 18.965694427490348],
          [72.802635192871264, 18.968471527099666],
          [72.802085876465014, 18.96846961975109],
          [72.802085876465014, 18.968751907348633],
          [72.80179595947294, 18.968751907348633],
          [72.80179595947294, 18.969039916992131],
          [72.801528930664063, 18.969028472900447],
          [72.801528930664063, 18.969863891601563],
          [72.801803588867472, 18.969863891601563],
          [72.801803588867472, 18.970695495605526],
          [72.802085876465014, 18.970689773559627],
          [72.802085876465014, 18.971250534057731],
          [72.802360534668026, 18.971250534057731],
          [72.802360534668026, 18.971809387207088],
          [72.802635192871264, 18.971805572509709],
          [72.802635192871264, 18.972360610961914],
          [72.803192138671818, 18.972360610961914],
          [72.803192138671818, 18.972640991211051],
          [72.803466796875057, 18.972640991211051],
          [72.803466796875057, 18.972919464111442],
          [72.80374908447277, 18.972917556762695],
          [72.80374908447277, 18.973194122314453],
          [72.804031372070369, 18.973194122314453],
          [72.804031372070369, 18.973472595214844],
          [72.804306030273722, 18.973470687866268],
          [72.804306030273722, 18.973751068115234],
          [72.804580688476562, 18.973751068115234],
          [72.804580688476562, 18.974309921264762],
          [72.804862976074503, 18.974306106567383],
          [72.804862976074503, 18.974861145019588],
          [72.805137634277514, 18.974849700927848],
          [72.805137634277514, 18.975418090820369],
          [72.805694580078296, 18.975416183471737],
          [72.805694580078296, 18.975973129272518],
          [72.805969238281477, 18.975971221923942],
          [72.805969238281477, 18.976528167724723],
          [72.805686950683764, 18.976528167724723],
          [72.805686950683764, 18.97821044921875],
          [72.808471679687784, 18.978195190429631],
          [72.808471679687784, 18.978471755981445],
          [72.808746337890796, 18.978469848632869],
          [72.808746337890796, 18.97874832153326],
          [72.809028625488338, 18.97874832153326],
          [72.809028625488338, 18.979032516479549],
          [72.809303283691577, 18.979032516479549],
          [72.809303283691577, 18.97874832153326],
          [72.811248779296875, 18.97874832153326],
          [72.811248779296875, 18.979032516479549],
          [72.811531066894815, 18.979032516479549],
          [72.811531066894815, 18.979312896728516],
          [72.811805725097827, 18.979305267333984],
          [72.811805725097827, 18.979583740234375],
          [72.812080383300838, 18.979581832885799],
          [72.812080383300838, 18.97986030578619],
          [72.812362670898608, 18.97986030578619],
          [72.812362670898608, 18.980142593383903],
          [72.81263732910179, 18.98013877868658],
          [72.81263732910179, 18.980693817138729],
          [72.813186645507869, 18.980691909790153],
          [72.813186645507869, 18.981252670288086],
          [72.813751220703182, 18.981252670288086],
          [72.813751220703182, 18.981809616088867],
          [72.814025878906534, 18.981809616088867],
          [72.814025878906534, 18.982919692993221],
          [72.814308166503906, 18.982919692993221],
          [72.814308166503906, 18.985139846801758],
          [72.814025878906534, 18.985139846801758],
          [72.814025878906534, 18.986249923706112],
          [72.813751220703182, 18.986249923706112],
          [72.813751220703182, 18.986530303955078],
          [72.813468933105582, 18.986528396606502],
          [72.813468933105582, 18.987083435058651],
          [72.812919616699162, 18.987083435058651],
          [72.812919616699162, 18.986806869506893],
          [72.812362670898608, 18.986806869506893],
          [72.812362670898608, 18.987083435058651],
          [72.811248779296875, 18.987083435058651],
          [72.811248779296875, 18.987361907959041],
          [72.810974121094034, 18.987361907959041],
          [72.810974121094034, 18.988471984863395],
          [72.810691833496094, 18.988470077514648],
          [72.810691833496094, 18.989030838012752],
          [72.810974121094034, 18.989028930664176],
          [72.810974121094034, 18.989583969116325],
          [72.811248779296875, 18.989580154419002],
          [72.811248779296875, 18.990148544311637],
          [72.811531066894815, 18.990137100219727],
          [72.811531066894815, 18.990694046020508],
          [72.811813354492358, 18.990690231323356],
          [72.811813354492358, 18.991249084472713],
          [72.812080383300838, 18.991249084472713],
          [72.812080383300838, 18.992359161377067],
          [72.812362670898608, 18.992359161377067],
          [72.812362670898608, 18.993471145629996],
          [72.812080383300838, 18.99346923828125],
          [72.812080383300838, 18.99403190612793],
          [72.811531066894815, 18.994028091430778],
          [72.811531066894815, 18.994304656982536],
          [72.811805725097827, 18.994304656982536],
          [72.811805725097827, 18.995973587036246],
          [72.811531066894815, 18.99596023559576],
          [72.811531066894815, 18.997920989990348],
          [72.811248779296875, 18.997920989990348],
          [72.811248779296875, 18.999309539794922],
          [72.810966491699503, 18.999309539794922],
          [72.810966491699503, 18.999860763549918],
          [72.811248779296875, 18.999860763549918],
          [72.811248779296875, 19.002361297607422],
          [72.811531066894815, 19.002361297607422],
          [72.811531066894815, 19.003471374511776],
          [72.811813354492358, 19.0034694671632],
          [72.811813354492358, 19.004028320312557],
          [72.812080383300838, 19.004028320312557],
          [72.812080383300838, 19.004583358764705],
          [72.812362670898608, 19.004579544067383],
          [72.812362670898608, 19.005151748657227],
          [72.81263732910179, 19.005151748657227],
          [72.81263732910179, 19.00570106506359],
          [72.812919616699162, 19.005695343017635],
          [72.812919616699162, 19.00597190856945],
          [72.813186645507869, 19.00597190856945],
          [72.813186645507869, 19.006532669067383],
          [72.813468933105582, 19.006526947021428],
          [72.813468933105582, 19.007083892822379],
          [72.813751220703182, 19.007083892822379],
          [72.813751220703182, 19.009584426879883],
          [72.814025878906534, 19.009580612182731],
          [72.814025878906534, 19.009862899780273],
          [72.814308166503906, 19.009862899780273],
          [72.814308166503906, 19.010139465332088],
          [72.814582824707315, 19.010139465332088],
          [72.814582824707315, 19.010692596435661],
          [72.814857482910327, 19.010690689086914],
          [72.814857482910327, 19.011249542236442],
          [72.815139770507869, 19.011249542236442],
          [72.815139770507869, 19.011800765991268],
          [72.815414428711108, 19.011806488037223],
          [72.815414428711108, 19.012083053588981],
          [72.815696716308821, 19.012083053588981],
          [72.815696716308821, 19.012361526489371],
          [72.815971374511662, 19.012359619140625],
          [72.815971374511662, 19.013200759887695],
          [72.816246032714901, 19.013200759887695],
          [72.816246032714901, 19.01652908325201],
          [72.815971374511662, 19.01652908325201],
          [72.815971374511662, 19.017639160156364],
          [72.815696716308821, 19.017639160156364],
          [72.815696716308821, 19.020694732666016],
          [72.815406799316577, 19.02069282531744],
          [72.815406799316577, 19.024030685424862],
          [72.815139770507869, 19.024026870727482],
          [72.815139770507869, 19.024585723877067],
          [72.814857482910327, 19.024580001831112],
          [72.814857482910327, 19.025140762329215],
          [72.814582824707315, 19.025138854980469],
          [72.814582824707315, 19.027082443237362],
          [72.815414428711108, 19.027082443237362],
          [72.815414428711108, 19.02680778503418],
          [72.815696716308821, 19.026809692382926],
          [72.815696716308821, 19.025690078735465],
          [72.815971374511662, 19.025695800781193],
          [72.815971374511662, 19.025138854980469],
          [72.816246032714901, 19.025140762329215],
          [72.816246032714901, 19.024860382080078],
          [72.816528320312614, 19.024860382080078],
          [72.816528320312614, 19.024580001831112],
          [72.816802978515682, 19.024585723877067],
          [72.816802978515682, 19.024303436279297],
          [72.817092895507926, 19.024311065673828],
          [72.817092895507926, 19.024030685424862],
          [72.817359924316406, 19.024030685424862],
          [72.817359924316406, 19.023750305175895],
          [72.817642211914347, 19.023750305175895],
          [72.817642211914347, 19.023469924926758],
          [72.817916870117358, 19.02347373962408],
          [72.817916870117358, 19.022916793823356],
          [72.818191528320369, 19.022920608520508],
          [72.818191528320369, 19.022640228271541],
          [72.818466186523608, 19.022640228271541],
          [72.818466186523608, 19.022359848022575],
          [72.818748474121321, 19.022363662719727],
          [72.818748474121321, 19.020694732666016],
          [72.819030761718921, 19.020694732666016],
          [72.819030761718921, 19.020139694213867],
          [72.819305419921932, 19.020139694213867],
          [72.819305419921932, 19.019306182861271],
          [72.819580078125114, 19.019311904907227],
          [72.819580078125114, 19.018470764160156],
          [72.819862365722713, 19.018472671508903],
          [72.819862365722713, 19.018194198608512],
          [72.820137023926065, 19.018194198608512],
          [72.820137023926065, 19.017915725707951],
          [72.820419311523438, 19.017921447753906],
          [72.820419311523438, 19.017639160156364],
          [72.822906494140682, 19.017639160156364],
          [72.822906494140682, 19.017921447753906],
          [72.825141906738452, 19.017915725707951],
          [72.825141906738452, 19.018194198608512],
          [72.825416564941634, 19.018194198608512],
          [72.825416564941634, 19.018472671508903],
          [72.826530456543026, 19.018470764160156],
          [72.826530456543026, 19.018749237060547],
          [72.826812744140909, 19.018749237060547],
          [72.826812744140909, 19.01903152465826],
          [72.827079772949219, 19.01903152465826],
          [72.827079772949219, 19.019311904907227],
          [72.827362060547159, 19.019306182861271],
          [72.827362060547159, 19.019582748413086],
          [72.827636718750171, 19.01958084106451],
          [72.827636718750171, 19.019859313964901],
          [72.828193664550952, 19.019859313964901],
          [72.828193664550952, 19.020139694213867],
          [72.828475952148665, 19.020128250122127],
          [72.828475952148665, 19.020420074463004],
          [72.829025268554744, 19.020416259765625],
          [72.829025268554744, 19.020694732666016],
          [72.829582214355526, 19.020694732666016],
          [72.829582214355526, 19.02097129821783],
          [72.829856872558878, 19.020969390869254],
          [72.829856872558878, 19.021249771118221],
          [72.830406188965128, 19.021249771118221],
          [72.830406188965128, 19.021530151367188],
          [72.830696105957202, 19.021528244018612],
          [72.830696105957202, 19.021804809570369],
          [72.830970764160213, 19.021804809570369],
          [72.830970764160213, 19.022081375122184],
          [72.831253051757983, 19.022081375122184],
          [72.831253051757983, 19.022363662719727],
          [72.831527709961165, 19.022359848022575],
          [72.831527709961165, 19.022640228271541],
          [72.831802368164006, 19.022640228271541],
          [72.831802368164006, 19.022920608520508],
          [72.832084655761776, 19.022916793823356],
          [72.832084655761776, 19.02319526672369],
          [72.832359313964957, 19.02319526672369],
          [72.832359313964957, 19.02347373962408],
          [72.832641601562557, 19.023469924926758],
          [72.832641601562557, 19.024030685424862],
          [72.832916259765909, 19.024030685424862],
          [72.832916259765909, 19.024311065673828],
          [72.83319091796875, 19.024303436279297],
          [72.83319091796875, 19.024585723877067],
          [72.83347320556669, 19.024580001831112],
          [72.83347320556669, 19.024860382080078],
          [72.833740234375171, 19.024860382080078],
          [72.833740234375171, 19.025140762329215],
          [72.834030151367472, 19.025140762329215],
          [72.834030151367472, 19.026260375976506],
          [72.834297180175952, 19.026260375976506],
          [72.834297180175952, 19.026531219482536],
          [72.834861755371264, 19.026531219482536],
          [72.834861755371264, 19.026809692382926],
          [72.835136413574276, 19.026809692382926],
          [72.835136413574276, 19.027360916137752],
          [72.835418701171818, 19.027360916137752],
          [72.835418701171818, 19.027639389038143],
          [72.835693359375057, 19.027639389038143],
          [72.835693359375057, 19.028194427490291],
          [72.83597564697277, 19.028194427490291],
          [72.83597564697277, 19.028749465942496],
          [72.836250305175781, 19.028749465942496],
          [72.836250305175781, 19.02932167053234],
          [72.836517333984659, 19.02932167053234],
          [72.836517333984659, 19.030139923095817],
          [72.836799621582202, 19.030139923095817],
          [72.836799621582202, 19.030418395996207],
          [72.837081909179972, 19.030418395996207],
          [72.837081909179972, 19.031248092651424],
          [72.837364196777514, 19.031248092651424],
          [72.837364196777514, 19.032083511352539],
          [72.837638854980526, 19.032068252563477],
          [72.837638854980526, 19.032922744751033],
          [72.837905883789006, 19.032922744751033],
          [72.837905883789006, 19.034860610962028],
          [72.838195800781477, 19.034860610962028],
          [72.838195800781477, 19.03928184509283],
          [72.837905883789006, 19.039300918579102],
          [72.837905883789006, 19.041810989379883],
          [72.837638854980526, 19.041805267333928],
          [72.837638854980526, 19.044584274291992],
          [72.837356567382983, 19.04458045959484],
          [72.837356567382983, 19.045139312744197],
          [72.837081909179972, 19.045139312744197],
          [72.837081909179972, 19.045421600341911],
          [72.836807250976562, 19.045415878295955],
          [72.836807250976562, 19.045972824096737],
          [72.83652496337919, 19.045972824096737],
          [72.83652496337919, 19.048194885253849],
          [72.836250305175781, 19.048191070556697],
          [72.836250305175781, 19.048749923706055],
          [72.835983276367301, 19.048749923706055],
          [72.835983276367301, 19.049030303955192],
          [72.835693359375057, 19.049030303955192],
          [72.835693359375057, 19.049310684204158],
          [72.835136413574276, 19.049303054809627],
          [72.835136413574276, 19.049581527710018],
          [72.834861755371264, 19.049581527710018],
          [72.834861755371264, 19.04986381530756],
          [72.83347320556669, 19.04986381530756],
          [72.83347320556669, 19.049581527710018],
          [72.832641601562557, 19.049581527710018],
          [72.832641601562557, 19.049303054809627],
          [72.832359313964957, 19.049310684204158],
          [72.832359313964957, 19.049030303955192],
          [72.831253051757983, 19.049030303955192],
          [72.831253051757983, 19.048191070556697],
          [72.830696105957202, 19.048194885253849],
          [72.830696105957202, 19.047916412353459],
          [72.830406188965128, 19.047920227050838],
          [72.830406188965128, 19.047359466552734],
          [72.83013916015625, 19.047361373901481],
          [72.83013916015625, 19.046806335449332],
          [72.829856872558878, 19.046810150146484],
          [72.829856872558878, 19.046531677246094],
          [72.829582214355526, 19.046531677246094],
          [72.829582214355526, 19.045970916748161],
          [72.829864501953409, 19.045972824096737],
          [72.829864501953409, 19.045694351196346],
          [72.829582214355526, 19.045694351196346],
          [72.829582214355526, 19.045415878295955],
          [72.829032897949276, 19.045421600341911],
          [72.829032897949276, 19.045139312744197],
          [72.828475952148665, 19.045139312744197],
          [72.828475952148665, 19.044860839843807],
          [72.827919006347713, 19.044860839843807],
          [72.827919006347713, 19.044584274291992],
          [72.827636718750171, 19.044584274291992],
          [72.827636718750171, 19.044305801391602],
          [72.827362060547159, 19.044321060180721],
          [72.827362060547159, 19.044029235839844],
          [72.826530456543026, 19.044029235839844],
          [72.826530456543026, 19.043750762939453],
          [72.826248168945426, 19.043750762939453],
          [72.826248168945426, 19.043470382690487],
          [72.825416564941634, 19.043472290039063],
          [72.825416564941634, 19.043193817138672],
          [72.825141906738452, 19.043193817138672],
          [72.825141906738452, 19.042917251586914],
          [72.824859619140682, 19.042919158935661],
          [72.824859619140682, 19.04264068603527],
          [72.824302673340128, 19.04264068603527],
          [72.824302673340128, 19.042360305786133],
          [72.824028015136719, 19.042360305786133],
          [72.824028015136719, 19.042079925537166],
          [72.823753356933878, 19.042083740234489],
          [72.823753356933878, 19.040416717529411],
          [72.824028015136719, 19.040420532226562],
          [72.824028015136719, 19.039859771728629],
          [72.824302673340128, 19.039861679077205],
          [72.824302673340128, 19.039306640625057],
          [72.824584960937671, 19.039306640625057],
          [72.824584960937671, 19.03819465637207],
          [72.824302673340128, 19.038200378418026],
          [72.824302673340128, 19.037639617919922],
          [72.823753356933878, 19.037639617919922],
          [72.823753356933878, 19.037919998169059],
          [72.823471069335938, 19.037919998169059],
          [72.823471069335938, 19.038200378418026],
          [72.823196411132926, 19.03819465637207],
          [72.823196411132926, 19.038473129272461],
          [72.822906494140682, 19.038471221923885],
          [72.822906494140682, 19.039030075073242],
          [72.822639465331974, 19.039028167724666],
          [72.822639465331974, 19.039583206176815],
          [72.822357177734432, 19.039579391479492],
          [72.822357177734432, 19.0407009124757],
          [72.822082519531421, 19.0407009124757],
          [72.822082519531421, 19.041810989379883],
          [72.821800231933821, 19.041810989379883],
          [72.821807861328182, 19.042360305786133],
          [72.821533203125171, 19.042360305786133],
          [72.821533203125171, 19.04264068603527],
          [72.820968627929858, 19.04264068603527],
          [72.820968627929858, 19.042360305786133],
          [72.820686340332315, 19.042360305786133],
          [72.820686340332315, 19.042079925537166],
          [72.820137023926065, 19.042083740234489],
          [72.820137023926065, 19.041805267333928],
          [72.819030761718921, 19.041810989379883],
          [72.819030761718921, 19.041530609130916],
          [72.81874084472679, 19.041530609130916],
          [72.81874084472679, 19.041259765625057],
          [72.817642211914347, 19.041259765625057],
          [72.817642211914347, 19.041530609130916],
          [72.817359924316406, 19.041530609130916],
          [72.817359924316406, 19.041810989379883],
          [72.816802978515682, 19.041810989379883],
          [72.816802978515682, 19.041530609130916],
          [72.816528320312614, 19.041530609130916],
          [72.816528320312614, 19.041810989379883],
          [72.816246032714901, 19.041810989379883],
          [72.816246032714901, 19.042360305786133],
          [72.815971374511662, 19.042360305786133],
          [72.815971374511662, 19.04264068603527],
          [72.816246032714901, 19.04264068603527],
          [72.816246032714901, 19.042919158935661],
          [72.816528320312614, 19.042917251586914],
          [72.816528320312614, 19.043472290039063],
          [72.817092895507926, 19.043470382690487],
          [72.817092895507926, 19.044029235839844],
          [72.817642211914347, 19.044029235839844],
          [72.817642211914347, 19.044860839843807],
          [72.817916870117358, 19.044860839843807],
          [72.817916870117358, 19.045421600341911],
          [72.818191528320369, 19.045421600341911],
          [72.818191528320369, 19.046531677246094],
          [72.818466186523608, 19.046531677246094],
          [72.818466186523608, 19.046249389648551],
          [72.81874084472679, 19.046249389648551],
          [72.81874084472679, 19.046531677246094],
          [72.819030761718921, 19.046531677246094],
          [72.819030761718921, 19.046810150146484],
          [72.819305419921932, 19.046806335449332],
          [72.819305419921932, 19.04708290100109],
          [72.819580078125114, 19.04708290100109],
          [72.819580078125114, 19.047361373901481],
          [72.819862365722713, 19.047361373901481],
          [72.819862365722713, 19.048471450805664],
          [72.820137023926065, 19.048469543457088],
          [72.820137023926065, 19.049030303955192],
          [72.820419311523438, 19.049028396606445],
          [72.820419311523438, 19.04986381530756],
          [72.820968627929858, 19.049860000610408],
          [72.820968627929858, 19.050140380859375],
          [72.821250915527628, 19.050140380859375],
          [72.821250915527628, 19.051530838012695],
          [72.821525573730639, 19.051525115966911],
          [72.821525573730639, 19.052360534668082],
          [72.821800231933821, 19.052360534668082],
          [72.821800231933821, 19.052640914917049],
          [72.822082519531421, 19.052640914917049],
          [72.822082519531421, 19.053199768066406],
          [72.822357177734432, 19.053199768066406],
          [72.822357177734432, 19.054029464721793],
          [72.822639465331974, 19.054029464721793],
          [72.822639465331974, 19.054861068725586],
          [72.823471069335938, 19.054861068725586],
          [72.823471069335938, 19.055139541625977],
          [72.823753356933878, 19.055139541625977],
          [72.823753356933878, 19.055973052978516],
          [72.823471069335938, 19.05597114562994],
          [72.823471069335938, 19.056259155273438],
          [72.823196411132926, 19.05624961853033],
          [72.823196411132926, 19.056804656982479],
          [72.822914123535213, 19.056804656982479],
          [72.822914123535213, 19.05736160278326],
          [72.822639465331974, 19.057359695434684],
          [72.822639465331974, 19.057638168335075],
          [72.820968627929858, 19.057638168335075],
          [72.820968627929858, 19.058471679687614],
          [72.820693969726847, 19.058471679687614],
          [72.820693969726847, 19.060693740844727],
          [72.820968627929858, 19.060693740844727],
          [72.820968627929858, 19.060970306396541],
          [72.821525573730639, 19.060970306396541],
          [72.821525573730639, 19.061252593994254],
          [72.821800231933821, 19.061252593994254],
          [72.821800231933821, 19.062360763549862],
          [72.822082519531421, 19.062360763549862],
          [72.822082519531421, 19.063474655151367],
          [72.821807861328182, 19.063474655151367],
          [72.821807861328182, 19.064861297607536],
          [72.821533203125171, 19.064859390258789],
          [72.821533203125171, 19.066530227661246],
          [72.821250915527628, 19.0665283203125],
          [72.821250915527628, 19.066806793212891],
          [72.820968627929858, 19.066801071167106],
          [72.820968627929858, 19.067920684814567],
          [72.821525573730639, 19.067916870117244],
          [72.821525573730639, 19.068471908569393],
          [72.822357177734432, 19.068470001220817],
          [72.822357177734432, 19.068750381469783],
          [72.822639465331974, 19.068750381469783],
          [72.822639465331974, 19.069860458374137],
          [72.822364807129134, 19.069860458374137],
          [72.822364807129134, 19.070972442627067],
          [72.822082519531421, 19.07097053527832],
          [72.822082519531421, 19.072359085083065],
          [72.821800231933821, 19.072359085083065],
          [72.821800231933821, 19.075700759887809],
          [72.820968627929858, 19.075700759887809],
          [72.820968627929858, 19.077640533447379],
          [72.821525573730639, 19.077638626098633],
          [72.821525573730639, 19.078195571899357],
          [72.822082519531421, 19.078195571899357],
          [72.822082519531421, 19.078472137451172],
          [72.822357177734432, 19.078470230102596],
          [72.822357177734432, 19.078750610351563],
          [72.822906494140682, 19.078750610351563],
          [72.822906494140682, 19.0790309906007],
          [72.823753356933878, 19.0790309906007],
          [72.823753356933878, 19.07930946350109],
          [72.824302673340128, 19.07930946350109],
          [72.824302673340128, 19.078750610351563],
          [72.824577331543139, 19.078750610351563],
          [72.824577331543139, 19.078470230102596],
          [72.824859619140682, 19.078472137451172],
          [72.824859619140682, 19.077917098999023],
          [72.825973510742244, 19.077917098999023],
          [72.825973510742244, 19.078195571899357],
          [72.826248168945426, 19.078189849853629],
          [72.826248168945426, 19.079860687255916],
          [72.825965881347713, 19.079860687255916],
          [72.825965881347713, 19.081529617309627],
          [72.826248168945426, 19.081529617309627],
          [72.826248168945426, 19.08236122131359],
          [72.825965881347713, 19.08236122131359],
          [72.825965881347713, 19.082918167114371],
          [72.825691223144474, 19.082916259765568],
          [72.825691223144474, 19.083471298217773],
          [72.825416564941634, 19.083469390869197],
          [72.825416564941634, 19.085420608520621],
          [72.825973510742244, 19.085416793823299],
          [72.825973510742244, 19.086250305175838],
          [72.826248168945426, 19.086240768432731],
          [72.826248168945426, 19.087642669677734],
          [72.826530456543026, 19.087638854980582],
          [72.826530456543026, 19.088470458984375],
          [72.826812744140909, 19.088470458984375],
          [72.826812744140909, 19.09403038024908],
          [72.826530456543026, 19.094028472900504],
          [72.826530456543026, 19.095418930053825],
          [72.826248168945426, 19.095418930053825],
          [72.826248168945426, 19.09819412231451],
          [72.825965881347713, 19.098180770874023],
          [72.825965881347713, 19.098749160766715],
          [72.825691223144474, 19.098749160766715],
          [72.825691223144474, 19.100139617920036],
          [72.825416564941634, 19.100139617920036],
          [72.825416564941634, 19.102081298828182],
          [72.825141906738452, 19.102079391479606],
          [72.825141906738452, 19.102640151977539],
          [72.824859619140682, 19.102640151977539],
          [72.824859619140682, 19.103200912475643],
          [72.824577331543139, 19.103200912475643],
          [72.824577331543139, 19.104310989379996],
          [72.824302673340128, 19.104310989379996],
          [72.824302673340128, 19.105140686035213],
          [72.824028015136719, 19.105138778686637],
          [72.824028015136719, 19.105972290039176],
          [72.823753356933878, 19.10597038269043],
          [72.823753356933878, 19.107641220092887],
          [72.823471069335938, 19.107639312744141],
          [72.823471069335938, 19.109861373901424],
          [72.823196411132926, 19.109861373901424],
          [72.823196411132926, 19.110971450805778],
          [72.822906494140682, 19.110969543457031],
          [72.822906494140682, 19.111528396606559],
          [72.822639465331974, 19.111528396606559],
          [72.822639465331974, 19.112361907959098],
          [72.822364807129134, 19.112361907959098],
          [72.822357177734432, 19.113740921020565],
          [72.822082519531421, 19.113750457763672],
          [72.822082519531421, 19.114311218261776],
          [72.821800231933821, 19.114311218261776],
          [72.821807861328182, 19.114860534668026],
          [72.821533203125171, 19.114860534668026],
          [72.821533203125171, 19.115419387817383],
          [72.821250915527628, 19.115417480468807],
          [72.821250915527628, 19.115974426269531],
          [72.820968627929858, 19.115970611572379],
          [72.820968627929858, 19.116540908813477],
          [72.820686340332315, 19.116540908813477],
          [72.820686340332315, 19.1173610687257],
          [72.820419311523438, 19.1173610687257],
          [72.820419311523438, 19.11763954162609],
          [72.820137023926065, 19.11763954162609],
          [72.820137023926065, 19.120420455932731],
          [72.820419311523438, 19.120420455932731],
          [72.820419311523438, 19.120700836181697],
          [72.821525573730639, 19.120695114135742],
          [72.821525573730639, 19.122083663940487],
          [72.820968627929858, 19.122083663940487],
          [72.820968627929858, 19.122360229492301],
          [72.820686340332315, 19.122350692748967],
          [72.820686340332315, 19.122919082641658],
          [72.820419311523438, 19.122917175293082],
          [72.820419311523438, 19.12319374084484],
          [72.819862365722713, 19.123189926147518],
          [72.819862365722713, 19.123750686645621],
          [72.819580078125114, 19.123750686645621],
          [72.819580078125114, 19.124029159546012],
          [72.819313049316634, 19.124029159546012],
          [72.819313049316634, 19.124311447143555],
          [72.818473815918139, 19.124305725097599],
          [72.818473815918139, 19.12458419799799],
          [72.817916870117358, 19.124580383300838],
          [72.817916870117358, 19.124860763549805],
          [72.817642211914347, 19.124860763549805],
          [72.817642211914347, 19.125139236450195],
          [72.817359924316406, 19.125139236450195],
          [72.817359924316406, 19.125421524047908],
          [72.817085266113565, 19.125415802001953],
          [72.817085266113565, 19.125694274902344],
          [72.816802978515682, 19.125694274902344],
          [72.816802978515682, 19.125972747802734],
          [72.816528320312614, 19.125970840454158],
          [72.816528320312614, 19.126249313354549],
          [72.816246032714901, 19.126249313354549],
          [72.816246032714901, 19.126531600952262],
          [72.815971374511662, 19.126531600952262],
          [72.815971374511662, 19.126810073852653],
          [72.815414428711108, 19.12680625915533],
          [72.815414428711108, 19.127082824707088],
          [72.815139770507869, 19.127082824707088],
          [72.815139770507869, 19.127361297607479],
          [72.814857482910327, 19.127359390258903],
          [72.814857482910327, 19.127639770507869],
          [72.814582824707315, 19.127639770507869],
          [72.814582824707315, 19.128194808960018],
          [72.814857482910327, 19.128192901611442],
          [72.814857482910327, 19.12848091125494],
          [72.814582824707315, 19.12848091125494],
          [72.814582824707315, 19.12903022766119],
          [72.814025878906534, 19.129028320312614],
          [72.814025878906534, 19.129304885864201],
          [72.813751220703182, 19.129304885864201],
          [72.813751220703182, 19.129028320312614],
          [72.813468933105582, 19.129028320312614],
          [72.813468933105582, 19.129581451416016],
          [72.813194274902401, 19.129581451416016],
          [72.813194274902401, 19.129863739013729],
          [72.812919616699162, 19.129863739013729],
          [72.812919616699162, 19.130973815917912],
          [72.81263732910179, 19.13097000122076],
          [72.81263732910179, 19.131250381469727],
          [72.812362670898608, 19.131250381469727],
          [72.812362670898608, 19.131526947021541],
          [72.812080383300838, 19.131521224975586],
          [72.812080383300838, 19.13181114196783],
          [72.811805725097827, 19.131803512573299],
          [72.811805725097827, 19.132085800170898],
          [72.811531066894815, 19.132080078125114],
          [72.811531066894815, 19.13236045837408],
          [72.811248779296875, 19.13236045837408],
          [72.811248779296875, 19.132640838623047],
          [72.810974121094034, 19.132638931274471],
          [72.810974121094034, 19.133195877075252],
          [72.810417175293082, 19.133195877075252],
          [72.810417175293082, 19.13347244262701],
          [72.810142517089901, 19.133470535278434],
          [72.810142517089901, 19.134029388427791],
          [72.809860229492131, 19.134029388427791],
          [72.809860229492131, 19.134309768676758],
          [72.80958557128929, 19.134307861328182],
          [72.80958557128929, 19.134582519531364],
          [72.809303283691577, 19.134580612182617],
          [72.809303283691577, 19.135139465332145],
          [72.809028625488338, 19.135139465332145],
          [72.809028625488338, 19.135419845581112],
          [72.808746337890796, 19.135417938232536],
          [72.808746337890796, 19.135694503784123],
          [72.808471679687784, 19.135694503784123],
          [72.808471679687784, 19.135972976684684],
          [72.808197021484375, 19.135971069335938],
          [72.808197021484375, 19.136249542236328],
          [72.807907104492472, 19.136249542236328],
          [72.807907104492472, 19.136529922485465],
          [72.807640075683594, 19.136529922485465],
          [72.807640075683594, 19.136808395385856],
          [72.807083129882869, 19.136806488037109],
          [72.807083129882869, 19.137083053588867],
          [72.80680084228527, 19.137081146240291],
          [72.80680084228527, 19.137638092041072],
          [72.806526184082088, 19.137638092041072],
          [72.806526184082088, 19.137918472290039],
          [72.806251525879077, 19.137918472290039],
          [72.806251525879077, 19.138200759887752],
          [72.805969238281477, 19.138195037841797],
          [72.805969238281477, 19.138471603393612],
          [72.805686950683764, 19.138469696045036],
          [72.805686950683764, 19.138748168945426],
          [72.805419921875284, 19.138748168945426],
          [72.805419921875284, 19.139028549194393],
          [72.804862976074503, 19.139028549194393],
          [72.804862976074503, 19.139583587646541],
          [72.804580688476562, 19.139583587646541],
          [72.804580688476562, 19.139860153198356],
          [72.804031372070369, 19.139860153198356],
          [72.804031372070369, 19.140142440795898],
          [72.80374908447277, 19.140138626098746],
          [72.80374908447277, 19.140693664550895],
          [72.803466796875057, 19.140691757202148],
          [72.803466796875057, 19.141532897949219],
          [72.80374908447277, 19.14152717590332],
          [72.80374908447277, 19.142082214355469],
          [72.804031372070369, 19.142082214355469],
          [72.804031372070369, 19.143474578857365],
          [72.804306030273722, 19.143461227417106],
          [72.804306030273722, 19.14402961730957],
          [72.804580688476562, 19.14402961730957],
          [72.804580688476562, 19.144309997558707],
          [72.804862976074503, 19.144309997558707],
          [72.804862976074503, 19.144861221313533],
          [72.805419921875284, 19.144861221313533],
          [72.805419921875284, 19.145139694213924],
          [72.805694580078296, 19.145139694213924],
          [72.805694580078296, 19.145696640014705],
          [72.805969238281477, 19.14569091796875],
          [72.805969238281477, 19.148750305175781],
          [72.806251525879077, 19.148750305175781],
          [72.806251525879077, 19.149311065673885],
          [72.806526184082088, 19.149311065673885],
          [72.806526184082088, 19.149589538574276],
          [72.807083129882869, 19.149589538574276],
          [72.807083129882869, 19.150140762329102],
          [72.807640075683594, 19.150140762329102],
          [72.807640075683594, 19.150419235229492],
          [72.807914733887003, 19.150417327880916],
          [72.807914733887003, 19.150693893432674],
          [72.808197021484375, 19.150693893432674],
          [72.808197021484375, 19.150972366333065],
          [72.808471679687784, 19.150970458984489],
          [72.808471679687784, 19.151250839233455],
          [72.808746337890796, 19.151250839233455],
          [72.808746337890796, 19.151529312133846],
          [72.809028625488338, 19.151529312133846],
          [72.809028625488338, 19.151811599731388],
          [72.809303283691577, 19.151805877685661],
          [72.809303283691577, 19.152082443237418],
          [72.80958557128929, 19.152082443237418],
          [72.80958557128929, 19.152360916137809],
          [72.809860229492131, 19.152360916137809],
          [72.809860229492131, 19.152652740478516],
          [72.810142517089901, 19.1526393890382],
          [72.810142517089901, 19.153194427490178],
          [72.810691833496094, 19.153194427490178],
          [72.810691833496094, 19.153472900390739],
          [72.810966491699503, 19.153469085693416],
          [72.810966491699503, 19.154031753540096],
          [72.811531066894815, 19.154031753540096],
          [72.811531066894815, 19.154310226440487],
          [72.812080383300838, 19.154306411743164],
          [72.812080383300838, 19.154581069946346],
          [72.812362670898608, 19.154581069946346],
          [72.812362670898608, 19.154861450195312],
          [72.812919616699162, 19.154859542846737],
          [72.812919616699162, 19.15542030334484],
          [72.813194274902401, 19.155416488647518],
          [72.813194274902401, 19.155971527099666],
          [72.813751220703182, 19.15596961975109],
          [72.813751220703182, 19.156250000000057],
          [72.814025878906534, 19.156250000000057],
          [72.814025878906534, 19.156530380249023],
          [72.814308166503906, 19.156528472900447],
          [72.814308166503906, 19.157085418701229],
          [72.814857482910327, 19.157085418701229],
          [72.814857482910327, 19.157363891601562],
          [72.815139770507869, 19.157360076904411],
          [72.815139770507869, 19.157920837402344],
          [72.815696716308821, 19.157917022705192],
          [72.815696716308821, 19.158195495605582],
          [72.815971374511662, 19.158195495605582],
          [72.815971374511662, 19.15847206115734],
          [72.816528320312614, 19.15846061706543],
          [72.816528320312614, 19.159030914306697],
          [72.817359924316406, 19.159030914306697],
          [72.817359924316406, 19.159309387207088],
          [72.817642211914347, 19.159305572509709],
          [72.817642211914347, 19.159585952758903],
          [72.818191528320369, 19.159580230712947],
          [72.818191528320369, 19.159860610961914],
          [72.818466186523608, 19.159860610961914],
          [72.818466186523608, 19.160140991211051],
          [72.81874084472679, 19.160140991211051],
          [72.81874084472679, 19.160419464111442],
          [72.819030761718921, 19.160417556762695],
          [72.819030761718921, 19.160972595214844],
          [72.819313049316634, 19.160970687866268],
          [72.819313049316634, 19.161251068115234],
          [72.819580078125114, 19.161251068115234],
          [72.819580078125114, 19.161809921264762],
          [72.820137023926065, 19.16180610656744],
          [72.820137023926065, 19.162082672119197],
          [72.820419311523438, 19.162080764770621],
          [72.820419311523438, 19.162361145019588],
          [72.820968627929858, 19.162361145019588],
          [72.820968627929858, 19.162639617919979],
          [72.821250915527628, 19.162639617919979],
          [72.821250915527628, 19.162918090820369],
          [72.821525573730639, 19.162916183471793],
          [72.821525573730639, 19.163194656372127],
          [72.821807861328182, 19.163194656372127],
          [72.821807861328182, 19.163473129272518],
          [72.822082519531421, 19.163471221923942],
          [72.822082519531421, 19.164028167724723],
          [72.822639465331974, 19.164028167724723],
          [72.822639465331974, 19.16430473327631],
          [72.822914123535213, 19.16430473327631],
          [72.822914123535213, 19.164861679077262],
          [72.823471069335938, 19.164859771728516],
          [72.823471069335938, 19.165138244628906],
          [72.823753356933878, 19.165138244628906],
          [72.823753356933878, 19.165418624878043],
          [72.824028015136719, 19.165416717529297],
          [72.824028015136719, 19.165971755981445],
          [72.825141906738452, 19.165969848632869],
          [72.825141906738452, 19.166250228881836],
          [72.825965881347713, 19.166250228881836],
          [72.825965881347713, 19.165969848632869],
          [72.826805114746378, 19.165971755981445],
          [72.826805114746378, 19.165416717529297],
          [72.827362060547159, 19.165418624878043],
          [72.827362060547159, 19.165138244628906],
          [72.828186035156421, 19.165138244628906],
          [72.828186035156421, 19.165418624878043],
          [72.828750610351506, 19.165418624878043],
          [72.828750610351506, 19.165700912475586],
          [72.829307556152457, 19.165695190429631],
          [72.829307556152457, 19.165971755981445],
          [72.829582214355526, 19.165969848632869],
          [72.829582214355526, 19.166812896728572],
          [72.829307556152457, 19.166812896728572],
          [72.829307556152457, 19.167650222778263],
          [72.829032897949276, 19.167650222778263],
          [72.829032897949276, 19.167921066284293],
          [72.828475952148665, 19.167917251586971],
          [72.828475952148665, 19.168193817138729],
          [72.827926635742472, 19.168191909790153],
          [72.827926635742472, 19.169031143188477],
          [72.828193664550952, 19.169027328491325],
          [72.828193664550952, 19.169582366943473],
          [72.828750610351506, 19.169580459594727],
          [72.828750610351506, 19.169860839843864],
          [72.829032897949276, 19.169860839843864],
          [72.829032897949276, 19.17014122009283],
          [72.829307556152457, 19.170139312744254],
          [72.829307556152457, 19.170692443847656],
          [72.829582214355526, 19.17069053649908],
          [72.829582214355526, 19.171529769897575],
          [72.829856872558878, 19.171529769897575],
          [72.829856872558878, 19.171810150146541],
          [72.83013916015625, 19.171810150146541],
          [72.83013916015625, 19.172639846801758],
          [72.830413818359659, 19.172637939453182],
          [72.830413818359659, 19.173471450805721],
          [72.83013916015625, 19.173469543457145],
          [72.83013916015625, 19.175140380859432],
          [72.829864501953409, 19.175138473510856],
          [72.829864501953409, 19.175693511963004],
          [72.830413818359659, 19.175693511963004],
          [72.830413818359659, 19.175971984863395],
          [72.830696105957202, 19.175970077514648],
          [72.830696105957202, 19.176530838012752],
          [72.830970764160213, 19.176530838012752],
          [72.830970764160213, 19.177640914917106],
          [72.830696105957202, 19.177637100219783],
          [72.830696105957202, 19.178472518920898],
          [72.830406188965128, 19.178470611572322],
          [72.830406188965128, 19.179859161377067],
          [72.83013916015625, 19.179859161377067],
          [72.83013916015625, 19.180971145629996],
          [72.829864501953409, 19.180971145629996],
          [72.829864501953409, 19.182363510131893],
          [72.829582214355526, 19.182363510131893],
          [72.829582214355526, 19.182638168334961],
          [72.829307556152457, 19.18263053894043],
          [72.829307556152457, 19.182920455932674],
          [72.829032897949276, 19.182920455932674],
          [72.829032897949276, 19.183200836181641],
          [72.828475952148665, 19.183193206787109],
          [72.828475952148665, 19.1834716796875],
          [72.828186035156421, 19.183469772338924],
          [72.828193664550952, 19.183750152587891],
          [72.827919006347713, 19.183750152587891],
          [72.827919006347713, 19.1834716796875],
          [72.827636718750171, 19.1834716796875],
          [72.827636718750171, 19.182638168334961],
          [72.827919006347713, 19.182638168334961],
          [72.827919006347713, 19.182363510131893],
          [72.828193664550952, 19.182363510131893],
          [72.828193664550952, 19.181528091430778],
          [72.828475952148665, 19.18153190612793],
          [72.828475952148665, 19.180971145629996],
          [72.828750610351506, 19.180971145629996],
          [72.828750610351506, 19.180694580078182],
          [72.829025268554744, 19.180694580078182],
          [72.829025268554744, 19.179582595825252],
          [72.829307556152457, 19.179590225219783],
          [72.829307556152457, 19.177921295166072],
          [72.829032897949276, 19.177921295166072],
          [72.829032897949276, 19.177360534667969],
          [72.828750610351506, 19.177360534667969],
          [72.828750610351506, 19.176820755004883],
          [72.828186035156421, 19.176820755004883],
          [72.828186035156421, 19.176530838012752],
          [72.827926635742472, 19.176530838012752],
          [72.827926635742472, 19.176250457763786],
          [72.827636718750171, 19.176250457763786],
          [72.827636718750171, 19.175970077514648],
          [72.827362060547159, 19.175971984863395],
          [72.827362060547159, 19.175695419311637],
          [72.827079772949219, 19.175689697265682],
          [72.827079772949219, 19.175418853759822],
          [72.826812744140909, 19.175420761108398],
          [72.826812744140909, 19.175140380859432],
          [72.826530456543026, 19.175140380859432],
          [72.826530456543026, 19.174860000610465],
          [72.826248168945426, 19.174861907959041],
          [72.826248168945426, 19.174583435058651],
          [72.825691223144474, 19.174583435058651],
          [72.825691223144474, 19.174306869506893],
          [72.825416564941634, 19.174310684204215],
          [72.825416564941634, 19.174030303955078],
          [72.824859619140682, 19.174030303955078],
          [72.824859619140682, 19.173749923706112],
          [72.824584960937671, 19.173749923706112],
          [72.824584960937671, 19.173471450805721],
          [72.824302673340128, 19.173471450805721],
          [72.824302673340128, 19.173196792602539],
          [72.823753356933878, 19.173196792602539],
          [72.823753356933878, 19.172916412353572],
          [72.823471069335938, 19.172920227050895],
          [72.823471069335938, 19.172639846801758],
          [72.823196411132926, 19.172639846801758],
          [72.823196411132926, 19.172359466552791],
          [72.822914123535213, 19.172361373901367],
          [72.822914123535213, 19.172084808349553],
          [72.822639465331974, 19.172084808349553],
          [72.822639465331974, 19.171806335449219],
          [72.822357177734432, 19.171810150146541],
          [72.822357177734432, 19.171529769897575],
          [72.821800231933821, 19.171529769897575],
          [72.821800231933821, 19.171810150146541],
          [72.820137023926065, 19.171810150146541],
          [72.820137023926065, 19.171529769897575],
          [72.819862365722713, 19.171529769897575],
          [72.819862365722713, 19.171249389648438],
          [72.819305419921932, 19.171249389648438],
          [72.819305419921932, 19.170974731445426],
          [72.819030761718921, 19.170974731445426],
          [72.819030761718921, 19.170692443847656],
          [72.818748474121321, 19.170692443847656],
          [72.818748474121321, 19.170139312744254],
          [72.818466186523608, 19.17014122009283],
          [72.818466186523608, 19.169031143188477],
          [72.818191528320369, 19.169031143188477],
          [72.818191528320369, 19.168470382690543],
          [72.817642211914347, 19.168470382690543],
          [72.817642211914347, 19.168193817138729],
          [72.817359924316406, 19.168193817138729],
          [72.817359924316406, 19.167917251586971],
          [72.817092895507926, 19.167921066284293],
          [72.817092895507926, 19.167650222778263],
          [72.816802978515682, 19.167650222778263],
          [72.816802978515682, 19.16736030578619],
          [72.816528320312614, 19.16736030578619],
          [72.816528320312614, 19.167081832885799],
          [72.816253662109432, 19.167083740234375],
          [72.816253662109432, 19.166805267333984],
          [72.815971374511662, 19.166812896728572],
          [72.815971374511662, 19.166532516479549],
          [72.815696716308821, 19.166532516479549],
          [72.815696716308821, 19.165969848632869],
          [72.815414428711108, 19.165971755981445],
          [72.815414428711108, 19.165695190429631],
          [72.815139770507869, 19.165700912475586],
          [72.815139770507869, 19.165138244628906],
          [72.814857482910327, 19.165138244628906],
          [72.814857482910327, 19.164859771728516],
          [72.814582824707315, 19.164861679077262],
          [72.814582824707315, 19.164583206176871],
          [72.814308166503906, 19.164590835571232],
          [72.814308166503906, 19.164028167724723],
          [72.814025878906534, 19.164028167724723],
          [72.814025878906534, 19.163749694824332],
          [72.813751220703182, 19.163749694824332],
          [72.813751220703182, 19.163471221923942],
          [72.813468933105582, 19.163473129272518],
          [72.813468933105582, 19.163194656372127],
          [72.813194274902401, 19.163194656372127],
          [72.813194274902401, 19.162916183471793],
          [72.812919616699162, 19.162918090820369],
          [72.812919616699162, 19.162361145019588],
          [72.81263732910179, 19.162361145019588],
          [72.81263732910179, 19.161809921264762],
          [72.812362670898608, 19.161809921264762],
          [72.812362670898608, 19.161251068115234],
          [72.812080383300838, 19.161251068115234],
          [72.812080383300838, 19.160419464111442],
          [72.811813354492358, 19.160419464111442],
          [72.811813354492358, 19.159860610961914],
          [72.811531066894815, 19.159860610961914],
          [72.811531066894815, 19.159580230712947],
          [72.811805725097827, 19.159585952758903],
          [72.811805725097827, 19.159025192260742],
          [72.811531066894815, 19.159030914306697],
          [72.811531066894815, 19.15846061706543],
          [72.811248779296875, 19.15847206115734],
          [72.811248779296875, 19.157917022705192],
          [72.810966491699503, 19.157920837402344],
          [72.810966491699503, 19.157360076904411],
          [72.810691833496094, 19.157363891601562],
          [72.810691833496094, 19.157085418701229],
          [72.810142517089901, 19.157085418701229],
          [72.810142517089901, 19.156803131103629],
          [72.809860229492131, 19.156810760498161],
          [72.809860229492131, 19.156530380249023],
          [72.809028625488338, 19.156530380249023],
          [72.809028625488338, 19.156250000000057],
          [72.808471679687784, 19.156250000000057],
          [72.808471679687784, 19.15596961975109],
          [72.807914733887003, 19.155971527099666],
          [72.807914733887003, 19.155693054199276],
          [72.807357788086222, 19.155710220336971],
          [72.807357788086222, 19.15514183044445],
          [72.807083129882869, 19.15514183044445],
          [72.807083129882869, 19.154859542846737],
          [72.806526184082088, 19.154861450195312],
          [72.806526184082088, 19.154581069946346],
          [72.806251525879077, 19.154581069946346],
          [72.806251525879077, 19.154861450195312],
          [72.805969238281477, 19.154861450195312],
          [72.805969238281477, 19.154581069946346],
          [72.805694580078296, 19.154581069946346],
          [72.805694580078296, 19.154027938842773],
          [72.805419921875284, 19.154031753540096],
          [72.805419921875284, 19.153749465942383],
          [72.805137634277514, 19.153749465942383],
          [72.805137634277514, 19.153190612793026],
          [72.804862976074503, 19.153194427490178],
          [72.804862976074503, 19.1526393890382],
          [72.804580688476562, 19.152652740478516],
          [72.804580688476562, 19.151529312133846],
          [72.804306030273722, 19.151529312133846],
          [72.804306030273722, 19.150970458984489],
          [72.80374908447277, 19.150972366333065],
          [72.803756713867131, 19.151250839233455],
          [72.803466796875057, 19.151250839233455],
          [72.803466796875057, 19.151529312133846],
          [72.802360534668026, 19.151529312133846],
          [72.802360534668026, 19.151811599731388],
          [72.802085876465014, 19.151805877685661],
          [72.802085876465014, 19.152082443237418],
          [72.80179595947294, 19.152080535888672],
          [72.80179595947294, 19.152360916137809],
          [72.80124664306669, 19.152360916137809],
          [72.80124664306669, 19.152652740478516],
          [72.800971984863338, 19.152652740478516],
          [72.800971984863338, 19.152921676635742],
          [72.80069732666027, 19.152915954589787],
          [72.80069732666027, 19.153194427490178],
          [72.800415039062557, 19.153194427490178],
          [72.800415039062557, 19.153472900390739],
          [72.800140380859318, 19.153469085693416],
          [72.800140380859318, 19.153749465942383],
          [72.799575805664233, 19.153749465942383],
          [72.799575805664233, 19.154031753540096],
          [72.799858093261946, 19.154031753540096],
          [72.799858093261946, 19.154310226440487],
          [72.799583435058764, 19.154306411743164],
          [72.799583435058764, 19.154581069946346],
          [72.799308776855526, 19.154581069946346],
          [72.799308776855526, 19.15514183044445],
          [72.799026489257983, 19.15514183044445],
          [72.799026489257983, 19.155710220336971],
          [72.798751831054972, 19.155693054199276],
          [72.798751831054972, 19.155971527099666],
          [72.798469543457031, 19.15596961975109],
          [72.798469543457031, 19.156250000000057],
          [72.798187255859659, 19.156250000000057],
          [72.798187255859659, 19.15596961975109],
          [72.797920227050838, 19.155971527099666],
          [72.797920227050838, 19.155416488647518],
          [72.798187255859659, 19.15542030334484],
          [72.798187255859659, 19.154581069946346],
          [72.798469543457031, 19.154581069946346],
          [72.798469543457031, 19.154306411743164],
          [72.798751831054972, 19.154310226440487],
          [72.798751831054972, 19.154031753540096],
          [72.799026489257983, 19.154031753540096],
          [72.799026489257983, 19.153469085693416],
          [72.799308776855526, 19.153472900390739],
          [72.799308776855526, 19.153194427490178],
          [72.799583435058764, 19.153194427490178],
          [72.799583435058764, 19.152915954589787],
          [72.800140380859318, 19.152921676635742],
          [72.800140380859318, 19.152360916137809],
          [72.799858093261946, 19.152360916137809],
          [72.799858093261946, 19.152080535888672],
          [72.800140380859318, 19.152082443237418],
          [72.800140380859318, 19.151805877685661],
          [72.80069732666027, 19.151811599731388],
          [72.80069732666027, 19.151250839233455],
          [72.800971984863338, 19.151250839233455],
          [72.800971984863338, 19.150970458984489],
          [72.80124664306669, 19.150972366333065],
          [72.80124664306669, 19.150693893432674],
          [72.801528930664063, 19.150693893432674],
          [72.801528930664063, 19.150417327880916],
          [72.802085876465014, 19.150419235229492],
          [72.802085876465014, 19.148750305175781],
          [72.802360534668026, 19.148750305175781],
          [72.802360534668026, 19.146520614624137],
          [72.802635192871264, 19.146528244018668],
          [72.802635192871264, 19.145139694213924],
          [72.802360534668026, 19.145139694213924],
          [72.802360534668026, 19.14402961730957],
          [72.801528930664063, 19.14402961730957],
          [72.801528930664063, 19.14375114440918],
          [72.800971984863338, 19.14375114440918],
          [72.800971984863338, 19.143461227417106],
          [72.80069732666027, 19.143474578857365],
          [72.80069732666027, 19.142082214355469],
          [72.800415039062557, 19.142082214355469],
          [72.800415039062557, 19.14152717590332],
          [72.800292968750284, 19.141529083252067],
          [72.800140380859318, 19.141532897949219],
          [72.800140380859318, 19.141250610351676],
          [72.799858093261946, 19.141250610351676],
          [72.799858093261946, 19.140970230102539],
          [72.799583435058764, 19.140970230102539],
          [72.799583435058764, 19.140693664550895],
          [72.799308776855526, 19.140693664550895],
          [72.799308776855526, 19.140417098999137],
          [72.799026489257983, 19.140422821044865],
          [72.799026489257983, 19.140142440795898],
          [72.797920227050838, 19.140142440795898],
          [72.797920227050838, 19.140422821044865],
          [72.797637939453239, 19.140417098999137],
          [72.797637939453239, 19.140693664550895],
          [72.795135498047159, 19.140693664550895],
          [72.795135498047159, 19.140417098999137],
          [72.79486083984375, 19.140422821044865],
          [72.79486083984375, 19.140142440795898],
          [72.79514312744169, 19.140142440795898],
          [72.79514312744169, 19.139860153198356],
          [72.795974731445483, 19.139860153198356],
          [72.795967102050952, 19.137081146240291],
          [72.796249389648494, 19.137083053588867],
          [72.796249389648494, 19.136529922485465],
          [72.796516418456974, 19.136529922485465],
          [72.796516418456974, 19.136249542236328],
          [72.796806335449446, 19.136249542236328],
          [72.796806335449446, 19.133470535278434],
          [72.796524047851733, 19.13347244262701],
          [72.796524047851733, 19.132917404174862],
          [72.796249389648494, 19.132921218872184],
          [72.796249389648494, 19.132640838623047],
          [72.795967102050952, 19.132640838623047],
          [72.795967102050952, 19.13236045837408],
          [72.79569244384794, 19.13236045837408],
          [72.79569244384794, 19.132080078125114],
          [72.795417785644531, 19.132085800170898],
          [72.795417785644531, 19.131526947021541],
          [72.795135498047159, 19.131526947021541],
          [72.795135498047159, 19.130973815917912],
          [72.79486083984375, 19.130973815917912],
          [72.79486083984375, 19.130695343017521],
          [72.794586181640739, 19.130701065063477],
          [72.794586181640739, 19.13042068481451],
          [72.793746948242244, 19.13042068481451],
          [72.793746948242244, 19.130140304565543],
          [72.793472290039233, 19.130140304565543],
          [72.793472290039233, 19.129859924316406],
          [72.791526794433878, 19.129859924316406],
          [72.791526794433878, 19.130140304565543],
          [72.790969848632926, 19.130140304565543],
          [72.790969848632926, 19.13042068481451],
          [72.789855957031421, 19.13042068481451],
          [72.789855957031421, 19.130140304565543],
          [72.789581298828182, 19.130140304565543],
          [72.789581298828182, 19.12957954406744],
          [72.789306640625171, 19.129581451416016],
          [72.789306640625171, 19.129304885864201],
          [72.787918090820426, 19.129304885864201],
          [72.787918090820426, 19.129028320312614],
          [72.786804199218921, 19.129028320312614],
          [72.786804199218921, 19.129304885864201],
          [72.786529541015682, 19.129304885864201],
          [72.786529541015682, 19.129581451416016],
          [72.786247253418139, 19.12957954406744],
          [72.786247253418139, 19.13042068481451],
          [72.786529541015682, 19.13042068481451],
          [72.786529541015682, 19.130701065063477],
          [72.787361145019474, 19.130695343017521],
          [72.787361145019474, 19.130973815917912],
          [72.787918090820426, 19.130973815917912],
          [72.787918090820426, 19.131526947021541],
          [72.787635803222713, 19.131521224975586],
          [72.787635803222713, 19.13181114196783],
          [72.786529541015682, 19.131803512573299],
          [72.786529541015682, 19.132085800170898],
          [72.785972595215128, 19.132080078125114],
          [72.785972595215128, 19.132640838623047],
          [72.785690307617188, 19.132640838623047],
          [72.785690307617188, 19.132921218872184],
          [72.785972595215128, 19.132917404174862],
          [72.785972595215128, 19.13347244262701],
          [72.787635803222713, 19.133470535278434],
          [72.787635803222713, 19.134029388427791],
          [72.787918090820426, 19.134029388427791],
          [72.787918090820426, 19.134860992431754],
          [72.788192749023494, 19.134860992431754],
          [72.788192749023494, 19.139583587646541],
          [72.787918090820426, 19.139581680297965],
          [72.787918090820426, 19.140142440795898],
          [72.787635803222713, 19.140142440795898],
          [72.787635803222713, 19.141532897949219],
          [72.787361145019474, 19.14152717590332],
          [72.787361145019474, 19.143192291259822],
          [72.787635803222713, 19.143190383911246],
          [72.787635803222713, 19.14375114440918],
          [72.787918090820426, 19.14375114440918],
          [72.787918090820426, 19.144309997558707],
          [72.788192749023494, 19.144306182861385],
          [72.788192749023494, 19.144584655761719],
          [72.788475036621378, 19.144584655761719],
          [72.788475036621378, 19.144861221313533],
          [72.78875732421875, 19.144861221313533],
          [72.78875732421875, 19.145420074462891],
          [72.789016723633097, 19.145420074462891],
          [72.789016723633097, 19.150140762329102],
          [72.78875732421875, 19.150140762329102],
          [72.78875732421875, 19.150419235229492],
          [72.788475036621378, 19.150417327880916],
          [72.788475036621378, 19.150693893432674],
          [72.788192749023494, 19.150688171386719],
          [72.788192749023494, 19.151250839233455],
          [72.787918090820426, 19.151250839233455],
          [72.787918090820426, 19.152082443237418],
          [72.787635803222713, 19.152080535888672],
          [72.787635803222713, 19.152360916137809],
          [72.787361145019474, 19.152360916137809],
          [72.787361145019474, 19.152652740478516],
          [72.787086486816634, 19.152652740478516],
          [72.787086486816634, 19.152921676635742],
          [72.786804199218921, 19.152915954589787],
          [72.786804199218921, 19.153194427490178],
          [72.786529541015682, 19.153194427490178],
          [72.786529541015682, 19.153472900390739],
          [72.785972595215128, 19.153469085693416],
          [72.785972595215128, 19.153749465942383],
          [72.785423278808878, 19.153749465942383],
          [72.785423278808878, 19.154031753540096],
          [72.784576416015682, 19.154031753540096],
          [72.784576416015682, 19.154310226440487],
          [72.784309387206974, 19.154306411743164],
          [72.784301757812443, 19.154861450195312],
          [72.784027099609602, 19.154859542846737],
          [72.784027099609602, 19.15542030334484],
          [72.784301757812443, 19.15542030334484],
          [72.784309387206974, 19.156250000000057],
          [72.784576416015682, 19.156250000000057],
          [72.784576416015682, 19.156530380249023],
          [72.784309387206974, 19.156528472900447],
          [72.784301757812443, 19.157085418701229],
          [72.784027099609602, 19.157085418701229],
          [72.784027099609602, 19.157363891601562],
          [72.783470153808651, 19.157360076904411],
          [72.783470153808651, 19.157640457153377],
          [72.781249999999943, 19.157638549804801],
          [72.781249999999943, 19.158195495605582],
          [72.781517028808651, 19.158189773559627],
          [72.781517028808651, 19.158750534057731],
          [72.781806945800895, 19.158750534057731],
          [72.781806945800895, 19.159309387207088],
          [72.782363891601847, 19.159305572509709],
          [72.782363891601847, 19.159585952758903],
          [72.783195495605639, 19.159585952758903],
          [72.783195495605639, 19.159860610961914],
          [72.783752441406421, 19.159860610961914],
          [72.783752441406421, 19.160140991211051],
          [72.784027099609602, 19.160140991211051],
          [72.784027099609602, 19.162361145019588],
          [72.783752441406421, 19.162361145019588],
          [72.783752441406421, 19.162639617919979],
          [72.783203125000171, 19.162639617919979],
          [72.783203125000171, 19.162918090820369],
          [72.782638549804687, 19.162916183471793],
          [72.782638549804687, 19.163194656372127],
          [72.781249999999943, 19.163194656372127],
          [72.781249999999943, 19.163473129272518],
          [72.780975341797102, 19.163473129272518],
          [72.780975341797102, 19.16430473327631],
          [72.780693054199389, 19.164300918579158],
          [72.780693054199389, 19.165138244628906],
          [72.780418395996151, 19.165138244628906],
          [72.780418395996151, 19.165971755981445],
          [72.780136108398608, 19.165969848632869],
          [72.780136108398608, 19.166250228881836],
          [72.780418395996151, 19.166250228881836],
          [72.780418395996151, 19.166532516479549],
          [72.780693054199389, 19.166532516479549],
          [72.780693054199389, 19.16736030578619],
          [72.780982971191634, 19.16736030578619],
          [72.780982971191634, 19.167650222778263],
          [72.781249999999943, 19.167650222778263],
          [72.781249999999943, 19.167921066284293],
          [72.781524658203182, 19.167917251586971],
          [72.781524658203182, 19.168193817138729],
          [72.782363891601847, 19.168193817138729],
          [72.782363891601847, 19.167917251586971],
          [72.784027099609602, 19.167921066284293],
          [72.784027099609602, 19.167650222778263],
          [72.784576416015682, 19.167650222778263],
          [72.784576416015682, 19.167081832885799],
          [72.784858703613395, 19.167083740234375],
          [72.784858703613395, 19.166805267333984],
          [72.785140991210994, 19.166812896728572],
          [72.785140991210994, 19.166532516479549],
          [72.786247253418139, 19.166532516479549],
          [72.786247253418139, 19.166812896728572],
          [72.786796569824389, 19.166812896728572],
          [72.786796569824389, 19.16736030578619],
          [72.787086486816634, 19.16736030578619],
          [72.787086486816634, 19.167921066284293],
          [72.787361145019474, 19.167917251586971],
          [72.787361145019474, 19.168193817138729],
          [72.787635803222713, 19.168191909790153],
          [72.787635803222713, 19.168752670288086],
          [72.787918090820426, 19.168752670288086],
          [72.787918090820426, 19.169309616088867],
          [72.788192749023494, 19.169305801391715],
          [72.788192749023494, 19.169582366943473],
          [72.790138244629134, 19.169580459594727],
          [72.790138244629134, 19.169860839843864],
          [72.790412902831974, 19.169860839843864],
          [72.790412902831974, 19.17014122009283],
          [72.790695190429744, 19.170139312744254],
          [72.790695190429744, 19.170974731445426],
          [72.790969848632926, 19.170970916748047],
          [72.790969848632926, 19.171249389648438],
          [72.792076110840128, 19.171249389648438],
          [72.792076110840128, 19.171529769897575],
          [72.792358398437671, 19.171529769897575],
          [72.792358398437671, 19.171810150146541],
          [72.794303894043026, 19.171806335449219],
          [72.794303894043026, 19.172084808349553],
          [72.794586181640739, 19.172080993652401],
          [72.794586181640739, 19.172920227050895],
          [72.79486083984375, 19.172916412353572],
          [72.79486083984375, 19.173471450805721],
          [72.795135498047159, 19.173471450805721],
          [72.795135498047159, 19.173749923706112],
          [72.795417785644531, 19.173749923706112],
          [72.795417785644531, 19.174861907959041],
          [72.79569244384794, 19.174860000610465],
          [72.79569244384794, 19.175420761108398],
          [72.795967102050952, 19.175420761108398],
          [72.795967102050952, 19.177640914917106],
          [72.796249389648494, 19.177640914917106],
          [72.796249389648494, 19.177921295166072],
          [72.796524047851733, 19.17791748046875],
          [72.796524047851733, 19.180694580078182],
          [72.796249389648494, 19.180690765380859],
          [72.796249389648494, 19.18153190612793],
          [72.795974731445483, 19.181528091430778],
          [72.795974731445483, 19.181804656982365],
          [72.796249389648494, 19.181804656982365],
          [72.796249389648494, 19.182363510131893],
          [72.795967102050952, 19.18235969543457],
          [72.795967102050952, 19.182920455932674],
          [72.796249389648494, 19.182920455932674],
          [72.796249389648494, 19.184030532837028],
          [72.796516418456974, 19.184030532837028],
          [72.796516418456974, 19.184860229492244],
          [72.796249389648494, 19.184860229492244],
          [72.796249389648494, 19.187360763549918],
          [72.795967102050952, 19.187360763549918],
          [72.795967102050952, 19.187919616699276],
          [72.79569244384794, 19.1879177093507],
          [72.79569244384794, 19.188472747802848],
          [72.795967102050952, 19.188470840454102],
          [72.795967102050952, 19.191249847412166],
          [72.796249389648494, 19.191249847412166],
          [72.796249389648494, 19.191528320312557],
          [72.795974731445483, 19.191528320312557],
          [72.795974731445483, 19.191804885864315],
          [72.796249389648494, 19.191799163818416],
          [72.796249389648494, 19.19375038146984],
          [72.796524047851733, 19.19375038146984],
          [72.796524047851733, 19.194583892822209],
          [72.796630859375057, 19.194578170776481],
          [72.796806335449446, 19.194570541381893],
          [72.796806335449446, 19.194860458374023],
          [72.796524047851733, 19.194860458374023],
          [72.796524047851733, 19.195421218872127],
          [72.796524047851733, 19.198192596435661],
          [72.796806335449446, 19.198192596435661],
          [72.796806335449446, 19.19847488403326],
          [72.797080993652287, 19.198471069336051],
          [72.797080993652287, 19.198749542236442],
          [72.796806335449446, 19.198749542236442],
          [72.796806335449446, 19.199029922485408],
          [72.797080993652287, 19.199028015136832],
          [72.797080993652287, 19.199583053588981],
          [72.797363281250057, 19.199583053588981],
          [72.797363281250057, 19.199861526489371],
          [72.797920227050838, 19.199861526489371],
          [72.797920227050838, 19.199583053588981],
          [72.798751831054972, 19.199583053588981],
          [72.798751831054972, 19.199861526489371],
          [72.799026489257983, 19.199861526489371],
          [72.799026489257983, 19.199583053588981],
          [72.800415039062557, 19.199583053588981],
          [72.800415039062557, 19.199861526489371],
          [72.80069732666027, 19.199859619140625],
          [72.80069732666027, 19.200420379638729],
          [72.800971984863338, 19.200420379638729],
          [72.800971984863338, 19.200700759887695],
          [72.80124664306669, 19.200696945190543],
          [72.80124664306669, 19.200971603393555],
          [72.801528930664063, 19.200969696044979],
          [72.801528930664063, 19.201530456543082],
          [72.801803588867472, 19.201528549194336],
          [72.801803588867472, 19.202083587646484],
          [72.802085876465014, 19.202079772949332],
          [72.802085876465014, 19.202640533447266],
          [72.802642822265796, 19.202640533447266],
          [72.802642822265796, 19.205139160156364],
          [72.802917480468977, 19.205139160156364],
          [72.802917480468977, 19.206249237060547],
          [72.803192138671818, 19.206249237060547],
          [72.803192138671818, 19.206529617309684],
          [72.803474426269588, 19.206527709960937],
          [72.803474426269588, 19.206806182861328],
          [72.80374908447277, 19.206806182861328],
          [72.80374908447277, 19.20847129821783],
          [72.804031372070369, 19.208469390869254],
          [72.804031372070369, 19.208749771118221],
          [72.804306030273722, 19.208749771118221],
          [72.804306030273722, 19.209030151367188],
          [72.804580688476562, 19.209028244018612],
          [72.804580688476562, 19.209304809570369],
          [72.805137634277514, 19.209304809570369],
          [72.805137634277514, 19.209581375122184],
          [72.805419921875284, 19.209581375122184],
          [72.805419921875284, 19.209863662719727],
          [72.805686950683764, 19.209859848022575],
          [72.805686950683764, 19.210140228271541],
          [72.805969238281477, 19.210140228271541],
          [72.805969238281477, 19.210420608520508],
          [72.806251525879077, 19.210420608520508],
          [72.806251525879077, 19.210700988769474],
          [72.806808471679631, 19.210693359375114],
          [72.806808471679631, 19.21097373962408],
          [72.807640075683594, 19.210969924926758],
          [72.807640075683594, 19.211250305175895],
          [72.807907104492472, 19.211250305175895],
          [72.807907104492472, 19.211530685424862],
          [72.808197021484375, 19.211530685424862],
          [72.808197021484375, 19.211811065673828],
          [72.809028625488338, 19.211803436279297],
          [72.809028625488338, 19.212085723877067],
          [72.809303283691577, 19.212080001831112],
          [72.809303283691577, 19.212360382080078],
          [72.809593200683821, 19.212360382080078],
          [72.809593200683821, 19.212640762329215],
          [72.809860229492131, 19.212640762329215],
          [72.809860229492131, 19.212930679321346],
          [72.810142517089901, 19.212917327880859],
          [72.810142517089901, 19.21319580078125],
          [72.810417175293082, 19.213190078735465],
          [72.810417175293082, 19.213750839233398],
          [72.810691833496094, 19.213750839233398],
          [72.810691833496094, 19.214309692382926],
          [72.811248779296875, 19.21430778503418],
          [72.811248779296875, 19.214582443237362],
          [72.811531066894815, 19.214580535888786],
          [72.811531066894815, 19.215139389038143],
          [72.811248779296875, 19.215139389038143],
          [72.811248779296875, 19.215419769287109],
          [72.810966491699503, 19.215419769287109],
          [72.810966491699503, 19.2156982421875],
          [72.811248779296875, 19.2156982421875],
          [72.811248779296875, 19.216249465942496],
          [72.810966491699503, 19.216249465942496],
          [72.810966491699503, 19.22014045715332],
          [72.811248779296875, 19.22014045715332],
          [72.811248779296875, 19.221250534057674],
          [72.811531066894815, 19.221250534057674],
          [72.811531066894815, 19.221532821655217],
          [72.811805725097827, 19.221527099609489],
          [72.811805725097827, 19.222082138061637],
          [72.812080383300838, 19.222080230712891],
          [72.812080383300838, 19.222360610962028],
          [72.812362670898608, 19.222360610962028],
          [72.812362670898608, 19.222919464111385],
          [72.81263732910179, 19.222917556762809],
          [72.81263732910179, 19.22347450256359],
          [72.814308166503906, 19.223470687866211],
          [72.814308166503906, 19.223751068115348],
          [72.815139770507869, 19.223751068115348],
          [72.815139770507869, 19.224029541015739],
          [72.815696716308821, 19.224029541015739],
          [72.815696716308821, 19.224309921264705],
          [72.815971374511662, 19.22430419921875],
          [72.815971374511662, 19.224584579467717],
          [72.816528320312614, 19.224580764770565],
          [72.816528320312614, 19.224870681762638],
          [72.816802978515682, 19.224870681762638],
          [72.816802978515682, 19.225139617919922],
          [72.817092895507926, 19.225139617919922],
          [72.817092895507926, 19.225419998169059],
          [72.817359924316406, 19.225414276123104],
          [72.817359924316406, 19.225696563720703],
          [72.817642211914347, 19.225696563720703],
          [72.817642211914347, 19.225973129272461],
          [72.817916870117358, 19.225971221923885],
          [72.817916870117358, 19.226249694824276],
          [72.818466186523608, 19.226249694824276],
          [72.818466186523608, 19.226530075073242],
          [72.818748474121321, 19.226528167724666],
          [72.818748474121321, 19.226806640625057],
          [72.819030761718921, 19.226806640625057],
          [72.819030761718921, 19.227083206176815],
          [72.819305419921932, 19.227083206176815],
          [72.819305419921932, 19.227361679077205],
          [72.819580078125114, 19.227359771728629],
          [72.819580078125114, 19.227928161621094],
          [72.819862365722713, 19.227928161621094],
          [72.819862365722713, 19.228200912475529],
          [72.820137023926065, 19.228195190429801],
          [72.820137023926065, 19.228471755981559],
          [72.820419311523438, 19.228469848632812],
          [72.820419311523438, 19.22875022888195],
          [72.820686340332315, 19.22875022888195],
          [72.820686340332315, 19.229030609130916],
          [72.820968627929858, 19.22902870178234],
          [72.820968627929858, 19.229583740234318],
          [72.821250915527628, 19.229579925537166],
          [72.821250915527628, 19.229860305786133],
          [72.821533203125171, 19.229860305786133],
          [72.821533203125171, 19.230419158935661],
          [72.821807861328182, 19.230417251586914],
          [72.821807861328182, 19.230693817138672],
          [72.822082519531421, 19.230693817138672],
          [72.822082519531421, 19.230972290039063],
          [72.822357177734432, 19.230970382690487],
          [72.822357177734432, 19.231529235839844],
          [72.822639465331974, 19.231527328491268],
          [72.822639465331974, 19.232082366943416],
          [72.822914123535213, 19.232084274291992],
          [72.822914123535213, 19.233472824096737],
          [72.823196411132926, 19.233472824096737],
          [72.823196411132926, 19.233749389648551],
          [72.823471069335938, 19.233739852905217],
          [72.823471069335938, 19.234310150146484],
          [72.823753356933878, 19.234306335449332],
          [72.823753356933878, 19.23458290100109],
          [72.824028015136719, 19.23458290100109],
          [72.824028015136719, 19.234861373901481],
          [72.824302673340128, 19.234859466552734],
          [72.824302673340128, 19.235420227050838],
          [72.824584960937671, 19.235416412353516],
          [72.824584960937671, 19.236249923706055],
          [72.825141906738452, 19.236249923706055],
          [72.825141906738452, 19.236530303955192],
          [72.825416564941634, 19.236528396606445],
          [72.825416564941634, 19.237081527710018],
          [72.825691223144474, 19.237081527710018],
          [72.825691223144474, 19.239585876464901],
          [72.825965881347713, 19.239580154418945],
          [72.825965881347713, 19.24041938781744],
          [72.826248168945426, 19.240417480468864],
          [72.826248168945426, 19.240695953369254],
          [72.826530456543026, 19.240690231323299],
          [72.826530456543026, 19.241529464721793],
          [72.826812744140909, 19.241529464721793],
          [72.826812744140909, 19.24180984497076],
          [72.826530456543026, 19.241807937622184],
          [72.826530456543026, 19.242082595825195],
          [72.826805114746378, 19.242082595825195],
          [72.826805114746378, 19.242639541625977],
          [72.827079772949219, 19.242639541625977],
          [72.827079772949219, 19.242916107177791],
          [72.826805114746378, 19.242916107177791],
          [72.826805114746378, 19.243194580078125],
          [72.827079772949219, 19.243190765380973],
          [72.827079772949219, 19.24374961853033],
          [72.827362060547159, 19.24374961853033],
          [72.827362060547159, 19.244304656982479],
          [72.827636718750171, 19.244304656982479],
          [72.827636718750171, 19.24486160278326],
          [72.827926635742472, 19.244859695434684],
          [72.827926635742472, 19.245138168335075],
          [72.828186035156421, 19.245138168335075],
          [72.828186035156421, 19.245700836181584],
          [72.828475952148665, 19.245695114135856],
          [72.828475952148665, 19.245969772338867],
          [72.828788757324389, 19.246013641357479],
          [72.828750610351506, 19.246250152588004],
          [72.829032897949276, 19.246250152588004],
          [72.829032897949276, 19.246532440185547],
          [72.829307556152457, 19.246532440185547],
          [72.829307556152457, 19.24681282043457],
          [72.830413818359659, 19.246805191039982],
          [72.830413818359659, 19.247083663940373],
          [72.831253051757983, 19.247081756591797],
          [72.831253051757983, 19.247360229492188],
          [72.831802368164006, 19.247360229492188],
          [72.831802368164006, 19.247642517089901],
          [72.833740234375171, 19.247642517089901],
          [72.833740234375171, 19.247922897338924],
          [72.834030151367472, 19.247917175292969],
          [72.834030151367472, 19.248193740844727],
          [72.835693359375057, 19.248193740844727],
          [72.835693359375057, 19.248470306396541],
          [72.836250305175781, 19.248470306396541],
          [72.836250305175781, 19.248750686645508],
          [72.836799621582202, 19.248750686645508],
          [72.836799621582202, 19.249031066894645],
          [72.837081909179972, 19.249031066894645],
          [72.837081909179972, 19.249309539795036],
          [72.837638854980526, 19.249305725097713],
          [72.837638854980526, 19.249582290649471],
          [72.837905883789006, 19.249580383300895],
          [72.837905883789006, 19.249860763549862],
          [72.838195800781477, 19.249860763549862],
          [72.838195800781477, 19.250141143798828],
          [72.838752746582088, 19.250141143798828],
          [72.838752746582088, 19.250419616699219],
          [72.839302062988281, 19.250415802002067],
          [72.839302062988281, 19.250692367553825],
          [72.839584350586222, 19.250692367553825],
          [72.839584350586222, 19.252361297607536],
          [72.839866638183594, 19.252359390258789],
          [72.839866638183594, 19.252920150756893],
          [72.839584350586222, 19.252914428710938],
          [72.839584350586222, 19.253471374511719],
          [72.839866638183594, 19.253469467163143],
          [72.839866638183594, 19.254030227661246],
          [72.839584350586222, 19.2540283203125],
          [72.839584350586222, 19.254583358764648],
          [72.839302062988281, 19.254579544067496],
          [72.839302062988281, 19.255420684814567],
          [72.83902740478527, 19.255420684814567],
          [72.83902740478527, 19.255701065063533],
          [72.838752746582088, 19.255695343017635],
          [72.838752746582088, 19.255971908569393],
          [72.838470458984318, 19.255970001220817],
          [72.838470458984318, 19.256250381469783],
          [72.838195800781477, 19.256250381469783],
          [72.838195800781477, 19.25653076171875],
          [72.837638854980526, 19.256528854370174],
          [72.837638854980526, 19.257083892822322],
          [72.837356567382983, 19.257078170776424],
          [72.837356567382983, 19.257640838623104],
          [72.837081909179972, 19.257638931274528],
          [72.837081909179972, 19.258193969726506],
          [72.836807250976562, 19.258193969726506],
          [72.836807250976562, 19.258472442627067],
          [72.83652496337919, 19.258472442627067],
          [72.83652496337919, 19.258750915527457],
          [72.835983276367301, 19.258750915527457],
          [72.835983276367301, 19.259029388427848],
          [72.835693359375057, 19.259027481079102],
          [72.835693359375057, 19.25958251953125],
          [72.835418701171818, 19.259580612182674],
          [72.835418701171818, 19.260421752929744],
          [72.835136413574276, 19.260416030883846],
          [72.835136413574276, 19.26069450378418],
          [72.835418701171818, 19.260690689087028],
          [72.835418701171818, 19.261531829833928],
          [72.835693359375057, 19.261528015136776],
          [72.835693359375057, 19.262081146240348],
          [72.83597564697277, 19.262081146240348],
          [72.83597564697277, 19.262361526489315],
          [72.836250305175781, 19.262361526489315],
          [72.836250305175781, 19.263471603393668],
          [72.83652496337919, 19.263471603393668],
          [72.83652496337919, 19.263750076294059],
          [72.836799621582202, 19.263750076294059],
          [72.836799621582202, 19.26403999328619],
          [72.837081909179972, 19.26403999328619],
          [72.837081909179972, 19.264860153198242],
          [72.837356567382983, 19.264860153198242],
          [72.837356567382983, 19.265140533447379],
          [72.837638854980526, 19.265140533447379],
          [72.837638854980526, 19.265420913696346],
          [72.837913513183764, 19.265417098999023],
          [72.837913513183764, 19.265695571899414],
          [72.838195800781477, 19.265695571899414],
          [72.838195800781477, 19.265972137451172],
          [72.838470458984318, 19.265970230102596],
          [72.838470458984318, 19.266250610351562],
          [72.838752746582088, 19.266250610351562],
          [72.838752746582088, 19.2665309906007],
          [72.83902740478527, 19.2665309906007],
          [72.83902740478527, 19.26680946350109],
          [72.839302062988281, 19.266805648803768],
          [72.839302062988281, 19.267084121704102],
          [72.83957672119169, 19.26708030700695],
          [72.83957672119169, 19.267360687255916],
          [72.839302062988281, 19.267360687255916],
          [72.839302062988281, 19.267641067504883],
          [72.83902740478527, 19.267641067504883],
          [72.83902740478527, 19.267360687255916],
          [72.838752746582088, 19.267360687255916],
          [72.838752746582088, 19.26708030700695],
          [72.838195800781477, 19.267084121704102],
          [72.838195800781477, 19.266805648803768],
          [72.837905883789006, 19.26680946350109],
          [72.837905883789006, 19.2665309906007],
          [72.837638854980526, 19.2665309906007],
          [72.837638854980526, 19.266250610351562],
          [72.837356567382983, 19.266250610351562],
          [72.837356567382983, 19.265970230102596],
          [72.837081909179972, 19.265972137451172],
          [72.837081909179972, 19.265695571899414],
          [72.836807250976562, 19.265695571899414],
          [72.836807250976562, 19.265138626098633],
          [72.836532592773722, 19.265140533447379],
          [72.836532592773722, 19.264860153198242],
          [72.836250305175781, 19.264862060546989],
          [72.836250305175781, 19.26402854919445],
          [72.835983276367301, 19.26403999328619],
          [72.835983276367301, 19.263750076294059],
          [72.835693359375057, 19.263750076294059],
          [72.835693359375057, 19.263469696044922],
          [72.835418701171818, 19.263471603393668],
          [72.835418701171818, 19.262361526489315],
          [72.835136413574276, 19.262361526489315],
          [72.835136413574276, 19.262081146240348],
          [72.834861755371264, 19.262081146240348],
          [72.834861755371264, 19.261528015136776],
          [72.834587097168026, 19.261531829833928],
          [72.834587097168026, 19.260690689087028],
          [72.834304809570483, 19.26069450378418],
          [72.834304809570483, 19.260139465332031],
          [72.834587097168026, 19.260139465332031],
          [72.834587097168026, 19.259311676025391],
          [72.834861755371264, 19.259311676025391],
          [72.834861755371264, 19.258750915527457],
          [72.835136413574276, 19.258750915527457],
          [72.835136413574276, 19.25847053527832],
          [72.835693359375057, 19.258472442627067],
          [72.835693359375057, 19.258193969726506],
          [72.83597564697277, 19.258193969726506],
          [72.83597564697277, 19.257917404174918],
          [72.836250305175781, 19.257917404174918],
          [72.836250305175781, 19.257638931274528],
          [72.836532592773722, 19.257640838623104],
          [72.836532592773722, 19.257078170776424],
          [72.836807250976562, 19.257083892822322],
          [72.836807250976562, 19.256528854370174],
          [72.837081909179972, 19.25653076171875],
          [72.837081909179972, 19.256250381469783],
          [72.837356567382983, 19.256250381469783],
          [72.837356567382983, 19.255970001220817],
          [72.837638854980526, 19.255971908569393],
          [72.837638854980526, 19.255695343017635],
          [72.837905883789006, 19.255701065063533],
          [72.837905883789006, 19.253749847412109],
          [72.837638854980526, 19.253749847412109],
          [72.837638854980526, 19.253469467163143],
          [72.837364196777514, 19.253471374511719],
          [72.837364196777514, 19.252914428710938],
          [72.837081909179972, 19.252920150756893],
          [72.837081909179972, 19.252639770507926],
          [72.836799621582202, 19.252639770507926],
          [72.836799621582202, 19.252080917358398],
          [72.83652496337919, 19.252084732055778],
          [72.83652496337919, 19.251249313354606],
          [72.835983276367301, 19.251251220703182],
          [72.835983276367301, 19.250970840454215],
          [72.834587097168026, 19.250974655151424],
          [72.834587097168026, 19.250692367553825],
          [72.83347320556669, 19.250692367553825],
          [72.83347320556669, 19.250415802002067],
          [72.830696105957202, 19.250419616699219],
          [72.830696105957202, 19.250141143798828],
          [72.829032897949276, 19.250141143798828],
          [72.829032897949276, 19.249860763549862],
          [72.828475952148665, 19.249860763549862],
          [72.828475952148665, 19.249580383300895],
          [72.827636718750171, 19.249582290649471],
          [72.827636718750171, 19.249305725097713],
          [72.827362060547159, 19.249305725097713],
          [72.827362060547159, 19.249582290649471],
          [72.827079772949219, 19.249582290649471],
          [72.827079772949219, 19.249305725097713],
          [72.826812744140909, 19.249309539795036],
          [72.826812744140909, 19.249031066894645],
          [72.826248168945426, 19.249031066894645],
          [72.826248168945426, 19.248750686645508],
          [72.825698852539006, 19.248750686645508],
          [72.825691223144474, 19.248470306396541],
          [72.825416564941634, 19.248470306396541],
          [72.825416564941634, 19.248193740844727],
          [72.825141906738452, 19.248193740844727],
          [72.825141906738452, 19.247917175292969],
          [72.824859619140682, 19.247922897338924],
          [72.824859619140682, 19.247642517089901],
          [72.824577331543139, 19.247642517089901],
          [72.824577331543139, 19.247360229492188],
          [72.824302673340128, 19.247360229492188],
          [72.824302673340128, 19.247081756591797],
          [72.823753356933878, 19.247083663940373],
          [72.823753356933878, 19.246805191039982],
          [72.823471069335938, 19.24681282043457],
          [72.823471069335938, 19.246532440185547],
          [72.823196411132926, 19.246532440185547],
          [72.823196411132926, 19.246250152588004],
          [72.822906494140682, 19.246250152588004],
          [72.822906494140682, 19.245969772338867],
          [72.822639465331974, 19.245971679687614],
          [72.822639465331974, 19.245695114135856],
          [72.822357177734432, 19.245700836181584],
          [72.822357177734432, 19.245418548584041],
          [72.821800231933821, 19.245418548584041],
          [72.821800231933821, 19.245138168335075],
          [72.820968627929858, 19.245138168335075],
          [72.820968627929858, 19.245418548584041],
          [72.820419311523438, 19.245418548584041],
          [72.820419311523438, 19.244859695434684],
          [72.820693969726847, 19.24486160278326],
          [72.820693969726847, 19.244583129882869],
          [72.820968627929858, 19.244583129882869],
          [72.820968627929858, 19.24374961853033],
          [72.821533203125171, 19.24374961853033],
          [72.821525573730639, 19.242082595825195],
          [72.821250915527628, 19.242082595825195],
          [72.821250915527628, 19.241807937622184],
          [72.821533203125171, 19.24180984497076],
          [72.821533203125171, 19.241529464721793],
          [72.821250915527628, 19.241529464721793],
          [72.821250915527628, 19.240690231323299],
          [72.820968627929858, 19.240695953369254],
          [72.820968627929858, 19.240139007568473],
          [72.820686340332315, 19.240140914917049],
          [72.820686340332315, 19.239311218261662],
          [72.820419311523438, 19.239311218261662],
          [72.820419311523438, 19.238470077514762],
          [72.820137023926065, 19.238473892211914],
          [72.820137023926065, 19.237638473510799],
          [72.819862365722713, 19.237640380859375],
          [72.819862365722713, 19.236810684204158],
          [72.819580078125114, 19.236810684204158],
          [72.819580078125114, 19.236249923706055],
          [72.819305419921932, 19.236249923706055],
          [72.819305419921932, 19.235971450805664],
          [72.819030761718921, 19.235971450805664],
          [72.819030761718921, 19.235416412353516],
          [72.818466186523608, 19.235420227050838],
          [72.818466186523608, 19.235139846801871],
          [72.818191528320369, 19.235139846801871],
          [72.818191528320369, 19.23458290100109],
          [72.817916870117358, 19.23458290100109],
          [72.817916870117358, 19.234306335449332],
          [72.817642211914347, 19.234310150146484],
          [72.817642211914347, 19.234031677246094],
          [72.817092895507926, 19.234031677246094],
          [72.817092895507926, 19.233470916748161],
          [72.816802978515682, 19.233472824096737],
          [72.816802978515682, 19.232915878296012],
          [72.816528320312614, 19.23292160034174],
          [72.816528320312614, 19.232639312744197],
          [72.816246032714901, 19.232639312744197],
          [72.816246032714901, 19.23208045959484],
          [72.815971374511662, 19.232084274291992],
          [72.815971374511662, 19.231805801391658],
          [72.815696716308821, 19.231811523437557],
          [72.815696716308821, 19.231250762939453],
          [72.815139770507869, 19.231250762939453],
          [72.815139770507869, 19.230970382690487],
          [72.814857482910327, 19.230972290039063],
          [72.814857482910327, 19.230693817138672],
          [72.814582824707315, 19.230693817138672],
          [72.814582824707315, 19.230417251586914],
          [72.814308166503906, 19.230419158935661],
          [72.814308166503906, 19.23014068603527],
          [72.813186645507869, 19.23014068603527],
          [72.813186645507869, 19.229860305786133],
          [72.812362670898608, 19.229860305786133],
          [72.812362670898608, 19.229579925537166],
          [72.812080383300838, 19.229583740234318],
          [72.812080383300838, 19.229305267333928],
          [72.811813354492358, 19.229309082031307],
          [72.811813354492358, 19.229030609130916],
          [72.811531066894815, 19.229030609130916],
          [72.811531066894815, 19.22875022888195],
          [72.811248779296875, 19.22875022888195],
          [72.811248779296875, 19.228469848632812],
          [72.810974121094034, 19.228471755981559],
          [72.810974121094034, 19.228195190429801],
          [72.810691833496094, 19.228200912475529],
          [72.810691833496094, 19.227928161621094],
          [72.810417175293082, 19.227928161621094],
          [72.810417175293082, 19.227640151977596],
          [72.810142517089901, 19.227640151977596],
          [72.810142517089901, 19.227359771728629],
          [72.809860229492131, 19.227361679077205],
          [72.809860229492131, 19.226806640625057],
          [72.80958557128929, 19.226806640625057],
          [72.80958557128929, 19.226528167724666],
          [72.809303283691577, 19.226530075073242],
          [72.809303283691577, 19.226249694824276],
          [72.809028625488338, 19.226249694824276],
          [72.809028625488338, 19.225971221923885],
          [72.808471679687784, 19.225973129272461],
          [72.808471679687784, 19.225696563720703],
          [72.808197021484375, 19.225696563720703],
          [72.808197021484375, 19.225414276123104],
          [72.807907104492472, 19.225419998169059],
          [72.807907104492472, 19.225139617919922],
          [72.807640075683594, 19.225139617919922],
          [72.807640075683594, 19.224870681762638],
          [72.807357788086222, 19.224870681762638],
          [72.807357788086222, 19.224580764770565],
          [72.807083129882869, 19.224584579467717],
          [72.807083129882869, 19.224027633666992],
          [72.80680084228527, 19.224029541015739],
          [72.80680084228527, 19.223470687866211],
          [72.806526184082088, 19.22347450256359],
          [72.806526184082088, 19.22319221496582],
          [72.806251525879077, 19.22319221496582],
          [72.806251525879077, 19.222917556762809],
          [72.805969238281477, 19.222919464111385],
          [72.805969238281477, 19.222360610962028],
          [72.805686950683764, 19.222360610962028],
          [72.805686950683764, 19.222080230712891],
          [72.805419921875284, 19.222082138061637],
          [72.805419921875284, 19.221805572509879],
          [72.805137634277514, 19.221805572509879],
          [72.805137634277514, 19.220970153808707],
          [72.804306030273722, 19.220970153808707],
          [72.804306030273722, 19.221250534057674],
          [72.804031372070369, 19.221250534057674],
          [72.804031372070369, 19.221532821655217],
          [72.803474426269588, 19.221527099609489],
          [72.803474426269588, 19.221805572509879],
          [72.802917480468977, 19.221805572509879],
          [72.802917480468977, 19.222082138061637],
          [72.802360534668026, 19.222080230712891],
          [72.802360534668026, 19.222360610962028],
          [72.80069732666027, 19.222360610962028],
          [72.80069732666027, 19.222919464111385],
          [72.800415039062557, 19.222917556762809],
          [72.800415039062557, 19.22319221496582],
          [72.799858093261946, 19.22319221496582],
          [72.799858093261946, 19.22347450256359],
          [72.798751831054972, 19.22347450256359],
          [72.798751831054972, 19.22319221496582],
          [72.798469543457031, 19.22319221496582],
          [72.798469543457031, 19.222639083862418],
          [72.798751831054972, 19.22264289855957],
          [72.798751831054972, 19.222360610962028],
          [72.799308776855526, 19.222360610962028],
          [72.799308776855526, 19.222080230712891],
          [72.800140380859318, 19.222082138061637],
          [72.800140380859318, 19.221805572509879],
          [72.80069732666027, 19.221805572509879],
          [72.80069732666027, 19.221527099609489],
          [72.80124664306669, 19.221532821655217],
          [72.80124664306669, 19.221250534057674],
          [72.801528930664063, 19.221250534057674],
          [72.801528930664063, 19.220970153808707],
          [72.802635192871264, 19.220970153808707],
          [72.802635192871264, 19.220693588256893],
          [72.802917480468977, 19.220693588256893],
          [72.802917480468977, 19.220417022705135],
          [72.803192138671818, 19.22042274475109],
          [72.803192138671818, 19.22014045715332],
          [72.803466796875057, 19.22014045715332],
          [72.803466796875057, 19.219860076904354],
          [72.80374908447277, 19.219860076904354],
          [72.80374908447277, 19.219305038452148],
          [72.804031372070369, 19.219312667846737],
          [72.804031372070369, 19.218740463256893],
          [72.80374908447277, 19.218748092651424],
          [72.80374908447277, 19.217361450195426],
          [72.803474426269588, 19.217361450195426],
          [72.803474426269588, 19.216806411743278],
          [72.803192138671818, 19.216808319091854],
          [72.803192138671818, 19.216529846191463],
          [72.802917480468977, 19.216529846191463],
          [72.802917480468977, 19.216249465942496],
          [72.802642822265796, 19.216249465942496],
          [72.802642822265796, 19.216529846191463],
          [72.802360534668026, 19.216529846191463],
          [72.802360534668026, 19.216249465942496],
          [72.802085876465014, 19.216249465942496],
          [72.802085876465014, 19.2156982421875],
          [72.80179595947294, 19.2156982421875],
          [72.80179595947294, 19.215419769287109],
          [72.801528930664063, 19.215419769287109],
          [72.801528930664063, 19.215139389038143],
          [72.80124664306669, 19.215139389038143],
          [72.80124664306669, 19.214860916137752],
          [72.800971984863338, 19.214860916137752],
          [72.800971984863338, 19.214580535888786],
          [72.80069732666027, 19.214582443237362],
          [72.80069732666027, 19.21430778503418],
          [72.800140380859318, 19.214309692382926],
          [72.800140380859318, 19.213470458984432],
          [72.799858093261946, 19.213472366333008],
          [72.799858093261946, 19.212917327880859],
          [72.799575805664233, 19.212930679321346],
          [72.799575805664233, 19.212640762329215],
          [72.799308776855526, 19.212640762329215],
          [72.799308776855526, 19.212360382080078],
          [72.799026489257983, 19.212360382080078],
          [72.799026489257983, 19.212080001831112],
          [72.798751831054972, 19.212085723877067],
          [72.798751831054972, 19.211803436279297],
          [72.798469543457031, 19.211811065673828],
          [72.798469543457031, 19.211530685424862],
          [72.798187255859659, 19.211530685424862],
          [72.798187255859659, 19.211250305175895],
          [72.797920227050838, 19.211250305175895],
          [72.797920227050838, 19.210700988769474],
          [72.797630310058878, 19.210700988769474],
          [72.797630310058878, 19.210420608520508],
          [72.797363281250057, 19.210420608520508],
          [72.797363281250057, 19.209859848022575],
          [72.797080993652287, 19.209863662719727],
          [72.797080993652287, 19.209304809570369],
          [72.796806335449446, 19.209304809570369],
          [72.796806335449446, 19.208749771118221],
          [72.796516418456974, 19.208749771118221],
          [72.796516418456974, 19.207920074463004],
          [72.796249389648494, 19.207920074463004],
          [72.796249389648494, 19.207639694213867],
          [72.795967102050952, 19.207639694213867],
          [72.795967102050952, 19.20708084106451],
          [72.79486083984375, 19.207082748413086],
          [72.79486083984375, 19.206806182861328],
          [72.794586181640739, 19.206806182861328],
          [72.794586181640739, 19.206527709960937],
          [72.794296264648494, 19.206529617309684],
          [72.794296264648494, 19.206249237060547],
          [72.794029235839787, 19.206249237060547],
          [72.794029235839787, 19.205970764160156],
          [72.793746948242244, 19.205972671508903],
          [72.793746948242244, 19.205417633056754],
          [72.793197631835994, 19.205421447753906],
          [72.793197631835994, 19.205139160156364],
          [72.792922973632983, 19.205139160156364],
          [72.792922973632983, 19.204580307006836],
          [72.79264068603544, 19.204584121704158],
          [72.79264068603544, 19.204305648803825],
          [72.792358398437671, 19.204307556152401],
          [72.792358398437671, 19.203758239746151],
          [72.792076110840128, 19.203758239746151],
          [72.792076110840128, 19.202640533447266],
          [72.791816711425838, 19.202640533447266],
          [72.791816711425838, 19.200700759887695],
          [72.792076110840128, 19.200700759887695],
          [72.792076110840128, 19.200139999389762],
          [72.792358398437671, 19.200139999389762],
          [72.792358398437671, 19.199859619140625],
          [72.79264068603544, 19.199861526489371],
          [72.79264068603544, 19.199583053588981],
          [72.792915344238452, 19.199583053588981],
          [72.792915344238452, 19.199028015136832],
          [72.793197631835994, 19.199029922485408],
          [72.793197631835994, 19.198471069336051],
          [72.793472290039233, 19.19847488403326],
          [72.793472290039233, 19.197639465332088],
          [72.793746948242244, 19.197639465332088],
          [72.793746948242244, 19.195974349975529],
          [72.793472290039233, 19.195974349975529],
          [72.793472290039233, 19.195692062377987],
          [72.793197631835994, 19.195692062377987],
          [72.793197631835994, 19.195138931274414],
          [72.792922973632983, 19.195142745971737],
          [72.792922973632983, 19.194860458374023],
          [72.79264068603544, 19.194860458374023],
          [72.79264068603544, 19.194570541381893],
          [72.792358398437671, 19.194583892822209],
          [72.792358398437671, 19.194305419921818],
          [72.792076110840128, 19.194311141967773],
          [72.792076110840128, 19.194032669067383],
          [72.791816711425838, 19.194032669067383],
          [72.791816711425838, 19.19375038146984],
          [72.791526794433878, 19.19375038146984],
          [72.791526794433878, 19.19347190856945],
          [72.791252136230526, 19.19347190856945],
          [72.791252136230526, 19.193195343017692],
          [72.790969848632926, 19.19320106506342],
          [72.790969848632926, 19.192922592163029],
          [72.790138244629134, 19.192922592163029],
          [72.790138244629134, 19.192640304565487],
          [72.789016723633097, 19.192640304565487],
          [72.789016723633097, 19.192922592163029],
          [72.78875732421875, 19.192922592163029],
          [72.78875732421875, 19.19320106506342],
          [72.788475036621378, 19.193195343017692],
          [72.788475036621378, 19.19347190856945],
          [72.787918090820426, 19.19347190856945],
          [72.787918090820426, 19.193195343017692],
          [72.787086486816634, 19.19320106506342],
          [72.787086486816634, 19.192922592163029],
          [72.785972595215128, 19.192922592163029],
          [72.785972595215128, 19.192640304565487],
          [72.785690307617188, 19.192640304565487],
          [72.785690307617188, 19.19235992431652],
          [72.785423278808878, 19.19235992431652],
          [72.785423278808878, 19.192640304565487],
          [72.784576416015682, 19.192640304565487],
          [72.784576416015682, 19.19235992431652],
          [72.783752441406421, 19.19235992431652],
          [72.783752441406421, 19.192640304565487],
          [72.783470153808651, 19.192640304565487],
          [72.783470153808651, 19.192922592163029],
          [72.783203125000171, 19.192922592163029],
          [72.783203125000171, 19.19320106506342],
          [72.782363891601847, 19.193195343017692],
          [72.782363891601847, 19.19347190856945],
          [72.782081604003906, 19.19347190856945],
          [72.782081604003906, 19.19375038146984],
          [72.781806945800895, 19.19375038146984],
          [72.781806945800895, 19.194032669067383],
          [72.781524658203182, 19.194026947021484],
          [72.781524658203182, 19.194583892822209],
          [72.781249999999943, 19.194570541381893],
          [72.781249999999943, 19.196529388427734],
          [72.781524658203182, 19.196527481079158],
          [72.781524658203182, 19.197082519531307],
          [72.781806945800895, 19.197082519531307],
          [72.781806945800895, 19.199300765991268],
          [72.782081604003906, 19.199310302734375],
          [72.782081604003906, 19.200139999389762],
          [72.782356262207315, 19.200139999389762],
          [72.782356262207315, 19.200700759887695],
          [72.782638549804687, 19.200696945190543],
          [72.782638549804687, 19.200971603393555],
          [72.782913208008097, 19.200969696044979],
          [72.782913208008097, 19.201250076293945],
          [72.784576416015682, 19.201250076293945],
          [72.784576416015682, 19.200969696044979],
          [72.785140991210994, 19.200969696044979],
          [72.785140991210994, 19.201250076293945],
          [72.785690307617188, 19.201250076293945],
          [72.785690307617188, 19.201530456543082],
          [72.785972595215128, 19.201530456543082],
          [72.785972595215128, 19.201810836792049],
          [72.786247253418139, 19.201810836792049],
          [72.786247253418139, 19.202640533447266],
          [72.785972595215128, 19.20263862609869],
          [72.785972595215128, 19.203472137451229],
          [72.785690307617188, 19.203470230102653],
          [72.785690307617188, 19.203758239746151],
          [72.785140991210994, 19.203758239746151],
          [72.785140991210994, 19.205139160156364],
          [72.784858703613395, 19.205139160156364],
          [72.784858703613395, 19.205421447753906],
          [72.784584045410213, 19.205417633056754],
          [72.784584045410213, 19.205694198608342],
          [72.784309387206974, 19.205694198608342],
          [72.784301757812443, 19.205972671508903],
          [72.783752441406421, 19.205970764160156],
          [72.783752441406421, 19.206249237060547],
          [72.781517028808651, 19.206249237060547],
          [72.781517028808651, 19.205970764160156],
          [72.781249999999943, 19.205972671508903],
          [72.781249999999943, 19.205694198608342],
          [72.780975341797102, 19.205694198608342],
          [72.780975341797102, 19.205417633056754],
          [72.779296875000284, 19.205421447753906],
          [72.779296875000284, 19.207359313964901],
          [72.779586791992188, 19.207359313964901],
          [72.779586791992188, 19.207639694213867],
          [72.779861450195597, 19.207639694213867],
          [72.779861450195597, 19.207920074463004],
          [72.780136108398608, 19.207916259765682],
          [72.780136108398608, 19.20847129821783],
          [72.780418395996151, 19.208469390869254],
          [72.780418395996151, 19.209030151367188],
          [72.780693054199389, 19.209028244018612],
          [72.780693054199389, 19.209304809570369],
          [72.780982971191634, 19.209302902221793],
          [72.780982971191634, 19.210140228271541],
          [72.781249999999943, 19.210140228271541],
          [72.781249999999943, 19.211530685424862],
          [72.781517028808651, 19.211530685424862],
          [72.781517028808651, 19.215139389038143],
          [72.781249999999943, 19.215139389038143],
          [72.781249999999943, 19.2156982421875],
          [72.780982971191634, 19.2156982421875],
          [72.780982971191634, 19.216529846191463],
          [72.780693054199389, 19.216529846191463],
          [72.780693054199389, 19.216808319091854],
          [72.780418395996151, 19.216806411743278],
          [72.780418395996151, 19.217082977295036],
          [72.780136108398608, 19.217082977295036],
          [72.780136108398608, 19.217361450195426],
          [72.779861450195597, 19.21735954284668],
          [72.779861450195597, 19.217639923095817],
          [72.779586791992188, 19.217639923095817],
          [72.779586791992188, 19.217918395996207],
          [72.779029846191406, 19.217918395996207],
          [72.779029846191406, 19.219312667846737],
          [72.778747558594034, 19.219305038452148],
          [72.778747558594034, 19.219860076904354],
          [72.778472900390682, 19.219860076904354],
          [72.778472900390682, 19.22014045715332],
          [72.778198242187443, 19.22014045715332],
          [72.778198242187443, 19.219999313354435],
          [72.778190612793082, 19.219860076904354],
          [72.777915954589901, 19.219860076904354],
          [72.777915954589901, 19.22014045715332],
          [72.777641296386889, 19.220138549804744],
          [72.777641296386889, 19.220693588256893],
          [72.77735900878929, 19.220693588256893],
          [72.77735900878929, 19.220970153808707],
          [72.776802062988338, 19.220970153808707],
          [72.776802062988338, 19.221250534057674],
          [72.776527404785327, 19.221250534057674],
          [72.776527404785327, 19.221532821655217],
          [72.776252746582315, 19.221527099609489],
          [72.776252746582315, 19.222082138061637],
          [72.775970458984375, 19.222082138061637],
          [72.775970458984375, 19.224584579467717],
          [72.776252746582315, 19.224584579467717],
          [72.776252746582315, 19.225696563720703],
          [72.776527404785327, 19.225690841674918],
          [72.776527404785327, 19.226249694824276],
          [72.776802062988338, 19.226249694824276],
          [72.776802062988338, 19.226806640625057],
          [72.77735900878929, 19.226806640625057],
          [72.77735900878929, 19.227083206176815],
          [72.777641296386889, 19.227083206176815],
          [72.777641296386889, 19.227361679077205],
          [72.777915954589901, 19.227359771728629],
          [72.777915954589901, 19.227640151977596],
          [72.778472900390682, 19.227640151977596],
          [72.778472900390682, 19.227928161621094],
          [72.778747558594034, 19.227928161621094],
          [72.778747558594034, 19.228200912475529],
          [72.779029846191406, 19.228200912475529],
          [72.779029846191406, 19.22875022888195],
          [72.779296875000284, 19.22875022888195],
          [72.779296875000284, 19.229860305786133],
          [72.779586791992188, 19.229860305786133],
          [72.779586791992188, 19.230419158935661],
          [72.779861450195597, 19.230417251586914],
          [72.779861450195597, 19.233194351196346],
          [72.779586791992188, 19.233190536499023],
          [72.779586791992188, 19.235420227050838],
          [72.779304504394815, 19.235416412353516],
          [72.779304504394815, 19.235971450805664],
          [72.779029846191406, 19.235969543457088],
          [72.779029846191406, 19.236249923706055],
          [72.778747558594034, 19.236249923706055],
          [72.778747558594034, 19.236530303955192],
          [72.778198242187443, 19.236528396606445],
          [72.778198242187443, 19.237081527710018],
          [72.777915954589901, 19.237079620361442],
          [72.777915954589901, 19.237920761108512],
          [72.779586791992188, 19.23791694641119],
          [72.779586791992188, 19.23819541931158],
          [72.779861450195597, 19.23819541931158],
          [72.779861450195597, 19.238473892211914],
          [72.780136108398608, 19.238470077514762],
          [72.780136108398608, 19.239311218261662],
          [72.780418395996151, 19.239311218261662],
          [72.780418395996151, 19.23987007141119],
          [72.780693054199389, 19.239860534668082],
          [72.780693054199389, 19.240972518921012],
          [72.780418395996151, 19.240970611572266],
          [72.780418395996151, 19.241250991821403],
          [72.780136108398608, 19.241250991821403],
          [72.780136108398608, 19.242361068725586],
          [72.780418395996151, 19.242361068725586],
          [72.780418395996151, 19.243194580078125],
          [72.780693054199389, 19.243194580078125],
          [72.780693054199389, 19.243473052978516],
          [72.780975341797102, 19.243473052978516],
          [72.780975341797102, 19.24374961853033],
          [72.781249999999943, 19.24374961853033],
          [72.781249999999943, 19.244304656982479],
          [72.780982971191634, 19.244300842285156],
          [72.780982971191634, 19.245418548584041],
          [72.781249999999943, 19.245416641235465],
          [72.781249999999943, 19.245971679687614],
          [72.781517028808651, 19.245969772338867],
          [72.781517028808651, 19.24681282043457],
          [72.781806945800895, 19.24681282043457],
          [72.781806945800895, 19.247922897338924],
          [72.782081604003906, 19.247922897338924],
          [72.782081604003906, 19.249031066894645],
          [72.782356262207315, 19.249031066894645],
          [72.782356262207315, 19.249860763549862],
          [72.782630920410327, 19.249860763549862],
          [72.782630920410327, 19.250141143798828],
          [72.782913208008097, 19.250141143798828],
          [72.782913208008097, 19.251810073852539],
          [72.782638549804687, 19.251806259155387],
          [72.782638549804687, 19.253196716308707],
          [72.782356262207315, 19.253190994262752],
          [72.782356262207315, 19.25653076171875],
          [72.782081604003906, 19.256528854370174],
          [72.782081604003906, 19.257083892822322],
          [72.781806945800895, 19.257083892822322],
          [72.781806945800895, 19.258193969726506],
          [72.781524658203182, 19.258193969726506],
          [72.781524658203182, 19.25958251953125],
          [72.781806945800895, 19.259580612182674],
          [72.781806945800895, 19.260139465332031],
          [72.782913208008097, 19.260139465332031],
          [72.782913208008097, 19.260421752929744],
          [72.783195495605639, 19.260416030883846],
          [72.783195495605639, 19.26069450378418],
          [72.783470153808651, 19.260690689087028],
          [72.783470153808651, 19.261531829833928],
          [72.783752441406421, 19.261528015136776],
          [72.783752441406421, 19.261802673339957],
          [72.784027099609602, 19.261806488037166],
          [72.784027099609602, 19.263471603393668],
          [72.783752441406421, 19.263469696044922],
          [72.783752441406421, 19.26403999328619],
          [72.783470153808651, 19.26403999328619],
          [72.783470153808651, 19.265140533447379],
          [72.783752441406421, 19.265140533447379],
          [72.783752441406421, 19.265420913696346],
          [72.784301757812443, 19.265417098999023],
          [72.784309387206974, 19.265695571899414],
          [72.784584045410213, 19.265695571899414],
          [72.784584045410213, 19.265972137451172],
          [72.784309387206974, 19.265972137451172],
          [72.784301757812443, 19.268194198608455],
          [72.784027099609602, 19.268194198608455],
          [72.784027099609602, 19.268472671508846],
          [72.783752441406421, 19.26847076416027],
          [72.783752441406421, 19.268751144409237],
          [72.783470153808651, 19.268751144409237],
          [72.783470153808651, 19.269029617309627],
          [72.782081604003906, 19.269029617309627],
          [72.782081604003906, 19.269308090210018],
          [72.781524658203182, 19.269306182861442],
          [72.781524658203182, 19.2695827484132],
          [72.781249999999943, 19.2695827484132],
          [72.781249999999943, 19.271804809570312],
          [72.780975341797102, 19.271804809570312],
          [72.780975341797102, 19.272083282470703],
          [72.780693054199389, 19.272083282470703],
          [72.780693054199389, 19.272916793823299],
          [72.780418395996151, 19.272916793823299],
          [72.780418395996151, 19.273471832275447],
          [72.780136108398608, 19.273471832275447],
          [72.780136108398608, 19.275421142578125],
          [72.779861450195597, 19.275421142578125],
          [72.779861450195597, 19.276252746582088],
          [72.779586791992188, 19.276252746582088],
          [72.779586791992188, 19.276531219482479],
          [72.779304504394815, 19.276527404785156],
          [72.779304504394815, 19.277082443237305],
          [72.779029846191406, 19.277080535888729],
          [72.779029846191406, 19.277919769287223],
          [72.778747558594034, 19.277914047241268],
          [72.778747558594034, 19.278192520141658],
          [72.778472900390682, 19.278192520141658],
          [72.778472900390682, 19.278474807739258],
          [72.778198242187443, 19.278470993042049],
          [72.778198242187443, 19.279039382934513],
          [72.778747558594034, 19.279039382934513],
          [72.778747558594034, 19.279310226440543],
          [72.779861450195597, 19.279306411743221],
          [72.779861450195597, 19.279584884643612],
          [72.781806945800895, 19.279584884643612],
          [72.781806945800895, 19.279306411743221],
          [72.783195495605639, 19.279306411743221],
          [72.783195495605639, 19.279861450195369],
          [72.783470153808651, 19.279859542846793],
          [72.783470153808651, 19.280420303344727],
          [72.783752441406421, 19.280420303344727],
          [72.783752441406421, 19.287639617920036],
          [72.784027099609602, 19.287639617920036],
          [72.784027099609602, 19.288471221923828],
          [72.784301757812443, 19.288471221923828],
          [72.784309387206974, 19.289030075073356],
          [72.784576416015682, 19.289030075073356],
          [72.784576416015682, 19.291530609130859],
          [72.784309387206974, 19.291530609130859],
          [72.784309387206974, 19.293750762939567],
          [72.784576416015682, 19.293750762939567],
          [72.784576416015682, 19.300422668457088],
          [72.784309387206974, 19.300422668457088],
          [72.784309387206974, 19.302642822265568],
          [72.784584045410213, 19.302639007568416],
          [72.784584045410213, 19.303474426269588],
          [72.784858703613395, 19.303470611572379],
          [72.784858703613395, 19.303752899169922],
          [72.785140991210994, 19.303752899169922],
          [72.785140991210994, 19.304029464721737],
          [72.785423278808878, 19.304029464721737],
          [72.785423278808878, 19.304309844970703],
          [72.785697937011719, 19.304304122924748],
          [72.785697937011719, 19.305973052978459],
          [72.785972595215128, 19.305959701538143],
          [72.785972595215128, 19.306249618530273],
          [72.786247253418139, 19.306249618530273],
          [72.786247253418139, 19.306529998779411],
          [72.786529541015682, 19.306528091430664],
          [72.786529541015682, 19.306806564331055],
          [72.786247253418139, 19.306806564331055],
          [72.786247253418139, 19.307083129882813],
          [72.786529541015682, 19.307083129882813],
          [72.786529541015682, 19.307361602783203],
          [72.786796569824389, 19.307359695434627],
          [72.786796569824389, 19.307640075683594],
          [72.787086486816634, 19.307640075683594],
          [72.787086486816634, 19.307920455932731],
          [72.787361145019474, 19.307920455932731],
          [72.787361145019474, 19.308200836181697],
          [72.787918090820426, 19.308195114135799],
          [72.787918090820426, 19.308471679687557],
          [72.788475036621378, 19.308471679687557],
          [72.788475036621378, 19.308750152587947],
          [72.789024353027628, 19.308750152587947],
          [72.789024353027628, 19.309028625488338],
          [72.789581298828182, 19.309020996093807],
          [72.789581298828182, 19.309310913085881],
          [72.789863586425952, 19.309305191040153],
          [72.789863586425952, 19.309583663940487],
          [72.790969848632926, 19.309579849243164],
          [72.790969848632926, 19.309860229492301],
          [72.791816711425838, 19.309860229492301],
          [72.791816711425838, 19.310140609741268],
          [72.792358398437671, 19.310140609741268],
          [72.792358398437671, 19.310419082641658],
          [72.793197631835994, 19.310428619384766],
          [72.793197631835994, 19.311250686645621],
          [72.793472290039233, 19.311250686645621],
          [72.793472290039233, 19.312091827392578],
          [72.793746948242244, 19.31208419799799],
          [72.793746948242244, 19.313194274902344],
          [72.794029235839787, 19.313188552856445],
          [72.794029235839787, 19.314310073852653],
          [72.794296264648494, 19.314310073852653],
          [72.794296264648494, 19.315151214599609],
          [72.794586181640739, 19.315151214599609],
          [72.794586181640739, 19.316249847412223],
          [72.79486083984375, 19.316249847412223],
          [72.79486083984375, 19.317081451416016],
          [72.795135498047159, 19.317081451416016],
          [72.795135498047159, 19.318193435668945],
          [72.795417785644531, 19.318189620971793],
          [72.795417785644531, 19.31931114196783],
          [72.79569244384794, 19.31931114196783],
          [72.79569244384794, 19.320140838623047],
          [72.795967102050952, 19.320140838623047],
          [72.795967102050952, 19.321250915527401],
          [72.796249389648494, 19.321250915527401],
          [72.796249389648494, 19.322082519531364],
          [72.796524047851733, 19.322082519531364],
          [72.796524047851733, 19.323194503784123],
          [72.796806335449446, 19.323194503784123],
          [72.796806335449446, 19.324300765991325],
          [72.797080993652287, 19.324321746826172],
          [72.797080993652287, 19.325138092041072],
          [72.797363281250057, 19.325138092041072],
          [72.797363281250057, 19.326250076294002],
          [72.797630310058878, 19.326250076294002],
          [72.797630310058878, 19.327091217041129],
          [72.797920227050838, 19.327083587646541],
          [72.797920227050838, 19.328193664550724],
          [72.798187255859659, 19.328191757202148],
          [72.798187255859659, 19.329309463501033],
          [72.798469543457031, 19.329305648803711],
          [72.798469543457031, 19.33013916015625],
          [72.798751831054972, 19.33013916015625],
          [72.798751831054972, 19.330974578857422],
          [72.799026489257983, 19.330970764160213],
          [72.799026489257983, 19.33125114440918],
          [72.798469543457031, 19.33125114440918],
          [72.798469543457031, 19.33152961730957],
          [72.798187255859659, 19.33152961730957],
          [72.798187255859659, 19.331809997558707],
          [72.797920227050838, 19.331804275512752],
          [72.797920227050838, 19.332084655761776],
          [72.797630310058878, 19.332080841064567],
          [72.797630310058878, 19.332361221313533],
          [72.797080993652287, 19.332361221313533],
          [72.797080993652287, 19.332639694213924],
          [72.796806335449446, 19.332639694213924],
          [72.796806335449446, 19.332920074462891],
          [72.796524047851733, 19.332914352416935],
          [72.796524047851733, 19.333196640014705],
          [72.796249389648494, 19.33319091796875],
          [72.796249389648494, 19.333749771118278],
          [72.79569244384794, 19.333749771118278],
          [72.79569244384794, 19.334030151367244],
          [72.795417785644531, 19.334028244018668],
          [72.795417785644531, 19.334583282470646],
          [72.795135498047159, 19.334583282470646],
          [72.795135498047159, 19.334861755371207],
          [72.79486083984375, 19.334859848022461],
          [72.79486083984375, 19.335140228271598],
          [72.794296264648494, 19.335140228271598],
          [72.794296264648494, 19.335700988769531],
          [72.793746948242244, 19.335695266723633],
          [72.793746948242244, 19.335971832275391],
          [72.793472290039233, 19.335969924926815],
          [72.793472290039233, 19.336530685424918],
          [72.793197631835994, 19.336530685424918],
          [72.793197631835994, 19.336809158325309],
          [72.792915344238452, 19.336805343627987],
          [72.792922973632983, 19.337360382080135],
          [72.79264068603544, 19.337360382080135],
          [72.79264068603544, 19.337640762329102],
          [72.792358398437671, 19.337640762329102],
          [72.792358398437671, 19.337919235229492],
          [72.792083740234659, 19.337917327880916],
          [72.792083740234659, 19.338193893432674],
          [72.79180908203125, 19.338193893432674],
          [72.79180908203125, 19.338472366333065],
          [72.791526794433878, 19.338470458984489],
          [72.791526794433878, 19.338750839233455],
          [72.791252136230526, 19.338750839233455],
          [72.791252136230526, 19.339321136474723],
          [72.790695190429744, 19.339305877685661],
          [72.790702819824446, 19.339860916137809],
          [72.790412902831974, 19.339860916137809],
          [72.790412902831974, 19.340421676635742],
          [72.790138244629134, 19.340415954589844],
          [72.790138244629134, 19.340694427490178],
          [72.789863586425952, 19.340694427490178],
          [72.789863586425952, 19.340972900390568],
          [72.789581298828182, 19.340969085693416],
          [72.789581298828182, 19.341531753540096],
          [72.789306640625171, 19.341531753540096],
          [72.789306640625171, 19.341810226440487],
          [72.789024353027628, 19.341806411743164],
          [72.789024353027628, 19.342081069946346],
          [72.78875732421875, 19.342071533203239],
          [72.78875732421875, 19.342639923095703],
          [72.788482666015739, 19.342639923095703],
          [72.788482666015739, 19.34292030334484],
          [72.787918090820426, 19.34292030334484],
          [72.787918090820426, 19.343200683593807],
          [72.787635803222713, 19.343193054199276],
          [72.787635803222713, 19.343471527099666],
          [72.787086486816634, 19.34346961975109],
          [72.787086486816634, 19.344030380249023],
          [72.786804199218921, 19.344028472900447],
          [72.786804199218921, 19.344585418701229],
          [72.786529541015682, 19.344585418701229],
          [72.786529541015682, 19.344863891601619],
          [72.785690307617188, 19.344860076904411],
          [72.785690307617188, 19.345420837402344],
          [72.785415649414347, 19.345415115356388],
          [72.785415649414347, 19.345695495605582],
          [72.785140991210994, 19.345695495605582],
          [72.785140991210994, 19.34597206115734],
          [72.784858703613395, 19.345970153808594],
          [72.784858703613395, 19.346250534057731],
          [72.784576416015682, 19.346250534057731],
          [72.784576416015682, 19.346530914306697],
          [72.784309387206974, 19.346530914306697],
          [72.784301757812443, 19.346809387207088],
          [72.784027099609602, 19.346803665161133],
          [72.784027099609602, 19.347085952758903],
          [72.783752441406421, 19.347080230712947],
          [72.783752441406421, 19.347360610961914],
          [72.783470153808651, 19.347360610961914],
          [72.783470153808651, 19.348199844360408],
          [72.783195495605639, 19.348194122314453],
          [72.783195495605639, 19.348472595214844],
          [72.782913208008097, 19.348470687866268],
          [72.782913208008097, 19.349029541015625],
          [72.782630920410327, 19.349029541015625],
          [72.782630920410327, 19.349309921264762],
          [72.782081604003906, 19.34930610656744],
          [72.782081604003906, 19.349582672119197],
          [72.781806945800895, 19.349580764770621],
          [72.781806945800895, 19.349861145019588],
          [72.781517028808651, 19.349861145019588],
          [72.781517028808651, 19.350139617919979],
          [72.781249999999943, 19.350139617919979],
          [72.781249999999943, 19.350418090820369],
          [72.780418395996151, 19.350416183471793],
          [72.780418395996151, 19.350694656372184],
          [72.780136108398608, 19.350694656372184],
          [72.780136108398608, 19.350973129272518],
          [72.779861450195597, 19.350971221923942],
          [72.779861450195597, 19.35125923156744],
          [72.777915954589901, 19.35125923156744],
          [72.777915954589901, 19.351528167724723],
          [72.777641296386889, 19.351528167724723],
          [72.777641296386889, 19.35180473327631],
          [72.77735900878929, 19.35180473327631],
          [72.77735900878929, 19.352361679077262],
          [72.777076721191577, 19.352359771728516],
          [72.777076721191577, 19.352638244628906],
          [72.776527404785327, 19.352638244628906],
          [72.776527404785327, 19.352922439575252],
          [72.775695800781534, 19.352922439575252],
          [72.775695800781534, 19.353202819824219],
          [72.775405883789063, 19.353202819824219],
          [72.775405883789063, 19.354032516479606],
          [72.775138854980582, 19.354028701782227],
          [72.775138854980582, 19.354583740234375],
          [72.774856567382869, 19.354581832885799],
          [72.774856567382869, 19.35486030578619],
          [72.774581909179631, 19.35486030578619],
          [72.774581909179631, 19.355421066284123],
          [72.77430725097679, 19.355417251586971],
          [72.77430725097679, 19.355972290039119],
          [72.774017333984546, 19.355970382690543],
          [72.774017333984546, 19.356531143188477],
          [72.773750305175838, 19.356527328491325],
          [72.773750305175838, 19.357082366943473],
          [72.773475646972827, 19.357082366943473],
          [72.773483276367188, 19.357360839843864],
          [72.773193359375284, 19.357360839843864],
          [72.773193359375284, 19.358192443847656],
          [72.772918701171875, 19.35819053649908],
          [72.772918701171875, 19.358749389648438],
          [72.772636413574503, 19.358749389648438],
          [72.772636413574503, 19.359584808349609],
          [72.772361755371151, 19.359580993652401],
          [72.772361755371151, 19.360139846801758],
          [72.772087097168082, 19.360139846801758],
          [72.772087097168082, 19.361530303955078],
          [72.771797180175838, 19.361530303955078],
          [72.771797180175838, 19.361810684204045],
          [72.771530151367131, 19.361806869506893],
          [72.771530151367131, 19.362083435058651],
          [72.771247863769759, 19.362083435058651],
          [72.771247863769759, 19.362361907959041],
          [72.770973205566577, 19.362360000610465],
          [72.770973205566577, 19.362640380859432],
          [72.770690917968807, 19.362640380859432],
          [72.770690917968807, 19.362920761108398],
          [72.770416259765796, 19.362920761108398],
          [72.770416259765796, 19.363201141357365],
          [72.770141601562784, 19.363195419311637],
          [72.770141601562784, 19.363471984863395],
          [72.769859313964844, 19.363468170166072],
          [72.769859313964844, 19.363750457763786],
          [72.769577026367472, 19.363750457763786],
          [72.769577026367472, 19.364309310913143],
          [72.769302368164062, 19.36430549621582],
          [72.769302368164062, 19.364583969116154],
          [72.769027709961051, 19.364578247070426],
          [72.769027709961051, 19.364860534667969],
          [72.768753051757869, 19.364860534667969],
          [72.768753051757869, 19.365140914917106],
          [72.768470764160099, 19.365140914917106],
          [72.768470764160099, 19.365419387817496],
          [72.768196105957259, 19.36541748046875],
          [72.768196105957259, 19.365972518920898],
          [72.767646789550838, 19.365970611572322],
          [72.767646789550838, 19.366260528564453],
          [72.767356872558764, 19.366260528564453],
          [72.767356872558764, 19.36652946472168],
          [72.766807556152344, 19.36652946472168],
          [72.766807556152344, 19.36681175231945],
          [72.766525268554972, 19.366806030273494],
          [72.766532897949503, 19.367359161377067],
          [72.766250610351563, 19.367359161377067],
          [72.766250610351563, 19.367639541626033],
          [72.765686035156307, 19.367639541626033],
          [72.765686035156307, 19.367921829223576],
          [72.765419006347599, 19.367916107177848],
          [72.765419006347599, 19.368194580078239],
          [72.765136718750057, 19.368194580078239],
          [72.765136718750057, 19.368471145629996],
          [72.764862060547046, 19.368471145629996],
          [72.764862060547046, 19.368749618530387],
          [72.764587402343807, 19.368749618530387],
          [72.764587402343807, 19.36903190612793],
          [72.764030456543253, 19.369028091430778],
          [72.764030456543253, 19.369304656982365],
          [72.763748168945483, 19.369304656982365],
          [72.763748168945483, 19.36958122253418],
          [72.763191223144531, 19.36958122253418],
          [72.763191223144531, 19.369861602783317],
          [72.76291656494169, 19.36985969543457],
          [72.76291656494169, 19.370140075683707],
          [72.762641906738338, 19.370140075683707],
          [72.762641906738338, 19.370420455932674],
          [72.762359619140739, 19.370420455932674],
          [72.762359619140739, 19.370700836181641],
          [72.762084960937557, 19.370693206787109],
          [72.762084960937557, 19.3709716796875],
          [72.761520385742415, 19.370969772338924],
          [72.761520385742415, 19.371250152587891],
          [72.761253356933764, 19.371250152587891],
          [72.761253356933764, 19.371810913085994],
          [72.760971069335994, 19.371803283691463],
          [72.760971069335994, 19.372085571289063],
          [72.760696411132983, 19.372079849243278],
          [72.760696411132983, 19.372360229492244],
          [72.760139465332031, 19.372360229492244],
          [72.760139465332031, 19.372640609741211],
          [72.75986480712919, 19.372638702392635],
          [72.75986480712919, 19.373195648193416],
          [72.759582519531307, 19.373195648193416],
          [72.759582519531307, 19.373472213745174],
          [72.759033203125057, 19.373470306396598],
          [72.759033203125057, 19.374031066894531],
          [72.758750915527287, 19.374031066894531],
          [72.758750915527287, 19.374309539794922],
          [72.758460998535213, 19.374309539794922],
          [72.758460998535213, 19.374860763549918],
          [72.758186340332202, 19.374860763549918],
          [72.758186340332202, 19.37542915344244],
          [72.757919311523494, 19.3754177093507],
          [72.757919311523494, 19.375972747802678],
          [72.757637023925952, 19.375972747802678],
          [72.757637023925952, 19.378194808960018],
          [72.75736236572294, 19.378194808960018],
          [72.75736236572294, 19.379583358764705],
          [72.757637023925952, 19.379577636718807],
          [72.757637023925952, 19.380140304565487],
          [72.757919311523494, 19.380138397216911],
          [72.757919311523494, 19.38125038146984],
          [72.758186340332202, 19.381240844726562],
          [72.758186340332202, 19.382642745971793],
          [72.758460998535213, 19.382642745971793],
          [72.758460998535213, 19.384029388427734],
          [72.758750915527287, 19.384027481079158],
          [72.758750915527287, 19.384304046630916],
          [72.759025573730526, 19.384304046630916],
          [72.759025573730526, 19.385139465332088],
          [72.759307861328239, 19.385139465332088],
          [72.759307861328239, 19.385696411132869],
          [72.759582519531307, 19.385696411132869],
          [72.759582519531307, 19.38597488403326],
          [72.759857177734659, 19.385971069336051],
          [72.759857177734659, 19.386529922485408],
          [72.760139465332031, 19.386529922485408],
          [72.760139465332031, 19.387639999389762],
          [72.760406494140909, 19.387639999389762],
          [72.760406494140909, 19.388200759887695],
          [72.760696411132983, 19.388200759887695],
          [72.760696411132983, 19.389030456543082],
          [72.760971069335994, 19.389030456543082],
          [72.760971069335994, 19.389310836792049],
          [72.761253356933764, 19.389305114746151],
          [72.761253356933764, 19.389583587646484],
          [72.761520385742415, 19.389579772949332],
          [72.761520385742415, 19.390428543090763],
          [72.761802673339787, 19.39041709899908],
          [72.761802673339787, 19.390693664550838],
          [72.762084960937557, 19.390693664550838],
          [72.762084960937557, 19.390972137451229],
          [72.762359619140739, 19.390970230102653],
          [72.762359619140739, 19.39152908325201],
          [72.765686035156307, 19.39152908325201],
          [72.765686035156307, 19.391811370849553],
          [72.765975952148551, 19.391805648803825],
          [72.765975952148551, 19.393194198608342],
          [72.765693664550838, 19.393194198608342],
          [72.765693664550838, 19.393472671508732],
          [72.765136718750057, 19.393470764160156],
          [72.765136718750057, 19.393749237060547],
          [72.764587402343807, 19.393749237060547],
          [72.764587402343807, 19.394029617309684],
          [72.764030456543253, 19.394029617309684],
          [72.764030456543253, 19.394311904907283],
          [72.763748168945483, 19.394306182861328],
          [72.763748168945483, 19.394582748413086],
          [72.76346588134794, 19.394582748413086],
          [72.76346588134794, 19.394861221313477],
          [72.763191223144531, 19.394861221313477],
          [72.763191223144531, 19.395139694213867],
          [72.76291656494169, 19.395139694213867],
          [72.76291656494169, 19.395420074463004],
          [72.762359619140739, 19.395416259765682],
          [72.762359619140739, 19.39597129821783],
          [72.762084960937557, 19.39597129821783],
          [72.762084960937557, 19.396249771118221],
          [72.761802673339787, 19.396249771118221],
          [72.761802673339787, 19.398471832275504],
          [72.761520385742415, 19.398469924926758],
          [72.761520385742415, 19.400140762329215],
          [72.761802673339787, 19.400140762329215],
          [72.761802673339787, 19.402919769287109],
          [72.761528015136946, 19.402917861938533],
          [72.761528015136946, 19.405416488647461],
          [72.761253356933764, 19.405416488647461],
          [72.761253356933764, 19.407083511352539],
          [72.760971069335994, 19.407081604003963],
          [72.760971069335994, 19.40792274475109],
          [72.760696411132983, 19.40792274475109],
          [72.760696411132983, 19.409032821655273],
          [72.760406494140909, 19.409032821655273],
          [72.760406494140909, 19.409860610962028],
          [72.760139465332031, 19.409860610962028],
          [72.760139465332031, 19.410419464111385],
          [72.76041412353544, 19.410417556762809],
          [72.76041412353544, 19.414861679077205],
          [72.760139465332031, 19.414861679077205],
          [72.760139465332031, 19.415971755981559],
          [72.759857177734659, 19.415969848632813],
          [72.759857177734659, 19.416530609130916],
          [72.759582519531307, 19.416530609130916],
          [72.759582519531307, 19.417919158935661],
          [72.759307861328239, 19.417919158935661],
          [72.759307861328239, 19.418750762939453],
          [72.759025573730526, 19.418750762939453],
          [72.759025573730526, 19.419584274292049],
          [72.758750915527287, 19.41958045959484],
          [72.758750915527287, 19.421249389648551],
          [72.758186340332202, 19.421249389648551],
          [72.758186340332202, 19.422920227050838],
          [72.757919311523494, 19.422920227050838],
          [72.757919311523494, 19.424030303955192],
          [72.757637023925952, 19.424028396606445],
          [72.757637023925952, 19.424863815307617],
          [72.75736236572294, 19.424863815307617],
          [72.75736236572294, 19.425973892211971],
          [72.757080078125, 19.425970077514762],
          [72.757080078125, 19.426811218261662],
          [72.756805419922159, 19.426803588867131],
          [72.75681304931669, 19.427360534668082],
          [72.756530761718807, 19.427360534668082],
          [72.756530761718807, 19.428195953369254],
          [72.756248474121207, 19.428195953369254],
          [72.756248474121207, 19.428472518920842],
          [72.755966186523494, 19.428470611572266],
          [72.755966186523494, 19.42930984497076],
          [72.755691528320256, 19.429307937622184],
          [72.755691528320256, 19.431804656982536],
          [72.755142211914233, 19.431804656982536],
          [72.755142211914233, 19.432083129882869],
          [72.754859924316463, 19.432083129882869],
          [72.754859924316463, 19.43236160278326],
          [72.754592895507983, 19.432350158691406],
          [72.754592895507983, 19.433202743530387],
          [72.754302978515909, 19.433202743530387],
          [72.754302978515909, 19.434032440185604],
          [72.7540283203125, 19.434032440185604],
          [72.7540283203125, 19.434860229492187],
          [72.753753662109659, 19.434860229492187],
          [72.753753662109659, 19.435970306396541],
          [72.753471374511719, 19.435970306396541],
          [72.753471374511719, 19.436250686645508],
          [72.753196716308707, 19.436250686645508],
          [72.753196716308707, 19.436809539795036],
          [72.752906799316463, 19.436809539795036],
          [72.752914428710994, 19.437360763549862],
          [72.752647399902287, 19.437360763549862],
          [72.752647399902287, 19.438480377197379],
          [72.752357482910213, 19.438480377197379],
          [72.752357482910213, 19.439310073852539],
          [72.752082824707202, 19.439310073852539],
          [72.752082824707202, 19.440420150756893],
          [72.751808166503963, 19.440420150756893],
          [72.751808166503963, 19.441249847412109],
          [72.751525878906421, 19.441249847412109],
          [72.751525878906421, 19.441806793212891],
          [72.751251220703409, 19.441806793212891],
          [72.751251220703409, 19.442083358764648],
          [72.750968933105639, 19.442079544067496],
          [72.750968933105639, 19.442920684814396],
          [72.751251220703409, 19.442920684814396],
          [72.751251220703409, 19.443199157714957],
          [72.750686645508097, 19.443199157714957],
          [72.750686645508097, 19.443750381469783],
          [72.750419616699219, 19.443750381469783],
          [72.750419616699219, 19.444583892822379],
          [72.750137329101847, 19.444578170776424],
          [72.750137329101847, 19.445419311523494],
          [72.749862670898494, 19.445419311523494],
          [72.749862670898494, 19.446250915527457],
          [72.749580383300895, 19.446250915527457],
          [72.749580383300895, 19.446811676025447],
          [72.749305725097713, 19.446805953979492],
          [72.749313354492415, 19.447639465332031],
          [72.749031066894702, 19.447639465332031],
          [72.749031066894702, 19.448194503784237],
          [72.748748779297102, 19.448194503784237],
          [72.748748779297102, 19.449861526489315],
          [72.748466491699389, 19.449859619140739],
          [72.748466491699389, 19.450420379638672],
          [72.748191833496151, 19.450420379638672],
          [72.748191833496151, 19.450710296630973],
          [72.747917175293139, 19.450710296630973],
          [72.747917175293139, 19.451250076294059],
          [72.747642517090128, 19.451250076294059],
          [72.747642517090128, 19.451568603515739],
          [72.747642517090128, 19.452362060546818],
          [72.747360229492187, 19.452362060546818],
          [72.747360229492187, 19.453195571899414],
          [72.747093200683707, 19.453189849853629],
          [72.747093200683707, 19.454030990600529],
          [72.746803283691463, 19.454030990600529],
          [72.746803283691463, 19.45430946350109],
          [72.746528625488395, 19.454307556152344],
          [72.746528625488395, 19.454584121704158],
          [72.745971679687443, 19.45458030700695],
          [72.745971679687443, 19.454860687255916],
          [72.745697021484602, 19.454860687255916],
          [72.745697021484602, 19.455419540405273],
          [72.745414733886889, 19.455417633056697],
          [72.745414733886889, 19.455694198608512],
          [72.745140075683651, 19.455694198608512],
          [72.745140075683651, 19.457082748413029],
          [72.744857788086108, 19.457080841064453],
          [72.744857788086108, 19.458749771118164],
          [72.744583129883097, 19.458749771118164],
          [72.744583129883097, 19.462100982666072],
          [72.744583129883097, 19.462921142578125],
          [72.744857788086108, 19.462917327880973],
          [72.744857788086108, 19.463472366332951],
          [72.745140075683651, 19.463470458984375],
          [72.745140075683651, 19.464031219482479],
          [72.745407104492358, 19.464031219482479],
          [72.745407104492358, 19.464309692382869],
          [72.745697021484602, 19.464305877685547],
          [72.745697021484602, 19.464582443237305],
          [72.745971679687443, 19.464580535888729],
          [72.745971679687443, 19.464860916137695],
          [72.746246337890682, 19.464860916137695],
          [72.746246337890682, 19.465139389038086],
          [72.746520996093864, 19.465139389038086],
          [72.746520996093864, 19.465419769287223],
          [72.746803283691463, 19.465414047241268],
          [72.746803283691463, 19.465696334838867],
          [72.747085571289347, 19.465696334838867],
          [72.747085571289347, 19.465974807739258],
          [72.747642517090128, 19.465970993042049],
          [72.747642517090128, 19.46624946594244],
          [72.747917175293139, 19.46624946594244],
          [72.747917175293139, 19.466529846191406],
          [72.748191833496151, 19.466529846191406],
          [72.748191833496151, 19.466810226440373],
          [72.748474121093921, 19.466806411743221],
          [72.748474121093921, 19.467084884643612],
          [72.749031066894702, 19.467081069946403],
          [72.749031066894702, 19.46763992309576],
          [72.749580383300895, 19.46763992309576],
          [72.749580383300895, 19.467920303344727],
          [72.749862670898494, 19.467920303344727],
          [72.749862670898494, 19.468200683593693],
          [72.750137329101847, 19.468196868896541],
          [72.750137329101847, 19.468471527099723],
          [72.750419616699219, 19.468460083007869],
          [72.750419616699219, 19.46903038024908],
          [72.750686645508097, 19.46903038024908],
          [72.750686645508097, 19.469310760498047],
          [72.750968933105639, 19.469306945800895],
          [72.750968933105639, 19.469861984252873],
          [72.751251220703409, 19.469860076904297],
          [72.751251220703409, 19.470140457153434],
          [72.751525878906421, 19.470138549804688],
          [72.751525878906421, 19.470693588256836],
          [72.751808166503963, 19.470689773559684],
          [72.751808166503963, 19.471250534057617],
          [72.752357482910213, 19.471250534057617],
          [72.752357482910213, 19.471530914306584],
          [72.752647399902287, 19.471530914306584],
          [72.752647399902287, 19.471809387207145],
          [72.752914428710994, 19.471805572509822],
          [72.752914428710994, 19.472084045410213],
          [72.753196716308707, 19.472078323364258],
          [72.753196716308707, 19.472360610961971],
          [72.753471374511719, 19.472360610961971],
          [72.753471374511719, 19.472639083862362],
          [72.753753662109659, 19.472639083862362],
          [72.753753662109659, 19.473194122314567],
          [72.7540283203125, 19.473194122314567],
          [72.7540283203125, 19.473472595214901],
          [72.754302978515909, 19.473470687866325],
          [72.754302978515909, 19.473749160766715],
          [72.754592895507983, 19.473749160766715],
          [72.754592895507983, 19.474311828613281],
          [72.755416870117415, 19.474311828613281],
          [72.755416870117415, 19.474590301513615],
          [72.755966186523494, 19.474590301513615],
          [72.755966186523494, 19.475139617920036],
          [72.756530761718807, 19.475139617920036],
          [72.756530761718807, 19.475421905517635],
          [72.75736236572294, 19.47541618347168],
          [72.75736236572294, 19.47569465637207],
          [72.75986480712919, 19.47569465637207],
          [72.75986480712919, 19.475971221923828],
          [72.759956359863281, 19.475971221923828],
          [72.760696411132983, 19.475971221923828],
          [72.760696411132983, 19.476249694824219],
          [72.761253356933764, 19.476249694824219],
          [72.761253356933764, 19.476530075073356],
          [72.762084960937557, 19.476528167724609],
          [72.762084960937557, 19.476804733276424],
          [72.76291656494169, 19.476804733276424],
          [72.76291656494169, 19.476528167724609],
          [72.76346588134794, 19.476530075073356],
          [72.76346588134794, 19.476249694824219],
          [72.764312744140796, 19.476249694824219],
          [72.764312744140796, 19.476530075073356],
          [72.764579772949446, 19.476528167724609],
          [72.764579772949446, 19.476804733276424],
          [72.764862060547046, 19.476804733276424],
          [72.764862060547046, 19.477361679077148],
          [72.765419006347599, 19.477359771728572],
          [72.765419006347599, 19.4782009124757],
          [72.765686035156307, 19.4782009124757],
          [72.765686035156307, 19.478750228881893],
          [72.765975952148551, 19.478750228881893],
          [72.765975952148551, 19.479310989379826],
          [72.766250610351563, 19.479310989379826],
          [72.766250610351563, 19.479860305786246],
          [72.766532897949503, 19.479860305786246],
          [72.766532897949503, 19.48042106628418],
          [72.766807556152344, 19.480417251587028],
          [72.766807556152344, 19.480972290039006],
          [72.767082214355753, 19.48097038269043],
          [72.767082214355753, 19.481531143188533],
          [72.767356872558764, 19.481531143188533],
          [72.767356872558764, 19.48236083984375],
          [72.767082214355753, 19.48236083984375],
          [72.767082214355753, 19.48347282409668],
          [72.767356872558764, 19.483470916748104],
          [72.767356872558764, 19.484029769897461],
          [72.767906188964787, 19.484029769897461],
          [72.767906188964787, 19.484308242797852],
          [72.768196105957259, 19.484306335449276],
          [72.768196105957259, 19.484582901001033],
          [72.768470764160099, 19.484582901001033],
          [72.768470764160099, 19.484861373901424],
          [72.768753051757869, 19.484859466552848],
          [72.768753051757869, 19.485139846801815],
          [72.769302368164062, 19.485139846801815],
          [72.769302368164062, 19.485418319702205],
          [72.769584655762003, 19.485416412353629],
          [72.769584655762003, 19.485971450805778],
          [72.769859313964844, 19.485967636108455],
          [72.769859313964844, 19.486249923706168],
          [72.770141601562784, 19.486249923706168],
          [72.770141601562784, 19.486530303955135],
          [72.770973205566577, 19.486530303955135],
          [72.770973205566577, 19.486820220947266],
          [72.772361755371151, 19.486820220947266],
          [72.772361755371151, 19.485967636108455],
          [72.772636413574503, 19.485971450805778],
          [72.772636413574503, 19.485416412353629],
          [72.772918701171875, 19.485418319702205],
          [72.772918701171875, 19.485139846801815],
          [72.773193359375284, 19.485139846801815],
          [72.773193359375284, 19.483749389648494],
          [72.773483276367188, 19.483749389648494],
          [72.773483276367188, 19.484029769897461],
          [72.774032592773608, 19.484029769897461],
          [72.774032592773608, 19.484308242797852],
          [72.77430725097679, 19.484306335449276],
          [72.77430725097679, 19.484582901001033],
          [72.774581909179631, 19.484582901001033],
          [72.774581909179631, 19.484861373901424],
          [72.774856567382869, 19.484859466552848],
          [72.774856567382869, 19.485418319702205],
          [72.775138854980582, 19.485416412353629],
          [72.775138854980582, 19.485971450805778],
          [72.774864196777401, 19.485971450805778],
          [72.774856567382869, 19.488191604614315],
          [72.774581909179631, 19.488201141357479],
          [72.774581909179631, 19.489032745361442],
          [72.774856567382869, 19.489032745361442],
          [72.774856567382869, 19.489860534668026],
          [72.775138854980582, 19.489860534668026],
          [72.775138854980582, 19.490142822265625],
          [72.775405883789063, 19.490142822265625],
          [72.775405883789063, 19.490419387817383],
          [72.775695800781534, 19.490417480468807],
          [72.775695800781534, 19.490692138671989],
          [72.776252746582315, 19.490692138671989],
          [72.776252746582315, 19.490972518920955],
          [72.776527404785327, 19.490970611572379],
          [72.776527404785327, 19.491252899169979],
          [72.778198242187443, 19.491252899169979],
          [72.778198242187443, 19.491529464721737],
          [72.778747558594034, 19.491529464721737],
          [72.778747558594034, 19.491252899169979],
          [72.780136108398608, 19.491252899169979],
          [72.780136108398608, 19.491529464721737],
          [72.779861450195597, 19.491527557373161],
          [72.779861450195597, 19.495971679687557],
          [72.779586791992188, 19.495969772338981],
          [72.779586791992188, 19.50542068481451],
          [72.779861450195597, 19.505416870117188],
          [72.779861450195597, 19.505971908569336],
          [72.779586791992188, 19.50597000122076],
          [72.779586791992188, 19.506530761718693],
          [72.779296875000284, 19.506530761718693],
          [72.779296875000284, 19.506811141967887],
          [72.779029846191406, 19.506811141967887],
          [72.779029846191406, 19.50736045837408],
          [72.778747558594034, 19.50736045837408],
          [72.778747558594034, 19.508750915527401],
          [72.779296875000284, 19.508750915527401],
          [72.779296875000284, 19.509309768676758],
          [72.779586791992188, 19.509307861328182],
          [72.779586791992188, 19.509582519531193],
          [72.780136108398608, 19.509580612182617],
          [72.780136108398608, 19.509860992431754],
          [72.780418395996151, 19.509860992431754],
          [72.780418395996151, 19.510139465332145],
          [72.780693054199389, 19.510139465332145],
          [72.780693054199389, 19.510419845581112],
          [72.780975341797102, 19.510417938232536],
          [72.780975341797102, 19.510972976684513],
          [72.781249999999943, 19.510971069335938],
          [72.781249999999943, 19.511249542236328],
          [72.781517028808651, 19.511249542236328],
          [72.781517028808651, 19.511529922485465],
          [72.782081604003906, 19.511529922485465],
          [72.782081604003906, 19.511800765991325],
          [72.782363891601847, 19.511806488037109],
          [72.782363891601847, 19.512361526489258],
          [72.782913208008097, 19.512359619140682],
          [72.782913208008097, 19.512638092041072],
          [72.783203125000171, 19.512638092041072],
          [72.783203125000171, 19.512918472290039],
          [72.783470153808651, 19.512918472290039],
          [72.783470153808651, 19.513202667236385],
          [72.783752441406421, 19.513202667236385],
          [72.783752441406421, 19.514030456542969],
          [72.784027099609602, 19.514028549194393],
          [72.784027099609602, 19.514583587646598],
          [72.784301757812443, 19.514581680297965],
          [72.784309387206974, 19.515140533447322],
          [72.784584045410213, 19.515138626098746],
          [72.784584045410213, 19.515970230102539],
          [72.784858703613395, 19.515970230102539],
          [72.784858703613395, 19.516532897949276],
          [72.785140991210994, 19.516532897949276],
          [72.785140991210994, 19.517360687255859],
          [72.785415649414347, 19.517360687255859],
          [72.785415649414347, 19.518192291259822],
          [72.785690307617188, 19.518190383911246],
          [72.785690307617188, 19.51875114440918],
          [72.785423278808878, 19.51875114440918],
          [72.785423278808878, 19.519309997558537],
          [72.785690307617188, 19.519309997558537],
          [72.785690307617188, 19.520420074462891],
          [72.785972595215128, 19.520420074462891],
          [72.785972595215128, 19.521249771118278],
          [72.786529541015682, 19.521249771118278],
          [72.786529541015682, 19.524309158325309],
          [72.786247253418139, 19.524305343627987],
          [72.786247253418139, 19.525972366333065],
          [72.785972595215128, 19.525970458984489],
          [72.785972595215128, 19.526811599731445],
          [72.785690307617188, 19.526811599731445],
          [72.785697937011719, 19.527360916137809],
          [72.785423278808878, 19.527360916137809],
          [72.785423278808878, 19.527921676635799],
          [72.784858703613395, 19.527915954589844],
          [72.784858703613395, 19.528194427490234],
          [72.783752441406421, 19.528194427490234],
          [72.783752441406421, 19.528472900390568],
          [72.783195495605639, 19.528472900390568],
          [72.783195495605639, 19.528749465942383],
          [72.778747558594034, 19.528749465942383],
          [72.778747558594034, 19.528472900390568],
          [72.778472900390682, 19.528472900390568],
          [72.778472900390682, 19.528194427490234],
          [72.777915954589901, 19.528194427490234],
          [72.777915954589901, 19.527915954589844],
          [72.77735900878929, 19.527921676635799],
          [72.77735900878929, 19.5276393890382],
          [72.776802062988338, 19.5276393890382],
          [72.776802062988338, 19.527360916137809],
          [72.776527404785327, 19.527360916137809],
          [72.776527404785327, 19.527080535888672],
          [72.776252746582315, 19.527082443237248],
          [72.776252746582315, 19.526805877685661],
          [72.775695800781534, 19.526811599731445],
          [72.775695800781534, 19.526529312133846],
          [72.775405883789063, 19.526529312133846],
          [72.775405883789063, 19.525970458984489],
          [72.776527404785327, 19.525970458984489],
          [72.776527404785327, 19.526250839233455],
          [72.777076721191577, 19.526250839233455],
          [72.777076721191577, 19.526529312133846],
          [72.777641296386889, 19.526529312133846],
          [72.777641296386889, 19.526811599731445],
          [72.777915954589901, 19.526805877685661],
          [72.777915954589901, 19.527082443237248],
          [72.778747558594034, 19.527080535888672],
          [72.778747558594034, 19.527360916137809],
          [72.779861450195597, 19.527360916137809],
          [72.779861450195597, 19.5276393890382],
          [72.780136108398608, 19.5276393890382],
          [72.780136108398608, 19.527360916137809],
          [72.781249999999943, 19.527360916137809],
          [72.781249999999943, 19.527080535888672],
          [72.782081604003906, 19.527082443237248],
          [72.782081604003906, 19.52652740478527],
          [72.782356262207315, 19.526529312133846],
          [72.782356262207315, 19.526250839233455],
          [72.782913208008097, 19.526250839233455],
          [72.782913208008097, 19.525970458984489],
          [72.783470153808651, 19.525972366333065],
          [72.783470153808651, 19.525693893432731],
          [72.784027099609602, 19.525701522827262],
          [72.784027099609602, 19.522359848022461],
          [72.783752441406421, 19.522361755371037],
          [72.783752441406421, 19.521249771118278],
          [72.783470153808651, 19.521249771118278],
          [72.783470153808651, 19.516250610351676],
          [72.783195495605639, 19.516250610351676],
          [72.783195495605639, 19.515693664550724],
          [72.782913208008097, 19.515693664550724],
          [72.782913208008097, 19.515417098999137],
          [72.782630920410327, 19.515422821044922],
          [72.782630920410327, 19.515140533447322],
          [72.782356262207315, 19.515140533447322],
          [72.782356262207315, 19.514860153198356],
          [72.782081604003906, 19.514860153198356],
          [72.782081604003906, 19.514305114746207],
          [72.781806945800895, 19.514312744140739],
          [72.781806945800895, 19.514030456542969],
          [72.781517028808651, 19.514030456542969],
          [72.781517028808651, 19.513759613037166],
          [72.781249999999943, 19.513759613037166],
          [72.781249999999943, 19.513202667236385],
          [72.780693054199389, 19.513202667236385],
          [72.780693054199389, 19.512918472290039],
          [72.780136108398608, 19.512918472290039],
          [72.780136108398608, 19.512638092041072],
          [72.779861450195597, 19.512638092041072],
          [72.779861450195597, 19.512359619140682],
          [72.779586791992188, 19.512361526489258],
          [72.779586791992188, 19.512083053588867],
          [72.779304504394815, 19.512083053588867],
          [72.779304504394815, 19.511529922485465],
          [72.779029846191406, 19.511529922485465],
          [72.779029846191406, 19.511249542236328],
          [72.778747558594034, 19.511249542236328],
          [72.778747558594034, 19.510971069335938],
          [72.778472900390682, 19.510972976684513],
          [72.778472900390682, 19.51069450378418],
          [72.778198242187443, 19.510698318481502],
          [72.778190612793082, 19.510419845581112],
          [72.777915954589901, 19.510419845581112],
          [72.777915954589901, 19.509860992431754],
          [72.77735900878929, 19.509860992431754],
          [72.77735900878929, 19.509580612182617],
          [72.776802062988338, 19.509582519531193],
          [72.776802062988338, 19.509025573730469],
          [72.776527404785327, 19.509029388427791],
          [72.776527404785327, 19.508750915527401],
          [72.775695800781534, 19.508750915527401],
          [72.775695800781534, 19.508470535278434],
          [72.775413513183651, 19.50847244262701],
          [72.775413513183651, 19.507638931274471],
          [72.775138854980582, 19.507638931274471],
          [72.775138854980582, 19.507085800170898],
          [72.774864196777401, 19.507085800170898],
          [72.774864196777401, 19.506803512573299],
          [72.774581909179631, 19.506811141967887],
          [72.774581909179631, 19.506530761718693],
          [72.774032592773608, 19.506530761718693],
          [72.774032592773608, 19.506250381469727],
          [72.773750305175838, 19.506250381469727],
          [72.773750305175838, 19.505701065063533],
          [72.773483276367188, 19.505701065063533],
          [72.773483276367188, 19.50542068481451],
          [72.773193359375284, 19.50542068481451],
          [72.773193359375284, 19.505140304565543],
          [72.772918701171875, 19.505140304565543],
          [72.772918701171875, 19.504859924316406],
          [72.772636413574503, 19.504863739013786],
          [72.772636413574503, 19.504583358764592],
          [72.769584655762003, 19.504583358764592],
          [72.769584655762003, 19.504304885864258],
          [72.764862060547046, 19.504304885864258],
          [72.764862060547046, 19.504863739013786],
          [72.764587402343807, 19.504859924316406],
          [72.764587402343807, 19.505140304565543],
          [72.763191223144531, 19.505140304565543],
          [72.763191223144531, 19.50542068481451],
          [72.762641906738338, 19.50542068481451],
          [72.762641906738338, 19.505701065063533],
          [72.762359619140739, 19.505693435668945],
          [72.762359619140739, 19.505971908569336],
          [72.761520385742415, 19.50597000122076],
          [72.761520385742415, 19.506250381469727],
          [72.760696411132983, 19.506250381469727],
          [72.760696411132983, 19.506530761718693],
          [72.759857177734659, 19.506530761718693],
          [72.759857177734659, 19.506811141967887],
          [72.758750915527287, 19.506803512573299],
          [72.758750915527287, 19.507085800170898],
          [72.758186340332202, 19.507080078125114],
          [72.758193969726733, 19.50736045837408],
          [72.756805419922159, 19.50736045837408],
          [72.756805419922159, 19.507085800170898],
          [72.756530761718807, 19.507080078125114],
          [72.756530761718807, 19.50736045837408],
          [72.755691528320256, 19.50736045837408],
          [72.755691528320256, 19.507638931274471],
          [72.755416870117415, 19.507638931274471],
          [72.755416870117415, 19.508195877075252],
          [72.755142211914233, 19.508195877075252],
          [72.755142211914233, 19.50847244262701],
          [72.754585266113452, 19.50847244262701],
          [72.754592895507983, 19.508750915527401],
          [72.752906799316463, 19.508750915527401],
          [72.752906799316463, 19.509029388427791],
          [72.752647399902287, 19.509029388427791],
          [72.752647399902287, 19.509309768676758],
          [72.752357482910213, 19.509307861328182],
          [72.752357482910213, 19.509582519531193],
          [72.752082824707202, 19.509580612182617],
          [72.752082824707202, 19.509860992431754],
          [72.751808166503963, 19.509860992431754],
          [72.751808166503963, 19.510139465332145],
          [72.751251220703409, 19.510139465332145],
          [72.751251220703409, 19.510419845581112],
          [72.750419616699219, 19.510419845581112],
          [72.750419616699219, 19.510698318481502],
          [72.750137329101847, 19.51069450378418],
          [72.750137329101847, 19.510972976684513],
          [72.749862670898494, 19.510971069335938],
          [72.749862670898494, 19.511249542236328],
          [72.749031066894702, 19.511249542236328],
          [72.749031066894702, 19.511529922485465],
          [72.748191833496151, 19.511529922485465],
          [72.748191833496151, 19.511808395385856],
          [72.747642517090128, 19.511806488037109],
          [72.747642517090128, 19.512361526489258],
          [72.747360229492187, 19.512359619140682],
          [72.747360229492187, 19.512638092041072],
          [72.746803283691463, 19.512638092041072],
          [72.746803283691463, 19.512918472290039],
          [72.746520996093864, 19.512918472290039],
          [72.746520996093864, 19.513202667236385],
          [72.745971679687443, 19.513202667236385],
          [72.745971679687443, 19.513759613037166],
          [72.745697021484602, 19.513759613037166],
          [72.745697021484602, 19.514030456542969],
          [72.744857788086108, 19.514030456542969],
          [72.744857788086108, 19.514312744140739],
          [72.744583129883097, 19.514305114746207],
          [72.744583129883097, 19.514583587646598],
          [72.744026184082315, 19.514583587646598],
          [72.744026184082315, 19.514860153198356],
          [72.743476867675895, 19.514860153198356],
          [72.743476867675895, 19.515140533447322],
          [72.742919921874943, 19.515140533447322],
          [72.742919921874943, 19.515422821044922],
          [72.742362976074389, 19.515417098999137],
          [72.742362976074389, 19.515693664550724],
          [72.741806030273608, 19.515693664550724],
          [72.741806030273608, 19.515970230102539],
          [72.741531372070597, 19.515970230102539],
          [72.741531372070597, 19.516532897949276],
          [72.741249084472656, 19.51652717590332],
          [72.741249084472656, 19.516805648803711],
          [72.740974426269815, 19.516805648803711],
          [72.740974426269815, 19.517082214355469],
          [72.740692138671875, 19.517080307006893],
          [72.740661621093921, 19.517641067504826],
          [72.740417480468864, 19.517641067504826],
          [72.740417480468864, 19.517919540405387],
          [72.740135192871151, 19.517917633056641],
          [72.740135192871151, 19.518474578857422],
          [72.739860534667912, 19.518470764160213],
          [72.739860534667912, 19.51902961730957],
          [72.739295959472599, 19.51902961730957],
          [72.739295959472599, 19.519309997558537],
          [72.739028930664119, 19.519309997558537],
          [72.739028930664119, 19.519861221313533],
          [72.738746643066577, 19.519861221313533],
          [72.738746643066577, 19.520990371704158],
          [72.738746643066577, 19.522361755371037],
          [72.738471984863565, 19.522359848022461],
          [72.738471984863565, 19.522640228271598],
          [72.738197326660156, 19.522640228271598],
          [72.738197326660156, 19.522928237915153],
          [72.737358093262003, 19.522918701171989],
          [72.737358093262003, 19.523471832275391],
          [72.737075805664119, 19.523469924926815],
          [72.737075805664119, 19.524309158325309],
          [72.736808776855412, 19.524309158325309],
          [72.736808776855412, 19.525140762329102],
          [72.736526489257869, 19.525140762329102],
          [72.736526489257869, 19.526529312133846],
          [72.734863281250284, 19.526529312133846],
          [72.734863281250284, 19.526811599731445],
          [72.733139038086222, 19.526805877685661],
          [72.732917785644759, 19.526811599731445],
          [72.732917785644759, 19.526529312133846],
          [72.731536865234375, 19.526529312133846],
          [72.731536865234375, 19.526811599731445],
          [72.731246948242472, 19.526811599731445],
          [72.731246948242472, 19.527360916137809],
          [72.730972290039119, 19.527360916137809],
          [72.730972290039119, 19.5276393890382],
          [72.730140686035099, 19.5276393890382],
          [72.730140686035099, 19.527921676635799],
          [72.729858398437727, 19.527915954589844],
          [72.729858398437727, 19.528472900390568],
          [72.729583740234546, 19.528472900390568],
          [72.729583740234546, 19.528749465942383],
          [72.729026794433764, 19.528749465942383],
          [72.729026794433764, 19.529581069946346],
          [72.728752136230753, 19.529581069946346],
          [72.728752136230753, 19.531803131103459],
          [72.728469848632812, 19.531803131103459],
          [72.728469848632812, 19.532363891601619],
          [72.728202819824503, 19.532360076904411],
          [72.728202819824503, 19.532640457153377],
          [72.72763824462902, 19.532640457153377],
          [72.72763824462902, 19.532920837402344],
          [72.727363586425838, 19.532915115356445],
          [72.727363586425838, 19.53347206115717],
          [72.727081298828068, 19.533470153808594],
          [72.727081298828068, 19.533750534057731],
          [72.726806640625227, 19.533750534057731],
          [72.726806640625227, 19.534030914306697],
          [72.726516723632756, 19.534030914306697],
          [72.726516723632756, 19.533750534057731],
          [72.726249694824276, 19.533750534057731],
          [72.726249694824276, 19.532640457153377],
          [72.725982666015796, 19.532640457153377],
          [72.725982666015796, 19.532079696655273],
          [72.725692749023722, 19.532085418701229],
          [72.725692749023722, 19.531803131103459],
          [72.72458648681652, 19.531803131103459],
          [72.72458648681652, 19.532363891601619],
          [72.724861145019531, 19.532360076904411],
          [72.724861145019531, 19.532920837402344],
          [72.72513580322294, 19.532915115356445],
          [72.72513580322294, 19.53347206115717],
          [72.725692749023722, 19.533470153808594],
          [72.725692749023722, 19.533750534057731],
          [72.725982666015796, 19.533750534057731],
          [72.725982666015796, 19.534870147705078],
          [72.726249694824276, 19.534870147705078],
          [72.726249694824276, 19.535140991210881],
          [72.726516723632756, 19.535140991210881],
          [72.726516723632756, 19.536809921264592],
          [72.726249694824276, 19.53680610656744],
          [72.726249694824276, 19.537082672119197],
          [72.725975036621264, 19.537082672119197],
          [72.725982666015796, 19.537361145019588],
          [72.725418090820312, 19.537361145019588],
          [72.725418090820312, 19.537929534912109],
          [72.72513580322294, 19.537916183471793],
          [72.72513580322294, 19.538194656372184],
          [72.724861145019531, 19.538190841674805],
          [72.724861145019531, 19.538749694824332],
          [72.72458648681652, 19.538749694824332],
          [72.72458648681652, 19.539028167724723],
          [72.724029541015568, 19.539028167724723],
          [72.724029541015568, 19.539304733276367],
          [72.722915649414233, 19.539304733276367],
          [72.722915649414233, 19.539028167724723],
          [72.722351074218921, 19.539028167724723],
          [72.722351074218921, 19.538749694824332],
          [72.7218017578125, 19.538749694824332],
          [72.7218017578125, 19.538471221923942],
          [72.721252441406307, 19.538471221923942],
          [72.721252441406307, 19.538749694824332],
          [72.720703125000227, 19.538749694824332],
          [72.720703125000227, 19.539028167724723],
          [72.720138549804915, 19.539028167724723],
          [72.720138549804915, 19.538749694824332],
          [72.719856262207202, 19.538749694824332],
          [72.719856262207202, 19.538471221923942],
          [72.719017028808878, 19.538471221923942],
          [72.719017028808878, 19.538749694824332],
          [72.718193054199276, 19.538749694824332],
          [72.718193054199276, 19.540422439575252],
          [72.71848297119152, 19.540422439575252],
          [72.71848297119152, 19.540702819824219],
          [72.71875, 19.540695190429687],
          [72.71875, 19.540971755981445],
          [72.719017028808878, 19.540971755981445],
          [72.719017028808878, 19.54236030578619],
          [72.720138549804915, 19.54236030578619],
          [72.720138549804915, 19.542640686035156],
          [72.720695495605526, 19.54263877868658],
          [72.720695495605526, 19.543472290039119],
          [72.720413208007756, 19.543472290039119],
          [72.720413208007756, 19.54375076293951],
          [72.719306945800952, 19.543741226196403],
          [72.719306945800952, 19.544031143188477],
          [72.717086791992415, 19.544027328491325],
          [72.717086791992415, 19.544582366943303],
          [72.716796875000171, 19.544580459594727],
          [72.716796875000171, 19.545419692993221],
          [72.71848297119152, 19.545419692993221],
          [72.71848297119152, 19.54514122009283],
          [72.71875, 19.54514122009283],
          [72.71875, 19.544860839843864],
          [72.719306945800952, 19.544860839843864],
          [72.719306945800952, 19.544580459594727],
          [72.719581604003963, 19.544582366943303],
          [72.719581604003963, 19.544305801391715],
          [72.720138549804915, 19.544309616088867],
          [72.720138549804915, 19.544031143188477],
          [72.721252441406307, 19.544031143188477],
          [72.721252441406307, 19.543741226196403],
          [72.7218017578125, 19.54375076293951],
          [72.7218017578125, 19.543472290039119],
          [72.722358703613452, 19.543472290039119],
          [72.722358703613452, 19.54375076293951],
          [72.722640991211222, 19.543741226196403],
          [72.722640991211222, 19.544031143188477],
          [72.722923278808764, 19.544031143188477],
          [72.722923278808764, 19.54514122009283],
          [72.721809387207031, 19.54514122009283],
          [72.7218017578125, 19.545419692993221],
          [72.721252441406307, 19.545415878295898],
          [72.721252441406307, 19.545692443847656],
          [72.720695495605526, 19.545692443847656],
          [72.720695495605526, 19.545974731445426],
          [72.720413208007756, 19.545970916748047],
          [72.720413208007756, 19.546249389648437],
          [72.720138549804915, 19.546249389648437],
          [72.720138549804915, 19.547084808349609],
          [72.720413208007756, 19.547080993652401],
          [72.720413208007756, 19.547639846801758],
          [72.721527099609659, 19.547639846801758],
          [72.721527099609659, 19.547920227050724],
          [72.7218017578125, 19.547914505004996],
          [72.721809387207031, 19.548196792602539],
          [72.72208404541044, 19.548196792602539],
          [72.72208404541044, 19.552083969116211],
          [72.721809387207031, 19.552078247070426],
          [72.7218017578125, 19.552360534667969],
          [72.721527099609659, 19.552360534667969],
          [72.721527099609659, 19.553194046020565],
          [72.7218017578125, 19.553194046020565],
          [72.7218017578125, 19.553472518920898],
          [72.721527099609659, 19.553470611572322],
          [72.721527099609659, 19.553749084472713],
          [72.7218017578125, 19.553749084472713],
          [72.7218017578125, 19.554861068725643],
          [72.721527099609659, 19.554861068725643],
          [72.721527099609659, 19.555694580078239],
          [72.721252441406307, 19.555679321289119],
          [72.721252441406307, 19.556249618530387],
          [72.720970153808707, 19.556249618530387],
          [72.720970153808707, 19.556531906127987],
          [72.720695495605526, 19.556528091430778],
          [72.720695495605526, 19.557361602783146],
          [72.720413208007756, 19.55735969543457],
          [72.720413208007756, 19.557920455932674],
          [72.720138549804915, 19.557920455932674],
          [72.720138549804915, 19.559310913086051],
          [72.719856262207202, 19.559310913086051],
          [72.719856262207202, 19.559860229492244],
          [72.719581604003963, 19.559860229492244],
          [72.719581604003963, 19.56069374084484],
          [72.719856262207202, 19.560689926147461],
          [72.719856262207202, 19.562360763549918],
          [72.720138549804915, 19.562360763549918],
          [72.720138549804915, 19.563751220703068],
          [72.720413208007756, 19.563749313354492],
          [72.720413208007756, 19.564861297607422],
          [72.720703125000227, 19.564849853515739],
          [72.720703125000227, 19.565418243408203],
          [72.720970153808707, 19.565418243408203],
          [72.720970153808707, 19.566530227661133],
          [72.720138549804915, 19.566528320312557],
          [72.720138549804915, 19.566804885864371],
          [72.719856262207202, 19.566799163818416],
          [72.719856262207202, 19.567640304565487],
          [72.719581604003963, 19.567638397216911],
          [72.719581604003963, 19.567916870117301],
          [72.719024658203409, 19.567916870117301],
          [72.719024658203409, 19.568471908569279],
          [72.71875, 19.568471908569279],
          [72.71875, 19.56903266906744],
          [72.71848297119152, 19.56903266906744],
          [72.71848297119152, 19.56931114196783],
          [72.718193054199276, 19.56931114196783],
          [72.718193054199276, 19.569860458374023],
          [72.717918395996207, 19.569860458374023],
          [72.717918395996207, 19.570142745971793],
          [72.717636108398494, 19.570142745971793],
          [72.717636108398494, 19.570421218872184],
          [72.717361450195256, 19.570417404174805],
          [72.717361450195256, 19.570972442626953],
          [72.717086791992415, 19.570970535278377],
          [72.717086791992415, 19.571529388427734],
          [72.716804504394702, 19.571527481079158],
          [72.716804504394702, 19.572082519531307],
          [72.716529846191463, 19.572082519531307],
          [72.716537475586222, 19.572639465332088],
          [72.716247558593921, 19.572639465332088],
          [72.716247558593921, 19.575139999389762],
          [72.715972900390909, 19.575139999389762],
          [72.715972900390909, 19.575420379638729],
          [72.716247558593921, 19.575420379638729],
          [72.716247558593921, 19.576250076293945],
          [72.716529846191463, 19.576250076293945],
          [72.716529846191463, 19.577083587646541],
          [72.716796875000171, 19.577079772949332],
          [72.716796875000171, 19.577920913696232],
          [72.717086791992415, 19.577920913696232],
          [72.717086791992415, 19.579309463500977],
          [72.717361450195256, 19.579305648803825],
          [72.717361450195256, 19.579860687255973],
          [72.717636108398494, 19.579851150512695],
          [72.717636108398494, 19.581811904907283],
          [72.717918395996207, 19.581811904907283],
          [72.717918395996207, 19.582639694213867],
          [72.717636108398494, 19.582639694213867],
          [72.717636108398494, 19.584030151367188],
          [72.717361450195256, 19.584028244018612],
          [72.717361450195256, 19.584304809570426],
          [72.717086791992415, 19.584304809570426],
          [72.717086791992415, 19.584861755371151],
          [72.716796875000171, 19.584859848022575],
          [72.716796875000171, 19.586811065673885],
          [72.716529846191463, 19.586803436279297],
          [72.716529846191463, 19.58819580078125],
          [72.7156982421875, 19.588190078735465],
          [72.7156982421875, 19.590139389038143],
          [72.715415954590128, 19.590139389038143],
          [72.715415954590128, 19.590419769287109],
          [72.714859008789176, 19.590417861938533],
          [72.714859008789176, 19.590694427490348],
          [72.714302062988224, 19.590694427490348],
          [72.714302062988224, 19.590972900390739],
          [72.714027404785384, 19.590970993042106],
          [72.714027404785384, 19.591249465942496],
          [72.713470458984432, 19.591249465942496],
          [72.713470458984432, 19.592639923095817],
          [72.713195800781421, 19.592639923095817],
          [72.713195800781421, 19.592918395996207],
          [72.712905883789119, 19.592918395996207],
          [72.712905883789119, 19.593202590942383],
          [72.712638854980469, 19.593194961547852],
          [72.712638854980469, 19.593471527099609],
          [72.712356567383097, 19.593471527099609],
          [72.712356567383097, 19.594030380248967],
          [72.712638854980469, 19.594028472900391],
          [72.712638854980469, 19.595970153808707],
          [72.713470458984432, 19.595970153808707],
          [72.713470458984432, 19.59569358825695],
          [72.714584350585994, 19.59569358825695],
          [72.714584350585994, 19.595417022705135],
          [72.715415954590128, 19.595417022705135],
          [72.715415954590128, 19.59569358825695],
          [72.715972900390909, 19.59569358825695],
          [72.715972900390909, 19.595138549804744],
          [72.71848297119152, 19.59514045715332],
          [72.71848297119152, 19.59542274475109],
          [72.719581604003963, 19.595417022705135],
          [72.719581604003963, 19.59569358825695],
          [72.720138549804915, 19.59569358825695],
          [72.720138549804915, 19.595970153808707],
          [72.720413208007756, 19.595970153808707],
          [72.720413208007756, 19.596532821655273],
          [72.720970153808707, 19.596532821655273],
          [72.720970153808707, 19.596809387207031],
          [72.721527099609659, 19.596805572509879],
          [72.721527099609659, 19.597082138061467],
          [72.722351074218921, 19.597080230712891],
          [72.722351074218921, 19.597360610962028],
          [72.723197937011776, 19.597360610962028],
          [72.723197937011776, 19.596809387207031],
          [72.723747253418026, 19.596809387207031],
          [72.723747253418026, 19.596250534057674],
          [72.724029541015568, 19.596250534057674],
          [72.724029541015568, 19.595970153808707],
          [72.724304199218807, 19.595970153808707],
          [72.724304199218807, 19.59569358825695],
          [72.72458648681652, 19.59569358825695],
          [72.72458648681652, 19.595417022705135],
          [72.72513580322294, 19.59542274475109],
          [72.72513580322294, 19.594860076904354],
          [72.725692749023722, 19.594860076904354],
          [72.725692749023722, 19.594583511352596],
          [72.72763824462902, 19.594583511352596],
          [72.72763824462902, 19.594860076904354],
          [72.728477478027344, 19.594860076904354],
          [72.728477478027344, 19.59514045715332],
          [72.728752136230753, 19.59514045715332],
          [72.728752136230753, 19.59542274475109],
          [72.729026794433764, 19.595417022705135],
          [72.729026794433764, 19.595970153808707],
          [72.729309082031307, 19.595970153808707],
          [72.729309082031307, 19.596250534057674],
          [72.729583740234546, 19.596250534057674],
          [72.729583740234546, 19.597082138061467],
          [72.730140686035099, 19.597080230712891],
          [72.730140686035099, 19.597360610962028],
          [72.730415344238338, 19.597360610962028],
          [72.730415344238338, 19.598472595214787],
          [72.730972290039119, 19.598470687866211],
          [72.730972290039119, 19.598751068115178],
          [72.732856750488281, 19.598751068115178],
          [72.732917785644759, 19.598470687866211],
          [72.733474731445369, 19.598472595214787],
          [72.733474731445369, 19.59819221496582],
          [72.733749389648551, 19.59819221496582],
          [72.733749389648551, 19.597917556762809],
          [72.734016418457031, 19.597919464111385],
          [72.734016418457031, 19.597642898559627],
          [72.734306335449503, 19.597642898559627],
          [72.734306335449503, 19.597360610962028],
          [72.737358093262003, 19.597360610962028],
          [72.737358093262003, 19.597642898559627],
          [72.737922668457315, 19.597642898559627],
          [72.737922668457315, 19.597919464111385],
          [72.736808776855412, 19.597917556762809],
          [72.736808776855412, 19.598472595214787],
          [72.736526489257869, 19.598470687866211],
          [72.736526489257869, 19.598751068115178],
          [72.735687255859546, 19.598751068115178],
          [72.735687255859546, 19.599309921264705],
          [72.735420227051065, 19.599309921264705],
          [72.735420227051065, 19.599861145019531],
          [72.734580993652344, 19.599861145019531],
          [72.734580993652344, 19.600139617919922],
          [72.734306335449503, 19.600139617919922],
          [72.734306335449503, 19.600419998168888],
          [72.734024047851619, 19.600414276123161],
          [72.734024047851619, 19.600696563720703],
          [72.733749389648551, 19.600690841674918],
          [72.733749389648551, 19.600980758667049],
          [72.733596801757983, 19.600973129272518],
          [72.731796264648722, 19.600980758667049],
          [72.731796264648722, 19.600419998168888],
          [72.730972290039119, 19.600414276123161],
          [72.730972290039119, 19.600696563720703],
          [72.730697631836051, 19.600690841674918],
          [72.730697631836051, 19.600980758667049],
          [72.730415344238338, 19.600973129272518],
          [72.730422973632869, 19.601249694824276],
          [72.730140686035099, 19.601249694824276],
          [72.730140686035099, 19.602640151977596],
          [72.729858398437727, 19.602636337280273],
          [72.729858398437727, 19.605693817138729],
          [72.730140686035099, 19.605693817138729],
          [72.730140686035099, 19.605417251586914],
          [72.730415344238338, 19.605417251586914],
          [72.730415344238338, 19.605693817138729],
          [72.730697631836051, 19.605693817138729],
          [72.730697631836051, 19.608472824096793],
          [72.730422973632869, 19.608472824096793],
          [72.730422973632869, 19.610149383545036],
          [72.730140686035099, 19.610149383545036],
          [72.730140686035099, 19.611249923706055],
          [72.729858398437727, 19.611249923706055],
          [72.729858398437727, 19.612920761108342],
          [72.729576110840014, 19.612920761108342],
          [72.729576110840014, 19.613750457763729],
          [72.729309082031307, 19.613750457763729],
          [72.729309082031307, 19.615140914917049],
          [72.729026794433764, 19.615137100219727],
          [72.729026794433764, 19.615695953369254],
          [72.728752136230753, 19.615690231323299],
          [72.728752136230753, 19.616250991821232],
          [72.728469848632812, 19.61624717712408],
          [72.728469848632812, 19.617082595825195],
          [72.728195190429972, 19.617082595825195],
          [72.728202819824503, 19.617639541625977],
          [72.727912902832031, 19.617639541625977],
          [72.727912902832031, 19.617919921874943],
          [72.727363586425838, 19.617916107177791],
          [72.727363586425838, 19.620971679687443],
          [72.72763824462902, 19.620971679687443],
          [72.72763824462902, 19.621250152588004],
          [72.727912902832031, 19.621250152588004],
          [72.727912902832031, 19.621770858764705],
          [72.727912902832031, 19.622089385986328],
          [72.728195190429972, 19.62208366394043],
          [72.728195190429972, 19.623472213745117],
          [72.727912902832031, 19.623470306396541],
          [72.727912902832031, 19.624860763549862],
          [72.727355957031307, 19.624860763549862],
          [72.727355957031307, 19.625419616699219],
          [72.727081298828068, 19.625415802002067],
          [72.727081298828068, 19.625692367553654],
          [72.726806640625227, 19.625692367553654],
          [72.726806640625227, 19.625974655151424],
          [72.726516723632756, 19.625970840454215],
          [72.726516723632756, 19.626810073852539],
          [72.726249694824276, 19.626804351806641],
          [72.726249694824276, 19.627361297607365],
          [72.725975036621264, 19.627361297607365],
          [72.725975036621264, 19.628471374511719],
          [72.725692749023722, 19.628469467163143],
          [72.725692749023722, 19.628749847412109],
          [72.72513580322294, 19.628749847412109],
          [72.72513580322294, 19.628469467163143],
          [72.724861145019531, 19.628471374511719],
          [72.724861145019531, 19.627639770507926],
          [72.72513580322294, 19.627639770507926],
          [72.72513580322294, 19.627080917358398],
          [72.725418090820312, 19.627082824706974],
          [72.725418090820312, 19.626527786254996],
          [72.725692749023722, 19.626529693603572],
          [72.725692749023722, 19.625970840454215],
          [72.724861145019531, 19.625974655151424],
          [72.724861145019531, 19.625692367553654],
          [72.72458648681652, 19.625692367553654],
          [72.72458648681652, 19.625974655151424],
          [72.723472595215014, 19.625970840454215],
          [72.723472595215014, 19.626251220703182],
          [72.723197937011776, 19.626251220703182],
          [72.723197937011776, 19.626529693603572],
          [72.722915649414233, 19.626527786254996],
          [72.722915649414233, 19.627082824706974],
          [72.722640991211222, 19.627080917358398],
          [72.722640991211222, 19.627639770507926],
          [72.722351074218921, 19.627639770507926],
          [72.722351074218921, 19.627920150756893],
          [72.72208404541044, 19.627914428710994],
          [72.72208404541044, 19.628196716308707],
          [72.721809387207031, 19.628190994262752],
          [72.7218017578125, 19.628749847412109],
          [72.721527099609659, 19.628749847412109],
          [72.721527099609659, 19.629306793212891],
          [72.721252441406307, 19.629306793212891],
          [72.721252441406307, 19.629583358764705],
          [72.720970153808707, 19.629583358764705],
          [72.720970153808707, 19.629861831665039],
          [72.720413208007756, 19.629859924316463],
          [72.720413208007756, 19.63014030456543],
          [72.720138549804915, 19.63014030456543],
          [72.720138549804915, 19.630420684814396],
          [72.719856262207202, 19.630420684814396],
          [72.719856262207202, 19.631250381469783],
          [72.719581604003963, 19.631250381469783],
          [72.719581604003963, 19.631809234619141],
          [72.719306945800952, 19.631809234619141],
          [72.719306945800952, 19.632360458374137],
          [72.719017028808878, 19.632360458374137],
          [72.719017028808878, 19.632640838623104],
          [72.71875, 19.632640838623104],
          [72.71875, 19.633472442626896],
          [72.718475341797159, 19.633472442626896],
          [72.71848297119152, 19.633750915527287],
          [72.718193054199276, 19.633750915527287],
          [72.718193054199276, 19.63458251953125],
          [72.717918395996207, 19.634580612182674],
          [72.717918395996207, 19.635421752929801],
          [72.717636108398494, 19.635416030883846],
          [72.717636108398494, 19.635694503784237],
          [72.717361450195256, 19.635692596435604],
          [72.717361450195256, 19.636249542236385],
          [72.717086791992415, 19.636249542236385],
          [72.717086791992415, 19.636810302734318],
          [72.716796875000171, 19.636810302734318],
          [72.716796875000171, 19.637090682983512],
          [72.716529846191463, 19.637081146240348],
          [72.716529846191463, 19.637361526489315],
          [72.716247558593921, 19.637359619140739],
          [72.716247558593921, 19.637639999389705],
          [72.715972900390909, 19.637639999389705],
          [72.715972900390909, 19.638200759887695],
          [72.7156982421875, 19.638193130493107],
          [72.7156982421875, 19.638471603393498],
          [72.715415954590128, 19.638469696044922],
          [72.715415954590128, 19.639030456543026],
          [72.715141296386776, 19.639030456543026],
          [72.715141296386776, 19.639310836792049],
          [72.714859008789176, 19.639303207397461],
          [72.714859008789176, 19.640138626098633],
          [72.714576721191463, 19.640130996704102],
          [72.714576721191463, 19.641250610351563],
          [72.714302062988224, 19.641250610351563],
          [72.714302062988224, 19.642084121704158],
          [72.714027404785384, 19.642084121704158],
          [72.714027404785384, 19.643194198608512],
          [72.713752746582202, 19.643190383911133],
          [72.713752746582202, 19.643751144409237],
          [72.713470458984432, 19.643751144409237],
          [72.713470458984432, 19.644308090210018],
          [72.713195800781421, 19.644306182861442],
          [72.713195800781421, 19.644582748413029],
          [72.712905883789119, 19.644580841064453],
          [72.712905883789119, 19.646528244018555],
          [72.712638854980469, 19.646528244018555],
          [72.712638854980469, 19.64708328247076],
          [72.712356567383097, 19.647081375122127],
          [72.712356567383097, 19.647640228271484],
          [72.712081909179688, 19.647638320922908],
          [72.712081909179688, 19.649583816528434],
          [72.711807250976676, 19.649581909179631],
          [72.711807250976676, 19.650421142578182],
          [72.711532592773494, 19.650421142578182],
          [72.711532592773494, 19.652919769287053],
          [72.711250305175724, 19.652914047241325],
          [72.711250305175724, 19.653474807739258],
          [72.710975646972884, 19.653474807739258],
          [72.710975646972884, 19.655971527099553],
          [72.710693359375171, 19.655969619750977],
          [72.710693359375171, 19.656810760498104],
          [72.710983276367415, 19.656810760498104],
          [72.710983276367415, 19.658199310302791],
          [72.710693359375171, 19.658193588256893],
          [72.710693359375171, 19.658472061157227],
          [72.710975646972884, 19.658472061157227],
          [72.710975646972884, 19.659584045410213],
          [72.711250305175724, 19.659578323364258],
          [72.711250305175724, 19.660139083862362],
          [72.710975646972884, 19.660139083862362],
          [72.710975646972884, 19.660694122314567],
          [72.710693359375171, 19.660688400268612],
          [72.710693359375171, 19.661811828613281],
          [72.710975646972884, 19.661806106567496],
          [72.710975646972884, 19.662082672119084],
          [72.711250305175724, 19.662082672119084],
          [72.711250305175724, 19.662639617920036],
          [72.710983276367415, 19.662639617920036],
          [72.710983276367415, 19.662921905517635],
          [72.710693359375171, 19.66291618347168],
          [72.710693359375171, 19.66319465637207],
          [72.710418701171932, 19.66319465637207],
          [72.710418701171932, 19.663471221923828],
          [72.710693359375171, 19.663471221923828],
          [72.710693359375171, 19.666810989379883],
          [72.710975646972884, 19.666803359985295],
          [72.710983276367415, 19.667360305786246],
          [72.710693359375171, 19.667360305786246],
          [72.710693359375171, 19.667640686035213],
          [72.710136413574389, 19.667640686035213],
          [72.710136413574389, 19.667921066284237],
          [72.709861755371378, 19.667915344238281],
          [72.709861755371378, 19.668193817138672],
          [72.709587097167969, 19.668190002441463],
          [72.709587097167969, 19.66903114318859],
          [72.709297180176065, 19.66903114318859],
          [72.709297180176065, 19.66986083984375],
          [72.709030151367188, 19.66986083984375],
          [72.709030151367188, 19.670419692993107],
          [72.708747863769815, 19.670450210571289],
          [72.708747863769815, 19.671529769897461],
          [72.708473205566463, 19.671529769897461],
          [72.708473205566463, 19.671808242797852],
          [72.708190917968864, 19.671806335449276],
          [72.708190917968864, 19.67208290100109],
          [72.707641601562671, 19.67208290100109],
          [72.707641601562671, 19.672361373901424],
          [72.70735168457054, 19.672357559204102],
          [72.70735168457054, 19.673751831054801],
          [72.707077026367358, 19.673751831054801],
          [72.707077026367358, 19.679029464721737],
          [72.706802368164119, 19.679027557373161],
          [72.706802368164119, 19.680973052978516],
          [72.706527709961108, 19.680973052978516],
          [72.706527709961108, 19.682361602783203],
          [72.706253051758097, 19.682359695434627],
          [72.706253051758097, 19.68292045593256],
          [72.706527709961108, 19.682918548583984],
          [72.706527709961108, 19.684583663940543],
          [72.706802368164119, 19.684579849243164],
          [72.706802368164119, 19.686250686645451],
          [72.707077026367358, 19.686250686645451],
          [72.707077026367358, 19.686809539794979],
          [72.707359313965071, 19.686805725097656],
          [72.707359313965071, 19.687084197998047],
          [72.707916259765682, 19.687078475952262],
          [72.707916259765682, 19.687360763549805],
          [72.708190917968864, 19.687360763549805],
          [72.708190917968864, 19.688194274902401],
          [72.708473205566463, 19.688180923461914],
          [72.708473205566463, 19.689029693603516],
          [72.708747863769815, 19.68902778625494],
          [72.708747863769815, 19.689582824707145],
          [72.709030151367188, 19.689582824707145],
          [72.709030151367188, 19.690139770507869],
          [72.709304809570597, 19.690139770507869],
          [72.709304809570597, 19.690694808960075],
          [72.709587097167969, 19.690694808960075],
          [72.709587097167969, 19.691249847412223],
          [72.709861755371378, 19.691240310668945],
          [72.709861755371378, 19.692640304565373],
          [72.710136413574389, 19.692638397216797],
          [72.710136413574389, 19.694307327270508],
          [72.710418701171932, 19.694307327270508],
          [72.710418701171932, 19.69847297668457],
          [72.710693359375171, 19.69847297668457],
          [72.710693359375171, 19.702083587646598],
          [72.710411071777571, 19.702081680297795],
          [72.710411071777571, 19.703750610351506],
          [72.710136413574389, 19.703750610351506],
          [72.710136413574389, 19.705141067504826],
          [72.709861755371378, 19.705141067504826],
          [72.709861755371378, 19.706809997558537],
          [72.709587097167969, 19.706809997558537],
          [72.709587097167969, 19.707639694213924],
          [72.709304809570597, 19.707639694213924],
          [72.709304809570597, 19.708196640014705],
          [72.709030151367188, 19.70819091796875],
          [72.709030151367188, 19.708749771118278],
          [72.708747863769815, 19.708749771118278],
          [72.708747863769815, 19.709310531616268],
          [72.708473205566463, 19.709306716919059],
          [72.708473205566463, 19.709861755371037],
          [72.708190917968864, 19.709859848022461],
          [72.708190917968864, 19.710420608520621],
          [72.707916259765682, 19.710418701171989],
          [72.707916259765682, 19.710971832275391],
          [72.707641601562671, 19.710969924926815],
          [72.707641601562671, 19.711530685424748],
          [72.707359313965071, 19.711528778076172],
          [72.707359313965071, 19.712083816528377],
          [72.707077026367358, 19.712078094482422],
          [72.707077026367358, 19.712371826171875],
          [72.706802368164119, 19.712371826171875],
          [72.706802368164119, 19.712919235229492],
          [72.706527709961108, 19.712917327880916],
          [72.706527709961108, 19.713193893432731],
          [72.706253051758097, 19.713193893432731],
          [72.706253051758097, 19.713472366333121],
          [72.705970764160156, 19.713470458984489],
          [72.705970764160156, 19.714029312133846],
          [72.705696105957315, 19.714029312133846],
          [72.705696105957315, 19.714311599731445],
          [72.705413818359432, 19.714305877685661],
          [72.705413818359432, 19.714582443237248],
          [72.705139160156364, 19.714578628540096],
          [72.705139160156364, 19.7151393890382],
          [72.704864501953182, 19.7151393890382],
          [72.704864501953182, 19.715415954589844],
          [72.704582214355412, 19.715415954589844],
          [72.704582214355412, 19.715694427490234],
          [72.704307556152571, 19.715694427490234],
          [72.704307556152571, 19.716249465942383],
          [72.704032897949389, 19.716249465942383],
          [72.704032897949389, 19.716529846191349],
          [72.703750610351619, 19.716527938842773],
          [72.703750610351619, 19.717081069946346],
          [72.703475952148608, 19.717081069946346],
          [72.703475952148608, 19.717361450195312],
          [72.703186035156534, 19.717359542846737],
          [72.703186035156534, 19.717639923095703],
          [72.702919006347656, 19.717639923095703],
          [72.702919006347656, 19.718200683593864],
          [72.702362060546932, 19.718193054199332],
          [72.702362060546932, 19.718471527099666],
          [72.702079772949332, 19.71846961975109],
          [72.702079772949332, 19.718750000000057],
          [72.701812744140682, 19.718750000000057],
          [72.701812744140682, 19.719030380249023],
          [72.701530456542912, 19.719030380249023],
          [72.701530456542912, 19.719310760498047],
          [72.70124816894554, 19.719303131103459],
          [72.70124816894554, 19.719583511352653],
          [72.700691223144588, 19.719583511352653],
          [72.700691223144588, 19.719861984253043],
          [72.700416564941577, 19.719860076904411],
          [72.700416564941577, 19.720420837402401],
          [72.700141906738565, 19.720415115356445],
          [72.700141906738565, 19.72097206115717],
          [72.699859619140625, 19.720970153808594],
          [72.699859619140625, 19.72125053405756],
          [72.699592590332315, 19.72125053405756],
          [72.699592590332315, 19.721809387207088],
          [72.699302673339844, 19.721807479858512],
          [72.699302673339844, 19.722085952758903],
          [72.699028015136832, 19.722080230712947],
          [72.699028015136832, 19.722360610961914],
          [72.69819641113304, 19.722360610961914],
          [72.69819641113304, 19.722919464111271],
          [72.697639465332088, 19.722917556762695],
          [72.697639465332088, 19.723472595214901],
          [72.697357177734546, 19.723470687866268],
          [72.697357177734546, 19.723751068115234],
          [72.696807861328125, 19.723751068115234],
          [72.696807861328125, 19.724029541015625],
          [72.696533203125284, 19.724029541015625],
          [72.696533203125284, 19.724309921264592],
          [72.696250915527344, 19.72430610656744],
          [72.696250915527344, 19.724582672119254],
          [72.695968627929972, 19.724580764770621],
          [72.695968627929972, 19.725139617919979],
          [72.695686340332088, 19.725139617919979],
          [72.695686340332088, 19.725418090820369],
          [72.695419311523381, 19.725416183471793],
          [72.695419311523381, 19.725973129272575],
          [72.695137023925838, 19.725971221923771],
          [72.695137023925838, 19.726249694824332],
          [72.694862365722827, 19.726249694824332],
          [72.694862365722827, 19.726528167724723],
          [72.694580078125227, 19.726528167724723],
          [72.694580078125227, 19.726804733276367],
          [72.694305419922046, 19.726804733276367],
          [72.694305419922046, 19.727083206176758],
          [72.694030761719034, 19.727083206176758],
          [72.694030761719034, 19.727361679077092],
          [72.693748474121264, 19.727348327636832],
          [72.693748474121264, 19.729312896728572],
          [72.694030761719034, 19.729305267334041],
          [72.694030761719034, 19.730417251586971],
          [72.694305419922046, 19.730417251586971],
          [72.694305419922046, 19.72986030578619],
          [72.694580078125227, 19.72986030578619],
          [72.694580078125227, 19.729581832885799],
          [72.694862365722827, 19.729583740234432],
          [72.694862365722827, 19.729305267334041],
          [72.695137023925838, 19.729312896728572],
          [72.695137023925838, 19.728750228881836],
          [72.695686340332088, 19.728750228881836],
          [72.695686340332088, 19.728471755981445],
          [72.695968627929972, 19.728471755981445],
          [72.695968627929972, 19.727916717529297],
          [72.696250915527344, 19.727922439575252],
          [72.696250915527344, 19.727640151977482],
          [72.696533203125284, 19.727640151977482],
          [72.696533203125284, 19.727348327636832],
          [72.697082519531534, 19.727361679077092],
          [72.697082519531534, 19.727083206176758],
          [72.697364807129077, 19.727083206176758],
          [72.697364807129077, 19.726528167724723],
          [72.69819641113304, 19.726528167724723],
          [72.69819641113304, 19.726804733276367],
          [72.698753356933651, 19.726804733276367],
          [72.698753356933651, 19.726249694824332],
          [72.702362060546932, 19.726249694824332],
          [72.702362060546932, 19.726528167724723],
          [72.706527709961108, 19.726528167724723],
          [72.706527709961108, 19.726249694824332],
          [72.708747863769815, 19.726249694824332],
          [72.708747863769815, 19.727922439575252],
          [72.709030151367188, 19.727922439575252],
          [72.709030151367188, 19.729312896728572],
          [72.709297180176065, 19.729312896728572],
          [72.709297180176065, 19.72986030578619],
          [72.709587097167969, 19.72986030578619],
          [72.709587097167969, 19.730417251586971],
          [72.709861755371378, 19.730417251586971],
          [72.709861755371378, 19.730693817138786],
          [72.710418701171932, 19.730693817138786],
          [72.710418701171932, 19.730972290039176],
          [72.710983276367415, 19.730970382690543],
          [72.710983276367415, 19.731531143188533],
          [72.711250305175724, 19.731527328491325],
          [72.711250305175724, 19.732082366943303],
          [72.711532592773494, 19.732080459594727],
          [72.711532592773494, 19.732641220092887],
          [72.711807250976676, 19.732641220092887],
          [72.711807250976676, 19.733749389648438],
          [72.712081909179688, 19.733749389648438],
          [72.712081909179688, 19.737640380859432],
          [72.712356567383097, 19.737640380859432],
          [72.712356567383097, 19.74181175231945],
          [72.712638854980469, 19.74181175231945],
          [72.712638854980469, 19.742921829223633],
          [72.712913513183878, 19.742916107177848],
          [72.712913513183878, 19.744304656982422],
          [72.713195800781421, 19.744302749633789],
          [72.713195800781421, 19.746250152587891],
          [72.713470458984432, 19.746250152587891],
          [72.713470458984432, 19.747920989990234],
          [72.713752746582202, 19.747920989990234],
          [72.713752746582202, 19.748750686645565],
          [72.714027404785384, 19.748750686645565],
          [72.714027404785384, 19.749309539794922],
          [72.714302062988224, 19.749309539794922],
          [72.714302062988224, 19.749860763549748],
          [72.714576721191463, 19.749860763549748],
          [72.714576721191463, 19.750419616699276],
          [72.714859008789176, 19.7504177093507],
          [72.714859008789176, 19.750972747802734],
          [72.715415954590128, 19.750972747802734],
          [72.715415954590128, 19.751529693603459],
          [72.715972900390909, 19.751529693603459],
          [72.715972900390909, 19.752361297607422],
          [72.716247558593921, 19.75235748291027],
          [72.716247558593921, 19.752639770507813],
          [72.716537475586222, 19.752639770507813],
          [72.716537475586222, 19.752918243408203],
          [72.716804504394702, 19.752916336059627],
          [72.716804504394702, 19.753471374511776],
          [72.717361450195256, 19.753467559814453],
          [72.717361450195256, 19.753751754760799],
          [72.717918395996207, 19.753751754760799],
          [72.717918395996207, 19.754030227661133],
          [72.718193054199276, 19.754028320312557],
          [72.718193054199276, 19.754304885864371],
          [72.71875, 19.754304885864371],
          [72.71875, 19.754583358764762],
          [72.719306945800952, 19.754581451415959],
          [72.719306945800952, 19.755140304565487],
          [72.71848297119152, 19.755140304565487],
          [72.71848297119152, 19.755422592163086],
          [72.717361450195256, 19.755422592163086],
          [72.717361450195256, 19.755140304565487],
          [72.716796875000171, 19.755140304565487],
          [72.716796875000171, 19.754861831665153],
          [72.716537475586222, 19.754861831665153],
          [72.716537475586222, 19.755140304565487],
          [72.715972900390909, 19.755140304565487],
          [72.715972900390909, 19.754861831665153],
          [72.715415954590128, 19.754861831665153],
          [72.715415954590128, 19.754583358764762],
          [72.715141296386776, 19.754583358764762],
          [72.715141296386776, 19.754028320312557],
          [72.714859008789176, 19.754030227661133],
          [72.714859008789176, 19.753467559814453],
          [72.714584350585994, 19.753471374511776],
          [72.714584350585994, 19.752916336059627],
          [72.714302062988224, 19.752918243408203],
          [72.714302062988224, 19.752639770507813],
          [72.714027404785384, 19.752639770507813],
          [72.714027404785384, 19.752080917358455],
          [72.713752746582202, 19.752082824707088],
          [72.713752746582202, 19.751247406005916],
          [72.713470458984432, 19.751251220703068],
          [72.713470458984432, 19.750690460205135],
          [72.713195800781421, 19.750694274902344],
          [72.713195800781421, 19.7504177093507],
          [72.712905883789119, 19.750419616699276],
          [72.712905883789119, 19.749860763549748],
          [72.712638854980469, 19.749860763549748],
          [72.712638854980469, 19.749031066894588],
          [72.712356567383097, 19.749031066894588],
          [72.712356567383097, 19.748189926147461],
          [72.712081909179688, 19.74819374084484],
          [72.712081909179688, 19.74791526794445],
          [72.711807250976676, 19.747920989990234],
          [72.711807250976676, 19.747640609741211],
          [72.711532592773494, 19.747640609741211],
          [72.711532592773494, 19.746810913086051],
          [72.711250305175724, 19.746810913086051],
          [72.711250305175724, 19.746250152587891],
          [72.710975646972884, 19.746250152587891],
          [72.710975646972884, 19.744028091430778],
          [72.710693359375171, 19.744029998779354],
          [72.710693359375171, 19.742351531982536],
          [72.710418701171932, 19.742361068725643],
          [72.710418701171932, 19.741527557373104],
          [72.710136413574389, 19.74152946472168],
          [72.710136413574389, 19.740419387817326],
          [72.709861755371378, 19.740419387817326],
          [72.709861755371378, 19.739860534667969],
          [72.709587097167969, 19.739860534667969],
          [72.709587097167969, 19.739030838012809],
          [72.709297180176065, 19.739030838012809],
          [72.709297180176065, 19.738468170166072],
          [72.709030151367188, 19.738471984863224],
          [72.709030151367188, 19.737636566162109],
          [72.708747863769815, 19.737640380859432],
          [72.708747863769815, 19.736249923706112],
          [72.708473205566463, 19.736249923706112],
          [72.708473205566463, 19.735691070556754],
          [72.708190917968864, 19.735696792602539],
          [72.708190917968864, 19.735139846801758],
          [72.707916259765682, 19.735139846801758],
          [72.707916259765682, 19.734859466552791],
          [72.707641601562671, 19.734861373901367],
          [72.707641601562671, 19.733749389648438],
          [72.70735168457054, 19.733749389648438],
          [72.70735168457054, 19.73319053649908],
          [72.707084655761889, 19.733194351196289],
          [72.707084655761889, 19.732915878295898],
          [72.706802368164119, 19.732919692993221],
          [72.706802368164119, 19.732360839843693],
          [72.704582214355412, 19.732360839843693],
          [72.704582214355412, 19.732080459594727],
          [72.700691223144588, 19.732080459594727],
          [72.700691223144588, 19.732360839843693],
          [72.699859619140625, 19.732360839843693],
          [72.699859619140625, 19.732641220092887],
          [72.699028015136832, 19.732641220092887],
          [72.699028015136832, 19.732919692993221],
          [72.698471069335881, 19.732915878295898],
          [72.698471069335881, 19.733194351196289],
          [72.697082519531534, 19.73319053649908],
          [72.697082519531534, 19.733480453491211],
          [72.696807861328125, 19.733480453491211],
          [72.696807861328125, 19.733749389648438],
          [72.696250915527344, 19.733749389648438],
          [72.696250915527344, 19.734310150146598],
          [72.695968627929972, 19.734310150146598],
          [72.695968627929972, 19.735420227050724],
          [72.695693969726619, 19.735414505004996],
          [72.695693969726619, 19.735696792602539],
          [72.693466186523722, 19.735691070556754],
          [72.693466186523722, 19.736249923706112],
          [72.693191528320312, 19.736249923706112],
          [72.693191528320312, 19.736539840698242],
          [72.692916870117472, 19.736528396606502],
          [72.692916870117472, 19.738189697265682],
          [72.692367553710881, 19.738199234008789],
          [72.692367553710881, 19.739309310913143],
          [72.692085266113338, 19.73930549621582],
          [72.692085266113338, 19.739583969116211],
          [72.691528320312727, 19.739578247070426],
          [72.691528320312727, 19.739860534667969],
          [72.691253662109546, 19.739860534667969],
          [72.691253662109546, 19.740972518920955],
          [72.690971374511776, 19.740970611572322],
          [72.690971374511776, 19.74152946472168],
          [72.690696716308764, 19.741527557373104],
          [72.690696716308764, 19.742361068725643],
          [72.690414428711222, 19.742361068725643],
          [72.690414428711222, 19.743194580078239],
          [72.690147399902344, 19.743192672729435],
          [72.690139770507813, 19.743749618530387],
          [72.68985748291044, 19.743749618530387],
          [72.68985748291044, 19.744861602783146],
          [72.689582824707088, 19.744861602783146],
          [72.689582824707088, 19.745420455932731],
          [72.689582824707088, 19.745700836181697],
          [72.68930816650402, 19.745693206787166],
          [72.68930816650402, 19.7459716796875],
          [72.689025878906307, 19.745969772338924],
          [72.689025878906307, 19.746530532836857],
          [72.688751220703068, 19.746530532836857],
          [72.688751220703068, 19.746810913086051],
          [72.688468933105696, 19.74680328369152],
          [72.688468933105696, 19.747083663940487],
          [72.688186645507983, 19.747079849243278],
          [72.688186645507983, 19.747360229492244],
          [72.687637329101733, 19.747360229492244],
          [72.687637329101733, 19.747640609741211],
          [72.687362670898722, 19.747640609741211],
          [72.687362670898722, 19.749309539794922],
          [72.687080383300781, 19.749309539794922],
          [72.687080383300781, 19.750141143798942],
          [72.68680572509794, 19.750139236450309],
          [72.68680572509794, 19.750694274902344],
          [72.686531066894588, 19.750690460205135],
          [72.686531066894588, 19.75180816650402],
          [72.686248779296989, 19.751806259155273],
          [72.686248779296989, 19.752361297607422],
          [72.685966491699276, 19.75235748291027],
          [72.685966491699276, 19.752918243408203],
          [72.686248779296989, 19.752916336059627],
          [72.686248779296989, 19.754583358764762],
          [72.685966491699276, 19.754581451415959],
          [72.685966491699276, 19.75625038146967],
          [72.685691833496037, 19.75625038146967],
          [72.685691833496037, 19.757083892822266],
          [72.685417175293196, 19.757080078125057],
          [72.685417175293196, 19.760139465332088],
          [72.685691833496037, 19.760139465332088],
          [72.685691833496037, 19.761529922485408],
          [72.685974121093807, 19.761526107788086],
          [72.685974121093807, 19.762361526489201],
          [72.686248779296989, 19.762361526489201],
          [72.686248779296989, 19.76263618469244],
          [72.686416625976847, 19.762639999389592],
          [72.686531066894588, 19.762639999389592],
          [72.686531066894588, 19.763750076293945],
          [72.686813354492472, 19.763750076293945],
          [72.686813354492472, 19.764030456542912],
          [72.687080383300781, 19.764030456542912],
          [72.687080383300781, 19.764310836792106],
          [72.687362670898722, 19.764310836792106],
          [72.687362670898722, 19.764858245849723],
          [72.687637329101733, 19.764858245849723],
          [72.687637329101733, 19.766809463500977],
          [72.687919616699276, 19.766809463500977],
          [72.687919616699276, 19.768751144409123],
          [72.688194274902514, 19.768749237060547],
          [72.688194274902514, 19.770694732666072],
          [72.688468933105696, 19.770692825317496],
          [72.688468933105696, 19.773200988769531],
          [72.688186645507983, 19.773200988769531],
          [72.688186645507983, 19.774311065673885],
          [72.687919616699276, 19.774311065673885],
          [72.687919616699276, 19.776250839233398],
          [72.687637329101733, 19.776250839233398],
          [72.687637329101733, 19.779308319091854],
          [72.687362670898722, 19.779306411743278],
          [72.687362670898722, 19.779861450195256],
          [72.687080383300781, 19.779857635498104],
          [72.687080383300781, 19.780702590942383],
          [72.687362670898722, 19.780702590942383],
          [72.687362670898722, 19.785140991211051],
          [72.687637329101733, 19.785140991211051],
          [72.687637329101733, 19.786809921264762],
          [72.687919616699276, 19.786809921264762],
          [72.687919616699276, 19.788749694824276],
          [72.688194274902514, 19.788749694824276],
          [72.688194274902514, 19.789583206176871],
          [72.688468933105696, 19.789579391479492],
          [72.688468933105696, 19.790140151977596],
          [72.688751220703068, 19.790136337280273],
          [72.688751220703068, 19.790695190429801],
          [72.689025878906307, 19.790689468383846],
          [72.689025878906307, 19.791250228881779],
          [72.68930816650402, 19.791250228881779],
          [72.68930816650402, 19.791809082031307],
          [72.689582824707088, 19.791805267333984],
          [72.689582824707088, 19.792083740234375],
          [72.68985748291044, 19.792079925537166],
          [72.68985748291044, 19.792360305786133],
          [72.690139770507813, 19.792360305786133],
          [72.690139770507813, 19.79291915893549],
          [72.690414428711222, 19.792917251586914],
          [72.690414428711222, 19.793472290039119],
          [72.690696716308764, 19.793468475341911],
          [72.690696716308764, 19.794029235839844],
          [72.690971374511776, 19.794029235839844],
          [72.690971374511776, 19.79430961608881],
          [72.691246032715014, 19.79430961608881],
          [72.691246032715014, 19.79514122009283],
          [72.690971374511776, 19.795139312744197],
          [72.690971374511776, 19.795694351196403],
          [72.690696716308764, 19.795692443847599],
          [72.690696716308764, 19.797639846801701],
          [72.69040679931669, 19.797639846801701],
          [72.69040679931669, 19.797920227050895],
          [72.690139770507813, 19.797916412353516],
          [72.690139770507813, 19.798471450805664],
          [72.68985748291044, 19.798469543457088],
          [72.68985748291044, 19.799310684204215],
          [72.689582824707088, 19.799303054809684],
          [72.689582824707088, 19.800689697265625],
          [72.68930816650402, 19.800701141357536],
          [72.68930816650402, 19.801530838012752],
          [72.689582824707088, 19.801530838012752],
          [72.689582824707088, 19.80291938781744],
          [72.68985748291044, 19.802915573120117],
          [72.68985748291044, 19.803195953369254],
          [72.690139770507813, 19.803190231323299],
          [72.690139770507813, 19.803750991821232],
          [72.69040679931669, 19.803750991821232],
          [72.69040679931669, 19.804309844970817],
          [72.691696166992244, 19.804307937622184],
          [72.692085266113338, 19.804307937622184],
          [72.692085266113338, 19.804582595825252],
          [72.693191528320312, 19.804582595825252],
          [72.693191528320312, 19.804307937622184],
          [72.693748474121264, 19.804309844970817],
          [72.693748474121264, 19.803760528564567],
          [72.693862915039347, 19.803756713867188],
          [72.694030761719034, 19.803750991821232],
          [72.694030761719034, 19.80291938781744],
          [72.695137023925838, 19.802915573120117],
          [72.695137023925838, 19.803195953369254],
          [72.695693969726619, 19.803195953369254],
          [72.695686340332088, 19.804229736328239],
          [72.695686340332088, 19.804861068725586],
          [72.695137023925838, 19.804861068725586],
          [72.695137023925838, 19.805139541625977],
          [72.694030761719034, 19.805139541625977],
          [72.694030761719034, 19.805419921874943],
          [72.693473815918253, 19.805416107177791],
          [72.693473815918253, 19.805694580078182],
          [72.690971374511776, 19.805694580078182],
          [72.690971374511776, 19.805973052978572],
          [72.689437866210994, 19.805973052978572],
          [72.689025878906307, 19.805973052978572],
          [72.689025878906307, 19.805694580078182],
          [72.688468933105696, 19.805694580078182],
          [72.688468933105696, 19.804861068725586],
          [72.688186645507983, 19.804861068725586],
          [72.688186645507983, 19.804309844970817],
          [72.687919616699276, 19.804309844970817],
          [72.687919616699276, 19.804029464721623],
          [72.687637329101733, 19.804029464721623],
          [72.687637329101733, 19.803750991821232],
          [72.687362670898722, 19.803750991821232],
          [72.687362670898722, 19.802080154418945],
          [72.687637329101733, 19.802085876464901],
          [72.687637329101733, 19.80041694641119],
          [72.687919616699276, 19.800420761108398],
          [72.687919616699276, 19.798469543457088],
          [72.688194274902514, 19.798471450805664],
          [72.688194274902514, 19.795139312744197],
          [72.688468933105696, 19.79514122009283],
          [72.688468933105696, 19.794860839843807],
          [72.688186645507983, 19.794860839843807],
          [72.688186645507983, 19.79430961608881],
          [72.687080383300781, 19.79430961608881],
          [72.687080383300781, 19.79514122009283],
          [72.68680572509794, 19.795139312744197],
          [72.68680572509794, 19.795694351196403],
          [72.686531066894588, 19.795694351196403],
          [72.686531066894588, 19.795972824096793],
          [72.686241149902628, 19.795972824096793],
          [72.686241149902628, 19.796529769897518],
          [72.685966491699276, 19.796529769897518],
          [72.685966491699276, 19.796819686889648],
          [72.686248779296989, 19.796806335449332],
          [72.686248779296989, 19.797082901000977],
          [72.685974121093807, 19.797082901000977],
          [72.685974121093807, 19.79736137390131],
          [72.685691833496037, 19.797359466552734],
          [72.685691833496037, 19.799030303955021],
          [72.685417175293196, 19.799030303955021],
          [72.685417175293196, 19.799591064453182],
          [72.685142517090014, 19.799591064453182],
          [72.685142517090014, 19.801811218261719],
          [72.684860229492244, 19.801811218261719],
          [72.684860229492244, 19.802360534667912],
          [72.684585571289233, 19.802360534667912],
          [72.684585571289233, 19.802637100219727],
          [72.68430328369169, 19.802637100219727],
          [72.68430328369169, 19.803195953369254],
          [72.684028625488281, 19.803190231323299],
          [72.684028625488281, 19.803750991821232],
          [72.683746337890909, 19.803750991821232],
          [72.683746337890909, 19.805419921874943],
          [72.6834716796875, 19.805416107177791],
          [72.6834716796875, 19.805694580078182],
          [72.683197021484489, 19.805694580078182],
          [72.683197021484489, 19.805973052978572],
          [72.682907104492244, 19.80597114562994],
          [72.682907104492244, 19.80624961853033],
          [72.682640075683537, 19.80624961853033],
          [72.682640075683537, 19.806528091430721],
          [72.682357788085994, 19.806528091430721],
          [72.682357788085994, 19.806804656982536],
          [72.682083129882983, 19.806804656982536],
          [72.682083129882983, 19.807083129882926],
          [72.681808471679744, 19.807079315185547],
          [72.681808471679744, 19.807640075683651],
          [72.681526184082202, 19.807640075683651],
          [72.681526184082202, 19.807920455932674],
          [72.68125152587919, 19.807916641235465],
          [72.68125152587919, 19.808471679687443],
          [72.681526184082202, 19.808471679687443],
          [72.681526184082202, 19.808759689331168],
          [72.68125152587919, 19.808759689331168],
          [72.68125152587919, 19.80931282043457],
          [72.680969238281421, 19.80931282043457],
          [72.680969238281421, 19.810140609741154],
          [72.680694580078409, 19.810138702392578],
          [72.680694580078409, 19.810693740844783],
          [72.680427551269588, 19.810691833496151],
          [72.680427551269588, 19.811820983886776],
          [72.680137634277628, 19.811820983886776],
          [72.680137634277628, 19.812360763549862],
          [72.679862976074276, 19.812360763549862],
          [72.679862976074276, 19.812919616699219],
          [72.679580688476676, 19.812915802002067],
          [72.679580688476676, 19.813472747802848],
          [72.679031372070483, 19.813470840454045],
          [72.679031372070483, 19.813751220703239],
          [72.678749084472884, 19.813751220703239],
          [72.678749084472884, 19.814029693603572],
          [72.677917480468921, 19.814027786254996],
          [72.677917480468921, 19.814582824707031],
          [72.677635192871378, 19.814582824707031],
          [72.677635192871378, 19.814861297607365],
          [72.677085876465128, 19.814859390258789],
          [72.677085876465128, 19.815139770507756],
          [72.676803588867244, 19.815139770507756],
          [72.676803588867244, 19.815696716308707],
          [72.676528930664176, 19.815696716308707],
          [72.676528930664176, 19.816806793212891],
          [72.676246643066463, 19.816806793212891],
          [72.676246643066463, 19.817083358764705],
          [72.675689697265852, 19.817083358764705],
          [72.675415039062671, 19.817083358764705],
          [72.675415039062671, 19.817361831665096],
          [72.675140380859432, 19.817359924316463],
          [72.675140380859432, 19.817920684814453],
          [72.674858093261889, 19.817920684814453],
          [72.674858093261889, 19.818199157714787],
          [72.674026489258097, 19.818195343017635],
          [72.674026489258097, 19.81847190856945],
          [72.672920227050724, 19.81847190856945],
          [72.672920227050724, 19.818195343017635],
          [72.672637939453352, 19.818199157714787],
          [72.672637939453352, 19.817920684814453],
          [72.670692443847656, 19.817920684814453],
          [72.670692443847656, 19.818199157714787],
          [72.670135498046932, 19.818195343017635],
          [72.670143127441463, 19.818750381469783],
          [72.669029235839901, 19.818750381469783],
          [72.669029235839901, 19.819030761718807],
          [72.668746948242358, 19.819030761718807],
          [72.668746948242358, 19.819309234619141],
          [72.668472290039347, 19.819305419921989],
          [72.668472290039347, 19.819583892822379],
          [72.668197631835938, 19.819578170776424],
          [72.668197631835938, 19.819860458373967],
          [72.667640686035156, 19.819860458373967],
          [72.667640686035156, 19.820140838623161],
          [72.667358398437784, 19.820140838623161],
          [72.667358398437784, 19.820419311523494],
          [72.667076110839901, 19.820419311523494],
          [72.667076110839901, 19.820701599121094],
          [72.666526794433651, 19.820693969726562],
          [72.666526794433651, 19.820972442626953],
          [72.666252136230639, 19.82097053527832],
          [72.666252136230639, 19.821250915527287],
          [72.665702819824389, 19.821250915527287],
          [72.665702819824389, 19.821529388427678],
          [72.665412902832088, 19.821529388427678],
          [72.665412902832088, 19.821811676025447],
          [72.664306640625284, 19.821811676025447],
          [72.664306640625284, 19.820419311523494],
          [72.664016723632812, 19.820419311523494],
          [72.663749694824332, 19.820419311523494],
          [72.663749694824332, 19.819860458373967],
          [72.663475036621151, 19.819860458373967],
          [72.663475036621151, 19.819583892822379],
          [72.661796569824503, 19.819578170776424],
          [72.661796569824503, 19.819860458373967],
          [72.662086486816577, 19.819860458373967],
          [72.662086486816577, 19.820419311523494],
          [72.661529541015625, 19.820419311523494],
          [72.661529541015625, 19.820701599121094],
          [72.661247253418253, 19.820693969726562],
          [72.661247253418253, 19.820972442626953],
          [72.659858703613509, 19.820972442626953],
          [72.659858703613509, 19.820693969726562],
          [72.659584045410327, 19.820693969726562],
          [72.659584045410327, 19.820972442626953],
          [72.659301757812557, 19.82097053527832],
          [72.659301757812557, 19.821811676025447],
          [72.659027099609546, 19.821811676025447],
          [72.659027099609546, 19.822362899780273],
          [72.660140991210881, 19.822362899780273],
          [72.660140991210881, 19.823760986328125],
          [72.659576416015796, 19.823760986328125],
          [72.659576416015796, 19.824029922485352],
          [72.659027099609546, 19.824028015136776],
          [72.659027099609546, 19.824581146240178],
          [72.657638549804801, 19.824581146240178],
          [72.657638549804801, 19.824861526489371],
          [72.657356262207088, 19.824859619140739],
          [72.657356262207088, 19.825139999389705],
          [72.656806945801009, 19.825139999389705],
          [72.656806945801009, 19.825420379638729],
          [72.656517028808537, 19.825420379638729],
          [72.656517028808537, 19.825700759887695],
          [72.656250000000057, 19.825693130493164],
          [72.656250000000057, 19.826250076293888],
          [72.655982971191577, 19.826250076293888],
          [72.655982971191577, 19.826530456543082],
          [72.655418395996094, 19.82652854919445],
          [72.655418395996094, 19.826803207397518],
          [72.655136108398722, 19.826799392700309],
          [72.655136108398722, 19.827360153198242],
          [72.655418395996094, 19.827360153198242],
          [72.655418395996094, 19.82930946350092],
          [72.655136108398722, 19.829307556152344],
          [72.655136108398722, 19.829584121704158],
          [72.653472900390796, 19.829584121704158],
          [72.653472900390796, 19.830972671508903],
          [72.653198242187557, 19.830970764160099],
          [72.653198242187557, 19.831529617309627],
          [72.652915954590014, 19.831529617309627],
          [72.652915954590014, 19.83263969421381],
          [72.652641296387003, 19.83263969421381],
          [72.652641296387003, 19.83458328247076],
          [72.652359008789233, 19.834581375122127],
          [72.652359008789233, 19.835140228271484],
          [72.652641296387003, 19.835138320922908],
          [72.652641296387003, 19.835971832275504],
          [72.652359008789233, 19.835971832275504],
          [72.652359008789233, 19.836811065673828],
          [72.652084350586222, 19.836805343628043],
          [72.652084350586222, 19.837083816528434],
          [72.65152740478544, 19.837081909179631],
          [72.65152740478544, 19.837921142578182],
          [72.651252746582088, 19.837917327880973],
          [72.651252746582088, 19.838750839233342],
          [72.650970458984489, 19.838750839233342],
          [72.650970458984489, 19.839582443237362],
          [72.650695800781307, 19.839580535888729],
          [72.650695800781307, 19.839860916137695],
          [72.651252746582088, 19.839860916137695],
          [72.651252746582088, 19.840139389038086],
          [72.65152740478544, 19.840139389038086],
          [72.65152740478544, 19.840419769287053],
          [72.651802062988281, 19.840414047241325],
          [72.651802062988281, 19.840694427490291],
          [72.65207672119169, 19.840690612793082],
          [72.65207672119169, 19.841529846191406],
          [72.651802062988281, 19.84152793884283],
          [72.651802062988281, 19.841804504394645],
          [72.65152740478544, 19.841804504394645],
          [72.65152740478544, 19.842361450195426],
          [72.652084350586222, 19.842361450195426],
          [72.652084350586222, 19.842082977295036],
          [72.653198242187557, 19.842082977295036],
          [72.653198242187557, 19.842361450195426],
          [72.654586791992301, 19.842359542846793],
          [72.654586791992301, 19.84263992309576],
          [72.654861450195313, 19.84263992309576],
          [72.654861450195313, 19.844030380249137],
          [72.654586791992301, 19.844030380249137],
          [72.654586791992301, 19.846530914306641],
          [72.654296875000057, 19.846530914306641],
          [72.654296875000057, 19.846809387206974],
          [72.654029846191349, 19.846809387206974],
          [72.654029846191349, 19.847360610961971],
          [72.653747558593807, 19.847360610961971],
          [72.653747558593807, 19.847639083862362],
          [72.653472900390796, 19.847639083862362],
          [72.653472900390796, 19.851249694824219],
          [72.653198242187557, 19.851249694824219],
          [72.653198242187557, 19.851530075073185],
          [72.652915954590014, 19.851528167724609],
          [72.652915954590014, 19.851804733276424],
          [72.652641296387003, 19.851804733276424],
          [72.652641296387003, 19.852083206176815],
          [72.652359008789233, 19.852083206176815],
          [72.652359008789233, 19.852361679077205],
          [72.65207672119169, 19.852359771728572],
          [72.65207672119169, 19.852640151977539],
          [72.65152740478544, 19.852640151977539],
          [72.65152740478544, 19.852920532226563],
          [72.651252746582088, 19.852920532226563],
          [72.651252746582088, 19.8532009124757],
          [72.650695800781307, 19.8532009124757],
          [72.650695800781307, 19.854310989379883],
          [72.650970458984489, 19.854310989379883],
          [72.650970458984489, 19.855421066284237],
          [72.651252746582088, 19.855421066284237],
          [72.651252746582088, 19.857919692993107],
          [72.65152740478544, 19.857917785644531],
          [72.65152740478544, 19.858194351196346],
          [72.651802062988281, 19.858194351196346],
          [72.651802062988281, 19.858472824096737],
          [72.653198242187557, 19.858470916748104],
          [72.653198242187557, 19.858747482299918],
          [72.653472900390796, 19.858747482299918],
          [72.653472900390796, 19.858470916748104],
          [72.653747558593807, 19.858470916748104],
          [72.653747558593807, 19.859029769897461],
          [72.654586791992301, 19.859029769897461],
          [72.654586791992301, 19.858190536499137],
          [72.654861450195313, 19.858194351196346],
          [72.654861450195313, 19.857917785644531],
          [72.655418395996094, 19.857919692993107],
          [72.655418395996094, 19.857641220092773],
          [72.655982971191577, 19.857641220092773],
          [72.655982971191577, 19.857080459594783],
          [72.656524658203296, 19.857082366943416],
          [72.656524658203296, 19.856807708740348],
          [72.656646728515909, 19.856807708740348],
          [72.656806945801009, 19.856809616088981],
          [72.656806945801009, 19.85653114318859],
          [72.657081604003849, 19.85653114318859],
          [72.657081604003849, 19.856250762939396],
          [72.657356262207088, 19.856250762939396],
          [72.657356262207088, 19.85597038269043],
          [72.657913208007812, 19.855972290039063],
          [72.657913208007812, 19.855693817138672],
          [72.658752441406534, 19.855693817138672],
          [72.658752441406534, 19.855138778686637],
          [72.659027099609546, 19.85514068603527],
          [72.659027099609546, 19.854030609130916],
          [72.659301757812557, 19.854030609130916],
          [72.659301757812557, 19.853740692138786],
          [72.659584045410327, 19.853750228881893],
          [72.659584045410327, 19.853471755981559],
          [72.660415649414119, 19.853471755981559],
          [72.660415649414119, 19.853193283081168],
          [72.660697937011832, 19.8532009124757],
          [72.660697937011832, 19.852920532226563],
          [72.660972595214901, 19.852920532226563],
          [72.660972595214901, 19.852640151977539],
          [72.661529541015625, 19.852640151977539],
          [72.661529541015625, 19.852359771728572],
          [72.662086486816577, 19.852361679077205],
          [72.662086486816577, 19.852083206176815],
          [72.662635803222827, 19.852083206176815],
          [72.662635803222827, 19.851804733276424],
          [72.66291809082054, 19.851804733276424],
          [72.66291809082054, 19.850971221923828],
          [72.664024353027401, 19.850971221923828],
          [72.664024353027401, 19.851804733276424],
          [72.666252136230639, 19.851804733276424],
          [72.666252136230639, 19.852083206176815],
          [72.666526794433651, 19.852083206176815],
          [72.666526794433651, 19.852361679077205],
          [72.666809082031193, 19.852359771728572],
          [72.666809082031193, 19.852640151977539],
          [72.667076110839901, 19.852640151977539],
          [72.667076110839901, 19.852920532226563],
          [72.667358398437784, 19.852920532226563],
          [72.667358398437784, 19.8532009124757],
          [72.668746948242358, 19.8532009124757],
          [72.668746948242358, 19.852920532226563],
          [72.669029235839901, 19.852920532226563],
          [72.669029235839901, 19.852359771728572],
          [72.669303894043139, 19.852361679077205],
          [72.669303894043139, 19.851804733276424],
          [72.670135498046932, 19.851804733276424],
          [72.670135498046932, 19.852083206176815],
          [72.670692443847656, 19.852083206176815],
          [72.670692443847656, 19.852361679077205],
          [72.671806335449389, 19.852359771728572],
          [72.671806335449389, 19.852640151977539],
          [72.672637939453352, 19.852640151977539],
          [72.672637939453352, 19.852920532226563],
          [72.673187255859432, 19.852920532226563],
          [72.673187255859432, 19.8532009124757],
          [72.673469543457145, 19.853193283081168],
          [72.673469543457145, 19.853471755981559],
          [72.673751831054744, 19.853469848632926],
          [72.673751831054744, 19.854030609130916],
          [72.673469543457145, 19.854030609130916],
          [72.673469543457145, 19.85514068603527],
          [72.673194885253963, 19.855138778686637],
          [72.673194885253963, 19.855972290039063],
          [72.673469543457145, 19.85597038269043],
          [72.673469543457145, 19.85653114318859],
          [72.673751831054744, 19.85653114318859],
          [72.673751831054744, 19.856809616088981],
          [72.674026489258097, 19.856809616088981],
          [72.674026489258097, 19.85736083984375],
          [72.674301147460938, 19.85736083984375],
          [72.674301147460938, 19.857919692993107],
          [72.674575805664347, 19.857919692993107],
          [72.674575805664347, 19.858747482299918],
          [72.674858093261889, 19.858747482299918],
          [72.674858093261889, 19.859308242797852],
          [72.675415039062671, 19.859306335449276],
          [72.675415039062671, 19.85958290100109],
          [72.675697326660384, 19.859579086303711],
          [72.675697326660384, 19.859870910644588],
          [72.675971984863224, 19.859870910644588],
          [72.675971984863224, 19.860139846801815],
          [72.676246643066463, 19.860139846801815],
          [72.676246643066463, 19.860420227050838],
          [72.676528930664176, 19.860416412353629],
          [72.676528930664176, 19.860971450805607],
          [72.676795959472656, 19.860971450805607],
          [72.676795959472656, 19.861530303955192],
          [72.677085876465128, 19.861528396606559],
          [72.677085876465128, 19.862083435058594],
          [72.677299499511662, 19.862083435058594],
          [72.677635192871378, 19.862083435058594],
          [72.677635192871378, 19.862361907958984],
          [72.677917480468921, 19.862361907958984],
          [72.677917480468921, 19.862916946411133],
          [72.678474426269702, 19.862916946411133],
          [72.678474426269702, 19.863193511962947],
          [72.679031372070483, 19.863193511962947],
          [72.679031372070483, 19.863473892211914],
          [72.679306030273494, 19.863470077514705],
          [72.679306030273494, 19.863750457763672],
          [72.679580688476676, 19.863750457763672],
          [72.679580688476676, 19.864032745361442],
          [72.680137634277628, 19.864032745361442],
          [72.680137634277628, 19.864311218261832],
          [72.680419921875, 19.864305496215877],
          [72.680419921875, 19.864582061767692],
          [72.68070220947294, 19.864572525024528],
          [72.680686950683878, 19.864860534668026],
          [72.680938720703296, 19.864860534668026],
          [72.680969238281421, 19.865140914917049],
          [72.681121826171818, 19.865139007568416],
          [72.68125152587919, 19.865139007568416],
          [72.68125152587919, 19.86533164978033],
          [72.68125152587919, 19.865417480468807],
          [72.680969238281421, 19.865417480468807],
          [72.680969238281421, 19.865692138671818],
          [72.680694580078409, 19.865692138671818],
          [72.680694580078409, 19.865972518921012],
          [72.680969238281421, 19.865970611572209],
          [72.680969238281421, 19.866250991821403],
          [72.680686950683878, 19.866250991821403],
          [72.680694580078409, 19.867361068725529],
          [72.680419921875, 19.867361068725529],
          [72.680419921875, 19.868473052978516],
          [72.680137634277628, 19.868473052978516],
          [72.680137634277628, 19.86986160278326],
          [72.680419921875, 19.86986160278326],
          [72.680419921875, 19.872358322143555],
          [72.680694580078409, 19.872358322143555],
          [72.680694580078409, 19.874860763549805],
          [72.680969238281421, 19.874860763549805],
          [72.680969238281421, 19.875972747802791],
          [72.68125152587919, 19.875972747802791],
          [72.68125152587919, 19.876529693603516],
          [72.681526184082202, 19.876529693603516],
          [72.681526184082202, 19.877639770507869],
          [72.681808471679744, 19.877639770507869],
          [72.681808471679744, 19.880140304565373],
          [72.682083129882983, 19.880140304565373],
          [72.682083129882983, 19.880701065063533],
          [72.682357788085994, 19.880701065063533],
          [72.682357788085994, 19.88292121887207],
          [72.682640075683537, 19.882915496826286],
          [72.682640075683537, 19.887361526489315],
          [72.682914733886776, 19.887361526489315],
          [72.682914733886776, 19.888471603393668],
          [72.682640075683537, 19.888471603393668],
          [72.682640075683537, 19.889030456543026],
          [72.682357788085994, 19.889028549194393],
          [72.682357788085994, 19.889583587646598],
          [72.682640075683537, 19.889583587646598],
          [72.682640075683537, 19.890737533569393],
          [72.682640075683537, 19.891250610351506],
          [72.682357788085994, 19.891250610351506],
          [72.682350158691463, 19.891410827636832],
          [72.682342529296932, 19.891532897949276],
          [72.682083129882983, 19.891532897949276],
          [72.682083129882983, 19.89180946350109],
          [72.681526184082202, 19.89180946350109],
          [72.681526184082202, 19.892360687255859],
          [72.68125152587919, 19.892360687255859],
          [72.68125152587919, 19.893194198608455],
          [72.680969238281421, 19.893190383911246],
          [72.680969238281421, 19.89486122131359],
          [72.680686950683878, 19.89486122131359],
          [72.680686950683878, 19.895420074462947],
          [72.680419921875, 19.895414352416992],
          [72.680419921875, 19.896419525146541],
          [72.680427551269588, 19.897640228271428],
          [72.680694580078409, 19.897636413574276],
          [72.680694580078409, 19.900693893432731],
          [72.680419921875, 19.900693893432731],
          [72.680419921875, 19.900972366333121],
          [72.679862976074276, 19.900968551635742],
          [72.679862976074276, 19.901250839233512],
          [72.679031372070483, 19.901250839233512],
          [72.679031372070483, 19.901529312133846],
          [72.678192138671932, 19.901529312133846],
          [72.678192138671932, 19.901809692382869],
          [72.677917480468921, 19.901805877685661],
          [72.677917480468921, 19.902082443237305],
          [72.677635192871378, 19.902082443237305],
          [72.677635192871378, 19.902639389038029],
          [72.6773681640625, 19.902639389038029],
          [72.6773681640625, 19.902919769287223],
          [72.677085876465128, 19.902915954589844],
          [72.677085876465128, 19.903194427490234],
          [72.676528930664176, 19.903192520141658],
          [72.676528930664176, 19.904029846191349],
          [72.676246643066463, 19.904027938842773],
          [72.676246643066463, 19.904581069946346],
          [72.675971984863224, 19.904581069946346],
          [72.675971984863224, 19.904861450195369],
          [72.675697326660384, 19.904861450195369],
          [72.675697326660384, 19.907361984253043],
          [72.675422668457202, 19.90736007690424],
          [72.675422668457202, 19.907920837402401],
          [72.675697326660384, 19.907915115356445],
          [72.675697326660384, 19.908472061157227],
          [72.675971984863224, 19.908470153808594],
          [72.675971984863224, 19.909030914306754],
          [72.676528930664176, 19.909025192260799],
          [72.676528930664176, 19.909585952758903],
          [72.67665100097679, 19.90958213806158],
          [72.676795959472656, 19.909580230712947],
          [72.676795959472656, 19.910419464111271],
          [72.677085876465128, 19.910419464111271],
          [72.677085876465128, 19.912361145019645],
          [72.6773681640625, 19.912361145019645],
          [72.6773681640625, 19.912918090820369],
          [72.677635192871378, 19.912916183471793],
          [72.677635192871378, 19.913749694824162],
          [72.677917480468921, 19.913749694824162],
          [72.677917480468921, 19.914861679077148],
          [72.677635192871378, 19.914861679077148],
          [72.677635192871378, 19.916250228881836],
          [72.6773681640625, 19.916250228881836],
          [72.6773681640625, 19.916530609130859],
          [72.677085876465128, 19.916530609130859],
          [72.677085876465128, 19.919309616088924],
          [72.676803588867244, 19.919305801391715],
          [72.676803588867244, 19.919582366943359],
          [72.676528930664176, 19.919580459594727],
          [72.676528930664176, 19.919860839843693],
          [72.676246643066463, 19.919860839843693],
          [72.676246643066463, 19.920419692993278],
          [72.675971984863224, 19.920415878295898],
          [72.675971984863224, 19.920694351196289],
          [72.675415039062671, 19.920694351196289],
          [72.675415039062671, 19.92097282409668],
          [72.675140380859432, 19.920970916748047],
          [72.675140380859432, 19.921249389648438],
          [72.674858093261889, 19.921249389648438],
          [72.674858093261889, 19.921810150146598],
          [72.674583435058878, 19.921804428100643],
          [72.674583435058878, 19.922361373901424],
          [72.674301147460938, 19.922359466552791],
          [72.674301147460938, 19.922920227050781],
          [72.674026489258097, 19.922918319702148],
          [72.674026489258097, 19.923196792602539],
          [72.673751831054744, 19.923196792602539],
          [72.673751831054744, 19.923471450805778],
          [72.673469543457145, 19.923469543457145],
          [72.673469543457145, 19.923749923706112],
          [72.672920227050724, 19.923749923706112],
          [72.672920227050724, 19.924030303955135],
          [72.672637939453352, 19.924026489257926],
          [72.672637939453352, 19.924861907959098],
          [72.672363281250171, 19.924858093261719],
          [72.672363281250171, 19.925140380859489],
          [72.672080993652401, 19.925140380859489],
          [72.672080993652401, 19.925420761108455],
          [72.671806335449389, 19.925418853759822],
          [72.671806335449389, 19.925971984863281],
          [72.671516418457088, 19.925960540771541],
          [72.671516418457088, 19.926530838012809],
          [72.671241760254077, 19.926530838012809],
          [72.671241760254077, 19.9268093109132],
          [72.670974731445597, 19.92680549621582],
          [72.670974731445597, 19.927083969116211],
          [72.670692443847656, 19.927078247070426],
          [72.670692443847656, 19.927640914916992],
          [72.667640686035156, 19.927640914916992],
          [72.667640686035156, 19.927919387817326],
          [72.667358398437784, 19.92791748046875],
          [72.667358398437784, 19.928194046020565],
          [72.667076110839901, 19.928194046020565],
          [72.666809082031193, 19.928194046020565],
          [72.666809082031193, 19.928472518920955],
          [72.666252136230639, 19.928470611572322],
          [72.666252136230639, 19.928752899169922],
          [72.665695190429858, 19.928749084472713],
          [72.665695190429858, 19.929027557373104],
          [72.665412902832088, 19.929021835327148],
          [72.665412902832088, 19.92931175231945],
          [72.665138244629077, 19.929306030273494],
          [72.665138244629077, 19.929582595825309],
          [72.664855957031534, 19.929582595825309],
          [72.664855957031534, 19.9298610687257],
          [72.664581298828125, 19.9298610687257],
          [72.664581298828125, 19.930139541626033],
          [72.664306640625284, 19.930139541626033],
          [72.664306640625284, 19.932920455932731],
          [72.664581298828125, 19.932916641235352],
          [72.664581298828125, 19.933471679687557],
          [72.664855957031534, 19.933469772338924],
          [72.664855957031534, 19.934030532836914],
          [72.665138244629077, 19.934028625488281],
          [72.665138244629077, 19.934583663940487],
          [72.665412902832088, 19.934579849243278],
          [72.665412902832088, 19.934860229492244],
          [72.666809082031193, 19.934860229492244],
          [72.666809082031193, 19.934579849243278],
          [72.667076110839901, 19.934579849243278],
          [72.667076110839901, 19.934860229492244],
          [72.667358398437784, 19.934860229492244],
          [72.667358398437784, 19.935150146484375],
          [72.667640686035156, 19.935150146484375],
          [72.667640686035156, 19.935420989990234],
          [72.668472290039347, 19.93541526794445],
          [72.668472290039347, 19.93569374084484],
          [72.668746948242358, 19.93569374084484],
          [72.668746948242358, 19.935972213745231],
          [72.669029235839901, 19.935970306396428],
          [72.669029235839901, 19.936250686645621],
          [72.669860839843693, 19.936250686645621],
          [72.669860839843693, 19.936531066894588],
          [72.670143127441463, 19.936531066894588],
          [72.670143127441463, 19.936809539794979],
          [72.670417785644645, 19.936807632446346],
          [72.670417785644645, 19.937084197998161],
          [72.670692443847656, 19.937080383300781],
          [72.670692443847656, 19.937641143798942],
          [72.670967102051065, 19.937641143798942],
          [72.670967102051065, 19.937919616699332],
          [72.671249389648437, 19.9379177093507],
          [72.671249389648437, 19.938194274902344],
          [72.671524047851847, 19.938194274902344],
          [72.671524047851847, 19.938472747802734],
          [72.672363281250171, 19.938470840454102],
          [72.672363281250171, 19.938751220703125],
          [72.672637939453352, 19.938751220703125],
          [72.672637939453352, 19.939029693603459],
          [72.673187255859432, 19.939029693603459],
          [72.673187255859432, 19.939308166503849],
          [72.674308776855469, 19.939306259155273],
          [72.674308776855469, 19.939582824707088],
          [72.675415039062671, 19.939582824707088],
          [72.675415039062671, 19.939861297607479],
          [72.675971984863224, 19.93985748291027],
          [72.675971984863224, 19.940139770507812],
          [72.676246643066463, 19.940139770507812],
          [72.676246643066463, 19.940418243408203],
          [72.676528930664176, 19.940416336059627],
          [72.676528930664176, 19.940694808960018],
          [72.677917480468921, 19.940694808960018],
          [72.677917480468921, 19.940971374511832],
          [72.678192138671932, 19.940959930419922],
          [72.678192138671932, 19.941251754760799],
          [72.679031372070483, 19.941251754760799],
          [72.679031372070483, 19.94153022766119],
          [72.679306030273494, 19.941528320312557],
          [72.679306030273494, 19.941804885864371],
          [72.679580688476676, 19.941804885864371],
          [72.679580688476676, 19.942083358764762],
          [72.679862976074276, 19.942083358764762],
          [72.679862976074276, 19.942361831665153],
          [72.680137634277628, 19.942361831665153],
          [72.680137634277628, 19.942922592163086],
          [72.680427551269588, 19.942922592163086],
          [72.680427551269588, 19.943201065063477],
          [72.680969238281421, 19.943195343017692],
          [72.680969238281421, 19.943471908569336],
          [72.681526184082202, 19.943471908569336],
          [72.681526184082202, 19.94375038146967],
          [72.681808471679744, 19.94375038146967],
          [72.681808471679744, 19.944030761718864],
          [72.682357788085994, 19.944030761718864],
          [72.682357788085994, 19.944320678710937],
          [72.682640075683537, 19.944305419921875],
          [72.682640075683537, 19.944583892822266],
          [72.682907104492244, 19.944580078125057],
          [72.682907104492244, 19.944860458374023],
          [72.683197021484489, 19.944860458374023],
          [72.683197021484489, 19.945140838623047],
          [72.6834716796875, 19.945140838623047],
          [72.6834716796875, 19.945421218872184],
          [72.683746337890909, 19.945421218872184],
          [72.683746337890909, 19.946250915527401],
          [72.684028625488281, 19.946250915527401],
          [72.684028625488281, 19.947090148925895],
          [72.68430328369169, 19.947090148925895],
          [72.68430328369169, 19.947639465332088],
          [72.684585571289233, 19.947639465332088],
          [72.684585571289233, 19.948194503784293],
          [72.684860229492244, 19.948190689086914],
          [72.684860229492244, 19.948749542236271],
          [72.685142517090014, 19.948749542236271],
          [72.685142517090014, 19.949029922485465],
          [72.685417175293196, 19.949026107788086],
          [72.685417175293196, 19.949583053588867],
          [72.685691833496037, 19.949583053588867],
          [72.685691833496037, 19.95013618469244],
          [72.685974121093807, 19.95013618469244],
          [72.685974121093807, 19.950971603393612],
          [72.686241149902628, 19.950969696044979],
          [72.686241149902628, 19.951810836792106],
          [72.686531066894588, 19.951810836792106],
          [72.686531066894588, 19.952358245849723],
          [72.686813354492472, 19.952358245849723],
          [72.686813354492472, 19.952920913696289],
          [72.687080383300781, 19.95291709899908],
          [72.687080383300781, 19.953193664550895],
          [72.687362670898722, 19.953189849853516],
          [72.687362670898722, 19.953750610351676],
          [72.687637329101733, 19.953750610351676],
          [72.687637329101733, 19.954309463501033],
          [72.687919616699276, 19.954309463501033],
          [72.687919616699276, 19.954860687255803],
          [72.688186645507983, 19.954860687255803],
          [72.688186645507983, 19.955419540405387],
          [72.688468933105696, 19.955415725708008],
          [72.688468933105696, 19.955972671508789],
          [72.688751220703068, 19.955972671508789],
          [72.688751220703068, 19.956260681152457],
          [72.689025878906307, 19.956249237060547],
          [72.689025878906307, 19.957082748413143],
          [72.68930816650402, 19.957082748413143],
          [72.68930816650402, 19.957361221313533],
          [72.689582824707088, 19.957361221313533],
          [72.689582824707088, 19.957639694213867],
          [72.68985748291044, 19.957639694213867],
          [72.68985748291044, 19.957920074462891],
          [72.690139770507813, 19.957916259765682],
          [72.690139770507813, 19.958194732666072],
          [72.690971374511776, 19.958194732666072],
          [72.690971374511776, 19.958471298217887],
          [72.691802978515568, 19.958469390869254],
          [72.691802978515568, 19.958749771118221],
          [72.692367553710881, 19.958749771118221],
          [72.692367553710881, 19.959030151367244],
          [72.692642211914119, 19.959028244018612],
          [72.692642211914119, 19.959304809570426],
          [72.693191528320312, 19.959304809570426],
          [72.693191528320312, 19.959583282470817],
          [72.693748474121264, 19.959583282470817],
          [72.693748474121264, 19.959861755371207],
          [72.694030761719034, 19.959859848022404],
          [72.694030761719034, 19.960140228271598],
          [72.696250915527344, 19.960138320922965],
          [72.696250915527344, 19.960971832275391],
          [72.696533203125284, 19.960969924926758],
          [72.696533203125284, 19.961530685424918],
          [72.696807861328125, 19.961530685424918],
          [72.696807861328125, 19.960969924926758],
          [72.697364807129077, 19.960971832275391],
          [72.697364807129077, 19.960693359375],
          [72.699584960937784, 19.960693359375],
          [72.699584960937784, 19.960971832275391],
          [72.700416564941577, 19.960969924926758],
          [72.700416564941577, 19.961250305175724],
          [72.700965881347827, 19.961250305175724],
          [72.700965881347827, 19.961530685424918],
          [72.70124816894554, 19.961530685424918],
          [72.70124816894554, 19.961811065673885],
          [72.701530456542912, 19.96180534362793],
          [72.701530456542912, 19.96208381652832],
          [72.701805114746151, 19.96208381652832],
          [72.701805114746151, 19.962360382080078],
          [72.702079772949332, 19.962360382080078],
          [72.702079772949332, 19.962640762329102],
          [72.702362060546932, 19.962638854980469],
          [72.702362060546932, 19.963193893432674],
          [72.702636718750284, 19.963193893432674],
          [72.702636718750284, 19.963472366333065],
          [72.703186035156534, 19.963470458984432],
          [72.703186035156534, 19.963750839233455],
          [72.703475952148608, 19.963750839233455],
          [72.703475952148608, 19.964031219482422],
          [72.703750610351619, 19.964025497436637],
          [72.703750610351619, 19.965139389038143],
          [72.704032897949389, 19.965129852295036],
          [72.704032897949389, 19.965419769287166],
          [72.704307556152571, 19.965417861938533],
          [72.704307556152571, 19.965694427490348],
          [72.704582214355412, 19.965694427490348],
          [72.704582214355412, 19.965972900390739],
          [72.704856872558651, 19.965969085693359],
          [72.704856872558651, 19.96624755859375],
          [72.705406188964844, 19.96624755859375],
          [72.705406188964844, 19.96652984619152],
          [72.705696105957315, 19.96652984619152],
          [72.705696105957315, 19.966808319091854],
          [72.706253051758097, 19.966806411743278],
          [72.706253051758097, 19.967082977294922],
          [72.706802368164119, 19.967082977294922],
          [72.706802368164119, 19.967361450195313],
          [72.707077026367358, 19.967361450195313],
          [72.707077026367358, 19.96764183044445],
          [72.707641601562671, 19.96764183044445],
          [72.707641601562671, 19.96792030334484],
          [72.707916259765682, 19.96792030334484],
          [72.707916259765682, 19.968202590942383],
          [72.710136413574389, 19.968194961547852],
          [72.710136413574389, 19.968471527099666],
          [72.710411071777571, 19.968471527099666],
          [72.710411071777571, 19.968751907348633],
          [72.710693359375171, 19.968751907348633],
          [72.710693359375171, 19.969030380249023],
          [72.710983276367415, 19.969030380249023],
          [72.710983276367415, 19.969312667846737],
          [72.712638854980469, 19.969305038452205],
          [72.712638854980469, 19.969583511352596],
          [72.713752746582202, 19.969583511352596],
          [72.713752746582202, 19.969305038452205],
          [72.717918395996207, 19.969312667846737],
          [72.717918395996207, 19.969030380249023],
          [72.718193054199276, 19.969030380249023],
          [72.718193054199276, 19.968751907348633],
          [72.719856262207202, 19.968751907348633],
          [72.719856262207202, 19.968471527099666],
          [72.720413208007756, 19.968471527099666],
          [72.720413208007756, 19.967916488647461],
          [72.720703125000227, 19.96792030334484],
          [72.720703125000227, 19.96764183044445],
          [72.720970153808707, 19.96764183044445],
          [72.720970153808707, 19.967361450195313],
          [72.721252441406307, 19.967361450195313],
          [72.721252441406307, 19.966806411743278],
          [72.7218017578125, 19.966808319091854],
          [72.7218017578125, 19.96652984619152],
          [72.722076416015909, 19.96652984619152],
          [72.722076416015909, 19.96624755859375],
          [72.722640991211222, 19.96624755859375],
          [72.722640991211222, 19.965690612792969],
          [72.723197937011776, 19.965694427490348],
          [72.723197937011776, 19.964860916137809],
          [72.723472595215014, 19.964860916137809],
          [72.723472595215014, 19.964580535888615],
          [72.724029541015568, 19.964582443237418],
          [72.724029541015568, 19.96430778503418],
          [72.724296569824276, 19.964309692382813],
          [72.724296569824276, 19.964031219482422],
          [72.72458648681652, 19.964031219482422],
          [72.72458648681652, 19.963750839233455],
          [72.724861145019531, 19.963750839233455],
          [72.724861145019531, 19.963470458984432],
          [72.72513580322294, 19.963472366333065],
          [72.72513580322294, 19.962915420532283],
          [72.725418090820312, 19.962921142578239],
          [72.725418090820312, 19.962640762329102],
          [72.725982666015796, 19.962640762329102],
          [72.725982666015796, 19.962360382080078],
          [72.726524353027514, 19.962360382080078],
          [72.726516723632756, 19.962070465088004],
          [72.726249694824276, 19.96208381652832],
          [72.726249694824276, 19.961526870727539],
          [72.726516723632756, 19.961530685424918],
          [72.726516723632756, 19.961250305175724],
          [72.727081298828068, 19.961250305175724],
          [72.727081298828068, 19.960969924926758],
          [72.727363586425838, 19.960971832275391],
          [72.727363586425838, 19.960693359375],
          [72.72763824462902, 19.960700988769531],
          [72.72763824462902, 19.960420608520565],
          [72.728202819824503, 19.960420608520565],
          [72.728202819824503, 19.959859848022404],
          [72.728469848632812, 19.959861755371207],
          [72.728469848632812, 19.959583282470817],
          [72.728752136230753, 19.959583282470817],
          [72.728752136230753, 19.959304809570426],
          [72.729026794433764, 19.959304809570426],
          [72.729026794433764, 19.959028244018612],
          [72.729576110840014, 19.959030151367244],
          [72.729576110840014, 19.958749771118221],
          [72.730140686035099, 19.958749771118221],
          [72.730140686035099, 19.958469390869254],
          [72.730415344238338, 19.958471298217887],
          [72.730415344238338, 19.958194732666072],
          [72.730697631836051, 19.958194732666072],
          [72.730697631836051, 19.957082748413143],
          [72.730972290039119, 19.957082748413143],
          [72.730972290039119, 19.951570510864201],
          [72.730972290039119, 19.95013618469244],
          [72.731246948242472, 19.95013618469244],
          [72.731246948242472, 19.947914123535156],
          [72.731536865234375, 19.947919845581112],
          [72.731536865234375, 19.947360992431754],
          [72.731803894043253, 19.947360992431754],
          [72.731796264648722, 19.945970535278377],
          [72.732086181640796, 19.94597244262701],
          [72.732086181640796, 19.945417404174805],
          [72.732360839843807, 19.945421218872184],
          [72.732360839843807, 19.945140838623047],
          [72.732643127441577, 19.945140838623047],
          [72.732643127441577, 19.944580078125057],
          [72.732917785644759, 19.944583892822266],
          [72.732917785644759, 19.944305419921875],
          [72.733192443847599, 19.944320678710937],
          [72.733192443847599, 19.944030761718864],
          [72.733467102050838, 19.944030761718864],
          [72.733467102050838, 19.94375038146967],
          [72.733749389648551, 19.94375038146967],
          [72.733749389648551, 19.943471908569336],
          [72.734306335449503, 19.943471908569336],
          [72.734306335449503, 19.943189620971737],
          [72.734306335449503, 19.942638397216911],
          [72.735137939453296, 19.942640304565543],
          [72.735137939453296, 19.942361831665153],
          [72.735420227051065, 19.942361831665153],
          [72.735420227051065, 19.942083358764762],
          [72.735969543457259, 19.942083358764762],
          [72.735969543457259, 19.941528320312557],
          [72.738746643066577, 19.94153022766119],
          [72.738746643066577, 19.941251754760799],
          [72.739860534667912, 19.941251754760799],
          [72.739860534667912, 19.940959930419922],
          [72.740135192871151, 19.940971374511832],
          [72.740135192871151, 19.940694808960018],
          [72.742637634277571, 19.940694808960018],
          [72.742637634277571, 19.940971374511832],
          [72.743186950683651, 19.940959930419922],
          [72.743186950683651, 19.941251754760799],
          [72.743476867675895, 19.941251754760799],
          [72.743476867675895, 19.94153022766119],
          [72.745414733886889, 19.941528320312557],
          [72.745414733886889, 19.941804885864371],
          [72.745971679687443, 19.941804885864371],
          [72.745971679687443, 19.942083358764762],
          [72.746528625488395, 19.942083358764762],
          [72.746528625488395, 19.942361831665153],
          [72.747093200683707, 19.942361831665153],
          [72.747093200683707, 19.942640304565543],
          [72.749862670898494, 19.942640304565543],
          [72.749862670898494, 19.942361831665153],
          [72.750694274902628, 19.942361831665153],
          [72.750694274902628, 19.942083358764762],
          [72.750968933105639, 19.942083358764762],
          [72.750968933105639, 19.941804885864371],
          [72.751525878906421, 19.941804885864371],
          [72.751525878906421, 19.941528320312557],
          [72.751808166503963, 19.94153022766119],
          [72.751808166503963, 19.940959930419922],
          [72.752357482910213, 19.940971374511832],
          [72.752357482910213, 19.940416336059627],
          [72.752647399902287, 19.940418243408203],
          [72.752647399902287, 19.940139770507812],
          [72.752914428710994, 19.940139770507812],
          [72.752906799316463, 19.93985748291027],
          [72.753196716308707, 19.939861297607479],
          [72.753196716308707, 19.939582824707088],
          [72.753471374511719, 19.939582824707088],
          [72.753471374511719, 19.939306259155273],
          [72.753746032715128, 19.939308166503849],
          [72.753746032715128, 19.939029693603459],
          [72.7540283203125, 19.939029693603459],
          [72.7540283203125, 19.934579849243278],
          [72.753753662109659, 19.934583663940487],
          [72.753753662109659, 19.932638168334961],
          [72.753471374511719, 19.932640075683537],
          [72.753471374511719, 19.927919387817326],
          [72.753746032715128, 19.927919387817326],
          [72.753746032715128, 19.927360534667969],
          [72.754859924316463, 19.927360534667969],
          [72.754859924316463, 19.934310913086051],
          [72.755142211914233, 19.934310913086051],
          [72.755142211914233, 19.935420989990234],
          [72.755416870117415, 19.935420989990234],
          [72.755416870117415, 19.939029693603459],
          [72.755142211914233, 19.939029693603459],
          [72.755142211914233, 19.939308166503849],
          [72.754859924316463, 19.939306259155273],
          [72.754859924316463, 19.939861297607479],
          [72.754592895507983, 19.93985748291027],
          [72.754592895507983, 19.940418243408203],
          [72.754302978515909, 19.940416336059627],
          [72.754302978515909, 19.940694808960018],
          [72.7540283203125, 19.940694808960018],
          [72.7540283203125, 19.940971374511832],
          [72.753753662109659, 19.940971374511832],
          [72.753753662109659, 19.941804885864371],
          [72.753471374511719, 19.941804885864371],
          [72.753471374511719, 19.942083358764762],
          [72.753746032715128, 19.942081451415959],
          [72.753746032715128, 19.942640304565543],
          [72.753471374511719, 19.942640304565543],
          [72.753471374511719, 19.942922592163086],
          [72.753196716308707, 19.942922592163086],
          [72.753196716308707, 19.943201065063477],
          [72.752914428710994, 19.943195343017692],
          [72.752914428710994, 19.943471908569336],
          [72.752357482910213, 19.943471908569336],
          [72.752357482910213, 19.944030761718864],
          [72.746803283691463, 19.944030761718864],
          [72.746803283691463, 19.94375038146967],
          [72.744857788086108, 19.94375038146967],
          [72.744857788086108, 19.943471908569336],
          [72.744583129883097, 19.943471908569336],
          [72.744583129883097, 19.943195343017692],
          [72.740974426269815, 19.943195343017692],
          [72.740974426269815, 19.943471908569336],
          [72.740692138671875, 19.943471908569336],
          [72.740692138671875, 19.94375038146967],
          [72.739585876465071, 19.94375038146967],
          [72.739585876465071, 19.944030761718864],
          [72.738471984863565, 19.944030761718864],
          [72.738471984863565, 19.944320678710937],
          [72.737915039062784, 19.944305419921875],
          [72.737915039062784, 19.944583892822266],
          [72.737640380859375, 19.944580078125057],
          [72.737640380859375, 19.945140838623047],
          [72.737358093262003, 19.945140838623047],
          [72.737358093262003, 19.945421218872184],
          [72.737083435058651, 19.945417404174805],
          [72.737083435058651, 19.945692062378043],
          [72.736808776855412, 19.945690155029411],
          [72.736808776855412, 19.946250915527401],
          [72.736526489257869, 19.946250915527401],
          [72.736526489257869, 19.946529388427734],
          [72.736396789551065, 19.946527481079158],
          [72.736251831054858, 19.946529388427734],
          [72.736251831054858, 19.947090148925895],
          [72.735969543457259, 19.947090148925895],
          [72.735969543457259, 19.947919845581112],
          [72.735687255859546, 19.947919845581112],
          [72.735687255859546, 19.949029922485465],
          [72.735420227051065, 19.949026107788086],
          [72.735420227051065, 19.950971603393612],
          [72.735137939453296, 19.950971603393612],
          [72.735137939453296, 19.951120376586971],
          [72.735137939453296, 19.954309463501033],
          [72.734863281250284, 19.954309463501033],
          [72.734863281250284, 19.956529617309513],
          [72.734580993652344, 19.956529617309513],
          [72.734580993652344, 19.957639694213867],
          [72.734306335449503, 19.957639694213867],
          [72.734306335449503, 19.957920074462891],
          [72.734024047851619, 19.957916259765682],
          [72.734024047851619, 19.958471298217887],
          [72.733467102050838, 19.958469390869254],
          [72.733467102050838, 19.960140228271598],
          [72.733192443847599, 19.960140228271598],
          [72.733192443847599, 19.960700988769531],
          [72.732917785644759, 19.960700988769531],
          [72.732917785644759, 19.961250305175724],
          [72.732643127441577, 19.961250305175724],
          [72.732643127441577, 19.961530685424918],
          [72.730972290039119, 19.961530685424918],
          [72.730972290039119, 19.961811065673885],
          [72.730697631836051, 19.96180534362793],
          [72.730697631836051, 19.96208381652832],
          [72.730415344238338, 19.96208381652832],
          [72.730422973632869, 19.962360382080078],
          [72.730140686035099, 19.962360382080078],
          [72.730140686035099, 19.962640762329102],
          [72.729858398437727, 19.962640762329102],
          [72.729858398437727, 19.962921142578239],
          [72.730140686035099, 19.962915420532283],
          [72.730140686035099, 19.963193893432674],
          [72.729858398437727, 19.963193893432674],
          [72.729858398437727, 19.963472366333065],
          [72.729576110840014, 19.963470458984432],
          [72.729576110840014, 19.963750839233455],
          [72.729309082031307, 19.963750839233455],
          [72.729309082031307, 19.964031219482422],
          [72.729026794433764, 19.964031219482422],
          [72.729026794433764, 19.964309692382813],
          [72.728752136230753, 19.96430778503418],
          [72.728752136230753, 19.964582443237418],
          [72.728469848632812, 19.964582443237418],
          [72.728469848632812, 19.964860916137809],
          [72.728195190429972, 19.964860916137809],
          [72.728195190429972, 19.965139389038143],
          [72.727912902832031, 19.965139389038143],
          [72.727912902832031, 19.965694427490348],
          [72.72763824462902, 19.965694427490348],
          [72.72763824462902, 19.965972900390739],
          [72.727355957031307, 19.965969085693359],
          [72.727355957031307, 19.96652984619152],
          [72.727081298828068, 19.96652984619152],
          [72.727081298828068, 19.966808319091854],
          [72.726806640625227, 19.966806411743278],
          [72.726806640625227, 19.967082977294922],
          [72.726516723632756, 19.967079162597713],
          [72.726516723632756, 19.96764183044445],
          [72.726249694824276, 19.96764183044445],
          [72.726249694824276, 19.96792030334484],
          [72.725982666015796, 19.96792030334484],
          [72.725982666015796, 19.968202590942383],
          [72.725418090820312, 19.968202590942383],
          [72.725418090820312, 19.968751907348633],
          [72.72513580322294, 19.968751907348633],
          [72.72513580322294, 19.969030380249023],
          [72.724861145019531, 19.969030380249023],
          [72.724861145019531, 19.969312667846737],
          [72.724304199218807, 19.969305038452205],
          [72.724304199218807, 19.969583511352596],
          [72.723747253418026, 19.969583511352596],
          [72.723747253418026, 19.969860076904354],
          [72.722640991211222, 19.969860076904354],
          [72.722640991211222, 19.970140457153377],
          [72.721527099609659, 19.970138549804744],
          [72.721527099609659, 19.97069358825695],
          [72.720970153808707, 19.97069358825695],
          [72.720970153808707, 19.97097206115734],
          [72.720138549804915, 19.970970153808537],
          [72.720138549804915, 19.971530914306697],
          [72.716804504394702, 19.971527099609489],
          [72.716804504394702, 19.972082138061523],
          [72.716529846191463, 19.972082138061523],
          [72.716537475586222, 19.972360610961857],
          [72.716247558593921, 19.972360610961857],
          [72.716247558593921, 19.974029541015568],
          [72.716529846191463, 19.974027633666992],
          [72.716529846191463, 19.974861145019588],
          [72.716796875000171, 19.974861145019588],
          [72.716796875000171, 19.975139617919922],
          [72.717086791992415, 19.975139617919922],
          [72.717086791992415, 19.975419998168945],
          [72.717361450195256, 19.975419998168945],
          [72.717361450195256, 19.976249694824276],
          [72.717636108398494, 19.976249694824276],
          [72.717636108398494, 19.977083206176871],
          [72.717918395996207, 19.977083206176871],
          [72.717918395996207, 19.977361679077262],
          [72.718193054199276, 19.977359771728459],
          [72.718193054199276, 19.977640151977653],
          [72.71848297119152, 19.977640151977653],
          [72.71848297119152, 19.978200912475586],
          [72.71875, 19.978200912475586],
          [72.71875, 19.978750228881779],
          [72.719017028808878, 19.978750228881779],
          [72.719017028808878, 19.98041915893549],
          [72.719306945800952, 19.980417251586914],
          [72.719306945800952, 19.980972290039119],
          [72.719581604003963, 19.980968475341911],
          [72.719581604003963, 19.981809616088867],
          [72.719863891601733, 19.981805801391658],
          [72.719863891601733, 19.982082366943473],
          [72.720138549804915, 19.982084274292049],
          [72.720138549804915, 19.983472824096793],
          [72.720413208007756, 19.983472824096793],
          [72.720413208007756, 19.984029769897575],
          [72.720695495605526, 19.984027862548942],
          [72.720695495605526, 19.985971450805721],
          [72.720970153808707, 19.985971450805721],
          [72.720970153808707, 19.986249923706055],
          [72.721252441406307, 19.986240386962947],
          [72.721252441406307, 19.986530303955078],
          [72.721527099609659, 19.986528396606445],
          [72.721527099609659, 19.987361907959041],
          [72.7218017578125, 19.987361907959041],
          [72.721809387207031, 19.989305496215934],
          [72.72208404541044, 19.989305496215934],
          [72.72208404541044, 19.989585876464901],
          [72.721809387207031, 19.989580154418945],
          [72.721809387207031, 19.991529464721623],
          [72.722076416015909, 19.991529464721623],
          [72.722076416015909, 19.992919921875],
          [72.721809387207031, 19.992919921875],
          [72.7218017578125, 19.997360229492187],
          [72.721527099609659, 19.997360229492187],
          [72.721527099609659, 19.999031066894531],
          [72.721252441406307, 19.999031066894531],
          [72.721252441406307, 19.999982833862305],
          [72.721252441406307, 20.000694274902457],
          [72.721527099609659, 20.000694274902457],
          [72.721527099609659, 20.001249313354435],
          [72.721252441406307, 20.001239776611328],
          [72.721252441406307, 20.001529693603629],
          [72.720970153808707, 20.001527786254996],
          [72.720970153808707, 20.002361297607422],
          [72.720703125000227, 20.002359390258789],
          [72.720703125000227, 20.005699157714844],
          [72.720413208007756, 20.005695343017635],
          [72.720413208007756, 20.00597190856945],
          [72.720138549804915, 20.00596809387207],
          [72.720138549804915, 20.006809234619197],
          [72.719863891601733, 20.006805419921989],
          [72.719863891601733, 20.008472442626953],
          [72.719581604003963, 20.008468627929744],
          [72.719581604003963, 20.009029388427678],
          [72.719863891601733, 20.009027481079102],
          [72.719863891601733, 20.009582519531307],
          [72.719581604003963, 20.009582519531307],
          [72.719581604003963, 20.010429382324332],
          [72.719306945800952, 20.010416030883846],
          [72.719306945800952, 20.010694503784237],
          [72.719017028808878, 20.010692596435661],
          [72.719017028808878, 20.011529922485408],
          [72.71875, 20.011528015136776],
          [72.71875, 20.012083053588981],
          [72.719017028808878, 20.012081146240178],
          [72.719017028808878, 20.013200759887695],
          [72.71875, 20.013200759887695],
          [72.71875, 20.013750076293888],
          [72.718475341797159, 20.013750076293888],
          [72.718475341797159, 20.014862060546875],
          [72.718193054199276, 20.014860153198242],
          [72.718193054199276, 20.015420913696403],
          [72.717918395996207, 20.015420913696403],
          [72.717918395996207, 20.01764106750494],
          [72.717636108398494, 20.01764106750494],
          [72.717636108398494, 20.01791954040533],
          [72.717086791992415, 20.01791954040533],
          [72.717086791992415, 20.018472671508903],
          [72.716796875000171, 20.018470764160099],
          [72.716796875000171, 20.019029617309684],
          [72.716529846191463, 20.019029617309684],
          [72.716537475586222, 20.019861221313477],
          [72.716247558593921, 20.019861221313477],
          [72.716247558593921, 20.020418167114201],
          [72.715972900390909, 20.020416259765625],
          [72.715972900390909, 20.02097129821783],
          [72.7156982421875, 20.02097129821783],
          [72.7156982421875, 20.021251678466797],
          [72.715415954590128, 20.021251678466797],
          [72.715415954590128, 20.021804809570369],
          [72.715141296386776, 20.021799087524414],
          [72.715141296386776, 20.022640228271541],
          [72.714859008789176, 20.022640228271541],
          [72.714859008789176, 20.025140762329215],
          [72.715141296386776, 20.025140762329215],
          [72.715141296386776, 20.026531219482536],
          [72.715415954590128, 20.026527404785156],
          [72.715415954590128, 20.028194427490291],
          [72.7156982421875, 20.028194427490291],
          [72.7156982421875, 20.029861450195426],
          [72.715415954590128, 20.029859542846623],
          [72.715415954590128, 20.031539916992244],
          [72.715141296386776, 20.031539916992244],
          [72.715141296386776, 20.03264045715332],
          [72.715415954590128, 20.03264045715332],
          [72.715415954590128, 20.034030914306641],
          [72.715141296386776, 20.034030914306641],
          [72.715141296386776, 20.036251068115348],
          [72.715415954590128, 20.036249160766545],
          [72.715415954590128, 20.037082672119141],
          [72.715141296386776, 20.037082672119141],
          [72.715141296386776, 20.037361145019531],
          [72.714859008789176, 20.037351608276367],
          [72.714859008789176, 20.037919998169059],
          [72.715141296386776, 20.037919998169059],
          [72.715141296386776, 20.038749694824219],
          [72.714859008789176, 20.038749694824219],
          [72.714859008789176, 20.039304733276424],
          [72.715141296386776, 20.039304733276424],
          [72.715141296386776, 20.040416717529354],
          [72.714859008789176, 20.040412902832031],
          [72.714859008789176, 20.04264068603527],
          [72.714576721191463, 20.04264068603527],
          [72.714576721191463, 20.042921066284237],
          [72.714302062988224, 20.042921066284237],
          [72.714302062988224, 20.043479919433594],
          [72.714576721191463, 20.043479919433594],
          [72.714576721191463, 20.04403114318859],
          [72.714302062988224, 20.04403114318859],
          [72.714302062988224, 20.044309616088981],
          [72.714027404785384, 20.044309616088981],
          [72.714027404785384, 20.045419692993164],
          [72.713752746582202, 20.045419692993164],
          [72.713752746582202, 20.046247482299918],
          [72.713470458984432, 20.046247482299918],
          [72.713470458984432, 20.047641754150447],
          [72.713195800781421, 20.047641754150447],
          [72.713195800781421, 20.04819488525402],
          [72.712905883789119, 20.048189163208065],
          [72.712905883789119, 20.049030303955192],
          [72.712638854980469, 20.049028396606388],
          [72.712638854980469, 20.050689697265739],
          [72.712364196777628, 20.050695419311523],
          [72.712364196777628, 20.050973892211914],
          [72.712081909179688, 20.050970077514705],
          [72.712081909179688, 20.051811218261832],
          [72.711807250976676, 20.051805496215877],
          [72.711807250976676, 20.052360534668082],
          [72.711524963378963, 20.052360534668082],
          [72.711524963378963, 20.053472518921012],
          [72.711250305175724, 20.053472518921012],
          [72.711250305175724, 20.054582595825195],
          [72.710975646972884, 20.054582595825195],
          [72.710983276367415, 20.056249618530273],
          [72.710693359375171, 20.056249618530273],
          [72.710693359375171, 20.057083129882869],
          [72.710411071777571, 20.057081222534293],
          [72.710411071777571, 20.060419082641715],
          [72.710136413574389, 20.060417175293082],
          [72.710136413574389, 20.062084197998047],
          [72.709861755371378, 20.062084197998047],
          [72.709861755371378, 20.063194274902401],
          [72.709587097167969, 20.063190460205021],
          [72.709587097167969, 20.065139770507926],
          [72.709297180176065, 20.065139770507926],
          [72.709297180176065, 20.066249847412053],
          [72.709030151367188, 20.066249847412053],
          [72.709030151367188, 20.066530227661246],
          [72.708747863769815, 20.066528320312443],
          [72.708747863769815, 20.067361831665039],
          [72.708473205566463, 20.067359924316406],
          [72.708473205566463, 20.068201065063533],
          [72.708190917968864, 20.068201065063533],
          [72.708190917968864, 20.068750381469783],
          [72.707916259765682, 20.068750381469783],
          [72.707916259765682, 20.070140838623104],
          [72.707641601562671, 20.070140838623104],
          [72.707641601562671, 20.07042121887207],
          [72.707916259765682, 20.07042121887207],
          [72.707916259765682, 20.071250915527457],
          [72.708190917968864, 20.071250915527457],
          [72.708190917968864, 20.07208251953125],
          [72.708473205566463, 20.072080612182617],
          [72.708473205566463, 20.072639465331974],
          [72.708747863769815, 20.072639465331974],
          [72.708747863769815, 20.07347297668457],
          [72.709030151367188, 20.07347297668457],
          [72.709030151367188, 20.074300765991154],
          [72.709297180176065, 20.074310302734489],
          [72.709297180176065, 20.075141906738281],
          [72.709587097167969, 20.075138092041072],
          [72.709587097167969, 20.075971603393668],
          [72.709861755371378, 20.075971603393668],
          [72.709861755371378, 20.076812744140739],
          [72.710136413574389, 20.076812744140739],
          [72.710136413574389, 20.077360153198185],
          [72.710411071777571, 20.077360153198185],
          [72.710411071777571, 20.077640533447379],
          [72.710693359375171, 20.077638626098576],
          [72.710693359375171, 20.078193664550781],
          [72.710975646972884, 20.078193664550781],
          [72.710975646972884, 20.078750610351563],
          [72.711250305175724, 20.078750610351563],
          [72.711250305175724, 20.0790309906007],
          [72.711532592773494, 20.0790309906007],
          [72.711532592773494, 20.07930946350109],
          [72.712081909179688, 20.07930946350109],
          [72.712081909179688, 20.079589843750057],
          [72.712356567383097, 20.079589843750057],
          [72.712356567383097, 20.079860687255916],
          [72.712905883789119, 20.079860687255916],
          [72.712905883789119, 20.079589843750057],
          [72.713195800781421, 20.079589843750057],
          [72.713195800781421, 20.079860687255916],
          [72.714302062988224, 20.079860687255916],
          [72.714302062988224, 20.080141067504883],
          [72.715141296386776, 20.080141067504883],
          [72.715141296386776, 20.080419540405273],
          [72.716247558593921, 20.080415725708065],
          [72.716247558593921, 20.080694198608455],
          [72.716445922851733, 20.080694198608455],
          [72.717086791992415, 20.080694198608455],
          [72.717086791992415, 20.080972671508846],
          [72.718475341797159, 20.080972671508846],
          [72.718475341797159, 20.080694198608455],
          [72.720695495605526, 20.080694198608455],
          [72.720695495605526, 20.080972671508846],
          [72.724861145019531, 20.08097076416027],
          [72.724861145019531, 20.081251144409237],
          [72.725418090820312, 20.081251144409237],
          [72.725418090820312, 20.081529617309627],
          [72.725982666015796, 20.081529617309627],
          [72.725982666015796, 20.081809997558594],
          [72.725692749023722, 20.081804275512809],
          [72.725692749023722, 20.0820827484132],
          [72.725418090820312, 20.082080841064396],
          [72.725418090820312, 20.082651138305664],
          [72.725692749023722, 20.082651138305664],
          [72.725692749023722, 20.08236122131359],
          [72.725982666015796, 20.08236122131359],
          [72.725975036621264, 20.0820827484132],
          [72.726249694824276, 20.082080841064396],
          [72.726249694824276, 20.082651138305664],
          [72.726524353027514, 20.082639694213981],
          [72.726524353027514, 20.083194732666129],
          [72.726806640625227, 20.08319091796875],
          [72.726806640625227, 20.084030151367301],
          [72.727081298828068, 20.084026336669922],
          [72.727081298828068, 20.084583282470703],
          [72.727355957031307, 20.084579467773494],
          [72.727355957031307, 20.085420608520621],
          [72.72763824462902, 20.085418701171818],
          [72.72763824462902, 20.085971832275447],
          [72.727912902832031, 20.085969924926815],
          [72.727912902832031, 20.086809158325195],
          [72.728195190429972, 20.086805343627987],
          [72.728195190429972, 20.088193893432731],
          [72.728469848632812, 20.088193893432731],
          [72.728469848632812, 20.088750839233512],
          [72.728752136230753, 20.088750839233512],
          [72.728752136230753, 20.090139389038029],
          [72.729026794433764, 20.090139389038029],
          [72.729026794433764, 20.092361450195369],
          [72.729309082031307, 20.092359542846737],
          [72.729309082031307, 20.092920303344727],
          [72.729583740234546, 20.092916488647518],
          [72.729583740234546, 20.093471527099723],
          [72.729858398437727, 20.09346961975092],
          [72.729858398437727, 20.09403038024908],
          [72.730140686035099, 20.094028472900447],
          [72.730140686035099, 20.094861984253043],
          [72.730415344238338, 20.094861984253043],
          [72.730415344238338, 20.095693588256836],
          [72.730972290039119, 20.095689773559627],
          [72.730972290039119, 20.096250534057617],
          [72.731246948242472, 20.096250534057617],
          [72.731246948242472, 20.096530914306754],
          [72.731529235839844, 20.096525192260799],
          [72.731529235839844, 20.097085952758903],
          [72.731796264648722, 20.097080230712947],
          [72.731796264648722, 20.097650527954215],
          [72.732086181640796, 20.097637176513729],
          [72.732086181640796, 20.09819412231451],
          [72.732360839843807, 20.098190307617131],
          [72.732360839843807, 20.099029541015682],
          [72.732635498047046, 20.099029541015682],
          [72.732635498047046, 20.099861145019645],
          [72.732917785644759, 20.099861145019645],
          [72.732917785644759, 20.100694656372184],
          [72.733192443847599, 20.100690841674805],
          [72.733192443847599, 20.101530075073356],
          [72.733474731445369, 20.101528167724553],
          [72.733474731445369, 20.102361679077148],
          [72.733749389648551, 20.102361679077148],
          [72.733749389648551, 20.103202819824219],
          [72.734016418457031, 20.103202819824219],
          [72.734016418457031, 20.103750228881893],
          [72.734306335449503, 20.103750228881893],
          [72.734306335449503, 20.104583740234432],
          [72.734580993652344, 20.104581832885856],
          [72.734580993652344, 20.105140686035213],
          [72.734863281250284, 20.10513877868658],
          [72.734863281250284, 20.105972290039176],
          [72.735137939453296, 20.105970382690373],
          [72.735137939453296, 20.106531143188533],
          [72.735420227051065, 20.106531143188533],
          [72.735420227051065, 20.10736083984375],
          [72.735687255859546, 20.10736083984375],
          [72.735687255859546, 20.107919692993278],
          [72.735969543457259, 20.107919692993278],
          [72.735969543457259, 20.108749389648437],
          [72.736251831054858, 20.108749389648437],
          [72.736251831054858, 20.109310150146598],
          [72.736526489257869, 20.109310150146598],
          [72.736526489257869, 20.110139846801815],
          [72.736808776855412, 20.110139846801815],
          [72.736808776855412, 20.110420227050781],
          [72.737083435058651, 20.110416412353572],
          [72.737083435058651, 20.110696792602539],
          [72.737358093262003, 20.110691070556584],
          [72.737358093262003, 20.112920761108455],
          [72.737640380859375, 20.112920761108455],
          [72.737640380859375, 20.113750457763672],
          [72.737915039062784, 20.113750457763672],
          [72.737915039062784, 20.114583969116211],
          [72.738197326660156, 20.114583969116211],
          [72.738197326660156, 20.118400573730582],
          [72.738197326660156, 20.122920989990234],
          [72.737915039062784, 20.12291526794445],
          [72.737915039062784, 20.125694274902344],
          [72.737640380859375, 20.125694274902344],
          [72.737640380859375, 20.127361297607479],
          [72.737922668457315, 20.12735748291027],
          [72.737922668457315, 20.12903022766119],
          [72.737640380859375, 20.12903022766119],
          [72.737640380859375, 20.132640838623047],
          [72.737358093262003, 20.132640838623047],
          [72.737358093262003, 20.135419845581112],
          [72.737640380859375, 20.135414123535156],
          [72.737640380859375, 20.136539459228572],
          [72.741065979003906, 20.135959625244197],
          [72.748306274414063, 20.134410858154354],
          [72.754646301269588, 20.133039474487418],
          [72.761810302734546, 20.131498336792106],
          [72.774528503418253, 20.130800247192496],
          [72.787612915039063, 20.130081176757813],
          [72.794471740722656, 20.128179550170955],
          [72.801849365234318, 20.125019073486328],
          [72.803527832031534, 20.126010894775391],
          [72.805198669433821, 20.127010345459041],
          [72.801261901855582, 20.137809753418082],
          [72.800666809082315, 20.145269393920898],
          [72.801483154297046, 20.147117614746151],
          [72.802062988281421, 20.148469924926758],
          [72.805366516113338, 20.150030136108342],
          [72.809127807617358, 20.151800155639648],
          [72.811950683593864, 20.152420043945313],
          [72.815856933593807, 20.153280258178711],
          [72.826042175293253, 20.146280288696403],
          [72.832298278808651, 20.144020080566406],
          [72.83534240722679, 20.144641876220646],
          [72.834167480468807, 20.149730682373161],
          [72.828842163085994, 20.156570434570313],
          [72.833618164062727, 20.183570861816463],
          [72.834640502929801, 20.185770034790153],
          [72.835533142090071, 20.187660217285156],
          [72.837257385253963, 20.188680648803768],
          [72.842201232910384, 20.188869476318473],
          [72.843521118164119, 20.190040588378963],
          [72.849670410156534, 20.189250946045036],
          [72.849052429199276, 20.19094276428217],
          [72.845718383789006, 20.194139480590934],
          [72.844139099121378, 20.19779014587408],
          [72.846138000488452, 20.203569412231445],
          [72.850288391113395, 20.207941055297852],
          [72.855087280273608, 20.209110260009709],
          [72.864387512207315, 20.208629608154354],
          [72.872001647949503, 20.20824050903326],
          [72.872879028320369, 20.21251106262207],
          [72.871887207031421, 20.222560882568416],
          [72.874542236328296, 20.225809097290153],
          [72.884323120117244, 20.226579666137809],
          [72.888732910156307, 20.225820541381893],
          [72.899841308594034, 20.221670150756893],
          [72.905380249023722, 20.22623252868658],
          [72.910865783691634, 20.22606086730957],
          [72.916809082031534, 20.224769592285213],
          [72.922187805175895, 20.223598480224553],
          [72.928428649902401, 20.223369598388786],
          [72.94181060791044, 20.21780967712408],
          [72.951019287109546, 20.215980529785213],
          [72.960823059082088, 20.214040756225643],
          [72.969245910644588, 20.210910797119197],
          [72.970428466797159, 20.212329864502067],
          [72.975921630859432, 20.189598083496094],
          [72.976196289062671, 20.180019378662166],
          [72.986038208007869, 20.176549911499023],
          [72.986686706543139, 20.171310424804687],
          [72.986236572265909, 20.1627197265625],
          [72.9859619140625, 20.157529830932617],
          [72.973228454589901, 20.130800247192496],
          [72.979629516601733, 20.125299453735465],
          [72.985321044921989, 20.113451004028434],
          [72.989242553710994, 20.113212585449332],
          [72.994186401367244, 20.113901138305664],
          [73.004310607910213, 20.117919921875057],
          [73.006652832031534, 20.121250152587947],
          [73.007278442382756, 20.124120712280273],
          [73.007781982421932, 20.126390457153377],
          [73.007713317871094, 20.129400253296012],
          [73.007637023925895, 20.132469177246207],
          [73.008758544922159, 20.13701057434082],
          [73.010513305664006, 20.140222549438477],
          [73.017478942871151, 20.134958267211971],
          [73.017021179199389, 20.132450103759766],
          [73.016670227050781, 20.130491256713924],
          [73.014991760253963, 20.124860763549805],
          [73.010208129882869, 20.11040115356451],
          [73.019546508789063, 20.105020523071346],
          [73.024681091308594, 20.096300125122184],
          [73.031776428222713, 20.084421157836971],
          [73.038528442383097, 20.078098297119141],
          [73.045272827148608, 20.071781158447209],
          [73.052810668945597, 20.067670822143555],
          [73.059211730957031, 20.067930221557674],
          [73.057991027832145, 20.096731185913143],
          [73.060638427734659, 20.099060058593807],
          [73.078231811523381, 20.095270156860408],
          [73.088317871093864, 20.09446907043457],
          [73.098449707031193, 20.093669891357536],
          [73.105171203613281, 20.087219238281307],
          [73.107940673828409, 20.087320327758903],
          [73.110382080078352, 20.084611892700252],
          [73.111831665039233, 20.083011627197379],
          [73.117546081543139, 20.078809738159237],
          [73.123130798339901, 20.077939987182617],
          [73.126121520996264, 20.078090667724609],
          [73.127738952636946, 20.078161239624023],
          [73.12967681884794, 20.078840255737418],
          [73.131401062012003, 20.079429626464901],
          [73.136695861816634, 20.085250854492188],
          [73.139541625976619, 20.084270477294979],
          [73.144493103027401, 20.077859878540039],
          [73.156745910644588, 20.073959350586051],
          [73.163299560546818, 20.07311058044445],
          [73.17022705078125, 20.06560134887701],
          [73.175392150878963, 20.058050155639762],
          [73.181442260742358, 20.051620483398551],
          [73.183799743652401, 20.052299499511776],
          [73.185867309570313, 20.052900314331168],
          [73.198905944824503, 20.062271118164119],
          [73.198036193847827, 20.077810287475643],
          [73.202896118164119, 20.081050872802791],
          [73.206916809082315, 20.083711624145621],
          [73.213935852050838, 20.090641021728629],
          [73.219116210937557, 20.097499847412223],
          [73.217742919921932, 20.106340408325252],
          [73.216316223144474, 20.121999740600586],
          [73.221488952636889, 20.120798110961914],
          [73.226722717285384, 20.122579574584961],
          [73.230331420898494, 20.128160476684684],
          [73.229522705078296, 20.133159637451286],
          [73.230468750000171, 20.137710571289063],
          [73.232643127441634, 20.14060020446783],
          [73.235488891601619, 20.140991210937557],
          [73.236907958984489, 20.136922836303711],
          [73.236679077148722, 20.129722595214844],
          [73.238121032714844, 20.128110885620117],
          [73.243919372558878, 20.129039764404297],
          [73.25361633300804, 20.128520965576229],
          [73.256149291992472, 20.127889633178825],
          [73.259468078613452, 20.124639511108512],
          [73.261291503906534, 20.125591278076172],
          [73.262809753418253, 20.127950668334961],
          [73.264976501465014, 20.133760452270508],
          [73.268463134765682, 20.139289855957088],
          [73.283470153808764, 20.145759582519588],
          [73.289077758789119, 20.149562835693473],
          [73.293632507324219, 20.153881072998104],
          [73.293212890625171, 20.162160873413143],
          [73.290657043457315, 20.174409866333008],
          [73.290733337402514, 20.177350997924805],
          [73.293746948242301, 20.185979843139705],
          [73.294059753418196, 20.193861007690543],
          [73.294876098633097, 20.196210861206055],
          [73.298217773437557, 20.196161270141658],
          [73.311149597168139, 20.207210540771484],
          [73.314163208007756, 20.207670211791992],
          [73.320472717285327, 20.20433235168457],
          [73.327873229980753, 20.202499389648551],
          [73.336425781250284, 20.204099655151424],
          [73.34806060791044, 20.199050903320426],
          [73.352851867676065, 20.198471069336051],
          [73.354812622070483, 20.199621200561467],
          [73.35721588134794, 20.202499389648551],
          [73.359306335449276, 20.209110260009709],
          [73.361785888671932, 20.211988449096793],
          [73.367599487304858, 20.213371276855582],
          [73.36923980712919, 20.211708068847656],
          [73.367607116699389, 20.20940017700201],
          [73.364799499511776, 20.200998306274528],
          [73.366912841797102, 20.1963405609132],
          [73.374313354492188, 20.192659378051701],
          [73.375946044921989, 20.194971084594727],
          [73.375289916992244, 20.202909469604492],
          [73.376327514648551, 20.205320358276481],
          [73.383666992187557, 20.202390670776424],
          [73.388519287109659, 20.20630073547369],
          [73.395286560058594, 20.20916938781744],
          [73.397361755371264, 20.205940246582145],
          [73.396263122558651, 20.201631546020508],
          [73.398078918457145, 20.196001052856502],
          [73.402816772461222, 20.195020675659293],
          [73.405471801758097, 20.197969436645621],
          [73.409202575683594, 20.200490951538143],
          [73.416816711425952, 20.200309753418026],
          [73.426826477050838, 20.201570510864371],
          [73.429916381836222, 20.206230163574276],
          [73.430313110351676, 20.212320327758789],
          [73.427886962890796, 20.215431213378963],
          [73.426071166992472, 20.223598480224553],
          [73.422378540039063, 20.231761932373161],
          [73.42280578613304, 20.236761093139762],
          [73.420326232910384, 20.242280960083008],
          [73.42227935791044, 20.248090744018555],
          [73.421607971191406, 20.253719329834098],
          [73.420410156249943, 20.256999969482422],
          [73.421806335449219, 20.263561248779354],
          [73.424423217773608, 20.26914024353033],
          [73.423141479492188, 20.273689270019531],
          [73.424621582031421, 20.276830673217887],
          [73.436203002929972, 20.279020309448242],
          [73.436943054199503, 20.282121658325195],
          [73.430763244628906, 20.298049926757926],
          [73.428543090820369, 20.311910629272575],
          [73.426116943359489, 20.315929412841797],
          [73.425315856933878, 20.320720672607422],
          [73.425399780273608, 20.337671279907227],
          [73.423736572265682, 20.341810226440487],
          [73.423431396484659, 20.352090835571403],
          [73.421737670898381, 20.355600357055664],
          [73.414787292480696, 20.381570816040096],
          [73.412002563476676, 20.383529663085881],
          [73.407676696777344, 20.383920669555778],
          [73.403106689453125, 20.381799697876033],
          [73.398078918457145, 20.374740600586051],
          [73.394546508789119, 20.372949600219727],
          [73.39157867431669, 20.372890472412223],
          [73.390251159668082, 20.380189895629883],
          [73.391349792480526, 20.390199661254996],
          [73.395507812500057, 20.398019790649528],
          [73.397727966308764, 20.399232864379883],
          [73.407623291015568, 20.39628982543951],
          [73.40952301025402, 20.401348114013786],
          [73.408790588379077, 20.404220581054744],
          [73.413063049316463, 20.40784835815424],
          [73.414611816406307, 20.405660629272461],
          [73.415832519531193, 20.40619087219244],
          [73.416336059570369, 20.410659790039063],
          [73.422889709472599, 20.414329528808651],
          [73.429740905761832, 20.414390563964957],
          [73.429283142090071, 20.419969558715934],
          [73.430809020996321, 20.42881965637207],
          [73.435859680175724, 20.436069488525504],
          [73.437927246094034, 20.445722579956055],
          [73.449012756347599, 20.46669960021984],
          [73.452041625976847, 20.471401214599609],
          [73.455940246582031, 20.475370407104606],
          [73.461090087890625, 20.478130340576229],
          [73.465232849121037, 20.484159469604606],
          [73.466697692871378, 20.488300323486442],
          [73.469833374023608, 20.492330551147518],
          [73.475936889648608, 20.495019912719727],
          [73.474136352539347, 20.501060485839844],
          [73.47226715087902, 20.514049530029411],
          [73.473808288574162, 20.515319824218864],
          [73.476905822754077, 20.522037506103572],
          [73.4847412109375, 20.525709152221737],
          [73.497299194336108, 20.536222457885856],
          [73.500740051269702, 20.540241241455078],
          [73.493270874023381, 20.542200088501033],
          [73.481796264648722, 20.54335975646984],
          [73.485847473144702, 20.564050674438477],
          [73.483726501464787, 20.578430175781364],
          [73.480819702148722, 20.583599090576229],
          [73.476707458496264, 20.586309432983455],
          [73.468559265136776, 20.58876991271984],
          [73.454826354980526, 20.594589233398494],
          [73.440361022949276, 20.595119476318473],
          [73.437500000000057, 20.597471237182731],
          [73.439086914062614, 20.601261138915959],
          [73.433822631835938, 20.614719390869197],
          [73.430786132812557, 20.62053108215332],
          [73.427642822265739, 20.624490737915039],
          [73.415962219238565, 20.626161575317496],
          [73.415122985839844, 20.628059387206974],
          [73.417976379394531, 20.630470275878963],
          [73.414710998535327, 20.635700225830135],
          [73.411346435546932, 20.638580322265625],
          [73.402732849121094, 20.642599105835018],
          [73.401580810546875, 20.649209976196346],
          [73.403648376465014, 20.652370452880803],
          [73.409835815429915, 20.655010223388786],
          [73.414962768554744, 20.656040191650391],
          [73.417526245117301, 20.657890319824276],
          [73.419166564941463, 20.660470962524528],
          [73.430358886718921, 20.660881042480469],
          [73.435516357422046, 20.662372589111385],
          [73.439918518066406, 20.664840698242301],
          [73.443252563476847, 20.67437934875494],
          [73.443572998046932, 20.677999496459961],
          [73.450088500976619, 20.680759429931754],
          [73.452880859375, 20.683000564575309],
          [73.454528808593864, 20.686050415039063],
          [73.456542968750057, 20.693399429321289],
          [73.447296142578068, 20.701110839843693],
          [73.453697204590071, 20.710470199584961],
          [73.458686828613565, 20.71431922912592],
          [73.475189208984546, 20.721670150756836],
          [73.480499267578296, 20.719650268554687],
          [73.482612609863452, 20.717229843139762],
          [73.484169006347656, 20.709070205688533],
          [73.488739013671875, 20.706600189208984],
          [73.493362426757869, 20.694299697875977],
          [73.493759155273665, 20.689529418945313],
          [73.497291564941577, 20.686019897461051],
          [73.497222900390909, 20.680959701538143],
          [73.492050170898494, 20.680330276489371],
          [73.489189147949276, 20.678501129150334],
          [73.487411499023438, 20.67555046081543],
          [73.487777709961108, 20.672121047973746],
          [73.489540100097713, 20.669639587402287],
          [73.492507934570256, 20.668430328369141],
          [73.493362426757869, 20.665559768676815],
          [73.495475769043196, 20.662691116333008],
          [73.498435974121264, 20.653419494628849],
          [73.500877380371207, 20.652740478515682],
          [73.507881164550838, 20.658649444580192],
          [73.512329101562614, 20.663021087646598],
          [73.517807006835994, 20.670141220092887],
          [73.519989013672046, 20.666339874267578],
          [73.525161743164233, 20.667142868041992],
          [73.526977539062784, 20.670129776000977],
          [73.530403137207315, 20.67312049865717],
          [73.538375854492244, 20.673860549926871],
          [73.544761657714787, 20.669200897216797],
          [73.553657531738338, 20.655330657959041],
          [73.562942504882813, 20.647390365600643],
          [73.567329406738281, 20.647911071777344],
          [73.574195861816406, 20.651050567626953],
          [73.584182739257869, 20.647899627685604],
          [73.591209411621151, 20.645111083984432],
          [73.602752685546818, 20.637861251831112],
          [73.607307434082145, 20.636301040649357],
          [73.622192382812614, 20.625299453735352],
          [73.625946044921932, 20.621110916137695],
          [73.629486083984546, 20.612300872802848],
          [73.630386352539176, 20.60602951049799],
          [73.632171630859375, 20.602239608764762],
          [73.635063171386776, 20.591659545898438],
          [73.634483337402401, 20.582290649414063],
          [73.636772155761776, 20.579290390014705],
          [73.639495849609432, 20.577909469604492],
          [73.643287658691634, 20.577159881591854],
          [73.647102355957259, 20.577499389648551],
          [73.650939941406307, 20.576410293579045],
          [73.657051086426065, 20.572191238403434],
          [73.661857604980582, 20.565740585327205],
          [73.665840148926065, 20.562810897827148],
          [73.670707702636719, 20.562339782714901],
          [73.676177978515568, 20.564159393310604],
          [73.681365966797046, 20.567670822143612],
          [73.685508728027457, 20.571689605712834],
          [73.692436218261889, 20.575349807739315],
          [73.701019287109546, 20.578380584716797],
          [73.709648132324276, 20.574502944946232],
          [73.719856262206974, 20.576320648193359],
          [73.724281311035327, 20.575801849365291],
          [73.729026794433764, 20.574129104614201],
          [73.737663269042969, 20.573989868164119],
          [73.741546630859659, 20.57261848449707],
          [73.748207092285213, 20.56735992431652],
          [73.763946533203296, 20.583330154418945],
          [73.769065856933537, 20.587169647216797],
          [73.775695800781534, 20.588760375976506],
          [73.779975891113452, 20.591859817504826],
          [73.781356811523494, 20.595079421997184],
          [73.787055969238281, 20.602258682251033],
          [73.792732238769702, 20.604310989379883],
          [73.802375793457088, 20.605791091918888],
          [73.805961608886776, 20.601520538330135],
          [73.816566467285099, 20.609369277954215],
          [73.825386047363281, 20.614019393920955],
          [73.830688476562671, 20.614919662475643],
          [73.833908081054801, 20.614120483398551],
          [73.838287353515739, 20.615760803222713],
          [73.846412658691463, 20.623519897460937],
          [73.843109130859546, 20.64441108703619],
          [73.843490600586108, 20.650329589843864],
          [73.847076416015568, 20.656362533569393],
          [73.845352172851676, 20.667070388793945],
          [73.841506958008097, 20.675138473510742],
          [73.834259033203409, 20.673538208007869],
          [73.825431823730526, 20.673618316650447],
          [73.822647094726676, 20.693820953369141],
          [73.828742980957315, 20.696460723876953],
          [73.833625793457088, 20.69960975646984],
          [73.839179992676009, 20.701900482177791],
          [73.842758178710938, 20.702119827270508],
          [73.863601684570369, 20.694299697875977],
          [73.873626708984546, 20.707719802856502],
          [73.877281188964844, 20.721330642700309],
          [73.881942749023722, 20.726879119873104],
          [73.885566711426065, 20.729610443115348],
          [73.888862609863452, 20.731081008911246],
          [73.903793334960937, 20.730640411376953],
          [73.90875244140625, 20.725229263305664],
          [73.920906066894702, 20.723529815673828],
          [73.927566528320256, 20.730440139770565],
          [73.935066223144531, 20.734619140625114],
          [73.935966491699162, 20.731500625610352],
          [73.949531555175952, 20.742309570312443],
          [73.948455810546932, 20.746700286865291],
          [73.945236206054744, 20.749290466308651],
          [73.947502136230526, 20.752470016479549],
          [73.94718170166044, 20.76078033447277],
          [73.938346862793026, 20.760789871215877],
          [73.940567016601733, 20.76885986328125],
          [73.938117980957031, 20.789670944213924],
          [73.941146850586108, 20.803781509399414],
          [73.940193176269702, 20.808860778808707],
          [73.946266174316349, 20.818670272827205],
          [73.947639465332202, 20.825090408325309],
          [73.947608947754077, 20.829399108886776],
          [73.945098876953239, 20.840131759643555],
          [73.935897827148494, 20.843439102172795],
          [73.933731079101563, 20.844970703125],
          [73.931060791015625, 20.848390579223746],
          [73.93155670166027, 20.852502822876033],
          [73.930130004882869, 20.860111236572266],
          [73.931686401367415, 20.864732742309627],
          [73.929679870605639, 20.868871688842887],
          [73.931236267090014, 20.876609802246094],
          [73.931037902832202, 20.885917663574332],
          [73.927322387695597, 20.899110794067496],
          [73.924438476562727, 20.902839660644588],
          [73.922737121582088, 20.907749176025504],
          [73.920326232910099, 20.911230087280387],
          [73.916816711425838, 20.915050506591797],
          [73.912216186523494, 20.917940139770565],
          [73.90956115722679, 20.92140007019043],
          [73.903961181640796, 20.925369262695426],
          [73.896339416503906, 20.933000564575252],
          [73.89501953125, 20.940139770507812],
          [73.895095825195597, 20.946521759033203],
          [73.896942138671932, 20.95255088806158],
          [73.901786804199503, 20.961700439453125],
          [73.911231994628906, 20.962352752685547],
          [73.915382385254077, 20.964820861816463],
          [73.913963317871151, 20.96996116638195],
          [73.911163330078068, 20.975429534912223],
          [73.906448364257813, 20.983150482177734],
          [73.898635864257813, 20.982229232788086],
          [73.879188537597656, 20.986471176147518],
          [73.872688293457031, 20.990730285644588],
          [73.857215881347827, 20.997709274291992],
          [73.853767395019702, 20.999111175537223],
          [73.850128173828068, 21.001419067382869],
          [73.846832275390909, 20.993989944458008],
          [73.840782165527287, 20.993139266967773],
          [73.837692260742472, 20.994831085205135],
          [73.827529907226619, 20.996070861816463],
          [73.820503234863338, 20.995040893554688],
          [73.816406250000171, 20.996051788330192],
          [73.814048767090128, 21.000801086425781],
          [73.812080383300838, 21.010660171508903],
          [73.807701110840071, 21.02255821228033],
          [73.793823242187784, 21.019769668579158],
          [73.784706115722599, 21.019569396972713],
          [73.774856567382813, 21.01045036315918],
          [73.769447326660099, 21.014520645141715],
          [73.773925781250057, 21.021619796752987],
          [73.775642395019588, 21.027601242065373],
          [73.766067504882813, 21.040050506591854],
          [73.763000488281421, 21.038640975952262],
          [73.756980895996151, 21.03917121887207],
          [73.747611999511776, 21.03997993469244],
          [73.742187500000171, 21.055500030517635],
          [73.743736267090014, 21.064161300659293],
          [73.740798950195597, 21.072870254516715],
          [73.744132995605469, 21.081670761108455],
          [73.742240905761719, 21.081569671630859],
          [73.740463256835881, 21.084869384765568],
          [73.739067077637003, 21.094839096069393],
          [73.749465942382983, 21.10774040222168],
          [73.752609252929972, 21.114089965820312],
          [73.743370056152344, 21.108249664306641],
          [73.738891601562784, 21.101329803466911],
          [73.735801696777571, 21.103229522705192],
          [73.714782714843807, 21.10719108581543],
          [73.708976745605582, 21.112340927124023],
          [73.710586547851619, 21.119022369384822],
          [73.703239440918253, 21.108961105346737],
          [73.693389892578296, 21.100990295410213],
          [73.689376831054858, 21.105989456176815],
          [73.678901672363281, 21.109251022338867],
          [73.659942626953409, 21.108379364013786],
          [73.657730102539062, 21.121049880981502],
          [73.65537261962902, 21.121799468994141],
          [73.653030395507869, 21.122541427612418],
          [73.649246215820597, 21.122749328613338],
          [73.645462036132926, 21.122959136962891],
          [73.638023376464957, 21.121709823608455],
          [73.628723144531421, 21.120149612426871],
          [73.62359619140625, 21.1379909515382],
          [73.626342773437784, 21.13982009887701],
          [73.629081726074389, 21.14166069030756],
          [73.618850708007869, 21.144172668457145],
          [73.614227294922046, 21.146980285644588],
          [73.613456726074389, 21.150430679321346],
          [73.612586975097884, 21.152191162109318],
          [73.611473083496378, 21.154460906982479],
          [73.604919433593807, 21.155059814453068],
          [73.600273132324162, 21.154331207275504],
          [73.596679687500171, 21.152730941772461],
          [73.592292785644702, 21.152940750122127],
          [73.588798522949503, 21.154190063476619],
          [73.587516784668139, 21.15674018859869],
          [73.588752746582088, 21.160860061645508],
          [73.588302612304688, 21.167900085449219],
          [73.598197937011889, 21.174720764160156],
          [73.606918334961222, 21.178461074829158],
          [73.609916687011946, 21.176679611206112],
          [73.613166809082088, 21.176059722900447],
          [73.614189147949162, 21.172451019287223],
          [73.613845825195483, 21.16797065734869],
          [73.614700317382869, 21.163480758667049],
          [73.619697570801065, 21.157949447631893],
          [73.637451171875114, 21.153139114379996],
          [73.638977050781364, 21.147340774536133],
          [73.636398315429744, 21.132659912109432],
          [73.671508789062557, 21.145139694213867],
          [73.674606323242472, 21.151020050048828],
          [73.68131256103527, 21.152120590210075],
          [73.689430236816463, 21.151161193847713],
          [73.698242187500057, 21.15011024475109],
          [73.713195800781421, 21.150461196899471],
          [73.715179443359432, 21.143100738525504],
          [73.717071533203182, 21.141740798950309],
          [73.722351074218921, 21.139240264892635],
          [73.736686706543139, 21.138280868530273],
          [73.739837646484659, 21.140161514282283],
          [73.743186950683594, 21.146802902221623],
          [73.746032714843921, 21.147609710693416],
          [73.747970581054744, 21.151531219482365],
          [73.746192932129077, 21.154830932617301],
          [73.740760803222884, 21.160398483276367],
          [73.741622924804858, 21.167110443115348],
          [73.753067016601733, 21.168180465698242],
          [73.779663085937727, 21.16455268859869],
          [73.783660888671932, 21.165060043335075],
          [73.787200927734546, 21.16632080078125],
          [73.789756774902401, 21.168678283691463],
          [73.791137695312784, 21.176229476928711],
          [73.796310424804972, 21.181730270385742],
          [73.802536010742244, 21.178571701049862],
          [73.807533264160213, 21.174600601196289],
          [73.812126159668253, 21.172067642212028],
          [73.817939758300952, 21.171438217163086],
          [73.822547912597713, 21.171920776367244],
          [73.829177856445483, 21.182340621948242],
          [73.830482482910099, 21.184392929077148],
          [73.832321166992244, 21.185398101806697],
          [73.835906982421932, 21.195180892944393],
          [73.834053039551065, 21.197191238403377],
          [73.821342468261889, 21.195320129394531],
          [73.819511413574276, 21.199609756469727],
          [73.818778991699276, 21.20385932922369],
          [73.818595886230526, 21.208570480346793],
          [73.818412780762003, 21.213720321655387],
          [73.820137023926065, 21.221860885620174],
          [73.823165893554744, 21.227569580078125],
          [73.827476501465014, 21.23314094543457],
          [73.836349487304972, 21.242340087890682],
          [73.83650207519554, 21.245820999145565],
          [73.832237243652514, 21.258302688598633],
          [73.832138061523494, 21.267450332641545],
          [73.858406066894588, 21.269950866699276],
          [73.871742248535156, 21.267379760742301],
          [73.884323120117187, 21.262630462646541],
          [73.891990661621151, 21.262411117553711],
          [73.923545837402457, 21.281019210815487],
          [73.933586120605696, 21.285329818725586],
          [73.948486328125057, 21.297550201416072],
          [73.949920654297046, 21.306589126586914],
          [73.950157165527401, 21.308050155639705],
          [73.951278686523438, 21.315008163452262],
          [73.951957702637003, 21.330600738525504],
          [73.957008361816406, 21.344451904296818],
          [73.956588745117358, 21.36161041259777],
          [73.955307006835994, 21.374259948730469],
          [73.955627441406421, 21.390010833740234],
          [73.952842712402401, 21.402370452880859],
          [73.955459594726733, 21.40253829956049],
          [73.961936950683764, 21.393110275268555],
          [73.968696594238338, 21.392061233520508],
          [73.971939086914119, 21.394798278808707],
          [73.9774169921875, 21.394969940185547],
          [73.981559753418139, 21.397331237792969],
          [73.985290527343807, 21.401910781860295],
          [73.988830566406421, 21.404489517211971],
          [74.005477905273494, 21.411830902099723],
          [74.007659912109489, 21.41257286071783],
          [74.009490966796932, 21.413370132446289],
          [74.011077880859659, 21.414529800415039],
          [74.012519836425838, 21.415840148925781],
          [74.014068603515682, 21.417030334472713],
          [74.015792846679915, 21.41798019409174],
          [74.017700195312727, 21.418558120727539],
          [74.019599914550838, 21.41798019409174],
          [74.021339416503963, 21.417020797729606],
          [74.023323059081974, 21.417100906372127],
          [74.025253295898608, 21.417510986328068],
          [74.027175903320483, 21.418041229248047],
          [74.029083251953296, 21.418621063232422],
          [74.030982971191577, 21.419160842895565],
          [74.032920837402344, 21.419580459594783],
          [74.034912109375284, 21.419811248779354],
          [74.036903381347827, 21.419660568237362],
          [74.038856506347713, 21.419300079345817],
          [74.040817260742472, 21.418960571289119],
          [74.042808532715014, 21.418769836425838],
          [74.044792175293196, 21.418529510498161],
          [74.046791076660327, 21.418521881103629],
          [74.048545837402344, 21.419429779052791],
          [74.049652099609546, 21.420980453491268],
          [74.050460815429687, 21.422700881957951],
          [74.051101684570369, 21.4244899749757],
          [74.051628112793026, 21.426280975341854],
          [74.052085876465128, 21.428110122680664],
          [74.052513122558764, 21.429950714111442],
          [74.052856445312784, 21.431789398193416],
          [74.053169250488338, 21.433660507202262],
          [74.053436279296989, 21.435510635375977],
          [74.0537109375, 21.437370300292969],
          [74.053962707519588, 21.439231872558707],
          [74.05417633056669, 21.441101074218864],
          [74.054260253906421, 21.442970275878963],
          [74.054321289062727, 21.444850921630973],
          [74.054443359375171, 21.446729660034237],
          [74.054718017578182, 21.448600769042912],
          [74.055130004883097, 21.450418472290039],
          [74.055656433105696, 21.452239990234375],
          [74.056343078613452, 21.453990936279411],
          [74.057167053222713, 21.455709457397518],
          [74.058036804199162, 21.457389831542969],
          [74.05893707275419, 21.459070205688533],
          [74.059883117676065, 21.460729598999137],
          [74.060829162597713, 21.462369918823299],
          [74.062370300293253, 21.465080261230526],
          [74.063278198242244, 21.466751098632813],
          [74.064132690429631, 21.468429565429631],
          [74.064971923828182, 21.470149993896541],
          [74.065696716308764, 21.471900939941406],
          [74.066169738769588, 21.473720550537109],
          [74.066482543945313, 21.475570678710994],
          [74.066658020019702, 21.47744178771967],
          [74.066429138183537, 21.479301452636662],
          [74.065986633301065, 21.4811305999757],
          [74.067161560058878, 21.48193168640131],
          [74.068916320800952, 21.481069564819393],
          [74.070426940917912, 21.47986030578619],
          [74.071769714355412, 21.478450775146428],
          [74.07301330566429, 21.476980209350586],
          [74.074188232422159, 21.475469589233398],
          [74.075271606445369, 21.473890304565543],
          [74.076240539550838, 21.472248077392635],
          [74.077011108398494, 21.470518112182617],
          [74.077400207519759, 21.468679428100643],
          [74.077522277832202, 21.466810226440543],
          [74.077583312988338, 21.46494293212902],
          [74.07740783691429, 21.463058471679801],
          [74.077087402343864, 21.461210250854549],
          [74.077049255371378, 21.459341049194393],
          [74.078147888183651, 21.45781135559082],
          [74.08001708984375, 21.45720291137701],
          [74.081977844238509, 21.456840515136719],
          [74.083946228027628, 21.45652961730957],
          [74.085922241211108, 21.456251144409237],
          [74.087898254394759, 21.455970764160213],
          [74.089881896972599, 21.455720901489258],
          [74.09185791015625, 21.455480575561523],
          [74.093826293945369, 21.455240249633846],
          [74.095817565918139, 21.455009460449276],
          [74.097785949707088, 21.454740524292049],
          [74.09976959228544, 21.454490661621207],
          [74.101753234863452, 21.454200744628963],
          [74.103729248047102, 21.453889846801815],
          [74.105361938476733, 21.45293998718256],
          [74.105583190917969, 21.451089859008903],
          [74.105606079101619, 21.449220657348576],
          [74.106986999511776, 21.448120117187557],
          [74.108985900879077, 21.44802284240734],
          [74.11097717285179, 21.448101043701286],
          [74.112976074218921, 21.448310852050838],
          [74.11492919921875, 21.448610305786246],
          [74.116889953613509, 21.448961257934627],
          [74.118858337402457, 21.449308395385685],
          [74.120819091797046, 21.449699401855582],
          [74.122459411621378, 21.450700759887809],
          [74.122901916504077, 21.452512741088981],
          [74.122871398925895, 21.454380035400504],
          [74.122695922851506, 21.456251144409237],
          [74.12255859375, 21.458129882812443],
          [74.122611999511946, 21.460000991821346],
          [74.123329162597656, 21.461709976196346],
          [74.125061035156307, 21.462671279907283],
          [74.126976013183651, 21.463201522827262],
          [74.128921508789119, 21.463520050048942],
          [74.130943298339844, 21.463670730590934],
          [74.132926940918026, 21.463701248169059],
          [74.134910583496264, 21.463600158691463],
          [74.136886596679744, 21.463390350341797],
          [74.138870239258097, 21.463039398193359],
          [74.140769958496378, 21.462490081787109],
          [74.141876220703352, 21.460990905761662],
          [74.142585754394531, 21.457719802856502],
          [74.143180847168026, 21.455930709838981],
          [74.144653320312671, 21.454719543457031],
          [74.146591186523438, 21.454280853271484],
          [74.148582458496378, 21.454090118408203],
          [74.150566101074389, 21.453889846801815],
          [74.152526855468807, 21.453609466552848],
          [74.154502868652628, 21.453340530395565],
          [74.156486511230639, 21.453130722045842],
          [74.158470153808821, 21.453081130981445],
          [74.160469055175952, 21.453350067138729],
          [74.161277770996094, 21.454967498779411],
          [74.161598205566349, 21.456830978393612],
          [74.163223266601619, 21.457599639892692],
          [74.165229797363224, 21.457460403442383],
          [74.166641235351619, 21.458652496337891],
          [74.167236328125227, 21.460441589355469],
          [74.167869567871378, 21.462221145629883],
          [74.169319152832088, 21.463430404663029],
          [74.171287536621378, 21.463710784912223],
          [74.173255920410327, 21.463520050048942],
          [74.175071716308651, 21.462739944458121],
          [74.176506042480639, 21.461450576782227],
          [74.178337097168253, 21.460870742797852],
          [74.180175781250057, 21.46156120300293],
          [74.181549072265852, 21.462919235229492],
          [74.182746887207315, 21.464420318603572],
          [74.183959960937671, 21.465900421142578],
          [74.185539245605526, 21.467021942138672],
          [74.187522888183707, 21.467029571533203],
          [74.189498901367188, 21.466810226440543],
          [74.191452026367244, 21.46636962890625],
          [74.193283081054858, 21.465621948242188],
          [74.194976806640568, 21.46464920043951],
          [74.196617126465071, 21.463552474975643],
          [74.198150634765682, 21.462360382080135],
          [74.199401855468921, 21.460901260375977],
          [74.200912475586108, 21.459699630737362],
          [74.202873229980526, 21.459440231323242],
          [74.204856872558878, 21.459590911865234],
          [74.206840515136889, 21.459880828857479],
          [74.208808898925838, 21.460140228271428],
          [74.210823059082202, 21.460189819336051],
          [74.212791442871151, 21.459980010986328],
          [74.21475982666044, 21.459640502929801],
          [74.21671295166027, 21.459270477294979],
          [74.21868896484375, 21.458950042724723],
          [74.220657348632869, 21.458778381347713],
          [74.222633361816349, 21.458990097046012],
          [74.223587036132756, 21.460567474365234],
          [74.223762512207145, 21.462419509887695],
          [74.223831176757812, 21.464311599731445],
          [74.22373199462919, 21.466182708740348],
          [74.223503112793196, 21.468059539794979],
          [74.223236083984546, 21.469909667968864],
          [74.223022460937443, 21.471782684326172],
          [74.222900390625057, 21.473659515380973],
          [74.223030090332202, 21.475521087646541],
          [74.223747253418253, 21.477260589599723],
          [74.225250244140909, 21.478460311889762],
          [74.227096557617244, 21.479158401489201],
          [74.229049682617244, 21.47960090637207],
          [74.231033325195256, 21.479820251464957],
          [74.233032226562557, 21.479869842529354],
          [74.235015869140739, 21.479707717895621],
          [74.236961364746264, 21.479288101196346],
          [74.238731384277401, 21.478412628173942],
          [74.240592956543139, 21.475559234619254],
          [74.241210937500057, 21.47376823425293],
          [74.241699218750114, 21.471950531005973],
          [74.242156982421875, 21.470132827758846],
          [74.242691040039233, 21.468311309814567],
          [74.243331909179744, 21.466539382934684],
          [74.244300842285384, 21.464910507202262],
          [74.245819091797102, 21.463701248169059],
          [74.247695922851619, 21.463100433349666],
          [74.24967193603544, 21.462869644165096],
          [74.251686096191406, 21.462869644165096],
          [74.253677368164347, 21.463039398193359],
          [74.255638122558537, 21.463331222534237],
          [74.257591247558594, 21.463750839233512],
          [74.259498596191406, 21.46426963806158],
          [74.261383056640796, 21.464910507202262],
          [74.263191223144588, 21.46570014953619],
          [74.264152526855526, 21.467292785644474],
          [74.264396667480582, 21.469152450561467],
          [74.264549255371378, 21.471010208129883],
          [74.265029907226562, 21.472841262817496],
          [74.266540527343921, 21.474020004272518],
          [74.268379211426065, 21.474739074707031],
          [74.270286560058878, 21.475250244140739],
          [74.272247314453296, 21.475620269775391],
          [74.274230957031307, 21.475900650024528],
          [74.276206970215128, 21.47612190246582],
          [74.2781982421875, 21.476310729980469],
          [74.280181884765909, 21.476499557495174],
          [74.282173156738452, 21.476720809936637],
          [74.284141540527401, 21.476961135864315],
          [74.286132812500114, 21.477172851562614],
          [74.288116455078125, 21.477340698242301],
          [74.290130615234659, 21.477479934692383],
          [74.292106628418139, 21.47760009765625],
          [74.294097900390682, 21.477741241455078],
          [74.296096801757983, 21.477880477905387],
          [74.298072814941463, 21.478040695190487],
          [74.300056457519645, 21.478240966796932],
          [74.302047729492188, 21.478500366211051],
          [74.304008483886776, 21.478870391845703],
          [74.305915832519588, 21.479391098022575],
          [74.307762145996094, 21.480119705200138],
          [74.309432983398608, 21.481180191040096],
          [74.310577392578296, 21.482660293579102],
          [74.311256408691463, 21.484439849853572],
          [74.311737060547046, 21.486259460449276],
          [74.312362670898494, 21.488058090209961],
          [74.313407897949332, 21.489620208740291],
          [74.314979553222827, 21.490781784057674],
          [74.316780090332259, 21.491569519042969],
          [74.318702697753963, 21.492170333862418],
          [74.320610046386776, 21.492679595947322],
          [74.322532653808878, 21.493192672729492],
          [74.324432373047159, 21.493770599365234],
          [74.326240539550952, 21.494541168212947],
          [74.327720642089957, 21.495750427246094],
          [74.328216552734602, 21.49756050109869],
          [74.328598022461165, 21.499399185180664],
          [74.329071044921818, 21.501230239868278],
          [74.329505920410156, 21.503061294555664],
          [74.329956054687557, 21.5048828125],
          [74.330390930175895, 21.506729125976676],
          [74.330825805664233, 21.508550643920955],
          [74.331253051757869, 21.510379791259822],
          [74.331657409668196, 21.512229919433651],
          [74.33206939697294, 21.514020919799805],
          [74.333358764648494, 21.519809722900504],
          [74.335517883301065, 21.540229797363338],
          [74.332740783691406, 21.541160583496094],
          [74.331649780273665, 21.541179656982536],
          [74.330650329589844, 21.541179656982536],
          [74.329620361328239, 21.541160583496094],
          [74.328613281250057, 21.541151046752987],
          [74.327621459960994, 21.541120529174805],
          [74.327270507812727, 21.541120529174805],
          [74.326591491699162, 21.541110992431697],
          [74.325592041015909, 21.541099548339787],
          [74.324577331543026, 21.541110992431697],
          [74.324066162109659, 21.541120529174805],
          [74.323577880859546, 21.541130065917969],
          [74.322608947754077, 21.541179656982536],
          [74.321617126464957, 21.541250228881779],
          [74.320648193359659, 21.541370391845817],
          [74.319686889648722, 21.541521072387809],
          [74.318672180175838, 21.541759490966911],
          [74.317649841308764, 21.542119979858455],
          [74.316658020019645, 21.542591094970703],
          [74.315818786621321, 21.543170928955078],
          [74.315200805664063, 21.543859481811637],
          [74.314849853515682, 21.544662475585994],
          [74.314613342285327, 21.545511245727653],
          [74.314430236816406, 21.546369552612418],
          [74.314300537109602, 21.547269821167049],
          [74.314186096191349, 21.54818153381359],
          [74.31410217285179, 21.549119949340934],
          [74.314056396484375, 21.550069808959961],
          [74.314048767089844, 21.550550460815543],
          [74.314025878906421, 21.551031112670898],
          [74.314018249511889, 21.552009582519531],
          [74.314010620117358, 21.552980422973576],
          [74.314010620117358, 21.553951263427848],
          [74.313980102539176, 21.554920196533317],
          [74.313911437988509, 21.555891036987418],
          [74.313873291015625, 21.556552886962947],
          [74.313850402832202, 21.556850433349609],
          [74.313781738281534, 21.557792663574276],
          [74.313697814941463, 21.558282852172965],
          [74.313636779785327, 21.558719635009879],
          [74.313468933105639, 21.559650421142692],
          [74.313278198242358, 21.56056022644043],
          [74.313018798828409, 21.561491012573242],
          [74.312759399414119, 21.562400817871151],
          [74.312461853027457, 21.563289642334098],
          [74.312126159668139, 21.564170837402457],
          [74.311759948730469, 21.565071105957088],
          [74.311271667480753, 21.566049575805721],
          [74.310668945312727, 21.566881179809684],
          [74.309967041015909, 21.567321777343807],
          [74.309097290039063, 21.567321777343807],
          [74.308059692383097, 21.567052841186523],
          [74.307060241699276, 21.566562652587834],
          [74.306236267089844, 21.565959930420036],
          [74.305686950683651, 21.565200805664062],
          [74.305328369140852, 21.564292907714901],
          [74.305236816406421, 21.56398963928234],
          [74.305046081543139, 21.563280105590763],
          [74.30478668212919, 21.562240600586051],
          [74.304512023925781, 21.561269760131779],
          [74.304092407226733, 21.560430526733455],
          [74.303543090820483, 21.559820175170955],
          [74.302757263183764, 21.559459686279411],
          [74.301902770996321, 21.559221267700309],
          [74.300956726074276, 21.559091567993164],
          [74.300521850585937, 21.559061050415153],
          [74.299957275390682, 21.559032440185604],
          [74.298927307128849, 21.559019088745117],
          [74.2978515625, 21.559040069580135],
          [74.296775817871378, 21.559091567993164],
          [74.296333312988338, 21.559120178222713],
          [74.295707702636889, 21.55912971496582],
          [74.295166015625, 21.55912971496582],
          [74.294647216797102, 21.559141159057731],
          [74.293609619140796, 21.559091567993164],
          [74.292617797851676, 21.558980941772404],
          [74.291709899902514, 21.558780670166016],
          [74.29103088378929, 21.558170318603459],
          [74.290527343750114, 21.55725288391119],
          [74.289970397949162, 21.556411743164063],
          [74.289169311523722, 21.555959701538086],
          [74.288192749023722, 21.555749893188533],
          [74.287132263183764, 21.555629730224666],
          [74.286560058593921, 21.555490493774414],
          [74.286170959472827, 21.555400848388729],
          [74.285346984863565, 21.554920196533317],
          [74.284606933593864, 21.554281234741211],
          [74.283966064453352, 21.553520202636719],
          [74.283432006836222, 21.552709579467773],
          [74.283271789550895, 21.552350997924805],
          [74.28305816650419, 21.551851272583008],
          [74.282920837402514, 21.55081939697277],
          [74.282821655273665, 21.549810409546012],
          [74.282417297363338, 21.549068450927734],
          [74.281631469726563, 21.548681259155217],
          [74.280632019043139, 21.54850006103527],
          [74.279518127441577, 21.548419952392692],
          [74.278396606445313, 21.548330307006836],
          [74.277351379394815, 21.548168182373104],
          [74.276512145996151, 21.547800064087028],
          [74.275909423828125, 21.547180175781364],
          [74.275436401367472, 21.546390533447266],
          [74.275016784668026, 21.54552078247076],
          [74.27469635009777, 21.544559478759822],
          [74.274406433105526, 21.543569564819336],
          [74.274131774902287, 21.542539596557731],
          [74.273872375488338, 21.541500091552791],
          [74.273612976074219, 21.540491104126033],
          [74.273323059082315, 21.539501190185547],
          [74.272979736328239, 21.538568496704158],
          [74.272583007812784, 21.537750244140682],
          [74.272117614746151, 21.537019729614258],
          [74.271553039550838, 21.536420822143668],
          [74.270866394043253, 21.535970687866211],
          [74.270111083984489, 21.53563117980957],
          [74.269241333007812, 21.535369873046989],
          [74.268341064453182, 21.535179138183707],
          [74.267372131347884, 21.53507041931158],
          [74.266380310058594, 21.534999847412166],
          [74.265350341796989, 21.534990310669059],
          [74.264266967773438, 21.535020828247184],
          [74.263687133789233, 21.53507041931158],
          [74.263191223144588, 21.535100936889762],
          [74.262092590332315, 21.535200119018555],
          [74.260986328125171, 21.53534126281744],
          [74.259925842285213, 21.535480499267521],
          [74.258850097656534, 21.535640716552848],
          [74.257812500000057, 21.535800933838004],
          [74.256797790527514, 21.535951614379996],
          [74.255836486816577, 21.536119461059627],
          [74.254966735839901, 21.536460876464901],
          [74.254142761230639, 21.537010192871151],
          [74.253356933593921, 21.537700653076229],
          [74.252670288085994, 21.538442611694336],
          [74.251976013183878, 21.539150238037109],
          [74.25138092041044, 21.539899826049918],
          [74.250785827636946, 21.540689468383846],
          [74.250251770019815, 21.541509628295955],
          [74.249702453613395, 21.542329788208008],
          [74.249366760254077, 21.542829513549805],
          [74.249160766601733, 21.543140411376953],
          [74.248573303222599, 21.543912887573185],
          [74.24796295166044, 21.544620513916129],
          [74.247322082519588, 21.545240402221793],
          [74.246467590332145, 21.545610427856502],
          [74.245391845703125, 21.545562744140682],
          [74.244293212890852, 21.545490264892635],
          [74.243408203125114, 21.545740127563477],
          [74.242790222168026, 21.546409606933707],
          [74.242370605468807, 21.547309875488338],
          [74.241943359375171, 21.548299789428654],
          [74.241477966308878, 21.549198150634879],
          [74.241256713867244, 21.54951286315918],
          [74.240936279296989, 21.549898147583121],
          [74.240173339843864, 21.550249099731559],
          [74.239196777344034, 21.550291061401424],
          [74.238105773925952, 21.550119400024357],
          [74.237052917480696, 21.549850463867301],
          [74.236686706543026, 21.549760818481445],
          [74.236076354980526, 21.549591064453182],
          [74.235069274902514, 21.549240112304744],
          [74.234069824218864, 21.548839569091797],
          [74.233238220215071, 21.548330307006836],
          [74.232589721679858, 21.54771995544445],
          [74.232467651367415, 21.547370910644645],
          [74.232322692871378, 21.546911239624137],
          [74.232376098632983, 21.545881271362305],
          [74.232505798340128, 21.544820785522575],
          [74.232505798340128, 21.54387092590332],
          [74.232330322265909, 21.543561935424805],
          [74.232131958008097, 21.543220520019531],
          [74.231117248535213, 21.543050765991268],
          [74.229949951171875, 21.543041229248104],
          [74.22910308837902, 21.54269981384283],
          [74.228759765625171, 21.541879653930778],
          [74.228660583496321, 21.540880203247127],
          [74.228569030761889, 21.539821624755973],
          [74.228340148925895, 21.538900375366325],
          [74.227783203124943, 21.538270950317496],
          [74.226951599121151, 21.537879943847656],
          [74.225952148437557, 21.537620544433707],
          [74.224876403808878, 21.537450790405273],
          [74.223831176757812, 21.537309646606559],
          [74.222831726074162, 21.537160873413143],
          [74.22183990478544, 21.537071228027457],
          [74.220779418945313, 21.537031173706168],
          [74.219741821289347, 21.536989212036133],
          [74.218696594238281, 21.536939620971737],
          [74.218208312988565, 21.536899566650447],
          [74.217697143554858, 21.536851882934627],
          [74.216735839843921, 21.536701202392635],
          [74.215866088867244, 21.536470413208065],
          [74.215148925781534, 21.536001205444393],
          [74.214782714844034, 21.535089492797852],
          [74.214447021484546, 21.534059524536246],
          [74.213867187499943, 21.533349990844727],
          [74.213043212890909, 21.532930374145621],
          [74.212089538574503, 21.532619476318303],
          [74.211082458496151, 21.532360076904354],
          [74.210540771484602, 21.532220840454102],
          [74.210090637207202, 21.532110214233398],
          [74.209152221679688, 21.531780242919979],
          [74.208976745605526, 21.531681060791016],
          [74.208312988281364, 21.531280517578182],
          [74.207977294922046, 21.530912399292106],
          [74.207626342773438, 21.530509948730526],
          [74.207260131835994, 21.530099868774414],
          [74.206939697265909, 21.529750823974553],
          [74.206176757812784, 21.529300689697322],
          [74.20523834228544, 21.529211044311637],
          [74.204216003418026, 21.52924919128418],
          [74.203147888183878, 21.529390335083008],
          [74.202117919921932, 21.529630661010742],
          [74.201156616210994, 21.529951095581168],
          [74.200309753418082, 21.530338287353516],
          [74.199691772461222, 21.531000137329215],
          [74.199302673339901, 21.531938552856559],
          [74.199012756347827, 21.532909393310604],
          [74.198905944824446, 21.533420562744141],
          [74.198829650879077, 21.533830642700252],
          [74.198791503906193, 21.534200668334961],
          [74.198730468750057, 21.534759521484489],
          [74.198699951171932, 21.535221099853572],
          [74.19866943359375, 21.535709381103516],
          [74.198600769042912, 21.536649703979606],
          [74.198501586914119, 21.53759956359869],
          [74.198318481445369, 21.53849983215332],
          [74.198013305664176, 21.53938102722168],
          [74.197586059570369, 21.540229797363338],
          [74.197113037109546, 21.541072845458984],
          [74.196540832519702, 21.541860580444336],
          [74.195953369140796, 21.542619705200309],
          [74.195320129394815, 21.543340682983342],
          [74.194641113281421, 21.544029235839844],
          [74.193916320800838, 21.544708251953239],
          [74.193237304687784, 21.545370101928768],
          [74.192512512207202, 21.546039581298885],
          [74.19184875488304, 21.54673957824707],
          [74.19122314453125, 21.547468185424862],
          [74.190681457519588, 21.548231124877987],
          [74.190116882324276, 21.54902267456049],
          [74.18961334228544, 21.549827575683707],
          [74.189331054687557, 21.550279617309684],
          [74.189102172851733, 21.5506591796875],
          [74.18863677978544, 21.55150032043457],
          [74.188217163086165, 21.552350997924805],
          [74.187828063964901, 21.553211212158146],
          [74.187507629394815, 21.554098129272518],
          [74.187362670898608, 21.555059432983455],
          [74.187255859375057, 21.556062698364258],
          [74.187187194824389, 21.557060241699276],
          [74.187049865722713, 21.558010101318359],
          [74.186798095703296, 21.558870315551871],
          [74.186340332031534, 21.559600830078068],
          [74.185691833496094, 21.560211181640625],
          [74.184837341308878, 21.560760498046875],
          [74.18387603759794, 21.561210632324276],
          [74.182868957519588, 21.56155967712408],
          [74.181831359863452, 21.561769485473633],
          [74.180816650390909, 21.561838150024471],
          [74.179847717285213, 21.56183052062994],
          [74.178886413574276, 21.561820983886776],
          [74.177871704101563, 21.561780929565487],
          [74.176879882812671, 21.561750411987362],
          [74.175872802734659, 21.561679840087947],
          [74.174858093261776, 21.561611175537053],
          [74.173835754394702, 21.561531066894531],
          [74.172821044922159, 21.561428070068359],
          [74.171821594238509, 21.561321258544979],
          [74.170799255371264, 21.561180114746094],
          [74.170341491699503, 21.56112098693859],
          [74.169799804687443, 21.561042785644588],
          [74.169456481933764, 21.560989379882812],
          [74.168792724609659, 21.560880661010856],
          [74.167800903320369, 21.560720443725586],
          [74.166816711425781, 21.560529708862305],
          [74.165847778320312, 21.560319900512752],
          [74.164886474609546, 21.560100555419922],
          [74.163948059082031, 21.559860229492187],
          [74.163017272949276, 21.559600830078068],
          [74.162139892578409, 21.559270858764705],
          [74.16133117675804, 21.558759689331168],
          [74.160575866699276, 21.55813026428217],
          [74.159889221191349, 21.557411193847713],
          [74.159210205078182, 21.556650161743164],
          [74.158546447753849, 21.555879592895508],
          [74.157897949218977, 21.555170059204158],
          [74.157356262207315, 21.554380416870231],
          [74.156860351562671, 21.553520202636719],
          [74.156326293945313, 21.552730560302791],
          [74.155639648437784, 21.552129745483398],
          [74.154739379882756, 21.551719665527401],
          [74.153732299804972, 21.551431655883903],
          [74.152763366699276, 21.551229476928711],
          [74.151802062988338, 21.55105018615734],
          [74.150787353515625, 21.550870895385799],
          [74.149803161621264, 21.550701141357536],
          [74.148796081543253, 21.550569534301815],
          [74.147827148437784, 21.550451278686523],
          [74.146812438964901, 21.550380706787109],
          [74.145828247070312, 21.55034065246582],
          [74.144836425781421, 21.55034065246582],
          [74.144447326660327, 21.550359725952262],
          [74.143806457519815, 21.550380706787109],
          [74.142745971679858, 21.550460815429688],
          [74.141700744628963, 21.550609588623047],
          [74.140716552734432, 21.550859451294059],
          [74.139839172363395, 21.551210403442496],
          [74.139106750488452, 21.551731109619141],
          [74.138549804687671, 21.552511215209961],
          [74.13809967041044, 21.55348014831543],
          [74.137718200683878, 21.554500579834098],
          [74.137298583984602, 21.555480957031307],
          [74.136772155762003, 21.556230545043945],
          [74.136093139648437, 21.55669975280756],
          [74.135200500488509, 21.556880950927734],
          [74.134307861328239, 21.556980133056754],
          [74.133346557617472, 21.557029724121151],
          [74.132881164550838, 21.557018280029411],
          [74.132400512695426, 21.557018280029411],
          [74.131439208984659, 21.55697059631359],
          [74.130416870117244, 21.556890487670842],
          [74.129409790039233, 21.556789398193473],
          [74.128402709961051, 21.556650161743164],
          [74.127349853515682, 21.556499481201172],
          [74.126319885253849, 21.55636024475109],
          [74.125267028808651, 21.556221008300781],
          [74.124221801757756, 21.556079864501896],
          [74.123191833496151, 21.555980682373104],
          [74.122169494628906, 21.555900573730526],
          [74.121147155761832, 21.555849075317383],
          [74.120162963867472, 21.555860519409237],
          [74.119171142578352, 21.555900573730526],
          [74.118217468261946, 21.556150436401367],
          [74.117286682128963, 21.556528091430721],
          [74.11637115478544, 21.55697059631359],
          [74.115463256836108, 21.557441711425838],
          [74.114532470703296, 21.557830810546989],
          [74.11358642578125, 21.558099746704215],
          [74.112609863281421, 21.558151245117244],
          [74.111602783203409, 21.558151245117244],
          [74.110626220703409, 21.55813026428217],
          [74.109642028808821, 21.558111190795955],
          [74.109138488769645, 21.558080673217773],
          [74.108642578125, 21.558048248291016],
          [74.108139038086222, 21.558019638061637],
          [74.107658386230639, 21.557989120483512],
          [74.106658935546989, 21.55792236328125],
          [74.105667114258097, 21.557840347290096],
          [74.104637145996094, 21.557741165161076],
          [74.103675842285156, 21.557638168335075],
          [74.102645874023551, 21.557540893554688],
          [74.101669311523722, 21.557428359985352],
          [74.100646972656307, 21.557319641113224],
          [74.099662780761719, 21.557210922241325],
          [74.098663330078068, 21.557100296020565],
          [74.097648620605753, 21.557001113891602],
          [74.096656799316463, 21.556909561157283],
          [74.095649719238452, 21.556821823120174],
          [74.094657897949162, 21.556739807128849],
          [74.094161987304744, 21.556711196899471],
          [74.093650817871378, 21.556682586669922],
          [74.093215942382869, 21.556650161743164],
          [74.09266662597679, 21.556619644165039],
          [74.091682434082088, 21.55657958984375],
          [74.090682983398608, 21.556552886962947],
          [74.089706420898608, 21.556560516357479],
          [74.089141845703296, 21.556570053100586],
          [74.08872222900402, 21.556570053100586],
          [74.087768554687614, 21.556770324707031],
          [74.086830139160099, 21.557140350341854],
          [74.085929870605469, 21.557582855224723],
          [74.085227966308821, 21.557931900024357],
          [74.085021972656307, 21.558040618896484],
          [74.084075927734602, 21.558429718017578],
          [74.083152770996378, 21.558692932128906],
          [74.082160949707088, 21.558839797973746],
          [74.0811767578125, 21.558969497680721],
          [74.080192565918139, 21.559078216552848],
          [74.079208374023381, 21.559190750122127],
          [74.078186035156307, 21.559270858764705],
          [74.077270507812784, 21.559339523315543],
          [74.076210021972656, 21.559419631958121],
          [74.075187683105582, 21.559459686279411],
          [74.074836730957202, 21.559480667114258],
          [74.074188232422159, 21.5594997406007],
          [74.073677062988224, 21.559522628784293],
          [74.073181152343807, 21.559530258178825],
          [74.07285308837919, 21.559530258178825],
          [74.072189331054858, 21.559539794921932],
          [74.071189880371037, 21.559539794921932],
          [74.070190429687784, 21.559539794921932],
          [74.069786071777401, 21.559530258178825],
          [74.069206237793196, 21.559509277343807],
          [74.068222045898494, 21.559371948242301],
          [74.067230224609546, 21.559141159057731],
          [74.066268920898608, 21.558860778808594],
          [74.065345764160156, 21.558521270752067],
          [74.064407348632869, 21.558179855346793],
          [74.063499450683651, 21.557792663574276],
          [74.062606811523381, 21.557380676269531],
          [74.061721801757813, 21.556951522827148],
          [74.060829162597713, 21.55652046203619],
          [74.059936523437443, 21.556089401245231],
          [74.059059143066463, 21.555681228637695],
          [74.054298400878963, 21.552169799804631],
          [74.047149658203239, 21.549680709838867],
          [74.04168701171875, 21.551349639892578],
          [74.025558471679972, 21.552619934082088],
          [74.019050598144588, 21.550510406494254],
          [74.005340576172159, 21.540769577026424],
          [73.9835205078125, 21.54204177856451],
          [73.981788635253906, 21.539770126342773],
          [73.982521057129077, 21.535730361938533],
          [73.987541198730526, 21.522409439087028],
          [73.985687255859659, 21.521360397338981],
          [73.982192993164119, 21.52180290222168],
          [73.974456787109659, 21.524080276489315],
          [73.973358154297046, 21.531410217285156],
          [73.969856262207315, 21.538568496704158],
          [73.966316223144702, 21.539070129394531],
          [73.962760925293026, 21.537879943847656],
          [73.961112976074503, 21.519298553466797],
          [73.957283020019815, 21.516471862793082],
          [73.953582763671932, 21.515800476074219],
          [73.939407348632983, 21.510110855102539],
          [73.937622070312784, 21.520660400390739],
          [73.936141967773551, 21.522449493408317],
          [73.933776855468977, 21.523590087890625],
          [73.930992126464957, 21.522991180419979],
          [73.928398132324219, 21.520629882812557],
          [73.926078796386889, 21.519599914550781],
          [73.910476684570369, 21.520170211792049],
          [73.910049438476733, 21.513301849365348],
          [73.903602600097656, 21.508752822875977],
          [73.897071838379077, 21.50604248046875],
          [73.886627197265625, 21.504680633544979],
          [73.882568359375171, 21.509782791137752],
          [73.880203247070369, 21.507890701294002],
          [73.876846313476733, 21.501188278198185],
          [73.870300292969034, 21.497259140014705],
          [73.860786437988565, 21.495822906494141],
          [73.854011535644531, 21.507261276245231],
          [73.84989166259794, 21.510980606079215],
          [73.84503173828125, 21.521568298339901],
          [73.840156555176065, 21.536909103393555],
          [73.833763122558764, 21.55348014831543],
          [73.829055786132869, 21.57295036315918],
          [73.824501037597713, 21.598289489746207],
          [73.823150634765852, 21.600679397583008],
          [73.818450927734489, 21.602331161499023],
          [73.806838989257756, 21.602371215820312],
          [73.790573120117472, 21.618509292602596],
          [73.789527893066406, 21.620910644531307],
          [73.787612915039233, 21.62504959106451],
          [73.790863037109375, 21.628789901733342],
          [73.800132751465128, 21.634639739990348],
          [73.808822631835994, 21.635711669921818],
          [73.829032897949276, 21.639789581298942],
          [73.838546752929688, 21.635379791259879],
          [73.845237731933594, 21.633159637451172],
          [73.853042602539062, 21.635869979858398],
          [73.860252380371264, 21.641847610473746],
          [73.870269775390852, 21.638790130615291],
          [73.885627746582202, 21.645059585571403],
          [73.891265869140682, 21.651510238647461],
          [73.894447326660156, 21.657079696655273],
          [73.898101806640682, 21.667270660400334],
          [73.896362304687557, 21.700281143188477],
          [73.893966674804972, 21.703140258789119],
          [73.890235900878906, 21.710649490356502],
          [73.885047912597827, 21.714429855346623],
          [73.878349304199332, 21.716930389404297],
          [73.871231079101619, 21.721918106079215],
          [73.865119934082259, 21.729379653930778],
          [73.860298156738281, 21.733011245727653],
          [73.856330871582088, 21.734640121460075],
          [73.846359252929858, 21.742000579834098],
          [73.831207275390909, 21.762889862060547],
          [73.841293334960994, 21.768650054931697],
          [73.842948913574219, 21.77213096618658],
          [73.838378906250057, 21.784130096435604],
          [73.844139099121321, 21.78711128234869],
          [73.844963073730582, 21.790681838989258],
          [73.835670471191577, 21.793479919433594],
          [73.834213256836165, 21.796611785888672],
          [73.838935852050781, 21.8001708984375],
          [73.833518981933707, 21.805160522460994],
          [73.832107543945369, 21.810850143432674],
          [73.827598571777628, 21.81193923950201],
          [73.817596435546932, 21.808500289916992],
          [73.813568115234375, 21.810119628906307],
          [73.810516357421875, 21.823337554931641],
          [73.816238403320312, 21.828569412231559],
          [73.827926635742415, 21.834859848022518],
          [73.841522216797159, 21.8385009765625],
          [73.863746643066463, 21.836650848388615],
          [73.879600524902401, 21.838640213012809],
          [73.89951324462902, 21.854490280151367],
          [73.906669616699276, 21.853630065918026],
          [73.921928405761776, 21.856582641601506],
          [73.936363220215014, 21.86314964294445],
          [73.949180603027344, 21.870340347290153],
          [73.960807800292969, 21.875991821289176],
          [73.979736328125057, 21.88750076293951],
          [74.004890441894588, 21.899360656738281],
          [74.011688232421818, 21.900539398193303],
          [74.023040771484602, 21.905971527099666],
          [74.035606384277401, 21.916009902954102],
          [74.046669006347713, 21.922809600830192],
          [74.056427001953352, 21.926410675048885],
          [74.06162261962919, 21.928050994873047],
          [74.071510314941463, 21.929601669311523],
          [74.098670959472827, 21.937629699707145],
          [74.113647460937727, 21.944700241088867],
          [74.138160705566577, 21.953371047973633],
          [74.146018981933594, 21.954059600830135],
          [74.147026062011946, 21.954040527343693],
          [74.148033142090128, 21.954040527343693],
          [74.149040222168139, 21.954030990600586],
          [74.150032043457031, 21.954010009765739],
          [74.151016235351619, 21.953960418701172],
          [74.152023315429972, 21.953861236572322],
          [74.153022766113224, 21.95369911193859],
          [74.154006958007983, 21.953569412231445],
          [74.155006408691463, 21.953348159790039],
          [74.155982971191634, 21.953109741210937],
          [74.156921386718807, 21.952800750732365],
          [74.157806396484546, 21.952409744262695],
          [74.158721923828239, 21.952011108398437],
          [74.159622192382869, 21.951589584350643],
          [74.160507202148438, 21.951169967651367],
          [74.161407470703068, 21.950740814208984],
          [74.162269592285213, 21.950300216674862],
          [74.163162231445483, 21.949850082397461],
          [74.164047241211222, 21.949399948120231],
          [74.164909362792969, 21.94893836975092],
          [74.165786743164176, 21.948461532592717],
          [74.166656494140682, 21.948009490966911],
          [74.167526245117358, 21.947521209716797],
          [74.168395996093807, 21.947040557861442],
          [74.169242858886889, 21.946550369262752],
          [74.170112609863338, 21.94608116149908],
          [74.170951843261662, 21.945579528808651],
          [74.171791076660213, 21.945091247558594],
          [74.172607421875284, 21.944549560546875],
          [74.173439025879077, 21.943981170654411],
          [74.174186706542912, 21.943380355834961],
          [74.174942016601676, 21.942731857299918],
          [74.175636291504134, 21.94205284118658],
          [74.17624664306669, 21.941341400146598],
          [74.176811218262003, 21.940559387207031],
          [74.177352905273665, 21.939760208129996],
          [74.177871704101563, 21.938949584961051],
          [74.178390502929631, 21.938140869140682],
          [74.17893218994169, 21.937351226806584],
          [74.179527282714787, 21.936611175537109],
          [74.180160522460938, 21.935880661010685],
          [74.180809020996378, 21.935140609741211],
          [74.181442260742131, 21.934391021728572],
          [74.18206787109375, 21.933650970459041],
          [74.182731628418253, 21.932920455932674],
          [74.183418273925838, 21.932199478149414],
          [74.184089660644645, 21.931510925293082],
          [74.184806823730526, 21.930841445922852],
          [74.185546875000227, 21.930221557617188],
          [74.186309814453352, 21.92963981628418],
          [74.187088012695369, 21.929107666015625],
          [74.187927246093693, 21.928640365600586],
          [74.188827514648722, 21.928222656250057],
          [74.189743041992415, 21.927900314331055],
          [74.190696716308821, 21.927602767944393],
          [74.191696166992472, 21.927339553833121],
          [74.192687988281193, 21.927110671997127],
          [74.193679809570483, 21.926900863647575],
          [74.194679260253963, 21.926710128784293],
          [74.195671081543026, 21.926519393921012],
          [74.196662902832315, 21.926338195800895],
          [74.197639465332145, 21.926139831543082],
          [74.198631286621264, 21.925970077514648],
          [74.199623107910156, 21.925800323486385],
          [74.200637817382869, 21.925649642944393],
          [74.20163726806652, 21.925529479980526],
          [74.202621459961108, 21.92543983459484],
          [74.203620910644531, 21.925399780273551],
          [74.204643249511776, 21.925411224365291],
          [74.205619812012003, 21.925470352172965],
          [74.206588745117472, 21.925579071044922],
          [74.207580566406421, 21.925718307495231],
          [74.208557128906421, 21.925870895385799],
          [74.209526062011719, 21.926059722900504],
          [74.210517883300838, 21.926240921020451],
          [74.211479187011776, 21.926450729370174],
          [74.212463378906307, 21.926660537719727],
          [74.213432312012003, 21.926879882812557],
          [74.214408874512003, 21.927120208740234],
          [74.215393066406193, 21.927360534667969],
          [74.216369628906421, 21.927591323852539],
          [74.217330932617358, 21.927841186523494],
          [74.218307495117187, 21.928091049194336],
          [74.219276428222713, 21.92831993103033],
          [74.220268249511946, 21.928550720214844],
          [74.221229553222713, 21.928779602050838],
          [74.222198486328409, 21.929000854492301],
          [74.223190307617301, 21.92920112609869],
          [74.224166870117131, 21.929412841796989],
          [74.225135803222827, 21.929588317871207],
          [74.226142883300838, 21.929759979248047],
          [74.227096557617244, 21.929901123046932],
          [74.228096008300838, 21.930009841919059],
          [74.229087829590128, 21.930040359497184],
          [74.230087280273608, 21.930019378662166],
          [74.231086730957031, 21.929960250854435],
          [74.232086181640852, 21.929880142211914],
          [74.233108520507926, 21.929780960083065],
          [74.234123229980639, 21.929700851440487],
          [74.235107421875057, 21.92963981628418],
          [74.236106872558651, 21.929630279541072],
          [74.237106323242472, 21.929660797119197],
          [74.238090515136662, 21.929759979248047],
          [74.239097595214844, 21.92987060546875],
          [74.240097045898665, 21.929990768432617],
          [74.241081237793253, 21.930110931396428],
          [74.242080688476676, 21.930250167846737],
          [74.243041992187443, 21.930389404296818],
          [74.244026184082202, 21.930530548095703],
          [74.245033264160213, 21.930690765380859],
          [74.246032714843807, 21.930841445922852],
          [74.247001647949503, 21.931011199951286],
          [74.247985839843864, 21.931179046630916],
          [74.248962402343693, 21.931341171264648],
          [74.249946594238452, 21.931499481201172],
          [74.250930786132813, 21.931682586669922],
          [74.251930236816634, 21.931829452514762],
          [74.25290679931669, 21.932001113891602],
          [74.253906250000114, 21.932149887085018],
          [74.254890441894702, 21.932310104370117],
          [74.255867004394702, 21.932441711425895],
          [74.256866455078182, 21.932590484619084],
          [74.257858276367244, 21.932729721069393],
          [74.258857727050895, 21.932851791381836],
          [74.259857177734546, 21.932960510253963],
          [74.260856628418026, 21.933071136474666],
          [74.261833190918026, 21.933170318603516],
          [74.262840270996378, 21.933269500732479],
          [74.263839721679631, 21.933361053466797],
          [74.264831542968921, 21.933441162109318],
          [74.265846252441634, 21.933521270752067],
          [74.266853332519815, 21.933597564697266],
          [74.267860412597827, 21.933668136596737],
          [74.268882751464901, 21.933740615844727],
          [74.269889831543253, 21.933809280395565],
          [74.270866394043253, 21.933881759643612],
          [74.271896362304688, 21.933940887451172],
          [74.272888183593807, 21.934019088745117],
          [74.27390289306669, 21.934091567993164],
          [74.274909973144702, 21.934160232544002],
          [74.275917053222656, 21.934230804443416],
          [74.276916503906477, 21.934299468994084],
          [74.27793121337902, 21.934379577636832],
          [74.278930664062671, 21.934459686279411],
          [74.279922485351563, 21.934551239013672],
          [74.280921936035384, 21.934640884399357],
          [74.281906127929972, 21.934740066528377],
          [74.282913208007756, 21.934839248657227],
          [74.283897399902514, 21.93494987487793],
          [74.284866333007812, 21.935079574585075],
          [74.285842895507869, 21.935188293457031],
          [74.286819458007869, 21.935342788696403],
          [74.287796020507869, 21.935480117797908],
          [74.288749694824276, 21.935630798339901],
          [74.289710998535213, 21.935791015625],
          [74.290649414062727, 21.936059951782283],
          [74.291488647460881, 21.936582565307731],
          [74.292259216308537, 21.937250137329215],
          [74.292907714843807, 21.938060760498161],
          [74.29345703125, 21.938880920410213],
          [74.293876647949276, 21.939701080322266],
          [74.294258117675838, 21.940559387207031],
          [74.294548034667912, 21.941450119018555],
          [74.294807434082088, 21.942367553711051],
          [74.295021057128963, 21.94330024719244],
          [74.295211791992244, 21.944250106811637],
          [74.295387268066463, 21.94518089294445],
          [74.295593261718807, 21.946098327636719],
          [74.295707702636889, 21.947032928466911],
          [74.295852661133097, 21.94795036315918],
          [74.295936584472656, 21.948890686035099],
          [74.296035766601847, 21.949829101562614],
          [74.296119689941406, 21.950759887695426],
          [74.296211242676065, 21.95169830322277],
          [74.296310424804687, 21.952630996704102],
          [74.296417236328409, 21.953569412231445],
          [74.296569824218807, 21.954490661621094],
          [74.296775817871378, 21.955400466919059],
          [74.296966552734659, 21.956310272216854],
          [74.297210693359318, 21.957218170166016],
          [74.297492980957088, 21.958131790161133],
          [74.297760009765909, 21.959030151367188],
          [74.298080444336165, 21.959920883178711],
          [74.298431396484432, 21.960819244384709],
          [74.298759460449389, 21.961690902709961],
          [74.299102783203239, 21.962570190429801],
          [74.29947662353544, 21.963449478149414],
          [74.299873352050895, 21.964330673217773],
          [74.300300598144702, 21.965219497680664],
          [74.300796508789347, 21.966051101684684],
          [74.301361083984659, 21.966800689697322],
          [74.302040100097656, 21.967439651489201],
          [74.302803039550781, 21.968040466308651],
          [74.303588867187557, 21.968620300293026],
          [74.304397583007869, 21.969179153442383],
          [74.305236816406421, 21.969720840454215],
          [74.306106567382869, 21.970220565795898],
          [74.306999206542969, 21.970689773559513],
          [74.307907104492358, 21.971130371093807],
          [74.308830261230582, 21.971519470214901],
          [74.309761047363565, 21.971860885620174],
          [74.310676574707259, 21.972150802612305],
          [74.311653137207315, 21.972400665283317],
          [74.312606811523722, 21.972618103027401],
          [74.313568115234659, 21.972810745239258],
          [74.31455230712902, 21.972969055175781],
          [74.315551757812671, 21.973100662231502],
          [74.316551208496151, 21.973230361938477],
          [74.317558288574276, 21.973331451416072],
          [74.318572998046818, 21.973421096801758],
          [74.319580078125, 21.973520278930778],
          [74.320587158203352, 21.973590850830021],
          [74.321586608887003, 21.973649978637752],
          [74.322601318359546, 21.973728179931754],
          [74.323593139648437, 21.973831176757926],
          [74.324592590332259, 21.973920822143612],
          [74.325576782226847, 21.973979949951115],
          [74.326568603515739, 21.974050521850586],
          [74.327583312988452, 21.97412109375],
          [74.328582763671932, 21.9741725921632],
          [74.329589843750284, 21.974218368530217],
          [74.330581665039176, 21.974269866943416],
          [74.331588745117358, 21.974319458007813],
          [74.332580566406307, 21.974372863769588],
          [74.333602905273722, 21.974411010742301],
          [74.334587097168082, 21.97445106506359],
          [74.335578918457202, 21.974510192871094],
          [74.336601257324276, 21.974550247192383],
          [74.337577819824276, 21.974599838256779],
          [74.338592529296989, 21.974662780761719],
          [74.339576721191577, 21.974708557128906],
          [74.340576171875, 21.974779129028377],
          [74.341583251953182, 21.974861145019531],
          [74.342582702637003, 21.974920272827262],
          [74.343582153320483, 21.975009918212947],
          [74.344551086425952, 21.975099563598633],
          [74.345558166503963, 21.975219726562443],
          [74.346527099609602, 21.975410461425724],
          [74.347496032714901, 21.975650787353629],
          [74.348449707031307, 21.975999832153434],
          [74.349357604980526, 21.976390838623104],
          [74.350242614746037, 21.976829528808651],
          [74.351142883301065, 21.977291107177791],
          [74.352020263671875, 21.977741241455192],
          [74.352897644043082, 21.978210449218864],
          [74.353782653808821, 21.978691101074219],
          [74.354637145996264, 21.979198455810604],
          [74.355461120605526, 21.979721069335994],
          [74.356262207031477, 21.980289459228516],
          [74.357009887695369, 21.980880737304801],
          [74.357757568359432, 21.981510162353572],
          [74.358421325683707, 21.982200622558651],
          [74.359016418456974, 21.982919692993164],
          [74.359626770019702, 21.983680725097713],
          [74.360191345215014, 21.984462738037053],
          [74.360748291015796, 21.985260009765682],
          [74.361267089844034, 21.986080169677791],
          [74.361808776855526, 21.986890792846737],
          [74.362350463867244, 21.987699508667106],
          [74.362869262695483, 21.988500595092887],
          [74.363426208496264, 21.989290237426815],
          [74.364006042480639, 21.990039825439453],
          [74.364639282226619, 21.990760803222713],
          [74.365310668945256, 21.991441726684684],
          [74.366020202637003, 21.99204063415533],
          [74.366851806640796, 21.99253082275402],
          [74.367782592773381, 21.992910385131779],
          [74.368759155273608, 21.993249893188477],
          [74.369743347167969, 21.993568420410156],
          [74.370697021484375, 21.993919372558594],
          [74.371597290039006, 21.994342803955192],
          [74.372383117675952, 21.994871139526367],
          [74.373107910156364, 21.995491027832031],
          [74.373756408691406, 21.996189117431697],
          [74.374382019043196, 21.996910095214957],
          [74.374961853027401, 21.997671127319279],
          [74.375526428222884, 21.998439788818359],
          [74.376098632812727, 21.999250411987305],
          [74.376640319824276, 22.000040054321403],
          [74.377189636230469, 22.000850677490348],
          [74.378181457519588, 22.002170562744254],
          [74.3836669921875, 22.011751174926758],
          [74.388313293457088, 22.02017974853527],
          [74.396438598632983, 22.023702621460018],
          [74.406517028808764, 22.024400711059627],
          [74.417747497558707, 22.025810241699219],
          [74.435546875, 22.030998229980526],
        ],
      },
    },
  ],
};
